
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirebab8"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirebab8"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("caZvI", function(module, exports) {
'use strict';

module.exports = (parcelRequire("71dwH"));

});
parcelRegister("71dwH", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $51c31e74819f2799$export$ffb0004e005737fa; }, function (v) { return $51c31e74819f2799$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $51c31e74819f2799$export$34b9dba7ce09269b; }, function (v) { return $51c31e74819f2799$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $51c31e74819f2799$export$25062201e9e25d76; }, function (v) { return $51c31e74819f2799$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $51c31e74819f2799$export$ffb0004e005737fa;
var $51c31e74819f2799$export$34b9dba7ce09269b;
var $51c31e74819f2799$export$25062201e9e25d76;
"use strict";
var $51c31e74819f2799$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $51c31e74819f2799$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $51c31e74819f2799$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $51c31e74819f2799$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$51c31e74819f2799$export$ffb0004e005737fa = $51c31e74819f2799$var$REACT_FRAGMENT_TYPE;
$51c31e74819f2799$export$34b9dba7ce09269b = $51c31e74819f2799$var$jsxProd;
$51c31e74819f2799$export$25062201e9e25d76 = $51c31e74819f2799$var$jsxProd;

});


parcelRegister("jpgPw", function(module, exports) {
'use strict';

module.exports = (parcelRequire("3aDAT"));

});
parcelRegister("3aDAT", function(module, exports) {

$parcel$export(module.exports, "Activity", function () { return $24f104d8a8c8fcaf$export$9c16c1426311996d; }, function (v) { return $24f104d8a8c8fcaf$export$9c16c1426311996d = v; });
$parcel$export(module.exports, "Children", function () { return $24f104d8a8c8fcaf$export$dca3b0875bd9a954; }, function (v) { return $24f104d8a8c8fcaf$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $24f104d8a8c8fcaf$export$16fa2f45be04daa8; }, function (v) { return $24f104d8a8c8fcaf$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $24f104d8a8c8fcaf$export$ffb0004e005737fa; }, function (v) { return $24f104d8a8c8fcaf$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $24f104d8a8c8fcaf$export$e2c29f18771995cb; }, function (v) { return $24f104d8a8c8fcaf$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $24f104d8a8c8fcaf$export$221d75b3f55bb0bd; }, function (v) { return $24f104d8a8c8fcaf$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $24f104d8a8c8fcaf$export$5f8d39834fd61797; }, function (v) { return $24f104d8a8c8fcaf$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $24f104d8a8c8fcaf$export$74bf444e3cd11ea5; }, function (v) { return $24f104d8a8c8fcaf$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "ViewTransition", function () { return $24f104d8a8c8fcaf$export$8cdaa4703948c5e9; }, function (v) { return $24f104d8a8c8fcaf$export$8cdaa4703948c5e9 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $24f104d8a8c8fcaf$export$1ced07cd6b1985ce; }, function (v) { return $24f104d8a8c8fcaf$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "__COMPILER_RUNTIME", function () { return $24f104d8a8c8fcaf$export$abd8e32b826d7ea7; }, function (v) { return $24f104d8a8c8fcaf$export$abd8e32b826d7ea7 = v; });
$parcel$export(module.exports, "addTransitionType", function () { return $24f104d8a8c8fcaf$export$87c99536b1b8cdd8; }, function (v) { return $24f104d8a8c8fcaf$export$87c99536b1b8cdd8 = v; });
$parcel$export(module.exports, "cache", function () { return $24f104d8a8c8fcaf$export$69a3209f1a06c04d; }, function (v) { return $24f104d8a8c8fcaf$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cacheSignal", function () { return $24f104d8a8c8fcaf$export$8c538325882c7eec; }, function (v) { return $24f104d8a8c8fcaf$export$8c538325882c7eec = v; });
$parcel$export(module.exports, "cloneElement", function () { return $24f104d8a8c8fcaf$export$e530037191fcd5d7; }, function (v) { return $24f104d8a8c8fcaf$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $24f104d8a8c8fcaf$export$fd42f52fd3ae1109; }, function (v) { return $24f104d8a8c8fcaf$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $24f104d8a8c8fcaf$export$c8a8987d4410bf2d; }, function (v) { return $24f104d8a8c8fcaf$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $24f104d8a8c8fcaf$export$7d1e3a5e95ceca43; }, function (v) { return $24f104d8a8c8fcaf$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $24f104d8a8c8fcaf$export$257a8862b851cb5b; }, function (v) { return $24f104d8a8c8fcaf$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $24f104d8a8c8fcaf$export$a8257692ac88316c; }, function (v) { return $24f104d8a8c8fcaf$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $24f104d8a8c8fcaf$export$488013bae63b21da; }, function (v) { return $24f104d8a8c8fcaf$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $24f104d8a8c8fcaf$export$7c73462e0d25e514; }, function (v) { return $24f104d8a8c8fcaf$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $24f104d8a8c8fcaf$export$7568632d0d33d16d; }, function (v) { return $24f104d8a8c8fcaf$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $24f104d8a8c8fcaf$export$f93f40ac0ca7e3a8; }, function (v) { return $24f104d8a8c8fcaf$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $24f104d8a8c8fcaf$export$1f96ae73734a86cc; }, function (v) { return $24f104d8a8c8fcaf$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $24f104d8a8c8fcaf$export$9a47ced3238df325; }, function (v) { return $24f104d8a8c8fcaf$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $24f104d8a8c8fcaf$export$35808ee640e87ca7; }, function (v) { return $24f104d8a8c8fcaf$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $24f104d8a8c8fcaf$export$fae74005e78b1a27; }, function (v) { return $24f104d8a8c8fcaf$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $24f104d8a8c8fcaf$export$dc8fbce3eb94dc1e; }, function (v) { return $24f104d8a8c8fcaf$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $24f104d8a8c8fcaf$export$6a7bc4e911dc01cf; }, function (v) { return $24f104d8a8c8fcaf$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $24f104d8a8c8fcaf$export$6d9c69b0de29b591; }, function (v) { return $24f104d8a8c8fcaf$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useEffectEvent", function () { return $24f104d8a8c8fcaf$export$7f54fc3180508a52; }, function (v) { return $24f104d8a8c8fcaf$export$7f54fc3180508a52 = v; });
$parcel$export(module.exports, "useId", function () { return $24f104d8a8c8fcaf$export$f680877a34711e37; }, function (v) { return $24f104d8a8c8fcaf$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $24f104d8a8c8fcaf$export$d5a552a76deda3c2; }, function (v) { return $24f104d8a8c8fcaf$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $24f104d8a8c8fcaf$export$aaabe4eda9ed9969; }, function (v) { return $24f104d8a8c8fcaf$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $24f104d8a8c8fcaf$export$e5c5a5f917a5871c; }, function (v) { return $24f104d8a8c8fcaf$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $24f104d8a8c8fcaf$export$1538c33de8887b59; }, function (v) { return $24f104d8a8c8fcaf$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $24f104d8a8c8fcaf$export$fca7f784ae7a249a; }, function (v) { return $24f104d8a8c8fcaf$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $24f104d8a8c8fcaf$export$13e3392192263954; }, function (v) { return $24f104d8a8c8fcaf$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $24f104d8a8c8fcaf$export$b8f5890fc79d6aca; }, function (v) { return $24f104d8a8c8fcaf$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $24f104d8a8c8fcaf$export$60241385465d0a34; }, function (v) { return $24f104d8a8c8fcaf$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $24f104d8a8c8fcaf$export$306c0aa65ff9ec16; }, function (v) { return $24f104d8a8c8fcaf$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $24f104d8a8c8fcaf$export$7b286972b8d8ccbf; }, function (v) { return $24f104d8a8c8fcaf$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $24f104d8a8c8fcaf$export$83d89fbfd8236492; }, function (v) { return $24f104d8a8c8fcaf$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $24f104d8a8c8fcaf$export$9c16c1426311996d;
var $24f104d8a8c8fcaf$export$dca3b0875bd9a954;
var $24f104d8a8c8fcaf$export$16fa2f45be04daa8;
var $24f104d8a8c8fcaf$export$ffb0004e005737fa;
var $24f104d8a8c8fcaf$export$e2c29f18771995cb;
var $24f104d8a8c8fcaf$export$221d75b3f55bb0bd;
var $24f104d8a8c8fcaf$export$5f8d39834fd61797;
var $24f104d8a8c8fcaf$export$74bf444e3cd11ea5;
var $24f104d8a8c8fcaf$export$8cdaa4703948c5e9;
var $24f104d8a8c8fcaf$export$1ced07cd6b1985ce;
var $24f104d8a8c8fcaf$export$abd8e32b826d7ea7;
var $24f104d8a8c8fcaf$export$87c99536b1b8cdd8;
var $24f104d8a8c8fcaf$export$69a3209f1a06c04d;
var $24f104d8a8c8fcaf$export$8c538325882c7eec;
var $24f104d8a8c8fcaf$export$e530037191fcd5d7;
var $24f104d8a8c8fcaf$export$fd42f52fd3ae1109;
var $24f104d8a8c8fcaf$export$c8a8987d4410bf2d;
var $24f104d8a8c8fcaf$export$7d1e3a5e95ceca43;
var $24f104d8a8c8fcaf$export$257a8862b851cb5b;
var $24f104d8a8c8fcaf$export$a8257692ac88316c;
var $24f104d8a8c8fcaf$export$488013bae63b21da;
var $24f104d8a8c8fcaf$export$7c73462e0d25e514;
var $24f104d8a8c8fcaf$export$7568632d0d33d16d;
var $24f104d8a8c8fcaf$export$f93f40ac0ca7e3a8;
var $24f104d8a8c8fcaf$export$1f96ae73734a86cc;
var $24f104d8a8c8fcaf$export$9a47ced3238df325;
var $24f104d8a8c8fcaf$export$35808ee640e87ca7;
var $24f104d8a8c8fcaf$export$fae74005e78b1a27;
var $24f104d8a8c8fcaf$export$dc8fbce3eb94dc1e;
var $24f104d8a8c8fcaf$export$6a7bc4e911dc01cf;
var $24f104d8a8c8fcaf$export$6d9c69b0de29b591;
var $24f104d8a8c8fcaf$export$7f54fc3180508a52;
var $24f104d8a8c8fcaf$export$f680877a34711e37;
var $24f104d8a8c8fcaf$export$d5a552a76deda3c2;
var $24f104d8a8c8fcaf$export$aaabe4eda9ed9969;
var $24f104d8a8c8fcaf$export$e5c5a5f917a5871c;
var $24f104d8a8c8fcaf$export$1538c33de8887b59;
var $24f104d8a8c8fcaf$export$fca7f784ae7a249a;
var $24f104d8a8c8fcaf$export$13e3392192263954;
var $24f104d8a8c8fcaf$export$b8f5890fc79d6aca;
var $24f104d8a8c8fcaf$export$60241385465d0a34;
var $24f104d8a8c8fcaf$export$306c0aa65ff9ec16;
var $24f104d8a8c8fcaf$export$7b286972b8d8ccbf;
var $24f104d8a8c8fcaf$export$83d89fbfd8236492;
"use strict";
var $24f104d8a8c8fcaf$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $24f104d8a8c8fcaf$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $24f104d8a8c8fcaf$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $24f104d8a8c8fcaf$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $24f104d8a8c8fcaf$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $24f104d8a8c8fcaf$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $24f104d8a8c8fcaf$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $24f104d8a8c8fcaf$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $24f104d8a8c8fcaf$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $24f104d8a8c8fcaf$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $24f104d8a8c8fcaf$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $24f104d8a8c8fcaf$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $24f104d8a8c8fcaf$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $24f104d8a8c8fcaf$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $24f104d8a8c8fcaf$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $24f104d8a8c8fcaf$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$24f104d8a8c8fcaf$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $24f104d8a8c8fcaf$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $24f104d8a8c8fcaf$var$assign = Object.assign, $24f104d8a8c8fcaf$var$emptyObject = {};
function $24f104d8a8c8fcaf$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $24f104d8a8c8fcaf$var$emptyObject;
    this.updater = updater || $24f104d8a8c8fcaf$var$ReactNoopUpdateQueue;
}
$24f104d8a8c8fcaf$var$Component.prototype.isReactComponent = {};
$24f104d8a8c8fcaf$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$24f104d8a8c8fcaf$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $24f104d8a8c8fcaf$var$ComponentDummy() {}
$24f104d8a8c8fcaf$var$ComponentDummy.prototype = $24f104d8a8c8fcaf$var$Component.prototype;
function $24f104d8a8c8fcaf$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $24f104d8a8c8fcaf$var$emptyObject;
    this.updater = updater || $24f104d8a8c8fcaf$var$ReactNoopUpdateQueue;
}
var $24f104d8a8c8fcaf$var$pureComponentPrototype = $24f104d8a8c8fcaf$var$PureComponent.prototype = new $24f104d8a8c8fcaf$var$ComponentDummy();
$24f104d8a8c8fcaf$var$pureComponentPrototype.constructor = $24f104d8a8c8fcaf$var$PureComponent;
$24f104d8a8c8fcaf$var$assign($24f104d8a8c8fcaf$var$pureComponentPrototype, $24f104d8a8c8fcaf$var$Component.prototype);
$24f104d8a8c8fcaf$var$pureComponentPrototype.isPureReactComponent = !0;
var $24f104d8a8c8fcaf$var$isArrayImpl = Array.isArray;
function $24f104d8a8c8fcaf$var$noop() {}
var $24f104d8a8c8fcaf$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $24f104d8a8c8fcaf$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $24f104d8a8c8fcaf$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $24f104d8a8c8fcaf$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $24f104d8a8c8fcaf$var$cloneAndReplaceKey(oldElement, newKey) {
    return $24f104d8a8c8fcaf$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $24f104d8a8c8fcaf$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $24f104d8a8c8fcaf$var$REACT_ELEMENT_TYPE;
}
function $24f104d8a8c8fcaf$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $24f104d8a8c8fcaf$var$userProvidedKeyEscapeRegex = /\/+/g;
function $24f104d8a8c8fcaf$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $24f104d8a8c8fcaf$var$escape("" + element.key) : index.toString(36);
}
function $24f104d8a8c8fcaf$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($24f104d8a8c8fcaf$var$noop, $24f104d8a8c8fcaf$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $24f104d8a8c8fcaf$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $24f104d8a8c8fcaf$var$REACT_ELEMENT_TYPE:
                case $24f104d8a8c8fcaf$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $24f104d8a8c8fcaf$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $24f104d8a8c8fcaf$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $24f104d8a8c8fcaf$var$getElementKey(children, 0) : nameSoFar, $24f104d8a8c8fcaf$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($24f104d8a8c8fcaf$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $24f104d8a8c8fcaf$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($24f104d8a8c8fcaf$var$isValidElement(callback) && (callback = $24f104d8a8c8fcaf$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($24f104d8a8c8fcaf$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($24f104d8a8c8fcaf$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $24f104d8a8c8fcaf$var$getElementKey(nameSoFar, i), invokeCallback += $24f104d8a8c8fcaf$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $24f104d8a8c8fcaf$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $24f104d8a8c8fcaf$var$getElementKey(nameSoFar, i++), invokeCallback += $24f104d8a8c8fcaf$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $24f104d8a8c8fcaf$var$mapIntoArray($24f104d8a8c8fcaf$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $24f104d8a8c8fcaf$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $24f104d8a8c8fcaf$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $24f104d8a8c8fcaf$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result, thenable = ctor();
        thenable.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject, void 0 === thenable.status && (thenable.status = "fulfilled", thenable.value = moduleObject);
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error, void 0 === thenable.status && (thenable.status = "rejected", thenable.reason = error);
        });
        -1 === payload._status && (payload._status = 0, payload._result = thenable);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $24f104d8a8c8fcaf$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $24f104d8a8c8fcaf$var$startTransition(scope) {
    var prevTransition = $24f104d8a8c8fcaf$var$ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    $24f104d8a8c8fcaf$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $24f104d8a8c8fcaf$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($24f104d8a8c8fcaf$var$noop, $24f104d8a8c8fcaf$var$reportGlobalError);
    } catch (error) {
        $24f104d8a8c8fcaf$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $24f104d8a8c8fcaf$var$ReactSharedInternals.T = prevTransition;
    }
}
function $24f104d8a8c8fcaf$var$addTransitionType(type) {
    var transition = $24f104d8a8c8fcaf$var$ReactSharedInternals.T;
    if (null !== transition) {
        var transitionTypes = transition.types;
        null === transitionTypes ? transition.types = [
            type
        ] : -1 === transitionTypes.indexOf(type) && transitionTypes.push(type);
    } else $24f104d8a8c8fcaf$var$startTransition($24f104d8a8c8fcaf$var$addTransitionType.bind(null, type));
}
var $24f104d8a8c8fcaf$var$Children = {
    map: $24f104d8a8c8fcaf$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $24f104d8a8c8fcaf$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $24f104d8a8c8fcaf$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $24f104d8a8c8fcaf$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$24f104d8a8c8fcaf$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$24f104d8a8c8fcaf$export$9c16c1426311996d = $24f104d8a8c8fcaf$var$REACT_ACTIVITY_TYPE;
$24f104d8a8c8fcaf$export$dca3b0875bd9a954 = $24f104d8a8c8fcaf$var$Children;
$24f104d8a8c8fcaf$export$16fa2f45be04daa8 = $24f104d8a8c8fcaf$var$Component;
$24f104d8a8c8fcaf$export$ffb0004e005737fa = $24f104d8a8c8fcaf$var$REACT_FRAGMENT_TYPE;
$24f104d8a8c8fcaf$export$e2c29f18771995cb = $24f104d8a8c8fcaf$var$REACT_PROFILER_TYPE;
$24f104d8a8c8fcaf$export$221d75b3f55bb0bd = $24f104d8a8c8fcaf$var$PureComponent;
$24f104d8a8c8fcaf$export$5f8d39834fd61797 = $24f104d8a8c8fcaf$var$REACT_STRICT_MODE_TYPE;
$24f104d8a8c8fcaf$export$74bf444e3cd11ea5 = $24f104d8a8c8fcaf$var$REACT_SUSPENSE_TYPE;
$24f104d8a8c8fcaf$export$8cdaa4703948c5e9 = $24f104d8a8c8fcaf$var$REACT_VIEW_TRANSITION_TYPE;
$24f104d8a8c8fcaf$export$1ced07cd6b1985ce = $24f104d8a8c8fcaf$var$ReactSharedInternals;
$24f104d8a8c8fcaf$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $24f104d8a8c8fcaf$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$24f104d8a8c8fcaf$export$87c99536b1b8cdd8 = $24f104d8a8c8fcaf$var$addTransitionType;
$24f104d8a8c8fcaf$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$24f104d8a8c8fcaf$export$8c538325882c7eec = function() {
    return null;
};
$24f104d8a8c8fcaf$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $24f104d8a8c8fcaf$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$24f104d8a8c8fcaf$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $24f104d8a8c8fcaf$var$ReactElement(element.type, key, props);
};
$24f104d8a8c8fcaf$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $24f104d8a8c8fcaf$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $24f104d8a8c8fcaf$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$24f104d8a8c8fcaf$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$24f104d8a8c8fcaf$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $24f104d8a8c8fcaf$var$ReactElement(type, key, props);
};
$24f104d8a8c8fcaf$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$24f104d8a8c8fcaf$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $24f104d8a8c8fcaf$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$24f104d8a8c8fcaf$export$a8257692ac88316c = $24f104d8a8c8fcaf$var$isValidElement;
$24f104d8a8c8fcaf$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $24f104d8a8c8fcaf$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $24f104d8a8c8fcaf$var$lazyInitializer
    };
};
$24f104d8a8c8fcaf$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $24f104d8a8c8fcaf$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$24f104d8a8c8fcaf$export$7568632d0d33d16d = $24f104d8a8c8fcaf$var$startTransition;
$24f104d8a8c8fcaf$export$f93f40ac0ca7e3a8 = function() {
    return $24f104d8a8c8fcaf$var$ReactSharedInternals.H.useCacheRefresh();
};
$24f104d8a8c8fcaf$export$1f96ae73734a86cc = function(usable) {
    return $24f104d8a8c8fcaf$var$ReactSharedInternals.H.use(usable);
};
$24f104d8a8c8fcaf$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $24f104d8a8c8fcaf$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$24f104d8a8c8fcaf$export$35808ee640e87ca7 = function(callback, deps) {
    return $24f104d8a8c8fcaf$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$24f104d8a8c8fcaf$export$fae74005e78b1a27 = function(Context) {
    return $24f104d8a8c8fcaf$var$ReactSharedInternals.H.useContext(Context);
};
$24f104d8a8c8fcaf$export$dc8fbce3eb94dc1e = function() {};
$24f104d8a8c8fcaf$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $24f104d8a8c8fcaf$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$24f104d8a8c8fcaf$export$6d9c69b0de29b591 = function(create, deps) {
    return $24f104d8a8c8fcaf$var$ReactSharedInternals.H.useEffect(create, deps);
};
$24f104d8a8c8fcaf$export$7f54fc3180508a52 = function(callback) {
    return $24f104d8a8c8fcaf$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$24f104d8a8c8fcaf$export$f680877a34711e37 = function() {
    return $24f104d8a8c8fcaf$var$ReactSharedInternals.H.useId();
};
$24f104d8a8c8fcaf$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $24f104d8a8c8fcaf$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$24f104d8a8c8fcaf$export$aaabe4eda9ed9969 = function(create, deps) {
    return $24f104d8a8c8fcaf$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$24f104d8a8c8fcaf$export$e5c5a5f917a5871c = function(create, deps) {
    return $24f104d8a8c8fcaf$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$24f104d8a8c8fcaf$export$1538c33de8887b59 = function(create, deps) {
    return $24f104d8a8c8fcaf$var$ReactSharedInternals.H.useMemo(create, deps);
};
$24f104d8a8c8fcaf$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $24f104d8a8c8fcaf$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$24f104d8a8c8fcaf$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $24f104d8a8c8fcaf$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$24f104d8a8c8fcaf$export$b8f5890fc79d6aca = function(initialValue) {
    return $24f104d8a8c8fcaf$var$ReactSharedInternals.H.useRef(initialValue);
};
$24f104d8a8c8fcaf$export$60241385465d0a34 = function(initialState) {
    return $24f104d8a8c8fcaf$var$ReactSharedInternals.H.useState(initialState);
};
$24f104d8a8c8fcaf$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $24f104d8a8c8fcaf$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$24f104d8a8c8fcaf$export$7b286972b8d8ccbf = function() {
    return $24f104d8a8c8fcaf$var$ReactSharedInternals.H.useTransition();
};
$24f104d8a8c8fcaf$export$83d89fbfd8236492 = "19.3.1";

});


parcelRegister("k7KD3", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $ea68a19c2d46a931$export$882461b6382ed46c; }, function (v) { return $ea68a19c2d46a931$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $ea68a19c2d46a931$export$757ceba2d55c277e; }, function (v) { return $ea68a19c2d46a931$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $ea68a19c2d46a931$export$83d89fbfd8236492; }, function (v) { return $ea68a19c2d46a931$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $ea68a19c2d46a931$export$882461b6382ed46c;
var $ea68a19c2d46a931$export$757ceba2d55c277e;
var $ea68a19c2d46a931$export$83d89fbfd8236492;
"use strict";

var $953uR = parcelRequire("953uR");

var $jpgPw = parcelRequire("jpgPw");

var $3dD61 = parcelRequire("3dD61");
function $ea68a19c2d46a931$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $ea68a19c2d46a931$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $ea68a19c2d46a931$var$getNearestMountedFiber(fiber) {
    for(var node = fiber, nextNode = node; nextNode && !nextNode.alternate;)node = nextNode, 0 !== (node.flags & 4098) && (fiber = node.return), nextNode = node.return;
    for(; node.return;)node = node.return;
    return 3 === node.tag ? fiber : null;
}
function $ea68a19c2d46a931$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $ea68a19c2d46a931$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $ea68a19c2d46a931$var$assertIsMounted(fiber) {
    if ($ea68a19c2d46a931$var$getNearestMountedFiber(fiber) !== fiber) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(188));
}
function $ea68a19c2d46a931$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $ea68a19c2d46a931$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $ea68a19c2d46a931$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $ea68a19c2d46a931$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $ea68a19c2d46a931$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $ea68a19c2d46a931$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
function $ea68a19c2d46a931$var$traverseVisibleInstancesAndTextInstances(child, searchWithinHosts, fn, a, b, c) {
    for(; null !== child;){
        if ((5 === child.tag || 27 === child.tag || 6 === child.tag) && fn(child, a, b, c) || (22 !== child.tag || null === child.memoizedState) && (searchWithinHosts || 5 !== child.tag && 27 !== child.tag) && $ea68a19c2d46a931$var$traverseVisibleInstancesAndTextInstances(child.child, searchWithinHosts, fn, a, b, c)) return !0;
        child = child.sibling;
    }
    return !1;
}
function $ea68a19c2d46a931$var$getFragmentParentInstanceOrContainerFiber(fiber) {
    for(fiber = fiber.return; null !== fiber;){
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) return fiber;
        fiber = fiber.return;
    }
    return null;
}
function $ea68a19c2d46a931$var$fiberIsPortaledIntoHost(fiber) {
    var foundPortalParent = !1;
    for(fiber = fiber.return; null !== fiber;){
        4 === fiber.tag && (foundPortalParent = !0);
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) break;
        fiber = fiber.return;
    }
    return foundPortalParent;
}
function $ea68a19c2d46a931$var$getFragmentInstanceOrTextInstanceSiblings(fiber) {
    var result = [
        null,
        null
    ], parentHostFiber = $ea68a19c2d46a931$var$getFragmentParentInstanceOrContainerFiber(fiber);
    if (null === parentHostFiber) return result;
    $ea68a19c2d46a931$var$findFragmentInstanceOrTextInstanceSiblings(result, fiber, parentHostFiber.child, {
        foundSelf: !1
    });
    return result;
}
function $ea68a19c2d46a931$var$findFragmentInstanceOrTextInstanceSiblings(result, self, child, state) {
    for(; null !== child;){
        if (child === self) state.foundSelf = !0;
        else if (5 === child.tag || 27 === child.tag || 6 === child.tag) {
            if (state.foundSelf) return result[1] = child, !0;
            result[0] = child;
        } else if ((22 !== child.tag || null === child.memoizedState) && $ea68a19c2d46a931$var$findFragmentInstanceOrTextInstanceSiblings(result, self, child.child, state)) return !0;
        child = child.sibling;
    }
    return !1;
}
function $ea68a19c2d46a931$var$getInstanceFromHostFiber(fiber) {
    switch(fiber.tag){
        case 5:
        case 27:
        case 6:
            return fiber.stateNode;
        case 3:
            return fiber.stateNode.containerInfo;
        default:
            throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(559));
    }
}
var $ea68a19c2d46a931$var$searchTarget = null, $ea68a19c2d46a931$var$searchBoundary = null;
function $ea68a19c2d46a931$var$isFiberPrecedingCheck(child, target, boundary) {
    return child === boundary ? !0 : child === target ? ($ea68a19c2d46a931$var$searchTarget = child, !0) : !1;
}
function $ea68a19c2d46a931$var$isFiberFollowingCheck(child, target, boundary) {
    return child === boundary ? ($ea68a19c2d46a931$var$searchBoundary = child, !1) : child === target ? (null !== $ea68a19c2d46a931$var$searchBoundary && ($ea68a19c2d46a931$var$searchTarget = child), !0) : !1;
}
function $ea68a19c2d46a931$var$getParentForFragmentAncestors(inst) {
    if (null === inst) return null;
    do inst = null === inst ? null : inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag && 3 !== inst.tag);
    return inst ? inst : null;
}
function $ea68a19c2d46a931$var$getLowestCommonAncestor(instA, instB, getParent) {
    for(var depthA = 0, tempA = instA; tempA; tempA = getParent(tempA))depthA++;
    tempA = 0;
    for(var tempB = instB; tempB; tempB = getParent(tempB))tempA++;
    for(; 0 < depthA - tempA;)instA = getParent(instA), depthA--;
    for(; 0 < tempA - depthA;)instB = getParent(instB), tempA--;
    for(; depthA--;){
        if (instA === instB || null !== instB && instA === instB.alternate) return instA;
        instA = getParent(instA);
        instB = getParent(instB);
    }
    return null;
}
var $ea68a19c2d46a931$var$assign = Object.assign, $ea68a19c2d46a931$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $ea68a19c2d46a931$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $ea68a19c2d46a931$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $ea68a19c2d46a931$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $ea68a19c2d46a931$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $ea68a19c2d46a931$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $ea68a19c2d46a931$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $ea68a19c2d46a931$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $ea68a19c2d46a931$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $ea68a19c2d46a931$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $ea68a19c2d46a931$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $ea68a19c2d46a931$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $ea68a19c2d46a931$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $ea68a19c2d46a931$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $ea68a19c2d46a931$var$REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $ea68a19c2d46a931$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), $ea68a19c2d46a931$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $ea68a19c2d46a931$var$REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), $ea68a19c2d46a931$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $ea68a19c2d46a931$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $ea68a19c2d46a931$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$ea68a19c2d46a931$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $ea68a19c2d46a931$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $ea68a19c2d46a931$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $ea68a19c2d46a931$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $ea68a19c2d46a931$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $ea68a19c2d46a931$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $ea68a19c2d46a931$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $ea68a19c2d46a931$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $ea68a19c2d46a931$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $ea68a19c2d46a931$var$REACT_ACTIVITY_TYPE:
            return "Activity";
        case $ea68a19c2d46a931$var$REACT_VIEW_TRANSITION_TYPE:
            return "ViewTransition";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $ea68a19c2d46a931$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $ea68a19c2d46a931$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $ea68a19c2d46a931$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $ea68a19c2d46a931$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $ea68a19c2d46a931$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $ea68a19c2d46a931$var$getComponentNameFromType(type.type) || "Memo";
        case $ea68a19c2d46a931$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $ea68a19c2d46a931$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $ea68a19c2d46a931$var$isArrayImpl = Array.isArray, $ea68a19c2d46a931$var$ReactSharedInternals = $jpgPw.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $ea68a19c2d46a931$var$ReactDOMSharedInternals = $3dD61.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $ea68a19c2d46a931$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $ea68a19c2d46a931$var$valueStack = [], $ea68a19c2d46a931$var$index = -1;
function $ea68a19c2d46a931$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $ea68a19c2d46a931$var$pop(cursor) {
    0 > $ea68a19c2d46a931$var$index || (cursor.current = $ea68a19c2d46a931$var$valueStack[$ea68a19c2d46a931$var$index], $ea68a19c2d46a931$var$valueStack[$ea68a19c2d46a931$var$index] = null, $ea68a19c2d46a931$var$index--);
}
function $ea68a19c2d46a931$var$push(cursor, value) {
    $ea68a19c2d46a931$var$index++;
    $ea68a19c2d46a931$var$valueStack[$ea68a19c2d46a931$var$index] = cursor.current;
    cursor.current = value;
}
var $ea68a19c2d46a931$var$contextStackCursor = $ea68a19c2d46a931$var$createCursor(null), $ea68a19c2d46a931$var$contextFiberStackCursor = $ea68a19c2d46a931$var$createCursor(null), $ea68a19c2d46a931$var$rootInstanceStackCursor = $ea68a19c2d46a931$var$createCursor(null), $ea68a19c2d46a931$var$hostTransitionProviderCursor = $ea68a19c2d46a931$var$createCursor(null);
function $ea68a19c2d46a931$var$pushHostContainer(fiber, nextRootInstance) {
    $ea68a19c2d46a931$var$push($ea68a19c2d46a931$var$rootInstanceStackCursor, nextRootInstance);
    $ea68a19c2d46a931$var$push($ea68a19c2d46a931$var$contextFiberStackCursor, fiber);
    $ea68a19c2d46a931$var$push($ea68a19c2d46a931$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $ea68a19c2d46a931$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $ea68a19c2d46a931$var$getOwnHostContext(nextRootInstance), fiber = $ea68a19c2d46a931$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $ea68a19c2d46a931$var$pop($ea68a19c2d46a931$var$contextStackCursor);
    $ea68a19c2d46a931$var$push($ea68a19c2d46a931$var$contextStackCursor, fiber);
}
function $ea68a19c2d46a931$var$popHostContainer() {
    $ea68a19c2d46a931$var$pop($ea68a19c2d46a931$var$contextStackCursor);
    $ea68a19c2d46a931$var$pop($ea68a19c2d46a931$var$contextFiberStackCursor);
    $ea68a19c2d46a931$var$pop($ea68a19c2d46a931$var$rootInstanceStackCursor);
}
function $ea68a19c2d46a931$var$pushHostContext(fiber) {
    var stateHook = fiber.memoizedState;
    null !== stateHook && ($ea68a19c2d46a931$var$HostTransitionContext._currentValue = stateHook.memoizedState, $ea68a19c2d46a931$var$push($ea68a19c2d46a931$var$hostTransitionProviderCursor, fiber));
    stateHook = $ea68a19c2d46a931$var$contextStackCursor.current;
    var JSCompiler_inline_result = $ea68a19c2d46a931$var$getChildHostContextProd(stateHook, fiber.type);
    stateHook !== JSCompiler_inline_result && ($ea68a19c2d46a931$var$push($ea68a19c2d46a931$var$contextFiberStackCursor, fiber), $ea68a19c2d46a931$var$push($ea68a19c2d46a931$var$contextStackCursor, JSCompiler_inline_result));
}
function $ea68a19c2d46a931$var$popHostContext(fiber) {
    $ea68a19c2d46a931$var$contextFiberStackCursor.current === fiber && ($ea68a19c2d46a931$var$pop($ea68a19c2d46a931$var$contextStackCursor), $ea68a19c2d46a931$var$pop($ea68a19c2d46a931$var$contextFiberStackCursor));
    $ea68a19c2d46a931$var$hostTransitionProviderCursor.current === fiber && ($ea68a19c2d46a931$var$pop($ea68a19c2d46a931$var$hostTransitionProviderCursor), $ea68a19c2d46a931$var$HostTransitionContext._currentValue = $ea68a19c2d46a931$var$sharedNotPendingObject);
}
var $ea68a19c2d46a931$var$prefix, $ea68a19c2d46a931$var$suffix;
function $ea68a19c2d46a931$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $ea68a19c2d46a931$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $ea68a19c2d46a931$var$prefix = match && match[1] || "";
        $ea68a19c2d46a931$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $ea68a19c2d46a931$var$prefix + name + $ea68a19c2d46a931$var$suffix;
}
var $ea68a19c2d46a931$var$reentry = !1;
function $ea68a19c2d46a931$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $ea68a19c2d46a931$var$reentry) return "";
    $ea68a19c2d46a931$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            Fake = !1;
                            try {
                                var prevProps = Object.getOwnPropertyDescriptor(fn.prototype, "props");
                                Object.defineProperty(fn.prototype, "props", {
                                    configurable: !0,
                                    set: function() {
                                        throw Error();
                                    }
                                });
                                Fake = !0;
                                new fn();
                            } finally{
                                Fake && (void 0 !== prevProps ? Object.defineProperty(fn.prototype, "props", prevProps) : delete fn.prototype.props);
                            }
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $ea68a19c2d46a931$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $ea68a19c2d46a931$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $ea68a19c2d46a931$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $ea68a19c2d46a931$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $ea68a19c2d46a931$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $ea68a19c2d46a931$var$describeBuiltInComponentFrame("Suspense Fallback") : $ea68a19c2d46a931$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $ea68a19c2d46a931$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $ea68a19c2d46a931$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $ea68a19c2d46a931$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $ea68a19c2d46a931$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $ea68a19c2d46a931$var$describeBuiltInComponentFrame("Activity");
        case 30:
            return $ea68a19c2d46a931$var$describeBuiltInComponentFrame("ViewTransition");
        default:
            return "";
    }
}
function $ea68a19c2d46a931$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $ea68a19c2d46a931$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $ea68a19c2d46a931$var$hasOwnProperty = Object.prototype.hasOwnProperty, $ea68a19c2d46a931$var$scheduleCallback$3 = $953uR.unstable_scheduleCallback, $ea68a19c2d46a931$var$cancelCallback$1 = $953uR.unstable_cancelCallback, $ea68a19c2d46a931$var$shouldYield = $953uR.unstable_shouldYield, $ea68a19c2d46a931$var$requestPaint = $953uR.unstable_requestPaint, $ea68a19c2d46a931$var$now = $953uR.unstable_now, $ea68a19c2d46a931$var$getCurrentPriorityLevel = $953uR.unstable_getCurrentPriorityLevel, $ea68a19c2d46a931$var$ImmediatePriority = $953uR.unstable_ImmediatePriority, $ea68a19c2d46a931$var$UserBlockingPriority = $953uR.unstable_UserBlockingPriority, $ea68a19c2d46a931$var$NormalPriority$1 = $953uR.unstable_NormalPriority, $ea68a19c2d46a931$var$LowPriority = $953uR.unstable_LowPriority, $ea68a19c2d46a931$var$IdlePriority = $953uR.unstable_IdlePriority, $ea68a19c2d46a931$var$log$1 = $953uR.log, $ea68a19c2d46a931$var$unstable_setDisableYieldValue = $953uR.unstable_setDisableYieldValue, $ea68a19c2d46a931$var$rendererID = null, $ea68a19c2d46a931$var$injectedHook = null;
function $ea68a19c2d46a931$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $ea68a19c2d46a931$var$log$1 && $ea68a19c2d46a931$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($ea68a19c2d46a931$var$injectedHook && "function" === typeof $ea68a19c2d46a931$var$injectedHook.setStrictMode) try {
        $ea68a19c2d46a931$var$injectedHook.setStrictMode($ea68a19c2d46a931$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $ea68a19c2d46a931$var$clz32 = Math.clz32 ? Math.clz32 : $ea68a19c2d46a931$var$clz32Fallback, $ea68a19c2d46a931$var$log = Math.log, $ea68a19c2d46a931$var$LN2 = Math.LN2;
function $ea68a19c2d46a931$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($ea68a19c2d46a931$var$log(x) / $ea68a19c2d46a931$var$LN2 | 0) | 0;
}
var $ea68a19c2d46a931$var$nextTransitionUpdateLane = 256, $ea68a19c2d46a931$var$nextTransitionDeferredLane = 262144, $ea68a19c2d46a931$var$nextRetryLane = 4194304;
function $ea68a19c2d46a931$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & -lanes;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $ea68a19c2d46a931$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $ea68a19c2d46a931$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $ea68a19c2d46a931$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $ea68a19c2d46a931$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $ea68a19c2d46a931$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $ea68a19c2d46a931$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $ea68a19c2d46a931$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $ea68a19c2d46a931$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $ea68a19c2d46a931$var$getEntangledLanes(root, renderLanes) {
    0 !== (renderLanes & 8) && (renderLanes |= renderLanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= renderLanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $ea68a19c2d46a931$var$clz32(allEntangledLanes), lane = 1 << index$4;
        renderLanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    return renderLanes;
}
function $ea68a19c2d46a931$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $ea68a19c2d46a931$var$claimNextRetryLane() {
    var lane = $ea68a19c2d46a931$var$nextRetryLane;
    $ea68a19c2d46a931$var$nextRetryLane <<= 1;
    0 === ($ea68a19c2d46a931$var$nextRetryLane & 62914560) && ($ea68a19c2d46a931$var$nextRetryLane = 4194304);
    return lane;
}
function $ea68a19c2d46a931$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $ea68a19c2d46a931$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $ea68a19c2d46a931$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $ea68a19c2d46a931$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $ea68a19c2d46a931$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $ea68a19c2d46a931$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $ea68a19c2d46a931$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $ea68a19c2d46a931$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $ea68a19c2d46a931$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $ea68a19c2d46a931$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $ea68a19c2d46a931$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $ea68a19c2d46a931$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $ea68a19c2d46a931$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $ea68a19c2d46a931$var$resolveUpdatePriority() {
    var updatePriority = $ea68a19c2d46a931$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $ea68a19c2d46a931$var$getEventPriority(updatePriority.type);
}
function $ea68a19c2d46a931$var$runWithPriority(priority, fn) {
    var previousPriority = $ea68a19c2d46a931$var$ReactDOMSharedInternals.p;
    try {
        return $ea68a19c2d46a931$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $ea68a19c2d46a931$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $ea68a19c2d46a931$var$randomKey = Math.random().toString(36).slice(2), $ea68a19c2d46a931$var$internalInstanceKey = "__reactFiber$" + $ea68a19c2d46a931$var$randomKey, $ea68a19c2d46a931$var$internalPropsKey = "__reactProps$" + $ea68a19c2d46a931$var$randomKey, $ea68a19c2d46a931$var$internalContainerInstanceKey = "__reactContainer$" + $ea68a19c2d46a931$var$randomKey, $ea68a19c2d46a931$var$internalEventHandlersKey = "__reactEvents$" + $ea68a19c2d46a931$var$randomKey, $ea68a19c2d46a931$var$internalEventHandlerListenersKey = "__reactListeners$" + $ea68a19c2d46a931$var$randomKey, $ea68a19c2d46a931$var$internalEventHandlesSetKey = "__reactHandles$" + $ea68a19c2d46a931$var$randomKey, $ea68a19c2d46a931$var$internalRootNodeResourcesKey = "__reactResources$" + $ea68a19c2d46a931$var$randomKey, $ea68a19c2d46a931$var$internalHoistableMarker = "__reactMarker$" + $ea68a19c2d46a931$var$randomKey, $ea68a19c2d46a931$var$internalLoadPendingKey = "__reactLoad$" + $ea68a19c2d46a931$var$randomKey;
function $ea68a19c2d46a931$var$detachDeletedInstance(node) {
    delete node[$ea68a19c2d46a931$var$internalInstanceKey];
    delete node[$ea68a19c2d46a931$var$internalPropsKey];
    delete node[$ea68a19c2d46a931$var$internalEventHandlerListenersKey];
    delete node[$ea68a19c2d46a931$var$internalEventHandlesSetKey];
}
function $ea68a19c2d46a931$var$getClosestInstanceFromNode(targetNode) {
    var targetInst;
    if (targetInst = targetNode[$ea68a19c2d46a931$var$internalInstanceKey]) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$ea68a19c2d46a931$var$internalContainerInstanceKey] || parentNode[$ea68a19c2d46a931$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $ea68a19c2d46a931$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$ea68a19c2d46a931$var$internalInstanceKey]) return parentNode;
                targetNode = $ea68a19c2d46a931$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $ea68a19c2d46a931$var$getInstanceFromNode(node) {
    if (node = node[$ea68a19c2d46a931$var$internalInstanceKey] || node[$ea68a19c2d46a931$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $ea68a19c2d46a931$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(33));
}
function $ea68a19c2d46a931$var$getResourcesFromRoot(root) {
    var resources = root[$ea68a19c2d46a931$var$internalRootNodeResourcesKey];
    resources || (resources = root[$ea68a19c2d46a931$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $ea68a19c2d46a931$var$markNodeAsHoistable(node) {
    node[$ea68a19c2d46a931$var$internalHoistableMarker] = !0;
}
function $ea68a19c2d46a931$var$clearPendingLoadOnNode(node) {
    node[$ea68a19c2d46a931$var$internalLoadPendingKey] = void 0;
}
var $ea68a19c2d46a931$var$allNativeEvents = new Set(), $ea68a19c2d46a931$var$registrationNameDependencies = {};
function $ea68a19c2d46a931$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $ea68a19c2d46a931$var$registerDirectEvent(registrationName, dependencies);
    $ea68a19c2d46a931$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $ea68a19c2d46a931$var$registerDirectEvent(registrationName, dependencies) {
    $ea68a19c2d46a931$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$ea68a19c2d46a931$var$allNativeEvents.add(dependencies[registrationName]);
}
var $ea68a19c2d46a931$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $ea68a19c2d46a931$var$illegalAttributeNameCache = {}, $ea68a19c2d46a931$var$validatedAttributeNameCache = {};
function $ea68a19c2d46a931$var$isAttributeNameSafe(attributeName) {
    if ($ea68a19c2d46a931$var$hasOwnProperty.call($ea68a19c2d46a931$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($ea68a19c2d46a931$var$hasOwnProperty.call($ea68a19c2d46a931$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($ea68a19c2d46a931$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $ea68a19c2d46a931$var$validatedAttributeNameCache[attributeName] = !0;
    $ea68a19c2d46a931$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
var $ea68a19c2d46a931$var$viewTransitionMutationContext = !1;
function $ea68a19c2d46a931$var$pushMutationContext() {
    var prev = $ea68a19c2d46a931$var$viewTransitionMutationContext;
    $ea68a19c2d46a931$var$viewTransitionMutationContext = !1;
    return prev;
}
function $ea68a19c2d46a931$var$setValueForAttribute(node, name, value) {
    if ($ea68a19c2d46a931$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, value);
        }
    }
}
function $ea68a19c2d46a931$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, value);
    }
}
function $ea68a19c2d46a931$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, value);
    }
}
function $ea68a19c2d46a931$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $ea68a19c2d46a931$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $ea68a19c2d46a931$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $ea68a19c2d46a931$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $ea68a19c2d46a931$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $ea68a19c2d46a931$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $ea68a19c2d46a931$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $ea68a19c2d46a931$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
var $ea68a19c2d46a931$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $ea68a19c2d46a931$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($ea68a19c2d46a931$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $ea68a19c2d46a931$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $ea68a19c2d46a931$var$getToStringValue(value);
        } else element.value !== "" + $ea68a19c2d46a931$var$getToStringValue(value) && (element.value = "" + $ea68a19c2d46a931$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? "number" === type && element.value == value ? $ea68a19c2d46a931$var$setDefaultValue(element, $ea68a19c2d46a931$var$getToStringValue(element.value)) : $ea68a19c2d46a931$var$setDefaultValue(element, $ea68a19c2d46a931$var$getToStringValue(value)) : null != defaultValue ? $ea68a19c2d46a931$var$setDefaultValue(element, $ea68a19c2d46a931$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $ea68a19c2d46a931$var$getToStringValue(name) : element.removeAttribute("name");
}
function $ea68a19c2d46a931$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $ea68a19c2d46a931$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $ea68a19c2d46a931$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $ea68a19c2d46a931$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $ea68a19c2d46a931$var$track(element);
}
function $ea68a19c2d46a931$var$setDefaultValue(node, value) {
    node.defaultValue !== "" + value && (node.defaultValue = "" + value);
}
function $ea68a19c2d46a931$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $ea68a19c2d46a931$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $ea68a19c2d46a931$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $ea68a19c2d46a931$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $ea68a19c2d46a931$var$getToStringValue(defaultValue) : "";
}
function $ea68a19c2d46a931$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(92));
            if ($ea68a19c2d46a931$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $ea68a19c2d46a931$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $ea68a19c2d46a931$var$track(element);
}
function $ea68a19c2d46a931$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $ea68a19c2d46a931$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $ea68a19c2d46a931$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $ea68a19c2d46a931$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $ea68a19c2d46a931$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "", $ea68a19c2d46a931$var$viewTransitionMutationContext = !0);
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && ($ea68a19c2d46a931$var$setValueForStyle(node, styleName$16, styleName), $ea68a19c2d46a931$var$viewTransitionMutationContext = !0);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $ea68a19c2d46a931$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $ea68a19c2d46a931$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $ea68a19c2d46a931$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "maskType",
        "mask-type"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $ea68a19c2d46a931$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $ea68a19c2d46a931$var$sanitizeURL(url) {
    return $ea68a19c2d46a931$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $ea68a19c2d46a931$var$noop$1() {}
var $ea68a19c2d46a931$var$currentReplayingEvent = null;
function $ea68a19c2d46a931$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $ea68a19c2d46a931$var$restoreTarget = null, $ea68a19c2d46a931$var$restoreQueue = null;
function $ea68a19c2d46a931$var$restoreStateOfTarget(target) {
    var internalInstance = $ea68a19c2d46a931$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$ea68a19c2d46a931$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $ea68a19c2d46a931$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $ea68a19c2d46a931$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$ea68a19c2d46a931$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(90));
                            $ea68a19c2d46a931$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $ea68a19c2d46a931$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $ea68a19c2d46a931$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $ea68a19c2d46a931$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $ea68a19c2d46a931$var$isInsideEventHandler = !1;
function $ea68a19c2d46a931$var$batchedUpdates$1(fn, a, b) {
    if ($ea68a19c2d46a931$var$isInsideEventHandler) return fn(a, b);
    $ea68a19c2d46a931$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($ea68a19c2d46a931$var$isInsideEventHandler = !1, null !== $ea68a19c2d46a931$var$restoreTarget || null !== $ea68a19c2d46a931$var$restoreQueue) {
            if ($ea68a19c2d46a931$var$flushSyncWork$1(), $ea68a19c2d46a931$var$restoreTarget && (a = $ea68a19c2d46a931$var$restoreTarget, fn = $ea68a19c2d46a931$var$restoreQueue, $ea68a19c2d46a931$var$restoreQueue = $ea68a19c2d46a931$var$restoreTarget = null, $ea68a19c2d46a931$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$ea68a19c2d46a931$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $ea68a19c2d46a931$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$ea68a19c2d46a931$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $ea68a19c2d46a931$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $ea68a19c2d46a931$var$passiveBrowserEventsSupported = !1;
if ($ea68a19c2d46a931$var$canUseDOM) try {
    var $ea68a19c2d46a931$var$options = {};
    Object.defineProperty($ea68a19c2d46a931$var$options, "passive", {
        get: function() {
            $ea68a19c2d46a931$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $ea68a19c2d46a931$var$options, $ea68a19c2d46a931$var$options);
    window.removeEventListener("test", $ea68a19c2d46a931$var$options, $ea68a19c2d46a931$var$options);
} catch (e) {
    $ea68a19c2d46a931$var$passiveBrowserEventsSupported = !1;
}
var $ea68a19c2d46a931$var$root = null, $ea68a19c2d46a931$var$startText = null, $ea68a19c2d46a931$var$fallbackText = null;
function $ea68a19c2d46a931$var$getData() {
    if ($ea68a19c2d46a931$var$fallbackText) return $ea68a19c2d46a931$var$fallbackText;
    var start, startValue = $ea68a19c2d46a931$var$startText, startLength = startValue.length, end, endValue = "value" in $ea68a19c2d46a931$var$root ? $ea68a19c2d46a931$var$root.value : $ea68a19c2d46a931$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $ea68a19c2d46a931$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $ea68a19c2d46a931$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $ea68a19c2d46a931$var$functionThatReturnsTrue() {
    return !0;
}
function $ea68a19c2d46a931$var$functionThatReturnsFalse() {
    return !1;
}
function $ea68a19c2d46a931$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $ea68a19c2d46a931$var$functionThatReturnsTrue : $ea68a19c2d46a931$var$functionThatReturnsFalse;
        this.isPropagationStopped = $ea68a19c2d46a931$var$functionThatReturnsFalse;
        return this;
    }
    $ea68a19c2d46a931$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $ea68a19c2d46a931$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $ea68a19c2d46a931$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $ea68a19c2d46a931$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $ea68a19c2d46a931$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $ea68a19c2d46a931$var$SyntheticEvent = $ea68a19c2d46a931$var$createSyntheticEvent($ea68a19c2d46a931$var$EventInterface), $ea68a19c2d46a931$var$UIEventInterface = $ea68a19c2d46a931$var$assign({}, $ea68a19c2d46a931$var$EventInterface, {
    view: 0,
    detail: 0
}), $ea68a19c2d46a931$var$SyntheticUIEvent = $ea68a19c2d46a931$var$createSyntheticEvent($ea68a19c2d46a931$var$UIEventInterface), $ea68a19c2d46a931$var$lastMovementX, $ea68a19c2d46a931$var$lastMovementY, $ea68a19c2d46a931$var$lastMouseEvent, $ea68a19c2d46a931$var$MouseEventInterface = $ea68a19c2d46a931$var$assign({}, $ea68a19c2d46a931$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $ea68a19c2d46a931$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $ea68a19c2d46a931$var$lastMouseEvent && ($ea68a19c2d46a931$var$lastMouseEvent && "mousemove" === event.type ? ($ea68a19c2d46a931$var$lastMovementX = event.screenX - $ea68a19c2d46a931$var$lastMouseEvent.screenX, $ea68a19c2d46a931$var$lastMovementY = event.screenY - $ea68a19c2d46a931$var$lastMouseEvent.screenY) : $ea68a19c2d46a931$var$lastMovementY = $ea68a19c2d46a931$var$lastMovementX = 0, $ea68a19c2d46a931$var$lastMouseEvent = event);
        return $ea68a19c2d46a931$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $ea68a19c2d46a931$var$lastMovementY;
    }
}), $ea68a19c2d46a931$var$SyntheticMouseEvent = $ea68a19c2d46a931$var$createSyntheticEvent($ea68a19c2d46a931$var$MouseEventInterface), $ea68a19c2d46a931$var$DragEventInterface = $ea68a19c2d46a931$var$assign({}, $ea68a19c2d46a931$var$MouseEventInterface, {
    dataTransfer: 0
}), $ea68a19c2d46a931$var$SyntheticDragEvent = $ea68a19c2d46a931$var$createSyntheticEvent($ea68a19c2d46a931$var$DragEventInterface), $ea68a19c2d46a931$var$FocusEventInterface = $ea68a19c2d46a931$var$assign({}, $ea68a19c2d46a931$var$UIEventInterface, {
    relatedTarget: 0
}), $ea68a19c2d46a931$var$SyntheticFocusEvent = $ea68a19c2d46a931$var$createSyntheticEvent($ea68a19c2d46a931$var$FocusEventInterface), $ea68a19c2d46a931$var$AnimationEventInterface = $ea68a19c2d46a931$var$assign({}, $ea68a19c2d46a931$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $ea68a19c2d46a931$var$SyntheticAnimationEvent = $ea68a19c2d46a931$var$createSyntheticEvent($ea68a19c2d46a931$var$AnimationEventInterface), $ea68a19c2d46a931$var$ClipboardEventInterface = $ea68a19c2d46a931$var$assign({}, $ea68a19c2d46a931$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $ea68a19c2d46a931$var$SyntheticClipboardEvent = $ea68a19c2d46a931$var$createSyntheticEvent($ea68a19c2d46a931$var$ClipboardEventInterface), $ea68a19c2d46a931$var$CompositionEventInterface = $ea68a19c2d46a931$var$assign({}, $ea68a19c2d46a931$var$EventInterface, {
    data: 0
}), $ea68a19c2d46a931$var$SyntheticCompositionEvent = $ea68a19c2d46a931$var$createSyntheticEvent($ea68a19c2d46a931$var$CompositionEventInterface), $ea68a19c2d46a931$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $ea68a19c2d46a931$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $ea68a19c2d46a931$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $ea68a19c2d46a931$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $ea68a19c2d46a931$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $ea68a19c2d46a931$var$getEventModifierState() {
    return $ea68a19c2d46a931$var$modifierStateGetter;
}
var $ea68a19c2d46a931$var$KeyboardEventInterface = $ea68a19c2d46a931$var$assign({}, $ea68a19c2d46a931$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $ea68a19c2d46a931$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $ea68a19c2d46a931$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $ea68a19c2d46a931$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $ea68a19c2d46a931$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $ea68a19c2d46a931$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $ea68a19c2d46a931$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $ea68a19c2d46a931$var$SyntheticKeyboardEvent = $ea68a19c2d46a931$var$createSyntheticEvent($ea68a19c2d46a931$var$KeyboardEventInterface), $ea68a19c2d46a931$var$PointerEventInterface = $ea68a19c2d46a931$var$assign({}, $ea68a19c2d46a931$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $ea68a19c2d46a931$var$SyntheticPointerEvent = $ea68a19c2d46a931$var$createSyntheticEvent($ea68a19c2d46a931$var$PointerEventInterface), $ea68a19c2d46a931$var$SubmitEventInterface = $ea68a19c2d46a931$var$assign({}, $ea68a19c2d46a931$var$EventInterface, {
    submitter: 0
}), $ea68a19c2d46a931$var$SyntheticSubmitEvent = $ea68a19c2d46a931$var$createSyntheticEvent($ea68a19c2d46a931$var$SubmitEventInterface), $ea68a19c2d46a931$var$TouchEventInterface = $ea68a19c2d46a931$var$assign({}, $ea68a19c2d46a931$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $ea68a19c2d46a931$var$getEventModifierState
}), $ea68a19c2d46a931$var$SyntheticTouchEvent = $ea68a19c2d46a931$var$createSyntheticEvent($ea68a19c2d46a931$var$TouchEventInterface), $ea68a19c2d46a931$var$TransitionEventInterface = $ea68a19c2d46a931$var$assign({}, $ea68a19c2d46a931$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $ea68a19c2d46a931$var$SyntheticTransitionEvent = $ea68a19c2d46a931$var$createSyntheticEvent($ea68a19c2d46a931$var$TransitionEventInterface), $ea68a19c2d46a931$var$WheelEventInterface = $ea68a19c2d46a931$var$assign({}, $ea68a19c2d46a931$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $ea68a19c2d46a931$var$SyntheticWheelEvent = $ea68a19c2d46a931$var$createSyntheticEvent($ea68a19c2d46a931$var$WheelEventInterface), $ea68a19c2d46a931$var$ToggleEventInterface = $ea68a19c2d46a931$var$assign({}, $ea68a19c2d46a931$var$EventInterface, {
    newState: 0,
    oldState: 0,
    source: 0
}), $ea68a19c2d46a931$var$SyntheticToggleEvent = $ea68a19c2d46a931$var$createSyntheticEvent($ea68a19c2d46a931$var$ToggleEventInterface), $ea68a19c2d46a931$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $ea68a19c2d46a931$var$canUseCompositionEvent = $ea68a19c2d46a931$var$canUseDOM && "CompositionEvent" in window, $ea68a19c2d46a931$var$documentMode = null;
$ea68a19c2d46a931$var$canUseDOM && "documentMode" in document && ($ea68a19c2d46a931$var$documentMode = document.documentMode);
var $ea68a19c2d46a931$var$canUseTextInputEvent = $ea68a19c2d46a931$var$canUseDOM && "TextEvent" in window && !$ea68a19c2d46a931$var$documentMode, $ea68a19c2d46a931$var$useFallbackCompositionData = $ea68a19c2d46a931$var$canUseDOM && (!$ea68a19c2d46a931$var$canUseCompositionEvent || $ea68a19c2d46a931$var$documentMode && 8 < $ea68a19c2d46a931$var$documentMode && 11 >= $ea68a19c2d46a931$var$documentMode), $ea68a19c2d46a931$var$SPACEBAR_CHAR = String.fromCharCode(32), $ea68a19c2d46a931$var$hasSpaceKeypress = !1;
function $ea68a19c2d46a931$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $ea68a19c2d46a931$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $ea68a19c2d46a931$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $ea68a19c2d46a931$var$isComposing = !1;
function $ea68a19c2d46a931$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $ea68a19c2d46a931$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $ea68a19c2d46a931$var$hasSpaceKeypress = !0;
            return $ea68a19c2d46a931$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $ea68a19c2d46a931$var$SPACEBAR_CHAR && $ea68a19c2d46a931$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $ea68a19c2d46a931$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($ea68a19c2d46a931$var$isComposing) return "compositionend" === domEventName || !$ea68a19c2d46a931$var$canUseCompositionEvent && $ea68a19c2d46a931$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $ea68a19c2d46a931$var$getData(), $ea68a19c2d46a931$var$fallbackText = $ea68a19c2d46a931$var$startText = $ea68a19c2d46a931$var$root = null, $ea68a19c2d46a931$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $ea68a19c2d46a931$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $ea68a19c2d46a931$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $ea68a19c2d46a931$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$ea68a19c2d46a931$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $ea68a19c2d46a931$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $ea68a19c2d46a931$var$restoreTarget ? $ea68a19c2d46a931$var$restoreQueue ? $ea68a19c2d46a931$var$restoreQueue.push(target) : $ea68a19c2d46a931$var$restoreQueue = [
        target
    ] : $ea68a19c2d46a931$var$restoreTarget = target;
    inst = $ea68a19c2d46a931$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $ea68a19c2d46a931$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $ea68a19c2d46a931$var$activeElement$1 = null, $ea68a19c2d46a931$var$activeElementInst$1 = null;
function $ea68a19c2d46a931$var$runEventInBatch(dispatchQueue) {
    $ea68a19c2d46a931$var$processDispatchQueue(dispatchQueue, 0);
}
function $ea68a19c2d46a931$var$getInstIfValueChanged(targetInst) {
    var targetNode = $ea68a19c2d46a931$var$getNodeFromInstance(targetInst);
    if ($ea68a19c2d46a931$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $ea68a19c2d46a931$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $ea68a19c2d46a931$var$isInputEventSupported = !1;
if ($ea68a19c2d46a931$var$canUseDOM) {
    var $ea68a19c2d46a931$var$JSCompiler_inline_result$jscomp$318;
    if ($ea68a19c2d46a931$var$canUseDOM) {
        var $ea68a19c2d46a931$var$isSupported$jscomp$inline_474 = "oninput" in document;
        if (!$ea68a19c2d46a931$var$isSupported$jscomp$inline_474) {
            var $ea68a19c2d46a931$var$element$jscomp$inline_475 = document.createElement("div");
            $ea68a19c2d46a931$var$element$jscomp$inline_475.setAttribute("oninput", "return;");
            $ea68a19c2d46a931$var$isSupported$jscomp$inline_474 = "function" === typeof $ea68a19c2d46a931$var$element$jscomp$inline_475.oninput;
        }
        $ea68a19c2d46a931$var$JSCompiler_inline_result$jscomp$318 = $ea68a19c2d46a931$var$isSupported$jscomp$inline_474;
    } else $ea68a19c2d46a931$var$JSCompiler_inline_result$jscomp$318 = !1;
    $ea68a19c2d46a931$var$isInputEventSupported = $ea68a19c2d46a931$var$JSCompiler_inline_result$jscomp$318 && (!document.documentMode || 9 < document.documentMode);
}
function $ea68a19c2d46a931$var$stopWatchingForValueChange() {
    $ea68a19c2d46a931$var$activeElement$1 && ($ea68a19c2d46a931$var$activeElement$1.detachEvent("onpropertychange", $ea68a19c2d46a931$var$handlePropertyChange), $ea68a19c2d46a931$var$activeElementInst$1 = $ea68a19c2d46a931$var$activeElement$1 = null);
}
function $ea68a19c2d46a931$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $ea68a19c2d46a931$var$getInstIfValueChanged($ea68a19c2d46a931$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $ea68a19c2d46a931$var$createAndAccumulateChangeEvent(dispatchQueue, $ea68a19c2d46a931$var$activeElementInst$1, nativeEvent, $ea68a19c2d46a931$var$getEventTarget(nativeEvent));
        $ea68a19c2d46a931$var$batchedUpdates$1($ea68a19c2d46a931$var$runEventInBatch, dispatchQueue);
    }
}
function $ea68a19c2d46a931$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($ea68a19c2d46a931$var$stopWatchingForValueChange(), $ea68a19c2d46a931$var$activeElement$1 = target, $ea68a19c2d46a931$var$activeElementInst$1 = targetInst, $ea68a19c2d46a931$var$activeElement$1.attachEvent("onpropertychange", $ea68a19c2d46a931$var$handlePropertyChange)) : "focusout" === domEventName && $ea68a19c2d46a931$var$stopWatchingForValueChange();
}
function $ea68a19c2d46a931$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $ea68a19c2d46a931$var$getInstIfValueChanged($ea68a19c2d46a931$var$activeElementInst$1);
}
function $ea68a19c2d46a931$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $ea68a19c2d46a931$var$getInstIfValueChanged(targetInst);
}
function $ea68a19c2d46a931$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $ea68a19c2d46a931$var$getInstIfValueChanged(targetInst);
}
function $ea68a19c2d46a931$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $ea68a19c2d46a931$var$objectIs = "function" === typeof Object.is ? Object.is : $ea68a19c2d46a931$var$is;
function $ea68a19c2d46a931$var$shallowEqual(objA, objB) {
    if ($ea68a19c2d46a931$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$ea68a19c2d46a931$var$hasOwnProperty.call(objB, currentKey) || !$ea68a19c2d46a931$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $ea68a19c2d46a931$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e$20) {
        return doc.body;
    }
}
function $ea68a19c2d46a931$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $ea68a19c2d46a931$var$getNodeForCharacterOffset(root, offset) {
    var node = $ea68a19c2d46a931$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $ea68a19c2d46a931$var$getLeafNode(node);
    }
}
function $ea68a19c2d46a931$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $ea68a19c2d46a931$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $ea68a19c2d46a931$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $ea68a19c2d46a931$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $ea68a19c2d46a931$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $ea68a19c2d46a931$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $ea68a19c2d46a931$var$skipSelectionChangeEvent = $ea68a19c2d46a931$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $ea68a19c2d46a931$var$activeElement = null, $ea68a19c2d46a931$var$activeElementInst = null, $ea68a19c2d46a931$var$lastSelection = null, $ea68a19c2d46a931$var$mouseDown = !1;
function $ea68a19c2d46a931$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $ea68a19c2d46a931$var$mouseDown || null == $ea68a19c2d46a931$var$activeElement || $ea68a19c2d46a931$var$activeElement !== $ea68a19c2d46a931$var$getActiveElement(doc) || (doc = $ea68a19c2d46a931$var$activeElement, "selectionStart" in doc && $ea68a19c2d46a931$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $ea68a19c2d46a931$var$lastSelection && $ea68a19c2d46a931$var$shallowEqual($ea68a19c2d46a931$var$lastSelection, doc) || ($ea68a19c2d46a931$var$lastSelection = doc, doc = $ea68a19c2d46a931$var$accumulateTwoPhaseListeners($ea68a19c2d46a931$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $ea68a19c2d46a931$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $ea68a19c2d46a931$var$activeElement)));
}
function $ea68a19c2d46a931$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $ea68a19c2d46a931$var$vendorPrefixes = {
    animationend: $ea68a19c2d46a931$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $ea68a19c2d46a931$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $ea68a19c2d46a931$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $ea68a19c2d46a931$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $ea68a19c2d46a931$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $ea68a19c2d46a931$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $ea68a19c2d46a931$var$makePrefixMap("Transition", "TransitionEnd")
}, $ea68a19c2d46a931$var$prefixedEventNames = {}, $ea68a19c2d46a931$var$style = {};
$ea68a19c2d46a931$var$canUseDOM && ($ea68a19c2d46a931$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $ea68a19c2d46a931$var$vendorPrefixes.animationend.animation, delete $ea68a19c2d46a931$var$vendorPrefixes.animationiteration.animation, delete $ea68a19c2d46a931$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $ea68a19c2d46a931$var$vendorPrefixes.transitionend.transition);
function $ea68a19c2d46a931$var$getVendorPrefixedEventName(eventName) {
    if ($ea68a19c2d46a931$var$prefixedEventNames[eventName]) return $ea68a19c2d46a931$var$prefixedEventNames[eventName];
    if (!$ea68a19c2d46a931$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $ea68a19c2d46a931$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $ea68a19c2d46a931$var$style) return $ea68a19c2d46a931$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $ea68a19c2d46a931$var$ANIMATION_END = $ea68a19c2d46a931$var$getVendorPrefixedEventName("animationend"), $ea68a19c2d46a931$var$ANIMATION_ITERATION = $ea68a19c2d46a931$var$getVendorPrefixedEventName("animationiteration"), $ea68a19c2d46a931$var$ANIMATION_START = $ea68a19c2d46a931$var$getVendorPrefixedEventName("animationstart"), $ea68a19c2d46a931$var$TRANSITION_RUN = $ea68a19c2d46a931$var$getVendorPrefixedEventName("transitionrun"), $ea68a19c2d46a931$var$TRANSITION_START = $ea68a19c2d46a931$var$getVendorPrefixedEventName("transitionstart"), $ea68a19c2d46a931$var$TRANSITION_CANCEL = $ea68a19c2d46a931$var$getVendorPrefixedEventName("transitioncancel"), $ea68a19c2d46a931$var$TRANSITION_END = $ea68a19c2d46a931$var$getVendorPrefixedEventName("transitionend"), $ea68a19c2d46a931$var$topLevelEventsToReactNames = new Map(), $ea68a19c2d46a931$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error fullscreenChange fullscreenError gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$ea68a19c2d46a931$var$simpleEventPluginEvents.push("scrollEnd");
function $ea68a19c2d46a931$var$registerSimpleEvent(domEventName, reactName) {
    $ea68a19c2d46a931$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $ea68a19c2d46a931$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $ea68a19c2d46a931$var$globalClientIdCounter$1 = 0;
function $ea68a19c2d46a931$var$getViewTransitionName(props, instance) {
    if (null != props.name && "auto" !== props.name) return props.name;
    if (null !== instance.autoName) return instance.autoName;
    props = $ea68a19c2d46a931$var$pendingEffectsRoot.identifierPrefix;
    var globalClientId = $ea68a19c2d46a931$var$globalClientIdCounter$1++;
    props = "_" + props + "t_" + globalClientId.toString(32) + "_";
    return instance.autoName = props;
}
function $ea68a19c2d46a931$var$getClassNameByType(classByType) {
    if (null == classByType || "string" === typeof classByType) return classByType;
    var className = null, activeTypes = $ea68a19c2d46a931$var$pendingTransitionTypes;
    if (null !== activeTypes) for(var i = 0; i < activeTypes.length; i++){
        var match = classByType[activeTypes[i]];
        if (null != match) {
            if ("none" === match) return "none";
            className = null == className ? match : className + (" " + match);
        }
    }
    return null == className ? classByType.default : className;
}
function $ea68a19c2d46a931$var$getViewTransitionClassName(defaultClass, eventClass) {
    defaultClass = $ea68a19c2d46a931$var$getClassNameByType(defaultClass);
    eventClass = $ea68a19c2d46a931$var$getClassNameByType(eventClass);
    return null == eventClass ? "auto" === defaultClass ? null : defaultClass : "auto" === eventClass ? null : eventClass;
}
var $ea68a19c2d46a931$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $ea68a19c2d46a931$var$concurrentQueues = [], $ea68a19c2d46a931$var$concurrentQueuesIndex = 0, $ea68a19c2d46a931$var$concurrentlyUpdatedLanes = 0;
function $ea68a19c2d46a931$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $ea68a19c2d46a931$var$concurrentQueuesIndex, i = $ea68a19c2d46a931$var$concurrentlyUpdatedLanes = $ea68a19c2d46a931$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $ea68a19c2d46a931$var$concurrentQueues[i];
        $ea68a19c2d46a931$var$concurrentQueues[i++] = null;
        var queue = $ea68a19c2d46a931$var$concurrentQueues[i];
        $ea68a19c2d46a931$var$concurrentQueues[i++] = null;
        var update = $ea68a19c2d46a931$var$concurrentQueues[i];
        $ea68a19c2d46a931$var$concurrentQueues[i++] = null;
        var lane = $ea68a19c2d46a931$var$concurrentQueues[i];
        $ea68a19c2d46a931$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $ea68a19c2d46a931$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $ea68a19c2d46a931$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $ea68a19c2d46a931$var$concurrentQueues[$ea68a19c2d46a931$var$concurrentQueuesIndex++] = fiber;
    $ea68a19c2d46a931$var$concurrentQueues[$ea68a19c2d46a931$var$concurrentQueuesIndex++] = queue;
    $ea68a19c2d46a931$var$concurrentQueues[$ea68a19c2d46a931$var$concurrentQueuesIndex++] = update;
    $ea68a19c2d46a931$var$concurrentQueues[$ea68a19c2d46a931$var$concurrentQueuesIndex++] = lane;
    $ea68a19c2d46a931$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $ea68a19c2d46a931$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $ea68a19c2d46a931$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $ea68a19c2d46a931$var$getRootForUpdatedFiber(fiber);
}
function $ea68a19c2d46a931$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $ea68a19c2d46a931$var$enqueueUpdate$1(fiber, null, null, lane);
    return $ea68a19c2d46a931$var$getRootForUpdatedFiber(fiber);
}
function $ea68a19c2d46a931$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $ea68a19c2d46a931$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $ea68a19c2d46a931$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $ea68a19c2d46a931$var$nestedUpdateCount) throw $ea68a19c2d46a931$var$nestedUpdateCount = 0, $ea68a19c2d46a931$var$rootWithNestedUpdates = null, Error($ea68a19c2d46a931$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $ea68a19c2d46a931$var$emptyContextObject = {};
function $ea68a19c2d46a931$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $ea68a19c2d46a931$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $ea68a19c2d46a931$var$FiberNode(tag, pendingProps, key, mode);
}
function $ea68a19c2d46a931$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $ea68a19c2d46a931$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $ea68a19c2d46a931$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 1206910976;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $ea68a19c2d46a931$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 1206910978;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $ea68a19c2d46a931$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof owner) $ea68a19c2d46a931$var$shouldConstruct(owner) && (fiberTag = 1);
    else if ("string" === typeof owner) fiberTag = $ea68a19c2d46a931$var$isHostHoistableType(type, pendingProps, $ea68a19c2d46a931$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(owner){
        case $ea68a19c2d46a931$var$REACT_ACTIVITY_TYPE:
            return type = $ea68a19c2d46a931$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $ea68a19c2d46a931$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $ea68a19c2d46a931$var$REACT_FRAGMENT_TYPE:
            return $ea68a19c2d46a931$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $ea68a19c2d46a931$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $ea68a19c2d46a931$var$REACT_PROFILER_TYPE:
            return type = $ea68a19c2d46a931$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $ea68a19c2d46a931$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $ea68a19c2d46a931$var$REACT_SUSPENSE_TYPE:
            return type = $ea68a19c2d46a931$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $ea68a19c2d46a931$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $ea68a19c2d46a931$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $ea68a19c2d46a931$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $ea68a19c2d46a931$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        case $ea68a19c2d46a931$var$REACT_LEGACY_HIDDEN_TYPE:
        case $ea68a19c2d46a931$var$REACT_VIEW_TRANSITION_TYPE:
            return type = mode | 32, type = $ea68a19c2d46a931$var$createFiberImplClass(30, pendingProps, key, type), type.elementType = $ea68a19c2d46a931$var$REACT_VIEW_TRANSITION_TYPE, type.lanes = lanes, type.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }, type;
        default:
            if ("object" === typeof owner && null !== owner) switch(owner.$$typeof){
                case $ea68a19c2d46a931$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $ea68a19c2d46a931$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $ea68a19c2d46a931$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $ea68a19c2d46a931$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $ea68a19c2d46a931$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($ea68a19c2d46a931$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $ea68a19c2d46a931$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $ea68a19c2d46a931$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $ea68a19c2d46a931$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $ea68a19c2d46a931$var$createFiberFromText(content, mode, lanes) {
    content = $ea68a19c2d46a931$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $ea68a19c2d46a931$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $ea68a19c2d46a931$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $ea68a19c2d46a931$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $ea68a19c2d46a931$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $ea68a19c2d46a931$var$CapturedStacks = new WeakMap();
function $ea68a19c2d46a931$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $ea68a19c2d46a931$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $ea68a19c2d46a931$var$getStackByFiberInDevAndProd(source)
        };
        $ea68a19c2d46a931$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $ea68a19c2d46a931$var$getStackByFiberInDevAndProd(source)
    };
}
var $ea68a19c2d46a931$var$forkStack = [], $ea68a19c2d46a931$var$forkStackIndex = 0, $ea68a19c2d46a931$var$treeForkProvider = null, $ea68a19c2d46a931$var$treeForkCount = 0, $ea68a19c2d46a931$var$idStack = [], $ea68a19c2d46a931$var$idStackIndex = 0, $ea68a19c2d46a931$var$treeContextProvider = null, $ea68a19c2d46a931$var$treeContextId = 1, $ea68a19c2d46a931$var$treeContextOverflow = "";
function $ea68a19c2d46a931$var$pushTreeFork(workInProgress, totalChildren) {
    $ea68a19c2d46a931$var$forkStack[$ea68a19c2d46a931$var$forkStackIndex++] = $ea68a19c2d46a931$var$treeForkCount;
    $ea68a19c2d46a931$var$forkStack[$ea68a19c2d46a931$var$forkStackIndex++] = $ea68a19c2d46a931$var$treeForkProvider;
    $ea68a19c2d46a931$var$treeForkProvider = workInProgress;
    $ea68a19c2d46a931$var$treeForkCount = totalChildren;
}
function $ea68a19c2d46a931$var$pushTreeId(workInProgress, totalChildren, index) {
    $ea68a19c2d46a931$var$idStack[$ea68a19c2d46a931$var$idStackIndex++] = $ea68a19c2d46a931$var$treeContextId;
    $ea68a19c2d46a931$var$idStack[$ea68a19c2d46a931$var$idStackIndex++] = $ea68a19c2d46a931$var$treeContextOverflow;
    $ea68a19c2d46a931$var$idStack[$ea68a19c2d46a931$var$idStackIndex++] = $ea68a19c2d46a931$var$treeContextProvider;
    $ea68a19c2d46a931$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $ea68a19c2d46a931$var$treeContextId;
    workInProgress = $ea68a19c2d46a931$var$treeContextOverflow;
    var baseLength = 32 - $ea68a19c2d46a931$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $ea68a19c2d46a931$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $ea68a19c2d46a931$var$treeContextId = 1 << 32 - $ea68a19c2d46a931$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $ea68a19c2d46a931$var$treeContextOverflow = length + workInProgress;
    } else $ea68a19c2d46a931$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $ea68a19c2d46a931$var$treeContextOverflow = workInProgress;
}
function $ea68a19c2d46a931$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($ea68a19c2d46a931$var$pushTreeFork(workInProgress, 1), $ea68a19c2d46a931$var$pushTreeId(workInProgress, 1, 0));
}
function $ea68a19c2d46a931$var$popTreeContext(workInProgress) {
    for(; workInProgress === $ea68a19c2d46a931$var$treeForkProvider;)$ea68a19c2d46a931$var$treeForkProvider = $ea68a19c2d46a931$var$forkStack[--$ea68a19c2d46a931$var$forkStackIndex], $ea68a19c2d46a931$var$forkStack[$ea68a19c2d46a931$var$forkStackIndex] = null, $ea68a19c2d46a931$var$treeForkCount = $ea68a19c2d46a931$var$forkStack[--$ea68a19c2d46a931$var$forkStackIndex], $ea68a19c2d46a931$var$forkStack[$ea68a19c2d46a931$var$forkStackIndex] = null;
    for(; workInProgress === $ea68a19c2d46a931$var$treeContextProvider;)$ea68a19c2d46a931$var$treeContextProvider = $ea68a19c2d46a931$var$idStack[--$ea68a19c2d46a931$var$idStackIndex], $ea68a19c2d46a931$var$idStack[$ea68a19c2d46a931$var$idStackIndex] = null, $ea68a19c2d46a931$var$treeContextOverflow = $ea68a19c2d46a931$var$idStack[--$ea68a19c2d46a931$var$idStackIndex], $ea68a19c2d46a931$var$idStack[$ea68a19c2d46a931$var$idStackIndex] = null, $ea68a19c2d46a931$var$treeContextId = $ea68a19c2d46a931$var$idStack[--$ea68a19c2d46a931$var$idStackIndex], $ea68a19c2d46a931$var$idStack[$ea68a19c2d46a931$var$idStackIndex] = null;
}
function $ea68a19c2d46a931$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $ea68a19c2d46a931$var$idStack[$ea68a19c2d46a931$var$idStackIndex++] = $ea68a19c2d46a931$var$treeContextId;
    $ea68a19c2d46a931$var$idStack[$ea68a19c2d46a931$var$idStackIndex++] = $ea68a19c2d46a931$var$treeContextOverflow;
    $ea68a19c2d46a931$var$idStack[$ea68a19c2d46a931$var$idStackIndex++] = $ea68a19c2d46a931$var$treeContextProvider;
    $ea68a19c2d46a931$var$treeContextId = suspendedContext.id;
    $ea68a19c2d46a931$var$treeContextOverflow = suspendedContext.overflow;
    $ea68a19c2d46a931$var$treeContextProvider = workInProgress;
}
var $ea68a19c2d46a931$var$hydrationParentFiber = null, $ea68a19c2d46a931$var$nextHydratableInstance = null, $ea68a19c2d46a931$var$isHydrating = !1, $ea68a19c2d46a931$var$hydrationErrors = null, $ea68a19c2d46a931$var$rootOrSingletonContext = !1, $ea68a19c2d46a931$var$HydrationMismatchException = Error($ea68a19c2d46a931$var$formatProdErrorMessage(519));
function $ea68a19c2d46a931$var$throwOnHydrationMismatch(fiber) {
    var error = Error($ea68a19c2d46a931$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $ea68a19c2d46a931$var$queueHydrationError($ea68a19c2d46a931$var$createCapturedValueAtFiber(error, fiber));
    throw $ea68a19c2d46a931$var$HydrationMismatchException;
}
function $ea68a19c2d46a931$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$ea68a19c2d46a931$var$internalInstanceKey] = fiber;
    instance[$ea68a19c2d46a931$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $ea68a19c2d46a931$var$listenToNonDelegatedEvent("cancel", instance);
            $ea68a19c2d46a931$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $ea68a19c2d46a931$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $ea68a19c2d46a931$var$mediaEventTypes.length; type++)$ea68a19c2d46a931$var$listenToNonDelegatedEvent($ea68a19c2d46a931$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $ea68a19c2d46a931$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $ea68a19c2d46a931$var$listenToNonDelegatedEvent("error", instance);
            $ea68a19c2d46a931$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $ea68a19c2d46a931$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $ea68a19c2d46a931$var$listenToNonDelegatedEvent("invalid", instance);
            $ea68a19c2d46a931$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $ea68a19c2d46a931$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $ea68a19c2d46a931$var$listenToNonDelegatedEvent("invalid", instance), $ea68a19c2d46a931$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $ea68a19c2d46a931$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($ea68a19c2d46a931$var$listenToNonDelegatedEvent("beforetoggle", instance), $ea68a19c2d46a931$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $ea68a19c2d46a931$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $ea68a19c2d46a931$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $ea68a19c2d46a931$var$noop$1), instance = !0) : instance = !1;
    instance || $ea68a19c2d46a931$var$throwOnHydrationMismatch(fiber, !0);
}
function $ea68a19c2d46a931$var$popToNextHostParent(fiber) {
    for($ea68a19c2d46a931$var$hydrationParentFiber = fiber.return; $ea68a19c2d46a931$var$hydrationParentFiber;)switch($ea68a19c2d46a931$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $ea68a19c2d46a931$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $ea68a19c2d46a931$var$rootOrSingletonContext = !0;
            return;
        default:
            $ea68a19c2d46a931$var$hydrationParentFiber = $ea68a19c2d46a931$var$hydrationParentFiber.return;
    }
}
function $ea68a19c2d46a931$var$popHydrationState(fiber) {
    if (fiber !== $ea68a19c2d46a931$var$hydrationParentFiber) return !1;
    if (!$ea68a19c2d46a931$var$isHydrating) return $ea68a19c2d46a931$var$popToNextHostParent(fiber), $ea68a19c2d46a931$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $ea68a19c2d46a931$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $ea68a19c2d46a931$var$nextHydratableInstance && $ea68a19c2d46a931$var$throwOnHydrationMismatch(fiber);
    $ea68a19c2d46a931$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(317));
        $ea68a19c2d46a931$var$nextHydratableInstance = $ea68a19c2d46a931$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(317));
        $ea68a19c2d46a931$var$nextHydratableInstance = $ea68a19c2d46a931$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $ea68a19c2d46a931$var$nextHydratableInstance, $ea68a19c2d46a931$var$isSingletonScope(fiber.type) ? (fiber = $ea68a19c2d46a931$var$previousHydratableOnEnteringScopedSingleton, $ea68a19c2d46a931$var$previousHydratableOnEnteringScopedSingleton = null, $ea68a19c2d46a931$var$nextHydratableInstance = fiber) : $ea68a19c2d46a931$var$nextHydratableInstance = tag) : $ea68a19c2d46a931$var$nextHydratableInstance = $ea68a19c2d46a931$var$hydrationParentFiber ? $ea68a19c2d46a931$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $ea68a19c2d46a931$var$resetHydrationState() {
    $ea68a19c2d46a931$var$nextHydratableInstance = $ea68a19c2d46a931$var$hydrationParentFiber = null;
    $ea68a19c2d46a931$var$isHydrating = !1;
}
function $ea68a19c2d46a931$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $ea68a19c2d46a931$var$hydrationErrors;
    null !== queuedErrors && (null === $ea68a19c2d46a931$var$workInProgressRootRecoverableErrors ? $ea68a19c2d46a931$var$workInProgressRootRecoverableErrors = queuedErrors : $ea68a19c2d46a931$var$workInProgressRootRecoverableErrors.push.apply($ea68a19c2d46a931$var$workInProgressRootRecoverableErrors, queuedErrors), $ea68a19c2d46a931$var$hydrationErrors = null);
    return queuedErrors;
}
function $ea68a19c2d46a931$var$queueHydrationError(error) {
    null === $ea68a19c2d46a931$var$hydrationErrors ? $ea68a19c2d46a931$var$hydrationErrors = [
        error
    ] : $ea68a19c2d46a931$var$hydrationErrors.push(error);
}
var $ea68a19c2d46a931$var$valueCursor = $ea68a19c2d46a931$var$createCursor(null), $ea68a19c2d46a931$var$currentlyRenderingFiber$1 = null, $ea68a19c2d46a931$var$lastContextDependency = null;
function $ea68a19c2d46a931$var$pushProvider(providerFiber, context, nextValue) {
    $ea68a19c2d46a931$var$push($ea68a19c2d46a931$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $ea68a19c2d46a931$var$popProvider(context) {
    context._currentValue = $ea68a19c2d46a931$var$valueCursor.current;
    $ea68a19c2d46a931$var$pop($ea68a19c2d46a931$var$valueCursor);
}
function $ea68a19c2d46a931$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $ea68a19c2d46a931$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $ea68a19c2d46a931$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $ea68a19c2d46a931$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else 13 === fiber.tag && null !== fiber.memoizedState && null === fiber.memoizedState.dehydrated ? (fiber.lanes |= renderLanes, nextFiber = fiber.alternate, null !== nextFiber && (nextFiber.lanes |= renderLanes), $ea68a19c2d46a931$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, workInProgress), nextFiber = fiber.child, nextFiber = null !== nextFiber ? nextFiber.sibling : null) : nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $ea68a19c2d46a931$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $ea68a19c2d46a931$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $ea68a19c2d46a931$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($ea68a19c2d46a931$var$HostTransitionContext) : current = [
                $ea68a19c2d46a931$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $ea68a19c2d46a931$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
    return null !== current;
}
function $ea68a19c2d46a931$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$ea68a19c2d46a931$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $ea68a19c2d46a931$var$prepareToReadContext(workInProgress) {
    $ea68a19c2d46a931$var$currentlyRenderingFiber$1 = workInProgress;
    $ea68a19c2d46a931$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $ea68a19c2d46a931$var$readContext(context) {
    return $ea68a19c2d46a931$var$readContextForConsumer($ea68a19c2d46a931$var$currentlyRenderingFiber$1, context);
}
function $ea68a19c2d46a931$var$readContextDuringReconciliation(consumer, context) {
    null === $ea68a19c2d46a931$var$currentlyRenderingFiber$1 && $ea68a19c2d46a931$var$prepareToReadContext(consumer);
    return $ea68a19c2d46a931$var$readContextForConsumer(consumer, context);
}
function $ea68a19c2d46a931$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $ea68a19c2d46a931$var$lastContextDependency) {
        if (null === consumer) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(308));
        $ea68a19c2d46a931$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $ea68a19c2d46a931$var$lastContextDependency = $ea68a19c2d46a931$var$lastContextDependency.next = context;
    return value;
}
var $ea68a19c2d46a931$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $ea68a19c2d46a931$var$scheduleCallback$2 = $953uR.unstable_scheduleCallback, $ea68a19c2d46a931$var$NormalPriority = $953uR.unstable_NormalPriority, $ea68a19c2d46a931$var$CacheContext = {
    $$typeof: $ea68a19c2d46a931$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $ea68a19c2d46a931$var$createCache() {
    return {
        controller: new $ea68a19c2d46a931$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $ea68a19c2d46a931$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $ea68a19c2d46a931$var$scheduleCallback$2($ea68a19c2d46a931$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
function $ea68a19c2d46a931$var$queueTransitionTypes(root, transitionTypes) {
    if (0 !== (root.pendingLanes & 4194048)) {
        var queued = root.transitionTypes;
        null === queued && (queued = root.transitionTypes = []);
        for(root = 0; root < transitionTypes.length; root++){
            var transitionType = transitionTypes[root];
            -1 === queued.indexOf(transitionType) && queued.push(transitionType);
        }
    }
}
var $ea68a19c2d46a931$var$entangledTransitionTypes = null;
function $ea68a19c2d46a931$var$claimQueuedTransitionTypes(root) {
    var claimed = root.transitionTypes;
    root.transitionTypes = null;
    return claimed;
}
var $ea68a19c2d46a931$var$currentEntangledListeners = null, $ea68a19c2d46a931$var$currentEntangledPendingCount = 0, $ea68a19c2d46a931$var$currentEntangledLane = 0, $ea68a19c2d46a931$var$currentEntangledActionThenable = null;
function $ea68a19c2d46a931$var$entangleAsyncAction(transition, thenable) {
    if (null === $ea68a19c2d46a931$var$currentEntangledListeners) {
        var entangledListeners = $ea68a19c2d46a931$var$currentEntangledListeners = [];
        $ea68a19c2d46a931$var$currentEntangledPendingCount = 0;
        $ea68a19c2d46a931$var$currentEntangledLane = $ea68a19c2d46a931$var$requestTransitionLane();
        $ea68a19c2d46a931$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $ea68a19c2d46a931$var$currentEntangledPendingCount++;
    thenable.then($ea68a19c2d46a931$var$pingEngtangledActionScope, $ea68a19c2d46a931$var$pingEngtangledActionScope);
    return thenable;
}
function $ea68a19c2d46a931$var$pingEngtangledActionScope() {
    if (0 === --$ea68a19c2d46a931$var$currentEntangledPendingCount && ($ea68a19c2d46a931$var$entangledTransitionTypes = null, null !== $ea68a19c2d46a931$var$currentEntangledListeners)) {
        null !== $ea68a19c2d46a931$var$currentEntangledActionThenable && ($ea68a19c2d46a931$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $ea68a19c2d46a931$var$currentEntangledListeners;
        $ea68a19c2d46a931$var$currentEntangledListeners = null;
        $ea68a19c2d46a931$var$currentEntangledLane = 0;
        $ea68a19c2d46a931$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $ea68a19c2d46a931$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $ea68a19c2d46a931$var$prevOnStartTransitionFinish = $ea68a19c2d46a931$var$ReactSharedInternals.S;
$ea68a19c2d46a931$var$ReactSharedInternals.S = function(transition, returnValue) {
    $ea68a19c2d46a931$var$globalMostRecentTransitionTime = $ea68a19c2d46a931$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $ea68a19c2d46a931$var$entangleAsyncAction(transition, returnValue);
    if (null !== $ea68a19c2d46a931$var$entangledTransitionTypes) for(var root$28 = $ea68a19c2d46a931$var$firstScheduledRoot; null !== root$28;)$ea68a19c2d46a931$var$queueTransitionTypes(root$28, $ea68a19c2d46a931$var$entangledTransitionTypes), root$28 = root$28.next;
    root$28 = transition.types;
    if (null !== root$28) {
        for(var root$29 = $ea68a19c2d46a931$var$firstScheduledRoot; null !== root$29;)$ea68a19c2d46a931$var$queueTransitionTypes(root$29, root$28), root$29 = root$29.next;
        if (0 !== $ea68a19c2d46a931$var$currentEntangledLane) {
            root$29 = $ea68a19c2d46a931$var$entangledTransitionTypes;
            null === root$29 && (root$29 = $ea68a19c2d46a931$var$entangledTransitionTypes = []);
            for(var i = 0; i < root$28.length; i++){
                var transitionType = root$28[i];
                -1 === root$29.indexOf(transitionType) && root$29.push(transitionType);
            }
        }
    }
    null !== $ea68a19c2d46a931$var$prevOnStartTransitionFinish && $ea68a19c2d46a931$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $ea68a19c2d46a931$var$resumedCache = $ea68a19c2d46a931$var$createCursor(null);
function $ea68a19c2d46a931$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $ea68a19c2d46a931$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $ea68a19c2d46a931$var$workInProgressRoot.pooledCache;
}
function $ea68a19c2d46a931$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $ea68a19c2d46a931$var$push($ea68a19c2d46a931$var$resumedCache, $ea68a19c2d46a931$var$resumedCache.current) : $ea68a19c2d46a931$var$push($ea68a19c2d46a931$var$resumedCache, prevCachePool.pool);
}
function $ea68a19c2d46a931$var$getSuspendedCache() {
    var cacheFromPool = $ea68a19c2d46a931$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $ea68a19c2d46a931$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $ea68a19c2d46a931$var$SuspenseException = Error($ea68a19c2d46a931$var$formatProdErrorMessage(460)), $ea68a19c2d46a931$var$SuspenseyCommitException = Error($ea68a19c2d46a931$var$formatProdErrorMessage(474)), $ea68a19c2d46a931$var$SuspenseActionException = Error($ea68a19c2d46a931$var$formatProdErrorMessage(542)), $ea68a19c2d46a931$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $ea68a19c2d46a931$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $ea68a19c2d46a931$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($ea68a19c2d46a931$var$noop$1, $ea68a19c2d46a931$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            thenableState = thenable.reason;
            $ea68a19c2d46a931$var$checkIfUseWrappedInAsyncCatch(thenableState);
            if (void 0 === thenableState && !("reason" in thenable)) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(600));
            throw thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($ea68a19c2d46a931$var$noop$1, $ea68a19c2d46a931$var$noop$1);
            else {
                thenableState = $ea68a19c2d46a931$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $ea68a19c2d46a931$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $ea68a19c2d46a931$var$suspendedThenable = thenable;
            throw $ea68a19c2d46a931$var$SuspenseException;
    }
}
function $ea68a19c2d46a931$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $ea68a19c2d46a931$var$suspendedThenable = x, $ea68a19c2d46a931$var$SuspenseException;
        throw x;
    }
}
var $ea68a19c2d46a931$var$suspendedThenable = null;
function $ea68a19c2d46a931$var$getSuspendedThenable() {
    if (null === $ea68a19c2d46a931$var$suspendedThenable) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(459));
    var thenable = $ea68a19c2d46a931$var$suspendedThenable;
    $ea68a19c2d46a931$var$suspendedThenable = null;
    return thenable;
}
function $ea68a19c2d46a931$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $ea68a19c2d46a931$var$SuspenseException || rejectedReason === $ea68a19c2d46a931$var$SuspenseActionException) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(483));
}
var $ea68a19c2d46a931$var$thenableState$1 = null, $ea68a19c2d46a931$var$thenableIndexCounter$1 = 0;
function $ea68a19c2d46a931$var$unwrapThenable(thenable) {
    var index = $ea68a19c2d46a931$var$thenableIndexCounter$1;
    $ea68a19c2d46a931$var$thenableIndexCounter$1 += 1;
    null === $ea68a19c2d46a931$var$thenableState$1 && ($ea68a19c2d46a931$var$thenableState$1 = []);
    return $ea68a19c2d46a931$var$trackUsedThenable($ea68a19c2d46a931$var$thenableState$1, thenable, index);
}
function $ea68a19c2d46a931$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $ea68a19c2d46a931$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $ea68a19c2d46a931$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $ea68a19c2d46a931$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null === currentFirstChild.key ? existingChildren.set(currentFirstChild.index, currentFirstChild) : existingChildren.set(currentFirstChild.key, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $ea68a19c2d46a931$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 2, lastPlacedIndex) : newIndex;
        newFiber.flags |= 134217730;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 134217730);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $ea68a19c2d46a931$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $ea68a19c2d46a931$var$REACT_FRAGMENT_TYPE) return returnFiber = updateFragment(returnFiber, current, element.props.children, lanes, element.key), $ea68a19c2d46a931$var$coerceRef(returnFiber, element), returnFiber;
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $ea68a19c2d46a931$var$REACT_LAZY_TYPE && $ea68a19c2d46a931$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $ea68a19c2d46a931$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $ea68a19c2d46a931$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $ea68a19c2d46a931$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $ea68a19c2d46a931$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $ea68a19c2d46a931$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $ea68a19c2d46a931$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $ea68a19c2d46a931$var$REACT_ELEMENT_TYPE:
                    return lanes = $ea68a19c2d46a931$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $ea68a19c2d46a931$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $ea68a19c2d46a931$var$REACT_PORTAL_TYPE:
                    return newChild = $ea68a19c2d46a931$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $ea68a19c2d46a931$var$REACT_LAZY_TYPE:
                    return newChild = $ea68a19c2d46a931$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($ea68a19c2d46a931$var$isArrayImpl(newChild) || $ea68a19c2d46a931$var$getIteratorFn(newChild)) return newChild = $ea68a19c2d46a931$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $ea68a19c2d46a931$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $ea68a19c2d46a931$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $ea68a19c2d46a931$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $ea68a19c2d46a931$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $ea68a19c2d46a931$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $ea68a19c2d46a931$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $ea68a19c2d46a931$var$REACT_LAZY_TYPE:
                    return newChild = $ea68a19c2d46a931$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($ea68a19c2d46a931$var$isArrayImpl(newChild) || $ea68a19c2d46a931$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $ea68a19c2d46a931$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $ea68a19c2d46a931$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $ea68a19c2d46a931$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $ea68a19c2d46a931$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $ea68a19c2d46a931$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $ea68a19c2d46a931$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $ea68a19c2d46a931$var$REACT_LAZY_TYPE:
                    return newChild = $ea68a19c2d46a931$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($ea68a19c2d46a931$var$isArrayImpl(newChild) || $ea68a19c2d46a931$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $ea68a19c2d46a931$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $ea68a19c2d46a931$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $ea68a19c2d46a931$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $ea68a19c2d46a931$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $ea68a19c2d46a931$var$isHydrating && $ea68a19c2d46a931$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $ea68a19c2d46a931$var$isHydrating && $ea68a19c2d46a931$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && (newFiber = nextOldFiber.alternate, null !== newFiber && oldFiber.delete(null === newFiber.key ? newIdx : newFiber.key)), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $ea68a19c2d46a931$var$isHydrating && $ea68a19c2d46a931$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $ea68a19c2d46a931$var$isHydrating && $ea68a19c2d46a931$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $ea68a19c2d46a931$var$isHydrating && $ea68a19c2d46a931$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && (nextOldFiber = step.alternate, null !== nextOldFiber && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key)), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $ea68a19c2d46a931$var$isHydrating && $ea68a19c2d46a931$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $ea68a19c2d46a931$var$REACT_FRAGMENT_TYPE && null === newChild.key && void 0 === newChild.props.ref && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $ea68a19c2d46a931$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $ea68a19c2d46a931$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        $ea68a19c2d46a931$var$coerceRef(lanes, newChild);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $ea68a19c2d46a931$var$REACT_LAZY_TYPE && $ea68a19c2d46a931$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $ea68a19c2d46a931$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $ea68a19c2d46a931$var$REACT_FRAGMENT_TYPE ? (lanes = $ea68a19c2d46a931$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), $ea68a19c2d46a931$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $ea68a19c2d46a931$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $ea68a19c2d46a931$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $ea68a19c2d46a931$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $ea68a19c2d46a931$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $ea68a19c2d46a931$var$REACT_LAZY_TYPE:
                    return newChild = $ea68a19c2d46a931$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($ea68a19c2d46a931$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($ea68a19c2d46a931$var$getIteratorFn(newChild)) {
                key = $ea68a19c2d46a931$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $ea68a19c2d46a931$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $ea68a19c2d46a931$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $ea68a19c2d46a931$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $ea68a19c2d46a931$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $ea68a19c2d46a931$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $ea68a19c2d46a931$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $ea68a19c2d46a931$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $ea68a19c2d46a931$var$SuspenseException || x === $ea68a19c2d46a931$var$SuspenseActionException) throw x;
            var fiber = $ea68a19c2d46a931$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $ea68a19c2d46a931$var$reconcileChildFibers = $ea68a19c2d46a931$var$createChildReconciler(!0), $ea68a19c2d46a931$var$mountChildFibers = $ea68a19c2d46a931$var$createChildReconciler(!1), $ea68a19c2d46a931$var$hasForceUpdate = !1;
function $ea68a19c2d46a931$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $ea68a19c2d46a931$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $ea68a19c2d46a931$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $ea68a19c2d46a931$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($ea68a19c2d46a931$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $ea68a19c2d46a931$var$getRootForUpdatedFiber(fiber);
        $ea68a19c2d46a931$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $ea68a19c2d46a931$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $ea68a19c2d46a931$var$getRootForUpdatedFiber(fiber);
}
function $ea68a19c2d46a931$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $ea68a19c2d46a931$var$markRootEntangled(root, lane);
    }
}
function $ea68a19c2d46a931$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $ea68a19c2d46a931$var$didReadFromEntangledAsyncAction = !1;
function $ea68a19c2d46a931$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($ea68a19c2d46a931$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $ea68a19c2d46a931$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $ea68a19c2d46a931$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $ea68a19c2d46a931$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $ea68a19c2d46a931$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($ea68a19c2d46a931$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $ea68a19c2d46a931$var$currentEntangledLane && ($ea68a19c2d46a931$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $ea68a19c2d46a931$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $ea68a19c2d46a931$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $ea68a19c2d46a931$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $ea68a19c2d46a931$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $ea68a19c2d46a931$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$ea68a19c2d46a931$var$callCallback(callbacks[updateQueue], context);
}
var $ea68a19c2d46a931$var$currentTreeHiddenStackCursor = $ea68a19c2d46a931$var$createCursor(null), $ea68a19c2d46a931$var$prevEntangledRenderLanesCursor = $ea68a19c2d46a931$var$createCursor(0);
function $ea68a19c2d46a931$var$pushHiddenContext(fiber, context) {
    fiber = $ea68a19c2d46a931$var$entangledRenderLanes;
    $ea68a19c2d46a931$var$push($ea68a19c2d46a931$var$prevEntangledRenderLanesCursor, fiber);
    $ea68a19c2d46a931$var$push($ea68a19c2d46a931$var$currentTreeHiddenStackCursor, context);
    $ea68a19c2d46a931$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $ea68a19c2d46a931$var$reuseHiddenContextOnStack() {
    $ea68a19c2d46a931$var$push($ea68a19c2d46a931$var$prevEntangledRenderLanesCursor, $ea68a19c2d46a931$var$entangledRenderLanes);
    $ea68a19c2d46a931$var$push($ea68a19c2d46a931$var$currentTreeHiddenStackCursor, $ea68a19c2d46a931$var$currentTreeHiddenStackCursor.current);
}
function $ea68a19c2d46a931$var$popHiddenContext() {
    $ea68a19c2d46a931$var$entangledRenderLanes = $ea68a19c2d46a931$var$prevEntangledRenderLanesCursor.current;
    $ea68a19c2d46a931$var$pop($ea68a19c2d46a931$var$currentTreeHiddenStackCursor);
    $ea68a19c2d46a931$var$pop($ea68a19c2d46a931$var$prevEntangledRenderLanesCursor);
}
var $ea68a19c2d46a931$var$suspenseHandlerStackCursor = $ea68a19c2d46a931$var$createCursor(null), $ea68a19c2d46a931$var$shellBoundary = null;
function $ea68a19c2d46a931$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $ea68a19c2d46a931$var$push($ea68a19c2d46a931$var$suspenseStackCursor, $ea68a19c2d46a931$var$suspenseStackCursor.current & 1);
    $ea68a19c2d46a931$var$push($ea68a19c2d46a931$var$suspenseHandlerStackCursor, handler);
    null === $ea68a19c2d46a931$var$shellBoundary && (null === current || null !== $ea68a19c2d46a931$var$currentTreeHiddenStackCursor.current ? $ea68a19c2d46a931$var$shellBoundary = handler : null !== current.memoizedState && ($ea68a19c2d46a931$var$shellBoundary = handler));
}
function $ea68a19c2d46a931$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $ea68a19c2d46a931$var$push($ea68a19c2d46a931$var$suspenseStackCursor, $ea68a19c2d46a931$var$suspenseStackCursor.current);
    $ea68a19c2d46a931$var$push($ea68a19c2d46a931$var$suspenseHandlerStackCursor, fiber);
    null === $ea68a19c2d46a931$var$shellBoundary && ($ea68a19c2d46a931$var$shellBoundary = fiber);
}
function $ea68a19c2d46a931$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($ea68a19c2d46a931$var$push($ea68a19c2d46a931$var$suspenseStackCursor, $ea68a19c2d46a931$var$suspenseStackCursor.current), $ea68a19c2d46a931$var$push($ea68a19c2d46a931$var$suspenseHandlerStackCursor, fiber), null === $ea68a19c2d46a931$var$shellBoundary && ($ea68a19c2d46a931$var$shellBoundary = fiber)) : $ea68a19c2d46a931$var$reuseSuspenseHandlerOnStack();
}
function $ea68a19c2d46a931$var$reuseSuspenseHandlerOnStack() {
    $ea68a19c2d46a931$var$push($ea68a19c2d46a931$var$suspenseStackCursor, $ea68a19c2d46a931$var$suspenseStackCursor.current);
    $ea68a19c2d46a931$var$push($ea68a19c2d46a931$var$suspenseHandlerStackCursor, $ea68a19c2d46a931$var$suspenseHandlerStackCursor.current);
}
function $ea68a19c2d46a931$var$popSuspenseHandler(fiber) {
    $ea68a19c2d46a931$var$pop($ea68a19c2d46a931$var$suspenseHandlerStackCursor);
    $ea68a19c2d46a931$var$shellBoundary === fiber && ($ea68a19c2d46a931$var$shellBoundary = null);
    $ea68a19c2d46a931$var$pop($ea68a19c2d46a931$var$suspenseStackCursor);
}
var $ea68a19c2d46a931$var$suspenseStackCursor = $ea68a19c2d46a931$var$createCursor(0);
function $ea68a19c2d46a931$var$pushSuspenseListContext(fiber, newContext) {
    $ea68a19c2d46a931$var$push($ea68a19c2d46a931$var$suspenseHandlerStackCursor, $ea68a19c2d46a931$var$suspenseHandlerStackCursor.current);
    $ea68a19c2d46a931$var$push($ea68a19c2d46a931$var$suspenseStackCursor, newContext);
}
function $ea68a19c2d46a931$var$popSuspenseListContext(fiber) {
    $ea68a19c2d46a931$var$pop($ea68a19c2d46a931$var$suspenseStackCursor);
    $ea68a19c2d46a931$var$pop($ea68a19c2d46a931$var$suspenseHandlerStackCursor);
    $ea68a19c2d46a931$var$shellBoundary === fiber && ($ea68a19c2d46a931$var$shellBoundary = null);
}
function $ea68a19c2d46a931$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $ea68a19c2d46a931$var$isSuspenseInstancePending(state) || $ea68a19c2d46a931$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && "independent" !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $ea68a19c2d46a931$var$renderLanes = 0, $ea68a19c2d46a931$var$currentlyRenderingFiber = null, $ea68a19c2d46a931$var$currentHook = null, $ea68a19c2d46a931$var$workInProgressHook = null, $ea68a19c2d46a931$var$didScheduleRenderPhaseUpdate = !1, $ea68a19c2d46a931$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $ea68a19c2d46a931$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $ea68a19c2d46a931$var$localIdCounter = 0, $ea68a19c2d46a931$var$thenableIndexCounter = 0, $ea68a19c2d46a931$var$thenableState = null, $ea68a19c2d46a931$var$globalClientIdCounter = 0;
function $ea68a19c2d46a931$var$throwInvalidHookError() {
    throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(321));
}
function $ea68a19c2d46a931$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$ea68a19c2d46a931$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $ea68a19c2d46a931$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $ea68a19c2d46a931$var$renderLanes = nextRenderLanes;
    $ea68a19c2d46a931$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $ea68a19c2d46a931$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $ea68a19c2d46a931$var$HooksDispatcherOnMount : $ea68a19c2d46a931$var$HooksDispatcherOnUpdate;
    $ea68a19c2d46a931$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $ea68a19c2d46a931$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $ea68a19c2d46a931$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $ea68a19c2d46a931$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $ea68a19c2d46a931$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $ea68a19c2d46a931$var$finishRenderingHooks(current) {
    $ea68a19c2d46a931$var$ReactSharedInternals.H = $ea68a19c2d46a931$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $ea68a19c2d46a931$var$currentHook && null !== $ea68a19c2d46a931$var$currentHook.next;
    $ea68a19c2d46a931$var$renderLanes = 0;
    $ea68a19c2d46a931$var$workInProgressHook = $ea68a19c2d46a931$var$currentHook = $ea68a19c2d46a931$var$currentlyRenderingFiber = null;
    $ea68a19c2d46a931$var$didScheduleRenderPhaseUpdate = !1;
    $ea68a19c2d46a931$var$thenableIndexCounter = 0;
    $ea68a19c2d46a931$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(300));
    null === current || $ea68a19c2d46a931$var$didReceiveUpdate || (current = current.dependencies, null !== current && $ea68a19c2d46a931$var$checkIfContextChanged(current) && ($ea68a19c2d46a931$var$didReceiveUpdate = !0));
}
function $ea68a19c2d46a931$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $ea68a19c2d46a931$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $ea68a19c2d46a931$var$didScheduleRenderPhaseUpdateDuringThisPass && ($ea68a19c2d46a931$var$thenableState = null);
        $ea68a19c2d46a931$var$thenableIndexCounter = 0;
        $ea68a19c2d46a931$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $ea68a19c2d46a931$var$workInProgressHook = $ea68a19c2d46a931$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $ea68a19c2d46a931$var$ReactSharedInternals.H = $ea68a19c2d46a931$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($ea68a19c2d46a931$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $ea68a19c2d46a931$var$TransitionAwareHostComponent() {
    var dispatcher = $ea68a19c2d46a931$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $ea68a19c2d46a931$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $ea68a19c2d46a931$var$currentHook ? $ea68a19c2d46a931$var$currentHook.memoizedState : null) !== dispatcher && ($ea68a19c2d46a931$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $ea68a19c2d46a931$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $ea68a19c2d46a931$var$localIdCounter;
    $ea68a19c2d46a931$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $ea68a19c2d46a931$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $ea68a19c2d46a931$var$resetHooksOnUnwind(workInProgress) {
    if ($ea68a19c2d46a931$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $ea68a19c2d46a931$var$didScheduleRenderPhaseUpdate = !1;
    }
    $ea68a19c2d46a931$var$renderLanes = 0;
    $ea68a19c2d46a931$var$workInProgressHook = $ea68a19c2d46a931$var$currentHook = $ea68a19c2d46a931$var$currentlyRenderingFiber = null;
    $ea68a19c2d46a931$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $ea68a19c2d46a931$var$thenableIndexCounter = $ea68a19c2d46a931$var$localIdCounter = 0;
    $ea68a19c2d46a931$var$thenableState = null;
}
function $ea68a19c2d46a931$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $ea68a19c2d46a931$var$workInProgressHook ? $ea68a19c2d46a931$var$currentlyRenderingFiber.memoizedState = $ea68a19c2d46a931$var$workInProgressHook = hook : $ea68a19c2d46a931$var$workInProgressHook = $ea68a19c2d46a931$var$workInProgressHook.next = hook;
    return $ea68a19c2d46a931$var$workInProgressHook;
}
function $ea68a19c2d46a931$var$updateWorkInProgressHook() {
    if (null === $ea68a19c2d46a931$var$currentHook) {
        var nextCurrentHook = $ea68a19c2d46a931$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $ea68a19c2d46a931$var$currentHook.next;
    var nextWorkInProgressHook = null === $ea68a19c2d46a931$var$workInProgressHook ? $ea68a19c2d46a931$var$currentlyRenderingFiber.memoizedState : $ea68a19c2d46a931$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $ea68a19c2d46a931$var$workInProgressHook = nextWorkInProgressHook, $ea68a19c2d46a931$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $ea68a19c2d46a931$var$currentlyRenderingFiber.alternate) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(467));
            throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(310));
        }
        $ea68a19c2d46a931$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $ea68a19c2d46a931$var$currentHook.memoizedState,
            baseState: $ea68a19c2d46a931$var$currentHook.baseState,
            baseQueue: $ea68a19c2d46a931$var$currentHook.baseQueue,
            queue: $ea68a19c2d46a931$var$currentHook.queue,
            next: null
        };
        null === $ea68a19c2d46a931$var$workInProgressHook ? $ea68a19c2d46a931$var$currentlyRenderingFiber.memoizedState = $ea68a19c2d46a931$var$workInProgressHook = nextCurrentHook : $ea68a19c2d46a931$var$workInProgressHook = $ea68a19c2d46a931$var$workInProgressHook.next = nextCurrentHook;
    }
    return $ea68a19c2d46a931$var$workInProgressHook;
}
function $ea68a19c2d46a931$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $ea68a19c2d46a931$var$useThenable(thenable) {
    var index = $ea68a19c2d46a931$var$thenableIndexCounter;
    $ea68a19c2d46a931$var$thenableIndexCounter += 1;
    null === $ea68a19c2d46a931$var$thenableState && ($ea68a19c2d46a931$var$thenableState = []);
    thenable = $ea68a19c2d46a931$var$trackUsedThenable($ea68a19c2d46a931$var$thenableState, thenable, index);
    index = $ea68a19c2d46a931$var$currentlyRenderingFiber;
    null === (null === $ea68a19c2d46a931$var$workInProgressHook ? index.memoizedState : $ea68a19c2d46a931$var$workInProgressHook.next) && (index = index.alternate, $ea68a19c2d46a931$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $ea68a19c2d46a931$var$HooksDispatcherOnMount : $ea68a19c2d46a931$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $ea68a19c2d46a931$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $ea68a19c2d46a931$var$useThenable(usable);
        if (usable.$$typeof === $ea68a19c2d46a931$var$REACT_RECOVERABLE_TYPE) return;
        if (usable.$$typeof === $ea68a19c2d46a931$var$REACT_CONTEXT_TYPE) return $ea68a19c2d46a931$var$readContext(usable);
    }
    throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(438, String(usable)));
}
function $ea68a19c2d46a931$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $ea68a19c2d46a931$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $ea68a19c2d46a931$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $ea68a19c2d46a931$var$createFunctionComponentUpdateQueue(), $ea68a19c2d46a931$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $ea68a19c2d46a931$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $ea68a19c2d46a931$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $ea68a19c2d46a931$var$updateReducer(reducer) {
    var hook = $ea68a19c2d46a931$var$updateWorkInProgressHook();
    return $ea68a19c2d46a931$var$updateReducerImpl(hook, $ea68a19c2d46a931$var$currentHook, reducer);
}
function $ea68a19c2d46a931$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$64 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($ea68a19c2d46a931$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($ea68a19c2d46a931$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $ea68a19c2d46a931$var$currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                else if (($ea68a19c2d46a931$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $ea68a19c2d46a931$var$currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $ea68a19c2d46a931$var$currentlyRenderingFiber.lanes |= revertLane, $ea68a19c2d46a931$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $ea68a19c2d46a931$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $ea68a19c2d46a931$var$currentlyRenderingFiber.lanes |= updateLane, $ea68a19c2d46a931$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$ea68a19c2d46a931$var$objectIs(pendingQueue, hook.memoizedState) && ($ea68a19c2d46a931$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$64 && (reducer = $ea68a19c2d46a931$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $ea68a19c2d46a931$var$rerenderReducer(reducer) {
    var hook = $ea68a19c2d46a931$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $ea68a19c2d46a931$var$objectIs(newState, hook.memoizedState) || ($ea68a19c2d46a931$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $ea68a19c2d46a931$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $ea68a19c2d46a931$var$currentlyRenderingFiber, hook = $ea68a19c2d46a931$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $ea68a19c2d46a931$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$ea68a19c2d46a931$var$objectIs(($ea68a19c2d46a931$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $ea68a19c2d46a931$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $ea68a19c2d46a931$var$updateEffect($ea68a19c2d46a931$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    subscribe = hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $ea68a19c2d46a931$var$workInProgressHook && 0 !== ($ea68a19c2d46a931$var$workInProgressHook.memoizedState.tag & 1);
    $ea68a19c2d46a931$var$pushSimpleEffect(subscribe ? 9 : 8, {
        destroy: void 0
    }, $ea68a19c2d46a931$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
    if (subscribe) {
        fiber.flags |= 2048;
        if (null === $ea68a19c2d46a931$var$workInProgressRoot) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($ea68a19c2d46a931$var$renderLanes & 127) || $ea68a19c2d46a931$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $ea68a19c2d46a931$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $ea68a19c2d46a931$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $ea68a19c2d46a931$var$createFunctionComponentUpdateQueue(), $ea68a19c2d46a931$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $ea68a19c2d46a931$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $ea68a19c2d46a931$var$checkIfSnapshotChanged(inst) && $ea68a19c2d46a931$var$forceStoreRerender(fiber);
}
function $ea68a19c2d46a931$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $ea68a19c2d46a931$var$checkIfSnapshotChanged(inst) && $ea68a19c2d46a931$var$forceStoreRerender(fiber);
    });
}
function $ea68a19c2d46a931$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$ea68a19c2d46a931$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $ea68a19c2d46a931$var$forceStoreRerender(fiber) {
    var root = $ea68a19c2d46a931$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $ea68a19c2d46a931$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $ea68a19c2d46a931$var$mountStateImpl(initialState) {
    var hook = $ea68a19c2d46a931$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($ea68a19c2d46a931$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $ea68a19c2d46a931$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $ea68a19c2d46a931$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $ea68a19c2d46a931$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $ea68a19c2d46a931$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $ea68a19c2d46a931$var$updateReducerImpl(hook, $ea68a19c2d46a931$var$currentHook, "function" === typeof reducer ? reducer : $ea68a19c2d46a931$var$basicStateReducer);
}
function $ea68a19c2d46a931$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($ea68a19c2d46a931$var$isRenderPhaseUpdate(fiber)) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $ea68a19c2d46a931$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $ea68a19c2d46a931$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $ea68a19c2d46a931$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $ea68a19c2d46a931$var$ReactSharedInternals.T, currentTransition = {};
        currentTransition.types = null !== prevTransition ? prevTransition.types : null;
        $ea68a19c2d46a931$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $ea68a19c2d46a931$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $ea68a19c2d46a931$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $ea68a19c2d46a931$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $ea68a19c2d46a931$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $ea68a19c2d46a931$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$70) {
        $ea68a19c2d46a931$var$onActionError(actionQueue, node, error$70);
    }
}
function $ea68a19c2d46a931$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $ea68a19c2d46a931$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $ea68a19c2d46a931$var$onActionError(actionQueue, node, error);
    }) : $ea68a19c2d46a931$var$onActionSuccess(actionQueue, node, returnValue);
}
function $ea68a19c2d46a931$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $ea68a19c2d46a931$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $ea68a19c2d46a931$var$runActionStateAction(actionQueue, nextState)));
}
function $ea68a19c2d46a931$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $ea68a19c2d46a931$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $ea68a19c2d46a931$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $ea68a19c2d46a931$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $ea68a19c2d46a931$var$mountActionState(action, initialStateProp) {
    if ($ea68a19c2d46a931$var$isHydrating) {
        var ssrFormState = $ea68a19c2d46a931$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $ea68a19c2d46a931$var$currentlyRenderingFiber;
                if ($ea68a19c2d46a931$var$isHydrating) {
                    if ($ea68a19c2d46a931$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $ea68a19c2d46a931$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $ea68a19c2d46a931$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $ea68a19c2d46a931$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $ea68a19c2d46a931$var$nextHydratableInstance = $ea68a19c2d46a931$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $ea68a19c2d46a931$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $ea68a19c2d46a931$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $ea68a19c2d46a931$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $ea68a19c2d46a931$var$dispatchSetState.bind(null, $ea68a19c2d46a931$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $ea68a19c2d46a931$var$mountStateImpl(!1);
    inRootOrSingleton = $ea68a19c2d46a931$var$dispatchOptimisticSetState.bind(null, $ea68a19c2d46a931$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $ea68a19c2d46a931$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $ea68a19c2d46a931$var$dispatchActionState.bind(null, $ea68a19c2d46a931$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $ea68a19c2d46a931$var$updateActionState(action) {
    var stateHook = $ea68a19c2d46a931$var$updateWorkInProgressHook();
    return $ea68a19c2d46a931$var$updateActionStateImpl(stateHook, $ea68a19c2d46a931$var$currentHook, action);
}
function $ea68a19c2d46a931$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $ea68a19c2d46a931$var$updateReducerImpl(stateHook, currentStateHook, $ea68a19c2d46a931$var$actionStateReducer)[0];
    stateHook = $ea68a19c2d46a931$var$updateReducer($ea68a19c2d46a931$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $ea68a19c2d46a931$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $ea68a19c2d46a931$var$SuspenseException) throw $ea68a19c2d46a931$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $ea68a19c2d46a931$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($ea68a19c2d46a931$var$currentlyRenderingFiber.flags |= 2048, $ea68a19c2d46a931$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $ea68a19c2d46a931$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $ea68a19c2d46a931$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $ea68a19c2d46a931$var$rerenderActionState(action) {
    var stateHook = $ea68a19c2d46a931$var$updateWorkInProgressHook(), currentStateHook = $ea68a19c2d46a931$var$currentHook;
    if (null !== currentStateHook) return $ea68a19c2d46a931$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $ea68a19c2d46a931$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $ea68a19c2d46a931$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $ea68a19c2d46a931$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $ea68a19c2d46a931$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $ea68a19c2d46a931$var$createFunctionComponentUpdateQueue(), $ea68a19c2d46a931$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $ea68a19c2d46a931$var$updateRef() {
    return $ea68a19c2d46a931$var$updateWorkInProgressHook().memoizedState;
}
function $ea68a19c2d46a931$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $ea68a19c2d46a931$var$mountWorkInProgressHook();
    $ea68a19c2d46a931$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $ea68a19c2d46a931$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $ea68a19c2d46a931$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $ea68a19c2d46a931$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $ea68a19c2d46a931$var$currentHook && null !== deps && $ea68a19c2d46a931$var$areHookInputsEqual(deps, $ea68a19c2d46a931$var$currentHook.memoizedState.deps) ? hook.memoizedState = $ea68a19c2d46a931$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($ea68a19c2d46a931$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $ea68a19c2d46a931$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $ea68a19c2d46a931$var$mountEffect(create, deps) {
    $ea68a19c2d46a931$var$mountEffectImpl(8390656, 8, create, deps);
}
function $ea68a19c2d46a931$var$updateEffect(create, deps) {
    $ea68a19c2d46a931$var$updateEffectImpl(2048, 8, create, deps);
}
function $ea68a19c2d46a931$var$useEffectEventImpl(payload) {
    $ea68a19c2d46a931$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $ea68a19c2d46a931$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $ea68a19c2d46a931$var$createFunctionComponentUpdateQueue(), $ea68a19c2d46a931$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $ea68a19c2d46a931$var$updateEvent(callback) {
    var ref = $ea68a19c2d46a931$var$updateWorkInProgressHook().memoizedState;
    $ea68a19c2d46a931$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($ea68a19c2d46a931$var$executionContext & 2)) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $ea68a19c2d46a931$var$updateInsertionEffect(create, deps) {
    return $ea68a19c2d46a931$var$updateEffectImpl(4, 2, create, deps);
}
function $ea68a19c2d46a931$var$updateLayoutEffect(create, deps) {
    return $ea68a19c2d46a931$var$updateEffectImpl(4, 4, create, deps);
}
function $ea68a19c2d46a931$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $ea68a19c2d46a931$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $ea68a19c2d46a931$var$updateEffectImpl(4, 4, $ea68a19c2d46a931$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $ea68a19c2d46a931$var$mountDebugValue() {}
function $ea68a19c2d46a931$var$updateCallback(callback, deps) {
    var hook = $ea68a19c2d46a931$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $ea68a19c2d46a931$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $ea68a19c2d46a931$var$updateMemo(nextCreate, deps) {
    var hook = $ea68a19c2d46a931$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $ea68a19c2d46a931$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($ea68a19c2d46a931$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $ea68a19c2d46a931$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $ea68a19c2d46a931$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $ea68a19c2d46a931$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($ea68a19c2d46a931$var$renderLanes & 1073741824) && 0 === ($ea68a19c2d46a931$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $ea68a19c2d46a931$var$requestDeferredLane();
    $ea68a19c2d46a931$var$currentlyRenderingFiber.lanes |= hook;
    $ea68a19c2d46a931$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $ea68a19c2d46a931$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($ea68a19c2d46a931$var$objectIs(value, prevValue)) return value;
    if (null !== $ea68a19c2d46a931$var$currentTreeHiddenStackCursor.current) return hook = $ea68a19c2d46a931$var$mountDeferredValueImpl(hook, value, initialValue), $ea68a19c2d46a931$var$objectIs(hook, prevValue) || ($ea68a19c2d46a931$var$didReceiveUpdate = !0), hook;
    if (0 === ($ea68a19c2d46a931$var$renderLanes & 106) || 0 !== ($ea68a19c2d46a931$var$renderLanes & 1073741824) && 0 === ($ea68a19c2d46a931$var$workInProgressRootRenderLanes & 261930)) return $ea68a19c2d46a931$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $ea68a19c2d46a931$var$requestDeferredLane();
    $ea68a19c2d46a931$var$currentlyRenderingFiber.lanes |= hook;
    $ea68a19c2d46a931$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $ea68a19c2d46a931$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $ea68a19c2d46a931$var$ReactDOMSharedInternals.p;
    $ea68a19c2d46a931$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $ea68a19c2d46a931$var$ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    $ea68a19c2d46a931$var$ReactSharedInternals.T = currentTransition;
    $ea68a19c2d46a931$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $ea68a19c2d46a931$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $ea68a19c2d46a931$var$chainThenableValue(returnValue, finishedState);
            $ea68a19c2d46a931$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $ea68a19c2d46a931$var$requestUpdateLane(fiber));
        } else $ea68a19c2d46a931$var$dispatchSetStateInternal(fiber, queue, finishedState, $ea68a19c2d46a931$var$requestUpdateLane(fiber));
    } catch (error) {
        $ea68a19c2d46a931$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $ea68a19c2d46a931$var$requestUpdateLane());
    } finally{
        $ea68a19c2d46a931$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $ea68a19c2d46a931$var$ReactSharedInternals.T = prevTransition;
    }
}
function $ea68a19c2d46a931$var$noop() {}
function $ea68a19c2d46a931$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(476));
    var queue = $ea68a19c2d46a931$var$ensureFormComponentIsStateful(formFiber).queue;
    $ea68a19c2d46a931$var$startTransition(formFiber, queue, pendingState, $ea68a19c2d46a931$var$sharedNotPendingObject, null === action ? $ea68a19c2d46a931$var$noop : function() {
        $ea68a19c2d46a931$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $ea68a19c2d46a931$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $ea68a19c2d46a931$var$sharedNotPendingObject,
        baseState: $ea68a19c2d46a931$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $ea68a19c2d46a931$var$basicStateReducer,
            lastRenderedState: $ea68a19c2d46a931$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $ea68a19c2d46a931$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $ea68a19c2d46a931$var$requestFormReset$1(formFiber) {
    var stateHook = $ea68a19c2d46a931$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $ea68a19c2d46a931$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $ea68a19c2d46a931$var$requestUpdateLane());
}
function $ea68a19c2d46a931$var$useHostTransitionStatus() {
    return $ea68a19c2d46a931$var$readContext($ea68a19c2d46a931$var$HostTransitionContext);
}
function $ea68a19c2d46a931$var$updateId() {
    return $ea68a19c2d46a931$var$updateWorkInProgressHook().memoizedState;
}
function $ea68a19c2d46a931$var$updateRefresh() {
    return $ea68a19c2d46a931$var$updateWorkInProgressHook().memoizedState;
}
function $ea68a19c2d46a931$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $ea68a19c2d46a931$var$requestUpdateLane();
                fiber = $ea68a19c2d46a931$var$createUpdate(lane);
                var root$73 = $ea68a19c2d46a931$var$enqueueUpdate(provider, fiber, lane);
                null !== root$73 && ($ea68a19c2d46a931$var$scheduleUpdateOnFiber(root$73, provider, lane), $ea68a19c2d46a931$var$entangleTransitions(root$73, provider, lane));
                provider = {
                    cache: $ea68a19c2d46a931$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $ea68a19c2d46a931$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $ea68a19c2d46a931$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $ea68a19c2d46a931$var$isRenderPhaseUpdate(fiber) ? $ea68a19c2d46a931$var$enqueueRenderPhaseUpdate(queue, action) : (action = $ea68a19c2d46a931$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($ea68a19c2d46a931$var$scheduleUpdateOnFiber(action, fiber, lane), $ea68a19c2d46a931$var$entangleTransitionUpdate(action, queue, lane)));
}
function $ea68a19c2d46a931$var$dispatchSetState(fiber, queue, action) {
    var lane = $ea68a19c2d46a931$var$requestUpdateLane();
    $ea68a19c2d46a931$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $ea68a19c2d46a931$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($ea68a19c2d46a931$var$isRenderPhaseUpdate(fiber)) $ea68a19c2d46a931$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($ea68a19c2d46a931$var$objectIs(eagerState, currentState)) return $ea68a19c2d46a931$var$enqueueUpdate$1(fiber, queue, update, 0), null === $ea68a19c2d46a931$var$workInProgressRoot && $ea68a19c2d46a931$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $ea68a19c2d46a931$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $ea68a19c2d46a931$var$scheduleUpdateOnFiber(action, fiber, lane), $ea68a19c2d46a931$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $ea68a19c2d46a931$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $ea68a19c2d46a931$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($ea68a19c2d46a931$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $ea68a19c2d46a931$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $ea68a19c2d46a931$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $ea68a19c2d46a931$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $ea68a19c2d46a931$var$currentlyRenderingFiber || null !== alternate && alternate === $ea68a19c2d46a931$var$currentlyRenderingFiber;
}
function $ea68a19c2d46a931$var$enqueueRenderPhaseUpdate(queue, update) {
    $ea68a19c2d46a931$var$didScheduleRenderPhaseUpdateDuringThisPass = $ea68a19c2d46a931$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $ea68a19c2d46a931$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $ea68a19c2d46a931$var$markRootEntangled(root, lane);
    }
}
var $ea68a19c2d46a931$var$ContextOnlyDispatcher = {
    readContext: $ea68a19c2d46a931$var$readContext,
    use: $ea68a19c2d46a931$var$use,
    useCallback: $ea68a19c2d46a931$var$throwInvalidHookError,
    useContext: $ea68a19c2d46a931$var$throwInvalidHookError,
    useEffect: $ea68a19c2d46a931$var$throwInvalidHookError,
    useImperativeHandle: $ea68a19c2d46a931$var$throwInvalidHookError,
    useLayoutEffect: $ea68a19c2d46a931$var$throwInvalidHookError,
    useInsertionEffect: $ea68a19c2d46a931$var$throwInvalidHookError,
    useMemo: $ea68a19c2d46a931$var$throwInvalidHookError,
    useReducer: $ea68a19c2d46a931$var$throwInvalidHookError,
    useRef: $ea68a19c2d46a931$var$throwInvalidHookError,
    useState: $ea68a19c2d46a931$var$throwInvalidHookError,
    useDebugValue: $ea68a19c2d46a931$var$throwInvalidHookError,
    useDeferredValue: $ea68a19c2d46a931$var$throwInvalidHookError,
    useTransition: $ea68a19c2d46a931$var$throwInvalidHookError,
    useSyncExternalStore: $ea68a19c2d46a931$var$throwInvalidHookError,
    useId: $ea68a19c2d46a931$var$throwInvalidHookError,
    useHostTransitionStatus: $ea68a19c2d46a931$var$throwInvalidHookError,
    useFormState: $ea68a19c2d46a931$var$throwInvalidHookError,
    useActionState: $ea68a19c2d46a931$var$throwInvalidHookError,
    useOptimistic: $ea68a19c2d46a931$var$throwInvalidHookError,
    useMemoCache: $ea68a19c2d46a931$var$throwInvalidHookError,
    useCacheRefresh: $ea68a19c2d46a931$var$throwInvalidHookError,
    useEffectEvent: $ea68a19c2d46a931$var$throwInvalidHookError
}, $ea68a19c2d46a931$var$HooksDispatcherOnMount = {
    readContext: $ea68a19c2d46a931$var$readContext,
    use: $ea68a19c2d46a931$var$use,
    useCallback: function(callback, deps) {
        $ea68a19c2d46a931$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $ea68a19c2d46a931$var$readContext,
    useEffect: $ea68a19c2d46a931$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $ea68a19c2d46a931$var$mountEffectImpl(4194308, 4, $ea68a19c2d46a931$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $ea68a19c2d46a931$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $ea68a19c2d46a931$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $ea68a19c2d46a931$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($ea68a19c2d46a931$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $ea68a19c2d46a931$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $ea68a19c2d46a931$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $ea68a19c2d46a931$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($ea68a19c2d46a931$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $ea68a19c2d46a931$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $ea68a19c2d46a931$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $ea68a19c2d46a931$var$dispatchReducerAction.bind(null, $ea68a19c2d46a931$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $ea68a19c2d46a931$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $ea68a19c2d46a931$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $ea68a19c2d46a931$var$dispatchSetState.bind(null, $ea68a19c2d46a931$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $ea68a19c2d46a931$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $ea68a19c2d46a931$var$mountWorkInProgressHook();
        return $ea68a19c2d46a931$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $ea68a19c2d46a931$var$mountStateImpl(!1);
        stateHook = $ea68a19c2d46a931$var$startTransition.bind(null, $ea68a19c2d46a931$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $ea68a19c2d46a931$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $ea68a19c2d46a931$var$currentlyRenderingFiber, hook = $ea68a19c2d46a931$var$mountWorkInProgressHook();
        if ($ea68a19c2d46a931$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $ea68a19c2d46a931$var$workInProgressRoot) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(349));
            0 !== ($ea68a19c2d46a931$var$workInProgressRootRenderLanes & 127) || $ea68a19c2d46a931$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $ea68a19c2d46a931$var$mountEffect($ea68a19c2d46a931$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $ea68a19c2d46a931$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $ea68a19c2d46a931$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $ea68a19c2d46a931$var$mountWorkInProgressHook(), identifierPrefix = $ea68a19c2d46a931$var$workInProgressRoot.identifierPrefix;
        if ($ea68a19c2d46a931$var$isHydrating) {
            var JSCompiler_inline_result = $ea68a19c2d46a931$var$treeContextOverflow;
            var idWithLeadingBit = $ea68a19c2d46a931$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $ea68a19c2d46a931$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $ea68a19c2d46a931$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $ea68a19c2d46a931$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $ea68a19c2d46a931$var$useHostTransitionStatus,
    useFormState: $ea68a19c2d46a931$var$mountActionState,
    useActionState: $ea68a19c2d46a931$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $ea68a19c2d46a931$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $ea68a19c2d46a931$var$dispatchOptimisticSetState.bind(null, $ea68a19c2d46a931$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $ea68a19c2d46a931$var$useMemoCache,
    useCacheRefresh: function() {
        return $ea68a19c2d46a931$var$mountWorkInProgressHook().memoizedState = $ea68a19c2d46a931$var$refreshCache.bind(null, $ea68a19c2d46a931$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $ea68a19c2d46a931$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($ea68a19c2d46a931$var$executionContext & 2)) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $ea68a19c2d46a931$var$HooksDispatcherOnUpdate = {
    readContext: $ea68a19c2d46a931$var$readContext,
    use: $ea68a19c2d46a931$var$use,
    useCallback: $ea68a19c2d46a931$var$updateCallback,
    useContext: $ea68a19c2d46a931$var$readContext,
    useEffect: $ea68a19c2d46a931$var$updateEffect,
    useImperativeHandle: $ea68a19c2d46a931$var$updateImperativeHandle,
    useInsertionEffect: $ea68a19c2d46a931$var$updateInsertionEffect,
    useLayoutEffect: $ea68a19c2d46a931$var$updateLayoutEffect,
    useMemo: $ea68a19c2d46a931$var$updateMemo,
    useReducer: $ea68a19c2d46a931$var$updateReducer,
    useRef: $ea68a19c2d46a931$var$updateRef,
    useState: function() {
        return $ea68a19c2d46a931$var$updateReducer($ea68a19c2d46a931$var$basicStateReducer);
    },
    useDebugValue: $ea68a19c2d46a931$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $ea68a19c2d46a931$var$updateWorkInProgressHook();
        return $ea68a19c2d46a931$var$updateDeferredValueImpl(hook, $ea68a19c2d46a931$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $ea68a19c2d46a931$var$updateReducer($ea68a19c2d46a931$var$basicStateReducer)[0], start = $ea68a19c2d46a931$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $ea68a19c2d46a931$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $ea68a19c2d46a931$var$updateSyncExternalStore,
    useId: $ea68a19c2d46a931$var$updateId,
    useHostTransitionStatus: $ea68a19c2d46a931$var$useHostTransitionStatus,
    useFormState: $ea68a19c2d46a931$var$updateActionState,
    useActionState: $ea68a19c2d46a931$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $ea68a19c2d46a931$var$updateWorkInProgressHook();
        return $ea68a19c2d46a931$var$updateOptimisticImpl(hook, $ea68a19c2d46a931$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $ea68a19c2d46a931$var$useMemoCache,
    useCacheRefresh: $ea68a19c2d46a931$var$updateRefresh,
    useEffectEvent: $ea68a19c2d46a931$var$updateEvent
}, $ea68a19c2d46a931$var$HooksDispatcherOnRerender = {
    readContext: $ea68a19c2d46a931$var$readContext,
    use: $ea68a19c2d46a931$var$use,
    useCallback: $ea68a19c2d46a931$var$updateCallback,
    useContext: $ea68a19c2d46a931$var$readContext,
    useEffect: $ea68a19c2d46a931$var$updateEffect,
    useImperativeHandle: $ea68a19c2d46a931$var$updateImperativeHandle,
    useInsertionEffect: $ea68a19c2d46a931$var$updateInsertionEffect,
    useLayoutEffect: $ea68a19c2d46a931$var$updateLayoutEffect,
    useMemo: $ea68a19c2d46a931$var$updateMemo,
    useReducer: $ea68a19c2d46a931$var$rerenderReducer,
    useRef: $ea68a19c2d46a931$var$updateRef,
    useState: function() {
        return $ea68a19c2d46a931$var$rerenderReducer($ea68a19c2d46a931$var$basicStateReducer);
    },
    useDebugValue: $ea68a19c2d46a931$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $ea68a19c2d46a931$var$updateWorkInProgressHook();
        return null === $ea68a19c2d46a931$var$currentHook ? $ea68a19c2d46a931$var$mountDeferredValueImpl(hook, value, initialValue) : $ea68a19c2d46a931$var$updateDeferredValueImpl(hook, $ea68a19c2d46a931$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $ea68a19c2d46a931$var$rerenderReducer($ea68a19c2d46a931$var$basicStateReducer)[0], start = $ea68a19c2d46a931$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $ea68a19c2d46a931$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $ea68a19c2d46a931$var$updateSyncExternalStore,
    useId: $ea68a19c2d46a931$var$updateId,
    useHostTransitionStatus: $ea68a19c2d46a931$var$useHostTransitionStatus,
    useFormState: $ea68a19c2d46a931$var$rerenderActionState,
    useActionState: $ea68a19c2d46a931$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $ea68a19c2d46a931$var$updateWorkInProgressHook();
        if (null !== $ea68a19c2d46a931$var$currentHook) return $ea68a19c2d46a931$var$updateOptimisticImpl(hook, $ea68a19c2d46a931$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $ea68a19c2d46a931$var$useMemoCache,
    useCacheRefresh: $ea68a19c2d46a931$var$updateRefresh,
    useEffectEvent: $ea68a19c2d46a931$var$updateEvent
};
function $ea68a19c2d46a931$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $ea68a19c2d46a931$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $ea68a19c2d46a931$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $ea68a19c2d46a931$var$requestUpdateLane(), update = $ea68a19c2d46a931$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $ea68a19c2d46a931$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($ea68a19c2d46a931$var$scheduleUpdateOnFiber(payload, inst, lane), $ea68a19c2d46a931$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $ea68a19c2d46a931$var$requestUpdateLane(), update = $ea68a19c2d46a931$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $ea68a19c2d46a931$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($ea68a19c2d46a931$var$scheduleUpdateOnFiber(payload, inst, lane), $ea68a19c2d46a931$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $ea68a19c2d46a931$var$requestUpdateLane(), update = $ea68a19c2d46a931$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $ea68a19c2d46a931$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($ea68a19c2d46a931$var$scheduleUpdateOnFiber(callback, inst, lane), $ea68a19c2d46a931$var$entangleTransitions(callback, inst, lane));
    }
};
function $ea68a19c2d46a931$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$ea68a19c2d46a931$var$shallowEqual(oldProps, newProps) || !$ea68a19c2d46a931$var$shallowEqual(oldState, newState) : !0;
}
function $ea68a19c2d46a931$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $ea68a19c2d46a931$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $ea68a19c2d46a931$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $ea68a19c2d46a931$var$assign({}, newProps));
        for(var propName$77 in Component)void 0 === newProps[propName$77] && (newProps[propName$77] = Component[propName$77]);
    }
    return newProps;
}
function $ea68a19c2d46a931$var$defaultOnUncaughtError(error) {
    $ea68a19c2d46a931$var$reportGlobalError(error);
}
function $ea68a19c2d46a931$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $ea68a19c2d46a931$var$defaultOnRecoverableError(error) {
    $ea68a19c2d46a931$var$reportGlobalError(error);
}
function $ea68a19c2d46a931$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$78) {
        setTimeout(function() {
            throw e$78;
        });
    }
}
function $ea68a19c2d46a931$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$79) {
        setTimeout(function() {
            throw e$79;
        });
    }
}
function $ea68a19c2d46a931$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $ea68a19c2d46a931$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $ea68a19c2d46a931$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $ea68a19c2d46a931$var$createClassErrorUpdate(lane) {
    lane = $ea68a19c2d46a931$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $ea68a19c2d46a931$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $ea68a19c2d46a931$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $ea68a19c2d46a931$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $ea68a19c2d46a931$var$legacyErrorBoundariesThatAlreadyFailed ? $ea68a19c2d46a931$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $ea68a19c2d46a931$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $ea68a19c2d46a931$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $ea68a19c2d46a931$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $ea68a19c2d46a931$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                case 19:
                    return null === $ea68a19c2d46a931$var$shellBoundary ? $ea68a19c2d46a931$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $ea68a19c2d46a931$var$workInProgressRootExitStatus && ($ea68a19c2d46a931$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $ea68a19c2d46a931$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $ea68a19c2d46a931$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $ea68a19c2d46a931$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $ea68a19c2d46a931$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $ea68a19c2d46a931$var$attachPingListener(root, value, rootRenderLanes);
        $ea68a19c2d46a931$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($ea68a19c2d46a931$var$isHydrating) return returnFiber = $ea68a19c2d46a931$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $ea68a19c2d46a931$var$HydrationMismatchException && (root = Error($ea68a19c2d46a931$var$formatProdErrorMessage(422), {
        cause: value
    }), $ea68a19c2d46a931$var$queueHydrationError($ea68a19c2d46a931$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $ea68a19c2d46a931$var$HydrationMismatchException && (returnFiber = Error($ea68a19c2d46a931$var$formatProdErrorMessage(423), {
        cause: value
    }), $ea68a19c2d46a931$var$queueHydrationError($ea68a19c2d46a931$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $ea68a19c2d46a931$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $ea68a19c2d46a931$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $ea68a19c2d46a931$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $ea68a19c2d46a931$var$workInProgressRootExitStatus && ($ea68a19c2d46a931$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($ea68a19c2d46a931$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $ea68a19c2d46a931$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $ea68a19c2d46a931$var$workInProgressRootConcurrentErrors ? $ea68a19c2d46a931$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $ea68a19c2d46a931$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $ea68a19c2d46a931$var$workInProgressRootExitStatus && ($ea68a19c2d46a931$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $ea68a19c2d46a931$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $ea68a19c2d46a931$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $ea68a19c2d46a931$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                returnFiber = sourceFiber.type;
                wrapperError = sourceFiber.stateNode;
                if (0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $ea68a19c2d46a931$var$legacyErrorBoundariesThatAlreadyFailed || !$ea68a19c2d46a931$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $ea68a19c2d46a931$var$createClassErrorUpdate(rootRenderLanes), $ea68a19c2d46a931$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $ea68a19c2d46a931$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
                break;
            case 22:
                if (null !== sourceFiber.memoizedState) return sourceFiber.flags |= 65536, !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $ea68a19c2d46a931$var$SelectiveHydrationException = Error($ea68a19c2d46a931$var$formatProdErrorMessage(461)), $ea68a19c2d46a931$var$didReceiveUpdate = !1;
function $ea68a19c2d46a931$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $ea68a19c2d46a931$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $ea68a19c2d46a931$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $ea68a19c2d46a931$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $ea68a19c2d46a931$var$prepareToReadContext(workInProgress);
    nextProps = $ea68a19c2d46a931$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $ea68a19c2d46a931$var$checkDidRenderIdHook();
    if (null !== current && !$ea68a19c2d46a931$var$didReceiveUpdate) return $ea68a19c2d46a931$var$bailoutHooks(current, workInProgress, renderLanes), $ea68a19c2d46a931$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $ea68a19c2d46a931$var$isHydrating && key && $ea68a19c2d46a931$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $ea68a19c2d46a931$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $ea68a19c2d46a931$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$ea68a19c2d46a931$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $ea68a19c2d46a931$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $ea68a19c2d46a931$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$ea68a19c2d46a931$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $ea68a19c2d46a931$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $ea68a19c2d46a931$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $ea68a19c2d46a931$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $ea68a19c2d46a931$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($ea68a19c2d46a931$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($ea68a19c2d46a931$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $ea68a19c2d46a931$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($ea68a19c2d46a931$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $ea68a19c2d46a931$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $ea68a19c2d46a931$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $ea68a19c2d46a931$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $ea68a19c2d46a931$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $ea68a19c2d46a931$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $ea68a19c2d46a931$var$pushHiddenContext(workInProgress, prevState) : $ea68a19c2d46a931$var$reuseHiddenContextOnStack(), $ea68a19c2d46a931$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $ea68a19c2d46a931$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($ea68a19c2d46a931$var$pushTransition(workInProgress, prevState.cachePool), $ea68a19c2d46a931$var$pushHiddenContext(workInProgress, prevState), $ea68a19c2d46a931$var$reuseSuspenseHandlerOnStack(), workInProgress.memoizedState = null) : (null !== current && $ea68a19c2d46a931$var$pushTransition(workInProgress, null), $ea68a19c2d46a931$var$reuseHiddenContextOnStack(), $ea68a19c2d46a931$var$reuseSuspenseHandlerOnStack());
    $ea68a19c2d46a931$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $ea68a19c2d46a931$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $ea68a19c2d46a931$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $ea68a19c2d46a931$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $ea68a19c2d46a931$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $ea68a19c2d46a931$var$pushTransition(workInProgress, null);
    $ea68a19c2d46a931$var$reuseHiddenContextOnStack();
    $ea68a19c2d46a931$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $ea68a19c2d46a931$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $ea68a19c2d46a931$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $ea68a19c2d46a931$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $ea68a19c2d46a931$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $ea68a19c2d46a931$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $ea68a19c2d46a931$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $ea68a19c2d46a931$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $ea68a19c2d46a931$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($ea68a19c2d46a931$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $ea68a19c2d46a931$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, current.memoizedState = {
                baseLanes: 0,
                cachePool: null
            }, $ea68a19c2d46a931$var$bailoutOffscreenComponent(null, current);
            $ea68a19c2d46a931$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $ea68a19c2d46a931$var$nextHydratableInstance) ? (current = $ea68a19c2d46a931$var$canHydrateHydrationBoundary(current, $ea68a19c2d46a931$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $ea68a19c2d46a931$var$treeContextProvider ? {
                    id: $ea68a19c2d46a931$var$treeContextId,
                    overflow: $ea68a19c2d46a931$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $ea68a19c2d46a931$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $ea68a19c2d46a931$var$hydrationParentFiber = workInProgress, $ea68a19c2d46a931$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $ea68a19c2d46a931$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $ea68a19c2d46a931$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $ea68a19c2d46a931$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $ea68a19c2d46a931$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(558));
        } else if ($ea68a19c2d46a931$var$didReceiveUpdate || $ea68a19c2d46a931$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $ea68a19c2d46a931$var$didReceiveUpdate || didSuspend) {
            if (null === $ea68a19c2d46a931$var$currentTreeHiddenStackCursor.current) {
                nextProps = $ea68a19c2d46a931$var$workInProgressRoot;
                if (null !== nextProps && (dehydrated = $ea68a19c2d46a931$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $ea68a19c2d46a931$var$enqueueConcurrentRenderForLane(current, dehydrated), $ea68a19c2d46a931$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $ea68a19c2d46a931$var$SelectiveHydrationException;
                $ea68a19c2d46a931$var$renderDidSuspendDelayIfPossible();
            }
            workInProgress = $ea68a19c2d46a931$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $ea68a19c2d46a931$var$nextHydratableInstance = $ea68a19c2d46a931$var$getNextHydratable(dehydrated.nextSibling), $ea68a19c2d46a931$var$hydrationParentFiber = workInProgress, $ea68a19c2d46a931$var$isHydrating = !0, $ea68a19c2d46a931$var$hydrationErrors = null, $ea68a19c2d46a931$var$rootOrSingletonContext = !1, null !== current && $ea68a19c2d46a931$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $ea68a19c2d46a931$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 134221824;
        return workInProgress;
    }
    current = $ea68a19c2d46a931$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $ea68a19c2d46a931$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $ea68a19c2d46a931$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $ea68a19c2d46a931$var$prepareToReadContext(workInProgress);
    Component = $ea68a19c2d46a931$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $ea68a19c2d46a931$var$checkDidRenderIdHook();
    if (null !== current && !$ea68a19c2d46a931$var$didReceiveUpdate) return $ea68a19c2d46a931$var$bailoutHooks(current, workInProgress, renderLanes), $ea68a19c2d46a931$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $ea68a19c2d46a931$var$isHydrating && nextProps && $ea68a19c2d46a931$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $ea68a19c2d46a931$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $ea68a19c2d46a931$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $ea68a19c2d46a931$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $ea68a19c2d46a931$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $ea68a19c2d46a931$var$finishRenderingHooks(current);
    Component = $ea68a19c2d46a931$var$checkDidRenderIdHook();
    if (null !== current && !$ea68a19c2d46a931$var$didReceiveUpdate) return $ea68a19c2d46a931$var$bailoutHooks(current, workInProgress, renderLanes), $ea68a19c2d46a931$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $ea68a19c2d46a931$var$isHydrating && Component && $ea68a19c2d46a931$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $ea68a19c2d46a931$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $ea68a19c2d46a931$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $ea68a19c2d46a931$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $ea68a19c2d46a931$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $ea68a19c2d46a931$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $ea68a19c2d46a931$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $ea68a19c2d46a931$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $ea68a19c2d46a931$var$readContext(contextType) : $ea68a19c2d46a931$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($ea68a19c2d46a931$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $ea68a19c2d46a931$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $ea68a19c2d46a931$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $ea68a19c2d46a931$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $ea68a19c2d46a931$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $ea68a19c2d46a931$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $ea68a19c2d46a931$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $ea68a19c2d46a931$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $ea68a19c2d46a931$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $ea68a19c2d46a931$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $ea68a19c2d46a931$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $ea68a19c2d46a931$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($ea68a19c2d46a931$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $ea68a19c2d46a931$var$hasForceUpdate || $ea68a19c2d46a931$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $ea68a19c2d46a931$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $ea68a19c2d46a931$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $ea68a19c2d46a931$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $ea68a19c2d46a931$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $ea68a19c2d46a931$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $ea68a19c2d46a931$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $ea68a19c2d46a931$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $ea68a19c2d46a931$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $ea68a19c2d46a931$var$hasForceUpdate || null !== current && null !== current.dependencies && $ea68a19c2d46a931$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($ea68a19c2d46a931$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $ea68a19c2d46a931$var$hasForceUpdate || $ea68a19c2d46a931$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $ea68a19c2d46a931$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $ea68a19c2d46a931$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $ea68a19c2d46a931$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $ea68a19c2d46a931$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $ea68a19c2d46a931$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $ea68a19c2d46a931$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $ea68a19c2d46a931$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $ea68a19c2d46a931$var$resetHydrationState();
    workInProgress.flags |= 256;
    $ea68a19c2d46a931$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $ea68a19c2d46a931$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $ea68a19c2d46a931$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $ea68a19c2d46a931$var$getSuspendedCache()
    };
}
function $ea68a19c2d46a931$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $ea68a19c2d46a931$var$workInProgressDeferredLane);
    return current;
}
function $ea68a19c2d46a931$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($ea68a19c2d46a931$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($ea68a19c2d46a931$var$isHydrating) {
            showFallback ? $ea68a19c2d46a931$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $ea68a19c2d46a931$var$reuseSuspenseHandlerOnStack();
            (current = $ea68a19c2d46a931$var$nextHydratableInstance) ? (current = $ea68a19c2d46a931$var$canHydrateHydrationBoundary(current, $ea68a19c2d46a931$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $ea68a19c2d46a931$var$treeContextProvider ? {
                    id: $ea68a19c2d46a931$var$treeContextId,
                    overflow: $ea68a19c2d46a931$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $ea68a19c2d46a931$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $ea68a19c2d46a931$var$hydrationParentFiber = workInProgress, $ea68a19c2d46a931$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $ea68a19c2d46a931$var$throwOnHydrationMismatch(workInProgress);
            $ea68a19c2d46a931$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        didSuspend = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $ea68a19c2d46a931$var$reuseSuspenseHandlerOnStack(), showFallback = workInProgress.mode, didSuspend = $ea68a19c2d46a931$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: didSuspend
        }, showFallback), nextProps = $ea68a19c2d46a931$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), didSuspend.return = workInProgress, nextProps.return = workInProgress, didSuspend.sibling = nextProps, workInProgress.child = didSuspend, nextProps = workInProgress.child, nextProps.memoizedState = $ea68a19c2d46a931$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $ea68a19c2d46a931$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $ea68a19c2d46a931$var$SUSPENDED_MARKER, $ea68a19c2d46a931$var$bailoutOffscreenComponent(null, nextProps);
        $ea68a19c2d46a931$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $ea68a19c2d46a931$var$mountSuspensePrimaryChildren(workInProgress, didSuspend);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated$96 = prevState.dehydrated;
        if (null !== dehydrated$96) return $ea68a19c2d46a931$var$updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, JSCompiler_temp, nextProps, dehydrated$96, prevState, renderLanes);
    }
    if (showFallback) return $ea68a19c2d46a931$var$reuseSuspenseHandlerOnStack(), showFallback = nextProps.fallback, didSuspend = workInProgress.mode, prevState = current.child, dehydrated$96 = prevState.sibling, nextProps = $ea68a19c2d46a931$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 1206910976, null !== dehydrated$96 ? showFallback = $ea68a19c2d46a931$var$createWorkInProgress(dehydrated$96, showFallback) : (showFallback = $ea68a19c2d46a931$var$createFiberFromFragment(showFallback, didSuspend, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $ea68a19c2d46a931$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, showFallback = current.child.memoizedState, null === showFallback ? showFallback = $ea68a19c2d46a931$var$mountSuspenseOffscreenState(renderLanes) : (didSuspend = showFallback.cachePool, null !== didSuspend ? (prevState = $ea68a19c2d46a931$var$CacheContext._currentValue, didSuspend = didSuspend.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : didSuspend) : didSuspend = $ea68a19c2d46a931$var$getSuspendedCache(), showFallback = {
        baseLanes: showFallback.baseLanes | renderLanes,
        cachePool: didSuspend
    }), nextProps.memoizedState = showFallback, nextProps.childLanes = $ea68a19c2d46a931$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $ea68a19c2d46a931$var$SUSPENDED_MARKER, $ea68a19c2d46a931$var$bailoutOffscreenComponent(current.child, nextProps);
    $ea68a19c2d46a931$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $ea68a19c2d46a931$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $ea68a19c2d46a931$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $ea68a19c2d46a931$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $ea68a19c2d46a931$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $ea68a19c2d46a931$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $ea68a19c2d46a931$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $ea68a19c2d46a931$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $ea68a19c2d46a931$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $ea68a19c2d46a931$var$updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, didPrimaryChildrenDefer, nextProps, suspenseInstance, suspenseState, renderLanes) {
    if (didSuspend) {
        if (workInProgress.flags & 256) return $ea68a19c2d46a931$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, $ea68a19c2d46a931$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        if (null !== workInProgress.memoizedState) return $ea68a19c2d46a931$var$reuseSuspenseHandlerOnStack(), workInProgress.child = current.child, workInProgress.flags |= 128, null;
        $ea68a19c2d46a931$var$reuseSuspenseHandlerOnStack();
        suspenseInstance = nextProps.fallback;
        suspenseState = workInProgress.mode;
        nextProps = $ea68a19c2d46a931$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, suspenseState);
        suspenseInstance = $ea68a19c2d46a931$var$createFiberFromFragment(suspenseInstance, suspenseState, renderLanes, null);
        suspenseInstance.flags |= 2;
        nextProps.return = workInProgress;
        suspenseInstance.return = workInProgress;
        nextProps.sibling = suspenseInstance;
        workInProgress.child = nextProps;
        $ea68a19c2d46a931$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        nextProps = workInProgress.child;
        nextProps.memoizedState = $ea68a19c2d46a931$var$mountSuspenseOffscreenState(renderLanes);
        nextProps.childLanes = $ea68a19c2d46a931$var$getRemainingWorkInPrimaryTree(current, didPrimaryChildrenDefer, renderLanes);
        workInProgress.memoizedState = $ea68a19c2d46a931$var$SUSPENDED_MARKER;
        return $ea68a19c2d46a931$var$bailoutOffscreenComponent(null, nextProps);
    }
    $ea68a19c2d46a931$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    if ($ea68a19c2d46a931$var$isSuspenseInstanceFallback(suspenseInstance)) {
        didPrimaryChildrenDefer = suspenseInstance.nextSibling && suspenseInstance.nextSibling.dataset;
        if (didPrimaryChildrenDefer) var digest = didPrimaryChildrenDefer.dgst;
        didPrimaryChildrenDefer = digest;
        "" !== didPrimaryChildrenDefer && (nextProps = Error($ea68a19c2d46a931$var$formatProdErrorMessage(419)), nextProps.stack = "", nextProps.digest = didPrimaryChildrenDefer, $ea68a19c2d46a931$var$queueHydrationError({
            value: nextProps,
            source: null,
            stack: null
        }));
        return $ea68a19c2d46a931$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    $ea68a19c2d46a931$var$didReceiveUpdate || $ea68a19c2d46a931$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1);
    didPrimaryChildrenDefer = 0 !== (renderLanes & current.childLanes);
    if ($ea68a19c2d46a931$var$didReceiveUpdate || didPrimaryChildrenDefer) {
        if (null !== $ea68a19c2d46a931$var$currentTreeHiddenStackCursor.current) return $ea68a19c2d46a931$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        didPrimaryChildrenDefer = $ea68a19c2d46a931$var$workInProgressRoot;
        if (null !== didPrimaryChildrenDefer && (nextProps = $ea68a19c2d46a931$var$getBumpedLaneForHydration(didPrimaryChildrenDefer, renderLanes), 0 !== nextProps && nextProps !== suspenseState.retryLane)) throw suspenseState.retryLane = nextProps, $ea68a19c2d46a931$var$enqueueConcurrentRenderForLane(current, nextProps), $ea68a19c2d46a931$var$scheduleUpdateOnFiber(didPrimaryChildrenDefer, current, nextProps), $ea68a19c2d46a931$var$SelectiveHydrationException;
        $ea68a19c2d46a931$var$isSuspenseInstancePending(suspenseInstance) || $ea68a19c2d46a931$var$renderDidSuspendDelayIfPossible();
        return $ea68a19c2d46a931$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    if ($ea68a19c2d46a931$var$isSuspenseInstancePending(suspenseInstance)) return workInProgress.flags |= 192, workInProgress.child = current.child, null;
    current = suspenseState.treeContext;
    $ea68a19c2d46a931$var$nextHydratableInstance = $ea68a19c2d46a931$var$getNextHydratable(suspenseInstance.nextSibling);
    $ea68a19c2d46a931$var$hydrationParentFiber = workInProgress;
    $ea68a19c2d46a931$var$isHydrating = !0;
    $ea68a19c2d46a931$var$hydrationErrors = null;
    $ea68a19c2d46a931$var$rootOrSingletonContext = !1;
    null !== current && $ea68a19c2d46a931$var$restoreSuspendedTreeContext(workInProgress, current);
    workInProgress = $ea68a19c2d46a931$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children);
    workInProgress.flags |= 134221824;
    return workInProgress;
}
function $ea68a19c2d46a931$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $ea68a19c2d46a931$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $ea68a19c2d46a931$var$findLastContentRow(firstChild) {
    for(var lastContentRow = null; null !== firstChild;){
        var currentRow = firstChild.alternate;
        null !== currentRow && null === $ea68a19c2d46a931$var$findFirstSuspended(currentRow) && (lastContentRow = firstChild);
        firstChild = firstChild.sibling;
    }
    return lastContentRow;
}
function $ea68a19c2d46a931$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $ea68a19c2d46a931$var$reverseChildren(fiber) {
    var row = fiber.child;
    for(fiber.child = null; null !== row;){
        var nextRow = row.sibling;
        row.sibling = fiber.child;
        fiber.child = row;
        row = nextRow;
    }
}
function $ea68a19c2d46a931$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $ea68a19c2d46a931$var$suspenseStackCursor.current;
    if (workInProgress.flags & 128) return $ea68a19c2d46a931$var$pushSuspenseListContext(workInProgress, suspenseContext), null;
    var shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $ea68a19c2d46a931$var$pushSuspenseListContext(workInProgress, suspenseContext);
    "backwards" === revealOrder && null !== current ? ($ea68a19c2d46a931$var$reverseChildren(current), $ea68a19c2d46a931$var$reconcileChildren(current, workInProgress, nextProps, renderLanes), $ea68a19c2d46a931$var$reverseChildren(current)) : $ea68a19c2d46a931$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $ea68a19c2d46a931$var$isHydrating ? $ea68a19c2d46a931$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $ea68a19c2d46a931$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $ea68a19c2d46a931$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "backwards":
            renderLanes = $ea68a19c2d46a931$var$findLastContentRow(workInProgress.child);
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null, $ea68a19c2d46a931$var$reverseChildren(workInProgress));
            $ea68a19c2d46a931$var$initSuspenseListRenderState(workInProgress, !0, revealOrder, null, tailMode, nextProps);
            break;
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $ea68a19c2d46a931$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $ea68a19c2d46a931$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $ea68a19c2d46a931$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        case "independent":
            workInProgress.memoizedState = null;
            break;
        default:
            renderLanes = $ea68a19c2d46a931$var$findLastContentRow(workInProgress.child), null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null), $ea68a19c2d46a931$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
    }
    return workInProgress.child;
}
function $ea68a19c2d46a931$var$updateContextProvider(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $ea68a19c2d46a931$var$pushProvider(workInProgress, workInProgress.type, newProps.value);
    $ea68a19c2d46a931$var$reconcileChildren(current, workInProgress, newProps.children, renderLanes);
    return workInProgress.child;
}
function $ea68a19c2d46a931$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $ea68a19c2d46a931$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($ea68a19c2d46a931$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $ea68a19c2d46a931$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $ea68a19c2d46a931$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $ea68a19c2d46a931$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $ea68a19c2d46a931$var$checkIfContextChanged(current) ? !0 : !1;
}
function $ea68a19c2d46a931$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $ea68a19c2d46a931$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $ea68a19c2d46a931$var$pushProvider(workInProgress, $ea68a19c2d46a931$var$CacheContext, current.memoizedState.cache);
            $ea68a19c2d46a931$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $ea68a19c2d46a931$var$pushHostContext(workInProgress);
            break;
        case 4:
            $ea68a19c2d46a931$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $ea68a19c2d46a931$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $ea68a19c2d46a931$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$108 = workInProgress.memoizedState;
            if (null !== state$108) {
                if (null !== state$108.dehydrated) return $ea68a19c2d46a931$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                state$108 = $ea68a19c2d46a931$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1);
                var primaryChildLanes = workInProgress.child.childLanes;
                if (state$108 || 0 !== (renderLanes & primaryChildLanes)) return $ea68a19c2d46a931$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $ea68a19c2d46a931$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $ea68a19c2d46a931$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $ea68a19c2d46a931$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            if (workInProgress.flags & 128) return $ea68a19c2d46a931$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
            primaryChildLanes = 0 !== (current.flags & 128);
            state$108 = 0 !== (renderLanes & workInProgress.childLanes);
            state$108 || ($ea68a19c2d46a931$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$108 = 0 !== (renderLanes & workInProgress.childLanes));
            if (primaryChildLanes) {
                if (state$108) return $ea68a19c2d46a931$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            primaryChildLanes = workInProgress.memoizedState;
            null !== primaryChildLanes && (primaryChildLanes.rendering = null, primaryChildLanes.tail = null, primaryChildLanes.lastEffect = null);
            $ea68a19c2d46a931$var$pushSuspenseListContext(workInProgress, $ea68a19c2d46a931$var$suspenseStackCursor.current);
            if (state$108) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $ea68a19c2d46a931$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $ea68a19c2d46a931$var$pushProvider(workInProgress, $ea68a19c2d46a931$var$CacheContext, current.memoizedState.cache);
    }
    return $ea68a19c2d46a931$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $ea68a19c2d46a931$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $ea68a19c2d46a931$var$didReceiveUpdate = !0;
        else {
            if (!$ea68a19c2d46a931$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $ea68a19c2d46a931$var$didReceiveUpdate = !1, $ea68a19c2d46a931$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $ea68a19c2d46a931$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $ea68a19c2d46a931$var$didReceiveUpdate = !1, $ea68a19c2d46a931$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $ea68a19c2d46a931$var$pushTreeId(workInProgress, $ea68a19c2d46a931$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $ea68a19c2d46a931$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $ea68a19c2d46a931$var$shouldConstruct(current) ? (props = $ea68a19c2d46a931$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $ea68a19c2d46a931$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $ea68a19c2d46a931$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $ea68a19c2d46a931$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $ea68a19c2d46a931$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $ea68a19c2d46a931$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $ea68a19c2d46a931$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $ea68a19c2d46a931$var$REACT_CONTEXT_TYPE) {
                            workInProgress.tag = 10;
                            workInProgress.type = current;
                            workInProgress = $ea68a19c2d46a931$var$updateContextProvider(null, workInProgress, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $ea68a19c2d46a931$var$getComponentNameFromType(current) || current;
                    throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $ea68a19c2d46a931$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $ea68a19c2d46a931$var$resolveClassComponentProps(props, workInProgress.pendingProps), $ea68a19c2d46a931$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $ea68a19c2d46a931$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $ea68a19c2d46a931$var$cloneUpdateQueue(current, workInProgress);
                $ea68a19c2d46a931$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $ea68a19c2d46a931$var$pushProvider(workInProgress, $ea68a19c2d46a931$var$CacheContext, props);
                props !== prevState.cache && $ea68a19c2d46a931$var$propagateContextChanges(workInProgress, [
                    $ea68a19c2d46a931$var$CacheContext
                ], renderLanes, !0);
                $ea68a19c2d46a931$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $ea68a19c2d46a931$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $ea68a19c2d46a931$var$createCapturedValueAtFiber(Error($ea68a19c2d46a931$var$formatProdErrorMessage(424)), workInProgress);
                        $ea68a19c2d46a931$var$queueHydrationError($$typeof);
                        workInProgress = $ea68a19c2d46a931$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $ea68a19c2d46a931$var$nextHydratableInstance = $ea68a19c2d46a931$var$getNextHydratable(current.firstChild);
                        $ea68a19c2d46a931$var$hydrationParentFiber = workInProgress;
                        $ea68a19c2d46a931$var$isHydrating = !0;
                        $ea68a19c2d46a931$var$hydrationErrors = null;
                        $ea68a19c2d46a931$var$rootOrSingletonContext = !0;
                        renderLanes = $ea68a19c2d46a931$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 134221824, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $ea68a19c2d46a931$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $ea68a19c2d46a931$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $ea68a19c2d46a931$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $ea68a19c2d46a931$var$markRef(current, workInProgress), null === current ? (renderLanes = $ea68a19c2d46a931$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $ea68a19c2d46a931$var$isHydrating || (workInProgress.stateNode = $ea68a19c2d46a931$var$createHoistableInstance(workInProgress.type, workInProgress.pendingProps, $ea68a19c2d46a931$var$rootInstanceStackCursor.current, workInProgress)) : workInProgress.memoizedState = $ea68a19c2d46a931$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $ea68a19c2d46a931$var$pushHostContext(workInProgress), null === current && $ea68a19c2d46a931$var$isHydrating && (props = workInProgress.stateNode = $ea68a19c2d46a931$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $ea68a19c2d46a931$var$rootInstanceStackCursor.current), $ea68a19c2d46a931$var$hydrationParentFiber = workInProgress, $ea68a19c2d46a931$var$rootOrSingletonContext = !0, $$typeof = $ea68a19c2d46a931$var$nextHydratableInstance, $ea68a19c2d46a931$var$isSingletonScope(workInProgress.type) ? ($ea68a19c2d46a931$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $ea68a19c2d46a931$var$nextHydratableInstance = $ea68a19c2d46a931$var$getNextHydratable(props.firstChild)) : $ea68a19c2d46a931$var$nextHydratableInstance = $$typeof), $ea68a19c2d46a931$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $ea68a19c2d46a931$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $ea68a19c2d46a931$var$isHydrating) {
                if ($$typeof = props = $ea68a19c2d46a931$var$nextHydratableInstance) props = $ea68a19c2d46a931$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $ea68a19c2d46a931$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $ea68a19c2d46a931$var$hydrationParentFiber = workInProgress, $ea68a19c2d46a931$var$nextHydratableInstance = $ea68a19c2d46a931$var$getNextHydratable(props.firstChild), $ea68a19c2d46a931$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $ea68a19c2d46a931$var$throwOnHydrationMismatch(workInProgress);
            }
            $ea68a19c2d46a931$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $ea68a19c2d46a931$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $ea68a19c2d46a931$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $ea68a19c2d46a931$var$renderWithHooks(current, workInProgress, $ea68a19c2d46a931$var$TransitionAwareHostComponent, null, null, renderLanes), $ea68a19c2d46a931$var$HostTransitionContext._currentValue = $$typeof);
            $ea68a19c2d46a931$var$markRef(current, workInProgress);
            $ea68a19c2d46a931$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $ea68a19c2d46a931$var$isHydrating) {
                if (current = renderLanes = $ea68a19c2d46a931$var$nextHydratableInstance) renderLanes = $ea68a19c2d46a931$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $ea68a19c2d46a931$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $ea68a19c2d46a931$var$hydrationParentFiber = workInProgress, $ea68a19c2d46a931$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $ea68a19c2d46a931$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $ea68a19c2d46a931$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $ea68a19c2d46a931$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $ea68a19c2d46a931$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $ea68a19c2d46a931$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $ea68a19c2d46a931$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return props = workInProgress.pendingProps, $ea68a19c2d46a931$var$markRef(current, workInProgress), $ea68a19c2d46a931$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 8:
            return $ea68a19c2d46a931$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $ea68a19c2d46a931$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return $ea68a19c2d46a931$var$updateContextProvider(current, workInProgress, renderLanes);
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $ea68a19c2d46a931$var$prepareToReadContext(workInProgress), $$typeof = $ea68a19c2d46a931$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $ea68a19c2d46a931$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $ea68a19c2d46a931$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $ea68a19c2d46a931$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $ea68a19c2d46a931$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $ea68a19c2d46a931$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $ea68a19c2d46a931$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $ea68a19c2d46a931$var$prepareToReadContext(workInProgress), props = $ea68a19c2d46a931$var$readContext($ea68a19c2d46a931$var$CacheContext), null === current ? ($$typeof = $ea68a19c2d46a931$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $ea68a19c2d46a931$var$workInProgressRoot, prevState = $ea68a19c2d46a931$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $ea68a19c2d46a931$var$initializeUpdateQueue(workInProgress), $ea68a19c2d46a931$var$pushProvider(workInProgress, $ea68a19c2d46a931$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($ea68a19c2d46a931$var$cloneUpdateQueue(current, workInProgress), $ea68a19c2d46a931$var$processUpdateQueue(workInProgress, null, null, renderLanes), $ea68a19c2d46a931$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $ea68a19c2d46a931$var$pushProvider(workInProgress, $ea68a19c2d46a931$var$CacheContext, props)) : (props = prevState.cache, $ea68a19c2d46a931$var$pushProvider(workInProgress, $ea68a19c2d46a931$var$CacheContext, props), props !== $$typeof.cache && $ea68a19c2d46a931$var$propagateContextChanges(workInProgress, [
                $ea68a19c2d46a931$var$CacheContext
            ], renderLanes, !0))), $ea68a19c2d46a931$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 30:
            return null === workInProgress.stateNode && (workInProgress.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }), props = workInProgress.pendingProps, null != props.name && "auto" !== props.name ? workInProgress.flags |= null === current ? 18882560 : 18874368 : $ea68a19c2d46a931$var$isHydrating && $ea68a19c2d46a931$var$pushMaterializedTreeId(workInProgress), null !== current && current.memoizedProps.name !== props.name ? workInProgress.flags |= 4194816 : $ea68a19c2d46a931$var$markRef(current, workInProgress), $ea68a19c2d46a931$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $ea68a19c2d46a931$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $ea68a19c2d46a931$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    var JSCompiler_temp;
    if (JSCompiler_temp = 0 !== (workInProgress.mode & 32)) JSCompiler_temp = null === oldProps ? $ea68a19c2d46a931$var$maySuspendCommit(type, newProps) : $ea68a19c2d46a931$var$maySuspendCommit(type, newProps) && (newProps.src !== oldProps.src || newProps.srcSet !== oldProps.srcSet);
    if (JSCompiler_temp) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($ea68a19c2d46a931$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $ea68a19c2d46a931$var$suspendedThenable = $ea68a19c2d46a931$var$noopSuspenseyCommitThenable, $ea68a19c2d46a931$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $ea68a19c2d46a931$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$ea68a19c2d46a931$var$preloadResource(resource)) {
        if ($ea68a19c2d46a931$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $ea68a19c2d46a931$var$suspendedThenable = $ea68a19c2d46a931$var$noopSuspenseyCommitThenable, $ea68a19c2d46a931$var$SuspenseyCommitException;
    }
}
function $ea68a19c2d46a931$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $ea68a19c2d46a931$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $ea68a19c2d46a931$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $ea68a19c2d46a931$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$ea68a19c2d46a931$var$isHydrating) switch(renderState.tailMode){
        case "visible":
            break;
        case "collapsed":
            for(var tailNode = renderState.tail, lastTailNode = null; null !== tailNode;)null !== tailNode.alternate && (lastTailNode = tailNode), tailNode = tailNode.sibling;
            null === lastTailNode ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode.sibling = null;
            break;
        default:
            hasRenderedATailFallback = renderState.tail;
            for(tailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (tailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === tailNode ? renderState.tail = null : tailNode.sibling = null;
    }
}
function $ea68a19c2d46a931$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags & 1206910976, subtreeFlags |= child$113.flags & 1206910976, child$113.return = completedWork, child$113 = child$113.sibling;
    else for(child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags, subtreeFlags |= child$113.flags, child$113.return = completedWork, child$113 = child$113.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $ea68a19c2d46a931$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $ea68a19c2d46a931$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $ea68a19c2d46a931$var$bubbleProperties(workInProgress), null;
        case 1:
            return $ea68a19c2d46a931$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $ea68a19c2d46a931$var$popProvider($ea68a19c2d46a931$var$CacheContext);
            $ea68a19c2d46a931$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $ea68a19c2d46a931$var$popHydrationState(workInProgress) ? $ea68a19c2d46a931$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $ea68a19c2d46a931$var$upgradeHydrationErrorsToRecoverable());
            $ea68a19c2d46a931$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($ea68a19c2d46a931$var$markUpdate(workInProgress), null !== nextResource ? ($ea68a19c2d46a931$var$bubbleProperties(workInProgress), $ea68a19c2d46a931$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($ea68a19c2d46a931$var$bubbleProperties(workInProgress), $ea68a19c2d46a931$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($ea68a19c2d46a931$var$markUpdate(workInProgress), $ea68a19c2d46a931$var$bubbleProperties(workInProgress), $ea68a19c2d46a931$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($ea68a19c2d46a931$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $ea68a19c2d46a931$var$markUpdate(workInProgress), $ea68a19c2d46a931$var$bubbleProperties(workInProgress), $ea68a19c2d46a931$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $ea68a19c2d46a931$var$popHostContext(workInProgress);
            renderLanes = $ea68a19c2d46a931$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $ea68a19c2d46a931$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(166));
                    $ea68a19c2d46a931$var$bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                current = $ea68a19c2d46a931$var$contextStackCursor.current;
                $ea68a19c2d46a931$var$popHydrationState(workInProgress) ? $ea68a19c2d46a931$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $ea68a19c2d46a931$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $ea68a19c2d46a931$var$markUpdate(workInProgress));
            }
            $ea68a19c2d46a931$var$bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            return null;
        case 5:
            $ea68a19c2d46a931$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $ea68a19c2d46a931$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(166));
                    $ea68a19c2d46a931$var$bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                nextResource = $ea68a19c2d46a931$var$contextStackCursor.current;
                if ($ea68a19c2d46a931$var$popHydrationState(workInProgress)) $ea68a19c2d46a931$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $ea68a19c2d46a931$var$getOwnerDocumentFromRootContainer($ea68a19c2d46a931$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$ea68a19c2d46a931$var$internalInstanceKey] = workInProgress;
                    nextResource[$ea68a19c2d46a931$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($ea68a19c2d46a931$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $ea68a19c2d46a931$var$markUpdate(workInProgress);
                }
            }
            $ea68a19c2d46a931$var$bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            $ea68a19c2d46a931$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $ea68a19c2d46a931$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(166));
                current = $ea68a19c2d46a931$var$rootInstanceStackCursor.current;
                if ($ea68a19c2d46a931$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $ea68a19c2d46a931$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$ea68a19c2d46a931$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $ea68a19c2d46a931$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $ea68a19c2d46a931$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $ea68a19c2d46a931$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$ea68a19c2d46a931$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $ea68a19c2d46a931$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $ea68a19c2d46a931$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(557));
                        current[$ea68a19c2d46a931$var$internalInstanceKey] = workInProgress;
                    } else $ea68a19c2d46a931$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $ea68a19c2d46a931$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $ea68a19c2d46a931$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $ea68a19c2d46a931$var$popSuspenseHandler(workInProgress), workInProgress;
                    $ea68a19c2d46a931$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(558));
            }
            $ea68a19c2d46a931$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $ea68a19c2d46a931$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(317));
                        type[$ea68a19c2d46a931$var$internalInstanceKey] = workInProgress;
                    } else $ea68a19c2d46a931$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $ea68a19c2d46a931$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $ea68a19c2d46a931$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $ea68a19c2d46a931$var$popSuspenseHandler(workInProgress), workInProgress;
                    $ea68a19c2d46a931$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $ea68a19c2d46a931$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $ea68a19c2d46a931$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $ea68a19c2d46a931$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $ea68a19c2d46a931$var$popHostContainer(), null === current && $ea68a19c2d46a931$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), workInProgress.flags |= 67108864, $ea68a19c2d46a931$var$bubbleProperties(workInProgress), null;
        case 10:
            return $ea68a19c2d46a931$var$popProvider(workInProgress.type), $ea68a19c2d46a931$var$bubbleProperties(workInProgress), null;
        case 19:
            $ea68a19c2d46a931$var$popSuspenseListContext(workInProgress);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $ea68a19c2d46a931$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $ea68a19c2d46a931$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $ea68a19c2d46a931$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $ea68a19c2d46a931$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $ea68a19c2d46a931$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $ea68a19c2d46a931$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$ea68a19c2d46a931$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $ea68a19c2d46a931$var$pushSuspenseListContext(workInProgress, $ea68a19c2d46a931$var$suspenseStackCursor.current & 1 | 2);
                            $ea68a19c2d46a931$var$isHydrating && $ea68a19c2d46a931$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $ea68a19c2d46a931$var$now() > $ea68a19c2d46a931$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $ea68a19c2d46a931$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $ea68a19c2d46a931$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $ea68a19c2d46a931$var$scheduleRetryEffect(workInProgress, current), $ea68a19c2d46a931$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "collapsed" !== newProps.tailMode && "visible" !== newProps.tailMode && !nextResource.alternate && !$ea68a19c2d46a931$var$isHydrating) return $ea68a19c2d46a931$var$bubbleProperties(workInProgress), null;
                    } else 2 * $ea68a19c2d46a931$var$now() - newProps.renderingStartTime > $ea68a19c2d46a931$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $ea68a19c2d46a931$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) {
                current = newProps.tail;
                a: {
                    for(renderLanes = current; null !== renderLanes;){
                        if (null !== renderLanes.alternate) {
                            renderLanes = !1;
                            break a;
                        }
                        renderLanes = renderLanes.sibling;
                    }
                    renderLanes = !0;
                }
                newProps.rendering = current;
                newProps.tail = current.sibling;
                newProps.renderingStartTime = $ea68a19c2d46a931$var$now();
                current.sibling = null;
                nextResource = $ea68a19c2d46a931$var$suspenseStackCursor.current;
                nextResource = type ? nextResource & 1 | 2 : nextResource & 1;
                "visible" === newProps.tailMode || "collapsed" === newProps.tailMode || !renderLanes || $ea68a19c2d46a931$var$isHydrating ? $ea68a19c2d46a931$var$pushSuspenseListContext(workInProgress, nextResource) : (renderLanes = nextResource, $ea68a19c2d46a931$var$push($ea68a19c2d46a931$var$suspenseHandlerStackCursor, workInProgress), $ea68a19c2d46a931$var$push($ea68a19c2d46a931$var$suspenseStackCursor, renderLanes), null === $ea68a19c2d46a931$var$shellBoundary && ($ea68a19c2d46a931$var$shellBoundary = workInProgress));
                $ea68a19c2d46a931$var$isHydrating && $ea68a19c2d46a931$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                return current;
            }
            $ea68a19c2d46a931$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $ea68a19c2d46a931$var$popSuspenseHandler(workInProgress), $ea68a19c2d46a931$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($ea68a19c2d46a931$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $ea68a19c2d46a931$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $ea68a19c2d46a931$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $ea68a19c2d46a931$var$pop($ea68a19c2d46a931$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $ea68a19c2d46a931$var$popProvider($ea68a19c2d46a931$var$CacheContext), $ea68a19c2d46a931$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return workInProgress.flags |= 33554432, $ea68a19c2d46a931$var$bubbleProperties(workInProgress), null;
    }
    throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $ea68a19c2d46a931$var$unwindWork(current, workInProgress) {
    $ea68a19c2d46a931$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $ea68a19c2d46a931$var$popProvider($ea68a19c2d46a931$var$CacheContext), $ea68a19c2d46a931$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $ea68a19c2d46a931$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $ea68a19c2d46a931$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(340));
                $ea68a19c2d46a931$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $ea68a19c2d46a931$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(340));
                $ea68a19c2d46a931$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $ea68a19c2d46a931$var$popSuspenseListContext(workInProgress), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, current = workInProgress.memoizedState, null !== current && (current.rendering = null, current.tail = null), workInProgress.flags |= 4, workInProgress) : null;
        case 4:
            return $ea68a19c2d46a931$var$popHostContainer(), null;
        case 10:
            return $ea68a19c2d46a931$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $ea68a19c2d46a931$var$popSuspenseHandler(workInProgress), $ea68a19c2d46a931$var$popHiddenContext(), null !== current && $ea68a19c2d46a931$var$pop($ea68a19c2d46a931$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $ea68a19c2d46a931$var$popProvider($ea68a19c2d46a931$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $ea68a19c2d46a931$var$unwindInterruptedWork(current, interruptedWork) {
    $ea68a19c2d46a931$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $ea68a19c2d46a931$var$popProvider($ea68a19c2d46a931$var$CacheContext);
            $ea68a19c2d46a931$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $ea68a19c2d46a931$var$popHostContext(interruptedWork);
            break;
        case 4:
            $ea68a19c2d46a931$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $ea68a19c2d46a931$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $ea68a19c2d46a931$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $ea68a19c2d46a931$var$popSuspenseListContext(interruptedWork);
            break;
        case 10:
            $ea68a19c2d46a931$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $ea68a19c2d46a931$var$popSuspenseHandler(interruptedWork);
            $ea68a19c2d46a931$var$popHiddenContext();
            null !== current && $ea68a19c2d46a931$var$pop($ea68a19c2d46a931$var$resumedCache);
            break;
        case 24:
            $ea68a19c2d46a931$var$popProvider($ea68a19c2d46a931$var$CacheContext);
    }
}
function $ea68a19c2d46a931$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $ea68a19c2d46a931$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $ea68a19c2d46a931$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $ea68a19c2d46a931$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $ea68a19c2d46a931$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $ea68a19c2d46a931$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $ea68a19c2d46a931$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $ea68a19c2d46a931$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $ea68a19c2d46a931$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $ea68a19c2d46a931$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $ea68a19c2d46a931$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $ea68a19c2d46a931$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    var instance = current.stateNode, name = $ea68a19c2d46a931$var$getViewTransitionName(current.memoizedProps, instance);
                    if (null === instance.ref || instance.ref.name !== name) instance.ref = $ea68a19c2d46a931$var$createViewTransitionInstance(name);
                    instanceToUse = instance.ref;
                    break;
                case 7:
                    if (null === current.stateNode) {
                        var fragmentInstance = new $ea68a19c2d46a931$var$FragmentInstance(current);
                        $ea68a19c2d46a931$var$traverseVisibleInstancesAndTextInstances(current.child, !1, $ea68a19c2d46a931$var$addFragmentHandleToFiber, fragmentInstance, void 0, void 0);
                        current.stateNode = fragmentInstance;
                    }
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $ea68a19c2d46a931$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $ea68a19c2d46a931$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $ea68a19c2d46a931$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$148) {
            $ea68a19c2d46a931$var$captureCommitPhaseError(current, nearestMountedAncestor, error$148);
        }
        else ref.current = null;
    }
}
function $ea68a19c2d46a931$var$commitNewChildToFragmentInstances(fiber, parentFragmentInstances) {
    if ((5 === fiber.tag || 27 === fiber.tag || 6 === fiber.tag) && null === fiber.alternate && null !== parentFragmentInstances) for(var i = 0; i < parentFragmentInstances.length; i++)$ea68a19c2d46a931$var$commitNewChildToFragmentInstance(fiber.stateNode, parentFragmentInstances[i]);
}
function $ea68a19c2d46a931$var$commitFragmentInstanceInsertionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        $ea68a19c2d46a931$var$isFragmentInstanceParent(parent) && $ea68a19c2d46a931$var$commitNewChildToFragmentInstance(fiber.stateNode, parent.stateNode);
        if ($ea68a19c2d46a931$var$isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function $ea68a19c2d46a931$var$commitFragmentInstanceDeletionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        $ea68a19c2d46a931$var$isFragmentInstanceParent(parent) && $ea68a19c2d46a931$var$deleteChildFromFragmentInstance(fiber.stateNode, parent.stateNode);
        if ($ea68a19c2d46a931$var$isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function $ea68a19c2d46a931$var$isFragmentInstanceHostBoundary(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 27 === fiber.tag;
}
function $ea68a19c2d46a931$var$isFragmentInstanceParent(fiber) {
    return fiber && 7 === fiber.tag && null !== fiber.stateNode;
}
function $ea68a19c2d46a931$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $ea68a19c2d46a931$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $ea68a19c2d46a931$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $ea68a19c2d46a931$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$ea68a19c2d46a931$var$internalPropsKey] = newProps;
    } catch (error) {
        $ea68a19c2d46a931$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $ea68a19c2d46a931$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $ea68a19c2d46a931$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $ea68a19c2d46a931$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $ea68a19c2d46a931$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $ea68a19c2d46a931$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $ea68a19c2d46a931$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(tag, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(tag), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $ea68a19c2d46a931$var$noop$1)), $ea68a19c2d46a931$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), $ea68a19c2d46a931$var$viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && ($ea68a19c2d46a931$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, $ea68a19c2d46a931$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null)), node = node.child, null !== node)) for($ea68a19c2d46a931$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)$ea68a19c2d46a931$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function $ea68a19c2d46a931$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? parent.insertBefore(tag, before) : parent.appendChild(tag), $ea68a19c2d46a931$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), $ea68a19c2d46a931$var$viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && ($ea68a19c2d46a931$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, $ea68a19c2d46a931$var$isSingletonScope(node.type) && (parent = node.stateNode)), node = node.child, null !== node)) for($ea68a19c2d46a931$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)$ea68a19c2d46a931$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function $ea68a19c2d46a931$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $ea68a19c2d46a931$var$setInitialProperties(singleton, type, props);
        singleton[$ea68a19c2d46a931$var$internalInstanceKey] = finishedWork;
        singleton[$ea68a19c2d46a931$var$internalPropsKey] = props;
    } catch (error) {
        $ea68a19c2d46a931$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $ea68a19c2d46a931$var$shouldStartViewTransition = !1, $ea68a19c2d46a931$var$appearingViewTransitions = null;
function $ea68a19c2d46a931$var$trackEnterViewTransitions(placement) {
    if (30 === placement.tag || 0 !== (placement.subtreeFlags & 33554432)) $ea68a19c2d46a931$var$shouldStartViewTransition = !0;
}
var $ea68a19c2d46a931$var$viewTransitionCancelableChildren = null;
function $ea68a19c2d46a931$var$pushViewTransitionCancelableScope() {
    var prevChildren = $ea68a19c2d46a931$var$viewTransitionCancelableChildren;
    $ea68a19c2d46a931$var$viewTransitionCancelableChildren = null;
    return prevChildren;
}
var $ea68a19c2d46a931$var$viewTransitionHostInstanceIdx = 0;
function $ea68a19c2d46a931$var$applyViewTransitionToHostInstances(fiber, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    $ea68a19c2d46a931$var$viewTransitionHostInstanceIdx = 0;
    return $ea68a19c2d46a931$var$applyViewTransitionToHostInstancesRecursive(fiber.child, name, className, collectMeasurements, stopAtNestedViewTransitions);
}
function $ea68a19c2d46a931$var$applyViewTransitionToHostInstancesRecursive(child, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== collectMeasurements) {
                var measurement = $ea68a19c2d46a931$var$measureInstance(instance);
                collectMeasurements.push(measurement);
                measurement.view && (inViewport = !0);
            } else inViewport || $ea68a19c2d46a931$var$measureInstance(instance).view && (inViewport = !0);
            $ea68a19c2d46a931$var$shouldStartViewTransition = !0;
            $ea68a19c2d46a931$var$applyViewTransitionName(instance, 0 === $ea68a19c2d46a931$var$viewTransitionHostInstanceIdx ? name : name + "_" + $ea68a19c2d46a931$var$viewTransitionHostInstanceIdx, className);
            $ea68a19c2d46a931$var$viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || $ea68a19c2d46a931$var$applyViewTransitionToHostInstancesRecursive(child.child, name, className, collectMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function $ea68a19c2d46a931$var$restoreViewTransitionOnHostInstances(child, stopAtNestedViewTransitions) {
    for(; null !== child;){
        if (5 === child.tag) $ea68a19c2d46a931$var$restoreViewTransitionName(child.stateNode, child.memoizedProps);
        else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || $ea68a19c2d46a931$var$restoreViewTransitionOnHostInstances(child.child, stopAtNestedViewTransitions);
        child = child.sibling;
    }
}
function $ea68a19c2d46a931$var$commitAppearingPairViewTransitions(placement) {
    if (0 !== (placement.subtreeFlags & 18874368)) for(placement = placement.child; null !== placement;){
        if (22 !== placement.tag || null === placement.memoizedState) {
            if ($ea68a19c2d46a931$var$commitAppearingPairViewTransitions(placement), 30 === placement.tag && 0 !== (placement.flags & 18874368) && placement.stateNode.paired) {
                var props = placement.memoizedProps;
                if (null == props.name || "auto" === props.name) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(544));
                var name = props.name;
                props = $ea68a19c2d46a931$var$getViewTransitionClassName(props.default, props.share);
                "none" !== props && ($ea68a19c2d46a931$var$applyViewTransitionToHostInstances(placement, name, props, null, !1) || $ea68a19c2d46a931$var$restoreViewTransitionOnHostInstances(placement.child, !1));
            }
        }
        placement = placement.sibling;
    }
}
function $ea68a19c2d46a931$var$commitEnterViewTransitions(placement, gesture) {
    if (30 === placement.tag) {
        var state = placement.stateNode, props = placement.memoizedProps, name = $ea68a19c2d46a931$var$getViewTransitionName(props, state), className = $ea68a19c2d46a931$var$getViewTransitionClassName(props.default, state.paired ? props.share : props.enter);
        "none" !== className ? $ea68a19c2d46a931$var$applyViewTransitionToHostInstances(placement, name, className, null, !1) ? ($ea68a19c2d46a931$var$commitAppearingPairViewTransitions(placement), state.paired || gesture || $ea68a19c2d46a931$var$scheduleViewTransitionEvent(placement, props.onEnter)) : $ea68a19c2d46a931$var$restoreViewTransitionOnHostInstances(placement.child, !1) : $ea68a19c2d46a931$var$commitAppearingPairViewTransitions(placement);
    } else if (0 !== (placement.subtreeFlags & 33554432)) for(placement = placement.child; null !== placement;)$ea68a19c2d46a931$var$commitEnterViewTransitions(placement, gesture), placement = placement.sibling;
    else $ea68a19c2d46a931$var$commitAppearingPairViewTransitions(placement);
}
function $ea68a19c2d46a931$var$commitDeletedPairViewTransitions(deletion) {
    if (null !== $ea68a19c2d46a931$var$appearingViewTransitions && 0 !== $ea68a19c2d46a931$var$appearingViewTransitions.size) {
        var pairs = $ea68a19c2d46a931$var$appearingViewTransitions;
        if (0 !== (deletion.subtreeFlags & 18874368)) for(deletion = deletion.child; null !== deletion;){
            if (22 !== deletion.tag || null === deletion.memoizedState) {
                if (30 === deletion.tag && 0 !== (deletion.flags & 18874368)) {
                    var props = deletion.memoizedProps, name = props.name;
                    if (null != name && "auto" !== name) {
                        var pair = pairs.get(name);
                        if (void 0 !== pair) {
                            var className = $ea68a19c2d46a931$var$getViewTransitionClassName(props.default, props.share);
                            "none" !== className && ($ea68a19c2d46a931$var$applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, $ea68a19c2d46a931$var$scheduleViewTransitionEvent(deletion, props.onShare)) : $ea68a19c2d46a931$var$restoreViewTransitionOnHostInstances(deletion.child, !1));
                            pairs.delete(name);
                            if (0 === pairs.size) break;
                        }
                    }
                }
                $ea68a19c2d46a931$var$commitDeletedPairViewTransitions(deletion);
            }
            deletion = deletion.sibling;
        }
    }
}
function $ea68a19c2d46a931$var$commitExitViewTransitions(deletion) {
    if (30 === deletion.tag) {
        var props = deletion.memoizedProps, name = $ea68a19c2d46a931$var$getViewTransitionName(props, deletion.stateNode), pair = null !== $ea68a19c2d46a931$var$appearingViewTransitions ? $ea68a19c2d46a931$var$appearingViewTransitions.get(name) : void 0, className = $ea68a19c2d46a931$var$getViewTransitionClassName(props.default, void 0 !== pair ? props.share : props.exit);
        "none" !== className && ($ea68a19c2d46a931$var$applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? void 0 !== pair ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, $ea68a19c2d46a931$var$appearingViewTransitions.delete(name), $ea68a19c2d46a931$var$scheduleViewTransitionEvent(deletion, props.onShare)) : $ea68a19c2d46a931$var$scheduleViewTransitionEvent(deletion, props.onExit) : $ea68a19c2d46a931$var$restoreViewTransitionOnHostInstances(deletion.child, !1));
        null !== $ea68a19c2d46a931$var$appearingViewTransitions && $ea68a19c2d46a931$var$commitDeletedPairViewTransitions(deletion);
    } else if (0 !== (deletion.subtreeFlags & 33554432)) for(deletion = deletion.child; null !== deletion;)$ea68a19c2d46a931$var$commitExitViewTransitions(deletion), deletion = deletion.sibling;
    else null !== $ea68a19c2d46a931$var$appearingViewTransitions && $ea68a19c2d46a931$var$commitDeletedPairViewTransitions(deletion);
}
function $ea68a19c2d46a931$var$commitNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, name = $ea68a19c2d46a931$var$getViewTransitionName(props, changedParent.stateNode);
            props = $ea68a19c2d46a931$var$getViewTransitionClassName(props.default, props.update);
            changedParent.flags &= -5;
            "none" !== props && $ea68a19c2d46a931$var$applyViewTransitionToHostInstances(changedParent, name, props, changedParent.memoizedState = [], !1);
        } else 0 !== (changedParent.subtreeFlags & 33554432) && $ea68a19c2d46a931$var$commitNestedViewTransitions(changedParent);
        changedParent = changedParent.sibling;
    }
}
function $ea68a19c2d46a931$var$restorePairedViewTransitions(parent) {
    if (0 !== (parent.subtreeFlags & 18874368)) for(parent = parent.child; null !== parent;){
        if (22 !== parent.tag || null === parent.memoizedState) {
            if (30 === parent.tag && 0 !== (parent.flags & 18874368)) {
                var instance = parent.stateNode;
                null !== instance.paired && (instance.paired = null, $ea68a19c2d46a931$var$restoreViewTransitionOnHostInstances(parent.child, !1));
            }
            $ea68a19c2d46a931$var$restorePairedViewTransitions(parent);
        }
        parent = parent.sibling;
    }
}
function $ea68a19c2d46a931$var$restoreEnterOrExitViewTransitions(fiber) {
    if (30 === fiber.tag) fiber.stateNode.paired = null, $ea68a19c2d46a931$var$restoreViewTransitionOnHostInstances(fiber.child, !1), $ea68a19c2d46a931$var$restorePairedViewTransitions(fiber);
    else if (0 !== (fiber.subtreeFlags & 33554432)) for(fiber = fiber.child; null !== fiber;)$ea68a19c2d46a931$var$restoreEnterOrExitViewTransitions(fiber), fiber = fiber.sibling;
    else $ea68a19c2d46a931$var$restorePairedViewTransitions(fiber);
}
function $ea68a19c2d46a931$var$restoreNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;)30 === changedParent.tag ? $ea68a19c2d46a931$var$restoreViewTransitionOnHostInstances(changedParent.child, !1) : 0 !== (changedParent.subtreeFlags & 33554432) && $ea68a19c2d46a931$var$restoreNestedViewTransitions(changedParent), changedParent = changedParent.sibling;
}
function $ea68a19c2d46a931$var$measureViewTransitionHostInstancesRecursive(parentViewTransition, child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== previousMeasurements && $ea68a19c2d46a931$var$viewTransitionHostInstanceIdx < previousMeasurements.length) {
                var previousMeasurement = previousMeasurements[$ea68a19c2d46a931$var$viewTransitionHostInstanceIdx], nextMeasurement = $ea68a19c2d46a931$var$measureInstance(instance);
                if (previousMeasurement.view || nextMeasurement.view) inViewport = !0;
                var JSCompiler_temp;
                if (JSCompiler_temp = 0 === (parentViewTransition.flags & 4)) {
                    if (nextMeasurement.clip) JSCompiler_temp = !0;
                    else {
                        JSCompiler_temp = previousMeasurement.rect;
                        var newRect = nextMeasurement.rect;
                        JSCompiler_temp = JSCompiler_temp.y !== newRect.y || JSCompiler_temp.x !== newRect.x || JSCompiler_temp.height !== newRect.height || JSCompiler_temp.width !== newRect.width;
                    }
                }
                JSCompiler_temp && (parentViewTransition.flags |= 4);
                nextMeasurement.abs ? nextMeasurement = !previousMeasurement.abs : (previousMeasurement = previousMeasurement.rect, nextMeasurement = nextMeasurement.rect, nextMeasurement = previousMeasurement.height !== nextMeasurement.height || previousMeasurement.width !== nextMeasurement.width);
                nextMeasurement && (parentViewTransition.flags |= 32);
            } else parentViewTransition.flags |= 32;
            0 !== (parentViewTransition.flags & 4) && $ea68a19c2d46a931$var$applyViewTransitionName(instance, 0 === $ea68a19c2d46a931$var$viewTransitionHostInstanceIdx ? newName : newName + "_" + $ea68a19c2d46a931$var$viewTransitionHostInstanceIdx, className);
            inViewport && 0 !== (parentViewTransition.flags & 4) || (null === $ea68a19c2d46a931$var$viewTransitionCancelableChildren && ($ea68a19c2d46a931$var$viewTransitionCancelableChildren = []), $ea68a19c2d46a931$var$viewTransitionCancelableChildren.push(instance, 0 === $ea68a19c2d46a931$var$viewTransitionHostInstanceIdx ? oldName : oldName + "_" + $ea68a19c2d46a931$var$viewTransitionHostInstanceIdx, child.memoizedProps));
            $ea68a19c2d46a931$var$viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions ? parentViewTransition.flags |= child.flags & 32 : $ea68a19c2d46a931$var$measureViewTransitionHostInstancesRecursive(parentViewTransition, child.child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function $ea68a19c2d46a931$var$measureNestedViewTransitions(changedParent, gesture) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, state = changedParent.stateNode, name = $ea68a19c2d46a931$var$getViewTransitionName(props, state), className = $ea68a19c2d46a931$var$getViewTransitionClassName(props.default, props.update);
            if (gesture) {
                state = state.clones;
                var previousMeasurements = null === state ? null : state.map($ea68a19c2d46a931$var$measureClonedInstance);
            } else previousMeasurements = changedParent.memoizedState, changedParent.memoizedState = null;
            state = changedParent;
            var child = changedParent.child;
            $ea68a19c2d46a931$var$viewTransitionHostInstanceIdx = 0;
            name = $ea68a19c2d46a931$var$measureViewTransitionHostInstancesRecursive(state, child, name, name, className, previousMeasurements, !1);
            0 !== (changedParent.flags & 4) && name && (gesture || $ea68a19c2d46a931$var$scheduleViewTransitionEvent(changedParent, props.onUpdate));
        } else 0 !== (changedParent.subtreeFlags & 33554432) && $ea68a19c2d46a931$var$measureNestedViewTransitions(changedParent, gesture);
        changedParent = changedParent.sibling;
    }
}
var $ea68a19c2d46a931$var$offscreenSubtreeIsHidden = !1, $ea68a19c2d46a931$var$offscreenSubtreeWasHidden = !1, $ea68a19c2d46a931$var$offscreenDirectParentIsHidden = !1, $ea68a19c2d46a931$var$needsFormReset = !1, $ea68a19c2d46a931$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $ea68a19c2d46a931$var$nextEffect = null, $ea68a19c2d46a931$var$viewTransitionContextChanged = !1, $ea68a19c2d46a931$var$inUpdateViewTransition = !1, $ea68a19c2d46a931$var$rootViewTransitionAffected = !1, $ea68a19c2d46a931$var$rootViewTransitionNameCanceled = !1;
function $ea68a19c2d46a931$var$commitBeforeMutationEffects(root, firstChild, committedLanes) {
    root = root.containerInfo;
    $ea68a19c2d46a931$var$eventsEnabled = $ea68a19c2d46a931$var$_enabled;
    root = $ea68a19c2d46a931$var$getActiveElementDeep(root);
    if ($ea68a19c2d46a931$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$21) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $ea68a19c2d46a931$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $ea68a19c2d46a931$var$_enabled = !1;
    committedLanes = (committedLanes & 335544064) === committedLanes;
    $ea68a19c2d46a931$var$nextEffect = firstChild;
    for(firstChild = committedLanes ? 9270 : 1024; null !== $ea68a19c2d46a931$var$nextEffect;){
        root = $ea68a19c2d46a931$var$nextEffect;
        if (committedLanes && (JSCompiler_temp = root.deletions, null !== JSCompiler_temp)) for(anchorOffset = 0; anchorOffset < JSCompiler_temp.length; anchorOffset++)committedLanes && $ea68a19c2d46a931$var$commitExitViewTransitions(JSCompiler_temp[anchorOffset]);
        if (null === root.alternate && 0 !== (root.flags & 2)) committedLanes && $ea68a19c2d46a931$var$trackEnterViewTransitions(root), $ea68a19c2d46a931$var$commitBeforeMutationEffects_complete(committedLanes);
        else {
            if (22 === root.tag) {
                if (JSCompiler_temp = root.alternate, null !== root.memoizedState) {
                    null !== JSCompiler_temp && null === JSCompiler_temp.memoizedState && committedLanes && $ea68a19c2d46a931$var$commitExitViewTransitions(JSCompiler_temp);
                    $ea68a19c2d46a931$var$commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                } else if (null !== JSCompiler_temp && null !== JSCompiler_temp.memoizedState) {
                    committedLanes && $ea68a19c2d46a931$var$trackEnterViewTransitions(root);
                    $ea68a19c2d46a931$var$commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                }
            }
            JSCompiler_temp = root.child;
            0 !== (root.subtreeFlags & firstChild) && null !== JSCompiler_temp ? (JSCompiler_temp.return = root, $ea68a19c2d46a931$var$nextEffect = JSCompiler_temp) : (committedLanes && $ea68a19c2d46a931$var$commitNestedViewTransitions(root), $ea68a19c2d46a931$var$commitBeforeMutationEffects_complete(committedLanes));
        }
    }
    $ea68a19c2d46a931$var$appearingViewTransitions = null;
}
function $ea68a19c2d46a931$var$commitBeforeMutationEffects_complete(isViewTransitionEligible$jscomp$0) {
    for(; null !== $ea68a19c2d46a931$var$nextEffect;){
        var fiber = $ea68a19c2d46a931$var$nextEffect, isViewTransitionEligible = isViewTransitionEligible$jscomp$0, current = fiber.alternate, flags = fiber.flags;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (flags & 1024) && null !== current) {
                    isViewTransitionEligible = void 0;
                    flags = current.memoizedProps;
                    current = current.memoizedState;
                    var instance = fiber.stateNode;
                    try {
                        var resolvedPrevProps = $ea68a19c2d46a931$var$resolveClassComponentProps(fiber.type, flags);
                        isViewTransitionEligible = instance.getSnapshotBeforeUpdate(resolvedPrevProps, current);
                        instance.__reactInternalSnapshotBeforeUpdate = isViewTransitionEligible;
                    } catch (error) {
                        $ea68a19c2d46a931$var$captureCommitPhaseError(fiber, fiber.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (flags & 1024)) {
                    if (current = fiber.stateNode.containerInfo, isViewTransitionEligible = current.nodeType, 9 === isViewTransitionEligible) $ea68a19c2d46a931$var$clearContainerSparingly(current);
                    else if (1 === isViewTransitionEligible) switch(current.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $ea68a19c2d46a931$var$clearContainerSparingly(current);
                            break;
                        default:
                            current.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            case 30:
                isViewTransitionEligible && null !== current && (isViewTransitionEligible = $ea68a19c2d46a931$var$getViewTransitionName(current.memoizedProps, current.stateNode), flags = fiber.memoizedProps, flags = $ea68a19c2d46a931$var$getViewTransitionClassName(flags.default, flags.update), "none" !== flags && $ea68a19c2d46a931$var$applyViewTransitionToHostInstances(current, isViewTransitionEligible, flags, current.memoizedState = [], !0));
                break;
            default:
                if (0 !== (flags & 1024)) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(163));
        }
        current = fiber.sibling;
        if (null !== current) {
            current.return = fiber.return;
            $ea68a19c2d46a931$var$nextEffect = current;
            break;
        }
        $ea68a19c2d46a931$var$nextEffect = fiber.return;
    }
}
function $ea68a19c2d46a931$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $ea68a19c2d46a931$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $ea68a19c2d46a931$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $ea68a19c2d46a931$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $ea68a19c2d46a931$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $ea68a19c2d46a931$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$146) {
                        $ea68a19c2d46a931$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$146);
                    }
                }
            }
            flags & 64 && $ea68a19c2d46a931$var$commitClassCallbacks(finishedWork);
            flags & 512 && $ea68a19c2d46a931$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $ea68a19c2d46a931$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $ea68a19c2d46a931$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $ea68a19c2d46a931$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $ea68a19c2d46a931$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $ea68a19c2d46a931$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $ea68a19c2d46a931$var$commitHostMount(finishedWork);
            flags & 512 && $ea68a19c2d46a931$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $ea68a19c2d46a931$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $ea68a19c2d46a931$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $ea68a19c2d46a931$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $ea68a19c2d46a931$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $ea68a19c2d46a931$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $ea68a19c2d46a931$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $ea68a19c2d46a931$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $ea68a19c2d46a931$var$offscreenSubtreeIsHidden;
            if (!flags) {
                var newOffscreenSubtreeWasHidden = null !== current && null !== current.memoizedState || $ea68a19c2d46a931$var$offscreenSubtreeWasHidden;
                current = $ea68a19c2d46a931$var$offscreenSubtreeIsHidden;
                prevProps = $ea68a19c2d46a931$var$offscreenSubtreeWasHidden;
                $ea68a19c2d46a931$var$offscreenSubtreeIsHidden = flags;
                ($ea68a19c2d46a931$var$offscreenSubtreeWasHidden = newOffscreenSubtreeWasHidden) && !prevProps ? (flags = 2, 0 !== (finishedWork.subtreeFlags & 8772) && (flags |= 1), $ea68a19c2d46a931$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, flags)) : $ea68a19c2d46a931$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $ea68a19c2d46a931$var$offscreenSubtreeIsHidden = current;
                $ea68a19c2d46a931$var$offscreenSubtreeWasHidden = prevProps;
            }
            break;
        case 30:
            $ea68a19c2d46a931$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 512 && $ea68a19c2d46a931$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 7:
            flags & 512 && $ea68a19c2d46a931$var$safelyAttachRef(finishedWork, finishedWork.return);
        default:
            $ea68a19c2d46a931$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $ea68a19c2d46a931$var$hideOrUnhideAllChildren(parentFiber, isHidden) {
    for(parentFiber = parentFiber.child; null !== parentFiber;)$ea68a19c2d46a931$var$hideOrUnhideAllChildrenOnFiber(parentFiber, isHidden), parentFiber = parentFiber.sibling;
}
function $ea68a19c2d46a931$var$hideOrUnhideAllChildrenOnFiber(fiber, isHidden) {
    switch(fiber.tag){
        case 5:
        case 26:
            try {
                var instance = fiber.stateNode;
                if (isHidden) {
                    var style = instance.style;
                    "function" === typeof style.setProperty ? style.setProperty("display", "none", "important") : style.display = "none";
                } else {
                    var instance$jscomp$0 = fiber.stateNode, styleProp = fiber.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                    instance$jscomp$0.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                }
            } catch (error) {
                $ea68a19c2d46a931$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            $ea68a19c2d46a931$var$hideOrUnhideNearestPortals(fiber, isHidden);
            break;
        case 6:
            try {
                fiber.stateNode.nodeValue = isHidden ? "" : fiber.memoizedProps, $ea68a19c2d46a931$var$viewTransitionMutationContext = !0;
            } catch (error) {
                $ea68a19c2d46a931$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 18:
            try {
                var instance$jscomp$1 = fiber.stateNode;
                isHidden ? $ea68a19c2d46a931$var$hideOrUnhideDehydratedBoundary(instance$jscomp$1, !0) : $ea68a19c2d46a931$var$hideOrUnhideDehydratedBoundary(fiber.stateNode, !1);
            } catch (error) {
                $ea68a19c2d46a931$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 22:
        case 23:
            null === fiber.memoizedState && $ea68a19c2d46a931$var$hideOrUnhideAllChildren(fiber, isHidden);
            break;
        default:
            $ea68a19c2d46a931$var$hideOrUnhideAllChildren(fiber, isHidden);
    }
}
function $ea68a19c2d46a931$var$hideOrUnhideNearestPortals(parentFiber, isHidden$jscomp$0) {
    if (parentFiber.subtreeFlags & 67108864) for(parentFiber = parentFiber.child; null !== parentFiber;){
        a: {
            var fiber = parentFiber, isHidden = isHidden$jscomp$0;
            switch(fiber.tag){
                case 4:
                    $ea68a19c2d46a931$var$hideOrUnhideAllChildrenOnFiber(fiber, isHidden);
                    break a;
                case 22:
                    null === fiber.memoizedState && $ea68a19c2d46a931$var$hideOrUnhideNearestPortals(fiber, isHidden);
                    break a;
                default:
                    $ea68a19c2d46a931$var$hideOrUnhideNearestPortals(fiber, isHidden);
            }
        }
        parentFiber = parentFiber.sibling;
    }
}
function $ea68a19c2d46a931$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $ea68a19c2d46a931$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $ea68a19c2d46a931$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $ea68a19c2d46a931$var$hostParent = null, $ea68a19c2d46a931$var$hostParentIsContainer = !1;
function $ea68a19c2d46a931$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$ea68a19c2d46a931$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $ea68a19c2d46a931$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($ea68a19c2d46a931$var$injectedHook && "function" === typeof $ea68a19c2d46a931$var$injectedHook.onCommitFiberUnmount) try {
        $ea68a19c2d46a931$var$injectedHook.onCommitFiberUnmount($ea68a19c2d46a931$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $ea68a19c2d46a931$var$offscreenSubtreeWasHidden || $ea68a19c2d46a931$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $ea68a19c2d46a931$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && !$ea68a19c2d46a931$var$offscreenSubtreeWasHidden && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $ea68a19c2d46a931$var$offscreenSubtreeWasHidden || $ea68a19c2d46a931$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $ea68a19c2d46a931$var$commitFragmentInstanceDeletionEffects(deletedFiber);
            var prevHostParent = $ea68a19c2d46a931$var$hostParent, prevHostParentIsContainer = $ea68a19c2d46a931$var$hostParentIsContainer;
            $ea68a19c2d46a931$var$isSingletonScope(deletedFiber.type) && ($ea68a19c2d46a931$var$hostParent = deletedFiber.stateNode, $ea68a19c2d46a931$var$hostParentIsContainer = !1);
            $ea68a19c2d46a931$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $ea68a19c2d46a931$var$releaseSingletonInstance(deletedFiber.stateNode, deletedFiber.type, deletedFiber.memoizedProps);
            $ea68a19c2d46a931$var$hostParent = prevHostParent;
            $ea68a19c2d46a931$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $ea68a19c2d46a931$var$offscreenSubtreeWasHidden || $ea68a19c2d46a931$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), $ea68a19c2d46a931$var$commitFragmentInstanceDeletionEffects(deletedFiber);
        case 6:
            6 === deletedFiber.tag && $ea68a19c2d46a931$var$commitFragmentInstanceDeletionEffects(deletedFiber);
            prevHostParent = $ea68a19c2d46a931$var$hostParent;
            prevHostParentIsContainer = $ea68a19c2d46a931$var$hostParentIsContainer;
            $ea68a19c2d46a931$var$hostParent = null;
            $ea68a19c2d46a931$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $ea68a19c2d46a931$var$hostParent = prevHostParent;
            $ea68a19c2d46a931$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $ea68a19c2d46a931$var$hostParent) {
                if ($ea68a19c2d46a931$var$hostParentIsContainer) try {
                    (9 === $ea68a19c2d46a931$var$hostParent.nodeType ? $ea68a19c2d46a931$var$hostParent.body : "HTML" === $ea68a19c2d46a931$var$hostParent.nodeName ? $ea68a19c2d46a931$var$hostParent.ownerDocument.body : $ea68a19c2d46a931$var$hostParent).removeChild(deletedFiber.stateNode), $ea68a19c2d46a931$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $ea68a19c2d46a931$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $ea68a19c2d46a931$var$hostParent.removeChild(deletedFiber.stateNode), $ea68a19c2d46a931$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $ea68a19c2d46a931$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $ea68a19c2d46a931$var$hostParent && ($ea68a19c2d46a931$var$hostParentIsContainer ? (finishedRoot = $ea68a19c2d46a931$var$hostParent, $ea68a19c2d46a931$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $ea68a19c2d46a931$var$retryIfBlockedOn(finishedRoot)) : $ea68a19c2d46a931$var$clearHydrationBoundary($ea68a19c2d46a931$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $ea68a19c2d46a931$var$hostParent;
            prevHostParentIsContainer = $ea68a19c2d46a931$var$hostParentIsContainer;
            $ea68a19c2d46a931$var$hostParent = deletedFiber.stateNode.containerInfo;
            $ea68a19c2d46a931$var$hostParentIsContainer = !0;
            $ea68a19c2d46a931$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $ea68a19c2d46a931$var$hostParent = prevHostParent;
            $ea68a19c2d46a931$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $ea68a19c2d46a931$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $ea68a19c2d46a931$var$offscreenSubtreeWasHidden || $ea68a19c2d46a931$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $ea68a19c2d46a931$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $ea68a19c2d46a931$var$offscreenSubtreeWasHidden || ($ea68a19c2d46a931$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $ea68a19c2d46a931$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $ea68a19c2d46a931$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $ea68a19c2d46a931$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $ea68a19c2d46a931$var$offscreenSubtreeWasHidden = (prevHostParent = $ea68a19c2d46a931$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $ea68a19c2d46a931$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $ea68a19c2d46a931$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        case 30:
            $ea68a19c2d46a931$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $ea68a19c2d46a931$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 7:
            $ea68a19c2d46a931$var$offscreenSubtreeWasHidden || $ea68a19c2d46a931$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $ea68a19c2d46a931$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        default:
            $ea68a19c2d46a931$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $ea68a19c2d46a931$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $ea68a19c2d46a931$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $ea68a19c2d46a931$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $ea68a19c2d46a931$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $ea68a19c2d46a931$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $ea68a19c2d46a931$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $ea68a19c2d46a931$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $ea68a19c2d46a931$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $ea68a19c2d46a931$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $ea68a19c2d46a931$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $ea68a19c2d46a931$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $ea68a19c2d46a931$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $ea68a19c2d46a931$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber, lanes) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($ea68a19c2d46a931$var$isSingletonScope(parent.type)) {
                        $ea68a19c2d46a931$var$hostParent = parent.stateNode;
                        $ea68a19c2d46a931$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $ea68a19c2d46a931$var$hostParent = parent.stateNode;
                    $ea68a19c2d46a931$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $ea68a19c2d46a931$var$hostParent = parent.stateNode.containerInfo;
                    $ea68a19c2d46a931$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $ea68a19c2d46a931$var$hostParent) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(160));
        $ea68a19c2d46a931$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $ea68a19c2d46a931$var$hostParent = null;
        $ea68a19c2d46a931$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$ea68a19c2d46a931$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0, lanes), parentFiber = parentFiber.sibling;
}
var $ea68a19c2d46a931$var$currentHoistableRoot = null;
function $ea68a19c2d46a931$var$commitMutationEffectsOnFiber(finishedWork, root, lanes) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            if (flags & 4 && (current = finishedWork.updateQueue, current = null !== current ? current.events : null, null !== current)) for(var ii = 0; ii < current.length; ii++){
                var _eventPayloads$ii2 = current[ii];
                _eventPayloads$ii2.ref.impl = _eventPayloads$ii2.nextImpl;
            }
            $ea68a19c2d46a931$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $ea68a19c2d46a931$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($ea68a19c2d46a931$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $ea68a19c2d46a931$var$commitHookEffectListMount(3, finishedWork), $ea68a19c2d46a931$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $ea68a19c2d46a931$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $ea68a19c2d46a931$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($ea68a19c2d46a931$var$offscreenSubtreeWasHidden || null === current || $ea68a19c2d46a931$var$safelyDetachRef(current, current.return));
            flags & 64 && $ea68a19c2d46a931$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (root = finishedWork.callbacks, null !== root && (lanes = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === lanes ? root : lanes.concat(root))));
            break;
        case 26:
            ii = $ea68a19c2d46a931$var$currentHoistableRoot;
            $ea68a19c2d46a931$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $ea68a19c2d46a931$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($ea68a19c2d46a931$var$offscreenSubtreeWasHidden || null === current || $ea68a19c2d46a931$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                if (flags = null !== current ? current.memoizedState : null, lanes = finishedWork.memoizedState, null === current) {
                    if (null === lanes) {
                        if (null === finishedWork.stateNode) {
                            if ($ea68a19c2d46a931$var$offscreenSubtreeIsHidden) finishedWork.stateNode = $ea68a19c2d46a931$var$createHoistableInstance(finishedWork.type, finishedWork.memoizedProps, root.containerInfo, finishedWork);
                            else {
                                a: {
                                    root = finishedWork.type;
                                    lanes = finishedWork.memoizedProps;
                                    flags = ii.ownerDocument || ii;
                                    b: switch(root){
                                        case "title":
                                            current = flags.getElementsByTagName("title")[0];
                                            if (!current || current[$ea68a19c2d46a931$var$internalHoistableMarker] || current[$ea68a19c2d46a931$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === current.namespaceURI || current.hasAttribute("itemprop")) current = flags.createElement(root), flags.head.insertBefore(current, flags.querySelector("head > title"));
                                            $ea68a19c2d46a931$var$setInitialProperties(current, root, lanes);
                                            current[$ea68a19c2d46a931$var$internalInstanceKey] = finishedWork;
                                            $ea68a19c2d46a931$var$markNodeAsHoistable(current);
                                            root = current;
                                            break a;
                                        case "link":
                                            if (ii = $ea68a19c2d46a931$var$getHydratableHoistableCache("link", "href", flags).get(root + (lanes.href || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("href") === (null == lanes.href || "" === lanes.href ? null : lanes.href) && current.getAttribute("rel") === (null == lanes.rel ? null : lanes.rel) && current.getAttribute("title") === (null == lanes.title ? null : lanes.title) && current.getAttribute("crossorigin") === (null == lanes.crossOrigin ? null : lanes.crossOrigin)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            $ea68a19c2d46a931$var$setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        case "meta":
                                            if (ii = $ea68a19c2d46a931$var$getHydratableHoistableCache("meta", "content", flags).get(root + (lanes.content || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("content") === (null == lanes.content ? null : "" + lanes.content) && current.getAttribute("name") === (null == lanes.name ? null : lanes.name) && current.getAttribute("property") === (null == lanes.property ? null : lanes.property) && current.getAttribute("http-equiv") === (null == lanes.httpEquiv ? null : lanes.httpEquiv) && current.getAttribute("charset") === (null == lanes.charSet ? null : lanes.charSet)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            $ea68a19c2d46a931$var$setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        default:
                                            throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(468, root));
                                    }
                                    current[$ea68a19c2d46a931$var$internalInstanceKey] = finishedWork;
                                    $ea68a19c2d46a931$var$markNodeAsHoistable(current);
                                    root = current;
                                }
                                finishedWork.stateNode = root;
                            }
                        } else $ea68a19c2d46a931$var$offscreenSubtreeIsHidden || $ea68a19c2d46a931$var$mountHoistable(ii, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $ea68a19c2d46a931$var$acquireResource(ii, lanes, finishedWork.memoizedProps);
                } else flags !== lanes ? (null === flags ? (root = current.stateNode, null === root || $ea68a19c2d46a931$var$offscreenSubtreeWasHidden || root.parentNode.removeChild(root)) : flags.count--, null === lanes ? $ea68a19c2d46a931$var$offscreenSubtreeIsHidden || $ea68a19c2d46a931$var$mountHoistable(ii, finishedWork.type, finishedWork.stateNode) : $ea68a19c2d46a931$var$acquireResource(ii, lanes, finishedWork.memoizedProps)) : null === lanes && null !== finishedWork.stateNode && $ea68a19c2d46a931$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $ea68a19c2d46a931$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $ea68a19c2d46a931$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($ea68a19c2d46a931$var$offscreenSubtreeWasHidden || null === current || $ea68a19c2d46a931$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $ea68a19c2d46a931$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            ii = $ea68a19c2d46a931$var$offscreenDirectParentIsHidden;
            $ea68a19c2d46a931$var$offscreenDirectParentIsHidden = !1;
            $ea68a19c2d46a931$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $ea68a19c2d46a931$var$offscreenDirectParentIsHidden = ii;
            $ea68a19c2d46a931$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($ea68a19c2d46a931$var$offscreenSubtreeWasHidden || null === current || $ea68a19c2d46a931$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                root = finishedWork.stateNode;
                try {
                    $ea68a19c2d46a931$var$setTextContent(root, ""), $ea68a19c2d46a931$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $ea68a19c2d46a931$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (root = finishedWork.memoizedProps, $ea68a19c2d46a931$var$commitHostUpdate(finishedWork, root, null !== current ? current.memoizedProps : root));
            flags & 1024 && ($ea68a19c2d46a931$var$needsFormReset = !0);
            break;
        case 6:
            $ea68a19c2d46a931$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $ea68a19c2d46a931$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(162));
                root = finishedWork.memoizedProps;
                lanes = finishedWork.stateNode;
                try {
                    lanes.nodeValue = root, $ea68a19c2d46a931$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $ea68a19c2d46a931$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $ea68a19c2d46a931$var$viewTransitionMutationContext = !1;
            $ea68a19c2d46a931$var$tagCaches = null;
            ii = $ea68a19c2d46a931$var$currentHoistableRoot;
            $ea68a19c2d46a931$var$currentHoistableRoot = $ea68a19c2d46a931$var$getHoistableRoot(root.containerInfo);
            $ea68a19c2d46a931$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $ea68a19c2d46a931$var$currentHoistableRoot = ii;
            $ea68a19c2d46a931$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $ea68a19c2d46a931$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $ea68a19c2d46a931$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $ea68a19c2d46a931$var$needsFormReset && ($ea68a19c2d46a931$var$needsFormReset = !1, $ea68a19c2d46a931$var$recursivelyResetForms(finishedWork));
            $ea68a19c2d46a931$var$viewTransitionMutationContext = !1;
            break;
        case 4:
            flags = $ea68a19c2d46a931$var$offscreenDirectParentIsHidden;
            $ea68a19c2d46a931$var$offscreenDirectParentIsHidden = $ea68a19c2d46a931$var$offscreenSubtreeIsHidden;
            current = $ea68a19c2d46a931$var$pushMutationContext();
            ii = $ea68a19c2d46a931$var$currentHoistableRoot;
            $ea68a19c2d46a931$var$currentHoistableRoot = $ea68a19c2d46a931$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $ea68a19c2d46a931$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $ea68a19c2d46a931$var$commitReconciliationEffects(finishedWork);
            $ea68a19c2d46a931$var$currentHoistableRoot = ii;
            $ea68a19c2d46a931$var$viewTransitionMutationContext && $ea68a19c2d46a931$var$inUpdateViewTransition && ($ea68a19c2d46a931$var$rootViewTransitionAffected = !0);
            $ea68a19c2d46a931$var$viewTransitionMutationContext = current;
            $ea68a19c2d46a931$var$offscreenDirectParentIsHidden = flags;
            break;
        case 12:
            $ea68a19c2d46a931$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $ea68a19c2d46a931$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $ea68a19c2d46a931$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $ea68a19c2d46a931$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $ea68a19c2d46a931$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 13:
            $ea68a19c2d46a931$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $ea68a19c2d46a931$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($ea68a19c2d46a931$var$globalMostRecentFallbackTime = $ea68a19c2d46a931$var$now());
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $ea68a19c2d46a931$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 22:
            ii = null !== finishedWork.memoizedState;
            _eventPayloads$ii2 = null !== current && null !== current.memoizedState;
            var prevOffscreenSubtreeIsHidden = $ea68a19c2d46a931$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $ea68a19c2d46a931$var$offscreenSubtreeWasHidden, prevOffscreenDirectParentIsHidden$166 = $ea68a19c2d46a931$var$offscreenDirectParentIsHidden;
            $ea68a19c2d46a931$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || ii;
            $ea68a19c2d46a931$var$offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166 || ii;
            $ea68a19c2d46a931$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || _eventPayloads$ii2;
            $ea68a19c2d46a931$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $ea68a19c2d46a931$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $ea68a19c2d46a931$var$offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166;
            $ea68a19c2d46a931$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $ea68a19c2d46a931$var$commitReconciliationEffects(finishedWork);
            flags & 8192 && (root = finishedWork.stateNode, root._visibility = ii ? root._visibility & -2 : root._visibility | 1, !ii || null === current || _eventPayloads$ii2 || $ea68a19c2d46a931$var$offscreenSubtreeIsHidden || $ea68a19c2d46a931$var$offscreenSubtreeWasHidden || (root = _eventPayloads$ii2 || $ea68a19c2d46a931$var$offscreenSubtreeWasHidden, lanes = $ea68a19c2d46a931$var$offscreenSubtreeIsHidden, current = $ea68a19c2d46a931$var$offscreenSubtreeWasHidden, $ea68a19c2d46a931$var$offscreenSubtreeIsHidden = ii || $ea68a19c2d46a931$var$offscreenSubtreeIsHidden, $ea68a19c2d46a931$var$offscreenSubtreeWasHidden = root, $ea68a19c2d46a931$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, 2), $ea68a19c2d46a931$var$offscreenSubtreeIsHidden = lanes, $ea68a19c2d46a931$var$offscreenSubtreeWasHidden = current), !ii && $ea68a19c2d46a931$var$offscreenDirectParentIsHidden || $ea68a19c2d46a931$var$hideOrUnhideAllChildren(finishedWork, ii));
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (lanes = root.retryQueue, null !== lanes && (root.retryQueue = null, $ea68a19c2d46a931$var$attachSuspenseRetryListeners(finishedWork, lanes))));
            break;
        case 19:
            $ea68a19c2d46a931$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $ea68a19c2d46a931$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $ea68a19c2d46a931$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 30:
            flags & 512 && ($ea68a19c2d46a931$var$offscreenSubtreeWasHidden || null === current || $ea68a19c2d46a931$var$safelyDetachRef(current, current.return));
            flags = $ea68a19c2d46a931$var$pushMutationContext();
            ii = $ea68a19c2d46a931$var$inUpdateViewTransition;
            _eventPayloads$ii2 = (lanes & 335544064) === lanes;
            prevOffscreenSubtreeIsHidden = finishedWork.memoizedProps;
            $ea68a19c2d46a931$var$inUpdateViewTransition = _eventPayloads$ii2 && "none" !== $ea68a19c2d46a931$var$getViewTransitionClassName(prevOffscreenSubtreeIsHidden.default, prevOffscreenSubtreeIsHidden.update);
            $ea68a19c2d46a931$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $ea68a19c2d46a931$var$commitReconciliationEffects(finishedWork);
            _eventPayloads$ii2 && null !== current && $ea68a19c2d46a931$var$viewTransitionMutationContext && (finishedWork.flags |= 4);
            $ea68a19c2d46a931$var$inUpdateViewTransition = ii;
            $ea68a19c2d46a931$var$viewTransitionMutationContext = flags;
            break;
        case 21:
            break;
        case 7:
            flags & 512 && ($ea68a19c2d46a931$var$offscreenSubtreeWasHidden || null === current || $ea68a19c2d46a931$var$safelyDetachRef(current, current.return)), current && null !== current.stateNode && (current.stateNode._fragmentFiber = finishedWork);
        default:
            $ea68a19c2d46a931$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes), $ea68a19c2d46a931$var$commitReconciliationEffects(finishedWork);
    }
}
function $ea68a19c2d46a931$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($ea68a19c2d46a931$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            parentFiber = null;
            for(var parent = finishedWork.return; null !== parent;){
                if ($ea68a19c2d46a931$var$isFragmentInstanceParent(parent)) {
                    var fragmentInstance = parent.stateNode;
                    null === parentFiber ? parentFiber = [
                        fragmentInstance
                    ] : parentFiber.push(fragmentInstance);
                }
                if ($ea68a19c2d46a931$var$isFragmentInstanceHostBoundary(parent)) break;
                parent = parent.return;
            }
            var JSCompiler_inline_result = parentFiber;
            if (null == hostParentFiber) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent$jscomp$0 = hostParentFiber.stateNode, before = $ea68a19c2d46a931$var$getHostSibling(finishedWork);
                    $ea68a19c2d46a931$var$insertOrAppendPlacementNode(finishedWork, before, parent$jscomp$0, JSCompiler_inline_result);
                    break;
                case 5:
                    var parent$149 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($ea68a19c2d46a931$var$setTextContent(parent$149, ""), hostParentFiber.flags &= -33);
                    var before$150 = $ea68a19c2d46a931$var$getHostSibling(finishedWork);
                    $ea68a19c2d46a931$var$insertOrAppendPlacementNode(finishedWork, before$150, parent$149, JSCompiler_inline_result);
                    break;
                case 3:
                case 4:
                    var parent$151 = hostParentFiber.stateNode.containerInfo, before$152 = $ea68a19c2d46a931$var$getHostSibling(finishedWork);
                    $ea68a19c2d46a931$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$152, parent$151, JSCompiler_inline_result);
                    break;
                default:
                    throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $ea68a19c2d46a931$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $ea68a19c2d46a931$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $ea68a19c2d46a931$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && (fiber = fiber.stateNode, $ea68a19c2d46a931$var$_enabled = !0, fiber.reset(), $ea68a19c2d46a931$var$_enabled = !1);
        parentFiber = parentFiber.sibling;
    }
}
function $ea68a19c2d46a931$var$recursivelyTraverseAfterMutationEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 9270) for(parentFiber = parentFiber.child; null !== parentFiber;)$ea68a19c2d46a931$var$commitAfterMutationEffectsOnFiber(parentFiber, root), parentFiber = parentFiber.sibling;
    else $ea68a19c2d46a931$var$measureNestedViewTransitions(parentFiber, !1);
}
function $ea68a19c2d46a931$var$commitAfterMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate;
    if (null === current) $ea68a19c2d46a931$var$commitEnterViewTransitions(finishedWork, !1);
    else switch(finishedWork.tag){
        case 3:
            $ea68a19c2d46a931$var$rootViewTransitionNameCanceled = $ea68a19c2d46a931$var$viewTransitionContextChanged = !1;
            $ea68a19c2d46a931$var$pushViewTransitionCancelableScope();
            $ea68a19c2d46a931$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            if (!$ea68a19c2d46a931$var$viewTransitionContextChanged && !$ea68a19c2d46a931$var$rootViewTransitionAffected) {
                finishedWork = $ea68a19c2d46a931$var$viewTransitionCancelableChildren;
                if (null !== finishedWork) for(var i = 0; i < finishedWork.length; i += 3){
                    current = finishedWork[i];
                    var oldName = finishedWork[i + 1];
                    $ea68a19c2d46a931$var$restoreViewTransitionName(current, finishedWork[i + 2]);
                    current = current.ownerDocument.documentElement;
                    null !== current && current.animate({
                        opacity: [
                            0,
                            0
                        ],
                        pointerEvents: [
                            "none",
                            "none"
                        ]
                    }, {
                        duration: 0,
                        fill: "forwards",
                        pseudoElement: "::view-transition-group(" + oldName + ")"
                    });
                }
                finishedWork = root.containerInfo;
                finishedWork = 9 === finishedWork.nodeType ? finishedWork.documentElement : finishedWork.ownerDocument.documentElement;
                null !== finishedWork && "" === finishedWork.style.viewTransitionName && (finishedWork.style.viewTransitionName = "none", finishedWork.animate({
                    opacity: [
                        0,
                        0
                    ],
                    pointerEvents: [
                        "none",
                        "none"
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition-group(root)"
                }), finishedWork.animate({
                    width: [
                        0,
                        0
                    ],
                    height: [
                        0,
                        0
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition"
                }));
                $ea68a19c2d46a931$var$rootViewTransitionNameCanceled = !0;
            }
            $ea68a19c2d46a931$var$viewTransitionCancelableChildren = null;
            break;
        case 5:
            $ea68a19c2d46a931$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            break;
        case 4:
            i = $ea68a19c2d46a931$var$viewTransitionContextChanged;
            $ea68a19c2d46a931$var$viewTransitionContextChanged = !1;
            $ea68a19c2d46a931$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            $ea68a19c2d46a931$var$viewTransitionContextChanged && ($ea68a19c2d46a931$var$rootViewTransitionAffected = !0);
            $ea68a19c2d46a931$var$viewTransitionContextChanged = i;
            break;
        case 22:
            null === finishedWork.memoizedState && (null !== current.memoizedState ? $ea68a19c2d46a931$var$commitEnterViewTransitions(finishedWork, !1) : $ea68a19c2d46a931$var$recursivelyTraverseAfterMutationEffects(root, finishedWork));
            break;
        case 30:
            i = $ea68a19c2d46a931$var$viewTransitionContextChanged;
            oldName = $ea68a19c2d46a931$var$pushViewTransitionCancelableScope();
            $ea68a19c2d46a931$var$viewTransitionContextChanged = !1;
            $ea68a19c2d46a931$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            $ea68a19c2d46a931$var$viewTransitionContextChanged && (finishedWork.flags |= 4);
            var props = finishedWork.memoizedProps, state = finishedWork.stateNode;
            root = $ea68a19c2d46a931$var$getViewTransitionName(props, state);
            state = $ea68a19c2d46a931$var$getViewTransitionName(current.memoizedProps, state);
            var className = $ea68a19c2d46a931$var$getViewTransitionClassName(props.default, props.update);
            "none" === className ? root = !1 : (props = current.memoizedState, current.memoizedState = null, current = finishedWork.child, $ea68a19c2d46a931$var$viewTransitionHostInstanceIdx = 0, root = $ea68a19c2d46a931$var$measureViewTransitionHostInstancesRecursive(finishedWork, current, root, state, className, props, !0), $ea68a19c2d46a931$var$viewTransitionHostInstanceIdx !== (null === props ? 0 : props.length) && (finishedWork.flags |= 32));
            0 !== (finishedWork.flags & 4) && root ? ($ea68a19c2d46a931$var$scheduleViewTransitionEvent(finishedWork, finishedWork.memoizedProps.onUpdate), $ea68a19c2d46a931$var$viewTransitionCancelableChildren = oldName) : null !== oldName && (oldName.push.apply(oldName, $ea68a19c2d46a931$var$viewTransitionCancelableChildren), $ea68a19c2d46a931$var$viewTransitionCancelableChildren = oldName);
            $ea68a19c2d46a931$var$viewTransitionContextChanged = 0 !== (finishedWork.flags & 32) ? !0 : i;
            break;
        default:
            $ea68a19c2d46a931$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
    }
}
function $ea68a19c2d46a931$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$ea68a19c2d46a931$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $ea68a19c2d46a931$var$recursivelyTraverseDisappearLayoutEffects(parentFiber, layoutEffectTraversalFlags$jscomp$0) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber, layoutEffectTraversalFlags = layoutEffectTraversalFlags$jscomp$0;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $ea68a19c2d46a931$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $ea68a19c2d46a931$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 1:
                $ea68a19c2d46a931$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $ea68a19c2d46a931$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $ea68a19c2d46a931$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && $ea68a19c2d46a931$var$releaseSingletonInstance(finishedWork.stateNode, finishedWork.type, finishedWork.memoizedProps);
            case 5:
                $ea68a19c2d46a931$var$safelyDetachRef(finishedWork, finishedWork.return);
                5 !== finishedWork.tag && 27 !== finishedWork.tag || $ea68a19c2d46a931$var$commitFragmentInstanceDeletionEffects(finishedWork);
                $ea68a19c2d46a931$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 6:
                $ea68a19c2d46a931$var$commitFragmentInstanceDeletionEffects(finishedWork);
                break;
            case 26:
                $ea68a19c2d46a931$var$safelyDetachRef(finishedWork, finishedWork.return);
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || $ea68a19c2d46a931$var$offscreenSubtreeWasHidden || instance.parentNode.removeChild(instance);
                $ea68a19c2d46a931$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 22:
                null === finishedWork.memoizedState && $ea68a19c2d46a931$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 30:
                $ea68a19c2d46a931$var$safelyDetachRef(finishedWork, finishedWork.return);
                $ea68a19c2d46a931$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 7:
                $ea68a19c2d46a931$var$safelyDetachRef(finishedWork, finishedWork.return);
            default:
                $ea68a19c2d46a931$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $ea68a19c2d46a931$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, layoutEffectTraversalFlags) {
    layoutEffectTraversalFlags = 0 !== (parentFiber.subtreeFlags & 8772) ? layoutEffectTraversalFlags : layoutEffectTraversalFlags & -2;
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags, includeWorkInProgressEffects = 0 !== (layoutEffectTraversalFlags & 1);
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $ea68a19c2d46a931$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $ea68a19c2d46a931$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $ea68a19c2d46a931$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $ea68a19c2d46a931$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$ea68a19c2d46a931$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $ea68a19c2d46a931$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $ea68a19c2d46a931$var$commitClassCallbacks(finishedWork);
                $ea68a19c2d46a931$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && $ea68a19c2d46a931$var$commitHostSingletonAcquisition(finishedWork);
            case 5:
                5 !== finishedWork.tag && 27 !== finishedWork.tag || $ea68a19c2d46a931$var$commitFragmentInstanceInsertionEffects(finishedWork);
                $ea68a19c2d46a931$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && $ea68a19c2d46a931$var$commitHostMount(finishedWork);
                $ea68a19c2d46a931$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 6:
                $ea68a19c2d46a931$var$commitFragmentInstanceInsertionEffects(finishedWork);
                break;
            case 26:
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || $ea68a19c2d46a931$var$offscreenSubtreeIsHidden || $ea68a19c2d46a931$var$mountHoistable($ea68a19c2d46a931$var$getHoistableRoot(instance.ownerDocument), finishedWork.type, instance);
                $ea68a19c2d46a931$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && $ea68a19c2d46a931$var$commitHostMount(finishedWork);
                $ea68a19c2d46a931$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $ea68a19c2d46a931$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                break;
            case 31:
                $ea68a19c2d46a931$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && $ea68a19c2d46a931$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $ea68a19c2d46a931$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && $ea68a19c2d46a931$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $ea68a19c2d46a931$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $ea68a19c2d46a931$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                $ea68a19c2d46a931$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $ea68a19c2d46a931$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 7:
                $ea68a19c2d46a931$var$safelyAttachRef(finishedWork, finishedWork.return);
            default:
                $ea68a19c2d46a931$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $ea68a19c2d46a931$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $ea68a19c2d46a931$var$releaseCache(previousCache));
}
function $ea68a19c2d46a931$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $ea68a19c2d46a931$var$releaseCache(current));
}
function $ea68a19c2d46a931$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    if (parentFiber.subtreeFlags & (isViewTransitionEligible ? 10262 : 10256)) for(parentFiber = parentFiber.child; null !== parentFiber;)$ea68a19c2d46a931$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
    else isViewTransitionEligible && $ea68a19c2d46a931$var$restoreNestedViewTransitions(parentFiber);
}
function $ea68a19c2d46a931$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    isViewTransitionEligible && null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate && $ea68a19c2d46a931$var$restoreEnterOrExitViewTransitions(finishedWork);
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $ea68a19c2d46a931$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $ea68a19c2d46a931$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $ea68a19c2d46a931$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $ea68a19c2d46a931$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            isViewTransitionEligible && $ea68a19c2d46a931$var$rootViewTransitionNameCanceled && (finishedRoot = finishedRoot.containerInfo, finishedRoot = 9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, "root" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""), finishedRoot = finishedRoot.ownerDocument.documentElement, null !== finishedRoot && "none" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""));
            flags & 2048 && (flags = null, null !== finishedWork.alternate && (flags = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== flags && (finishedWork.refCount++, null != flags && $ea68a19c2d46a931$var$releaseCache(flags)));
            break;
        case 12:
            if (flags & 2048) {
                $ea68a19c2d46a931$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                flags = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", flags.passiveEffectDuration, -0);
                } catch (error) {
                    $ea68a19c2d46a931$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $ea68a19c2d46a931$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $ea68a19c2d46a931$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $ea68a19c2d46a931$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? (isViewTransitionEligible && null !== id && null === id.memoizedState && $ea68a19c2d46a931$var$restoreEnterOrExitViewTransitions(id), _finishedWork$memoize2._visibility & 2 ? $ea68a19c2d46a931$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $ea68a19c2d46a931$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork)) : (isViewTransitionEligible && null !== id && null !== id.memoizedState && $ea68a19c2d46a931$var$restoreEnterOrExitViewTransitions(finishedWork), _finishedWork$memoize2._visibility & 2 ? $ea68a19c2d46a931$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $ea68a19c2d46a931$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1)));
            flags & 2048 && $ea68a19c2d46a931$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $ea68a19c2d46a931$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $ea68a19c2d46a931$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        case 30:
            isViewTransitionEligible && (flags = finishedWork.alternate, null !== flags && ($ea68a19c2d46a931$var$restoreViewTransitionOnHostInstances(flags.child, !0), $ea68a19c2d46a931$var$restoreViewTransitionOnHostInstances(finishedWork.child, !0)));
            $ea68a19c2d46a931$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        default:
            $ea68a19c2d46a931$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $ea68a19c2d46a931$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $ea68a19c2d46a931$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $ea68a19c2d46a931$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $ea68a19c2d46a931$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $ea68a19c2d46a931$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $ea68a19c2d46a931$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $ea68a19c2d46a931$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $ea68a19c2d46a931$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $ea68a19c2d46a931$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $ea68a19c2d46a931$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $ea68a19c2d46a931$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $ea68a19c2d46a931$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $ea68a19c2d46a931$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $ea68a19c2d46a931$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $ea68a19c2d46a931$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $ea68a19c2d46a931$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $ea68a19c2d46a931$var$suspenseyCommitFlag = 8192;
function $ea68a19c2d46a931$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $ea68a19c2d46a931$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$ea68a19c2d46a931$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $ea68a19c2d46a931$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $ea68a19c2d46a931$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $ea68a19c2d46a931$var$suspenseyCommitFlag && (null !== fiber.memoizedState ? $ea68a19c2d46a931$var$suspendResource(suspendedState, $ea68a19c2d46a931$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps) : (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && $ea68a19c2d46a931$var$suspendInstance(suspendedState, fiber)));
            break;
        case 5:
            $ea68a19c2d46a931$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $ea68a19c2d46a931$var$suspenseyCommitFlag && (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && $ea68a19c2d46a931$var$suspendInstance(suspendedState, fiber));
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $ea68a19c2d46a931$var$currentHoistableRoot;
            $ea68a19c2d46a931$var$currentHoistableRoot = $ea68a19c2d46a931$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $ea68a19c2d46a931$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $ea68a19c2d46a931$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $ea68a19c2d46a931$var$suspenseyCommitFlag, $ea68a19c2d46a931$var$suspenseyCommitFlag = 16777216, $ea68a19c2d46a931$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $ea68a19c2d46a931$var$suspenseyCommitFlag = previousHoistableRoot) : $ea68a19c2d46a931$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        case 30:
            if (0 !== (fiber.flags & $ea68a19c2d46a931$var$suspenseyCommitFlag) && (previousHoistableRoot = fiber.memoizedProps.name, null != previousHoistableRoot && "auto" !== previousHoistableRoot)) {
                var state = fiber.stateNode;
                state.paired = null;
                null === $ea68a19c2d46a931$var$appearingViewTransitions && ($ea68a19c2d46a931$var$appearingViewTransitions = new Map());
                $ea68a19c2d46a931$var$appearingViewTransitions.set(previousHoistableRoot, state);
            }
            $ea68a19c2d46a931$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        default:
            $ea68a19c2d46a931$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $ea68a19c2d46a931$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $ea68a19c2d46a931$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $ea68a19c2d46a931$var$nextEffect = childToDelete;
            $ea68a19c2d46a931$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $ea68a19c2d46a931$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$ea68a19c2d46a931$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $ea68a19c2d46a931$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $ea68a19c2d46a931$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $ea68a19c2d46a931$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $ea68a19c2d46a931$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $ea68a19c2d46a931$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $ea68a19c2d46a931$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $ea68a19c2d46a931$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $ea68a19c2d46a931$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $ea68a19c2d46a931$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $ea68a19c2d46a931$var$nextEffect = childToDelete;
            $ea68a19c2d46a931$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $ea68a19c2d46a931$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $ea68a19c2d46a931$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $ea68a19c2d46a931$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $ea68a19c2d46a931$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $ea68a19c2d46a931$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $ea68a19c2d46a931$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $ea68a19c2d46a931$var$nextEffect;){
        var fiber = $ea68a19c2d46a931$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $ea68a19c2d46a931$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $ea68a19c2d46a931$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $ea68a19c2d46a931$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $ea68a19c2d46a931$var$nextEffect;){
            cache = $ea68a19c2d46a931$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $ea68a19c2d46a931$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $ea68a19c2d46a931$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $ea68a19c2d46a931$var$nextEffect = sibling;
                break a;
            }
            $ea68a19c2d46a931$var$nextEffect = returnFiber;
        }
    }
}
var $ea68a19c2d46a931$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $ea68a19c2d46a931$var$readContext($ea68a19c2d46a931$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $ea68a19c2d46a931$var$readContext($ea68a19c2d46a931$var$CacheContext).controller.signal;
    }
}, $ea68a19c2d46a931$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $ea68a19c2d46a931$var$executionContext = 0, $ea68a19c2d46a931$var$workInProgressRoot = null, $ea68a19c2d46a931$var$workInProgress = null, $ea68a19c2d46a931$var$workInProgressRootRenderLanes = 0, $ea68a19c2d46a931$var$workInProgressSuspendedReason = 0, $ea68a19c2d46a931$var$workInProgressThrownValue = null, $ea68a19c2d46a931$var$workInProgressRootDidSkipSuspendedSiblings = !1, $ea68a19c2d46a931$var$workInProgressRootIsPrerendering = !1, $ea68a19c2d46a931$var$workInProgressRootDidAttachPingListener = !1, $ea68a19c2d46a931$var$entangledRenderLanes = 0, $ea68a19c2d46a931$var$workInProgressRootExitStatus = 0, $ea68a19c2d46a931$var$workInProgressRootSkippedLanes = 0, $ea68a19c2d46a931$var$workInProgressRootInterleavedUpdatedLanes = 0, $ea68a19c2d46a931$var$workInProgressRootPingedLanes = 0, $ea68a19c2d46a931$var$workInProgressDeferredLane = 0, $ea68a19c2d46a931$var$workInProgressSuspendedRetryLanes = 0, $ea68a19c2d46a931$var$workInProgressRootConcurrentErrors = null, $ea68a19c2d46a931$var$workInProgressRootRecoverableErrors = null, $ea68a19c2d46a931$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $ea68a19c2d46a931$var$globalMostRecentFallbackTime = 0, $ea68a19c2d46a931$var$globalMostRecentTransitionTime = 0, $ea68a19c2d46a931$var$workInProgressRootRenderTargetTime = Infinity, $ea68a19c2d46a931$var$workInProgressTransitions = null, $ea68a19c2d46a931$var$legacyErrorBoundariesThatAlreadyFailed = null, $ea68a19c2d46a931$var$pendingEffectsStatus = 0, $ea68a19c2d46a931$var$pendingEffectsRoot = null, $ea68a19c2d46a931$var$pendingFinishedWork = null, $ea68a19c2d46a931$var$pendingEffectsLanes = 0, $ea68a19c2d46a931$var$pendingEffectsRemainingLanes = 0, $ea68a19c2d46a931$var$pendingPassiveTransitions = null, $ea68a19c2d46a931$var$pendingRecoverableErrors = null, $ea68a19c2d46a931$var$pendingViewTransition = null, $ea68a19c2d46a931$var$pendingViewTransitionEvents = null, $ea68a19c2d46a931$var$pendingTransitionTypes = null, $ea68a19c2d46a931$var$nestedUpdateCount = 0, $ea68a19c2d46a931$var$rootWithNestedUpdates = null;
function $ea68a19c2d46a931$var$requestUpdateLane() {
    return 0 !== ($ea68a19c2d46a931$var$executionContext & 2) && 0 !== $ea68a19c2d46a931$var$workInProgressRootRenderLanes ? $ea68a19c2d46a931$var$workInProgressRootRenderLanes & -$ea68a19c2d46a931$var$workInProgressRootRenderLanes : null !== $ea68a19c2d46a931$var$ReactSharedInternals.T ? $ea68a19c2d46a931$var$requestTransitionLane() : $ea68a19c2d46a931$var$resolveUpdatePriority();
}
function $ea68a19c2d46a931$var$requestDeferredLane() {
    if (0 === $ea68a19c2d46a931$var$workInProgressDeferredLane) {
        if (0 === ($ea68a19c2d46a931$var$workInProgressRootRenderLanes & 536870912) || $ea68a19c2d46a931$var$isHydrating) {
            var lane = $ea68a19c2d46a931$var$nextTransitionDeferredLane;
            $ea68a19c2d46a931$var$nextTransitionDeferredLane <<= 1;
            0 === ($ea68a19c2d46a931$var$nextTransitionDeferredLane & 3932160) && ($ea68a19c2d46a931$var$nextTransitionDeferredLane = 262144);
            $ea68a19c2d46a931$var$workInProgressDeferredLane = lane;
        } else $ea68a19c2d46a931$var$workInProgressDeferredLane = 536870912;
    }
    lane = $ea68a19c2d46a931$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $ea68a19c2d46a931$var$workInProgressDeferredLane;
}
function $ea68a19c2d46a931$var$scheduleViewTransitionEvent(fiber, callback) {
    if (null != callback) {
        var state = fiber.stateNode, instance = state.ref;
        null === instance && (instance = state.ref = $ea68a19c2d46a931$var$createViewTransitionInstance($ea68a19c2d46a931$var$getViewTransitionName(fiber.memoizedProps, state)));
        null === $ea68a19c2d46a931$var$pendingViewTransitionEvents && ($ea68a19c2d46a931$var$pendingViewTransitionEvents = []);
        $ea68a19c2d46a931$var$pendingViewTransitionEvents.push(callback.bind(null, instance));
    }
}
function $ea68a19c2d46a931$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $ea68a19c2d46a931$var$workInProgressRoot && (2 === $ea68a19c2d46a931$var$workInProgressSuspendedReason || 9 === $ea68a19c2d46a931$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $ea68a19c2d46a931$var$prepareFreshStack(root, 0), $ea68a19c2d46a931$var$markRootSuspended(root, $ea68a19c2d46a931$var$workInProgressRootRenderLanes, $ea68a19c2d46a931$var$workInProgressDeferredLane, !1);
    $ea68a19c2d46a931$var$markRootUpdated$1(root, lane);
    if (0 === ($ea68a19c2d46a931$var$executionContext & 2) || root !== $ea68a19c2d46a931$var$workInProgressRoot) root === $ea68a19c2d46a931$var$workInProgressRoot && (0 === ($ea68a19c2d46a931$var$executionContext & 2) && ($ea68a19c2d46a931$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $ea68a19c2d46a931$var$workInProgressRootExitStatus && $ea68a19c2d46a931$var$markRootSuspended(root, $ea68a19c2d46a931$var$workInProgressRootRenderLanes, $ea68a19c2d46a931$var$workInProgressDeferredLane, !1)), $ea68a19c2d46a931$var$ensureRootIsScheduled(root);
}
function $ea68a19c2d46a931$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($ea68a19c2d46a931$var$executionContext & 6)) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $ea68a19c2d46a931$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $ea68a19c2d46a931$var$renderRootConcurrent(root$jscomp$0, lanes) : $ea68a19c2d46a931$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $ea68a19c2d46a931$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $ea68a19c2d46a931$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$ea68a19c2d46a931$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $ea68a19c2d46a931$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $ea68a19c2d46a931$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($ea68a19c2d46a931$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $ea68a19c2d46a931$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result && 6 !== JSCompiler_inline_result) {
                            if ($ea68a19c2d46a931$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $ea68a19c2d46a931$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $ea68a19c2d46a931$var$workInProgressRootRecoverableErrors;
                            $ea68a19c2d46a931$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $ea68a19c2d46a931$var$workInProgressRootRecoverableErrors ? $ea68a19c2d46a931$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $ea68a19c2d46a931$var$workInProgressRootRecoverableErrors.push.apply($ea68a19c2d46a931$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $ea68a19c2d46a931$var$prepareFreshStack(root$jscomp$0, 0);
                $ea68a19c2d46a931$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes && (lanes & 62914560) !== lanes) break;
                    case 6:
                        $ea68a19c2d46a931$var$markRootSuspended(shouldTimeSlice, lanes, $ea68a19c2d46a931$var$workInProgressDeferredLane, !$ea68a19c2d46a931$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $ea68a19c2d46a931$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $ea68a19c2d46a931$var$globalMostRecentFallbackTime + 300 - $ea68a19c2d46a931$var$now(), 10 < exitStatus)) {
                    $ea68a19c2d46a931$var$markRootSuspended(shouldTimeSlice, lanes, $ea68a19c2d46a931$var$workInProgressDeferredLane, !$ea68a19c2d46a931$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $ea68a19c2d46a931$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $ea68a19c2d46a931$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $ea68a19c2d46a931$var$scheduleTimeout($ea68a19c2d46a931$var$completeRootWhenReady.bind(null, shouldTimeSlice, forceSync, $ea68a19c2d46a931$var$workInProgressRootRecoverableErrors, $ea68a19c2d46a931$var$workInProgressTransitions, $ea68a19c2d46a931$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $ea68a19c2d46a931$var$workInProgressDeferredLane, $ea68a19c2d46a931$var$workInProgressRootInterleavedUpdatedLanes, $ea68a19c2d46a931$var$workInProgressSuspendedRetryLanes, $ea68a19c2d46a931$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $ea68a19c2d46a931$var$completeRootWhenReady(shouldTimeSlice, forceSync, $ea68a19c2d46a931$var$workInProgressRootRecoverableErrors, $ea68a19c2d46a931$var$workInProgressTransitions, $ea68a19c2d46a931$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $ea68a19c2d46a931$var$workInProgressDeferredLane, $ea68a19c2d46a931$var$workInProgressRootInterleavedUpdatedLanes, $ea68a19c2d46a931$var$workInProgressSuspendedRetryLanes, $ea68a19c2d46a931$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $ea68a19c2d46a931$var$ensureRootIsScheduled(root$jscomp$0);
}
function $ea68a19c2d46a931$var$completeRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    var subtreeFlags = finishedWork.subtreeFlags, isViewTransitionEligible = (lanes & 335544064) === lanes;
    suspendedCommitReason = null;
    if (isViewTransitionEligible || subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
        if (suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $ea68a19c2d46a931$var$noop$1
        }, $ea68a19c2d46a931$var$appearingViewTransitions = null, $ea68a19c2d46a931$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason), isViewTransitionEligible && (subtreeFlags = suspendedCommitReason, isViewTransitionEligible = root.containerInfo, isViewTransitionEligible = (9 === isViewTransitionEligible.nodeType ? isViewTransitionEligible : isViewTransitionEligible.ownerDocument).__reactViewTransition, null != isViewTransitionEligible && (subtreeFlags.count++, subtreeFlags.waitingForViewTransition = !0, subtreeFlags = $ea68a19c2d46a931$var$onUnsuspend.bind(subtreeFlags), isViewTransitionEligible.finished.then(subtreeFlags, subtreeFlags))), subtreeFlags = (lanes & 62914560) === lanes ? $ea68a19c2d46a931$var$globalMostRecentFallbackTime - $ea68a19c2d46a931$var$now() : (lanes & 4194048) === lanes ? $ea68a19c2d46a931$var$globalMostRecentTransitionTime - $ea68a19c2d46a931$var$now() : 0, subtreeFlags = $ea68a19c2d46a931$var$waitForCommitToBeReady(suspendedCommitReason, subtreeFlags), null !== subtreeFlags) {
            $ea68a19c2d46a931$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = subtreeFlags($ea68a19c2d46a931$var$completeRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $ea68a19c2d46a931$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $ea68a19c2d46a931$var$completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason);
}
function $ea68a19c2d46a931$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$ea68a19c2d46a931$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $ea68a19c2d46a931$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes = $ea68a19c2d46a931$var$getEntangledLanes(root, suspendedLanes);
    suspendedLanes &= ~$ea68a19c2d46a931$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$ea68a19c2d46a931$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $ea68a19c2d46a931$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $ea68a19c2d46a931$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $ea68a19c2d46a931$var$flushSyncWork$1() {
    return 0 === ($ea68a19c2d46a931$var$executionContext & 6) ? ($ea68a19c2d46a931$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $ea68a19c2d46a931$var$resetWorkInProgressStack() {
    if (null !== $ea68a19c2d46a931$var$workInProgress) {
        if (0 === $ea68a19c2d46a931$var$workInProgressSuspendedReason) var interruptedWork = $ea68a19c2d46a931$var$workInProgress.return;
        else interruptedWork = $ea68a19c2d46a931$var$workInProgress, $ea68a19c2d46a931$var$lastContextDependency = $ea68a19c2d46a931$var$currentlyRenderingFiber$1 = null, $ea68a19c2d46a931$var$resetHooksOnUnwind(interruptedWork), $ea68a19c2d46a931$var$thenableState$1 = null, $ea68a19c2d46a931$var$thenableIndexCounter$1 = 0, interruptedWork = $ea68a19c2d46a931$var$workInProgress;
        for(; null !== interruptedWork;)$ea68a19c2d46a931$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $ea68a19c2d46a931$var$workInProgress = null;
    }
}
function $ea68a19c2d46a931$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $ea68a19c2d46a931$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $ea68a19c2d46a931$var$pendingEffectsLanes = 0;
    $ea68a19c2d46a931$var$resetWorkInProgressStack();
    $ea68a19c2d46a931$var$workInProgressRoot = root;
    $ea68a19c2d46a931$var$workInProgress = timeoutHandle = $ea68a19c2d46a931$var$createWorkInProgress(root.current, null);
    $ea68a19c2d46a931$var$workInProgressRootRenderLanes = lanes;
    $ea68a19c2d46a931$var$workInProgressSuspendedReason = 0;
    $ea68a19c2d46a931$var$workInProgressThrownValue = null;
    $ea68a19c2d46a931$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $ea68a19c2d46a931$var$workInProgressRootIsPrerendering = $ea68a19c2d46a931$var$checkIfRootIsPrerendering(root, lanes);
    $ea68a19c2d46a931$var$workInProgressRootDidAttachPingListener = !1;
    $ea68a19c2d46a931$var$workInProgressSuspendedRetryLanes = $ea68a19c2d46a931$var$workInProgressDeferredLane = $ea68a19c2d46a931$var$workInProgressRootPingedLanes = $ea68a19c2d46a931$var$workInProgressRootInterleavedUpdatedLanes = $ea68a19c2d46a931$var$workInProgressRootSkippedLanes = $ea68a19c2d46a931$var$workInProgressRootExitStatus = 0;
    $ea68a19c2d46a931$var$workInProgressRootRecoverableErrors = $ea68a19c2d46a931$var$workInProgressRootConcurrentErrors = null;
    $ea68a19c2d46a931$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    $ea68a19c2d46a931$var$entangledRenderLanes = $ea68a19c2d46a931$var$getEntangledLanes(root, lanes);
    $ea68a19c2d46a931$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $ea68a19c2d46a931$var$handleThrow(root, thrownValue) {
    $ea68a19c2d46a931$var$currentlyRenderingFiber = null;
    $ea68a19c2d46a931$var$ReactSharedInternals.H = $ea68a19c2d46a931$var$ContextOnlyDispatcher;
    thrownValue === $ea68a19c2d46a931$var$SuspenseException || thrownValue === $ea68a19c2d46a931$var$SuspenseActionException ? (thrownValue = $ea68a19c2d46a931$var$getSuspendedThenable(), $ea68a19c2d46a931$var$workInProgressSuspendedReason = 3) : thrownValue === $ea68a19c2d46a931$var$SuspenseyCommitException ? (thrownValue = $ea68a19c2d46a931$var$getSuspendedThenable(), $ea68a19c2d46a931$var$workInProgressSuspendedReason = 4) : $ea68a19c2d46a931$var$workInProgressSuspendedReason = thrownValue === $ea68a19c2d46a931$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $ea68a19c2d46a931$var$workInProgressThrownValue = thrownValue;
    null === $ea68a19c2d46a931$var$workInProgress && ($ea68a19c2d46a931$var$workInProgressRootExitStatus = 1, $ea68a19c2d46a931$var$logUncaughtError(root, $ea68a19c2d46a931$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $ea68a19c2d46a931$var$shouldRemainOnPreviousScreen() {
    var handler = $ea68a19c2d46a931$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($ea68a19c2d46a931$var$workInProgressRootRenderLanes & 4194048) === $ea68a19c2d46a931$var$workInProgressRootRenderLanes ? null === $ea68a19c2d46a931$var$shellBoundary ? !0 : !1 : ($ea68a19c2d46a931$var$workInProgressRootRenderLanes & 62914560) === $ea68a19c2d46a931$var$workInProgressRootRenderLanes || 0 !== ($ea68a19c2d46a931$var$workInProgressRootRenderLanes & 536870912) ? handler === $ea68a19c2d46a931$var$shellBoundary : !1;
}
function $ea68a19c2d46a931$var$pushDispatcher() {
    var prevDispatcher = $ea68a19c2d46a931$var$ReactSharedInternals.H;
    $ea68a19c2d46a931$var$ReactSharedInternals.H = $ea68a19c2d46a931$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $ea68a19c2d46a931$var$ContextOnlyDispatcher : prevDispatcher;
}
function $ea68a19c2d46a931$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $ea68a19c2d46a931$var$ReactSharedInternals.A;
    $ea68a19c2d46a931$var$ReactSharedInternals.A = $ea68a19c2d46a931$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $ea68a19c2d46a931$var$renderDidSuspendDelayIfPossible() {
    $ea68a19c2d46a931$var$workInProgressRootExitStatus = 4;
    $ea68a19c2d46a931$var$workInProgressRootDidSkipSuspendedSiblings || ($ea68a19c2d46a931$var$workInProgressRootRenderLanes & 4194048) !== $ea68a19c2d46a931$var$workInProgressRootRenderLanes && null !== $ea68a19c2d46a931$var$suspenseHandlerStackCursor.current || ($ea68a19c2d46a931$var$workInProgressRootIsPrerendering = !0);
    0 === ($ea68a19c2d46a931$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($ea68a19c2d46a931$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $ea68a19c2d46a931$var$workInProgressRoot || $ea68a19c2d46a931$var$markRootSuspended($ea68a19c2d46a931$var$workInProgressRoot, $ea68a19c2d46a931$var$workInProgressRootRenderLanes, $ea68a19c2d46a931$var$workInProgressDeferredLane, !1);
}
function $ea68a19c2d46a931$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $ea68a19c2d46a931$var$executionContext;
    $ea68a19c2d46a931$var$executionContext |= 2;
    var prevDispatcher = $ea68a19c2d46a931$var$pushDispatcher(), prevAsyncDispatcher = $ea68a19c2d46a931$var$pushAsyncDispatcher();
    if ($ea68a19c2d46a931$var$workInProgressRoot !== root || $ea68a19c2d46a931$var$workInProgressRootRenderLanes !== lanes) $ea68a19c2d46a931$var$workInProgressTransitions = null, $ea68a19c2d46a931$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $ea68a19c2d46a931$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $ea68a19c2d46a931$var$workInProgressSuspendedReason && null !== $ea68a19c2d46a931$var$workInProgress) {
            var unitOfWork = $ea68a19c2d46a931$var$workInProgress, thrownValue = $ea68a19c2d46a931$var$workInProgressThrownValue;
            switch($ea68a19c2d46a931$var$workInProgressSuspendedReason){
                case 8:
                    $ea68a19c2d46a931$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $ea68a19c2d46a931$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $ea68a19c2d46a931$var$workInProgressSuspendedReason;
                    $ea68a19c2d46a931$var$workInProgressSuspendedReason = 0;
                    $ea68a19c2d46a931$var$workInProgressThrownValue = null;
                    $ea68a19c2d46a931$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $ea68a19c2d46a931$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $ea68a19c2d46a931$var$workInProgressSuspendedReason, $ea68a19c2d46a931$var$workInProgressSuspendedReason = 0, $ea68a19c2d46a931$var$workInProgressThrownValue = null, $ea68a19c2d46a931$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $ea68a19c2d46a931$var$workLoopSync();
        exitStatus = $ea68a19c2d46a931$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$184) {
        $ea68a19c2d46a931$var$handleThrow(root, thrownValue$184);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $ea68a19c2d46a931$var$lastContextDependency = $ea68a19c2d46a931$var$currentlyRenderingFiber$1 = null;
    $ea68a19c2d46a931$var$executionContext = prevExecutionContext;
    $ea68a19c2d46a931$var$ReactSharedInternals.H = prevDispatcher;
    $ea68a19c2d46a931$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $ea68a19c2d46a931$var$workInProgress && ($ea68a19c2d46a931$var$workInProgressRoot = null, $ea68a19c2d46a931$var$workInProgressRootRenderLanes = 0, $ea68a19c2d46a931$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $ea68a19c2d46a931$var$workLoopSync() {
    for(; null !== $ea68a19c2d46a931$var$workInProgress;)$ea68a19c2d46a931$var$performUnitOfWork($ea68a19c2d46a931$var$workInProgress);
}
function $ea68a19c2d46a931$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $ea68a19c2d46a931$var$executionContext;
    $ea68a19c2d46a931$var$executionContext |= 2;
    var prevDispatcher = $ea68a19c2d46a931$var$pushDispatcher(), prevAsyncDispatcher = $ea68a19c2d46a931$var$pushAsyncDispatcher();
    $ea68a19c2d46a931$var$workInProgressRoot !== root || $ea68a19c2d46a931$var$workInProgressRootRenderLanes !== lanes ? ($ea68a19c2d46a931$var$workInProgressTransitions = null, $ea68a19c2d46a931$var$workInProgressRootRenderTargetTime = $ea68a19c2d46a931$var$now() + 500, $ea68a19c2d46a931$var$prepareFreshStack(root, lanes)) : $ea68a19c2d46a931$var$workInProgressRootIsPrerendering = $ea68a19c2d46a931$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $ea68a19c2d46a931$var$workInProgressSuspendedReason && null !== $ea68a19c2d46a931$var$workInProgress) {
            lanes = $ea68a19c2d46a931$var$workInProgress;
            var thrownValue = $ea68a19c2d46a931$var$workInProgressThrownValue;
            b: switch($ea68a19c2d46a931$var$workInProgressSuspendedReason){
                case 1:
                    $ea68a19c2d46a931$var$workInProgressSuspendedReason = 0;
                    $ea68a19c2d46a931$var$workInProgressThrownValue = null;
                    $ea68a19c2d46a931$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($ea68a19c2d46a931$var$isThenableResolved(thrownValue)) {
                        $ea68a19c2d46a931$var$workInProgressSuspendedReason = 0;
                        $ea68a19c2d46a931$var$workInProgressThrownValue = null;
                        $ea68a19c2d46a931$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $ea68a19c2d46a931$var$workInProgressSuspendedReason && 9 !== $ea68a19c2d46a931$var$workInProgressSuspendedReason || $ea68a19c2d46a931$var$workInProgressRoot !== root || ($ea68a19c2d46a931$var$workInProgressSuspendedReason = 7);
                        $ea68a19c2d46a931$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $ea68a19c2d46a931$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $ea68a19c2d46a931$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $ea68a19c2d46a931$var$isThenableResolved(thrownValue) ? ($ea68a19c2d46a931$var$workInProgressSuspendedReason = 0, $ea68a19c2d46a931$var$workInProgressThrownValue = null, $ea68a19c2d46a931$var$replaySuspendedUnitOfWork(lanes)) : ($ea68a19c2d46a931$var$workInProgressSuspendedReason = 0, $ea68a19c2d46a931$var$workInProgressThrownValue = null, $ea68a19c2d46a931$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($ea68a19c2d46a931$var$workInProgress.tag){
                        case 26:
                            resource = $ea68a19c2d46a931$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $ea68a19c2d46a931$var$workInProgress;
                            if (resource ? $ea68a19c2d46a931$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $ea68a19c2d46a931$var$workInProgressSuspendedReason = 0;
                                $ea68a19c2d46a931$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $ea68a19c2d46a931$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($ea68a19c2d46a931$var$workInProgress = returnFiber, $ea68a19c2d46a931$var$completeUnitOfWork(returnFiber)) : $ea68a19c2d46a931$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $ea68a19c2d46a931$var$workInProgressSuspendedReason = 0;
                    $ea68a19c2d46a931$var$workInProgressThrownValue = null;
                    $ea68a19c2d46a931$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $ea68a19c2d46a931$var$workInProgressSuspendedReason = 0;
                    $ea68a19c2d46a931$var$workInProgressThrownValue = null;
                    $ea68a19c2d46a931$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $ea68a19c2d46a931$var$resetWorkInProgressStack();
                    $ea68a19c2d46a931$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(462));
            }
        }
        $ea68a19c2d46a931$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$186) {
        $ea68a19c2d46a931$var$handleThrow(root, thrownValue$186);
    }
    while (1);
    $ea68a19c2d46a931$var$lastContextDependency = $ea68a19c2d46a931$var$currentlyRenderingFiber$1 = null;
    $ea68a19c2d46a931$var$ReactSharedInternals.H = prevDispatcher;
    $ea68a19c2d46a931$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $ea68a19c2d46a931$var$executionContext = prevExecutionContext;
    if (null !== $ea68a19c2d46a931$var$workInProgress) return 0;
    $ea68a19c2d46a931$var$workInProgressRoot = null;
    $ea68a19c2d46a931$var$workInProgressRootRenderLanes = 0;
    $ea68a19c2d46a931$var$finishQueueingConcurrentUpdates();
    return $ea68a19c2d46a931$var$workInProgressRootExitStatus;
}
function $ea68a19c2d46a931$var$workLoopConcurrentByScheduler() {
    for(; null !== $ea68a19c2d46a931$var$workInProgress && !$ea68a19c2d46a931$var$shouldYield();)$ea68a19c2d46a931$var$performUnitOfWork($ea68a19c2d46a931$var$workInProgress);
}
function $ea68a19c2d46a931$var$performUnitOfWork(unitOfWork) {
    var next = $ea68a19c2d46a931$var$beginWork(unitOfWork.alternate, unitOfWork, $ea68a19c2d46a931$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $ea68a19c2d46a931$var$completeUnitOfWork(unitOfWork) : $ea68a19c2d46a931$var$workInProgress = next;
}
function $ea68a19c2d46a931$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $ea68a19c2d46a931$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $ea68a19c2d46a931$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $ea68a19c2d46a931$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $ea68a19c2d46a931$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $ea68a19c2d46a931$var$resetHooksOnUnwind(next);
            var fiber = next;
            fiber === $ea68a19c2d46a931$var$hydrationParentFiber && ($ea68a19c2d46a931$var$isHydrating ? ($ea68a19c2d46a931$var$popToNextHostParent(fiber), 5 === fiber.tag && null != fiber.stateNode && ($ea68a19c2d46a931$var$nextHydratableInstance = fiber.stateNode)) : ($ea68a19c2d46a931$var$popToNextHostParent(fiber), $ea68a19c2d46a931$var$isHydrating = !0));
        default:
            $ea68a19c2d46a931$var$unwindInterruptedWork(current, next), next = $ea68a19c2d46a931$var$workInProgress = $ea68a19c2d46a931$var$resetWorkInProgress(next, $ea68a19c2d46a931$var$entangledRenderLanes), next = $ea68a19c2d46a931$var$beginWork(current, next, $ea68a19c2d46a931$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $ea68a19c2d46a931$var$completeUnitOfWork(unitOfWork) : $ea68a19c2d46a931$var$workInProgress = next;
}
function $ea68a19c2d46a931$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $ea68a19c2d46a931$var$lastContextDependency = $ea68a19c2d46a931$var$currentlyRenderingFiber$1 = null;
    $ea68a19c2d46a931$var$resetHooksOnUnwind(unitOfWork);
    $ea68a19c2d46a931$var$thenableState$1 = null;
    $ea68a19c2d46a931$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($ea68a19c2d46a931$var$throwException(root, returnFiber, unitOfWork, thrownValue, $ea68a19c2d46a931$var$workInProgressRootRenderLanes)) {
            $ea68a19c2d46a931$var$workInProgressRootExitStatus = 1;
            $ea68a19c2d46a931$var$logUncaughtError(root, $ea68a19c2d46a931$var$createCapturedValueAtFiber(thrownValue, root.current));
            $ea68a19c2d46a931$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $ea68a19c2d46a931$var$workInProgress = returnFiber, error;
        $ea68a19c2d46a931$var$workInProgressRootExitStatus = 1;
        $ea68a19c2d46a931$var$logUncaughtError(root, $ea68a19c2d46a931$var$createCapturedValueAtFiber(thrownValue, root.current));
        $ea68a19c2d46a931$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($ea68a19c2d46a931$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($ea68a19c2d46a931$var$workInProgressRootIsPrerendering || 0 !== ($ea68a19c2d46a931$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($ea68a19c2d46a931$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $ea68a19c2d46a931$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $ea68a19c2d46a931$var$unwindUnitOfWork(unitOfWork, root);
    } else $ea68a19c2d46a931$var$completeUnitOfWork(unitOfWork);
}
function $ea68a19c2d46a931$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $ea68a19c2d46a931$var$unwindUnitOfWork(completedWork, $ea68a19c2d46a931$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $ea68a19c2d46a931$var$completeWork(completedWork.alternate, completedWork, $ea68a19c2d46a931$var$entangledRenderLanes);
        if (null !== next) {
            $ea68a19c2d46a931$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $ea68a19c2d46a931$var$workInProgress = completedWork;
            return;
        }
        $ea68a19c2d46a931$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $ea68a19c2d46a931$var$workInProgressRootExitStatus && ($ea68a19c2d46a931$var$workInProgressRootExitStatus = 5);
}
function $ea68a19c2d46a931$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $ea68a19c2d46a931$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $ea68a19c2d46a931$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $ea68a19c2d46a931$var$workInProgress = unitOfWork;
            return;
        }
        $ea68a19c2d46a931$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $ea68a19c2d46a931$var$workInProgressRootExitStatus = 6;
    $ea68a19c2d46a931$var$workInProgress = null;
}
function $ea68a19c2d46a931$var$completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedState) {
    root.cancelPendingCommit = null;
    do $ea68a19c2d46a931$var$flushPendingEffects();
    while (0 !== $ea68a19c2d46a931$var$pendingEffectsStatus);
    if (0 !== ($ea68a19c2d46a931$var$executionContext & 6)) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(177));
        root === $ea68a19c2d46a931$var$workInProgressRoot && ($ea68a19c2d46a931$var$workInProgress = $ea68a19c2d46a931$var$workInProgressRoot = null, $ea68a19c2d46a931$var$workInProgressRootRenderLanes = 0);
        $ea68a19c2d46a931$var$pendingFinishedWork = finishedWork;
        $ea68a19c2d46a931$var$pendingEffectsRoot = root;
        $ea68a19c2d46a931$var$pendingEffectsLanes = lanes;
        $ea68a19c2d46a931$var$pendingPassiveTransitions = transitions;
        $ea68a19c2d46a931$var$pendingRecoverableErrors = recoverableErrors;
        $ea68a19c2d46a931$var$commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState);
    }
}
function $ea68a19c2d46a931$var$commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState) {
    var remainingLanes = finishedWork.lanes | finishedWork.childLanes;
    $ea68a19c2d46a931$var$pendingEffectsRemainingLanes = remainingLanes;
    remainingLanes |= $ea68a19c2d46a931$var$concurrentlyUpdatedLanes;
    $ea68a19c2d46a931$var$markRootFinished(root, lanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes);
    $ea68a19c2d46a931$var$pendingViewTransitionEvents = null;
    (lanes & 335544064) === lanes ? ($ea68a19c2d46a931$var$pendingTransitionTypes = $ea68a19c2d46a931$var$claimQueuedTransitionTypes(root), spawnedLane = 10262) : ($ea68a19c2d46a931$var$pendingTransitionTypes = null, spawnedLane = 10256);
    0 !== (finishedWork.subtreeFlags & spawnedLane) || 0 !== (finishedWork.flags & spawnedLane) ? (root.callbackNode = null, root.callbackPriority = 0, $ea68a19c2d46a931$var$scheduleCallback$1($ea68a19c2d46a931$var$NormalPriority$1, function() {
        $ea68a19c2d46a931$var$flushPassiveEffects();
        return null;
    })) : (root.callbackNode = null, root.callbackPriority = 0);
    $ea68a19c2d46a931$var$shouldStartViewTransition = !1;
    spawnedLane = 0 !== (finishedWork.flags & 13878);
    if (0 !== (finishedWork.subtreeFlags & 13878) || spawnedLane) {
        spawnedLane = $ea68a19c2d46a931$var$ReactSharedInternals.T;
        $ea68a19c2d46a931$var$ReactSharedInternals.T = null;
        updatedLanes = $ea68a19c2d46a931$var$ReactDOMSharedInternals.p;
        $ea68a19c2d46a931$var$ReactDOMSharedInternals.p = 2;
        suspendedRetryLanes = $ea68a19c2d46a931$var$executionContext;
        $ea68a19c2d46a931$var$executionContext |= 4;
        try {
            $ea68a19c2d46a931$var$commitBeforeMutationEffects(root, finishedWork, lanes);
        } finally{
            $ea68a19c2d46a931$var$executionContext = suspendedRetryLanes, $ea68a19c2d46a931$var$ReactDOMSharedInternals.p = updatedLanes, $ea68a19c2d46a931$var$ReactSharedInternals.T = spawnedLane;
        }
    }
    $ea68a19c2d46a931$var$pendingEffectsStatus = 1;
    $ea68a19c2d46a931$var$shouldStartViewTransition ? $ea68a19c2d46a931$var$pendingViewTransition = $ea68a19c2d46a931$var$startViewTransition(suspendedState, root.containerInfo, $ea68a19c2d46a931$var$pendingTransitionTypes, $ea68a19c2d46a931$var$flushMutationEffects, $ea68a19c2d46a931$var$flushLayoutEffects, $ea68a19c2d46a931$var$flushAfterMutationEffects, $ea68a19c2d46a931$var$flushSpawnedWork, $ea68a19c2d46a931$var$flushPassiveEffects, $ea68a19c2d46a931$var$reportViewTransitionError, null, null) : ($ea68a19c2d46a931$var$flushMutationEffects(), $ea68a19c2d46a931$var$flushLayoutEffects(), $ea68a19c2d46a931$var$flushSpawnedWork());
}
function $ea68a19c2d46a931$var$reportViewTransitionError(error) {
    if (0 !== $ea68a19c2d46a931$var$pendingEffectsStatus) {
        var onRecoverableError = $ea68a19c2d46a931$var$pendingEffectsRoot.onRecoverableError;
        onRecoverableError(error, {
            componentStack: null
        });
    }
}
function $ea68a19c2d46a931$var$flushAfterMutationEffects() {
    3 === $ea68a19c2d46a931$var$pendingEffectsStatus && ($ea68a19c2d46a931$var$pendingEffectsStatus = 0, $ea68a19c2d46a931$var$commitAfterMutationEffectsOnFiber($ea68a19c2d46a931$var$pendingFinishedWork, $ea68a19c2d46a931$var$pendingEffectsRoot), $ea68a19c2d46a931$var$pendingEffectsStatus = 4);
}
function $ea68a19c2d46a931$var$flushMutationEffects() {
    if (1 === $ea68a19c2d46a931$var$pendingEffectsStatus) {
        $ea68a19c2d46a931$var$pendingEffectsStatus = 0;
        var root = $ea68a19c2d46a931$var$pendingEffectsRoot, finishedWork = $ea68a19c2d46a931$var$pendingFinishedWork, lanes = $ea68a19c2d46a931$var$pendingEffectsLanes, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $ea68a19c2d46a931$var$ReactSharedInternals.T;
            $ea68a19c2d46a931$var$ReactSharedInternals.T = null;
            var previousPriority = $ea68a19c2d46a931$var$ReactDOMSharedInternals.p;
            $ea68a19c2d46a931$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $ea68a19c2d46a931$var$executionContext;
            $ea68a19c2d46a931$var$executionContext |= 4;
            try {
                $ea68a19c2d46a931$var$inUpdateViewTransition = $ea68a19c2d46a931$var$rootViewTransitionAffected = !1;
                $ea68a19c2d46a931$var$commitMutationEffectsOnFiber(finishedWork, root, lanes);
                lanes = $ea68a19c2d46a931$var$selectionInformation;
                var curFocusedElem = $ea68a19c2d46a931$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = lanes.focusedElem, priorSelectionRange = lanes.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $ea68a19c2d46a931$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $ea68a19c2d46a931$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $ea68a19c2d46a931$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $ea68a19c2d46a931$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $ea68a19c2d46a931$var$_enabled = !!$ea68a19c2d46a931$var$eventsEnabled;
                $ea68a19c2d46a931$var$selectionInformation = $ea68a19c2d46a931$var$eventsEnabled = null;
            } finally{
                $ea68a19c2d46a931$var$executionContext = prevExecutionContext, $ea68a19c2d46a931$var$ReactDOMSharedInternals.p = previousPriority, $ea68a19c2d46a931$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $ea68a19c2d46a931$var$pendingEffectsStatus = 2;
    }
}
function $ea68a19c2d46a931$var$flushLayoutEffects() {
    if (2 === $ea68a19c2d46a931$var$pendingEffectsStatus) {
        $ea68a19c2d46a931$var$pendingEffectsStatus = 0;
        var root = $ea68a19c2d46a931$var$pendingEffectsRoot, finishedWork = $ea68a19c2d46a931$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $ea68a19c2d46a931$var$ReactSharedInternals.T;
            $ea68a19c2d46a931$var$ReactSharedInternals.T = null;
            var previousPriority = $ea68a19c2d46a931$var$ReactDOMSharedInternals.p;
            $ea68a19c2d46a931$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $ea68a19c2d46a931$var$executionContext;
            $ea68a19c2d46a931$var$executionContext |= 4;
            try {
                $ea68a19c2d46a931$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $ea68a19c2d46a931$var$executionContext = prevExecutionContext, $ea68a19c2d46a931$var$ReactDOMSharedInternals.p = previousPriority, $ea68a19c2d46a931$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $ea68a19c2d46a931$var$pendingEffectsStatus = 3;
    }
}
function $ea68a19c2d46a931$var$flushSpawnedWork() {
    if (4 === $ea68a19c2d46a931$var$pendingEffectsStatus || 3 === $ea68a19c2d46a931$var$pendingEffectsStatus) {
        $ea68a19c2d46a931$var$pendingEffectsStatus = 0;
        var committedViewTransition = $ea68a19c2d46a931$var$pendingViewTransition;
        $ea68a19c2d46a931$var$pendingViewTransition = null;
        $ea68a19c2d46a931$var$requestPaint();
        var root = $ea68a19c2d46a931$var$pendingEffectsRoot, finishedWork = $ea68a19c2d46a931$var$pendingFinishedWork, lanes = $ea68a19c2d46a931$var$pendingEffectsLanes, recoverableErrors = $ea68a19c2d46a931$var$pendingRecoverableErrors, passiveSubtreeMask = (lanes & 335544064) === lanes ? 10262 : 10256;
        0 !== (finishedWork.subtreeFlags & passiveSubtreeMask) || 0 !== (finishedWork.flags & passiveSubtreeMask) ? $ea68a19c2d46a931$var$pendingEffectsStatus = 5 : ($ea68a19c2d46a931$var$pendingEffectsStatus = 0, $ea68a19c2d46a931$var$pendingFinishedWork = $ea68a19c2d46a931$var$pendingEffectsRoot = null, $ea68a19c2d46a931$var$releaseRootPooledCache(root, root.pendingLanes));
        passiveSubtreeMask = root.pendingLanes;
        0 === passiveSubtreeMask && ($ea68a19c2d46a931$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $ea68a19c2d46a931$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($ea68a19c2d46a931$var$injectedHook && "function" === typeof $ea68a19c2d46a931$var$injectedHook.onCommitFiberRoot) try {
            $ea68a19c2d46a931$var$injectedHook.onCommitFiberRoot($ea68a19c2d46a931$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $ea68a19c2d46a931$var$ReactSharedInternals.T;
            passiveSubtreeMask = $ea68a19c2d46a931$var$ReactDOMSharedInternals.p;
            $ea68a19c2d46a931$var$ReactDOMSharedInternals.p = 2;
            $ea68a19c2d46a931$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $ea68a19c2d46a931$var$ReactSharedInternals.T = finishedWork, $ea68a19c2d46a931$var$ReactDOMSharedInternals.p = passiveSubtreeMask;
            }
        }
        recoverableErrors = $ea68a19c2d46a931$var$pendingViewTransitionEvents;
        onRecoverableError = $ea68a19c2d46a931$var$pendingTransitionTypes;
        $ea68a19c2d46a931$var$pendingTransitionTypes = null;
        if (null !== recoverableErrors && ($ea68a19c2d46a931$var$pendingViewTransitionEvents = null, null === onRecoverableError && (onRecoverableError = []), null !== committedViewTransition)) for(recoverableError = 0; recoverableError < recoverableErrors.length; recoverableError++)finishedWork = (0, recoverableErrors[recoverableError])(onRecoverableError), void 0 !== finishedWork && committedViewTransition.finished.finally(finishedWork);
        0 !== ($ea68a19c2d46a931$var$pendingEffectsLanes & 3) && $ea68a19c2d46a931$var$flushPendingEffects();
        $ea68a19c2d46a931$var$ensureRootIsScheduled(root);
        passiveSubtreeMask = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (passiveSubtreeMask & 42) ? root === $ea68a19c2d46a931$var$rootWithNestedUpdates ? $ea68a19c2d46a931$var$nestedUpdateCount++ : ($ea68a19c2d46a931$var$nestedUpdateCount = 0, $ea68a19c2d46a931$var$rootWithNestedUpdates = root) : ($ea68a19c2d46a931$var$nestedUpdateCount = 0, $ea68a19c2d46a931$var$rootWithNestedUpdates = null);
        $ea68a19c2d46a931$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $ea68a19c2d46a931$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $ea68a19c2d46a931$var$releaseCache(remainingLanes)));
}
function $ea68a19c2d46a931$var$flushPendingEffects() {
    null !== $ea68a19c2d46a931$var$pendingViewTransition && ($ea68a19c2d46a931$var$pendingViewTransition.skipTransition(), $ea68a19c2d46a931$var$pendingViewTransition = null);
    $ea68a19c2d46a931$var$flushMutationEffects();
    $ea68a19c2d46a931$var$flushLayoutEffects();
    $ea68a19c2d46a931$var$flushSpawnedWork();
    return $ea68a19c2d46a931$var$flushPassiveEffects();
}
function $ea68a19c2d46a931$var$flushPassiveEffects() {
    if (5 !== $ea68a19c2d46a931$var$pendingEffectsStatus) return !1;
    var root = $ea68a19c2d46a931$var$pendingEffectsRoot, remainingLanes = $ea68a19c2d46a931$var$pendingEffectsRemainingLanes;
    $ea68a19c2d46a931$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $ea68a19c2d46a931$var$lanesToEventPriority($ea68a19c2d46a931$var$pendingEffectsLanes), prevTransition = $ea68a19c2d46a931$var$ReactSharedInternals.T, previousPriority = $ea68a19c2d46a931$var$ReactDOMSharedInternals.p;
    try {
        $ea68a19c2d46a931$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $ea68a19c2d46a931$var$ReactSharedInternals.T = null;
        renderPriority = $ea68a19c2d46a931$var$pendingPassiveTransitions;
        $ea68a19c2d46a931$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $ea68a19c2d46a931$var$pendingEffectsRoot, lanes = $ea68a19c2d46a931$var$pendingEffectsLanes;
        $ea68a19c2d46a931$var$pendingEffectsStatus = 0;
        $ea68a19c2d46a931$var$pendingFinishedWork = $ea68a19c2d46a931$var$pendingEffectsRoot = null;
        $ea68a19c2d46a931$var$pendingEffectsLanes = 0;
        if (0 !== ($ea68a19c2d46a931$var$executionContext & 6)) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(331));
        var prevExecutionContext = $ea68a19c2d46a931$var$executionContext;
        $ea68a19c2d46a931$var$executionContext |= 4;
        $ea68a19c2d46a931$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $ea68a19c2d46a931$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $ea68a19c2d46a931$var$executionContext = prevExecutionContext;
        $ea68a19c2d46a931$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($ea68a19c2d46a931$var$injectedHook && "function" === typeof $ea68a19c2d46a931$var$injectedHook.onPostCommitFiberRoot) try {
            $ea68a19c2d46a931$var$injectedHook.onPostCommitFiberRoot($ea68a19c2d46a931$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $ea68a19c2d46a931$var$ReactDOMSharedInternals.p = previousPriority, $ea68a19c2d46a931$var$ReactSharedInternals.T = prevTransition, $ea68a19c2d46a931$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $ea68a19c2d46a931$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $ea68a19c2d46a931$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $ea68a19c2d46a931$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $ea68a19c2d46a931$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($ea68a19c2d46a931$var$markRootUpdated$1(rootFiber, 2), $ea68a19c2d46a931$var$ensureRootIsScheduled(rootFiber));
}
function $ea68a19c2d46a931$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $ea68a19c2d46a931$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $ea68a19c2d46a931$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $ea68a19c2d46a931$var$legacyErrorBoundariesThatAlreadyFailed || !$ea68a19c2d46a931$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $ea68a19c2d46a931$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $ea68a19c2d46a931$var$createClassErrorUpdate(2);
                instance = $ea68a19c2d46a931$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($ea68a19c2d46a931$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $ea68a19c2d46a931$var$markRootUpdated$1(instance, 2), $ea68a19c2d46a931$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $ea68a19c2d46a931$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $ea68a19c2d46a931$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($ea68a19c2d46a931$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $ea68a19c2d46a931$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $ea68a19c2d46a931$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $ea68a19c2d46a931$var$workInProgressRoot === root && ($ea68a19c2d46a931$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $ea68a19c2d46a931$var$workInProgressRootExitStatus || 3 === $ea68a19c2d46a931$var$workInProgressRootExitStatus && ($ea68a19c2d46a931$var$workInProgressRootRenderLanes & 62914560) === $ea68a19c2d46a931$var$workInProgressRootRenderLanes && 300 > $ea68a19c2d46a931$var$now() - $ea68a19c2d46a931$var$globalMostRecentFallbackTime ? 0 === ($ea68a19c2d46a931$var$executionContext & 2) ? $ea68a19c2d46a931$var$prepareFreshStack(root, 0) : $ea68a19c2d46a931$var$workInProgressRootPingedLanes |= pingedLanes : $ea68a19c2d46a931$var$workInProgressRootPingedLanes |= pingedLanes, $ea68a19c2d46a931$var$workInProgressSuspendedRetryLanes === $ea68a19c2d46a931$var$workInProgressRootRenderLanes && ($ea68a19c2d46a931$var$workInProgressSuspendedRetryLanes = 0));
    $ea68a19c2d46a931$var$ensureRootIsScheduled(root);
}
function $ea68a19c2d46a931$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $ea68a19c2d46a931$var$claimNextRetryLane());
    boundaryFiber = $ea68a19c2d46a931$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($ea68a19c2d46a931$var$markRootUpdated$1(boundaryFiber, retryLane), $ea68a19c2d46a931$var$ensureRootIsScheduled(boundaryFiber));
}
function $ea68a19c2d46a931$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $ea68a19c2d46a931$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $ea68a19c2d46a931$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $ea68a19c2d46a931$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $ea68a19c2d46a931$var$scheduleCallback$1(priorityLevel, callback) {
    return $ea68a19c2d46a931$var$scheduleCallback$3(priorityLevel, callback);
}
var $ea68a19c2d46a931$var$firstScheduledRoot = null, $ea68a19c2d46a931$var$lastScheduledRoot = null, $ea68a19c2d46a931$var$didScheduleMicrotask = !1, $ea68a19c2d46a931$var$mightHavePendingSyncWork = !1, $ea68a19c2d46a931$var$isFlushingWork = !1, $ea68a19c2d46a931$var$currentEventTransitionLane = 0;
function $ea68a19c2d46a931$var$ensureRootIsScheduled(root) {
    root !== $ea68a19c2d46a931$var$lastScheduledRoot && null === root.next && (null === $ea68a19c2d46a931$var$lastScheduledRoot ? $ea68a19c2d46a931$var$firstScheduledRoot = $ea68a19c2d46a931$var$lastScheduledRoot = root : $ea68a19c2d46a931$var$lastScheduledRoot = $ea68a19c2d46a931$var$lastScheduledRoot.next = root);
    $ea68a19c2d46a931$var$mightHavePendingSyncWork = !0;
    $ea68a19c2d46a931$var$didScheduleMicrotask || ($ea68a19c2d46a931$var$didScheduleMicrotask = !0, $ea68a19c2d46a931$var$scheduleImmediateRootScheduleTask());
}
function $ea68a19c2d46a931$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$ea68a19c2d46a931$var$isFlushingWork && $ea68a19c2d46a931$var$mightHavePendingSyncWork) {
        $ea68a19c2d46a931$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$190 = $ea68a19c2d46a931$var$firstScheduledRoot; null !== root$190;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$190.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$190.suspendedLanes, pingedLanes = root$190.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $ea68a19c2d46a931$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $ea68a19c2d46a931$var$performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $ea68a19c2d46a931$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $ea68a19c2d46a931$var$getNextLanes(root$190, root$190 === $ea68a19c2d46a931$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$190.cancelPendingCommit || -1 !== root$190.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $ea68a19c2d46a931$var$checkIfRootIsPrerendering(root$190, JSCompiler_inline_result) || (didPerformSomeWork = !0, $ea68a19c2d46a931$var$performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                }
                root$190 = root$190.next;
            }
        }while (didPerformSomeWork);
        $ea68a19c2d46a931$var$isFlushingWork = !1;
    }
}
function $ea68a19c2d46a931$var$processRootScheduleInImmediateTask() {
    $ea68a19c2d46a931$var$processRootScheduleInMicrotask();
}
function $ea68a19c2d46a931$var$processRootScheduleInMicrotask() {
    $ea68a19c2d46a931$var$mightHavePendingSyncWork = $ea68a19c2d46a931$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $ea68a19c2d46a931$var$currentEventTransitionLane && $ea68a19c2d46a931$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $ea68a19c2d46a931$var$currentEventTransitionLane);
    for(var currentTime = $ea68a19c2d46a931$var$now(), prev = null, root = $ea68a19c2d46a931$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $ea68a19c2d46a931$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $ea68a19c2d46a931$var$firstScheduledRoot = next : prev.next = next, null === next && ($ea68a19c2d46a931$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $ea68a19c2d46a931$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $ea68a19c2d46a931$var$pendingEffectsStatus && 5 !== $ea68a19c2d46a931$var$pendingEffectsStatus || $ea68a19c2d46a931$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $ea68a19c2d46a931$var$currentEventTransitionLane && ($ea68a19c2d46a931$var$currentEventTransitionLane = 0);
}
function $ea68a19c2d46a931$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $ea68a19c2d46a931$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $ea68a19c2d46a931$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $ea68a19c2d46a931$var$workInProgressRoot;
    suspendedLanes = $ea68a19c2d46a931$var$workInProgressRootRenderLanes;
    suspendedLanes = $ea68a19c2d46a931$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $ea68a19c2d46a931$var$workInProgressSuspendedReason || 9 === $ea68a19c2d46a931$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $ea68a19c2d46a931$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $ea68a19c2d46a931$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $ea68a19c2d46a931$var$cancelCallback$1(pingedLanes);
        switch($ea68a19c2d46a931$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $ea68a19c2d46a931$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $ea68a19c2d46a931$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $ea68a19c2d46a931$var$IdlePriority;
                break;
            default:
                suspendedLanes = $ea68a19c2d46a931$var$NormalPriority$1;
        }
        pingedLanes = $ea68a19c2d46a931$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $ea68a19c2d46a931$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $ea68a19c2d46a931$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $ea68a19c2d46a931$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $ea68a19c2d46a931$var$pendingEffectsStatus && 5 !== $ea68a19c2d46a931$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($ea68a19c2d46a931$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $ea68a19c2d46a931$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $ea68a19c2d46a931$var$getNextLanes(root, root === $ea68a19c2d46a931$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $ea68a19c2d46a931$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $ea68a19c2d46a931$var$scheduleTaskForRootDuringMicrotask(root, $ea68a19c2d46a931$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $ea68a19c2d46a931$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $ea68a19c2d46a931$var$performSyncWorkOnRoot(root, lanes) {
    if ($ea68a19c2d46a931$var$flushPendingEffects()) return null;
    $ea68a19c2d46a931$var$performWorkOnRoot(root, lanes, !0);
}
function $ea68a19c2d46a931$var$scheduleImmediateRootScheduleTask() {
    $ea68a19c2d46a931$var$scheduleMicrotask(function() {
        0 !== ($ea68a19c2d46a931$var$executionContext & 6) ? $ea68a19c2d46a931$var$scheduleCallback$3($ea68a19c2d46a931$var$ImmediatePriority, $ea68a19c2d46a931$var$processRootScheduleInImmediateTask) : $ea68a19c2d46a931$var$processRootScheduleInMicrotask();
    });
}
function $ea68a19c2d46a931$var$requestTransitionLane() {
    if (0 === $ea68a19c2d46a931$var$currentEventTransitionLane) {
        var actionScopeLane = $ea68a19c2d46a931$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $ea68a19c2d46a931$var$nextTransitionUpdateLane, $ea68a19c2d46a931$var$nextTransitionUpdateLane <<= 1, 0 === ($ea68a19c2d46a931$var$nextTransitionUpdateLane & 261888) && ($ea68a19c2d46a931$var$nextTransitionUpdateLane = 256));
        $ea68a19c2d46a931$var$currentEventTransitionLane = actionScopeLane;
    }
    return $ea68a19c2d46a931$var$currentEventTransitionLane;
}
function $ea68a19c2d46a931$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $ea68a19c2d46a931$var$sanitizeURL(actionProp);
}
function $ea68a19c2d46a931$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $ea68a19c2d46a931$var$coerceFormActionProp((nativeEventTarget[$ea68a19c2d46a931$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$ea68a19c2d46a931$var$internalPropsKey] || null) ? $ea68a19c2d46a931$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $ea68a19c2d46a931$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $ea68a19c2d46a931$var$currentEventTransitionLane) {
                                var formData = new FormData(nativeEventTarget, submitter);
                                $ea68a19c2d46a931$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = new FormData(nativeEventTarget, submitter), $ea68a19c2d46a931$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $ea68a19c2d46a931$var$i$jscomp$inline_1667 = 0; $ea68a19c2d46a931$var$i$jscomp$inline_1667 < $ea68a19c2d46a931$var$simpleEventPluginEvents.length; $ea68a19c2d46a931$var$i$jscomp$inline_1667++){
    var $ea68a19c2d46a931$var$eventName$jscomp$inline_1668 = $ea68a19c2d46a931$var$simpleEventPluginEvents[$ea68a19c2d46a931$var$i$jscomp$inline_1667], $ea68a19c2d46a931$var$domEventName$jscomp$inline_1669 = $ea68a19c2d46a931$var$eventName$jscomp$inline_1668.toLowerCase(), $ea68a19c2d46a931$var$capitalizedEvent$jscomp$inline_1670 = $ea68a19c2d46a931$var$eventName$jscomp$inline_1668[0].toUpperCase() + $ea68a19c2d46a931$var$eventName$jscomp$inline_1668.slice(1);
    $ea68a19c2d46a931$var$registerSimpleEvent($ea68a19c2d46a931$var$domEventName$jscomp$inline_1669, "on" + $ea68a19c2d46a931$var$capitalizedEvent$jscomp$inline_1670);
}
$ea68a19c2d46a931$var$registerSimpleEvent($ea68a19c2d46a931$var$ANIMATION_END, "onAnimationEnd");
$ea68a19c2d46a931$var$registerSimpleEvent($ea68a19c2d46a931$var$ANIMATION_ITERATION, "onAnimationIteration");
$ea68a19c2d46a931$var$registerSimpleEvent($ea68a19c2d46a931$var$ANIMATION_START, "onAnimationStart");
$ea68a19c2d46a931$var$registerSimpleEvent("dblclick", "onDoubleClick");
$ea68a19c2d46a931$var$registerSimpleEvent("focusin", "onFocus");
$ea68a19c2d46a931$var$registerSimpleEvent("focusout", "onBlur");
$ea68a19c2d46a931$var$registerSimpleEvent($ea68a19c2d46a931$var$TRANSITION_RUN, "onTransitionRun");
$ea68a19c2d46a931$var$registerSimpleEvent($ea68a19c2d46a931$var$TRANSITION_START, "onTransitionStart");
$ea68a19c2d46a931$var$registerSimpleEvent($ea68a19c2d46a931$var$TRANSITION_CANCEL, "onTransitionCancel");
$ea68a19c2d46a931$var$registerSimpleEvent($ea68a19c2d46a931$var$TRANSITION_END, "onTransitionEnd");
$ea68a19c2d46a931$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$ea68a19c2d46a931$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$ea68a19c2d46a931$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$ea68a19c2d46a931$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$ea68a19c2d46a931$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$ea68a19c2d46a931$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$ea68a19c2d46a931$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$ea68a19c2d46a931$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$ea68a19c2d46a931$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$ea68a19c2d46a931$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $ea68a19c2d46a931$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $ea68a19c2d46a931$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($ea68a19c2d46a931$var$mediaEventTypes));
function $ea68a19c2d46a931$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $ea68a19c2d46a931$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $ea68a19c2d46a931$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $ea68a19c2d46a931$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$ea68a19c2d46a931$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$ea68a19c2d46a931$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($ea68a19c2d46a931$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $ea68a19c2d46a931$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $ea68a19c2d46a931$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $ea68a19c2d46a931$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $ea68a19c2d46a931$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$ea68a19c2d46a931$var$listeningMarker]) {
        rootContainerElement[$ea68a19c2d46a931$var$listeningMarker] = !0;
        $ea68a19c2d46a931$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($ea68a19c2d46a931$var$nonDelegatedEvents.has(domEventName) || $ea68a19c2d46a931$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $ea68a19c2d46a931$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$ea68a19c2d46a931$var$listeningMarker] || (ownerDocument[$ea68a19c2d46a931$var$listeningMarker] = !0, $ea68a19c2d46a931$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $ea68a19c2d46a931$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($ea68a19c2d46a931$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $ea68a19c2d46a931$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $ea68a19c2d46a931$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $ea68a19c2d46a931$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$ea68a19c2d46a931$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $ea68a19c2d46a931$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $ea68a19c2d46a931$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $ea68a19c2d46a931$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $ea68a19c2d46a931$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $ea68a19c2d46a931$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $ea68a19c2d46a931$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $ea68a19c2d46a931$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $ea68a19c2d46a931$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $ea68a19c2d46a931$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $ea68a19c2d46a931$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $ea68a19c2d46a931$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $ea68a19c2d46a931$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $ea68a19c2d46a931$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $ea68a19c2d46a931$var$SyntheticTouchEvent;
                        break;
                    case $ea68a19c2d46a931$var$ANIMATION_END:
                    case $ea68a19c2d46a931$var$ANIMATION_ITERATION:
                    case $ea68a19c2d46a931$var$ANIMATION_START:
                        SyntheticEventCtor = $ea68a19c2d46a931$var$SyntheticAnimationEvent;
                        break;
                    case $ea68a19c2d46a931$var$TRANSITION_END:
                        SyntheticEventCtor = $ea68a19c2d46a931$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $ea68a19c2d46a931$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $ea68a19c2d46a931$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $ea68a19c2d46a931$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $ea68a19c2d46a931$var$SyntheticPointerEvent;
                        break;
                    case "submit":
                        SyntheticEventCtor = $ea68a19c2d46a931$var$SyntheticSubmitEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $ea68a19c2d46a931$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $ea68a19c2d46a931$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($ea68a19c2d46a931$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                SyntheticEventCtor = "mouseover" === domEventName || "pointerover" === domEventName;
                reactName = "mouseout" === domEventName || "pointerout" === domEventName;
                if (SyntheticEventCtor && nativeEvent !== $ea68a19c2d46a931$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($ea68a19c2d46a931$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$ea68a19c2d46a931$var$internalContainerInstanceKey])) break a;
                if (reactName || SyntheticEventCtor) {
                    reactEventType = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (SyntheticEventCtor = nativeEventTarget.ownerDocument) ? SyntheticEventCtor.defaultView || SyntheticEventCtor.parentWindow : window;
                    if (reactName) {
                        if (SyntheticEventCtor = nativeEvent.relatedTarget || nativeEvent.toElement, reactName = targetInst, SyntheticEventCtor = SyntheticEventCtor ? $ea68a19c2d46a931$var$getClosestInstanceFromNode(SyntheticEventCtor) : null, null !== SyntheticEventCtor && (accumulateTargetOnly = $ea68a19c2d46a931$var$getNearestMountedFiber(SyntheticEventCtor), inCapturePhase = SyntheticEventCtor.tag, SyntheticEventCtor !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) SyntheticEventCtor = null;
                    } else reactName = null, SyntheticEventCtor = targetInst;
                    if (reactName !== SyntheticEventCtor) {
                        inCapturePhase = $ea68a19c2d46a931$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $ea68a19c2d46a931$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == reactName ? reactEventType : $ea68a19c2d46a931$var$getNodeFromInstance(reactName);
                        lastHostComponent = null == SyntheticEventCtor ? reactEventType : $ea68a19c2d46a931$var$getNodeFromInstance(SyntheticEventCtor);
                        reactEventType = new inCapturePhase(_instance, instance + "leave", reactName, nativeEvent, nativeEventTarget);
                        reactEventType.target = accumulateTargetOnly;
                        reactEventType.relatedTarget = lastHostComponent;
                        _instance = null;
                        $ea68a19c2d46a931$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", SyntheticEventCtor, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        inCapturePhase = reactName && SyntheticEventCtor ? $ea68a19c2d46a931$var$getLowestCommonAncestor(reactName, SyntheticEventCtor, $ea68a19c2d46a931$var$getParent) : null;
                        null !== reactName && $ea68a19c2d46a931$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactEventType, reactName, inCapturePhase, !1);
                        null !== SyntheticEventCtor && null !== accumulateTargetOnly && $ea68a19c2d46a931$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, SyntheticEventCtor, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $ea68a19c2d46a931$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $ea68a19c2d46a931$var$getTargetInstForChangeEvent;
                else if ($ea68a19c2d46a931$var$isTextInputElement(reactName)) {
                    if ($ea68a19c2d46a931$var$isInputEventSupported) getTargetInstFunc = $ea68a19c2d46a931$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $ea68a19c2d46a931$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $ea68a19c2d46a931$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $ea68a19c2d46a931$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $ea68a19c2d46a931$var$getTargetInstForChangeEvent) : getTargetInstFunc = $ea68a19c2d46a931$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $ea68a19c2d46a931$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
            }
            handleEventFunc = targetInst ? $ea68a19c2d46a931$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($ea68a19c2d46a931$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $ea68a19c2d46a931$var$activeElement = handleEventFunc, $ea68a19c2d46a931$var$activeElementInst = targetInst, $ea68a19c2d46a931$var$lastSelection = null;
                    break;
                case "focusout":
                    $ea68a19c2d46a931$var$lastSelection = $ea68a19c2d46a931$var$activeElementInst = $ea68a19c2d46a931$var$activeElement = null;
                    break;
                case "mousedown":
                    $ea68a19c2d46a931$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $ea68a19c2d46a931$var$mouseDown = !1;
                    $ea68a19c2d46a931$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($ea68a19c2d46a931$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $ea68a19c2d46a931$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($ea68a19c2d46a931$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $ea68a19c2d46a931$var$isComposing ? $ea68a19c2d46a931$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($ea68a19c2d46a931$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($ea68a19c2d46a931$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $ea68a19c2d46a931$var$isComposing && (fallbackData = $ea68a19c2d46a931$var$getData()) : ($ea68a19c2d46a931$var$root = nativeEventTarget, $ea68a19c2d46a931$var$startText = "value" in $ea68a19c2d46a931$var$root ? $ea68a19c2d46a931$var$root.value : $ea68a19c2d46a931$var$root.textContent, $ea68a19c2d46a931$var$isComposing = !0)), handleEventFunc = $ea68a19c2d46a931$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $ea68a19c2d46a931$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $ea68a19c2d46a931$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $ea68a19c2d46a931$var$canUseTextInputEvent ? $ea68a19c2d46a931$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $ea68a19c2d46a931$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $ea68a19c2d46a931$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $ea68a19c2d46a931$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $ea68a19c2d46a931$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $ea68a19c2d46a931$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $ea68a19c2d46a931$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $ea68a19c2d46a931$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $ea68a19c2d46a931$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($ea68a19c2d46a931$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $ea68a19c2d46a931$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($ea68a19c2d46a931$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $ea68a19c2d46a931$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $ea68a19c2d46a931$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $ea68a19c2d46a931$var$getListener(target, registrationName), null != stateNode && listeners.unshift($ea68a19c2d46a931$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $ea68a19c2d46a931$var$getListener(target, registrationName), null != stateNode && listeners.push($ea68a19c2d46a931$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $ea68a19c2d46a931$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $ea68a19c2d46a931$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $ea68a19c2d46a931$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($ea68a19c2d46a931$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($ea68a19c2d46a931$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $ea68a19c2d46a931$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $ea68a19c2d46a931$var$normalizeMarkupForTextOrAttribute(clientText);
    return $ea68a19c2d46a931$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $ea68a19c2d46a931$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            if ("string" === typeof value) "body" === tag || "textarea" === tag && "" === value || $ea68a19c2d46a931$var$setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) "body" !== tag && $ea68a19c2d46a931$var$setTextContent(domElement, "" + value);
            else return;
            break;
        case "className":
            $ea68a19c2d46a931$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $ea68a19c2d46a931$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $ea68a19c2d46a931$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $ea68a19c2d46a931$var$setValueForStyles(domElement, value, prevValue);
            return;
        case "data":
            if ("object" !== tag) {
                $ea68a19c2d46a931$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $ea68a19c2d46a931$var$sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $ea68a19c2d46a931$var$setProp(domElement, tag, "name", props.name, props, null), $ea68a19c2d46a931$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $ea68a19c2d46a931$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $ea68a19c2d46a931$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($ea68a19c2d46a931$var$setProp(domElement, tag, "encType", props.encType, props, null), $ea68a19c2d46a931$var$setProp(domElement, tag, "method", props.method, props, null), $ea68a19c2d46a931$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $ea68a19c2d46a931$var$sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $ea68a19c2d46a931$var$noop$1);
            return;
        case "onScroll":
            null != value && $ea68a19c2d46a931$var$listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && $ea68a19c2d46a931$var$listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $ea68a19c2d46a931$var$sanitizeURL(value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "credentialless":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $ea68a19c2d46a931$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $ea68a19c2d46a931$var$listenToNonDelegatedEvent("toggle", domElement);
            $ea68a19c2d46a931$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $ea68a19c2d46a931$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $ea68a19c2d46a931$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $ea68a19c2d46a931$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $ea68a19c2d46a931$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $ea68a19c2d46a931$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $ea68a19c2d46a931$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $ea68a19c2d46a931$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $ea68a19c2d46a931$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $ea68a19c2d46a931$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $ea68a19c2d46a931$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $ea68a19c2d46a931$var$aliases.get(key) || key, $ea68a19c2d46a931$var$setValueForAttribute(domElement, key, value);
            else return;
    }
    $ea68a19c2d46a931$var$viewTransitionMutationContext = !0;
}
function $ea68a19c2d46a931$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $ea68a19c2d46a931$var$setValueForStyles(domElement, value, prevValue);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "children":
            if ("string" === typeof value) $ea68a19c2d46a931$var$setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) $ea68a19c2d46a931$var$setTextContent(domElement, "" + value);
            else return;
            break;
        case "onScroll":
            null != value && $ea68a19c2d46a931$var$listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && $ea68a19c2d46a931$var$listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "onClick":
            null != value && (domElement.onclick = $ea68a19c2d46a931$var$noop$1);
            return;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            return;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!$ea68a19c2d46a931$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), prevValue = key.slice(2, props ? key.length - 7 : void 0), tag = domElement[$ea68a19c2d46a931$var$internalPropsKey] || null, tag = null != tag ? tag[key] : null, "function" === typeof tag && domElement.removeEventListener(prevValue, tag, props), "function" === typeof value)) {
                    "function" !== typeof tag && null !== tag && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(prevValue, value, props);
                    break a;
                }
                $ea68a19c2d46a931$var$viewTransitionMutationContext = !0;
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $ea68a19c2d46a931$var$setValueForAttribute(domElement, key, value);
            }
            return;
    }
    $ea68a19c2d46a931$var$viewTransitionMutationContext = !0;
}
function $ea68a19c2d46a931$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $ea68a19c2d46a931$var$listenToNonDelegatedEvent("error", domElement);
            $ea68a19c2d46a931$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(137, tag));
                    default:
                        $ea68a19c2d46a931$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $ea68a19c2d46a931$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $ea68a19c2d46a931$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $ea68a19c2d46a931$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$204 = props[hasSrc];
                if (null != propValue$204) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$204;
                        break;
                    case "type":
                        propValue = propValue$204;
                        break;
                    case "checked":
                        checked = propValue$204;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$204;
                        break;
                    case "value":
                        propKey = propValue$204;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$204;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$204) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $ea68a19c2d46a931$var$setProp(domElement, tag, hasSrc, propValue$204, props, null);
                }
            }
            $ea68a19c2d46a931$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $ea68a19c2d46a931$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $ea68a19c2d46a931$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $ea68a19c2d46a931$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $ea68a19c2d46a931$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $ea68a19c2d46a931$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(91));
                    break;
                default:
                    $ea68a19c2d46a931$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $ea68a19c2d46a931$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $ea68a19c2d46a931$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $ea68a19c2d46a931$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $ea68a19c2d46a931$var$listenToNonDelegatedEvent("toggle", domElement);
            $ea68a19c2d46a931$var$listenToNonDelegatedEvent("cancel", domElement);
            $ea68a19c2d46a931$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $ea68a19c2d46a931$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $ea68a19c2d46a931$var$mediaEventTypes.length; hasSrc++)$ea68a19c2d46a931$var$listenToNonDelegatedEvent($ea68a19c2d46a931$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $ea68a19c2d46a931$var$listenToNonDelegatedEvent("error", domElement);
            $ea68a19c2d46a931$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $ea68a19c2d46a931$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $ea68a19c2d46a931$var$listenToNonDelegatedEvent("error", domElement), $ea68a19c2d46a931$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(137, tag));
                default:
                    $ea68a19c2d46a931$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($ea68a19c2d46a931$var$isCustomElement(tag)) {
                for(propValue$204 in props)props.hasOwnProperty(propValue$204) && (hasSrc = props[propValue$204], void 0 !== hasSrc && $ea68a19c2d46a931$var$setPropOnCustomElement(domElement, tag, propValue$204, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $ea68a19c2d46a931$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
var $ea68a19c2d46a931$var$emptyProps = {};
function $ea68a19c2d46a931$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $ea68a19c2d46a931$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$221 in nextProps){
                var propKey = nextProps[propKey$221];
                lastProp = lastProps[propKey$221];
                if (nextProps.hasOwnProperty(propKey$221) && (null != propKey || null != lastProp)) switch(propKey$221){
                    case "type":
                        propKey !== lastProp && ($ea68a19c2d46a931$var$viewTransitionMutationContext = !0);
                        type = propKey;
                        break;
                    case "name":
                        propKey !== lastProp && ($ea68a19c2d46a931$var$viewTransitionMutationContext = !0);
                        name = propKey;
                        break;
                    case "checked":
                        propKey !== lastProp && ($ea68a19c2d46a931$var$viewTransitionMutationContext = !0);
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        propKey !== lastProp && ($ea68a19c2d46a931$var$viewTransitionMutationContext = !0);
                        defaultChecked = propKey;
                        break;
                    case "value":
                        propKey !== lastProp && ($ea68a19c2d46a931$var$viewTransitionMutationContext = !0);
                        value = propKey;
                        break;
                    case "defaultValue":
                        propKey !== lastProp && ($ea68a19c2d46a931$var$viewTransitionMutationContext = !0);
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $ea68a19c2d46a931$var$setProp(domElement, tag, propKey$221, propKey, nextProps, lastProp);
                }
            }
            $ea68a19c2d46a931$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$221 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $ea68a19c2d46a931$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    type !== lastDefaultValue && ($ea68a19c2d46a931$var$viewTransitionMutationContext = !0);
                    propKey$221 = type;
                    break;
                case "defaultValue":
                    type !== lastDefaultValue && ($ea68a19c2d46a931$var$viewTransitionMutationContext = !0);
                    defaultValue = type;
                    break;
                case "multiple":
                    type !== lastDefaultValue && ($ea68a19c2d46a931$var$viewTransitionMutationContext = !0), value = type;
                default:
                    type !== lastDefaultValue && $ea68a19c2d46a931$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$221 ? $ea68a19c2d46a931$var$updateOptions(domElement, !!lastProps, propKey$221, !1) : !!nextProps !== !!lastProps && (null != tag ? $ea68a19c2d46a931$var$updateOptions(domElement, !!lastProps, tag, !0) : $ea68a19c2d46a931$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$221 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $ea68a19c2d46a931$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    name !== type && ($ea68a19c2d46a931$var$viewTransitionMutationContext = !0);
                    propKey$221 = name;
                    break;
                case "defaultValue":
                    name !== type && ($ea68a19c2d46a931$var$viewTransitionMutationContext = !0);
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $ea68a19c2d46a931$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $ea68a19c2d46a931$var$updateTextarea(domElement, propKey$221, propKey);
            return;
        case "option":
            for(var propKey$237 in lastProps)if (propKey$221 = lastProps[propKey$237], lastProps.hasOwnProperty(propKey$237) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$237)) switch(propKey$237){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $ea68a19c2d46a931$var$setProp(domElement, tag, propKey$237, null, nextProps, propKey$221);
            }
            for(lastDefaultValue in nextProps)if (propKey$221 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    propKey$221 !== propKey && ($ea68a19c2d46a931$var$viewTransitionMutationContext = !0);
                    domElement.selected = propKey$221 && "function" !== typeof propKey$221 && "symbol" !== typeof propKey$221;
                    break;
                default:
                    $ea68a19c2d46a931$var$setProp(domElement, tag, lastDefaultValue, propKey$221, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$242 in lastProps)propKey$221 = lastProps[propKey$242], lastProps.hasOwnProperty(propKey$242) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$242) && $ea68a19c2d46a931$var$setProp(domElement, tag, propKey$242, null, nextProps, propKey$221);
            for(checked in nextProps)if (propKey$221 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$221) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $ea68a19c2d46a931$var$setProp(domElement, tag, checked, propKey$221, nextProps, propKey);
            }
            return;
        default:
            if ($ea68a19c2d46a931$var$isCustomElement(tag)) {
                for(var propKey$247 in lastProps)propKey$221 = lastProps[propKey$247], lastProps.hasOwnProperty(propKey$247) && void 0 !== propKey$221 && !nextProps.hasOwnProperty(propKey$247) && $ea68a19c2d46a931$var$setPropOnCustomElement(domElement, tag, propKey$247, void 0, nextProps, propKey$221);
                for(defaultChecked in nextProps)propKey$221 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$221 === propKey || void 0 === propKey$221 && void 0 === propKey || $ea68a19c2d46a931$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$221, nextProps, propKey);
                return;
            }
    }
    for(var propKey$252 in lastProps)propKey$221 = lastProps[propKey$252], lastProps.hasOwnProperty(propKey$252) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$252) && $ea68a19c2d46a931$var$setProp(domElement, tag, propKey$252, null, nextProps, propKey$221);
    for(lastProp in nextProps)propKey$221 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$221 === propKey || null == propKey$221 && null == propKey || $ea68a19c2d46a931$var$setProp(domElement, tag, lastProp, propKey$221, nextProps, propKey);
}
function $ea68a19c2d46a931$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $ea68a19c2d46a931$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $ea68a19c2d46a931$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $ea68a19c2d46a931$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $ea68a19c2d46a931$var$eventsEnabled = null, $ea68a19c2d46a931$var$selectionInformation = null;
function $ea68a19c2d46a931$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $ea68a19c2d46a931$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $ea68a19c2d46a931$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $ea68a19c2d46a931$var$createHoistableInstance(type, props, rootContainerInstance, internalInstanceHandle) {
    rootContainerInstance = $ea68a19c2d46a931$var$getOwnerDocumentFromRootContainer(rootContainerInstance).createElement(type);
    rootContainerInstance[$ea68a19c2d46a931$var$internalInstanceKey] = internalInstanceHandle;
    rootContainerInstance[$ea68a19c2d46a931$var$internalPropsKey] = props;
    $ea68a19c2d46a931$var$setInitialProperties(rootContainerInstance, type, props);
    $ea68a19c2d46a931$var$markNodeAsHoistable(rootContainerInstance);
    return rootContainerInstance;
}
function $ea68a19c2d46a931$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $ea68a19c2d46a931$var$currentPopstateTransitionEvent = null;
function $ea68a19c2d46a931$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $ea68a19c2d46a931$var$currentPopstateTransitionEvent) return !1;
        $ea68a19c2d46a931$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $ea68a19c2d46a931$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $ea68a19c2d46a931$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $ea68a19c2d46a931$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $ea68a19c2d46a931$var$localPromise = "function" === typeof Promise ? Promise : void 0, $ea68a19c2d46a931$var$localRequestAnimationFrame = "function" === typeof requestAnimationFrame ? requestAnimationFrame : $ea68a19c2d46a931$var$scheduleTimeout, $ea68a19c2d46a931$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $ea68a19c2d46a931$var$localPromise ? function(callback) {
    return $ea68a19c2d46a931$var$localPromise.resolve(null).then(callback).catch($ea68a19c2d46a931$var$handleErrorInNextTick);
} : $ea68a19c2d46a931$var$scheduleTimeout;
function $ea68a19c2d46a931$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $ea68a19c2d46a931$var$isSingletonScope(type) {
    return "head" === type;
}
function $ea68a19c2d46a931$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $ea68a19c2d46a931$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $ea68a19c2d46a931$var$clearSingletonPreambleContribution(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $ea68a19c2d46a931$var$clearSingletonPreambleContribution(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$ea68a19c2d46a931$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $ea68a19c2d46a931$var$clearSingletonPreambleContribution(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $ea68a19c2d46a931$var$retryIfBlockedOn(hydrationInstance);
}
function $ea68a19c2d46a931$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $ea68a19c2d46a931$var$applyViewTransitionName(instance, name, className) {
    name = CSS.escape(name) !== name ? "r-" + btoa(name).replace(/=/g, "") : name;
    instance.style.viewTransitionName = name;
    null != className && (instance.style.viewTransitionClass = className);
    className = getComputedStyle(instance);
    if ("inline" === className.display) {
        name = instance.getClientRects();
        if (1 === name.length) var JSCompiler_inline_result = 1;
        else for(var i = JSCompiler_inline_result = 0; i < name.length; i++){
            var rect = name[i];
            0 < rect.width && 0 < rect.height && JSCompiler_inline_result++;
        }
        1 === JSCompiler_inline_result && (instance = instance.style, instance.display = 1 === name.length ? "inline-block" : "block", instance.marginTop = "-" + className.paddingTop, instance.marginBottom = "-" + className.paddingBottom);
    }
}
function $ea68a19c2d46a931$var$restoreViewTransitionName(instance, props) {
    instance = instance.style;
    props = props.style;
    var viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionName") ? props.viewTransitionName : props.hasOwnProperty("view-transition-name") ? props["view-transition-name"] : null : null;
    instance.viewTransitionName = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionClass") ? props.viewTransitionClass : props.hasOwnProperty("view-transition-class") ? props["view-transition-class"] : null : null;
    instance.viewTransitionClass = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    "inline-block" === instance.display && (null == props ? instance.display = instance.margin = "" : (viewTransitionName = props.display, instance.display = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, viewTransitionName = props.margin, null != viewTransitionName ? instance.margin = viewTransitionName : (viewTransitionName = props.hasOwnProperty("marginTop") ? props.marginTop : props["margin-top"], instance.marginTop = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, props = props.hasOwnProperty("marginBottom") ? props.marginBottom : props["margin-bottom"], instance.marginBottom = null == props || "boolean" === typeof props ? "" : props)));
}
function $ea68a19c2d46a931$var$createMeasurement(rect, computedStyle, element) {
    element = element.ownerDocument.defaultView;
    return {
        rect: rect,
        abs: "absolute" === computedStyle.position || "fixed" === computedStyle.position,
        clip: "none" !== computedStyle.clipPath || "visible" !== computedStyle.overflow || "none" !== computedStyle.filter || "none" !== computedStyle.mask || "none" !== computedStyle.mask || "0px" !== computedStyle.borderRadius,
        view: 0 <= rect.bottom && 0 <= rect.right && rect.top <= element.innerHeight && rect.left <= element.innerWidth
    };
}
function $ea68a19c2d46a931$var$measureInstance(instance) {
    var rect = instance.getBoundingClientRect(), computedStyle = getComputedStyle(instance);
    return $ea68a19c2d46a931$var$createMeasurement(rect, computedStyle, instance);
}
function $ea68a19c2d46a931$var$measureClonedInstance(instance) {
    var measuredRect = instance.getBoundingClientRect();
    measuredRect = new DOMRect(measuredRect.x + 2e4, measuredRect.y + 2e4, measuredRect.width, measuredRect.height);
    var computedStyle = getComputedStyle(instance);
    return $ea68a19c2d46a931$var$createMeasurement(measuredRect, computedStyle, instance);
}
function $ea68a19c2d46a931$var$forceLayout(ownerDocument) {
    return ownerDocument.documentElement.clientHeight;
}
function $ea68a19c2d46a931$var$waitForImageToLoad(resolve) {
    this.addEventListener("load", resolve);
    this.addEventListener("error", resolve);
}
function $ea68a19c2d46a931$var$startViewTransition(suspendedState, rootContainer, transitionTypes, mutationCallback, layoutCallback, afterMutationCallback, spawnedWorkCallback, passiveCallback, errorCallback) {
    var ownerDocument = 9 === rootContainer.nodeType ? rootContainer : rootContainer.ownerDocument;
    try {
        var transition = ownerDocument.startViewTransition({
            update: function() {
                var ownerWindow = ownerDocument.defaultView, pendingNavigation = ownerWindow.navigation && ownerWindow.navigation.transition, previousFontLoadingStatus = ownerDocument.fonts.status;
                mutationCallback();
                var blockingPromises = [];
                "loaded" === previousFontLoadingStatus && ($ea68a19c2d46a931$var$forceLayout(ownerDocument), "loading" === ownerDocument.fonts.status && blockingPromises.push(ownerDocument.fonts.ready));
                previousFontLoadingStatus = blockingPromises.length;
                if (null !== suspendedState) for(var suspenseyImages = suspendedState.suspenseyImages, imgBytes = 0, i = 0; i < suspenseyImages.length; i++){
                    var suspenseyImage = suspenseyImages[i];
                    if (!suspenseyImage.complete) {
                        var rect = suspenseyImage.getBoundingClientRect();
                        if (0 < rect.bottom && 0 < rect.right && rect.top < ownerWindow.innerHeight && rect.left < ownerWindow.innerWidth) {
                            imgBytes += $ea68a19c2d46a931$var$estimateImageBytes(suspenseyImage);
                            if (imgBytes > $ea68a19c2d46a931$var$estimatedBytesWithinLimit) {
                                blockingPromises.length = previousFontLoadingStatus;
                                break;
                            }
                            suspenseyImage = new Promise($ea68a19c2d46a931$var$waitForImageToLoad.bind(suspenseyImage));
                            blockingPromises.push(suspenseyImage);
                        }
                    }
                }
                if (0 < blockingPromises.length) return ownerWindow = Promise.race([
                    Promise.all(blockingPromises),
                    new Promise(function(resolve) {
                        return setTimeout(resolve, 500);
                    })
                ]).then(layoutCallback, layoutCallback), (pendingNavigation ? Promise.allSettled([
                    pendingNavigation.finished,
                    ownerWindow
                ]) : ownerWindow).then(afterMutationCallback, afterMutationCallback);
                layoutCallback();
                if (pendingNavigation) return pendingNavigation.finished.then(afterMutationCallback, afterMutationCallback);
                afterMutationCallback();
            },
            types: transitionTypes
        });
        ownerDocument.__reactViewTransition = transition;
        var viewTransitionAnimations = [];
        transition.ready.then(function() {
            for(var animations = ownerDocument.documentElement.getAnimations({
                subtree: !0
            }), i = 0; i < animations.length; i++){
                var animation = animations[i], effect = animation.effect, pseudoElement = effect.pseudoElement;
                if (null != pseudoElement && pseudoElement.startsWith("::view-transition")) {
                    viewTransitionAnimations.push(animation);
                    animation = effect.getKeyframes();
                    for(var height = pseudoElement = void 0, unchangedDimensions = !0, j = 0; j < animation.length; j++){
                        var keyframe = animation[j], w = keyframe.width;
                        if (void 0 === pseudoElement) pseudoElement = w;
                        else if (pseudoElement !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        w = keyframe.height;
                        if (void 0 === height) height = w;
                        else if (height !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        delete keyframe.width;
                        delete keyframe.height;
                        "none" === keyframe.transform && delete keyframe.transform;
                    }
                    unchangedDimensions && void 0 !== pseudoElement && void 0 !== height && (effect.setKeyframes(animation), unchangedDimensions = getComputedStyle(effect.target, effect.pseudoElement), unchangedDimensions.width !== pseudoElement || unchangedDimensions.height !== height) && (unchangedDimensions = animation[0], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, unchangedDimensions = animation[animation.length - 1], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, effect.setKeyframes(animation));
                }
            }
            spawnedWorkCallback();
        }, function(error) {
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            try {
                if ("object" === typeof error && null !== error) switch(error.name){
                    case "InvalidStateError":
                        if ("View transition was skipped because document visibility state is hidden." === error.message || "Skipping view transition because document visibility state has become hidden." === error.message || "Skipping view transition because viewport size changed." === error.message || "Transition was aborted because of invalid state" === error.message) error = null;
                }
                null !== error && errorCallback(error);
            } finally{
                mutationCallback(), layoutCallback(), spawnedWorkCallback();
            }
        });
        transition.finished.finally(function() {
            for(var i = 0; i < viewTransitionAnimations.length; i++)viewTransitionAnimations[i].cancel();
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            passiveCallback();
        });
        return transition;
    } catch (x) {
        return mutationCallback(), layoutCallback(), spawnedWorkCallback(), null;
    }
}
function $ea68a19c2d46a931$var$ViewTransitionPseudoElement(pseudo, name) {
    this._scope = document.documentElement;
    this._selector = "::view-transition-" + pseudo + "(" + name + ")";
}
$ea68a19c2d46a931$var$ViewTransitionPseudoElement.prototype.animate = function(keyframes, options) {
    options = "number" === typeof options ? {
        duration: options
    } : $ea68a19c2d46a931$var$assign({}, options);
    options.pseudoElement = this._selector;
    return this._scope.animate(keyframes, options);
};
$ea68a19c2d46a931$var$ViewTransitionPseudoElement.prototype.getAnimations = function() {
    for(var scope = this._scope, selector = this._selector, animations = scope.getAnimations({
        subtree: !0
    }), result = [], i = 0; i < animations.length; i++){
        var effect = animations[i].effect;
        null !== effect && effect.target === scope && effect.pseudoElement === selector && result.push(animations[i]);
    }
    return result;
};
$ea68a19c2d46a931$var$ViewTransitionPseudoElement.prototype.getComputedStyle = function() {
    return getComputedStyle(this._scope, this._selector);
};
function $ea68a19c2d46a931$var$createViewTransitionInstance(name) {
    return {
        name: name,
        group: new $ea68a19c2d46a931$var$ViewTransitionPseudoElement("group", name),
        imagePair: new $ea68a19c2d46a931$var$ViewTransitionPseudoElement("image-pair", name),
        old: new $ea68a19c2d46a931$var$ViewTransitionPseudoElement("old", name),
        new: new $ea68a19c2d46a931$var$ViewTransitionPseudoElement("new", name)
    };
}
function $ea68a19c2d46a931$var$FragmentInstance(fragmentFiber) {
    this._fragmentFiber = fragmentFiber;
    this._observers = this._eventListeners = null;
}
$ea68a19c2d46a931$var$FragmentInstance.prototype.addEventListener = function(type, listener, optionsOrUseCapture) {
    var signal = null, cleanup = null;
    if (null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && (signal = optionsOrUseCapture.signal || null, null !== signal && signal.aborted)) return;
    null === this._eventListeners && (this._eventListeners = []);
    var listeners = this._eventListeners;
    if (-1 === $ea68a19c2d46a931$var$indexOfEventListener(listeners, type, listener, optionsOrUseCapture)) {
        var fragmentInstance = this, attachedListener = listener;
        null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && !0 === optionsOrUseCapture.once && (attachedListener = function(event) {
            fragmentInstance.removeEventListener(type, listener, optionsOrUseCapture);
            "function" === typeof listener ? listener.call(this, event) : listener.handleEvent(event);
        });
        null !== signal && (cleanup = fragmentInstance.removeEventListener.bind(fragmentInstance, type, listener, optionsOrUseCapture), signal.addEventListener("abort", cleanup, {
            once: !0
        }), cleanup = signal.removeEventListener.bind(signal, "abort", cleanup));
        signal = $ea68a19c2d46a931$var$getAttachOptions(optionsOrUseCapture);
        listeners.push({
            type: type,
            listener: listener,
            optionsOrUseCapture: optionsOrUseCapture,
            attachedListener: attachedListener,
            cleanup: cleanup
        });
        $ea68a19c2d46a931$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $ea68a19c2d46a931$var$addEventListenerToChild, type, attachedListener, signal);
    }
    this._eventListeners = listeners;
};
function $ea68a19c2d46a931$var$addEventListenerToChild(child, type, listener, optionsOrUseCapture) {
    $ea68a19c2d46a931$var$getInstanceFromHostFiber(child).addEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
$ea68a19c2d46a931$var$FragmentInstance.prototype.removeEventListener = function(type, listener, optionsOrUseCapture) {
    var listeners = this._eventListeners;
    if (null !== listeners && (listener = $ea68a19c2d46a931$var$indexOfEventListener(listeners, type, listener, optionsOrUseCapture), -1 !== listener)) {
        var _listeners$index = listeners[listener];
        optionsOrUseCapture = _listeners$index.attachedListener;
        var cleanup = _listeners$index.cleanup;
        _listeners$index = $ea68a19c2d46a931$var$getAttachOptions(_listeners$index.optionsOrUseCapture);
        $ea68a19c2d46a931$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $ea68a19c2d46a931$var$removeEventListenerFromChild, type, optionsOrUseCapture, _listeners$index);
        listeners.splice(listener, 1);
        null !== cleanup && cleanup();
    }
};
function $ea68a19c2d46a931$var$removeEventListenerFromChild(child, type, listener, optionsOrUseCapture) {
    $ea68a19c2d46a931$var$getInstanceFromHostFiber(child).removeEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
function $ea68a19c2d46a931$var$getAttachOptions(opts) {
    return null != opts && "boolean" !== typeof opts && (!0 === opts.once || opts.signal instanceof AbortSignal) ? {
        capture: opts.capture,
        passive: opts.passive
    } : opts;
}
function $ea68a19c2d46a931$var$normalizeListenerOptions(opts) {
    return null == opts ? "c=0" : "boolean" === typeof opts ? "c=" + (opts ? "1" : "0") : "c=" + (opts.capture ? "1" : "0");
}
function $ea68a19c2d46a931$var$indexOfEventListener(eventListeners, type, listener, optionsOrUseCapture) {
    if (0 === eventListeners.length) return -1;
    optionsOrUseCapture = $ea68a19c2d46a931$var$normalizeListenerOptions(optionsOrUseCapture);
    for(var i = 0; i < eventListeners.length; i++){
        var item = eventListeners[i];
        if (item.type === type && item.listener === listener && $ea68a19c2d46a931$var$normalizeListenerOptions(item.optionsOrUseCapture) === optionsOrUseCapture) return i;
    }
    return -1;
}
$ea68a19c2d46a931$var$FragmentInstance.prototype.dispatchEvent = function(event) {
    var parentHostFiber = $ea68a19c2d46a931$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return !0;
    parentHostFiber = $ea68a19c2d46a931$var$getInstanceFromHostFiber(parentHostFiber);
    var eventListeners = this._eventListeners;
    if (null !== eventListeners && 0 < eventListeners.length || !event.bubbles) {
        var temp = 9 === parentHostFiber.nodeType ? parentHostFiber.createComment("") : document.createTextNode("");
        if (eventListeners) for(var i = 0; i < eventListeners.length; i++){
            var _eventListeners$i = eventListeners[i];
            temp.addEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, $ea68a19c2d46a931$var$getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        }
        parentHostFiber.appendChild(temp);
        event = temp.dispatchEvent(event);
        if (eventListeners) for(i = 0; i < eventListeners.length; i++)_eventListeners$i = eventListeners[i], temp.removeEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, $ea68a19c2d46a931$var$getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        parentHostFiber.removeChild(temp);
        return event;
    }
    return parentHostFiber.dispatchEvent(event);
};
$ea68a19c2d46a931$var$FragmentInstance.prototype.focus = function(focusOptions) {
    $ea68a19c2d46a931$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, $ea68a19c2d46a931$var$setFocusOnFiberIfFocusable, focusOptions, void 0, void 0);
};
function $ea68a19c2d46a931$var$setFocusOnFiberIfFocusable(fiber, focusOptions) {
    if (6 === fiber.tag) return !1;
    fiber = $ea68a19c2d46a931$var$getInstanceFromHostFiber(fiber);
    return $ea68a19c2d46a931$var$setFocusIfFocusable(fiber, focusOptions);
}
$ea68a19c2d46a931$var$FragmentInstance.prototype.focusLast = function(focusOptions) {
    var children = [];
    $ea68a19c2d46a931$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, $ea68a19c2d46a931$var$collectChildren, children, void 0, void 0);
    for(var i = children.length - 1; 0 <= i && !$ea68a19c2d46a931$var$setFocusOnFiberIfFocusable(children[i], focusOptions); i--);
};
function $ea68a19c2d46a931$var$collectChildren(child, collection) {
    collection.push(child);
    return !1;
}
$ea68a19c2d46a931$var$FragmentInstance.prototype.blur = function() {
    var parentHostFiber = $ea68a19c2d46a931$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    null !== parentHostFiber && (parentHostFiber = $ea68a19c2d46a931$var$getInstanceFromHostFiber(parentHostFiber), parentHostFiber = $ea68a19c2d46a931$var$getOwnerDocumentFromRootContainer(parentHostFiber).activeElement, null !== parentHostFiber && $ea68a19c2d46a931$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $ea68a19c2d46a931$var$blurActiveElementWithinFragment, parentHostFiber, void 0, void 0));
};
function $ea68a19c2d46a931$var$blurActiveElementWithinFragment(child, activeElement) {
    if (6 === child.tag) return !1;
    child = $ea68a19c2d46a931$var$getInstanceFromHostFiber(child);
    return child === activeElement || child.contains(activeElement) ? (activeElement.blur(), !0) : !1;
}
$ea68a19c2d46a931$var$FragmentInstance.prototype.observeUsing = function(observer) {
    null === this._observers && (this._observers = new Set());
    this._observers.add(observer);
    $ea68a19c2d46a931$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $ea68a19c2d46a931$var$observeChild, observer, void 0, void 0);
};
function $ea68a19c2d46a931$var$observeChild(child, observer) {
    if (6 === child.tag) return !1;
    child = $ea68a19c2d46a931$var$getInstanceFromHostFiber(child);
    observer.observe(child);
    return !1;
}
$ea68a19c2d46a931$var$FragmentInstance.prototype.unobserveUsing = function(observer) {
    var observers = this._observers;
    if (null !== observers && observers.has(observer)) {
        observers.delete(observer);
        $ea68a19c2d46a931$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $ea68a19c2d46a931$var$unobserveChild, observer, void 0, void 0);
        for(var i = observers = 0; i < $ea68a19c2d46a931$var$pendingIntersectionUnobserves.length; i++){
            var pending = $ea68a19c2d46a931$var$pendingIntersectionUnobserves[i];
            pending.fragmentInstance === this && pending.observer === observer ? observer.unobserve(pending.instance) : $ea68a19c2d46a931$var$pendingIntersectionUnobserves[observers++] = pending;
        }
        $ea68a19c2d46a931$var$pendingIntersectionUnobserves.length = observers;
    }
};
function $ea68a19c2d46a931$var$unobserveChild(child, observer) {
    if (6 === child.tag) return !1;
    child = $ea68a19c2d46a931$var$getInstanceFromHostFiber(child);
    observer.unobserve(child);
    return !1;
}
var $ea68a19c2d46a931$var$pendingIntersectionUnobserves = [], $ea68a19c2d46a931$var$intersectionUnobserveScheduled = !1;
function $ea68a19c2d46a931$var$schedulePendingIntersectionUnobserve(fragmentInstance, observer, instance) {
    $ea68a19c2d46a931$var$pendingIntersectionUnobserves.push({
        fragmentInstance: fragmentInstance,
        observer: observer,
        instance: instance
    });
    $ea68a19c2d46a931$var$intersectionUnobserveScheduled || ($ea68a19c2d46a931$var$intersectionUnobserveScheduled = !0, $ea68a19c2d46a931$var$requestPostPaintCallback(function() {
        $ea68a19c2d46a931$var$intersectionUnobserveScheduled = !1;
        var pending = $ea68a19c2d46a931$var$pendingIntersectionUnobserves;
        $ea68a19c2d46a931$var$pendingIntersectionUnobserves = [];
        for(var i = 0; i < pending.length; i++){
            var item = pending[i];
            item.observer.unobserve(item.instance);
        }
    }));
}
$ea68a19c2d46a931$var$FragmentInstance.prototype.getClientRects = function() {
    var rects = [];
    $ea68a19c2d46a931$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $ea68a19c2d46a931$var$collectClientRects, rects, void 0, void 0);
    return rects;
};
function $ea68a19c2d46a931$var$collectClientRects(child, rects) {
    if (6 === child.tag) {
        child = child.stateNode;
        var range = child.ownerDocument.createRange();
        range.selectNodeContents(child);
        rects.push.apply(rects, range.getClientRects());
    } else child = $ea68a19c2d46a931$var$getInstanceFromHostFiber(child), rects.push.apply(rects, child.getClientRects());
    return !1;
}
$ea68a19c2d46a931$var$FragmentInstance.prototype.getRootNode = function(getRootNodeOptions) {
    var parentHostFiber = $ea68a19c2d46a931$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    return null === parentHostFiber ? this : $ea68a19c2d46a931$var$getInstanceFromHostFiber(parentHostFiber).getRootNode(getRootNodeOptions);
};
$ea68a19c2d46a931$var$FragmentInstance.prototype.compareDocumentPosition = function(otherNode) {
    var parentHostFiber = $ea68a19c2d46a931$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return Node.DOCUMENT_POSITION_DISCONNECTED;
    var children = [];
    $ea68a19c2d46a931$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $ea68a19c2d46a931$var$collectChildren, children, void 0, void 0);
    var parentHostInstance = $ea68a19c2d46a931$var$getInstanceFromHostFiber(parentHostFiber);
    if (0 === children.length) {
        children = parentHostInstance;
        if ($ea68a19c2d46a931$var$fiberIsPortaledIntoHost(this._fragmentFiber)) {
            a: {
                for(parentHostFiber = this._fragmentFiber.return; null !== parentHostFiber;){
                    if (4 === parentHostFiber.tag) {
                        parentHostFiber = parentHostFiber.stateNode.containerInfo;
                        break a;
                    }
                    if (3 === parentHostFiber.tag || 5 === parentHostFiber.tag || 27 === parentHostFiber.tag) break;
                    parentHostFiber = parentHostFiber.return;
                }
                parentHostFiber = null;
            }
            null != parentHostFiber && (children = parentHostFiber);
        }
        parentHostFiber = this._fragmentFiber;
        var result = parentHostInstance = children.compareDocumentPosition(otherNode);
        children === otherNode ? result = Node.DOCUMENT_POSITION_CONTAINS : parentHostInstance & Node.DOCUMENT_POSITION_CONTAINED_BY && (children = $ea68a19c2d46a931$var$getFragmentInstanceOrTextInstanceSiblings(parentHostFiber)[1], null === children ? result = Node.DOCUMENT_POSITION_PRECEDING : (otherNode = $ea68a19c2d46a931$var$getInstanceFromHostFiber(children).compareDocumentPosition(otherNode), result = 0 === otherNode || otherNode & Node.DOCUMENT_POSITION_FOLLOWING ? Node.DOCUMENT_POSITION_FOLLOWING : Node.DOCUMENT_POSITION_PRECEDING));
        return result |= Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
    }
    parentHostFiber = $ea68a19c2d46a931$var$getInstanceFromHostFiber(children[0]);
    result = $ea68a19c2d46a931$var$getInstanceFromHostFiber(children[children.length - 1]);
    var parentHostInstanceFromDOM = $ea68a19c2d46a931$var$fiberIsPortaledIntoHost(this._fragmentFiber) ? parentHostFiber.parentElement : parentHostInstance;
    if (null == parentHostInstanceFromDOM) return Node.DOCUMENT_POSITION_DISCONNECTED;
    parentHostInstance = parentHostInstanceFromDOM.compareDocumentPosition(parentHostFiber) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    parentHostInstanceFromDOM = parentHostInstanceFromDOM.compareDocumentPosition(result) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    var firstResult = parentHostFiber.compareDocumentPosition(otherNode), lastResult = result.compareDocumentPosition(otherNode), otherNodeIsWithinFirstOrLastChild = firstResult & Node.DOCUMENT_POSITION_CONTAINED_BY || lastResult & Node.DOCUMENT_POSITION_CONTAINED_BY;
    lastResult = parentHostInstance && parentHostInstanceFromDOM && firstResult & Node.DOCUMENT_POSITION_FOLLOWING && lastResult & Node.DOCUMENT_POSITION_PRECEDING;
    parentHostFiber = parentHostInstance && parentHostFiber === otherNode || parentHostInstanceFromDOM && result === otherNode || otherNodeIsWithinFirstOrLastChild || lastResult ? Node.DOCUMENT_POSITION_CONTAINED_BY : !parentHostInstance && parentHostFiber === otherNode || !parentHostInstanceFromDOM && result === otherNode ? Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC : firstResult;
    return parentHostFiber & Node.DOCUMENT_POSITION_DISCONNECTED || parentHostFiber & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC || $ea68a19c2d46a931$var$validateDocumentPositionWithFiberTree(parentHostFiber, this._fragmentFiber, children[0], children[children.length - 1], otherNode) ? parentHostFiber : Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
};
function $ea68a19c2d46a931$var$validateDocumentPositionWithFiberTree(documentPosition, fragmentFiber, precedingBoundaryFiber, followingBoundaryFiber, otherNode) {
    var otherFiber = $ea68a19c2d46a931$var$getClosestInstanceFromNode(otherNode);
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINED_BY) {
        if (precedingBoundaryFiber = !!otherFiber) a: {
            for(; null !== otherFiber;){
                if (7 === otherFiber.tag && (otherFiber === fragmentFiber || otherFiber.alternate === fragmentFiber)) {
                    precedingBoundaryFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            precedingBoundaryFiber = !1;
        }
        return precedingBoundaryFiber;
    }
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINS) {
        if (null === otherFiber) return otherFiber = otherNode.ownerDocument, otherNode === otherFiber || otherNode === otherFiber.documentElement || otherNode === otherFiber.body;
        a: {
            otherFiber = fragmentFiber;
            for(fragmentFiber = $ea68a19c2d46a931$var$getFragmentParentInstanceOrContainerFiber(fragmentFiber); null !== otherFiber;){
                if (!(5 !== otherFiber.tag && 3 !== otherFiber.tag && 27 !== otherFiber.tag || otherFiber !== fragmentFiber && otherFiber.alternate !== fragmentFiber)) {
                    otherFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            otherFiber = !1;
        }
        return otherFiber;
    }
    return documentPosition & Node.DOCUMENT_POSITION_PRECEDING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === precedingBoundaryFiber) && (fragmentFiber = $ea68a19c2d46a931$var$getLowestCommonAncestor(precedingBoundaryFiber, otherFiber, $ea68a19c2d46a931$var$getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : ($ea68a19c2d46a931$var$traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, $ea68a19c2d46a931$var$isFiberPrecedingCheck, otherFiber, precedingBoundaryFiber), otherFiber = $ea68a19c2d46a931$var$searchTarget, $ea68a19c2d46a931$var$searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : documentPosition & Node.DOCUMENT_POSITION_FOLLOWING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === followingBoundaryFiber) && (fragmentFiber = $ea68a19c2d46a931$var$getLowestCommonAncestor(followingBoundaryFiber, otherFiber, $ea68a19c2d46a931$var$getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : ($ea68a19c2d46a931$var$traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, $ea68a19c2d46a931$var$isFiberFollowingCheck, otherFiber, followingBoundaryFiber), otherFiber = $ea68a19c2d46a931$var$searchTarget, $ea68a19c2d46a931$var$searchBoundary = $ea68a19c2d46a931$var$searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : !1;
}
function $ea68a19c2d46a931$var$scrollTextNodeIntoView(textNode, resolvedAlignToTop) {
    var range = textNode.ownerDocument.createRange();
    range.selectNodeContents(textNode);
    textNode = range.getBoundingClientRect();
    window.scrollTo(window.scrollX + textNode.left, resolvedAlignToTop ? window.scrollY + textNode.top : window.scrollY + textNode.bottom - window.innerHeight);
}
$ea68a19c2d46a931$var$FragmentInstance.prototype.scrollIntoView = function(alignToTop) {
    if ("object" === typeof alignToTop) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(566));
    var children = [];
    $ea68a19c2d46a931$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $ea68a19c2d46a931$var$collectChildren, children, void 0, void 0);
    var resolvedAlignToTop = !1 !== alignToTop;
    if (0 === children.length) {
        var hostSiblings = $ea68a19c2d46a931$var$getFragmentInstanceOrTextInstanceSiblings(this._fragmentFiber);
        hostSiblings = resolvedAlignToTop ? hostSiblings[1] || hostSiblings[0] || $ea68a19c2d46a931$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber) : hostSiblings[0] || hostSiblings[1];
        if (null === hostSiblings) return;
        if (6 === hostSiblings.tag) {
            alignToTop = $ea68a19c2d46a931$var$getInstanceFromHostFiber(hostSiblings);
            $ea68a19c2d46a931$var$scrollTextNodeIntoView(alignToTop, resolvedAlignToTop);
            return;
        }
        hostSiblings = $ea68a19c2d46a931$var$getInstanceFromHostFiber(hostSiblings);
        if (9 !== hostSiblings.nodeType) {
            if (11 === hostSiblings.nodeType) {
                resolvedAlignToTop = "host" in hostSiblings ? hostSiblings.host : null;
                null !== resolvedAlignToTop && resolvedAlignToTop.scrollIntoView(alignToTop);
                return;
            }
            hostSiblings.scrollIntoView(alignToTop);
        }
    }
    for(hostSiblings = resolvedAlignToTop ? children.length - 1 : 0; hostSiblings !== (resolvedAlignToTop ? -1 : children.length);){
        var child = children[hostSiblings];
        6 === child.tag ? (child = $ea68a19c2d46a931$var$getInstanceFromHostFiber(child), $ea68a19c2d46a931$var$scrollTextNodeIntoView(child, resolvedAlignToTop)) : $ea68a19c2d46a931$var$getInstanceFromHostFiber(child).scrollIntoView(alignToTop);
        hostSiblings += resolvedAlignToTop ? -1 : 1;
    }
};
function $ea68a19c2d46a931$var$addFragmentHandleToFiber(child, fragmentInstance) {
    child = $ea68a19c2d46a931$var$getInstanceFromHostFiber(child);
    $ea68a19c2d46a931$var$addFragmentHandleToInstance(child, fragmentInstance);
    return !1;
}
function $ea68a19c2d46a931$var$addFragmentHandleToInstance(instance, fragmentInstance) {
    null == instance.reactFragments && (instance.reactFragments = new Set());
    instance.reactFragments.add(fragmentInstance);
}
function $ea68a19c2d46a931$var$commitNewChildToFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i$jscomp$0 = 0; i$jscomp$0 < eventListeners.length; i$jscomp$0++){
        var _eventListeners$i3 = eventListeners[i$jscomp$0];
        childInstance.addEventListener(_eventListeners$i3.type, _eventListeners$i3.attachedListener, $ea68a19c2d46a931$var$getAttachOptions(_eventListeners$i3.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        for(var writeIdx = 0, i = 0; i < $ea68a19c2d46a931$var$pendingIntersectionUnobserves.length; i++){
            var pending = $ea68a19c2d46a931$var$pendingIntersectionUnobserves[i];
            if (pending.fragmentInstance !== fragmentInstance || pending.observer !== observer || pending.instance !== childInstance) $ea68a19c2d46a931$var$pendingIntersectionUnobserves[writeIdx++] = pending;
        }
        $ea68a19c2d46a931$var$pendingIntersectionUnobserves.length = writeIdx;
        observer.observe(childInstance);
    }), $ea68a19c2d46a931$var$addFragmentHandleToInstance(childInstance, fragmentInstance));
}
function $ea68a19c2d46a931$var$deleteChildFromFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i = 0; i < eventListeners.length; i++){
        var _eventListeners$i4 = eventListeners[i];
        childInstance.removeEventListener(_eventListeners$i4.type, _eventListeners$i4.attachedListener, $ea68a19c2d46a931$var$getAttachOptions(_eventListeners$i4.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        "string" === typeof observer.rootMargin ? $ea68a19c2d46a931$var$schedulePendingIntersectionUnobserve(fragmentInstance, observer, childInstance) : observer.unobserve(childInstance);
    }), null != childInstance.reactFragments && childInstance.reactFragments.delete(fragmentInstance));
}
function $ea68a19c2d46a931$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $ea68a19c2d46a931$var$clearContainerSparingly(node);
                $ea68a19c2d46a931$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $ea68a19c2d46a931$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$ea68a19c2d46a931$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $ea68a19c2d46a931$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $ea68a19c2d46a931$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $ea68a19c2d46a931$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $ea68a19c2d46a931$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $ea68a19c2d46a931$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $ea68a19c2d46a931$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $ea68a19c2d46a931$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $ea68a19c2d46a931$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $ea68a19c2d46a931$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $ea68a19c2d46a931$var$previousHydratableOnEnteringScopedSingleton = null;
function $ea68a19c2d46a931$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $ea68a19c2d46a931$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $ea68a19c2d46a931$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $ea68a19c2d46a931$var$setFocusIfFocusable(node, focusOptions) {
    function handleFocus() {
        didFocus = !0;
    }
    if (node.ownerDocument.activeElement === node) return !0;
    var didFocus = !1;
    try {
        node.ownerDocument.addEventListener("focus", handleFocus, !0), (node.focus || HTMLElement.prototype.focus).call(node, focusOptions);
    } finally{
        node.ownerDocument.removeEventListener("focus", handleFocus, !0);
    }
    return didFocus;
}
function $ea68a19c2d46a931$var$requestPostPaintCallback(callback) {
    $ea68a19c2d46a931$var$localRequestAnimationFrame(function() {
        $ea68a19c2d46a931$var$localRequestAnimationFrame(function(time) {
            return callback(time);
        });
    });
}
function $ea68a19c2d46a931$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $ea68a19c2d46a931$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(451));
    }
}
function $ea68a19c2d46a931$var$releaseSingletonInstance(instance, type, props) {
    for(var propKey in props){
        var propValue = props[propKey];
        props.hasOwnProperty(propKey) && null != propValue && $ea68a19c2d46a931$var$setProp(instance, type, propKey, null, $ea68a19c2d46a931$var$emptyProps, propValue);
    }
    null != props.dangerouslySetInnerHTML && (instance.textContent = "");
    instance.onclick === $ea68a19c2d46a931$var$noop$1 && (instance.onclick = null);
    $ea68a19c2d46a931$var$detachDeletedInstance(instance);
}
function $ea68a19c2d46a931$var$clearSingletonPreambleContribution(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $ea68a19c2d46a931$var$detachDeletedInstance(instance);
}
var $ea68a19c2d46a931$var$preloadPropsMap = new Map(), $ea68a19c2d46a931$var$preconnectsSet = new Set();
function $ea68a19c2d46a931$var$getHoistableRoot(container) {
    if ("function" === typeof container.getRootNode) {
        var rootNode = container.getRootNode();
        if (9 === rootNode.nodeType || 11 === rootNode.nodeType) return rootNode;
    }
    return 9 === container.nodeType ? container : container.ownerDocument;
}
var $ea68a19c2d46a931$var$previousDispatcher = $ea68a19c2d46a931$var$ReactDOMSharedInternals.d;
$ea68a19c2d46a931$var$ReactDOMSharedInternals.d = {
    f: $ea68a19c2d46a931$var$flushSyncWork,
    r: $ea68a19c2d46a931$var$requestFormReset,
    D: $ea68a19c2d46a931$var$prefetchDNS,
    C: $ea68a19c2d46a931$var$preconnect,
    L: $ea68a19c2d46a931$var$preload,
    m: $ea68a19c2d46a931$var$preloadModule,
    X: $ea68a19c2d46a931$var$preinitScript,
    S: $ea68a19c2d46a931$var$preinitStyle,
    M: $ea68a19c2d46a931$var$preinitModuleScript
};
function $ea68a19c2d46a931$var$flushSyncWork() {
    var previousWasRendering = $ea68a19c2d46a931$var$previousDispatcher.f(), wasRendering = $ea68a19c2d46a931$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $ea68a19c2d46a931$var$requestFormReset(form) {
    var formInst = $ea68a19c2d46a931$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $ea68a19c2d46a931$var$requestFormReset$1(formInst) : $ea68a19c2d46a931$var$previousDispatcher.r(form);
}
var $ea68a19c2d46a931$var$globalDocument = "undefined" === typeof document ? null : document;
function $ea68a19c2d46a931$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $ea68a19c2d46a931$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $ea68a19c2d46a931$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $ea68a19c2d46a931$var$preconnectsSet.has(limitedEscapedHref) || ($ea68a19c2d46a931$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $ea68a19c2d46a931$var$setInitialProperties(href, "link", rel), $ea68a19c2d46a931$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $ea68a19c2d46a931$var$prefetchDNS(href) {
    $ea68a19c2d46a931$var$previousDispatcher.D(href);
    $ea68a19c2d46a931$var$preconnectAs("dns-prefetch", href, null);
}
function $ea68a19c2d46a931$var$preconnect(href, crossOrigin) {
    $ea68a19c2d46a931$var$previousDispatcher.C(href, crossOrigin);
    $ea68a19c2d46a931$var$preconnectAs("preconnect", href, crossOrigin);
}
function $ea68a19c2d46a931$var$preload(href, as, options) {
    $ea68a19c2d46a931$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $ea68a19c2d46a931$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $ea68a19c2d46a931$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $ea68a19c2d46a931$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $ea68a19c2d46a931$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $ea68a19c2d46a931$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $ea68a19c2d46a931$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $ea68a19c2d46a931$var$getStyleKey(href);
                break;
            case "script":
                key = $ea68a19c2d46a931$var$getScriptKey(href);
        }
        if (!($ea68a19c2d46a931$var$preloadPropsMap.has(key) || (href = $ea68a19c2d46a931$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $ea68a19c2d46a931$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($ea68a19c2d46a931$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($ea68a19c2d46a931$var$getScriptSelectorFromKey(key))))) {
            var instance = ownerDocument.createElement("link");
            $ea68a19c2d46a931$var$setInitialProperties(instance, "link", href);
            "style" === as && (instance[$ea68a19c2d46a931$var$internalLoadPendingKey] = !0, instance.onload = instance.onerror = function() {
                $ea68a19c2d46a931$var$clearPendingLoadOnNode(instance);
            });
            $ea68a19c2d46a931$var$markNodeAsHoistable(instance);
            ownerDocument.head.appendChild(instance);
        }
    }
}
function $ea68a19c2d46a931$var$preloadModule(href, options) {
    $ea68a19c2d46a931$var$previousDispatcher.m(href, options);
    var ownerDocument = $ea68a19c2d46a931$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $ea68a19c2d46a931$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $ea68a19c2d46a931$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $ea68a19c2d46a931$var$getScriptKey(href);
        }
        if (!$ea68a19c2d46a931$var$preloadPropsMap.has(key) && (href = $ea68a19c2d46a931$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $ea68a19c2d46a931$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($ea68a19c2d46a931$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $ea68a19c2d46a931$var$setInitialProperties(as, "link", href);
            $ea68a19c2d46a931$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $ea68a19c2d46a931$var$preinitStyle(href, precedence, options) {
    $ea68a19c2d46a931$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $ea68a19c2d46a931$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $ea68a19c2d46a931$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $ea68a19c2d46a931$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($ea68a19c2d46a931$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $ea68a19c2d46a931$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $ea68a19c2d46a931$var$preloadPropsMap.get(key)) && $ea68a19c2d46a931$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $ea68a19c2d46a931$var$markNodeAsHoistable(link);
                $ea68a19c2d46a931$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $ea68a19c2d46a931$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $ea68a19c2d46a931$var$preinitScript(src, options) {
    $ea68a19c2d46a931$var$previousDispatcher.X(src, options);
    var ownerDocument = $ea68a19c2d46a931$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $ea68a19c2d46a931$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $ea68a19c2d46a931$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($ea68a19c2d46a931$var$getScriptSelectorFromKey(key)), resource || (src = $ea68a19c2d46a931$var$assign({
            src: src,
            async: !0
        }, options), (options = $ea68a19c2d46a931$var$preloadPropsMap.get(key)) && $ea68a19c2d46a931$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $ea68a19c2d46a931$var$markNodeAsHoistable(resource), $ea68a19c2d46a931$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $ea68a19c2d46a931$var$preinitModuleScript(src, options) {
    $ea68a19c2d46a931$var$previousDispatcher.M(src, options);
    var ownerDocument = $ea68a19c2d46a931$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $ea68a19c2d46a931$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $ea68a19c2d46a931$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($ea68a19c2d46a931$var$getScriptSelectorFromKey(key)), resource || (src = $ea68a19c2d46a931$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $ea68a19c2d46a931$var$preloadPropsMap.get(key)) && $ea68a19c2d46a931$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $ea68a19c2d46a931$var$markNodeAsHoistable(resource), $ea68a19c2d46a931$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $ea68a19c2d46a931$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $ea68a19c2d46a931$var$rootInstanceStackCursor.current) ? $ea68a19c2d46a931$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (pendingProps = $ea68a19c2d46a931$var$getStyleKey(pendingProps.href), currentProps = $ea68a19c2d46a931$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $ea68a19c2d46a931$var$getStyleKey(pendingProps.href);
                var styles$268 = $ea68a19c2d46a931$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$269 = styles$268.get(type);
                resource$269 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$269 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$268.set(type, resource$269), (styles$268 = JSCompiler_inline_result.querySelector($ea68a19c2d46a931$var$getStylesheetSelectorFromKey(type))) ? styles$268._p || (resource$269.instance = styles$268, resource$269.state.loading = 5) : (styles$268 = $ea68a19c2d46a931$var$preloadPropsMap.get(type), styles$268 || (styles$268 = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $ea68a19c2d46a931$var$preloadPropsMap.set(type, styles$268)), $ea68a19c2d46a931$var$preloadStylesheet(JSCompiler_inline_result, type, styles$268, resource$269.state)));
                if (currentProps && null === currentResource) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(528, ""));
                return resource$269;
            }
            if (currentProps && null !== currentResource) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (pendingProps = $ea68a19c2d46a931$var$getScriptKey(pendingProps), currentProps = $ea68a19c2d46a931$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(444, type));
    }
}
function $ea68a19c2d46a931$var$getStyleKey(href) {
    return 'href="' + $ea68a19c2d46a931$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $ea68a19c2d46a931$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $ea68a19c2d46a931$var$stylesheetPropsFromRawProps(rawProps) {
    return $ea68a19c2d46a931$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $ea68a19c2d46a931$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    if (key = ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]")) {
        if (!0 !== key[$ea68a19c2d46a931$var$internalLoadPendingKey]) {
            state.loading = 1;
            return;
        }
    } else key = ownerDocument.createElement("link"), key[$ea68a19c2d46a931$var$internalLoadPendingKey] = !0, key.onload = key.onerror = $ea68a19c2d46a931$var$clearPendingLoadOnNode.bind(null, key), $ea68a19c2d46a931$var$setInitialProperties(key, "link", preloadProps), $ea68a19c2d46a931$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key);
    state.preload = key;
    key.addEventListener("load", function() {
        return state.loading |= 1;
    });
    key.addEventListener("error", function() {
        return state.loading |= 2;
    });
}
function $ea68a19c2d46a931$var$getScriptKey(src) {
    return '[src="' + $ea68a19c2d46a931$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $ea68a19c2d46a931$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $ea68a19c2d46a931$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $ea68a19c2d46a931$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $ea68a19c2d46a931$var$markNodeAsHoistable(instance), instance;
            var styleProps = $ea68a19c2d46a931$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $ea68a19c2d46a931$var$markNodeAsHoistable(instance);
            $ea68a19c2d46a931$var$setInitialProperties(instance, "style", styleProps);
            $ea68a19c2d46a931$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $ea68a19c2d46a931$var$getStyleKey(props.href);
            var instance$274 = hoistableRoot.querySelector($ea68a19c2d46a931$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$274) return resource.state.loading |= 4, resource.instance = instance$274, $ea68a19c2d46a931$var$markNodeAsHoistable(instance$274), instance$274;
            instance = $ea68a19c2d46a931$var$stylesheetPropsFromRawProps(props);
            (styleProps = $ea68a19c2d46a931$var$preloadPropsMap.get(styleProps)) && $ea68a19c2d46a931$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$274 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $ea68a19c2d46a931$var$markNodeAsHoistable(instance$274);
            var linkInstance = instance$274;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $ea68a19c2d46a931$var$setInitialProperties(instance$274, "link", instance);
            resource.state.loading |= 4;
            $ea68a19c2d46a931$var$insertStylesheet(instance$274, props.precedence, hoistableRoot);
            return resource.instance = instance$274;
        case "script":
            instance$274 = $ea68a19c2d46a931$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($ea68a19c2d46a931$var$getScriptSelectorFromKey(instance$274))) return resource.instance = styleProps, $ea68a19c2d46a931$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $ea68a19c2d46a931$var$preloadPropsMap.get(instance$274)) instance = $ea68a19c2d46a931$var$assign({}, props), $ea68a19c2d46a931$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $ea68a19c2d46a931$var$markNodeAsHoistable(styleProps);
            $ea68a19c2d46a931$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $ea68a19c2d46a931$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $ea68a19c2d46a931$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $ea68a19c2d46a931$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $ea68a19c2d46a931$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $ea68a19c2d46a931$var$tagCaches = null;
function $ea68a19c2d46a931$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $ea68a19c2d46a931$var$tagCaches) {
        var cache = new Map();
        var caches = $ea68a19c2d46a931$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $ea68a19c2d46a931$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$ea68a19c2d46a931$var$internalHoistableMarker] || node[$ea68a19c2d46a931$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $ea68a19c2d46a931$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $ea68a19c2d46a931$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $ea68a19c2d46a931$var$maySuspendCommit(type, props) {
    return "img" === type && null != props.src && "" !== props.src && null == props.onLoad && "lazy" !== props.loading;
}
function $ea68a19c2d46a931$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $ea68a19c2d46a931$var$estimateImageBytes(instance) {
    return (instance.width || 100) * (instance.height || 100) * ("number" === typeof devicePixelRatio ? devicePixelRatio : 1) * 0.25;
}
function $ea68a19c2d46a931$var$suspendInstance(state, instance) {
    "function" === typeof instance.decode && (state.imgCount++, instance.complete || (state.imgBytes += $ea68a19c2d46a931$var$estimateImageBytes(instance), state.suspenseyImages.push(instance)), state = $ea68a19c2d46a931$var$onUnsuspendImg.bind(state), instance.decode().then(state, state));
}
function $ea68a19c2d46a931$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $ea68a19c2d46a931$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($ea68a19c2d46a931$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $ea68a19c2d46a931$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $ea68a19c2d46a931$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $ea68a19c2d46a931$var$stylesheetPropsFromRawProps(props);
            (key = $ea68a19c2d46a931$var$preloadPropsMap.get(key)) && $ea68a19c2d46a931$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $ea68a19c2d46a931$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $ea68a19c2d46a931$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $ea68a19c2d46a931$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $ea68a19c2d46a931$var$estimatedBytesWithinLimit = 0;
function $ea68a19c2d46a931$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $ea68a19c2d46a931$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $ea68a19c2d46a931$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $ea68a19c2d46a931$var$estimatedBytesWithinLimit && ($ea68a19c2d46a931$var$estimatedBytesWithinLimit = 62500 * $ea68a19c2d46a931$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $ea68a19c2d46a931$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $ea68a19c2d46a931$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $ea68a19c2d46a931$var$checkIfFullyUnsuspended(state) {
    if (0 === state.count && (0 === state.imgCount || !state.waitingForImages)) {
        if (state.stylesheets) $ea68a19c2d46a931$var$insertSuspendedStylesheets(state, state.stylesheets);
        else if (state.unsuspend) {
            var unsuspend = state.unsuspend;
            state.unsuspend = null;
            unsuspend();
        }
    }
}
function $ea68a19c2d46a931$var$onUnsuspend() {
    this.count--;
    $ea68a19c2d46a931$var$checkIfFullyUnsuspended(this);
}
function $ea68a19c2d46a931$var$onUnsuspendImg() {
    this.imgCount--;
    $ea68a19c2d46a931$var$checkIfFullyUnsuspended(this);
}
var $ea68a19c2d46a931$var$precedencesByRoot = null;
function $ea68a19c2d46a931$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $ea68a19c2d46a931$var$precedencesByRoot = new Map(), resources.forEach($ea68a19c2d46a931$var$insertStylesheetIntoRoot, state), $ea68a19c2d46a931$var$precedencesByRoot = null, $ea68a19c2d46a931$var$onUnsuspend.call(state));
}
function $ea68a19c2d46a931$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $ea68a19c2d46a931$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $ea68a19c2d46a931$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $ea68a19c2d46a931$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $ea68a19c2d46a931$var$HostTransitionContext = {
    $$typeof: $ea68a19c2d46a931$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $ea68a19c2d46a931$var$sharedNotPendingObject,
    _currentValue2: $ea68a19c2d46a931$var$sharedNotPendingObject,
    _threadCount: 0
};
function $ea68a19c2d46a931$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $ea68a19c2d46a931$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $ea68a19c2d46a931$var$createLaneMap(0);
    this.hiddenUpdates = $ea68a19c2d46a931$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.transitionTypes = null;
    this.incompleteTransitions = new Map();
}
function $ea68a19c2d46a931$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $ea68a19c2d46a931$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $ea68a19c2d46a931$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $ea68a19c2d46a931$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $ea68a19c2d46a931$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $ea68a19c2d46a931$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $ea68a19c2d46a931$var$emptyContextObject;
    parentComponent = $ea68a19c2d46a931$var$emptyContextObject;
    return parentComponent;
}
function $ea68a19c2d46a931$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $ea68a19c2d46a931$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $ea68a19c2d46a931$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $ea68a19c2d46a931$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($ea68a19c2d46a931$var$scheduleUpdateOnFiber(element, rootFiber, lane), $ea68a19c2d46a931$var$entangleTransitions(element, rootFiber, lane));
}
function $ea68a19c2d46a931$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $ea68a19c2d46a931$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $ea68a19c2d46a931$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $ea68a19c2d46a931$var$markRetryLaneImpl(fiber, retryLane);
}
function $ea68a19c2d46a931$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $ea68a19c2d46a931$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $ea68a19c2d46a931$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $ea68a19c2d46a931$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $ea68a19c2d46a931$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $ea68a19c2d46a931$var$requestUpdateLane();
        lane = $ea68a19c2d46a931$var$getBumpedLaneForHydrationByLane(lane);
        var root = $ea68a19c2d46a931$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $ea68a19c2d46a931$var$scheduleUpdateOnFiber(root, fiber, lane);
        $ea68a19c2d46a931$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $ea68a19c2d46a931$var$_enabled = !0;
function $ea68a19c2d46a931$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $ea68a19c2d46a931$var$ReactSharedInternals.T;
    $ea68a19c2d46a931$var$ReactSharedInternals.T = null;
    var previousPriority = $ea68a19c2d46a931$var$ReactDOMSharedInternals.p;
    try {
        $ea68a19c2d46a931$var$ReactDOMSharedInternals.p = 2, $ea68a19c2d46a931$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $ea68a19c2d46a931$var$ReactDOMSharedInternals.p = previousPriority, $ea68a19c2d46a931$var$ReactSharedInternals.T = prevTransition;
    }
}
function $ea68a19c2d46a931$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $ea68a19c2d46a931$var$ReactSharedInternals.T;
    $ea68a19c2d46a931$var$ReactSharedInternals.T = null;
    var previousPriority = $ea68a19c2d46a931$var$ReactDOMSharedInternals.p;
    try {
        $ea68a19c2d46a931$var$ReactDOMSharedInternals.p = 8, $ea68a19c2d46a931$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $ea68a19c2d46a931$var$ReactDOMSharedInternals.p = previousPriority, $ea68a19c2d46a931$var$ReactSharedInternals.T = prevTransition;
    }
}
function $ea68a19c2d46a931$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($ea68a19c2d46a931$var$_enabled) {
        var blockedOn = $ea68a19c2d46a931$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $ea68a19c2d46a931$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $ea68a19c2d46a931$var$return_targetInst, targetContainer), $ea68a19c2d46a931$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($ea68a19c2d46a931$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($ea68a19c2d46a931$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $ea68a19c2d46a931$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $ea68a19c2d46a931$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $ea68a19c2d46a931$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $ea68a19c2d46a931$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $ea68a19c2d46a931$var$ensureRootIsScheduled(fiber);
                                0 === ($ea68a19c2d46a931$var$executionContext & 6) && ($ea68a19c2d46a931$var$workInProgressRootRenderTargetTime = $ea68a19c2d46a931$var$now() + 500, $ea68a19c2d46a931$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $ea68a19c2d46a931$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $ea68a19c2d46a931$var$scheduleUpdateOnFiber(root, fiber, 2), $ea68a19c2d46a931$var$flushSyncWork$1(), $ea68a19c2d46a931$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $ea68a19c2d46a931$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $ea68a19c2d46a931$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $ea68a19c2d46a931$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $ea68a19c2d46a931$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $ea68a19c2d46a931$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $ea68a19c2d46a931$var$getEventTarget(nativeEvent);
    return $ea68a19c2d46a931$var$findInstanceBlockingTarget(nativeEvent);
}
var $ea68a19c2d46a931$var$return_targetInst = null;
function $ea68a19c2d46a931$var$findInstanceBlockingTarget(targetNode) {
    $ea68a19c2d46a931$var$return_targetInst = null;
    targetNode = $ea68a19c2d46a931$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $ea68a19c2d46a931$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $ea68a19c2d46a931$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $ea68a19c2d46a931$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $ea68a19c2d46a931$var$return_targetInst = targetNode;
    return null;
}
function $ea68a19c2d46a931$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "fullscreenerror":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "resize":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($ea68a19c2d46a931$var$getCurrentPriorityLevel()){
                case $ea68a19c2d46a931$var$ImmediatePriority:
                    return 2;
                case $ea68a19c2d46a931$var$UserBlockingPriority:
                    return 8;
                case $ea68a19c2d46a931$var$NormalPriority$1:
                case $ea68a19c2d46a931$var$LowPriority:
                    return 32;
                case $ea68a19c2d46a931$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $ea68a19c2d46a931$var$hasScheduledReplayAttempt = !1, $ea68a19c2d46a931$var$queuedFocus = null, $ea68a19c2d46a931$var$queuedDrag = null, $ea68a19c2d46a931$var$queuedMouse = null, $ea68a19c2d46a931$var$queuedPointers = new Map(), $ea68a19c2d46a931$var$queuedPointerCaptures = new Map(), $ea68a19c2d46a931$var$queuedExplicitHydrationTargets = [], $ea68a19c2d46a931$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $ea68a19c2d46a931$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $ea68a19c2d46a931$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $ea68a19c2d46a931$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $ea68a19c2d46a931$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $ea68a19c2d46a931$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $ea68a19c2d46a931$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $ea68a19c2d46a931$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $ea68a19c2d46a931$var$getInstanceFromNode(blockedOn), null !== blockedOn && $ea68a19c2d46a931$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $ea68a19c2d46a931$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $ea68a19c2d46a931$var$queuedFocus = $ea68a19c2d46a931$var$accumulateOrCreateContinuousQueuedReplayableEvent($ea68a19c2d46a931$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $ea68a19c2d46a931$var$queuedDrag = $ea68a19c2d46a931$var$accumulateOrCreateContinuousQueuedReplayableEvent($ea68a19c2d46a931$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $ea68a19c2d46a931$var$queuedMouse = $ea68a19c2d46a931$var$accumulateOrCreateContinuousQueuedReplayableEvent($ea68a19c2d46a931$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $ea68a19c2d46a931$var$queuedPointers.set(pointerId, $ea68a19c2d46a931$var$accumulateOrCreateContinuousQueuedReplayableEvent($ea68a19c2d46a931$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $ea68a19c2d46a931$var$queuedPointerCaptures.set(pointerId, $ea68a19c2d46a931$var$accumulateOrCreateContinuousQueuedReplayableEvent($ea68a19c2d46a931$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $ea68a19c2d46a931$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $ea68a19c2d46a931$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $ea68a19c2d46a931$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $ea68a19c2d46a931$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $ea68a19c2d46a931$var$runWithPriority(queuedTarget.priority, function() {
                        $ea68a19c2d46a931$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $ea68a19c2d46a931$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $ea68a19c2d46a931$var$runWithPriority(queuedTarget.priority, function() {
                        $ea68a19c2d46a931$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $ea68a19c2d46a931$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $ea68a19c2d46a931$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $ea68a19c2d46a931$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $ea68a19c2d46a931$var$currentReplayingEvent = null;
        } else return targetContainers = $ea68a19c2d46a931$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $ea68a19c2d46a931$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $ea68a19c2d46a931$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $ea68a19c2d46a931$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $ea68a19c2d46a931$var$replayUnblockedEvents() {
    $ea68a19c2d46a931$var$hasScheduledReplayAttempt = !1;
    null !== $ea68a19c2d46a931$var$queuedFocus && $ea68a19c2d46a931$var$attemptReplayContinuousQueuedEvent($ea68a19c2d46a931$var$queuedFocus) && ($ea68a19c2d46a931$var$queuedFocus = null);
    null !== $ea68a19c2d46a931$var$queuedDrag && $ea68a19c2d46a931$var$attemptReplayContinuousQueuedEvent($ea68a19c2d46a931$var$queuedDrag) && ($ea68a19c2d46a931$var$queuedDrag = null);
    null !== $ea68a19c2d46a931$var$queuedMouse && $ea68a19c2d46a931$var$attemptReplayContinuousQueuedEvent($ea68a19c2d46a931$var$queuedMouse) && ($ea68a19c2d46a931$var$queuedMouse = null);
    $ea68a19c2d46a931$var$queuedPointers.forEach($ea68a19c2d46a931$var$attemptReplayContinuousQueuedEventInMap);
    $ea68a19c2d46a931$var$queuedPointerCaptures.forEach($ea68a19c2d46a931$var$attemptReplayContinuousQueuedEventInMap);
}
function $ea68a19c2d46a931$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $ea68a19c2d46a931$var$hasScheduledReplayAttempt || ($ea68a19c2d46a931$var$hasScheduledReplayAttempt = !0, $953uR.unstable_scheduleCallback($953uR.unstable_NormalPriority, $ea68a19c2d46a931$var$replayUnblockedEvents)));
}
var $ea68a19c2d46a931$var$lastScheduledReplayQueue = null;
function $ea68a19c2d46a931$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $ea68a19c2d46a931$var$lastScheduledReplayQueue !== formReplayingQueue && ($ea68a19c2d46a931$var$lastScheduledReplayQueue = formReplayingQueue, $953uR.unstable_scheduleCallback($953uR.unstable_NormalPriority, function() {
        $ea68a19c2d46a931$var$lastScheduledReplayQueue === formReplayingQueue && ($ea68a19c2d46a931$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $ea68a19c2d46a931$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $ea68a19c2d46a931$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $ea68a19c2d46a931$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $ea68a19c2d46a931$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $ea68a19c2d46a931$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $ea68a19c2d46a931$var$queuedFocus && $ea68a19c2d46a931$var$scheduleCallbackIfUnblocked($ea68a19c2d46a931$var$queuedFocus, unblocked);
    null !== $ea68a19c2d46a931$var$queuedDrag && $ea68a19c2d46a931$var$scheduleCallbackIfUnblocked($ea68a19c2d46a931$var$queuedDrag, unblocked);
    null !== $ea68a19c2d46a931$var$queuedMouse && $ea68a19c2d46a931$var$scheduleCallbackIfUnblocked($ea68a19c2d46a931$var$queuedMouse, unblocked);
    $ea68a19c2d46a931$var$queuedPointers.forEach(unblock);
    $ea68a19c2d46a931$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $ea68a19c2d46a931$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $ea68a19c2d46a931$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $ea68a19c2d46a931$var$queuedExplicitHydrationTargets.length && (i = $ea68a19c2d46a931$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$ea68a19c2d46a931$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $ea68a19c2d46a931$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$ea68a19c2d46a931$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $ea68a19c2d46a931$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$ea68a19c2d46a931$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $ea68a19c2d46a931$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $ea68a19c2d46a931$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $ea68a19c2d46a931$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $ea68a19c2d46a931$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$ea68a19c2d46a931$var$ReactDOMHydrationRoot.prototype.render = $ea68a19c2d46a931$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(409));
    var current = root.current, lane = $ea68a19c2d46a931$var$requestUpdateLane();
    $ea68a19c2d46a931$var$updateContainerImpl(current, lane, children, root, null, null);
};
$ea68a19c2d46a931$var$ReactDOMHydrationRoot.prototype.unmount = $ea68a19c2d46a931$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $ea68a19c2d46a931$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $ea68a19c2d46a931$var$flushSyncWork$1();
        container[$ea68a19c2d46a931$var$internalContainerInstanceKey] = null;
    }
};
function $ea68a19c2d46a931$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$ea68a19c2d46a931$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $ea68a19c2d46a931$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $ea68a19c2d46a931$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $ea68a19c2d46a931$var$queuedExplicitHydrationTargets[i].priority; i++);
        $ea68a19c2d46a931$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $ea68a19c2d46a931$var$attemptExplicitHydrationTarget(target);
    }
};
var $ea68a19c2d46a931$var$isomorphicReactPackageVersion$jscomp$inline_2043 = $jpgPw.version;
if ("19.3.1" !== $ea68a19c2d46a931$var$isomorphicReactPackageVersion$jscomp$inline_2043) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(527, $ea68a19c2d46a931$var$isomorphicReactPackageVersion$jscomp$inline_2043, "19.3.1"));
$ea68a19c2d46a931$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $ea68a19c2d46a931$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $ea68a19c2d46a931$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $ea68a19c2d46a931$var$internals$jscomp$inline_2586 = {
    bundleType: 0,
    version: "19.3.1",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $ea68a19c2d46a931$var$ReactSharedInternals,
    reconcilerVersion: "19.3.1"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $ea68a19c2d46a931$var$hook$jscomp$inline_2587 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$ea68a19c2d46a931$var$hook$jscomp$inline_2587.isDisabled && $ea68a19c2d46a931$var$hook$jscomp$inline_2587.supportsFiber) try {
        $ea68a19c2d46a931$var$rendererID = $ea68a19c2d46a931$var$hook$jscomp$inline_2587.inject($ea68a19c2d46a931$var$internals$jscomp$inline_2586), $ea68a19c2d46a931$var$injectedHook = $ea68a19c2d46a931$var$hook$jscomp$inline_2587;
    } catch (err) {}
}
$ea68a19c2d46a931$export$882461b6382ed46c = function(container, options) {
    if (!$ea68a19c2d46a931$var$isValidContainer(container)) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $ea68a19c2d46a931$var$defaultOnUncaughtError, onCaughtError = $ea68a19c2d46a931$var$defaultOnCaughtError, onRecoverableError = $ea68a19c2d46a931$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $ea68a19c2d46a931$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $ea68a19c2d46a931$var$defaultOnDefaultTransitionIndicator);
    container[$ea68a19c2d46a931$var$internalContainerInstanceKey] = options.current;
    $ea68a19c2d46a931$var$listenToAllSupportedEvents(container);
    return new $ea68a19c2d46a931$var$ReactDOMRoot(options);
};
$ea68a19c2d46a931$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$ea68a19c2d46a931$var$isValidContainer(container)) throw Error($ea68a19c2d46a931$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $ea68a19c2d46a931$var$defaultOnUncaughtError, onCaughtError = $ea68a19c2d46a931$var$defaultOnCaughtError, onRecoverableError = $ea68a19c2d46a931$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $ea68a19c2d46a931$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $ea68a19c2d46a931$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $ea68a19c2d46a931$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $ea68a19c2d46a931$var$requestUpdateLane();
    isStrictMode = $ea68a19c2d46a931$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $ea68a19c2d46a931$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $ea68a19c2d46a931$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $ea68a19c2d46a931$var$markRootUpdated$1(initialChildren, options);
    $ea68a19c2d46a931$var$ensureRootIsScheduled(initialChildren);
    container[$ea68a19c2d46a931$var$internalContainerInstanceKey] = initialChildren.current;
    $ea68a19c2d46a931$var$listenToAllSupportedEvents(container);
    return new $ea68a19c2d46a931$var$ReactDOMHydrationRoot(initialChildren);
};
$ea68a19c2d46a931$export$83d89fbfd8236492 = "19.3.1";

});
parcelRegister("953uR", function(module, exports) {
'use strict';

module.exports = (parcelRequire("eMm76"));

});
parcelRegister("eMm76", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $ac26b3b212d6beb6$export$c4744153514ff05d; }, function (v) { return $ac26b3b212d6beb6$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $ac26b3b212d6beb6$export$3e506c1ccc9cc1a7; }, function (v) { return $ac26b3b212d6beb6$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $ac26b3b212d6beb6$export$e26fe2ed2fa76875; }, function (v) { return $ac26b3b212d6beb6$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $ac26b3b212d6beb6$export$502329bbf4b505b1; }, function (v) { return $ac26b3b212d6beb6$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $ac26b3b212d6beb6$export$6e3807111c4874c4; }, function (v) { return $ac26b3b212d6beb6$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $ac26b3b212d6beb6$export$c27134553091fb3a; }, function (v) { return $ac26b3b212d6beb6$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $ac26b3b212d6beb6$export$33ee1acdc04fd2a2; }, function (v) { return $ac26b3b212d6beb6$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $ac26b3b212d6beb6$export$b00a404bbd5edef2; }, function (v) { return $ac26b3b212d6beb6$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $ac26b3b212d6beb6$export$d66a1c1c77bd778b; }, function (v) { return $ac26b3b212d6beb6$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $ac26b3b212d6beb6$export$d3dfb8e4810cb555; }, function (v) { return $ac26b3b212d6beb6$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $ac26b3b212d6beb6$export$72fdf0e06517287b; }, function (v) { return $ac26b3b212d6beb6$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $ac26b3b212d6beb6$export$816d2913ae6b83b1; }, function (v) { return $ac26b3b212d6beb6$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $ac26b3b212d6beb6$export$61bcfe829111a1d0; }, function (v) { return $ac26b3b212d6beb6$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $ac26b3b212d6beb6$export$7ee8c9beb337bc3f; }, function (v) { return $ac26b3b212d6beb6$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $ac26b3b212d6beb6$export$b5836b71941fa3ed; }, function (v) { return $ac26b3b212d6beb6$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $ac26b3b212d6beb6$export$cf845f2c119da08a; }, function (v) { return $ac26b3b212d6beb6$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ac26b3b212d6beb6$export$c4744153514ff05d;
var $ac26b3b212d6beb6$export$3e506c1ccc9cc1a7;
var $ac26b3b212d6beb6$export$e26fe2ed2fa76875;
var $ac26b3b212d6beb6$export$502329bbf4b505b1;
var $ac26b3b212d6beb6$export$6e3807111c4874c4;
var $ac26b3b212d6beb6$export$c27134553091fb3a;
var $ac26b3b212d6beb6$export$33ee1acdc04fd2a2;
var $ac26b3b212d6beb6$export$b00a404bbd5edef2;
var $ac26b3b212d6beb6$export$d66a1c1c77bd778b;
var $ac26b3b212d6beb6$export$d3dfb8e4810cb555;
var $ac26b3b212d6beb6$export$72fdf0e06517287b;
var $ac26b3b212d6beb6$export$816d2913ae6b83b1;
var $ac26b3b212d6beb6$export$61bcfe829111a1d0;
var $ac26b3b212d6beb6$export$7ee8c9beb337bc3f;
var $ac26b3b212d6beb6$export$b5836b71941fa3ed;
var $ac26b3b212d6beb6$export$cf845f2c119da08a;
"use strict";
function $ac26b3b212d6beb6$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $ac26b3b212d6beb6$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $ac26b3b212d6beb6$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $ac26b3b212d6beb6$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $ac26b3b212d6beb6$var$compare(left, last)) rightIndex < length && 0 > $ac26b3b212d6beb6$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $ac26b3b212d6beb6$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $ac26b3b212d6beb6$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$ac26b3b212d6beb6$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $ac26b3b212d6beb6$var$localPerformance = performance;
    $ac26b3b212d6beb6$export$c4744153514ff05d = function() {
        return $ac26b3b212d6beb6$var$localPerformance.now();
    };
} else {
    var $ac26b3b212d6beb6$var$localDate = Date, $ac26b3b212d6beb6$var$initialTime = $ac26b3b212d6beb6$var$localDate.now();
    $ac26b3b212d6beb6$export$c4744153514ff05d = function() {
        return $ac26b3b212d6beb6$var$localDate.now() - $ac26b3b212d6beb6$var$initialTime;
    };
}
var $ac26b3b212d6beb6$var$taskQueue = [], $ac26b3b212d6beb6$var$timerQueue = [], $ac26b3b212d6beb6$var$taskIdCounter = 1, $ac26b3b212d6beb6$var$currentTask = null, $ac26b3b212d6beb6$var$currentPriorityLevel = 3, $ac26b3b212d6beb6$var$isPerformingWork = !1, $ac26b3b212d6beb6$var$isHostCallbackScheduled = !1, $ac26b3b212d6beb6$var$isHostTimeoutScheduled = !1, $ac26b3b212d6beb6$var$needsPaint = !1, $ac26b3b212d6beb6$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $ac26b3b212d6beb6$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $ac26b3b212d6beb6$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $ac26b3b212d6beb6$var$advanceTimers(currentTime) {
    for(var timer = $ac26b3b212d6beb6$var$peek($ac26b3b212d6beb6$var$timerQueue); null !== timer;){
        if (null === timer.callback) $ac26b3b212d6beb6$var$pop($ac26b3b212d6beb6$var$timerQueue);
        else if (timer.startTime <= currentTime) $ac26b3b212d6beb6$var$pop($ac26b3b212d6beb6$var$timerQueue), timer.sortIndex = timer.expirationTime, $ac26b3b212d6beb6$var$push($ac26b3b212d6beb6$var$taskQueue, timer);
        else break;
        timer = $ac26b3b212d6beb6$var$peek($ac26b3b212d6beb6$var$timerQueue);
    }
}
function $ac26b3b212d6beb6$var$handleTimeout(currentTime) {
    $ac26b3b212d6beb6$var$isHostTimeoutScheduled = !1;
    $ac26b3b212d6beb6$var$advanceTimers(currentTime);
    if (!$ac26b3b212d6beb6$var$isHostCallbackScheduled) {
        if (null !== $ac26b3b212d6beb6$var$peek($ac26b3b212d6beb6$var$taskQueue)) $ac26b3b212d6beb6$var$isHostCallbackScheduled = !0, $ac26b3b212d6beb6$var$isMessageLoopRunning || ($ac26b3b212d6beb6$var$isMessageLoopRunning = !0, $ac26b3b212d6beb6$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $ac26b3b212d6beb6$var$peek($ac26b3b212d6beb6$var$timerQueue);
            null !== firstTimer && $ac26b3b212d6beb6$var$requestHostTimeout($ac26b3b212d6beb6$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $ac26b3b212d6beb6$var$isMessageLoopRunning = !1, $ac26b3b212d6beb6$var$taskTimeoutID = -1, $ac26b3b212d6beb6$var$frameInterval = 5, $ac26b3b212d6beb6$var$startTime = -1;
function $ac26b3b212d6beb6$var$shouldYieldToHost() {
    return $ac26b3b212d6beb6$var$needsPaint ? !0 : $ac26b3b212d6beb6$export$c4744153514ff05d() - $ac26b3b212d6beb6$var$startTime < $ac26b3b212d6beb6$var$frameInterval ? !1 : !0;
}
function $ac26b3b212d6beb6$var$performWorkUntilDeadline() {
    $ac26b3b212d6beb6$var$needsPaint = !1;
    if ($ac26b3b212d6beb6$var$isMessageLoopRunning) {
        var currentTime = $ac26b3b212d6beb6$export$c4744153514ff05d();
        $ac26b3b212d6beb6$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $ac26b3b212d6beb6$var$isHostCallbackScheduled = !1;
                $ac26b3b212d6beb6$var$isHostTimeoutScheduled && ($ac26b3b212d6beb6$var$isHostTimeoutScheduled = !1, $ac26b3b212d6beb6$var$localClearTimeout($ac26b3b212d6beb6$var$taskTimeoutID), $ac26b3b212d6beb6$var$taskTimeoutID = -1);
                $ac26b3b212d6beb6$var$isPerformingWork = !0;
                var previousPriorityLevel = $ac26b3b212d6beb6$var$currentPriorityLevel;
                try {
                    b: {
                        $ac26b3b212d6beb6$var$advanceTimers(currentTime);
                        for($ac26b3b212d6beb6$var$currentTask = $ac26b3b212d6beb6$var$peek($ac26b3b212d6beb6$var$taskQueue); null !== $ac26b3b212d6beb6$var$currentTask && !($ac26b3b212d6beb6$var$currentTask.expirationTime > currentTime && $ac26b3b212d6beb6$var$shouldYieldToHost());){
                            var callback = $ac26b3b212d6beb6$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $ac26b3b212d6beb6$var$currentTask.callback = null;
                                $ac26b3b212d6beb6$var$currentPriorityLevel = $ac26b3b212d6beb6$var$currentTask.priorityLevel;
                                var continuationCallback = callback($ac26b3b212d6beb6$var$currentTask.expirationTime <= currentTime);
                                currentTime = $ac26b3b212d6beb6$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $ac26b3b212d6beb6$var$currentTask.callback = continuationCallback;
                                    $ac26b3b212d6beb6$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $ac26b3b212d6beb6$var$currentTask === $ac26b3b212d6beb6$var$peek($ac26b3b212d6beb6$var$taskQueue) && $ac26b3b212d6beb6$var$pop($ac26b3b212d6beb6$var$taskQueue);
                                $ac26b3b212d6beb6$var$advanceTimers(currentTime);
                            } else $ac26b3b212d6beb6$var$pop($ac26b3b212d6beb6$var$taskQueue);
                            $ac26b3b212d6beb6$var$currentTask = $ac26b3b212d6beb6$var$peek($ac26b3b212d6beb6$var$taskQueue);
                        }
                        if (null !== $ac26b3b212d6beb6$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $ac26b3b212d6beb6$var$peek($ac26b3b212d6beb6$var$timerQueue);
                            null !== firstTimer && $ac26b3b212d6beb6$var$requestHostTimeout($ac26b3b212d6beb6$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $ac26b3b212d6beb6$var$currentTask = null, $ac26b3b212d6beb6$var$currentPriorityLevel = previousPriorityLevel, $ac26b3b212d6beb6$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $ac26b3b212d6beb6$var$schedulePerformWorkUntilDeadline() : $ac26b3b212d6beb6$var$isMessageLoopRunning = !1;
        }
    }
}
var $ac26b3b212d6beb6$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $ac26b3b212d6beb6$var$localSetImmediate) $ac26b3b212d6beb6$var$schedulePerformWorkUntilDeadline = function() {
    $ac26b3b212d6beb6$var$localSetImmediate($ac26b3b212d6beb6$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $ac26b3b212d6beb6$var$channel = new MessageChannel(), $ac26b3b212d6beb6$var$port = $ac26b3b212d6beb6$var$channel.port2;
    $ac26b3b212d6beb6$var$channel.port1.onmessage = $ac26b3b212d6beb6$var$performWorkUntilDeadline;
    $ac26b3b212d6beb6$var$schedulePerformWorkUntilDeadline = function() {
        $ac26b3b212d6beb6$var$port.postMessage(null);
    };
} else $ac26b3b212d6beb6$var$schedulePerformWorkUntilDeadline = function() {
    $ac26b3b212d6beb6$var$localSetTimeout($ac26b3b212d6beb6$var$performWorkUntilDeadline, 0);
};
function $ac26b3b212d6beb6$var$requestHostTimeout(callback, ms) {
    $ac26b3b212d6beb6$var$taskTimeoutID = $ac26b3b212d6beb6$var$localSetTimeout(function() {
        callback($ac26b3b212d6beb6$export$c4744153514ff05d());
    }, ms);
}
$ac26b3b212d6beb6$export$3e506c1ccc9cc1a7 = 5;
$ac26b3b212d6beb6$export$e26fe2ed2fa76875 = 1;
$ac26b3b212d6beb6$export$502329bbf4b505b1 = 4;
$ac26b3b212d6beb6$export$6e3807111c4874c4 = 3;
$ac26b3b212d6beb6$export$c27134553091fb3a = null;
$ac26b3b212d6beb6$export$33ee1acdc04fd2a2 = 2;
$ac26b3b212d6beb6$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$ac26b3b212d6beb6$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $ac26b3b212d6beb6$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$ac26b3b212d6beb6$export$d3dfb8e4810cb555 = function() {
    return $ac26b3b212d6beb6$var$currentPriorityLevel;
};
$ac26b3b212d6beb6$export$72fdf0e06517287b = function(eventHandler) {
    switch($ac26b3b212d6beb6$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $ac26b3b212d6beb6$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $ac26b3b212d6beb6$var$currentPriorityLevel;
    $ac26b3b212d6beb6$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $ac26b3b212d6beb6$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$ac26b3b212d6beb6$export$816d2913ae6b83b1 = function() {
    $ac26b3b212d6beb6$var$needsPaint = !0;
};
$ac26b3b212d6beb6$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $ac26b3b212d6beb6$var$currentPriorityLevel;
    $ac26b3b212d6beb6$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $ac26b3b212d6beb6$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$ac26b3b212d6beb6$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $ac26b3b212d6beb6$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $ac26b3b212d6beb6$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $ac26b3b212d6beb6$var$push($ac26b3b212d6beb6$var$timerQueue, priorityLevel), null === $ac26b3b212d6beb6$var$peek($ac26b3b212d6beb6$var$taskQueue) && priorityLevel === $ac26b3b212d6beb6$var$peek($ac26b3b212d6beb6$var$timerQueue) && ($ac26b3b212d6beb6$var$isHostTimeoutScheduled ? ($ac26b3b212d6beb6$var$localClearTimeout($ac26b3b212d6beb6$var$taskTimeoutID), $ac26b3b212d6beb6$var$taskTimeoutID = -1) : $ac26b3b212d6beb6$var$isHostTimeoutScheduled = !0, $ac26b3b212d6beb6$var$requestHostTimeout($ac26b3b212d6beb6$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $ac26b3b212d6beb6$var$push($ac26b3b212d6beb6$var$taskQueue, priorityLevel), $ac26b3b212d6beb6$var$isHostCallbackScheduled || $ac26b3b212d6beb6$var$isPerformingWork || ($ac26b3b212d6beb6$var$isHostCallbackScheduled = !0, $ac26b3b212d6beb6$var$isMessageLoopRunning || ($ac26b3b212d6beb6$var$isMessageLoopRunning = !0, $ac26b3b212d6beb6$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$ac26b3b212d6beb6$export$b5836b71941fa3ed = $ac26b3b212d6beb6$var$shouldYieldToHost;
$ac26b3b212d6beb6$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $ac26b3b212d6beb6$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $ac26b3b212d6beb6$var$currentPriorityLevel;
        $ac26b3b212d6beb6$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $ac26b3b212d6beb6$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("3dD61", function(module, exports) {
'use strict';
function $2580e9a65ae3298e$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($2580e9a65ae3298e$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$2580e9a65ae3298e$var$checkDCE();

module.exports = (parcelRequire("lubGL"));

});
parcelRegister("lubGL", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $fa45777555404396$export$69ce8ef3fe5cead0; }, function (v) { return $fa45777555404396$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "browser", function () { return $fa45777555404396$export$3f2684e5d7cb1006; }, function (v) { return $fa45777555404396$export$3f2684e5d7cb1006 = v; });
$parcel$export(module.exports, "createPortal", function () { return $fa45777555404396$export$d39a5bbd09211389; }, function (v) { return $fa45777555404396$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $fa45777555404396$export$cd75ccfd720a3cd4; }, function (v) { return $fa45777555404396$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $fa45777555404396$export$a0816fa17a9e79be; }, function (v) { return $fa45777555404396$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $fa45777555404396$export$7292efcadded39f3; }, function (v) { return $fa45777555404396$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $fa45777555404396$export$da407abadb9b8f86; }, function (v) { return $fa45777555404396$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $fa45777555404396$export$314cfea32580671c; }, function (v) { return $fa45777555404396$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $fa45777555404396$export$513ccb98c53b8039; }, function (v) { return $fa45777555404396$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $fa45777555404396$export$dbca993bc2d264a; }, function (v) { return $fa45777555404396$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $fa45777555404396$export$4797a8006f0655d0; }, function (v) { return $fa45777555404396$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $fa45777555404396$export$c78a37762a8d58e1; }, function (v) { return $fa45777555404396$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $fa45777555404396$export$606f11b2eb45ecc6; }, function (v) { return $fa45777555404396$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $fa45777555404396$export$f7e8a0bf92324b1e; }, function (v) { return $fa45777555404396$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $fa45777555404396$export$83d89fbfd8236492; }, function (v) { return $fa45777555404396$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $fa45777555404396$export$69ce8ef3fe5cead0;
var $fa45777555404396$export$3f2684e5d7cb1006;
var $fa45777555404396$export$d39a5bbd09211389;
var $fa45777555404396$export$cd75ccfd720a3cd4;
var $fa45777555404396$export$a0816fa17a9e79be;
var $fa45777555404396$export$7292efcadded39f3;
var $fa45777555404396$export$da407abadb9b8f86;
var $fa45777555404396$export$314cfea32580671c;
var $fa45777555404396$export$513ccb98c53b8039;
var $fa45777555404396$export$dbca993bc2d264a;
var $fa45777555404396$export$4797a8006f0655d0;
var $fa45777555404396$export$c78a37762a8d58e1;
var $fa45777555404396$export$606f11b2eb45ecc6;
var $fa45777555404396$export$f7e8a0bf92324b1e;
var $fa45777555404396$export$83d89fbfd8236492;
"use strict";

var $jpgPw = parcelRequire("jpgPw");
function $fa45777555404396$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $fa45777555404396$var$noop() {}
var $fa45777555404396$var$Internals = {
    d: {
        f: $fa45777555404396$var$noop,
        r: function() {
            throw Error($fa45777555404396$var$formatProdErrorMessage(522));
        },
        D: $fa45777555404396$var$noop,
        C: $fa45777555404396$var$noop,
        L: $fa45777555404396$var$noop,
        m: $fa45777555404396$var$noop,
        X: $fa45777555404396$var$noop,
        S: $fa45777555404396$var$noop,
        M: $fa45777555404396$var$noop
    },
    p: 0,
    findDOMNode: null
}, $fa45777555404396$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $fa45777555404396$var$REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), $fa45777555404396$var$REACT_OPTIMISTIC_KEY = Symbol.for("react.optimistic_key");
function $fa45777555404396$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $fa45777555404396$var$REACT_PORTAL_TYPE,
        key: null == key ? null : key === $fa45777555404396$var$REACT_OPTIMISTIC_KEY ? $fa45777555404396$var$REACT_OPTIMISTIC_KEY : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $fa45777555404396$var$ReactSharedInternals = $jpgPw.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $fa45777555404396$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$fa45777555404396$export$69ce8ef3fe5cead0 = $fa45777555404396$var$Internals;
$fa45777555404396$export$3f2684e5d7cb1006 = function(reason) {
    return {
        $$typeof: $fa45777555404396$var$REACT_RECOVERABLE_TYPE,
        _reason: reason
    };
};
$fa45777555404396$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($fa45777555404396$var$formatProdErrorMessage(299));
    return $fa45777555404396$var$createPortal$1(children, container, null, key);
};
$fa45777555404396$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $fa45777555404396$var$ReactSharedInternals.T, previousUpdatePriority = $fa45777555404396$var$Internals.p;
    try {
        if ($fa45777555404396$var$ReactSharedInternals.T = null, $fa45777555404396$var$Internals.p = 2, fn) return fn();
    } finally{
        $fa45777555404396$var$ReactSharedInternals.T = previousTransition, $fa45777555404396$var$Internals.p = previousUpdatePriority, $fa45777555404396$var$Internals.d.f();
    }
};
$fa45777555404396$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $fa45777555404396$var$Internals.d.C(href, options));
};
$fa45777555404396$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $fa45777555404396$var$Internals.d.D(href);
};
$fa45777555404396$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $fa45777555404396$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $fa45777555404396$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $fa45777555404396$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$fa45777555404396$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $fa45777555404396$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $fa45777555404396$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                    fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
                });
            }
        } else null == options && $fa45777555404396$var$Internals.d.M(href);
    }
};
$fa45777555404396$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $fa45777555404396$var$getCrossOriginStringAs(as, options.crossOrigin);
        $fa45777555404396$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$fa45777555404396$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $fa45777555404396$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $fa45777555404396$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
            });
        } else $fa45777555404396$var$Internals.d.m(href);
    }
};
$fa45777555404396$export$4797a8006f0655d0 = function(form) {
    $fa45777555404396$var$Internals.d.r(form);
};
$fa45777555404396$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$fa45777555404396$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $fa45777555404396$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$fa45777555404396$export$f7e8a0bf92324b1e = function() {
    return $fa45777555404396$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$fa45777555404396$export$83d89fbfd8236492 = "19.3.1";

});



parcelRegister("2qbEs", function(module, exports) {

$parcel$export(module.exports, "HelmetProvider", function () { return $1c370c40d12dc48f$export$4719288a8f5f7e71; });
$parcel$export(module.exports, "Helmet", function () { return $1c370c40d12dc48f$export$dcef8f9bb9a41431; });
// src/index.tsx

var $jpgPw = parcelRequire("jpgPw");

var $4zeGV = parcelRequire("4zeGV");

var $4AFr1 = parcelRequire("4AFr1");

var $fDLVH = parcelRequire("fDLVH");
// src/constants.ts
var $1c370c40d12dc48f$var$TAG_NAMES = /* @__PURE__ */ ((TAG_NAMES2)=>{
    TAG_NAMES2["BASE"] = "base";
    TAG_NAMES2["BODY"] = "body";
    TAG_NAMES2["HEAD"] = "head";
    TAG_NAMES2["HTML"] = "html";
    TAG_NAMES2["LINK"] = "link";
    TAG_NAMES2["META"] = "meta";
    TAG_NAMES2["NOSCRIPT"] = "noscript";
    TAG_NAMES2["SCRIPT"] = "script";
    TAG_NAMES2["STYLE"] = "style";
    TAG_NAMES2["TITLE"] = "title";
    TAG_NAMES2["FRAGMENT"] = "Symbol(react.fragment)";
    return TAG_NAMES2;
})($1c370c40d12dc48f$var$TAG_NAMES || {});
var $1c370c40d12dc48f$var$SEO_PRIORITY_TAGS = {
    link: {
        rel: [
            "amphtml",
            "canonical",
            "alternate"
        ]
    },
    script: {
        type: [
            "application/ld+json"
        ]
    },
    meta: {
        charset: "",
        name: [
            "generator",
            "robots",
            "description"
        ],
        property: [
            "og:type",
            "og:title",
            "og:url",
            "og:image",
            "og:image:alt",
            "og:description",
            "twitter:url",
            "twitter:title",
            "twitter:description",
            "twitter:image",
            "twitter:image:alt",
            "twitter:card",
            "twitter:site"
        ]
    }
};
var $1c370c40d12dc48f$var$VALID_TAG_NAMES = Object.values($1c370c40d12dc48f$var$TAG_NAMES);
var $1c370c40d12dc48f$var$REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var $1c370c40d12dc48f$var$HTML_TAG_MAP = Object.entries($1c370c40d12dc48f$var$REACT_TAG_MAP).reduce((carry, [key, value])=>{
    carry[value] = key;
    return carry;
}, {});
var $1c370c40d12dc48f$var$HELMET_ATTRIBUTE = "data-rh";
// src/utils.ts
var $1c370c40d12dc48f$var$HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate",
    PRIORITIZE_SEO_TAGS: "prioritizeSeoTags"
};
var $1c370c40d12dc48f$var$getInnermostProperty = (propsList, property)=>{
    for(let i = propsList.length - 1; i >= 0; i -= 1){
        const props = propsList[i];
        if (Object.prototype.hasOwnProperty.call(props, property)) return props[property];
    }
    return null;
};
var $1c370c40d12dc48f$var$getTitleFromPropsList = (propsList)=>{
    let innermostTitle = $1c370c40d12dc48f$var$getInnermostProperty(propsList, "title" /* TITLE */ );
    const innermostTemplate = $1c370c40d12dc48f$var$getInnermostProperty(propsList, $1c370c40d12dc48f$var$HELMET_PROPS.TITLE_TEMPLATE);
    if (Array.isArray(innermostTitle)) innermostTitle = innermostTitle.join("");
    if (innermostTemplate && innermostTitle) return innermostTemplate.replace(/%s/g, ()=>innermostTitle);
    const innermostDefaultTitle = $1c370c40d12dc48f$var$getInnermostProperty(propsList, $1c370c40d12dc48f$var$HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || void 0;
};
var $1c370c40d12dc48f$var$getOnChangeClientState = (propsList)=>$1c370c40d12dc48f$var$getInnermostProperty(propsList, $1c370c40d12dc48f$var$HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || (()=>{});
var $1c370c40d12dc48f$var$getAttributesFromPropsList = (tagType, propsList)=>propsList.filter((props)=>typeof props[tagType] !== "undefined").map((props)=>props[tagType]).reduce((tagAttrs, current)=>({
            ...tagAttrs,
            ...current
        }), {});
var $1c370c40d12dc48f$var$getBaseTagFromPropsList = (primaryAttributes, propsList)=>propsList.filter((props)=>typeof props["base" /* BASE */ ] !== "undefined").map((props)=>props["base" /* BASE */ ]).reverse().reduce((innermostBaseTag, tag)=>{
        if (!innermostBaseTag.length) {
            const keys = Object.keys(tag);
            for(let i = 0; i < keys.length; i += 1){
                const attributeKey = keys[i];
                const lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
var $1c370c40d12dc48f$var$warn = (msg)=>console && typeof console.warn === "function" && console.warn(msg);
var $1c370c40d12dc48f$var$getTagsFromPropsList = (tagName, primaryAttributes, propsList)=>{
    const approvedSeenTags = {};
    return propsList.filter((props)=>{
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") $1c370c40d12dc48f$var$warn(`Helmet: ${tagName} should be of type "Array". Instead found type "${typeof props[tagName]}"`);
        return false;
    }).map((props)=>props[tagName]).reverse().reduce((approvedTags, instanceTags)=>{
        const instanceSeenTags = {};
        instanceTags.filter((tag)=>{
            let primaryAttributeKey;
            const keys2 = Object.keys(tag);
            for(let i = 0; i < keys2.length; i += 1){
                const attributeKey = keys2[i];
                const lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === "rel" /* REL */  && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === "rel" /* REL */  && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === "innerHTML" /* INNER_HTML */  || attributeKey === "cssText" /* CSS_TEXT */  || attributeKey === "itemprop" /* ITEM_PROP */ )) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            const value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach((tag)=>approvedTags.push(tag));
        const keys = Object.keys(instanceSeenTags);
        for(let i = 0; i < keys.length; i += 1){
            const attributeKey = keys[i];
            const tagUnion = {
                ...approvedSeenTags[attributeKey],
                ...instanceSeenTags[attributeKey]
            };
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var $1c370c40d12dc48f$var$getAnyTrueFromPropsList = (propsList, checkedTag)=>{
    if (Array.isArray(propsList) && propsList.length) for(let index = 0; index < propsList.length; index += 1){
        const prop = propsList[index];
        if (prop[checkedTag]) return true;
    }
    return false;
};
var $1c370c40d12dc48f$var$reducePropsToState = (propsList)=>({
        baseTag: $1c370c40d12dc48f$var$getBaseTagFromPropsList([
            "href" /* HREF */ 
        ], propsList),
        bodyAttributes: $1c370c40d12dc48f$var$getAttributesFromPropsList("bodyAttributes" /* BODY */ , propsList),
        defer: $1c370c40d12dc48f$var$getInnermostProperty(propsList, $1c370c40d12dc48f$var$HELMET_PROPS.DEFER),
        encode: $1c370c40d12dc48f$var$getInnermostProperty(propsList, $1c370c40d12dc48f$var$HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: $1c370c40d12dc48f$var$getAttributesFromPropsList("htmlAttributes" /* HTML */ , propsList),
        linkTags: $1c370c40d12dc48f$var$getTagsFromPropsList("link" /* LINK */ , [
            "rel" /* REL */ ,
            "href" /* HREF */ 
        ], propsList),
        metaTags: $1c370c40d12dc48f$var$getTagsFromPropsList("meta" /* META */ , [
            "name" /* NAME */ ,
            "charset" /* CHARSET */ ,
            "http-equiv" /* HTTPEQUIV */ ,
            "property" /* PROPERTY */ ,
            "itemprop" /* ITEM_PROP */ 
        ], propsList),
        noscriptTags: $1c370c40d12dc48f$var$getTagsFromPropsList("noscript" /* NOSCRIPT */ , [
            "innerHTML" /* INNER_HTML */ 
        ], propsList),
        onChangeClientState: $1c370c40d12dc48f$var$getOnChangeClientState(propsList),
        scriptTags: $1c370c40d12dc48f$var$getTagsFromPropsList("script" /* SCRIPT */ , [
            "src" /* SRC */ ,
            "innerHTML" /* INNER_HTML */ 
        ], propsList),
        styleTags: $1c370c40d12dc48f$var$getTagsFromPropsList("style" /* STYLE */ , [
            "cssText" /* CSS_TEXT */ 
        ], propsList),
        title: $1c370c40d12dc48f$var$getTitleFromPropsList(propsList),
        titleAttributes: $1c370c40d12dc48f$var$getAttributesFromPropsList("titleAttributes" /* TITLE */ , propsList),
        prioritizeSeoTags: $1c370c40d12dc48f$var$getAnyTrueFromPropsList(propsList, $1c370c40d12dc48f$var$HELMET_PROPS.PRIORITIZE_SEO_TAGS)
    });
var $1c370c40d12dc48f$var$flattenArray = (possibleArray)=>Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
var $1c370c40d12dc48f$var$checkIfPropsMatch = (props, toMatch)=>{
    const keys = Object.keys(props);
    for(let i = 0; i < keys.length; i += 1){
        if (toMatch[keys[i]] && toMatch[keys[i]].includes(props[keys[i]])) return true;
    }
    return false;
};
var $1c370c40d12dc48f$var$prioritizer = (elementsList, propsToMatch)=>{
    if (Array.isArray(elementsList)) return elementsList.reduce((acc, elementAttrs)=>{
        if ($1c370c40d12dc48f$var$checkIfPropsMatch(elementAttrs, propsToMatch)) acc.priority.push(elementAttrs);
        else acc.default.push(elementAttrs);
        return acc;
    }, {
        priority: [],
        default: []
    });
    return {
        default: elementsList,
        priority: []
    };
};
var $1c370c40d12dc48f$var$without = (obj, key)=>{
    return {
        ...obj,
        [key]: void 0
    };
};
// src/server.ts
var $1c370c40d12dc48f$var$SELF_CLOSING_TAGS = [
    "noscript" /* NOSCRIPT */ ,
    "script" /* SCRIPT */ ,
    "style" /* STYLE */ 
];
var $1c370c40d12dc48f$var$encodeSpecialCharacters = (str, encode = true)=>{
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var $1c370c40d12dc48f$var$generateElementAttributesAsString = (attributes)=>Object.keys(attributes).reduce((str, key)=>{
        const attr = typeof attributes[key] !== "undefined" ? `${key}="${attributes[key]}"` : `${key}`;
        return str ? `${str} ${attr}` : attr;
    }, "");
var $1c370c40d12dc48f$var$generateTitleAsString = (type, title, attributes, encode)=>{
    const attributeString = $1c370c40d12dc48f$var$generateElementAttributesAsString(attributes);
    const flattenedTitle = $1c370c40d12dc48f$var$flattenArray(title);
    return attributeString ? `<${type} ${$1c370c40d12dc48f$var$HELMET_ATTRIBUTE}="true" ${attributeString}>${$1c370c40d12dc48f$var$encodeSpecialCharacters(flattenedTitle, encode)}</${type}>` : `<${type} ${$1c370c40d12dc48f$var$HELMET_ATTRIBUTE}="true">${$1c370c40d12dc48f$var$encodeSpecialCharacters(flattenedTitle, encode)}</${type}>`;
};
var $1c370c40d12dc48f$var$generateTagsAsString = (type, tags, encode = true)=>tags.reduce((str, t)=>{
        const tag = t;
        const attributeHtml = Object.keys(tag).filter((attribute)=>!(attribute === "innerHTML" /* INNER_HTML */  || attribute === "cssText" /* CSS_TEXT */ )).reduce((string, attribute)=>{
            const attr = typeof tag[attribute] === "undefined" ? attribute : `${attribute}="${$1c370c40d12dc48f$var$encodeSpecialCharacters(tag[attribute], encode)}"`;
            return string ? `${string} ${attr}` : attr;
        }, "");
        const tagContent = tag.innerHTML || tag.cssText || "";
        const isSelfClosing = $1c370c40d12dc48f$var$SELF_CLOSING_TAGS.indexOf(type) === -1;
        return `${str}<${type} ${$1c370c40d12dc48f$var$HELMET_ATTRIBUTE}="true" ${attributeHtml}${isSelfClosing ? `/>` : `>${tagContent}</${type}>`}`;
    }, "");
var $1c370c40d12dc48f$var$convertElementAttributesToReactProps = (attributes, initProps = {})=>Object.keys(attributes).reduce((obj, key)=>{
        const mapped = $1c370c40d12dc48f$var$REACT_TAG_MAP[key];
        obj[mapped || key] = attributes[key];
        return obj;
    }, initProps);
var $1c370c40d12dc48f$var$generateTitleAsReactComponent = (_type, title, attributes)=>{
    const initProps = {
        key: title,
        [$1c370c40d12dc48f$var$HELMET_ATTRIBUTE]: true
    };
    const props = $1c370c40d12dc48f$var$convertElementAttributesToReactProps(attributes, initProps);
    return [
        (0, (/*@__PURE__*/$parcel$interopDefault($jpgPw))).createElement("title" /* TITLE */ , props, title)
    ];
};
var $1c370c40d12dc48f$var$generateTagsAsReactComponent = (type, tags)=>tags.map((tag, i)=>{
        const mappedTag = {
            key: i,
            [$1c370c40d12dc48f$var$HELMET_ATTRIBUTE]: true
        };
        Object.keys(tag).forEach((attribute)=>{
            const mapped = $1c370c40d12dc48f$var$REACT_TAG_MAP[attribute];
            const mappedAttribute = mapped || attribute;
            if (mappedAttribute === "innerHTML" /* INNER_HTML */  || mappedAttribute === "cssText" /* CSS_TEXT */ ) {
                const content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($jpgPw))).createElement(type, mappedTag);
    });
var $1c370c40d12dc48f$var$getMethodsForTag = (type, tags, encode = true)=>{
    switch(type){
        case "title" /* TITLE */ :
            return {
                toComponent: ()=>$1c370c40d12dc48f$var$generateTitleAsReactComponent(type, tags.title, tags.titleAttributes),
                toString: ()=>$1c370c40d12dc48f$var$generateTitleAsString(type, tags.title, tags.titleAttributes, encode)
            };
        case "bodyAttributes" /* BODY */ :
        case "htmlAttributes" /* HTML */ :
            return {
                toComponent: ()=>$1c370c40d12dc48f$var$convertElementAttributesToReactProps(tags),
                toString: ()=>$1c370c40d12dc48f$var$generateElementAttributesAsString(tags)
            };
        default:
            return {
                toComponent: ()=>$1c370c40d12dc48f$var$generateTagsAsReactComponent(type, tags),
                toString: ()=>$1c370c40d12dc48f$var$generateTagsAsString(type, tags, encode)
            };
    }
};
var $1c370c40d12dc48f$var$getPriorityMethods = ({ metaTags: metaTags, linkTags: linkTags, scriptTags: scriptTags, encode: encode })=>{
    const meta = $1c370c40d12dc48f$var$prioritizer(metaTags, $1c370c40d12dc48f$var$SEO_PRIORITY_TAGS.meta);
    const link = $1c370c40d12dc48f$var$prioritizer(linkTags, $1c370c40d12dc48f$var$SEO_PRIORITY_TAGS.link);
    const script = $1c370c40d12dc48f$var$prioritizer(scriptTags, $1c370c40d12dc48f$var$SEO_PRIORITY_TAGS.script);
    const priorityMethods = {
        toComponent: ()=>[
                ...$1c370c40d12dc48f$var$generateTagsAsReactComponent("meta" /* META */ , meta.priority),
                ...$1c370c40d12dc48f$var$generateTagsAsReactComponent("link" /* LINK */ , link.priority),
                ...$1c370c40d12dc48f$var$generateTagsAsReactComponent("script" /* SCRIPT */ , script.priority)
            ],
        toString: ()=>// generate all the tags as strings and concatenate them
            `${$1c370c40d12dc48f$var$getMethodsForTag("meta" /* META */ , meta.priority, encode)} ${$1c370c40d12dc48f$var$getMethodsForTag("link" /* LINK */ , link.priority, encode)} ${$1c370c40d12dc48f$var$getMethodsForTag("script" /* SCRIPT */ , script.priority, encode)}`
    };
    return {
        priorityMethods: priorityMethods,
        metaTags: meta.default,
        linkTags: link.default,
        scriptTags: script.default
    };
};
var $1c370c40d12dc48f$var$mapStateOnServer = (props)=>{
    const { baseTag: baseTag, bodyAttributes: bodyAttributes, encode: encode = true, htmlAttributes: htmlAttributes, noscriptTags: noscriptTags, styleTags: styleTags, title: title = "", titleAttributes: titleAttributes, prioritizeSeoTags: prioritizeSeoTags } = props;
    let { linkTags: linkTags, metaTags: metaTags, scriptTags: scriptTags } = props;
    let priorityMethods = {
        toComponent: ()=>[],
        toString: ()=>""
    };
    if (prioritizeSeoTags) ({ priorityMethods: priorityMethods, linkTags: linkTags, metaTags: metaTags, scriptTags: scriptTags } = $1c370c40d12dc48f$var$getPriorityMethods(props));
    return {
        priority: priorityMethods,
        base: $1c370c40d12dc48f$var$getMethodsForTag("base" /* BASE */ , baseTag, encode),
        bodyAttributes: $1c370c40d12dc48f$var$getMethodsForTag("bodyAttributes" /* BODY */ , bodyAttributes, encode),
        htmlAttributes: $1c370c40d12dc48f$var$getMethodsForTag("htmlAttributes" /* HTML */ , htmlAttributes, encode),
        link: $1c370c40d12dc48f$var$getMethodsForTag("link" /* LINK */ , linkTags, encode),
        meta: $1c370c40d12dc48f$var$getMethodsForTag("meta" /* META */ , metaTags, encode),
        noscript: $1c370c40d12dc48f$var$getMethodsForTag("noscript" /* NOSCRIPT */ , noscriptTags, encode),
        script: $1c370c40d12dc48f$var$getMethodsForTag("script" /* SCRIPT */ , scriptTags, encode),
        style: $1c370c40d12dc48f$var$getMethodsForTag("style" /* STYLE */ , styleTags, encode),
        title: $1c370c40d12dc48f$var$getMethodsForTag("title" /* TITLE */ , {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
var $1c370c40d12dc48f$var$server_default = $1c370c40d12dc48f$var$mapStateOnServer;
// src/HelmetData.ts
var $1c370c40d12dc48f$var$instances = [];
var $1c370c40d12dc48f$var$isDocument = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var $1c370c40d12dc48f$export$a9cf6990c9c7feb9 = class {
    instances = [];
    canUseDOM = $1c370c40d12dc48f$var$isDocument;
    context;
    value = {
        setHelmet: (serverState)=>{
            this.context.helmet = serverState;
        },
        helmetInstances: {
            get: ()=>this.canUseDOM ? $1c370c40d12dc48f$var$instances : this.instances,
            add: (instance)=>{
                (this.canUseDOM ? $1c370c40d12dc48f$var$instances : this.instances).push(instance);
            },
            remove: (instance)=>{
                const index = (this.canUseDOM ? $1c370c40d12dc48f$var$instances : this.instances).indexOf(instance);
                (this.canUseDOM ? $1c370c40d12dc48f$var$instances : this.instances).splice(index, 1);
            }
        }
    };
    constructor(context, canUseDOM){
        this.context = context;
        this.canUseDOM = canUseDOM || false;
        if (!canUseDOM) context.helmet = $1c370c40d12dc48f$var$server_default({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
    }
};
var $1c370c40d12dc48f$var$major = parseInt((0, (/*@__PURE__*/$parcel$interopDefault($jpgPw))).version.split(".")[0], 10);
var $1c370c40d12dc48f$var$isReact19 = $1c370c40d12dc48f$var$major >= 19;
// src/Provider.tsx
var $1c370c40d12dc48f$var$defaultValue = {};
var $1c370c40d12dc48f$var$Context = (0, (/*@__PURE__*/$parcel$interopDefault($jpgPw))).createContext($1c370c40d12dc48f$var$defaultValue);
var $1c370c40d12dc48f$export$4719288a8f5f7e71 = class _HelmetProvider extends (0, $jpgPw.Component) {
    static canUseDOM = $1c370c40d12dc48f$var$isDocument;
    helmetData;
    constructor(props){
        super(props);
        if ($1c370c40d12dc48f$var$isReact19) this.helmetData = null;
        else this.helmetData = new $1c370c40d12dc48f$export$a9cf6990c9c7feb9(this.props.context || {}, _HelmetProvider.canUseDOM);
    }
    render() {
        if ($1c370c40d12dc48f$var$isReact19) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($jpgPw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jpgPw))).Fragment, null, this.props.children);
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($jpgPw))).createElement($1c370c40d12dc48f$var$Context.Provider, {
            value: this.helmetData.value
        }, this.props.children);
    }
};
// src/client.ts
var $1c370c40d12dc48f$var$updateTags = (type, tags)=>{
    const headElement = document.head || document.querySelector("head" /* HEAD */ );
    const tagNodes = headElement.querySelectorAll(`${type}[${$1c370c40d12dc48f$var$HELMET_ATTRIBUTE}]`);
    const oldTags = [].slice.call(tagNodes);
    const newTags = [];
    let indexToDelete;
    if (tags && tags.length) tags.forEach((tag)=>{
        const newElement = document.createElement(type);
        for(const attribute in tag)if (Object.prototype.hasOwnProperty.call(tag, attribute)) {
            if (attribute === "innerHTML" /* INNER_HTML */ ) newElement.innerHTML = tag.innerHTML;
            else if (attribute === "cssText" /* CSS_TEXT */ ) {
                const cssText = tag.cssText;
                newElement.appendChild(document.createTextNode(cssText));
            } else {
                const attr = attribute;
                const value = typeof tag[attr] === "undefined" ? "" : tag[attr];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute($1c370c40d12dc48f$var$HELMET_ATTRIBUTE, "true");
        if (oldTags.some((existingTag, index)=>{
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach((tag)=>tag.parentNode?.removeChild(tag));
    newTags.forEach((tag)=>headElement.appendChild(tag));
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var $1c370c40d12dc48f$var$updateAttributes = (tagName, attributes)=>{
    const elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    const helmetAttributeString = elementTag.getAttribute($1c370c40d12dc48f$var$HELMET_ATTRIBUTE);
    const helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    const attributesToRemove = [
        ...helmetAttributes
    ];
    const attributeKeys = Object.keys(attributes);
    for (const attribute of attributeKeys){
        const value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        const indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(let i = attributesToRemove.length - 1; i >= 0; i -= 1)elementTag.removeAttribute(attributesToRemove[i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute($1c370c40d12dc48f$var$HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute($1c370c40d12dc48f$var$HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute($1c370c40d12dc48f$var$HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var $1c370c40d12dc48f$var$updateTitle = (title, attributes)=>{
    if (typeof title !== "undefined" && document.title !== title) document.title = $1c370c40d12dc48f$var$flattenArray(title);
    $1c370c40d12dc48f$var$updateAttributes("title" /* TITLE */ , attributes);
};
var $1c370c40d12dc48f$var$commitTagChanges = (newState, cb)=>{
    const { baseTag: baseTag, bodyAttributes: bodyAttributes, htmlAttributes: htmlAttributes, linkTags: linkTags, metaTags: metaTags, noscriptTags: noscriptTags, onChangeClientState: onChangeClientState, scriptTags: scriptTags, styleTags: styleTags, title: title, titleAttributes: titleAttributes } = newState;
    $1c370c40d12dc48f$var$updateAttributes("body" /* BODY */ , bodyAttributes);
    $1c370c40d12dc48f$var$updateAttributes("html" /* HTML */ , htmlAttributes);
    $1c370c40d12dc48f$var$updateTitle(title, titleAttributes);
    const tagUpdates = {
        baseTag: $1c370c40d12dc48f$var$updateTags("base" /* BASE */ , baseTag),
        linkTags: $1c370c40d12dc48f$var$updateTags("link" /* LINK */ , linkTags),
        metaTags: $1c370c40d12dc48f$var$updateTags("meta" /* META */ , metaTags),
        noscriptTags: $1c370c40d12dc48f$var$updateTags("noscript" /* NOSCRIPT */ , noscriptTags),
        scriptTags: $1c370c40d12dc48f$var$updateTags("script" /* SCRIPT */ , scriptTags),
        styleTags: $1c370c40d12dc48f$var$updateTags("style" /* STYLE */ , styleTags)
    };
    const addedTags = {};
    const removedTags = {};
    Object.keys(tagUpdates).forEach((tagType)=>{
        const { newTags: newTags, oldTags: oldTags } = tagUpdates[tagType];
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    if (cb) cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var $1c370c40d12dc48f$var$_helmetCallback = null;
var $1c370c40d12dc48f$var$handleStateChangeOnClient = (newState)=>{
    if ($1c370c40d12dc48f$var$_helmetCallback) cancelAnimationFrame($1c370c40d12dc48f$var$_helmetCallback);
    if (newState.defer) $1c370c40d12dc48f$var$_helmetCallback = requestAnimationFrame(()=>{
        $1c370c40d12dc48f$var$commitTagChanges(newState, ()=>{
            $1c370c40d12dc48f$var$_helmetCallback = null;
        });
    });
    else {
        $1c370c40d12dc48f$var$commitTagChanges(newState);
        $1c370c40d12dc48f$var$_helmetCallback = null;
    }
};
var $1c370c40d12dc48f$var$client_default = $1c370c40d12dc48f$var$handleStateChangeOnClient;
// src/Dispatcher.tsx
var $1c370c40d12dc48f$var$HelmetDispatcher = class extends (0, $jpgPw.Component) {
    rendered = false;
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($fDLVH)))(nextProps, this.props);
    }
    componentDidUpdate() {
        this.emitChange();
    }
    componentWillUnmount() {
        const { helmetInstances: helmetInstances } = this.props.context;
        helmetInstances.remove(this);
        this.emitChange();
    }
    emitChange() {
        const { helmetInstances: helmetInstances, setHelmet: setHelmet } = this.props.context;
        let serverState = null;
        const state = $1c370c40d12dc48f$var$reducePropsToState(helmetInstances.get().map((instance)=>{
            const { context: _context, ...props } = instance.props;
            return props;
        }));
        if ($1c370c40d12dc48f$export$4719288a8f5f7e71.canUseDOM) $1c370c40d12dc48f$var$client_default(state);
        else if ($1c370c40d12dc48f$var$server_default) serverState = $1c370c40d12dc48f$var$server_default(state);
        setHelmet(serverState);
    }
    // componentWillMount will be deprecated
    // for SSR, initialize on first render
    // constructor is also unsafe in StrictMode
    init() {
        if (this.rendered) return;
        this.rendered = true;
        const { helmetInstances: helmetInstances } = this.props.context;
        helmetInstances.add(this);
        this.emitChange();
    }
    render() {
        this.init();
        return null;
    }
};
var $1c370c40d12dc48f$var$react19Instances = [];
var $1c370c40d12dc48f$var$toHtmlAttributes = (props)=>{
    const result = {};
    for (const key of Object.keys(props))result[$1c370c40d12dc48f$var$HTML_TAG_MAP[key] || key] = props[key];
    return result;
};
var $1c370c40d12dc48f$var$toReactProps = (attrs)=>{
    const result = {};
    for (const key of Object.keys(attrs)){
        const mapped = $1c370c40d12dc48f$var$REACT_TAG_MAP[key];
        result[mapped || key] = attrs[key];
    }
    return result;
};
var $1c370c40d12dc48f$var$applyAttributes = (tagName, attributes)=>{
    if (!$1c370c40d12dc48f$var$isDocument) return;
    const el = document.getElementsByTagName(tagName)[0];
    if (!el) return;
    const managedAttr = "data-rh-managed";
    const prev = el.getAttribute(managedAttr);
    const prevKeys = prev ? prev.split(",") : [];
    const nextKeys = Object.keys(attributes);
    for (const key of prevKeys)if (!nextKeys.includes(key)) el.removeAttribute(key);
    for (const key of nextKeys){
        const value = attributes[key];
        if (value === void 0 || value === null || value === false) el.removeAttribute(key);
        else if (value === true) el.setAttribute(key, "");
        else el.setAttribute(key, String(value));
    }
    if (nextKeys.length > 0) el.setAttribute(managedAttr, nextKeys.join(","));
    else el.removeAttribute(managedAttr);
};
var $1c370c40d12dc48f$var$syncAllAttributes = ()=>{
    const htmlAttrs = {};
    const bodyAttrs = {};
    for (const instance of $1c370c40d12dc48f$var$react19Instances){
        const { htmlAttributes: htmlAttributes, bodyAttributes: bodyAttributes } = instance.props;
        if (htmlAttributes) Object.assign(htmlAttrs, $1c370c40d12dc48f$var$toHtmlAttributes(htmlAttributes));
        if (bodyAttributes) Object.assign(bodyAttrs, $1c370c40d12dc48f$var$toHtmlAttributes(bodyAttributes));
    }
    $1c370c40d12dc48f$var$applyAttributes("html" /* HTML */ , htmlAttrs);
    $1c370c40d12dc48f$var$applyAttributes("body" /* BODY */ , bodyAttrs);
};
var $1c370c40d12dc48f$var$React19Dispatcher = class extends (0, $jpgPw.Component) {
    componentDidMount() {
        $1c370c40d12dc48f$var$react19Instances.push(this);
        $1c370c40d12dc48f$var$syncAllAttributes();
    }
    componentDidUpdate() {
        $1c370c40d12dc48f$var$syncAllAttributes();
    }
    componentWillUnmount() {
        const index = $1c370c40d12dc48f$var$react19Instances.indexOf(this);
        if (index !== -1) $1c370c40d12dc48f$var$react19Instances.splice(index, 1);
        $1c370c40d12dc48f$var$syncAllAttributes();
    }
    resolveTitle() {
        const { title: title, titleTemplate: titleTemplate, defaultTitle: defaultTitle } = this.props;
        if (title && titleTemplate) return titleTemplate.replace(/%s/g, ()=>Array.isArray(title) ? title.join("") : title);
        return title || defaultTitle || void 0;
    }
    renderTitle() {
        const title = this.resolveTitle();
        if (title === void 0) return null;
        const titleAttributes = this.props.titleAttributes || {};
        return (0, (/*@__PURE__*/$parcel$interopDefault($jpgPw))).createElement("title" /* TITLE */ , $1c370c40d12dc48f$var$toReactProps(titleAttributes), title);
    }
    renderBase() {
        const { base: base } = this.props;
        if (!base) return null;
        return (0, (/*@__PURE__*/$parcel$interopDefault($jpgPw))).createElement("base" /* BASE */ , $1c370c40d12dc48f$var$toReactProps(base));
    }
    renderMeta() {
        const { meta: meta } = this.props;
        if (!meta || !Array.isArray(meta)) return null;
        return meta.map((attrs, i)=>(0, (/*@__PURE__*/$parcel$interopDefault($jpgPw))).createElement("meta" /* META */ , {
                key: i,
                ...$1c370c40d12dc48f$var$toReactProps(attrs)
            }));
    }
    renderLink() {
        const { link: link } = this.props;
        if (!link || !Array.isArray(link)) return null;
        return link.map((attrs, i)=>(0, (/*@__PURE__*/$parcel$interopDefault($jpgPw))).createElement("link" /* LINK */ , {
                key: i,
                ...$1c370c40d12dc48f$var$toReactProps(attrs)
            }));
    }
    renderScript() {
        const { script: script } = this.props;
        if (!script || !Array.isArray(script)) return null;
        return script.map((attrs, i)=>{
            const { innerHTML: innerHTML, ...rest } = attrs;
            const props = $1c370c40d12dc48f$var$toReactProps(rest);
            if (innerHTML) props.dangerouslySetInnerHTML = {
                __html: innerHTML
            };
            return (0, (/*@__PURE__*/$parcel$interopDefault($jpgPw))).createElement("script" /* SCRIPT */ , {
                key: i,
                ...props
            });
        });
    }
    renderStyle() {
        const { style: style } = this.props;
        if (!style || !Array.isArray(style)) return null;
        return style.map((attrs, i)=>{
            const { cssText: cssText, ...rest } = attrs;
            const props = $1c370c40d12dc48f$var$toReactProps(rest);
            if (cssText) props.dangerouslySetInnerHTML = {
                __html: cssText
            };
            return (0, (/*@__PURE__*/$parcel$interopDefault($jpgPw))).createElement("style" /* STYLE */ , {
                key: i,
                ...props
            });
        });
    }
    renderNoscript() {
        const { noscript: noscript } = this.props;
        if (!noscript || !Array.isArray(noscript)) return null;
        return noscript.map((attrs, i)=>{
            const { innerHTML: innerHTML, ...rest } = attrs;
            const props = $1c370c40d12dc48f$var$toReactProps(rest);
            if (innerHTML) props.dangerouslySetInnerHTML = {
                __html: innerHTML
            };
            return (0, (/*@__PURE__*/$parcel$interopDefault($jpgPw))).createElement("noscript" /* NOSCRIPT */ , {
                key: i,
                ...props
            });
        });
    }
    render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($jpgPw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jpgPw))).Fragment, null, this.renderTitle(), this.renderBase(), this.renderMeta(), this.renderLink(), this.renderScript(), this.renderStyle(), this.renderNoscript());
    }
};
// src/index.tsx
var $1c370c40d12dc48f$export$dcef8f9bb9a41431 = class extends (0, $jpgPw.Component) {
    static defaultProps = {
        defer: true,
        encodeSpecialCharacters: true,
        prioritizeSeoTags: false
    };
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($4zeGV)))($1c370c40d12dc48f$var$without(this.props, "helmetData"), $1c370c40d12dc48f$var$without(nextProps, "helmetData"));
    }
    mapNestedChildrenToProps(child, nestedChildren) {
        if (!nestedChildren) return null;
        switch(child.type){
            case "script" /* SCRIPT */ :
            case "noscript" /* NOSCRIPT */ :
                return {
                    innerHTML: nestedChildren
                };
            case "style" /* STYLE */ :
                return {
                    cssText: nestedChildren
                };
            default:
                throw new Error(`<${child.type} /> elements are self-closing and can not contain children. Refer to our API for more information.`);
        }
    }
    flattenArrayTypeChildren(child, arrayTypeChildren, newChildProps, nestedChildren) {
        return {
            ...arrayTypeChildren,
            [child.type]: [
                ...arrayTypeChildren[child.type] || [],
                {
                    ...newChildProps,
                    ...this.mapNestedChildrenToProps(child, nestedChildren)
                }
            ]
        };
    }
    mapObjectTypeChildren(child, newProps, newChildProps, nestedChildren) {
        switch(child.type){
            case "title" /* TITLE */ :
                return {
                    ...newProps,
                    [child.type]: nestedChildren,
                    titleAttributes: {
                        ...newChildProps
                    }
                };
            case "body" /* BODY */ :
                return {
                    ...newProps,
                    bodyAttributes: {
                        ...newChildProps
                    }
                };
            case "html" /* HTML */ :
                return {
                    ...newProps,
                    htmlAttributes: {
                        ...newChildProps
                    }
                };
            default:
                return {
                    ...newProps,
                    [child.type]: {
                        ...newChildProps
                    }
                };
        }
    }
    mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
        let newFlattenedProps = {
            ...newProps
        };
        Object.keys(arrayTypeChildren).forEach((arrayChildName)=>{
            newFlattenedProps = {
                ...newFlattenedProps,
                [arrayChildName]: arrayTypeChildren[arrayChildName]
            };
        });
        return newFlattenedProps;
    }
    warnOnInvalidChildren(child, nestedChildren) {
        (0, (/*@__PURE__*/$parcel$interopDefault($4AFr1)))($1c370c40d12dc48f$var$VALID_TAG_NAMES.some((name)=>child.type === name), typeof child.type === "function" ? `You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.` : `Only elements types ${$1c370c40d12dc48f$var$VALID_TAG_NAMES.join(", ")} are allowed. Helmet does not support rendering <${child.type}> elements. Refer to our API for more information.`);
        (0, (/*@__PURE__*/$parcel$interopDefault($4AFr1)))(!nestedChildren || typeof nestedChildren === "string" || Array.isArray(nestedChildren) && !nestedChildren.some((nestedChild)=>typeof nestedChild !== "string"), `Helmet expects a string as a child of <${child.type}>. Did you forget to wrap your children in braces? ( <${child.type}>{\`\`}</${child.type}> ) Refer to our API for more information.`);
        return true;
    }
    mapChildrenToProps(children, newProps) {
        let arrayTypeChildren = {};
        (0, (/*@__PURE__*/$parcel$interopDefault($jpgPw))).Children.forEach(children, (child)=>{
            if (!child || !child.props) return;
            const { children: nestedChildren, ...childProps } = child.props;
            const newChildProps = Object.keys(childProps).reduce((obj, key)=>{
                obj[$1c370c40d12dc48f$var$HTML_TAG_MAP[key] || key] = childProps[key];
                return obj;
            }, {});
            let { type: type } = child;
            if (typeof type === "symbol") type = type.toString();
            else this.warnOnInvalidChildren(child, nestedChildren);
            switch(type){
                case "Symbol(react.fragment)" /* FRAGMENT */ :
                    newProps = this.mapChildrenToProps(nestedChildren, newProps);
                    break;
                case "link" /* LINK */ :
                case "meta" /* META */ :
                case "noscript" /* NOSCRIPT */ :
                case "script" /* SCRIPT */ :
                case "style" /* STYLE */ :
                    arrayTypeChildren = this.flattenArrayTypeChildren(child, arrayTypeChildren, newChildProps, nestedChildren);
                    break;
                default:
                    newProps = this.mapObjectTypeChildren(child, newProps, newChildProps, nestedChildren);
                    break;
            }
        });
        return this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
    }
    render() {
        const { children: children, ...props } = this.props;
        let newProps = {
            ...props
        };
        let { helmetData: helmetData } = props;
        if (children) newProps = this.mapChildrenToProps(children, newProps);
        if (helmetData && !(helmetData instanceof $1c370c40d12dc48f$export$a9cf6990c9c7feb9)) {
            const data = helmetData;
            helmetData = new $1c370c40d12dc48f$export$a9cf6990c9c7feb9(data.context, true);
            delete newProps.helmetData;
        }
        if ($1c370c40d12dc48f$var$isReact19) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($jpgPw))).createElement($1c370c40d12dc48f$var$React19Dispatcher, {
            ...newProps
        });
        return helmetData ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($jpgPw))).createElement($1c370c40d12dc48f$var$HelmetDispatcher, {
            ...newProps,
            context: helmetData.value
        }) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($jpgPw))).createElement($1c370c40d12dc48f$var$Context.Consumer, null, (context)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($jpgPw))).createElement($1c370c40d12dc48f$var$HelmetDispatcher, {
                ...newProps,
                context: context
            }));
    }
};

});
parcelRegister("4zeGV", function(module, exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $3535d3b342cc3ae6$var$hasElementType = typeof Element !== 'undefined';
var $3535d3b342cc3ae6$var$hasMap = typeof Map === 'function';
var $3535d3b342cc3ae6$var$hasSet = typeof Set === 'function';
var $3535d3b342cc3ae6$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $3535d3b342cc3ae6$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$3535d3b342cc3ae6$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($3535d3b342cc3ae6$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$3535d3b342cc3ae6$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($3535d3b342cc3ae6$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($3535d3b342cc3ae6$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($3535d3b342cc3ae6$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$3535d3b342cc3ae6$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return $3535d3b342cc3ae6$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("4AFr1", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $357aaa538e4e490a$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = $357aaa538e4e490a$var$invariant;

});

parcelRegister("fDLVH", function(module, exports) {
//
module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};

});


parcelRegister("eQhQZ", function(module, exports) {

$parcel$export(module.exports, "keyFromSelector", function () { return $ace3c568f3120479$export$ec2cccc18ab4c2ae; });
$parcel$export(module.exports, "default", function () { return $ace3c568f3120479$export$2e2bcd8739ae039; });
const $ace3c568f3120479$var$isString = (obj)=>typeof obj === 'string';
const $ace3c568f3120479$var$defer = ()=>{
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
};
const $ace3c568f3120479$var$makeString = (object)=>{
    if (object == null) return '';
    return String(object);
};
const $ace3c568f3120479$var$copy = (a, s, t)=>{
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
};
const $ace3c568f3120479$var$lastOfPathSeparatorRegExp = /###/g;
const $ace3c568f3120479$var$cleanKey = (key)=>key && key.includes('###') ? key.replace($ace3c568f3120479$var$lastOfPathSeparatorRegExp, '.') : key;
const $ace3c568f3120479$var$canNotTraverseDeeper = (object)=>!object || $ace3c568f3120479$var$isString(object);
const $ace3c568f3120479$var$getLastOfPath = (object, path, Empty)=>{
    const stack = !$ace3c568f3120479$var$isString(path) ? path : path.split('.');
    let stackIndex = 0;
    while(stackIndex < stack.length - 1){
        if ($ace3c568f3120479$var$canNotTraverseDeeper(object)) return {};
        const key = $ace3c568f3120479$var$cleanKey(stack[stackIndex]);
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
        ++stackIndex;
    }
    if ($ace3c568f3120479$var$canNotTraverseDeeper(object)) return {};
    return {
        obj: object,
        k: $ace3c568f3120479$var$cleanKey(stack[stackIndex])
    };
};
const $ace3c568f3120479$var$setPath = (object, path, newValue)=>{
    const { obj: obj, k: k } = $ace3c568f3120479$var$getLastOfPath(object, path, Object);
    if (obj !== undefined || path.length === 1) {
        obj[k] = newValue;
        return;
    }
    let e = path[path.length - 1];
    let p = path.slice(0, path.length - 1);
    let last = $ace3c568f3120479$var$getLastOfPath(object, p, Object);
    while(last.obj === undefined && p.length){
        e = `${p[p.length - 1]}.${e}`;
        p = p.slice(0, p.length - 1);
        last = $ace3c568f3120479$var$getLastOfPath(object, p, Object);
        if (last?.obj && typeof last.obj[`${last.k}.${e}`] !== 'undefined') last.obj = undefined;
    }
    last.obj[`${last.k}.${e}`] = newValue;
};
const $ace3c568f3120479$var$pushPath = (object, path, newValue, concat)=>{
    const { obj: obj, k: k } = $ace3c568f3120479$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    obj[k].push(newValue);
};
const $ace3c568f3120479$var$getPath = (object, path)=>{
    const { obj: obj, k: k } = $ace3c568f3120479$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    if (!Object.prototype.hasOwnProperty.call(obj, k)) return undefined;
    return obj[k];
};
const $ace3c568f3120479$var$getPathWithDefaults = (data, defaultData, key)=>{
    const value = $ace3c568f3120479$var$getPath(data, key);
    if (value !== undefined) return value;
    return $ace3c568f3120479$var$getPath(defaultData, key);
};
const $ace3c568f3120479$var$deepExtend = (target, source, overwrite)=>{
    for(const prop in source)if (prop !== '__proto__' && prop !== 'constructor') {
        if (Object.prototype.hasOwnProperty.call(target, prop)) {
            if ($ace3c568f3120479$var$isString(target[prop]) || target[prop] instanceof String || $ace3c568f3120479$var$isString(source[prop]) || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $ace3c568f3120479$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
};
const $ace3c568f3120479$var$regexEscape = (str)=>str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
const $ace3c568f3120479$var$_entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
const $ace3c568f3120479$var$escape = (data)=>{
    if ($ace3c568f3120479$var$isString(data)) return data.replace(/[&<>"'\/]/g, (s)=>$ace3c568f3120479$var$_entityMap[s]);
    return data;
};
class $ace3c568f3120479$var$RegExpCache {
    constructor(capacity){
        this.capacity = capacity;
        this.regExpMap = new Map();
        this.regExpQueue = [];
    }
    getRegExp(pattern) {
        const regExpFromCache = this.regExpMap.get(pattern);
        if (regExpFromCache !== undefined) return regExpFromCache;
        const regExpNew = new RegExp(pattern);
        if (this.regExpQueue.length === this.capacity) this.regExpMap.delete(this.regExpQueue.shift());
        this.regExpMap.set(pattern, regExpNew);
        this.regExpQueue.push(pattern);
        return regExpNew;
    }
}
const $ace3c568f3120479$var$chars = [
    ' ',
    ',',
    '?',
    '!',
    ';'
];
const $ace3c568f3120479$var$looksLikeObjectPathRegExpCache = new $ace3c568f3120479$var$RegExpCache(20);
const $ace3c568f3120479$var$looksLikeObjectPath = (key, nsSeparator, keySeparator)=>{
    nsSeparator = nsSeparator || '';
    keySeparator = keySeparator || '';
    const possibleChars = $ace3c568f3120479$var$chars.filter((c)=>!nsSeparator.includes(c) && !keySeparator.includes(c));
    if (possibleChars.length === 0) return true;
    const r = $ace3c568f3120479$var$looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map((c)=>c === '?' ? '\\?' : c).join('|')})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
};
const $ace3c568f3120479$var$deepFind = (obj, path, keySeparator = '.')=>{
    if (!obj) return undefined;
    if (obj[path]) {
        if (!Object.prototype.hasOwnProperty.call(obj, path)) return undefined;
        return obj[path];
    }
    const tokens = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < tokens.length;){
        if (!current || typeof current !== 'object') return undefined;
        let next;
        let nextPath = '';
        for(let j = i; j < tokens.length; ++j){
            if (j !== i) nextPath += keySeparator;
            nextPath += tokens[j];
            next = current[nextPath];
            if ((typeof next === 'function' || nextPath === '__proto__') && !Object.prototype.hasOwnProperty.call(current, nextPath)) next = undefined;
            if (next !== undefined) {
                if ([
                    'string',
                    'number',
                    'boolean'
                ].includes(typeof next) && j < tokens.length - 1) continue;
                i += j - i + 1;
                break;
            }
        }
        current = next;
    }
    return current;
};
const $ace3c568f3120479$var$getCleanedCode = (code)=>code?.replace(/_/g, '-');
const $ace3c568f3120479$var$consoleLogger = {
    type: 'logger',
    log (args) {
        this.output('log', args);
    },
    warn (args) {
        this.output('warn', args);
    },
    error (args) {
        this.output('error', args);
    },
    output (type, args) {
        console?.[type]?.apply?.(console, args);
    }
};
class $ace3c568f3120479$var$Logger {
    constructor(concreteLogger, options = {}){
        this.init(concreteLogger, options);
    }
    init(concreteLogger, options = {}) {
        this.prefix = options.prefix || 'i18next:';
        this.logger = concreteLogger || $ace3c568f3120479$var$consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log(...args) {
        return this.forward(args, 'log', '', true);
    }
    warn(...args) {
        return this.forward(args, 'warn', '', true);
    }
    error(...args) {
        return this.forward(args, 'error', '');
    }
    deprecate(...args) {
        return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        args = args.map((a)=>$ace3c568f3120479$var$isString(a) ? a.replace(/[\r\n\x00-\x1F\x7F]/g, ' ') : a);
        if ($ace3c568f3120479$var$isString(args[0])) args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $ace3c568f3120479$var$Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new $ace3c568f3120479$var$Logger(this.logger, options);
    }
}
var $ace3c568f3120479$var$baseLogger = new $ace3c568f3120479$var$Logger();
class $ace3c568f3120479$var$EventEmitter {
    constructor(){
        this.observers = {};
    }
    on(events, listener) {
        events.split(' ').forEach((event)=>{
            if (!this.observers[event]) this.observers[event] = new Map();
            const numListeners = this.observers[event].get(listener) || 0;
            this.observers[event].set(listener, numListeners + 1);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event].delete(listener);
    }
    once(event, listener) {
        const wrapper = (...args)=>{
            listener(...args);
            this.off(event, wrapper);
        };
        this.on(event, wrapper);
        return this;
    }
    emit(event, ...args) {
        if (this.observers[event]) {
            const cloned = Array.from(this.observers[event].entries());
            cloned.forEach(([observer, numTimesAdded])=>{
                for(let i = 0; i < numTimesAdded; i++)observer(...args);
            });
        }
        if (this.observers['*']) {
            const cloned = Array.from(this.observers['*'].entries());
            cloned.forEach(([observer, numTimesAdded])=>{
                for(let i = 0; i < numTimesAdded; i++)observer(event, ...args);
            });
        }
    }
}
const $ace3c568f3120479$var$nonEmptyBundles = new WeakSet();
class $ace3c568f3120479$var$ResourceStore extends $ace3c568f3120479$var$EventEmitter {
    constructor(data, options = {
        ns: [
            'translation'
        ],
        defaultNS: 'translation'
    }){
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
    addNamespaces(ns) {
        if (!this.options.ns.includes(ns)) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key, options = {}) {
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path;
        if (lng.includes('.')) path = lng.split('.');
        else {
            path = [
                lng,
                ns
            ];
            if (key) {
                if (Array.isArray(key)) path.push(...key);
                else if ($ace3c568f3120479$var$isString(key) && keySeparator) path.push(...key.split(keySeparator));
                else path.push(key);
            }
        }
        const result = $ace3c568f3120479$var$getPath(this.data, path);
        if (result == null && !ns && !key && lng.includes('.')) {
            lng = path[0];
            ns = path[1];
            key = path.slice(2).join('.');
        }
        if (result != null || !ignoreJSONStructure || !$ace3c568f3120479$var$isString(key)) return result;
        return $ace3c568f3120479$var$deepFind(this.data?.[lng]?.[ns], key, keySeparator);
    }
    addResource(lng, ns, key, value, options = {
        silent: false
    }) {
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.includes('.')) {
            path = lng.split('.');
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $ace3c568f3120479$var$setPath(this.data, path, value);
        if (!options.silent) this.emit('added', lng, ns, key, value);
    }
    addResources(lng, ns, resources, options = {
        silent: false
    }) {
        for(const m in resources)if ($ace3c568f3120479$var$isString(resources[m]) || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite, options = {
        silent: false,
        skipCopy: false
    }) {
        let path = [
            lng,
            ns
        ];
        if (lng.includes('.')) {
            path = lng.split('.');
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $ace3c568f3120479$var$getPath(this.data, path) || {};
        if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
        if (deep) $ace3c568f3120479$var$deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        $ace3c568f3120479$var$setPath(this.data, path, pack);
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit('removed', lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>{
            const bundle = data[v];
            if ($ace3c568f3120479$var$nonEmptyBundles.has(bundle)) return true;
            if (!bundle || Object.keys(bundle).length === 0) return false;
            if (typeof bundle === 'object') $ace3c568f3120479$var$nonEmptyBundles.add(bundle);
            return true;
        });
    }
    toJSON() {
        return this.data;
    }
}
var $ace3c568f3120479$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            value = this.processors[processor]?.process(value, key, options, translator) ?? value;
        });
        return value;
    }
};
const $ace3c568f3120479$var$PATH_KEY = Symbol('i18next/PATH_KEY');
function $ace3c568f3120479$var$createProxy() {
    const state = [];
    const handler = Object.create(null);
    let proxy;
    handler.get = (target, key)=>{
        proxy?.revoke?.();
        if (key === $ace3c568f3120479$var$PATH_KEY) return state;
        state.push(key);
        proxy = Proxy.revocable(target, handler);
        return proxy.proxy;
    };
    return Proxy.revocable(Object.create(null), handler).proxy;
}
function $ace3c568f3120479$export$ec2cccc18ab4c2ae(selector, opts) {
    const { [$ace3c568f3120479$var$PATH_KEY]: path } = selector($ace3c568f3120479$var$createProxy());
    const keySeparator = opts?.keySeparator ?? '.';
    const nsSeparator = opts?.nsSeparator ?? ':';
    const strict = opts?.enableSelector === 'strict';
    if (path.length > 1 && nsSeparator) {
        const ns = opts?.ns;
        const nsList = strict ? Array.isArray(ns) ? ns : ns ? [
            ns
        ] : null : Array.isArray(ns) ? ns : null;
        if (nsList) {
            const candidates = strict ? nsList : nsList.length > 1 ? nsList.slice(1) : [];
            if (candidates.includes(path[0])) return `${path[0]}${nsSeparator}${path.slice(1).join(keySeparator)}`;
        }
    }
    return path.join(keySeparator);
}
const $ace3c568f3120479$var$shouldHandleAsObject = (res)=>!$ace3c568f3120479$var$isString(res) && typeof res !== 'boolean' && typeof res !== 'number';
class $ace3c568f3120479$var$Translator extends $ace3c568f3120479$var$EventEmitter {
    constructor(services, options = {}){
        super();
        $ace3c568f3120479$var$copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        this.logger = $ace3c568f3120479$var$baseLogger.create('translator');
        this.checkedLoadedFor = {};
    }
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key, o = {
        interpolation: {}
    }) {
        const opt = {
            ...o
        };
        if (key == null) return false;
        const resolved = this.resolve(key, opt);
        if (resolved?.res === undefined) return false;
        const isObject = $ace3c568f3120479$var$shouldHandleAsObject(resolved.res);
        if (opt.returnObjects === false && isObject) return false;
        return true;
    }
    extractFromKey(key, opt) {
        let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
        let namespaces = opt.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.includes(nsSeparator);
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !opt.keySeparator && !this.options.userDefinedNsSeparator && !opt.nsSeparator && !$ace3c568f3120479$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: $ace3c568f3120479$var$isString(namespaces) ? [
                    namespaces
                ] : namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.includes(parts[0])) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        return {
            key: key,
            namespaces: $ace3c568f3120479$var$isString(namespaces) ? [
                namespaces
            ] : namespaces
        };
    }
    translate(keys, o, lastKey) {
        let opt = typeof o === 'object' ? {
            ...o
        } : o;
        if (typeof opt !== 'object' && this.options.overloadTranslationOptionHandler) opt = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof opt === 'object') opt = {
            ...opt
        };
        if (!opt) opt = {};
        if (keys == null) return '';
        if (typeof keys === 'function') keys = $ace3c568f3120479$export$ec2cccc18ab4c2ae(keys, {
            ...this.options,
            ...opt
        });
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        keys = keys.map((k)=>typeof k === 'function' ? $ace3c568f3120479$export$ec2cccc18ab4c2ae(k, {
                ...this.options,
                ...opt
            }) : String(k));
        const returnDetails = opt.returnDetails !== undefined ? opt.returnDetails : this.options.returnDetails;
        const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], opt);
        const namespace = namespaces[namespaces.length - 1];
        let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const lng = opt.lng || this.language;
        const appendNamespaceToCIMode = opt.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng?.toLowerCase() === 'cimode') {
            if (appendNamespaceToCIMode) {
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(opt)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(opt)
            };
            return key;
        }
        const resolved = this.resolve(keys, opt);
        let res = resolved?.res;
        const resUsedKey = resolved?.usedKey || key;
        const resExactUsedKey = resolved?.exactUsedKey || key;
        const noObject = [
            '[object Number]',
            '[object Function]',
            '[object RegExp]'
        ];
        const joinArrays = opt.joinArrays !== undefined ? opt.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const needsPluralHandling = opt.count !== undefined && !$ace3c568f3120479$var$isString(opt.count);
        const hasDefaultValue = $ace3c568f3120479$var$Translator.hasDefaultValue(opt);
        const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, opt) : '';
        const defaultValueSuffixOrdinalFallback = opt.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, {
            ordinal: false
        }) : '';
        const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
        const defaultValue = needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] || opt[`defaultValue${defaultValueSuffix}`] || opt[`defaultValue${defaultValueSuffixOrdinalFallback}`] || opt.defaultValue;
        let resForObjHndl = res;
        if (handleAsObjectInI18nFormat && !res && hasDefaultValue) resForObjHndl = defaultValue;
        const handleAsObject = $ace3c568f3120479$var$shouldHandleAsObject(resForObjHndl);
        const resType = Object.prototype.toString.apply(resForObjHndl);
        if (handleAsObjectInI18nFormat && resForObjHndl && handleAsObject && !noObject.includes(resType) && !($ace3c568f3120479$var$isString(joinArrays) && Array.isArray(resForObjHndl))) {
            if (!opt.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, resForObjHndl, {
                    ...opt,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(opt);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = Array.isArray(resForObjHndl);
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in resForObjHndl)if (Object.prototype.hasOwnProperty.call(resForObjHndl, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    if (hasDefaultValue && !res) copy[m] = this.translate(deepKey, {
                        ...opt,
                        defaultValue: $ace3c568f3120479$var$shouldHandleAsObject(defaultValue) ? defaultValue[m] : undefined,
                        joinArrays: false,
                        ns: namespaces
                    });
                    else copy[m] = this.translate(deepKey, {
                        ...opt,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = resForObjHndl[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && $ace3c568f3120479$var$isString(joinArrays) && Array.isArray(res)) {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, opt, resolved, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = opt.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, needsPluralHandling && !updateMissing ? `${key}${this.pluralResolver.getSuffix(lng, opt.count, opt)}` : key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...opt,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, opt.lng || this.language);
                if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(opt.lng || this.language);
                else lngs.push(opt.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, opt);
                    else if (this.backendConnector?.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, opt);
                    this.emit('missingKey', l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        const suffixes = this.pluralResolver.getSuffixes(language, opt);
                        if (needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] && !suffixes.includes(`${this.options.pluralSeparator}zero`)) suffixes.push(`${this.options.pluralSeparator}zero`);
                        suffixes.forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, opt[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, opt, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}${nsSeparator}${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}${nsSeparator}${key}` : key, usedDefault ? res : undefined, opt);
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(opt);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, opt, resolved, lastKey) {
        if (this.i18nFormat?.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...opt
        }, opt.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!opt.skipInterpolation) {
            if (opt.interpolation) this.interpolator.init({
                ...opt,
                interpolation: {
                    ...this.options.interpolation,
                    ...opt.interpolation
                }
            });
            const skipOnVariables = $ace3c568f3120479$var$isString(res) && (opt?.interpolation?.skipOnVariables !== undefined ? opt.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = opt.replace && !$ace3c568f3120479$var$isString(opt.replace) ? opt.replace : opt;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, opt.lng || this.language || resolved.usedLng, opt);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) opt.nest = false;
            }
            if (!opt.lng && resolved && resolved.res) opt.lng = this.language || resolved.usedLng;
            if (opt.nest !== false) res = this.interpolator.nest(res, (...args)=>{
                if (lastKey?.[0] === args[0] && !opt.context) {
                    this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return this.translate(...args, key);
            }, opt);
            if (opt.interpolation) this.interpolator.reset();
        }
        const postProcess = opt.postProcess || this.options.postProcess;
        const postProcessorNames = $ace3c568f3120479$var$isString(postProcess) ? [
            postProcess
        ] : postProcess;
        if (res != null && postProcessorNames?.length && opt.applyPostProcessor !== false) res = $ace3c568f3120479$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: {
                ...resolved,
                usedParams: this.getUsedParamsDetails(opt)
            },
            ...opt
        } : opt, this);
        return res;
    }
    resolve(keys, opt = {}) {
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if ($ace3c568f3120479$var$isString(keys)) keys = [
            keys
        ];
        if (Array.isArray(keys)) keys = keys.map((k)=>typeof k === 'function' ? $ace3c568f3120479$export$ec2cccc18ab4c2ae(k, {
                ...this.options,
                ...opt
            }) : k);
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, opt);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = opt.count !== undefined && !$ace3c568f3120479$var$isString(opt.count);
            const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
            const needsContextHandling = opt.context !== undefined && ($ace3c568f3120479$var$isString(opt.context) || typeof opt.context === 'number') && opt.context !== '';
            const codes = opt.lngs ? opt.lngs : this.languageUtils.toResolveHierarchy(opt.lng || this.language, opt.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!this.checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils?.hasLoadedNamespace && !this.utils?.hasLoadedNamespace(usedNS)) {
                    this.checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(', ')}" won't get resolved as namespace "${usedNS}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat?.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, opt);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, opt.count, opt);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            if (opt.ordinal && pluralSuffix.startsWith(ordinalPrefix)) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            finalKeys.push(key + pluralSuffix);
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator || '_'}${opt.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                if (opt.ordinal && pluralSuffix.startsWith(ordinalPrefix)) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                finalKeys.push(contextKey + pluralSuffix);
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, opt);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
    getResource(code, ns, key, options = {}) {
        if (this.i18nFormat?.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    getUsedParamsDetails(options = {}) {
        const optionsKeys = [
            'defaultValue',
            'ordinal',
            'context',
            'replace',
            'lng',
            'lngs',
            'fallbackLng',
            'ns',
            'keySeparator',
            'nsSeparator',
            'returnObjects',
            'returnDetails',
            'joinArrays',
            'postProcess',
            'interpolation'
        ];
        const useOptionsReplaceForData = options.replace && !$ace3c568f3120479$var$isString(options.replace);
        let data = useOptionsReplaceForData ? options.replace : options;
        if (useOptionsReplaceForData && typeof options.count !== 'undefined') data = {
            ...data,
            count: options.count
        };
        if (this.options.interpolation.defaultVariables) data = {
            ...this.options.interpolation.defaultVariables,
            ...data
        };
        if (!useOptionsReplaceForData) {
            data = {
                ...data
            };
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options) {
        const prefix = 'defaultValue';
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && option.startsWith(prefix) && undefined !== options[option]) return true;
        }
        return false;
    }
}
class $ace3c568f3120479$var$LanguageUtil {
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $ace3c568f3120479$var$baseLogger.create('languageUtils');
        this.resolveHierarchyCache = {};
    }
    clearCache() {
        this.resolveHierarchyCache = {};
    }
    getScriptPartFromCode(code) {
        code = $ace3c568f3120479$var$getCleanedCode(code);
        if (!code || !code.includes('-')) return null;
        const p = code.split('-');
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === 'x') return null;
        return this.formatLanguageCode(p.join('-'));
    }
    getLanguagePartFromCode(code) {
        code = $ace3c568f3120479$var$getCleanedCode(code);
        if (!code || !code.includes('-')) return code;
        const p = code.split('-');
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if ($ace3c568f3120479$var$isString(code) && code.includes('-')) {
            let formattedCode;
            try {
                formattedCode = Intl.getCanonicalLocales(code)[0];
            } catch (e) {}
            if (formattedCode && this.options.lowerCaseLng) formattedCode = formattedCode.toLowerCase();
            if (formattedCode) return formattedCode;
            if (this.options.lowerCaseLng) return code.toLowerCase();
            return code;
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.includes(code);
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngScOnly = this.getScriptPartFromCode(code);
            if (this.isSupportedCode(lngScOnly)) return found = lngScOnly;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return true;
                if (!supportedLng.includes('-') && !lngOnly.includes('-')) return false;
                if (supportedLng.includes('-') && !lngOnly.includes('-') && supportedLng.slice(0, supportedLng.indexOf('-')) === lngOnly) return true;
                return false;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
        if ($ace3c568f3120479$var$isString(fallbacks)) fallbacks = [
            fallbacks
        ];
        if (Array.isArray(fallbacks)) return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackLng = this.options.fallbackLng;
        const fallbackLngKey = Array.isArray(fallbackLng) ? fallbackLng.join('|') : fallbackLng;
        if (fallbackLngKey !== this._cachedFallbackLng) {
            this.resolveHierarchyCache = {};
            this._cachedFallbackLng = fallbackLngKey;
        }
        const hasCacheableFallback = fallbackCode === undefined || fallbackCode === false || $ace3c568f3120479$var$isString(fallbackCode);
        const usesUncacheableOptionsFallback = fallbackCode === undefined && typeof this.options.fallbackLng === 'function';
        const cacheable = $ace3c568f3120479$var$isString(code) && hasCacheableFallback && !usesUncacheableOptionsFallback;
        let cacheKey = null;
        if (cacheable) {
            let fallbackCacheKey;
            if (fallbackCode === undefined) fallbackCacheKey = 'undefined';
            else if (fallbackCode === false) fallbackCacheKey = 'boolean:false';
            else fallbackCacheKey = `string:${fallbackCode}`;
            cacheKey = `${code.length}:${code}|${fallbackCacheKey}`;
        }
        if (cacheKey !== null) {
            const cached = this.resolveHierarchyCache[cacheKey];
            if (cached !== undefined) return cached.slice();
        }
        const fallbackCodes = this.getFallbackCodes((fallbackCode === false ? [] : fallbackCode) || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if ($ace3c568f3120479$var$isString(code) && (code.includes('-') || code.includes('_'))) {
            if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
            if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
        } else if ($ace3c568f3120479$var$isString(code)) addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            const formattedFc = this.formatLanguageCode(fc);
            if (!codes.includes(formattedFc)) addCode(formattedFc);
        });
        if (cacheKey !== null) {
            this.resolveHierarchyCache[cacheKey] = codes;
            return codes.slice();
        }
        return codes;
    }
}
const $ace3c568f3120479$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
const $ace3c568f3120479$var$dummyRule = {
    select: (count)=>count === 1 ? 'one' : 'other',
    resolvedOptions: ()=>({
            pluralCategories: [
                'one',
                'other'
            ]
        })
};
class $ace3c568f3120479$var$PluralResolver {
    constructor(languageUtils, options = {}){
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $ace3c568f3120479$var$baseLogger.create('pluralResolver');
        this.pluralRulesCache = {};
    }
    clearCache() {
        this.pluralRulesCache = {};
    }
    getRule(code, options = {}) {
        const cleanedCode = $ace3c568f3120479$var$getCleanedCode(code === 'dev' ? 'en' : code);
        const type = options.ordinal ? 'ordinal' : 'cardinal';
        const cacheKey = JSON.stringify({
            cleanedCode: cleanedCode,
            type: type
        });
        if (cacheKey in this.pluralRulesCache) return this.pluralRulesCache[cacheKey];
        let rule;
        try {
            rule = new Intl.PluralRules(cleanedCode, {
                type: type
            });
        } catch (err) {
            if (typeof Intl === 'undefined') {
                this.logger.error('No Intl support, please use an Intl polyfill!');
                return $ace3c568f3120479$var$dummyRule;
            }
            if (!code.match(/-|_/)) return $ace3c568f3120479$var$dummyRule;
            const lngPart = this.languageUtils.getLanguagePartFromCode(code);
            rule = this.getRule(lngPart, options);
        }
        this.pluralRulesCache[cacheKey] = rule;
        return rule;
    }
    needsPlural(code, options = {}) {
        let rule = this.getRule(code, options);
        if (!rule) rule = this.getRule('dev', options);
        return rule?.resolvedOptions().pluralCategories.length > 1;
    }
    getPluralFormsOfKey(code, key, options = {}) {
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code, options = {}) {
        let rule = this.getRule(code, options);
        if (!rule) rule = this.getRule('dev', options);
        if (!rule) return [];
        return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$ace3c568f3120479$var$suffixesOrder[pluralCategory1] - $ace3c568f3120479$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${pluralCategory}`);
    }
    getSuffix(code, count, options = {}) {
        const rule = this.getRule(code, options);
        if (rule) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${rule.select(count)}`;
        this.logger.warn(`no plural rule found for: ${code}`);
        return this.getSuffix('dev', count, options);
    }
}
const $ace3c568f3120479$var$deepFindWithDefaults = (data, defaultData, key, keySeparator = '.', ignoreJSONStructure = true)=>{
    let path = $ace3c568f3120479$var$getPathWithDefaults(data, defaultData, key);
    if (path == null && ignoreJSONStructure && $ace3c568f3120479$var$isString(key)) {
        path = $ace3c568f3120479$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $ace3c568f3120479$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
};
class $ace3c568f3120479$var$Interpolator {
    constructor(options = {}){
        this.logger = $ace3c568f3120479$var$baseLogger.create('interpolator');
        this.options = options;
        this.format = options?.interpolation?.format || ((value)=>value);
        this.init(options);
    }
    init(options = {}) {
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const { escape: escape$1, escapeValue: escapeValue, useRawValueToEscape: useRawValueToEscape, prefix: prefix, prefixEscaped: prefixEscaped, suffix: suffix, suffixEscaped: suffixEscaped, formatSeparator: formatSeparator, unescapeSuffix: unescapeSuffix, unescapePrefix: unescapePrefix, nestingPrefix: nestingPrefix, nestingPrefixEscaped: nestingPrefixEscaped, nestingSuffix: nestingSuffix, nestingSuffixEscaped: nestingSuffixEscaped, nestingOptionsSeparator: nestingOptionsSeparator, maxReplaces: maxReplaces, alwaysFormat: alwaysFormat } = options.interpolation;
        this.escape = escape$1 !== undefined ? escape$1 : $ace3c568f3120479$var$escape;
        this.escapeValue = escapeValue !== undefined ? escapeValue : true;
        this.useRawValueToEscape = useRawValueToEscape !== undefined ? useRawValueToEscape : false;
        this.prefix = prefix ? $ace3c568f3120479$var$regexEscape(prefix) : prefixEscaped || '{{';
        this.suffix = suffix ? $ace3c568f3120479$var$regexEscape(suffix) : suffixEscaped || '}}';
        this.formatSeparator = formatSeparator || ',';
        this.unescapePrefix = unescapeSuffix ? '' : unescapePrefix ? $ace3c568f3120479$var$regexEscape(unescapePrefix) : '-';
        this.unescapeSuffix = this.unescapePrefix ? '' : unescapeSuffix ? $ace3c568f3120479$var$regexEscape(unescapeSuffix) : '';
        this.nestingPrefix = nestingPrefix ? $ace3c568f3120479$var$regexEscape(nestingPrefix) : nestingPrefixEscaped || $ace3c568f3120479$var$regexEscape('$t(');
        this.nestingSuffix = nestingSuffix ? $ace3c568f3120479$var$regexEscape(nestingSuffix) : nestingSuffixEscaped || $ace3c568f3120479$var$regexEscape(')');
        this.nestingOptionsSeparator = nestingOptionsSeparator || ',';
        this.maxReplaces = maxReplaces || 1000;
        this.alwaysFormat = alwaysFormat !== undefined ? alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const getOrResetRegExp = (existingRegExp, pattern)=>{
            if (existingRegExp?.source === pattern) {
                existingRegExp.lastIndex = 0;
                return existingRegExp;
            }
            return new RegExp(pattern, 'g');
        };
        this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
        this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
        this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}((?:[^()"']|"[^"]*"|'[^']*'|\\((?:[^()"']|"[^"]*"|'[^']*')*\\))*?)${this.nestingSuffix}`);
    }
    interpolate(str, data, lng, options) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        const handleFormat = (key)=>{
            if (!key.includes(this.formatSeparator)) {
                const path = $ace3c568f3120479$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($ace3c568f3120479$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        if (!this.escapeValue && typeof str === 'string' && /\$t\([^)]*\{[^}]*\{\{/.test(str)) this.logger.warn("nesting options string contains interpolated variables with escapeValue: false \u2014 if any of those values are attacker-controlled they can inject additional nesting options (e.g. redirect lng/ns). Sanitise untrusted input before passing it to t(), or keep escapeValue: true.");
        const missingInterpolationHandler = options?.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options?.interpolation?.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>val
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? this.escape(val) : val
            }
        ];
        const unescapedValues = [];
        let shift = 0;
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const at = match.index - shift;
                const written = unescapedValues.find(([start, end])=>at >= start && at < end);
                if (written) {
                    todo.regex.lastIndex = written[1] + shift;
                    continue;
                }
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === 'function') {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = $ace3c568f3120479$var$isString(temp) ? temp : '';
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = '';
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = '';
                    }
                } else if (!$ace3c568f3120479$var$isString(value) && !this.useRawValueToEscape) value = $ace3c568f3120479$var$makeString(value);
                const safeValue = $ace3c568f3120479$var$makeString(todo.safeValue(value));
                str = str.slice(0, match.index) + safeValue + str.slice(match.index + match[0].length);
                if (skipOnVariables) {
                    if (todo.regex === this.regexpUnescape) unescapedValues.push([
                        match.index,
                        match.index + safeValue.length
                    ]);
                    else shift += safeValue.length - match[0].length;
                    todo.regex.lastIndex += safeValue.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc, options = {}) {
        let match;
        let value;
        let clonedOptions;
        const handleHasOptions = (key, inheritedOptions)=>{
            const sep = this.nestingOptionsSeparator;
            if (!key.includes(sep)) return key;
            const c = key.split(new RegExp(`${$ace3c568f3120479$var$regexEscape(sep)}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if ((matchedSingleQuotes?.length ?? 0) % 2 === 0 && !matchedDoubleQuotes || (matchedDoubleQuotes?.length ?? 0) % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            if (clonedOptions.defaultValue && clonedOptions.defaultValue.includes(this.prefix)) delete clonedOptions.defaultValue;
            return key;
        };
        const nestingRegexp = new RegExp(this.nestingRegexp);
        let out = '';
        let lastEnd = 0;
        while(match = nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options
            };
            clonedOptions = clonedOptions.replace && !$ace3c568f3120479$var$isString(clonedOptions.replace) ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            const keyEndIndex = /{.*}/s.test(match[1]) ? match[1].lastIndexOf('}') + 1 : match[1].indexOf(this.formatSeparator);
            if (keyEndIndex !== -1) {
                formatters = match[1].slice(keyEndIndex).split(this.formatSeparator).map((elem)=>elem.trim()).filter(Boolean);
                match[1] = match[1].slice(0, keyEndIndex);
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && !$ace3c568f3120479$var$isString(value)) return value;
            if (!$ace3c568f3120479$var$isString(value)) value = $ace3c568f3120479$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = '';
            }
            if (formatters.length) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, {
                    ...options,
                    interpolationkey: match[1].trim()
                }), value.trim());
            out += str.slice(lastEnd, match.index) + $ace3c568f3120479$var$makeString(value);
            lastEnd = nestingRegexp.lastIndex;
            this.regexp.lastIndex = 0;
        }
        return lastEnd ? out + str.slice(lastEnd) : str;
    }
}
const $ace3c568f3120479$var$parseFormatStr = (formatStr)=>{
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.includes('(')) {
        const p = formatStr.split('(');
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].slice(0, -1);
        if (formatName === 'currency' && !optStr.includes(':')) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === 'relativetime' && !optStr.includes(':')) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(';');
            opts.forEach((opt)=>{
                if (opt) {
                    const [key, ...rest] = opt.split(':');
                    const val = rest.join(':').trim().replace(/^'+|'+$/g, '');
                    const trimmedKey = key.trim();
                    if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
                    if (val === 'false') formatOptions[trimmedKey] = false;
                    if (val === 'true') formatOptions[trimmedKey] = true;
                    if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
                }
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
};
const $ace3c568f3120479$var$createCachedFormatter = (fn)=>{
    const cache = {};
    return (v, l, o)=>{
        let optForCache = o;
        if (o && o.interpolationkey && o.formatParams && o.formatParams[o.interpolationkey] && o[o.interpolationkey]) optForCache = {
            ...optForCache,
            [o.interpolationkey]: undefined
        };
        let key;
        try {
            key = l + JSON.stringify(optForCache);
        } catch (e) {
            return fn($ace3c568f3120479$var$getCleanedCode(l), o)(v);
        }
        let frm = cache[key];
        if (!frm) {
            frm = fn($ace3c568f3120479$var$getCleanedCode(l), o);
            cache[key] = frm;
        }
        return frm(v);
    };
};
const $ace3c568f3120479$var$createNonCachedFormatter = (fn)=>(v, l, o)=>fn($ace3c568f3120479$var$getCleanedCode(l), o)(v);
class $ace3c568f3120479$var$Formatter {
    constructor(options = {}){
        this.logger = $ace3c568f3120479$var$baseLogger.create('formatter');
        this.options = options;
        this.init(options);
    }
    init(services, options = {
        interpolation: {}
    }) {
        this.formatSeparator = options.interpolation.formatSeparator || ',';
        const cf = options.cacheInBuiltFormats ? $ace3c568f3120479$var$createCachedFormatter : $ace3c568f3120479$var$createNonCachedFormatter;
        this.formats = {
            number: cf((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: cf((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: 'currency'
                });
                return (val)=>formatter.format(val);
            }),
            datetime: cf((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: cf((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || 'day');
            }),
            list: cf((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $ace3c568f3120479$var$createCachedFormatter(fc);
    }
    format(value, format, lng, options = {}) {
        if (!format) return value;
        if (value == null) return value;
        const rawFormats = format.split(this.formatSeparator);
        const formats = [];
        for(let i = 0; i < rawFormats.length; i++){
            let f = rawFormats[i];
            while(f.indexOf('(') > -1 && !f.includes(')') && i + 1 < rawFormats.length)f = `${f}${this.formatSeparator}${rawFormats[++i]}`;
            formats.push(f);
        }
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $ace3c568f3120479$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options?.formatParams?.[options.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
}
const $ace3c568f3120479$var$removePending = (q, name)=>{
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
};
class $ace3c568f3120479$var$Connector extends $ace3c568f3120479$var$EventEmitter {
    constructor(backend, store, services, options = {}){
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = $ace3c568f3120479$var$baseLogger.create('backendConnector');
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        this.backend?.init?.(services, options.backend, options);
    }
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit('failedLoading', lng, ns, err);
        if (!err && data) this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
            skipCopy: true
        });
        this.state[name] = err ? -1 : 2;
        if (err && data) this.state[name] = 0;
        const loaded = {};
        this.queue.forEach((q)=>{
            $ace3c568f3120479$var$pushPath(q.loaded, [
                lng
            ], ns);
            $ace3c568f3120479$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit('loaded', loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName, tried = 0, wait = this.retryTimeout, callback) {
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read(lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === 'function') r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces, options = {}, callback) {
        if (!this.backend) {
            this.logger.warn('No backend was added via i18next.use. Will not load resources.');
            return callback && callback();
        }
        if ($ace3c568f3120479$var$isString(languages)) languages = this.languageUtils.toResolveHierarchy(languages);
        if ($ace3c568f3120479$var$isString(namespaces)) namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name, prefix = '') {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, 'read', undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate, options = {}, clb = ()=>{}) {
        if (this.services?.utils?.hasLoadedNamespace && !this.services?.utils?.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
            return;
        }
        if (key === undefined || key === null || key === '') return;
        if (this.backend?.create) {
            const opts = {
                ...options,
                isUpdate: isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === 'function') r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
}
const $ace3c568f3120479$var$get = ()=>({
        debug: false,
        initAsync: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        enableSelector: false,
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: (args)=>{
            let ret = {};
            if (typeof args[1] === 'object') ret = args[1];
            if ($ace3c568f3120479$var$isString(args[1])) ret.defaultValue = args[1];
            if ($ace3c568f3120479$var$isString(args[2])) ret.tDescription = args[2];
            if (typeof args[2] === 'object' || typeof args[3] === 'object') {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: true
        },
        cacheInBuiltFormats: true
    });
const $ace3c568f3120479$var$transformOptions = (options)=>{
    if ($ace3c568f3120479$var$isString(options.ns)) options.ns = [
        options.ns
    ];
    if ($ace3c568f3120479$var$isString(options.fallbackLng)) options.fallbackLng = [
        options.fallbackLng
    ];
    if ($ace3c568f3120479$var$isString(options.fallbackNS)) options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && !options.supportedLngs.includes('cimode')) options.supportedLngs = options.supportedLngs.concat([
        'cimode'
    ]);
    return options;
};
const $ace3c568f3120479$var$noop = ()=>{};
const $ace3c568f3120479$var$bindMemberFunctions = (inst)=>{
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === 'function') inst[mem] = inst[mem].bind(inst);
    });
};
class $ace3c568f3120479$var$I18n extends $ace3c568f3120479$var$EventEmitter {
    constructor(options = {}, callback){
        super();
        this.options = $ace3c568f3120479$var$transformOptions(options);
        this.services = {};
        this.logger = $ace3c568f3120479$var$baseLogger;
        this.modules = {
            external: []
        };
        $ace3c568f3120479$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initAsync) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
    init(options = {}, callback) {
        this.isInitializing = true;
        if (typeof options === 'function') {
            callback = options;
            options = {};
        }
        if (options.defaultNS == null && options.ns) {
            if ($ace3c568f3120479$var$isString(options.ns)) options.defaultNS = options.ns;
            else if (!options.ns.includes('translation')) options.defaultNS = options.ns[0];
        }
        const defOpts = $ace3c568f3120479$var$get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...$ace3c568f3120479$var$transformOptions(options)
        };
        this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        if (typeof this.options.overloadTranslationOptionHandler !== 'function') this.options.overloadTranslationOptionHandler = defOpts.overloadTranslationOptionHandler;
        const createClassOnDemand = (ClassOrObject)=>{
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === 'function') return new ClassOrObject();
            return ClassOrObject;
        };
        if (!this.options.isClone) {
            if (this.modules.logger) $ace3c568f3120479$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $ace3c568f3120479$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else formatter = $ace3c568f3120479$var$Formatter;
            const lu = new $ace3c568f3120479$var$LanguageUtil(this.options);
            this.store = new $ace3c568f3120479$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $ace3c568f3120479$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $ace3c568f3120479$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator
            });
            if (formatter) {
                s.formatter = createClassOnDemand(formatter);
                if (s.formatter.init) s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $ace3c568f3120479$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $ace3c568f3120479$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on('*', (event, ...args)=>{
                this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $ace3c568f3120479$var$Translator(this.services, this.options);
            this.translator.on('*', (event, ...args)=>{
                this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $ace3c568f3120479$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
        const storeApi = [
            'getResource',
            'hasResourceBundle',
            'getResourceBundle',
            'getDataByLanguage'
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = (...args)=>this.store[fcName](...args);
        });
        const storeApiChained = [
            'addResource',
            'addResources',
            'addResourceBundle',
            'removeResourceBundle'
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = (...args)=>{
                this.store[fcName](...args);
                return this;
            };
        });
        const deferred = $ace3c568f3120479$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                this.isInitializing = false;
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn('init: i18next is already initialized. You should call init just once!');
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log('initialized', this.options);
                this.emit('initialized', this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if ((this.languages || this.isLanguageChangingTo) && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initAsync) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language, callback = $ace3c568f3120479$var$noop) {
        let usedCallback = callback;
        const usedLng = $ace3c568f3120479$var$isString(language) ? language : this.language;
        if (typeof language === 'function') usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng?.toLowerCase() === 'cimode' && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === 'cimode') return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === 'cimode') return;
                    if (!toLoad.includes(l)) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            this.options.preload?.forEach?.((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $ace3c568f3120479$var$defer();
        if (typeof lngs === 'function') {
            callback = lngs;
            lngs = undefined;
        }
        if (typeof ns === 'function') {
            callback = ns;
            ns = undefined;
        }
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $ace3c568f3120479$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
        if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
        if (module.type === 'backend') this.modules.backend = module;
        if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === 'languageDetector') this.modules.languageDetector = module;
        if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
        if (module.type === 'postProcessor') $ace3c568f3120479$var$postProcessor.addPostProcessor(module);
        if (module.type === 'formatter') this.modules.formatter = module;
        if (module.type === '3rdParty') this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            'cimode',
            'dev'
        ].includes(l)) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                'cimode',
                'dev'
            ].includes(lngInLngs)) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
        if (!this.resolvedLanguage && !this.languages.includes(l) && this.store.hasLanguageSomeTranslations(l)) {
            this.resolvedLanguage = l;
            this.languages.unshift(l);
        }
    }
    changeLanguage(lng, callback) {
        this.isLanguageChangingTo = lng;
        const deferred = $ace3c568f3120479$var$defer();
        this.emit('languageChanging', lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                if (this.isLanguageChangingTo === lng) {
                    setLngProps(l);
                    this.translator.changeLanguage(l);
                    this.isLanguageChangingTo = undefined;
                    this.emit('languageChanged', l);
                    this.logger.log('languageChanged', l);
                }
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve((...args)=>this.t(...args));
            if (callback) callback(err, (...args)=>this.t(...args));
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const fl = $ace3c568f3120479$var$isString(lngs) ? lngs : lngs && lngs[0];
            const l = this.store.hasLanguageSomeTranslations(fl) ? fl : this.services.languageUtils.getBestMatchFromCodes($ace3c568f3120479$var$isString(lngs) ? [
                lngs
            ] : lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                this.services.languageDetector?.cacheUserLanguage?.(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix, fixedOpts) {
        const scopeNs = fixedOpts?.scopeNs;
        const fixedT = (key, opts, ...rest)=>{
            let o;
            if (typeof opts !== 'object') o = this.options.overloadTranslationOptionHandler([
                key,
                opts
            ].concat(rest));
            else o = {
                ...opts
            };
            o.lng = o.lng || fixedT.lng;
            o.lngs = o.lngs || fixedT.lngs;
            const explicitCallNs = o.ns !== undefined && o.ns !== null;
            o.ns = o.ns || fixedT.ns;
            if (o.keyPrefix !== '') o.keyPrefix = o.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const selectorOpts = {
                ...this.options,
                ...o
            };
            if (Array.isArray(scopeNs) && !explicitCallNs) selectorOpts.ns = scopeNs;
            if (typeof o.keyPrefix === 'function') o.keyPrefix = $ace3c568f3120479$export$ec2cccc18ab4c2ae(o.keyPrefix, selectorOpts);
            const keySeparator = this.options.keySeparator || '.';
            let resultKey;
            if (o.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>{
                if (typeof k === 'function') k = $ace3c568f3120479$export$ec2cccc18ab4c2ae(k, selectorOpts);
                return `${o.keyPrefix}${keySeparator}${k}`;
            });
            else {
                if (typeof key === 'function') key = $ace3c568f3120479$export$ec2cccc18ab4c2ae(key, selectorOpts);
                resultKey = o.keyPrefix ? `${o.keyPrefix}${keySeparator}${key}` : key;
            }
            return this.t(resultKey, o);
        };
        if ($ace3c568f3120479$var$isString(lng)) fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t(...args) {
        return this.translator?.translate(...args);
    }
    exists(...args) {
        return this.translator?.exists(...args);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns, options = {}) {
        if (!this.isInitialized) {
            this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === 'cimode') return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 0 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        const { languageUtils: languageUtils } = this.services;
        const loadLng = !options.lng ? lng : languageUtils.isSupportedCode(lng) && languageUtils.toResolveHierarchy(lng, false)[0];
        if ((!loadLng || loadNotPending(loadLng, ns)) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $ace3c568f3120479$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if ($ace3c568f3120479$var$isString(ns)) ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (!this.options.ns.includes(n)) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $ace3c568f3120479$var$defer();
        if ($ace3c568f3120479$var$isString(lngs)) lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>!preloaded.includes(lng) && this.services.languageUtils.isSupportedCode(lng));
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language);
        if (!lng) return 'rtl';
        try {
            const l = new Intl.Locale(lng);
            if (l && l.getTextInfo) {
                const ti = l.getTextInfo();
                if (ti && ti.direction) return ti.direction;
            }
        } catch (e) {}
        const rtlLngs = [
            'ar',
            'shu',
            'sqr',
            'ssh',
            'xaa',
            'yhd',
            'yud',
            'aao',
            'abh',
            'abv',
            'acm',
            'acq',
            'acw',
            'acx',
            'acy',
            'adf',
            'ads',
            'aeb',
            'aec',
            'afb',
            'ajp',
            'apc',
            'apd',
            'arb',
            'arq',
            'ars',
            'ary',
            'arz',
            'auz',
            'avl',
            'ayh',
            'ayl',
            'ayn',
            'ayp',
            'bbz',
            'pga',
            'he',
            'iw',
            'ps',
            'pbt',
            'pbu',
            'pst',
            'prp',
            'prd',
            'ug',
            'ur',
            'ydd',
            'yds',
            'yih',
            'ji',
            'yi',
            'hbo',
            'men',
            'xmn',
            'fa',
            'jpr',
            'peo',
            'pes',
            'prs',
            'dv',
            'sam',
            'ckb'
        ];
        const languageUtils = this.services?.languageUtils || new $ace3c568f3120479$var$LanguageUtil($ace3c568f3120479$var$get());
        if (lng.toLowerCase().indexOf('-latn') > 1) return 'ltr';
        return rtlLngs.includes(languageUtils.getLanguagePartFromCode(lng)) || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
    static createInstance(options = {}, callback) {
        const instance = new $ace3c568f3120479$var$I18n(options, callback);
        instance.createInstance = $ace3c568f3120479$var$I18n.createInstance;
        return instance;
    }
    cloneInstance(options = {}, callback = $ace3c568f3120479$var$noop) {
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) {
            options = {
                ...options
            };
            delete options.forkResourceStore;
        }
        const mergedOptions = {
            ...this.options,
            preload: false,
            ...options,
            isClone: true
        };
        const clone = new $ace3c568f3120479$var$I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            'store',
            'services',
            'language'
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            const copyData = (obj)=>{
                const copied = Array.isArray(obj) ? [
                    ...obj
                ] : {
                    ...obj
                };
                Object.keys(copied).forEach((k)=>{
                    if (copied[k] && typeof copied[k] === 'object') copied[k] = copyData(copied[k]);
                });
                return copied;
            };
            const clonedData = copyData(this.store.data);
            clone.store = new $ace3c568f3120479$var$ResourceStore(clonedData, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        if (options.interpolation) {
            const defOpts = $ace3c568f3120479$var$get();
            const mergedInterpolation = {
                ...defOpts.interpolation,
                ...this.options.interpolation,
                ...options.interpolation
            };
            const mergedForInterpolator = {
                ...mergedOptions,
                interpolation: mergedInterpolation
            };
            clone.services.interpolator = new $ace3c568f3120479$var$Interpolator(mergedForInterpolator);
        }
        clone.translator = new $ace3c568f3120479$var$Translator(clone.services, mergedOptions);
        clone.translator.on('*', (event, ...args)=>{
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const $ace3c568f3120479$export$2e2bcd8739ae039 = $ace3c568f3120479$var$I18n.createInstance();
const $ace3c568f3120479$export$99152e8d49ca4e7d = $ace3c568f3120479$export$2e2bcd8739ae039.createInstance;
const $ace3c568f3120479$export$147ec2801e896265 = $ace3c568f3120479$export$2e2bcd8739ae039.dir;
const $ace3c568f3120479$export$2cd8252107eb640b = $ace3c568f3120479$export$2e2bcd8739ae039.init;
const $ace3c568f3120479$export$d3d08d944062d7e = $ace3c568f3120479$export$2e2bcd8739ae039.loadResources;
const $ace3c568f3120479$export$a5d9bf5d83fcab09 = $ace3c568f3120479$export$2e2bcd8739ae039.reloadResources;
const $ace3c568f3120479$export$1f96ae73734a86cc = $ace3c568f3120479$export$2e2bcd8739ae039.use;
const $ace3c568f3120479$export$61465194746e7fd2 = $ace3c568f3120479$export$2e2bcd8739ae039.changeLanguage;
const $ace3c568f3120479$export$f90d180fc7da3b3b = $ace3c568f3120479$export$2e2bcd8739ae039.getFixedT;
const $ace3c568f3120479$export$625550452a3fa3ec = $ace3c568f3120479$export$2e2bcd8739ae039.t;
const $ace3c568f3120479$export$f7e9f41ea797a17 = $ace3c568f3120479$export$2e2bcd8739ae039.exists;
const $ace3c568f3120479$export$2b4b218e406d2d00 = $ace3c568f3120479$export$2e2bcd8739ae039.setDefaultNamespace;
const $ace3c568f3120479$export$93d9ee97c1ad3f31 = $ace3c568f3120479$export$2e2bcd8739ae039.hasLoadedNamespace;
const $ace3c568f3120479$export$83be934b53fff43b = $ace3c568f3120479$export$2e2bcd8739ae039.loadNamespaces;
const $ace3c568f3120479$export$8cd7e7a54fa865bc = $ace3c568f3120479$export$2e2bcd8739ae039.loadLanguages;

});

parcelRegister("21Cbc", function(module, exports) {

$parcel$export(module.exports, "setDefaults", function () { return $17994a7494e8ef5e$export$2e2366488d12e20d; });
$parcel$export(module.exports, "getDefaults", function () { return $17994a7494e8ef5e$export$212bb2fc580a90a8; });

var $4AwnR = parcelRequire("4AwnR");
let $17994a7494e8ef5e$var$defaultOptions = {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: '',
    transKeepBasicHtmlNodesFor: [
        'br',
        'strong',
        'i',
        'p'
    ],
    useSuspense: true,
    unescape: $4AwnR.unescape,
    transDefaultProps: undefined
};
const $17994a7494e8ef5e$export$2e2366488d12e20d = (options = {})=>{
    $17994a7494e8ef5e$var$defaultOptions = {
        ...$17994a7494e8ef5e$var$defaultOptions,
        ...options
    };
};
const $17994a7494e8ef5e$export$212bb2fc580a90a8 = ()=>$17994a7494e8ef5e$var$defaultOptions;

});
parcelRegister("4AwnR", function(module, exports) {

$parcel$export(module.exports, "unescape", function () { return $3573a4f429b0aea2$export$e8bacd2802a88316; });
const $3573a4f429b0aea2$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const $3573a4f429b0aea2$var$htmlEntities = {
    '&amp;': '&',
    '&#38;': '&',
    '&lt;': '<',
    '&#60;': '<',
    '&gt;': '>',
    '&#62;': '>',
    '&apos;': "'",
    '&#39;': "'",
    '&quot;': '"',
    '&#34;': '"',
    '&nbsp;': '\u00A0',
    '&#160;': '\u00A0',
    '&copy;': "\xa9",
    '&#169;': "\xa9",
    '&reg;': "\xae",
    '&#174;': "\xae",
    '&hellip;': "\u2026",
    '&#8230;': "\u2026",
    '&#x2F;': '/',
    '&#47;': '/'
};
const $3573a4f429b0aea2$var$unescapeHtmlEntity = (m)=>$3573a4f429b0aea2$var$htmlEntities[m];
const $3573a4f429b0aea2$export$e8bacd2802a88316 = (text)=>text.replace($3573a4f429b0aea2$var$matchHtmlEntity, $3573a4f429b0aea2$var$unescapeHtmlEntity);

});


parcelRegister("ch6yl", function(module, exports) {

$parcel$export(module.exports, "setI18n", function () { return $8efc27dd27f637cf$export$a039134f2fc7e0; });
$parcel$export(module.exports, "getI18n", function () { return $8efc27dd27f637cf$export$64af334f494c2f47; });
let $8efc27dd27f637cf$var$i18nInstance;
const $8efc27dd27f637cf$export$a039134f2fc7e0 = (instance)=>{
    $8efc27dd27f637cf$var$i18nInstance = instance;
};
const $8efc27dd27f637cf$export$64af334f494c2f47 = ()=>$8efc27dd27f637cf$var$i18nInstance;

});

parcelRegister("5AAkb", function(module, exports) {
//! moment.js
//! version : 2.31.0
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidOffset: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid$2(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidOffset && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid$1(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg + '\n' + new Error().stack);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\e)|(\\)?(eHHmm|[Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        var cacheKey = '$' + format;
        if (!hasOwnProp(formatFunctions, cacheKey)) formatFunctions[cacheKey] = makeFormatFunction(format);
        return formatFunctions[cacheKey](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get$2(this, unit);
        };
    }
    function get$2(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod$1(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod$1(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord, monthsParseProperties = [
        'monthsParse',
        'longMonthsParse',
        'shortMonthsParse',
        'monthsRegex',
        'monthsShortRegex',
        'monthsStrictRegex',
        'monthsShortStrictRegex'
    ];
    function clearMonthsParseCache(locale, config) {
        var i, prop;
        for(i = 0; i < monthsParseProperties.length; i++){
            prop = monthsParseProperties[i];
            if (!hasOwnProp(config, prop)) delete locale['_' + prop];
        }
    }
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse$1(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse$1.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get$2(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    addFormatToken('eHHmm', 0, 0, function() {
        return '' + this.weekday() + zeroFill(this.hours(), 2) + zeroFill(this.minutes(), 2);
    });
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('eHHmm', match5to6);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    addWeekParseToken('eHHmm', function(input, week, config) {
        var weekdayEnd = input.length - 4;
        week.e = toInt(input.substr(0, weekdayEnd));
        config._a[HOUR] = toInt(input.substr(weekdayEnd, 2));
        config._a[MINUTE] = toInt(input.substr(weekdayEnd + 2));
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord, weekdaysParseProperties = [
        'weekdaysParse',
        'fullWeekdaysParse',
        'shortWeekdaysParse',
        'minWeekdaysParse',
        'weekdaysRegex',
        'weekdaysShortRegex',
        'weekdaysMinRegex',
        'weekdaysStrictRegex',
        'weekdaysShortStrictRegex',
        'weekdaysMinStrictRegex'
    ];
    function clearWeekdaysParseCache(locale, config) {
        var i, prop;
        for(i = 0; i < weekdaysParseProperties.length; i++){
            prop = weekdaysParseProperties[i];
            if (!hasOwnProp(config, prop)) delete locale['_' + prop];
        }
    }
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get$2(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    function set(config) {
        var prop, i;
        clearMonthsParseCache(this, config);
        clearWeekdaysParseCache(this, config);
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar$1(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()], formatCache = this._longDateFormatCache;
        if (format || !formatUpper) return format;
        if (formatCache && formatCache[key] && formatCache[key].formatUpper === formatUpper) return formatCache[key].format;
        format = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        if (!formatCache) formatCache = this._longDateFormatCache = {};
        formatCache[key] = {
            formatUpper: formatUpper,
            format: format
        };
        return format;
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTimeWithoutPostformat(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function relativeTime$1(number, withoutSuffix, string, isFuture) {
        return this.postformat(relativeTimeWithoutPostformat.call(this, number, withoutSuffix, string, isFuture));
    }
    function pastFutureWithoutPostformat(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    function pastFuture(diff, output) {
        return this.postformat(pastFutureWithoutPostformat.call(this, diff, output));
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYearFromDayOfYear(year, dayOfYear, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), week = Math.floor((dayOfYear - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = year - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(year, dow, doy)) {
            resWeek = week - weeksInYear(year, dow, doy);
            resYear = year + 1;
        } else {
            resYear = year;
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        return weekOfYearFromDayOfYear(mom.year(), mom.dayOfYear(), dow, doy);
    }
    function weekOfYearFromDate(year, month, date, dow, doy) {
        var dayOfYear = Math.round((createUTCDate(year, month, date) - createUTCDate(year, 0, 1)) / 864e5) + 1;
        return weekOfYearFromDayOfYear(year, dayOfYear, dow, doy);
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Only canonical locale module names are safe to append to the require path.
        return typeof name === 'string' && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(name);
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire, normalizedName;
        // Preserve exact custom locale names before trying the canonical built-in name.
        // Use hasOwnProp rather than a plain lookup so that names like "__proto__",
        // "constructor", or "prototype" can't resolve to an inherited Object.prototype
        // property instead of a real (or missing) locale entry.
        if (hasOwnProp(locales, name)) return locales[name];
        normalizedName = normalizeLocale(name);
        if (hasOwnProp(locales, normalizedName)) return locales[normalizedName];
        // TODO: Find a better way to register and load all the locales in Node
        if (module && module.exports && isLocaleNameSane(normalizedName)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + normalizedName);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[normalizedName] = null; // null means not found
        }
        if (hasOwnProp(locales, normalizedName)) return locales[normalizedName];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        var locale, tmpLocale = loadLocale(name), parentConfig = baseConfig;
        if (tmpLocale != null) name = tmpLocale._abbr;
        if (config != null) {
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config, now, forWeek) {
        var hadWeekContext = Object.prototype.hasOwnProperty.call(config, '_isDefaultDatePartsForWeek'), weekContext = config._isDefaultDatePartsForWeek;
        // hooks is actually the exported moment object
        config._isDefaultDatePartsForWeek = !!forWeek;
        try {
            return hooks._getDefaultDateParts(config, now, forWeek);
        } finally{
            if (hadWeekContext) config._isDefaultDatePartsForWeek = weekContext;
            else delete config._isDefaultDatePartsForWeek;
        }
    }
    function currentDateNow(config) {
        var now = config._defaultDatePartsNow;
        if (!now) return hooks.now();
        if (!now.hasValue) {
            now.value = hooks.now();
            now.hasValue = true;
        }
        return now.value;
    }
    // Internal hook for extensions that supply omitted calendar fields.
    function getDefaultDateParts(config, now, forWeek) {
        var useWeekDefaults = forWeek || config._isDefaultDatePartsForWeek, nowValue = useWeekDefaults ? createLocal(now) : new Date(now);
        if (useWeekDefaults) return [
            nowValue.year(),
            nowValue.month(),
            nowValue.date()
        ];
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    hooks._getDefaultDateParts = getDefaultDateParts;
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], now, currentDate, expectedWeekday, yearToUse, dateIsDefaulted;
        if (config._d) return;
        if (config._a[YEAR] == null || config._a[MONTH] == null || config._a[DATE] == null) {
            now = currentDateNow(config);
            currentDate = currentDateArray(config, now);
        }
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config, currentDateArray(config, now, true));
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = config._a[YEAR] != null ? config._a[YEAR] : currentDate[YEAR];
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        dateIsDefaulted = config._a[YEAR] == null || config._a[MONTH] == null || config._a[DATE] == null;
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && !dateIsDefaulted && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config, currentDate) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYearFromDate(currentDate[YEAR], currentDate[MONTH], currentDate[DATE], 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYearFromDate(currentDate[YEAR], currentDate[MONTH], currentDate[DATE], dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, defaultDatePartsNow = {}, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._defaultDatePartsNow = defaultDatePartsNow;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid$2(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid$1({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid$2(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid$1();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid$1();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        for(i = 0; i < moments.length; ++i)if (isMoment(moments[i])) {
            res = moments[i];
            break;
        }
        if (!res) return createInvalid$1();
        for(++i; i < moments.length; ++i)if (isMoment(moments[i]) && (!moments[i].isValid() || moments[i][fn](res))) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        var offset = offsetFromString(matchShortOffset, input);
        config._useUTC = true;
        config._tzm = offset;
        if (offset === null) getParsingFlags(config).invalidOffset = input;
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        if (toInt(parts[2]) > 59 || (parts[0] === '+' ? minutes > 840 : minutes > 720)) return null;
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract$1(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract$1(this, dur, direction);
            return this;
        };
    }
    function addSubtract$1(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get$2(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get$2(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add$1 = createAdder(1, 'add'), subtract$1 = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone$1() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString$1(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf$1() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid() {
        return isValid$2(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto$2 = Moment.prototype;
    proto$2.add = add$1;
    proto$2.calendar = calendar;
    proto$2.clone = clone$1;
    proto$2.diff = diff;
    proto$2.endOf = endOf;
    proto$2.format = format;
    proto$2.from = from;
    proto$2.fromNow = fromNow;
    proto$2.to = to;
    proto$2.toNow = toNow;
    proto$2.get = stringGet;
    proto$2.invalidAt = invalidAt;
    proto$2.isAfter = isAfter;
    proto$2.isBefore = isBefore;
    proto$2.isBetween = isBetween;
    proto$2.isSame = isSame;
    proto$2.isSameOrAfter = isSameOrAfter;
    proto$2.isSameOrBefore = isSameOrBefore;
    proto$2.isValid = isValid;
    proto$2.lang = lang;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.max = prototypeMax;
    proto$2.min = prototypeMin;
    proto$2.parsingFlags = parsingFlags;
    proto$2.set = stringSet;
    proto$2.startOf = startOf;
    proto$2.subtract = subtract$1;
    proto$2.toArray = toArray;
    proto$2.toObject = toObject;
    proto$2.toDate = toDate;
    proto$2.toISOString = toISOString$1;
    proto$2.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto$2[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto$2.toJSON = toJSON;
    proto$2.toString = toString;
    proto$2.unix = unix;
    proto$2.valueOf = valueOf$1;
    proto$2.creationData = creationData;
    proto$2.eraName = getEraName;
    proto$2.eraNarrow = getEraNarrow;
    proto$2.eraAbbr = getEraAbbr;
    proto$2.eraYear = getEraYear;
    proto$2.year = getSetYear;
    proto$2.isLeapYear = getIsLeapYear;
    proto$2.weekYear = getSetWeekYear;
    proto$2.isoWeekYear = getSetISOWeekYear;
    proto$2.quarter = proto$2.quarters = getSetQuarter;
    proto$2.month = getSetMonth;
    proto$2.daysInMonth = getDaysInMonth;
    proto$2.week = proto$2.weeks = getSetWeek;
    proto$2.isoWeek = proto$2.isoWeeks = getSetISOWeek;
    proto$2.weeksInYear = getWeeksInYear;
    proto$2.weeksInWeekYear = getWeeksInWeekYear;
    proto$2.isoWeeksInYear = getISOWeeksInYear;
    proto$2.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto$2.date = getSetDayOfMonth;
    proto$2.day = proto$2.days = getSetDayOfWeek;
    proto$2.weekday = getSetLocaleDayOfWeek;
    proto$2.isoWeekday = getSetISODayOfWeek;
    proto$2.dayOfYear = getSetDayOfYear;
    proto$2.hour = proto$2.hours = getSetHour;
    proto$2.minute = proto$2.minutes = getSetMinute;
    proto$2.second = proto$2.seconds = getSetSecond;
    proto$2.millisecond = proto$2.milliseconds = getSetMillisecond;
    proto$2.utcOffset = getSetOffset;
    proto$2.utc = setOffsetToUTC;
    proto$2.local = setOffsetToLocal;
    proto$2.parseZone = setOffsetToParsedOffset;
    proto$2.hasAlignedHourOffset = hasAlignedHourOffset;
    proto$2.isDST = isDaylightSavingTime;
    proto$2.isLocal = isLocal;
    proto$2.isUtcOffset = isUtcOffset;
    proto$2.isUtc = isUtc;
    proto$2.isUTC = isUtc;
    proto$2.zoneAbbr = getZoneAbbr;
    proto$2.zoneName = getZoneName;
    proto$2.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto$2.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto$2.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto$2.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto$2.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar$1;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime$1;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs$1() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add(input, value) {
        return addSubtract(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract(input, value) {
        return addSubtract(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf = asMilliseconds;
    function clone() {
        return createDuration(this);
    }
    function get(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return relativeTimeWithoutPostformat.call(locale, number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = extend(extend({}, thresholds), argThresholds || {});
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime(this, !withSuffix, th, locale);
        if (withSuffix) output = pastFutureWithoutPostformat.call(locale, +this, output);
        return locale.postformat(output);
    }
    var abs = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs(this._milliseconds) / 1000, days = abs(this._days), months = abs(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto = Duration.prototype;
    proto.isValid = isValid$1;
    proto.abs = abs$1;
    proto.add = add;
    proto.subtract = subtract;
    proto.as = as;
    proto.asMilliseconds = asMilliseconds;
    proto.asSeconds = asSeconds;
    proto.asMinutes = asMinutes;
    proto.asHours = asHours;
    proto.asDays = asDays;
    proto.asWeeks = asWeeks;
    proto.asMonths = asMonths;
    proto.asQuarters = asQuarters;
    proto.asYears = asYears;
    proto.valueOf = valueOf;
    proto._bubble = bubble;
    proto.clone = clone;
    proto.get = get;
    proto.milliseconds = milliseconds;
    proto.seconds = seconds;
    proto.minutes = minutes;
    proto.hours = hours;
    proto.days = days;
    proto.weeks = weeks;
    proto.months = months;
    proto.years = years;
    proto.humanize = humanize;
    proto.toISOString = toISOString;
    proto.toString = toISOString;
    proto.toJSON = toISOString;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString);
    proto.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.31.0';
    setHookCallback(createLocal);
    hooks.fn = proto$2;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid$1;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto$2;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});

parcelRegister("2eqHs", function(module, exports) {

$parcel$export(module.exports, "useTranslation", function () { return $1a01999b93cbc850$export$9fc83ad70ead8663; });

var $jpgPw = parcelRequire("jpgPw");

var $5vkWK = parcelRequire("5vkWK");

var $eQhQZ = parcelRequire("eQhQZ");

var $21Cbc = parcelRequire("21Cbc");parcelRequire("jU3fb");
var $ch6yl = parcelRequire("ch6yl");
var $jU3fb = parcelRequire("jU3fb");

var $ldxAu = parcelRequire("ldxAu");
const $1a01999b93cbc850$var$notReadyT = (k, optsOrDefaultValue)=>{
    if ((0, $ldxAu.isString)(optsOrDefaultValue)) return optsOrDefaultValue;
    if ((0, $ldxAu.isObject)(optsOrDefaultValue) && (0, $ldxAu.isString)(optsOrDefaultValue.defaultValue)) return optsOrDefaultValue.defaultValue;
    if (typeof k === 'function') return '';
    if (Array.isArray(k)) {
        const last = k[k.length - 1];
        return typeof last === 'function' ? '' : last;
    }
    return k;
};
const $1a01999b93cbc850$var$notReadySnapshot = {
    t: $1a01999b93cbc850$var$notReadyT,
    ready: false
};
const $1a01999b93cbc850$var$dummySubscribe = ()=>()=>{};
const $1a01999b93cbc850$export$9fc83ad70ead8663 = (ns, props = {})=>{
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $jpgPw.useContext)((0, $jU3fb.I18nContext)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $ch6yl.getI18n)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $jU3fb.ReportNamespaces)();
    if (!i18n) (0, $ldxAu.warnOnce)(i18n, 'NO_I18NEXT_INSTANCE', 'useTranslation: You will need to pass in an i18next instance by using initReactI18next or by passing it via props or context. In monorepo setups, make sure there is only one instance of react-i18next.');
    const i18nOptions = (0, $jpgPw.useMemo)(()=>({
            ...(0, $21Cbc.getDefaults)(),
            ...i18n?.options?.react,
            ...props
        }), [
        i18n,
        props
    ]);
    const { useSuspense: useSuspense, keyPrefix: keyPrefix, bindI18n: bindI18n, bindI18nStore: bindI18nStore } = i18nOptions;
    const nsOrContext = ns || defaultNSFromContext || i18n?.options?.defaultNS;
    const unstableNamespaces = (0, $ldxAu.isString)(nsOrContext) ? [
        nsOrContext
    ] : nsOrContext || [
        'translation'
    ];
    const namespacesKey = JSON.stringify(unstableNamespaces);
    const namespaces = (0, $jpgPw.useMemo)(()=>unstableNamespaces, [
        namespacesKey
    ]);
    i18n?.reportNamespaces?.addUsedNamespaces?.(namespaces);
    const revisionRef = (0, $jpgPw.useRef)(0);
    const subscribe = (0, $jpgPw.useCallback)((callback)=>{
        if (!i18n) return $1a01999b93cbc850$var$dummySubscribe;
        const wrappedCallback = ()=>{
            revisionRef.current += 1;
            callback();
        };
        if (bindI18n) i18n.on(bindI18n, wrappedCallback);
        if (bindI18nStore) i18n.store.on(bindI18nStore, wrappedCallback);
        return ()=>{
            if (bindI18n) bindI18n.split(' ').forEach((e)=>i18n.off(e, wrappedCallback));
            if (bindI18nStore) bindI18nStore.split(' ').forEach((e)=>i18n.store.off(e, wrappedCallback));
        };
    }, [
        i18n,
        bindI18n,
        bindI18nStore
    ]);
    const snapshotRef = (0, $jpgPw.useRef)();
    const getSnapshot = (0, $jpgPw.useCallback)(()=>{
        if (!i18n) return $1a01999b93cbc850$var$notReadySnapshot;
        const calculatedReady = !!(i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every((n)=>(0, $ldxAu.hasLoadedNamespace)(n, i18n, i18nOptions));
        const currentLng = props.lng || i18n.language;
        const currentRevision = revisionRef.current;
        const keyPrefixKey = typeof keyPrefix === 'function' ? (0, $eQhQZ.keyFromSelector)(keyPrefix, {
            ...i18n.options,
            ns: namespaces
        }) : keyPrefix;
        const lastSnapshot = snapshotRef.current;
        if (lastSnapshot && lastSnapshot.i18n === i18n && lastSnapshot.ready === calculatedReady && lastSnapshot.lng === currentLng && lastSnapshot.namespaces === namespaces && lastSnapshot.keyPrefix === keyPrefixKey && lastSnapshot.revision === currentRevision) return lastSnapshot;
        const calculatedT = i18n.getFixedT(currentLng, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix, {
            scopeNs: namespaces
        });
        const newSnapshot = {
            t: calculatedT,
            i18n: i18n,
            ready: calculatedReady,
            lng: currentLng,
            namespaces: namespaces,
            keyPrefix: keyPrefixKey,
            revision: currentRevision
        };
        snapshotRef.current = newSnapshot;
        return newSnapshot;
    }, [
        i18n,
        namespaces,
        keyPrefix,
        i18nOptions,
        props.lng
    ]);
    const [loadCount, setLoadCount] = (0, $jpgPw.useState)(0);
    let { t: t, ready: ready } = (0, $5vkWK.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    let pendingTranslationLoad;
    if (i18n && useSuspense && !ready) {
        pendingTranslationLoad = new Promise((resolve)=>{
            const onLoaded = ()=>resolve();
            if (props.lng) (0, $ldxAu.loadLanguages)(i18n, props.lng, namespaces, onLoaded);
            else (0, $ldxAu.loadNamespaces)(i18n, namespaces, onLoaded);
        });
        ({ t: t, ready: ready } = getSnapshot());
    }
    (0, $jpgPw.useEffect)(()=>{
        if (i18n && !ready && !useSuspense) {
            const onLoaded = ()=>setLoadCount((c)=>c + 1);
            if (props.lng) (0, $ldxAu.loadLanguages)(i18n, props.lng, namespaces, onLoaded);
            else (0, $ldxAu.loadNamespaces)(i18n, namespaces, onLoaded);
        }
    }, [
        i18n,
        props.lng,
        namespaces,
        ready,
        useSuspense,
        loadCount
    ]);
    const finalI18n = i18n || {};
    const wrapperRef = (0, $jpgPw.useRef)(null);
    const wrapperLangRef = (0, $jpgPw.useRef)();
    const languageKey = (inst)=>`${inst.language}|${inst.resolvedLanguage}|${inst.languages?.join(',')}`;
    const createI18nWrapper = (original)=>{
        const descriptors = Object.getOwnPropertyDescriptors(original);
        if (descriptors.__original) delete descriptors.__original;
        const wrapper = Object.create(Object.getPrototypeOf(original), descriptors);
        if (!Object.prototype.hasOwnProperty.call(wrapper, '__original')) try {
            Object.defineProperty(wrapper, '__original', {
                value: original,
                writable: false,
                enumerable: false,
                configurable: false
            });
        } catch (_) {}
        return wrapper;
    };
    const ret = (0, $jpgPw.useMemo)(()=>{
        const original = finalI18n;
        const lang = original && languageKey(original);
        let i18nWrapper = original;
        if (original) {
            if (wrapperRef.current && wrapperRef.current.__original === original) {
                if (wrapperLangRef.current !== lang) {
                    i18nWrapper = createI18nWrapper(original);
                    wrapperRef.current = i18nWrapper;
                    wrapperLangRef.current = lang;
                } else i18nWrapper = wrapperRef.current;
            } else {
                i18nWrapper = createI18nWrapper(original);
                wrapperRef.current = i18nWrapper;
                wrapperLangRef.current = lang;
            }
        }
        const effectiveT = !ready && !useSuspense ? (...args)=>{
            (0, $ldxAu.warnOnce)(i18n, 'USE_T_BEFORE_READY', 'useTranslation: t was called before ready. When using useSuspense: false, make sure to check the ready flag before using t.');
            return t(...args);
        } : t;
        const arr = [
            effectiveT,
            i18nWrapper,
            ready
        ];
        arr.t = effectiveT;
        arr.i18n = i18nWrapper;
        arr.ready = ready;
        return arr;
    }, [
        t,
        finalI18n,
        ready,
        finalI18n.resolvedLanguage,
        finalI18n.language,
        finalI18n.languages
    ]);
    if (i18n && useSuspense && !ready) {
        let inDevelopment = false;
        try {
            inDevelopment = false;
        } catch (e) {}
        if (inDevelopment) (0, $ldxAu.warnOnce)(i18n, 'SUSPENDED_WHILE_LOADING', 'useTranslation: suspended while translations are loading (useSuspense is true by default). Add a <Suspense> boundary above this component, or set react.useSuspense: false in the i18next init options. https://react.i18next.com/latest/usetranslation-hook');
        throw pendingTranslationLoad;
    }
    return ret;
};

});
parcelRegister("5vkWK", function(module, exports) {
'use strict';

module.exports = (parcelRequire("kJ7aO"));

});
parcelRegister("kJ7aO", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $f16d931f22139a31$export$306c0aa65ff9ec16; }, function (v) { return $f16d931f22139a31$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f16d931f22139a31$export$306c0aa65ff9ec16;
"use strict";

var $jpgPw = parcelRequire("jpgPw");
function $f16d931f22139a31$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $f16d931f22139a31$var$objectIs = "function" === typeof Object.is ? Object.is : $f16d931f22139a31$var$is, $f16d931f22139a31$var$useState = $jpgPw.useState, $f16d931f22139a31$var$useEffect = $jpgPw.useEffect, $f16d931f22139a31$var$useLayoutEffect = $jpgPw.useLayoutEffect, $f16d931f22139a31$var$useDebugValue = $jpgPw.useDebugValue;
function $f16d931f22139a31$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $f16d931f22139a31$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $f16d931f22139a31$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $f16d931f22139a31$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $f16d931f22139a31$var$useEffect(function() {
        $f16d931f22139a31$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $f16d931f22139a31$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $f16d931f22139a31$var$useDebugValue(value);
    return value;
}
function $f16d931f22139a31$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$f16d931f22139a31$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $f16d931f22139a31$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $f16d931f22139a31$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $f16d931f22139a31$var$useSyncExternalStore$1 : $f16d931f22139a31$var$useSyncExternalStore$2;
$f16d931f22139a31$export$306c0aa65ff9ec16 = void 0 !== $jpgPw.useSyncExternalStore ? $jpgPw.useSyncExternalStore : $f16d931f22139a31$var$shim;

});


parcelRegister("jU3fb", function(module, exports) {

$parcel$export(module.exports, "I18nContext", function () { return $e7d5c37083191f98$export$5603ab5ced17ce64; });
$parcel$export(module.exports, "ReportNamespaces", function () { return $e7d5c37083191f98$export$ea171b67e3820290; });
$parcel$export(module.exports, "getI18n", function () { return (parcelRequire("ch6yl")).getI18n; });

var $jpgPw = parcelRequire("jpgPw");

var $21Cbc = parcelRequire("21Cbc");

var $ch6yl = parcelRequire("ch6yl");

const $e7d5c37083191f98$export$5603ab5ced17ce64 = (0, $jpgPw.createContext)();
class $e7d5c37083191f98$export$ea171b67e3820290 {
    constructor(){
        this.usedNamespaces = {};
    }
    addUsedNamespaces(namespaces) {
        namespaces.forEach((ns)=>{
            if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
        });
    }
    getUsedNamespaces() {
        return Object.keys(this.usedNamespaces);
    }
}
const $e7d5c37083191f98$export$30ff0342ccf735a = (ForComponent)=>async (ctx)=>{
        const componentsInitialProps = await ForComponent.getInitialProps?.(ctx) ?? {};
        const i18nInitialProps = $e7d5c37083191f98$export$704200e5d0b9e8f();
        return {
            ...componentsInitialProps,
            ...i18nInitialProps
        };
    };
const $e7d5c37083191f98$export$704200e5d0b9e8f = ()=>{
    const i18n = (0, $ch6yl.getI18n)();
    if (!i18n) {
        console.warn('react-i18next:: getInitialProps: You will need to pass in an i18next instance by using initReactI18next');
        return {};
    }
    const namespaces = i18n.reportNamespaces?.getUsedNamespaces() ?? [];
    const ret = {};
    const initialI18nStore = {};
    i18n.languages.forEach((l)=>{
        initialI18nStore[l] = {};
        namespaces.forEach((ns)=>{
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
};

});

parcelRegister("ldxAu", function(module, exports) {

$parcel$export(module.exports, "warn", function () { return $f724dda2bfbffb69$export$c106dd0671a0fc2d; });
$parcel$export(module.exports, "isString", function () { return $f724dda2bfbffb69$export$844ec244b1367d54; });
$parcel$export(module.exports, "warnOnce", function () { return $f724dda2bfbffb69$export$5b28268982f175ba; });
$parcel$export(module.exports, "loadNamespaces", function () { return $f724dda2bfbffb69$export$83be934b53fff43b; });
$parcel$export(module.exports, "loadLanguages", function () { return $f724dda2bfbffb69$export$8cd7e7a54fa865bc; });
$parcel$export(module.exports, "hasLoadedNamespace", function () { return $f724dda2bfbffb69$export$93d9ee97c1ad3f31; });
$parcel$export(module.exports, "getDisplayName", function () { return $f724dda2bfbffb69$export$be63e0664592e141; });
$parcel$export(module.exports, "isObject", function () { return $f724dda2bfbffb69$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "getFormatPlugin", function () { return $f724dda2bfbffb69$export$42dc1be010b7c7a5; });
$parcel$export(module.exports, "escapeStringValues", function () { return $f724dda2bfbffb69$export$5cbeb09aec284329; });
const $f724dda2bfbffb69$export$c106dd0671a0fc2d = (i18n, code, msg, rest)=>{
    const args = [
        msg,
        {
            code: code,
            ...rest || {}
        }
    ];
    if (i18n?.services?.logger?.forward) return i18n.services.logger.forward(args, 'warn', 'react-i18next::', true);
    if ($f724dda2bfbffb69$export$844ec244b1367d54(args[0])) args[0] = `react-i18next:: ${args[0]}`;
    if (i18n?.services?.logger?.warn) i18n.services.logger.warn(...args);
    else if (console?.warn) console.warn(...args);
};
const $f724dda2bfbffb69$var$alreadyWarned = {};
const $f724dda2bfbffb69$export$5b28268982f175ba = (i18n, code, msg, rest)=>{
    if ($f724dda2bfbffb69$export$844ec244b1367d54(msg) && $f724dda2bfbffb69$var$alreadyWarned[msg]) return;
    if ($f724dda2bfbffb69$export$844ec244b1367d54(msg)) $f724dda2bfbffb69$var$alreadyWarned[msg] = new Date();
    $f724dda2bfbffb69$export$c106dd0671a0fc2d(i18n, code, msg, rest);
};
const $f724dda2bfbffb69$var$loadedClb = (i18n, cb)=>()=>{
        if (i18n.isInitialized) cb();
        else {
            const initialized = ()=>{
                setTimeout(()=>{
                    i18n.off('initialized', initialized);
                }, 0);
                cb();
            };
            i18n.on('initialized', initialized);
        }
    };
const $f724dda2bfbffb69$export$83be934b53fff43b = (i18n, ns, cb)=>{
    i18n.loadNamespaces(ns, $f724dda2bfbffb69$var$loadedClb(i18n, cb));
};
const $f724dda2bfbffb69$export$8cd7e7a54fa865bc = (i18n, lng, ns, cb)=>{
    if ($f724dda2bfbffb69$export$844ec244b1367d54(ns)) ns = [
        ns
    ];
    if (i18n.options.preload && i18n.options.preload.indexOf(lng) > -1) return $f724dda2bfbffb69$export$83be934b53fff43b(i18n, ns, cb);
    ns.forEach((n)=>{
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $f724dda2bfbffb69$var$loadedClb(i18n, cb));
};
const $f724dda2bfbffb69$export$93d9ee97c1ad3f31 = (ns, i18n, options = {})=>{
    if (!i18n.languages || !i18n.languages.length) {
        $f724dda2bfbffb69$export$5b28268982f175ba(i18n, 'NO_LANGUAGES', 'i18n.languages were undefined or empty', {
            languages: i18n.languages
        });
        return true;
    }
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: (i18nInstance, loadNotPending)=>{
            if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
};
const $f724dda2bfbffb69$export$be63e0664592e141 = (Component)=>Component.displayName || Component.name || ($f724dda2bfbffb69$export$844ec244b1367d54(Component) && Component.length > 0 ? Component : 'Unknown');
const $f724dda2bfbffb69$export$844ec244b1367d54 = (obj)=>typeof obj === 'string';
const $f724dda2bfbffb69$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'object' && obj !== null;
const $f724dda2bfbffb69$export$42dc1be010b7c7a5 = (i18n)=>{
    const plugin = i18n?.services?.i18nFormat;
    return typeof plugin?.parse === 'function' ? plugin : undefined;
};
const $f724dda2bfbffb69$var$htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
};
const $f724dda2bfbffb69$export$5cbeb09aec284329 = (values)=>{
    if (!values) return values;
    const escaped = {};
    Object.keys(values).forEach((k)=>{
        const v = values[k];
        escaped[k] = $f724dda2bfbffb69$export$844ec244b1367d54(v) ? v.replace(/[&<>"']/g, (c)=>$f724dda2bfbffb69$var$htmlEscapes[c]) : v;
    });
    return escaped;
};

});


parcelRegister("3AnAR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29c70917eadef818$export$2e2bcd8739ae039; });

var $caZvI = parcelRequire("caZvI");
parcelRequire("jpgPw");

var $3da5u = parcelRequire("3da5u");

var $58fAg = parcelRequire("58fAg");

var $fCgwC = parcelRequire("fCgwC");

var $cXDiG = parcelRequire("cXDiG");
const $29c70917eadef818$var$Frame = ({ id: id, className: className, children: children })=>{
    return (0, $caZvI.jsxs)($29c70917eadef818$var$Container, {
        id: id,
        className: className,
        children: [
            (0, $caZvI.jsx)((0, $58fAg.TopMenuBar), {}),
            (0, $caZvI.jsx)((0, $cXDiG.default), {}),
            (0, $caZvI.jsx)($29c70917eadef818$var$Main, {
                children: children
            }),
            (0, $caZvI.jsx)((0, $fCgwC.default), {})
        ]
    });
};
const $29c70917eadef818$var$Container = (0, $3da5u.default).div`
  min-height: 100vh;
  display: flex;
  flex-flow: column nowrap;
`;
const $29c70917eadef818$var$Main = (0, $3da5u.default).main`
  flex: 1 1 100%;
  position: relative;
  z-index: 1;
  display: flex;
  flex-flow: column nowrap;
`;
var $29c70917eadef818$export$2e2bcd8739ae039 = $29c70917eadef818$var$Frame;

});
parcelRegister("3da5u", function(module, exports) {

$parcel$export(module.exports, "css", function () { return $256a692f819e7a3b$export$dbf350e5966cf602; });
$parcel$export(module.exports, "createGlobalStyle", function () { return $256a692f819e7a3b$export$f0f03736edb61697; });
$parcel$export(module.exports, "keyframes", function () { return $256a692f819e7a3b$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "default", function () { return $256a692f819e7a3b$export$2e2bcd8739ae039; });

var $lvxRU = parcelRequire("lvxRU");

var $jpgPw = parcelRequire("jpgPw");

var $fDLVH = parcelRequire("fDLVH");

var $jbPwP = parcelRequire("jbPwP");

var $3RrRC = parcelRequire("3RrRC");

var $bxfQs = parcelRequire("bxfQs");

var $5UQkf = parcelRequire("5UQkf");
function $256a692f819e7a3b$var$y() {
    return ($256a692f819e7a3b$var$y = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }).apply(this, arguments);
}
var $256a692f819e7a3b$var$v = function(e, t) {
    for(var n = [
        e[0]
    ], r = 0, o = t.length; r < o; r += 1)n.push(t[r], e[r + 1]);
    return n;
}, $256a692f819e7a3b$var$g = function(t) {
    return null !== t && "object" == typeof t && "[object Object]" === (t.toString ? t.toString() : Object.prototype.toString.call(t)) && !(0, $lvxRU.typeOf)(t);
}, $256a692f819e7a3b$var$S = Object.freeze([]), $256a692f819e7a3b$var$w = Object.freeze({});
function $256a692f819e7a3b$var$E(e) {
    return "function" == typeof e;
}
function $256a692f819e7a3b$var$b(e) {
    return e.displayName || e.name || "Component";
}
function $256a692f819e7a3b$export$7ba318d8d2f06c76(e) {
    return e && "string" == typeof e.styledComponentId;
}
var $256a692f819e7a3b$var$N = "data-styled", $256a692f819e7a3b$export$83d89fbfd8236492 = "5.3.11", $256a692f819e7a3b$var$C = "undefined" != typeof window && "HTMLElement" in window, $256a692f819e7a3b$var$I = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : false), $256a692f819e7a3b$var$P = {}, $256a692f819e7a3b$var$O = {};
function $256a692f819e7a3b$var$R() {
    for(var e = arguments.length <= 0 ? void 0 : arguments[0], t = [], n = 1, r = arguments.length; n < r; n += 1)t.push(n < 0 || arguments.length <= n ? void 0 : arguments[n]);
    return t.forEach(function(t) {
        e = e.replace(/%[a-z]/, t);
    }), e;
}
function $256a692f819e7a3b$var$D(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    throw new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (n.length > 0 ? " Args: " + n.join(", ") : ""));
}
var $256a692f819e7a3b$var$j = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    var t = e.prototype;
    return t.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, t.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, r = n.length, o = r; e >= o;)(o <<= 1) < 0 && $256a692f819e7a3b$var$D(16, "" + e);
            this.groupSizes = new Uint32Array(o), this.groupSizes.set(n), this.length = o;
            for(var s = r; s < o; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = 0, c = t.length; a < c; a++)this.tag.insertRule(i, t[a]) && (this.groupSizes[e]++, i++);
    }, t.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), r = n + t;
            this.groupSizes[e] = 0;
            for(var o = n; o < r; o++)this.tag.deleteRule(n);
        }
    }, t.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], r = this.indexOfGroup(e), o = r + n, s = r; s < o; s++)t += this.tag.getRule(s) + "/*!sc*/\n";
        return t;
    }, e;
}(), $256a692f819e7a3b$var$T = new Map, $256a692f819e7a3b$var$x = new Map, $256a692f819e7a3b$var$k = 1, $256a692f819e7a3b$var$V = function(e) {
    if ($256a692f819e7a3b$var$T.has(e)) return $256a692f819e7a3b$var$T.get(e);
    for(; $256a692f819e7a3b$var$x.has($256a692f819e7a3b$var$k);)$256a692f819e7a3b$var$k++;
    var t = $256a692f819e7a3b$var$k++;
    return $256a692f819e7a3b$var$T.set(e, t), $256a692f819e7a3b$var$x.set(t, e), t;
}, $256a692f819e7a3b$var$B = function(e) {
    return $256a692f819e7a3b$var$x.get(e);
}, $256a692f819e7a3b$var$z = function(e, t) {
    t >= $256a692f819e7a3b$var$k && ($256a692f819e7a3b$var$k = t + 1), $256a692f819e7a3b$var$T.set(e, t), $256a692f819e7a3b$var$x.set(t, e);
}, $256a692f819e7a3b$var$M = "style[" + $256a692f819e7a3b$var$N + '][data-styled-version="5.3.11"]', $256a692f819e7a3b$var$G = new RegExp("^" + $256a692f819e7a3b$var$N + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), $256a692f819e7a3b$var$L = function(e, t, n) {
    for(var r, o = n.split(","), s = 0, i = o.length; s < i; s++)(r = o[s]) && e.registerName(t, r);
}, $256a692f819e7a3b$var$F = function(e, t) {
    for(var n = (t.textContent || "").split("/*!sc*/\n"), r = [], o = 0, s = n.length; o < s; o++){
        var i = n[o].trim();
        if (i) {
            var a = i.match($256a692f819e7a3b$var$G);
            if (a) {
                var c = 0 | parseInt(a[1], 10), u = a[2];
                0 !== c && ($256a692f819e7a3b$var$z(u, c), $256a692f819e7a3b$var$L(e, u, a[3]), e.getTag().insertRules(c, r)), r.length = 0;
            } else r.push(i);
        }
    }
}, $256a692f819e7a3b$var$Y = function() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}, $256a692f819e7a3b$var$q = function(e) {
    var t = document.head, n = e || t, r = document.createElement("style"), o = function(e) {
        for(var t = e.childNodes, n = t.length; n >= 0; n--){
            var r = t[n];
            if (r && 1 === r.nodeType && r.hasAttribute($256a692f819e7a3b$var$N)) return r;
        }
    }(n), s = void 0 !== o ? o.nextSibling : null;
    r.setAttribute($256a692f819e7a3b$var$N, "active"), r.setAttribute("data-styled-version", "5.3.11");
    var i = $256a692f819e7a3b$var$Y();
    return i && r.setAttribute("nonce", i), n.insertBefore(r, s), r;
}, $256a692f819e7a3b$var$H = function() {
    function e(e) {
        var t = this.element = $256a692f819e7a3b$var$q(e);
        t.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, r = t.length; n < r; n++){
                var o = t[n];
                if (o.ownerNode === e) return o;
            }
            $256a692f819e7a3b$var$D(17);
        }(t), this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, t.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, t.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return void 0 !== t && "string" == typeof t.cssText ? t.cssText : "";
    }, e;
}(), $256a692f819e7a3b$var$$ = function() {
    function e(e) {
        var t = this.element = $256a692f819e7a3b$var$q(e);
        this.nodes = t.childNodes, this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t), r = this.nodes[e];
            return this.element.insertBefore(n, r || null), this.length++, !0;
        }
        return !1;
    }, t.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $256a692f819e7a3b$var$W = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, t.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $256a692f819e7a3b$var$U = $256a692f819e7a3b$var$C, $256a692f819e7a3b$var$J = {
    isServer: !$256a692f819e7a3b$var$C,
    useCSSOMInjection: !$256a692f819e7a3b$var$I
}, $256a692f819e7a3b$var$X = function() {
    function e(e, t, n) {
        void 0 === e && (e = $256a692f819e7a3b$var$w), void 0 === t && (t = {}), this.options = $256a692f819e7a3b$var$y({}, $256a692f819e7a3b$var$J, {}, e), this.gs = t, this.names = new Map(n), this.server = !!e.isServer, !this.server && $256a692f819e7a3b$var$C && $256a692f819e7a3b$var$U && ($256a692f819e7a3b$var$U = !1, function(e) {
            for(var t = document.querySelectorAll($256a692f819e7a3b$var$M), n = 0, r = t.length; n < r; n++){
                var o = t[n];
                o && "active" !== o.getAttribute($256a692f819e7a3b$var$N) && ($256a692f819e7a3b$var$F(e, o), o.parentNode && o.parentNode.removeChild(o));
            }
        }(this));
    }
    e.registerId = function(e) {
        return $256a692f819e7a3b$var$V(e);
    };
    var t = e.prototype;
    return t.reconstructWithOptions = function(t, n) {
        return void 0 === n && (n = !0), new e($256a692f819e7a3b$var$y({}, this.options, {}, t), this.gs, n && this.names || void 0);
    }, t.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, t.getTag = function() {
        var e, t, n, r, o;
        return this.tag || (this.tag = (n = (t = this.options).isServer, r = t.useCSSOMInjection, o = t.target, e = n ? new $256a692f819e7a3b$var$W(o) : r ? new $256a692f819e7a3b$var$H(o) : new $256a692f819e7a3b$var$$(o), new $256a692f819e7a3b$var$j(e)));
    }, t.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, t.registerName = function(e, t) {
        if ($256a692f819e7a3b$var$V(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, t.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($256a692f819e7a3b$var$V(e), n);
    }, t.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, t.clearRules = function(e) {
        this.getTag().clearGroup($256a692f819e7a3b$var$V(e)), this.clearNames(e);
    }, t.clearTag = function() {
        this.tag = void 0;
    }, t.toString = function() {
        return function(e) {
            for(var t = e.getTag(), n = t.length, r = "", o = 0; o < n; o++){
                var s = $256a692f819e7a3b$var$B(o);
                if (void 0 !== s) {
                    var i = e.names.get(s), a = t.getGroup(o);
                    if (i && a && i.size) {
                        var c = $256a692f819e7a3b$var$N + ".g" + o + '[id="' + s + '"]', u = "";
                        void 0 !== i && i.forEach(function(e) {
                            e.length > 0 && (u += e + ",");
                        }), r += "" + a + c + '{content:"' + u + '"}/*!sc*/\n';
                    }
                }
            }
            return r;
        }(this);
    }, e;
}(), $256a692f819e7a3b$var$Z = /(a)(d)/gi, $256a692f819e7a3b$var$K = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $256a692f819e7a3b$var$Q(e) {
    var t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $256a692f819e7a3b$var$K(t % 52) + n;
    return ($256a692f819e7a3b$var$K(t % 52) + n).replace($256a692f819e7a3b$var$Z, "$1-$2");
}
var $256a692f819e7a3b$var$ee = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $256a692f819e7a3b$var$te = function(e) {
    return $256a692f819e7a3b$var$ee(5381, e);
};
function $256a692f819e7a3b$var$ne(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($256a692f819e7a3b$var$E(n) && !$256a692f819e7a3b$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $256a692f819e7a3b$var$re = $256a692f819e7a3b$var$te("5.3.11"), $256a692f819e7a3b$var$oe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $256a692f819e7a3b$var$ne(e), this.componentId = t, this.baseHash = $256a692f819e7a3b$var$ee($256a692f819e7a3b$var$re, t), this.baseStyle = n, $256a692f819e7a3b$var$X.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var r = this.componentId, o = [];
        if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(r, this.staticRulesId)) o.push(this.staticRulesId);
            else {
                var s = $256a692f819e7a3b$var$_e(this.rules, e, t, n).join(""), i = $256a692f819e7a3b$var$Q($256a692f819e7a3b$var$ee(this.baseHash, s) >>> 0);
                if (!t.hasNameForId(r, i)) {
                    var a = n(s, "." + i, void 0, r);
                    t.insertRules(r, i, a);
                }
                o.push(i), this.staticRulesId = i;
            }
        } else {
            for(var c = this.rules.length, u = $256a692f819e7a3b$var$ee(this.baseHash, n.hash), l = "", d = 0; d < c; d++){
                var h = this.rules[d];
                if ("string" == typeof h) l += h;
                else if (h) {
                    var p = $256a692f819e7a3b$var$_e(h, e, t, n), f = Array.isArray(p) ? p.join("") : p;
                    u = $256a692f819e7a3b$var$ee(u, f + d), l += f;
                }
            }
            if (l) {
                var m = $256a692f819e7a3b$var$Q(u >>> 0);
                if (!t.hasNameForId(r, m)) {
                    var y = n(l, "." + m, void 0, r);
                    t.insertRules(r, m, y);
                }
                o.push(m);
            }
        }
        return o.join(" ");
    }, e;
}(), $256a692f819e7a3b$var$se = /^\s*\/\/.*$/gm, $256a692f819e7a3b$var$ie = [
    ":",
    "[",
    ".",
    "#"
];
function $256a692f819e7a3b$var$ae(e) {
    var t, n, r, o, s = void 0 === e ? $256a692f819e7a3b$var$w : e, i = s.options, a = void 0 === i ? $256a692f819e7a3b$var$w : i, c = s.plugins, u = void 0 === c ? $256a692f819e7a3b$var$S : c, l = new (0, $jbPwP.default)(a), d = [], p = function(e) {
        function t(t) {
            if (t) try {
                e(t + "}");
            } catch (e) {}
        }
        return function(n, r, o, s, i, a, c, u, l, d) {
            switch(n){
                case 1:
                    if (0 === l && 64 === r.charCodeAt(0)) return e(r + ";"), "";
                    break;
                case 2:
                    if (0 === u) return r + "/*|*/";
                    break;
                case 3:
                    switch(u){
                        case 102:
                        case 112:
                            return e(o[0] + r), "";
                        default:
                            return r + (0 === d ? "/*|*/" : "");
                    }
                case -2:
                    r.split("/*|*/}").forEach(t);
            }
        };
    }(function(e) {
        d.push(e);
    }), f = function(e, r, s) {
        return 0 === r && -1 !== $256a692f819e7a3b$var$ie.indexOf(s[n.length]) || s.match(o) ? e : "." + t;
    };
    function m(e, s, i, a) {
        void 0 === a && (a = "&");
        var c = e.replace($256a692f819e7a3b$var$se, ""), u = s && i ? i + " " + s + " { " + c + " }" : c;
        return t = a, n = s, r = new RegExp("\\" + n + "\\b", "g"), o = new RegExp("(\\" + n + "\\b){2,}"), l(i || !s ? "" : s, u);
    }
    return l.use([].concat(u, [
        function(e, t, o) {
            2 === e && o.length && o[0].lastIndexOf(n) > 0 && (o[0] = o[0].replace(r, f));
        },
        p,
        function(e) {
            if (-2 === e) {
                var t = d;
                return d = [], t;
            }
        }
    ])), m.hash = u.length ? u.reduce(function(e, t) {
        return t.name || $256a692f819e7a3b$var$D(15), $256a692f819e7a3b$var$ee(e, t.name);
    }, 5381).toString() : "", m;
}
var $256a692f819e7a3b$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($jpgPw))).createContext(), $256a692f819e7a3b$export$91317688fc694efa = $256a692f819e7a3b$export$8c190ef828af4c86.Consumer, $256a692f819e7a3b$var$le = (0, (/*@__PURE__*/$parcel$interopDefault($jpgPw))).createContext(), $256a692f819e7a3b$var$de = ($256a692f819e7a3b$var$le.Consumer, new $256a692f819e7a3b$var$X), $256a692f819e7a3b$var$he = $256a692f819e7a3b$var$ae();
function $256a692f819e7a3b$var$pe() {
    return (0, $jpgPw.useContext)($256a692f819e7a3b$export$8c190ef828af4c86) || $256a692f819e7a3b$var$de;
}
function $256a692f819e7a3b$var$fe() {
    return (0, $jpgPw.useContext)($256a692f819e7a3b$var$le) || $256a692f819e7a3b$var$he;
}
function $256a692f819e7a3b$export$a473771da2f0ff7c(e) {
    var t = (0, $jpgPw.useState)(e.stylisPlugins), n = t[0], s = t[1], c = $256a692f819e7a3b$var$pe(), u = (0, $jpgPw.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target
    ]), l = (0, $jpgPw.useMemo)(function() {
        return $256a692f819e7a3b$var$ae({
            options: {
                prefix: !e.disableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.disableVendorPrefixes,
        n
    ]);
    return (0, $jpgPw.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fDLVH)))(n, e.stylisPlugins) || s(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($jpgPw))).createElement($256a692f819e7a3b$export$8c190ef828af4c86.Provider, {
        value: u
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jpgPw))).createElement($256a692f819e7a3b$var$le.Provider, {
        value: l
    }, (0, e.children)));
}
var $256a692f819e7a3b$var$ye = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $256a692f819e7a3b$var$he);
            var r = n.name + t.hash;
            e.hasNameForId(n.id, r) || e.insertRules(n.id, r, t(n.rules, r, "@keyframes"));
        }, this.toString = function() {
            return $256a692f819e7a3b$var$D(12, String(n.name));
        }, this.name = e, this.id = "sc-keyframes-" + e, this.rules = t;
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $256a692f819e7a3b$var$he), this.name + e.hash;
    }, e;
}(), $256a692f819e7a3b$var$ve = /([A-Z])/, $256a692f819e7a3b$var$ge = /([A-Z])/g, $256a692f819e7a3b$var$Se = /^ms-/, $256a692f819e7a3b$var$we = function(e) {
    return "-" + e.toLowerCase();
};
function $256a692f819e7a3b$var$Ee(e) {
    return $256a692f819e7a3b$var$ve.test(e) ? e.replace($256a692f819e7a3b$var$ge, $256a692f819e7a3b$var$we).replace($256a692f819e7a3b$var$Se, "-ms-") : e;
}
var $256a692f819e7a3b$var$be = function(e) {
    return null == e || !1 === e || "" === e;
};
function $256a692f819e7a3b$var$_e(e, n, r, o) {
    if (Array.isArray(e)) {
        for(var s, i = [], a = 0, c = e.length; a < c; a += 1)"" !== (s = $256a692f819e7a3b$var$_e(e[a], n, r, o)) && (Array.isArray(s) ? i.push.apply(i, s) : i.push(s));
        return i;
    }
    if ($256a692f819e7a3b$var$be(e)) return "";
    if ($256a692f819e7a3b$export$7ba318d8d2f06c76(e)) return "." + e.styledComponentId;
    if ($256a692f819e7a3b$var$E(e)) {
        if ("function" != typeof (l = e) || l.prototype && l.prototype.isReactComponent || !n) return e;
        var u = e(n);
        return $256a692f819e7a3b$var$_e(u, n, r, o);
    }
    var l;
    return e instanceof $256a692f819e7a3b$var$ye ? r ? (e.inject(r, o), e.getName(o)) : e : $256a692f819e7a3b$var$g(e) ? function e(t, n) {
        var r, o, s = [];
        for(var i in t)t.hasOwnProperty(i) && !$256a692f819e7a3b$var$be(t[i]) && (Array.isArray(t[i]) && t[i].isCss || $256a692f819e7a3b$var$E(t[i]) ? s.push($256a692f819e7a3b$var$Ee(i) + ":", t[i], ";") : $256a692f819e7a3b$var$g(t[i]) ? s.push.apply(s, e(t[i], i)) : s.push($256a692f819e7a3b$var$Ee(i) + ": " + (r = i, null == (o = t[i]) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || r in (0, $3RrRC.default) || r.startsWith("--") ? String(o).trim() : o + "px") + ";"));
        return n ? [
            n + " {"
        ].concat(s, [
            "}"
        ]) : s;
    }(e) : e.toString();
}
var $256a692f819e7a3b$var$Ne = function(e) {
    return Array.isArray(e) && (e.isCss = !0), e;
};
function $256a692f819e7a3b$export$dbf350e5966cf602(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    return $256a692f819e7a3b$var$E(e) || $256a692f819e7a3b$var$g(e) ? $256a692f819e7a3b$var$Ne($256a692f819e7a3b$var$_e($256a692f819e7a3b$var$v($256a692f819e7a3b$var$S, [
        e
    ].concat(n)))) : 0 === n.length && 1 === e.length && "string" == typeof e[0] ? e : $256a692f819e7a3b$var$Ne($256a692f819e7a3b$var$_e($256a692f819e7a3b$var$v(e, n)));
}
var $256a692f819e7a3b$var$Ce = /invalid hook call/i, $256a692f819e7a3b$var$Ie = new Set, $256a692f819e7a3b$var$Pe = function(e, t) {
    var n, r, o, e1;
}, $256a692f819e7a3b$var$Oe = function(e, t, n) {
    return void 0 === n && (n = $256a692f819e7a3b$var$w), e.theme !== n.theme && e.theme || t || n.theme;
}, $256a692f819e7a3b$var$Re = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $256a692f819e7a3b$var$De = /(^-|-$)/g;
function $256a692f819e7a3b$var$je(e) {
    return e.replace($256a692f819e7a3b$var$Re, "-").replace($256a692f819e7a3b$var$De, "");
}
var $256a692f819e7a3b$var$Te = function(e) {
    return $256a692f819e7a3b$var$Q($256a692f819e7a3b$var$te(e) >>> 0);
};
function $256a692f819e7a3b$var$xe(e) {
    return "string" == typeof e && true;
}
var $256a692f819e7a3b$var$ke = function(e) {
    return "function" == typeof e || "object" == typeof e && null !== e && !Array.isArray(e);
}, $256a692f819e7a3b$var$Ve = function(e) {
    return "__proto__" !== e && "constructor" !== e && "prototype" !== e;
};
function $256a692f819e7a3b$var$Be(e, t, n) {
    var r = e[n];
    $256a692f819e7a3b$var$ke(t) && $256a692f819e7a3b$var$ke(r) ? $256a692f819e7a3b$var$ze(r, t) : e[n] = t;
}
function $256a692f819e7a3b$var$ze(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    for(var o = 0, s = n; o < s.length; o++){
        var i = s[o];
        if ($256a692f819e7a3b$var$ke(i)) for(var a in i)$256a692f819e7a3b$var$Ve(a) && $256a692f819e7a3b$var$Be(e, i[a], a);
    }
    return e;
}
var $256a692f819e7a3b$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($jpgPw))).createContext(), $256a692f819e7a3b$export$b631efc24e9d5e2f = $256a692f819e7a3b$export$2c657da244d00bd6.Consumer;
function $256a692f819e7a3b$export$d8964aec282183a3(e) {
    var t = (0, $jpgPw.useContext)($256a692f819e7a3b$export$2c657da244d00bd6), n = (0, $jpgPw.useMemo)(function() {
        return function(e, t) {
            if (!e) return $256a692f819e7a3b$var$D(14);
            if ($256a692f819e7a3b$var$E(e)) {
                var n = e(t);
                return n;
            }
            return Array.isArray(e) || "object" != typeof e ? $256a692f819e7a3b$var$D(8) : t ? $256a692f819e7a3b$var$y({}, t, {}, e) : e;
        }(e.theme, t);
    }, [
        e.theme,
        t
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($jpgPw))).createElement($256a692f819e7a3b$export$2c657da244d00bd6.Provider, {
        value: n
    }, e.children) : null;
}
var $256a692f819e7a3b$var$Fe = {};
function $256a692f819e7a3b$var$Ye(e, t, n) {
    var o = $256a692f819e7a3b$export$7ba318d8d2f06c76(e), i = !$256a692f819e7a3b$var$xe(e), a = t.attrs, c = void 0 === a ? $256a692f819e7a3b$var$S : a, l = t.componentId, d = void 0 === l ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $256a692f819e7a3b$var$je(e);
        $256a692f819e7a3b$var$Fe[n] = ($256a692f819e7a3b$var$Fe[n] || 0) + 1;
        var r = n + "-" + $256a692f819e7a3b$var$Te("5.3.11" + n + $256a692f819e7a3b$var$Fe[n]);
        return t ? t + "-" + r : r;
    }(t.displayName, t.parentComponentId) : l, h = t.displayName, p = void 0 === h ? function(e) {
        return $256a692f819e7a3b$var$xe(e) ? "styled." + e : "Styled(" + $256a692f819e7a3b$var$b(e) + ")";
    }(e) : h, v = t.displayName && t.componentId ? $256a692f819e7a3b$var$je(t.displayName) + "-" + t.componentId : t.componentId || d, g = o && e.attrs ? Array.prototype.concat(e.attrs, c).filter(Boolean) : c, N = t.shouldForwardProp;
    o && e.shouldForwardProp && (N = t.shouldForwardProp ? function(n, r, o) {
        return e.shouldForwardProp(n, r, o) && t.shouldForwardProp(n, r, o);
    } : e.shouldForwardProp);
    var A, C = new $256a692f819e7a3b$var$oe(n, v, o ? e.componentStyle : void 0), I = C.isStatic && 0 === c.length, P = function(e, t) {
        return function(e, t, n, r) {
            var o = e.attrs, i = e.componentStyle, a = e.defaultProps, c = e.foldedComponentIds, l = e.shouldForwardProp, d = e.styledComponentId, h = e.target, p = function(e, t, n) {
                void 0 === e && (e = $256a692f819e7a3b$var$w);
                var r = $256a692f819e7a3b$var$y({}, t, {
                    theme: e
                }), o = {};
                return n.forEach(function(e) {
                    var t, n, s, i = e;
                    for(t in $256a692f819e7a3b$var$E(i) && (i = i(r)), i)r[t] = o[t] = "className" === t ? (n = o[t], s = i[t], n && s ? n + " " + s : n || s) : i[t];
                }), [
                    r,
                    o
                ];
            }($256a692f819e7a3b$var$Oe(t, (0, $jpgPw.useContext)($256a692f819e7a3b$export$2c657da244d00bd6), a) || $256a692f819e7a3b$var$w, t, o), m = p[0], v = p[1], g = function(e, t, n, r) {
                var o = $256a692f819e7a3b$var$pe(), s = $256a692f819e7a3b$var$fe(), i = t ? e.generateAndInjectStyles($256a692f819e7a3b$var$w, o, s) : e.generateAndInjectStyles(n, o, s);
                return i;
            }(i, r, m, void 0), S = n, b = v.$as || t.$as || v.as || t.as || h, _ = $256a692f819e7a3b$var$xe(b), N = v !== t ? $256a692f819e7a3b$var$y({}, t, {}, v) : t, A = {};
            for(var C in N)"$" !== C[0] && "as" !== C && ("forwardedAs" === C ? A.as = N[C] : (l ? l(C, (0, $bxfQs.default), b) : !_ || (0, $bxfQs.default)(C)) && (A[C] = N[C]));
            return t.style && v.style !== t.style && (A.style = $256a692f819e7a3b$var$y({}, t.style, {}, v.style)), A.className = Array.prototype.concat(c, d, g !== d ? g : null, t.className, v.className).filter(Boolean).join(" "), A.ref = S, (0, $jpgPw.createElement)(b, A);
        }(A, e, t, I);
    };
    return P.displayName = p, (A = (0, (/*@__PURE__*/$parcel$interopDefault($jpgPw))).forwardRef(P)).attrs = g, A.componentStyle = C, A.displayName = p, A.shouldForwardProp = N, A.foldedComponentIds = o ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : $256a692f819e7a3b$var$S, A.styledComponentId = v, A.target = o ? e.target : e, A.withComponent = function(e) {
        var r = t.componentId, o = function(e, t) {
            if (null == e) return {};
            var n, r, o = {}, s = Object.keys(e);
            for(r = 0; r < s.length; r++)n = s[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
            return o;
        }(t, [
            "componentId"
        ]), s = r && r + "-" + ($256a692f819e7a3b$var$xe(e) ? e : $256a692f819e7a3b$var$je($256a692f819e7a3b$var$b(e)));
        return $256a692f819e7a3b$var$Ye(e, $256a692f819e7a3b$var$y({}, o, {
            attrs: g,
            componentId: s
        }), n);
    }, Object.defineProperty(A, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(t) {
            this._foldedDefaultProps = o ? $256a692f819e7a3b$var$ze({}, e.defaultProps, t) : t;
        }
    }), Object.defineProperty(A, "toString", {
        value: function() {
            return "." + A.styledComponentId;
        }
    }), i && (0, (/*@__PURE__*/$parcel$interopDefault($5UQkf)))(A, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0,
        withComponent: !0
    }), A;
}
var $256a692f819e7a3b$var$qe = function(e) {
    return function e(t, r, o) {
        if (void 0 === o && (o = $256a692f819e7a3b$var$w), !(0, $lvxRU.isValidElementType)(r)) return $256a692f819e7a3b$var$D(1, String(r));
        var s = function() {
            return t(r, o, $256a692f819e7a3b$export$dbf350e5966cf602.apply(void 0, arguments));
        };
        return s.withConfig = function(n) {
            return e(t, r, $256a692f819e7a3b$var$y({}, o, {}, n));
        }, s.attrs = function(n) {
            return e(t, r, $256a692f819e7a3b$var$y({}, o, {
                attrs: Array.prototype.concat(o.attrs, n).filter(Boolean)
            }));
        }, s;
    }($256a692f819e7a3b$var$Ye, e);
};
[
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "textPath",
    "tspan"
].forEach(function(e) {
    $256a692f819e7a3b$var$qe[e] = $256a692f819e7a3b$var$qe(e);
});
var $256a692f819e7a3b$var$He = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $256a692f819e7a3b$var$ne(e), $256a692f819e7a3b$var$X.registerId(this.componentId + 1);
    }
    var t = e.prototype;
    return t.createStyles = function(e, t, n, r) {
        var o = r($256a692f819e7a3b$var$_e(this.rules, t, n, r).join(""), ""), s = this.componentId + e;
        n.insertRules(s, s, o);
    }, t.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, t.renderStyles = function(e, t, n, r) {
        e > 2 && $256a692f819e7a3b$var$X.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, r);
    }, e;
}();
function $256a692f819e7a3b$export$f0f03736edb61697(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)n[o - 1] = arguments[o];
    var i = $256a692f819e7a3b$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)), a = "sc-global-" + $256a692f819e7a3b$var$Te(JSON.stringify(i)), u = new $256a692f819e7a3b$var$He(i, a);
    function d(e) {
        var t = $256a692f819e7a3b$var$pe(), n = $256a692f819e7a3b$var$fe(), o = (0, $jpgPw.useContext)($256a692f819e7a3b$export$2c657da244d00bd6), d = (0, $jpgPw.useRef)(t.allocateGSInstance(a)).current;
        return t.server && h(d, e, t, o, n), (0, $jpgPw.useLayoutEffect)(function() {
            if (!t.server) return h(d, e, t, o, n), function() {
                return u.removeStyles(d, t);
            };
        }, [
            d,
            e,
            t,
            o,
            n
        ]), null;
    }
    function h(e, t, n, r, o) {
        if (u.isStatic) u.renderStyles(e, $256a692f819e7a3b$var$P, n, o);
        else {
            var s = $256a692f819e7a3b$var$y({}, t, {
                theme: $256a692f819e7a3b$var$Oe(t, r, d.defaultProps)
            });
            u.renderStyles(e, s, n, o);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($jpgPw))).memo(d);
}
function $256a692f819e7a3b$export$d25ddfdf17c3ad3e(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    var o = $256a692f819e7a3b$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)).join(""), s = $256a692f819e7a3b$var$Te(o);
    return new $256a692f819e7a3b$var$ye(s, o);
}
var $256a692f819e7a3b$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $256a692f819e7a3b$var$Y();
            return "<style " + [
                n && 'nonce="' + n + '"',
                $256a692f819e7a3b$var$N + '="true"',
                'data-styled-version="5.3.11"'
            ].filter(Boolean).join(" ") + ">" + t + "</style>";
        }, this.getStyleTags = function() {
            return e.sealed ? $256a692f819e7a3b$var$D(2) : e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var t;
            if (e.sealed) return $256a692f819e7a3b$var$D(2);
            var n = ((t = {})[$256a692f819e7a3b$var$N] = "", t["data-styled-version"] = "5.3.11", t.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, t), o = $256a692f819e7a3b$var$Y();
            return o && (n.nonce = o), [
                (0, (/*@__PURE__*/$parcel$interopDefault($jpgPw))).createElement("style", $256a692f819e7a3b$var$y({}, n, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $256a692f819e7a3b$var$X({
            isServer: !0
        }), this.sealed = !1;
    }
    var t = e.prototype;
    return t.collectStyles = function(e) {
        return this.sealed ? $256a692f819e7a3b$var$D(2) : (0, (/*@__PURE__*/$parcel$interopDefault($jpgPw))).createElement($256a692f819e7a3b$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, t.interleaveWithNodeStream = function(e) {
        return $256a692f819e7a3b$var$D(3);
    }, e;
}(), $256a692f819e7a3b$export$e8748c6a27b910dc = function(e) {
    var t = (0, (/*@__PURE__*/$parcel$interopDefault($jpgPw))).forwardRef(function(t, n) {
        var o = (0, $jpgPw.useContext)($256a692f819e7a3b$export$2c657da244d00bd6), i = e.defaultProps, a = $256a692f819e7a3b$var$Oe(t, o, i);
        return (0, (/*@__PURE__*/$parcel$interopDefault($jpgPw))).createElement(e, $256a692f819e7a3b$var$y({}, t, {
            theme: a,
            ref: n
        }));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($5UQkf)))(t, e), t.displayName = "WithTheme(" + $256a692f819e7a3b$var$b(e) + ")", t;
}, $256a692f819e7a3b$export$93d4e7f90805808f = function() {
    return (0, $jpgPw.useContext)($256a692f819e7a3b$export$2c657da244d00bd6);
}, $256a692f819e7a3b$export$5c87cfe6c475f500 = {
    StyleSheet: $256a692f819e7a3b$var$X,
    masterSheet: $256a692f819e7a3b$var$de
};
var $256a692f819e7a3b$export$2e2bcd8739ae039 = $256a692f819e7a3b$var$qe;

});
parcelRegister("lvxRU", function(module, exports) {
'use strict';

module.exports = (parcelRequire("kmrCG"));

});
parcelRegister("kmrCG", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $ed2b4a0ebb5e0b23$export$2b8d127b894957b9; }, function (v) { return $ed2b4a0ebb5e0b23$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $ed2b4a0ebb5e0b23$export$cea3a54a6425200c; }, function (v) { return $ed2b4a0ebb5e0b23$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $ed2b4a0ebb5e0b23$export$a7c73072b1a182ae; }, function (v) { return $ed2b4a0ebb5e0b23$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $ed2b4a0ebb5e0b23$export$9f27bc3417b4524d; }, function (v) { return $ed2b4a0ebb5e0b23$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $ed2b4a0ebb5e0b23$export$db77ccec0bb4ccac; }, function (v) { return $ed2b4a0ebb5e0b23$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $ed2b4a0ebb5e0b23$export$8392c0c9d3dcbd35; }, function (v) { return $ed2b4a0ebb5e0b23$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $ed2b4a0ebb5e0b23$export$ffb0004e005737fa; }, function (v) { return $ed2b4a0ebb5e0b23$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $ed2b4a0ebb5e0b23$export$b624eff549462981; }, function (v) { return $ed2b4a0ebb5e0b23$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $ed2b4a0ebb5e0b23$export$7897aa7841a5380c; }, function (v) { return $ed2b4a0ebb5e0b23$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $ed2b4a0ebb5e0b23$export$602eac185826482c; }, function (v) { return $ed2b4a0ebb5e0b23$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $ed2b4a0ebb5e0b23$export$e2c29f18771995cb; }, function (v) { return $ed2b4a0ebb5e0b23$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $ed2b4a0ebb5e0b23$export$5f8d39834fd61797; }, function (v) { return $ed2b4a0ebb5e0b23$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $ed2b4a0ebb5e0b23$export$74bf444e3cd11ea5; }, function (v) { return $ed2b4a0ebb5e0b23$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $ed2b4a0ebb5e0b23$export$92387174baf9b227; }, function (v) { return $ed2b4a0ebb5e0b23$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $ed2b4a0ebb5e0b23$export$ec112efeb987d9c6; }, function (v) { return $ed2b4a0ebb5e0b23$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $ed2b4a0ebb5e0b23$export$b706b080d889d2c9; }, function (v) { return $ed2b4a0ebb5e0b23$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $ed2b4a0ebb5e0b23$export$5be5a87408f70ddc; }, function (v) { return $ed2b4a0ebb5e0b23$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $ed2b4a0ebb5e0b23$export$45a5e7f76e0caa8d; }, function (v) { return $ed2b4a0ebb5e0b23$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $ed2b4a0ebb5e0b23$export$455c2e768291efa6; }, function (v) { return $ed2b4a0ebb5e0b23$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $ed2b4a0ebb5e0b23$export$9522e17588c12572; }, function (v) { return $ed2b4a0ebb5e0b23$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $ed2b4a0ebb5e0b23$export$2110ac352bb060b9; }, function (v) { return $ed2b4a0ebb5e0b23$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $ed2b4a0ebb5e0b23$export$56885ab8b9c456ab; }, function (v) { return $ed2b4a0ebb5e0b23$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $ed2b4a0ebb5e0b23$export$d927fcb6adf8f9de; }, function (v) { return $ed2b4a0ebb5e0b23$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $ed2b4a0ebb5e0b23$export$b82d16f27459e05a; }, function (v) { return $ed2b4a0ebb5e0b23$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $ed2b4a0ebb5e0b23$export$522c17b4f5e123e8; }, function (v) { return $ed2b4a0ebb5e0b23$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $ed2b4a0ebb5e0b23$export$1aabd8a0274ecfd6; }, function (v) { return $ed2b4a0ebb5e0b23$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $ed2b4a0ebb5e0b23$export$9b621391a187a31a; }, function (v) { return $ed2b4a0ebb5e0b23$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $ed2b4a0ebb5e0b23$export$f5bbd400c2f4426f; }, function (v) { return $ed2b4a0ebb5e0b23$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ed2b4a0ebb5e0b23$export$2b8d127b894957b9;
var $ed2b4a0ebb5e0b23$export$cea3a54a6425200c;
var $ed2b4a0ebb5e0b23$export$a7c73072b1a182ae;
var $ed2b4a0ebb5e0b23$export$9f27bc3417b4524d;
var $ed2b4a0ebb5e0b23$export$db77ccec0bb4ccac;
var $ed2b4a0ebb5e0b23$export$8392c0c9d3dcbd35;
var $ed2b4a0ebb5e0b23$export$ffb0004e005737fa;
var $ed2b4a0ebb5e0b23$export$b624eff549462981;
var $ed2b4a0ebb5e0b23$export$7897aa7841a5380c;
var $ed2b4a0ebb5e0b23$export$602eac185826482c;
var $ed2b4a0ebb5e0b23$export$e2c29f18771995cb;
var $ed2b4a0ebb5e0b23$export$5f8d39834fd61797;
var $ed2b4a0ebb5e0b23$export$74bf444e3cd11ea5;
var $ed2b4a0ebb5e0b23$export$92387174baf9b227;
var $ed2b4a0ebb5e0b23$export$ec112efeb987d9c6;
var $ed2b4a0ebb5e0b23$export$b706b080d889d2c9;
var $ed2b4a0ebb5e0b23$export$5be5a87408f70ddc;
var $ed2b4a0ebb5e0b23$export$45a5e7f76e0caa8d;
var $ed2b4a0ebb5e0b23$export$455c2e768291efa6;
var $ed2b4a0ebb5e0b23$export$9522e17588c12572;
var $ed2b4a0ebb5e0b23$export$2110ac352bb060b9;
var $ed2b4a0ebb5e0b23$export$56885ab8b9c456ab;
var $ed2b4a0ebb5e0b23$export$d927fcb6adf8f9de;
var $ed2b4a0ebb5e0b23$export$b82d16f27459e05a;
var $ed2b4a0ebb5e0b23$export$522c17b4f5e123e8;
var $ed2b4a0ebb5e0b23$export$1aabd8a0274ecfd6;
var $ed2b4a0ebb5e0b23$export$9b621391a187a31a;
var $ed2b4a0ebb5e0b23$export$f5bbd400c2f4426f;
'use strict';
var $ed2b4a0ebb5e0b23$var$b = "function" === typeof Symbol && Symbol.for, $ed2b4a0ebb5e0b23$var$c = $ed2b4a0ebb5e0b23$var$b ? Symbol.for("react.element") : 60103, $ed2b4a0ebb5e0b23$var$d = $ed2b4a0ebb5e0b23$var$b ? Symbol.for("react.portal") : 60106, $ed2b4a0ebb5e0b23$var$e = $ed2b4a0ebb5e0b23$var$b ? Symbol.for("react.fragment") : 60107, $ed2b4a0ebb5e0b23$var$f = $ed2b4a0ebb5e0b23$var$b ? Symbol.for("react.strict_mode") : 60108, $ed2b4a0ebb5e0b23$var$g = $ed2b4a0ebb5e0b23$var$b ? Symbol.for("react.profiler") : 60114, $ed2b4a0ebb5e0b23$var$h = $ed2b4a0ebb5e0b23$var$b ? Symbol.for("react.provider") : 60109, $ed2b4a0ebb5e0b23$var$k = $ed2b4a0ebb5e0b23$var$b ? Symbol.for("react.context") : 60110, $ed2b4a0ebb5e0b23$var$l = $ed2b4a0ebb5e0b23$var$b ? Symbol.for("react.async_mode") : 60111, $ed2b4a0ebb5e0b23$var$m = $ed2b4a0ebb5e0b23$var$b ? Symbol.for("react.concurrent_mode") : 60111, $ed2b4a0ebb5e0b23$var$n = $ed2b4a0ebb5e0b23$var$b ? Symbol.for("react.forward_ref") : 60112, $ed2b4a0ebb5e0b23$var$p = $ed2b4a0ebb5e0b23$var$b ? Symbol.for("react.suspense") : 60113, $ed2b4a0ebb5e0b23$var$q = $ed2b4a0ebb5e0b23$var$b ? Symbol.for("react.suspense_list") : 60120, $ed2b4a0ebb5e0b23$var$r = $ed2b4a0ebb5e0b23$var$b ? Symbol.for("react.memo") : 60115, $ed2b4a0ebb5e0b23$var$t = $ed2b4a0ebb5e0b23$var$b ? Symbol.for("react.lazy") : 60116, $ed2b4a0ebb5e0b23$var$v = $ed2b4a0ebb5e0b23$var$b ? Symbol.for("react.block") : 60121, $ed2b4a0ebb5e0b23$var$w = $ed2b4a0ebb5e0b23$var$b ? Symbol.for("react.fundamental") : 60117, $ed2b4a0ebb5e0b23$var$x = $ed2b4a0ebb5e0b23$var$b ? Symbol.for("react.responder") : 60118, $ed2b4a0ebb5e0b23$var$y = $ed2b4a0ebb5e0b23$var$b ? Symbol.for("react.scope") : 60119;
function $ed2b4a0ebb5e0b23$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $ed2b4a0ebb5e0b23$var$c:
                switch(a = a.type, a){
                    case $ed2b4a0ebb5e0b23$var$l:
                    case $ed2b4a0ebb5e0b23$var$m:
                    case $ed2b4a0ebb5e0b23$var$e:
                    case $ed2b4a0ebb5e0b23$var$g:
                    case $ed2b4a0ebb5e0b23$var$f:
                    case $ed2b4a0ebb5e0b23$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $ed2b4a0ebb5e0b23$var$k:
                            case $ed2b4a0ebb5e0b23$var$n:
                            case $ed2b4a0ebb5e0b23$var$t:
                            case $ed2b4a0ebb5e0b23$var$r:
                            case $ed2b4a0ebb5e0b23$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $ed2b4a0ebb5e0b23$var$d:
                return u;
        }
    }
}
function $ed2b4a0ebb5e0b23$var$A(a) {
    return $ed2b4a0ebb5e0b23$var$z(a) === $ed2b4a0ebb5e0b23$var$m;
}
$ed2b4a0ebb5e0b23$export$2b8d127b894957b9 = $ed2b4a0ebb5e0b23$var$l;
$ed2b4a0ebb5e0b23$export$cea3a54a6425200c = $ed2b4a0ebb5e0b23$var$m;
$ed2b4a0ebb5e0b23$export$a7c73072b1a182ae = $ed2b4a0ebb5e0b23$var$k;
$ed2b4a0ebb5e0b23$export$9f27bc3417b4524d = $ed2b4a0ebb5e0b23$var$h;
$ed2b4a0ebb5e0b23$export$db77ccec0bb4ccac = $ed2b4a0ebb5e0b23$var$c;
$ed2b4a0ebb5e0b23$export$8392c0c9d3dcbd35 = $ed2b4a0ebb5e0b23$var$n;
$ed2b4a0ebb5e0b23$export$ffb0004e005737fa = $ed2b4a0ebb5e0b23$var$e;
$ed2b4a0ebb5e0b23$export$b624eff549462981 = $ed2b4a0ebb5e0b23$var$t;
$ed2b4a0ebb5e0b23$export$7897aa7841a5380c = $ed2b4a0ebb5e0b23$var$r;
$ed2b4a0ebb5e0b23$export$602eac185826482c = $ed2b4a0ebb5e0b23$var$d;
$ed2b4a0ebb5e0b23$export$e2c29f18771995cb = $ed2b4a0ebb5e0b23$var$g;
$ed2b4a0ebb5e0b23$export$5f8d39834fd61797 = $ed2b4a0ebb5e0b23$var$f;
$ed2b4a0ebb5e0b23$export$74bf444e3cd11ea5 = $ed2b4a0ebb5e0b23$var$p;
$ed2b4a0ebb5e0b23$export$92387174baf9b227 = function(a) {
    return $ed2b4a0ebb5e0b23$var$A(a) || $ed2b4a0ebb5e0b23$var$z(a) === $ed2b4a0ebb5e0b23$var$l;
};
$ed2b4a0ebb5e0b23$export$ec112efeb987d9c6 = $ed2b4a0ebb5e0b23$var$A;
$ed2b4a0ebb5e0b23$export$b706b080d889d2c9 = function(a) {
    return $ed2b4a0ebb5e0b23$var$z(a) === $ed2b4a0ebb5e0b23$var$k;
};
$ed2b4a0ebb5e0b23$export$5be5a87408f70ddc = function(a) {
    return $ed2b4a0ebb5e0b23$var$z(a) === $ed2b4a0ebb5e0b23$var$h;
};
$ed2b4a0ebb5e0b23$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $ed2b4a0ebb5e0b23$var$c;
};
$ed2b4a0ebb5e0b23$export$455c2e768291efa6 = function(a) {
    return $ed2b4a0ebb5e0b23$var$z(a) === $ed2b4a0ebb5e0b23$var$n;
};
$ed2b4a0ebb5e0b23$export$9522e17588c12572 = function(a) {
    return $ed2b4a0ebb5e0b23$var$z(a) === $ed2b4a0ebb5e0b23$var$e;
};
$ed2b4a0ebb5e0b23$export$2110ac352bb060b9 = function(a) {
    return $ed2b4a0ebb5e0b23$var$z(a) === $ed2b4a0ebb5e0b23$var$t;
};
$ed2b4a0ebb5e0b23$export$56885ab8b9c456ab = function(a) {
    return $ed2b4a0ebb5e0b23$var$z(a) === $ed2b4a0ebb5e0b23$var$r;
};
$ed2b4a0ebb5e0b23$export$d927fcb6adf8f9de = function(a) {
    return $ed2b4a0ebb5e0b23$var$z(a) === $ed2b4a0ebb5e0b23$var$d;
};
$ed2b4a0ebb5e0b23$export$b82d16f27459e05a = function(a) {
    return $ed2b4a0ebb5e0b23$var$z(a) === $ed2b4a0ebb5e0b23$var$g;
};
$ed2b4a0ebb5e0b23$export$522c17b4f5e123e8 = function(a) {
    return $ed2b4a0ebb5e0b23$var$z(a) === $ed2b4a0ebb5e0b23$var$f;
};
$ed2b4a0ebb5e0b23$export$1aabd8a0274ecfd6 = function(a) {
    return $ed2b4a0ebb5e0b23$var$z(a) === $ed2b4a0ebb5e0b23$var$p;
};
$ed2b4a0ebb5e0b23$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $ed2b4a0ebb5e0b23$var$e || a === $ed2b4a0ebb5e0b23$var$m || a === $ed2b4a0ebb5e0b23$var$g || a === $ed2b4a0ebb5e0b23$var$f || a === $ed2b4a0ebb5e0b23$var$p || a === $ed2b4a0ebb5e0b23$var$q || "object" === typeof a && null !== a && (a.$$typeof === $ed2b4a0ebb5e0b23$var$t || a.$$typeof === $ed2b4a0ebb5e0b23$var$r || a.$$typeof === $ed2b4a0ebb5e0b23$var$h || a.$$typeof === $ed2b4a0ebb5e0b23$var$k || a.$$typeof === $ed2b4a0ebb5e0b23$var$n || a.$$typeof === $ed2b4a0ebb5e0b23$var$w || a.$$typeof === $ed2b4a0ebb5e0b23$var$x || a.$$typeof === $ed2b4a0ebb5e0b23$var$y || a.$$typeof === $ed2b4a0ebb5e0b23$var$v);
};
$ed2b4a0ebb5e0b23$export$f5bbd400c2f4426f = $ed2b4a0ebb5e0b23$var$z;

});


parcelRegister("jbPwP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df8703e784f26b34$export$2e2bcd8739ae039; });
function $df8703e784f26b34$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ''));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + '{' + k + '}';
                                        break;
                                    case 107:
                                        f = f.replace(fa, '$1 $2');
                                        k = f + '{' + k + '}';
                                        k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ''));
                                }
                                else k = '';
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, '') : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = '';
                                    break;
                                default:
                                    32 !== g && (y = ' ');
                            }
                            break;
                        case 0:
                            y = '\\0';
                            break;
                        case 12:
                            y = '\\f';
                            break;
                        case 11:
                            y = '\\v';
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = '\f' + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += '\r');
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(',') + '{' + p + '}';
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ':-moz-$1') + p;
                        break;
                    case 112:
                        p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? '' : d[0] + ' '; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + ' ', h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, '$1' + d.trim());
            case 58:
                return d.trim() + c.replace(F, '$1' + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ';', m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(':', 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ';';
            return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return '-webkit-' + a + a;
            case 978:
                return '-webkit-' + a + '-moz-' + a + a;
            case 1019:
            case 983:
                return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
                if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
                    case 115:
                        return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
                    case 98:
                        return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
                }
                return '-webkit-' + a + '-ms-' + a + a;
            case 964:
                return '-webkit-' + a + '-ms-flex-' + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
                return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf('-') + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, 'tb');
                        break;
                    case 232:
                        b = a.replace(G, 'tb-rl');
                        break;
                    case 220:
                        b = a.replace(G, 'lr');
                        break;
                    default:
                        return a;
                }
                return '-webkit-' + a + '-ms-' + b + a;
            case 1017:
                if (-1 === a.indexOf('sticky', 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, '-webkit-' + b) + ';' + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
                }
                return a + ';';
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
                    case 115:
                        return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
                    default:
                        return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
                break;
            case 962:
                if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ':' : '{'), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, '$1'), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ('function' === typeof d) S[A++] = d;
                else if ('object' === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && 'string' === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = '';
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = '';
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $df8703e784f26b34$export$2e2bcd8739ae039 = $df8703e784f26b34$var$stylis_min;

});

parcelRegister("3RrRC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2cfbef7f5a9a0c4e$export$2e2bcd8739ae039; });
var $2cfbef7f5a9a0c4e$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $2cfbef7f5a9a0c4e$export$2e2bcd8739ae039 = $2cfbef7f5a9a0c4e$var$unitlessKeys;

});

parcelRegister("bxfQs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $865f114e6b16aded$export$2e2bcd8739ae039; });

var $1XY4w = parcelRequire("1XY4w");
// eslint-disable-next-line no-undef
var $865f114e6b16aded$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $865f114e6b16aded$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $1XY4w.default)(function(prop) {
    return $865f114e6b16aded$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});
parcelRegister("1XY4w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16e9e62a4961586a$export$2e2bcd8739ae039; });
function $16e9e62a4961586a$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("5UQkf", function(module, exports) {
'use strict';

var $lvxRU = parcelRequire("lvxRU");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $44eac576d9908511$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $44eac576d9908511$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $44eac576d9908511$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $44eac576d9908511$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $44eac576d9908511$var$TYPE_STATICS = {};
$44eac576d9908511$var$TYPE_STATICS[$lvxRU.ForwardRef] = $44eac576d9908511$var$FORWARD_REF_STATICS;
$44eac576d9908511$var$TYPE_STATICS[$lvxRU.Memo] = $44eac576d9908511$var$MEMO_STATICS;
function $44eac576d9908511$var$getStatics(component) {
    // React v16.11 and below
    if ($lvxRU.isMemo(component)) return $44eac576d9908511$var$MEMO_STATICS;
     // React v16.12 and above
    return $44eac576d9908511$var$TYPE_STATICS[component['$$typeof']] || $44eac576d9908511$var$REACT_STATICS;
}
var $44eac576d9908511$var$defineProperty = Object.defineProperty;
var $44eac576d9908511$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $44eac576d9908511$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $44eac576d9908511$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $44eac576d9908511$var$getPrototypeOf = Object.getPrototypeOf;
var $44eac576d9908511$var$objectPrototype = Object.prototype;
function $44eac576d9908511$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($44eac576d9908511$var$objectPrototype) {
            var inheritedComponent = $44eac576d9908511$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $44eac576d9908511$var$objectPrototype) $44eac576d9908511$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $44eac576d9908511$var$getOwnPropertyNames(sourceComponent);
        if ($44eac576d9908511$var$getOwnPropertySymbols) keys = keys.concat($44eac576d9908511$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $44eac576d9908511$var$getStatics(targetComponent);
        var sourceStatics = $44eac576d9908511$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$44eac576d9908511$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $44eac576d9908511$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $44eac576d9908511$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $44eac576d9908511$var$hoistNonReactStatics;

});


parcelRegister("58fAg", function(module, exports) {

$parcel$export(module.exports, "TopMenuBar", function () { return $3bc9c9c409ec92c1$export$9170cb1a733ed8f5; });

var $caZvI = parcelRequire("caZvI");

var $b1LPP = parcelRequire("b1LPP");
parcelRequire("jpgPw");

var $3da5u = parcelRequire("3da5u");

var $2eqHs = parcelRequire("2eqHs");

var $hSeA2 = parcelRequire("hSeA2");

var $eUJ8V = parcelRequire("eUJ8V");

var $1Hynf = parcelRequire("1Hynf");

var $bt0KQ = parcelRequire("bt0KQ");

var $jyFzD = parcelRequire("jyFzD");

var $dXNPX = parcelRequire("dXNPX");

const $3bc9c9c409ec92c1$var$logoUrl = new URL((parcelRequire("fdLNz")));
const $3bc9c9c409ec92c1$export$9170cb1a733ed8f5 = ()=>{
    const { t: t } = (0, $2eqHs.useTranslation)();
    return (0, $caZvI.jsx)((0, $eUJ8V.UniContainer), {
        "$wide": true,
        id: 'topMenuBar',
        children: (0, $caZvI.jsx)((0, $eUJ8V.UniContainer), {
            "$wide": true,
            "$borderBottom": true,
            "$paddingInline": false,
            children: (0, $caZvI.jsxs)($3bc9c9c409ec92c1$var$Flex, {
                children: [
                    (0, $caZvI.jsxs)($3bc9c9c409ec92c1$var$UniversityHomeLink, {
                        href: "https://helsinki.fi",
                        target: "_blank",
                        children: [
                            (0, $caZvI.jsx)($3bc9c9c409ec92c1$var$Logo, {
                                src: $3bc9c9c409ec92c1$var$logoUrl.toString(),
                                alt: t((0, $b1LPP.default).LOGO_OF_UNIVERSITY_OF_HELSINKI)
                            }),
                            t((0, $b1LPP.default).UNIVERSITY_OF_HELSINKI)
                        ]
                    }),
                    (0, $caZvI.jsx)($3bc9c9c409ec92c1$var$LanguageMenuDesktop, {}),
                    (0, $caZvI.jsx)($3bc9c9c409ec92c1$var$LanguageSelectMobile, {})
                ]
            })
        })
    });
};
const $3bc9c9c409ec92c1$var$Flex = (0, $3da5u.default).div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
`;
const $3bc9c9c409ec92c1$var$Logo = (0, $3da5u.default).img`
  width: 2em;
  height: 2em;
  filter: invert(100%);
`;
const $3bc9c9c409ec92c1$var$UniversityHomeLink = (0, $3da5u.default).a`
  display: flex;
  align-items: center;
  gap: 0.2em;
  color: ${(0, $hSeA2.BRAND_MAIN_NEARLY_BLACK)};
  ${(0, $bt0KQ.DEFAULT_FONT)}
  font-size: 11px;
  font-weight: 600;
  line-height: 14px;
  text-transform: uppercase;
  padding-right: 2em;

  ${(0, $1Hynf.fromPhoneUp)((0, $3da5u.css)`
    letter-spacing: -0.6px;
    font-size: 14px;
  `)}

  ${(0, $1Hynf.fromTabletUp)((0, $3da5u.css)`
    gap: 1em;
  `)}

  &:hover,
  &:focus {
    color: ${(0, $hSeA2.BRAND_MAIN)};
    text-decoration: none;
  }

  &:focus {
    outline-offset: 3px;
  }
`;
const $3bc9c9c409ec92c1$var$LanguageMenuBase = ({ id: id, className: className })=>{
    const [currentLanguage, setCurrentLanguage] = (0, $jyFzD.useLocalStorage)('currentLanguage', 'fi');
    const { t: t } = (0, $2eqHs.useTranslation)();
    return (0, $caZvI.jsx)($3bc9c9c409ec92c1$var$LanguageMenuContainer, {
        id: id,
        className: className,
        children: (0, $caZvI.jsx)("nav", {
            "aria-label": t((0, $b1LPP.default).CHANGE_LANGUAGE),
            children: (0, $caZvI.jsxs)($3bc9c9c409ec92c1$var$LanguageMenuList, {
                children: [
                    (0, $caZvI.jsx)($3bc9c9c409ec92c1$var$LanguageMenuItem, {
                        children: (0, $caZvI.jsx)($3bc9c9c409ec92c1$export$d7143e0b7139a20b, {
                            "$active": currentLanguage === 'fi',
                            onClick: ()=>setCurrentLanguage('fi'),
                            children: 'Suomi'
                        })
                    }),
                    (0, $caZvI.jsx)($3bc9c9c409ec92c1$var$LanguageMenuItem, {
                        children: (0, $caZvI.jsx)($3bc9c9c409ec92c1$export$d7143e0b7139a20b, {
                            "$active": currentLanguage === 'sv',
                            onClick: ()=>setCurrentLanguage('sv'),
                            children: 'Svenska'
                        })
                    }),
                    (0, $caZvI.jsx)($3bc9c9c409ec92c1$var$LanguageMenuItem, {
                        children: (0, $caZvI.jsx)($3bc9c9c409ec92c1$export$d7143e0b7139a20b, {
                            "$active": currentLanguage === 'en',
                            onClick: ()=>setCurrentLanguage('en'),
                            children: 'English'
                        })
                    })
                ]
            })
        })
    });
};
const $3bc9c9c409ec92c1$var$LanguageMenuContainer = (0, $3da5u.default).div`
  display: flex;
  gap: 15px;
`;
const $3bc9c9c409ec92c1$var$LanguageMenuList = (0, $3da5u.default).ul`
  margin: 0;
  padding: 0;
  display: flex;
`;
const $3bc9c9c409ec92c1$var$LanguageMenuItem = (0, $3da5u.default).li`
  list-style: none;
`;
const $3bc9c9c409ec92c1$var$LanguageMenuDesktop = (0, $3da5u.default)($3bc9c9c409ec92c1$var$LanguageMenuBase)`
  display: none;

  ${(0, $1Hynf.fromPhoneUp)((0, $3da5u.css)`
    display: flex;
  `)}
`;
const $3bc9c9c409ec92c1$var$languageOptions = {
    fi: 'Suomi (fi)',
    sv: 'Svenska (sv)',
    en: 'English (en)'
};
const $3bc9c9c409ec92c1$var$LanguageSelectBase = ({ id: id, className: className })=>{
    const { t: t } = (0, $2eqHs.useTranslation)();
    const [currentLanguage, setCurrentLanguage] = (0, $jyFzD.useLocalStorage)('currentLanguage', 'fi');
    return (0, $caZvI.jsx)($3bc9c9c409ec92c1$var$LanguageSelectWrapper, {
        className: className,
        children: (0, $caZvI.jsx)((0, $dXNPX.UniSelectWithLabel), {
            id: id,
            label: t((0, $b1LPP.default).CHOOSE_LANGUAGE),
            value: currentLanguage,
            onChange: (value)=>setCurrentLanguage(value),
            options: [
                {
                    value: 'fi',
                    label: $3bc9c9c409ec92c1$var$languageOptions['fi']
                },
                {
                    value: 'sv',
                    label: $3bc9c9c409ec92c1$var$languageOptions['sv']
                },
                {
                    value: 'en',
                    label: $3bc9c9c409ec92c1$var$languageOptions['en']
                }
            ],
            small: true
        })
    });
};
const $3bc9c9c409ec92c1$var$LanguageSelectWrapper = (0, $3da5u.default).div`
  position: relative;
`;
const $3bc9c9c409ec92c1$var$LanguageSelectMobile = (0, $3da5u.default)($3bc9c9c409ec92c1$var$LanguageSelectBase)`
  display: flex;
  margin-block-start: -12px;

  ${(0, $1Hynf.fromPhoneUp)((0, $3da5u.css)`
    display: none;
  `)}
`;
const $3bc9c9c409ec92c1$export$d7143e0b7139a20b = (0, $3da5u.default).button`
  background: transparent;
  border: none;
  color: ${(0, $hSeA2.BRAND_MAIN_NEARLY_BLACK)};
  font-size: 11px;
  font-weight: 600;
  padding: 12px 8px;
  text-transform: uppercase;
  ${(0, $bt0KQ.DEFAULT_FONT)}

  &:hover,
  &:focus {
    color: ${(0, $hSeA2.BRAND_MAIN)};
  }

  &:focus {
    outline-offset: 3px;
  }

  ${(props)=>props.$active && (0, $3da5u.css)`
      text-decoration: underline;
    `}
`;

});
parcelRegister("b1LPP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8074e4b8ed096a9e$export$2e2bcd8739ae039; });
const $8074e4b8ed096a9e$var$keys = {
    key: 'key',
    SUPPORT_EMAIL: 'SUPPORT_EMAIL',
    ABOUT: 'ABOUT',
    THESSA: 'THESSA',
    THESSA_IS_THE_DOCTORAL_STUDIES: 'THESSA_IS_THE_DOCTORAL_STUDIES',
    ALL_KINDS_OF_FEEDBACK_AND_ERRO: 'ALL_KINDS_OF_FEEDBACK_AND_ERRO',
    RIGHTS_OBLIGATIONS_AND_RESPON: 'RIGHTS_OBLIGATIONS_AND_RESPON',
    PROBLEMS_LOGGING_IN: 'PROBLEMS_LOGGING_IN',
    IF_YOU_FORGOT_YOUR_PASSWORD_Y: 'IF_YOU_FORGOT_YOUR_PASSWORD_Y',
    RESET_IT: 'RESET_IT',
    SEND_PASSWORD_RESET_LINK_TO_MY: 'SEND_PASSWORD_RESET_LINK_TO_MY',
    EMAIL_FOR_THESSA_ACCOUNT: 'EMAIL_FOR_THESSA_ACCOUNT',
    SEND: 'SEND',
    BACK_TO_LOGIN: 'BACK_TO_LOGIN',
    BACK_TO_MY_PHD_PROJECT: 'BACK_TO_MY_PHD_PROJECT',
    MESSAGE_SENT_CHECK_YOUR_EMAIL: 'MESSAGE_SENT_CHECK_YOUR_EMAIL',
    TOO_MANY_PASSWORD_RESET_REQUES: 'TOO_MANY_PASSWORD_RESET_REQUES',
    TOO_MANY_PASSWORD_RESET_ATTEMPTS: 'TOO_MANY_PASSWORD_RESET_ATTEMPTS',
    WAIT_FIVE_MINUTES_BEFORE_TRYIN: 'WAIT_FIVE_MINUTES_BEFORE_TRYIN',
    HELPDESK: 'HELPDESK',
    YOU_MAY_RESET_YOUR_PASSWORD: 'YOU_MAY_RESET_YOUR_PASSWORD',
    SOMETHING_WENT_WRONG: 'SOMETHING_WENT_WRONG',
    TRY_AGAIN_LATER: 'TRY_AGAIN_LATER',
    NO_NETWORK_CONNECTION: 'NO_NETWORK_CONNECTION',
    RIGHTS_OBLIGATIONS_AND_RESPON1: 'RIGHTS_OBLIGATIONS_AND_RESPON1',
    ABOUT_THESSA: 'ABOUT_THESSA',
    THE_DOCTORAL_STUDIES_PLANNING: 'THE_DOCTORAL_STUDIES_PLANNING',
    EMAIL: 'EMAIL',
    PASSWORD: 'PASSWORD',
    LOG_IN: 'LOG_IN',
    LOGIN_WAS_NOT_SUCCESSFUL: 'LOGIN_WAS_NOT_SUCCESSFUL',
    CHECK_USERNAME_AND_PASSWORD_I: 'CHECK_USERNAME_AND_PASSWORD_I',
    CHECK_USERNAME_AND_PASSWORD_I1: 'CHECK_USERNAME_AND_PASSWORD_I1',
    TOO_MANY_FAILED_LOGIN_ATTEMPTS: 'TOO_MANY_FAILED_LOGIN_ATTEMPTS',
    WAIT_FIVE_MINUTES_BEFORE_TRYIN1: 'WAIT_FIVE_MINUTES_BEFORE_TRYIN1',
    YOU_NEED_AN_INVITATION_OR_AN_A: 'YOU_NEED_AN_INVITATION_OR_AN_A',
    YOUR_EMAIL_ADDRESS_IS_ALREADY: 'YOUR_EMAIL_ADDRESS_IS_ALREADY',
    HINT_USE_UNIVERSITY_LOGIN: 'HINT_USE_UNIVERSITY_LOGIN',
    CONTACT_US: 'CONTACT_US',
    CONTACT_US1: 'CONTACT_US1',
    CONTACT_US_END_OF_SENTENCE: 'CONTACT_US_END_OF_SENTENCE',
    FOR_HELP_WITH_THIS_ERROR: 'FOR_HELP_WITH_THIS_ERROR',
    LOG_IN_PAGE: {
        UNIVERSITY_STAFF_OR_STUDENTS: 'LOG_IN_PAGE.UNIVERSITY_STAFF_OR_STUDENTS',
        OTHERS: 'LOG_IN_PAGE.OTHERS'
    },
    LOGIN_FAILED_WITH_ERROR_CODE: 'LOGIN_FAILED_WITH_ERROR_CODE',
    LOGIN_FAILED_PASSWORD_MUST_BE_RESET: 'LOGIN_FAILED_PASSWORD_MUST_BE_RESET',
    LOGIN_FAILED_USE_UNIVERSITY_LOGIN: 'LOGIN_FAILED_USE_UNIVERSITY_LOGIN',
    PASSWORD_RESET_REFUSED_USE_UNIVERSITY_LOGIN: 'PASSWORD_RESET_REFUSED_USE_UNIVERSITY_LOGIN',
    FORGOT_PASSWORD_PAGE: 'FORGOT_PASSWORD_PAGE',
    TO_CHANGE_YOUR_PASSWORD: 'TO_CHANGE_YOUR_PASSWORD',
    USE_YOUR_UNIVERSITY_OF_HELSINK: 'USE_YOUR_UNIVERSITY_OF_HELSINK',
    FORGOT_PASSWORD: 'FORGOT_PASSWORD',
    LOG_IN_WITH_OIDC: 'LOG_IN_WITH_OIDC',
    RESET_PASSWORD: 'RESET_PASSWORD',
    NEW_PASSWORD: 'NEW_PASSWORD',
    SAVE_PASSWORD: 'SAVE_PASSWORD',
    CANCEL: 'CANCEL',
    PASSWORD_SET_REDIRECTING_YOU: 'PASSWORD_SET_REDIRECTING_YOU',
    INSIDE: 'INSIDE',
    THERE_WERE_PROBLEMS_WITH_SAVIN: 'THERE_WERE_PROBLEMS_WITH_SAVIN',
    SIGN_UP_TO_THESSA: 'SIGN_UP_TO_THESSA',
    IF_YOU_HAVE_A_UNIVERSITY_OF_HE: 'IF_YOU_HAVE_A_UNIVERSITY_OF_HE',
    MON: 'MON',
    TUE: 'TUE',
    WED: 'WED',
    THU: 'THU',
    FRI: 'FRI',
    SAT: 'SAT',
    SUN: 'SUN',
    LOADING_WITH_ELLIPSIS: 'LOADING_WITH_ELLIPSIS',
    YOU_MAY_USE: 'YOU_MAY_USE',
    MARKDOWN: 'MARKDOWN',
    ITALICS: 'ITALICS',
    BOLD: 'BOLD',
    LINKS_HTTPS: 'LINKS_HTTPS',
    HEADINGS: 'HEADINGS',
    LISTS: 'LISTS',
    AND_MORE: 'AND_MORE',
    THESSA_FOR: 'THESSA_FOR',
    UNIVERSITY_OF_HELSINKI: 'UNIVERSITY_OF_HELSINKI',
    PRIVACY_POLICY: 'PRIVACY_POLICY',
    ASK_FOR_HELP_AND_GIVE_FEEDBACK: 'ASK_FOR_HELP_AND_GIVE_FEEDBACK',
    TOGGLE_NAVIGATION: 'TOGGLE_NAVIGATION',
    LOG_OUT: 'LOG_OUT',
    LOGIN: 'LOGIN',
    REMINDERS1: 'REMINDERS1',
    PROFILE1: 'PROFILE1',
    HELP1: 'HELP1',
    MY_PHD_PROJECT: 'MY_PHD_PROJECT',
    MY_DOCTORAL_CANDIDATES: 'MY_DOCTORAL_CANDIDATES',
    DOCTORAL_CANDIDATES1: 'DOCTORAL_CANDIDATES1',
    USERS1: 'USERS1',
    QUEUE1: 'QUEUE1',
    STATISTICS1: 'STATISTICS1',
    LEFT: 'LEFT',
    BOTTOM: 'BOTTOM',
    ARE_YOU_SURE: 'ARE_YOU_SURE',
    CONFIRM_DELETE: 'CONFIRM_DELETE',
    THANKS: 'THANKS',
    YOU_CAN_GIVE_MORE_FEEDBACK_HER: 'YOU_CAN_GIVE_MORE_FEEDBACK_HER',
    SEND_FEEDBACK: 'SEND_FEEDBACK',
    PAGE_HEADER: 'PAGE_HEADER',
    HEADING: 'HEADING',
    HEADING1: 'HEADING1',
    HEADING2: 'HEADING2',
    HEADING3: 'HEADING3',
    HEADING4: 'HEADING4',
    HEADING5: 'HEADING5',
    LEAD_TEXT: 'LEAD_TEXT',
    BODY_TEXT: 'BODY_TEXT',
    SMALL_TEXT: 'SMALL_TEXT',
    LABEL: 'LABEL',
    LABEL1: 'LABEL1',
    LABEL2: 'LABEL2',
    CHECK: 'CHECK',
    CHECK1: 'CHECK1',
    SUBMIT: 'SUBMIT',
    SAVE: 'SAVE',
    TOGGLE: 'TOGGLE',
    CALENDAR: 'CALENDAR',
    OK: 'OK',
    REMOVE: 'REMOVE',
    CLEAR: 'CLEAR',
    SUBMITTED: 'SUBMITTED',
    CONCLUSION_MISSING: 'CONCLUSION_MISSING',
    GIVE_FEEDBACK: 'GIVE_FEEDBACK',
    DEFAULT: 'DEFAULT',
    RIGHT: 'RIGHT',
    LEFT1: 'LEFT1',
    CALL_TO_ACTION: 'CALL_TO_ACTION',
    SECONDARY: 'SECONDARY',
    ACTION: 'ACTION',
    ACTIONS: 'ACTIONS',
    STUDENT_NUMBER: 'STUDENT_NUMBER',
    NAME: 'NAME',
    ACCOUNT: 'ACCOUNT',
    NO_ACCOUNT: 'NO_ACCOUNT',
    NO_SUPERVISORS_IN_OODI: 'NO_SUPERVISORS_IN_OODI',
    STUDY_RIGHT_START_DATE: 'STUDY_RIGHT_START_DATE',
    RECENT: 'RECENT',
    COORDINATOR_QUEUE: 'COORDINATOR_QUEUE',
    LOADING_INACTIVE_USERS: 'LOADING_INACTIVE_USERS',
    THERE_WAS_AN_ERROR_IN_LOADING: 'THERE_WAS_AN_ERROR_IN_LOADING',
    PLEASE: 'PLEASE',
    TRY_AGAIN: 'TRY_AGAIN',
    LET_US_KNOW: 'LET_US_KNOW',
    IF_THE_PROBLEM_DOES_NOT_GO_AWA: 'IF_THE_PROBLEM_DOES_NOT_GO_AWA',
    INACTIVE_USER: 'INACTIVE_USER',
    TYPE: 'TYPE',
    N_A: 'N_A',
    NO_COURSES_IN_PLAN_YET: 'NO_COURSES_IN_PLAN_YET',
    ADD: 'ADD',
    BUTTON_ABOVE: 'BUTTON_ABOVE',
    TITLE: 'TITLE',
    COURSES_TOTAL: 'COURSES_TOTAL',
    CREDITS: 'CREDITS',
    CREDITS_ABBREVIATED: 'CREDITS_ABBREVIATED',
    CREDITS_COMPLETED: 'CREDITS_COMPLETED',
    CREDITS_PLANNED: 'CREDITS_PLANNED',
    CREDITS_TOTAL: 'CREDITS_TOTAL',
    STATUS: 'STATUS',
    COMPLETED: 'COMPLETED',
    COMPLETED_AT: 'COMPLETED_AT',
    TO_BE_COMPLETED_AT: 'TO_BE_COMPLETED_AT',
    COURSE_UNIT_CODE: 'COURSE_UNIT_CODE',
    COURSE_UNIT_CODE_MISSING: 'COURSE_UNIT_CODE_MISSING',
    FAILED_TO_CREATE_COURSE: 'FAILED_TO_CREATE_COURSE',
    CHANGED_SINCE_LAST_OPENED: 'CHANGED_SINCE_LAST_OPENED',
    REPORT: {
        NEXT_REPORT_BY_DATE: 'REPORT.NEXT_REPORT_BY_DATE',
        REPORT: 'REPORT.REPORT',
        REPORT_LATE_NOTIFICATION_FOR_SUPERVISOR: 'REPORT.REPORT_LATE_NOTIFICATION_FOR_SUPERVISOR',
        REPORT_STATUS: 'REPORT.REPORT_STATUS',
        REPORT_STATUS_DRAFT: 'REPORT.REPORT_STATUS_DRAFT',
        REPORT_STATUS_SUBMITTED: 'REPORT.REPORT_STATUS_SUBMITTED',
        REPORT_STATUS_FINAL: 'REPORT.REPORT_STATUS_FINAL',
        NOT_SUBMITTED: 'REPORT.NOT_SUBMITTED',
        THESIS_COMMITTEE_MEETING_NOT_HELD: 'REPORT.THESIS_COMMITTEE_MEETING_NOT_HELD',
        THESIS_COMMITTEE_MEETING_INSTRUCTIONS: 'REPORT.THESIS_COMMITTEE_MEETING_INSTRUCTIONS',
        THESIS_COMMITTEE_MEETING_LEGACY_INSTRUCTIONS: 'REPORT.THESIS_COMMITTEE_MEETING_LEGACY_INSTRUCTIONS',
        REPORTING_PERIOD_WHILE_EDITING_LEGACY: 'REPORT.REPORTING_PERIOD_WHILE_EDITING_LEGACY',
        REPORTING_PERIOD_WHILE_EDITING: 'REPORT.REPORTING_PERIOD_WHILE_EDITING',
        REPORTING_PERIOD_DATES: 'REPORT.REPORTING_PERIOD_DATES',
        REPORTING_PERIOD_STARTING_FROM: 'REPORT.REPORTING_PERIOD_STARTING_FROM',
        FEEDBACK_DUE_TAG: 'REPORT.FEEDBACK_DUE_TAG'
    },
    SUPERVISION_PLAN: 'SUPERVISION_PLAN',
    SUPERVISION_PLAN_other: 'SUPERVISION_PLAN_other',
    MY_DOCTORAL_CANDIDATES1: 'MY_DOCTORAL_CANDIDATES1',
    LOADING_DOCTORAL_CANDIDATES: 'LOADING_DOCTORAL_CANDIDATES',
    FAILED_TO_LOAD_DOCTORAL_CANDID: 'FAILED_TO_LOAD_DOCTORAL_CANDID',
    MISSING_DOCTORAL_CANDIDATES: 'MISSING_DOCTORAL_CANDIDATES',
    TO_SEE_YOUR_DOCTORAL_CANDIDATE: 'TO_SEE_YOUR_DOCTORAL_CANDIDATE',
    YOU_WILL_GET_THE_INVITATION_BY: 'YOU_WILL_GET_THE_INVITATION_BY',
    HIDE: 'HIDE',
    SHOW: 'SHOW',
    CLOSED_ACCOUNTS: 'CLOSED_ACCOUNTS',
    RELATIONSHIP: 'RELATIONSHIP',
    PROGRESS: 'PROGRESS',
    YOU_HAVE_NO_DOCTORAL_CANDIDATE: 'YOU_HAVE_NO_DOCTORAL_CANDIDATE',
    NO_DOCTORAL_CANDIDATES: 'NO_DOCTORAL_CANDIDATES',
    YOUR_USER_ACCOUNT_NEEDS_TO_BE: 'YOUR_USER_ACCOUNT_NEEDS_TO_BE',
    INVITE_ALL_YOUR_SUPERVISORS_AN: 'INVITE_ALL_YOUR_SUPERVISORS_AN',
    IN_THESSA: 'IN_THESSA',
    YOU_WILL_RECEIVE_AN_EMAIL_WHEN: 'YOU_WILL_RECEIVE_AN_EMAIL_WHEN',
    INVITE_SUPERVISORS: 'INVITE_SUPERVISORS',
    THERE_ARE_NO_SUPERVISION_PLANS: 'THERE_ARE_NO_SUPERVISION_PLANS',
    DOCTORAL_CANDIDATE_AND_SUPERVI: 'DOCTORAL_CANDIDATE_AND_SUPERVI',
    SUPERVISORS: 'SUPERVISORS',
    LOADING_NEXT_REPORT_DUE_DATE: 'LOADING_NEXT_REPORT_DUE_DATE',
    NEXT_REPORT_DUE_ON: 'NEXT_REPORT_DUE_ON',
    PERIOD: 'PERIOD',
    PUBLICATIONS: 'PUBLICATIONS',
    COURSES: 'COURSES',
    GRADUATION: 'GRADUATION',
    CONCLUSION: 'CONCLUSION',
    DRAFT: 'DRAFT',
    OPEN: 'OPEN',
    MISSING: 'MISSING',
    HAVE_A_THESIS_COMMITTEE_MEETIN: 'HAVE_A_THESIS_COMMITTEE_MEETIN',
    REPORTS: 'REPORTS',
    LOADING_REPORTS: 'LOADING_REPORTS',
    NO_REPORTS_YET: 'NO_REPORTS_YET',
    VIEW_CUMULATIVE_REPORT: 'VIEW_CUMULATIVE_REPORT',
    THESSA_IS_IN_MAINTENANCE: 'THESSA_IS_IN_MAINTENANCE',
    PLEASE_WAIT_A_FEW_MINUTES_AND: 'PLEASE_WAIT_A_FEW_MINUTES_AND',
    PAGE_NOT_FOUND: 'PAGE_NOT_FOUND',
    SORRY_THE_PAGE_YOU_OPENED_CAN: 'SORRY_THE_PAGE_YOU_OPENED_CAN',
    FRONT_PAGE_INSTEAD: 'FRONT_PAGE_INSTEAD',
    ADD_GRANT: 'ADD_GRANT',
    ADD_SALARY: 'ADD_SALARY',
    SALARIES: 'SALARIES',
    GRANTS: 'GRANTS',
    NO_SALARIES_IN_PLAN_YET: 'NO_SALARIES_IN_PLAN_YET',
    NO_SALARIES: 'NO_SALARIES',
    NO_GRANTS_IN_PLAN_YET: 'NO_GRANTS_IN_PLAN_YET',
    NO_GRANTS: 'NO_GRANTS',
    SOURCE: 'SOURCE',
    AMOUNT: 'AMOUNT',
    FOR_MONTHS: 'FOR_MONTHS',
    USED_FOR: 'USED_FOR',
    NOT_GRANTED: 'NOT_GRANTED',
    GRANTED: 'GRANTED',
    FOR_DATES: 'FOR_DATES',
    HELP_MORE_GUIDES_LINK_PREFIX: 'HELP_MORE_GUIDES_LINK_PREFIX',
    HELP_MORE_GUIDES_LINK_URL: 'HELP_MORE_GUIDES_LINK_URL',
    HELP_MORE_GUIDES_LINK_LINK_TEXT: 'HELP_MORE_GUIDES_LINK_LINK_TEXT',
    HELP_MORE_GUIDES_LINK_SUFFIX: 'HELP_MORE_GUIDES_LINK_SUFFIX',
    TRY_TO_INCLUDE_AS_MUCH_DETAI: 'TRY_TO_INCLUDE_AS_MUCH_DETAI',
    IF_YOU_NEED_MORE_HELP_PLEASE: 'IF_YOU_NEED_MORE_HELP_PLEASE',
    INVITE: 'INVITE',
    S_EMAIL_ADDRESS: 'S_EMAIL_ADDRESS',
    INVITE_TO_YOUR_PHD_PROJECT_IN: 'INVITE_TO_YOUR_PHD_PROJECT_IN',
    INVITATION_SUBMITTED: 'INVITATION_SUBMITTED',
    SUBMITTING_INVITATION_FAILED: 'SUBMITTING_INVITATION_FAILED',
    YOU_ARE_INVITED: 'YOU_ARE_INVITED',
    WHAT_IS_THESSA: 'WHAT_IS_THESSA',
    ALL_DOCTORAL_CANDIDATES_AND_TH: 'ALL_DOCTORAL_CANDIDATES_AND_TH',
    WELCOME_TO_THESSA: 'WELCOME_TO_THESSA',
    YOU_ARE_NOT_CONNECTED_TO_ANYON: 'YOU_ARE_NOT_CONNECTED_TO_ANYON',
    ASK_YOUR_DOCTORAL_CANDIDATES_T: 'ASK_YOUR_DOCTORAL_CANDIDATES_T',
    OTHERWISE_IT_S_GOING_TO: 'OTHERWISE_IT_S_GOING_TO',
    NO_NOTES: 'NO_NOTES',
    EDIT: 'EDIT',
    SAVING: 'SAVING',
    UPDATE_ANNUAL_REPORTS: 'UPDATE_ANNUAL_REPORTS',
    ANNUAL_REPORTS_SECTION_HAS_BEE: 'ANNUAL_REPORTS_SECTION_HAS_BEE',
    UPDATE_CUMULATIVE_REPORT: 'UPDATE_CUMULATIVE_REPORT',
    CUMULATIVE_REPORT_VIEW_SHOWS_A: 'CUMULATIVE_REPORT_VIEW_SHOWS_A',
    UPDATE_REVIEWING_REPORTS: 'UPDATE_REVIEWING_REPORTS',
    CUMULATIVE_REPORT: 'CUMULATIVE_REPORT',
    YOU_CAN_NOW_SEE_THE_CUMULATIVE: 'YOU_CAN_NOW_SEE_THE_CUMULATIVE',
    COMMENTING_REPORT: 'COMMENTING_REPORT',
    DISCUSS_REPORTS: 'DISCUSS_REPORTS',
    NEW_IMPROVEMENTS: 'NEW_IMPROVEMENTS',
    INVITE_SUPERVISORS_AND_THESIS: 'INVITE_SUPERVISORS_AND_THESIS',
    DISCUSS_IN_SIMPLIFIED_ANNUAL_R: 'DISCUSS_IN_SIMPLIFIED_ANNUAL_R',
    REPORTS_ARE_CLOSED_BY_WRITING: 'REPORTS_ARE_CLOSED_BY_WRITING',
    READ_MORE_FROM_HELP_PAGE: 'READ_MORE_FROM_HELP_PAGE',
    SET_OF_DECISIONS_BETWEEN_DOCTO: 'SET_OF_DECISIONS_BETWEEN_DOCTO',
    KEEPING_TRACK_OF_FUTURE_PLANS: 'KEEPING_TRACK_OF_FUTURE_PLANS',
    A_SNAPSHOT_OF_PHD_PROJECT_IT: 'A_SNAPSHOT_OF_PHD_PROJECT_IT',
    START_USING_THESSA: 'START_USING_THESSA',
    WE_RECOMMEND_THAT_YOU_START_US: 'WE_RECOMMEND_THAT_YOU_START_US',
    THEN_YOU_SHOULD_UPDATE_YOUR_PH: 'THEN_YOU_SHOULD_UPDATE_YOUR_PH',
    YOU_CAN_FIND_MORE_DETAILS_ABOU: 'YOU_CAN_FIND_MORE_DETAILS_ABOU',
    IF_YOU_FIND_BUGS_OR_ERRORS_IN: 'IF_YOU_FIND_BUGS_OR_ERRORS_IN',
    DROP_AN_EMAIL_TO_US: 'DROP_AN_EMAIL_TO_US',
    YOUR_DOCTORAL_CANDIDATES_WILL: 'YOUR_DOCTORAL_CANDIDATES_WILL',
    REMOVE1: 'REMOVE1',
    INTERNATIONAL_ACTIVITIES: {
        TYPE: {
            conference: 'INTERNATIONAL_ACTIVITIES.TYPE.CONFERENCE',
            'research-visit': 'INTERNATIONAL_ACTIVITIES.TYPE.RESEARCH_VISIT',
            other: 'INTERNATIONAL_ACTIVITIES.TYPE.OTHER'
        },
        PARTICIPATION_TYPE: {
            'participant-poster': 'INTERNATIONAL_ACTIVITIES.PARTICIPATION_TYPE.PARTICIPANT_POSTER',
            'participant-talk': 'INTERNATIONAL_ACTIVITIES.PARTICIPATION_TYPE.PARTICIPANT_TALK',
            'participant-no-presentation': 'INTERNATIONAL_ACTIVITIES.PARTICIPATION_TYPE.PARTICIPANT_WITHOUT_PRESENTATION',
            organiser: 'INTERNATIONAL_ACTIVITIES.PARTICIPATION_TYPE.ORGANISER'
        }
    },
    CONFERENCES_AND_MOBILITY: 'CONFERENCES_AND_MOBILITY',
    LOCATION: 'LOCATION',
    DATE: 'DATE',
    DATES: 'DATES',
    LOADING_CONFERENCES_AND_MOBILI: 'LOADING_CONFERENCES_AND_MOBILI',
    NO_CONFERENCES_OR_MOBILITY_PLA: 'NO_CONFERENCES_OR_MOBILITY_PLA',
    ADD_CONFERENCE_OR_MOBILITY: 'ADD_CONFERENCE_OR_MOBILITY',
    FAILED_TO_CREATE_CONFERENCE_OR_MOBILITY: 'FAILED_TO_CREATE_CONFERENCE_OR_MOBILITY',
    DELETE: 'DELETE',
    REALLY_CANCEL_INVITATION: 'REALLY_CANCEL_INVITATION',
    KEEP_INVITATION: 'KEEP_INVITATION',
    CANCEL_INVITATION: 'CANCEL_INVITATION',
    INVITATION_EXPIRED: 'INVITATION_EXPIRED',
    INVITED_NOT_YET_RESPONDED: 'INVITED_NOT_YET_RESPONDED',
    FIRST_NAME: 'FIRST_NAME',
    LAST_NAME: 'LAST_NAME',
    EMAIL_ADDRESS: 'EMAIL_ADDRESS',
    SAVED: 'SAVED',
    REALLY_REMOVE: 'REALLY_REMOVE',
    THE_LAST_MEMBER_CANNOT_BE_REMO: 'THE_LAST_MEMBER_CANNOT_BE_REMO',
    RESEND_INVITATION: 'RESEND_INVITATION',
    INVITATION_TO_BECOME_A: 'INVITATION_TO_BECOME_A',
    FOR: 'FOR',
    EXPIRES_ON: 'EXPIRES_ON',
    THIS_INVITATION_HAS_EXPIRED_Y: 'THIS_INVITATION_HAS_EXPIRED_Y',
    ACCEPT: 'ACCEPT',
    DECLINE: 'DECLINE',
    DUE_TO_DATA_MIGRATION_THESSA: 'DUE_TO_DATA_MIGRATION_THESSA',
    NO_PUBLICATIONS_IN_PLAN_YET: 'NO_PUBLICATIONS_IN_PLAN_YET',
    TOPIC_OR_TITLE: 'TOPIC_OR_TITLE',
    EDIT_REMINDER: 'EDIT_REMINDER',
    LOADING_YOUR_REMINDERS: 'LOADING_YOUR_REMINDERS',
    NEW_REMINDER: 'NEW_REMINDER',
    UPCOMING_REMINDERS: 'UPCOMING_REMINDERS',
    PAST_REMINDERS: 'PAST_REMINDERS',
    NO_REMINDERS: 'NO_REMINDERS',
    DUE: 'DUE',
    SEND_REMINDERS_TO: 'SEND_REMINDERS_TO',
    REMINDER_TIMING: 'REMINDER_TIMING',
    DAYS_BEFORE_DUE_DATE: 'DAYS_BEFORE_DUE_DATE',
    CREATE_REPORT: 'CREATE_REPORT',
    YOUR_ACCOUNT_IS_INACTIVE_THER: 'YOUR_ACCOUNT_IS_INACTIVE_THER',
    YOUR_DOCTORAL_PROGRAMME_S_STAF: 'YOUR_DOCTORAL_PROGRAMME_S_STAF',
    OPEN_REPORT: 'OPEN_REPORT',
    OPEN_MEETING: 'OPEN_MEETING',
    SUMMARIZE_THE_REPORTING_PERIOD: 'SUMMARIZE_THE_REPORTING_PERIOD',
    AS_AN_OVERVIEW_OF_THE_REPORTIN: 'AS_AN_OVERVIEW_OF_THE_REPORTIN',
    PHD_PROJECT_PAGE: 'PHD_PROJECT_PAGE',
    PUBLICATIONS_IN_REPORTING_PERIOD: 'PUBLICATIONS_IN_REPORTING_PERIOD',
    NO_PUBLICATIONS_IN_REPORTING_PERIOD: 'NO_PUBLICATIONS_IN_REPORTING_PERIOD',
    COURSES_IN_REPORTING_PERIOD: 'COURSES_IN_REPORTING_PERIOD',
    INTERNATIONAL_ACTIVITY_IN_REPORTING_PERIOD: 'INTERNATIONAL_ACTIVITY_IN_REPORTING_PERIOD',
    TEACHING_IN_REPORTING_PERIOD: 'TEACHING_IN_REPORTING_PERIOD',
    NO_COURSES_OR_WORKSHOPS_IN_REPORTING_PERIOD: 'NO_COURSES_OR_WORKSHOPS_IN_REPORTING_PERIOD',
    NO_THESIS_INSTRUCTION_IN_REPORTING_PERIOD: 'NO_THESIS_INSTRUCTION_IN_REPORTING_PERIOD',
    FUNDING_IN_REPORTING_PERIOD: 'FUNDING_IN_REPORTING_PERIOD',
    NO_SALARIES_IN_REPORTING_PERIOD: 'NO_SALARIES_IN_REPORTING_PERIOD',
    NO_GRANTS_IN_REPORTING_PERIOD: 'NO_GRANTS_IN_REPORTING_PERIOD',
    NOT_SUBMITTED: 'NOT_SUBMITTED',
    CONCLUSION_DONE: 'CONCLUSION_DONE',
    WRITE_CONCLUSION: 'WRITE_CONCLUSION',
    HAVE_A_THESIS_COMMITTEE_MEETIN1: 'HAVE_A_THESIS_COMMITTEE_MEETIN1',
    THE_DOCTORAL_CANDIDATE_NEEDS_T: 'THE_DOCTORAL_CANDIDATE_NEEDS_T',
    DONE: 'DONE',
    REPORT_SUBMITTED_FOR_REVIEW_SU: 'REPORT_SUBMITTED_FOR_REVIEW_SU',
    REPORT_SUBMITTED: 'REPORT_SUBMITTED',
    REPORT_UPDATED: 'REPORT_UPDATED',
    EDIT_REPORT: 'EDIT_REPORT',
    YOU_CAN_MAKE_CHANGES_TO_THE_RE: 'YOU_CAN_MAKE_CHANGES_TO_THE_RE',
    NO_REPORTS_TO_REVIEW_FOUND: 'NO_REPORTS_TO_REVIEW_FOUND',
    EDIT_REVIEW: 'EDIT_REVIEW',
    REVIEW_REPORT: 'REVIEW_REPORT',
    CHANGES_SAVED: 'CHANGES_SAVED',
    LAST_SAVED: 'LAST_SAVED',
    CANCEL_EDITING: 'CANCEL_EDITING',
    SAVE_REPORT: 'SAVE_REPORT',
    SUBMIT_REPORT_FOR_REVIEW: 'SUBMIT_REPORT_FOR_REVIEW',
    CREATED_IN: 'CREATED_IN',
    CONFERENCES_AND_MOBILITY1: 'CONFERENCES_AND_MOBILITY1',
    FUNDING: 'FUNDING',
    TEACHING: 'TEACHING',
    COURSES_AND_WORKSHOPS: 'COURSES_AND_WORKSHOPS',
    THESIS_INSTRUCTION: 'THESIS_INSTRUCTION',
    YOU_ARE_EDITING_THE_REPORT_S_C: 'YOU_ARE_EDITING_THE_REPORT_S_C',
    SHOW_EDITOR: 'SHOW_EDITOR',
    PLEASE_INDICATE_WHO_ATTENDED_T: 'PLEASE_INDICATE_WHO_ATTENDED_T',
    THESIS_COMMITTEE_MEETING_FORM: 'THESIS_COMMITTEE_MEETING_FORM',
    CONCLUSION_AND_RECOMMENDATIONS: 'CONCLUSION_AND_RECOMMENDATIONS',
    NO_REPORT_FOUND_CANNOT_EDIT_CONCLUSION: 'NO_REPORT_FOUND_CANNOT_EDIT_CONCLUSION',
    NO_TEXT_TO_PREVIEW: 'NO_TEXT_TO_PREVIEW',
    CANNOT_SUBMIT_CONCLUSION_EMPTY: 'CANNOT_SUBMIT_CONCLUSION_EMPTY',
    THE_DOCTORAL_CANDIDATE_IS_EXPE: 'THE_DOCTORAL_CANDIDATE_IS_EXPE',
    PREVIEW: 'PREVIEW',
    SUBMITTING_PLEASE_WAIT: 'SUBMITTING_PLEASE_WAIT',
    CONCLUSION_CONFIRM_CANCEL: 'CONCLUSION_CONFIRM_CANCEL',
    CONCLUSION_CANNOT_BE_EDITED: 'CONCLUSION_CANNOT_BE_EDITED',
    CUMULATIVE_REPORT_FOR: 'CUMULATIVE_REPORT_FOR',
    COMPLETED_IN_THE_MOST_RECENT: 'COMPLETED_IN_THE_MOST_RECENT',
    IN_PROGRESS_IN_THE_MOST_RECE: 'IN_PROGRESS_IN_THE_MOST_RECE',
    PUBLICATION_IS_IN_THESIS: 'PUBLICATION_IS_IN_THESIS',
    COMPLETE: 'COMPLETE',
    NOTHING_REPORTED_YET: 'NOTHING_REPORTED_YET',
    DELETE_REPORT: 'DELETE_REPORT',
    YOU_CAN_DELETE_YOUR_REPORT_BEF: 'YOU_CAN_DELETE_YOUR_REPORT_BEF',
    COMPLETED1: 'COMPLETED1',
    ESTIMATE_OF_HOW_COMPLETE_YOUR: 'ESTIMATE_OF_HOW_COMPLETE_YOUR',
    FULL_TIME: 'FULL_TIME',
    ESTIMATE_OF_FULL_PART_TIME_WOR: 'ESTIMATE_OF_FULL_PART_TIME_WOR',
    YOUR_DOCTORAL_PROGRAMME_ASKS_Y: 'YOUR_DOCTORAL_PROGRAMME_ASKS_Y',
    PLEASE_FILL_IN_ALL_OF_THE_FIEL: 'PLEASE_FILL_IN_ALL_OF_THE_FIEL',
    THE_REPORT_WILL_BE_VISIBLE_TO: 'THE_REPORT_WILL_BE_VISIBLE_TO',
    AND: 'AND',
    WHEN_YOU_ARE_DONE_PRESS_THE_S: 'WHEN_YOU_ARE_DONE_PRESS_THE_S',
    REMEMBER_TO_SAVE_THE_REPORT_PE: 'REMEMBER_TO_SAVE_THE_REPORT_PE',
    MESSAGE_REMOVED: 'MESSAGE_REMOVED',
    DISCUSSION: 'DISCUSSION',
    LOADING: 'LOADING',
    NO_DOCUMENT_FOUND_WITH_DATE: 'NO_DOCUMENT_FOUND_WITH_DATE',
    APPROVED_BY_THE_BOARD_OF_DOCTO: 'APPROVED_BY_THE_BOARD_OF_DOCTO',
    THESSA_JOIN_A_THESIS_COMMITT: 'THESSA_JOIN_A_THESIS_COMMITT',
    WITH_YOUR_THESSA_CREDENTIALS_O: 'WITH_YOUR_THESSA_CREDENTIALS_O',
    OTHERWISE: 'OTHERWISE',
    REGISTER_AN_EXTERNAL_ACCOUNT: 'REGISTER_AN_EXTERNAL_ACCOUNT',
    YOU_WILL_USE_THIS_FOR_LOGGING: 'YOU_WILL_USE_THIS_FOR_LOGGING',
    AT_LEAST_CHARACTERS: 'AT_LEAST_CHARACTERS',
    YOUR_ORGANIZATION: 'YOUR_ORGANIZATION',
    FOR_EXAMPLE_FINNISH_METEOROLO: 'FOR_EXAMPLE_FINNISH_METEOROLO',
    THERE_WERE_PROBLEMS_WITH_SIGN: 'THERE_WERE_PROBLEMS_WITH_SIGN',
    WELCOME_TO_THESSA_AS_A_NON_UN: 'WELCOME_TO_THESSA_AS_A_NON_UN',
    ERROR: 'ERROR',
    SORRY_AN_ERROR_HAS_OCCURRED_I: 'SORRY_AN_ERROR_HAS_OCCURRED_I',
    DOCTORAL_STUDIES: 'DOCTORAL_STUDIES',
    FILL_IN_DETAILS_OF_YOUR_STUDIE: 'FILL_IN_DETAILS_OF_YOUR_STUDIE',
    BEGINNING_OF_DOCTORAL_STUDIES: 'BEGINNING_OF_DOCTORAL_STUDIES',
    DOCTORAL_PROGRAMME: 'DOCTORAL_PROGRAMME',
    BACK: 'BACK',
    CONTINUE: 'CONTINUE',
    OR: 'OR',
    LOG_OUT1: 'LOG_OUT1',
    WELCOME_TO_THESSA1: 'WELCOME_TO_THESSA1',
    WE_NEED_SOME_INFORMATION_ABOUT: 'WE_NEED_SOME_INFORMATION_ABOUT',
    MY_ROLE_IN_THESSA: 'MY_ROLE_IN_THESSA',
    DOCTORAL_CANDIDATE: 'DOCTORAL_CANDIDATE',
    SUPERVISOR: 'SUPERVISOR',
    SUPERVISOR_other: 'SUPERVISOR_other',
    THESIS_COMMITTEE_MEMBER: 'THESIS_COMMITTEE_MEMBER',
    VERIFY_YOUR_DETAILS: 'VERIFY_YOUR_DETAILS',
    WE_FOUND_THE_FOLLOWING_DETAILS: 'WE_FOUND_THE_FOLLOWING_DETAILS',
    PLEASE_CHECK_THAT_THEY_ARE_COR: 'PLEASE_CHECK_THAT_THEY_ARE_COR',
    LIST_DOCTORAL_CANDIDATES_BY_RE: 'LIST_DOCTORAL_CANDIDATES_BY_RE',
    LIST_REVIEWERS_OF_NOT_COMPLETE: 'LIST_REVIEWERS_OF_NOT_COMPLETE',
    DOWNLOAD_THESSA_ADMIN_REPORT: 'DOWNLOAD_THESSA_ADMIN_REPORT',
    REPORT_CONCLUSIONS_OVERVIEW: 'REPORT_CONCLUSIONS_OVERVIEW',
    FILTER: 'FILTER',
    SHOW_ALL_REPORTS: 'SHOW_ALL_REPORTS',
    OVER_MONTH_OLD_REPORTS: 'OVER_MONTH_OLD_REPORTS',
    COPY_REVIEWER_EMAIL_ADDRESSES: 'COPY_REVIEWER_EMAIL_ADDRESSES',
    EMAIL_ADDRESSES_COPIED: 'EMAIL_ADDRESSES_COPIED',
    CREATED_AT: 'CREATED_AT',
    REVIEWERS: 'REVIEWERS',
    FILTER_BY_DOCTORAL_PROGRAMME: 'FILTER_BY_DOCTORAL_PROGRAMME',
    NO_REPORT_CONCLUSIONS_AVAILABL: 'NO_REPORT_CONCLUSIONS_AVAILABL',
    PRELIMINARY_TITLE_OF_DISSERTAT: 'PRELIMINARY_TITLE_OF_DISSERTAT',
    STUDENT_NUMBER1: 'STUDENT_NUMBER1',
    NAME1: 'NAME1',
    ACCOUNT_CLOSED: 'ACCOUNT_CLOSED',
    STUDIES: 'STUDIES',
    FACULTY: 'FACULTY',
    SUPERVISORS1: 'SUPERVISORS1',
    THESIS_COMMITTEE2: 'THESIS_COMMITTEE2',
    REPORT_CREATED: 'REPORT_CREATED',
    PROGRESS1: 'PROGRESS1',
    LINK_TO_THE_DOCTORAL_CANDIDATE: 'LINK_TO_THE_DOCTORAL_CANDIDATE',
    STUDENT_ID_NUMBER: 'STUDENT_ID_NUMBER',
    ACCOUNT_STATUS_OPEN_CLOSED: 'ACCOUNT_STATUS_OPEN_CLOSED',
    IF_ACCOUNT_IS_CLOSED_REASON_F: 'IF_ACCOUNT_IS_CLOSED_REASON_F',
    IS_ACCOUNT_ACTIVE_ACTIVE_INAC: 'IS_ACCOUNT_ACTIVE_ACTIVE_INAC',
    EMAIL2: 'EMAIL2',
    FACULTY1: 'FACULTY1',
    FACULTY_OF_DEGREE: 'FACULTY_OF_DEGREE',
    STARTING_DATE_OF_DOCTORAL_STUD: 'STARTING_DATE_OF_DOCTORAL_STUD',
    DOES_THE_DOCTORAL_CANDIDATE_HA: 'DOES_THE_DOCTORAL_CANDIDATE_HA',
    IS_THE_SUPERVISION_PLAN_IN_EFF: 'IS_THE_SUPERVISION_PLAN_IN_EFF',
    SUPERVISORS2: 'SUPERVISORS2',
    SUPERVISORS_AND_THEIR_EMAIL_AD: 'SUPERVISORS_AND_THEIR_EMAIL_AD',
    IS_THE_ANNUAL_REPORT_SUBMITTED: 'IS_THE_ANNUAL_REPORT_SUBMITTED',
    LATEST_REPORT_SUBMITTED_AT_DATE: 'LATEST_REPORT_SUBMITTED_AT_DATE',
    THE_ANNUAL_REPORTING_IS_CLOSED: 'THE_ANNUAL_REPORTING_IS_CLOSED',
    NEXT_REPORT_S_DEADLINE: 'NEXT_REPORT_S_DEADLINE',
    THESIS_COMMITTEE_HAS_BEEN_ASSI: 'THESIS_COMMITTEE_HAS_BEEN_ASSI',
    MEMBERS_OF_THE_THESIS_COMMITTE: 'MEMBERS_OF_THE_THESIS_COMMITTE',
    OVERALL_PERCENTAGE_OF_COMPLETI: 'OVERALL_PERCENTAGE_OF_COMPLETI',
    ADVANCEMENT_OF_THESIS_WORK_COM: 'ADVANCEMENT_OF_THESIS_WORK_COM',
    FULL_TIME_PART_TIME: 'FULL_TIME_PART_TIME',
    SALARIES2: 'SALARIES2',
    GRANTS2: 'GRANTS2',
    GRANTS_OBTAINED_AND_APPLIED_FO: 'GRANTS_OBTAINED_AND_APPLIED_FO',
    EXPORT: 'EXPORT',
    CREATE_SUPERVISION_PLAN: 'CREATE_SUPERVISION_PLAN',
    DELETE_SUPERVISION_PLAN: 'DELETE_SUPERVISION_PLAN',
    ACCEPT_PLAN: 'ACCEPT_PLAN',
    VALID_BETWEEN: 'VALID_BETWEEN',
    VALID_FROM: 'VALID_FROM',
    VALID_INDEFINITELY: 'VALID_INDEFINITELY',
    VALID_INDEFINITELY_SHORT: 'VALID_INDEFINITELY_SHORT',
    DECISIONS: 'DECISIONS',
    SIGNATURES: 'SIGNATURES',
    SIGNED: 'SIGNED',
    NOT_YET_SIGNED: 'NOT_YET_SIGNED',
    WHAT_HAVE_YOU_DECIDED_ABOUT_TH: 'WHAT_HAVE_YOU_DECIDED_ABOUT_TH',
    ACTIVE: 'ACTIVE',
    PENDING: 'PENDING',
    EXPIRED: 'EXPIRED',
    GENERAL_TERMS_ON: 'GENERAL_TERMS_ON',
    RIGHTS_OBLIGATIONS_AND_RESPON2: 'RIGHTS_OBLIGATIONS_AND_RESPON2',
    THAT_APPLY_TO_THE_SUPERVISION: 'THAT_APPLY_TO_THE_SUPERVISION',
    NO_COURSES_OR_WORKSHOPS_IN_PLA: 'NO_COURSES_OR_WORKSHOPS_IN_PLA',
    NO_THESIS_INSTRUCTIONS_IN_PLAN: 'NO_THESIS_INSTRUCTIONS_IN_PLAN',
    ADD_TEACHING: 'ADD_TEACHING',
    TYPE_OF_TEACHING: 'TYPE_OF_TEACHING',
    DATES1: 'DATES1',
    COURSE_OR_WORKSHOP_NAME: 'COURSE_OR_WORKSHOP_NAME',
    MY_ROLE: 'MY_ROLE',
    WORK_HOURS: 'WORK_HOURS',
    STUDENT_S_NAME: 'STUDENT_S_NAME',
    THESIS_LEVEL: 'THESIS_LEVEL',
    THESIS_TOPIC_OR_TITLE: 'THESIS_TOPIC_OR_TITLE',
    SIGNED_UP_ON: 'SIGNED_UP_ON',
    USERNAME: 'USERNAME',
    ACTIVATE_ACCOUNT_NOW: 'ACTIVATE_ACCOUNT_NOW',
    USER_ACCOUNT_IS_NOT_YET_ACTIVA: 'USER_ACCOUNT_IS_NOT_YET_ACTIVA',
    CHECK_THE_ACCOUNT_DETAILS_IF: 'CHECK_THE_ACCOUNT_DETAILS_IF',
    CONTACT_THESSA_S_ADMINS: 'CONTACT_THESSA_S_ADMINS',
    CLOSE_ACCOUNT: 'CLOSE_ACCOUNT',
    REASON_FOR_CLOSING_THE_ACCOUNT: 'REASON_FOR_CLOSING_THE_ACCOUNT',
    OPEN_ACCOUNT: 'OPEN_ACCOUNT',
    OPEN_ACCOUNT_ERROR: {
        ERROR: 'OPEN_ACCOUNT_ERROR.ERROR',
        IS_ALREADY_OPEN: 'OPEN_ACCOUNT_ERROR.IS_ALREADY_OPEN',
        NOT_DOCTORAL_CANDIDATE: 'OPEN_ACCOUNT_ERROR.NOT_DOCTORAL_CANDIDATE',
        ALREADY_REOPENED_BY_USERNAME: 'OPEN_ACCOUNT_ERROR.ALREADY_REOPENED_BY_USERNAME',
        ALREADY_REOPENED_BY_EMAIL: 'OPEN_ACCOUNT_ERROR.ALREADY_REOPENED_BY_EMAIL'
    },
    FACULTY2: 'FACULTY2',
    MAJOR: 'MAJOR',
    DOCTORAL_PROGRAMME1: 'DOCTORAL_PROGRAMME1',
    BEGINNING_OF_DOCTORAL_STUDIES1: 'BEGINNING_OF_DOCTORAL_STUDIES1',
    BACK_TO: 'BACK_TO',
    ORGANIZATION: 'ORGANIZATION',
    STUDENT_NUMBER2: 'STUDENT_NUMBER2',
    VERIFIED_FROM_LDAP: 'VERIFIED_FROM_LDAP',
    NOT_VERIFIED_REPORTED_BY_DOCT: 'NOT_VERIFIED_REPORTED_BY_DOCT',
    THESIS_COMMITTEE_MEMBER1: 'THESIS_COMMITTEE_MEMBER1',
    IN_THESIS_COMMITTEE_FOR: 'IN_THESIS_COMMITTEE_FOR',
    IN_THESIS_COMMITTEE_FOR_other: 'IN_THESIS_COMMITTEE_FOR_other',
    THE_INVITATION_HAS_EXPIRED: 'THE_INVITATION_HAS_EXPIRED',
    THE_INVITATION_HAS_ALREADY_BEEN_USED: 'THE_INVITATION_HAS_ALREADY_BEEN_USED',
    THERE_WAS_AN_ERROR_IN_LOADING_THE_INVITATION: 'THERE_WAS_AN_ERROR_IN_LOADING_THE_INVITATION',
    INVITATION_DECLINED: 'INVITATION_DECLINED',
    YOUR_ACCOUNT_IS_CLOSED: 'YOUR_ACCOUNT_IS_CLOSED',
    SUPERVISION_PLAN_NOT_FOUND: 'SUPERVISION_PLAN_NOT_FOUND',
    IN_THESIS: 'IN_THESIS',
    PUBLISHED: 'PUBLISHED',
    NOT_STARTED: 'NOT_STARTED',
    THE_SUPERVISION_PLAN_AFFECTS_THE_DOCTORAL: 'THE_SUPERVISION_PLAN_AFFECTS_THE_DOCTORAL',
    IT_IS_RECOMMENDED_THAT_SUPERVISION_PLANS: 'IT_IS_RECOMMENDED_THAT_SUPERVISION_PLANS',
    CREATE_AND_SIGN_PLAN_AS: 'CREATE_AND_SIGN_PLAN_AS',
    SAVE_DRAFT: 'SAVE_DRAFT',
    SAVE_DRAFT_FEEDBACK: 'SAVE_DRAFT_FEEDBACK',
    LOADING_DOCTORAL_PROGRAMMES: 'LOADING_DOCTORAL_PROGRAMMES',
    FORM_IS_INCOMPLETE: 'FORM_IS_INCOMPLETE',
    DESCRIPTION: 'DESCRIPTION',
    ROLE_IN_CONFERENCE: 'ROLE_IN_CONFERENCE',
    FAILED_TO_SAVE: 'FAILED_TO_SAVE',
    ROLE: 'ROLE',
    PREVIOUS_PAGE: 'PREVIOUS_PAGE',
    NEXT_PAGE: 'NEXT_PAGE',
    ROWS: 'ROWS',
    PAGE_OF: 'PAGE_OF',
    PAGE: 'PAGE',
    MAX_SIZE_PER_ATTACHMENT: 'MAX_SIZE_PER_ATTACHMENT',
    UPLOAD_ATTACHMENTS: 'UPLOAD_ATTACHMENTS',
    UPLOADING: 'UPLOADING',
    WHAT_PLANS_DO_YOU_HAVE: 'WHAT_PLANS_DO_YOU_HAVE',
    WRITE_HERE_ABOUT_YOUR_RESEARCH_PROGRESS: 'WRITE_HERE_ABOUT_YOUR_RESEARCH_PROGRESS',
    FOR_EXAMPLE_WRITE_ABOUT_HOSTING_A_VISITOR: 'FOR_EXAMPLE_WRITE_ABOUT_HOSTING_A_VISITOR',
    FOR_EXAMPLE_HAVE_YOU_WRITTEN_A_BLOG: 'FOR_EXAMPLE_HAVE_YOU_WRITTEN_A_BLOG',
    NO_REPORTS: 'NO_REPORTS',
    ANY: 'ANY',
    FILTER_BY: 'FILTER_BY',
    SORT_BY: 'SORT_BY',
    THERE_WAS_AN_ERROR_IN_LOADING_DOCTORAL_CANDIDATES: 'THERE_WAS_AN_ERROR_IN_LOADING_DOCTORAL_CANDIDATES',
    THERE_ARE_NO_DOCTORAL_CANDIDATES_IN_THE_SELECTED: 'THERE_ARE_NO_DOCTORAL_CANDIDATES_IN_THE_SELECTED',
    DOCTORAL_PROGRAMMES: 'DOCTORAL_PROGRAMMES',
    ERROR_LOADING_DOCTORAL_PROGRAMMES: 'ERROR_LOADING_DOCTORAL_PROGRAMMES',
    SELECT_NONE: 'SELECT_NONE',
    SELECT_ALL: 'SELECT_ALL',
    WHEN_WILL_EACH_STAGE_OF_THE_PUBLICATION_BEGIN: 'WHEN_WILL_EACH_STAGE_OF_THE_PUBLICATION_BEGIN',
    THE_STATUSES_ARE_IN_INCORRECT_ORDER: 'THE_STATUSES_ARE_IN_INCORRECT_ORDER',
    TO_BE_INCLUDED_IN_THE_PHD_THESIS: 'TO_BE_INCLUDED_IN_THE_PHD_THESIS',
    SAVE_PUBLICATION: 'SAVE_PUBLICATION',
    CREATE_ANOTHER: 'CREATE_ANOTHER',
    CREATING_ANOTHER_PUBLICATION: 'CREATING_ANOTHER_PUBLICATION',
    CREATING_ANOTHER_GRANT: 'CREATING_ANOTHER_GRANT',
    SOURCE_OF_GRANT: 'SOURCE_OF_GRANT',
    FROM_WHICH_ORGANIZATION_IS_THE_GRANT_FROM: 'FROM_WHICH_ORGANIZATION_IS_THE_GRANT_FROM',
    HOW_MUCH_IS_THIS_GRANT: 'HOW_MUCH_IS_THIS_GRANT',
    SAVE_GRANT: 'SAVE_GRANT',
    ENDS_AT: 'ENDS_AT',
    BEGINS_AT: 'BEGINS_AT',
    WHAT_IS_THE_INTENDED_USAGE_OF_THIS_GRANT: 'WHAT_IS_THE_INTENDED_USAGE_OF_THIS_GRANT',
    DURATION_OF_GRANT: 'DURATION_OF_GRANT',
    WHEN_DOES_THIS_GRANT_BEGIN_AND_END: 'WHEN_DOES_THIS_GRANT_BEGIN_AND_END',
    CREATING_ANOTHER_TEACHING: 'CREATING_ANOTHER_TEACHING',
    BEGINNING_DATE: 'BEGINNING_DATE',
    END_DATE: 'END_DATE',
    NAME_OF_THE_COURSE_OR_WORKSHOP: 'NAME_OF_THE_COURSE_OR_WORKSHOP',
    MY_ROLE_IN_TEACHING: 'MY_ROLE_IN_TEACHING',
    FOR_EXAMPLE_LECTURER_OR_ASSISTANT: 'FOR_EXAMPLE_LECTURER_OR_ASSISTANT',
    TOPIC_OR_TITLE_OF_THE_THESIS: 'TOPIC_OR_TITLE_OF_THE_THESIS',
    LEVEL_OF_THESIS: 'LEVEL_OF_THESIS',
    COURSE_OR_WORKSHOP: 'COURSE_OR_WORKSHOP',
    HOW_MANY_HOURS_OF_WORK_DID_YOU_SPEND_IN_TOTAL: 'HOW_MANY_HOURS_OF_WORK_DID_YOU_SPEND_IN_TOTAL',
    NAME_OF_THE_STUDENT_WHO_YOUR_WERE_INSTRUCTING: 'NAME_OF_THE_STUDENT_WHO_YOUR_WERE_INSTRUCTING',
    MY_ROLE_IN_INSTRUCTING_THE_STUDENT: 'MY_ROLE_IN_INSTRUCTING_THE_STUDENT',
    FOR_EXAMPLE_MAIN_SUPERVISOR_OR_CO_SUPERVISOR: 'FOR_EXAMPLE_MAIN_SUPERVISOR_OR_CO_SUPERVISOR',
    FOR_EXAMPLE_MASTERS_THESIS_OR_BACHELORS_THESIS: 'FOR_EXAMPLE_MASTERS_THESIS_OR_BACHELORS_THESIS',
    CREATING_ANOTHER_SALARY: 'CREATING_ANOTHER_SALARY',
    SOURCE_OF_SALARY: 'SOURCE_OF_SALARY',
    FROM_WHICH_ORGANIZATION_AND_OR_PROJECT_DO_YOU_GET: 'FROM_WHICH_ORGANIZATION_AND_OR_PROJECT_DO_YOU_GET',
    DURATION_OF_SALARY: 'DURATION_OF_SALARY',
    WHEN_DOES_THIS_SALARY_BEGIN_AND_END_IF_THERE_IS_NO: 'WHEN_DOES_THIS_SALARY_BEGIN_AND_END_IF_THERE_IS_NO',
    SAVE_SALARY: 'SAVE_SALARY',
    DUE_DATE: 'DUE_DATE',
    SEND_REMINDER_EMAILS_AT: 'SEND_REMINDER_EMAILS_AT',
    SAVE_REMINDER: 'SAVE_REMINDER',
    LOG_IN_OR_SIGN_UP_TO_ACCEPT_INVITATION: 'LOG_IN_OR_SIGN_UP_TO_ACCEPT_INVITATION',
    LOG_IN_WITH_UNIVERSITY_OF_HELSINKI_ACCOUNT: 'LOG_IN_WITH_UNIVERSITY_OF_HELSINKI_ACCOUNT',
    I_DON_T_HAVE_A_UNIVERSITY_OF_HELSINKI_ACCOUNT: 'I_DON_T_HAVE_A_UNIVERSITY_OF_HELSINKI_ACCOUNT',
    LOG_IN_WITH_AN_EXISTING_THESSA_ACCOUNT: 'LOG_IN_WITH_AN_EXISTING_THESSA_ACCOUNT',
    LOG_IN_OR_SIGN_UP_FOR_A_THESSA_ACCOUNT_TO: 'LOG_IN_OR_SIGN_UP_FOR_A_THESSA_ACCOUNT_TO',
    SIGN_UP_FOR_A_NEW_THESSA_ACCOUNT: 'SIGN_UP_FOR_A_NEW_THESSA_ACCOUNT',
    ERROR_LOGIN_OR_SIGN_UP: 'ERROR_LOGIN_OR_SIGN_UP',
    INVITATION_HAS_EXPIRED_AT: 'INVITATION_HAS_EXPIRED_AT',
    INVITATIONS: {
        BY_ACCEPTING_THE_INVITATION: 'INVITATIONS.BY_ACCEPTING_THE_INVITATION',
        UNIVERSITY_STAFF_OR_STUDENTS_HEADING: 'INVITATIONS.UNIVERSITY_STAFF_OR_STUDENTS_HEADING',
        UNIVERSITY_STAFF_OR_STUDENTS_INSTRUCTIONS: 'INVITATIONS.UNIVERSITY_STAFF_OR_STUDENTS_INSTRUCTIONS',
        EXTERNAL_USERS_HEADING: 'INVITATIONS.EXTERNAL_USERS_HEADING',
        EXTERNAL_USERS_INSTRUCTIONS: 'INVITATIONS.EXTERNAL_USERS_INSTRUCTIONS',
        EXTERNAL_EXISTING_USERS_HEADING: 'INVITATIONS.EXTERNAL_EXISTING_USERS_HEADING',
        EXTERNAL_EXISTING_USERS_INSTRUCTIONS: 'INVITATIONS.EXTERNAL_EXISTING_USERS_INSTRUCTIONS',
        EXTERNAL_NEW_USERS_HEADING: 'INVITATIONS.EXTERNAL_NEW_USERS_HEADING',
        EXTERNAL_NEW_USERS_INSTRUCTIONS: 'INVITATIONS.EXTERNAL_NEW_USERS_INSTRUCTIONS',
        EXTERNAL_NEW_USERS_ACTION: 'INVITATIONS.EXTERNAL_NEW_USERS_ACTION',
        YOU_ARE_USING_UNIVERSITY_EMAIL: 'INVITATIONS.YOU_ARE_USING_UNIVERSITY_EMAIL',
        DECLINE_INSTRUCTIONS: 'INVITATIONS.DECLINE_INSTRUCTIONS',
        DECLINE_ACTION: 'INVITATIONS.DECLINE_ACTION',
        FAILED_TO_ACCEPT_INVITATION: 'INVITATIONS.FAILED_TO_ACCEPT_INVITATION'
    },
    YOU_HAVE_BEEN_INVITED_TO_BECOME: 'YOU_HAVE_BEEN_INVITED_TO_BECOME',
    ACCEPT_INVITATION: 'ACCEPT_INVITATION',
    THERE_WAS_AN_ERROR_IN_DECLINING_THE_INVITATION: 'THERE_WAS_AN_ERROR_IN_DECLINING_THE_INVITATION',
    SIGN_UP_FOR_A_NEW_THESSA_ACCOUNT_TO: 'SIGN_UP_FOR_A_NEW_THESSA_ACCOUNT_TO',
    SIGN_UP: 'SIGN_UP',
    ERROR_IN_SIGN_UP: 'ERROR_IN_SIGN_UP',
    LOG_IN_FAILED_TRY_AGAIN: 'LOG_IN_FAILED_TRY_AGAIN',
    ROLES: 'ROLES',
    DOES_NOT_HAVE_ANY_ROLES_ASSIGNED: 'DOES_NOT_HAVE_ANY_ROLES_ASSIGNED',
    THERE_WAS_AN_ERROR_IN_UPDATING_ROLES: 'THERE_WAS_AN_ERROR_IN_UPDATING_ROLES',
    ONLY_ONE_PERSON_CAN_BE_THE_COORDINATING: 'ONLY_ONE_PERSON_CAN_BE_THE_COORDINATING',
    ONLY_ONE_PERSON_CAN_BE_THE_MAIN_SUPERVISOR: 'ONLY_ONE_PERSON_CAN_BE_THE_MAIN_SUPERVISOR',
    ONE_PERSON_SHOULD_BE_SELECTED_AS_THE_COORDINATING: 'ONE_PERSON_SHOULD_BE_SELECTED_AS_THE_COORDINATING',
    ONE_PERSON_SHOULD_BE_SELECTED_AS_THE_MAIN: 'ONE_PERSON_SHOULD_BE_SELECTED_AS_THE_MAIN',
    MYSELF: 'MYSELF',
    FILTERS: 'FILTERS',
    CHOOSE_A_DOCTORAL_PROGRAMME: 'CHOOSE_A_DOCTORAL_PROGRAMME',
    LOADING_INACTIVE_USER: 'LOADING_INACTIVE_USER',
    NO_STUDENT_NUMBER: 'NO_STUDENT_NUMBER',
    SIGNED_UP: 'SIGNED_UP',
    NO_SUPERVISORS: 'NO_SUPERVISORS',
    SUPERVISOR_INVITATIONS: 'SUPERVISOR_INVITATIONS',
    ACTIVATE: 'ACTIVATE',
    SEND_EMAIL: 'SEND_EMAIL',
    NO_EMAIL_ADDRESS: 'NO_EMAIL_ADDRESS',
    THERE_WAS_AN_ERROR_IN_ACTIVATING_THE_USER_ACCOUNT: 'THERE_WAS_AN_ERROR_IN_ACTIVATING_THE_USER_ACCOUNT',
    SELECT_DOCTORAL_PROGRAMME: 'SELECT_DOCTORAL_PROGRAMME',
    NO_DOCTORAL_PROGRAMME_SELECTED: 'NO_DOCTORAL_PROGRAMME_SELECTED',
    SELECT_DOCTORAL_PROGRAMMES: 'SELECT_DOCTORAL_PROGRAMMES',
    ALL_DOCTORAL_PROGRAMMES: 'ALL_DOCTORAL_PROGRAMMES',
    NOT_VERIFIED: 'NOT_VERIFIED',
    VERIFY_NOW: 'VERIFY_NOW',
    DOCTORAL_CANDIDATE_DOES_NOT_HAVE_ANY_SUPERVISORS: 'DOCTORAL_CANDIDATE_DOES_NOT_HAVE_ANY_SUPERVISORS',
    COUNT_THESIS_COMMITTEE_MEMBER: 'COUNT_THESIS_COMMITTEE_MEMBER',
    COUNT_THESIS_COMMITTEE_MEMBER_other: 'COUNT_THESIS_COMMITTEE_MEMBER_other',
    COUNT_SUPERVISOR_RELATIONSHIP: 'COUNT_SUPERVISOR_RELATIONSHIP',
    COUNT_SUPERVISOR_RELATIONSHIP_other: 'COUNT_SUPERVISOR_RELATIONSHIP_other',
    COUNT_PUBLICATION_IN_PROGRESS: 'COUNT_PUBLICATION_IN_PROGRESS',
    COUNT_PUBLICATION_IN_PROGRESS_other: 'COUNT_PUBLICATION_IN_PROGRESS_other',
    COUNT_PUBLICATION_PUBLISHED: 'COUNT_PUBLICATION_PUBLISHED',
    COUNT_PUBLICATION_PUBLISHED_other: 'COUNT_PUBLICATION_PUBLISHED_other',
    MAIN_SUPERVISOR: 'MAIN_SUPERVISOR',
    MAIN_SUPERVISOR_other: 'MAIN_SUPERVISOR_other',
    COORDINATING_ACADEMIC: 'COORDINATING_ACADEMIC',
    COORDINATING_ACADEMIC_other: 'COORDINATING_ACADEMIC_other',
    COUNT_DOCTORAL_CANDIDATE: 'COUNT_DOCTORAL_CANDIDATE',
    COUNT_DOCTORAL_CANDIDATE_other: 'COUNT_DOCTORAL_CANDIDATE_other',
    ONLY_SHOW_DOCTORAL_CANDIDATES_LATE_WITH_NEXT_THESIS_COMMITTEE_MEETING: 'ONLY_SHOW_DOCTORAL_CANDIDATES_LATE_WITH_NEXT_THESIS_COMMITTEE_MEETING',
    ONLY_SHOW_DOCTORAL_CANDIDATES_WITHOUT_ACCOUNT: 'ONLY_SHOW_DOCTORAL_CANDIDATES_WITHOUT_ACCOUNT',
    ONLY_SHOW_DOCTORAL_CANDIDATES_WITHOUT_SUPERVISOR: 'ONLY_SHOW_DOCTORAL_CANDIDATES_WITHOUT_SUPERVISOR',
    COUNT_DOCTORAL_CANDIDATE_S_REPORT: 'COUNT_DOCTORAL_CANDIDATE_S_REPORT',
    COUNT_DOCTORAL_CANDIDATE_S_REPORT_other: 'COUNT_DOCTORAL_CANDIDATE_S_REPORT_other',
    COUNT_DOCTORAL_CANDIDATE_S_LATEST: 'COUNT_DOCTORAL_CANDIDATE_S_LATEST',
    COUNT_DOCTORAL_CANDIDATE_S_LATEST_other: 'COUNT_DOCTORAL_CANDIDATE_S_LATEST_other',
    COUNT_DOCTORAL_CANDIDATE_IS_ON_TIME: 'COUNT_DOCTORAL_CANDIDATE_IS_ON_TIME',
    COUNT_DOCTORAL_CANDIDATE_IS_ON_TIME_other: 'COUNT_DOCTORAL_CANDIDATE_IS_ON_TIME_other',
    COUNT_ITEM_IN_QUEUE: 'COUNT_ITEM_IN_QUEUE',
    COUNT_ITEM_IN_QUEUE_other: 'COUNT_ITEM_IN_QUEUE_other',
    OLDEST_ITEM_FIRST: 'OLDEST_ITEM_FIRST',
    ISPROCEEDING: 'ISPROCEEDING',
    IS_THE_ANNUAL_REPORT_PROCEEDING_AS_PLANNED: 'IS_THE_ANNUAL_REPORT_PROCEEDING_AS_PLANNED',
    CONCLUSIONCOMMENT: 'CONCLUSIONCOMMENT',
    COMMENT_ABOUT_THE_PROGRESS_OF_THE: 'COMMENT_ABOUT_THE_PROGRESS_OF_THE',
    PROGRESS_FEEDBACK_BY: 'PROGRESS_FEEDBACK_BY',
    IS_THE_DISSERTATION_WORK_PROCEEDING_AS_PLANNED: 'IS_THE_DISSERTATION_WORK_PROCEEDING_AS_PLANNED',
    PROGRESS_FEEDBACK_IS_MISSING: 'PROGRESS_FEEDBACK_IS_MISSING',
    PROGRESS_FEEDBACK_SUBMITTED: 'PROGRESS_FEEDBACK_SUBMITTED',
    GIVE_PROGRESS_FEEDBACK: 'GIVE_PROGRESS_FEEDBACK',
    THERE_WAS_A_PROBLEM_SUBMITTING_PROGRESS_FEEDBACK: 'THERE_WAS_A_PROBLEM_SUBMITTING_PROGRESS_FEEDBACK',
    PROGRESS_FEEDBACK_SUBMITTED_REDIRECTING_YOU_BACK: 'PROGRESS_FEEDBACK_SUBMITTED_REDIRECTING_YOU_BACK',
    PROGRESS_FEEDBACK: 'PROGRESS_FEEDBACK',
    COMMENT1: 'COMMENT1',
    OPTIONAL_COMMENT_ABOUT_THE_PROGRESS_OF_THE: 'OPTIONAL_COMMENT_ABOUT_THE_PROGRESS_OF_THE',
    MOBILE: 'MOBILE',
    DESKTOP: 'DESKTOP',
    VIEW_ACCOUNT: 'VIEW_ACCOUNT',
    EDIT_ROLES: 'EDIT_ROLES',
    REMOVE_SUPERVISOR: 'REMOVE_SUPERVISOR',
    ENDING_ON_DATE: 'ENDING_ON_DATE',
    INVITE_SUPERVISOR: 'INVITE_SUPERVISOR',
    ADD_SUPERVISOR: 'ADD_SUPERVISOR',
    FAILED_TO_SEND_INVITE_PLEASE_TRY_AGAIN: 'FAILED_TO_SEND_INVITE_PLEASE_TRY_AGAIN',
    SAVE_ROLES: 'SAVE_ROLES',
    ERROR_IN_SAVING_ROLES_TRY_AGAIN_OR: 'ERROR_IN_SAVING_ROLES_TRY_AGAIN_OR',
    INVITATION: 'INVITATION',
    REMOVE_INVITATION: 'REMOVE_INVITATION',
    YOU_HAVE_NO_ACTIVE_DOCTORAL_CANDIDATES_IN_THESSA: 'YOU_HAVE_NO_ACTIVE_DOCTORAL_CANDIDATES_IN_THESSA',
    NOT_IN_THESSA: 'NOT_IN_THESSA',
    UPLOAD_AN_EXCEL_FILE_WITH_SUPERVISOR_RELATIONSHIPS: 'UPLOAD_AN_EXCEL_FILE_WITH_SUPERVISOR_RELATIONSHIPS',
    CHANGE_FILE: 'CHANGE_FILE',
    GO_BACK: 'GO_BACK',
    SAVE_SUPERVISOR_RELATIONSHIPS: 'SAVE_SUPERVISOR_RELATIONSHIPS',
    DOCTORAL_CANDIDATE_ROW: 'DOCTORAL_CANDIDATE_ROW',
    IGNORE: 'IGNORE',
    COORDINATING_ACADEMIC_EMAIL: 'COORDINATING_ACADEMIC_EMAIL',
    MAIN_SUPERVISOR_EMAIL: 'MAIN_SUPERVISOR_EMAIL',
    SUPERVISOR_EMAIL: 'SUPERVISOR_EMAIL',
    SUPERVISOR_RELATIONSHIPS: 'SUPERVISOR_RELATIONSHIPS',
    UPLOAD_A_FILE_WITH_SUPERVISOR_RELATIONSHIPS: 'UPLOAD_A_FILE_WITH_SUPERVISOR_RELATIONSHIPS',
    PICK_COLUMNS_AND_ROWS_TO_IMPORT: 'PICK_COLUMNS_AND_ROWS_TO_IMPORT',
    FOR_EACH_COLUMN_WITH_RELEVANT_DATA: 'FOR_EACH_COLUMN_WITH_RELEVANT_DATA',
    THEN_SELECT_EACH_ROW_WITH_A_SUPERVISOR: 'THEN_SELECT_EACH_ROW_WITH_A_SUPERVISOR',
    CHECK_THAT_THE_FOLLOWING_PREVIEW_IS_CORRECT: 'CHECK_THAT_THE_FOLLOWING_PREVIEW_IS_CORRECT',
    IMPORT_SUCCESSFUL: 'IMPORT_SUCCESSFUL',
    IMPORT_FAILED_PLEASE_CONTACT_US_FOR_HELP: 'IMPORT_FAILED_PLEASE_CONTACT_US_FOR_HELP',
    FILE_UPLOAD_WAS_NOT_SUCCESSFUL_PLEASE_TRY_AGAIN: 'FILE_UPLOAD_WAS_NOT_SUCCESSFUL_PLEASE_TRY_AGAIN',
    NOTES: 'NOTES',
    COURSE_TITLE: 'COURSE_TITLE',
    SALARY_SOURCE: 'SALARY_SOURCE',
    GRANT_SOURCE: 'GRANT_SOURCE',
    STUDENT: 'STUDENT',
    STATUS_OF_THE_PHD_PROJECT: 'STATUS_OF_THE_PHD_PROJECT',
    LATEST_REPORT: 'LATEST_REPORT',
    TIME_SPENT_ON_PHD: 'TIME_SPENT_ON_PHD',
    SOCIAL_IMPACT_AND_PUBLIC_OUTREACH: 'SOCIAL_IMPACT_AND_PUBLIC_OUTREACH',
    ATTACHMENTS: 'ATTACHMENTS',
    THREE_POSITIVE_THINGS: 'THREE_POSITIVE_THINGS',
    THREE_NEGATIVE_THINGS: 'THREE_NEGATIVE_THINGS',
    CAREER_PLANNING: 'CAREER_PLANNING',
    CONCLUSIONS: 'CONCLUSIONS',
    OTHER_WORK: 'OTHER_WORK',
    WAIT_FOR_ONE_MINUTE_BEFORE_RESENDING: 'WAIT_FOR_ONE_MINUTE_BEFORE_RESENDING',
    ACCOUNT_IS_CLOSED: 'ACCOUNT_IS_CLOSED',
    ACCOUNT_IS_ACTIVE: 'ACCOUNT_IS_ACTIVE',
    ACCOUNT_IS_INACTIVE: 'ACCOUNT_IS_INACTIVE',
    ESTIMATED_STATUS_OF_THE_PHD_PROJECT: 'ESTIMATED_STATUS_OF_THE_PHD_PROJECT',
    ESTIMATED_TIME_OF_PHD_DEFENCE: 'ESTIMATED_TIME_OF_PHD_DEFENCE',
    CAREER_PLANS_AFTER_YOUR_PHD: 'CAREER_PLANS_AFTER_YOUR_PHD',
    BACK_TO_OVERVIEW: 'BACK_TO_OVERVIEW',
    BACK_TO_REPORT: 'BACK_TO_REPORT',
    CHANGE_SUPERVISOR: 'CHANGE_SUPERVISOR',
    ADD_SUPERVISOR_FOR_NAME: 'ADD_SUPERVISOR_FOR_NAME',
    FAILED_TO_ADD_SUPERVISOR_PLEASE_TRY_AGAIN_OR: 'FAILED_TO_ADD_SUPERVISOR_PLEASE_TRY_AGAIN_OR',
    FAILED_TO_INVITE_SUPERVISOR_PLEASE_TRY_AGAIN_OR: 'FAILED_TO_INVITE_SUPERVISOR_PLEASE_TRY_AGAIN_OR',
    INVITE_SUPERVISOR_FOR_NAME: 'INVITE_SUPERVISOR_FOR_NAME',
    CHOOSE_LANGUAGE: 'CHOOSE_LANGUAGE',
    PREPARATION_AND_ANALYSIS: 'PREPARATION_AND_ANALYSIS',
    WRITING: 'WRITING',
    NAME_IS_NOT_YET_ON_THESSA_WHEN_THEY_SIGN_UP: 'NAME_IS_NOT_YET_ON_THESSA_WHEN_THEY_SIGN_UP',
    INVITE_THESIS_COMMITTEE: 'INVITE_THESIS_COMMITTEE',
    EDIT_THESIS_COMMITTEE: 'EDIT_THESIS_COMMITTEE',
    YOUR_USER_ACCOUNT_NEEDS_TO_BE_ACTIVATED: 'YOUR_USER_ACCOUNT_NEEDS_TO_BE_ACTIVATED',
    YOU_WILL_RECEIVE_AN_EMAIL_WHEN_YOUR_ACCOUNT: 'YOU_WILL_RECEIVE_AN_EMAIL_WHEN_YOUR_ACCOUNT',
    ESTIMATE_MADE_ON: 'ESTIMATE_MADE_ON',
    PHD_PROJECT_STATUS: 'PHD_PROJECT_STATUS',
    TIME_SPENT_PERIOD: 'TIME_SPENT_PERIOD',
    PRELIMINARY_TITLE_OF_DISSERTATION: 'PRELIMINARY_TITLE_OF_DISSERTATION',
    EDIT_PRELIMINARY_TITLE_OF_DISSERTATION: 'EDIT_PRELIMINARY_TITLE_OF_DISSERTATION',
    CREATE_PRELIMINARY_TITLE_OF_DISSERTATION: 'CREATE_PRELIMINARY_TITLE_OF_DISSERTATION',
    SUBJECT_OR_STUDENT: 'SUBJECT_OR_STUDENT',
    APPLICATION_SENT: 'APPLICATION_SENT',
    PLANNING_TO_APPLY: 'PLANNING_TO_APPLY',
    CREDITS_one: 'CREDITS_one',
    CREDITS_other: 'CREDITS_other',
    CR: 'CR',
    WHAT_WAS_DECIDED: 'WHAT_WAS_DECIDED',
    ROLE_NAME: 'ROLE_NAME',
    CHECK_REPORT_STATUS: 'CHECK_REPORT_STATUS',
    CHECK_SUPERVISION_PLAN_STATUS: 'CHECK_SUPERVISION_PLAN_STATUS',
    CHECK_NEXT_THESIS_COMMITTEE_MEETING_REPORT_STATUS: 'CHECK_NEXT_THESIS_COMMITTEE_MEETING_REPORT_STATUS',
    SEARCH_BY: 'SEARCH_BY',
    COMPLETE_THE_REPORT_FORM: 'COMPLETE_THE_REPORT_FORM',
    CONCLUSION_CAN_BE_WRITTER_AFTER: 'CONCLUSION_CAN_BE_WRITTER_AFTER',
    YES: 'YES',
    NO: 'NO',
    PLEASE_INVITE_TCMS_TO_THESSA: 'PLEASE_INVITE_TCMS_TO_THESSA',
    COORDINATOR_TOOLS: {
        MAIN_HEADING: 'COORDINATOR_TOOLS.MAIN_HEADING',
        HEADINGS: {
            MANAGE_USERS: 'COORDINATOR_TOOLS.HEADINGS.MANAGE_USERS',
            STATISTICS: 'COORDINATOR_TOOLS.HEADINGS.STATISTICS',
            OTHER: 'COORDINATOR_TOOLS.HEADINGS.OTHER'
        },
        TOOLS: {
            LATEST_REPORTS: 'COORDINATOR_TOOLS.TOOLS.LATEST_REPORTS',
            INCOMPLETE_REPORTS: 'COORDINATOR_TOOLS.TOOLS.INCOMPLETE_REPORTS',
            ADMIN_REPORT: 'COORDINATOR_TOOLS.TOOLS.ADMIN_REPORT',
            IMPORT_SUPERVISOR_RELATIONSHIPS: 'COORDINATOR_TOOLS.TOOLS.IMPORT_SUPERVISOR_RELATIONSHIPS'
        },
        DESCRIPTIONS: {
            DOCTORAL_CANDIDATES: 'COORDINATOR_TOOLS.DESCRIPTIONS.DOCTORAL_CANDIDATES',
            USERS: 'COORDINATOR_TOOLS.DESCRIPTIONS.USERS',
            REPORT_CONCLUSIONS_OVERVIEW: 'COORDINATOR_TOOLS.DESCRIPTIONS.REPORT_CONCLUSIONS_OVERVIEW',
            LATEST_REPORTS: 'COORDINATOR_TOOLS.DESCRIPTIONS.LATEST_REPORTS',
            INCOMPLETE_REPORTS: 'COORDINATOR_TOOLS.DESCRIPTIONS.INCOMPLETE_REPORTS',
            ADMIN_REPORT: 'COORDINATOR_TOOLS.DESCRIPTIONS.ADMIN_REPORT',
            IMPORT_SUPERVISOR_RELATIONSHIPS: 'COORDINATOR_TOOLS.DESCRIPTIONS.IMPORT_SUPERVISOR_RELATIONSHIPS'
        }
    },
    SHOW_ALL_DOCTORAL_CANDIDATES: 'SHOW_ALL_DOCTORAL_CANDIDATES',
    HIDE_INACTIVE_DOCTORAL_RESEARCHERS: 'HIDE_INACTIVE_DOCTORAL_RESEARCHERS',
    DOCTORAL_RESEARCHER_OVERVIEW: 'DOCTORAL_RESEARCHER_OVERVIEW',
    LAST_COMPLETED_REPORT: 'LAST_COMPLETED_REPORT',
    FILTER_DOCTORAL_RESEARCHERS: 'FILTER_DOCTORAL_RESEARCHERS',
    SUPERVISOR_RELATIONSHIP_OVERVIEW: {
        IF_MISSING: 'SUPERVISOR_RELATIONSHIP_OVERVIEW.IF_MISSING'
    },
    THESIS_COMMITTEE_MEMBERS: {
        SUPERVISORS_ARE_HANDLED_BY_OTHERS: 'THESIS_COMMITTEE_MEMBERS.SUPERVISORS_ARE_HANDLED_BY_OTHERS',
        LINK: 'THESIS_COMMITTEE_MEMBERS.LINK',
        LINK_TITLE: 'THESIS_COMMITTEE_MEMBERS.LINK_TITLE',
        INVITATION_HEADING: 'THESIS_COMMITTEE_MEMBERS.INVITATION_HEADING',
        INVITATION_HEADING_FOR_SUPERVISORS: 'THESIS_COMMITTEE_MEMBERS.INVITATION_HEADING_FOR_SUPERVISORS',
        INVITATION_LABEL: 'THESIS_COMMITTEE_MEMBERS.INVITATION_LABEL',
        INVITATION_LABEL_FOR_SUPERVISORS: 'THESIS_COMMITTEE_MEMBERS.INVITATION_LABEL_FOR_SUPERVISORS'
    },
    CONTACT: {
        HEADING: 'CONTACT.HEADING',
        CONTACT_TEXT_PREFIX: 'CONTACT.CONTACT_TEXT_PREFIX',
        CONTACT_TEXT_SUFFIX: 'CONTACT.CONTACT_TEXT_SUFFIX',
        UNIHELP_URL: 'CONTACT.UNIHELP_URL',
        UNIHELP_URL_TITLE: 'CONTACT.UNIHELP_URL_TITLE'
    },
    DATE_RANGE_PICKER: {
        INVALID_START_DATE: 'DATE_RANGE_PICKER.INVALID_START_DATE',
        INVALID_END_DATE: 'DATE_RANGE_PICKER.INVALID_END_DATE',
        INVALID_END_IS_BEFORE_START: 'DATE_RANGE_PICKER.INVALID_END_IS_BEFORE_START'
    },
    COORDINATOR_DOCTORAL_CANDIDATES: {
        PLACEHOLDER: 'COORDINATOR_DOCTORAL_CANDIDATES.PLACEHOLDER',
        LABEL: 'COORDINATOR_DOCTORAL_CANDIDATES.LABEL',
        ACTION: 'COORDINATOR_DOCTORAL_CANDIDATES.ACTION'
    },
    END_OF_SENTENCE_PERIOD: 'END_OF_SENTENCE_PERIOD',
    RESOURCES: {
        INTRO_VIDEO: 'RESOURCES.INTRO_VIDEO'
    },
    MENU: 'MENU',
    FRONTPAGE: 'FRONTPAGE',
    OPEN_PROFILE_MENU: 'OPEN_PROFILE_MENU',
    CLOSE_PROFILE_MENU: 'CLOSE_PROFILE_MENU',
    OPEN_MAIN_MENU: 'OPEN_MAIN_MENU',
    CLOSE_MAIN_MENU: 'CLOSE_MAIN_MENU',
    CHANGE_LANGUAGE: 'CHANGE_LANGUAGE',
    PROFILE_MENU: 'PROFILE_MENU',
    MAIN_MENU: 'MAIN_MENU',
    FOOTER_MENU: 'FOOTER_MENU',
    DATE_NOT_SPECIFIED: 'DATE_NOT_SPECIFIED',
    EMAIL_OR_USER_INPUT: {
        HINT: 'EMAIL_OR_USER_INPUT.HINT'
    },
    FORM: {
        REQUIRED_FIELD: 'FORM.REQUIRED_FIELD',
        OPTIONAL_FIELD: 'FORM.OPTIONAL_FIELD',
        VALID_EMAIL_ADDRESS_REQUIRED: 'FORM.VALID_EMAIL_ADDRESS_REQUIRED',
        PASSWORD_REQUIREMENTS: 'FORM.PASSWORD_REQUIREMENTS',
        VALID: 'FORM.VALID',
        INVALID: 'FORM.INVALID',
        OPTIONAL: 'FORM.OPTIONAL',
        COMPLETE_FIELDS_TO_SAVE_FORM: 'FORM.COMPLETE_FIELDS_TO_SAVE_FORM',
        COMPLETE_FIELDS_TO_SUBMIT_FORM: 'FORM.COMPLETE_FIELDS_TO_SUBMIT_FORM',
        CONFIRM_CANCEL: 'FORM.CONFIRM_CANCEL'
    },
    INVITATION_ROLE: {
        YOUR_ROLE: 'INVITATION_ROLE.YOUR_ROLE',
        COORDINATING_ACADEMIC: 'INVITATION_ROLE.COORDINATING_ACADEMIC',
        MAIN_SUPERVISOR: 'INVITATION_ROLE.MAIN_SUPERVISOR',
        SUPERVISOR: 'INVITATION_ROLE.SUPERVISOR',
        THESIS_COMMITTEE_MEMBER: 'INVITATION_ROLE.THESIS_COMMITTEE_MEMBER'
    },
    EDIT_PUBLICATION: 'EDIT_PUBLICATION',
    EDIT_SALARY: 'EDIT_SALARY',
    EDIT_GRANT: 'EDIT_GRANT',
    EDIT_COURSE_WORKSHOP: 'EDIT_COURSE_WORKSHOP',
    EDIT_THESIS_INSTRUCTION: 'EDIT_THESIS_INSTRUCTION',
    EDIT_TEACHING: 'EDIT_TEACHING',
    FOR_STUDENT: 'FOR_STUDENT',
    CREATE_NEW_REMINDER: 'CREATE_NEW_REMINDER',
    LOGO_OF_UNIVERSITY_OF_HELSINKI: 'LOGO_OF_UNIVERSITY_OF_HELSINKI',
    NEW: 'NEW',
    CHANGED: 'CHANGED',
    INDICATOR: 'INDICATOR',
    STATUS_IN_THE_MOST_RECENT: 'STATUS_IN_THE_MOST_RECENT',
    DETAILS_WITH_LABEL: 'DETAILS_WITH_LABEL',
    ADD_PUBLICATION: 'ADD_PUBLICATION',
    ADD_COURSE: 'ADD_COURSE',
    EDIT_NOTES: 'EDIT_NOTES',
    CANCEL_EDITING_NOTES: 'CANCEL_EDITING_NOTES',
    SAVE_NOTES: 'SAVE_NOTES',
    SEND_MESSAGE: 'SEND_MESSAGE',
    REMOVE_COMMENT: 'REMOVE_COMMENT',
    REPORT_VIEW: {
        ERROR: {
            MISSING_REPORT: 'REPORT_VIEW.ERROR.MISSING_REPORT',
            FAILED_TO_SAVE_REPORT: 'REPORT_VIEW.ERROR.FAILED_TO_SAVE_REPORT',
            FAILED_TO_SUBMIT_REPORT: 'REPORT_VIEW.ERROR.FAILED_TO_SUBMIT_REPORT',
            FAILED_TO_DELETE_REPORT: 'REPORT_VIEW.ERROR.FAILED_TO_DELETE_REPORT'
        }
    },
    PHD_PROJECT: {
        ERROR: {
            GENERAL_ERROR_HEADING: 'PHD_PROJECT.ERROR.GENERAL_ERROR_HEADING',
            YOU_CAN_RETRY_OR: 'PHD_PROJECT.ERROR.YOU_CAN_RETRY_OR',
            INCLUDE_THIS_TEXT: 'PHD_PROJECT.ERROR.INCLUDE_THIS_TEXT',
            CANNOT_INITIALIZE: 'PHD_PROJECT.ERROR.CANNOT_INITIALIZE'
        }
    },
    CANCEL_INVITING_THESIS_COMMITTEE_MEMBER: 'CANCEL_INVITING_THESIS_COMMITTEE_MEMBER',
    INFORMATION: 'INFORMATION',
    COMMENT: 'COMMENT',
    WRITE_YOUR_COMMENT_HERE: 'WRITE_YOUR_COMMENT_HERE',
    HIDE_DISCUSSION: 'HIDE_DISCUSSION',
    SHOW_DISCUSSION: 'SHOW_DISCUSSION',
    VIEW_SUPERVISION_PLAN: 'VIEW_SUPERVISION_PLAN',
    ADD_COURSE_WORKSHOP: 'ADD_COURSE_WORKSHOP',
    ADD_THESIS_INSTRUCTION: 'ADD_THESIS_INSTRUCTION',
    UNTITLED: 'UNTITLED',
    UNTITLED_PUBLICATION: 'UNTITLED_PUBLICATION',
    UNTITLED_SALARY: 'UNTITLED_SALARY',
    UNTITLED_GRANT: 'UNTITLED_GRANT',
    UNTITLED_TEACHING: 'UNTITLED_TEACHING',
    REMOVAL_CONFIRMATION: 'REMOVAL_CONFIRMATION',
    THESSA_INTRODUCTION_VIDEO: 'THESSA_INTRODUCTION_VIDEO',
    ACCESSIBILITY_STATEMENT: 'ACCESSIBILITY_STATEMENT',
    INFORMATION_ON_THE_ACCESSIBILITY_OF_THE_WEBSITE: 'INFORMATION_ON_THE_ACCESSIBILITY_OF_THE_WEBSITE',
    LAST_UPDATED: 'LAST_UPDATED',
    YOU_WILL_NOT_BE_ABLE_TO_ACCESS: 'YOU_WILL_NOT_BE_ABLE_TO_ACCESS',
    REQUEST_ACCOUNT_REACTIVATION: 'REQUEST_ACCOUNT_REACTIVATION',
    REMINDER: 'REMINDER',
    BACK_TO_STATISTICS: 'BACK_TO_STATISTICS',
    BACK_TO_USER_DETAILS: 'BACK_TO_USER_DETAILS',
    FOR_EXAMPLE: 'FOR_EXAMPLE',
    DOWNLOAD: {
        DOWNLOAD: 'DOWNLOAD.DOWNLOAD',
        DOWNLOAD_CSV_FILE: 'DOWNLOAD.DOWNLOAD_CSV_FILE',
        DOWNLOAD_EXCEL_FILE: 'DOWNLOAD.DOWNLOAD_EXCEL_FILE'
    },
    PLEASE_SELECT_ONE_OF_THE_FOLLOWING_TYPES: 'PLEASE_SELECT_ONE_OF_THE_FOLLOWING_TYPES',
    PLEASE_SELECT_YOUR_ROLE_IN_THE_CONFERENCE: 'PLEASE_SELECT_YOUR_ROLE_IN_THE_CONFERENCE',
    PLEASE_NOTE_YOU_HAVE_THE_OPTION_TO_SAVE: 'PLEASE_NOTE_YOU_HAVE_THE_OPTION_TO_SAVE',
    DURATION_OF_TEACHING: 'DURATION_OF_TEACHING',
    CURRENT: 'CURRENT',
    UPCOMING: 'UPCOMING',
    SITEMAP: 'SITEMAP',
    UPON_LOGGING_IN: 'UPON_LOGGING_IN',
    OVERVIEW_OF_ALL_SITE_PAGES: 'OVERVIEW_OF_ALL_SITE_PAGES',
    UPDATED: 'UPDATED',
    PLEASE_FILL_OUT_ALL_REQUIRED_FIELDS: 'PLEASE_FILL_OUT_ALL_REQUIRED_FIELDS',
    PLEASE_FILL_OUT_ALL_REQUIRED_FIELDS_AND_DATES: 'PLEASE_FILL_OUT_ALL_REQUIRED_FIELDS_AND_DATES',
    PLEASE_ENTER_VALID_DATES: 'PLEASE_ENTER_VALID_DATES',
    IS_MISSING: 'IS_MISSING',
    THE_VALUE_ENTERED_IS_INVALID: 'THE_VALUE_ENTERED_IS_INVALID',
    CLOSE: 'CLOSE',
    CHOOSE: 'CHOOSE',
    SUBMITTING_FORM_FAILED: 'SUBMITTING_FORM_FAILED',
    TRANSCRIPT_OF_THESSA_INTRODUCTION_VIDEO: 'TRANSCRIPT_OF_THESSA_INTRODUCTION_VIDEO',
    INTRODUCTION_TO_USING_THESSA_FOR_DOCTORAL: 'INTRODUCTION_TO_USING_THESSA_FOR_DOCTORAL',
    CHOOSE_LANGUAGE_FROM_THE_LANGUAGE_NAVIGATION: 'CHOOSE_LANGUAGE_FROM_THE_LANGUAGE_NAVIGATION',
    AFTER_LOGGING_IN: 'AFTER_LOGGING_IN',
    PLANS_FOR_YOUR_PHD_PROJECT: 'PLANS_FOR_YOUR_PHD_PROJECT',
    SUPERVISION_PLANS_ARE_CREATED_BY_YOUR_SUPERVISORS: 'SUPERVISION_PLANS_ARE_CREATED_BY_YOUR_SUPERVISORS',
    PLANS_FOR_YOUR_PHD_PROJECT_ARE_CREATED_BY_YOU: 'PLANS_FOR_YOUR_PHD_PROJECT_ARE_CREATED_BY_YOU',
    REPORTS_ARE_CREATED_BY_YOU_AND_INCLUDE_INFORMATION: 'REPORTS_ARE_CREATED_BY_YOU_AND_INCLUDE_INFORMATION',
    YOUR_SUPERVISORS_ARE_ADDED_AUTOMATICALLY: 'YOUR_SUPERVISORS_ARE_ADDED_AUTOMATICALLY',
    YOU_CAN_SEE_INFORMATION_ABOUT_YOUR_THESIS_COMMITTEE: 'YOU_CAN_SEE_INFORMATION_ABOUT_YOUR_THESIS_COMMITTEE',
    DIGITAL_SERVICE_ACCESSIBILITY_STATUS: 'DIGITAL_SERVICE_ACCESSIBILITY_STATUS',
    GENERAL_SECTIONS_AND_FEATURES_THAT_ARE_NOT_ACCESSIBLE: 'GENERAL_SECTIONS_AND_FEATURES_THAT_ARE_NOT_ACCESSIBLE',
    SERVICES_FOR_DOCTORAL_RESEARCHERS_THAT_ARE_NOT_ACCESSIBLE: 'SERVICES_FOR_DOCTORAL_RESEARCHERS_THAT_ARE_NOT_ACCESSIBLE',
    SERVICES_FOR_SUPERVISORS_THAT_ARE_NOT_ACCESSIBLE: 'SERVICES_FOR_SUPERVISORS_THAT_ARE_NOT_ACCESSIBLE',
    SERVICES_FOR_COORDINATORS_THAT_ARE_NOT_ACCESSIBLE: 'SERVICES_FOR_COORDINATORS_THAT_ARE_NOT_ACCESSIBLE',
    NOT_WITHIN_THE_SCOPE_OF_LEGISLATION: 'NOT_WITHIN_THE_SCOPE_OF_LEGISLATION',
    ACCESSIBILITY_FEEDBACK: 'ACCESSIBILITY_FEEDBACK',
    SUPERVISORY_AUTHORITY: 'SUPERVISORY_AUTHORITY',
    CONTACT_INFORMATION_OF_THE_REGULATOR: 'CONTACT_INFORMATION_OF_THE_REGULATOR',
    REGULATOR: 'REGULATOR',
    ACCESSIBILITY_CONTROL_UNIT: 'ACCESSIBILITY_CONTROL_UNIT',
    TEL_SWITCHBOARD: 'TEL_SWITCHBOARD',
    PERCEIVABLE: 'PERCEIVABLE',
    OPERABLE: 'OPERABLE',
    UNDERSTANDABLE: 'UNDERSTANDABLE',
    ROBUST: 'ROBUST',
    ACCESSIBILITY_OF_THESSA: 'ACCESSIBILITY_OF_THESSA',
    THIS_ACCESSIBILITY_STATEMENT_APPLIES: 'THIS_ACCESSIBILITY_STATEMENT_APPLIES',
    THE_SERVICE_IS_SUBJECT_TO_THE_LAW: 'THE_SERVICE_IS_SUBJECT_TO_THE_LAW',
    THE_ACCESSIBILITY_STATEMENT_HAS_BEEN_CREATED_ON: 'THE_ACCESSIBILITY_STATEMENT_HAS_BEEN_CREATED_ON',
    INFO_AND_RELATIONSHIPS: 'INFO_AND_RELATIONSHIPS',
    ERROR_IDENTIFICATION: 'ERROR_IDENTIFICATION',
    ON_INPUT: 'ON_INPUT',
    TIMING_ADJUSTABLE: 'TIMING_ADJUSTABLE',
    USE_OF_COLOR: 'USE_OF_COLOR',
    CONTRAST_MINIMUM: 'CONTRAST_MINIMUM',
    PARSING: 'PARSING',
    NAME_ROLE_VALUE: 'NAME_ROLE_VALUE',
    STATUS_MESSAGES: 'STATUS_MESSAGES',
    THE_THESSA_SERVICE_OF_THE_UNIVERSITY_OF_HELSINKI_MEETS: 'THE_THESSA_SERVICE_OF_THE_UNIVERSITY_OF_HELSINKI_MEETS',
    DATA_TABLES_ARE_NOT_PROGRAMMATICALLY_DISPLAYED: 'DATA_TABLES_ARE_NOT_PROGRAMMATICALLY_DISPLAYED',
    THE_INFORMATION_ON_THE_CONFERENCES_AND_MOBILITY: 'THE_INFORMATION_ON_THE_CONFERENCES_AND_MOBILITY',
    FORMS_DO_NOT_SUFFICIENTLY_GUIDE_USERS_ON_INCORRECT: 'FORMS_DO_NOT_SUFFICIENTLY_GUIDE_USERS_ON_INCORRECT',
    THE_SUBMISSION_BUTTONS_IN_THE_FORMS_FOR_SUPERVISION: 'THE_SUBMISSION_BUTTONS_IN_THE_FORMS_FOR_SUPERVISION',
    THE_INFORMATION_ON_THE_MY_DOCTORAL_THESIS_PAGE: 'THE_INFORMATION_ON_THE_MY_DOCTORAL_THESIS_PAGE',
    A_FORM_DOES_NOT_DISPLAY_THE_SUBMISSION_BUTTON: 'A_FORM_DOES_NOT_DISPLAY_THE_SUBMISSION_BUTTON',
    THE_SUBMISSION_BUTTON_FOR_THE_PROGRESS_FEEDBACK: 'THE_SUBMISSION_BUTTON_FOR_THE_PROGRESS_FEEDBACK',
    TITLES_HAVE_NOT_BEEN_USED_TO_PARSE_CONTENT: 'TITLES_HAVE_NOT_BEEN_USED_TO_PARSE_CONTENT',
    THE_TITLES_ON_THE_OVERVIEW_OF_CONCLUDING_STATEMENTS: 'THE_TITLES_ON_THE_OVERVIEW_OF_CONCLUDING_STATEMENTS',
    THE_DISTINCTIVENESS_OF_LINKS_FROM_OTHER_TEXT_AND_FOCUS: 'THE_DISTINCTIVENESS_OF_LINKS_FROM_OTHER_TEXT_AND_FOCUS',
    IN_THE_COORDINATOR_SERVICES_THE_DISTINCTIVENESS: 'IN_THE_COORDINATOR_SERVICES_THE_DISTINCTIVENESS',
    THE_CONTRAST_RATIO_OF_TEXT_ELEMENTS_COMPARED: 'THE_CONTRAST_RATIO_OF_TEXT_ELEMENTS_COMPARED',
    THE_CONTRAST_RATIO_OF_TEXT_ELEMENTS_ON_THE: 'THE_CONTRAST_RATIO_OF_TEXT_ELEMENTS_ON_THE',
    THE_SUBMISSION_BUTTON_IN_THE_FORM_FOR_ADDING_SUPERVISORS: 'THE_SUBMISSION_BUTTON_IN_THE_FORM_FOR_ADDING_SUPERVISORS',
    BUTTONS_HAVE_NO_VISIBLE_OR_PROGRAMMATIC_TEXT: 'BUTTONS_HAVE_NO_VISIBLE_OR_PROGRAMMATIC_TEXT',
    THE_SUPERVISOR_FORM_ON_THE_DOCTORAL_RESEARCHERS_PAGE: 'THE_SUPERVISOR_FORM_ON_THE_DOCTORAL_RESEARCHERS_PAGE',
    SCREEN_READERS_DO_NOT_AUTOMATICALLY: 'SCREEN_READERS_DO_NOT_AUTOMATICALLY',
    ON_THE_DOCTORAL_RESEARCHERS_AND_LIST_THE_REVIEWERS: 'ON_THE_DOCTORAL_RESEARCHERS_AND_LIST_THE_REVIEWERS',
    NOT_COVERED_BY_LEGISLATION: 'NOT_COVERED_BY_LEGISLATION',
    CONTENT_PUBLISHED_BY_USERS_OR_OTHER_THIRD_PARTIES: 'CONTENT_PUBLISHED_BY_USERS_OR_OTHER_THIRD_PARTIES',
    CONTENT_PUBLISHED_BY_USERS_THAT_CANNOT: 'CONTENT_PUBLISHED_BY_USERS_THAT_CANNOT',
    THE_USER_IS_LOGGED_OUT_AUTOMATICALLY_WHEN_THE_SESSION: 'THE_USER_IS_LOGGED_OUT_AUTOMATICALLY_WHEN_THE_SESSION',
    THE_WEBSITE_LOGS_THE_USER_OUT_AUTOMATICALLY_WHEN: 'THE_WEBSITE_LOGS_THE_USER_OUT_AUTOMATICALLY_WHEN',
    DID_YOU_NOTICE_AN_ACCESSIBILITY_ISSUE_IN: 'DID_YOU_NOTICE_AN_ACCESSIBILITY_ISSUE_IN',
    IF_YOU_NOTICE_ACCESSIBILITY_ISSUES_ON: 'IF_YOU_NOTICE_ACCESSIBILITY_ISSUES_ON',
    PAGINATION: 'PAGINATION',
    GO_TO_PAGE: 'GO_TO_PAGE',
    AMOUNT_OF_ITEMS_PER_PAGE: 'AMOUNT_OF_ITEMS_PER_PAGE',
    THERE_WAS_AN_ERROR_IN_LOADING_SUPERVISION_PLANS: 'THERE_WAS_AN_ERROR_IN_LOADING_SUPERVISION_PLANS',
    PHD_PROJECT_LIST: {
        ERROR_DELETE_FAILED: 'PHD_PROJECT_LIST.ERROR_DELETE_FAILED'
    },
    CAREER_COUNSELLING: {
        OPEN_CAREER_COUNSELLING: 'CAREER_COUNSELLING.OPEN_CAREER_COUNSELLING',
        TITLE: 'CAREER_COUNSELLING.TITLE',
        INITIAL_PHASE: {
            TITLE: 'CAREER_COUNSELLING.INITIAL_PHASE.TITLE',
            MOTIVATION_AND_GOALS: 'CAREER_COUNSELLING.INITIAL_PHASE.MOTIVATION_AND_GOALS',
            INTEGRATION_INTO_THE_ACADEMIC_COMMUNITY: 'CAREER_COUNSELLING.INITIAL_PHASE.INTEGRATION_INTO_THE_ACADEMIC_COMMUNITY',
            MY_COMMUNITY_AND_FUTURE: 'CAREER_COUNSELLING.INITIAL_PHASE.MY_COMMUNITY_AND_FUTURE'
        },
        MIDDLE_PHASE: {
            TITLE: 'CAREER_COUNSELLING.MIDDLE_PHASE.TITLE',
            MOTIVATION_AND_GOALS: 'CAREER_COUNSELLING.MIDDLE_PHASE.MOTIVATION_AND_GOALS',
            SKILLS_AND_DEVELOPMENT_NEEDS: 'CAREER_COUNSELLING.MIDDLE_PHASE.SKILLS_AND_DEVELOPMENT_NEEDS',
            MY_COMMUNITY_AND_FUTURE: 'CAREER_COUNSELLING.MIDDLE_PHASE.MY_COMMUNITY_AND_FUTURE'
        },
        FINAL_PHASE: {
            TITLE: 'CAREER_COUNSELLING.FINAL_PHASE.TITLE',
            MY_SKILLS_AND_STRENGTHS: 'CAREER_COUNSELLING.FINAL_PHASE.MY_SKILLS_AND_STRENGTHS',
            MY_COMMUNITY_AND_FUTURE: 'CAREER_COUNSELLING.FINAL_PHASE.MY_COMMUNITY_AND_FUTURE',
            PROFESSIONAL_LIFE_CAREER_PLANNING_AND_LIFESTYLE: 'CAREER_COUNSELLING.FINAL_PHASE.PROFESSIONAL_LIFE_CAREER_PLANNING_AND_LIFESTYLE'
        },
        ASSIGNMENT: {
            CONSIDER_QUESTIONS: 'CAREER_COUNSELLING.ASSIGNMENT.CONSIDER_QUESTIONS',
            THESIS_PHASE_BASED_ON_REPORT: 'CAREER_COUNSELLING.ASSIGNMENT.THESIS_PHASE_BASED_ON_REPORT',
            THESIS_PHASE: {
                INITIAL_PHASE: 'CAREER_COUNSELLING.ASSIGNMENT.THESIS_PHASE.INITIAL_PHASE',
                MIDDLE_PHASE: 'CAREER_COUNSELLING.ASSIGNMENT.THESIS_PHASE.MIDDLE_PHASE',
                FINAL_PHASE: 'CAREER_COUNSELLING.ASSIGNMENT.THESIS_PHASE.FINAL_PHASE'
            }
        }
    },
    THESIS_COMMITTEE: {
        BACK_TO_THESIS_COMMITTEE: 'THESIS_COMMITTEE.BACK_TO_THESIS_COMMITTEE',
        CHANGE_DATE: 'THESIS_COMMITTEE.CHANGE_DATE',
        CHOOSE_DATE: 'THESIS_COMMITTEE.CHOOSE_DATE',
        ADD: 'THESIS_COMMITTEE.ADD',
        NO_MEETINGS: 'THESIS_COMMITTEE.NO_MEETINGS',
        CHOOSE_FIRST_MEETING_DATE: 'THESIS_COMMITTEE.CHOOSE_FIRST_MEETING_DATE',
        CONTINUE_MEETING: 'THESIS_COMMITTEE.CONTINUE_MEETING',
        END_MEETING: 'THESIS_COMMITTEE.END_MEETING',
        END_MEETING_NOTIFICATION: 'THESIS_COMMITTEE.END_MEETING_NOTIFICATION',
        ERROR_MEETING_ALREADY_COMPLETED: 'THESIS_COMMITTEE.ERROR_MEETING_ALREADY_COMPLETED',
        ERROR_MISSING_DATE: 'THESIS_COMMITTEE.ERROR_MISSING_DATE',
        ERROR_REPORT_NOT_FOUND: 'THESIS_COMMITTEE.ERROR_REPORT_NOT_FOUND',
        FAST_DOCTORAL_CANDIDATE_MEETING_EVERY_N_MONTHS: 'THESIS_COMMITTEE.FAST_DOCTORAL_CANDIDATE_MEETING_EVERY_N_MONTHS',
        FIRST_MEETING: 'THESIS_COMMITTEE.FIRST_MEETING',
        MEETING: 'THESIS_COMMITTEE.MEETING',
        MEETINGS: 'THESIS_COMMITTEE.MEETINGS',
        THESIS_COMMITTEE_MEETINGS: 'THESIS_COMMITTEE.THESIS_COMMITTEE_MEETINGS',
        MEETING_AGENDA: 'THESIS_COMMITTEE.MEETING_AGENDA',
        MEETING_AGENDA_NOT_FOUND: 'THESIS_COMMITTEE.MEETING_AGENDA_NOT_FOUND',
        MEETING_COMPLETED_AT: 'THESIS_COMMITTEE.MEETING_COMPLETED_AT',
        MEETING_DATE: 'THESIS_COMMITTEE.MEETING_DATE',
        MEETING_DATE_IN_PAST: 'THESIS_COMMITTEE.MEETING_DATE_IN_PAST',
        MEETING_DATE_MISSING: 'THESIS_COMMITTEE.MEETING_DATE_MISSING',
        MEETING_EVERY_N_MONTHS: 'THESIS_COMMITTEE.MEETING_EVERY_N_MONTHS',
        MEETING_LATE_NOTIFICATION_FOR_COORDINATOR: 'THESIS_COMMITTEE.MEETING_LATE_NOTIFICATION_FOR_COORDINATOR',
        MEETING_LATE_NOTIFICATION_FOR_SUPERVISOR: 'THESIS_COMMITTEE.MEETING_LATE_NOTIFICATION_FOR_SUPERVISOR',
        MEETING_LATE_NOTIFICATION_FOR_DOCTORAL_CANDIDATE: 'THESIS_COMMITTEE.MEETING_LATE_NOTIFICATION_FOR_DOCTORAL_CANDIDATE',
        MEETING_LATE_NOTIFICATION_FOR_THESIS_COMMITTEE_MEMBERS: 'THESIS_COMMITTEE.MEETING_LATE_NOTIFICATION_FOR_THESIS_COMMITTEE_MEMBERS',
        MEETING_NOTES: 'THESIS_COMMITTEE.MEETING_NOTES',
        MEETING_NOTES_ALERT: 'THESIS_COMMITTEE.MEETING_NOTES_ALERT',
        MEETING_NOTES_INSTRUCTIONS: 'THESIS_COMMITTEE.MEETING_NOTES_INSTRUCTIONS',
        MEETING_PLANNED_FOR: 'THESIS_COMMITTEE.MEETING_PLANNED_FOR',
        MEETINGS_AND_REPORTS: 'THESIS_COMMITTEE.MEETINGS_AND_REPORTS',
        NEXT_MEETING_ON_DATE: 'THESIS_COMMITTEE.NEXT_MEETING_ON_DATE',
        NO_FIRST_MEETING_DATE_YET: 'THESIS_COMMITTEE.NO_FIRST_MEETING_DATE_YET',
        NO_NEXT_MEETING_DATE_YET: 'THESIS_COMMITTEE.NO_NEXT_MEETING_DATE_YET',
        NOT_SCHEDULED: 'THESIS_COMMITTEE.NOT_SCHEDULED',
        OPEN_REPORT_FOR_MEETING: 'THESIS_COMMITTEE.OPEN_REPORT_FOR_MEETING',
        REPORT_EVERY_N_MONTHS: 'THESIS_COMMITTEE.REPORT_EVERY_N_MONTHS',
        REPORT_FOR_MEETING: 'THESIS_COMMITTEE.REPORT_FOR_MEETING',
        REPORT_FOR_MEETING_MISSING: 'THESIS_COMMITTEE.REPORT_FOR_MEETING_MISSING',
        SET_MEETING_DATE: 'THESIS_COMMITTEE.SET_MEETING_DATE',
        SUBMIT_A_REPORT: 'THESIS_COMMITTEE.SUBMIT_A_REPORT',
        REPORT_FOR_MEETING_READY: 'THESIS_COMMITTEE.REPORT_FOR_MEETING_READY',
        NOTE_REPORT_SUBMISSION_DATE: 'THESIS_COMMITTEE.NOTE_REPORT_SUBMISSION_DATE',
        REPORT_WAS_DISCUSSED: 'THESIS_COMMITTEE.REPORT_WAS_DISCUSSED',
        START_MEETING: 'THESIS_COMMITTEE.START_MEETING',
        TITLE: 'THESIS_COMMITTEE.TITLE',
        VIEW: 'THESIS_COMMITTEE.VIEW',
        VIEW_MEETING: 'THESIS_COMMITTEE.VIEW_MEETING',
        ADDING_MEETING_FAILED_WITH_ERROR_CODE: 'THESIS_COMMITTEE.ADDING_MEETING_FAILED_WITH_ERROR_CODE',
        UPDATING_MEETING_FAILED_WITH_ERROR_CODE: 'THESIS_COMMITTEE.UPDATING_MEETING_FAILED_WITH_ERROR_CODE',
        DELETING_MEETING_FAILED_WITH_ERROR_CODE: 'THESIS_COMMITTEE.DELETING_MEETING_FAILED_WITH_ERROR_CODE',
        MOVING_MEETING_FAILED_WITH_ERROR_CODE: 'THESIS_COMMITTEE.MOVING_MEETING_FAILED_WITH_ERROR_CODE',
        PROGRESS_ESTIMATION_MISSING: 'THESIS_COMMITTEE.PROGRESS_ESTIMATION_MISSING',
        ESTIMATE_YOUR_PROGRESS: 'THESIS_COMMITTEE.ESTIMATE_YOUR_PROGRESS',
        PROGRESS_FASTER: 'THESIS_COMMITTEE.PROGRESS_FASTER',
        PROGRESS_EXPECTED: 'THESIS_COMMITTEE.PROGRESS_EXPECTED',
        PROGRESS_SLOWER: 'THESIS_COMMITTEE.PROGRESS_SLOWER',
        SUPPORT_FEEDBACK: 'THESIS_COMMITTEE.SUPPORT_FEEDBACK',
        CONFIRM_ENDING_MEETING_TITLE: 'THESIS_COMMITTEE.CONFIRM_ENDING_MEETING_TITLE',
        CONFIRM_ENDING_MEETING_OPTION: 'THESIS_COMMITTEE.CONFIRM_ENDING_MEETING_OPTION',
        MEETING_STATUS: 'THESIS_COMMITTEE.MEETING_STATUS',
        MEETING_DONE: 'THESIS_COMMITTEE.MEETING_DONE',
        MEETING_DRAFT: 'THESIS_COMMITTEE.MEETING_DRAFT'
    },
    ATTACHMENT: {
        TITLE: 'ATTACHMENT.TITLE',
        ADD: 'ATTACHMENT.ADD',
        ADD_NEW: 'ATTACHMENT.ADD_NEW',
        ADD_TO_REPORT_INFO: 'ATTACHMENT.ADD_TO_REPORT_INFO',
        REPORT_INFO: 'ATTACHMENT.REPORT_INFO',
        UPLOAD: 'ATTACHMENT.UPLOAD',
        UPLOADING: 'ATTACHMENT.UPLOADING',
        ADDING_ATTACHMENT_FAILED_WITH_ERROR_CODE: 'ATTACHMENT.ADDING_ATTACHMENT_FAILED_WITH_ERROR_CODE',
        DELETING_ATTACHMENT_FAILED_WITH_ERROR_CODE: 'ATTACHMENT.DELETING_ATTACHMENT_FAILED_WITH_ERROR_CODE',
        NO_ATTACHMENTS: 'ATTACHMENT.NO_ATTACHMENTS',
        FILE: 'ATTACHMENT.FILE',
        NAME: 'ATTACHMENT.NAME',
        DATE_ADDED: 'ATTACHMENT.DATE_ADDED',
        NOT_AVAILABLE: 'ATTACHMENT.NOT_AVAILABLE',
        SIZE: 'ATTACHMENT.SIZE',
        IN_REPORT: 'ATTACHMENT.IN_REPORT',
        REPORT_NOTICE: 'ATTACHMENT.REPORT_NOTICE',
        ALREADY_ATTACHED_TO_REPORT: 'ATTACHMENT.ALREADY_ATTACHED_TO_REPORT'
    },
    SUPERVISION_PLAN_TITLE_NO_END_DATE: 'SUPERVISION_PLAN_TITLE_NO_END_DATE',
    SUPERVISION_PLAN_HEAD_TITLE: 'SUPERVISION_PLAN_HEAD_TITLE',
    SUPERVISION_PLAN_HEAD_TITLE_NO_END_DATE: 'SUPERVISION_PLAN_HEAD_TITLE_NO_END_DATE',
    SUPERVISION_PLAN_EXPIRED_SHORT: 'SUPERVISION_PLAN_EXPIRED_SHORT',
    SUPERVISION_PLAN_IS_VALID_UNTIL_DATE: 'SUPERVISION_PLAN_IS_VALID_UNTIL_DATE',
    TO_UPLOAD_AN_EXCEL_FILE: 'TO_UPLOAD_AN_EXCEL_FILE',
    NEED_A_TEMPLATE_FOR_THE_EXCEL_FILE: 'NEED_A_TEMPLATE_FOR_THE_EXCEL_FILE',
    DOWNLOAD_THE_SAMPLE_EXCEL_FILE: 'DOWNLOAD_THE_SAMPLE_EXCEL_FILE',
    FILL_IN_THE_DATA: 'FILL_IN_THE_DATA',
    SAVE_AND_UPLOAD_THE_FILE: 'SAVE_AND_UPLOAD_THE_FILE',
    SAMPLE_EXCEL_FILE: 'SAMPLE_EXCEL_FILE',
    VALIDITY: 'VALIDITY',
    COPY_DECISIONS_TO_NEW_PLAN: 'COPY_DECISIONS_TO_NEW_PLAN',
    COPY_DECISIONS_FROM_A_PREVIOUS_PLAN: 'COPY_DECISIONS_FROM_A_PREVIOUS_PLAN',
    PREVIEW_OF_THE_SUPEVISION_PLAN_FOR: 'PREVIEW_OF_THE_SUPEVISION_PLAN_FOR',
    SELECT_A_PREVIOUS_SUPERVISION_PLAN_TO_COPY_FROM: 'SELECT_A_PREVIOUS_SUPERVISION_PLAN_TO_COPY_FROM',
    PLEASE_NOTE_THAT_SUPERVISION_PLANS_MAY_CONTAIN: 'PLEASE_NOTE_THAT_SUPERVISION_PLANS_MAY_CONTAIN',
    DOCTORAL_CANDIDATE_PARTICIPATES_IN_THE_DOCTORAL_EDUCATION_PILOT: 'DOCTORAL_CANDIDATE_PARTICIPATES_IN_THE_DOCTORAL_EDUCATION_PILOT',
    DOCTORAL_EDUCATION_PILOT_PARTICIPANT: 'DOCTORAL_EDUCATION_PILOT_PARTICIPANT',
    CHAPTER: 'CHAPTER',
    CHAPTERS: 'CHAPTERS',
    CHAPTERS_AND_MILESTONES: 'CHAPTERS_AND_MILESTONES',
    CURRENT_CHAPTER: 'CURRENT_CHAPTER',
    COMPLETED_CHAPTER: 'COMPLETED_CHAPTER',
    MILESTONE: 'MILESTONE',
    MILESTONES: 'MILESTONES',
    PERSONAL_MILESTONE: 'PERSONAL_MILESTONE',
    PERSONAL_MILESTONES: 'PERSONAL_MILESTONES',
    COMMON_MILESTONE: 'COMMON_MILESTONE',
    COMMON_MILESTONES: 'COMMON_MILESTONES',
    ADD_PERSONAL_MILESTONE: 'ADD_PERSONAL_MILESTONE',
    EDIT_PERSONAL_MILESTONE: 'EDIT_PERSONAL_MILESTONE',
    ADD_COMMON_MILESTONE: 'ADD_COMMON_MILESTONE',
    EDIT_COMMON_MILESTONE: 'EDIT_COMMON_MILESTONE',
    STARTING: 'STARTING',
    STARTED: 'STARTED',
    PLANNED: 'PLANNED',
    ESTIMATED: 'ESTIMATED',
    STARTED_FROM_GRANTING_STUDY_RIGHT: 'STARTED_FROM_GRANTING_STUDY_RIGHT',
    STARTED_AT_THE_THESIS_COMMITTEE_MEETING_HELD_ON: 'STARTED_AT_THE_THESIS_COMMITTEE_MEETING_HELD_ON',
    BEGIN_AT_THE_THESIS_COMMITTEE_MEETING_HELD_ON: 'BEGIN_AT_THE_THESIS_COMMITTEE_MEETING_HELD_ON',
    BEGIN_AT_THE_MEETING_ESTIMATED_TO_BE_HELD_ON: 'BEGIN_AT_THE_MEETING_ESTIMATED_TO_BE_HELD_ON',
    EACH_CHAPTER_REPRESENTS_THE_TIME_PERIOD: 'EACH_CHAPTER_REPRESENTS_THE_TIME_PERIOD',
    OVERVIEW: 'OVERVIEW',
    NO_MILESTONES_IN_THE_PLAN_FOR_THE_CHAPTER_YET: 'NO_MILESTONES_IN_THE_PLAN_FOR_THE_CHAPTER_YET',
    VIEW_CHAPTERS: 'VIEW_CHAPTERS',
    EDIT_MILESTONES: 'EDIT_MILESTONES',
    CUSTOM_MILESTONES_CREATED_BY_THE_USER: 'CUSTOM_MILESTONES_CREATED_BY_THE_USER',
    A_PREDEFINED_SET_OF_MILESTONES_THAT_MUST_BE_ASSIGNED: 'A_PREDEFINED_SET_OF_MILESTONES_THAT_MUST_BE_ASSIGNED',
    STUDY_RIGHT_GRANTED: 'STUDY_RIGHT_GRANTED',
    ADD_ITEM: 'ADD_ITEM',
    ITEM: 'ITEM',
    MILESTONE_DESCRIPTION: 'MILESTONE_DESCRIPTION',
    MOVE: 'MOVE',
    OPEN_CONTEXT_MENU: 'OPEN_CONTEXT_MENU',
    CONTEXT_MENU: 'CONTEXT_MENU',
    SET_AS_COMPLETED: 'SET_AS_COMPLETED',
    COMMON: 'COMMON',
    PERSONAL: 'PERSONAL',
    ADDING_MILESTONE_FAILED_WITH_ERROR_CODE: 'ADDING_MILESTONE_FAILED_WITH_ERROR_CODE',
    UPDATING_MILESTONE_FAILED_WITH_ERROR_CODE: 'UPDATING_MILESTONE_FAILED_WITH_ERROR_CODE',
    DELETING_MILESTONE_FAILED_WITH_ERROR_CODE: 'DELETING_MILESTONE_FAILED_WITH_ERROR_CODE',
    MOVING_MILESTONE_FAILED_WITH_ERROR_CODE: 'MOVING_MILESTONE_FAILED_WITH_ERROR_CODE',
    PRESSING_ENTER_ON_THE_KEYBOARD_WILL_ADD_THE_MILESTONE: 'PRESSING_ENTER_ON_THE_KEYBOARD_WILL_ADD_THE_MILESTONE',
    PRESSING_ENTER_ON_THE_KEYBOARD_WILL_SAVE_THE_MILESTONE: 'PRESSING_ENTER_ON_THE_KEYBOARD_WILL_SAVE_THE_MILESTONE',
    ALL_COMMON_MILESTONES_HAVE_BEEN_ASSIGNED_TO_CHAPTERS: 'ALL_COMMON_MILESTONES_HAVE_BEEN_ASSIGNED_TO_CHAPTERS',
    NO_COMMON_MILESTONES_AVAILABLE: 'NO_COMMON_MILESTONES_AVAILABLE',
    INPUT_EXCEEDS_THE_CHARACTER_LIMIT: 'INPUT_EXCEEDS_THE_CHARACTER_LIMIT',
    FILE_INPUT_EXCEEDS_THE_FILE_SIZE_LIMIT: 'FILE_INPUT_EXCEEDS_THE_FILE_SIZE_LIMIT',
    UNASSIGNED_COMMON_MILESTONES: 'UNASSIGNED_COMMON_MILESTONES',
    UNASSIGNED_COMMON_MILESTONES_AMOUNT: 'UNASSIGNED_COMMON_MILESTONES_AMOUNT',
    MOVE_TO_NEXT_CHAPTER: 'MOVE_TO_NEXT_CHAPTER',
    MOVE_TO_PREVIOUS_CHAPTER: 'MOVE_TO_PREVIOUS_CHAPTER',
    RETURN: 'RETURN',
    USE_OF_GENERATIVE_ARTIFICIAL_INTELLIGENCE_IN_RESEARCH: 'USE_OF_GENERATIVE_ARTIFICIAL_INTELLIGENCE_IN_RESEARCH',
    AI_RESEARCH: 'AI_RESEARCH',
    ARTIFICIAL_INTELLIGENCE_AI_SCIENCE: 'ARTIFICIAL_INTELLIGENCE_AI_SCIENCE',
    IS_IN_PILOT: 'IS_IN_PILOT',
    LATEST_PROGRESS_ESTIMATION: 'LATEST_PROGRESS_ESTIMATION',
    NO_ACTIVE_STUDY_RIGHT: 'NO_ACTIVE_STUDY_RIGHT',
    CONSORTIUM: 'CONSORTIUM',
    NEXT_STEPS: {
        TITLE: 'NEXT_STEPS.TITLE',
        INTRO: {
            CYCLIC: 'NEXT_STEPS.INTRO.CYCLIC',
            FAST: 'NEXT_STEPS.INTRO.FAST',
            LEGACY: 'NEXT_STEPS.INTRO.LEGACY'
        },
        TIMING: {
            SUBMISSION_WINDOW: 'NEXT_STEPS.TIMING.SUBMISSION_WINDOW',
            SUBMISSION_WINDOW_OBSERVER: 'NEXT_STEPS.TIMING.SUBMISSION_WINDOW_OBSERVER',
            MEETING_DATE: 'NEXT_STEPS.TIMING.MEETING_DATE',
            REPORT_DEADLINE: 'NEXT_STEPS.TIMING.REPORT_DEADLINE',
            REPORT_DEADLINE_OBSERVER: 'NEXT_STEPS.TIMING.REPORT_DEADLINE_OBSERVER',
            REPORT_BEFORE_MEETING: 'NEXT_STEPS.TIMING.REPORT_BEFORE_MEETING',
            REPORT_BEFORE_MEETING_OBSERVER: 'NEXT_STEPS.TIMING.REPORT_BEFORE_MEETING_OBSERVER'
        },
        REPORT: {
            SUBMIT_STUDENT: 'NEXT_STEPS.REPORT.SUBMIT_STUDENT',
            SUBMIT_OBSERVER: 'NEXT_STEPS.REPORT.SUBMIT_OBSERVER',
            CONCLUSION_STUDENT: 'NEXT_STEPS.REPORT.CONCLUSION_STUDENT',
            CONCLUSION_OBSERVER: 'NEXT_STEPS.REPORT.CONCLUSION_OBSERVER',
            FEEDBACK_REMINDER: 'NEXT_STEPS.REPORT.FEEDBACK_REMINDER',
            SUBMIT_LABEL: 'NEXT_STEPS.REPORT.SUBMIT_LABEL',
            CONCLUSION_LABEL: 'NEXT_STEPS.REPORT.CONCLUSION_LABEL'
        },
        MEETING: {
            PLAN_STUDENT: 'NEXT_STEPS.MEETING.PLAN_STUDENT',
            PLAN_OBSERVER: 'NEXT_STEPS.MEETING.PLAN_OBSERVER',
            ATTEND_STUDENT: 'NEXT_STEPS.MEETING.ATTEND_STUDENT',
            ATTEND_OBSERVER: 'NEXT_STEPS.MEETING.ATTEND_OBSERVER',
            ATTEND_LATE_STUDENT: 'NEXT_STEPS.MEETING.ATTEND_LATE_STUDENT',
            ATTEND_LATE_OBSERVER: 'NEXT_STEPS.MEETING.ATTEND_LATE_OBSERVER',
            LATE_STUDENT: 'NEXT_STEPS.MEETING.LATE_STUDENT',
            LATE_OBSERVER: 'NEXT_STEPS.MEETING.LATE_OBSERVER',
            SCHEDULE_LABEL: 'NEXT_STEPS.MEETING.SCHEDULE_LABEL',
            ATTEND_LABEL: 'NEXT_STEPS.MEETING.ATTEND_LABEL'
        }
    },
    REPORTING: {
        TITLE: 'REPORTING.TITLE'
    },
    COURSE: {
        NOT_EDITABLE: 'COURSE.NOT_EDITABLE'
    }
};
var $8074e4b8ed096a9e$export$2e2bcd8739ae039 = $8074e4b8ed096a9e$var$keys;

});

parcelRegister("hSeA2", function(module, exports) {

$parcel$export(module.exports, "BRAND_MAIN", function () { return $d032ca20beb4d4bb$export$f91ee2a5d9fb6b1c; });
$parcel$export(module.exports, "BRAND_MAIN_LIGHT", function () { return $d032ca20beb4d4bb$export$c2228bd21983e9f8; });
$parcel$export(module.exports, "BRAND_MAIN_ACTIVE", function () { return $d032ca20beb4d4bb$export$5a69b9e5ec7bb927; });
$parcel$export(module.exports, "BRAND_MAIN_DARK", function () { return $d032ca20beb4d4bb$export$1e9f6d1d0a85a1e8; });
$parcel$export(module.exports, "BRAND_MAIN_NEARLY_BLACK", function () { return $d032ca20beb4d4bb$export$eac2eb09a9bdc057; });
$parcel$export(module.exports, "LINK_BLUE", function () { return $d032ca20beb4d4bb$export$704882cb521e782; });
$parcel$export(module.exports, "GRAYSCALE_WHITE", function () { return $d032ca20beb4d4bb$export$4380fb2405d85d10; });
$parcel$export(module.exports, "GRAYSCALE_LIGHT", function () { return $d032ca20beb4d4bb$export$132f324942976c63; });
$parcel$export(module.exports, "GRAYSCALE_MEDIUM", function () { return $d032ca20beb4d4bb$export$bb796ed5f8b8c955; });
$parcel$export(module.exports, "GRAYSCALE_MEDIUM_TEXT", function () { return $d032ca20beb4d4bb$export$e4420f6e7fa30ba9; });
$parcel$export(module.exports, "GRAYSCALE_BACKGROUND_BOX", function () { return $d032ca20beb4d4bb$export$e5a7939e9cd2a45a; });
$parcel$export(module.exports, "GRAYSCALE_MEDIUM_DARK", function () { return $d032ca20beb4d4bb$export$2c21af7a28e31ee5; });
$parcel$export(module.exports, "GRAYSCALE_DARK", function () { return $d032ca20beb4d4bb$export$d4fe340741564eed; });
$parcel$export(module.exports, "GRAYSCALE_DARK_TEXT", function () { return $d032ca20beb4d4bb$export$19486e4809691c69; });
$parcel$export(module.exports, "GRAYSCALE_BLACK", function () { return $d032ca20beb4d4bb$export$e1d1640e699d724b; });
$parcel$export(module.exports, "ADDITIONAL_RED_SOFT", function () { return $d032ca20beb4d4bb$export$a749b83af77aa9b7; });
$parcel$export(module.exports, "ADDITIONAL_RED", function () { return $d032ca20beb4d4bb$export$60e5a2938d372d83; });
$parcel$export(module.exports, "ADDITIONAL_RED_DARK", function () { return $d032ca20beb4d4bb$export$f9b5ae95886265f5; });
$parcel$export(module.exports, "ADDITIONAL_YELLOW", function () { return $d032ca20beb4d4bb$export$2424939be8812040; });
$parcel$export(module.exports, "ADDITIONAL_YELLOW_MEDIUM_DARK", function () { return $d032ca20beb4d4bb$export$6e8ab66afbfe26d9; });
$parcel$export(module.exports, "ADDITIONAL_YELLOW_DARK", function () { return $d032ca20beb4d4bb$export$a718e8d9c1c7ff30; });
$parcel$export(module.exports, "ADDITIONAL_SKYBLUE", function () { return $d032ca20beb4d4bb$export$a5daf9a41e416668; });
$parcel$export(module.exports, "ADDITIONAL_BLUE_SOFT", function () { return $d032ca20beb4d4bb$export$58afa197fea2a06e; });
$parcel$export(module.exports, "ADDITIONAL_BLUE", function () { return $d032ca20beb4d4bb$export$4f3e7d3e3b550cce; });
$parcel$export(module.exports, "ADDITIONAL_ORANGE", function () { return $d032ca20beb4d4bb$export$5b35761e97934fbc; });
$parcel$export(module.exports, "ADDITIONAL_GREEN_BRIGHT", function () { return $d032ca20beb4d4bb$export$957b72d3a92b02a1; });
$parcel$export(module.exports, "ADDITIONAL_GREEN_DARK", function () { return $d032ca20beb4d4bb$export$dafcf13a8c30ab4b; });
const $d032ca20beb4d4bb$export$f91ee2a5d9fb6b1c = '#0e688b';
const $d032ca20beb4d4bb$export$835ef0dd6a3e3ef5 = '#b1e7ff';
const $d032ca20beb4d4bb$export$26dda72472a4914a = '#48c5f8';
const $d032ca20beb4d4bb$export$c2228bd21983e9f8 = '#107eab';
const $d032ca20beb4d4bb$export$5a69b9e5ec7bb927 = '#005379';
const $d032ca20beb4d4bb$export$1e9f6d1d0a85a1e8 = '#003146';
const $d032ca20beb4d4bb$export$eac2eb09a9bdc057 = '#000222';
const $d032ca20beb4d4bb$export$704882cb521e782 = '#0479a4';
const $d032ca20beb4d4bb$export$9fa4b1d7e0cd74bf = '#767676';
const $d032ca20beb4d4bb$export$4380fb2405d85d10 = '#fff';
const $d032ca20beb4d4bb$export$39a1f25712969f23 = '#fefefe';
const $d032ca20beb4d4bb$export$132f324942976c63 = '#f8f8f8';
const $d032ca20beb4d4bb$export$bb796ed5f8b8c955 = '#d2d2d2';
const $d032ca20beb4d4bb$export$e4420f6e7fa30ba9 = '#757575';
const $d032ca20beb4d4bb$export$e5a7939e9cd2a45a = '#f5f5f5';
const $d032ca20beb4d4bb$export$20504c67c02fa78a = '#e6e6e6';
const $d032ca20beb4d4bb$export$cd2953ad9dc65423 = '#dfdfdf';
const $d032ca20beb4d4bb$export$2c21af7a28e31ee5 = '#979797';
const $d032ca20beb4d4bb$export$d4fe340741564eed = '#555555';
const $d032ca20beb4d4bb$export$19486e4809691c69 = '#222222';
const $d032ca20beb4d4bb$export$e1d1640e699d724b = '#000000';
const $d032ca20beb4d4bb$export$a749b83af77aa9b7 = '#ff6b76';
const $d032ca20beb4d4bb$export$2e728ca29d41c615 = '#e5053a';
const $d032ca20beb4d4bb$export$60e5a2938d372d83 = '#EB0010';
const $d032ca20beb4d4bb$export$f9b5ae95886265f5 = '#a31621';
const $d032ca20beb4d4bb$export$228c95ac5ea648c8 = '#420039';
const $d032ca20beb4d4bb$export$2424939be8812040 = '#f9a21a';
const $d032ca20beb4d4bb$export$6e8ab66afbfe26d9 = '#D18305';
const $d032ca20beb4d4bb$export$a718e8d9c1c7ff30 = '#A66703';
const $d032ca20beb4d4bb$export$a5daf9a41e416668 = '#48c5f8';
const $d032ca20beb4d4bb$export$58afa197fea2a06e = '#eef2fa';
const $d032ca20beb4d4bb$export$4f3e7d3e3b550cce = '#107eab';
const $d032ca20beb4d4bb$export$b8e08781b7ad0443 = '#005379';
const $d032ca20beb4d4bb$export$dadfec73ee89d67f = '#ffedb4';
const $d032ca20beb4d4bb$export$5b35761e97934fbc = '#d14600';
const $d032ca20beb4d4bb$export$945cb0972de50b6b = '#963800';
const $d032ca20beb4d4bb$export$148ed6796cfb4400 = '#d9ffd2';
const $d032ca20beb4d4bb$export$957b72d3a92b02a1 = '#83e172';
const $d032ca20beb4d4bb$export$1a375c7ba28aad42 = '#96ba3c';
const $d032ca20beb4d4bb$export$dafcf13a8c30ab4b = '#006400';
const $d032ca20beb4d4bb$export$b9c1f8754e85cf42 = '#eaeaea';

});

parcelRegister("eUJ8V", function(module, exports) {

$parcel$export(module.exports, "UniContainer", function () { return $adb95018f8251d9a$export$427dca1fc70150e2; });

var $3da5u = parcelRequire("3da5u");

var $1Hynf = parcelRequire("1Hynf");

var $hSeA2 = parcelRequire("hSeA2");
const $adb95018f8251d9a$export$427dca1fc70150e2 = (0, $3da5u.default).div`
  margin: 0 auto;
  width: 100%;
  max-width: 1216px;
  transition-duration: 0.1s;
  transition-property: all;

  ${({ $borderTop: $borderTop = false })=>$borderTop && (0, $3da5u.css)`
      border-top: 1px solid ${0, $hSeA2.GRAYSCALE_MEDIUM};
    `}

  ${({ $borderBottom: $borderBottom = false })=>$borderBottom && (0, $3da5u.css)`
      border-bottom: 1px solid ${0, $hSeA2.GRAYSCALE_MEDIUM};
    `}

  ${({ $border: $border = false })=>$border && (0, $3da5u.css)`
      border: 1px solid ${0, $hSeA2.GRAYSCALE_MEDIUM};
    `}

  ${({ $gray: $gray = false })=>$gray && (0, $3da5u.css)`
      background-color: ${0, $hSeA2.GRAYSCALE_LIGHT};
    `}

  ${({ $white: $white = false })=>$white && (0, $3da5u.css)`
      background-color: ${0, $hSeA2.GRAYSCALE_WHITE};
    `}

  ${({ $paddingTop: $paddingTop = false })=>$paddingTop && (0, $3da5u.css)`
      padding-top: 16px;

      ${(0, $1Hynf.fromTabletUp)((0, $3da5u.css)`
        padding-top: 32px;
      `)}
    `}

  ${({ $paddingBottom: $paddingBottom = false })=>$paddingBottom && (0, $3da5u.css)`
      padding-bottom: 16px;

      ${(0, $1Hynf.fromTabletUp)((0, $3da5u.css)`
        padding-bottom: 32px;
      `)}
    `}

  ${({ $paddingInline: $paddingInline = true })=>$paddingInline && (0, $3da5u.css)`
      padding-inline: 16px;

      ${(0, $1Hynf.fromTabletUp)((0, $3da5u.css)`
        padding-inline: 32px;
      `)}

      ${(0, $1Hynf.fromDesktopUp)((0, $3da5u.css)`
        padding-inline: 64px;
      `)}
    `}

  ${({ $marginBlock: $marginBlock = false })=>$marginBlock && (0, $3da5u.css)`
      margin-block: 32px;
    `}

  ${({ $wide: $wide = false })=>$wide && (0, $3da5u.css)`
      max-width: 1600px;
    `}

  ${({ $row: $row })=>$row && (0, $3da5u.css)`
      display: flex;
      flex-flow: row wrap;
    `}
`;

});
parcelRegister("1Hynf", function(module, exports) {

$parcel$export(module.exports, "LARGE_DESKTOP_MIN", function () { return $13d47887aa8dfc49$export$d5960ac5f5afd3d6; });
$parcel$export(module.exports, "DESKTOP_MIN", function () { return $13d47887aa8dfc49$export$abcc96a6a54dfce0; });
$parcel$export(module.exports, "TABLET_MAX", function () { return $13d47887aa8dfc49$export$35a11c2c96d3e66a; });
$parcel$export(module.exports, "TABLET_MIN", function () { return $13d47887aa8dfc49$export$cba32964746c8ff6; });
$parcel$export(module.exports, "PHONE_MAX", function () { return $13d47887aa8dfc49$export$d969f50274f45f0c; });
$parcel$export(module.exports, "maxTabletQuery", function () { return $13d47887aa8dfc49$export$174dbcd646c929f2; });
$parcel$export(module.exports, "fromPhoneUp", function () { return $13d47887aa8dfc49$export$d69956f20ee4db99; });
$parcel$export(module.exports, "fromTabletUp", function () { return $13d47887aa8dfc49$export$da5d1f5606ff04f6; });
$parcel$export(module.exports, "fromDesktopUp", function () { return $13d47887aa8dfc49$export$1bbab99a9023d62b; });
$parcel$export(module.exports, "fromLargeDesktopUp", function () { return $13d47887aa8dfc49$export$e6bbf3dee1e3267c; });
$parcel$export(module.exports, "wasUpdatedNow", function () { return $13d47887aa8dfc49$export$a958f0595cebb1df; });

var $3da5u = parcelRequire("3da5u");
const $13d47887aa8dfc49$export$d5960ac5f5afd3d6 = 1200;
const $13d47887aa8dfc49$export$abcc96a6a54dfce0 = 992;
const $13d47887aa8dfc49$export$35a11c2c96d3e66a = $13d47887aa8dfc49$export$abcc96a6a54dfce0 - 1;
const $13d47887aa8dfc49$export$cba32964746c8ff6 = 768;
const $13d47887aa8dfc49$export$d969f50274f45f0c = $13d47887aa8dfc49$export$cba32964746c8ff6 - 1;
const $13d47887aa8dfc49$export$5b2c8cf47eebea51 = 480;
function $13d47887aa8dfc49$export$174dbcd646c929f2(content) {
    return $13d47887aa8dfc49$var$maxQuery($13d47887aa8dfc49$export$35a11c2c96d3e66a, content);
}
function $13d47887aa8dfc49$var$maxQuery(maxWidth, content) {
    return (0, $3da5u.css)`
    @media screen and (max-width: ${maxWidth}px) {
      ${content}
    }
  `;
}
function $13d47887aa8dfc49$export$d69956f20ee4db99(content) {
    return $13d47887aa8dfc49$var$minQuery($13d47887aa8dfc49$export$5b2c8cf47eebea51, content);
}
function $13d47887aa8dfc49$export$da5d1f5606ff04f6(content) {
    return $13d47887aa8dfc49$var$minQuery($13d47887aa8dfc49$export$cba32964746c8ff6, content);
}
function $13d47887aa8dfc49$export$1bbab99a9023d62b(content) {
    return $13d47887aa8dfc49$var$minQuery($13d47887aa8dfc49$export$abcc96a6a54dfce0, content);
}
function $13d47887aa8dfc49$export$e6bbf3dee1e3267c(content) {
    return $13d47887aa8dfc49$var$minQuery($13d47887aa8dfc49$export$d5960ac5f5afd3d6, content);
}
function $13d47887aa8dfc49$var$minQuery(minWidth, content) {
    return (0, $3da5u.css)`
    @media screen and (min-width: ${minWidth}px) {
      ${content}
    }
  `;
}
function $13d47887aa8dfc49$export$a958f0595cebb1df(updated) {
    const animationKeyframes = (0, $3da5u.keyframes)`
    0% {
      box-shadow: inset 0 0 0 5px #fff;
    }
    
    5% {
      box-shadow: inset 0 0 0 5px #e9a500;
    }
    
    50% {
      box-shadow: inset 0 0 0 5px #e9a500;
    }
    
    100% {
      box-shadow: inset 0 0 0 5px #fff;
    }
  `;
    if (updated) return (0, $3da5u.css)`
      animation: ${animationKeyframes} linear 6s;
    `;
    return (0, $3da5u.css)``;
}

});


parcelRegister("bt0KQ", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_FONT", function () { return $8592fcfa301cd031$export$7d7a232b6d2cc80c; });

var $3da5u = parcelRequire("3da5u");
const $8592fcfa301cd031$export$7d7a232b6d2cc80c = (0, $3da5u.css)`
  font-family: 'Open Sans Variable', Helvetica, Arial, sans-serif;
`;

});

parcelRegister("jyFzD", function(module, exports) {

$parcel$export(module.exports, "sortByFunction", function () { return $e3d170f49c0103b7$export$cbaec1e340df7678; });
$parcel$export(module.exports, "isCreatingNewPlanItem", function () { return $e3d170f49c0103b7$export$6a749db4e81507e6; });
$parcel$export(module.exports, "useSessionStorage", function () { return $e3d170f49c0103b7$export$864b6828bd07eda6; });
$parcel$export(module.exports, "toString", function () { return $e3d170f49c0103b7$export$f84e8e69fd4488a5; });
$parcel$export(module.exports, "useAuthStatus", function () { return $e3d170f49c0103b7$export$bdf1f89fcedf9b32; });
$parcel$export(module.exports, "sortSupervisorRoles", function () { return $e3d170f49c0103b7$export$512e0e394448de79; });
$parcel$export(module.exports, "useTimeout", function () { return $e3d170f49c0103b7$export$d8e6abf214c9ec0f; });
$parcel$export(module.exports, "getLocalStorageValue", function () { return $e3d170f49c0103b7$export$2446c4ac5b624d37; });
$parcel$export(module.exports, "useLocalStorage", function () { return $e3d170f49c0103b7$export$86e2cef2561044ac; });
$parcel$export(module.exports, "useCurrentLanguage", function () { return $e3d170f49c0103b7$export$1b909bd880c93326; });
$parcel$export(module.exports, "onKeyboardClick", function () { return $e3d170f49c0103b7$export$33ee3e98d1dfc0d7; });
$parcel$export(module.exports, "getQueryParameters", function () { return $e3d170f49c0103b7$export$2c02b58bdf58d1c3; });
$parcel$export(module.exports, "useActionOutside", function () { return $e3d170f49c0103b7$export$65f7d00351849baa; });
$parcel$export(module.exports, "generateAccessibleColorFromString", function () { return $e3d170f49c0103b7$export$3cc1b93c69a38f3d; });
$parcel$export(module.exports, "useInterruptReloading", function () { return $e3d170f49c0103b7$export$2134cb3274e81080; });
$parcel$export(module.exports, "useWindowSize", function () { return $e3d170f49c0103b7$export$42c02f33970a2afa; });
$parcel$export(module.exports, "generatePageTitle", function () { return $e3d170f49c0103b7$export$b381ceb92f558884; });
$parcel$export(module.exports, "formatDate", function () { return $e3d170f49c0103b7$export$3ae94a2503e890a1; });
$parcel$export(module.exports, "hasExceededMaxLength", function () { return $e3d170f49c0103b7$export$dfe9a1f342cfde36; });
$parcel$export(module.exports, "isTextFieldValid", function () { return $e3d170f49c0103b7$export$7f23633464b2aee; });
$parcel$export(module.exports, "isNumericFieldValid", function () { return $e3d170f49c0103b7$export$266d0791b7dc739a; });
$parcel$export(module.exports, "isDateFieldValid", function () { return $e3d170f49c0103b7$export$6e1053bc7669a672; });
$parcel$export(module.exports, "isFileFieldValid", function () { return $e3d170f49c0103b7$export$9ba6dd97df0adfb6; });
$parcel$export(module.exports, "useMutationObserver", function () { return $e3d170f49c0103b7$export$8ecdcf3bb089e9cd; });
$parcel$export(module.exports, "sortByDate", function () { return $e3d170f49c0103b7$export$2830befb6f558677; });
$parcel$export(module.exports, "parseFileName", function () { return $e3d170f49c0103b7$export$90501ca74bad4dc4; });
$parcel$export(module.exports, "renameFile", function () { return $e3d170f49c0103b7$export$35956cb5939e0c69; });

var $2eqHs = parcelRequire("2eqHs");

var $5AAkb = parcelRequire("5AAkb");

var $jpgPw = parcelRequire("jpgPw");

var $78dMK = parcelRequire("78dMK");
function $e3d170f49c0103b7$var$useEventListener(eventName, handler, element) {
    const savedHandler = (0, $jpgPw.useRef)(null);
    (0, $jpgPw.useEffect)(()=>{
        const targetElement = element?.current || window;
        if (!(targetElement && targetElement.addEventListener)) return;
        if (savedHandler.current !== handler) savedHandler.current = handler;
        const eventListener = (event)=>{
            // eslint-disable-next-line no-extra-boolean-cast
            if (!!savedHandler?.current) savedHandler.current(event);
        };
        targetElement.addEventListener(eventName, eventListener);
        return ()=>{
            targetElement.removeEventListener(eventName, eventListener);
        };
    }, [
        eventName,
        element,
        handler
    ]);
}
function $e3d170f49c0103b7$export$cbaec1e340df7678(fieldName) {
    return function(itemA, itemB) {
        if (itemA[fieldName] < itemB[fieldName]) return -1;
        else if (itemA[fieldName] > itemB[fieldName]) return 1;
        return 0;
    };
}
const $e3d170f49c0103b7$export$6a749db4e81507e6 = (queryParameters)=>queryParameters.get('isNew') === 'true';
function $e3d170f49c0103b7$export$864b6828bd07eda6(key, defaultValue) {
    function getSessionStorageOrDefault(key, defaultValue) {
        try {
            const stored = sessionStorage.getItem(key);
            if (!stored) return defaultValue;
            return JSON.parse(stored);
        } catch  {
            return defaultValue;
        }
    }
    const [value, setValue] = (0, $jpgPw.useState)(getSessionStorageOrDefault(key, defaultValue));
    (0, $jpgPw.useEffect)(()=>{
        sessionStorage.setItem(key, JSON.stringify(value));
    }, [
        key,
        value
    ]);
    return [
        value,
        setValue
    ];
}
function $e3d170f49c0103b7$export$f84e8e69fd4488a5(value, separator = ', ') {
    return Array.isArray(value) ? value.join(`${separator}`) : value !== undefined ? `${value}` : '';
}
var $e3d170f49c0103b7$export$77c219755a7e3571;
(function(AuthStatus) {
    AuthStatus[AuthStatus["NotLoggedIn"] = 3] = "NotLoggedIn";
    AuthStatus[AuthStatus["NotRegistered"] = 4] = "NotRegistered";
    AuthStatus[AuthStatus["Closed"] = 6] = "Closed";
    AuthStatus[AuthStatus["LoggedIn"] = 2] = "LoggedIn";
})($e3d170f49c0103b7$export$77c219755a7e3571 || ($e3d170f49c0103b7$export$77c219755a7e3571 = {}));
function $e3d170f49c0103b7$export$bdf1f89fcedf9b32(authStatus) {
    const [status, setStatus] = (0, $jpgPw.useState)(()=>{
        let initialValue = null;
        const unsubscribe = authStatus.onValue((s)=>{
            initialValue = s;
        });
        unsubscribe();
        return initialValue;
    });
    (0, $jpgPw.useEffect)(()=>{
        const unsubscribe = authStatus.onValue((newStatus)=>setStatus(newStatus));
        return unsubscribe;
    }, []);
    return status;
}
const $e3d170f49c0103b7$var$supervisorRoles = [
    (0, $78dMK.SupervisorRole).CoordinatingAcademic,
    (0, $78dMK.SupervisorRole).MainSupervisor,
    (0, $78dMK.SupervisorRole).Supervisor
];
function $e3d170f49c0103b7$export$512e0e394448de79(roles) {
    roles.sort((roleA, roleB)=>{
        const roleAIndex = $e3d170f49c0103b7$var$supervisorRoles.indexOf(roleA);
        const roleBIndex = $e3d170f49c0103b7$var$supervisorRoles.indexOf(roleB);
        if (roleAIndex < roleBIndex) return -1;
        else if (roleAIndex > roleBIndex) return 1;
        return 0;
    });
    return roles;
}
function $e3d170f49c0103b7$export$d8e6abf214c9ec0f(callback, delay) {
    const savedCallback = (0, $jpgPw.useRef)(callback);
    (0, $jpgPw.useEffect)(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, $jpgPw.useEffect)(()=>{
        if (delay === null) return;
        const id = setTimeout(()=>savedCallback.current(), delay);
        return ()=>clearTimeout(id);
    }, [
        delay
    ]);
}
function $e3d170f49c0103b7$var$parseJSON(value) {
    try {
        return value === 'undefined' ? undefined : JSON.parse(value ?? '');
    } catch  {
        console.log('parsing error on', {
            value: value
        });
        return undefined;
    }
}
function $e3d170f49c0103b7$export$2446c4ac5b624d37(key) {
    if (typeof window === 'undefined') return undefined;
    try {
        const item = window.localStorage.getItem(key);
        return item ? $e3d170f49c0103b7$var$parseJSON(item) : undefined;
    } catch (error) {
        console.warn(`Error reading localStorage key \u{201C}${key}\u{201D}:`, error);
        return undefined;
    }
}
function $e3d170f49c0103b7$export$86e2cef2561044ac(key, initialValue) {
    const [storedValue, setStoredValue] = (0, $jpgPw.useState)(()=>$e3d170f49c0103b7$export$2446c4ac5b624d37(key) ?? initialValue);
    const setValue = (value)=>{
        if (typeof window == 'undefined') console.warn(`Tried setting localStorage key \u{201C}${key}\u{201D} even though environment is not a client`);
        try {
            const newValue = value instanceof Function ? value(storedValue) : value;
            window.localStorage.setItem(key, JSON.stringify(newValue));
            setStoredValue(newValue);
            window.dispatchEvent(new Event('local-storage'));
        } catch (error) {
            console.warn(`Error setting localStorage key \u{201C}${key}\u{201D}:`, error);
        }
    };
    (0, $jpgPw.useEffect)(()=>{
        setStoredValue($e3d170f49c0103b7$export$2446c4ac5b624d37(key) ?? initialValue);
    }, []);
    const handleStorageChange = ()=>{
        setStoredValue($e3d170f49c0103b7$export$2446c4ac5b624d37(key) ?? initialValue);
    };
    $e3d170f49c0103b7$var$useEventListener('storage', handleStorageChange);
    $e3d170f49c0103b7$var$useEventListener('local-storage', handleStorageChange);
    return [
        storedValue,
        setValue
    ];
}
function $e3d170f49c0103b7$export$1b909bd880c93326() {
    const { i18n: i18n } = (0, $2eqHs.useTranslation)();
    const [currentLanguage] = $e3d170f49c0103b7$export$86e2cef2561044ac('currentLanguage', 'fi');
    (0, $jpgPw.useEffect)(()=>{
        i18n.changeLanguage(currentLanguage);
    }, [
        currentLanguage
    ]);
    return currentLanguage;
}
function $e3d170f49c0103b7$export$33ee3e98d1dfc0d7(onClickHandler) {
    return (event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            onClickHandler();
        }
    };
}
function $e3d170f49c0103b7$export$2c02b58bdf58d1c3() {
    return window.location.search.slice(1).split('&').map((queryItem)=>queryItem.split('=', 2).map((item)=>decodeURIComponent(item))).reduce((queryParameters, [key, value])=>{
        queryParameters[key] = queryParameters[key] ? [
            ...queryParameters[key],
            value
        ] : [
            value
        ];
        return queryParameters;
    }, {});
}
function $e3d170f49c0103b7$export$65f7d00351849baa(callback, ref, eventType = 'mousedown') {
    (0, $jpgPw.useEffect)(()=>{
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) callback();
        }
        document.addEventListener(eventType, handleClickOutside);
        return ()=>{
            document.removeEventListener(eventType, handleClickOutside);
        };
    }, [
        ref
    ]);
}
function $e3d170f49c0103b7$export$3cc1b93c69a38f3d(string) {
    function hashCode(string) {
        let hash = 0;
        for(let index = 0; index < string.length; index++)hash = string.charCodeAt(index) + ((hash << 5) - hash);
        return hash;
    }
    return `hsl(${hashCode(`${string}`) % 360}, 85%, 30%)`;
}
function $e3d170f49c0103b7$export$2134cb3274e81080() {
    (0, $jpgPw.useEffect)(()=>{
        window.onbeforeunload = function() {
            return '';
        };
        return ()=>window.onbeforeunload = undefined;
    }, []);
}
function $e3d170f49c0103b7$export$61fc7d43ac8f84b0(callback, waitFor) {
    let timeout;
    return (...parameters)=>{
        clearTimeout(timeout);
        timeout = setTimeout(()=>callback(...parameters), waitFor);
    };
}
function $e3d170f49c0103b7$export$42c02f33970a2afa(delay = 20) {
    const [windowSize, setWindowSize] = (0, $jpgPw.useState)({
        width: undefined,
        height: undefined
    });
    (0, $jpgPw.useEffect)(()=>{
        const handleResize = ()=>{
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };
        const debouncedHandleResize = $e3d170f49c0103b7$export$61fc7d43ac8f84b0(handleResize, delay);
        window.addEventListener('resize', debouncedHandleResize);
        handleResize();
        return ()=>{
            window.removeEventListener('resize', debouncedHandleResize);
        };
    }, [
        delay
    ]);
    return windowSize;
}
function $e3d170f49c0103b7$export$b381ceb92f558884(...pageHierarchy) {
    const filteredPageHierarchy = pageHierarchy.filter((name)=>name);
    return filteredPageHierarchy.join(' | ');
}
function $e3d170f49c0103b7$export$3ae94a2503e890a1(timestamp) {
    return new Date(timestamp).toLocaleDateString('fi-FI', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    });
}
function $e3d170f49c0103b7$export$dfe9a1f342cfde36(value, maxLength) {
    return value.length > (maxLength ?? 0);
}
function $e3d170f49c0103b7$export$7f23633464b2aee(value, maxLength) {
    if (value) return value.trim() !== '' && maxLength ? !$e3d170f49c0103b7$export$dfe9a1f342cfde36(value, maxLength) : true;
    else return false;
}
function $e3d170f49c0103b7$export$266d0791b7dc739a(value, minValue, maxValue) {
    return value >= (minValue ?? 0) && value <= (maxValue ?? Number.MAX_SAFE_INTEGER);
}
function $e3d170f49c0103b7$export$6e1053bc7669a672(value, type, min, max) {
    if (!value || !value.isValid()) return false;
    const validMin = min && min.isValid() ? min : undefined;
    const validMax = max && max.isValid() ? max : undefined;
    if (type === 'date') {
        if (validMin && value.isBefore(validMin, 'day')) return false;
        if (validMax && value.isAfter(validMax, 'day')) return false;
    } else if (type === 'month') {
        if (validMin && value.isBefore(validMin, 'month')) return false;
        if (validMax && value.isAfter(validMax, 'month')) return false;
    }
    return true;
}
function $e3d170f49c0103b7$export$5c3d37ffdbbe5495(file, maxSizeMB) {
    return maxSizeMB && file.size > maxSizeMB * 1048576;
}
function $e3d170f49c0103b7$export$9ba6dd97df0adfb6(file, options) {
    if (!file) return false;
    if (options?.allowedTypes && !options.allowedTypes.includes(file.type)) return false;
    if (options?.maxSizeMB && $e3d170f49c0103b7$export$5c3d37ffdbbe5495(file, options.maxSizeMB)) return false;
    return true;
}
const $e3d170f49c0103b7$export$8ecdcf3bb089e9cd = (callback, element, debounceDelay, options = {
    childList: true,
    subtree: true,
    attributes: true,
    characterData: true
})=>{
    (0, $jpgPw.useEffect)(()=>{
        let observerCallback = callback;
        if (debounceDelay !== undefined) observerCallback = $e3d170f49c0103b7$export$61fc7d43ac8f84b0(callback, debounceDelay);
        const observer = new MutationObserver(observerCallback);
        if (element.current) observer.observe(element.current, options);
        return ()=>{
            observer.disconnect();
        };
    }, [
        callback,
        element,
        options,
        debounceDelay
    ]);
};
function $e3d170f49c0103b7$export$2830befb6f558677(array, sortBy) {
    const sortedArray = [
        ...array
    ];
    return sortedArray.sort((first, second)=>{
        const firstDateValue = first[sortBy];
        const secondDateValue = second[sortBy];
        const firstItemDate = firstDateValue ? (0, (/*@__PURE__*/$parcel$interopDefault($5AAkb)))(firstDateValue) : null;
        const secondItemDate = secondDateValue ? (0, (/*@__PURE__*/$parcel$interopDefault($5AAkb)))(secondDateValue) : null;
        if (!firstItemDate && !secondItemDate) return 0;
        if (!firstItemDate) return -1;
        if (!secondItemDate) return 1;
        return firstItemDate.diff(secondItemDate);
    });
}
function $e3d170f49c0103b7$export$90501ca74bad4dc4(filename) {
    const lastDotIndex = filename.lastIndexOf('.');
    if (lastDotIndex === -1 || lastDotIndex === 0) return {
        baseName: filename,
        extension: ''
    };
    const baseName = filename.substring(0, lastDotIndex);
    const extension = filename.substring(lastDotIndex + 1);
    return {
        baseName: baseName,
        extension: extension
    };
}
function $e3d170f49c0103b7$export$35956cb5939e0c69(file, newBaseName) {
    if (!file || !newBaseName) return undefined;
    const { extension: extension } = $e3d170f49c0103b7$export$90501ca74bad4dc4(file.name);
    const safeBaseName = newBaseName.replace(/\s+/g, '_');
    const newFileName = extension ? `${safeBaseName}.${extension}` : safeBaseName;
    return new File([
        file
    ], newFileName, {
        type: file.type,
        lastModified: file.lastModified
    });
}

});
parcelRegister("78dMK", function(module, exports) {

$parcel$export(module.exports, "SupervisorRole", function () { return $5313f937ea25f9ed$export$9b87219d2869fcad; });
$parcel$export(module.exports, "ThesisCommitteeMemberRole", function () { return $5313f937ea25f9ed$export$2ca93ba77a460380; });
var $5313f937ea25f9ed$export$9b87219d2869fcad;
(function(SupervisorRole) {
    SupervisorRole["CoordinatingAcademic"] = "coordinating-academic";
    SupervisorRole["MainSupervisor"] = "main-supervisor";
    SupervisorRole["Supervisor"] = "supervisor";
})($5313f937ea25f9ed$export$9b87219d2869fcad || ($5313f937ea25f9ed$export$9b87219d2869fcad = {}));
const $5313f937ea25f9ed$export$2ca93ba77a460380 = 'thesis-committee-member';

});


parcelRegister("dXNPX", function(module, exports) {

$parcel$export(module.exports, "UniSelectWithLabel", function () { return $a2a771a38ff667a1$export$d4fec998b47116f7; });

var $caZvI = parcelRequire("caZvI");
parcelRequire("jpgPw");

var $kYULb = parcelRequire("kYULb");

var $3da5u = parcelRequire("3da5u");

var $aGmfh = parcelRequire("aGmfh");
const $a2a771a38ff667a1$export$d4fec998b47116f7 = ({ id: id, label: label, value: value, onChange: onChange, required: required, autoFocus: autoFocus, disabled: disabled, isValid: isValid, validationHintAfter: validationHintAfter, validationHintBefore: validationHintBefore, validationHintInline: validationHintInline, hasInvalidHighlight: hasInvalidHighlight, small: small, fullWidth: fullWidth, flex: flex, visuallyHideLabel: visuallyHideLabel, visuallyHideLabelHelperText: visuallyHideLabelHelperText, visuallyHideValidationHintAfter: visuallyHideValidationHintAfter, visuallyHideValidationHintBefore: visuallyHideValidationHintBefore, hideHelperText: hideHelperText, className: className, onKeyDown: onKeyDown, options: options, ref: ref })=>(0, $caZvI.jsxs)($a2a771a38ff667a1$var$Container, {
        "$fullWidth": fullWidth,
        "$flex": visuallyHideLabel ? false : flex,
        "$small": small,
        children: [
            (0, $caZvI.jsx)((0, $kYULb.UniLabel), {
                required: required,
                htmlFor: id,
                visuallyHideText: visuallyHideLabel,
                visuallyHideHelperText: visuallyHideLabelHelperText,
                hideHelperText: hideHelperText,
                small: small,
                children: label
            }),
            (0, $caZvI.jsx)((0, $aGmfh.UniSelect), {
                id: id,
                className: className,
                ref: ref,
                label: label,
                required: required,
                value: value,
                onChange: (event)=>onChange(event.target.value),
                autoFocus: autoFocus,
                disabled: disabled,
                isValid: isValid,
                validationHintAfter: validationHintAfter,
                validationHintBefore: validationHintBefore,
                validationHintInline: validationHintInline,
                hasInvalidHighlight: hasInvalidHighlight,
                visuallyHideValidationHintAfter: visuallyHideValidationHintAfter,
                visuallyHideValidationHintBefore: visuallyHideValidationHintBefore,
                small: small,
                fullWidth: fullWidth,
                onKeyDown: onKeyDown,
                options: options
            })
        ]
    });
const $a2a771a38ff667a1$var$Container = (0, $3da5u.default).div`
  ${(props)=>props.$flex && (0, $3da5u.css)`
      display: flex;
      flex-direction: column;
      gap: 12px;
      flex: 1 1 auto;
    `}

  ${(props)=>props.$fullWidth && (0, $3da5u.css)`
      width: 100%;
    `}


  ${(props)=>props.$small && (0, $3da5u.css)`
      gap: 8px;
    `}
`;

});
parcelRegister("kYULb", function(module, exports) {

$parcel$export(module.exports, "UniLabel", function () { return $f46570a098ad52f8$export$bd9306d0c6885553; });
$parcel$export(module.exports, "RequiredText", function () { return $f46570a098ad52f8$export$a756498aed557fc4; });
$parcel$export(module.exports, "OptionalText", function () { return $f46570a098ad52f8$export$97c1d1e216e215ff; });

var $caZvI = parcelRequire("caZvI");
parcelRequire("jpgPw");

var $3da5u = parcelRequire("3da5u");

var $hSeA2 = parcelRequire("hSeA2");

var $bt0KQ = parcelRequire("bt0KQ");

var $3ZbSx = parcelRequire("3ZbSx");

var $2eqHs = parcelRequire("2eqHs");

var $b1LPP = parcelRequire("b1LPP");
const $f46570a098ad52f8$export$bd9306d0c6885553 = ({ id: id, htmlFor: htmlFor, visuallyHideText: visuallyHideText, small: small, visuallyHideHelperText: visuallyHideHelperText, hideHelperText: hideHelperText, required: required = false, as: as = 'label', children: children, ...rest })=>{
    return (0, $caZvI.jsx)($f46570a098ad52f8$var$Label, {
        id: id,
        htmlFor: htmlFor,
        "$visuallyHideText": visuallyHideText,
        as: as,
        "$small": small,
        ...rest,
        children: visuallyHideText ? (0, $caZvI.jsxs)((0, $3ZbSx.default), {
            children: [
                children,
                required ? (0, $caZvI.jsx)($f46570a098ad52f8$export$a756498aed557fc4, {
                    visuallyHideText: visuallyHideHelperText,
                    hideHelperText: hideHelperText
                }) : (0, $caZvI.jsx)($f46570a098ad52f8$export$97c1d1e216e215ff, {
                    visuallyHideText: visuallyHideHelperText,
                    hideHelperText: hideHelperText
                })
            ]
        }) : (0, $caZvI.jsxs)((0, $caZvI.Fragment), {
            children: [
                children,
                required ? (0, $caZvI.jsx)($f46570a098ad52f8$export$a756498aed557fc4, {
                    visuallyHideText: visuallyHideHelperText,
                    hideHelperText: hideHelperText
                }) : (0, $caZvI.jsx)($f46570a098ad52f8$export$97c1d1e216e215ff, {
                    visuallyHideText: visuallyHideHelperText,
                    hideHelperText: hideHelperText
                })
            ]
        })
    });
};
const $f46570a098ad52f8$var$Label = (0, $3da5u.default).label`
  color: ${(0, $hSeA2.GRAYSCALE_DARK_TEXT)};
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  margin: 0;
  ${(0, $bt0KQ.DEFAULT_FONT)}

  ${(props)=>props.$visuallyHideText && (0, $3da5u.css)`
      display: inline;
    `}

  ${(props)=>props.$small && (0, $3da5u.css)`
      font-size: 14px;
    `}
`;
const $f46570a098ad52f8$export$a756498aed557fc4 = ({ visuallyHideText: visuallyHideText = false, hideHelperText: hideHelperText = false })=>{
    const { t: t } = (0, $2eqHs.useTranslation)();
    if (hideHelperText) return null;
    if (visuallyHideText) return (0, $caZvI.jsxs)((0, $3ZbSx.default), {
        children: [
            ' (',
            t((0, $b1LPP.default).FORM.REQUIRED_FIELD),
            ')'
        ]
    });
    return (0, $caZvI.jsxs)($f46570a098ad52f8$export$7bc3de131d90901c, {
        children: [
            ' (',
            t((0, $b1LPP.default).FORM.REQUIRED_FIELD),
            ')'
        ]
    });
};
const $f46570a098ad52f8$export$97c1d1e216e215ff = ({ visuallyHideText: visuallyHideText = true, hideHelperText: hideHelperText = false })=>{
    const { t: t } = (0, $2eqHs.useTranslation)();
    if (hideHelperText) return null;
    if (visuallyHideText) return (0, $caZvI.jsxs)((0, $3ZbSx.default), {
        children: [
            ' (',
            t((0, $b1LPP.default).FORM.OPTIONAL_FIELD),
            ')'
        ]
    });
    return (0, $caZvI.jsxs)($f46570a098ad52f8$export$7bc3de131d90901c, {
        children: [
            ' (',
            t((0, $b1LPP.default).FORM.OPTIONAL_FIELD),
            ')'
        ]
    });
};
const $f46570a098ad52f8$export$7bc3de131d90901c = (0, $3da5u.default).span`
  ${(0, $bt0KQ.DEFAULT_FONT)}
  color: ${(0, $hSeA2.GRAYSCALE_MEDIUM_TEXT)};
  text-transform: uppercase;
  font-size: 13px;
  margin-left: 4px;
`;

});
parcelRegister("3ZbSx", function(module, exports) {

$parcel$export(module.exports, "HideStyles", function () { return $2e70487583118a78$export$a13da06f63ec8e49; });
$parcel$export(module.exports, "default", function () { return $2e70487583118a78$export$2e2bcd8739ae039; });

var $caZvI = parcelRequire("caZvI");
parcelRequire("jpgPw");

var $3da5u = parcelRequire("3da5u");
const $2e70487583118a78$export$a13da06f63ec8e49 = (0, $3da5u.css)`
  display: block;
  height: 1px;
  width: 1px;
  overflow: hidden;
  clip: rect(1px 1px 1px 1px);
  clip: rect(1px, 1px, 1px, 1px);
  clip-path: inset(1px);
  white-space: nowrap;
  position: absolute;
`;
const $2e70487583118a78$var$VisuallyHidden = ({ id: id, hidden: hidden, children: children })=>(0, $caZvI.jsx)($2e70487583118a78$var$Hide, {
        id: id,
        "aria-hidden": hidden,
        children: children
    });
const $2e70487583118a78$var$Hide = (0, $3da5u.default).span`
  ${$2e70487583118a78$export$a13da06f63ec8e49}
`;
var $2e70487583118a78$export$2e2bcd8739ae039 = $2e70487583118a78$var$VisuallyHidden;

});


parcelRegister("aGmfh", function(module, exports) {

$parcel$export(module.exports, "UniSelect", function () { return $7c6f152157038dfe$export$d1eb6fc351e5fee4; });

var $caZvI = parcelRequire("caZvI");

var $jpgPw = parcelRequire("jpgPw");

var $3da5u = parcelRequire("3da5u");

var $bt0KQ = parcelRequire("bt0KQ");

var $hSeA2 = parcelRequire("hSeA2");

var $c3mfK = parcelRequire("c3mfK");

var $fXJ44 = parcelRequire("fXJ44");

var $2eqHs = parcelRequire("2eqHs");

var $b1LPP = parcelRequire("b1LPP");

var $3ZbSx = parcelRequire("3ZbSx");
var $7c6f152157038dfe$export$3f4d80650c8ab22c;
(function(SelectStateIcon) {
    SelectStateIcon[SelectStateIcon["Required"] = 0] = "Required";
    SelectStateIcon[SelectStateIcon["Valid"] = 1] = "Valid";
    SelectStateIcon[SelectStateIcon["Invalid"] = 2] = "Invalid";
})($7c6f152157038dfe$export$3f4d80650c8ab22c || ($7c6f152157038dfe$export$3f4d80650c8ab22c = {}));
const $7c6f152157038dfe$export$d1eb6fc351e5fee4 = ({ id: id, label: label, required: required, options: options, isValid: isValid, disabled: disabled, validationHintAfter: validationHintAfter, validationHintBefore: validationHintBefore, validationHintInline: validationHintInline, small: small, hasInvalidHighlight: hasInvalidHighlight, visuallyHideValidationHintAfter: visuallyHideValidationHintAfter, visuallyHideValidationHintBefore: visuallyHideValidationHintBefore, ref: ref, ...props })=>{
    const { t: t } = (0, $2eqHs.useTranslation)();
    const [hasFocus, setHasFocus] = (0, $jpgPw.useState)(false);
    const onFocus = (0, $jpgPw.useCallback)(()=>setHasFocus(true), []);
    const onBlur = (0, $jpgPw.useCallback)(()=>setHasFocus(false), []);
    const hasIcon = required === true && isValid !== undefined;
    const isEmpty = !props.value;
    const { icon: icon, highlightInvalidField: highlightInvalidField } = $7c6f152157038dfe$var$getIcon(required, isValid, hasInvalidHighlight, isEmpty, hasFocus);
    return (0, $caZvI.jsxs)($7c6f152157038dfe$export$d586e0ae81c7b89b, {
        children: [
            validationHintBefore && (0, $caZvI.jsx)((0, $fXJ44.ValidationHintBeforeContainer), {
                id: `${id}-help-before`,
                "$showInvalidColor": highlightInvalidField,
                "aria-hidden": "true",
                children: visuallyHideValidationHintBefore ? (0, $caZvI.jsx)((0, $3ZbSx.default), {
                    children: validationHintBefore
                }) : validationHintBefore
            }),
            (0, $caZvI.jsxs)($7c6f152157038dfe$var$Container, {
                "$validationHintInline": validationHintInline,
                children: [
                    (0, $caZvI.jsxs)($7c6f152157038dfe$var$SelectContainer, {
                        children: [
                            (0, $caZvI.jsx)($7c6f152157038dfe$var$Select, {
                                id: id,
                                ref: ref,
                                ...props,
                                disabled: disabled,
                                "$small": small,
                                "$showInvalidBorder": highlightInvalidField,
                                "$hasIcon": hasIcon,
                                onFocus: onFocus,
                                onBlur: onBlur,
                                "aria-required": required ? 'true' : undefined,
                                "aria-describedby": validationHintBefore || validationHintInline || validationHintAfter ? `${validationHintBefore ? `${id}-help-before ` : ''}${validationHintInline ? `${id}-help-inline ` : ''}${validationHintAfter ? `${id}-help-after ` : ''}` : undefined,
                                children: options.map((optionOrGroup)=>{
                                    if ('options' in optionOrGroup) return (0, $caZvI.jsx)("optgroup", {
                                        label: optionOrGroup.label,
                                        children: optionOrGroup.options.map((option)=>(0, $caZvI.jsx)("option", {
                                                value: option.value,
                                                disabled: option.disabled,
                                                children: option.label
                                            }, option.value))
                                    }, `group-${optionOrGroup.label}`);
                                    else return (0, $caZvI.jsx)("option", {
                                        value: optionOrGroup.value,
                                        disabled: optionOrGroup.disabled,
                                        children: optionOrGroup.label
                                    }, optionOrGroup.value);
                                })
                            }),
                            (0, $caZvI.jsxs)($7c6f152157038dfe$export$8f314e512d92575f, {
                                "$icon": icon,
                                "$small": small,
                                children: [
                                    hasIcon && (0, $caZvI.jsx)((0, $fXJ44.Icon), {
                                        valid: icon === $7c6f152157038dfe$export$3f4d80650c8ab22c.Valid,
                                        required: icon === $7c6f152157038dfe$export$3f4d80650c8ab22c.Required,
                                        info: icon === $7c6f152157038dfe$export$3f4d80650c8ab22c.Invalid
                                    }),
                                    (0, $caZvI.jsx)($7c6f152157038dfe$var$DropdownIcon, {
                                        caretDown: true,
                                        "$small": small,
                                        "$disabled": disabled
                                    })
                                ]
                            })
                        ]
                    }),
                    validationHintInline && (0, $caZvI.jsx)((0, $fXJ44.ValidationHintInlineContainer), {
                        id: `${id}-help-inline`,
                        "$showInvalidColor": highlightInvalidField,
                        "aria-hidden": "true",
                        children: validationHintInline
                    })
                ]
            }),
            (0, $caZvI.jsxs)((0, $fXJ44.ValidationHintAfterContainer), {
                id: validationHintAfter || highlightInvalidField ? `${id}-help-after` : undefined,
                "$showInvalidColor": highlightInvalidField,
                "aria-hidden": "true",
                children: [
                    highlightInvalidField ? (0, $caZvI.jsx)((0, $fXJ44.ValidationErrorAfterContainer), {
                        children: isEmpty ? `${label} ${t((0, $b1LPP.default).IS_MISSING)}` : t((0, $b1LPP.default).THE_VALUE_ENTERED_IS_INVALID)
                    }) : null,
                    visuallyHideValidationHintAfter ? (0, $caZvI.jsx)((0, $3ZbSx.default), {
                        children: validationHintAfter
                    }) : validationHintAfter
                ]
            })
        ]
    });
};
function $7c6f152157038dfe$var$getIcon(isRequired, isValid, hasInvalidHighlight, isEmpty, hasFocus) {
    if (isRequired) {
        if (hasInvalidHighlight) return {
            icon: $7c6f152157038dfe$export$3f4d80650c8ab22c.Invalid,
            highlightInvalidField: true
        };
        if (isValid) return {
            icon: $7c6f152157038dfe$export$3f4d80650c8ab22c.Valid,
            highlightInvalidField: false
        };
        if (hasFocus) return {
            icon: $7c6f152157038dfe$export$3f4d80650c8ab22c.Required,
            highlightInvalidField: false
        };
        if (isEmpty) return {
            icon: $7c6f152157038dfe$export$3f4d80650c8ab22c.Required,
            highlightInvalidField: false
        };
        if (isValid === undefined) return {
            icon: undefined,
            highlightInvalidField: false
        };
        return {
            icon: $7c6f152157038dfe$export$3f4d80650c8ab22c.Invalid,
            highlightInvalidField: true
        };
    }
    return {
        icon: undefined,
        highlightInvalidField: false
    };
}
const $7c6f152157038dfe$export$d586e0ae81c7b89b = (0, $3da5u.default).div``;
const $7c6f152157038dfe$var$Container = (0, $3da5u.default).div`
  position: relative;

  ${(props)=>props.$validationHintInline && (0, $3da5u.css)`
      display: flex;
    `}
`;
const $7c6f152157038dfe$var$SelectContainer = (0, $3da5u.default).div`
  position: relative;
  width: 100%;
`;
const $7c6f152157038dfe$var$Select = (0, $3da5u.default).select`
  appearance: none;
  background: ${(0, $hSeA2.GRAYSCALE_WHITE)};
  border: 1px solid ${(0, $hSeA2.GRAYSCALE_MEDIUM_DARK)};
  border-radius: 0px;
  color: ${(0, $hSeA2.GRAYSCALE_DARK_TEXT)};
  height: 44px;
  font-size: 16px;
  line-height: 24px;
  padding: 8px 12px;
  padding-right: 56px;
  width: 100%;
  ${(0, $bt0KQ.DEFAULT_FONT)}

  &:focus {
    border: 1px solid ${(0, $hSeA2.BRAND_MAIN_LIGHT)};
    outline: solid 2px ${(0, $hSeA2.ADDITIONAL_YELLOW)};
    outline-offset: 2px;
  }

  ${(props)=>props.$showInvalidBorder && (0, $3da5u.css)`
      border-color: ${0, $hSeA2.ADDITIONAL_RED_DARK};
      box-shadow: 0 0 0 1px ${0, $hSeA2.ADDITIONAL_RED_DARK};
    `}

  ${(props)=>props.$hasIcon && (0, $3da5u.css)`
      padding-right: 84px;
    `}

  ${(props)=>props.$fullWidth && (0, $3da5u.css)`
      width: 100%;
    `}

  ${(props)=>props.$small && (0, $3da5u.css)`
      height: 32px;
      font-size: 14px;
      line-height: 20px;
      padding: 6px 8px;
      padding-right: 48px;
    `}
`;
const $7c6f152157038dfe$export$8f314e512d92575f = (0, $3da5u.default).div`
  align-items: center;
  bottom: 0px;
  display: flex;
  height: 44px;
  position: absolute;
  right: 12px;
  pointer-events: none;

  ${(props)=>props.$icon !== undefined && (0, $3da5u.css)`
      color: ${$7c6f152157038dfe$var$colorByIcon[props.$icon]};
    `}

  ${(props)=>props.$small && (0, $3da5u.css)`
      height: 32px;
    `}
`;
const $7c6f152157038dfe$var$colorByIcon = {
    [$7c6f152157038dfe$export$3f4d80650c8ab22c.Required]: (0, $hSeA2.BRAND_MAIN_LIGHT),
    [$7c6f152157038dfe$export$3f4d80650c8ab22c.Valid]: (0, $hSeA2.ADDITIONAL_GREEN_DARK),
    [$7c6f152157038dfe$export$3f4d80650c8ab22c.Invalid]: (0, $hSeA2.ADDITIONAL_RED_DARK)
};
const $7c6f152157038dfe$var$DropdownIcon = (0, $3da5u.default)((0, $c3mfK.HyIcon))`
  flex: 0 0 auto;
  color: ${(0, $hSeA2.BRAND_MAIN_LIGHT)};
  font-size: 16px;
  line-height: 1.5em;
  height: 1.5em;
  margin-inline-start: 16px;
  padding-inline-start: 16px;
  padding-inline-end: 4px;
  border-inline-start: 1px solid ${(0, $hSeA2.ADDITIONAL_SKYBLUE)};

  ${(props)=>props.$small && (0, $3da5u.css)`
      font-size: 12px;
      line-height: 1.5em;
      height: 1.5em;
      margin-inline-start: 10px;
      padding-inline-start: 10px;
      padding-inline-end: 0px;
    `}

  ${(props)=>props.$disabled && (0, $3da5u.css)`
      border-color: ${0, $hSeA2.GRAYSCALE_MEDIUM_DARK};
      color: ${0, $hSeA2.GRAYSCALE_MEDIUM_DARK};
    `}
`;

});
parcelRegister("c3mfK", function(module, exports) {

$parcel$export(module.exports, "HyIcon", function () { return $8c6706cf1d9e8be7$export$e193c762ec2cac7b; });

var $caZvI = parcelRequire("caZvI");
parcelRequire("jpgPw");

var $3da5u = parcelRequire("3da5u");

var $hSeA2 = parcelRequire("hSeA2");
const $8c6706cf1d9e8be7$export$e193c762ec2cac7b = ({ green: green, blue: blue, white: white, black: black, red: red, orange: orange, valid: valid, required: required, spinner: spinner, edit: edit, plus: plus, remove: remove, caretDown: caretDown, caretUp: caretUp, arrowRight: arrowRight, arrowLeft: arrowLeft, alert: alert, info: info, avatar: avatar, login: login, logout: logout, wrench: wrench, search: search, date: date, person: person, people: people, ref: ref, ...htmlProps })=>{
    const iconProps = {
        valid: valid,
        required: required,
        spinner: spinner,
        edit: edit,
        plus: plus,
        remove: remove,
        caretDown: caretDown,
        caretUp: caretUp,
        arrowRight: arrowRight,
        arrowLeft: arrowLeft,
        alert: alert,
        info: info,
        avatar: avatar,
        login: login,
        logout: logout,
        wrench: wrench,
        search: search,
        date: date,
        person: person,
        people: people
    };
    return (0, $caZvI.jsx)($8c6706cf1d9e8be7$var$Span, {
        ref: ref,
        role: "img",
        "aria-hidden": true,
        ...htmlProps,
        "$green": green,
        "$blue": blue,
        "$white": white,
        "$black": black,
        "$red": red,
        "$orange": orange,
        "$required": required,
        children: $8c6706cf1d9e8be7$var$getIcon(iconProps)
    });
};
function $8c6706cf1d9e8be7$var$getIcon(props) {
    if (props.valid) return "\uEA0B";
    if (props.required) return "\uEA74";
    if (props.spinner) return "\uEA4A";
    if (props.edit) return "\uEA0F";
    if (props.plus) return '\uEA2F';
    if (props.remove) return "\uEA32";
    if (props.caretDown) return "\uEA6D";
    if (props.caretUp) return "\uEA70";
    if (props.arrowRight) return "\uEA68";
    if (props.arrowLeft) return "\uEA67";
    if (props.alert) return "\uEA7D";
    if (props.info) return "\uEA18";
    if (props.avatar) return "\uEA05";
    if (props.login) return "\uEA49";
    if (props.logout) return "\uEA20";
    if (props.wrench) return "\uEA5B";
    if (props.search) return "\uEA35";
    if (props.date) return '\uEA09';
    if (props.person) return '\uea2e';
    if (props.people) return '\uea2c';
    return '';
}
const $8c6706cf1d9e8be7$var$Span = (0, $3da5u.default).span`
  font-family: 'hy-icons';
  user-select: none;

  &:before {
    content: '';
  }

  ${(props)=>props.$green && (0, $3da5u.css)`
      color: #96ba3c;
    `}

  ${(props)=>props.$blue && (0, $3da5u.css)`
      color: #107eab;
    `}

  ${(props)=>props.$white && (0, $3da5u.css)`
      color: #fff;
    `}

  ${(props)=>props.$black && (0, $3da5u.css)`
      color: #000;
    `}

  ${(props)=>props.$red && (0, $3da5u.css)`
      color: ${0, $hSeA2.ADDITIONAL_RED};
    `}

  ${(props)=>props.$orange && (0, $3da5u.css)`
      color: ${0, $hSeA2.ADDITIONAL_ORANGE};
    `}

  ${(props)=>props.$required && (0, $3da5u.css)`
      font-size: 10px;
    `}
`;

});

parcelRegister("fXJ44", function(module, exports) {

$parcel$export(module.exports, "InputStateIcon", function () { return $b9ef529f6549f996$export$e59e4b9b22117b1b; });
$parcel$export(module.exports, "UniInput", function () { return $b9ef529f6549f996$export$d510ab7e8f6c971; });
$parcel$export(module.exports, "InputWrapper", function () { return $b9ef529f6549f996$export$fb9f58ebe9de6283; });
$parcel$export(module.exports, "ValidationHintBeforeContainer", function () { return $b9ef529f6549f996$export$bffdace56f61e360; });
$parcel$export(module.exports, "InputContainer", function () { return $b9ef529f6549f996$export$b821cb5d358838ed; });
$parcel$export(module.exports, "IconContainer", function () { return $b9ef529f6549f996$export$8f314e512d92575f; });
$parcel$export(module.exports, "Icon", function () { return $b9ef529f6549f996$export$f04a61298a47a40f; });
$parcel$export(module.exports, "ValidationHintInlineContainer", function () { return $b9ef529f6549f996$export$d67f65a2530992fb; });
$parcel$export(module.exports, "ValidationHintAfterContainer", function () { return $b9ef529f6549f996$export$f1d8f93623574534; });
$parcel$export(module.exports, "ValidationErrorAfterContainer", function () { return $b9ef529f6549f996$export$8ccf7737b43a363e; });
$parcel$export(module.exports, "HINT_CONTAINER_HEIGHT", function () { return $b9ef529f6549f996$export$3cf62bdd4bbc2a7e; });

var $caZvI = parcelRequire("caZvI");

var $jpgPw = parcelRequire("jpgPw");

var $3da5u = parcelRequire("3da5u");

var $2eqHs = parcelRequire("2eqHs");

var $bt0KQ = parcelRequire("bt0KQ");

var $hSeA2 = parcelRequire("hSeA2");

var $c3mfK = parcelRequire("c3mfK");

var $b1LPP = parcelRequire("b1LPP");

var $jyFzD = parcelRequire("jyFzD");
var $b9ef529f6549f996$export$e59e4b9b22117b1b;
(function(InputStateIcon) {
    InputStateIcon[InputStateIcon["Required"] = 0] = "Required";
    InputStateIcon[InputStateIcon["Valid"] = 1] = "Valid";
    InputStateIcon[InputStateIcon["Invalid"] = 2] = "Invalid";
})($b9ef529f6549f996$export$e59e4b9b22117b1b || ($b9ef529f6549f996$export$e59e4b9b22117b1b = {}));
const $b9ef529f6549f996$export$d510ab7e8f6c971 = ({ id: id, label: label, required: required, isValid: isValid, validationHintAfter: validationHintAfter, validationHintBefore: validationHintBefore, validationHintInline: validationHintInline, hasInvalidHighlight: hasInvalidHighlight, fullWidth: fullWidth, maxWidth: maxWidth, maxLength: maxLength, small: small, ref: ref, ...props })=>{
    const { t: t } = (0, $2eqHs.useTranslation)();
    const [hasFocus, setHasFocus] = (0, $jpgPw.useState)(false);
    const onFocus = (0, $jpgPw.useCallback)(()=>setHasFocus(true), []);
    const onBlur = (0, $jpgPw.useCallback)(()=>setHasFocus(false), []);
    const hasIcon = required === true && isValid !== undefined;
    const isEmpty = !props.value || props.type === 'number' && props.value === '0';
    const { icon: icon, highlightInvalidField: highlightInvalidField } = $b9ef529f6549f996$var$getIcon(required, isValid, hasInvalidHighlight, isEmpty, hasFocus);
    return (0, $caZvI.jsxs)($b9ef529f6549f996$export$fb9f58ebe9de6283, {
        "$fullWidth": fullWidth,
        "$maxWidth": maxWidth,
        children: [
            validationHintBefore && (0, $caZvI.jsx)($b9ef529f6549f996$export$bffdace56f61e360, {
                id: `${id}-help-before`,
                "$showInvalidColor": highlightInvalidField,
                "aria-hidden": "true",
                children: validationHintBefore
            }),
            (0, $caZvI.jsxs)($b9ef529f6549f996$var$Container, {
                "$validationHintInline": validationHintInline,
                children: [
                    (0, $caZvI.jsxs)($b9ef529f6549f996$export$b821cb5d358838ed, {
                        children: [
                            (0, $caZvI.jsx)($b9ef529f6549f996$var$Input, {
                                id: id,
                                ref: ref,
                                ...props,
                                "$fullWidth": fullWidth,
                                "$small": small,
                                "$showInvalidBorder": highlightInvalidField,
                                "aria-invalid": highlightInvalidField ? 'true' : undefined,
                                "$hasIcon": hasIcon,
                                onFocus: onFocus,
                                onBlur: onBlur,
                                "aria-required": required ? 'true' : undefined,
                                "aria-describedby": validationHintBefore || validationHintInline || validationHintAfter || highlightInvalidField ? `${validationHintBefore ? `${id}-help-before ` : ''}${validationHintInline ? `${id}-help-inline ` : ''}${validationHintAfter || highlightInvalidField ? `${id}-help-after ` : ''}` : undefined
                            }),
                            hasIcon && (0, $caZvI.jsx)($b9ef529f6549f996$export$8f314e512d92575f, {
                                "$icon": icon,
                                className: "validated-form-group__validation-status",
                                "$small": small,
                                "data-testid": icon === $b9ef529f6549f996$export$e59e4b9b22117b1b.Valid ? 'validation-valid' : undefined,
                                children: (0, $caZvI.jsx)($b9ef529f6549f996$export$f04a61298a47a40f, {
                                    valid: icon === $b9ef529f6549f996$export$e59e4b9b22117b1b.Valid,
                                    required: icon === $b9ef529f6549f996$export$e59e4b9b22117b1b.Required,
                                    info: icon === $b9ef529f6549f996$export$e59e4b9b22117b1b.Invalid
                                })
                            })
                        ]
                    }),
                    validationHintInline && (0, $caZvI.jsx)($b9ef529f6549f996$export$d67f65a2530992fb, {
                        id: `${id}-help-inline`,
                        "$showInvalidColor": highlightInvalidField,
                        "aria-hidden": "true",
                        children: validationHintInline
                    })
                ]
            }),
            (0, $caZvI.jsxs)($b9ef529f6549f996$export$f1d8f93623574534, {
                id: validationHintAfter || highlightInvalidField ? `${id}-help-after` : undefined,
                "$showInvalidColor": highlightInvalidField,
                "aria-hidden": "true",
                children: [
                    highlightInvalidField ? (0, $caZvI.jsx)($b9ef529f6549f996$export$8ccf7737b43a363e, {
                        children: isEmpty ? `${label} ${t((0, $b1LPP.default).IS_MISSING)}` : maxLength && (0, $jyFzD.hasExceededMaxLength)(props.value.toString(), maxLength) ? t((0, $b1LPP.default).INPUT_EXCEEDS_THE_CHARACTER_LIMIT, {
                            maxLength: maxLength.toString()
                        }) : t((0, $b1LPP.default).THE_VALUE_ENTERED_IS_INVALID)
                    }) : null,
                    validationHintAfter
                ]
            })
        ]
    });
};
function $b9ef529f6549f996$var$getIcon(isRequired, isValid, hasInvalidHighlight, isEmpty, hasFocus) {
    if (isRequired) {
        if (hasInvalidHighlight) return {
            icon: $b9ef529f6549f996$export$e59e4b9b22117b1b.Invalid,
            highlightInvalidField: true
        };
        if (isValid) return {
            icon: $b9ef529f6549f996$export$e59e4b9b22117b1b.Valid,
            highlightInvalidField: false
        };
        if (hasFocus) return {
            icon: $b9ef529f6549f996$export$e59e4b9b22117b1b.Required,
            highlightInvalidField: false
        };
        if (isEmpty) return {
            icon: $b9ef529f6549f996$export$e59e4b9b22117b1b.Required,
            highlightInvalidField: false
        };
        if (isValid === undefined) return {
            icon: undefined,
            highlightInvalidField: false
        };
        return {
            icon: $b9ef529f6549f996$export$e59e4b9b22117b1b.Invalid,
            highlightInvalidField: true
        };
    }
    return {
        icon: undefined,
        highlightInvalidField: false
    };
}
const $b9ef529f6549f996$export$fb9f58ebe9de6283 = (0, $3da5u.default).div`
  ${(props)=>props.$fullWidth && (0, $3da5u.css)`
      width: 100%;
    `}

  ${(props)=>props.$maxWidth && (0, $3da5u.css)`
      max-width: ${props.$maxWidth};
    `}
`;
const $b9ef529f6549f996$var$Container = (0, $3da5u.default).div`
  position: relative;

  ${(props)=>props.$validationHintInline && (0, $3da5u.css)`
      display: flex;
    `}
`;
const $b9ef529f6549f996$export$b821cb5d358838ed = (0, $3da5u.default).div`
  position: relative;
  width: 100%;
`;
const $b9ef529f6549f996$var$Input = (0, $3da5u.default).input`
  background: ${(0, $hSeA2.GRAYSCALE_WHITE)};
  border: 1px solid ${(0, $hSeA2.GRAYSCALE_MEDIUM_DARK)};
  color: ${(0, $hSeA2.GRAYSCALE_DARK_TEXT)};
  height: 44px;
  font-size: 16px;
  line-height: 24px;
  padding: 8px 12px;
  width: 100%;
  ${(0, $bt0KQ.DEFAULT_FONT)}

  &:focus {
    border: 1px solid ${(0, $hSeA2.BRAND_MAIN_LIGHT)};
    outline: solid 2px ${(0, $hSeA2.ADDITIONAL_YELLOW)};
    outline-offset: 2px;
  }

  &::-webkit-calendar-picker-indicator {
    position: relative;
    background-position: center;
    background-size: 22px;
    height: 44px;
    width: 44px;
    opacity: 0.6;

    &:hover,
    &:focus {
      cursor: pointer;
      opacity: 1;
    }

    &:focus {
      outline: solid 2px ${(0, $hSeA2.ADDITIONAL_YELLOW)};
      outline-offset: -6px;
    }
  }

  ${(props)=>props.$showInvalidBorder && (0, $3da5u.css)`
      border-color: ${0, $hSeA2.ADDITIONAL_RED_DARK};
      box-shadow: 0 0 0 1px ${0, $hSeA2.ADDITIONAL_RED_DARK};
    `}

  ${(props)=>props.$hasIcon && (0, $3da5u.css)`
      padding-right: 36px;
    `}

    ${(props)=>props.$fullWidth && (0, $3da5u.css)`
      width: 100%;
    `}

  ${(props)=>props.$small && (0, $3da5u.css)`
      height: 32px;
      font-size: 14px;
      line-height: 20px;
      padding: 6px 8px;
      padding-right: 48px;
    `}

  &::file-selector-button {
    ${(0, $bt0KQ.DEFAULT_FONT)}
    background: transparent;
    border: 2px solid ${(0, $hSeA2.BRAND_MAIN)};
    padding: 0 16px;
    margin-right: 16px;
  }
`;
const $b9ef529f6549f996$export$3cf62bdd4bbc2a7e = 21;
const $b9ef529f6549f996$export$8f314e512d92575f = (0, $3da5u.default).div`
  align-items: center;
  bottom: 0px;
  display: flex;
  height: 44px;
  position: absolute;
  right: 12px;

  ${(props)=>props.$icon !== undefined && (0, $3da5u.css)`
      color: ${$b9ef529f6549f996$var$colorByIcon[props.$icon]};
    `}

  ${(props)=>props.$small && (0, $3da5u.css)`
      height: 32px;
    `}
`;
const $b9ef529f6549f996$var$colorByIcon = {
    [$b9ef529f6549f996$export$e59e4b9b22117b1b.Required]: (0, $hSeA2.BRAND_MAIN_LIGHT),
    [$b9ef529f6549f996$export$e59e4b9b22117b1b.Valid]: (0, $hSeA2.ADDITIONAL_GREEN_DARK),
    [$b9ef529f6549f996$export$e59e4b9b22117b1b.Invalid]: (0, $hSeA2.ADDITIONAL_RED_DARK)
};
const $b9ef529f6549f996$export$f04a61298a47a40f = (0, $3da5u.default)((0, $c3mfK.HyIcon))`
  font-size: 10px;
  min-height: 1px;

  ${(props)=>props.valid && (0, $3da5u.css)`
      font-size: 16px;
    `}

  ${(props)=>props.info && (0, $3da5u.css)`
      font-size: 20px;
    `}
`;
const $b9ef529f6549f996$export$bffdace56f61e360 = (0, $3da5u.default).div`
  color: ${(props)=>props.$showInvalidColor ? (0, $hSeA2.ADDITIONAL_RED_DARK) : (0, $hSeA2.GRAYSCALE_DARK)};
  min-height: ${$b9ef529f6549f996$export$3cf62bdd4bbc2a7e}px;
  font-size: 13px;
  margin-bottom: 2px;
  ${(0, $bt0KQ.DEFAULT_FONT)}
`;
const $b9ef529f6549f996$export$d67f65a2530992fb = (0, $3da5u.default).div`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  height: 44px;
  color: ${(props)=>props.$showInvalidColor ? (0, $hSeA2.ADDITIONAL_RED_DARK) : (0, $hSeA2.GRAYSCALE_DARK)};
  text-align: right;
  padding: 2px 12px 0;
  background-color: ${(0, $hSeA2.GRAYSCALE_BACKGROUND_BOX)};
  border: 1px solid ${(0, $hSeA2.GRAYSCALE_MEDIUM_DARK)};
  border-left: none;
  color: ${(0, $hSeA2.GRAYSCALE_DARK_TEXT)};
  ${(0, $bt0KQ.DEFAULT_FONT)}
`;
const $b9ef529f6549f996$export$f1d8f93623574534 = (0, $3da5u.default).div`
  color: ${(props)=>props.$showInvalidColor ? (0, $hSeA2.ADDITIONAL_RED_DARK) : (0, $hSeA2.GRAYSCALE_DARK)};
  min-height: ${$b9ef529f6549f996$export$3cf62bdd4bbc2a7e}px;
  font-size: 13px;
  text-align: right;
  padding-top: 2px;
  ${(0, $bt0KQ.DEFAULT_FONT)}
`;
const $b9ef529f6549f996$export$8ccf7737b43a363e = (0, $3da5u.default).div`
  ${(0, $bt0KQ.DEFAULT_FONT)}
  font-size: 14px;
  font-weight: 600;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;

  ${({ $borderTop: $borderTop })=>$borderTop && (0, $3da5u.css)`
      border-top: 2px solid ${0, $hSeA2.ADDITIONAL_RED_DARK};
      padding-top: 2px;
      margin-top: 4px;
    `}‰
`;

});



parcelRegister("fdLNz", function(module, exports) {
module.exports = $parcel$resolve("7olxG");

});


parcelRegister("fCgwC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b5e7392b5d451c30$export$2e2bcd8739ae039; });

var $caZvI = parcelRequire("caZvI");
parcelRequire("jpgPw");

var $2eqHs = parcelRequire("2eqHs");

var $3da5u = parcelRequire("3da5u");

var $b1LPP = parcelRequire("b1LPP");

var $eUJ8V = parcelRequire("eUJ8V");

var $hSeA2 = parcelRequire("hSeA2");

var $1Hynf = parcelRequire("1Hynf");

var $6kYN4 = parcelRequire("6kYN4");

var $edasP = parcelRequire("edasP");

var $jyFzD = parcelRequire("jyFzD");

var $dXNPX = parcelRequire("dXNPX");

const $b5e7392b5d451c30$var$logoUrl = new URL((parcelRequire("fdLNz")));
const $b5e7392b5d451c30$var$translatedPrivacyPolicyLinks = {
    fi: 'https://www.helsinki.fi/fi/tutustu-meihin/tietojen-kasittely-yliopistolla/tietosuoja',
    sv: 'https://www.helsinki.fi/sv/om-oss/behandling-av-uppgifter-vid-universitetet/dataskydd',
    en: 'https://www.helsinki.fi/en/about-us/processing-data-university/data-protection'
};
const $b5e7392b5d451c30$var$Footer = ()=>{
    const { t: t, i18n: i18n } = (0, $2eqHs.useTranslation)();
    const translatedPrivacyPolicyLink = $b5e7392b5d451c30$var$translatedPrivacyPolicyLinks[i18n.resolvedLanguage];
    return (0, $caZvI.jsx)($b5e7392b5d451c30$var$AlignBottom, {
        id: "Footer",
        children: (0, $caZvI.jsx)((0, $eUJ8V.UniContainer), {
            "$wide": true,
            children: (0, $caZvI.jsx)((0, $eUJ8V.UniContainer), {
                "$wide": true,
                "$paddingTop": true,
                "$paddingBottom": true,
                "$borderTop": true,
                "$paddingInline": false,
                children: (0, $caZvI.jsxs)($b5e7392b5d451c30$var$Flex, {
                    children: [
                        (0, $caZvI.jsx)($b5e7392b5d451c30$var$LogoColumn, {
                            children: (0, $caZvI.jsx)($b5e7392b5d451c30$var$Logo, {
                                src: $b5e7392b5d451c30$var$logoUrl.toString(),
                                alt: t((0, $b1LPP.default).LOGO_OF_UNIVERSITY_OF_HELSINKI)
                            })
                        }),
                        (0, $caZvI.jsxs)($b5e7392b5d451c30$var$InfoColumn, {
                            children: [
                                (0, $caZvI.jsxs)($b5e7392b5d451c30$var$SiteName, {
                                    children: [
                                        (0, $caZvI.jsx)($b5e7392b5d451c30$var$ThessaText, {
                                            children: t((0, $b1LPP.default).THESSA)
                                        }),
                                        (0, $caZvI.jsx)($b5e7392b5d451c30$var$SiteUrl, {
                                            children: 'thessa.helsinki.fi'
                                        })
                                    ]
                                }),
                                (0, $caZvI.jsx)($b5e7392b5d451c30$var$FooterLanguageSelect, {
                                    id: `footer-language-select`
                                })
                            ]
                        }),
                        (0, $caZvI.jsx)($b5e7392b5d451c30$var$ShortcutColumn, {
                            children: (0, $caZvI.jsx)((0, $edasP.UniShortcut), {
                                links: [
                                    {
                                        link: translatedPrivacyPolicyLink,
                                        title: t((0, $b1LPP.default).PRIVACY_POLICY),
                                        external: true
                                    },
                                    {
                                        link: '/accessibility-statement',
                                        title: t((0, $b1LPP.default).ACCESSIBILITY_STATEMENT)
                                    },
                                    {
                                        link: '/contact',
                                        title: t((0, $b1LPP.default).ASK_FOR_HELP_AND_GIVE_FEEDBACK)
                                    },
                                    {
                                        link: '/about',
                                        title: t((0, $b1LPP.default).ABOUT_THESSA)
                                    },
                                    {
                                        link: '/sitemap',
                                        title: t((0, $b1LPP.default).SITEMAP)
                                    }
                                ],
                                grid: true
                            })
                        })
                    ]
                })
            })
        })
    });
};
const $b5e7392b5d451c30$var$AlignBottom = (0, $3da5u.default).footer`
  margin-block-start: auto;
`;
const $b5e7392b5d451c30$var$Flex = (0, $3da5u.default).div`
  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 16px;

  ${(0, $1Hynf.fromTabletUp)((0, $3da5u.css)`
    flex-flow: row nowrap;
    justify-content: space-between;
  `)}
`;
const $b5e7392b5d451c30$var$LogoColumn = (0, $3da5u.default).div``;
const $b5e7392b5d451c30$var$Logo = (0, $3da5u.default).img`
  width: 3.75em;
  height: 3.75em;
  filter: invert(100%);
`;
const $b5e7392b5d451c30$var$InfoColumn = (0, $3da5u.default).div`
  margin-right: auto;
  padding-right: 48px;
`;
const $b5e7392b5d451c30$var$SiteName = (0, $3da5u.default).div`
  ${(0, $6kYN4.UniParagraphStyles)}
  font-weight: 700;
  letter-spacing: -0.6px;
  text-transform: uppercase;
  flex: 1 1 100%;
  padding-top: 2px;

  ${(0, $1Hynf.fromTabletUp)((0, $3da5u.css)`
    flex: 1 1 auto;
  `)}
`;
const $b5e7392b5d451c30$var$SiteUrl = (0, $3da5u.default).div`
  font-size: 15px;
  line-height: 14px;
  padding-top: 4px;
`;
const $b5e7392b5d451c30$var$ThessaText = (0, $3da5u.default).span`
  font-size: 18px;
`;
const $b5e7392b5d451c30$var$footerLanguageOptions = [
    {
        value: 'fi',
        label: 'Suomi (fi)'
    },
    {
        value: 'sv',
        label: 'Svenska (sv)'
    },
    {
        value: 'en',
        label: 'English (en)'
    }
];
const $b5e7392b5d451c30$var$FooterLanguageSelectBase = ({ id: id, className: className })=>{
    const { t: t } = (0, $2eqHs.useTranslation)();
    const [currentLanguage, setCurrentLanguage] = (0, $jyFzD.useLocalStorage)('currentLanguage', 'fi');
    return (0, $caZvI.jsx)($b5e7392b5d451c30$var$FooterLanguageSelectWrapper, {
        className: className,
        children: (0, $caZvI.jsx)((0, $dXNPX.UniSelectWithLabel), {
            id: id,
            label: t((0, $b1LPP.default).CHOOSE_LANGUAGE),
            value: currentLanguage,
            onChange: (value)=>setCurrentLanguage(value),
            options: $b5e7392b5d451c30$var$footerLanguageOptions,
            small: true
        })
    });
};
const $b5e7392b5d451c30$var$FooterLanguageSelectWrapper = (0, $3da5u.default).div`
  position: relative;
`;
const $b5e7392b5d451c30$var$FooterLanguageSelect = (0, $3da5u.default)($b5e7392b5d451c30$var$FooterLanguageSelectBase)`
  position: relative;
  padding-top: 18px;
  margin-top: 18px;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 1px;
    width: 36px;
    background: ${(0, $hSeA2.GRAYSCALE_DARK)};
  }
`;
const $b5e7392b5d451c30$var$ShortcutColumn = (0, $3da5u.default).div`
  flex: 1 1 auto;

  ${(0, $1Hynf.fromTabletUp)((0, $3da5u.css)`
    flex: 0 1 50%;
  `)}
`;
var $b5e7392b5d451c30$export$2e2bcd8739ae039 = $b5e7392b5d451c30$var$Footer;

});
parcelRegister("6kYN4", function(module, exports) {

$parcel$export(module.exports, "UniParagraphAnchorStyles", function () { return $49d3c4133611e34a$export$8ef003aadb6aacb0; });
$parcel$export(module.exports, "UniParagraphStyles", function () { return $49d3c4133611e34a$export$97bb2b3989e910a; });
$parcel$export(module.exports, "UniParagraphSmallStyles", function () { return $49d3c4133611e34a$export$96d9d88cb34357eb; });
$parcel$export(module.exports, "UniParagraphSemiBoldStyles", function () { return $49d3c4133611e34a$export$84c36e878b22d7d2; });
$parcel$export(module.exports, "UniParagraphNoMarginStyles", function () { return $49d3c4133611e34a$export$2b45d89e0a1f2ea7; });
$parcel$export(module.exports, "UniParagraphNoMarginTopStyles", function () { return $49d3c4133611e34a$export$bbc394f56d065; });
$parcel$export(module.exports, "UniParagraph", function () { return $49d3c4133611e34a$export$558292a1380f32e0; });

var $3da5u = parcelRequire("3da5u");

var $hSeA2 = parcelRequire("hSeA2");

var $bt0KQ = parcelRequire("bt0KQ");

var $1Hynf = parcelRequire("1Hynf");
const $49d3c4133611e34a$export$8ef003aadb6aacb0 = (0, $3da5u.css)`
  ${(0, $bt0KQ.DEFAULT_FONT)}
  appearance: none;
  border: none;
  background: none;
  padding: 0;
  color: ${(0, $hSeA2.BRAND_MAIN)};
  font-size: 15px;
  line-height: 22px;
  font-weight: 600;
  transition-duration: 0.1s;
  transition-property: all;
  text-decoration: underline;
  text-underline-offset: 2px;
  text-decoration-thickness: 1px;

  ${(0, $1Hynf.fromTabletUp)((0, $3da5u.css)`
    font-size: 16px;
    line-height: 24px;
  `)}

  ${(0, $1Hynf.fromTabletUp)((0, $3da5u.css)`
    font-size: 16px;
    line-height: 24px;
  `)}

  &:hover {
    text-decoration-thickness: 2px;
  }

  &:focus-visible {
    outline: solid 2px ${(0, $hSeA2.ADDITIONAL_YELLOW)};
    outline-offset: 2px;
  }

  ${(0, $1Hynf.fromTabletUp)((0, $3da5u.css)`
    font-size: 16px;
  `)}
`;
const $49d3c4133611e34a$export$97bb2b3989e910a = (0, $3da5u.css)`
  color: ${(0, $hSeA2.GRAYSCALE_DARK_TEXT)};
  font-size: 15px;
  line-height: 22px;
  transition-duration: 0.1s;
  transition-property: all;

  ${(0, $bt0KQ.DEFAULT_FONT)}

  ${(0, $1Hynf.fromTabletUp)((0, $3da5u.css)`
    font-size: 16px;
    line-height: 24px;
  `)}

  a:not(.uni-button) {
    ${$49d3c4133611e34a$export$8ef003aadb6aacb0}
  }
`;
const $49d3c4133611e34a$export$96d9d88cb34357eb = (0, $3da5u.css)`
  font-size: 14px;
  line-height: 20px;
  margin: 8px 0;

  ${(0, $1Hynf.fromTabletUp)((0, $3da5u.css)`
    font-size: 15px;
    line-height: 22px;
    margin: 12px 0;
  `)}

  a {
    font-size: 14px;
    line-height: 20px;

    ${(0, $1Hynf.fromTabletUp)((0, $3da5u.css)`
      font-size: 15px;
      line-height: 22px;
    `)}
  }
`;
const $49d3c4133611e34a$export$84c36e878b22d7d2 = (0, $3da5u.css)`
  font-weight: 600;
`;
const $49d3c4133611e34a$export$2b45d89e0a1f2ea7 = (0, $3da5u.css)`
  margin: 0;

  ${(0, $1Hynf.fromTabletUp)((0, $3da5u.css)`
    margin: 0;
  `)}
`;
const $49d3c4133611e34a$export$bbc394f56d065 = (0, $3da5u.css)`
  margin-top: 0;

  ${(0, $1Hynf.fromTabletUp)((0, $3da5u.css)`
    margin-top: 0;
  `)}
`;
const $49d3c4133611e34a$export$558292a1380f32e0 = (0, $3da5u.default).p`
  ${$49d3c4133611e34a$export$97bb2b3989e910a}
  margin: 16px 0;

  ${(0, $1Hynf.fromTabletUp)((0, $3da5u.css)`
    margin: 24px 0;
  `)}

  ${(props)=>props.$muted && (0, $3da5u.css)`
      color: ${0, $hSeA2.GRAYSCALE_MEDIUM_TEXT};
    `}

  ${(props)=>props.$white && (0, $3da5u.css)`
      color: ${0, $hSeA2.GRAYSCALE_LIGHT};

      a:not(.uni-button) {
        color: ${0, $hSeA2.GRAYSCALE_LIGHT};
      }
    `}

  ${(props)=>props.$semiBold && $49d3c4133611e34a$export$84c36e878b22d7d2}

  ${({ $cursive: $cursive = false })=>$cursive && (0, $3da5u.css)`
      font-style: italic;
    `}

  ${({ $textAlignEnd: $textAlignEnd = false })=>$textAlignEnd && (0, $3da5u.css)`
      text-align: end;
    `}

  ${(props)=>props.$small && $49d3c4133611e34a$export$96d9d88cb34357eb}

  ${({ $wide: $wide })=>$wide && (0, $3da5u.css)`
      max-width: 800px;
    `}

  ${({ $narrow: $narrow })=>$narrow && (0, $3da5u.css)`
      max-width: 400px;
    `}


  ${({ $truncated: $truncated })=>$truncated && (0, $3da5u.css)`
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    `}

  ${(props)=>props.$noMargin && $49d3c4133611e34a$export$2b45d89e0a1f2ea7}

  ${(props)=>props.$noMarginTop && $49d3c4133611e34a$export$bbc394f56d065}

  ${(props)=>props.$noMarginBottom && (0, $3da5u.css)`
      margin-bottom: 0;

      ${(0, $1Hynf.fromTabletUp)((0, $3da5u.css)`
        margin-bottom: 0;
      `)}
    `}
`;

});

parcelRegister("edasP", function(module, exports) {

$parcel$export(module.exports, "UniShortcut", function () { return $a58a6584e8b49822$export$43e378f05616d665; });

var $caZvI = parcelRequire("caZvI");
parcelRequire("jpgPw");

var $3da5u = parcelRequire("3da5u");

var $b9h0p = parcelRequire("b9h0p");

var $hSeA2 = parcelRequire("hSeA2");

var $c3mfK = parcelRequire("c3mfK");

var $1Hynf = parcelRequire("1Hynf");

var $6kYN4 = parcelRequire("6kYN4");
const $a58a6584e8b49822$export$43e378f05616d665 = ({ links: links, row: row = true, grid: grid, small: small })=>{
    return (0, $caZvI.jsx)($a58a6584e8b49822$var$List, {
        "$type": grid ? 'grid' : row ? 'row' : undefined,
        "$small": small,
        children: links.map(({ id: id, link: link, title: title, external: external }, key)=>(0, $caZvI.jsx)($a58a6584e8b49822$var$ListItem, {
                children: (0, $caZvI.jsxs)($a58a6584e8b49822$var$Link, {
                    as: external ? $a58a6584e8b49822$var$ExternalLink : undefined,
                    to: external ? undefined : link,
                    href: external ? link : undefined,
                    id: id,
                    "$type": grid ? 'grid' : row ? 'row' : undefined,
                    "$small": small,
                    children: [
                        (0, $caZvI.jsx)($a58a6584e8b49822$var$Text, {
                            children: title
                        }),
                        (0, $caZvI.jsx)($a58a6584e8b49822$var$Icon, {
                            arrowRight: true,
                            "aria-hidden": true,
                            "$type": grid ? 'grid' : row ? 'row' : undefined,
                            "$external": external,
                            "$small": small
                        })
                    ]
                })
            }, key))
    });
};
const $a58a6584e8b49822$var$List = (0, $3da5u.default).ul`
  ${({ $type: $type })=>$type === 'row' && (0, $3da5u.css)`
      display: flex;
      flex-flow: row wrap;
      align-items: center;
      justify-content: space-between;
      gap: 1.5em;
      padding: 0;

      ${(0, $1Hynf.fromTabletUp)((0, $3da5u.css)`
        gap: 2.5em;
      `)}

      ${(0, $1Hynf.fromDesktopUp)((0, $3da5u.css)`
        gap: 5em;
      `)}
    `}

  ${({ $small: $small })=>$small && (0, $3da5u.css)`
      gap: 1em;

      ${(0, $1Hynf.fromTabletUp)((0, $3da5u.css)`
        gap: 1.25em;
      `)}

      ${(0, $1Hynf.fromDesktopUp)((0, $3da5u.css)`
        gap: 2.5em;
      `)}
    `}

  ${({ $type: $type })=>$type === 'grid' && (0, $3da5u.css)`
      display: grid;
      grid-template-columns: 1fr;
      column-gap: 1.5em;
      padding: 0;

      ${(0, $1Hynf.fromTabletUp)((0, $3da5u.css)`
        grid-template-columns: 1fr 1fr;
      `)}
    `}
`;
const $a58a6584e8b49822$var$ListItem = (0, $3da5u.default).li`
  flex: 1 1 auto;
  position: relative;
  list-style: none;
`;
const $a58a6584e8b49822$var$Link = (0, $3da5u.default)((0, $b9h0p.Link))`
  ${(0, $6kYN4.UniParagraphAnchorStyles)}
  color: ${(0, $hSeA2.GRAYSCALE_BLACK)};
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;

  ${({ $type: $type })=>$type === 'row' && (0, $3da5u.css)`
      border-block-start: 3px solid ${0, $hSeA2.GRAYSCALE_BLACK};
      border-block-end: 3px solid ${0, $hSeA2.GRAYSCALE_BLACK};
      padding-block: 1em;
    `}

  ${({ $small: $small })=>$small && (0, $3da5u.css)`
      border-block-start: 1px solid ${0, $hSeA2.GRAYSCALE_BLACK};
    `}

  ${({ $type: $type, $small: $small })=>($type === 'grid' || $small) && (0, $3da5u.css)`
      border-block-end: 1px solid ${0, $hSeA2.GRAYSCALE_BLACK};
      padding-block: 0.5em;
    `}
`;
const $a58a6584e8b49822$var$ExternalLink = (0, $3da5u.default).a``;
const $a58a6584e8b49822$var$Text = (0, $3da5u.default).span`
  padding-right: 36px;
`;
const $a58a6584e8b49822$var$Icon = (0, $3da5u.default)((0, $c3mfK.HyIcon))`
  position: absolute;
  right: 0;
  width: 24px;
  font-size: 1.65em;
  color: ${(0, $hSeA2.BRAND_MAIN_LIGHT)};
  text-align: right;

  ${({ $type: $type, $external: $external })=>$type === 'row' && $external && (0, $3da5u.css)`
      transform: scale(0.88) translate(0, -3%) rotate(-45deg);
    `}

  ${({ $type: $type, $external: $external, $small: $small })=>($type === 'grid' || $small) && $external && (0, $3da5u.css)`
      transform: scale(0.55) translate(0, -3%) rotate(-45deg);
    `}

    ${({ $type: $type, $external: $external })=>$type === 'row' && !$external && (0, $3da5u.css)`
      transform: scale(0.88) translate(0, -3%);
    `}

  ${({ $type: $type, $external: $external, $small: $small })=>($type === 'grid' || $small) && !$external && (0, $3da5u.css)`
      transform: scale(0.5) translate(0, -3%);
    `}

  ${$a58a6584e8b49822$var$Link}:hover & {
  }
`;

});
parcelRegister("b9h0p", function(module, exports) {

$parcel$export(module.exports, "BrowserRouter", function () { return $81ddb9f191747cdc$export$9ba4e89fdfa1fc54; });
$parcel$export(module.exports, "Link", function () { return $81ddb9f191747cdc$export$a6c7ac8248d6e38a; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $2lzVq = parcelRequire("2lzVq");

var $aDbDg = parcelRequire("aDbDg");

var $jcvU7 = parcelRequire("jcvU7");

var $e1hMf = parcelRequire("e1hMf");

var $1e0kC = parcelRequire("1e0kC");

var $bdpx3 = parcelRequire("bdpx3");

var $jGoV5 = parcelRequire("jGoV5");

var $89PPr = parcelRequire("89PPr");

var $lx2i2 = parcelRequire("lx2i2");

var $loa1n = parcelRequire("loa1n");

var $jpgPw = parcelRequire("jpgPw");
//#region lib/dom/lib.tsx
const $81ddb9f191747cdc$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($81ddb9f191747cdc$var$isBrowser) window.__reactRouterVersion = "8";
} catch  {}
/**
* Create a new {@link DataRouter| data router} that manages the application
* path via [`history.pushState`](https://developer.mozilla.org/en-US/docs/Web/API/History/pushState)
* and [`history.replaceState`](https://developer.mozilla.org/en-US/docs/Web/API/History/replaceState).
*
* Data Routers should not be held in React state. You should create your router
* once outside of the React tree and pass it to {@link RouterProvider | `<RouterProvider>`}.
* You can use `patchRoutesOnNavigation` to add additional routes programmatically.
*
* @public
* @category Data Routers
* @mode data
* @param routes Application routes
* @param opts Options
* @param {DOMRouterOpts.basename} opts.basename n/a
* @param {DOMRouterOpts.dataStrategy} opts.dataStrategy n/a
* @param {DOMRouterOpts.future} opts.future n/a
* @param {DOMRouterOpts.getContext} opts.getContext n/a
* @param {DOMRouterOpts.hydrationData} opts.hydrationData n/a
* @param {DOMRouterOpts.instrumentations} opts.instrumentations n/a
* @param {DOMRouterOpts.patchRoutesOnNavigation} opts.patchRoutesOnNavigation n/a
* @param {DOMRouterOpts.window} opts.window n/a
* @returns An initialized {@link DataRouter| data router} to pass to {@link RouterProvider | `<RouterProvider>`}
*/ function $81ddb9f191747cdc$export$1f3f55432a00e06d(routes, opts) {
    return (0, $e1hMf.createRouter)({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: (0, $aDbDg.createBrowserHistory)({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $81ddb9f191747cdc$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $jcvU7.defaultMapRouteProperties),
        hydrationRouteProperties: $lx2i2.hydrationRouteProperties,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
/**
* Create a new {@link DataRouter| data router} that manages the application
* path via the URL [`hash`](https://developer.mozilla.org/en-US/docs/Web/API/URL/hash).
*
* Data Routers should not be held in React state. You should create your router
* once outside of the React tree and pass it to {@link RouterProvider | `<RouterProvider>`}.
* You can use `patchRoutesOnNavigation` to add additional routes programmatically.
*
* @public
* @category Data Routers
* @mode data
* @param routes Application routes
* @param opts Options
* @param {DOMRouterOpts.basename} opts.basename n/a
* @param {DOMRouterOpts.future} opts.future n/a
* @param {DOMRouterOpts.getContext} opts.getContext n/a
* @param {DOMRouterOpts.hydrationData} opts.hydrationData n/a
* @param {DOMRouterOpts.instrumentations} opts.instrumentations n/a
* @param {DOMRouterOpts.dataStrategy} opts.dataStrategy n/a
* @param {DOMRouterOpts.patchRoutesOnNavigation} opts.patchRoutesOnNavigation n/a
* @param {DOMRouterOpts.window} opts.window n/a
* @returns An initialized {@link DataRouter| data router} to pass to {@link RouterProvider | `<RouterProvider>`}
*/ function $81ddb9f191747cdc$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $e1hMf.createRouter)({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: (0, $aDbDg.createHashHistory)({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $81ddb9f191747cdc$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $jcvU7.defaultMapRouteProperties),
        hydrationRouteProperties: $lx2i2.hydrationRouteProperties,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $81ddb9f191747cdc$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $81ddb9f191747cdc$var$deserializeErrors(state.errors)
    };
    return state;
}
function $81ddb9f191747cdc$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries)if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $jcvU7.ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
    else if (val && val.__type === "Error") {
        if (typeof val.__subType === "string" && (0, $jcvU7.SUPPORTED_ERROR_TYPES).includes(val.__subType)) {
            let ErrorConstructor = window[val.__subType];
            if (typeof ErrorConstructor === "function") try {
                let error = new ErrorConstructor(val.message);
                error.stack = "";
                serialized[key] = error;
            } catch  {}
        }
        if (serialized[key] == null) {
            let error = new Error(val.message);
            error.stack = "";
            serialized[key] = error;
        }
    } else serialized[key] = val;
    return serialized;
}
/**
* A declarative {@link Router | `<Router>`} using the browser [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* API for client-side routing.
*
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {BrowserRouterProps.basename} props.basename n/a
* @param {BrowserRouterProps.children} props.children n/a
* @param {BrowserRouterProps.useTransitions} props.useTransitions n/a
* @param {BrowserRouterProps.window} props.window n/a
* @returns A declarative {@link Router | `<Router>`} using the browser [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* API for client-side routing.
*/ function $81ddb9f191747cdc$export$9ba4e89fdfa1fc54({ basename: basename, children: children, useTransitions: useTransitions, window: window1 }) {
    let historyRef = $jpgPw.useRef(null);
    if (historyRef.current == null) historyRef.current = (0, $aDbDg.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $jpgPw.useState({
        action: history.action,
        location: history.location
    });
    let setState = $jpgPw.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $jpgPw.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $jpgPw.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $jpgPw.createElement((0, $lx2i2.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
/**
* A declarative {@link Router | `<Router>`} that stores the location in the
* [`hash`](https://developer.mozilla.org/en-US/docs/Web/API/URL/hash) portion
* of the URL so it is not sent to the server.
*
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {HashRouterProps.basename} props.basename n/a
* @param {HashRouterProps.children} props.children n/a
* @param {HashRouterProps.useTransitions} props.useTransitions n/a
* @param {HashRouterProps.window} props.window n/a
* @returns A declarative {@link Router | `<Router>`} using the URL [`hash`](https://developer.mozilla.org/en-US/docs/Web/API/URL/hash)
* for client-side routing.
*/ function $81ddb9f191747cdc$export$7221d69dcfc8e36b({ basename: basename, children: children, useTransitions: useTransitions, window: window1 }) {
    let historyRef = $jpgPw.useRef(null);
    if (historyRef.current == null) historyRef.current = (0, $aDbDg.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $jpgPw.useState({
        action: history.action,
        location: history.location
    });
    let setState = $jpgPw.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $jpgPw.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $jpgPw.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $jpgPw.createElement((0, $lx2i2.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
/**
* A declarative {@link Router | `<Router>`} that accepts a pre-instantiated
* `history` object.
* It's important to note that using your own `history` object is highly discouraged
* and may add two versions of the `history` library to your bundles unless you use
* the same version of the `history` library that React Router uses internally.
*
* @name unstable_HistoryRouter
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {HistoryRouterProps.basename} props.basename n/a
* @param {HistoryRouterProps.children} props.children n/a
* @param {HistoryRouterProps.history} props.history n/a
* @param {HistoryRouterProps.useTransitions} props.useTransitions n/a
* @returns A declarative {@link Router | `<Router>`} using the provided history
* implementation for client-side routing.
*/ function $81ddb9f191747cdc$export$de73885c9336221c({ basename: basename, children: children, history: history, useTransitions: useTransitions }) {
    let [state, setStateImpl] = $jpgPw.useState({
        action: history.action,
        location: history.location
    });
    let setState = $jpgPw.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $jpgPw.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $jpgPw.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $jpgPw.createElement((0, $lx2i2.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
$81ddb9f191747cdc$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
/**
* A progressively enhanced [`<a href>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a)
* wrapper to enable navigation with client-side routing.
*
* @example
* import { Link } from "react-router";
*
* <Link to="/dashboard">Dashboard</Link>;
*
* <Link
*   to={{
*     pathname: "/some/path",
*     search: "?query=string",
*     hash: "#hash",
*   }}
* />;
*
* @public
* @category Components
* @param {LinkProps.discover} props.discover [modes: framework] n/a
* @param {LinkProps.prefetch} props.prefetch [modes: framework] n/a
* @param {LinkProps.preventScrollReset} props.preventScrollReset [modes: framework, data] n/a
* @param {LinkProps.relative} props.relative n/a
* @param {LinkProps.reloadDocument} props.reloadDocument n/a
* @param {LinkProps.replace} props.replace n/a
* @param {LinkProps.state} props.state n/a
* @param {LinkProps.to} props.to n/a
* @param {LinkProps.viewTransition} props.viewTransition [modes: framework, data] n/a
* @param {LinkProps.defaultShouldRevalidate} props.defaultShouldRevalidate n/a
* @param {LinkProps.mask} props.mask [modes: framework, data] n/a
*/ const $81ddb9f191747cdc$export$a6c7ac8248d6e38a = $jpgPw.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace, mask: mask, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...rest }, forwardedRef) {
    let { basename: basename, navigator: navigator, useTransitions: useTransitions } = $jpgPw.useContext((0, $1e0kC.NavigationContext));
    let isAbsolute = typeof to === "string" && (0, $2lzVq.ABSOLUTE_URL_REGEX).test(to);
    let parsed = (0, $jcvU7.parseToInfo)(to, basename);
    to = parsed.to;
    let href = (0, $bdpx3.useHref)(to, {
        relative: relative
    });
    let location = (0, $bdpx3.useLocation)();
    let maskedHref = null;
    if (mask) {
        let resolved = (0, $jcvU7.resolveTo)(mask, [], location.mask ? location.mask.pathname : "/", true);
        if (basename !== "/") resolved.pathname = resolved.pathname === "/" ? basename : (0, $jcvU7.joinPaths)([
            basename,
            resolved.pathname
        ]);
        maskedHref = navigator.createHref(resolved);
    }
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = (0, $89PPr.usePrefetchBehavior)(prefetch, rest);
    let internalOnClick = $81ddb9f191747cdc$export$67621102c14d847(to, {
        replace: replace,
        mask: mask,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        defaultShouldRevalidate: defaultShouldRevalidate,
        useTransitions: useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let isSpaLink = !(parsed.isExternal || reloadDocument);
    let link = /* @__PURE__ */ $jpgPw.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: (isSpaLink ? maskedHref : void 0) || parsed.absoluteURL || href,
        onClick: isSpaLink ? handleClick : onClick,
        ref: (0, $89PPr.mergeRefs)(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $jpgPw.createElement($jpgPw.Fragment, null, link, /* @__PURE__ */ $jpgPw.createElement((0, $89PPr.PrefetchPageLinks), {
        page: href
    })) : link;
});
$81ddb9f191747cdc$export$a6c7ac8248d6e38a.displayName = "Link";
/**
* Wraps {@link Link | `<Link>`} with additional props for styling active and
* pending states.
*
* - Automatically applies classes to the link based on its `active` and `pending`
* states, see {@link NavLinkProps.className}
*   - Note that `pending` is only available with Framework and Data modes.
* - Automatically applies `aria-current="page"` to the link when the link is active.
* See [`aria-current`](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-current)
* on MDN.
* - States are additionally available through the className, style, and children
* render props. See {@link NavLinkRenderProps}.
*
* @example
* <NavLink to="/message">Messages</NavLink>
*
* // Using render props
* <NavLink
*   to="/messages"
*   className={({ isActive, isPending }) =>
*     isPending ? "pending" : isActive ? "active" : ""
*   }
* >
*   Messages
* </NavLink>
*
* @public
* @category Components
* @param {NavLinkProps.caseSensitive} props.caseSensitive n/a
* @param {NavLinkProps.children} props.children n/a
* @param {NavLinkProps.className} props.className n/a
* @param {NavLinkProps.discover} props.discover [modes: framework] n/a
* @param {NavLinkProps.end} props.end n/a
* @param {NavLinkProps.prefetch} props.prefetch [modes: framework] n/a
* @param {NavLinkProps.preventScrollReset} props.preventScrollReset [modes: framework, data] n/a
* @param {NavLinkProps.relative} props.relative n/a
* @param {NavLinkProps.reloadDocument} props.reloadDocument n/a
* @param {NavLinkProps.replace} props.replace n/a
* @param {NavLinkProps.state} props.state n/a
* @param {NavLinkProps.style} props.style n/a
* @param {NavLinkProps.to} props.to n/a
* @param {NavLinkProps.viewTransition} props.viewTransition [modes: framework, data] n/a
*/ const $81ddb9f191747cdc$export$b0d92dbee9b5b60d = $jpgPw.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = (0, $bdpx3.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $bdpx3.useLocation)();
    let routerNavigation = $jpgPw.useContext((0, $1e0kC.DataRouterNavigationContext));
    let { navigator: navigator, basename: basename } = $jpgPw.useContext((0, $1e0kC.NavigationContext));
    let isTransitioning = routerNavigation != null && $81ddb9f191747cdc$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerNavigation?.navigation.location ? routerNavigation.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $jcvU7.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(endSlashPosition) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $jpgPw.createElement($81ddb9f191747cdc$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$81ddb9f191747cdc$export$b0d92dbee9b5b60d.displayName = "NavLink";
/**
* A progressively enhanced HTML [`<form>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form)
* that submits data to actions via [`fetch`](https://developer.mozilla.org/en-US/docs/Web/API/fetch),
* activating pending states in {@link useNavigation} which enables advanced
* user interfaces beyond a basic HTML [`<form>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form).
* After a form's `action` completes, all data on the page is automatically
* revalidated to keep the UI in sync with the data.
*
* Because it uses the HTML form API, server rendered pages are interactive at a
* basic level before JavaScript loads. Instead of React Router managing the
* submission, the browser manages the submission as well as the pending states
* (like the spinning favicon). After JavaScript loads, React Router takes over
* enabling web application user experiences.
*
* `Form` is most useful for submissions that should also change the URL or
* otherwise add an entry to the browser history stack. For forms that shouldn't
* manipulate the browser [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* stack, use {@link FetcherWithComponents.Form | `<fetcher.Form>`}.
*
* @example
* import { Form } from "react-router";
*
* function NewEvent() {
*   return (
*     <Form action="/events" method="post">
*       <input name="title" type="text" />
*       <input name="description" type="text" />
*     </Form>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @mode data
* @param {FormProps.action} action n/a
* @param {FormProps.discover} discover n/a
* @param {FormProps.encType} encType n/a
* @param {FormProps.fetcherKey} fetcherKey n/a
* @param {FormProps.method} method n/a
* @param {FormProps.navigate} navigate n/a
* @param {FormProps.preventScrollReset} preventScrollReset n/a
* @param {FormProps.relative} relative n/a
* @param {FormProps.reloadDocument} reloadDocument n/a
* @param {FormProps.replace} replace n/a
* @param {FormProps.state} state n/a
* @param {FormProps.viewTransition} viewTransition n/a
* @param {FormProps.defaultShouldRevalidate} defaultShouldRevalidate n/a
* @returns A progressively enhanced [`<form>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form) component
*/ const $81ddb9f191747cdc$export$a7fed597f4b8afd8 = $jpgPw.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = "get", action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...props }, forwardedRef)=>{
    let { useTransitions: useTransitions } = $jpgPw.useContext((0, $1e0kC.NavigationContext));
    let submit = $81ddb9f191747cdc$export$47c85c6e3a081d3();
    let formAction = $81ddb9f191747cdc$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && (0, $2lzVq.ABSOLUTE_URL_REGEX).test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
        if (useTransitions && navigate !== false) $jpgPw.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $jpgPw.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$81ddb9f191747cdc$export$a7fed597f4b8afd8.displayName = "Form";
/**
* Emulates the browser's scroll restoration on location changes. Apps should only render one of these, right before the {@link Scripts} component.
*
* ```tsx
* import { ScrollRestoration } from "react-router";
*
* export default function Root() {
*   return (
*     <html>
*       <body>
*         <ScrollRestoration />
*         <Scripts />
*       </body>
*     </html>
*   );
* }
* ```
*
* This component renders an inline `<script>` to prevent scroll flashing. The
* `nonce` prop will be passed down to the script tag to allow CSP nonce usage.
* If not provided in Framework Mode, it will default to any
* {@link ServerRouter | `<ServerRouter nonce>`} prop.
*
* ```tsx
* <ScrollRestoration nonce={cspNonce} />
* ```
*
* @public
* @category Components
* @mode framework
* @mode data
* @param props Props
* @param {ScrollRestorationProps.getKey} props.getKey n/a
* @param {ScriptsProps.nonce} props.nonce n/a
* @param {ScrollRestorationProps.storageKey} props.storageKey n/a
* @returns A [`<script>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/script)
* tag that restores scroll positions on navigation.
*/ function $81ddb9f191747cdc$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $jpgPw.useContext((0, $89PPr.FrameworkContext));
    let { basename: basename } = $jpgPw.useContext((0, $1e0kC.NavigationContext));
    let location = (0, $bdpx3.useLocation)();
    let matches = (0, $bdpx3.useMatches)();
    $81ddb9f191747cdc$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $jpgPw.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $81ddb9f191747cdc$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let storedY = JSON.parse(sessionStorage.getItem(storageKey) || "{}")[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey);
        }
    }).toString();
    if (props.nonce == null && remixContext?.nonce) props.nonce = remixContext.nonce;
    return /* @__PURE__ */ $jpgPw.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${(0, $jGoV5.escapeHtml)(JSON.stringify(storageKey || $81ddb9f191747cdc$var$SCROLL_RESTORATION_STORAGE_KEY))}, ${(0, $jGoV5.escapeHtml)(JSON.stringify(ssrKey))})`
        }
    });
}
$81ddb9f191747cdc$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
/**
* Handles the click behavior for router {@link Link | `<Link>`} components.This
* is useful if you need to create custom {@link Link | `<Link>`} components with
* the same click behavior we use in our exported {@link Link | `<Link>`}.
*
* @public
* @category Hooks
* @param to The URL to navigate to, can be a string or a partial {@link Path}.
* @param options Options
* @param options.preventScrollReset Whether to prevent the scroll position from
* being reset to the top of the viewport on completion of the navigation when
* using the {@link ScrollRestoration} component. Defaults to `false`.
* @param options.relative The {@link RelativeRoutingType | relative routing type}
* to use for the link. Defaults to `"route"`.
* @param options.replace Whether to replace the current [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* entry instead of pushing a new one. Defaults to `false`.
* @param options.state The state to add to the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* entry for this navigation. Defaults to `undefined`.
* @param options.target The target attribute for the link. Defaults to `undefined`.
* @param options.viewTransition **Deprecated.** Use React's
* [`<ViewTransition>`](https://react.dev/reference/react/ViewTransition) component
* instead. See the [migration guide](../../how-to/view-transitions).
* @param options.defaultShouldRevalidate Specify the default revalidation
* behavior for the navigation. When not specified, loaders revalidate
* according to the router's standard revalidation behavior.
* @param options.mask Masked location to display in the browser instead
* of the router location. Defaults to `undefined`.
* @param options.useTransitions Wraps the navigation in
* [`React.startTransition`](https://react.dev/reference/react/startTransition)
* for concurrent rendering. Defaults to `false`.
* @returns A click handler function that can be used in a custom {@link Link} component.
*/ function $81ddb9f191747cdc$export$67621102c14d847(to, { target: target, replace: replaceProp, mask: mask, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, useTransitions: useTransitions } = {}) {
    let navigate = (0, $bdpx3.useNavigate)();
    let location = (0, $bdpx3.useLocation)();
    let path = (0, $bdpx3.useResolvedPath)(to, {
        relative: relative
    });
    return $jpgPw.useCallback((event)=>{
        if ((0, $loa1n.shouldProcessLinkClick)(event, target)) {
            event.preventDefault();
            let replace = replaceProp !== void 0 ? replaceProp : (0, $aDbDg.createPath)(location) === (0, $aDbDg.createPath)(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace,
                    mask: mask,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    defaultShouldRevalidate: defaultShouldRevalidate
                });
            if (useTransitions) $jpgPw.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        mask,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        defaultShouldRevalidate,
        useTransitions
    ]);
}
/**
* Returns a tuple of the current URL's [`URLSearchParams`](https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams)
* and a function to update them. Setting the search params causes a navigation.
*
* ```tsx
* import { useSearchParams } from "react-router";
*
* export function SomeComponent() {
*   const [searchParams, setSearchParams] = useSearchParams();
*   // ...
* }
* ```
*
* ### `setSearchParams` function
*
* The second element of the tuple is a function that can be used to update the
* search params. It accepts the same types as `defaultInit` and will cause a
* navigation to the new URL.
*
* ```tsx
* let [searchParams, setSearchParams] = useSearchParams();
*
* // a search param string
* setSearchParams("?tab=1");
*
* // a shorthand object
* setSearchParams({ tab: "1" });
*
* // object keys can be arrays for multiple values on the key
* setSearchParams({ brand: ["nike", "reebok"] });
*
* // an array of tuples
* setSearchParams([["tab", "1"]]);
*
* // a `URLSearchParams` object
* setSearchParams(new URLSearchParams("?tab=1"));
* ```
*
* It also supports a function callback like React's
* [`setState`](https://react.dev/reference/react/useState#setstate):
*
* ```tsx
* setSearchParams((searchParams) => {
*   searchParams.set("tab", "2");
*   return searchParams;
* });
* ```
*
* <docs-warning>The function callback version of `setSearchParams` does not support
* the [queueing](https://react.dev/reference/react/useState#setstate-parameters)
* logic that React's `setState` implements.  Multiple calls to `setSearchParams`
* in the same tick will not build on the prior value.  If you need this behavior,
* you can use `setState` manually.</docs-warning>
*
* ### Notes
*
* Note that `searchParams` is a stable reference, so you can reliably use it
* as a dependency in React's [`useEffect`](https://react.dev/reference/react/useEffect)
* hooks.
*
* ```tsx
* useEffect(() => {
*   console.log(searchParams.get("tab"));
* }, [searchParams]);
* ```
*
* However, this also means it's mutable. If you change the object without
* calling `setSearchParams`, its values will change between renders if some
* other state causes the component to re-render and URL will not reflect the
* values.
*
* @public
* @category Hooks
* @param defaultInit
* You can initialize the search params with a default value, though it **will
* not** change the URL on the first render.
*
* ```tsx
* // a search param string
* useSearchParams("?tab=1");
*
* // a shorthand object
* useSearchParams({ tab: "1" });
*
* // object keys can be arrays for multiple values on the key
* useSearchParams({ brand: ["nike", "reebok"] });
*
* // an array of tuples
* useSearchParams([["tab", "1"]]);
*
* // a `URLSearchParams` object
* useSearchParams(new URLSearchParams("?tab=1"));
* ```
* @returns A tuple of the current [`URLSearchParams`](https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams)
* and a function to update them.
*/ function $81ddb9f191747cdc$export$f1a78c17382fe22a(defaultInit) {
    (0, $aDbDg.warning)(typeof URLSearchParams !== "undefined", "You cannot use the `useSearchParams` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.");
    let defaultSearchParamsRef = $jpgPw.useRef((0, $loa1n.createSearchParams)(defaultInit));
    let hasSetSearchParamsRef = $jpgPw.useRef(false);
    let location = (0, $bdpx3.useLocation)();
    let searchParams = $jpgPw.useMemo(()=>(0, $loa1n.getSearchParamsForLocation)(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $bdpx3.useNavigate)();
    return [
        searchParams,
        $jpgPw.useCallback((nextInit, navigateOptions)=>{
            const newSearchParams = (0, $loa1n.createSearchParams)(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
            hasSetSearchParamsRef.current = true;
            navigate("?" + newSearchParams, navigateOptions);
        }, [
            navigate,
            searchParams
        ])
    ];
}
let $81ddb9f191747cdc$var$fetcherId = 0;
let $81ddb9f191747cdc$var$getUniqueFetcherId = ()=>`__${String(++$81ddb9f191747cdc$var$fetcherId)}__`;
/**
* The imperative version of {@link Form | `<Form>`} that lets you submit a form
* from code instead of a user interaction.
*
* The `viewTransition` submission option is deprecated. Use React's
* [`<ViewTransition>`](https://react.dev/reference/react/ViewTransition) component
* instead. See the [migration guide](../../how-to/view-transitions).
*
* @example
* import { useSubmit } from "react-router";
*
* function SomeComponent() {
*   const submit = useSubmit();
*   return (
*     <Form onChange={(event) => submit(event.currentTarget)} />
*   );
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns A function that can be called to submit a {@link Form} imperatively.
*/ function $81ddb9f191747cdc$export$47c85c6e3a081d3() {
    let { router: router } = (0, $bdpx3.useDataRouterContext)("useSubmit");
    let { basename: basename } = $jpgPw.useContext((0, $1e0kC.NavigationContext));
    let currentRouteId = (0, $bdpx3.useCurrentRouteId)("useSubmit");
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $jpgPw.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = (0, $loa1n.getFormSubmissionInfo)(target, basename);
        if (options.navigate === false) await routerFetch(options.fetcherKey || $81ddb9f191747cdc$var$getUniqueFetcherId(), currentRouteId, options.action || action, {
            defaultShouldRevalidate: options.defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            relative: options.relative,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            flushSync: options.flushSync
        });
        else await routerNavigate(options.action || action, {
            defaultShouldRevalidate: options.defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            relative: options.relative,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
/**
* Resolves the URL to the closest route in the component hierarchy instead of
* the current URL of the app.
*
* This is used internally by {@link Form} to resolve the `action` to the closest
* route, but can be used generically as well.
*
* ```ts
* import { useFormAction } from "react-router";
*
* function SomeComponent() {
*   // closest route URL
*   let action = useFormAction();
*
*   // closest route URL + "destroy"
*   let destroyAction = useFormAction("destroy");
* }
* ```
*
* <docs-info>This hook adds a `basename` if your app specifies one, so that it
* can be used with raw `<form>` elements in a progressively enhanced way.  If
* you are using this to provide an `action` to `<Form>` or `fetcher.submit`, you
* will need to remove the `basename` since both of those will prepend it
* internally.</docs-info>
*
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param action The action to append to the closest route URL. Defaults to the
* closest route URL.
* @param options Options
* @param options.relative The relative routing type to use when resolving the
* action. Defaults to `"route"`.
* @returns The resolved action URL.
*/ function $81ddb9f191747cdc$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $jpgPw.useContext((0, $1e0kC.NavigationContext));
    let routeContext = $jpgPw.useContext((0, $1e0kC.RouteContext));
    (0, $aDbDg.invariant)(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...(0, $bdpx3.useResolvedPath)(action ? action : ".", {
            relative: relative
        })
    };
    let location = (0, $bdpx3.useLocation)();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        if (indexValues.some((v)=>v === "")) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $jcvU7.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $aDbDg.createPath)(path);
}
/**
* Useful for creating complex, dynamic user interfaces that require multiple,
* concurrent data interactions without causing a navigation.
*
* Fetchers track their own, independent state and can be used to load data, submit
* forms, and generally interact with [`action`](../../start/framework/route-module#action)
* and [`loader`](../../start/framework/route-module#loader) functions.
*
* @example
* import { useFetcher } from "react-router"
*
* function SomeComponent() {
*   let fetcher = useFetcher()
*
*   // states are available on the fetcher
*   fetcher.state // "idle" | "loading" | "submitting"
*   fetcher.data // the data returned from the action or loader
*
*   // render a form
*   <fetcher.Form method="post" />
*
*   // load data
*   fetcher.load("/some/route")
*
*   // submit data
*   fetcher.submit(someFormRef, { method: "post" })
*   fetcher.submit(someData, {
*     method: "post",
*     encType: "application/json"
*   })
*
*   // reset fetcher
*   fetcher.reset()
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param options Options
* @param options.key A unique key to identify the fetcher.
*
*
* By default, `useFetcher` generates a unique fetcher scoped to that component.
* If you want to identify a fetcher with your own key such that you can access
* it from elsewhere in your app, you can do that with the `key` option:
*
* ```tsx
* function SomeComp() {
*   let fetcher = useFetcher({ key: "my-key" })
*   // ...
* }
*
* // Somewhere else
* function AnotherComp() {
*   // this will be the same fetcher, sharing the state across the app
*   let fetcher = useFetcher({ key: "my-key" });
*   // ...
* }
* ```
* @returns A {@link FetcherWithComponents} object that contains the fetcher's state, data, and components for submitting forms and loading data.
*/ function $81ddb9f191747cdc$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = (0, $bdpx3.useDataRouterContext)("useFetcher");
    let fetchersContext = (0, $bdpx3.useDataRouterFetchers)("useFetcher");
    let routeId = (0, $bdpx3.useCurrentRouteId)("useFetcher");
    let defaultKey = $jpgPw.useId();
    let [fetcherKey, setFetcherKey] = $jpgPw.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $jpgPw.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $jpgPw.useCallback(async (href, opts)=>{
        (0, $aDbDg.invariant)(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $81ddb9f191747cdc$export$47c85c6e3a081d3();
    let submit = $jpgPw.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $jpgPw.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $jpgPw.useMemo(()=>{
        let FetcherForm = $jpgPw.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $jpgPw.createElement($81ddb9f191747cdc$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm.displayName = "fetcher.Form";
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    let fetcher = fetchersContext.fetchers.get(fetcherKey) || (0, $e1hMf.IDLE_FETCHER);
    let data = fetchersContext.fetcherData.get(fetcherKey);
    return $jpgPw.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset,
            ...fetcher,
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data
    ]);
}
/**
* Returns an array of all in-flight {@link Fetcher}s. This is useful for components
* throughout the app that didn't create the fetchers but want to use their submissions
* to participate in optimistic UI.
*
* @example
* import { useFetchers } from "react-router";
*
* function SomeComponent() {
*   const fetchers = useFetchers();
*   fetchers[0].formData; // FormData
*   fetchers[0].state; // etc.
*   // ...
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns An array of all in-flight {@link Fetcher}s, each with a unique `key`
* property.
*/ function $81ddb9f191747cdc$export$fa996778a3a31087() {
    let { fetchers: fetchers } = (0, $bdpx3.useDataRouterFetchers)("useFetchers");
    return $jpgPw.useMemo(()=>Array.from(fetchers.entries()).map(([key, fetcher])=>({
                ...fetcher,
                key: key
            })), [
        fetchers
    ]);
}
const $81ddb9f191747cdc$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $81ddb9f191747cdc$var$savedScrollPositions = {};
function $81ddb9f191747cdc$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: (0, $jcvU7.stripBasename)(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
/**
* When rendered inside a {@link RouterProvider}, will restore scroll positions
* on navigations
*
* <!--
* Not marked `@public` because we only export as UNSAFE_ and therefore we don't
* maintain an .md file for this hook
* -->
*
* @name UNSAFE_useScrollRestoration
* @category Hooks
* @mode framework
* @mode data
* @param options Options
* @param options.getKey A function that returns a key to use for scroll restoration.
* This is useful for custom scroll restoration logic, such as using only the pathname
* so that subsequent navigations to prior paths will restore the scroll. Defaults
* to `location.key`.
* @param options.storageKey The key to use for storing scroll positions in
* `sessionStorage`. Defaults to `"react-router-scroll-positions"`.
* @returns {void}
*/ function $81ddb9f191747cdc$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = (0, $bdpx3.useDataRouterContext)("useScrollRestoration");
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = (0, $bdpx3.useDataRouterState)("useScrollRestoration");
    let { basename: basename } = $jpgPw.useContext((0, $1e0kC.NavigationContext));
    let location = (0, $bdpx3.useLocation)();
    let matches = (0, $bdpx3.useMatches)();
    let navigation = (0, $bdpx3.useNavigation)();
    $jpgPw.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $81ddb9f191747cdc$var$usePageShow($jpgPw.useCallback((event)=>{
        if (event.persisted) window.history.scrollRestoration = "manual";
    }, []));
    $81ddb9f191747cdc$var$usePageHide($jpgPw.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $81ddb9f191747cdc$var$getScrollRestorationKey(location, matches, basename, getKey);
            $81ddb9f191747cdc$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $81ddb9f191747cdc$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($81ddb9f191747cdc$var$savedScrollPositions));
        } catch (error) {
            (0, $aDbDg.warning)(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $jpgPw.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $81ddb9f191747cdc$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $81ddb9f191747cdc$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch  {}
        }, [
            storageKey
        ]);
        $jpgPw.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($81ddb9f191747cdc$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location, matches)=>$81ddb9f191747cdc$var$getScrollRestorationKey(location, matches, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $jpgPw.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                (0, $aDbDg.warning)(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
* Set up a callback to be fired on [Window's `beforeunload` event](https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event).
*
* @public
* @category Hooks
* @param callback The callback to be called when the [`beforeunload` event](https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event)
* is fired.
* @param options Options
* @param options.capture If `true`, the event will be captured during the capture
* phase. Defaults to `false`.
* @returns {void}
*/ function $81ddb9f191747cdc$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $jpgPw.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $81ddb9f191747cdc$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $jpgPw.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $81ddb9f191747cdc$var$usePageShow(callback, options) {
    let { capture: capture } = options || {};
    $jpgPw.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pageshow", callback, opts);
        return ()=>{
            window.removeEventListener("pageshow", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
* Wrapper around {@link useBlocker} to show a [`window.confirm`](https://developer.mozilla.org/en-US/docs/Web/API/Window/confirm)
* prompt to users instead of building a custom UI with {@link useBlocker}.
*
* The `unstable_` flag will not be removed because this technique has a lot of
* rough edges and behaves very differently (and incorrectly sometimes) across
* browsers if users click addition back/forward navigations while the
* confirmation is open. Use at your own risk.
*
* @example
* function ImportantForm() {
*   let [value, setValue] = React.useState("");
*
*   // Block navigating elsewhere when data has been entered into the input
*   unstable_usePrompt({
*     message: "Are you sure?",
*     when: ({ currentLocation, nextLocation }) =>
*       value !== "" &&
*       currentLocation.pathname !== nextLocation.pathname,
*   });
*
*   return (
*     <Form method="post">
*       <label>
*         Enter some important data:
*         <input
*           name="data"
*           value={value}
*           onChange={(e) => setValue(e.target.value)}
*         />
*       </label>
*       <button type="submit">Save</button>
*     </Form>
*   );
* }
*
* @name unstable_usePrompt
* @public
* @category Hooks
* @mode framework
* @mode data
* @param options Options
* @param options.message The message to show in the confirmation dialog.
* @param options.when A boolean or a function that returns a boolean indicating
* whether to block the navigation. If a function is provided, it will receive an
* object with `currentLocation` and `nextLocation` properties.
* @returns {void}
*/ function $81ddb9f191747cdc$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = (0, $bdpx3.useBlocker)(when);
    $jpgPw.useEffect(()=>{
        if (blocker.state === "blocked") {
            if (window.confirm(message)) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $jpgPw.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
* **Deprecated.** Use React's [`<ViewTransition>`](https://react.dev/reference/react/ViewTransition)
* component to style transitions instead. This hook only tracks React Router's
* legacy view transitions, not transitions started by React. See the
* [migration guide](../../how-to/view-transitions).
*
* This hook returns `true` when there is an active [View Transition](https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API)
* and the specified location matches either side of the navigation (the URL you are
* navigating **to** or the URL you are navigating **from**). This can be used to apply finer-grained styles to
* elements to further customize the view transition. This requires that view
* transitions have been enabled for the given navigation via {@link LinkProps.viewTransition}
* (or the `Form`, `submit`, or `navigate` call)
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param to The {@link To} location to compare against the active transition's current
* and next URLs.
* @param options Options
* @param options.relative The relative routing type to use when resolving the
* `to` location, defaults to `"route"`. See {@link RelativeRoutingType} for
* more details.
* @returns `true` if there is an active [View Transition](https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API)
* and the resolved path matches the transition's destination or source pathname, otherwise `false`.
*
* @deprecated Use React's `<ViewTransition>` component instead.
*/ function $81ddb9f191747cdc$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $jpgPw.useContext((0, $1e0kC.ViewTransitionContext));
    (0, $aDbDg.invariant)(vtContext != null, "`useViewTransitionState` must be used within `react-router/dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = (0, $bdpx3.useDataRouterContext)("useViewTransitionState");
    let path = (0, $bdpx3.useResolvedPath)(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $jcvU7.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $jcvU7.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return (0, $jcvU7.matchPath)(path.pathname, nextPath) != null || (0, $jcvU7.matchPath)(path.pathname, currentPath) != null;
}

});
parcelRegister("2lzVq", function(module, exports) {

$parcel$export(module.exports, "ABSOLUTE_URL_REGEX", function () { return $1b5968f2727fee49$export$6c52c2011d568bd0; });
$parcel$export(module.exports, "PROTOCOL_RELATIVE_URL_REGEX", function () { return $1b5968f2727fee49$export$825a82322d91916e; });
$parcel$export(module.exports, "normalizeProtocolRelativeUrl", function () { return $1b5968f2727fee49$export$977999b735cd4f26; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/router/url.ts
const $1b5968f2727fee49$export$6c52c2011d568bd0 = /^(?:[a-z][a-z0-9+.-]*:|[\\/]{2})/i;
const $1b5968f2727fee49$export$825a82322d91916e = /^[\\/]{2}/;
function $1b5968f2727fee49$export$977999b735cd4f26(url, protocol) {
    return protocol + url.replace(/\\/g, "/");
}

});

parcelRegister("aDbDg", function(module, exports) {

$parcel$export(module.exports, "createMemoryHistory", function () { return $7bd691d13c7075f6$export$2b76ad033c6e6d08; });
$parcel$export(module.exports, "createLocation", function () { return $7bd691d13c7075f6$export$90c043f1c57770b8; });
$parcel$export(module.exports, "warning", function () { return $7bd691d13c7075f6$export$491112666e282270; });
$parcel$export(module.exports, "createPath", function () { return $7bd691d13c7075f6$export$fe53371bee54353d; });
$parcel$export(module.exports, "parsePath", function () { return $7bd691d13c7075f6$export$8ccf933b0513f8d0; });
$parcel$export(module.exports, "createBrowserHistory", function () { return $7bd691d13c7075f6$export$719fc203c4e16dee; });
$parcel$export(module.exports, "createHashHistory", function () { return $7bd691d13c7075f6$export$b71fdd3798280242; });
$parcel$export(module.exports, "invariant", function () { return $7bd691d13c7075f6$export$f5708dca728d7177; });
$parcel$export(module.exports, "createBrowserURLImpl", function () { return $7bd691d13c7075f6$export$e2450fce17852bf2; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $2lzVq = parcelRequire("2lzVq");
//#region lib/router/history.ts
/**
* Actions represent the type of change to a location value.
*/ let $7bd691d13c7075f6$export$e19cd5f9376f8cee = /* @__PURE__ */ function(Action) {
    /**
	* A POP indicates a change to an arbitrary index in the history stack, such
	* as a back or forward navigation. It does not describe the direction of the
	* navigation, only that the current index changed.
	*
	* Note: This is the default action for newly created history objects.
	*/ Action["Pop"] = "POP";
    /**
	* A PUSH indicates a new entry being added to the history stack, such as when
	* a link is clicked and a new page loads. When this happens, all subsequent
	* entries in the stack are lost.
	*/ Action["Push"] = "PUSH";
    /**
	* A REPLACE indicates the entry at the current index in the history stack
	* being replaced by a new one.
	*/ Action["Replace"] = "REPLACE";
    return Action;
}({});
const $7bd691d13c7075f6$var$PopStateEventType = "popstate";
function $7bd691d13c7075f6$var$isLocation(obj) {
    return typeof obj === "object" && obj != null && "pathname" in obj && "search" in obj && "hash" in obj && "state" in obj && "key" in obj;
}
/**
* Memory history stores the current location in memory. It is designed for use
* in stateful non-browser environments like tests and React Native.
*/ function $7bd691d13c7075f6$export$2b76ad033c6e6d08(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : void 0, typeof entry === "string" ? void 0 : entry.mask));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP";
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key, mask) {
        let location = $7bd691d13c7075f6$export$90c043f1c57770b8(entries ? getCurrentLocation().pathname : "/", to, state, key, mask);
        $7bd691d13c7075f6$export$491112666e282270(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $7bd691d13c7075f6$export$fe53371bee54353d(to);
    }
    return {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $7bd691d13c7075f6$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH";
            let nextLocation = $7bd691d13c7075f6$var$isLocation(to) ? to : createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE";
            let nextLocation = $7bd691d13c7075f6$var$isLocation(to) ? to : createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP";
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
}
/**
* Browser history stores the location in regular URLs. This is the standard for
* most web apps, but it requires some configuration on the server to ensure you
* serve the same app at multiple URLs.
*
* @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
*/ function $7bd691d13c7075f6$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window, globalHistory) {
        let maskedLocation = globalHistory.state?.masked;
        let { pathname: pathname, search: search, hash: hash } = maskedLocation || window.location;
        return $7bd691d13c7075f6$export$90c043f1c57770b8("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default", maskedLocation ? {
            pathname: window.location.pathname,
            search: window.location.search,
            hash: window.location.hash
        } : void 0);
    }
    function createBrowserHref(window, to) {
        return typeof to === "string" ? to : $7bd691d13c7075f6$export$fe53371bee54353d(to);
    }
    return $7bd691d13c7075f6$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
* Hash history stores the location in window.location.hash. This makes it ideal
* for situations where you don't want to send the location to the server for
* some reason, either because you do cannot configure it or the URL space is
* reserved for something else.
*
* @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
*/ function $7bd691d13c7075f6$export$b71fdd3798280242(options = {}) {
    function createHashLocation(window, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $7bd691d13c7075f6$export$8ccf933b0513f8d0(window.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $7bd691d13c7075f6$export$90c043f1c57770b8("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window, to) {
        let base = window.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $7bd691d13c7075f6$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $7bd691d13c7075f6$export$491112666e282270(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $7bd691d13c7075f6$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $7bd691d13c7075f6$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $7bd691d13c7075f6$export$491112666e282270(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch  {}
    }
}
function $7bd691d13c7075f6$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
/**
* For browser-based histories, we combine the state and key into an object
*/ function $7bd691d13c7075f6$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index,
        masked: location.mask ? {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash
        } : void 0
    };
}
/**
* Creates a Location object with a unique key from the given Path
*/ function $7bd691d13c7075f6$export$90c043f1c57770b8(current, to, state = null, key, mask) {
    return {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $7bd691d13c7075f6$export$8ccf933b0513f8d0(to) : to,
        state: state,
        key: to && to.key || key || $7bd691d13c7075f6$var$createKey(),
        mask: mask
    };
}
/**
* Creates a string URL path from the given pathname, search, and hash components.
*
* @public
* @category Utils
* @param path The pathname, search, and hash components to combine.
* @returns The combined URL path.
*/ function $7bd691d13c7075f6$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
* Parses a string URL path into its separate pathname, search, and hash components.
*
* @public
* @category Utils
* @param path The URL path to parse.
* @returns The parsed pathname, search, and hash components.
*/ function $7bd691d13c7075f6$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $7bd691d13c7075f6$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options = {}) {
    let { window: window = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window.history;
    let action = "POP";
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        return (globalHistory.state || {
            idx: null
        }).idx;
    }
    function handlePop() {
        action = "POP";
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH";
        let location = $7bd691d13c7075f6$var$isLocation(to) ? to : $7bd691d13c7075f6$export$90c043f1c57770b8(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $7bd691d13c7075f6$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = "REPLACE";
        let location = $7bd691d13c7075f6$var$isLocation(to) ? to : $7bd691d13c7075f6$export$90c043f1c57770b8(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $7bd691d13c7075f6$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $7bd691d13c7075f6$export$e2450fce17852bf2(window, to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window.addEventListener($7bd691d13c7075f6$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window.removeEventListener($7bd691d13c7075f6$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $7bd691d13c7075f6$export$e2450fce17852bf2(windowImpl, to, isAbsolute = false) {
    let base = "http://localhost";
    if (windowImpl) base = windowImpl.location.origin !== "null" ? windowImpl.location.origin : windowImpl.location.href;
    $7bd691d13c7075f6$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $7bd691d13c7075f6$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && (0, $2lzVq.PROTOCOL_RELATIVE_URL_REGEX).test(href)) href = base + href;
    return new URL(href, base);
}

});

parcelRegister("jcvU7", function(module, exports) {

$parcel$export(module.exports, "createContext", function () { return $dfa7e2cdccc31015$export$fd42f52fd3ae1109; });
$parcel$export(module.exports, "RouterContextProvider", function () { return $dfa7e2cdccc31015$export$b8d3e69d4b3eff04; });
$parcel$export(module.exports, "DiscoveryCancelledError", function () { return $dfa7e2cdccc31015$export$96cecaff35fb119d; });
$parcel$export(module.exports, "isUnsupportedLazyRouteObjectKey", function () { return $dfa7e2cdccc31015$export$3e22299e33adeed1; });
$parcel$export(module.exports, "isUnsupportedLazyRouteFunctionKey", function () { return $dfa7e2cdccc31015$export$a89d811eaa209e85; });
$parcel$export(module.exports, "defaultMapRouteProperties", function () { return $dfa7e2cdccc31015$export$6bc17138063be773; });
$parcel$export(module.exports, "convertRoutesToDataRoutes", function () { return $dfa7e2cdccc31015$export$87cb1a9238dc3fba; });
$parcel$export(module.exports, "matchRoutes", function () { return $dfa7e2cdccc31015$export$2708184779ceb39d; });
$parcel$export(module.exports, "matchRoutesImpl", function () { return $dfa7e2cdccc31015$export$5c7b09132f833c25; });
$parcel$export(module.exports, "stripBasename", function () { return $dfa7e2cdccc31015$export$b69e3301ce081aa3; });
$parcel$export(module.exports, "flattenAndRankRoutes", function () { return $dfa7e2cdccc31015$export$e486c0390e42ccf6; });
$parcel$export(module.exports, "decodePath", function () { return $dfa7e2cdccc31015$export$cd27bea214d030c2; });
$parcel$export(module.exports, "convertRouteMatchToUiMatch", function () { return $dfa7e2cdccc31015$export$fcf533780bf49ee2; });
$parcel$export(module.exports, "joinPaths", function () { return $dfa7e2cdccc31015$export$86d9a7913e44197e; });
$parcel$export(module.exports, "compilePath", function () { return $dfa7e2cdccc31015$export$d726f29eb2425705; });
$parcel$export(module.exports, "explodeOptionalSegments", function () { return $dfa7e2cdccc31015$export$82472424e06ad5c9; });
$parcel$export(module.exports, "matchPath", function () { return $dfa7e2cdccc31015$export$81336c211d5ff295; });
$parcel$export(module.exports, "normalizePathname", function () { return $dfa7e2cdccc31015$export$a5c6d149b50c1d86; });
$parcel$export(module.exports, "prependBasename", function () { return $dfa7e2cdccc31015$export$e9a5bfadbc179142; });
$parcel$export(module.exports, "isAbsoluteUrl", function () { return $dfa7e2cdccc31015$export$a1cbf2de32a9fd1; });
$parcel$export(module.exports, "removeDoubleSlashes", function () { return $dfa7e2cdccc31015$export$f857a07c5bd323b8; });
$parcel$export(module.exports, "getPathContributingMatches", function () { return $dfa7e2cdccc31015$export$b234c29a3bb68fc8; });
$parcel$export(module.exports, "getResolveToMatches", function () { return $dfa7e2cdccc31015$export$fe6dbc5de95f53ab; });
$parcel$export(module.exports, "resolveTo", function () { return $dfa7e2cdccc31015$export$cae722b0cc860f13; });
$parcel$export(module.exports, "data", function () { return $dfa7e2cdccc31015$export$4051a07651545597; });
$parcel$export(module.exports, "redirect", function () { return $dfa7e2cdccc31015$export$89e12c5b50f7529d; });
$parcel$export(module.exports, "SUPPORTED_ERROR_TYPES", function () { return $dfa7e2cdccc31015$export$1a235bd2b33434e5; });
$parcel$export(module.exports, "ErrorResponseImpl", function () { return $dfa7e2cdccc31015$export$f2680fa305b734ca; });
$parcel$export(module.exports, "isRouteErrorResponse", function () { return $dfa7e2cdccc31015$export$972111febbeef05b; });
$parcel$export(module.exports, "getRoutePattern", function () { return $dfa7e2cdccc31015$export$d738435097971c09; });
$parcel$export(module.exports, "createDataFunctionUrl", function () { return $dfa7e2cdccc31015$export$141d98e45b4b08e4; });
$parcel$export(module.exports, "isBrowser", function () { return $dfa7e2cdccc31015$export$4e09c449d6c407f7; });
$parcel$export(module.exports, "parseToInfo", function () { return $dfa7e2cdccc31015$export$ac5aeb949e84fd96; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $2lzVq = parcelRequire("2lzVq");

var $aDbDg = parcelRequire("aDbDg");

var $jpgPw = parcelRequire("jpgPw");
//#region lib/router/utils.ts
/**
* Creates a type-safe {@link RouterContext} object that can be used to
* store and retrieve arbitrary values in [`action`](../../start/framework/route-module#action)s,
* [`loader`](../../start/framework/route-module#loader)s, and [middleware](../../how-to/middleware).
* Similar to React's [`createContext`](https://react.dev/reference/react/createContext),
* but specifically designed for React Router's request/response lifecycle.
*
* If a `defaultValue` is provided, it will be returned from `context.get()`
* when no value has been set for the context. Otherwise, reading this context
* when no value has been set will throw an error.
*
* ```tsx filename=app/context.ts
* import { createContext } from "react-router";
*
* // Create a context for user data
* export const userContext =
*   createContext<User | null>(null);
* ```
*
* ```tsx filename=app/middleware/auth.ts
* import { getUserFromSession } from "~/auth.server";
* import { userContext } from "~/context";
*
* export const authMiddleware = async ({
*   context,
*   request,
* }) => {
*   const user = await getUserFromSession(request);
*   context.set(userContext, user);
* };
* ```
*
* ```tsx filename=app/routes/profile.tsx
* import { userContext } from "~/context";
*
* export async function loader({
*   context,
* }: Route.LoaderArgs) {
*   const user = context.get(userContext);
*
*   if (!user) {
*     throw new Response("Unauthorized", { status: 401 });
*   }
*
*   return { user };
* }
* ```
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param defaultValue An optional default value for the context. This value
* will be returned if no value has been set for this context.
* @returns A {@link RouterContext} object that can be used with
* `context.get()` and `context.set()` in [`action`](../../start/framework/route-module#action)s,
* [`loader`](../../start/framework/route-module#loader)s, and [middleware](../../how-to/middleware).
*/ function $dfa7e2cdccc31015$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
/**
* Provides methods for writing/reading values in application context in a
* type-safe way. Primarily for usage with [middleware](../../how-to/middleware).
*
* @example
* import {
*   createContext,
*   RouterContextProvider
* } from "react-router";
*
* const userContext = createContext<User | null>(null);
* const contextProvider = new RouterContextProvider();
* contextProvider.set(userContext, getUser());
* //                               ^ Type-safe
* const user = contextProvider.get(userContext);
* //    ^ User
*
* @public
* @category Utils
* @mode framework
* @mode data
*/ var $dfa7e2cdccc31015$export$b8d3e69d4b3eff04 = class {
    #map = /* @__PURE__ */ new Map();
    /**
	* Create a new `RouterContextProvider` instance
	* @param init An optional initial context map to populate the provider with
	*/ constructor(init){
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
	* Access a value from the context. If no value has been set for the context,
	* it will return the context's `defaultValue` if provided, or throw an error
	* if no `defaultValue` was set.
	* @param context The context to get the value for
	* @returns The value for the context, or the context's `defaultValue` if no
	* value was set
	*/ get(context) {
        if (this.#map.has(context)) return this.#map.get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
	* Set a value for the context. If the context already has a value set, this
	* will overwrite it.
	*
	* @param context The context to set the value for
	* @param value The value to set for the context
	* @returns {void}
	*/ set(context, value) {
        this.#map.set(context, value);
    }
};
var $dfa7e2cdccc31015$export$96cecaff35fb119d = class extends Error {
};
const $dfa7e2cdccc31015$var$unsupportedLazyRouteObjectKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children",
    "unstable_validateParams"
]);
function $dfa7e2cdccc31015$export$3e22299e33adeed1(key) {
    return $dfa7e2cdccc31015$var$unsupportedLazyRouteObjectKeys.has(key);
}
const $dfa7e2cdccc31015$var$unsupportedLazyRouteFunctionKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children",
    "unstable_validateParams"
]);
function $dfa7e2cdccc31015$export$a89d811eaa209e85(key) {
    return $dfa7e2cdccc31015$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $dfa7e2cdccc31015$var$isIndexRoute(route) {
    return route.index === true;
}
function $dfa7e2cdccc31015$export$6bc17138063be773(route) {
    let updates = {};
    if (route.Component) Object.assign(updates, {
        element: $jpgPw.createElement(route.Component),
        Component: void 0
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: $jpgPw.createElement(route.HydrateFallback),
        HydrateFallback: void 0
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: $jpgPw.createElement(route.ErrorBoundary),
        ErrorBoundary: void 0
    });
    return updates;
}
function $dfa7e2cdccc31015$export$87cb1a9238dc3fba(routes, mapRouteProperties = $dfa7e2cdccc31015$export$6bc17138063be773, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        (0, $aDbDg.invariant)(route.index !== true || !route.children, `Cannot specify children on an index route`);
        (0, $aDbDg.invariant)(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($dfa7e2cdccc31015$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $dfa7e2cdccc31015$var$mergeRouteUpdates(indexRoute, mapRouteProperties(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $dfa7e2cdccc31015$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $dfa7e2cdccc31015$export$87cb1a9238dc3fba(route.children, mapRouteProperties, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $dfa7e2cdccc31015$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
/**
* Matches the given routes to a location and returns the match data.
*
* @example
* import { matchRoutes } from "react-router";
*
* let routes = [{
*   path: "/",
*   Component: Root,
*   children: [{
*     path: "dashboard",
*     Component: Dashboard,
*   }]
* }];
*
* matchRoutes(routes, "/dashboard"); // [rootMatch, dashboardMatch]
*
* @public
* @category Utils
* @param routes The array of route objects to match against.
* @param locationArg The location to match against, either a string path or a
* partial {@link Location} object
* @param basename Optional base path to strip from the location before matching.
* Defaults to `/`.
* @returns An array of matched routes, or `null` if no matches were found.
*/ function $dfa7e2cdccc31015$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $dfa7e2cdccc31015$export$5c7b09132f833c25(routes, locationArg, basename, false);
}
function $dfa7e2cdccc31015$export$5c7b09132f833c25(routes, locationArg, basename, allowPartial, precomputedBranches) {
    let pathname = $dfa7e2cdccc31015$export$b69e3301ce081aa3((typeof locationArg === "string" ? (0, $aDbDg.parsePath)(locationArg) : locationArg).pathname || "/", basename);
    if (pathname == null) return null;
    let branches = precomputedBranches ?? $dfa7e2cdccc31015$export$e486c0390e42ccf6(routes);
    let matches = null;
    let decoded = $dfa7e2cdccc31015$export$cd27bea214d030c2(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $dfa7e2cdccc31015$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $dfa7e2cdccc31015$export$fcf533780bf49ee2(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $dfa7e2cdccc31015$export$e486c0390e42ccf6(routes) {
    let branches = $dfa7e2cdccc31015$var$flattenRoutes(routes);
    $dfa7e2cdccc31015$var$rankRouteBranches(branches);
    return branches;
}
function $dfa7e2cdccc31015$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            (0, $aDbDg.invariant)(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $dfa7e2cdccc31015$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            (0, $aDbDg.invariant)(route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $dfa7e2cdccc31015$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $dfa7e2cdccc31015$var$computeScore(path, route.index),
            routesMeta: routesMeta.map((meta, i)=>{
                let [matcher, params] = $dfa7e2cdccc31015$export$d726f29eb2425705(meta.relativePath, meta.caseSensitive, i === routesMeta.length - 1);
                return {
                    ...meta,
                    matcher: matcher,
                    compiledParams: params
                };
            })
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $dfa7e2cdccc31015$export$82472424e06ad5c9(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $dfa7e2cdccc31015$export$82472424e06ad5c9(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $dfa7e2cdccc31015$export$82472424e06ad5c9(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $dfa7e2cdccc31015$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $dfa7e2cdccc31015$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $dfa7e2cdccc31015$var$paramRe = /^:[\w-]+$/;
const $dfa7e2cdccc31015$var$partialParamRe = /^:[\w-]+/;
const $dfa7e2cdccc31015$var$partialDynamicSegmentValue = 3.5;
const $dfa7e2cdccc31015$var$dynamicSegmentValue = 3;
const $dfa7e2cdccc31015$var$indexRouteValue = 2;
const $dfa7e2cdccc31015$var$emptySegmentValue = 1;
const $dfa7e2cdccc31015$var$staticSegmentValue = 10;
const $dfa7e2cdccc31015$var$splatPenalty = -2;
const $dfa7e2cdccc31015$var$isSplat = (s)=>s === "*";
function $dfa7e2cdccc31015$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($dfa7e2cdccc31015$var$isSplat)) initialScore += $dfa7e2cdccc31015$var$splatPenalty;
    if (index) initialScore += $dfa7e2cdccc31015$var$indexRouteValue;
    return segments.filter((s)=>!$dfa7e2cdccc31015$var$isSplat(s)).reduce((score, segment)=>score + ($dfa7e2cdccc31015$var$paramRe.test(segment) ? $dfa7e2cdccc31015$var$dynamicSegmentValue : $dfa7e2cdccc31015$var$partialParamRe.test(segment) ? $dfa7e2cdccc31015$var$partialDynamicSegmentValue : segment === "" ? $dfa7e2cdccc31015$var$emptySegmentValue : $dfa7e2cdccc31015$var$staticSegmentValue), initialScore);
}
function $dfa7e2cdccc31015$var$compareIndexes(a, b) {
    return a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]) ? a[a.length - 1] - b[b.length - 1] : 0;
}
function $dfa7e2cdccc31015$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let pattern = {
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        };
        let match = meta.matcher && meta.compiledParams ? $dfa7e2cdccc31015$var$matchPathImpl(pattern, remainingPathname, meta.matcher, meta.compiledParams) : $dfa7e2cdccc31015$export$81336c211d5ff295(pattern, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $dfa7e2cdccc31015$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            params: matchedParams,
            pathname: $dfa7e2cdccc31015$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $dfa7e2cdccc31015$export$a5c6d149b50c1d86($dfa7e2cdccc31015$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $dfa7e2cdccc31015$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
* Characters that `encodeURIComponent` escapes but that are valid literally in
* a URL path segment. Per RFC 3986 §3.3, a path segment is made of `pchar`:
*
* ```
* pchar = unreserved / pct-encoded / sub-delims / ":" / "@"
* sub-delims = "!" / "$" / "&" / "'" / "(" / ")" / "*" / "+" / "," / ";" / "="
* ```
*
* `encodeURIComponent` targets query-string values, where `$ & + , ; = : @`
* are delimiters and must be escaped — but in a path segment they carry no
* special meaning, and browsers keep them literal in `location.pathname`.
* (`! ' ( ) *` and the unreserved set are already left alone by
* `encodeURIComponent`, so they need no restoring.)
*/ const $dfa7e2cdccc31015$var$PATH_PARAM_OVERESCAPED = {
    "%24": "$",
    "%26": "&",
    "%2B": "+",
    "%2C": ",",
    "%3A": ":",
    "%3B": ";",
    "%3D": "=",
    "%40": "@"
};
/**
* Encodes a param value for interpolation into a single URL path segment.
*
* Escapes characters that would break the path (`/ ? # %`, whitespace,
* non-ASCII, …) while leaving characters that RFC 3986 permits literally in a
* path segment untouched. Escaping those would needlessly rewrite URLs — e.g.
*  a semver build param `1.0.0+1` would become `1.0.0%2B1` even though browsers
* display and match the `+` literally in `location.pathname`.
*
* See [RFC 3986 §3.3](https://datatracker.ietf.org/doc/html/rfc3986#section-3.3))
*
* @param value The param value to encode.
* @returns The encoded value, safe for use as a single path segment.
*/ function $dfa7e2cdccc31015$export$1adf7db041bd81b8(value) {
    return encodeURIComponent(value).replace(/%(?:24|26|2B|2C|3A|3B|3D|40)/g, (match)=>$dfa7e2cdccc31015$var$PATH_PARAM_OVERESCAPED[match]);
}
/**
* Returns a path with params interpolated.
*
* Param values are percent-encoded for use in a path segment: characters that
* would change the URL structure (`/`, `?`, `#`, `%`, whitespace, non-ASCII)
* are escaped, while characters that RFC 3986 allows literally in a path
* segment (`$ & + , ; = : @`) are kept as-is. Note this differs from query-string
* encoding (`encodeURIComponent`/`URLSearchParams`), where those characters are
* delimiters and must be escaped. Splat (`*`) values are encoded per segment,
* preserving `/` separators.
*
* See [RFC 3986 §3.3](https://datatracker.ietf.org/doc/html/rfc3986#section-3.3)
*
* @example
* import { generatePath } from "react-router";
*
* generatePath("/users/:id", { id: "123" }); // "/users/123"
* generatePath("/files/:name", { name: "a b" }); // "/files/a%20b"
* generatePath("/releases/:v", { v: "1.0.0+1" }); // "/releases/1.0.0+1"
*
* @public
* @category Utils
* @param originalPath The original path to generate.
* @param params The parameters to interpolate into the path.
* @returns The generated path with parameters interpolated.
*/ function $dfa7e2cdccc31015$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        (0, $aDbDg.warning)(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    return prefix + path.split(/\/+/).map((segment, index, array)=>{
        if (index === array.length - 1 && segment === "*") return stringify(params["*"]);
        const keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            const [, key, optional, suffix] = keyMatch;
            let param = params[key];
            (0, $aDbDg.invariant)(optional === "?" || param != null, `Missing ":${key}" param`);
            return $dfa7e2cdccc31015$export$1adf7db041bd81b8(stringify(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment).join("/");
}
/**
* Performs pattern matching on a URL pathname and returns information about
* the match.
*
* @public
* @category Utils
* @param pattern The pattern to match against the URL pathname. This can be a
* string or a {@link PathPattern} object. If a string is provided, it will be
* treated as a pattern with `caseSensitive` set to `false` and `end` set to
* `true`.
* @param pathname The URL pathname to match against the pattern.
* @returns A path match object if the pattern matches the pathname,
* or `null` if it does not match.
*/ function $dfa7e2cdccc31015$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $dfa7e2cdccc31015$export$d726f29eb2425705(pattern.path, pattern.caseSensitive, pattern.end);
    return $dfa7e2cdccc31015$var$matchPathImpl(pattern, pathname, matcher, compiledParams);
}
function $dfa7e2cdccc31015$var$matchPathImpl(pattern, pathname, matcher, compiledParams) {
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = $dfa7e2cdccc31015$export$b6d465111d914331(matchedPathname, 1);
    let captureGroups = match.slice(1);
    return {
        params: compiledParams.reduce((memo, { paramName: paramName, isOptional: isOptional }, index)=>{
            if (paramName === "*") {
                let splatValue = captureGroups[index] || "";
                pathnameBase = $dfa7e2cdccc31015$export$b6d465111d914331(matchedPathname.slice(0, matchedPathname.length - splatValue.length), 1);
            }
            const value = captureGroups[index];
            if (isOptional && !value) memo[paramName] = void 0;
            else memo[paramName] = (value || "").replace(/%2F/g, "/");
            return memo;
        }, {}),
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $dfa7e2cdccc31015$export$d726f29eb2425705(path, caseSensitive = false, end = true) {
    (0, $aDbDg.warning)(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (match, paramName, isOptional, index, str)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        if (isOptional) {
            let nextChar = str.charAt(index + match.length);
            if (nextChar && nextChar !== "/") return "/([^\\/]*)";
            return "(?:/([^\\/]*))?";
        }
        return "/([^\\/]+)";
    }).replace(/\/((?:[^/?()[\]*^\\]|\\.)+)\?(?=\/|$|\()/g, "(?:/$1)?");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    return [
        new RegExp(regexpSource, caseSensitive ? void 0 : "i"),
        params
    ];
}
function $dfa7e2cdccc31015$export$cd27bea214d030c2(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        (0, $aDbDg.warning)(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $dfa7e2cdccc31015$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $dfa7e2cdccc31015$export$e9a5bfadbc179142({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $dfa7e2cdccc31015$export$86d9a7913e44197e([
        basename,
        pathname
    ]);
}
const $dfa7e2cdccc31015$export$a1cbf2de32a9fd1 = (url)=>(0, $2lzVq.ABSOLUTE_URL_REGEX).test(url);
/**
* Returns a resolved {@link Path} object relative to the given pathname.
*
* @public
* @category Utils
* @param to The path to resolve, either a string or a partial {@link Path}
* object.
* @param fromPathname The pathname to resolve the path from. Defaults to `/`.
* @returns A {@link Path} object with the resolved pathname, search, and hash.
*/ function $dfa7e2cdccc31015$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? (0, $aDbDg.parsePath)(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $dfa7e2cdccc31015$export$f857a07c5bd323b8(toPathname);
        if (toPathname.startsWith("/") || toPathname.startsWith("\\")) pathname = $dfa7e2cdccc31015$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $dfa7e2cdccc31015$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $dfa7e2cdccc31015$var$normalizeSearch(search),
        hash: $dfa7e2cdccc31015$var$normalizeHash(hash)
    };
}
function $dfa7e2cdccc31015$var$resolvePathname(relativePath, fromPathname) {
    let segments = $dfa7e2cdccc31015$export$b6d465111d914331(fromPathname).split("/");
    relativePath.split("/").forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $dfa7e2cdccc31015$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $dfa7e2cdccc31015$export$b234c29a3bb68fc8(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $dfa7e2cdccc31015$export$fe6dbc5de95f53ab(matches) {
    let pathMatches = $dfa7e2cdccc31015$export$b234c29a3bb68fc8(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $dfa7e2cdccc31015$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = (0, $aDbDg.parsePath)(toArg);
    else {
        to = {
            ...toArg
        };
        (0, $aDbDg.invariant)(!to.pathname || !to.pathname.includes("?"), $dfa7e2cdccc31015$var$getInvalidPathError("?", "pathname", "search", to));
        (0, $aDbDg.invariant)(!to.pathname || !to.pathname.includes("#"), $dfa7e2cdccc31015$var$getInvalidPathError("#", "pathname", "hash", to));
        (0, $aDbDg.invariant)(!to.search || !to.search.includes("#"), $dfa7e2cdccc31015$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $dfa7e2cdccc31015$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
const $dfa7e2cdccc31015$export$f857a07c5bd323b8 = (path)=>path.replace(/[\\/]{2,}/g, "/");
const $dfa7e2cdccc31015$export$86d9a7913e44197e = (paths)=>$dfa7e2cdccc31015$export$f857a07c5bd323b8(paths.join("/"));
function $dfa7e2cdccc31015$export$b6d465111d914331(path, minLength = 0) {
    let end = path.length;
    while(end > minLength && path.charCodeAt(end - 1) === 47)end--;
    return end === path.length ? path : path.slice(0, end);
}
const $dfa7e2cdccc31015$export$a5c6d149b50c1d86 = (pathname)=>$dfa7e2cdccc31015$export$b6d465111d914331(pathname).replace(/^\/*/, "/");
const $dfa7e2cdccc31015$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
const $dfa7e2cdccc31015$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $dfa7e2cdccc31015$var$DataWithResponseInit = class {
    type = "DataWithResponseInit";
    data;
    init;
    constructor(data, init){
        this.data = data;
        this.init = init || null;
    }
};
/**
* Create "responses" that contain `headers`/`status` without forcing
* serialization into an actual [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
*
* @example
* import { data } from "react-router";
*
* export async function action({ request }: Route.ActionArgs) {
*   let formData = await request.formData();
*   let item = await createItem(formData);
*   return data(item, {
*     headers: { "X-Custom-Header": "value" }
*     status: 201,
*   });
* }
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param data The data to be included in the response.
* @param init The status code or a `ResponseInit` object to be included in the
* response.
* @returns A {@link DataWithResponseInit} instance containing the data and
* response init.
*/ function $dfa7e2cdccc31015$export$4051a07651545597(data, init) {
    return new $dfa7e2cdccc31015$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
/**
* A redirect [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response).
* Sets the status code and the [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header. Defaults to [`302 Found`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/302).
*
* This utility accepts absolute URLs and can navigate to external domains, so
* the application should validate any user-supplied inputs to redirects.
*
* @example
* import { redirect } from "react-router";
*
* export async function loader({ request }: Route.LoaderArgs) {
*   if (!isLoggedIn(request))
*     throw redirect("/login");
*   }
*
*   // ...
* }
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param url The URL to redirect to.
* @param init The status code or a `ResponseInit` object to be included in the
* response.
* @returns A [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* object with the redirect status and [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header.
*/ const $dfa7e2cdccc31015$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
/**
* A redirect [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* that will force a document reload to the new location. Sets the status code
* and the [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header. Defaults to [`302 Found`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/302).
*
* This utility accepts absolute URLs and can navigate to external domains, so
* the application should validate any user-supplied inputs to redirects.
*
* ```tsx filename=routes/logout.tsx
* import { redirectDocument } from "react-router";
*
* import { destroySession } from "../sessions.server";
*
* export async function action({ request }: Route.ActionArgs) {
*   let session = await getSession(request.headers.get("Cookie"));
*   return redirectDocument("/", {
*     headers: { "Set-Cookie": await destroySession(session) }
*   });
* }
* ```
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param url The URL to redirect to.
* @param init The status code or a `ResponseInit` object to be included in the
* response.
* @returns A [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* object with the redirect status and [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header.
*/ const $dfa7e2cdccc31015$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $dfa7e2cdccc31015$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
* A redirect [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* that will perform a [`history.replaceState`](https://developer.mozilla.org/en-US/docs/Web/API/History/replaceState)
* instead of a [`history.pushState`](https://developer.mozilla.org/en-US/docs/Web/API/History/pushState)
* for client-side navigation redirects. Sets the status code and the [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header. Defaults to [`302 Found`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/302).
*
* @example
* import { replace } from "react-router";
*
* export async function loader() {
*   return replace("/new-location");
* }
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param url The URL to redirect to.
* @param init The status code or a `ResponseInit` object to be included in the
* response.
* @returns A [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* object with the redirect status and [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header.
*/ const $dfa7e2cdccc31015$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $dfa7e2cdccc31015$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
const $dfa7e2cdccc31015$export$1a235bd2b33434e5 = [
    "EvalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
var $dfa7e2cdccc31015$export$f2680fa305b734ca = class {
    status;
    statusText;
    data;
    error;
    internal;
    constructor(status, statusText, data, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
};
/**
* Check if the given error is an {@link ErrorResponse} generated from a 4xx/5xx
* [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* thrown from an [`action`](../../start/framework/route-module#action) or
* [`loader`](../../start/framework/route-module#loader) function.
*
* @example
* import { isRouteErrorResponse } from "react-router";
*
* export function ErrorBoundary({ error }: Route.ErrorBoundaryProps) {
*   if (isRouteErrorResponse(error)) {
*     return (
*       <>
*         <p>Error: `${error.status}: ${error.statusText}`</p>
*         <p>{error.data}</p>
*       </>
*     );
*   }
*
*   return (
*     <p>Error: {error instanceof Error ? error.message : "Unknown Error"}</p>
*   );
* }
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param error The error to check.
* @returns `true` if the error is an {@link ErrorResponse}, `false` otherwise.
*/ function $dfa7e2cdccc31015$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $dfa7e2cdccc31015$export$d738435097971c09(matches) {
    return $dfa7e2cdccc31015$export$86d9a7913e44197e(matches.map((m)=>m.route.path).filter(Boolean)) || "/";
}
function $dfa7e2cdccc31015$export$141d98e45b4b08e4(request, path) {
    let url = new URL(typeof request === "string" || request instanceof URL ? request : request.url);
    let parsed = typeof path === "string" ? (0, $aDbDg.parsePath)(path) : path;
    url.pathname = parsed.pathname || "/";
    if (parsed.search) {
        let searchParams = new URLSearchParams(parsed.search);
        let indexValues = searchParams.getAll("index");
        searchParams.delete("index");
        for (let value of indexValues.filter(Boolean))searchParams.append("index", value);
        let search = searchParams.toString();
        url.search = search ? `?${search}` : "";
    } else url.search = "";
    url.hash = parsed.hash || "";
    return url;
}
const $dfa7e2cdccc31015$export$4e09c449d6c407f7 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $dfa7e2cdccc31015$export$ac5aeb949e84fd96(_to, basename) {
    let to = _to;
    if (typeof to !== "string" || !(0, $2lzVq.ABSOLUTE_URL_REGEX).test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    let absoluteURL = to;
    let isExternal = false;
    if ($dfa7e2cdccc31015$export$4e09c449d6c407f7) try {
        let currentUrl = new URL(window.location.href);
        let targetUrl = (0, $2lzVq.PROTOCOL_RELATIVE_URL_REGEX).test(to) ? new URL((0, $2lzVq.normalizeProtocolRelativeUrl)(to, currentUrl.protocol)) : new URL(to);
        let path = $dfa7e2cdccc31015$export$b69e3301ce081aa3(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch  {
        (0, $aDbDg.warning)(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}

});

parcelRegister("e1hMf", function(module, exports) {

$parcel$export(module.exports, "IDLE_FETCHER", function () { return $a34ef2d9e87cf685$export$52eace9c284d3585; });
$parcel$export(module.exports, "IDLE_BLOCKER", function () { return $a34ef2d9e87cf685$export$386d57f03f0b2883; });
$parcel$export(module.exports, "clientErrors", function () { return $a34ef2d9e87cf685$export$f1f19d63f0eb8dcb; });
$parcel$export(module.exports, "createRouter", function () { return $a34ef2d9e87cf685$export$baddd0131ee8c05b; });
$parcel$export(module.exports, "isResponse", function () { return $a34ef2d9e87cf685$export$3f1eb41d9a6a6a27; });
$parcel$export(module.exports, "isDataWithResponseInit", function () { return $a34ef2d9e87cf685$export$e0163cfdf7bc9cfa; });
$parcel$export(module.exports, "hasInvalidProtocol", function () { return $a34ef2d9e87cf685$export$961a3ef7a4da3a39; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $2lzVq = parcelRequire("2lzVq");

var $aDbDg = parcelRequire("aDbDg");

var $jcvU7 = parcelRequire("jcvU7");

var $d1yHl = parcelRequire("d1yHl");

var $i9oDI = parcelRequire("i9oDI");

var $1wKl4 = parcelRequire("1wKl4");

var $2gfKq = parcelRequire("2gfKq");
//#region lib/router/router.ts
const $a34ef2d9e87cf685$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
const $a34ef2d9e87cf685$var$validMutationMethods = new Set($a34ef2d9e87cf685$var$validMutationMethodsArr);
const $a34ef2d9e87cf685$var$validRequestMethodsArr = [
    "GET",
    ...$a34ef2d9e87cf685$var$validMutationMethodsArr
];
const $a34ef2d9e87cf685$var$validRequestMethods = new Set($a34ef2d9e87cf685$var$validRequestMethodsArr);
const $a34ef2d9e87cf685$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $a34ef2d9e87cf685$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $a34ef2d9e87cf685$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    matches: void 0,
    historyAction: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
const $a34ef2d9e87cf685$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
const $a34ef2d9e87cf685$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
const $a34ef2d9e87cf685$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
const $a34ef2d9e87cf685$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
function $a34ef2d9e87cf685$export$5e64b3b9d7e2ec36(future, basename) {
    if (future.unstable_routePatternMatching) {
        let RoutePatternMatcher = (0, $1wKl4.getRoutePatternMatcher)();
        (0, $aDbDg.invariant)(RoutePatternMatcher, "You must call unstable_preloadRoutePattern() from \"react-router/route-pattern\" before enabling future.unstable_routePatternMatching.");
        return new RoutePatternMatcher(basename);
    }
    return new (0, $i9oDI.V6RegExMatcher)(basename);
}
/**
* Encapsulates the stable and in-flight route trees together with their
* pre-computed branch caches so the structures always stay in sync.
*/ var $a34ef2d9e87cf685$var$DataRoutes = class {
    #routes;
    #hmrRoutes;
    #matcher;
    constructor(routes, matcher){
        this.#routes = routes;
        this.#matcher = matcher;
        this.#matcher.update(routes);
    }
    /** The stable route tree */ get stableRoutes() {
        return this.#routes;
    }
    /** The in-flight route tree if one is active, otherwise the stable tree */ get activeRoutes() {
        return this.#hmrRoutes ?? this.#routes;
    }
    get hasHMRRoutes() {
        return this.#hmrRoutes != null;
    }
    /** Replace the stable route tree and recompute its branches */ setRoutes(routes) {
        this.#routes = routes;
        if (!this.#hmrRoutes) this.#matcher.update(routes);
    }
    /** Set a new in-flight route tree and recompute its branches */ setHmrRoutes(routes) {
        this.#hmrRoutes = routes;
        this.#matcher.update(routes);
    }
    /** Commit in-flight routes/branches to the stable slot and clear in-flight */ commitHmrRoutes() {
        if (this.#hmrRoutes) {
            this.#routes = this.#hmrRoutes;
            this.#hmrRoutes = void 0;
            this.#matcher.update(this.#routes);
        }
    }
};
const $a34ef2d9e87cf685$export$f1f19d63f0eb8dcb = /* @__PURE__ */ new WeakMap();
/**
* Create a router and listen to history POP navigations
*/ function $a34ef2d9e87cf685$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    (0, $aDbDg.invariant)(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties;
    let mapRouteProperties = _mapRouteProperties ? _mapRouteProperties : ()=>({});
    if (init.instrumentations) {
        let instrumentations = init.instrumentations;
        mapRouteProperties = (route)=>{
            return {
                ..._mapRouteProperties?.(route),
                ...(0, $d1yHl.getRouteInstrumentationUpdates)(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let future = {
        ...init.future
    };
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataRouteMatcher = $a34ef2d9e87cf685$export$5e64b3b9d7e2ec36(future, basename);
    let manifest = {};
    let dataRoutes = new $a34ef2d9e87cf685$var$DataRoutes((0, $jcvU7.convertRoutesToDataRoutes)(init.routes, mapRouteProperties, void 0, manifest), dataRouteMatcher);
    let dataStrategyImpl = init.dataStrategy || $a34ef2d9e87cf685$var$defaultDataStrategyWithMiddleware;
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let savedScrollPositions = null;
    let getScrollRestorationKey = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = dataRouteMatcher.match(init.history.location);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    let renderFallback;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $a34ef2d9e87cf685$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $a34ef2d9e87cf685$var$getShortCircuitMatches(dataRoutes.activeRoutes);
        initialized = true;
        renderFallback = !initialized;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            if (checkFogOfWar(initialMatches, init.history.location.pathname).active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            renderFallback = !initialized;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) {
            initialized = false;
            renderFallback = !initialized;
        } else if (!initialMatches.some((m)=>$a34ef2d9e87cf685$var$routeHasLoaderOrMiddleware(m.route))) {
            initialized = true;
            renderFallback = !initialized;
        } else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            let relevantMatches = initialMatches;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                relevantMatches = relevantMatches.slice(0, idx + 1);
            }
            renderFallback = false;
            initialized = true;
            relevantMatches.forEach((m)=>{
                let status = $a34ef2d9e87cf685$var$getRouteHydrationStatus(m.route, loaderData, errors);
                renderFallback = renderFallback || status.renderFallback;
                initialized = initialized && !status.shouldLoad;
            });
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        renderFallback: renderFallback,
        navigation: $a34ef2d9e87cf685$export$ed3e14b2f9e105d0,
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP";
    let pendingPopstateDelta = 0;
    let pendingDiscoveryCancellation;
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            (0, $aDbDg.warning)(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $a34ef2d9e87cf685$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd?.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            if (future.unstable_customRouteDiscovery) pendingPopstateDelta += delta || 0;
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            $a34ef2d9e87cf685$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$a34ef2d9e87cf685$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP", state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(state.fetchers, key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        let newErrors = newState.errors ?? null;
        let cachedErrors = newErrors ? $a34ef2d9e87cf685$export$f1f19d63f0eb8dcb.get(newErrors) : void 0;
        if (cachedErrors !== void 0) newErrors = cachedErrors;
        if (newState.errors !== void 0 || newState.initialized) {
            if (state.errors) $a34ef2d9e87cf685$export$f1f19d63f0eb8dcb.delete(state.errors);
            if (newState.errors) $a34ef2d9e87cf685$export$f1f19d63f0eb8dcb.set(newState.errors, newErrors);
        }
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: newErrors,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(state.fetchers, key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $a34ef2d9e87cf685$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $a34ef2d9e87cf685$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0 && !isUninterruptedRevalidation) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $a34ef2d9e87cf685$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $a34ef2d9e87cf685$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        dataRoutes.commitHmrRoutes();
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP") ;
        else if (pendingAction === "PUSH") init.history.push(location, location.state);
        else if (pendingAction === "REPLACE") init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" && !isUninterruptedRevalidation && location !== state.location) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            renderFallback: false,
            navigation: $a34ef2d9e87cf685$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        resetPendingNavigation();
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    function resetPendingNavigation() {
        pendingPopstateDelta = 0;
        pendingAction = "POP";
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = fetchReloadIds.size > 0;
    }
    async function navigate(to, opts) {
        if (pendingDiscoveryCancellation) await pendingDiscoveryCancellation;
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $a34ef2d9e87cf685$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let instrumentationNavigateMetaReceiver = (0, $d1yHl.consumeInstrumentationClientResultMetaReceiver)(router);
        let { path: path, submission: submission, error: error } = $a34ef2d9e87cf685$var$normalizeNavigateOptions(false, $a34ef2d9e87cf685$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative), opts);
        let maskPath;
        if (opts?.mask) {
            let partialPath = typeof opts.mask === "string" ? (0, $aDbDg.parsePath)(opts.mask) : {
                ...state.location.mask,
                ...opts.mask
            };
            maskPath = {
                pathname: partialPath.pathname ?? "",
                search: partialPath.search ?? "",
                hash: partialPath.hash ?? ""
            };
            if ((0, $2lzVq.PROTOCOL_RELATIVE_URL_REGEX).test(maskPath.pathname)) throw new Error("External navigation is not allowed");
            else if (maskPath.pathname.startsWith("\\")) maskPath.pathname = maskPath.pathname.replace(/^\\+/, "/");
            (0, $2gfKq.validateNavigationTarget)(typeof opts.mask === "string" ? opts.mask : (0, $aDbDg.createPath)(opts.mask), (0, $aDbDg.createPath)(maskPath), init.history.createURL("/"), "reject");
        }
        let currentLocation = state.location;
        let nextLocation = (0, $aDbDg.createLocation)(currentLocation, path, opts && opts.state, void 0, maskPath);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        (0, $2gfKq.validateNavigationTarget)(to == null ? init.history.createHref(state.location) : typeof to === "string" ? to : (0, $aDbDg.createPath)(to), init.history.createHref(nextLocation.mask || nextLocation), init.history.createURL("/"), "reject");
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH";
        let currentPath = state.location.pathname + state.location.search;
        if (userReplace === true) historyAction = "REPLACE";
        else if (userReplace === false) ;
        else if (submission != null && $a34ef2d9e87cf685$export$cbae47800eb95bc3(submission.formMethod) && (submission.formAction === currentPath || nextLocation.pathname + nextLocation.search === currentPath)) historyAction = "REPLACE";
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $a34ef2d9e87cf685$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync,
            callSiteDefaultShouldRevalidate: opts && opts.defaultShouldRevalidate,
            instrumentationNavigateMetaReceiver: instrumentationNavigateMetaReceiver
        });
    }
    function revalidate() {
        if (pendingDiscoveryCancellation) return pendingDiscoveryCancellation.then(revalidate);
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $a34ef2d9e87cf685$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true,
                dataStrategyInitiator: "revalidation"
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            dataStrategyInitiator: "revalidation",
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        if (pendingDiscoveryCancellation) await pendingDiscoveryCancellation;
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? state.matches : dataRouteMatcher.match(location);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $a34ef2d9e87cf685$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $a34ef2d9e87cf685$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (opts?.instrumentationNavigateMetaReceiver) {
            let meta = $a34ef2d9e87cf685$var$getInstrumentationNavigateMeta(init.history, location, matches);
            opts.instrumentationNavigateMetaReceiver(meta);
        }
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        let loadingNavigation = opts && opts.overrideNavigation ? {
            ...opts.overrideNavigation,
            matches: matches,
            historyAction: historyAction
        } : void 0;
        pendingNavigationController = new AbortController();
        let request = $a34ef2d9e87cf685$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let dataStrategyInitiator = opts?.initialHydration ? "initialization" : opts?.dataStrategyInitiator ?? "navigation";
        let scopedContext = init.getContext ? await init.getContext() : new (0, $jcvU7.RouterContextProvider)();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $a34ef2d9e87cf685$var$findNearestBoundary(matches).route.id,
            {
                type: "error",
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $a34ef2d9e87cf685$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, dataStrategyInitiator, location, opts.submission, matches, historyAction, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($a34ef2d9e87cf685$var$isErrorResult(result) && (0, $jcvU7.isRouteErrorResponse)(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $a34ef2d9e87cf685$var$getLoadingNavigation(location, matches, historyAction, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $a34ef2d9e87cf685$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors, workingFetchers: workingFetchers } = await handleLoaders(request, dataStrategyInitiator, location, matches, historyAction, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$a34ef2d9e87cf685$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors,
            ...workingFetchers ? {
                fetchers: workingFetchers
            } : {}
        });
    }
    function cancelDiscoveryNavigation() {
        let cancellation = $a34ef2d9e87cf685$var$createDeferred();
        pendingDiscoveryCancellation = cancellation.promise;
        let delta = pendingPopstateDelta;
        let popstateNavigationDfd = pendingPopstateNavigationDfd;
        pendingPopstateNavigationDfd = null;
        pendingNavigationController?.abort();
        pendingNavigationController = null;
        resetPendingNavigation();
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
        let blockers = new Map(state.blockers);
        blockers.forEach((blocker, key)=>{
            if (blocker.state === "proceeding") blockers.set(key, $a34ef2d9e87cf685$export$386d57f03f0b2883);
        });
        let fetchers = new Map(state.fetchers);
        let didUpdateFetchers = markFetchRedirectsDone(fetchers);
        fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "loading" && !fetchControllers.has(key)) {
                fetchers.set(key, $a34ef2d9e87cf685$var$getDoneFetcher(fetcher.data));
                didUpdateFetchers = true;
            }
        });
        cancelledFetcherLoads.clear();
        updateState({
            navigation: $a34ef2d9e87cf685$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            blockers: blockers,
            ...didUpdateFetchers ? {
                fetchers: fetchers
            } : {}
        });
        function finishCancellation() {
            pendingDiscoveryCancellation = void 0;
            popstateNavigationDfd?.resolve();
            cancellation.resolve();
        }
        if (delta) {
            unblockBlockerHistoryUpdate = finishCancellation;
            init.history.go(-delta);
        } else finishCancellation();
        return cancellation.promise;
    }
    async function handleAction(request, dataStrategyInitiator, location, submission, matches, historyAction, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        if (!future.unstable_customRouteDiscovery) interruptActiveLoads();
        updateState({
            navigation: $a34ef2d9e87cf685$var$getSubmittingNavigation(location, matches, historyAction, submission)
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (future.unstable_customRouteDiscovery && request.signal.aborted || discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "cancelled") {
                await cancelDiscoveryNavigation();
                return {
                    shortCircuited: true
                };
            } else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches, route: route } = $a34ef2d9e87cf685$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error",
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $a34ef2d9e87cf685$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error",
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error",
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        if (future.unstable_customRouteDiscovery) interruptActiveLoads();
        let result;
        let actionMatch = $a34ef2d9e87cf685$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error",
            error: $a34ef2d9e87cf685$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy(request, location, $a34ef2d9e87cf685$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, request, location, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties, scopedContext), scopedContext, null, dataStrategyInitiator, historyAction);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($a34ef2d9e87cf685$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else replace = $a34ef2d9e87cf685$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history) === state.location.pathname + state.location.search;
            await startRedirectNavigation(request, result, true, dataStrategyInitiator, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($a34ef2d9e87cf685$var$isErrorResult(result)) {
            let boundaryMatch = $a34ef2d9e87cf685$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH";
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, dataStrategyInitiator, location, matches, historyAction, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        let loadingNavigation = overrideNavigation || $a34ef2d9e87cf685$var$getLoadingNavigation(location, matches, historyAction, submission);
        let activeSubmission = submission || fetcherSubmission || $a34ef2d9e87cf685$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (future.unstable_customRouteDiscovery && request.signal.aborted || discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "cancelled") {
                await cancelDiscoveryNavigation();
                return {
                    shortCircuited: true
                };
            } else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches, route: route } = $a34ef2d9e87cf685$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $a34ef2d9e87cf685$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else {
                matches = discoverResult.matches;
                if (initialHydration && !request.signal.aborted) updateState({
                    matches: matches
                });
            }
        }
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $a34ef2d9e87cf685$var$getMatchesToLoad(request, scopedContext, mapRouteProperties, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, dataRouteMatcher, pendingActionResult, callSiteDefaultShouldRevalidate);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let workingFetchers = new Map(state.fetchers);
            let didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                errors: pendingActionResult && $a34ef2d9e87cf685$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$a34ef2d9e87cf685$var$getActionDataForCommit(pendingActionResult),
                ...didUpdateFetcherRedirects ? {
                    fetchers: workingFetchers
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>{
                if (fetchControllers.get(rf.key) === rf.controller) abortFetcher(rf.key);
            });
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, location, scopedContext, dataStrategyInitiator, historyAction);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.get(rf.key) === rf.controller) fetchControllers.delete(rf.key);
        });
        let redirect = $a34ef2d9e87cf685$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, dataStrategyInitiator, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $a34ef2d9e87cf685$var$findRedirect(fetcherResults);
        if (redirect) {
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, dataStrategyInitiator, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        let workingFetchers = new Map(state.fetchers);
        let { loaderData: loaderData, errors: errors } = $a34ef2d9e87cf685$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers);
        if (initialHydration && state.errors) {
            let newClientErrors = errors ?? null;
            errors = {
                ...state.errors,
                ...errors
            };
            $a34ef2d9e87cf685$export$f1f19d63f0eb8dcb.set(errors, newClientErrors);
        }
        let didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId, workingFetchers);
        let shouldUpdateFetchers = didUpdateFetcherRedirects || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                workingFetchers: workingFetchers
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$a34ef2d9e87cf685$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        let workingFetchers = new Map(state.fetchers);
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = workingFetchers.get(rf.key);
            let revalidatingFetcher = $a34ef2d9e87cf685$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            workingFetchers.set(rf.key, revalidatingFetcher);
        });
        return workingFetchers;
    }
    async function fetch(key, routeId, href, opts) {
        if (pendingDiscoveryCancellation) await pendingDiscoveryCancellation;
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let instrumentationResultMetaReceiver = (0, $d1yHl.consumeInstrumentationClientResultMetaReceiver)(router);
        let normalizedPath = $a34ef2d9e87cf685$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = dataRouteMatcher.match(normalizedPath);
        let fogOfWar = checkFogOfWar(matches, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (instrumentationResultMetaReceiver) instrumentationResultMetaReceiver($a34ef2d9e87cf685$var$getInstrumentationNavigateMeta(init.history, normalizedPath, matches));
        if (!matches) {
            setFetcherError(key, routeId, $a34ef2d9e87cf685$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $a34ef2d9e87cf685$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new (0, $jcvU7.RouterContextProvider)();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $a34ef2d9e87cf685$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.defaultShouldRevalidate);
            return;
        }
        let loadMatch = {
            routeId: routeId,
            path: path,
            isDiscovering: fogOfWar.active
        };
        fetchLoadMatches.set(key, loadMatch);
        await handleFetcherLoader(key, loadMatch, matches, scopedContext, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        if (!future.unstable_customRouteDiscovery) interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $a34ef2d9e87cf685$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        if (future.unstable_customRouteDiscovery) fetchControllers.set(key, abortController);
        let fetchRequest = $a34ef2d9e87cf685$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (future.unstable_customRouteDiscovery && fetchRequest.signal.aborted || discoverResult.type === "aborted") return;
            else if (discoverResult.type === "cancelled") {
                fetchControllers.delete(key);
                fetchLoadMatches.delete(key);
                updateFetcherState(key, $a34ef2d9e87cf685$var$getDoneFetcher(existingFetcher?.data), {
                    flushSync: flushSync
                });
                return;
            } else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $a34ef2d9e87cf685$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $a34ef2d9e87cf685$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            setFetcherError(key, routeId, $a34ef2d9e87cf685$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            }), {
                flushSync: flushSync
            });
            return;
        }
        if (future.unstable_customRouteDiscovery) interruptActiveLoads();
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $a34ef2d9e87cf685$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, path, requestMatches, match, hydrationRouteProperties, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, path, fetchMatches, scopedContext, key, "fetcher");
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match of fetchMatches)if (actionResults[match.route.id]) {
                actionResult = actionResults[match.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($a34ef2d9e87cf685$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $a34ef2d9e87cf685$var$getDoneFetcher(void 0));
                return;
            }
            if ($a34ef2d9e87cf685$var$isRedirectResult(actionResult)) {
                isRevalidationRequired = true;
                actionResult = {
                    type: "data",
                    data: void 0
                };
            }
        } else {
            if ($a34ef2d9e87cf685$var$isRedirectResult(actionResult)) {
                if (pendingNavigationLoadId > originatingLoadId) {
                    isRevalidationRequired = true;
                    actionResult = {
                        type: "data",
                        data: void 0
                    };
                } else {
                    fetchControllers.delete(key);
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $a34ef2d9e87cf685$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, "fetcher", {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($a34ef2d9e87cf685$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        isRevalidationRequired = true;
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $a34ef2d9e87cf685$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let matches = state.navigation.state !== "idle" ? dataRouteMatcher.match(state.navigation.location) : state.matches;
        (0, $aDbDg.invariant)(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $a34ef2d9e87cf685$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, dataRouteMatcher, [
            match.route.id,
            actionResult
        ], callSiteDefaultShouldRevalidate);
        let loadFetcher = $a34ef2d9e87cf685$var$getLoadingFetcher(submission, actionResult.data);
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, loadFetcher);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = workingFetchers.get(staleKey);
            let revalidatingFetcher = $a34ef2d9e87cf685$var$getLoadingFetcher(void 0, existingFetcher ? existingFetcher.data : void 0);
            workingFetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: workingFetchers
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>{
                if (fetchControllers.get(rf.key) === rf.controller) abortFetcher(rf.key);
            });
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, nextLocation, scopedContext, "fetcher");
        if (abortController.signal.aborted) {
            if (fetchReloadIds.get(key) === loadId) fetchReloadIds.delete(key);
            return;
        }
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>{
            if (fetchControllers.get(r.key) === r.controller) fetchControllers.delete(r.key);
        });
        let fetcherIsMounted = state.fetchers.has(key);
        let getRedirectStateWithDoneFetcher = (s)=>{
            if (!fetcherIsMounted) return s;
            let workingFetchers = new Map(s.fetchers);
            workingFetchers.set(key, $a34ef2d9e87cf685$var$getDoneFetcher(actionResult.data));
            return {
                ...s,
                fetchers: workingFetchers
            };
        };
        let redirect = $a34ef2d9e87cf685$var$findRedirect(loaderResults);
        if (redirect) {
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, "fetcher", {
                preventScrollReset: preventScrollReset
            });
        }
        redirect = $a34ef2d9e87cf685$var$findRedirect(fetcherResults);
        if (redirect) {
            fetchRedirectIds.add(redirect.key);
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, "fetcher", {
                preventScrollReset: preventScrollReset
            });
        }
        let finalFetchers = new Map(state.fetchers);
        if (fetcherIsMounted) finalFetchers.set(key, $a34ef2d9e87cf685$var$getDoneFetcher(actionResult.data));
        let { loaderData: loaderData, errors: errors } = $a34ef2d9e87cf685$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults, finalFetchers);
        abortStaleFetchLoads(loadId, finalFetchers);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            (0, $aDbDg.invariant)(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            markFetchRedirectsDone(finalFetchers);
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: finalFetchers
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $a34ef2d9e87cf685$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: finalFetchers
            });
            isRevalidationRequired = fetchReloadIds.size > 0;
        }
    }
    async function handleFetcherLoader(key, loadMatch, matches, scopedContext, flushSync, preventScrollReset, submission) {
        let { routeId: routeId, path: path } = loadMatch;
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $a34ef2d9e87cf685$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        if (future.unstable_customRouteDiscovery) fetchControllers.set(key, abortController);
        let fetchRequest = $a34ef2d9e87cf685$var$createClientSideRequest(init.history, path, abortController.signal);
        if (loadMatch.isDiscovering) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (future.unstable_customRouteDiscovery && fetchRequest.signal.aborted || discoverResult.type === "aborted") return;
            else if (discoverResult.type === "cancelled") {
                fetchControllers.delete(key);
                fetchLoadMatches.delete(key);
                updateFetcherState(key, $a34ef2d9e87cf685$var$getDoneFetcher(existingFetcher?.data), {
                    flushSync: flushSync
                });
                return;
            } else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $a34ef2d9e87cf685$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                loadMatch.isDiscovering = false;
            }
        }
        let match = $a34ef2d9e87cf685$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy(fetchRequest, path, $a34ef2d9e87cf685$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, path, matches, match, hydrationRouteProperties, scopedContext), scopedContext, key, "fetcher");
        let result = results[match.route.id];
        if (!result) {
            for (let match of matches)if (results[match.route.id]) {
                result = results[match.route.id];
                break;
            }
        }
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $a34ef2d9e87cf685$var$getDoneFetcher(void 0));
            return;
        }
        if ($a34ef2d9e87cf685$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $a34ef2d9e87cf685$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, "fetcher", {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($a34ef2d9e87cf685$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $a34ef2d9e87cf685$var$getDoneFetcher(result.data));
    }
    /**
	* Utility function to handle redirects returned from an action or loader.
	* Normally, a redirect "replaces" the navigation that triggered it.  So, for
	* example:
	*
	*  - user is on /a
	*  - user clicks a link to /b
	*  - loader for /b redirects to /c
	*
	* In a non-JS app the browser would track the in-flight navigation to /b and
	* then replace it with /c when it encountered the redirect response.  In
	* the end it would only ever update the URL bar with /c.
	*
	* In client-side routing using pushState/replaceState, we aim to emulate
	* this behavior and we also do not update history until the end of the
	* navigation (including processed redirects).  This means that we never
	* actually touch history until we've processed redirects, so we just use
	* the history action from the original navigation (PUSH or REPLACE).
	*/ async function startRedirectNavigation(request, redirect, isNavigation, dataStrategyInitiator, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd?.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        (0, $aDbDg.invariant)(location, "Expected a Location header on the redirect Response");
        let originalLocation = location;
        let currentUrl = new URL(request.url);
        location = $a34ef2d9e87cf685$var$normalizeRedirectLocation(location, currentUrl, basename, init.history);
        (0, $2gfKq.validateNavigationTarget)(originalLocation, location, currentUrl, "allow-explicit");
        let redirectLocation = (0, $aDbDg.createLocation)(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ((0, $jcvU7.isAbsoluteUrl)(location)) {
                const url = (0, $aDbDg.createBrowserURLImpl)(routerWindow, location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || (0, $jcvU7.stripBasename)(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace === true || redirect.response.headers.has("X-Remix-Replace") ? "REPLACE" : "PUSH";
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $a34ef2d9e87cf685$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($a34ef2d9e87cf685$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $a34ef2d9e87cf685$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0,
            dataStrategyInitiator: dataStrategyInitiator
        });
        else await startNavigation(redirectNavigationType, redirectLocation, {
            overrideNavigation: $a34ef2d9e87cf685$var$getLoadingNavigation(redirectLocation, [], redirectNavigationType, submission),
            fetcherSubmission: fetcherSubmission,
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0,
            dataStrategyInitiator: dataStrategyInitiator
        });
    }
    async function callDataStrategy(request, path, matches, scopedContext, fetcherKey, initiator, navigationType = null) {
        let results;
        let dataResults = {};
        try {
            results = await $a34ef2d9e87cf685$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, initiator, scopedContext, false, navigationType);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error",
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        if (!$a34ef2d9e87cf685$export$cbae47800eb95bc3(request.method)) for (let match of matches){
            if (results[match.route.id]?.type === "error") break;
            if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                type: "error",
                result: /* @__PURE__ */ new Error(`No result returned from dataStrategy for route ${match.route.id}`)
            };
        }
        for (let [routeId, result] of Object.entries(results))if ($a34ef2d9e87cf685$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect",
                response: $a34ef2d9e87cf685$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $a34ef2d9e87cf685$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, location, scopedContext, initiator, navigationType = null) {
        let loaderResultsPromise = callDataStrategy(request, location, matches, scopedContext, null, initiator, navigationType);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let result = (await callDataStrategy(f.request, f.path, f.matches, scopedContext, f.key, initiator, navigationType))[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error",
                    error: $a34ef2d9e87cf685$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        return {
            loaderResults: await loaderResultsPromise,
            fetcherResults: (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {})
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((loadMatch, key)=>{
            if (future.unstable_customRouteDiscovery && loadMatch.isDiscovering) return;
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, fetcher);
        updateState({
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $a34ef2d9e87cf685$var$findNearestBoundary(state.matches, routeId);
        let workingFetchers = new Map(state.fetchers);
        deleteFetcher(workingFetchers, key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $a34ef2d9e87cf685$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        fetchLoadMatches.delete(key);
        cancelledFetcherLoads.delete(key);
        updateFetcherState(key, $a34ef2d9e87cf685$var$getDoneFetcher(null));
    }
    function deleteFetcher(fetchers, key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys, fetchers) {
        for (let key of keys){
            let fetcher = fetchers.get(key);
            (0, $aDbDg.invariant)(fetcher, `Expected fetcher: ${key}`);
            let doneFetcher = $a34ef2d9e87cf685$var$getDoneFetcher(fetcher.data);
            fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone(fetchers) {
        let doneKeys = [];
        let didUpdateFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = fetchers.get(key);
            (0, $aDbDg.invariant)(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                didUpdateFetchers = true;
            }
        }
        markFetchersDone(doneKeys, fetchers);
        return didUpdateFetchers;
    }
    function abortStaleFetchLoads(landedId, fetchers) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = fetchers.get(key);
            (0, $aDbDg.invariant)(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys, fetchers);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $a34ef2d9e87cf685$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $a34ef2d9e87cf685$export$386d57f03f0b2883;
        (0, $aDbDg.invariant)(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) (0, $aDbDg.warning)(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $a34ef2d9e87cf685$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = dataRoutes.activeRoutes;
        let { matches: matches, route: route } = $a34ef2d9e87cf685$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        if (!initialScrollRestored && state.navigation === $a34ef2d9e87cf685$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) return getScrollRestorationKey(location, matches.map((m)=>(0, $jcvU7.convertRouteMatchToUiMatch)(m, state.loaderData))) || location.key;
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, pathname) {
        if (init.patchRoutesOnNavigation) {
            if (!matches) return {
                active: true,
                matches: dataRouteMatcher.match(pathname, true) || []
            };
            else if (Object.keys(matches[0].params).length > 0) return {
                active: true,
                matches: dataRouteMatcher.match(pathname, true)
            };
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $a34ef2d9e87cf685$var$patchRoutesImpl(routeId, children, dataRoutes, localManifest, mapRouteProperties, false);
                    }
                });
            } catch (e) {
                if (future.unstable_customRouteDiscovery) {
                    if (signal.aborted) return {
                        type: "aborted"
                    };
                    if (e instanceof (0, $jcvU7.DiscoveryCancelledError)) return {
                        type: "cancelled"
                    };
                }
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = dataRouteMatcher.match(pathname);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = dataRouteMatcher.match(pathname, true);
                    if (!(newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length)))) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = dataRouteMatcher.match(pathname, true);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        dataRoutes.setHmrRoutes((0, $jcvU7.convertRoutesToDataRoutes)(newRoutes, mapRouteProperties, void 0, manifest));
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        $a34ef2d9e87cf685$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties, unstable_allowElementMutations);
        if (!dataRoutes.hasHMRRoutes) updateState({});
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes.stableRoutes;
        },
        match (locationArg) {
            return dataRouteMatcher.match(locationArg);
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        createHref: (to)=>init.history.createHref(to),
        createURL: (to)=>init.history.createURL(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.instrumentations) router = (0, $d1yHl.instrumentClientSideRouter)(router, init.instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
/**
* Create a static handler to perform server-side data loading
*
* @example
* export async function handleRequest(request: Request) {
*   let { query, dataRoutes } = createStaticHandler(routes);
*   let context = await query(request);
*
*   if (context instanceof Response) {
*     return context;
*   }
*
*   let router = createStaticRouter(dataRoutes, context);
*   return new Response(
*     ReactDOMServer.renderToString(<StaticRouterProvider ... />),
*     { headers: { "Content-Type": "text/html" } }
*   );
* }
*
* @public
* @category Data Routers
* @mode data
* @param routes The {@link RouteObject | route objects} to create a static
* handler for
* @param opts Options
* @param opts.basename The base URL for the static handler (default: `/`)
* @param opts.future Future flags for the static handler
* @returns A static handler that can be used to query data for the provided
* routes
*/ function $a34ef2d9e87cf685$export$3336b097a6fbc59a(routes, opts) {
    (0, $aDbDg.invariant)(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties;
    let mapRouteProperties = _mapRouteProperties ? _mapRouteProperties : ()=>({});
    let dataRouteMatcher = $a34ef2d9e87cf685$export$5e64b3b9d7e2ec36({
        ...opts?.future
    }, basename);
    if (opts?.instrumentations) {
        let instrumentations = opts.instrumentations;
        mapRouteProperties = (route)=>{
            return {
                ..._mapRouteProperties?.(route),
                ...(0, $d1yHl.getRouteInstrumentationUpdates)(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = (0, $jcvU7.convertRoutesToDataRoutes)(routes, mapRouteProperties, void 0, manifest);
    dataRouteMatcher.update(dataRoutes);
    let match = (locationArg)=>dataRouteMatcher.match(locationArg);
    /**
	* The query() method is intended for document requests, in which we want to
	* call an optional action and potentially multiple loaders for all nested
	* routes.  It returns a StaticHandlerContext object, which is very similar
	* to the router state (location, loaderData, actionData, errors, etc.) and
	* also adds SSR-specific information such as the statusCode and headers
	* from action/loaders Responses.
	*
	* It _should_ never throw and should report all errors through the
	* returned handlerContext.errors object, properly associating errors to
	* their error boundary.  Additionally, it tracks _deepestRenderedBoundaryId
	* which can be used to emulate React error boundaries during SSR by performing
	* a second pass only down to the boundaryId.
	*
	* The one exception where we do not return a StaticHandlerContext is when a
	* redirect response is returned or thrown from any action/loader.  We
	* propagate that out and return the raw Response so the HTTP server can
	* return it directly.
	*
	* - `opts.requestContext` is an optional server context that will be passed
	*   to actions/loaders in the `context` parameter
	* - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
	*   the bubbling of errors which allows single-fetch-type implementations
	*   where the client will handle the bubbling and we may need to return data
	*   for the handling route
	*/ async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $a34ef2d9e87cf685$var$defaultNormalizePath;
        let method = request.method;
        let location = (0, $aDbDg.createLocation)("", normalizePathImpl(request), null, "default");
        let matches = dataRouteMatcher.match(location);
        requestContext = requestContext != null ? requestContext : new (0, $jcvU7.RouterContextProvider)();
        if (!$a34ef2d9e87cf685$var$isValidMethod(method) && method !== "HEAD") {
            let error = $a34ef2d9e87cf685$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $a34ef2d9e87cf685$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                _match: match
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $a34ef2d9e87cf685$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $a34ef2d9e87cf685$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                _match: match
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            (0, $aDbDg.invariant)(requestContext instanceof (0, $jcvU7.RouterContextProvider), "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $a34ef2d9e87cf685$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties);
                let renderedStaticContext;
                let response = await $a34ef2d9e87cf685$var$runServerMiddlewarePipeline({
                    request: request,
                    url: (0, $jcvU7.createDataFunctionUrl)(request, location),
                    pattern: (0, $jcvU7.getRoutePattern)(matches),
                    matches: matches,
                    params: matches[0].params,
                    context: requestContext
                }, async ()=>{
                    return await generateMiddlewareResponse(async (revalidationRequest, opts = {})=>{
                        let result = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts ? opts.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($a34ef2d9e87cf685$export$3f1eb41d9a6a6a27(result)) return result;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result,
                            _match: match
                        };
                        return renderedStaticContext;
                    });
                }, async (error, routeId)=>{
                    if ($a34ef2d9e87cf685$export$6e80290866a84dd4(error)) return error;
                    if ($a34ef2d9e87cf685$export$3f1eb41d9a6a6a27(error)) try {
                        error = new (0, $jcvU7.ErrorResponseImpl)(error.status, error.statusText, await $a34ef2d9e87cf685$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($a34ef2d9e87cf685$export$e0163cfdf7bc9cfa(error)) error = $a34ef2d9e87cf685$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $a34ef2d9e87cf685$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $a34ef2d9e87cf685$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [skipLoaderErrorBubbling ? routeId : $a34ef2d9e87cf685$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id]: error
                            },
                            statusCode: (0, $jcvU7.isRouteErrorResponse)(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {},
                            _match: match
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                (0, $aDbDg.invariant)($a34ef2d9e87cf685$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($a34ef2d9e87cf685$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($a34ef2d9e87cf685$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result,
            _match: match
        };
    }
    /**
	* The queryRoute() method is intended for targeted route requests, either
	* for fetch ?_data requests or resource route requests.  In this case, we
	* are only ever calling a single action or loader, and we are returning the
	* returned value directly.  In most cases, this will be a Response returned
	* from the action/loader, but it may be a primitive or other value as well -
	* and in such cases the calling context should handle that accordingly.
	*
	* We do respect the throw/return differentiation, so if an action/loader
	* throws, then this method will throw the value.  This is important so we
	* can do proper boundary identification in Remix where a thrown Response
	* must go to the Catch Boundary but a returned Response is happy-path.
	*
	* One thing to note is that any Router-initiated Errors that make sense
	* to associate with a status code will be thrown as an ErrorResponse
	* instance which include the raw Error, such that the calling context can
	* serialize the error as they see fit while including the proper response
	* code.  Examples here are 404 and 405 errors that occur prior to reaching
	* any user-defined loaders.
	*
	* - `opts.routeId` allows you to specify the specific route handler to call.
	*   If not provided the handler will determine the proper route by matching
	*   against `request.url`
	* - `opts.requestContext` is an optional server context that will be passed
	*    to actions/loaders in the `context` parameter
	*/ async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $a34ef2d9e87cf685$var$defaultNormalizePath;
        let method = request.method;
        let location = (0, $aDbDg.createLocation)("", normalizePathImpl(request), null, "default");
        let matches = dataRouteMatcher.match(location);
        requestContext = requestContext != null ? requestContext : new (0, $jcvU7.RouterContextProvider)();
        if (!$a34ef2d9e87cf685$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $a34ef2d9e87cf685$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $a34ef2d9e87cf685$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $a34ef2d9e87cf685$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $a34ef2d9e87cf685$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $a34ef2d9e87cf685$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            (0, $aDbDg.invariant)(requestContext instanceof (0, $jcvU7.RouterContextProvider), "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $a34ef2d9e87cf685$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties);
            return await $a34ef2d9e87cf685$var$runServerMiddlewarePipeline({
                request: request,
                url: (0, $jcvU7.createDataFunctionUrl)(request, location),
                pattern: (0, $jcvU7.getRoutePattern)(matches),
                matches: matches,
                params: matches[0].params,
                context: requestContext
            }, async ()=>{
                return await generateMiddlewareResponse(async (innerRequest)=>{
                    let processed = handleQueryResult(await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false));
                    return $a34ef2d9e87cf685$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
            }, (error)=>{
                if ($a34ef2d9e87cf685$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($a34ef2d9e87cf685$var$dataWithResponseInitToResponse(error));
                if ($a34ef2d9e87cf685$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
        }
        return handleQueryResult(await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false));
        function handleQueryResult(result) {
            if ($a34ef2d9e87cf685$export$3f1eb41d9a6a6a27(result)) return result;
            let error = result.errors ? Object.values(result.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result.actionData) return Object.values(result.actionData)[0];
            if (result.loaderData) return Object.values(result.loaderData)[0];
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        (0, $aDbDg.invariant)(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($a34ef2d9e87cf685$export$cbae47800eb95bc3(request.method)) return await submit(request, location, matches, routeMatch || $a34ef2d9e87cf685$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
            let result = await loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $a34ef2d9e87cf685$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($a34ef2d9e87cf685$var$isDataStrategyResult(e) && $a34ef2d9e87cf685$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error") throw e.result;
                return e.result;
            }
            if ($a34ef2d9e87cf685$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, location, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $a34ef2d9e87cf685$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error",
                error: error
            };
        } else {
            result = (await callDataStrategy(request, location, $a34ef2d9e87cf685$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, request, location, matches, actionMatch, [], requestContext), isRouteRequest, requestContext, dataStrategy))[actionMatch.route.id];
            if (request.signal.aborted) $a34ef2d9e87cf685$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($a34ef2d9e87cf685$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($a34ef2d9e87cf685$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($a34ef2d9e87cf685$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $a34ef2d9e87cf685$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: (0, $jcvU7.isRouteErrorResponse)(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($a34ef2d9e87cf685$var$isErrorResult(result)) return {
            ...await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                (skipLoaderErrorBubbling ? actionMatch : $a34ef2d9e87cf685$var$findNearestBoundary(matches, actionMatch.route.id)).route.id,
                result
            ]),
            statusCode: (0, $jcvU7.isRouteErrorResponse)(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
            actionData: null,
            actionHeaders: {
                ...result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {}
            }
        };
        return {
            ...await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad),
            actionData: {
                [actionMatch.route.id]: result.data
            },
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $a34ef2d9e87cf685$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $a34ef2d9e87cf685$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, request, location, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $a34ef2d9e87cf685$var$isErrorResult(pendingActionResult[1]) ? matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = (0, $jcvU7.getRoutePattern)(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $a34ef2d9e87cf685$var$getDataStrategyMatch(mapRouteProperties, manifest, request, location, pattern, match, [], requestContext, false);
                return $a34ef2d9e87cf685$var$getDataStrategyMatch(mapRouteProperties, manifest, request, location, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $a34ef2d9e87cf685$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $a34ef2d9e87cf685$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        return {
            ...$a34ef2d9e87cf685$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling),
            matches: matches
        };
    }
    async function callDataStrategy(request, location, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $a34ef2d9e87cf685$var$callDataStrategyImpl(dataStrategy || $a34ef2d9e87cf685$var$defaultDataStrategy, request, location, matches, null, "static", requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($a34ef2d9e87cf685$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $a34ef2d9e87cf685$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($a34ef2d9e87cf685$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($a34ef2d9e87cf685$export$e0163cfdf7bc9cfa(result.result)) throw $a34ef2d9e87cf685$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $a34ef2d9e87cf685$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        get _matchCost () {
            return dataRouteMatcher instanceof (0, $i9oDI.V6RegExMatcher) ? dataRouteMatcher.matchCost : void 0;
        },
        match: match,
        query: query,
        queryRoute: queryRoute
    };
}
/**
* Given an existing StaticHandlerContext and an error thrown at render time,
* provide an updated StaticHandlerContext suitable for a second SSR render
*
* @category Utils
*/ function $a34ef2d9e87cf685$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: (0, $jcvU7.isRouteErrorResponse)(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $a34ef2d9e87cf685$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    throw new Error(`${isRouteRequest ? "queryRoute" : "query"}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $a34ef2d9e87cf685$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $a34ef2d9e87cf685$var$defaultNormalizePath(request) {
    let url = new URL(request.url);
    return {
        pathname: url.pathname,
        search: url.search,
        hash: url.hash
    };
}
function $a34ef2d9e87cf685$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = (0, $jcvU7.resolveTo)(to ? to : ".", (0, $jcvU7.getResolveToMatches)(contextualMatches), (0, $jcvU7.stripBasename)(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $a34ef2d9e87cf685$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = (0, $jcvU7.prependBasename)({
        basename: basename,
        pathname: path.pathname
    });
    return (0, $aDbDg.createPath)(path);
}
function $a34ef2d9e87cf685$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$a34ef2d9e87cf685$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$a34ef2d9e87cf685$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $a34ef2d9e87cf685$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $a34ef2d9e87cf685$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let formMethod = (opts.formMethod || "get").toUpperCase();
    let formAction = $a34ef2d9e87cf685$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$a34ef2d9e87cf685$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}\n`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$a34ef2d9e87cf685$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch  {
                return getInvalidBodyError();
            }
        }
    }
    (0, $aDbDg.invariant)(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $a34ef2d9e87cf685$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $a34ef2d9e87cf685$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $a34ef2d9e87cf685$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $a34ef2d9e87cf685$var$convertSearchParamsToFormData(searchParams);
    } catch  {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($a34ef2d9e87cf685$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = (0, $aDbDg.parsePath)(path);
    if (isFetcher && parsedPath.search && $a34ef2d9e87cf685$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: (0, $aDbDg.createPath)(parsedPath),
        submission: submission
    };
}
function $a34ef2d9e87cf685$var$getMatchesToLoad(request, scopedContext, mapRouteProperties, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, dataRouteMatcher, pendingActionResult, callSiteDefaultShouldRevalidate) {
    let actionResult = pendingActionResult ? $a34ef2d9e87cf685$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $a34ef2d9e87cf685$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = (0, $jcvU7.getRoutePattern)(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$a34ef2d9e87cf685$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) {
            let { shouldLoad: shouldLoad } = $a34ef2d9e87cf685$var$getRouteHydrationStatus(route, state.loaderData, state.errors);
            forceShouldLoad = shouldLoad;
        } else if ($a34ef2d9e87cf685$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $a34ef2d9e87cf685$var$getDataStrategyMatch(mapRouteProperties, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if ($a34ef2d9e87cf685$var$isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        return $a34ef2d9e87cf685$var$getDataStrategyMatch(mapRouteProperties, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, $a34ef2d9e87cf685$var$shouldRevalidateLoader(match, shouldRevalidateArgs), shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key) || f.isDiscovering) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = dataRouteMatcher.match(f.path);
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $a34ef2d9e87cf685$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $a34ef2d9e87cf685$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $a34ef2d9e87cf685$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $a34ef2d9e87cf685$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            };
            if ($a34ef2d9e87cf685$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $a34ef2d9e87cf685$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $a34ef2d9e87cf685$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $a34ef2d9e87cf685$var$getRouteHydrationStatus(route, loaderData, errors) {
    if (route.lazy) return {
        shouldLoad: true,
        renderFallback: true
    };
    if (!$a34ef2d9e87cf685$var$routeHasLoaderOrMiddleware(route)) return {
        shouldLoad: false,
        renderFallback: false
    };
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return {
        shouldLoad: false,
        renderFallback: false
    };
    if (typeof route.loader === "function" && route.loader.hydrate === true) return {
        shouldLoad: true,
        renderFallback: !hasData
    };
    let shouldLoad = !hasData && !hasError;
    return {
        shouldLoad: shouldLoad,
        renderFallback: shouldLoad
    };
}
function $a34ef2d9e87cf685$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = !currentMatch || match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $a34ef2d9e87cf685$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return currentMatch.pathname !== match.pathname || currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"];
}
function $a34ef2d9e87cf685$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $a34ef2d9e87cf685$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        (0, $aDbDg.invariant)(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = dataRoutes.activeRoutes;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute)=>$a34ef2d9e87cf685$var$isSameRoute(newRoute, existingRoute));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = (0, $jcvU7.convertRoutesToDataRoutes)(uniqueChildren, mapRouteProperties, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = (0, $jcvU7.convertRoutesToDataRoutes)([
            newRoute
        ], mapRouteProperties, [], {}, true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
    if (!dataRoutes.hasHMRRoutes) dataRoutes.setRoutes([
        ...dataRoutes.activeRoutes
    ]);
}
function $a34ef2d9e87cf685$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children?.every((aChild, i)=>existingRoute.children?.some((bChild)=>$a34ef2d9e87cf685$var$isSameRoute(aChild, bChild))) ?? false;
}
const $a34ef2d9e87cf685$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
const $a34ef2d9e87cf685$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties })=>{
    let routeToUpdate = manifest[route.id];
    (0, $aDbDg.invariant)(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $a34ef2d9e87cf685$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $a34ef2d9e87cf685$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = (0, $jcvU7.isUnsupportedLazyRouteObjectKey)(key);
        let isStaticallyDefined = routeToUpdate[key] !== void 0;
        if (isUnsupported) {
            (0, $aDbDg.warning)(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) (0, $aDbDg.warning)(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    propertyPromise.catch(()=>{
        if (cache[key] === propertyPromise) delete cache[key];
    });
    return propertyPromise;
};
const $a34ef2d9e87cf685$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
/**
* Execute route.lazy functions to lazily load route modules (loader, action,
* shouldRevalidate) and update the routeManifest in place which shares objects
* with dataRoutes so those get updated as well.
*/ function $a34ef2d9e87cf685$var$loadLazyRoute(route, type, manifest, mapRouteProperties, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    (0, $aDbDg.invariant)(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $a34ef2d9e87cf685$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise = (async ()=>{
            (0, $aDbDg.invariant)(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = (0, $jcvU7.isUnsupportedLazyRouteFunctionKey)(lazyRouteProperty);
                let isStaticallyDefined = routeToUpdate[lazyRouteProperty] !== void 0;
                if (isUnsupported) (0, $aDbDg.warning)(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) (0, $aDbDg.warning)(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                ...mapRouteProperties(routeToUpdate),
                lazy: void 0
            });
        })();
        $a34ef2d9e87cf685$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise);
        lazyRoutePromise.catch(()=>{
            if ($a34ef2d9e87cf685$var$lazyRouteFunctionCache.get(routeToUpdate) === lazyRoutePromise) $a34ef2d9e87cf685$var$lazyRouteFunctionCache.delete(routeToUpdate);
        });
        return {
            lazyRoutePromise: lazyRoutePromise,
            lazyHandlerPromise: lazyRoutePromise
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $a34ef2d9e87cf685$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $a34ef2d9e87cf685$var$isNonNullable(value) {
    return value !== void 0;
}
function $a34ef2d9e87cf685$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return;
        return $a34ef2d9e87cf685$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties
        });
    }).filter($a34ef2d9e87cf685$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $a34ef2d9e87cf685$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    (await Promise.all(matchesToLoad.map((m)=>m.resolve()))).forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $a34ef2d9e87cf685$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $a34ef2d9e87cf685$var$defaultDataStrategy(args);
    return $a34ef2d9e87cf685$var$runClientMiddlewarePipeline(args, ()=>$a34ef2d9e87cf685$var$defaultDataStrategy(args));
}
function $a34ef2d9e87cf685$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $a34ef2d9e87cf685$var$runMiddlewarePipeline(args, handler, processResult, $a34ef2d9e87cf685$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $a34ef2d9e87cf685$export$e0163cfdf7bc9cfa(result) ? $a34ef2d9e87cf685$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $a34ef2d9e87cf685$var$runClientMiddlewarePipeline(args, handler) {
    return $a34ef2d9e87cf685$var$runMiddlewarePipeline(args, handler, (r)=>{
        if ($a34ef2d9e87cf685$export$6e80290866a84dd4(r)) throw r;
        return r;
    }, $a34ef2d9e87cf685$var$isDataStrategyResults, errorHandler);
    async function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        });
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let deepestRouteId = matches[maxBoundaryIdx].route.id;
            for (let match of matches.slice(0, maxBoundaryIdx + 1))try {
                await match._lazyPromises?.route;
            } catch  {
                deepestRouteId = match.route.id;
                break;
            }
            return {
                [$a34ef2d9e87cf685$var$findNearestBoundary(matches, deepestRouteId).route.id]: {
                    type: "error",
                    result: error
                }
            };
        }
    }
}
async function $a34ef2d9e87cf685$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, ...dataFnArgs } = args;
    return await $a34ef2d9e87cf685$var$callRouteMiddleware(dataFnArgs, matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []), handler, processResult, isResult, errorHandler);
}
async function $a34ef2d9e87cf685$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? /* @__PURE__ */ new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) return await handler();
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            nextResult = {
                value: await $a34ef2d9e87cf685$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1)
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        return await errorHandler(error, routeId, nextResult);
    }
}
function $a34ef2d9e87cf685$var$getDataStrategyMatchLazyPromises(mapRouteProperties, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $a34ef2d9e87cf685$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties
    });
    let lazyRoutePromises = $a34ef2d9e87cf685$var$loadLazyRoute(match.route, $a34ef2d9e87cf685$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $a34ef2d9e87cf685$var$getDataStrategyMatch(mapRouteProperties, manifest, request, path, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null, callSiteDefaultShouldRevalidate) {
    let isUsingNewApi = false;
    let _lazyPromises = $a34ef2d9e87cf685$var$getDataStrategyMatchLazyPromises(mapRouteProperties, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return $a34ef2d9e87cf685$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            });
            if (typeof defaultShouldRevalidate === "boolean") return $a34ef2d9e87cf685$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $a34ef2d9e87cf685$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$a34ef2d9e87cf685$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($a34ef2d9e87cf685$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $a34ef2d9e87cf685$var$callLoaderOrAction({
                request: request,
                path: path,
                pattern: pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data",
                result: void 0
            });
        }
    };
}
function $a34ef2d9e87cf685$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, request, path, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $a34ef2d9e87cf685$var$getDataStrategyMatchLazyPromises(mapRouteProperties, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $a34ef2d9e87cf685$var$getDataStrategyMatch(mapRouteProperties, manifest, request, path, (0, $jcvU7.getRoutePattern)(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $a34ef2d9e87cf685$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, initiator, scopedContext, isStaticHandler, navigationType = null) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        url: (0, $jcvU7.createDataFunctionUrl)(request, path),
        pattern: (0, $jcvU7.getRoutePattern)(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches,
        unstable_initiator: initiator,
        unstable_navigationType: initiator === "navigation" ? navigationType : null
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $a34ef2d9e87cf685$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch  {}
    return results;
}
async function $a34ef2d9e87cf685$var$callLoaderOrAction({ request: request, path: path, pattern: pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $a34ef2d9e87cf685$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(/* @__PURE__ */ new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                url: (0, $jcvU7.createDataFunctionUrl)(request, path),
                pattern: pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                return {
                    type: "data",
                    result: await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler())
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler = isAction ? match.route.action : match.route.loader;
                if (handler) [result] = await Promise.all([
                    runHandler(handler),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $a34ef2d9e87cf685$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else {
                    await lazyRoutePromise;
                    return {
                        type: "data",
                        result: void 0
                    };
                }
            }
        } else if (!handler) {
            let url = new URL(request.url);
            throw $a34ef2d9e87cf685$var$getInternalRouterError(404, {
                pathname: url.pathname + url.search
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error",
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $a34ef2d9e87cf685$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $a34ef2d9e87cf685$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($a34ef2d9e87cf685$export$3f1eb41d9a6a6a27(result)) {
        let data;
        try {
            data = await $a34ef2d9e87cf685$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error",
                error: e
            };
        }
        if (type === "error") return {
            type: "error",
            error: new (0, $jcvU7.ErrorResponseImpl)(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data",
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error") {
        if ($a34ef2d9e87cf685$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error",
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error",
                error: $a34ef2d9e87cf685$var$dataWithResponseInitToErrorResponse(result),
                statusCode: (0, $jcvU7.isRouteErrorResponse)(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error",
            error: result,
            statusCode: (0, $jcvU7.isRouteErrorResponse)(result) ? result.status : void 0
        };
    }
    if ($a34ef2d9e87cf685$export$e0163cfdf7bc9cfa(result)) return {
        type: "data",
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data",
        data: result
    };
}
function $a34ef2d9e87cf685$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    (0, $aDbDg.invariant)(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!(0, $jcvU7.isAbsoluteUrl)(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $a34ef2d9e87cf685$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
const $a34ef2d9e87cf685$var$invalidProtocols = [
    "about:",
    "blob:",
    "chrome:",
    "chrome-untrusted:",
    "content:",
    "data:",
    "devtools:",
    "file:",
    "filesystem:",
    "javascript:"
];
function $a34ef2d9e87cf685$export$961a3ef7a4da3a39(location) {
    try {
        return $a34ef2d9e87cf685$var$invalidProtocols.includes(new URL(location).protocol);
    } catch  {
        return false;
    }
}
function $a34ef2d9e87cf685$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    if ((0, $jcvU7.isAbsoluteUrl)(location)) {
        let normalizedLocation = location;
        let url = (0, $2lzVq.PROTOCOL_RELATIVE_URL_REGEX).test(normalizedLocation) ? new URL((0, $2lzVq.normalizeProtocolRelativeUrl)(normalizedLocation, currentUrl.protocol)) : new URL(normalizedLocation);
        if ($a34ef2d9e87cf685$export$961a3ef7a4da3a39(url.toString())) throw new Error("Invalid redirect location");
        let isSameBasename = (0, $jcvU7.stripBasename)(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return (0, $jcvU7.removeDoubleSlashes)(url.pathname) + url.search + url.hash;
    }
    try {
        if ($a34ef2d9e87cf685$export$961a3ef7a4da3a39(historyInstance.createURL(location).toString())) throw new Error("Invalid redirect location");
    } catch  {}
    return location;
}
function $a34ef2d9e87cf685$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($a34ef2d9e87cf685$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $a34ef2d9e87cf685$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $a34ef2d9e87cf685$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $a34ef2d9e87cf685$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $a34ef2d9e87cf685$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $a34ef2d9e87cf685$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $a34ef2d9e87cf685$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        (0, $aDbDg.invariant)(!$a34ef2d9e87cf685$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($a34ef2d9e87cf685$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $a34ef2d9e87cf685$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $a34ef2d9e87cf685$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = (0, $jcvU7.isRouteErrorResponse)(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $a34ef2d9e87cf685$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers) {
    let { loaderData: loaderData, errors: errors } = $a34ef2d9e87cf685$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, routeId: routeId, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        (0, $aDbDg.invariant)(result, "Did not find corresponding fetcher result");
        if ($a34ef2d9e87cf685$var$isErrorResult(result)) {
            let boundaryMatch = $a34ef2d9e87cf685$var$findNearestBoundary(state.matches, routeId);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            workingFetchers.delete(key);
        } else if ($a34ef2d9e87cf685$var$isRedirectResult(result)) (0, $aDbDg.invariant)(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $a34ef2d9e87cf685$var$getDoneFetcher(result.data);
            workingFetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $a34ef2d9e87cf685$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $a34ef2d9e87cf685$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    let preservedCount = 0;
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) {
            mergedLoaderData[id] = loaderData[id];
            preservedCount++;
        }
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return Object.keys(newLoaderData).length === 0 && preservedCount === Object.keys(loaderData).length ? loaderData : mergedLoaderData;
}
function $a34ef2d9e87cf685$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $a34ef2d9e87cf685$var$isErrorResult(pendingActionResult[1]) ? {
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $a34ef2d9e87cf685$var$findNearestBoundary(matches, routeId) {
    return (routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ]).reverse().find((m)=>m.route.ErrorBoundary != null || m.route.errorElement != null) || matches[0];
}
function $a34ef2d9e87cf685$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $a34ef2d9e87cf685$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new (0, $jcvU7.ErrorResponseImpl)(status || 500, statusText, new Error(errorMessage), true);
}
function $a34ef2d9e87cf685$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($a34ef2d9e87cf685$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $a34ef2d9e87cf685$var$stripHashFromPath(path) {
    return (0, $aDbDg.createPath)({
        ...typeof path === "string" ? (0, $aDbDg.parsePath)(path) : path,
        hash: ""
    });
}
function $a34ef2d9e87cf685$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $a34ef2d9e87cf685$var$dataWithResponseInitToResponse(data) {
    return Response.json(data.data, data.init ?? void 0);
}
function $a34ef2d9e87cf685$var$dataWithResponseInitToErrorResponse(data) {
    return new (0, $jcvU7.ErrorResponseImpl)(data.init?.status ?? 500, data.init?.statusText ?? "Internal Server Error", data.data);
}
function $a34ef2d9e87cf685$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $a34ef2d9e87cf685$var$isDataStrategyResult(value));
}
function $a34ef2d9e87cf685$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" || result.type === "error");
}
function $a34ef2d9e87cf685$var$isRedirectDataStrategyResult(result) {
    return $a34ef2d9e87cf685$export$3f1eb41d9a6a6a27(result.result) && $a34ef2d9e87cf685$var$redirectStatusCodes.has(result.result.status);
}
function $a34ef2d9e87cf685$var$isErrorResult(result) {
    return result.type === "error";
}
function $a34ef2d9e87cf685$var$isRedirectResult(result) {
    return (result && result.type) === "redirect";
}
function $a34ef2d9e87cf685$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $a34ef2d9e87cf685$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $a34ef2d9e87cf685$export$794b2760043cf8cd(statusCode) {
    return $a34ef2d9e87cf685$var$redirectStatusCodes.has(statusCode);
}
function $a34ef2d9e87cf685$export$6e80290866a84dd4(result) {
    return $a34ef2d9e87cf685$export$3f1eb41d9a6a6a27(result) && $a34ef2d9e87cf685$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $a34ef2d9e87cf685$var$isValidMethod(method) {
    return $a34ef2d9e87cf685$var$validRequestMethods.has(method.toUpperCase());
}
function $a34ef2d9e87cf685$export$cbae47800eb95bc3(method) {
    return $a34ef2d9e87cf685$var$validMutationMethods.has(method.toUpperCase());
}
function $a34ef2d9e87cf685$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $a34ef2d9e87cf685$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? (0, $aDbDg.parsePath)(location).search : location.search;
    if (matches[matches.length - 1].route.index && $a34ef2d9e87cf685$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = (0, $jcvU7.getPathContributingMatches)(matches);
    return pathMatches[pathMatches.length - 1];
}
function $a34ef2d9e87cf685$var$getInstrumentationNavigateMeta(history, location, matches) {
    return {
        url: (0, $jcvU7.createDataFunctionUrl)(history.createURL(location), location),
        pattern: matches ? (0, $jcvU7.getRoutePattern)(matches) : "",
        params: matches?.[0]?.params ? {
            ...matches[0].params
        } : {}
    };
}
function $a34ef2d9e87cf685$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $a34ef2d9e87cf685$var$getLoadingNavigation(location, matches, historyAction, submission) {
    if (submission) return {
        state: "loading",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    else return {
        state: "loading",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0
    };
}
function $a34ef2d9e87cf685$var$getSubmittingNavigation(location, matches, historyAction, submission) {
    return {
        state: "submitting",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
}
function $a34ef2d9e87cf685$var$getLoadingFetcher(submission, data) {
    if (submission) return {
        state: "loading",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: data
    };
    else return {
        state: "loading",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data
    };
}
function $a34ef2d9e87cf685$var$getSubmittingFetcher(submission, existingFetcher) {
    return {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
}
function $a34ef2d9e87cf685$var$getDoneFetcher(data) {
    return {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data
    };
}
function $a34ef2d9e87cf685$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($a34ef2d9e87cf685$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch  {}
}
function $a34ef2d9e87cf685$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($a34ef2d9e87cf685$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            (0, $aDbDg.warning)(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $a34ef2d9e87cf685$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch  {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch  {}
        };
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
}

});
parcelRegister("d1yHl", function(module, exports) {

$parcel$export(module.exports, "getRouteInstrumentationUpdates", function () { return $97b648abc2eb23e2$export$3cb8f5f9ecc770ef; });
$parcel$export(module.exports, "instrumentClientSideRouter", function () { return $97b648abc2eb23e2$export$ac4df491f31cbbfc; });
$parcel$export(module.exports, "consumeInstrumentationClientResultMetaReceiver", function () { return $97b648abc2eb23e2$export$5579798e35f5560e; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $aDbDg = parcelRequire("aDbDg");

var $jcvU7 = parcelRequire("jcvU7");
//#region lib/router/instrumentation.ts
const $97b648abc2eb23e2$var$UninstrumentedSymbol = Symbol("Uninstrumented");
const $97b648abc2eb23e2$export$b1aab28b8e9d7d25 = (0, $jcvU7.createContext)();
let $97b648abc2eb23e2$var$instrumentationClientResultMetaReceivers = /* @__PURE__ */ new WeakMap();
function $97b648abc2eb23e2$export$3cb8f5f9ecc770ef(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                if (i.lazy != null) aggregated.lazy.push(i.lazy);
                if (i["lazy.loader"] != null) aggregated["lazy.loader"].push(i["lazy.loader"]);
                if (i["lazy.action"] != null) aggregated["lazy.action"].push(i["lazy.action"]);
                if (i["lazy.middleware"] != null) aggregated["lazy.middleware"].push(i["lazy.middleware"]);
                if (i.middleware != null) aggregated.middleware.push(i.middleware);
                if (i.loader != null) aggregated.loader.push(i.loader);
                if (i.action != null) aggregated.action.push(i.action);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let lazy = route.lazy;
        updates.lazy = async (...args)=>{
            return $97b648abc2eb23e2$var$throwOrReturnResult(await $97b648abc2eb23e2$var$recurseRight(aggregated.lazy, void 0, ()=>lazy(...args), $97b648abc2eb23e2$var$getInstrumentationInnerResult));
        };
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        if (typeof lazyObject.middleware === "function" && aggregated["lazy.middleware"].length > 0) {
            let middleware = lazyObject.middleware;
            updates.lazy = Object.assign(updates.lazy || {}, {
                middleware: async (...args)=>{
                    return $97b648abc2eb23e2$var$throwOrReturnResult(await $97b648abc2eb23e2$var$recurseRight(aggregated["lazy.middleware"], void 0, ()=>middleware(...args), $97b648abc2eb23e2$var$getInstrumentationInnerResult));
                }
            });
        }
        if (typeof lazyObject.loader === "function" && aggregated["lazy.loader"].length > 0) {
            let loader = lazyObject.loader;
            updates.lazy = Object.assign(updates.lazy || {}, {
                loader: async (...args)=>{
                    return $97b648abc2eb23e2$var$throwOrReturnResult(await $97b648abc2eb23e2$var$recurseRight(aggregated["lazy.loader"], void 0, ()=>loader(...args), $97b648abc2eb23e2$var$getInstrumentationInnerResult));
                }
            });
        }
        if (typeof lazyObject.action === "function" && aggregated["lazy.action"].length > 0) {
            let action = lazyObject.action;
            updates.lazy = Object.assign(updates.lazy || {}, {
                action: async (...args)=>{
                    return $97b648abc2eb23e2$var$throwOrReturnResult(await $97b648abc2eb23e2$var$recurseRight(aggregated["lazy.action"], void 0, ()=>action(...args), $97b648abc2eb23e2$var$getInstrumentationInnerResult));
                }
            });
        }
    }
    if (typeof route.loader === "function" && aggregated.loader.length > 0) {
        let original = $97b648abc2eb23e2$var$getUninstrumentedHandler(route.loader);
        let instrumented = async (...args)=>{
            return $97b648abc2eb23e2$var$throwOrReturnResult(await $97b648abc2eb23e2$var$recurseRight(aggregated.loader, $97b648abc2eb23e2$var$getHandlerInfo(args[0]), ()=>original(...args), $97b648abc2eb23e2$var$getInstrumentationInnerResult));
        };
        if (original.hydrate === true) instrumented.hydrate = true;
        $97b648abc2eb23e2$var$setUninstrumentedHandler(instrumented, original);
        updates.loader = instrumented;
    }
    if (typeof route.action === "function" && aggregated.action.length > 0) {
        let original = $97b648abc2eb23e2$var$getUninstrumentedHandler(route.action);
        let instrumented = async (...args)=>{
            return $97b648abc2eb23e2$var$throwOrReturnResult(await $97b648abc2eb23e2$var$recurseRight(aggregated.action, $97b648abc2eb23e2$var$getHandlerInfo(args[0]), ()=>original(...args), $97b648abc2eb23e2$var$getInstrumentationInnerResult));
        };
        $97b648abc2eb23e2$var$setUninstrumentedHandler(instrumented, original);
        updates.action = instrumented;
    }
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = $97b648abc2eb23e2$var$getUninstrumentedHandler(middleware);
        let instrumented = async (...args)=>{
            return $97b648abc2eb23e2$var$throwOrReturnResult(await $97b648abc2eb23e2$var$recurseRight(aggregated.middleware, $97b648abc2eb23e2$var$getHandlerInfo(args[0]), ()=>original(...args), $97b648abc2eb23e2$var$getInstrumentationInnerResult));
        };
        $97b648abc2eb23e2$var$setUninstrumentedHandler(instrumented, original);
        return instrumented;
    });
    return updates;
}
function $97b648abc2eb23e2$export$ac4df491f31cbbfc(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                if (i.navigate != null) aggregated.navigate.push(i.navigate);
                if (i.fetch != null) aggregated.fetch.push(i.fetch);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = $97b648abc2eb23e2$var$getUninstrumentedHandler(router.navigate);
        let instrumentedNavigate = async (...args)=>{
            let [to, opts] = args;
            let meta;
            let info = {
                to: typeof to === "number" || typeof to === "string" ? to : to ? (0, $aDbDg.createPath)(to) : ".",
                ...$97b648abc2eb23e2$var$getRouterInfo(router, opts ?? {})
            };
            return $97b648abc2eb23e2$var$throwOrReturnResult(await $97b648abc2eb23e2$var$recurseRight(aggregated.navigate, info, async ()=>{
                if (typeof to === "number") return await navigate(...args);
                let cleanup = $97b648abc2eb23e2$var$setInstrumentationClientResultMetaReceiver(router, (value)=>{
                    meta = value;
                });
                try {
                    return await navigate(...args);
                } finally{
                    cleanup();
                }
            }, (result)=>({
                    ...$97b648abc2eb23e2$var$getInstrumentationInnerResult(result),
                    meta: meta
                })));
        };
        $97b648abc2eb23e2$var$setUninstrumentedHandler(instrumentedNavigate, navigate);
        router.navigate = instrumentedNavigate;
    }
    if (aggregated.fetch.length > 0) {
        let fetch = $97b648abc2eb23e2$var$getUninstrumentedHandler(router.fetch);
        let instrumentedFetch = async (...args)=>{
            let [key, _, href, opts] = args;
            let meta;
            return $97b648abc2eb23e2$var$throwOrReturnResult(await $97b648abc2eb23e2$var$recurseRight(aggregated.fetch, {
                href: href ?? ".",
                fetcherKey: key,
                ...$97b648abc2eb23e2$var$getRouterInfo(router, opts ?? {})
            }, async ()=>{
                let cleanup = $97b648abc2eb23e2$var$setInstrumentationClientResultMetaReceiver(router, (value)=>{
                    meta = value;
                });
                try {
                    return await fetch(...args);
                } finally{
                    cleanup();
                }
            }, (result)=>({
                    ...$97b648abc2eb23e2$var$getInstrumentationInnerResult(result),
                    meta: meta
                })));
        };
        $97b648abc2eb23e2$var$setUninstrumentedHandler(instrumentedFetch, fetch);
        router.fetch = instrumentedFetch;
    }
    return router;
}
function $97b648abc2eb23e2$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                if (i.request != null) aggregated.request.push(i.request);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = async (...args)=>{
        let [request, context] = args;
        let instrumentationContext = context ?? new (0, $jcvU7.RouterContextProvider)();
        return $97b648abc2eb23e2$var$throwOrReturnResult(await $97b648abc2eb23e2$var$recurseRight(aggregated.request, {
            request: $97b648abc2eb23e2$var$getReadonlyRequest(request),
            context: $97b648abc2eb23e2$var$getReadonlyContext(instrumentationContext)
        }, ()=>handler(request, instrumentationContext), (result, info)=>{
            let meta;
            try {
                meta = info.context?.get($97b648abc2eb23e2$export$b1aab28b8e9d7d25);
            } catch  {}
            (0, $aDbDg.invariant)(result.value instanceof Response, "Expected a Response from the request handler");
            return {
                ...$97b648abc2eb23e2$var$getInstrumentationInnerResult(result),
                statusCode: result.value.status,
                meta: meta
            };
        }));
    };
    return instrumentedHandler;
}
function $97b648abc2eb23e2$var$getUninstrumentedHandler(handler) {
    return handler[$97b648abc2eb23e2$var$UninstrumentedSymbol] ?? handler;
}
function $97b648abc2eb23e2$var$setUninstrumentedHandler(handler, uninstrumentedHandler) {
    handler[$97b648abc2eb23e2$var$UninstrumentedSymbol] = uninstrumentedHandler;
}
function $97b648abc2eb23e2$var$setInstrumentationClientResultMetaReceiver(router, receiver) {
    $97b648abc2eb23e2$var$instrumentationClientResultMetaReceivers.set(router, receiver);
    return ()=>{
        if ($97b648abc2eb23e2$var$instrumentationClientResultMetaReceivers.get(router) === receiver) $97b648abc2eb23e2$var$instrumentationClientResultMetaReceivers.delete(router);
    };
}
function $97b648abc2eb23e2$export$5579798e35f5560e(router) {
    let receiver = $97b648abc2eb23e2$var$instrumentationClientResultMetaReceivers.get(router);
    $97b648abc2eb23e2$var$instrumentationClientResultMetaReceivers.delete(router);
    return receiver;
}
function $97b648abc2eb23e2$var$throwOrReturnResult(result) {
    if (result.type === "error") throw result.value;
    return result.value;
}
async function $97b648abc2eb23e2$var$recurseRight(impls, info, handler, getInnerResult, state = {
    result: null,
    innerResult: null
}, index = impls.length - 1) {
    let impl = impls[index];
    if (!impl) {
        try {
            state.result = {
                type: "success",
                value: await handler()
            };
        } catch (e) {
            state.result = {
                type: "error",
                value: e
            };
        }
        state.innerResult = getInnerResult(state.result, info);
    } else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $97b648abc2eb23e2$var$recurseRight(impls, info, handler, getInnerResult, state, index - 1);
            await handlerPromise;
            (0, $aDbDg.invariant)(state.innerResult, "Expected an inner result");
            return state.innerResult;
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (state.result) return state.result;
    state.result = {
        type: "error",
        value: /* @__PURE__ */ new Error("No result assigned in instrumentation chain.")
    };
    state.innerResult = getInnerResult(state.result, info);
    return state.result;
}
function $97b648abc2eb23e2$var$getInstrumentationInnerResult(result) {
    if (result.type === "error" && result.value instanceof Error) return {
        status: "error",
        error: result.value
    };
    return {
        status: "success",
        error: void 0
    };
}
function $97b648abc2eb23e2$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params } = args;
    return {
        ...args,
        request: $97b648abc2eb23e2$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        context: $97b648abc2eb23e2$var$getReadonlyContext(context)
    };
}
function $97b648abc2eb23e2$var$getRouterInfo(router, opts) {
    return {
        currentUrl: (0, $aDbDg.createPath)(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $97b648abc2eb23e2$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $97b648abc2eb23e2$var$getReadonlyContext(context) {
    return {
        get: (ctx)=>context.get(ctx)
    };
}

});

parcelRegister("i9oDI", function(module, exports) {

$parcel$export(module.exports, "V6RegExMatcher", function () { return $d36c2e2e79fe9e93$export$92541312f2982378; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $jcvU7 = parcelRequire("jcvU7");
//#region lib/router/matcher.ts
var $d36c2e2e79fe9e93$export$92541312f2982378 = class {
    #routes = [];
    #branches = [];
    #basename;
    #matchCost = 0;
    constructor(basename){
        this.#basename = basename;
    }
    update(routes) {
        this.#routes = routes;
        this.#branches = (0, $jcvU7.flattenAndRankRoutes)(routes);
        this.#matchCost = this.#branches.reduce((total, branch)=>total + branch.routesMeta.length, 0);
    }
    get matchCost() {
        return this.#matchCost;
    }
    match(locationArg, allowPartial = false) {
        return (0, $jcvU7.matchRoutesImpl)(this.#routes, locationArg, this.#basename, allowPartial, this.#branches);
    }
};

});

parcelRegister("1wKl4", function(module, exports) {

$parcel$export(module.exports, "getRoutePatternMatcher", function () { return $11ccb98ef7bf22d3$export$45cda2a841115322; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $285CM = parcelRequire("285CM");
//#region lib/router/matcher-route-pattern.preload.ts
let $11ccb98ef7bf22d3$var$RoutePatternMatcher;
function $11ccb98ef7bf22d3$export$45cda2a841115322() {
    return $11ccb98ef7bf22d3$var$RoutePatternMatcher;
}
/**
* Initialize the route-pattern matcher before creating a Data Router or static
* handler with `future.unstable_routePatternMatching` enabled. Import from
* `react-router/route-pattern` and call this once during application startup.
* Server and browser applications must each preload their own matcher.
*
* The matcher is statically imported by this module. Tree-shaking bundlers can
* remove it from applications that do not use this function. Initialization is
* synchronous, and repeated calls are safe.
*
* @public
* @category Data Routers
* @mode data
* @returns {void}
*/ function $11ccb98ef7bf22d3$export$c6cb8c636109e21b() {
    $11ccb98ef7bf22d3$var$RoutePatternMatcher = (0, $285CM.RoutePatternDataRouteMatcher);
}

});
parcelRegister("285CM", function(module, exports) {

$parcel$export(module.exports, "RoutePatternDataRouteMatcher", function () { return $18d0b1098e1c6f56$export$9f42f7e9b7c469cc; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $aDbDg = parcelRequire("aDbDg");

var $jcvU7 = parcelRequire("jcvU7");
parcelRequire("1U9mU");
var $6OXdw = parcelRequire("6OXdw");
parcelRequire("7EoPo");
var $i4waS = parcelRequire("i4waS");
//#region lib/router/matcher-route-pattern.ts
var $18d0b1098e1c6f56$export$9f42f7e9b7c469cc = class {
    #state;
    #basename;
    constructor(basename){
        this.#basename = basename;
    }
    update(routes) {
        let branches = $18d0b1098e1c6f56$var$flattenRoutes(routes);
        let matcher = (0, $6OXdw.createMultiMatcher)({
            ignoreCase: true
        });
        let partialMatcher = (0, $6OXdw.createMultiMatcher)({
            ignoreCase: true
        });
        for (let branch of branches){
            let routePattern = $18d0b1098e1c6f56$var$convertReactRouterPathToRoutePattern(branch.path);
            $18d0b1098e1c6f56$var$validateRoutePatternSplat(branch.path, routePattern);
            routePattern = $18d0b1098e1c6f56$var$addOptionalTrailingSlash(routePattern);
            matcher.add(routePattern, branch);
            if (!branch.routesMeta[branch.routesMeta.length - 1].route.index) partialMatcher.add(routePattern === "/" ? `/*__rr_partial` : `${routePattern}(/*__rr_partial)`, branch);
        }
        this.#state = {
            branches: branches,
            matcher: matcher,
            partialMatcher: partialMatcher
        };
        return branches;
    }
    match(locationArg, allowPartial = false) {
        let pathname = (0, $jcvU7.stripBasename)((typeof locationArg === "string" ? (0, $aDbDg.parsePath)(locationArg) : locationArg).pathname || "/", this.#basename);
        if (pathname == null) return null;
        let decoded = (0, $jcvU7.decodePath)(pathname);
        let url = new URL("http://reactrouter.local");
        url.pathname = pathname.endsWith("/") ? pathname : `${pathname}/`;
        (0, $aDbDg.invariant)(this.#state, "Route pattern routes must be initialized before matching.");
        let matches = this.#state.matcher.matchAll(url);
        if (allowPartial) matches.push(...this.#state.partialMatcher.matchAll(url));
        for (let match of $18d0b1098e1c6f56$var$prioritizeValidatedMatches(matches)){
            let routeMatches = $18d0b1098e1c6f56$var$convertRoutePatternMatchToRouteMatches(match, decoded, allowPartial);
            if (routeMatches && $18d0b1098e1c6f56$var$validateRouteMatchParams(routeMatches)) return routeMatches;
        }
        return null;
    }
};
function $18d0b1098e1c6f56$var$validateRoutePatternSplat(routePath, routePattern) {
    (0, $aDbDg.invariant)($18d0b1098e1c6f56$var$getRoutePatternSplatIndexes(routePattern).length <= 1 && $18d0b1098e1c6f56$var$isTerminalRoutePatternSplat(routePattern), `Route path "${routePath}" is not supported with \`future.unstable_routePatternMatching\` because React Router only supports a single splat at the end of a route path.`);
}
function $18d0b1098e1c6f56$var$getRoutePatternSplatIndexes(routePattern) {
    let splatIndexes = [];
    for(let i = 0; i < routePattern.length; i++){
        let char = routePattern[i];
        if (char === "\\") {
            i++;
            continue;
        }
        if (char === "*") splatIndexes.push(i);
    }
    return splatIndexes;
}
function $18d0b1098e1c6f56$var$isTerminalRoutePatternSplat(routePattern) {
    for(let i = 0; i < routePattern.length; i++){
        let char = routePattern[i];
        if (char === "\\") {
            i++;
            continue;
        }
        if (char !== "*") continue;
        let suffix = routePattern.slice(i + 1);
        return /^[a-zA-Z_$][a-zA-Z_$0-9]*$/.test(suffix) || suffix === "";
    }
    return true;
}
function $18d0b1098e1c6f56$var$addOptionalTrailingSlash(routePattern) {
    return routePattern === "/" ? routePattern : `${routePattern.replace(/\/+$/, "")}(/)`;
}
function $18d0b1098e1c6f56$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "") {
    routes.forEach((route, index)=>{
        (0, $aDbDg.invariant)(route.caseSensitive !== true, "`caseSensitive` routes are not supported with `future.unstable_routePatternMatching`.");
        let meta = {
            relativePath: route.path || "",
            caseSensitive: false,
            childrenIndex: index,
            route: route
        };
        let absolutePath;
        if (meta.relativePath.startsWith("/")) {
            absolutePath = meta.relativePath;
            let parentPathMatch = (0, $jcvU7.explodeOptionalSegments)(parentPath).find((path)=>meta.relativePath.startsWith(path));
            (0, $aDbDg.invariant)(parentPathMatch != null, `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPathMatch.length);
        }
        let routesMeta = parentsMeta.concat(meta);
        let path = absolutePath ?? (meta.relativePath ? (0, $jcvU7.joinPaths)([
            parentPath,
            meta.relativePath
        ]) : parentPath);
        if (route.children && route.children.length > 0) {
            (0, $aDbDg.invariant)(route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $18d0b1098e1c6f56$var$flattenRoutes(route.children, branches, routesMeta, path);
            if (route.children?.some((child)=>child.index)) return;
        }
        if (route.path != null || route.index) branches.push({
            path: path,
            score: 0,
            routesMeta: routesMeta
        });
    });
    return branches;
}
function $18d0b1098e1c6f56$var$convertReactRouterPathToRoutePattern(path) {
    (0, $aDbDg.warning)(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) path = path.replace(/\*$/, "/*");
    path = path.replace(/^\/*/, "/");
    if (path === "") return "/";
    let segments = path.split("/");
    let pattern = segments.shift() || "";
    for(let i = 0; i < segments.length;){
        let optionalRun = [];
        while(i < segments.length && $18d0b1098e1c6f56$var$isOptionalRouteSegment(segments[i])){
            optionalRun.push($18d0b1098e1c6f56$var$convertRouteSegment(segments[i].slice(0, -1)));
            i++;
        }
        if (optionalRun.length > 0) {
            let nested = optionalRun.reduceRight((child, segment)=>`/${segment}${child ? `(${child})` : ""}`, "");
            pattern += `(${nested})`;
            continue;
        }
        pattern += `/${$18d0b1098e1c6f56$var$convertRouteSegment(segments[i])}`;
        i++;
    }
    return pattern || "/";
}
function $18d0b1098e1c6f56$var$isOptionalRouteSegment(segment) {
    return segment.endsWith("?");
}
function $18d0b1098e1c6f56$var$convertRouteSegment(segment) {
    if (segment === "*") return "*__rr_splat";
    let paramMatch = segment.match(/^:([\w-]+)(\?)?(.*)$/);
    if (paramMatch) {
        let [, paramName, optional, suffix] = paramMatch;
        let converted = `:${paramName}${$18d0b1098e1c6f56$var$escapeRoutePatternLiteral(suffix)}`;
        return optional ? `(:${paramName})${$18d0b1098e1c6f56$var$escapeRoutePatternLiteral(suffix)}` : converted;
    }
    return $18d0b1098e1c6f56$var$escapeRoutePatternLiteral(segment);
}
function $18d0b1098e1c6f56$var$escapeRoutePatternLiteral(value) {
    return value.replace(/[\\():*]/g, "\\$&");
}
function $18d0b1098e1c6f56$var$validateRouteMatchParams(matches) {
    return matches.every(({ route: route, params: params })=>route.unstable_validateParams == null || Object.keys(route.unstable_validateParams).length === 0 || Object.entries(route.unstable_validateParams).every(([param, re])=>params[param] != null ? new RegExp(re.source, re.flags).test(params[param]) : true));
}
function $18d0b1098e1c6f56$var$prioritizeValidatedMatches(matches) {
    return matches.sort((a, b)=>{
        let specificity = (0, $i4waS.descending)(a, b);
        if (specificity !== 0) return specificity;
        return Number($18d0b1098e1c6f56$var$hasParamValidators(b)) - Number($18d0b1098e1c6f56$var$hasParamValidators(a));
    });
}
function $18d0b1098e1c6f56$var$hasParamValidators(match) {
    return match.data.routesMeta.some((meta)=>meta.route.unstable_validateParams != null && Object.keys(meta.route.unstable_validateParams).length > 0);
}
function $18d0b1098e1c6f56$var$convertRoutePatternMatchToRouteMatches(match, pathname, allowPartial) {
    let result = $18d0b1098e1c6f56$var$matchRoutePatternBranch(match.data, pathname, allowPartial, 0, "/", {});
    if (result == null) return null;
    for (let routeMatch of result.matches)routeMatch.params = result.params;
    return result.matches;
}
function $18d0b1098e1c6f56$var$matchRoutePatternBranch(branch, pathname, allowPartial, metaIndex, matchedPathname, matchedParams) {
    let meta = branch.routesMeta[metaIndex];
    let end = metaIndex === branch.routesMeta.length - 1;
    let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
    for (let relativePath of (0, $jcvU7.explodeOptionalSegments)(meta.relativePath)){
        let pattern = {
            path: relativePath,
            caseSensitive: false,
            end: end
        };
        let pathMatch = (0, $jcvU7.matchPath)(pattern, remainingPathname);
        if (!pathMatch && end && allowPartial && !meta.route.index) pathMatch = (0, $jcvU7.matchPath)({
            ...pattern,
            end: false
        }, remainingPathname);
        if (!pathMatch) continue;
        let params = {
            ...matchedParams,
            ...pathMatch.params
        };
        let routeMatch = {
            params: params,
            pathname: (0, $jcvU7.joinPaths)([
                matchedPathname,
                pathMatch.pathname
            ]),
            pathnameBase: (0, $jcvU7.normalizePathname)((0, $jcvU7.joinPaths)([
                matchedPathname,
                pathMatch.pathnameBase
            ])),
            route: meta.route
        };
        let nextMatchedPathname = pathMatch.pathnameBase === "/" ? matchedPathname : (0, $jcvU7.joinPaths)([
            matchedPathname,
            pathMatch.pathnameBase
        ]);
        if (end) return {
            matches: [
                routeMatch
            ],
            params: params
        };
        let childResult = $18d0b1098e1c6f56$var$matchRoutePatternBranch(branch, pathname, allowPartial, metaIndex + 1, nextMatchedPathname, params);
        if (childResult) return {
            matches: [
                routeMatch,
                ...childResult.matches
            ],
            params: childResult.params
        };
    }
    return null;
}

});
parcelRegister("1U9mU", function(module, exports) {

$parcel$export(module.exports, "createMultiMatcher", function () { return (parcelRequire("6OXdw")).createMultiMatcher; });

var $6OXdw = parcelRequire("6OXdw");

});
parcelRegister("6OXdw", function(module, exports) {

$parcel$export(module.exports, "createMultiMatcher", function () { return $4f7558e104d62c45$export$cf760d085d57ec27; });

var $bR6of = parcelRequire("bR6of");

var $iigke = parcelRequire("iigke");

var $d5rhY = parcelRequire("d5rhY");

var $i4waS = parcelRequire("i4waS");
function $4f7558e104d62c45$export$1d94974cf1366deb(pattern, options) {
    pattern = typeof pattern === 'string' ? (0, $bR6of.RoutePattern).parse(pattern) : pattern;
    let matcher = $4f7558e104d62c45$export$cf760d085d57ec27(options);
    matcher.add(pattern, undefined);
    return {
        match (url) {
            return matcher.match(url);
        }
    };
}
function $4f7558e104d62c45$export$cf760d085d57ec27(options) {
    return new $4f7558e104d62c45$var$TrieMatcher(options);
}
class $4f7558e104d62c45$var$TrieMatcher {
    ignoreCase;
    #trie;
    constructor(options){
        this.ignoreCase = options?.ignoreCase ?? false;
        this.#trie = new (0, $d5rhY.Trie)({
            ignoreCase: this.ignoreCase
        });
    }
    add(pattern, data) {
        pattern = typeof pattern === 'string' ? (0, $iigke.parsePattern)(pattern) : pattern;
        this.#trie.insert(pattern, data);
    }
    match(url) {
        let parsedUrl = typeof url === 'string' ? new URL(url) : url;
        let best = null;
        for (let match of this.#trie.search(parsedUrl))if (best === null || $i4waS.greaterThan(match, best)) best = match;
        return best;
    }
    matchAll(url) {
        let parsedUrl = typeof url === 'string' ? new URL(url) : url;
        let matches = [];
        for (let match of this.#trie.search(parsedUrl))matches.push(match);
        return matches.sort($i4waS.descending);
    }
}

});
parcelRegister("bR6of", function(module, exports) {

$parcel$export(module.exports, "RoutePattern", function () { return $8a1999ddb8e21746$export$2917961db0dd6e8b; });

var $iigke = parcelRequire("iigke");

var $c2BMu = parcelRequire("c2BMu");
class $8a1999ddb8e21746$export$2917961db0dd6e8b {
    protocol;
    hostname;
    port;
    pathname;
    search;
    /**
     * Create a new `RoutePattern` by parsing a source string.
     *
     * @param source The route pattern source string.
     * @returns The parsed route pattern.
     */ static parse(source) {
        return (0, $iigke.parsePattern)(source);
    }
    /**
     * Create a new `RoutePattern` from parsed parts of a route pattern.
     *
     * Useful for efficiently deriving new patterns from already parsed patterns.
     * Unless you know what you are doing, you probably want `RoutePattern.parse`.
     *
     * @param parsed Parsed route pattern parts.
     */ constructor(parsed){
        this.protocol = parsed.protocol;
        this.hostname = parsed.hostname;
        this.port = parsed.port;
        this.pathname = parsed.pathname;
        this.search = parsed.search;
    }
    /** Normalized string representation of this pattern */ get source() {
        return (0, $c2BMu.serializePattern)(this);
    }
    /**
     * Returns a string representing this route pattern.
     *
     * @returns The same normalized pattern string as `RoutePattern.source`.
     */ toString() {
        return this.source;
    }
    /**
     * Returns a JSON-serializable object containing each serialized part of this route pattern.
     *
     * @returns The serialized protocol, hostname, port, pathname, and search.
     */ toJSON() {
        return (0, $c2BMu.serializePatternParts)(this);
    }
}

});
parcelRegister("iigke", function(module, exports) {

$parcel$export(module.exports, "parsePattern", function () { return $d516924fee26f8f0$export$e26190e3669abbfe; });

var $b67sb = parcelRequire("b67sb");

var $bR6of = parcelRequire("bR6of");
const $d516924fee26f8f0$var$IDENTIFIER_RE = /^[a-zA-Z_$][a-zA-Z_$0-9]*/;
function $d516924fee26f8f0$export$e26190e3669abbfe(source) {
    let spans = (0, $b67sb.split)(source);
    return new (0, $bR6of.RoutePattern)({
        protocol: $d516924fee26f8f0$var$parseProtocol(source, spans.protocol),
        hostname: $d516924fee26f8f0$var$parseHostname(source, spans.hostname),
        port: spans.port ? source.slice(...spans.port) : null,
        pathname: spans.pathname ? $d516924fee26f8f0$export$6681bda78b6b4cbd(source, {
            span: spans.pathname,
            type: 'pathname'
        }) : $d516924fee26f8f0$export$6681bda78b6b4cbd('', {
            span: [
                0,
                0
            ],
            type: 'pathname'
        }),
        search: spans.search ? $d516924fee26f8f0$var$parseSearch(source.slice(...spans.search)) : new Map()
    });
}
function $d516924fee26f8f0$export$6681bda78b6b4cbd(source, options) {
    let span = options.span ?? [
        0,
        source.length
    ];
    let separator = options.type === 'hostname' ? '.' : '/';
    let tokens = [];
    let optionals = new Map();
    let appendText = (text)=>{
        let currentToken = tokens.at(-1);
        if (currentToken?.type === 'text') currentToken.text += text;
        else tokens.push({
            type: 'text',
            text: text
        });
    };
    let i = span[0];
    let optionalStack = [];
    while(i < span[1]){
        let char = source[i];
        if (char === '(') {
            optionalStack.push(tokens.length);
            tokens.push({
                type: char
            });
            i += 1;
            continue;
        }
        if (char === ')') {
            let begin = optionalStack.pop();
            if (begin === undefined) throw new $d516924fee26f8f0$export$f9c837a54db411d('unmatched )', source, i);
            optionals.set(begin, tokens.length);
            tokens.push({
                type: char
            });
            i += 1;
            continue;
        }
        if (char === ':') {
            i += 1;
            let name = $d516924fee26f8f0$var$IDENTIFIER_RE.exec(source.slice(i, span[1]))?.[0];
            if (!name) throw new $d516924fee26f8f0$export$f9c837a54db411d('missing variable name', source, i - 1);
            tokens.push({
                type: ':',
                name: name
            });
            i += name.length;
            continue;
        }
        if (char === '*') {
            i += 1;
            let name = $d516924fee26f8f0$var$IDENTIFIER_RE.exec(source.slice(i, span[1]))?.[0];
            tokens.push({
                type: '*',
                name: name ?? '*'
            });
            i += name?.length ?? 0;
            continue;
        }
        if (char === separator) {
            tokens.push({
                type: 'separator'
            });
            i += 1;
            continue;
        }
        if (char === '\\') {
            if (i + 1 === span[1]) throw new $d516924fee26f8f0$export$f9c837a54db411d('dangling escape', source, i);
            let text = source.slice(i + 1, i + 2);
            appendText(text);
            i += 2;
            continue;
        }
        appendText(char);
        i += 1;
    }
    if (optionalStack.length > 0) throw new $d516924fee26f8f0$export$f9c837a54db411d('unmatched (', source, optionalStack.at(-1));
    return {
        tokens: tokens,
        optionals: optionals,
        type: options.type
    };
}
function $d516924fee26f8f0$var$parseProtocol(source, span) {
    if (!span) return null;
    let protocol = source.slice(...span);
    if (protocol === '' || protocol === 'http' || protocol === 'https' || protocol === 'http(s)') return protocol === '' ? null : protocol;
    throw new $d516924fee26f8f0$export$f9c837a54db411d('invalid protocol', source, span[0]);
}
function $d516924fee26f8f0$var$parseHostname(source, span) {
    if (!span) return null;
    let part = $d516924fee26f8f0$export$6681bda78b6b4cbd(source, {
        span: span,
        type: 'hostname'
    });
    if ($d516924fee26f8f0$var$isNamelessWildcard(part)) return null;
    return part;
}
function $d516924fee26f8f0$var$isNamelessWildcard(part) {
    if (part.tokens.length !== 1) return false;
    let token = part.tokens[0];
    if (token.type !== '*') return false;
    return token.name === '*';
}
function $d516924fee26f8f0$var$parseSearch(source) {
    let constraints = new Map();
    let searchParams = new URLSearchParams(source);
    for (let [key, value] of searchParams){
        let requiredValues = constraints.get(key);
        if (!requiredValues) {
            requiredValues = new Set();
            constraints.set(key, requiredValues);
        }
        if (value === '') continue;
        requiredValues.add(value);
    }
    return constraints;
}
class $d516924fee26f8f0$export$f9c837a54db411d extends Error {
    /** The parse failure category. */ type;
    /** Original pattern source being parsed. */ source;
    /** Character index where parsing failed. */ index;
    constructor(type, source, index){
        let underline = ' '.repeat(index) + '^';
        let message = `${type}\n\n${source}\n${underline}`;
        super(message);
        this.name = 'ParseError';
        this.type = type;
        this.source = source;
        this.index = index;
    }
}

});
parcelRegister("b67sb", function(module, exports) {

$parcel$export(module.exports, "split", function () { return $81460961f227861e$export$65980d18b75784e2; });
/**
 * Split a route pattern into protocol, hostname, port, pathname, and search
 * spans delimited as `protocol://hostname:port/pathname?search`.
 *
 * Delimiters are not included in the spans with the exception of the leading `/` for pathname.
 * Spans are [begin (inclusive), end (exclusive)].
 *
 * @param source the route pattern string to split
 * @returns an object containing spans for each URL component
 */ function $81460961f227861e$export$65980d18b75784e2(source) {
    let result = {
        protocol: null,
        hostname: null,
        port: null,
        pathname: null,
        search: null
    };
    let questionMarkIndex = source.indexOf('?');
    if (questionMarkIndex !== -1) {
        result.search = $81460961f227861e$var$span(questionMarkIndex + 1, source.length);
        source = source.slice(0, questionMarkIndex);
    }
    let solidusIndex = source.indexOf('://');
    if (solidusIndex === -1) {
        result.pathname = $81460961f227861e$var$pathnameSpan(source, 0, source.length);
        return result;
    }
    let slashIndex = source.indexOf('/');
    if (slashIndex === solidusIndex + 1) slashIndex = source.indexOf('/', solidusIndex + 3);
    if (slashIndex === -1) {
        result.protocol = $81460961f227861e$var$span(0, solidusIndex);
        let host = $81460961f227861e$var$span(solidusIndex + 3, source.length);
        if (host) {
            let { hostname: hostname, port: port } = $81460961f227861e$var$hostSpans(source, host);
            result.hostname = hostname;
            result.port = port;
        }
        return result;
    }
    if (slashIndex < solidusIndex) {
        result.pathname = $81460961f227861e$var$pathnameSpan(source, 0, source.length);
        return result;
    }
    result.protocol = $81460961f227861e$var$span(0, solidusIndex);
    let host = $81460961f227861e$var$span(solidusIndex + 3, slashIndex);
    if (host) {
        let { hostname: hostname, port: port } = $81460961f227861e$var$hostSpans(source, host);
        result.hostname = hostname;
        result.port = port;
    }
    result.pathname = $81460961f227861e$var$pathnameSpan(source, slashIndex, source.length);
    return result;
}
function $81460961f227861e$var$span(start, end) {
    if (start === end) return null;
    return [
        start,
        end
    ];
}
function $81460961f227861e$var$hostSpans(source, host) {
    let lastColonIndex = source.slice(0, host[1]).lastIndexOf(':');
    if (lastColonIndex === -1 || lastColonIndex < host[0]) return {
        hostname: host,
        port: null
    };
    if (source.slice(lastColonIndex + 1, host[1]).match(/^\d+$/)) return {
        hostname: $81460961f227861e$var$span(host[0], lastColonIndex),
        port: $81460961f227861e$var$span(lastColonIndex + 1, host[1])
    };
    return {
        hostname: host,
        port: null
    };
}
function $81460961f227861e$var$pathnameSpan(source, begin, end) {
    if (source[begin] === '/') begin += 1;
    return $81460961f227861e$var$span(begin, end);
}

});


parcelRegister("c2BMu", function(module, exports) {

$parcel$export(module.exports, "serializePattern", function () { return $8c42fa74753d2177$export$f54f830b0caf58b; });
$parcel$export(module.exports, "serializePatternParts", function () { return $8c42fa74753d2177$export$161f896add7aeb90; });

var $d5dle = parcelRequire("d5dle");
function $8c42fa74753d2177$export$f54f830b0caf58b(pattern) {
    let protocol = $8c42fa74753d2177$export$f5782abab8870711(pattern);
    let hostname = $8c42fa74753d2177$export$191bef10f978d68f(pattern);
    let port = $8c42fa74753d2177$export$776a5d5828862b2f(pattern);
    let pathname = $8c42fa74753d2177$export$a2dfe5fa28b7cbe3(pattern);
    let search = $8c42fa74753d2177$export$3ba2b473bde2deb8(pattern);
    let result = '';
    if (protocol || hostname || port) result += `${protocol}://${hostname}${port === '' ? '' : `:${port}`}`;
    result += '/' + pathname;
    if (search) result += `?${search}`;
    return result;
}
function $8c42fa74753d2177$export$161f896add7aeb90(pattern) {
    return {
        protocol: $8c42fa74753d2177$export$f5782abab8870711(pattern),
        hostname: $8c42fa74753d2177$export$191bef10f978d68f(pattern),
        port: $8c42fa74753d2177$export$776a5d5828862b2f(pattern),
        pathname: $8c42fa74753d2177$export$a2dfe5fa28b7cbe3(pattern),
        search: $8c42fa74753d2177$export$3ba2b473bde2deb8(pattern)
    };
}
function $8c42fa74753d2177$export$f5782abab8870711(pattern) {
    return pattern.protocol ?? '';
}
function $8c42fa74753d2177$export$191bef10f978d68f(pattern) {
    return pattern.hostname ? $8c42fa74753d2177$export$4d98ccdba8645223(pattern.hostname) : '';
}
function $8c42fa74753d2177$export$776a5d5828862b2f(pattern) {
    return pattern.port ?? '';
}
function $8c42fa74753d2177$export$a2dfe5fa28b7cbe3(pattern) {
    return $8c42fa74753d2177$export$4d98ccdba8645223(pattern.pathname);
}
function $8c42fa74753d2177$export$3ba2b473bde2deb8(pattern) {
    if (pattern.search.size === 0) return '';
    let searchParams = new URLSearchParams();
    for (let [key, constraint] of pattern.search){
        if (constraint.size === 0) searchParams.append(key, '');
        else for (let value of constraint)searchParams.append(key, value);
    }
    return searchParams.toString();
}
function $8c42fa74753d2177$var$escapeText(text) {
    return text.replaceAll(/[:*()\\]/g, '\\$&');
}
function $8c42fa74753d2177$export$4d98ccdba8645223(part) {
    let separator = part.type === 'hostname' ? '.' : '/';
    let result = '';
    for (let token of part.tokens){
        if (token.type === '(' || token.type === ')') {
            result += token.type;
            continue;
        }
        if (token.type === 'text') {
            result += $8c42fa74753d2177$var$escapeText(token.text);
            continue;
        }
        if (token.type === ':' || token.type === '*') {
            let name = token.name === '*' ? '' : token.name;
            result += `${token.type}${name}`;
            continue;
        }
        if (token.type === 'separator') {
            result += separator;
            continue;
        }
        (0, $d5dle.unreachable)(token.type);
    }
    return result;
}

});
parcelRegister("d5dle", function(module, exports) {

$parcel$export(module.exports, "unreachable", function () { return $986617550fe629bb$export$565e9d9bd6b6e0d4; });
/**
 * An internal error that should never happen.
 *
 * @param value Typed as `never` to ensure exhaustiveness for discriminated unions.
 */ function $986617550fe629bb$export$565e9d9bd6b6e0d4(value) {
    let message = value === undefined ? 'Unreachable' : `Unreachable: ${value}`;
    throw new Error(message);
}

});



parcelRegister("d5rhY", function(module, exports) {

$parcel$export(module.exports, "Trie", function () { return $9870e904044ccc5b$export$73571c50d0f2507e; });
parcelRequire("itssi");
var $aFt2m = parcelRequire("aFt2m");

var $ftjMu = parcelRequire("ftjMu");

var $d5dle = parcelRequire("d5dle");
class $9870e904044ccc5b$export$73571c50d0f2507e {
    ignoreCase;
    #root;
    constructor(options){
        this.ignoreCase = options?.ignoreCase ?? false;
        this.#root = {
            http: $9870e904044ccc5b$var$createHostnameNode(),
            https: $9870e904044ccc5b$var$createHostnameNode()
        };
    }
    insert(pattern, data) {
        for (let variant of (0, $ftjMu.generateVariants)(pattern)){
            let hostnameNode = this.#root[variant.protocol];
            let portNode;
            if (variant.hostname.type === 'any') portNode = hostnameNode.any;
            else if (variant.hostname.type === 'static') {
                let key = variant.hostname.value.toLowerCase();
                let existing = hostnameNode.static.get(key);
                if (existing === undefined) {
                    existing = new Map();
                    hostnameNode.static.set(key, existing);
                }
                portNode = existing;
            } else {
                portNode = new Map();
                hostnameNode.dynamic.push({
                    regexp: variant.hostname.regexp,
                    params: variant.hostname.params,
                    portNode: portNode
                });
            }
            let pathnameRoot = portNode.get(variant.port);
            if (pathnameRoot === undefined) {
                pathnameRoot = $9870e904044ccc5b$var$createPathnameNode();
                portNode.set(variant.port, pathnameRoot);
            }
            let pathnameNode = pathnameRoot;
            for (let segment of variant.pathname){
                if (segment.type === 'static') {
                    let key = this.ignoreCase ? segment.key.toLowerCase() : segment.key;
                    let next = pathnameNode.static.get(key);
                    if (next === undefined) {
                        next = $9870e904044ccc5b$var$createPathnameNode();
                        pathnameNode.static.set(key, next);
                    }
                    pathnameNode = next;
                    continue;
                }
                if (segment.type === 'variable') {
                    let next = pathnameNode.variable.get(segment.key);
                    if (next === undefined) {
                        next = {
                            regexp: segment.regexp,
                            pathnameNode: $9870e904044ccc5b$var$createPathnameNode()
                        };
                        pathnameNode.variable.set(segment.key, next);
                    }
                    pathnameNode = next.pathnameNode;
                    continue;
                }
                if (segment.type === 'wildcard') {
                    let next = pathnameNode.wildcard.get(segment.key);
                    if (next === undefined) {
                        next = {
                            regexp: segment.regexp,
                            pathnameNode: $9870e904044ccc5b$var$createPathnameNode()
                        };
                        pathnameNode.wildcard.set(segment.key, next);
                    }
                    pathnameNode = next.pathnameNode;
                    continue;
                }
                (0, $d5dle.unreachable)(segment);
            }
            let requiredParams = [];
            for (let segment of variant.pathname){
                if (segment.type === 'variable' || segment.type === 'wildcard') for (let param of segment.params)requiredParams.push(param);
            }
            let undefinedParams = [];
            for (let param of pattern.pathname.tokens){
                if (param.type !== ':' && param.type !== '*') continue;
                if (requiredParams.some((p)=>p.name === param.name)) continue;
                if (undefinedParams.some((p)=>p.name === param.name)) continue;
                undefinedParams.push(param);
            }
            pathnameNode.values.push({
                pattern: pattern,
                data: data,
                requiredParams: requiredParams,
                undefinedParams: undefinedParams
            });
        }
    }
    search(url) {
        let protocol = url.protocol.slice(0, -1);
        if (protocol !== 'http' && protocol !== 'https') return [];
        let hostnameNode = this.#root[protocol];
        let decodedHostname = (0, $aFt2m.toUnicode)(url.hostname);
        let origins = [];
        // any hostname (no port allowed -- empty-port key)
        let anyPathname = hostnameNode.any.get('');
        if (anyPathname) origins.push({
            hostnameMatch: [
                {
                    type: '*',
                    name: '*',
                    value: decodedHostname,
                    begin: 0,
                    end: decodedHostname.length
                }
            ],
            pathnameNode: anyPathname
        });
        // static hostname
        let staticPort = hostnameNode.static.get(decodedHostname.toLowerCase());
        if (staticPort) {
            let next = staticPort.get(url.port);
            if (next) origins.push({
                hostnameMatch: [],
                pathnameNode: next
            });
        }
        // dynamic hostnames
        for (let entry of hostnameNode.dynamic){
            let m = entry.regexp.exec(decodedHostname);
            if (!m) continue;
            let next = entry.portNode.get(url.port);
            if (!next) continue;
            let hostnameMatch = [];
            for(let i = 0; i < entry.params.length; i++){
                let param = entry.params[i];
                let span = m.indices?.[i + 1];
                if (span === undefined) continue;
                hostnameMatch.push({
                    type: param.type,
                    name: param.name,
                    value: m[i + 1],
                    begin: span[0],
                    end: span[1]
                });
            }
            origins.push({
                hostnameMatch: hostnameMatch,
                pathnameNode: next
            });
        }
        let results = [];
        let urlSegments = $9870e904044ccc5b$var$normalizePathname(url.pathname);
        if (urlSegments === null) return results;
        for (let origin of origins){
            let stack = [
                {
                    segmentIndex: 0,
                    pathnameNode: origin.pathnameNode,
                    charOffset: 0,
                    captures: []
                }
            ];
            while(stack.length > 0){
                let current = stack.pop();
                if (current.segmentIndex === urlSegments.length) {
                    for (let value of current.pathnameNode.values){
                        if (!$9870e904044ccc5b$var$matchSearch(url.searchParams, value.pattern.search)) continue;
                        let pathnameMatch = [];
                        for(let i = 0; i < value.requiredParams.length; i++){
                            let param = value.requiredParams[i];
                            let cap = current.captures[i];
                            pathnameMatch.push({
                                type: param.type,
                                name: param.name,
                                value: $9870e904044ccc5b$var$fastDecodeURIComponent(cap.value),
                                begin: cap.begin,
                                end: cap.end
                            });
                        }
                        let params = {};
                        for (let token of value.pattern.hostname?.tokens ?? [])if ((token.type === ':' || token.type === '*') && token.name !== '*') params[token.name] = undefined;
                        for (let token of value.pattern.pathname.tokens)if ((token.type === ':' || token.type === '*') && token.name !== '*') params[token.name] = undefined;
                        for (let p of origin.hostnameMatch){
                            if (p.name === '*') continue;
                            params[p.name] = p.value;
                        }
                        for (let p of pathnameMatch){
                            if (p.name === '*') continue;
                            params[p.name] = p.value;
                        }
                        results.push({
                            url: url,
                            pattern: value.pattern,
                            data: value.data,
                            params: params,
                            paramsMeta: {
                                hostname: origin.hostnameMatch,
                                pathname: pathnameMatch
                            }
                        });
                    }
                    continue;
                }
                let urlSegment = urlSegments[current.segmentIndex];
                let staticKey = this.ignoreCase ? urlSegment.toLowerCase() : urlSegment;
                let nextStatic = current.pathnameNode.static.get(staticKey);
                if (nextStatic) stack.push({
                    segmentIndex: current.segmentIndex + 1,
                    pathnameNode: nextStatic,
                    charOffset: current.charOffset + urlSegment.length + 1,
                    captures: current.captures
                });
                for (let { regexp: regexp, pathnameNode: pathnameNode } of current.pathnameNode.variable.values()){
                    let m = regexp.exec(urlSegment);
                    if (!m) continue;
                    let captures = current.captures.slice();
                    for(let i = 1; i < m.indices.length; i++){
                        let span = m.indices[i];
                        if (span === undefined) (0, $d5dle.unreachable)();
                        captures.push({
                            value: m[i],
                            begin: current.charOffset + span[0],
                            end: current.charOffset + span[1]
                        });
                    }
                    stack.push({
                        segmentIndex: current.segmentIndex + 1,
                        pathnameNode: pathnameNode,
                        charOffset: current.charOffset + m.index + m[0].length + 1,
                        captures: captures
                    });
                }
                for (let { regexp: regexp, pathnameNode: pathnameNode } of current.pathnameNode.wildcard.values()){
                    let remaining = urlSegments.slice(current.segmentIndex).join('/');
                    let m = regexp.exec(remaining);
                    if (!m) continue;
                    let captures = current.captures.slice();
                    for(let i = 1; i < m.indices.length; i++){
                        let span = m.indices[i];
                        if (span === undefined) continue;
                        captures.push({
                            value: m[i],
                            begin: current.charOffset + span[0],
                            end: current.charOffset + span[1]
                        });
                    }
                    stack.push({
                        segmentIndex: urlSegments.length,
                        pathnameNode: pathnameNode,
                        charOffset: current.charOffset + remaining.length,
                        captures: captures
                    });
                }
            }
        }
        return results;
    }
}
// Pathname codec ----------------------------------------------------------------------------------
// Pathname matching uses canonical percent-encoded text. URL pathnames are split on structural
// "/" before normalization so encoded slashes like "%2F" remain data within a segment instead of
// becoming separators. Pattern static text is encoded the same way when variants are generated.
function $9870e904044ccc5b$var$normalizePathname(pathname) {
    let segments = [];
    for (let segment of pathname.slice(1).split('/')){
        let normalized = $9870e904044ccc5b$var$normalizePathnameText(segment);
        if (normalized === null) return null;
        segments.push(normalized);
    }
    return segments;
}
function $9870e904044ccc5b$var$normalizePathnameText(text) {
    let decoded = $9870e904044ccc5b$var$safeDecodeURIComponent(text);
    return decoded === null ? null : encodeURIComponent(decoded);
}
function $9870e904044ccc5b$var$fastDecodeURIComponent(text) {
    return text.includes('%') ? decodeURIComponent(text) : text;
}
function $9870e904044ccc5b$var$safeDecodeURIComponent(text) {
    try {
        return $9870e904044ccc5b$var$fastDecodeURIComponent(text);
    } catch (error) {
        if (error instanceof URIError) return null;
        throw error;
    }
}
// Search ------------------------------------------------------------------------------------------
function $9870e904044ccc5b$var$matchSearch(params, constraints) {
    for (let [name, requiredValues] of constraints){
        if (requiredValues.size === 0) {
            if (!params.has(name)) return false;
            continue;
        }
        let values = params.getAll(name);
        for (let requiredValue of requiredValues){
            if (!values.includes(requiredValue)) return false;
        }
    }
    return true;
}
function $9870e904044ccc5b$var$createHostnameNode() {
    return {
        static: new Map(),
        dynamic: [],
        any: new Map()
    };
}
function $9870e904044ccc5b$var$createPathnameNode() {
    return {
        static: new Map(),
        variable: new Map(),
        wildcard: new Map(),
        values: []
    };
}

});
parcelRegister("itssi", function(module, exports) {

$parcel$export(module.exports, "decodeHostname", function () { return (parcelRequire("aFt2m")).toUnicode; });

var $aFt2m = parcelRequire("aFt2m");

});
parcelRegister("aFt2m", function(module, exports) {

$parcel$export(module.exports, "toUnicode", function () { return $7c4441df02cdb21c$export$110c810e8727e62b; });
// Adapted from https://github.com/mathiasbynens/punycode.js/blob/9e1b2cda98d215d3a73fcbfe93c62e021f4ba768/punycode.js
/** Highest positive signed 32-bit float value */ const $7c4441df02cdb21c$var$maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
/** Bootstring parameters */ const $7c4441df02cdb21c$var$base = 36;
const $7c4441df02cdb21c$var$tMin = 1;
const $7c4441df02cdb21c$var$tMax = 26;
const $7c4441df02cdb21c$var$skew = 38;
const $7c4441df02cdb21c$var$damp = 700;
const $7c4441df02cdb21c$var$initialBias = 72;
const $7c4441df02cdb21c$var$initialN = 128; // 0x80
const $7c4441df02cdb21c$var$delimiter = '-'; // '\x2D'
/** Regular expressions */ const $7c4441df02cdb21c$var$regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
/** Error messages */ const $7c4441df02cdb21c$var$errors = {
    overflow: 'Overflow: input needs wider integers to process',
    'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
    'invalid-input': 'Invalid input'
};
const $7c4441df02cdb21c$var$baseMinusTMin = $7c4441df02cdb21c$var$base - $7c4441df02cdb21c$var$tMin;
/*--------------------------------------------------------------------------*/ /**
 * A generic error utility function.
 * @param type The error type.
 */ function $7c4441df02cdb21c$var$error(type) {
    throw new RangeError($7c4441df02cdb21c$var$errors[type]);
}
/**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @param domain The domain name or email address.
 * @param callback The function that gets called for every character.
 * @returns A new string of characters returned by the callback function.
 */ function $7c4441df02cdb21c$var$mapDomain(domain, callback) {
    let parts = domain.split('@');
    let result = '';
    if (parts.length > 1) {
        // In email addresses, only the domain name should be punycoded. Leave
        // the local part (i.e. everything up to `@`) intact.
        result = parts[0] + '@';
        domain = parts[1];
    }
    domain = domain.replace($7c4441df02cdb21c$var$regexSeparators, '.');
    let labels = domain.split('.');
    let encoded = labels.map(callback).join('.');
    return result + encoded;
}
/**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @param codePoint The basic numeric code point value.
 * @returns The numeric value of a basic code point in the range `0` to
 * `base - 1`, or `base` if the code point does not represent a value.
 */ function $7c4441df02cdb21c$var$basicToDigit(codePoint) {
    if (codePoint >= 0x30 && codePoint < 0x3a) return 26 + (codePoint - 0x30);
    if (codePoint >= 0x41 && codePoint < 0x5b) return codePoint - 0x41;
    if (codePoint >= 0x61 && codePoint < 0x7b) return codePoint - 0x61;
    return $7c4441df02cdb21c$var$base;
}
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @param delta The current delta.
 * @param numPoints The number of code points handled.
 * @param firstTime Whether this is the first adaptation.
 * @returns The adapted bias.
 */ function $7c4441df02cdb21c$var$adapt(delta, numPoints, firstTime) {
    let k = 0;
    delta = firstTime ? Math.floor(delta / $7c4441df02cdb21c$var$damp) : delta >> 1;
    delta += Math.floor(delta / numPoints);
    for(; delta > $7c4441df02cdb21c$var$baseMinusTMin * $7c4441df02cdb21c$var$tMax >> 1; k += $7c4441df02cdb21c$var$base)delta = Math.floor(delta / $7c4441df02cdb21c$var$baseMinusTMin);
    return Math.floor(k + ($7c4441df02cdb21c$var$baseMinusTMin + 1) * delta / (delta + $7c4441df02cdb21c$var$skew));
}
/**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @param input The Punycode string of ASCII-only symbols.
 * @returns The resulting string of Unicode symbols.
 */ function $7c4441df02cdb21c$var$decode(input) {
    // Don't use UCS-2.
    let output = [];
    let inputLength = input.length;
    let i = 0;
    let n = $7c4441df02cdb21c$var$initialN;
    let bias = $7c4441df02cdb21c$var$initialBias;
    // Handle the basic code points: let `basic` be the number of input code
    // points before the last delimiter, or `0` if there is none, then copy
    // the first basic code points to the output.
    let basic = input.lastIndexOf($7c4441df02cdb21c$var$delimiter);
    if (basic < 0) basic = 0;
    for(let j = 0; j < basic; ++j){
        // if it's not a basic code point
        if (input.charCodeAt(j) >= 0x80) $7c4441df02cdb21c$var$error('not-basic');
        output.push(input.charCodeAt(j));
    }
    // Main decoding loop: start just after the last delimiter if any basic code
    // points were copied; start at the beginning otherwise.
    for(let index = basic > 0 ? basic + 1 : 0; index < inputLength /* no final expression */ ;){
        // `index` is the index of the next character to be consumed.
        // Decode a generalized variable-length integer into `delta`,
        // which gets added to `i`. The overflow checking is easier
        // if we increase `i` as we go, then subtract off its starting
        // value at the end to obtain `delta`.
        let oldi = i;
        for(let w = 1, k = $7c4441df02cdb21c$var$base /* no condition */ ;; k += $7c4441df02cdb21c$var$base){
            if (index >= inputLength) $7c4441df02cdb21c$var$error('invalid-input');
            let digit = $7c4441df02cdb21c$var$basicToDigit(input.charCodeAt(index++));
            if (digit >= $7c4441df02cdb21c$var$base) $7c4441df02cdb21c$var$error('invalid-input');
            if (digit > Math.floor(($7c4441df02cdb21c$var$maxInt - i) / w)) $7c4441df02cdb21c$var$error('overflow');
            i += digit * w;
            let t = k <= bias ? $7c4441df02cdb21c$var$tMin : k >= bias + $7c4441df02cdb21c$var$tMax ? $7c4441df02cdb21c$var$tMax : k - bias;
            if (digit < t) break;
            let baseMinusT = $7c4441df02cdb21c$var$base - t;
            if (w > Math.floor($7c4441df02cdb21c$var$maxInt / baseMinusT)) $7c4441df02cdb21c$var$error('overflow');
            w *= baseMinusT;
        }
        let out = output.length + 1;
        bias = $7c4441df02cdb21c$var$adapt(i - oldi, out, oldi === 0);
        // `i` was supposed to wrap around from `out` to `0`,
        // incrementing `n` each time, so we'll fix that now:
        if (Math.floor(i / out) > $7c4441df02cdb21c$var$maxInt - n) $7c4441df02cdb21c$var$error('overflow');
        n += Math.floor(i / out);
        i %= out;
        // Insert `n` at position `i` of the output.
        output.splice(i++, 0, n);
    }
    return String.fromCodePoint(...output);
}
const $7c4441df02cdb21c$export$110c810e8727e62b = function(input) {
    // Optimization: skip if no punycode markers found
    if (!input.includes('xn--')) return input;
    return $7c4441df02cdb21c$var$mapDomain(input, function(string) {
        return string.startsWith('xn--') ? $7c4441df02cdb21c$var$decode(string.slice(4).toLowerCase()) : string;
    });
};

});


parcelRegister("ftjMu", function(module, exports) {

$parcel$export(module.exports, "generateVariants", function () { return $b438e88fe085e870$export$9ac16898ad61bc17; });

var $aU2kG = parcelRequire("aU2kG");

var $d5dle = parcelRequire("d5dle");
function $b438e88fe085e870$export$9ac16898ad61bc17(pattern) {
    let result = [];
    for (let protocol of $b438e88fe085e870$var$generateProtocolVariants(pattern.protocol)){
        let port = $b438e88fe085e870$var$normalizePort(protocol, pattern.port);
        for (let hostname of $b438e88fe085e870$var$generateHostnameVariants(pattern.hostname))for (let pathname of $b438e88fe085e870$var$generatePathnameVariants(pattern.pathname))result.push({
            protocol: protocol,
            hostname: hostname,
            port: port,
            pathname: pathname
        });
    }
    return result;
}
function $b438e88fe085e870$var$generateProtocolVariants(protocol) {
    if (protocol === null || protocol === 'http(s)') return [
        'http',
        'https'
    ];
    return [
        protocol
    ];
}
function $b438e88fe085e870$var$normalizePort(protocol, port) {
    if (port === null) return '';
    if (protocol === 'http' && port === '80') return '';
    if (protocol === 'https' && port === '443') return '';
    return port;
}
function $b438e88fe085e870$var$toParams(tokens) {
    let params = [];
    for (let token of tokens)if (token.type === ':' || token.type === '*') params.push(token);
    return params;
}
function $b438e88fe085e870$var$generateHostnameVariants(hostname) {
    let result = [];
    if (hostname === null) return [
        {
            type: 'any'
        }
    ];
    for (let variant of $b438e88fe085e870$export$57a1d23d0b7a46c(hostname)){
        let params = $b438e88fe085e870$var$toParams(variant);
        if (params.length > 0) result.push({
            type: 'dynamic',
            params: params,
            regexp: (0, $aU2kG.toRegExp)(variant, {
                separator: '.',
                ignoreCase: false
            })
        });
        else result.push({
            type: 'static',
            value: $b438e88fe085e870$var$stringifyStatic(variant, '.')
        });
    }
    return result;
}
function $b438e88fe085e870$var$stringifyStatic(variant, separator) {
    let result = '';
    for (let token of variant){
        if (token.type === 'text') result += token.text;
        else if (token.type === 'separator') result += separator;
        else throw new Error(`expected static part variant, got token type '${token.type}'`);
    }
    return result;
}
function $b438e88fe085e870$var$generatePathnameVariants(pathname, options) {
    let result = [];
    let ignoreCase = options?.ignoreCase ?? false;
    for (let tokens of $b438e88fe085e870$export$57a1d23d0b7a46c(pathname)){
        let variant = [];
        let key = '';
        let reSource = '';
        let reFlags = ignoreCase ? 'di' : 'd';
        let type = 'static';
        let params = [];
        for (let token of tokens){
            if (token.type === 'separator') {
                if (type === 'static') {
                    variant.push({
                        type: 'static',
                        key: ignoreCase ? key.toLowerCase() : key
                    });
                    key = '';
                    reSource = '';
                    continue;
                }
                if (type === 'variable') {
                    variant.push({
                        type: 'variable',
                        key: key,
                        regexp: new RegExp(`^${reSource}$`, reFlags),
                        params: params
                    });
                    key = '';
                    reSource = '';
                    params = [];
                    type = 'static';
                    continue;
                }
                if (type === 'wildcard') {
                    key += '/';
                    reSource += (0, $aU2kG.escape)('/');
                    continue;
                }
                (0, $d5dle.unreachable)(type);
            }
            if (token.type === 'text') {
                // Encode to comply with URL pathname normalization in trie matcher
                let text = encodeURIComponent(token.text);
                key += text;
                reSource += (0, $aU2kG.escape)(text);
                continue;
            }
            if (token.type === ':') {
                key += '{:}';
                reSource += `([^/]+)`;
                params.push(token);
                if (type === 'static') type = 'variable';
                continue;
            }
            if (token.type === '*') {
                key += '{*}';
                reSource += `(.*)`;
                params.push(token);
                type = 'wildcard';
                continue;
            }
            (0, $d5dle.unreachable)(token.type);
        }
        if (type === 'static') variant.push({
            type: 'static',
            key: ignoreCase ? key.toLowerCase() : key
        });
        if (type === 'variable' || type === 'wildcard') variant.push({
            type: type,
            key: key,
            regexp: new RegExp(`^${reSource}$`, reFlags),
            params: params
        });
        result.push(variant);
    }
    return result;
}
function $b438e88fe085e870$export$57a1d23d0b7a46c(part) {
    let result = [];
    let stack = [
        {
            index: 0,
            tokens: []
        }
    ];
    while(stack.length > 0){
        let { index: index, tokens: tokens } = stack.pop();
        if (index === part.tokens.length) {
            result.push(tokens);
            continue;
        }
        let token = part.tokens[index];
        if (token.type === '(') {
            stack.push({
                index: index + 1,
                tokens: tokens
            }, {
                index: part.optionals.get(index) + 1,
                tokens: tokens.slice()
            });
            continue;
        }
        if (token.type === ')') {
            stack.push({
                index: index + 1,
                tokens: tokens
            });
            continue;
        }
        if (token.type === ':' || token.type === '*' || token.type === 'text' || token.type === 'separator') {
            tokens.push(token);
            stack.push({
                index: index + 1,
                tokens: tokens
            });
            continue;
        }
        (0, $d5dle.unreachable)(token.type);
    }
    return result;
}

});
parcelRegister("aU2kG", function(module, exports) {

$parcel$export(module.exports, "escape", function () { return $7f00f187be9ff3e7$export$4e7f196112fea3c5; });
$parcel$export(module.exports, "toRegExp", function () { return $7f00f187be9ff3e7$export$238374f1b270e387; });

var $d5dle = parcelRequire("d5dle");
function $7f00f187be9ff3e7$export$4e7f196112fea3c5(text) {
    return text.replace(/[.*+?^${}()|[\]\\-]/g, '\\$&');
}
function $7f00f187be9ff3e7$export$238374f1b270e387(tokens, options) {
    let result = '';
    for (let token of tokens){
        if (token.type === 'text') {
            result += $7f00f187be9ff3e7$export$4e7f196112fea3c5(token.text);
            continue;
        }
        if (token.type === ':') {
            result += `([^${options.separator}]+?)`;
            continue;
        }
        if (token.type === '*') {
            result += `(.*)`;
            continue;
        }
        if (token.type === '(') {
            result += '(?:';
            continue;
        }
        if (token.type === ')') {
            result += ')?';
            continue;
        }
        if (token.type === 'separator') {
            result += $7f00f187be9ff3e7$export$4e7f196112fea3c5(options.separator);
            continue;
        }
        (0, $d5dle.unreachable)(token.type);
    }
    let flags = 'd';
    if (options.ignoreCase) flags += 'i';
    return new RegExp(`^${result}$`, flags);
}

});



parcelRegister("i4waS", function(module, exports) {

$parcel$export(module.exports, "greaterThan", function () { return $d2818edd1db529e3$export$f517ea36c68d4644; });
$parcel$export(module.exports, "descending", function () { return $d2818edd1db529e3$export$4fa3190a997c3d8f; });
parcelRequire("itssi");
var $aFt2m = parcelRequire("aFt2m");
function $d2818edd1db529e3$export$9b050841a3a1b328(a, b) {
    return $d2818edd1db529e3$export$398604a469f7de9a(a, b) === -1;
}
function $d2818edd1db529e3$export$f517ea36c68d4644(a, b) {
    return $d2818edd1db529e3$export$398604a469f7de9a(a, b) === 1;
}
function $d2818edd1db529e3$export$411ce8e5a71e3069(a, b) {
    return $d2818edd1db529e3$export$398604a469f7de9a(a, b) === 0;
}
const $d2818edd1db529e3$export$fcb633242ef15540 = (a, b)=>$d2818edd1db529e3$export$398604a469f7de9a(a, b);
const $d2818edd1db529e3$export$4fa3190a997c3d8f = (a, b)=>$d2818edd1db529e3$export$398604a469f7de9a(a, b) * -1;
function $d2818edd1db529e3$export$398604a469f7de9a(a, b) {
    if (a.url.href !== b.url.href) throw new Error(`Cannot compare matches for different URLs: ${a.url.href} vs ${b.url.href}`);
    let hostname = (0, $aFt2m.toUnicode)(a.url.hostname);
    let hostnameResult = $d2818edd1db529e3$var$compareHostname(hostname, a.paramsMeta.hostname, b.paramsMeta.hostname);
    if (hostnameResult !== 0) return hostnameResult;
    let pathnameResult = $d2818edd1db529e3$var$comparePathname(a.paramsMeta.pathname, b.paramsMeta.pathname);
    if (pathnameResult !== 0) return pathnameResult;
    let searchResult = $d2818edd1db529e3$var$compareSearch(a.pattern.search, b.pattern.search);
    if (searchResult !== 0) return searchResult;
    return 0;
}
function $d2818edd1db529e3$var$compareHostname(hostname, a, b) {
    if (a.length === 0 && b.length === 0) return 0;
    if (a.length === 0 && b.length > 0) return 1;
    if (a.length > 0 && b.length === 0) return -1;
    // Encoding of hostname chars: 0 = static, 1 = variable (:), 2 = wildcard (*)
    // Note: `Int8Array` defaults to 0 for all indices not explicitly set.
    let aEncoding = new Int8Array(hostname.length);
    for (let range of a)aEncoding.fill(range.type === ':' ? 1 : 2, range.begin, range.end);
    let bEncoding = new Int8Array(hostname.length);
    for (let range of b)bEncoding.fill(range.type === ':' ? 1 : 2, range.begin, range.end);
    // Build segments right-to-left: desc order by begin
    let segments = [];
    let end = hostname.length;
    for(let i = hostname.length - 1; i >= 0; i--)if (hostname[i] === '.') {
        segments.push({
            begin: i + 1,
            end: end
        });
        end = i;
    }
    segments.push({
        begin: 0,
        end: end
    }); // leftmost segment
    for (let segment of segments)for(let j = segment.begin; j < segment.end; j++){
        if (aEncoding[j] < bEncoding[j]) return 1; // a is more specific
        if (aEncoding[j] > bEncoding[j]) return -1; // b is more specific
    }
    return 0;
}
function $d2818edd1db529e3$var$comparePathname(a, b) {
    if (a.length === 0 && b.length === 0) return 0;
    if (a.length === 0 && b.length > 0) return 1;
    if (a.length > 0 && b.length === 0) return -1;
    let i = 0;
    let aIndex = 0;
    let bIndex = 0;
    while(aIndex < a.length || bIndex < b.length){
        let aRange = a[aIndex];
        let bRange = b[bIndex];
        if (aRange === undefined) return 1; // a is fully static from here
        if (bRange === undefined) return -1; // b is fully static from here
        // Skip to the minimum begin of the two current ranges
        i = Math.min(aRange.begin, bRange.begin);
        if (i < aRange.begin) return 1; // a has static content at i
        if (i < bRange.begin) return -1; // b has static content at i
        if (aRange.type === ':' && bRange.type === '*') return 1; // a is more specific
        if (aRange.type === '*' && bRange.type === ':') return -1; // b is more specific
        let minEnd = Math.min(aRange.end, bRange.end);
        i = minEnd;
        // Advance range indices if we've reached their ends
        if (i >= aRange.end) aIndex += 1;
        if (i >= bRange.end) bIndex += 1;
    }
    return 0;
}
function $d2818edd1db529e3$var$compareSearch(a, b) {
    let aSpecificity = $d2818edd1db529e3$var$searchSpecificity(a);
    let bSpecificity = $d2818edd1db529e3$var$searchSpecificity(b);
    if (aSpecificity.keyValue > bSpecificity.keyValue) return 1;
    if (aSpecificity.keyValue < bSpecificity.keyValue) return -1;
    if (aSpecificity.key > bSpecificity.key) return 1;
    if (aSpecificity.key < bSpecificity.key) return -1;
    return 0;
}
function $d2818edd1db529e3$var$searchSpecificity(constraints) {
    let specificity = {
        key: 0,
        keyValue: 0
    };
    for (let constraint of constraints.values()){
        if (constraint.size === 0) {
            specificity.key += 1;
            continue;
        }
        specificity.keyValue += constraint.size;
    }
    return specificity;
}

});



parcelRegister("7EoPo", function(module, exports) {

$parcel$export(module.exports, "descending", function () { return (parcelRequire("i4waS")).descending; });

var $i4waS = parcelRequire("i4waS");

});



parcelRegister("2gfKq", function(module, exports) {

$parcel$export(module.exports, "getNavigatorCurrentUrl", function () { return $1a594a92a21bb28e$export$1da545bc000055cf; });
$parcel$export(module.exports, "validateNavigationTarget", function () { return $1a594a92a21bb28e$export$6c8e41f66e7aa990; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/router/navigation.ts
const $1a594a92a21bb28e$var$DEFAULT_NAVIGATION_URL = new URL("http://localhost");
function $1a594a92a21bb28e$export$1da545bc000055cf(navigator) {
    if (navigator.createURL) return navigator.createURL("/");
    try {
        return new URL(navigator.createHref("/"), $1a594a92a21bb28e$var$DEFAULT_NAVIGATION_URL);
    } catch  {
        return $1a594a92a21bb28e$var$DEFAULT_NAVIGATION_URL;
    }
}
function $1a594a92a21bb28e$var$isSameOrigin(a, b) {
    return a.origin === b.origin && (a.origin !== "null" || a.protocol === b.protocol && a.host === b.host);
}
function $1a594a92a21bb28e$var$isExplicitUrl(destination, target) {
    if (destination.startsWith("//")) return true;
    let protocol = target.protocol.toLowerCase();
    if (!destination.toLowerCase().startsWith(protocol)) return false;
    return target.host === "" || destination.slice(protocol.length).startsWith("//");
}
function $1a594a92a21bb28e$export$6c8e41f66e7aa990(original, resolved, currentUrl, externalPolicy) {
    let originalUrl = null;
    try {
        originalUrl = original == null ? null : new URL(original, currentUrl);
    } catch  {}
    let resolvedUrl = new URL(resolved, currentUrl);
    let originalIsExternal = originalUrl != null && !$1a594a92a21bb28e$var$isSameOrigin(originalUrl, currentUrl);
    let resolvedIsExternal = !$1a594a92a21bb28e$var$isSameOrigin(resolvedUrl, currentUrl);
    if (externalPolicy === "reject") {
        if (originalIsExternal || resolvedIsExternal) throw new Error("External navigation is not allowed");
    } else if (resolvedIsExternal) {
        if (originalUrl == null || !$1a594a92a21bb28e$var$isExplicitUrl(original, originalUrl) || !$1a594a92a21bb28e$var$isSameOrigin(originalUrl, resolvedUrl)) throw new Error("External navigation is not allowed");
    }
}

});


parcelRegister("1e0kC", function(module, exports) {

$parcel$export(module.exports, "DataRouterContext", function () { return $0e475b1dd66e050a$export$2eeee58951ff3c1c; });
$parcel$export(module.exports, "DataRouterStateContext", function () { return $0e475b1dd66e050a$export$315e3ffb01f217; });
$parcel$export(module.exports, "DataRouterDataContext", function () { return $0e475b1dd66e050a$export$19d7395466bdeac8; });
$parcel$export(module.exports, "DataRouterNavigationContext", function () { return $0e475b1dd66e050a$export$2473c5952c6a10d1; });
$parcel$export(module.exports, "RSCRouterContext", function () { return $0e475b1dd66e050a$export$717f757c655223f1; });
$parcel$export(module.exports, "useIsRSCRouterContext", function () { return $0e475b1dd66e050a$export$6e1eeb090b3ec35b; });
$parcel$export(module.exports, "ViewTransitionContext", function () { return $0e475b1dd66e050a$export$3681f408decb40d1; });
$parcel$export(module.exports, "FetchersContext", function () { return $0e475b1dd66e050a$export$cb3f1df1bef00a39; });
$parcel$export(module.exports, "AwaitContext", function () { return $0e475b1dd66e050a$export$804c460aade54ac8; });
$parcel$export(module.exports, "NavigationContext", function () { return $0e475b1dd66e050a$export$3044ab7fdabeaee6; });
$parcel$export(module.exports, "LocationContext", function () { return $0e475b1dd66e050a$export$e6a44b110a0c44d3; });
$parcel$export(module.exports, "RouteContext", function () { return $0e475b1dd66e050a$export$aac280ed165a4397; });
$parcel$export(module.exports, "IsDataRouteContext", function () { return $0e475b1dd66e050a$export$efd71bfc7ccfba1; });
$parcel$export(module.exports, "RouteIdContext", function () { return $0e475b1dd66e050a$export$92d0be8f6ef5c7bf; });
$parcel$export(module.exports, "RouteErrorContext", function () { return $0e475b1dd66e050a$export$af8bd2647fea9c11; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $jpgPw = parcelRequire("jpgPw");
//#region lib/context.ts
const $0e475b1dd66e050a$export$2eeee58951ff3c1c = $jpgPw.createContext(null);
$0e475b1dd66e050a$export$2eeee58951ff3c1c.displayName = "DataRouter";
const $0e475b1dd66e050a$export$315e3ffb01f217 = $jpgPw.createContext(null);
$0e475b1dd66e050a$export$315e3ffb01f217.displayName = "DataRouterState";
const $0e475b1dd66e050a$export$19d7395466bdeac8 = $jpgPw.createContext(null);
$0e475b1dd66e050a$export$19d7395466bdeac8.displayName = "DataRouterData";
const $0e475b1dd66e050a$export$2473c5952c6a10d1 = $jpgPw.createContext(null);
$0e475b1dd66e050a$export$2473c5952c6a10d1.displayName = "DataRouterNavigation";
const $0e475b1dd66e050a$export$717f757c655223f1 = $jpgPw.createContext(false);
function $0e475b1dd66e050a$export$6e1eeb090b3ec35b() {
    return $jpgPw.useContext($0e475b1dd66e050a$export$717f757c655223f1);
}
const $0e475b1dd66e050a$export$3681f408decb40d1 = $jpgPw.createContext({
    isTransitioning: false
});
$0e475b1dd66e050a$export$3681f408decb40d1.displayName = "ViewTransition";
const $0e475b1dd66e050a$export$cb3f1df1bef00a39 = $jpgPw.createContext(null);
$0e475b1dd66e050a$export$cb3f1df1bef00a39.displayName = "Fetchers";
const $0e475b1dd66e050a$export$804c460aade54ac8 = $jpgPw.createContext(null);
$0e475b1dd66e050a$export$804c460aade54ac8.displayName = "Await";
const $0e475b1dd66e050a$export$2666c20e15407622 = (props)=>$jpgPw.createElement($0e475b1dd66e050a$export$804c460aade54ac8.Provider, props);
const $0e475b1dd66e050a$export$3044ab7fdabeaee6 = $jpgPw.createContext(null);
$0e475b1dd66e050a$export$3044ab7fdabeaee6.displayName = "Navigation";
const $0e475b1dd66e050a$export$e6a44b110a0c44d3 = $jpgPw.createContext(null);
$0e475b1dd66e050a$export$e6a44b110a0c44d3.displayName = "Location";
const $0e475b1dd66e050a$export$aac280ed165a4397 = $jpgPw.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$0e475b1dd66e050a$export$aac280ed165a4397.displayName = "Route";
const $0e475b1dd66e050a$export$efd71bfc7ccfba1 = $jpgPw.createContext(false);
$0e475b1dd66e050a$export$efd71bfc7ccfba1.displayName = "IsDataRoute";
const $0e475b1dd66e050a$export$92d0be8f6ef5c7bf = $jpgPw.createContext(void 0);
$0e475b1dd66e050a$export$92d0be8f6ef5c7bf.displayName = "RouteId";
const $0e475b1dd66e050a$export$af8bd2647fea9c11 = $jpgPw.createContext(null);
$0e475b1dd66e050a$export$af8bd2647fea9c11.displayName = "RouteError";

});

parcelRegister("bdpx3", function(module, exports) {

$parcel$export(module.exports, "useHref", function () { return $82a4b6c3632a16f2$export$b66bb29c5006f12f; });
$parcel$export(module.exports, "useInRouterContext", function () { return $82a4b6c3632a16f2$export$9c954a9d03d32f4a; });
$parcel$export(module.exports, "useResolvedPath", function () { return $82a4b6c3632a16f2$export$e75d2a2d1b3c245b; });
$parcel$export(module.exports, "useLocation", function () { return $82a4b6c3632a16f2$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useNavigate", function () { return $82a4b6c3632a16f2$export$9770f232ac06a008; });
$parcel$export(module.exports, "useOutlet", function () { return $82a4b6c3632a16f2$export$a3be3530d8e40d0b; });
$parcel$export(module.exports, "useParams", function () { return $82a4b6c3632a16f2$export$99eaa27ddbbb95ef; });
$parcel$export(module.exports, "useRoutes", function () { return $82a4b6c3632a16f2$export$5d3fca4a98652595; });
$parcel$export(module.exports, "useRoutesImpl", function () { return $82a4b6c3632a16f2$export$f7ce0646a48561fb; });
$parcel$export(module.exports, "_renderMatches", function () { return $82a4b6c3632a16f2$export$569816e95a012c39; });
$parcel$export(module.exports, "useRouteError", function () { return $82a4b6c3632a16f2$export$ed527bf60f6e05f2; });
$parcel$export(module.exports, "useDataRouterContext", function () { return $82a4b6c3632a16f2$export$ae09415e57d46628; });
$parcel$export(module.exports, "useDataRouterState", function () { return $82a4b6c3632a16f2$export$f93124018767f269; });
$parcel$export(module.exports, "useDataRouterFetchers", function () { return $82a4b6c3632a16f2$export$c6e4e4d7047d4ffe; });
$parcel$export(module.exports, "useDataRouterData", function () { return $82a4b6c3632a16f2$export$798168c290ba5b3d; });
$parcel$export(module.exports, "useCurrentRouteId", function () { return $82a4b6c3632a16f2$export$501a3f562d56eac6; });
$parcel$export(module.exports, "useNavigation", function () { return $82a4b6c3632a16f2$export$d0fd4b7106de2769; });
$parcel$export(module.exports, "useMatches", function () { return $82a4b6c3632a16f2$export$2378eb7f5ff86053; });
$parcel$export(module.exports, "useLoaderData", function () { return $82a4b6c3632a16f2$export$1448a5050d252c4d; });
$parcel$export(module.exports, "useActionData", function () { return $82a4b6c3632a16f2$export$fdc00f3f26066d5e; });
$parcel$export(module.exports, "useAsyncValue", function () { return $82a4b6c3632a16f2$export$78a72ddb39bdd145; });
$parcel$export(module.exports, "useBlocker", function () { return $82a4b6c3632a16f2$export$b273b3273281a049; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $aDbDg = parcelRequire("aDbDg");

var $jcvU7 = parcelRequire("jcvU7");

var $2gfKq = parcelRequire("2gfKq");

var $e1hMf = parcelRequire("e1hMf");

var $1e0kC = parcelRequire("1e0kC");

var $7snpk = parcelRequire("7snpk");

var $jpgPw = parcelRequire("jpgPw");
//#region lib/hooks.tsx
/**
* Resolves a URL against the current {@link Location}.
*
* @example
* import { useHref } from "react-router";
*
* function SomeComponent() {
*   let href = useHref("some/where");
*   // "/resolved/some/where"
* }
*
* @public
* @category Hooks
* @param to The path to resolve
* @param options Options
* @param options.relative Defaults to `"route"` so routing is relative to the
* route tree.
* Set to `"path"` to make relative routing operate against path segments.
* @returns The resolved href string
*/ function $82a4b6c3632a16f2$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    (0, $aDbDg.invariant)($82a4b6c3632a16f2$export$9c954a9d03d32f4a(), `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $jpgPw.useContext((0, $1e0kC.NavigationContext));
    let { hash: hash, pathname: pathname, search: search } = $82a4b6c3632a16f2$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $jcvU7.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
* Returns `true` if this component is a descendant of a {@link Router}, useful
* to ensure a component is used within a {@link Router}.
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns Whether the component is within a {@link Router} context
*/ function $82a4b6c3632a16f2$export$9c954a9d03d32f4a() {
    return $jpgPw.useContext((0, $1e0kC.LocationContext)) != null;
}
/**
* Returns the current {@link Location}. This can be useful if you'd like to
* perform some side effect whenever it changes.
*
* @example
* import * as React from 'react'
* import { useLocation } from 'react-router'
*
* function SomeComponent() {
*   let location = useLocation()
*
*   React.useEffect(() => {
*     // Google Analytics
*     ga('send', 'pageview')
*   }, [location]);
*
*   return (
*     // ...
*   );
* }
*
* @public
* @category Hooks
* @returns The current {@link Location} object
*/ function $82a4b6c3632a16f2$export$45d76561a5302f2b() {
    (0, $aDbDg.invariant)($82a4b6c3632a16f2$export$9c954a9d03d32f4a(), `useLocation() may be used only in the context of a <Router> component.`);
    return $jpgPw.useContext((0, $1e0kC.LocationContext)).location;
}
/**
* Returns the current {@link Navigation} action which describes how the router
* came to the current {@link Location}, either by a pop, push, or replace on
* the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History) stack.
*
* @public
* @category Hooks
* @returns The current {@link NavigationType} (`"POP"`, `"PUSH"`, or `"REPLACE"`)
*/ function $82a4b6c3632a16f2$export$1b3f31771c5d07c() {
    return $jpgPw.useContext((0, $1e0kC.LocationContext)).navigationType;
}
/**
* Returns a {@link PathMatch} object if the given pattern matches the current URL.
* This is useful for components that need to know "active" state, e.g.
* {@link NavLink | `<NavLink>`}.
*
* @public
* @category Hooks
* @param pattern The pattern to match against the current {@link Location}
* @returns The path match object if the pattern matches, `null` otherwise
*/ function $82a4b6c3632a16f2$export$6c330e8992e8a295(pattern) {
    (0, $aDbDg.invariant)($82a4b6c3632a16f2$export$9c954a9d03d32f4a(), `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $82a4b6c3632a16f2$export$45d76561a5302f2b();
    return $jpgPw.useMemo(()=>(0, $jcvU7.matchPath)(pattern, (0, $jcvU7.decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
const $82a4b6c3632a16f2$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
/**
* Returns a function that lets you navigate programmatically in the browser in
* response to user interactions or effects.
*
* It's often better to use {@link redirect} in [`action`](../../start/framework/route-module#action)/[`loader`](../../start/framework/route-module#loader)
* functions than this hook.
*
* The returned function signature is `navigate(to, options?)`/`navigate(delta)` where:
*
* * `to` can be a string path, a {@link To} object, or a number (delta)
* * `options` contains options for modifying the navigation
*   * These options work in all modes (Framework, Data, and Declarative):
*     * `relative`: `"route"` or `"path"` to control relative routing logic
*     * `replace`: Replace the current entry in the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History) stack
*     * `state`: Optional [`history.state`](https://developer.mozilla.org/en-US/docs/Web/API/History/state) to include with the new {@link Location}
*   * These options only work in Framework and Data modes:
*     * `flushSync`: Wrap the DOM updates in [`ReactDom.flushSync`](https://react.dev/reference/react-dom/flushSync)
*     * `preventScrollReset`: Do not scroll back to the top of the page after navigation
*     * `viewTransition`: **Deprecated.** Use React's [`<ViewTransition>`](https://react.dev/reference/react/ViewTransition) component instead. See the [migration guide](../../how-to/view-transitions).
*
* @example
* import { useNavigate } from "react-router";
*
* function SomeComponent() {
*   let navigate = useNavigate();
*   return (
*     <button onClick={() => navigate(-1)}>
*       Go Back
*     </button>
*   );
* }
*
* @additionalExamples
* ### Navigate to another path
*
* ```tsx
* navigate("/some/route");
* navigate("/some/route?search=param");
* ```
*
* ### Navigate with a {@link To} object
*
* All properties are optional.
*
* ```tsx
* navigate(
*   {
*     pathname: "/some/route",
*     search: "?search=param",
*     hash: "#hash",
*   },
*   {
*     state: { some: "state" },
*   },
* );
* ```
*
* If you use `state`, that will be available on the {@link Location} object on
* the next page. Access it with `useLocation().state` (see {@link useLocation}).
*
* ### Navigate back or forward in the history stack
*
* ```tsx
* // back
* // often used to close modals
* navigate(-1);
*
* // forward
* // often used in a multistep wizard workflows
* navigate(1);
* ```
*
* Be cautious with `navigate(number)`. If your application can load up to a
* route that has a button that tries to navigate forward/back, there may not be
* a [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* entry to go back or forward to, or it can go somewhere you don't expect
* (like a different domain).
*
* Only use this if you're sure they will have an entry in the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* stack to navigate to.
*
* ### Replace the current entry in the history stack
*
* This will remove the current entry in the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* stack, replacing it with a new one, similar to a server side redirect.
*
* ```tsx
* navigate("/some/route", { replace: true });
* ```
*
* ### Prevent Scroll Reset
*
* [MODES: framework, data]
*
* To prevent {@link ScrollRestoration | `<ScrollRestoration>`} from resetting
* the scroll position, use the `preventScrollReset` option.
*
* ```tsx
* navigate("?some-tab=1", { preventScrollReset: true });
* ```
*
* For example, if you have a tab interface connected to search params in the
* middle of a page, and you don't want it to scroll to the top when a tab is
* clicked.
*
* ### Return Type Augmentation
*
* Internally, `useNavigate` uses a separate implementation when you are in
* Declarative mode versus Data/Framework mode - the primary difference being
* that the latter is able to return a stable reference that does not change
* identity across navigations. The implementation in Data/Framework mode also
* returns a [`Promise`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise)
* that resolves when the navigation is completed. This means the return type of
* `useNavigate` is `void | Promise<void>`. This is accurate, but can lead to
* some red squigglies based on the union in the return value:
*
* - If you're using `typescript-eslint`, you may see errors from
*   [`@typescript-eslint/no-floating-promises`](https://typescript-eslint.io/rules/no-floating-promises)
* - In Framework/Data mode, `React.use(navigate())` will show a false-positive
*   `Argument of type 'void | Promise<void>' is not assignable to parameter of
*   type 'Usable<void>'` error
*
* The easiest way to work around these issues is to augment the type based on the
* router you're using:
*
* ```ts
* // If using <BrowserRouter>
* declare module "react-router" {
*   interface NavigateFunction {
*     (to: To, options?: NavigateOptions): void;
*     (delta: number): void;
*   }
* }
*
* // If using <RouterProvider> or Framework mode
* declare module "react-router" {
*   interface NavigateFunction {
*     (to: To, options?: NavigateOptions): Promise<void>;
*     (delta: number): Promise<void>;
*   }
* }
* ```
*
* @public
* @category Hooks
* @returns A navigate function for programmatic navigation
*/ function $82a4b6c3632a16f2$export$9770f232ac06a008() {
    return $jpgPw.useContext((0, $1e0kC.IsDataRouteContext)) ? $82a4b6c3632a16f2$var$useNavigateStable() : $82a4b6c3632a16f2$var$useNavigateUnstable();
}
function $82a4b6c3632a16f2$var$useNavigateUnstable() {
    (0, $aDbDg.invariant)($82a4b6c3632a16f2$export$9c954a9d03d32f4a(), `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $jpgPw.useContext((0, $1e0kC.DataRouterContext));
    let { basename: basename, navigator: navigator } = $jpgPw.useContext((0, $1e0kC.NavigationContext));
    let { matches: matches } = $jpgPw.useContext((0, $1e0kC.RouteContext));
    let { pathname: locationPathname } = $82a4b6c3632a16f2$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $jcvU7.getResolveToMatches)(matches));
    let activeRef = $jpgPw.useRef(false);
    $jpgPw.useLayoutEffect(()=>{
        activeRef.current = true;
    });
    return $jpgPw.useCallback((to, options = {})=>{
        (0, $aDbDg.warning)(activeRef.current, $82a4b6c3632a16f2$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $jcvU7.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $jcvU7.joinPaths)([
            basename,
            path.pathname
        ]);
        (0, $2gfKq.validateNavigationTarget)(typeof to === "string" ? to : (0, $aDbDg.createPath)(to), navigator.createHref(path), (0, $2gfKq.getNavigatorCurrentUrl)(navigator), "reject");
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
}
const $82a4b6c3632a16f2$var$OutletContext = $jpgPw.createContext(null);
/**
* Returns the parent route {@link Outlet | `<Outlet context>`}.
*
* Often parent routes manage state or other values you want shared with child
* routes. You can create your own [context provider](https://react.dev/learn/passing-data-deeply-with-context)
* if you like, but this is such a common situation that it's built-into
* {@link Outlet | `<Outlet>`}.
*
* ```tsx
* // Parent route
* function Parent() {
*   const [count, setCount] = React.useState(0);
*   return <Outlet context={[count, setCount]} />;
* }
* ```
*
* ```tsx
* // Child route
* import { useOutletContext } from "react-router";
*
* function Child() {
*   const [count, setCount] = useOutletContext();
*   const increment = () => setCount((c) => c + 1);
*   return <button onClick={increment}>{count}</button>;
* }
* ```
*
* If you're using TypeScript, we recommend the parent component provide a
* custom hook for accessing the context value. This makes it easier for
* consumers to get nice typings, control consumers, and know who's consuming
* the context value.
*
* Here's a more realistic example:
*
* ```tsx filename=src/routes/dashboard.tsx lines=[14,20]
* import { useState } from "react";
* import { Outlet, useOutletContext } from "react-router";
*
* import type { User } from "./types";
*
* type ContextType = { user: User | null };
*
* export default function Dashboard() {
*   const [user, setUser] = useState<User | null>(null);
*
*   return (
*     <div>
*       <h1>Dashboard</h1>
*       <Outlet context={{ user } satisfies ContextType} />
*     </div>
*   );
* }
*
* export function useUser() {
*   return useOutletContext<ContextType>();
* }
* ```
*
* ```tsx filename=src/routes/dashboard/messages.tsx lines=[1,4]
* import { useUser } from "../dashboard";
*
* export default function DashboardMessages() {
*   const { user } = useUser();
*   return (
*     <div>
*       <h2>Messages</h2>
*       <p>Hello, {user.name}!</p>
*     </div>
*   );
* }
* ```
*
* @public
* @category Hooks
* @returns The context value passed to the parent {@link Outlet} component
*/ function $82a4b6c3632a16f2$export$4138103a3ae699cc() {
    return $jpgPw.useContext($82a4b6c3632a16f2$var$OutletContext);
}
/**
* Returns the element for the child route at this level of the route
* hierarchy. Used internally by {@link Outlet | `<Outlet>`} to render child
* routes.
*
* @public
* @category Hooks
* @param context The context to pass to the outlet
* @returns The child route element or `null` if no child routes match
*/ function $82a4b6c3632a16f2$export$a3be3530d8e40d0b(context) {
    let outlet = $jpgPw.useContext((0, $1e0kC.RouteContext)).outlet;
    return $jpgPw.useMemo(()=>outlet && /* @__PURE__ */ $jpgPw.createElement($82a4b6c3632a16f2$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
/**
* Returns an object of key/value-pairs of the dynamic params from the current
* URL that were matched by the routes. Child routes inherit all params from
* their parent routes.
*
* Assuming a route pattern like `/posts/:postId` is matched by `/posts/123`
* then `params.postId` will be `"123"`.
*
* @example
* import { useParams } from "react-router";
*
* function SomeComponent() {
*   let params = useParams();
*   params.postId;
* }
*
* @additionalExamples
* ### Basic Usage
*
* ```tsx
* import { useParams } from "react-router";
*
* // given a route like:
* <Route path="/posts/:postId" element={<Post />} />;
*
* // or a data route like:
* createBrowserRouter([
*   {
*     path: "/posts/:postId",
*     component: Post,
*   },
* ]);
*
* // or in routes.ts
* route("/posts/:postId", "routes/post.tsx");
* ```
*
* Access the params in a component:
*
* ```tsx
* import { useParams } from "react-router";
*
* export default function Post() {
*   let params = useParams();
*   return <h1>Post: {params.postId}</h1>;
* }
* ```
*
* ### Multiple Params
*
* Patterns can have multiple params:
*
* ```tsx
* "/posts/:postId/comments/:commentId";
* ```
*
* All will be available in the params object:
*
* ```tsx
* import { useParams } from "react-router";
*
* export default function Post() {
*   let params = useParams();
*   return (
*     <h1>
*       Post: {params.postId}, Comment: {params.commentId}
*     </h1>
*   );
* }
* ```
*
* ### Catchall Params
*
* Catchall params are defined with `*`:
*
* ```tsx
* "/files/*";
* ```
*
* The matched value will be available in the params object as follows:
*
* ```tsx
* import { useParams } from "react-router";
*
* export default function File() {
*   let params = useParams();
*   let catchall = params["*"];
*   // ...
* }
* ```
*
* You can destructure the catchall param:
*
* ```tsx
* export default function File() {
*   let { "*": catchall } = useParams();
*   console.log(catchall);
* }
* ```
*
* @public
* @category Hooks
* @returns An object containing the dynamic route parameters
*/ function $82a4b6c3632a16f2$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $jpgPw.useContext((0, $1e0kC.RouteContext));
    return matches[matches.length - 1]?.params ?? {};
}
/**
* Resolves the pathname of the given `to` value against the current
* {@link Location}. Similar to {@link useHref}, but returns a
* {@link Path} instead of a string.
*
* @example
* import { useResolvedPath } from "react-router";
*
* function SomeComponent() {
*   // if the user is at /dashboard/profile
*   let path = useResolvedPath("../accounts");
*   path.pathname; // "/dashboard/accounts"
*   path.search; // ""
*   path.hash; // ""
* }
*
* @public
* @category Hooks
* @param to The path to resolve
* @param options Options
* @param options.relative Defaults to `"route"` so routing is relative to the route tree.
*                         Set to `"path"` to make relative routing operate against path segments.
* @returns The resolved {@link Path} object with `pathname`, `search`, and `hash`
*/ function $82a4b6c3632a16f2$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $jpgPw.useContext((0, $1e0kC.RouteContext));
    let { pathname: locationPathname } = $82a4b6c3632a16f2$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $jcvU7.getResolveToMatches)(matches));
    return $jpgPw.useMemo(()=>(0, $jcvU7.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
* Hook version of {@link Routes | `<Routes>`} that uses objects instead of
* components. These objects have the same properties as the component props.
* The return value of `useRoutes` is either a valid React element you can use
* to render the route tree, or `null` if nothing matched.
*
* @example
* import { useRoutes } from "react-router";
*
* function App() {
*   let element = useRoutes([
*     {
*       path: "/",
*       element: <Dashboard />,
*       children: [
*         {
*           path: "messages",
*           element: <DashboardMessages />,
*         },
*         { path: "tasks", element: <DashboardTasks /> },
*       ],
*     },
*     { path: "team", element: <AboutPage /> },
*   ]);
*
*   return element;
* }
*
* @public
* @category Hooks
* @param routes An array of {@link RouteObject}s that define the route hierarchy
* @param locationArg An optional {@link Location} object or pathname string to
* use instead of the current {@link Location}
* @returns A React element to render the matched route, or `null` if no routes matched
*/ function $82a4b6c3632a16f2$export$5d3fca4a98652595(routes, locationArg) {
    return $82a4b6c3632a16f2$export$f7ce0646a48561fb(routes, locationArg);
}
function $82a4b6c3632a16f2$export$f7ce0646a48561fb(routes, locationArg, dataRouterOpts) {
    (0, $aDbDg.invariant)($82a4b6c3632a16f2$export$9c954a9d03d32f4a(), `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $jpgPw.useContext((0, $1e0kC.NavigationContext));
    let { matches: parentMatches } = $jpgPw.useContext((0, $1e0kC.RouteContext));
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    routeMatch && routeMatch.pathname;
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    routeMatch && routeMatch.route;
    let locationFromContext = $82a4b6c3632a16f2$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? (0, $aDbDg.parsePath)(locationArg) : locationArg;
        (0, $aDbDg.invariant)(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        remainingPathname = "/" + pathname.replace(/^\//, "").split("/").slice(parentSegments.length).join("/");
    }
    let matches;
    if (dataRouterOpts) {
        if (dataRouterOpts.state.matches.length) matches = dataRouterOpts.state.matches.map((m)=>Object.assign(m, {
                route: dataRouterOpts.manifest[m.route.id] || m.route
            }));
        else matches = dataRouterOpts.router.match(dataRouterOpts.state.location);
    } else matches = (0, $jcvU7.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $82a4b6c3632a16f2$export$569816e95a012c39(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $jcvU7.joinPaths)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $jcvU7.joinPaths)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterOpts);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $jpgPw.createElement((0, $1e0kC.LocationContext).Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                mask: void 0,
                ...location
            },
            navigationType: "POP"
        }
    }, renderedMatches);
    return renderedMatches;
}
function $82a4b6c3632a16f2$var$DefaultErrorComponent() {
    let error = $82a4b6c3632a16f2$export$ed527bf60f6e05f2();
    let message = (0, $jcvU7.isRouteErrorResponse)(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    return /* @__PURE__ */ $jpgPw.createElement($jpgPw.Fragment, null, /* @__PURE__ */ $jpgPw.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $jpgPw.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $jpgPw.createElement("pre", {
        style: {
            padding: "0.5rem",
            backgroundColor: "rgba(200,200,200, 0.5)"
        }
    }, stack) : null, null);
}
const $82a4b6c3632a16f2$var$defaultErrorElement = /* @__PURE__ */ $jpgPw.createElement($82a4b6c3632a16f2$var$DefaultErrorComponent, null);
var $82a4b6c3632a16f2$var$RenderErrorBoundary = class extends $jpgPw.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static contextType = (0, $1e0kC.RSCRouterContext);
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        let error = this.state.error;
        if (this.context && typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
            const decoded = (0, $7snpk.decodeRouteErrorResponseDigest)(error.digest);
            if (decoded) error = decoded;
        }
        let result = error !== void 0 ? /* @__PURE__ */ $jpgPw.createElement((0, $1e0kC.RouteContext).Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $jpgPw.createElement((0, $1e0kC.IsDataRouteContext).Provider, {
            value: this.props.routeContext.isDataRoute
        }, /* @__PURE__ */ $jpgPw.createElement((0, $1e0kC.RouteIdContext).Provider, {
            value: this.props.routeContext.matches[this.props.routeContext.matches.length - 1]?.route.id
        }, /* @__PURE__ */ $jpgPw.createElement((0, $1e0kC.RouteErrorContext).Provider, {
            value: error,
            children: this.props.component
        })))) : this.props.children;
        if (this.context) return /* @__PURE__ */ $jpgPw.createElement($82a4b6c3632a16f2$var$RSCErrorHandler, {
            error: error
        }, result);
        return result;
    }
};
const $82a4b6c3632a16f2$var$errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function $82a4b6c3632a16f2$var$RSCErrorHandler({ children: children, error: error }) {
    let { basename: basename, navigator: navigator } = $jpgPw.useContext((0, $1e0kC.NavigationContext));
    if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
        let redirect = (0, $7snpk.decodeRedirectErrorDigest)(error.digest);
        if (redirect) {
            let existingRedirect = $82a4b6c3632a16f2$var$errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            let parsed = (0, $jcvU7.parseToInfo)(redirect.location, basename);
            let target = parsed.absoluteURL || parsed.to;
            (0, $2gfKq.validateNavigationTarget)(redirect.location, target, (0, $2gfKq.getNavigatorCurrentUrl)(navigator), "allow-explicit");
            if ((0, $e1hMf.hasInvalidProtocol)(target)) throw new Error("Invalid redirect location");
            if ((0, $jcvU7.isBrowser) && !$82a4b6c3632a16f2$var$errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect.reloadDocument) window.location.href = target;
                else {
                    const redirectPromise = Promise.resolve().then(()=>window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect.replace
                        }));
                    $82a4b6c3632a16f2$var$errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $jpgPw.createElement("meta", {
                httpEquiv: "refresh",
                content: `0;url=${target}`
            });
        }
    }
    return children;
}
function $82a4b6c3632a16f2$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $jpgPw.useContext((0, $1e0kC.DataRouterContext));
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $jpgPw.createElement((0, $1e0kC.RouteContext).Provider, {
        value: routeContext
    }, /* @__PURE__ */ $jpgPw.createElement((0, $1e0kC.IsDataRouteContext).Provider, {
        value: routeContext.isDataRoute
    }, /* @__PURE__ */ $jpgPw.createElement((0, $1e0kC.RouteIdContext).Provider, {
        value: match.route.id
    }, children)));
}
function $82a4b6c3632a16f2$export$569816e95a012c39(matches, parentMatches = [], dataRouterOpts) {
    let dataRouterState = dataRouterOpts?.state;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        (0, $aDbDg.invariant)(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterOpts && dataRouterState) {
        renderFallback = dataRouterState.renderFallback;
        for(let i = 0; i < renderedMatches.length; i++){
            let match = renderedMatches[i];
            if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
            if (match.route.id) {
                let { loaderData: loaderData, errors: errors } = dataRouterState;
                let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors || errors[match.route.id] === void 0);
                if (match.route.lazy || needsToRunLoader) {
                    if (dataRouterOpts.isStatic) renderFallback = true;
                    if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                    else renderedMatches = [
                        renderedMatches[0]
                    ];
                    break;
                }
            }
        }
    }
    let onErrorHandler = dataRouterOpts?.onError;
    let onError = dataRouterState && onErrorHandler ? (error, errorInfo)=>{
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: dataRouterState.matches?.[0]?.params ?? {},
            pattern: (0, $jcvU7.getRoutePattern)(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $82a4b6c3632a16f2$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $82a4b6c3632a16f2$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $jpgPw.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $jpgPw.createElement($82a4b6c3632a16f2$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $jpgPw.createElement($82a4b6c3632a16f2$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $82a4b6c3632a16f2$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $82a4b6c3632a16f2$export$ae09415e57d46628(hookName) {
    let ctx = $jpgPw.useContext((0, $1e0kC.DataRouterContext));
    (0, $aDbDg.invariant)(ctx, $82a4b6c3632a16f2$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $82a4b6c3632a16f2$export$f93124018767f269(hookName) {
    let state = $jpgPw.useContext((0, $1e0kC.DataRouterStateContext));
    (0, $aDbDg.invariant)(state, $82a4b6c3632a16f2$var$getDataRouterConsoleError(hookName));
    return state;
}
function $82a4b6c3632a16f2$export$c6e4e4d7047d4ffe(hookName) {
    let fetchers = $jpgPw.useContext((0, $1e0kC.FetchersContext));
    (0, $aDbDg.invariant)(fetchers, $82a4b6c3632a16f2$var$getDataRouterConsoleError(hookName));
    return fetchers;
}
function $82a4b6c3632a16f2$export$798168c290ba5b3d(hookName) {
    let data = $jpgPw.useContext((0, $1e0kC.DataRouterDataContext));
    (0, $aDbDg.invariant)(data, $82a4b6c3632a16f2$var$getDataRouterConsoleError(hookName));
    return data;
}
function $82a4b6c3632a16f2$var$useDataRouterNavigation(hookName) {
    let navigation = $jpgPw.useContext((0, $1e0kC.DataRouterNavigationContext));
    (0, $aDbDg.invariant)(navigation, $82a4b6c3632a16f2$var$getDataRouterConsoleError(hookName));
    return navigation;
}
function $82a4b6c3632a16f2$export$501a3f562d56eac6(hookName) {
    let routeId = $jpgPw.useContext((0, $1e0kC.RouteIdContext));
    (0, $aDbDg.invariant)(routeId, `${hookName} can only be used on routes that contain a unique "id"`);
    return routeId;
}
/**
* Returns the current {@link Navigation}, defaulting to an "idle" navigation
* when no navigation is in progress. You can use this to render pending UI
* (like a global spinner) or read [`FormData`](https://developer.mozilla.org/en-US/docs/Web/API/FormData)
* from a form navigation.
*
* @example
* import { useNavigation } from "react-router";
*
* function SomeComponent() {
*   let navigation = useNavigation();
*   navigation.state;
*   navigation.formData;
*   // etc.
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The current {@link Navigation} object
*/ function $82a4b6c3632a16f2$export$d0fd4b7106de2769() {
    let { navigation: navigation } = $82a4b6c3632a16f2$var$useDataRouterNavigation("useNavigation");
    return $jpgPw.useMemo(()=>{
        let { matches: matches, historyAction: historyAction, ...rest } = navigation;
        return rest;
    }, [
        navigation
    ]);
}
/**
* Revalidate the data on the page for reasons outside of normal data mutations
* like [`Window` focus](https://developer.mozilla.org/en-US/docs/Web/API/Window/focus_event)
* or polling on an interval.
*
* Note that page data is already revalidated automatically after actions.
* If you find yourself using this for normal CRUD operations on your data in
* response to user interactions, you're probably not taking advantage of the
* other APIs like {@link useFetcher}, {@link Form}, {@link useSubmit} that do
* this automatically.
*
* @example
* import { useRevalidator } from "react-router";
*
* function WindowFocusRevalidator() {
*   const revalidator = useRevalidator();
*
*   useFakeWindowFocus(() => {
*     revalidator.revalidate();
*   });
*
*   return (
*     <div hidden={revalidator.state === "idle"}>
*       Revalidating...
*     </div>
*   );
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns An object with a `revalidate` function and the current revalidation
* `state`
*/ function $82a4b6c3632a16f2$export$600dc272ed516c15() {
    let dataRouterContext = $82a4b6c3632a16f2$export$ae09415e57d46628("useRevalidator");
    let { revalidation: revalidation } = $82a4b6c3632a16f2$var$useDataRouterNavigation("useRevalidator");
    let revalidate = $jpgPw.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $jpgPw.useMemo(()=>({
            revalidate: revalidate,
            state: revalidation
        }), [
        revalidate,
        revalidation
    ]);
}
/**
* Returns the active route matches, useful for accessing `loaderData` for
* parent/child routes or the route [`handle`](../../start/framework/route-module#handle)
* property
*
* Pairing the route `handle` with `useMatches` gets very powerful since you can put
* whatever you want on a route handle and have access to `useMatches` anywhere.
* Please see the [handle](../../how-to/using-handle) documentation for an example
* of breadcrumbs via `useMatches`/`handle`.
*
* ```tsx
* import { useMatches } from "react-router";
*
* function SomeComponent() {
*   const matches = useMatches();
*   // matches[i].id          // route id
*   // matches[i].pathname    // the portion of the URL the route matched
*   // matches[i].params      // the parsed params from the URL
*   // matches[i].loaderData  // the data from the loader
*   // matches[i].handle      // the route handle with any app specific data
* }
* ```
*
* <docs-info>useMatches only works with a data router like `createBrowserRouter`,
* since they know the full route tree up front and can provide all of the current
* matches. Additionally, `useMatches` will not match down into any descendant route
* trees since the router isn't aware of the descendant routes.</docs-info>
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns An array of {@link UIMatch | UI matches} for the current route hierarchy
*/ function $82a4b6c3632a16f2$export$2378eb7f5ff86053() {
    let { matches: matches } = $82a4b6c3632a16f2$export$f93124018767f269("useMatches");
    let { loaderData: loaderData } = $82a4b6c3632a16f2$export$798168c290ba5b3d("useMatches");
    return $jpgPw.useMemo(()=>matches.map((m)=>(0, $jcvU7.convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
* Returns the data from the closest route
* [`loader`](../../start/framework/route-module#loader) or
* [`clientLoader`](../../start/framework/route-module#clientloader).
*
* @example
* import { useLoaderData } from "react-router";
*
* export async function loader() {
*   return await fakeDb.invoices.findAll();
* }
*
* export default function Invoices() {
*   let invoices = useLoaderData<typeof loader>();
*   // ...
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The data returned from the route's [`loader`](../../start/framework/route-module#loader) or [`clientLoader`](../../start/framework/route-module#clientloader) function
*/ function $82a4b6c3632a16f2$export$1448a5050d252c4d() {
    let data = $82a4b6c3632a16f2$export$798168c290ba5b3d("useLoaderData");
    let routeId = $82a4b6c3632a16f2$export$501a3f562d56eac6("useLoaderData");
    return data.loaderData[routeId];
}
/**
* Returns the [`loader`](../../start/framework/route-module#loader) data for a
* given route by route ID.
*
* Route IDs are created automatically. They are simply the path of the route file
* relative to the app folder without the extension.
*
* | Route Filename               | Route ID               |
* | ---------------------------- | ---------------------- |
* | `app/root.tsx`               | `"root"`               |
* | `app/routes/teams.tsx`       | `"routes/teams"`       |
* | `app/whatever/teams.$id.tsx` | `"whatever/teams.$id"` |
*
* @example
* import { useRouteLoaderData } from "react-router";
*
* function SomeComponent() {
*   const { user } = useRouteLoaderData("root");
* }
*
* // You can also specify your own route ID's manually in your routes.ts file:
* route("/", "containers/app.tsx", { id: "app" })
* useRouteLoaderData("app");
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param routeId The ID of the route to return loader data from
* @returns The data returned from the specified route's [`loader`](../../start/framework/route-module#loader)
* function, or `undefined` if not found
*/ function $82a4b6c3632a16f2$export$fd5d37484eab868d(routeId) {
    return $82a4b6c3632a16f2$export$798168c290ba5b3d("useRouteLoaderData").loaderData[routeId];
}
/**
* Returns the [`action`](../../start/framework/route-module#action) data from
* the most recent `POST` navigation form submission or `undefined` if there
* hasn't been one.
*
* @example
* import { Form, useActionData } from "react-router";
*
* export async function action({ request }) {
*   const body = await request.formData();
*   const name = body.get("visitorsName");
*   return { message: `Hello, ${name}` };
* }
*
* export default function Invoices() {
*   const data = useActionData();
*   return (
*     <Form method="post">
*       <input type="text" name="visitorsName" />
*       {data ? data.message : "Waiting..."}
*     </Form>
*   );
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The data returned from the route's [`action`](../../start/framework/route-module#action)
* function, or `undefined` if no [`action`](../../start/framework/route-module#action)
* has been called
*/ function $82a4b6c3632a16f2$export$fdc00f3f26066d5e() {
    let data = $82a4b6c3632a16f2$export$798168c290ba5b3d("useActionData");
    let routeId = $82a4b6c3632a16f2$export$501a3f562d56eac6("useActionData");
    return data.actionData ? data.actionData[routeId] : void 0;
}
/**
* Accesses the error thrown during an
* [`action`](../../start/framework/route-module#action),
* [`loader`](../../start/framework/route-module#loader),
* or component render to be used in a route module
* [`ErrorBoundary`](../../start/framework/route-module#errorboundary).
*
* @example
* export function ErrorBoundary() {
*   const error = useRouteError();
*   return <div>{error.message}</div>;
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The error that was thrown during route [loading](../../start/framework/route-module#loader),
* [`action`](../../start/framework/route-module#action) execution, or rendering
*/ function $82a4b6c3632a16f2$export$ed527bf60f6e05f2() {
    let error = $jpgPw.useContext((0, $1e0kC.RouteErrorContext));
    let data = $82a4b6c3632a16f2$export$798168c290ba5b3d("useRouteError");
    let routeId = $82a4b6c3632a16f2$export$501a3f562d56eac6("useRouteError");
    if (error !== void 0) return error;
    return data.errors?.[routeId];
}
/**
* Returns the resolved promise value from the closest {@link Await | `<Await>`}.
*
* @example
* function SomeDescendant() {
*   const value = useAsyncValue();
*   // ...
* }
*
* // somewhere in your app
* <Await resolve={somePromise}>
*   <SomeDescendant />
* </Await>;
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The resolved value from the nearest {@link Await} component
*/ function $82a4b6c3632a16f2$export$78a72ddb39bdd145() {
    let value = $jpgPw.useContext((0, $1e0kC.AwaitContext));
    return value && "status" in value && !("_tracked" in value) ? value.status === "fulfilled" ? value.value : void 0 : value?._data;
}
/**
* Returns the rejection value from the closest {@link Await | `<Await>`}.
*
* @example
* import { Await, useAsyncError } from "react-router";
*
* function ErrorElement() {
*   const error = useAsyncError();
*   return (
*     <p>Uh Oh, something went wrong! {error.message}</p>
*   );
* }
*
* // somewhere in your app
* <Await
*   resolve={promiseThatRejects}
*   errorElement={<ErrorElement />}
* />;
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The error that was thrown in the nearest {@link Await} component
*/ function $82a4b6c3632a16f2$export$17f53340677d5831() {
    let value = $jpgPw.useContext((0, $1e0kC.AwaitContext));
    return value && "status" in value && !("_tracked" in value) ? value.status === "rejected" ? value.reason : void 0 : value?._error;
}
let $82a4b6c3632a16f2$var$blockerId = 0;
/**
* Allow the application to block navigations within the SPA and present the
* user a confirmation dialog to confirm the navigation. Mostly used to avoid
* using half-filled form data. This does not handle hard-reloads or
* cross-origin navigations.
*
* The {@link Blocker} object returned by the hook has the following properties:
*
* - **`state`**
*   - `unblocked` - the blocker is idle and has not prevented any navigation
*   - `blocked` - the blocker has prevented a navigation
*   - `proceeding` - the blocker is proceeding through from a blocked navigation
* - **`location`**
*   - When in a `blocked` state, this represents the {@link Location} to which
*     we blocked a navigation. When in a `proceeding` state, this is the
*     location being navigated to after a `blocker.proceed()` call.
* - **`proceed()`**
*   - When in a `blocked` state, you may call `blocker.proceed()` to proceed to
*     the blocked location.
* - **`reset()`**
*   - When in a `blocked` state, you may call `blocker.reset()` to return the
*     blocker to an `unblocked` state and leave the user at the current
*     location.
*
* @example
* // Boolean version
* let blocker = useBlocker(value !== "");
*
* // Function version
* let blocker = useBlocker(
*   ({ currentLocation, nextLocation, historyAction }) =>
*     value !== "" &&
*     currentLocation.pathname !== nextLocation.pathname
* );
*
* @additionalExamples
* ```tsx
* import { useCallback, useState } from "react";
* import { BlockerFunction, useBlocker } from "react-router";
*
* export function ImportantForm() {
*   const [value, setValue] = useState("");
*
*   const shouldBlock = useCallback<BlockerFunction>(
*     () => value !== "",
*     [value]
*   );
*   const blocker = useBlocker(shouldBlock);
*
*   return (
*     <form
*       onSubmit={(e) => {
*         e.preventDefault();
*         setValue("");
*         if (blocker.state === "blocked") {
*           blocker.proceed();
*         }
*       }}
*     >
*       <input
*         name="data"
*         value={value}
*         onChange={(e) => setValue(e.target.value)}
*       />
*
*       <button type="submit">Save</button>
*
*       {blocker.state === "blocked" ? (
*         <>
*           <p style={{ color: "red" }}>
*             Blocked the last navigation to
*           </p>
*           <button
*             type="button"
*             onClick={() => blocker.proceed()}
*           >
*             Let me through
*           </button>
*           <button
*             type="button"
*             onClick={() => blocker.reset()}
*           >
*             Keep me here
*           </button>
*         </>
*       ) : blocker.state === "proceeding" ? (
*         <p style={{ color: "orange" }}>
*           Proceeding through blocked navigation
*         </p>
*       ) : (
*         <p style={{ color: "green" }}>
*           Blocker is currently unblocked
*         </p>
*       )}
*     </form>
*   );
* }
* ```
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param shouldBlock Either a boolean or a function returning a boolean which
* indicates whether the navigation should be blocked. The function format
* receives a single object parameter containing the `currentLocation`,
* `nextLocation`, and `historyAction` of the potential navigation.
* @returns A {@link Blocker} object with state and reset functionality
*/ function $82a4b6c3632a16f2$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $82a4b6c3632a16f2$export$ae09415e57d46628("useBlocker");
    let state = $82a4b6c3632a16f2$export$f93124018767f269("useBlocker");
    let [blockerKey, setBlockerKey] = $jpgPw.useState("");
    let blockerFunction = $jpgPw.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: (0, $jcvU7.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: (0, $jcvU7.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $jpgPw.useEffect(()=>{
        let key = String(++$82a4b6c3632a16f2$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $jpgPw.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $e1hMf.IDLE_BLOCKER);
}
function $82a4b6c3632a16f2$var$useNavigateStable() {
    let { router: router } = $82a4b6c3632a16f2$export$ae09415e57d46628("useNavigate");
    let id = $82a4b6c3632a16f2$export$501a3f562d56eac6("useNavigate");
    let activeRef = $jpgPw.useRef(false);
    $jpgPw.useLayoutEffect(()=>{
        activeRef.current = true;
    });
    return $jpgPw.useCallback(async (to, options = {})=>{
        (0, $aDbDg.warning)(activeRef.current, $82a4b6c3632a16f2$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
}
const $82a4b6c3632a16f2$var$alreadyWarned = {};
function $82a4b6c3632a16f2$var$warningOnce(key, cond, message) {
    if (!cond && !$82a4b6c3632a16f2$var$alreadyWarned[key]) {
        $82a4b6c3632a16f2$var$alreadyWarned[key] = true;
        (0, $aDbDg.warning)(false, message);
    }
}
function $82a4b6c3632a16f2$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $82a4b6c3632a16f2$export$501a3f562d56eac6("useRoute");
    const id = args[0] ?? currentRouteId;
    const state = $82a4b6c3632a16f2$export$f93124018767f269("useRoute");
    const data = $82a4b6c3632a16f2$export$798168c290ba5b3d("useRoute");
    const route = state.matches.find(({ route: route })=>route.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: data.loaderData[id],
        actionData: data.actionData?.[id]
    };
}
function $82a4b6c3632a16f2$var$toRouterStateMatch(match) {
    return {
        id: match.route.id,
        pathname: match.pathname,
        params: match.params,
        handle: match.route.handle
    };
}
/**
* A unified hook for reading router state: current (`active`) and in-flight
* (`pending`) locations, search params, params, matches, and navigation type.
*
* This hook consolidates the information you used to get from {@link useLocation},
* {@link useSearchParams}, {@link useParams}, {@link useMatches}, {@link useNavigation},
* and {@link useNavigationType} into a single hook.
*
*
* @example
* import { unstable_useRouterState as useRouterState } from "react-router";
*
* let { active, pending } = useRouterState();
*
* // Active is always populated with the current location
* active.location; // replaces `useLocation()`
* active.searchParams; // replaces `useSearchParams()[0]`
* active.params; // replaces `useParams()`
* active.matches; // replaces `useMatches()`
* active.type; // replaces `useNavigationType()`
*
* // Pending is only populated during a navigation
* pending.location; // replaces `useNavigation().location`
* pending.searchParams; // equivalent to `new URLSearchParams(useNavigation().search)`
* pending.params; // Not directly accessible today
* pending.matches; // Not directly accessible today
* pending.type; // Not directly accessible today
* pending.state; // replaces `useNavigation().state`
* pending.formMethod; // replaces useNavigation().formMethod
* pending.formAction; // replaces useNavigation().formAction
* pending.formEncType; // replaces useNavigation().formEncType
* pending.formData; // replaces useNavigation().formData
* pending.json; // replaces useNavigation().json
* pending.text; // replaces useNavigation().text
*
* @name unstable_useRouterState
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The current router state with `active` and `pending` variants
*/ function $82a4b6c3632a16f2$export$dbb5ccc270afbbb4() {
    let { location: location, historyAction: type, matches: matches } = $82a4b6c3632a16f2$export$f93124018767f269("unstable_useRouterState");
    let { navigation: navigation } = $82a4b6c3632a16f2$var$useDataRouterNavigation("unstable_useRouterState");
    let active = $jpgPw.useMemo(()=>({
            type: type,
            location: location,
            searchParams: new URLSearchParams(location.search),
            params: matches[matches.length - 1]?.params ?? {},
            matches: matches.map((m)=>$82a4b6c3632a16f2$var$toRouterStateMatch(m))
        }), [
        location,
        matches,
        type
    ]);
    let pending = $jpgPw.useMemo(()=>{
        if (navigation.state === "idle") return null;
        let shared = {
            type: navigation.historyAction,
            location: navigation.location,
            searchParams: new URLSearchParams(navigation.location.search),
            params: navigation.matches[navigation.matches.length - 1]?.params ?? {},
            matches: navigation.matches.map((m)=>$82a4b6c3632a16f2$var$toRouterStateMatch(m))
        };
        return navigation.state === "loading" ? {
            ...shared,
            state: "loading",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        } : {
            ...shared,
            state: "submitting",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        };
    }, [
        navigation
    ]);
    return $jpgPw.useMemo(()=>({
            active: active,
            pending: pending
        }), [
        active,
        pending
    ]);
}

});
parcelRegister("7snpk", function(module, exports) {

$parcel$export(module.exports, "decodeRedirectErrorDigest", function () { return $56dd4e27f4495876$export$30db792b333fd2ee; });
$parcel$export(module.exports, "decodeRouteErrorResponseDigest", function () { return $56dd4e27f4495876$export$2b5950305b3e7eaf; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $jcvU7 = parcelRequire("jcvU7");
//#region lib/errors.ts
const $56dd4e27f4495876$var$ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
const $56dd4e27f4495876$var$ERROR_DIGEST_REDIRECT = "REDIRECT";
const $56dd4e27f4495876$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function $56dd4e27f4495876$export$30db792b333fd2ee(digest) {
    if (digest.startsWith(`${$56dd4e27f4495876$var$ERROR_DIGEST_BASE}:${$56dd4e27f4495876$var$ERROR_DIGEST_REDIRECT}:{`)) try {
        let parsed = JSON.parse(digest.slice(28));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch  {}
}
function $56dd4e27f4495876$export$2b5950305b3e7eaf(digest) {
    if (digest.startsWith(`${$56dd4e27f4495876$var$ERROR_DIGEST_BASE}:${$56dd4e27f4495876$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE}:{`)) try {
        let parsed = JSON.parse(digest.slice(40));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new (0, $jcvU7.ErrorResponseImpl)(parsed.status, parsed.statusText, parsed.data);
    } catch  {}
}

});


parcelRegister("jGoV5", function(module, exports) {

$parcel$export(module.exports, "escapeHtml", function () { return $e5454521fa95d035$export$4cf11838cdc2a8a8; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/dom/ssr/markup.ts
const $e5454521fa95d035$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
const $e5454521fa95d035$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $e5454521fa95d035$export$4cf11838cdc2a8a8(html) {
    return html.replace($e5454521fa95d035$var$ESCAPE_REGEX, (match)=>$e5454521fa95d035$var$ESCAPE_LOOKUP[match]);
}
function $e5454521fa95d035$export$30330f3d5eb70e11(value) {
    return value.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

});

parcelRegister("89PPr", function(module, exports) {

$parcel$export(module.exports, "FrameworkContext", function () { return $5f075e1e0ade2695$export$208d6a3bc3aa62bd; });
$parcel$export(module.exports, "useFrameworkContext", function () { return $5f075e1e0ade2695$export$17134ff624fc6bc2; });
$parcel$export(module.exports, "usePrefetchBehavior", function () { return $5f075e1e0ade2695$export$6eb91431f5da407c; });
$parcel$export(module.exports, "PrefetchPageLinks", function () { return $5f075e1e0ade2695$export$60dcec93e67386bd; });
$parcel$export(module.exports, "Scripts", function () { return $5f075e1e0ade2695$export$ff0bf87698939488; });
$parcel$export(module.exports, "mergeRefs", function () { return $5f075e1e0ade2695$export$c9058316764c140e; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $1e0kC = parcelRequire("1e0kC");

var $bdpx3 = parcelRequire("bdpx3");

var $daoDw = parcelRequire("daoDw");

var $fwz2C = parcelRequire("fwz2C");

var $jGoV5 = parcelRequire("jGoV5");

var $5wi0a = parcelRequire("5wi0a");

var $e11Sy = parcelRequire("e11Sy");

var $2fbUC = parcelRequire("2fbUC");

var $jpgPw = parcelRequire("jpgPw");
//#region lib/dom/ssr/components.tsx
const $5f075e1e0ade2695$export$208d6a3bc3aa62bd = $jpgPw.createContext(void 0);
$5f075e1e0ade2695$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $5f075e1e0ade2695$export$17134ff624fc6bc2() {
    let context = $jpgPw.useContext($5f075e1e0ade2695$export$208d6a3bc3aa62bd);
    (0, $daoDw.default)(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $5f075e1e0ade2695$export$6eb91431f5da407c(prefetch, theirElementProps) {
    let frameworkContext = $jpgPw.useContext($5f075e1e0ade2695$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $jpgPw.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $jpgPw.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $jpgPw.useRef(null);
    $jpgPw.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: .5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $jpgPw.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $5f075e1e0ade2695$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $5f075e1e0ade2695$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $5f075e1e0ade2695$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $5f075e1e0ade2695$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $5f075e1e0ade2695$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $5f075e1e0ade2695$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $5f075e1e0ade2695$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$5f075e1e0ade2695$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
const $5f075e1e0ade2695$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
/**
* Renders all the [`<link>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link)
* tags created by the route module's [`links`](../../start/framework/route-module#links)
* export. You should render it inside the [`<head>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/head)
* of your document.
*
* @example
* import { Links } from "react-router";
*
* export default function Root() {
*   return (
*     <html>
*       <head>
*         <Links />
*       </head>
*       <body></body>
*     </html>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @param props Props
* @param {LinksProps.nonce} props.nonce n/a
* @param {LinksProps.crossOrigin} props.crossOrigin n/a
* @returns A collection of React elements for [`<link>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link)
* tags
*/ function $5f075e1e0ade2695$export$b2e089eb3692b073({ nonce: nonce, crossOrigin: crossOrigin }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss, nonce: contextNonce } = $5f075e1e0ade2695$export$17134ff624fc6bc2();
    let { matches: routerMatches } = (0, $bdpx3.useDataRouterState)("Links");
    let { errors: errors } = (0, $bdpx3.useDataRouterData)("Links");
    let matches = $5f075e1e0ade2695$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $jpgPw.useMemo(()=>(0, $fwz2C.getKeyedLinksForMatches)(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    if (nonce == null && contextNonce) nonce = contextNonce;
    return /* @__PURE__ */ $jpgPw.createElement($jpgPw.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $jpgPw.createElement("style", {
        [$5f075e1e0ade2695$export$7e4ed4715c00dab0]: "",
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $jpgPw.createElement("link", {
        [$5f075e1e0ade2695$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce,
        crossOrigin: crossOrigin
    }) : null, keyedLinks.map(({ key: key, link: link })=>(0, $fwz2C.isPageLinkDescriptor)(link) ? /* @__PURE__ */ $jpgPw.createElement($5f075e1e0ade2695$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        }) : /* @__PURE__ */ $jpgPw.createElement("link", {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        })));
}
/**
* Renders [`<link rel=prefetch|modulepreload>`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLinkElement/rel)
* tags for modules and data of another page to enable an instant navigation to
* that page. [`<Link prefetch>`](./Link#prefetch) uses this internally, but you
* can render it to prefetch a page for any other reason.
*
* For example, you may render one of this as the user types into a search field
* to prefetch search results before they click through to their selection.
*
* @example
* import { PrefetchPageLinks } from "react-router";
*
* <PrefetchPageLinks page="/absolute/path" />
*
* @public
* @category Components
* @mode framework
* @param props Props
* @param {PageLinkDescriptor.page} props.page n/a
* @param props.linkProps Additional props to spread onto the [`<link>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link)
* tags, such as [`crossOrigin`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLinkElement/crossOrigin),
* [`integrity`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLinkElement/integrity),
* [`rel`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLinkElement/rel),
* etc.
* @returns A collection of React elements for [`<link>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link)
* tags
*/ function $5f075e1e0ade2695$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let rsc = (0, $1e0kC.useIsRSCRouterContext)();
    let { nonce: contextNonce } = $5f075e1e0ade2695$export$17134ff624fc6bc2();
    let { router: router } = (0, $bdpx3.useDataRouterContext)("PrefetchPageLinks");
    let matches = $jpgPw.useMemo(()=>router.match(page), [
        router,
        router.routes,
        page
    ]);
    if (!matches) return null;
    if (linkProps.nonce == null && contextNonce) linkProps = {
        ...linkProps,
        nonce: contextNonce
    };
    if (rsc) return /* @__PURE__ */ $jpgPw.createElement($5f075e1e0ade2695$var$RSCPrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
    return /* @__PURE__ */ $jpgPw.createElement($5f075e1e0ade2695$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $5f075e1e0ade2695$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $5f075e1e0ade2695$export$17134ff624fc6bc2();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $jpgPw.useState([]);
    $jpgPw.useEffect(()=>{
        let interrupted = false;
        (0, $fwz2C.getKeyedPrefetchLinks)(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $5f075e1e0ade2695$var$RSCPrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = (0, $bdpx3.useLocation)();
    let { unstable_apiServerOrigin: unstable_apiServerOrigin } = $5f075e1e0ade2695$export$17134ff624fc6bc2();
    let dataHrefs = $jpgPw.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let url = (0, $5wi0a.singleFetchUrl)(page, "rsc", unstable_apiServerOrigin);
        let hasSomeRoutesWithShouldRevalidate = false;
        let targetRoutes = [];
        for (let match of nextMatches)if (typeof match.route.shouldRevalidate === "function") hasSomeRoutesWithShouldRevalidate = true;
        else targetRoutes.push(match.route.id);
        if (hasSomeRoutesWithShouldRevalidate && targetRoutes.length > 0) url.searchParams.set("_routes", targetRoutes.join(","));
        return [
            unstable_apiServerOrigin ? url.toString() : url.pathname + url.search
        ];
    }, [
        page,
        location,
        nextMatches,
        unstable_apiServerOrigin
    ]);
    return /* @__PURE__ */ $jpgPw.createElement($jpgPw.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $jpgPw.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })));
}
function $5f075e1e0ade2695$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = (0, $bdpx3.useLocation)();
    let { manifest: manifest, routeModules: routeModules, unstable_apiServerOrigin: unstable_apiServerOrigin } = $5f075e1e0ade2695$export$17134ff624fc6bc2();
    let { matches: matches } = (0, $bdpx3.useDataRouterState)("PrefetchPageLinks");
    let { loaderData: loaderData } = (0, $bdpx3.useDataRouterData)("PrefetchPageLinks");
    let newMatchesForData = $jpgPw.useMemo(()=>(0, $fwz2C.getNewMatchesForLinks)(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $jpgPw.useMemo(()=>(0, $fwz2C.getNewMatchesForLinks)(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $jpgPw.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = (0, $5wi0a.singleFetchUrl)(page, "data", unstable_apiServerOrigin);
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            unstable_apiServerOrigin ? url.toString() : url.pathname + url.search
        ];
    }, [
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules,
        unstable_apiServerOrigin
    ]);
    let moduleHrefs = $jpgPw.useMemo(()=>(0, $fwz2C.getModuleLinkHrefs)(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $5f075e1e0ade2695$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $jpgPw.createElement($jpgPw.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $jpgPw.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $jpgPw.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>/* @__PURE__ */ $jpgPw.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? linkProps.crossOrigin
        })));
}
/**
* Renders all the [`<meta>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/meta)
* tags created by the route module's [`meta`](../../start/framework/route-module#meta)
* export. You should render it inside the [`<head>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/head)
* of your document.
*
* @example
* import { Meta } from "react-router";
*
* export default function Root() {
*   return (
*     <html>
*       <head>
*         <Meta />
*       </head>
*     </html>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @returns A collection of React elements for [`<meta>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/meta)
* tags
*/ function $5f075e1e0ade2695$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $5f075e1e0ade2695$export$17134ff624fc6bc2();
    let { matches: routerMatches } = (0, $bdpx3.useDataRouterState)("Meta");
    let { errors: errors, loaderData: loaderData } = (0, $bdpx3.useDataRouterData)("Meta");
    let location = (0, $bdpx3.useLocation)();
    let _matches = $5f075e1e0ade2695$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            loaderData: data,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            loaderData: data,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://reactrouter.com/start/framework/route-module#meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $jpgPw.createElement($jpgPw.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$5f075e1e0ade2695$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $jpgPw.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $jpgPw.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ??= metaProps.charset;
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $jpgPw.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $jpgPw.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: (0, $jGoV5.escapeHtml)(json)
                }
            });
        } catch  {
            return null;
        }
        return /* @__PURE__ */ $jpgPw.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $5f075e1e0ade2695$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
/**
* Tracks whether hydration is finished, so scripts can be skipped
* during client-side updates.
*/ let $5f075e1e0ade2695$var$isHydrated = false;
function $5f075e1e0ade2695$export$3be068dde909e563() {
    $5f075e1e0ade2695$var$isHydrated = true;
}
/**
* Renders the client runtime of your app. It should be rendered inside the
* [`<body>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/body)
*  of the document.
*
* If server rendering, you can omit `<Scripts/>` and the app will work as a
* traditional web app without JavaScript, relying solely on HTML and browser
* behaviors.
*
* @example
* import { Scripts } from "react-router";
*
* export default function Root() {
*   return (
*     <html>
*       <head />
*       <body>
*         <Scripts />
*       </body>
*     </html>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @param scriptProps Additional props to spread onto the [`<script>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/script)
* tags, such as [`crossOrigin`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLScriptElement/crossOrigin),
* [`nonce`](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Global_attributes/nonce),
* etc.
* @returns A collection of React elements for [`<script>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/script)
* tags
*/ function $5f075e1e0ade2695$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr, nonce: contextNonce } = $5f075e1e0ade2695$export$17134ff624fc6bc2();
    let { router: router, static: isStatic, staticContext: staticContext } = (0, $bdpx3.useDataRouterContext)("Scripts");
    let { matches: routerMatches } = (0, $bdpx3.useDataRouterState)("Scripts");
    let isRSCRouterContext = (0, $1e0kC.useIsRSCRouterContext)();
    let enableFogOfWar = (0, $2fbUC.isFogOfWarEnabled)(routeDiscovery, ssr);
    if (scriptProps.nonce == null && contextNonce) scriptProps = {
        ...scriptProps,
        nonce: contextNonce
    };
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $5f075e1e0ade2695$var$getActiveMatches(routerMatches, null, isSpaMode);
    $jpgPw.useEffect(()=>{
        $5f075e1e0ade2695$export$3be068dde909e563();
    }, []);
    let initialScripts = $jpgPw.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            (0, $daoDw.default)(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            return [
                chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n"),
                `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? `window.__reactRouterManifest = ${JSON.stringify((0, $2fbUC.getPartialManifest)(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $jpgPw.createElement($jpgPw.Fragment, null, /* @__PURE__ */ $jpgPw.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $jpgPw.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $5f075e1e0ade2695$var$isHydrated || isRSCRouterContext ? [] : [
        ...new Set(manifest.entry.imports.concat((0, $fwz2C.getModuleLinkHrefs)(matches, manifest, {
            includeHydrateFallback: true
        })))
    ];
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    (0, $e11Sy.warnOnce)(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $5f075e1e0ade2695$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $jpgPw.createElement($jpgPw.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $jpgPw.createElement("script", {
        ...scriptProps,
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $jpgPw.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $jpgPw.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $jpgPw.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            nonce: scriptProps.nonce,
            suppressHydrationWarning: true
        })), initialScripts);
}
function $5f075e1e0ade2695$export$c9058316764c140e(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}

});
parcelRegister("daoDw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $995f51cc9461cbb3$export$2e2bcd8739ae039; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/dom/ssr/invariant.ts
function $995f51cc9461cbb3$export$2e2bcd8739ae039(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}

});

parcelRegister("fwz2C", function(module, exports) {

$parcel$export(module.exports, "getKeyedLinksForMatches", function () { return $b4d506a715cd3d67$export$c43eb07eab2c950a; });
$parcel$export(module.exports, "getModuleLinkHrefs", function () { return $b4d506a715cd3d67$export$442b9e023f41af00; });
$parcel$export(module.exports, "prefetchRouteCss", function () { return $b4d506a715cd3d67$export$2ee8f5601ba37b41; });
$parcel$export(module.exports, "prefetchStyleLinks", function () { return $b4d506a715cd3d67$export$26f28bc6dfd6cfc6; });
$parcel$export(module.exports, "isPageLinkDescriptor", function () { return $b4d506a715cd3d67$export$aea1aca0de10baae; });
$parcel$export(module.exports, "getKeyedPrefetchLinks", function () { return $b4d506a715cd3d67$export$98f31d7a23772264; });
$parcel$export(module.exports, "getNewMatchesForLinks", function () { return $b4d506a715cd3d67$export$4af547f9516933c; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $2lFqh = parcelRequire("2lFqh");
//#region lib/dom/ssr/links.ts
/**
* Gets all the links for a set of matches. The modules are assumed to have been
* loaded already.
*/ function $b4d506a715cd3d67$export$c43eb07eab2c950a(matches, routeModules, manifest) {
    return $b4d506a715cd3d67$var$dedupeLinkDescriptors(matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2), $b4d506a715cd3d67$export$442b9e023f41af00(matches, manifest));
}
function $b4d506a715cd3d67$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $b4d506a715cd3d67$export$2ee8f5601ba37b41(route) {
    if (!route.css) return;
    let descriptors = $b4d506a715cd3d67$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($b4d506a715cd3d67$var$prefetchStyleLink));
}
async function $b4d506a715cd3d67$export$26f28bc6dfd6cfc6(route, routeModule) {
    if (!route.css && !routeModule.links || !$b4d506a715cd3d67$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$b4d506a715cd3d67$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$b4d506a715cd3d67$export$aea1aca0de10baae(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($b4d506a715cd3d67$var$prefetchStyleLink));
}
async function $b4d506a715cd3d67$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $b4d506a715cd3d67$export$aea1aca0de10baae(object) {
    return object != null && typeof object.page === "string";
}
function $b4d506a715cd3d67$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $b4d506a715cd3d67$export$98f31d7a23772264(matches, manifest, routeModules) {
    return $b4d506a715cd3d67$var$dedupeLinkDescriptors((await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await (0, $2lFqh.loadRouteModule)(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }))).flat(1).filter($b4d506a715cd3d67$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $b4d506a715cd3d67$export$4af547f9516933c(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return currentMatches[index].pathname !== match.pathname || currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"];
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $b4d506a715cd3d67$export$442b9e023f41af00(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $b4d506a715cd3d67$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $b4d506a715cd3d67$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $b4d506a715cd3d67$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $b4d506a715cd3d67$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        if (preloads && !$b4d506a715cd3d67$export$aea1aca0de10baae(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href)) return deduped;
        let key = JSON.stringify($b4d506a715cd3d67$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
let $b4d506a715cd3d67$var$_isPreloadSupported;
function $b4d506a715cd3d67$var$isPreloadSupported() {
    if ($b4d506a715cd3d67$var$_isPreloadSupported !== void 0) return $b4d506a715cd3d67$var$_isPreloadSupported;
    let el = document.createElement("link");
    $b4d506a715cd3d67$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $b4d506a715cd3d67$var$_isPreloadSupported;
}

});
parcelRegister("2lFqh", function(module, exports) {

$parcel$export(module.exports, "loadRouteModule", function () { return $1b5daca8329f7086$export$d9c4a4e8105733a6; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/dom/ssr/routeModules.ts
var $1b5daca8329f7086$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/production/lib/dom/ssr/routeModules.js"
});
async function $1b5daca8329f7086$export$d9c4a4e8105733a6(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && $1b5daca8329f7086$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}

});


parcelRegister("5wi0a", function(module, exports) {

$parcel$export(module.exports, "singleFetchUrl", function () { return $404de7b0cb3d70c9$export$7b977381851b2c; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $jcvU7 = parcelRequire("jcvU7");

var $e1hMf = parcelRequire("e1hMf");

var $daoDw = parcelRequire("daoDw");

var $jGoV5 = parcelRequire("jGoV5");

var $i1zFF = parcelRequire("i1zFF");

var $fuZ3b = parcelRequire("fuZ3b");

var $jpgPw = parcelRequire("jpgPw");
//#region lib/dom/ssr/single-fetch.tsx
const $404de7b0cb3d70c9$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $404de7b0cb3d70c9$var$SingleFetchNoResultError = class extends Error {
};
const $404de7b0cb3d70c9$export$e35ccdcde387134d = new Set([
    100,
    101,
    204,
    205
]);
function $404de7b0cb3d70c9$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $jpgPw.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${(0, $jGoV5.escapeHtml)(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $jpgPw.createElement($jpgPw.Fragment, null, scriptTag, /* @__PURE__ */ $jpgPw.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $jpgPw.createElement($jpgPw.Fragment, null, scriptTag, /* @__PURE__ */ $jpgPw.createElement($jpgPw.Suspense, null, /* @__PURE__ */ $jpgPw.createElement($404de7b0cb3d70c9$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $404de7b0cb3d70c9$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, fetchImplementation = (request)=>fetch(request), isApiOnly = false, serverOrigin, isSpaMode = false) {
    let dataStrategy = $404de7b0cb3d70c9$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        (0, $daoDw.default)(manifestRoute, "Route not found in manifest");
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader
        };
    }, $404de7b0cb3d70c9$var$fetchAndDecodeViaTurboStream(fetchImplementation, serverOrigin), ssr, void 0, isApiOnly, isSpaMode);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $404de7b0cb3d70c9$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, shouldAllowOptOut = ()=>true, isApiOnly = false, isSpaMode = false) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $404de7b0cb3d70c9$var$singleFetchActionStrategy(args, fetchAndDecode);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $404de7b0cb3d70c9$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode);
        if (fetcherKey) return $404de7b0cb3d70c9$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode);
        return $404de7b0cb3d70c9$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, shouldAllowOptOut, isApiOnly, isSpaMode);
    };
}
async function $404de7b0cb3d70c9$var$singleFetchActionStrategy(args, fetchAndDecode) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    (0, $daoDw.default)(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        return await handler(async ()=>{
            let { data: data, status: status } = await fetchAndDecode(args, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $404de7b0cb3d70c9$var$unwrapSingleFetchResult(data, actionMatch.route.id);
        });
    });
    if ((0, $e1hMf.isResponse)(result.result) || (0, $jcvU7.isRouteErrorResponse)(result.result) || (0, $e1hMf.isDataWithResponseInit)(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: (0, $jcvU7.data)(result.result, actionStatus)
        }
    };
}
async function $404de7b0cb3d70c9$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map(async (m)=>{
        let routeId = m.route.id;
        results[routeId] = await m.resolve(async (handler)=>{
            let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return hasClientLoader ? handler(async ()=>{
                let { data: data } = await fetchAndDecode(args, [
                    routeId
                ]);
                return $404de7b0cb3d70c9$var$unwrapSingleFetchResult(data, routeId);
            }) : handler();
        });
    }));
    return results;
}
async function $404de7b0cb3d70c9$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, shouldAllowOptOut = ()=>true, isApiOnly = false, isSpaMode = false) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$404de7b0cb3d70c9$var$createDeferred());
    let singleFetchDfd = $404de7b0cb3d70c9$var$createDeferred();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            if (!m.shouldCallHandler(defaultShouldRevalidate)) {
                foundOptOutRoute ||= m.shouldRevalidateArgs != null && hasLoader;
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    results[routeId] = {
                        type: "data",
                        result: await handler(async ()=>{
                            let { data: data } = await fetchAndDecode(args, [
                                routeId
                            ]);
                            return $404de7b0cb3d70c9$var$unwrapSingleFetchResult(data, routeId);
                        })
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                results[routeId] = {
                    type: "data",
                    result: await handler(async ()=>{
                        return $404de7b0cb3d70c9$var$unwrapSingleFetchResult(await singleFetchDfd.promise, routeId);
                    })
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    if ((!router.state.initialized && router.state.navigation.state === "idle" && !isApiOnly && !isSpaMode || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data = await fetchAndDecode(args, targetRoutes);
            singleFetchDfd.resolve(data.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $404de7b0cb3d70c9$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $404de7b0cb3d70c9$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $404de7b0cb3d70c9$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch  {}
}
async function $404de7b0cb3d70c9$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    (0, $daoDw.default)(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data } = await fetchAndDecode(args, [
                routeId
            ]);
            return $404de7b0cb3d70c9$var$unwrapSingleFetchResult(data, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $404de7b0cb3d70c9$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $404de7b0cb3d70c9$export$7b977381851b2c(reqUrl, extension, serverOrigin) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, serverOrigin ?? (typeof window === "undefined" ? "server://singlefetch/" : window.location.origin)) : new URL(reqUrl);
    if (serverOrigin && url.origin !== serverOrigin) url = new URL(url.pathname + url.search + url.hash, serverOrigin);
    if (url.pathname.endsWith("/")) url.pathname = `${url.pathname}_.${extension}`;
    else url.pathname = `${url.pathname}.${extension}`;
    return url;
}
function $404de7b0cb3d70c9$var$fetchAndDecodeViaTurboStream(fetchImplementation, serverOrigin) {
    return async (args, targetRoutes)=>{
        let { request: request } = args;
        let url = $404de7b0cb3d70c9$export$7b977381851b2c(request.url, "data", serverOrigin);
        if (request.method === "GET") {
            url = $404de7b0cb3d70c9$export$425969b7f98e2c9c(url);
            if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
        }
        let req = new Request(url, await (0, $fuZ3b.createRequestInit)(request));
        (0, $daoDw.default)(args.unstable_initiator !== "static", "Static data strategy initiator used for a client data request");
        let fetchContext;
        if (args.unstable_initiator === "navigation") {
            (0, $daoDw.default)(args.unstable_navigationType !== null, "Missing navigation type for a navigation data request");
            fetchContext = {
                type: "navigation",
                fetcherKey: args.fetcherKey,
                navigationType: args.unstable_navigationType
            };
        } else fetchContext = {
            type: args.unstable_initiator,
            fetcherKey: args.fetcherKey,
            navigationType: null
        };
        let res = await fetchImplementation(req, fetchContext);
        if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new (0, $jcvU7.ErrorResponseImpl)(res.status, res.statusText, await res.text());
        if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
            status: 202,
            data: {
                redirect: {
                    redirect: res.headers.get("X-Remix-Redirect"),
                    status: Number(res.headers.get("X-Remix-Status") || "302"),
                    revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                    reload: res.headers.get("X-Remix-Reload-Document") === "true",
                    replace: res.headers.get("X-Remix-Replace") === "true"
                }
            }
        };
        if ($404de7b0cb3d70c9$export$e35ccdcde387134d.has(res.status)) {
            let routes = {};
            if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
                data: void 0
            };
            return {
                status: res.status,
                data: {
                    routes: routes
                }
            };
        }
        (0, $daoDw.default)(res.body, "No response body to decode");
        try {
            let decoded = await $404de7b0cb3d70c9$export$4023ad4ecd4126a2(res.body, window);
            let data;
            if (request.method === "GET") {
                let typed = decoded.value;
                if ($404de7b0cb3d70c9$export$60644022b8b46aaa in typed) data = {
                    redirect: typed[$404de7b0cb3d70c9$export$60644022b8b46aaa]
                };
                else data = {
                    routes: typed
                };
            } else {
                let typed = decoded.value;
                let routeId = targetRoutes?.[0];
                (0, $daoDw.default)(routeId, "No routeId found for single fetch call decoding");
                if ("redirect" in typed) data = {
                    redirect: typed
                };
                else data = {
                    routes: {
                        [routeId]: typed
                    }
                };
            }
            return {
                status: res.status,
                data: data
            };
        } catch (cause) {
            throw new Error("Unable to decode turbo-stream response", {
                cause: cause
            });
        }
    };
}
function $404de7b0cb3d70c9$export$4023ad4ecd4126a2(body, global) {
    return (0, $i1zFF.decode)(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && (0, $jcvU7.SUPPORTED_ERROR_TYPES).includes(name) && name in global && typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data, status, statusText] = rest;
                    return {
                        value: new (0, $jcvU7.ErrorResponseImpl)(status, statusText, data)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$404de7b0cb3d70c9$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $404de7b0cb3d70c9$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace, status: status } = result.redirect;
        throw (0, $jcvU7.redirect)(location, {
            status: status,
            headers: {
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $404de7b0cb3d70c9$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $404de7b0cb3d70c9$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch  {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch  {}
        };
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
}

});
parcelRegister("i1zFF", function(module, exports) {

$parcel$export(module.exports, "decode", function () { return $d1f3fd848f7fb186$export$2f872c0f2117be69; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

var $5e4ay = parcelRequire("5e4ay");

var $fb32I = parcelRequire("fb32I");

var $2dZSk = parcelRequire("2dZSk");
//#region vendor/turbo-stream-v2/turbo-stream.ts
async function $d1f3fd848f7fb186$export$2f872c0f2117be69(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new (0, $5e4ay.Deferred)();
    const reader = readable.pipeThrough((0, $5e4ay.createLineSplittingTransform)()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $d1f3fd848f7fb186$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $d1f3fd848f7fb186$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $d1f3fd848f7fb186$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch  {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: (0, $2dZSk.unflatten).call(this, line)
    };
}
async function $d1f3fd848f7fb186$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case "P":
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch  {
                        throw new SyntaxError();
                    }
                    const value = (0, $2dZSk.unflatten).call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case "E":
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch  {
                        throw new SyntaxError();
                    }
                    const value = (0, $2dZSk.unflatten).call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $d1f3fd848f7fb186$export$c564cdbbe6da493(input, options) {
    const { onComplete: onComplete, plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    return new ReadableStream({
        async start (controller) {
            const id = await (0, $fb32I.flatten).call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}\n`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]\n`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            let processingChain = Promise.resolve();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || /* @__PURE__ */ new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            processingChain = processingChain.then(async ()=>{
                                const id = await (0, $fb32I.flatten).call(encoder, resolved);
                                if (Array.isArray(id)) {
                                    controller.enqueue(textEncoder.encode(`P${deferredId}:[["Z",${id[0]}]]\n`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id < 0) controller.enqueue(textEncoder.encode(`P${deferredId}:${id}\n`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`P${deferredId}:[${values}]\n`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }, (reason)=>{
                            processingChain = processingChain.then(async ()=>{
                                if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = /* @__PURE__ */ new Error("An unknown error occurred");
                                const id = await (0, $fb32I.flatten).call(encoder, reason);
                                if (Array.isArray(id)) {
                                    controller.enqueue(textEncoder.encode(`E${deferredId}:[["Z",${id[0]}]]\n`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id < 0) controller.enqueue(textEncoder.encode(`E${deferredId}:${id}\n`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`E${deferredId}:[${values}]\n`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            await processingChain;
            controller.close();
            onComplete?.();
        }
    });
}

});
parcelRegister("5e4ay", function(module, exports) {

$parcel$export(module.exports, "Deferred", function () { return $3ce17e791f3af133$export$85f6557964517f1a; });
$parcel$export(module.exports, "createLineSplittingTransform", function () { return $3ce17e791f3af133$export$4786a9f20844482d; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region vendor/turbo-stream-v2/utils.ts
var $3ce17e791f3af133$export$85f6557964517f1a = class {
    promise;
    resolve;
    reject;
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $3ce17e791f3af133$export$4786a9f20844482d() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}

});

parcelRegister("fb32I", function(module, exports) {

$parcel$export(module.exports, "flatten", function () { return $b0ca3e553595fcbb$export$bffa455ba8c619a6; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region vendor/turbo-stream-v2/flatten.ts
const $b0ca3e553595fcbb$var$TIME_LIMIT_MS = 1;
const $b0ca3e553595fcbb$var$getNow = ()=>Date.now();
const $b0ca3e553595fcbb$var$yieldToMain = ()=>new Promise((resolve)=>setTimeout(resolve, 0));
async function $b0ca3e553595fcbb$export$bffa455ba8c619a6(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return -7;
    if (input === null) return -5;
    if (Number.isNaN(input)) return -2;
    if (input === Number.POSITIVE_INFINITY) return -6;
    if (input === Number.NEGATIVE_INFINITY) return -3;
    if (input === 0 && 1 / input < 0) return -4;
    const index = this.index++;
    indices.set(input, index);
    const stack = [
        [
            input,
            index
        ]
    ];
    await $b0ca3e553595fcbb$var$stringify.call(this, stack);
    return index;
}
async function $b0ca3e553595fcbb$var$stringify(stack) {
    const { deferred: deferred, indices: indices, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    let lastYieldTime = $b0ca3e553595fcbb$var$getNow();
    const flattenValue = (value)=>{
        const existing = indices.get(value);
        if (existing) return [
            existing
        ];
        if (value === void 0) return -7;
        if (value === null) return -5;
        if (Number.isNaN(value)) return -2;
        if (value === Number.POSITIVE_INFINITY) return -6;
        if (value === Number.NEGATIVE_INFINITY) return -3;
        if (value === 0 && 1 / value < 0) return -4;
        const index = this.index++;
        indices.set(value, index);
        stack.push([
            value,
            index
        ]);
        return index;
    };
    let i = 0;
    while(stack.length > 0){
        const now = $b0ca3e553595fcbb$var$getNow();
        if (++i % 6e3 === 0 && now - lastYieldTime >= $b0ca3e553595fcbb$var$TIME_LIMIT_MS) {
            await $b0ca3e553595fcbb$var$yieldToMain();
            lastYieldTime = $b0ca3e553595fcbb$var$getNow();
        }
        const [input, index] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${flattenValue(k)}":${flattenValue(obj[k])}`).join(",");
        let error = null;
        switch(typeof input){
            case "boolean":
            case "number":
            case "string":
                str[index] = JSON.stringify(input);
                break;
            case "bigint":
                str[index] = `["B","${input}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input);
                    if (!keyFor) error = /* @__PURE__ */ new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index] = `["Y",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input) {
                        str[index] = `-5`;
                        break;
                    }
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i = 0; i < input.length; i++)result += (i ? "," : "") + (i in input ? flattenValue(input[i]) : -1);
                            str[index] = `${result}]`;
                        } else if (input instanceof Date) {
                            const dateTime = input.getTime();
                            str[index] = `["D",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input instanceof URL) str[index] = `["U",${JSON.stringify(input.href)}]`;
                        else if (input instanceof RegExp) str[index] = `["R",${JSON.stringify(input.source)},${JSON.stringify(input.flags)}]`;
                        else if (input instanceof Set) {
                            if (input.size > 0) str[index] = `["S",${[
                                ...input
                            ].map((val)=>flattenValue(val)).join(",")}]`;
                            else str[index] = `["S"]`;
                        } else if (input instanceof Map) {
                            if (input.size > 0) str[index] = `["M",${[
                                ...input
                            ].flatMap(([k, v])=>[
                                    flattenValue(k),
                                    flattenValue(v)
                                ]).join(",")}]`;
                            else str[index] = `["M"]`;
                        } else if (input instanceof Promise) {
                            str[index] = `["P",${index}]`;
                            deferred[index] = input;
                        } else if (input instanceof Error) {
                            str[index] = `["E",${JSON.stringify(input.message)}`;
                            if (input.name !== "Error") str[index] += `,${JSON.stringify(input.name)}`;
                            str[index] += "]";
                        } else if (Object.getPrototypeOf(input) === null) str[index] = `["N",{${partsForObj(input)}}]`;
                        else if ($b0ca3e553595fcbb$var$isPlainObject(input)) str[index] = `{${partsForObj(input)}}`;
                        else error = /* @__PURE__ */ new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = /* @__PURE__ */ new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                    str[index] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
const $b0ca3e553595fcbb$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $b0ca3e553595fcbb$var$isPlainObject(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $b0ca3e553595fcbb$var$objectProtoNames;
}

});

parcelRegister("2dZSk", function(module, exports) {

$parcel$export(module.exports, "unflatten", function () { return $19eccace6e445c1d$export$4315a2af848d75d7; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $jcvU7 = parcelRequire("jcvU7");

var $5e4ay = parcelRequire("5e4ay");
//#region vendor/turbo-stream-v2/unflatten.ts
const $19eccace6e445c1d$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $19eccace6e445c1d$export$4315a2af848d75d7(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $19eccace6e445c1d$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $19eccace6e445c1d$var$hydrate.call(this, startIndex);
}
function $19eccace6e445c1d$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index, set] = stack.pop();
        switch(index){
            case -7:
                set(void 0);
                continue;
            case -5:
                set(null);
                continue;
            case -2:
                set(NaN);
                continue;
            case -6:
                set(Infinity);
                continue;
            case -3:
                set(-Infinity);
                continue;
            case -4:
                set(-0);
                continue;
        }
        $19eccace6e445c1d$var$validateIndex(index, values.length);
        if (hydrated[index]) {
            set(hydrated[index]);
            continue;
        }
        const value = values[index];
        if (!value || typeof value !== "object") {
            hydrated[index] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case "D":
                        set(hydrated[index] = new Date(b));
                        continue;
                    case "U":
                        set(hydrated[index] = new URL(b));
                        continue;
                    case "B":
                        set(hydrated[index] = BigInt(b));
                        continue;
                    case "R":
                        set(hydrated[index] = new RegExp(b, c));
                        continue;
                    case "Y":
                        set(hydrated[index] = Symbol.for(b));
                        continue;
                    case "S":
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case "M":
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case "N":
                        const obj = Object.create(null);
                        hydrated[index] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case "P":
                        $19eccace6e445c1d$var$validateIndex(b, values.length);
                        if (hydrated[b]) set(hydrated[index] = hydrated[b]);
                        else {
                            const d = new (0, $5e4ay.Deferred)();
                            const promise = d.promise;
                            promise.status = "pending";
                            promise.then((value)=>{
                                promise.status = "fulfilled";
                                promise.value = value;
                            }, (reason)=>{
                                promise.status = "rejected";
                                promise.reason = reason;
                            });
                            deferred[b] = d;
                            set(hydrated[index] = promise);
                        }
                        continue;
                    case "E":
                        const [, message, errorType] = value;
                        let error = errorType && $19eccace6e445c1d$var$globalObj && (0, $jcvU7.SUPPORTED_ERROR_TYPES).includes(errorType) && errorType in $19eccace6e445c1d$var$globalObj && typeof $19eccace6e445c1d$var$globalObj[errorType] === "function" ? new $19eccace6e445c1d$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index] = error;
                        set(error);
                        continue;
                    case "Z":
                        $19eccace6e445c1d$var$validateIndex(b, values.length);
                        set(hydrated[index] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v)=>{
                                        r[i] = v;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result = plugin(value[0], ...r);
                                    if (result) {
                                        set(hydrated[index] = result.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== -1) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    Object.defineProperty(object, r[0], {
                        value: r[1],
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
function $19eccace6e445c1d$var$validateIndex(index, length) {
    if (!Number.isSafeInteger(index) || index < 0 || index >= length) throw new SyntaxError();
}

});


parcelRegister("fuZ3b", function(module, exports) {

$parcel$export(module.exports, "createRequestInit", function () { return $b48903aceb7a0cb2$export$a30aa2a0fce6c468; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/dom/ssr/data.ts
async function $b48903aceb7a0cb2$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}

});


parcelRegister("e11Sy", function(module, exports) {

$parcel$export(module.exports, "warnOnce", function () { return $a3429dc7b20a569c$export$5b28268982f175ba; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/server-runtime/warnings.ts
const $a3429dc7b20a569c$var$alreadyWarned = {};
function $a3429dc7b20a569c$export$5b28268982f175ba(condition, message) {
    if (!condition && !$a3429dc7b20a569c$var$alreadyWarned[message]) {
        $a3429dc7b20a569c$var$alreadyWarned[message] = true;
        console.warn(message);
    }
}

});

parcelRegister("2fbUC", function(module, exports) {

$parcel$export(module.exports, "isFogOfWarEnabled", function () { return $1a2638fdfecd7a48$export$741d98b28dbfd; });
$parcel$export(module.exports, "getPartialManifest", function () { return $1a2638fdfecd7a48$export$ae5150779dbcc11a; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $aDbDg = parcelRequire("aDbDg");

var $jcvU7 = parcelRequire("jcvU7");

var $kdAzH = parcelRequire("kdAzH");

var $jpgPw = parcelRequire("jpgPw");
//#region lib/dom/ssr/fog-of-war.ts
const $1a2638fdfecd7a48$var$nextPaths = /* @__PURE__ */ new Set();
const $1a2638fdfecd7a48$var$discoveredPathsMaxSize = 1e3;
const $1a2638fdfecd7a48$var$discoveredPaths = /* @__PURE__ */ new Set();
const $1a2638fdfecd7a48$export$b5915cf27fa06b9f = 7680;
function $1a2638fdfecd7a48$export$791cac19ae57137a(paths) {
    let result = /* @__PURE__ */ new Set();
    paths.forEach((path)=>{
        if (!path.startsWith("/")) path = `/${path}`;
        for(let i = 1; i < path.length; i++)if (path[i] === "/") result.add(path.slice(0, i));
        result.add(path);
    });
    return Array.from(result);
}
function $1a2638fdfecd7a48$export$741d98b28dbfd(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr;
}
const $1a2638fdfecd7a48$var$MANIFEST_MATCH_COST_LIMIT = 5e4;
const $1a2638fdfecd7a48$var$MANIFEST_MATCH_COST_SEGMENT_THRESHOLD = 10;
function $1a2638fdfecd7a48$export$6b125d9215e726d(pathname, matchCost = 0) {
    let segmentCount = pathname.split("/").length - 1;
    return Math.max(segmentCount - 1, 0) * pathname.length + 1 > 7680 || segmentCount > $1a2638fdfecd7a48$var$MANIFEST_MATCH_COST_SEGMENT_THRESHOLD && segmentCount * matchCost > $1a2638fdfecd7a48$var$MANIFEST_MATCH_COST_LIMIT;
}
function $1a2638fdfecd7a48$export$ae5150779dbcc11a({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = router.match(path);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $1a2638fdfecd7a48$export$72ab377a1030deb9(getRouter, manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename, fetchImplementation = (request)=>fetch(request), serverOrigin, isApiOnly = false) {
    if (!$1a2638fdfecd7a48$export$741d98b28dbfd(routeDiscovery, ssr)) return;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($1a2638fdfecd7a48$var$discoveredPaths.has(path)) return;
        let { state: state } = getRouter();
        await $1a2638fdfecd7a48$var$fetchAndApplyManifestPatches([
            path
        ], fetcherKey ? window.location.href : (0, $aDbDg.createPath)(state.navigation.location || state.location), manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal, fetchImplementation, serverOrigin, isApiOnly);
    };
}
function $1a2638fdfecd7a48$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode, fetchImplementation = (request)=>fetch(request), serverOrigin, isApiOnly = false) {
    $jpgPw.useEffect(()=>{
        if (!$1a2638fdfecd7a48$export$741d98b28dbfd(routeDiscovery, ssr) || window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$1a2638fdfecd7a48$var$discoveredPaths.has(pathname)) $1a2638fdfecd7a48$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($1a2638fdfecd7a48$var$nextPaths.keys()).filter((path)=>{
                if ($1a2638fdfecd7a48$var$discoveredPaths.has(path)) {
                    $1a2638fdfecd7a48$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $1a2638fdfecd7a48$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes, void 0, fetchImplementation, serverOrigin, isApiOnly);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $1a2638fdfecd7a48$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery,
        fetchImplementation,
        serverOrigin,
        isApiOnly
    ]);
}
function $1a2638fdfecd7a48$export$251abd15fde24921(paths) {
    return paths.slice().sort().map((path)=>path.replace(/,/g, "%2C")).join(",");
}
function $1a2638fdfecd7a48$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    return basename == null ? manifestPath : (0, $jcvU7.joinPaths)([
        basename,
        manifestPath
    ]);
}
const $1a2638fdfecd7a48$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
const $1a2638fdfecd7a48$var$MANIFEST_RELOAD_TIMEOUT = 5e3;
let $1a2638fdfecd7a48$var$pendingManifestReload;
async function $1a2638fdfecd7a48$export$2f7ce2790dc2d211(needsReload, version, errorReloadPath) {
    if ($1a2638fdfecd7a48$var$pendingManifestReload) return $1a2638fdfecd7a48$var$pendingManifestReload;
    if (!needsReload) {
        try {
            sessionStorage.removeItem($1a2638fdfecd7a48$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        return false;
    }
    if (!errorReloadPath) {
        console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
        return true;
    }
    let alreadyReloaded = false;
    try {
        alreadyReloaded = sessionStorage.getItem($1a2638fdfecd7a48$var$MANIFEST_VERSION_STORAGE_KEY) === version;
        if (!alreadyReloaded) sessionStorage.setItem($1a2638fdfecd7a48$var$MANIFEST_VERSION_STORAGE_KEY, version);
    } catch  {}
    if (alreadyReloaded) throw new Error("Unable to discover routes due to manifest version mismatch.");
    let rejectReload;
    let reloadPromise = new Promise((_, reject)=>{
        rejectReload = reject;
    });
    $1a2638fdfecd7a48$var$pendingManifestReload = reloadPromise;
    let failReload = ()=>{
        clearTimeout(timeout);
        window.removeEventListener("pageshow", onPageShow);
        $1a2638fdfecd7a48$var$pendingManifestReload = void 0;
        rejectReload(/* @__PURE__ */ new Error("Unable to discover routes due to manifest version mismatch."));
    };
    let timeout = setTimeout(failReload, $1a2638fdfecd7a48$var$MANIFEST_RELOAD_TIMEOUT);
    let onPageShow = (event)=>{
        if (event.persisted) failReload();
    };
    window.addEventListener("pageshow", onPageShow);
    try {
        window.location.href = errorReloadPath;
        console.warn("Detected manifest version mismatch, reloading...");
    } catch  {
        failReload();
    }
    return reloadPromise;
}
async function $1a2638fdfecd7a48$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal, fetchImplementation = (request)=>fetch(request), serverOrigin, isApiOnly = false) {
    paths = $1a2638fdfecd7a48$export$791cac19ae57137a(paths);
    const searchParams = new URLSearchParams();
    searchParams.set("paths", $1a2638fdfecd7a48$export$251abd15fde24921(paths));
    searchParams.set("version", manifest.version);
    let url = new URL($1a2638fdfecd7a48$export$bcb79c3deff01d56(manifestPath, basename), serverOrigin ?? window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > 7680) {
        $1a2638fdfecd7a48$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetchImplementation(new Request(url, {
            signal: signal
        }), {
            type: "manifest"
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        if (await $1a2638fdfecd7a48$export$2f7ce2790dc2d211(res.status === 204 && res.headers.has("X-Remix-Reload-Document"), manifest.version, errorReloadPath)) return;
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    if (signal?.aborted) return;
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$1a2638fdfecd7a48$var$addToFifoQueue(p, $1a2638fdfecd7a48$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, (0, $kdAzH.createClientRoutes)(patches, routeModules, null, ssr, isSpaMode, parentId, void 0, void 0, isApiOnly)));
}
function $1a2638fdfecd7a48$var$addToFifoQueue(path, queue) {
    if (queue.size >= $1a2638fdfecd7a48$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        if (first !== void 0) queue.delete(first);
    }
    queue.add(path);
}
function $1a2638fdfecd7a48$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}

});
parcelRegister("kdAzH", function(module, exports) {

$parcel$export(module.exports, "createClientRoutes", function () { return $eb816484c17df131$export$af76e85f27ba0229; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $jcvU7 = parcelRequire("jcvU7");

var $bdpx3 = parcelRequire("bdpx3");

var $daoDw = parcelRequire("daoDw");

var $2lFqh = parcelRequire("2lFqh");

var $fwz2C = parcelRequire("fwz2C");

var $gjMdx = parcelRequire("gjMdx");

var $idwJA = parcelRequire("idwJA");

var $jpgPw = parcelRequire("jpgPw");
//#region lib/dom/ssr/routes.tsx
function $eb816484c17df131$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $eb816484c17df131$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component = $eb816484c17df131$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? (0, $idwJA.RemixRootDefaultHydrateFallback) : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $jpgPw.createElement((0, $gjMdx.RemixRootDefaultErrorBoundary), {
            error: (0, $bdpx3.useRouteError)()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component ? {
            element: /* @__PURE__ */ $jpgPw.createElement(routeModule.Layout, null, /* @__PURE__ */ $jpgPw.createElement(Component, null))
        } : {
            Component: Component
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $jpgPw.createElement(routeModule.Layout, null, /* @__PURE__ */ $jpgPw.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $jpgPw.createElement(routeModule.Layout, null, /* @__PURE__ */ $jpgPw.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $eb816484c17df131$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $eb816484c17df131$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        (0, $daoDw.default)(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$eb816484c17df131$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $eb816484c17df131$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $eb816484c17df131$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $eb816484c17df131$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $eb816484c17df131$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $eb816484c17df131$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let msg = `You are trying to call ${type === "action" ? "serverAction()" : "serverLoader()"} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new (0, $jcvU7.ErrorResponseImpl)(400, "Bad Request", new Error(msg), true);
    }
}
function $eb816484c17df131$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new (0, $jcvU7.ErrorResponseImpl)(405, "Method Not Allowed", new Error(msg), true);
}
function $eb816484c17df131$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $eb816484c17df131$var$groupRoutesByParentId(manifest), needsRevalidation, isApiOnly = false) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            (0, $daoDw.default)(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $eb816484c17df131$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route) {
            if (route.clientActionModule) prefetchModule(route.clientActionModule);
            if (route.clientLoaderModule) prefetchModule(route.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? (0, $fwz2C.prefetchStyleLinks)(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$eb816484c17df131$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $eb816484c17df131$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                let _isHydrationRequest = isHydrationRequest;
                isHydrationRequest = false;
                return await prefetchStylesAndCallHandler(async ()=>{
                    (0, $daoDw.default)(routeModule, "No `routeModule` available for critical-route loader");
                    if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                    return routeModule.clientLoader({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverLoader () {
                            $eb816484c17df131$var$preventInvalidServerHandlerCall("loader", route);
                            if (_isHydrationRequest) {
                                if (hasInitialData) return initialData;
                                if (hasInitialError) throw initialError;
                            }
                            return fetchServerLoader(singleFetch);
                        }
                    });
                });
            };
            dataRoute.loader.hydrate = $eb816484c17df131$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode, isApiOnly);
            dataRoute.action = ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    (0, $daoDw.default)(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode && !isApiOnly) throw $eb816484c17df131$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverAction () {
                            $eb816484c17df131$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode && !isApiOnly) throw $eb816484c17df131$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $eb816484c17df131$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    (0, $daoDw.default)(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $eb816484c17df131$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    (0, $daoDw.default)(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $eb816484c17df131$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    (0, $daoDw.default)(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $eb816484c17df131$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $eb816484c17df131$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation, isApiOnly);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $eb816484c17df131$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $eb816484c17df131$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? (0, $jcvU7.compilePath)(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $eb816484c17df131$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $eb816484c17df131$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = (0, $2lFqh.loadRouteModule)(route, routeModules);
    let prefetchRouteCssPromise = (0, $fwz2C.prefetchRouteCss)(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        (0, $fwz2C.prefetchStyleLinks)(route, routeModule)
    ]);
    return {
        Component: $eb816484c17df131$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $eb816484c17df131$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    if (!(typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0)) return routeModule.default;
}
function $eb816484c17df131$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode, isApiOnly = false) {
    return isSpaMode && routeId !== "root" || isApiOnly && isSpaMode && hasLoader || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}

});
parcelRegister("gjMdx", function(module, exports) {

$parcel$export(module.exports, "RemixRootDefaultErrorBoundary", function () { return $be13d2ac97a6a75a$export$20b33acd14692c9; });
$parcel$export(module.exports, "BoundaryShell", function () { return $be13d2ac97a6a75a$export$cf8626ebc6a4ba63; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $jcvU7 = parcelRequire("jcvU7");

var $89PPr = parcelRequire("89PPr");

var $jpgPw = parcelRequire("jpgPw");
//#region lib/dom/ssr/errorBoundaries.tsx
var $be13d2ac97a6a75a$export$32e57f52df4b6e34 = class extends $jpgPw.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $jpgPw.createElement($be13d2ac97a6a75a$export$20b33acd14692c9, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
/**
* When app's don't provide a root level ErrorBoundary, we default to this.
*/ function $be13d2ac97a6a75a$export$20b33acd14692c9({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    let { nonce: nonce } = (0, $89PPr.useFrameworkContext)();
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $jpgPw.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ((0, $jcvU7.isRouteErrorResponse)(error)) return /* @__PURE__ */ $jpgPw.createElement($be13d2ac97a6a75a$export$cf8626ebc6a4ba63, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $jpgPw.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $jpgPw.createElement($be13d2ac97a6a75a$export$cf8626ebc6a4ba63, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $jpgPw.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $jpgPw.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $be13d2ac97a6a75a$export$cf8626ebc6a4ba63({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = (0, $89PPr.useFrameworkContext)();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $jpgPw.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $jpgPw.createElement("head", null, /* @__PURE__ */ $jpgPw.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $jpgPw.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $jpgPw.createElement("title", null, title)), /* @__PURE__ */ $jpgPw.createElement("body", null, /* @__PURE__ */ $jpgPw.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $jpgPw.createElement((0, $89PPr.Scripts), null) : null)));
}

});

parcelRegister("idwJA", function(module, exports) {

$parcel$export(module.exports, "RemixRootDefaultHydrateFallback", function () { return $d432d535e1c797e6$export$7e8143a7b6df36d9; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $gjMdx = parcelRequire("gjMdx");

var $89PPr = parcelRequire("89PPr");

var $jpgPw = parcelRequire("jpgPw");
//#region lib/dom/ssr/fallback.tsx
function $d432d535e1c797e6$export$7e8143a7b6df36d9() {
    let { nonce: nonce } = (0, $89PPr.useFrameworkContext)();
    return /* @__PURE__ */ $jpgPw.createElement((0, $gjMdx.BoundaryShell), {
        title: "Loading...",
        renderScripts: true
    }, null);
}

});




parcelRegister("lx2i2", function(module, exports) {

$parcel$export(module.exports, "hydrationRouteProperties", function () { return $face74c450701638$export$e2fd2c03906469db; });
$parcel$export(module.exports, "Router", function () { return $face74c450701638$export$55185c17a0fcbe46; });
$parcel$export(module.exports, "Navigate", function () { return $face74c450701638$export$444b3ab0cb9aec40; });
$parcel$export(module.exports, "Route", function () { return $face74c450701638$export$e7b0ac011bb776c6; });
$parcel$export(module.exports, "Routes", function () { return $face74c450701638$export$3565eb3d00ca5a74; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $aDbDg = parcelRequire("aDbDg");

var $jcvU7 = parcelRequire("jcvU7");

var $2gfKq = parcelRequire("2gfKq");

var $e1hMf = parcelRequire("e1hMf");

var $1e0kC = parcelRequire("1e0kC");

var $eCxNt = parcelRequire("eCxNt");

var $bdpx3 = parcelRequire("bdpx3");

var $e11Sy = parcelRequire("e11Sy");

var $89PPr = parcelRequire("89PPr");

var $jpgPw = parcelRequire("jpgPw");
//#region lib/components.tsx
const $face74c450701638$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
/**
* Create a new {@link DataRouter} that manages the application path using an
* in-memory [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* stack. Useful for non-browser environments without a DOM API.
*
* Data Routers should not be held in React state. You should create your router
* once outside of the React tree and pass it to {@link RouterProvider | `<RouterProvider>`}.
* You can use `patchRoutesOnNavigation` to add additional routes programmatically.
*
* @public
* @category Data Routers
* @mode data
* @param routes Application routes
* @param opts Options
* @param {MemoryRouterOpts.basename} opts.basename n/a
* @param {MemoryRouterOpts.dataStrategy} opts.dataStrategy n/a
* @param {MemoryRouterOpts.future} opts.future n/a
* @param {MemoryRouterOpts.getContext} opts.getContext n/a
* @param {MemoryRouterOpts.hydrationData} opts.hydrationData n/a
* @param {MemoryRouterOpts.initialEntries} opts.initialEntries n/a
* @param {MemoryRouterOpts.initialIndex} opts.initialIndex n/a
* @param {MemoryRouterOpts.instrumentations} opts.instrumentations n/a
* @param {MemoryRouterOpts.patchRoutesOnNavigation} opts.patchRoutesOnNavigation n/a
* @returns An initialized {@link DataRouter} to pass to {@link RouterProvider | `<RouterProvider>`}
*/ function $face74c450701638$export$f30f7e456d254e83(routes, opts) {
    return (0, $e1hMf.createRouter)({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: (0, $aDbDg.createMemoryHistory)({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        mapRouteProperties: (0, $jcvU7.defaultMapRouteProperties),
        hydrationRouteProperties: $face74c450701638$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        instrumentations: opts?.instrumentations
    }).initialize();
}
var $face74c450701638$var$Deferred = class {
    status = "pending";
    promise;
    resolve;
    reject;
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $face74c450701638$var$handleSkippedViewTransition(transition, document) {
    transition.ready.catch((reason)=>{
        if (!(document.visibilityState === "hidden" || typeof reason === "object" && reason !== null && "name" in reason && reason.name === "AbortError")) throw reason;
    });
}
/**
* Render the UI for the given {@link DataRouter}. This component should
* typically be at the top of an app's element tree. The router prop should
* be a single router instance created outside of the React tree. Avoid
* creating new routers during React renders/re-renders.
*
* ```tsx
* import { createBrowserRouter } from "react-router";
* import { RouterProvider } from "react-router/dom";
* import { createRoot } from "react-dom/client";
*
* const router = createBrowserRouter(routes);
* createRoot(document.getElementById("root")).render(
*   <RouterProvider router={router} />
* );
* ```
*
* <docs-info>Please note that this component is exported both from
* `react-router` and `react-router/dom` with the only difference being that the
* latter automatically wires up `react-dom`'s [`flushSync`](https://react.dev/reference/react-dom/flushSync)
* implementation. You _almost always_ want to use the version from
* `react-router/dom` unless you're running in a non-DOM environment.</docs-info>
*
*
* @public
* @category Data Routers
* @mode data
* @param props Props
* @param {RouterProviderProps.flushSync} props.flushSync n/a
* @param {RouterProviderProps.onError} props.onError n/a
* @param {RouterProviderProps.router} props.router n/a
* @param {RouterProviderProps.useTransitions} props.useTransitions n/a
* @returns React element for the rendered router
*/ function $face74c450701638$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, onError: onError, useTransitions: useTransitions }) {
    useTransitions = (0, $1e0kC.useIsRSCRouterContext)() || useTransitions;
    let [_state, setStateImpl] = $jpgPw.useState(router.state);
    let [state, setOptimisticState] = (0, $jpgPw.useOptimistic)(_state);
    let lastState = $jpgPw.useRef(state);
    let [pendingState, setPendingState] = $jpgPw.useState();
    let [vtContext, setVtContext] = $jpgPw.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $jpgPw.useState();
    let [transition, setTransition] = $jpgPw.useState();
    let [interruption, setInterruption] = $jpgPw.useState();
    let fetcherData = $jpgPw.useRef(/* @__PURE__ */ new Map());
    let handledErrors = $jpgPw.useRef(/* @__PURE__ */ new WeakSet());
    let setState = $jpgPw.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        lastState.current = newState;
        if (newErrors && newState.errors && (0, $e1hMf.clientErrors).has(newState.errors)) {
            if (handledErrors.current.has(newState.errors)) newErrors = null;
            else handledErrors.current.add(newState.errors);
        }
        if (newErrors && onError) Object.values(newErrors).forEach((error)=>onError(error, {
                location: newState.location,
                params: newState.matches[0]?.params ?? {},
                pattern: (0, $jcvU7.getRoutePattern)(newState.matches)
            }));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        (0, $e11Sy.warnOnce)(flushSync === false || reactDomFlushSyncImpl != null, "You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from \"react-router/dom\"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.");
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        (0, $e11Sy.warnOnce)(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (useTransitions === false) setStateImpl(newState);
            else $jpgPw.startTransition(()=>{
                if (useTransitions === true) setOptimisticState((s)=>$face74c450701638$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd?.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            $face74c450701638$var$handleSkippedViewTransition(t, router.window.document);
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd?.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        useTransitions,
        setOptimisticState,
        onError
    ]);
    $jpgPw.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $jpgPw.useLayoutEffect(()=>{
        let errors = router.state.errors;
        let newErrors = errors ? (0, $e1hMf.clientErrors).get(errors) : null;
        if (lastState.current !== router.state || errors && newErrors && !handledErrors.current.has(errors)) setState(router.state, {
            deletedFetchers: [],
            flushSync: false,
            newErrors: newErrors ?? null
        });
    }, [
        router,
        setState
    ]);
    $jpgPw.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $face74c450701638$var$Deferred());
    }, [
        vtContext
    ]);
    $jpgPw.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                if (useTransitions === false) setStateImpl(newState);
                else $jpgPw.startTransition(()=>{
                    if (useTransitions === true) setOptimisticState((s)=>$face74c450701638$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            $face74c450701638$var$handleSkippedViewTransition(transition, router.window.document);
            transition.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        useTransitions,
        setOptimisticState
    ]);
    $jpgPw.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $jpgPw.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $jpgPw.useMemo(()=>{
        return {
            createHref: router.createHref,
            createURL: router.createURL,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $jpgPw.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        }), [
        router,
        navigator,
        basename,
        onError
    ]);
    let dataRouterState = $jpgPw.useMemo(()=>({
            historyAction: state.historyAction,
            location: state.location,
            matches: state.matches,
            initialized: state.initialized,
            renderFallback: state.renderFallback,
            restoreScrollPosition: state.restoreScrollPosition,
            preventScrollReset: state.preventScrollReset,
            blockers: state.blockers
        }), [
        state.historyAction,
        state.location,
        state.matches,
        state.initialized,
        state.renderFallback,
        state.restoreScrollPosition,
        state.preventScrollReset,
        state.blockers
    ]);
    let dataRouterNavigation = $jpgPw.useMemo(()=>({
            navigation: state.navigation,
            revalidation: state.revalidation
        }), [
        state.navigation,
        state.revalidation
    ]);
    let dataRouterData = $jpgPw.useMemo(()=>({
            loaderData: state.loaderData,
            actionData: state.actionData,
            errors: state.errors
        }), [
        state.loaderData,
        state.actionData,
        state.errors
    ]);
    let fetchersContext = $jpgPw.useMemo(()=>({
            fetchers: state.fetchers,
            fetcherData: fetcherData.current
        }), [
        state.fetchers
    ]);
    return /* @__PURE__ */ $jpgPw.createElement($jpgPw.Fragment, null, /* @__PURE__ */ $jpgPw.createElement((0, $1e0kC.DataRouterContext).Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $jpgPw.createElement((0, $1e0kC.DataRouterStateContext).Provider, {
        value: dataRouterState
    }, /* @__PURE__ */ $jpgPw.createElement((0, $1e0kC.DataRouterNavigationContext).Provider, {
        value: dataRouterNavigation
    }, /* @__PURE__ */ $jpgPw.createElement((0, $1e0kC.DataRouterDataContext).Provider, {
        value: dataRouterData
    }, /* @__PURE__ */ $jpgPw.createElement((0, $1e0kC.FetchersContext).Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $jpgPw.createElement((0, $1e0kC.ViewTransitionContext).Provider, {
        value: vtContext
    }, /* @__PURE__ */ $jpgPw.createElement($face74c450701638$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        useTransitions: useTransitions
    }, /* @__PURE__ */ $jpgPw.createElement($face74c450701638$var$MemoizedDataRoutes, {
        routes: router.routes,
        manifest: router.manifest,
        state: state,
        isStatic: false,
        onError: onError
    })))))))), null);
}
function $face74c450701638$var$getOptimisticRouterState(currentState, newState) {
    return {
        ...currentState,
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    };
}
const $face74c450701638$var$MemoizedDataRoutes = $jpgPw.memo($face74c450701638$export$699f06c8afb533c9);
function $face74c450701638$export$699f06c8afb533c9({ routes: routes, manifest: manifest, state: state, isStatic: isStatic, onError: onError }) {
    let dataRouterContext = $jpgPw.useContext((0, $1e0kC.DataRouterContext));
    (0, $aDbDg.invariant)(dataRouterContext, "You must render this element inside a <DataRouterContext.Provider> element");
    let discoveryRuntime = $jpgPw.useContext((0, $89PPr.FrameworkContext))?.routeDiscoveryRuntime;
    $jpgPw.useEffect(()=>{
        if (state.initialized) discoveryRuntime?.markReady();
    }, [
        state.initialized,
        discoveryRuntime
    ]);
    return (0, $bdpx3.useRoutesImpl)(routes, void 0, {
        router: dataRouterContext.router,
        manifest: manifest,
        state: state,
        isStatic: isStatic,
        onError: onError
    });
}
/**
* A declarative {@link Router | `<Router>`} that stores all entries in memory.
*
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {MemoryRouterProps.basename} props.basename n/a
* @param {MemoryRouterProps.children} props.children n/a
* @param {MemoryRouterProps.initialEntries} props.initialEntries n/a
* @param {MemoryRouterProps.initialIndex} props.initialIndex n/a
* @param {MemoryRouterProps.useTransitions} props.useTransitions n/a
* @returns A declarative in-memory {@link Router | `<Router>`} for client-side
* routing.
*/ function $face74c450701638$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, useTransitions: useTransitions }) {
    let historyRef = $jpgPw.useRef(null);
    if (historyRef.current == null) historyRef.current = (0, $aDbDg.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $jpgPw.useState({
        action: history.action,
        location: history.location
    });
    let setState = $jpgPw.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $jpgPw.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $jpgPw.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $jpgPw.createElement($face74c450701638$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
/**
* A component-based version of {@link useNavigate} to use in a
* [`React.Component` class](https://react.dev/reference/react/Component) where
* hooks cannot be used.
*
* It's recommended to avoid using this component in favor of {@link useNavigate}.
*
* @example
* <Navigate to="/tasks" />
*
* @public
* @category Components
* @param props Props
* @param {NavigateProps.relative} props.relative n/a
* @param {NavigateProps.replace} props.replace n/a
* @param {NavigateProps.state} props.state n/a
* @param {NavigateProps.to} props.to n/a
* @returns {void}
*
*/ function $face74c450701638$export$444b3ab0cb9aec40({ to: to, replace: replace, state: state, relative: relative }) {
    (0, $aDbDg.invariant)((0, $bdpx3.useInRouterContext)(), `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic, navigator: navigator } = $jpgPw.useContext((0, $1e0kC.NavigationContext));
    (0, $aDbDg.warning)(!isStatic, "<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.");
    let { matches: matches } = $jpgPw.useContext((0, $1e0kC.RouteContext));
    let { pathname: locationPathname } = (0, $bdpx3.useLocation)();
    let navigate = (0, $bdpx3.useNavigate)();
    let path = (0, $jcvU7.resolveTo)(to, (0, $jcvU7.getResolveToMatches)(matches), locationPathname, relative === "path");
    (0, $2gfKq.validateNavigationTarget)(typeof to === "string" ? to : (0, $aDbDg.createPath)(to), navigator.createHref(path), (0, $2gfKq.getNavigatorCurrentUrl)(navigator), "reject");
    let jsonPath = JSON.stringify(path);
    $jpgPw.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
* Renders the matching child route of a parent route or nothing if no child
* route matches.
*
* @example
* import { Outlet } from "react-router";
*
* export default function SomeParent() {
*   return (
*     <div>
*       <h1>Parent Content</h1>
*       <Outlet />
*     </div>
*   );
* }
*
* @public
* @category Components
* @param props Props
* @param {OutletProps.context} props.context n/a
* @returns React element for the rendered outlet or `null` if no child route matches.
*/ function $face74c450701638$export$910ae8079b2c2852(props) {
    return (0, $bdpx3.useOutlet)(props.context);
}
/**
* Configures an element to render when a pattern matches the current location.
* It must be rendered within a {@link Routes} element. Note that these routes
* do not participate in data loading, actions, code splitting, or any other
* route module features.
*
* @example
* // Usually used in a declarative router
* function App() {
*   return (
*     <BrowserRouter>
*       <Routes>
*         <Route index element={<StepOne />} />
*         <Route path="step-2" element={<StepTwo />} />
*         <Route path="step-3" element={<StepThree />} />
*       </Routes>
*    </BrowserRouter>
*   );
* }
*
* // But can be used with a data router as well if you prefer the JSX notation
* const routes = createRoutesFromElements(
*   <>
*     <Route index loader={step1Loader} Component={StepOne} />
*     <Route path="step-2" loader={step2Loader} Component={StepTwo} />
*     <Route path="step-3" loader={step3Loader} Component={StepThree} />
*   </>
* );
*
* const router = createBrowserRouter(routes);
*
* function App() {
*   return <RouterProvider router={router} />;
* }
*
* @public
* @category Components
* @param props Props
* @param {PathRouteProps.action} props.action n/a
* @param {PathRouteProps.caseSensitive} props.caseSensitive n/a
* @param {PathRouteProps.Component} props.Component n/a
* @param {PathRouteProps.children} props.children n/a
* @param {PathRouteProps.element} props.element n/a
* @param {PathRouteProps.ErrorBoundary} props.ErrorBoundary n/a
* @param {PathRouteProps.errorElement} props.errorElement n/a
* @param {PathRouteProps.handle} props.handle n/a
* @param {PathRouteProps.HydrateFallback} props.HydrateFallback n/a
* @param {PathRouteProps.hydrateFallbackElement} props.hydrateFallbackElement n/a
* @param {PathRouteProps.id} props.id n/a
* @param {PathRouteProps.index} props.index n/a
* @param {PathRouteProps.lazy} props.lazy n/a
* @param {PathRouteProps.loader} props.loader n/a
* @param {PathRouteProps.path} props.path n/a
* @param {PathRouteProps.shouldRevalidate} props.shouldRevalidate n/a
* @returns {void}
*/ function $face74c450701638$export$e7b0ac011bb776c6(props) {
    (0, $aDbDg.invariant)(false, "A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.");
}
/**
* Provides location context for the rest of the app.
*
* Note: You usually won't render a `<Router>` directly. Instead, you'll render a
* router that is more specific to your environment such as a {@link BrowserRouter}
* in web browsers or a {@link ServerRouter} for server rendering.
*
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {RouterProps.basename} props.basename n/a
* @param {RouterProps.children} props.children n/a
* @param {RouterProps.location} props.location n/a
* @param {RouterProps.navigationType} props.navigationType n/a
* @param {RouterProps.navigator} props.navigator n/a
* @param {RouterProps.static} props.static n/a
* @param {RouterProps.useTransitions} props.useTransitions n/a
* @returns React element for the rendered router or `null` if the location does
* not match the {@link props.basename}
*/ function $face74c450701638$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP", navigator: navigator, static: staticProp = false, useTransitions: useTransitions }) {
    (0, $aDbDg.invariant)(!(0, $bdpx3.useInRouterContext)(), "You cannot render a <Router> inside another <Router>. You should never have more than one in your app.");
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $jpgPw.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            useTransitions: useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = (0, $aDbDg.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default", mask: mask } = locationProp;
    let locationContext = $jpgPw.useMemo(()=>{
        let trailingPathname = (0, $jcvU7.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key,
                mask: mask
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType,
        mask
    ]);
    (0, $aDbDg.warning)(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $jpgPw.createElement((0, $1e0kC.NavigationContext).Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $jpgPw.createElement((0, $1e0kC.LocationContext).Provider, {
        children: children,
        value: locationContext
    }));
}
/**
* Renders a branch of {@link Route | `<Route>`s} that best matches the current
* location. Note that these routes do not participate in [data loading](../../start/framework/route-module#loader),
* [`action`](../../start/framework/route-module#action), code splitting, or
* any other [route module](../../start/framework/route-module) features.
*
* @example
* import { Route, Routes } from "react-router";
*
* <Routes>
*   <Route index element={<StepOne />} />
*   <Route path="step-2" element={<StepTwo />} />
*   <Route path="step-3" element={<StepThree />} />
* </Routes>
*
* @public
* @category Components
* @param props Props
* @param {RoutesProps.children} props.children n/a
* @param {RoutesProps.location} props.location n/a
* @returns React element for the rendered routes or `null` if no route matches
*/ function $face74c450701638$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return (0, $bdpx3.useRoutes)($face74c450701638$export$16da398f5434bdec(children), location);
}
/**
* Used to render promise values with automatic error handling.
*
* **Note:** `<Await>` expects to be rendered inside a [`<React.Suspense>`](https://react.dev/reference/react/Suspense)
*
* Pass `unstable_promise` instead of `resolve` to opt into React's
* [`use()`](https://react.dev/reference/react/use) implementation. With
* `unstable_promise`, `errorElement` handles promise rejections, while errors
* thrown by children bubble to the nearest React error boundary.
*
* In React Server Components, `resolve` already has this error-handling behavior:
* `errorElement` handles only input rejections, while child render errors
* propagate to the surrounding error boundary. Both props accept promise-like
* values without modifying the source promise. Both props treat a falsy
* `errorElement` as absent and propagate the rejection. Pass an empty fragment
* to handle a rejection without rendering any content.
*
* <docs-warning>The `unstable_promise` prop is experimental and may change in
* minor or patch releases.</docs-warning>
*
* @example
* import { Await, useLoaderData } from "react-router";
*
* export async function loader() {
*   // not awaited
*   const reviews = getReviews();
*   // awaited (blocks the transition)
*   const book = await fetch("/api/book").then((res) => res.json());
*   return { book, reviews };
* }
*
* function Book() {
*   const { book, reviews } = useLoaderData();
*   return (
*     <div>
*       <h1>{book.title}</h1>
*       <p>{book.description}</p>
*       <React.Suspense fallback={<ReviewsSkeleton />}>
*         <Await
*           resolve={reviews}
*           errorElement={
*             <div>Could not load reviews 😬</div>
*           }
*           children={(resolvedReviews) => (
*             <Reviews items={resolvedReviews} />
*           )}
*         />
*       </React.Suspense>
*     </div>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @mode data
* @param props Props
* @param {AwaitProps.children} props.children n/a
* @param {AwaitProps.errorElement} props.errorElement n/a
* @param {AwaitProps.resolve} props.resolve n/a
* @param props.unstable_promise A promise (or value) to read using React's `use()`
* API in client components. Accepts promise-like values without modifying the
* source promise. Pass exactly one of `unstable_promise` or `resolve`.
* @returns React element for the rendered awaited value
*/ function $face74c450701638$export$6ddabde395c8c576(props) {
    (0, $aDbDg.invariant)("resolve" in props !== "unstable_promise" in props, "<Await> requires exactly one of `resolve` or `unstable_promise`");
    let { children: children, errorElement: errorElement } = props;
    let dataRouterContext = $jpgPw.useContext((0, $1e0kC.DataRouterContext));
    let dataRouterStateContext = $jpgPw.useContext((0, $1e0kC.DataRouterStateContext));
    let onError = $jpgPw.useCallback((error, errorInfo)=>{
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: dataRouterStateContext.matches[0]?.params || {},
            pattern: (0, $jcvU7.getRoutePattern)(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    if ("unstable_promise" in props) return /* @__PURE__ */ $jpgPw.createElement($face74c450701638$var$AwaitPromise, {
        value: props.unstable_promise,
        errorElement: errorElement,
        onError: onError
    }, children);
    return /* @__PURE__ */ $jpgPw.createElement($face74c450701638$var$AwaitErrorBoundary, {
        resolve: props.resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $jpgPw.createElement($face74c450701638$var$ResolveAwait, null, children));
}
function $face74c450701638$var$AwaitPromise({ value: value, children: children, errorElement: errorElement, onError: onError }) {
    let result = value != null && (typeof value === "object" || typeof value === "function") && "then" in value && typeof value.then === "function" ? $jpgPw.use((0, $eCxNt.getAwaitPromise)(value, onError)) : {
        status: "fulfilled",
        value: value
    };
    if (result.status === "rejected" && !errorElement) throw result.reason;
    return /* @__PURE__ */ $jpgPw.createElement((0, $1e0kC.AwaitContext).Provider, {
        value: result
    }, result.status === "rejected" ? errorElement : /* @__PURE__ */ $jpgPw.createElement($face74c450701638$var$ResolveAwait, null, children));
}
var $face74c450701638$var$AwaitErrorBoundary = class extends $jpgPw.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0;
        if (!(resolve instanceof Promise)) {
            status = 1;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 : "_data" in promise ? 1 : 0;
        } else {
            status = 0;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            let result = (0, $eCxNt.getPromiseResult)(resolve);
            if (result) {
                promise = resolve;
                if (result.status === "fulfilled") {
                    status = 1;
                    Object.defineProperty(resolve, "_data", {
                        get: ()=>result.value
                    });
                } else {
                    status = 2;
                    Object.defineProperty(resolve, "_error", {
                        get: ()=>result.reason
                    });
                    Promise.resolve(resolve).catch((reason)=>{
                        try {
                            this.props.onError?.(reason);
                        } catch (error) {
                            console.error("<Await> caught the following error in onError", error);
                        }
                    });
                }
            } else promise = Promise.resolve(resolve).then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>{
                this.props.onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 && !errorElement) throw promise._error;
        if (status === 2) return /* @__PURE__ */ $jpgPw.createElement((0, $1e0kC.AwaitContext).Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1) return /* @__PURE__ */ $jpgPw.createElement((0, $1e0kC.AwaitContext).Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $face74c450701638$var$ResolveAwait({ children: children }) {
    let data = (0, $bdpx3.useAsyncValue)();
    let toRender = typeof children === "function" ? children(data) : children;
    return /* @__PURE__ */ $jpgPw.createElement($jpgPw.Fragment, null, toRender);
}
/**
* Creates a route config from a React "children" object, which is usually
* either a `<Route>` element or an array of them. Used internally by
* `<Routes>` to create a route config from its children.
*
* @category Utils
* @mode data
* @param children The React children to convert into a route config
* @param parentPath The path of the parent route, used to generate unique IDs.
* @returns An array of {@link RouteObject}s that can be used with a {@link DataRouter}
*/ function $face74c450701638$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $jpgPw.Children.forEach(children, (element, index)=>{
        if (!$jpgPw.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $jpgPw.Fragment) {
            routes.push.apply(routes, $face74c450701638$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        (0, $aDbDg.invariant)(element.type === $face74c450701638$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        let props = element.props;
        (0, $aDbDg.invariant)(!props.index || !props.children, "An index route cannot have child routes.");
        let route = {
            id: props.id || treePath.join("-"),
            caseSensitive: props.caseSensitive,
            element: props.element,
            Component: props.Component,
            index: props.index,
            path: props.path,
            middleware: props.middleware,
            loader: props.loader,
            action: props.action,
            hydrateFallbackElement: props.hydrateFallbackElement,
            HydrateFallback: props.HydrateFallback,
            errorElement: props.errorElement,
            ErrorBoundary: props.ErrorBoundary,
            shouldRevalidate: props.shouldRevalidate,
            handle: props.handle,
            lazy: props.lazy
        };
        if (props.children) route.children = $face74c450701638$export$16da398f5434bdec(props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
* Create route objects from JSX elements instead of arrays of objects.
*
* @example
* const routes = createRoutesFromElements(
*   <>
*     <Route index loader={step1Loader} Component={StepOne} />
*     <Route path="step-2" loader={step2Loader} Component={StepTwo} />
*     <Route path="step-3" loader={step3Loader} Component={StepThree} />
*   </>
* );
*
* const router = createBrowserRouter(routes);
*
* function App() {
*   return <RouterProvider router={router} />;
* }
*
* @name createRoutesFromElements
* @public
* @category Utils
* @mode data
* @param children The React children to convert into a route config
* @param parentPath The path of the parent route, used to generate unique IDs.
* This is used for internal recursion and is not intended to be used by the
* application developer.
* @returns An array of {@link RouteObject}s that can be used with a {@link DataRouter}
*/ const $face74c450701638$export$9b5b6d122dea0c88 = $face74c450701638$export$16da398f5434bdec;
/**
* Renders the result of {@link matchRoutes} into a React element.
*
* @public
* @category Utils
* @param matches The array of {@link RouteMatch | route matches} to render
* @returns A React element that renders the matched routes or `null` if no matches
*/ function $face74c450701638$export$daf73786167a7f72(matches) {
    return (0, $bdpx3._renderMatches)(matches);
}
function $face74c450701638$var$useRouteComponentProps() {
    return {
        params: (0, $bdpx3.useParams)(),
        loaderData: (0, $bdpx3.useLoaderData)(),
        actionData: (0, $bdpx3.useActionData)(),
        matches: (0, $bdpx3.useMatches)()
    };
}
function $face74c450701638$export$6c4f3826290c37af({ children: children }) {
    const props = $face74c450701638$var$useRouteComponentProps();
    return $jpgPw.cloneElement(children, props);
}
function $face74c450701638$export$1a5de91a5c3255e0(Component) {
    return function WithComponentProps() {
        const props = $face74c450701638$var$useRouteComponentProps();
        return $jpgPw.createElement(Component, props);
    };
}
function $face74c450701638$var$useHydrateFallbackProps() {
    return {
        params: (0, $bdpx3.useParams)(),
        loaderData: (0, $bdpx3.useLoaderData)(),
        actionData: (0, $bdpx3.useActionData)()
    };
}
function $face74c450701638$export$f8cff34f39c1932a({ children: children }) {
    const props = $face74c450701638$var$useHydrateFallbackProps();
    return $jpgPw.cloneElement(children, props);
}
function $face74c450701638$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps() {
        const props = $face74c450701638$var$useHydrateFallbackProps();
        return $jpgPw.createElement(HydrateFallback, props);
    };
}
function $face74c450701638$var$useErrorBoundaryProps() {
    return {
        params: (0, $bdpx3.useParams)(),
        loaderData: (0, $bdpx3.useLoaderData)(),
        actionData: (0, $bdpx3.useActionData)(),
        error: (0, $bdpx3.useRouteError)()
    };
}
function $face74c450701638$export$e5afde5c4b6d747b({ children: children }) {
    const props = $face74c450701638$var$useErrorBoundaryProps();
    return $jpgPw.cloneElement(children, props);
}
function $face74c450701638$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps() {
        const props = $face74c450701638$var$useErrorBoundaryProps();
        return $jpgPw.createElement(ErrorBoundary, props);
    };
}

});
parcelRegister("eCxNt", function(module, exports) {

$parcel$export(module.exports, "getPromiseResult", function () { return $aa4ed4b205a9dda6$export$7c2250e1d8e9bb1b; });
$parcel$export(module.exports, "getAwaitPromise", function () { return $aa4ed4b205a9dda6$export$be7e832cbe7a26ed; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/await.ts
function $aa4ed4b205a9dda6$export$7c2250e1d8e9bb1b(promise) {
    if (promise.status === "fulfilled") return {
        status: "fulfilled",
        value: promise.value
    };
    if (promise.status === "rejected") return {
        status: "rejected",
        reason: promise.reason
    };
}
let $aa4ed4b205a9dda6$var$awaitPromises = /* @__PURE__ */ new WeakMap();
function $aa4ed4b205a9dda6$export$be7e832cbe7a26ed(source, onError) {
    let cached = $aa4ed4b205a9dda6$var$awaitPromises.get(source);
    if (!cached) {
        cached = {
            promise: Promise.resolve(source).then((value)=>settle({
                    status: "fulfilled",
                    value: value
                }), (reason)=>{
                let result = settle({
                    status: "rejected",
                    reason: reason
                });
                try {
                    cached.onError(reason);
                } catch (error) {
                    console.error("<Await> caught the following error in onError", error);
                }
                return result;
            }),
            onError: onError
        };
        $aa4ed4b205a9dda6$var$awaitPromises.set(source, cached);
    } else cached.onError = onError;
    function settle(result) {
        Object.assign(cached.promise, {
            status: "fulfilled",
            value: result
        });
        return result;
    }
    let result = $aa4ed4b205a9dda6$export$7c2250e1d8e9bb1b(source);
    if (result) settle(result);
    return cached.promise;
}

});


parcelRegister("loa1n", function(module, exports) {

$parcel$export(module.exports, "shouldProcessLinkClick", function () { return $f9239ce0a9a2429d$export$4c2d35dce1b682e; });
$parcel$export(module.exports, "createSearchParams", function () { return $f9239ce0a9a2429d$export$a2e4e2dcc7b1f22f; });
$parcel$export(module.exports, "getSearchParamsForLocation", function () { return $f9239ce0a9a2429d$export$4370c962fe3096e6; });
$parcel$export(module.exports, "getFormSubmissionInfo", function () { return $f9239ce0a9a2429d$export$80917616746b9ab4; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $aDbDg = parcelRequire("aDbDg");

var $jcvU7 = parcelRequire("jcvU7");
const $f9239ce0a9a2429d$var$defaultEncType = "application/x-www-form-urlencoded";
function $f9239ce0a9a2429d$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $f9239ce0a9a2429d$var$isButtonElement(object) {
    return $f9239ce0a9a2429d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $f9239ce0a9a2429d$var$isFormElement(object) {
    return $f9239ce0a9a2429d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $f9239ce0a9a2429d$var$isInputElement(object) {
    return $f9239ce0a9a2429d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $f9239ce0a9a2429d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $f9239ce0a9a2429d$export$4c2d35dce1b682e(event, target) {
    return event.button === 0 && (!target || target === "_self") && !$f9239ce0a9a2429d$var$isModifiedEvent(event);
}
/**
* Creates a URLSearchParams object using the given initializer.
*
* This is identical to `new URLSearchParams(init)` except it also supports
* arrays as values in the object form of the initializer instead of just
* strings. This is convenient when you need multiple values for a given key,
* but don't want to use an array initializer.
*
* @example
* // Instead of:
* let searchParams = new URLSearchParams([
*   ["sort", "name"],
*   ["sort", "price"],
* ]);
*
* // You can do:
* let searchParams = createSearchParams({
*   sort: ["name", "price"],
* });
*
* @public
* @category Utils
* @param init The value used to initialize the URL search parameters.
* @returns A URLSearchParams object containing the initialized search
* parameters.
*/ function $f9239ce0a9a2429d$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $f9239ce0a9a2429d$export$4370c962fe3096e6(locationSearch, defaultSearchParams) {
    let searchParams = $f9239ce0a9a2429d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
let $f9239ce0a9a2429d$var$_formDataSupportsSubmitter = null;
function $f9239ce0a9a2429d$var$isFormDataSubmitterSupported() {
    if ($f9239ce0a9a2429d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), 0);
        $f9239ce0a9a2429d$var$_formDataSupportsSubmitter = false;
    } catch  {
        $f9239ce0a9a2429d$var$_formDataSupportsSubmitter = true;
    }
    return $f9239ce0a9a2429d$var$_formDataSupportsSubmitter;
}
const $f9239ce0a9a2429d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $f9239ce0a9a2429d$var$getFormEncType(encType) {
    if (encType != null && !$f9239ce0a9a2429d$var$supportedFormEncTypes.has(encType)) {
        (0, $aDbDg.warning)(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$f9239ce0a9a2429d$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $f9239ce0a9a2429d$export$80917616746b9ab4(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($f9239ce0a9a2429d$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? (0, $jcvU7.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || "get";
        encType = $f9239ce0a9a2429d$var$getFormEncType(target.getAttribute("enctype")) || $f9239ce0a9a2429d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($f9239ce0a9a2429d$var$isButtonElement(target) || $f9239ce0a9a2429d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $jcvU7.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || "get";
        encType = $f9239ce0a9a2429d$var$getFormEncType(target.getAttribute("formenctype")) || $f9239ce0a9a2429d$var$getFormEncType(form.getAttribute("enctype")) || $f9239ce0a9a2429d$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$f9239ce0a9a2429d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($f9239ce0a9a2429d$var$isHtmlElement(target)) throw new Error("Cannot submit element that is not <form>, <button>, or <input type=\"submit|image\">");
    else {
        method = "get";
        action = null;
        encType = $f9239ce0a9a2429d$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}

});




parcelRegister("cXDiG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96f97aee6a81e4a7$export$2e2bcd8739ae039; });

var $caZvI = parcelRequire("caZvI");

var $2eqHs = parcelRequire("2eqHs");

var $3da5u = parcelRequire("3da5u");

var $b1LPP = parcelRequire("b1LPP");

var $jpgPw = parcelRequire("jpgPw");

var $b9h0p = parcelRequire("b9h0p");
var $bdpx3 = parcelRequire("bdpx3");

var $krtz1 = parcelRequire("krtz1");

var $eUJ8V = parcelRequire("eUJ8V");

var $bt0KQ = parcelRequire("bt0KQ");

var $1Hynf = parcelRequire("1Hynf");

var $jyFzD = parcelRequire("jyFzD");

var $aOwwP = parcelRequire("aOwwP");

var $cVY6z = parcelRequire("cVY6z");

var $ig0WQ = parcelRequire("ig0WQ");

var $kPFSZ = parcelRequire("kPFSZ");

var $jIMj0 = parcelRequire("jIMj0");
const $96f97aee6a81e4a7$var$MainMenu = ()=>{
    const ref = (0, $jpgPw.useRef)(null);
    const { t: t } = (0, $2eqHs.useTranslation)();
    const [isNavigationCollapsed, setIsNavigationCollapsed] = (0, $jpgPw.useState)(true);
    const [isProfileCollapsed, setIsProfileCollapsed] = (0, $jpgPw.useState)(true);
    const [currentAuthenticatedUser, setCurrentAuthenticatedUser] = (0, $jpgPw.useState)(null);
    const location = (0, $bdpx3.useLocation)();
    const collapseAll = ()=>{
        setIsProfileCollapsed(true);
        setIsNavigationCollapsed(true);
    };
    const { navigationItems: navigationItems, profileItems: profileItems } = $96f97aee6a81e4a7$var$useGetNavigationItems(currentAuthenticatedUser, location, ()=>collapseAll());
    (0, $jyFzD.useActionOutside)(()=>collapseAll(), ref);
    (0, $jyFzD.useActionOutside)(()=>collapseAll(), ref);
    (0, $jpgPw.useEffect)(()=>{
        const unsubscribeFromAuthenticatedUser = (0, $krtz1.authenticatedUser).onValue((authenticatedUser)=>setCurrentAuthenticatedUser(authenticatedUser));
        return ()=>{
            unsubscribeFromAuthenticatedUser();
        };
    }, []);
    const isLoading = currentAuthenticatedUser === null;
    const isLoggedIn = typeof currentAuthenticatedUser !== 'undefined';
    return (0, $caZvI.jsx)("header", {
        children: (0, $caZvI.jsxs)($96f97aee6a81e4a7$var$Container, {
            "$wide": true,
            ref: ref,
            children: [
                (0, $caZvI.jsx)($96f97aee6a81e4a7$var$DropdownToggleButton, {
                    isCollapsed: isNavigationCollapsed,
                    setIsCollapsed: setIsNavigationCollapsed,
                    collapseAll: collapseAll,
                    controls: 'main-dropdown-menu'
                }),
                (0, $caZvI.jsx)($96f97aee6a81e4a7$var$HomeLink, {
                    to: '/',
                    onClick: ()=>{
                        setIsProfileCollapsed(true);
                        setIsNavigationCollapsed(true);
                    },
                    children: t((0, $b1LPP.default).THESSA)
                }),
                (0, $caZvI.jsx)($96f97aee6a81e4a7$var$DropdownNavigation, {
                    id: 'main-dropdown-menu',
                    isLoading: isLoading,
                    "$isCollapsed": isNavigationCollapsed,
                    items: navigationItems
                }),
                (0, $caZvI.jsx)($96f97aee6a81e4a7$var$RowNavigation, {
                    id: 'main-menu',
                    isLoading: isLoading,
                    items: navigationItems
                }),
                (0, $caZvI.jsx)($96f97aee6a81e4a7$var$HeaderProfile, {
                    isLoading: isLoading,
                    isLoggedIn: isLoggedIn,
                    isCollapsed: isProfileCollapsed,
                    setIsCollapsed: setIsProfileCollapsed,
                    name: currentAuthenticatedUser?.firstName,
                    items: profileItems,
                    collapseAll: collapseAll
                })
            ]
        })
    });
};
const $96f97aee6a81e4a7$var$Container = (0, $3da5u.default)((0, $eUJ8V.UniContainer))`
  position: relative;
  z-index: 2;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  ${(0, $bt0KQ.DEFAULT_FONT)}
  margin-block: 24px;

  ${(0, $1Hynf.fromTabletUp)((0, $3da5u.css)`
    gap: 32px;
    margin-block: 32px;
  `)}
`;
const $96f97aee6a81e4a7$var$DropdownToggleButton = (0, $3da5u.default)((0, $jIMj0.default))`
  margin-left: -12px;

  ${(0, $1Hynf.fromTabletUp)((0, $3da5u.css)`
    display: none;
  `)}
`;
const $96f97aee6a81e4a7$var$HomeLink = (0, $3da5u.default)((0, $b9h0p.Link))`
  ${(0, $cVY6z.LinkStyles)()}
  padding-inline: 8px;
  align-items: flex-start;
  font-size: 18px;
  line-height: 18px;

  ${(0, $1Hynf.fromTabletUp)((0, $3da5u.css)`
    font-size: 24px;
    margin-left: -16px;
    padding-inline: 16px;
  `)}
`;
const $96f97aee6a81e4a7$var$DropdownNavigation = (0, $3da5u.default)((0, $aOwwP.default))`
  ${(0, $ig0WQ.DropdownStyles)('bottomLeft')}

  ${({ $isCollapsed: $isCollapsed })=>$isCollapsed && (0, $3da5u.css)`
      display: none;
    `}

  ${(0, $1Hynf.fromTabletUp)((0, $3da5u.css)`
    display: none;
  `)}
`;
const $96f97aee6a81e4a7$var$RowNavigation = (0, $3da5u.default)((0, $aOwwP.default))`
  display: none;

  ${(0, $1Hynf.fromTabletUp)((0, $3da5u.css)`
    display: flex;
  `)}
`;
const $96f97aee6a81e4a7$var$HeaderProfile = (0, $3da5u.default)((0, $kPFSZ.default))`
  display: flex;
  justify-content: flex-end;

  ${(0, $1Hynf.fromTabletUp)((0, $3da5u.css)`
    margin-inline-start: auto;
  `)}
`;
const $96f97aee6a81e4a7$var$useGetNavigationItems = (user, location, onClickFunction)=>{
    const { t: t } = (0, $2eqHs.useTranslation)();
    if (!user) {
        const unauthenticatedNavigationItems = [
            {
                path: '/',
                title: t((0, $b1LPP.default).FRONTPAGE),
                isActive: /^\/$/,
                location: location,
                onClickFunction: onClickFunction
            },
            {
                path: '/about',
                title: t((0, $b1LPP.default).ABOUT),
                isActive: /^\/about/,
                location: location,
                onClickFunction: onClickFunction
            }
        ];
        return {
            navigationItems: unauthenticatedNavigationItems,
            profileItems: [
                {
                    path: '/',
                    title: t((0, $b1LPP.default).LOGIN),
                    icon: 'login',
                    location: location,
                    onClickFunction: onClickFunction
                }
            ]
        };
    }
    const commonNavigationItems = [
        {
            path: '/help',
            title: t((0, $b1LPP.default).HELP1),
            isActive: /^\/help/
        },
        {
            path: '/about',
            title: t((0, $b1LPP.default).ABOUT),
            isActive: /^\/about/
        }
    ];
    const doctoralCandidateNavigationItems = [
        {
            path: '/phd-project',
            title: t((0, $b1LPP.default).MY_PHD_PROJECT),
            isActive: /^\/phd-project/
        }
    ];
    const supervisorNavigationItems = [
        {
            path: '/doctoral-candidates',
            title: t((0, $b1LPP.default).MY_DOCTORAL_CANDIDATES1),
            isActive: /^\/doctoral-candidates/
        }
    ];
    const thesisCommitteeMemberNavigationItems = [
        {
            path: '/doctoral-candidates',
            title: t((0, $b1LPP.default).MY_DOCTORAL_CANDIDATES1),
            isActive: /^\/doctoral-candidates/
        }
    ];
    const foremanNavigationItems = [
        {
            path: '/doctoral-candidates',
            title: t((0, $b1LPP.default).MY_DOCTORAL_CANDIDATES1),
            isActive: /^\/doctoral-candidates/
        }
    ];
    const coordinatorNavigationItems = [
        {
            path: '/coordinator',
            title: t((0, $b1LPP.default).COORDINATOR_TOOLS.MAIN_HEADING),
            isActive: /^\/coordinator$/
        },
        {
            path: '/coordinator/doctoral-candidates',
            title: t((0, $b1LPP.default).DOCTORAL_CANDIDATES1),
            isActive: /^\/coordinator\/doctoral-candidates/
        },
        {
            path: '/users',
            title: t((0, $b1LPP.default).USERS1),
            isActive: /^\/users/
        },
        {
            path: '/statistics',
            title: t((0, $b1LPP.default).STATISTICS1),
            isActive: /^\/statistics/
        }
    ];
    const isDoctoralCandidate = user.doctoralCandidate !== undefined;
    const isThesisCommitteeMember = user.isThesisCommitteeMember;
    const isCoordinator = user.coordinator !== undefined;
    let navigationItems = [];
    if (isDoctoralCandidate) navigationItems = [
        ...navigationItems,
        ...doctoralCandidateNavigationItems.filter($96f97aee6a81e4a7$var$onlyNewNavigationItems(navigationItems))
    ];
    if (user.isSupervisor) navigationItems = [
        ...navigationItems,
        ...supervisorNavigationItems.filter($96f97aee6a81e4a7$var$onlyNewNavigationItems(navigationItems))
    ];
    if (isThesisCommitteeMember) navigationItems = [
        ...navigationItems,
        ...thesisCommitteeMemberNavigationItems.filter($96f97aee6a81e4a7$var$onlyNewNavigationItems(navigationItems))
    ];
    if (isCoordinator) navigationItems = [
        ...navigationItems,
        ...coordinatorNavigationItems.filter($96f97aee6a81e4a7$var$onlyNewNavigationItems(navigationItems))
    ];
    if (user.isForeman) navigationItems = [
        ...navigationItems,
        ...foremanNavigationItems.filter($96f97aee6a81e4a7$var$onlyNewNavigationItems(navigationItems))
    ];
    navigationItems = [
        ...navigationItems,
        ...commonNavigationItems.filter($96f97aee6a81e4a7$var$onlyNewNavigationItems(navigationItems))
    ];
    navigationItems = navigationItems.map((navigationItem)=>({
            ...navigationItem,
            location: location,
            onClickFunction: onClickFunction
        }));
    return {
        navigationItems: navigationItems,
        profileItems: [
            {
                path: '/reminders',
                title: t((0, $b1LPP.default).REMINDERS1),
                isActive: /^\/reminders/,
                location: location,
                onClickFunction: onClickFunction
            },
            {
                path: '/profile',
                title: t((0, $b1LPP.default).PROFILE1),
                isActive: /^\/profile/,
                location: location,
                onClickFunction: onClickFunction
            }
        ]
    };
};
function $96f97aee6a81e4a7$var$onlyNewNavigationItems(existingNavigationItems) {
    return (newNavigationItem)=>!existingNavigationItems.some((existingNavigationItem)=>existingNavigationItem.path === newNavigationItem.path);
}
var $96f97aee6a81e4a7$export$2e2bcd8739ae039 = $96f97aee6a81e4a7$var$MainMenu;

});
parcelRegister("krtz1", function(module, exports) {

$parcel$export(module.exports, "IS_LOADING", function () { return $ee1d430b52e04365$export$a63dec0667c2f97a; });
$parcel$export(module.exports, "IS_LOGGED_IN", function () { return $ee1d430b52e04365$export$70cb672e34f97923; });
$parcel$export(module.exports, "IS_NOT_LOGGED_IN", function () { return $ee1d430b52e04365$export$1a4a18237fdaafdc; });
$parcel$export(module.exports, "IS_CLOSED", function () { return $ee1d430b52e04365$export$1e8c6f9c4f74d665; });
$parcel$export(module.exports, "ERROR_CODE_EMAIL_ALREADY_IN_USE", function () { return $ee1d430b52e04365$export$ef349a25e3b664b9; });
$parcel$export(module.exports, "ERROR_CODE_NO_ROLE", function () { return $ee1d430b52e04365$export$58d85a9d06f9a03c; });
$parcel$export(module.exports, "ERROR_CODE_PASSWORD_RESET_REQUIRED", function () { return $ee1d430b52e04365$export$1ce1f44e2202a62e; });
$parcel$export(module.exports, "ERROR_CODE_USE_UNIVERSITY_LOGIN", function () { return $ee1d430b52e04365$export$a09098ff4a8c400f; });
$parcel$export(module.exports, "formatRole", function () { return $ee1d430b52e04365$export$4ea149e0efbca2ed; });
$parcel$export(module.exports, "allRoles", function () { return $ee1d430b52e04365$export$34e53dc58297a06; });
$parcel$export(module.exports, "logInResponse", function () { return $ee1d430b52e04365$export$ad100b377ab70114; });
$parcel$export(module.exports, "logOutResponse", function () { return $ee1d430b52e04365$export$f02f3ce96d8de75a; });
$parcel$export(module.exports, "authenticatedUser", function () { return $ee1d430b52e04365$export$2113a2fd0338ceda; });
$parcel$export(module.exports, "authStatus", function () { return $ee1d430b52e04365$export$3ed79f77b3338468; });
$parcel$export(module.exports, "logInFailed", function () { return $ee1d430b52e04365$export$d04bbc9f0fd5c0e0; });
$parcel$export(module.exports, "getUserId", function () { return $ee1d430b52e04365$export$1617268687ac763c; });
$parcel$export(module.exports, "getDoctoralCandidateId", function () { return $ee1d430b52e04365$export$5d90a47331ee2771; });
$parcel$export(module.exports, "getCoordinatorId", function () { return $ee1d430b52e04365$export$bee9b2e9c5a55159; });
$parcel$export(module.exports, "requestPasswordResetEmailResponse", function () { return $ee1d430b52e04365$export$df7f96cb16fb169d; });
$parcel$export(module.exports, "resetPasswordResponse", function () { return $ee1d430b52e04365$export$9fd4fdd25d5ddae4; });
$parcel$export(module.exports, "maintenanceModeResponses", function () { return $ee1d430b52e04365$export$de58f347c726acf8; });
$parcel$export(module.exports, "maintenanceModeP", function () { return $ee1d430b52e04365$export$8e230f493f7e3f02; });
$parcel$export(module.exports, "hasRole", function () { return $ee1d430b52e04365$export$128c909470667330; });
$parcel$export(module.exports, "hasAnyRole", function () { return $ee1d430b52e04365$export$34cc34f5b1adb763; });

var $eVhSY = parcelRequire("eVhSY");

var $4D64z = parcelRequire("4D64z");

var $U31uw = parcelRequire("U31uw");

var $aOv8q = parcelRequire("aOv8q");

var $EgKdY = parcelRequire("EgKdY");

var $bTAuY = parcelRequire("bTAuY");

var $b1LPP = parcelRequire("b1LPP");

var $lSubk = parcelRequire("lSubk");
const $ee1d430b52e04365$export$a63dec0667c2f97a = 1;
const $ee1d430b52e04365$export$70cb672e34f97923 = 2;
const $ee1d430b52e04365$export$1a4a18237fdaafdc = 3;
const $ee1d430b52e04365$export$282c5776fad39c85 = 4;
const $ee1d430b52e04365$export$1e8c6f9c4f74d665 = 6;
const $ee1d430b52e04365$export$464b26db8981abe6 = 8;
const $ee1d430b52e04365$export$ef349a25e3b664b9 = 9;
const $ee1d430b52e04365$export$58d85a9d06f9a03c = 10;
const $ee1d430b52e04365$export$1ce1f44e2202a62e = 11;
const $ee1d430b52e04365$export$a09098ff4a8c400f = 12;
const $ee1d430b52e04365$export$4ea149e0efbca2ed = (role, t)=>{
    const TRANSLATED_ROLES = t((0, $b1LPP.default).ROLE_NAME, {
        returnObjects: true
    });
    return TRANSLATED_ROLES[role];
};
const $ee1d430b52e04365$export$34e53dc58297a06 = [
    (0, $lSubk.Role).DOCTORAL_CANDIDATE,
    (0, $lSubk.Role).SUPERVISOR,
    (0, $lSubk.Role).THESIS_COMMITTEE_MEMBER,
    (0, $lSubk.Role).COORDINATOR
];
const $ee1d430b52e04365$var$initialAuthStatusResponse = (0, $U31uw.ajaxGet)('/rest/auth');
const $ee1d430b52e04365$export$ad100b377ab70114 = (0, $aOv8q.logInAction).flatMap((credentials)=>(0, $U31uw.ajaxPostJSON)('/rest/auth', credentials));
const $ee1d430b52e04365$export$f02f3ce96d8de75a = (0, $aOv8q.logOutAction).flatMap(()=>(0, $U31uw.ajaxDelete)('/rest/auth'));
const $ee1d430b52e04365$var$authResponseToAuthStatus = (user)=>{
    if (typeof user === 'undefined') return $ee1d430b52e04365$export$1a4a18237fdaafdc;
    if (user.isSignUpRequired) return $ee1d430b52e04365$export$282c5776fad39c85;
    if (user.closedAt !== null) return $ee1d430b52e04365$export$1e8c6f9c4f74d665;
    else return $ee1d430b52e04365$export$70cb672e34f97923;
};
const $ee1d430b52e04365$var$loadAuthStatusResponse = (0, $aOv8q.loadAuthStatus).flatMap(()=>(0, $U31uw.ajaxGet)('/rest/auth'));
const $ee1d430b52e04365$export$2113a2fd0338ceda = new (0, (/*@__PURE__*/$parcel$interopDefault($4D64z))).Model();
const $ee1d430b52e04365$var$authStatusResponses = $ee1d430b52e04365$var$initialAuthStatusResponse.merge($ee1d430b52e04365$export$ad100b377ab70114).merge($ee1d430b52e04365$export$f02f3ce96d8de75a).merge((0, $EgKdY.signedUp)).merge((0, $bTAuY.saveProfileResponse)).merge($ee1d430b52e04365$var$loadAuthStatusResponse);
$ee1d430b52e04365$export$2113a2fd0338ceda.addSource($ee1d430b52e04365$var$authStatusResponses.map($ee1d430b52e04365$var$formatAuthenticatedUser));
const $ee1d430b52e04365$export$3ed79f77b3338468 = $ee1d430b52e04365$export$2113a2fd0338ceda.map($ee1d430b52e04365$var$authResponseToAuthStatus);
const $ee1d430b52e04365$export$d04bbc9f0fd5c0e0 = $ee1d430b52e04365$export$2113a2fd0338ceda.errors();
function $ee1d430b52e04365$var$formatAuthenticatedUser(user) {
    if (user === undefined) return user;
    else if (user.isSignUpRequired) return {
        isSignUpRequired: user.isSignUpRequired
    };
    else {
        const firstDoctoralCandidate = user.doctoral_candidates[0] // Only take the first because we don't yet support duplicate roles in the front end.
        ;
        const firstCoordinator = user.coordinators[0] // Only take the first because we don't yet support duplicate roles in the front end.
        ;
        const firstThesisCommitteeMember = user.thesis_committee_members[0] // Only take the first because we don't yet support duplicate roles in the front end.
        ;
        const formattedUser = {
            id: user.id,
            firstName: user.first_name,
            lastName: user.last_name,
            email: user.email,
            username: user.hy_username,
            closedAt: user.closed_at,
            isSupervisor: user.is_supervisor,
            isForeman: user.is_foreman
        };
        if (firstDoctoralCandidate) formattedUser.doctoralCandidate = {
            id: firstDoctoralCandidate.id,
            startedAtDate: firstDoctoralCandidate.started_at_date,
            studentNumber: firstDoctoralCandidate.student_number
        };
        if (firstThesisCommitteeMember) {
            formattedUser.thesisCommitteeMember = {
                id: firstThesisCommitteeMember.id
            };
            formattedUser.isThesisCommitteeMember = true;
        } else formattedUser.isThesisCommitteeMember = false;
        if (firstCoordinator) formattedUser.coordinator = {
            id: firstCoordinator.id
        };
        return formattedUser;
    }
}
function $ee1d430b52e04365$export$1617268687ac763c() {
    return $ee1d430b52e04365$export$2113a2fd0338ceda.get().id;
}
function $ee1d430b52e04365$export$5d90a47331ee2771() {
    const doctoralCandidate = $ee1d430b52e04365$export$2113a2fd0338ceda.get().doctoralCandidate;
    if (doctoralCandidate !== undefined) return doctoralCandidate.id;
    throw new Error('Logged in user is not a doctoral candidate');
}
function $ee1d430b52e04365$export$bee9b2e9c5a55159() {
    const coordinator = $ee1d430b52e04365$export$2113a2fd0338ceda.get().coordinator;
    if (coordinator !== undefined) return coordinator.id;
    throw new Error('Logged in user is not a coordinator');
}
const $ee1d430b52e04365$export$df7f96cb16fb169d = (0, $aOv8q.requestPasswordResetEmail).flatMap((email)=>(0, $U31uw.ajaxPostJSON)('/rest/auth/password-reset', {
        email: email
    }));
const $ee1d430b52e04365$export$9fd4fdd25d5ddae4 = (0, $aOv8q.resetPassword).flatMap(({ token: token, email: email, password: password })=>(0, $U31uw.ajaxPostJSON)('/rest/auth/password', {
        token: token,
        email: email,
        password: password,
        password_confirmation: password
    }));
const $ee1d430b52e04365$var$isCsrfTokenMismatchError = ({ status: status, responseJSON: responseJSON })=>status === 403 && responseJSON.errorCode === $ee1d430b52e04365$export$464b26db8981abe6;
$ee1d430b52e04365$export$ad100b377ab70114.errors().onError((errorResponse)=>{
    if ($ee1d430b52e04365$var$isCsrfTokenMismatchError(errorResponse)) $ee1d430b52e04365$var$handleCsrfTokenMismatchError();
});
function $ee1d430b52e04365$var$handleCsrfTokenMismatchError() {
    const shouldRefreshBrowser = confirm('Your session has been inactive for too long. Reload page to renew session?');
    if (shouldRefreshBrowser) window.location.reload();
}
const $ee1d430b52e04365$export$de58f347c726acf8 = new (0, (/*@__PURE__*/$parcel$interopDefault($4D64z))).Bus();
const $ee1d430b52e04365$export$8e230f493f7e3f02 = $ee1d430b52e04365$export$de58f347c726acf8.map(true).toProperty();
const $ee1d430b52e04365$var$roles = new (0, $eVhSY.Model)([]);
$ee1d430b52e04365$var$roles.addSource($ee1d430b52e04365$export$2113a2fd0338ceda.map((user)=>{
    if (!user) return [];
    const updatedRoles = [];
    if (user.doctoralCandidate) updatedRoles.push((0, $lSubk.Role).DOCTORAL_CANDIDATE);
    if (user.isSupervisor) updatedRoles.push((0, $lSubk.Role).SUPERVISOR);
    if (user.isThesisCommitteeMember) updatedRoles.push((0, $lSubk.Role).THESIS_COMMITTEE_MEMBER);
    if (user.coordinator) updatedRoles.push((0, $lSubk.Role).COORDINATOR);
    if (user.isForeman) updatedRoles.push((0, $lSubk.Role).SALARY_SYSTEM_FOREMAN);
    return updatedRoles;
}));
const $ee1d430b52e04365$export$128c909470667330 = (role)=>$ee1d430b52e04365$var$roles.get().includes(role);
const $ee1d430b52e04365$export$34cc34f5b1adb763 = ()=>{
    const isDoctoralCandidate = $ee1d430b52e04365$export$128c909470667330((0, $lSubk.Role).DOCTORAL_CANDIDATE);
    const isSupervisor = $ee1d430b52e04365$export$128c909470667330((0, $lSubk.Role).SUPERVISOR);
    const isCoordinator = $ee1d430b52e04365$export$128c909470667330((0, $lSubk.Role).COORDINATOR);
    const isThesisCommitteeMember = $ee1d430b52e04365$export$128c909470667330((0, $lSubk.Role).THESIS_COMMITTEE_MEMBER);
    const isForeman = $ee1d430b52e04365$export$128c909470667330((0, $lSubk.Role).SALARY_SYSTEM_FOREMAN);
    return isDoctoralCandidate || isSupervisor || isThesisCommitteeMember || isCoordinator || isForeman;
};

});
parcelRegister("eVhSY", function(module, exports) {

(function() {
    var Bacon, init, __slice = [].slice;
    init = function(Bacon) {
        var Lens, Model, defaultEquals, fold, globalModCount, id, idCounter, isModel, nonEmpty, sameValue, shallowCopy, valueLens;
        id = function(x) {
            return x;
        };
        nonEmpty = function(x) {
            return x.length > 0;
        };
        fold = function(xs, seed, f) {
            var x, _i, _len;
            for(_i = 0, _len = xs.length; _i < _len; _i++){
                x = xs[_i];
                seed = f(seed, x);
            }
            return seed;
        };
        isModel = function(obj) {
            return obj instanceof Bacon.Property;
        };
        globalModCount = 0;
        idCounter = 1;
        defaultEquals = function(a, b) {
            return a === b;
        };
        sameValue = function(eq) {
            return function(a, b) {
                return !a.initial && eq(a.value, b.value);
            };
        };
        Model = Bacon.Model = function(initValue) {
            var currentValue, eq, model, modificationBus, myId, myModCount, syncBus, valueWithSource;
            myId = idCounter++;
            eq = defaultEquals;
            myModCount = 0;
            modificationBus = new Bacon.Bus();
            syncBus = new Bacon.Bus();
            currentValue = void 0;
            valueWithSource = Bacon.update({
                initial: true
            }, [
                modificationBus
            ], function(_arg, _arg1) {
                var changed, f, modStack, newValue, source, value;
                value = _arg.value;
                source = _arg1.source, f = _arg1.f;
                newValue = f(value);
                modStack = [
                    myId
                ];
                changed = newValue !== value;
                return {
                    source: source,
                    value: newValue,
                    modStack: modStack,
                    changed: changed
                };
            }, [
                syncBus
            ], function(_, syncEvent) {
                return syncEvent;
            }).skipDuplicates(sameValue(eq)).changes().toProperty();
            model = valueWithSource.map(".value").skipDuplicates(eq);
            model.dispatcher.subscribe(function(event) {
                if (event.hasValue()) return currentValue = event.value();
            });
            if (!model.id) model.id = myId;
            model.addSyncSource = function(syncEvents) {
                return syncBus.plug(syncEvents.filter(function(e) {
                    return e.changed && !Bacon._.contains(e.modStack, myId);
                }).doAction(function() {
                    return Bacon.Model.syncCount++;
                }).map(function(e) {
                    return shallowCopy(e, "modStack", e.modStack.concat([
                        myId
                    ]));
                }).map(function(e) {
                    return valueLens.set(e, model.syncConverter(valueLens.get(e)));
                }));
            };
            model.apply = function(source) {
                modificationBus.plug(source.toEventStream().map(function(f) {
                    return {
                        source: source,
                        f: f
                    };
                }));
                return valueWithSource.changes().filter(function(change) {
                    return change.source !== source;
                }).map(function(change) {
                    return change.value;
                });
            };
            model.addSource = function(source) {
                return model.apply(source.map(function(v) {
                    return function() {
                        return v;
                    };
                }));
            };
            model.modify = function(f) {
                return model.apply(Bacon.once(f));
            };
            model.set = function(value) {
                return model.modify(function() {
                    return value;
                });
            };
            model.get = function() {
                return currentValue;
            };
            model.syncEvents = function() {
                return valueWithSource.toEventStream();
            };
            model.bind = function(other) {
                this.addSyncSource(other.syncEvents());
                return other.addSyncSource(this.syncEvents());
            };
            model.lens = function(lens) {
                var lensed;
                lens = Lens(lens);
                lensed = Model();
                this.addSyncSource(model.sampledBy(lensed.syncEvents(), function(full, lensedSync) {
                    return valueLens.set(lensedSync, lens.set(full, lensedSync.value));
                }));
                lensed.addSyncSource(this.syncEvents().map(function(e) {
                    return valueLens.set(e, lens.get(e.value));
                }));
                return lensed;
            };
            model.syncConverter = id;
            if (arguments.length >= 1) model.set(initValue);
            return model;
        };
        Bacon.Model.syncCount = 0;
        Model.combine = function(template) {
            var initValue, key, lens, lensedModel, model, value;
            if (typeof template !== "object") return Model(template);
            else if (isModel(template)) return template;
            else {
                initValue = template instanceof Array ? [] : {};
                model = Model(initValue);
                for(key in template){
                    value = template[key];
                    lens = Lens.objectLens(key);
                    lensedModel = model.lens(lens);
                    lensedModel.bind(Model.combine(value));
                }
                return model;
            }
        };
        Bacon.Binding = function(_arg) {
            var events, externalChanges, get, initValue, inputs, model, set;
            initValue = _arg.initValue, get = _arg.get, events = _arg.events, set = _arg.set;
            inputs = events.map(get);
            if (initValue != null) set(initValue);
            else initValue = get();
            model = Bacon.Model(initValue);
            externalChanges = model.addSource(inputs);
            externalChanges.assign(set);
            return model;
        };
        Lens = Bacon.Lens = function(lens) {
            if (typeof lens === "object") return lens;
            else return Lens.objectLens(lens);
        };
        Lens.id = Lens({
            get: function(x) {
                return x;
            },
            set: function(context, value) {
                return value;
            }
        });
        Lens.objectLens = function(path) {
            var keys, objectKeyLens;
            objectKeyLens = function(key) {
                return Lens({
                    get: function(x) {
                        return x != null ? x[key] : void 0;
                    },
                    set: function(context, value) {
                        return shallowCopy(context, key, value);
                    }
                });
            };
            keys = Bacon._.filter(nonEmpty, path.split("."));
            return Lens.compose.apply(Lens, Bacon._.map(objectKeyLens, keys));
        };
        Lens.compose = function() {
            var args, compose2;
            args = 1 <= arguments.length ? __slice.call(arguments, 0) : [];
            compose2 = function(outer, inner) {
                return Lens({
                    get: function(x) {
                        return inner.get(outer.get(x));
                    },
                    set: function(context, value) {
                        var innerContext, newInnerContext;
                        innerContext = outer.get(context);
                        newInnerContext = inner.set(innerContext, value);
                        return outer.set(context, newInnerContext);
                    }
                });
            };
            return fold(args, Lens.id, compose2);
        };
        valueLens = Lens.objectLens("value");
        shallowCopy = function(x, key, value) {
            var copy, k, v;
            copy = x instanceof Array ? [] : {};
            for(k in x){
                v = x[k];
                copy[k] = v;
            }
            if (key != null) copy[key] = value;
            return copy;
        };
        return Bacon;
    };
    if (module !== null) {
        Bacon = (parcelRequire("4D64z"));
        module.exports = init(Bacon);
    } else if (typeof define === "function" && define.amd) define([
        "bacon"
    ], init);
    else init(this.Bacon);
}).call(this);

});
parcelRegister("4D64z", function(module, exports) {
(function() {
    var _slice = Array.prototype.slice;
    var Bacon = {
        toString: function() {
            return "Bacon";
        }
    };
    Bacon.version = '0.7.95';
    var Exception = (typeof $parcel$global !== "undefined" && $parcel$global !== null ? $parcel$global : this).Error;
    var nop = function() {};
    var latter = function(_, x) {
        return x;
    };
    var former = function(x, _) {
        return x;
    };
    var cloneArray = function(xs) {
        return xs.slice(0);
    };
    var assert = function(message, condition) {
        if (!condition) throw new Exception(message);
    };
    var assertObservableIsProperty = function(x) {
        if ((x != null ? x._isObservable : void 0) && !(x != null ? x._isProperty : void 0)) throw new Exception("Observable is not a Property : " + x);
    };
    var assertEventStream = function(event) {
        if (!(event != null ? event._isEventStream : void 0)) throw new Exception("not an EventStream : " + event);
    };
    var assertObservable = function(event) {
        if (!(event != null ? event._isObservable : void 0)) throw new Exception("not an Observable : " + event);
    };
    var assertFunction = function(f) {
        return assert("not a function : " + f, _.isFunction(f));
    };
    var isArray = Array.isArray || function(xs) {
        return xs instanceof Array;
    };
    var isObservable = function(x) {
        return x && x._isObservable;
    };
    var assertArray = function(xs) {
        if (!isArray(xs)) throw new Exception("not an array : " + xs);
    };
    var assertNoArguments = function(args) {
        return assert("no arguments supported", args.length === 0);
    };
    var assertString = function(x) {
        if (typeof x === "string") throw new Exception("not a string : " + x);
    };
    var extend = function(target) {
        var length = arguments.length;
        for(var i = 1; 1 < length ? i < length : i > length; 1 < length ? i++ : i--)for(var prop in arguments[i])target[prop] = arguments[i][prop];
        return target;
    };
    var inherit = function(child, parent) {
        var hasProp = {}.hasOwnProperty;
        var ctor = function() {};
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        return child;
    };
    var symbol = function(key) {
        if (typeof Symbol !== "undefined" && Symbol[key]) return Symbol[key];
        else if (typeof Symbol !== "undefined" && typeof Symbol["for"] === "function") return Symbol[key] = Symbol["for"](key);
        else return "@@" + key;
    };
    var _ = {
        indexOf: function() {
            if (Array.prototype.indexOf) return function(xs, x) {
                return xs.indexOf(x);
            };
            else return function(xs, x) {
                for(var i = 0, y; i < xs.length; i++){
                    y = xs[i];
                    if (x === y) return i;
                }
                return -1;
            };
        }(),
        indexWhere: function(xs, f) {
            for(var i = 0, y; i < xs.length; i++){
                y = xs[i];
                if (f(y)) return i;
            }
            return -1;
        },
        head: function(xs) {
            return xs[0];
        },
        always: function(x) {
            return function() {
                return x;
            };
        },
        negate: function(f) {
            return function(x) {
                return !f(x);
            };
        },
        empty: function(xs) {
            return xs.length === 0;
        },
        tail: function(xs) {
            return xs.slice(1, xs.length);
        },
        filter: function(f, xs) {
            var filtered = [];
            for(var i = 0, x; i < xs.length; i++){
                x = xs[i];
                if (f(x)) filtered.push(x);
            }
            return filtered;
        },
        map: function(f, xs) {
            return function() {
                var result = [];
                for(var i = 0, x; i < xs.length; i++){
                    x = xs[i];
                    result.push(f(x));
                }
                return result;
            }();
        },
        each: function(xs, f) {
            for(var key in xs)if (Object.prototype.hasOwnProperty.call(xs, key)) {
                var value = xs[key];
                f(key, value);
            }
        },
        toArray: function(xs) {
            return isArray(xs) ? xs : [
                xs
            ];
        },
        contains: function(xs, x) {
            return _.indexOf(xs, x) !== -1;
        },
        id: function(x) {
            return x;
        },
        last: function(xs) {
            return xs[xs.length - 1];
        },
        all: function(xs) {
            var f = arguments.length <= 1 || arguments[1] === undefined ? _.id : arguments[1];
            for(var i = 0, x; i < xs.length; i++){
                x = xs[i];
                if (!f(x)) return false;
            }
            return true;
        },
        any: function(xs) {
            var f = arguments.length <= 1 || arguments[1] === undefined ? _.id : arguments[1];
            for(var i = 0, x; i < xs.length; i++){
                x = xs[i];
                if (f(x)) return true;
            }
            return false;
        },
        without: function(x, xs) {
            return _.filter(function(y) {
                return y !== x;
            }, xs);
        },
        remove: function(x, xs) {
            var i = _.indexOf(xs, x);
            if (i >= 0) return xs.splice(i, 1);
        },
        fold: function(xs, seed, f) {
            for(var i = 0, x; i < xs.length; i++){
                x = xs[i];
                seed = f(seed, x);
            }
            return seed;
        },
        flatMap: function(f, xs) {
            return _.fold(xs, [], function(ys, x) {
                return ys.concat(f(x));
            });
        },
        cached: function(f) {
            var value = None;
            return function() {
                if (typeof value !== "undefined" && value !== null ? value._isNone : undefined) {
                    value = f();
                    f = undefined;
                }
                return value;
            };
        },
        bind: function(fn, me) {
            return function() {
                return fn.apply(me, arguments);
            };
        },
        isFunction: function(f) {
            return typeof f === "function";
        },
        toString: function(obj) {
            var internals, key, value;
            var hasProp = {}.hasOwnProperty;
            try {
                recursionDepth++;
                if (obj == null) return "undefined";
                else if (_.isFunction(obj)) return "function";
                else if (isArray(obj)) {
                    if (recursionDepth > 5) return "[..]";
                    return "[" + _.map(_.toString, obj).toString() + "]";
                } else if ((obj != null ? obj.toString : void 0) != null && obj.toString !== Object.prototype.toString) return obj.toString();
                else if (typeof obj === "object") {
                    if (recursionDepth > 5) return "{..}";
                    internals = function() {
                        var results = [];
                        for(key in obj){
                            if (!hasProp.call(obj, key)) continue;
                            value = function() {
                                var error;
                                try {
                                    return obj[key];
                                } catch (error) {
                                    return error;
                                }
                            }();
                            results.push(_.toString(key) + ":" + _.toString(value));
                        }
                        return results;
                    }();
                    return "{" + internals + "}";
                } else return obj;
            } finally{
                recursionDepth--;
            }
        }
    };
    var recursionDepth = 0;
    Bacon._ = _;
    var UpdateBarrier = Bacon.UpdateBarrier = function() {
        var rootEvent;
        var waiterObs = [];
        var waiters = {};
        var aftersStack = [];
        var aftersStackHeight = 0;
        var flushed = {};
        function ensureStackHeight(h) {
            if (h <= aftersStackHeight) return;
            if (!aftersStack[h - 1]) aftersStack[h - 1] = [
                [],
                0
            ];
            aftersStackHeight = h;
        }
        var afterTransaction = function(obs, f) {
            if (rootEvent || aftersStack.length) {
                ensureStackHeight(1);
                var stackIndexForThisObs = 0;
                while(stackIndexForThisObs < aftersStackHeight - 1){
                    if (containsObs(obs, aftersStack[stackIndexForThisObs][0])) break;
                    stackIndexForThisObs++;
                }
                var listFromStack = aftersStack[stackIndexForThisObs][0];
                listFromStack.push([
                    obs,
                    f
                ]);
                if (!rootEvent) processAfters();
            } else return f();
        };
        function containsObs(obs, aftersList) {
            for(var i = 0; i < aftersList.length; i++){
                if (aftersList[i][0].id == obs.id) return true;
            }
            return false;
        }
        function processAfters() {
            var stackSizeAtStart = aftersStackHeight;
            if (!stackSizeAtStart) return;
            while(aftersStackHeight >= stackSizeAtStart){
                var topOfStack = aftersStack[aftersStackHeight - 1];
                if (!topOfStack) throw new Error("Unexpected stack top: " + topOfStack);
                var topAfters = topOfStack[0];
                var index = topOfStack[1];
                if (index < topAfters.length) {
                    var _topAfters$index = topAfters[index];
                    var obs = _topAfters$index[0];
                    var after = _topAfters$index[1];
                    topOfStack[1]++;
                    ensureStackHeight(aftersStackHeight + 1);
                    var callSuccess = false;
                    try {
                        after();
                        callSuccess = true;
                        while(aftersStackHeight > stackSizeAtStart && aftersStack[aftersStackHeight - 1][0].length == 0)aftersStackHeight--;
                    } finally{
                        if (!callSuccess) {
                            aftersStack = [];
                            aftersStackHeight = 0;
                        }
                    }
                } else {
                    topOfStack[0] = [];
                    topOfStack[1] = 0;
                    break;
                }
            }
        }
        var whenDoneWith = function(obs, f) {
            if (rootEvent) {
                var obsWaiters = waiters[obs.id];
                if (!(typeof obsWaiters !== "undefined" && obsWaiters !== null)) {
                    obsWaiters = waiters[obs.id] = [
                        f
                    ];
                    return waiterObs.push(obs);
                } else return obsWaiters.push(f);
            } else return f();
        };
        var flush = function() {
            while(waiterObs.length > 0)flushWaiters(0, true);
            flushed = {};
        };
        var flushWaiters = function(index, deps) {
            var obs = waiterObs[index];
            var obsId = obs.id;
            var obsWaiters = waiters[obsId];
            waiterObs.splice(index, 1);
            delete waiters[obsId];
            if (deps && waiterObs.length > 0) flushDepsOf(obs);
            for(var i = 0, f; i < obsWaiters.length; i++){
                f = obsWaiters[i];
                f();
            }
        };
        var flushDepsOf = function(obs) {
            if (flushed[obs.id]) return;
            var deps = obs.internalDeps();
            for(var i = 0, dep; i < deps.length; i++){
                dep = deps[i];
                flushDepsOf(dep);
                if (waiters[dep.id]) {
                    var index = _.indexOf(waiterObs, dep);
                    flushWaiters(index, false);
                }
            }
            flushed[obs.id] = true;
        };
        var inTransaction = function(event, context, f, args) {
            if (rootEvent) return f.apply(context, args);
            else {
                rootEvent = event;
                try {
                    var result = f.apply(context, args);
                    flush();
                } finally{
                    rootEvent = undefined;
                    processAfters();
                }
                return result;
            }
        };
        var currentEventId = function() {
            return rootEvent ? rootEvent.id : undefined;
        };
        var wrappedSubscribe = function(obs, sink) {
            var unsubd = false;
            var shouldUnsub = false;
            var doUnsub = function() {
                shouldUnsub = true;
                return shouldUnsub;
            };
            var unsub = function() {
                unsubd = true;
                return doUnsub();
            };
            doUnsub = obs.dispatcher.subscribe(function(event) {
                return afterTransaction(obs, function() {
                    if (!unsubd) {
                        var reply = sink(event);
                        if (reply === Bacon.noMore) return unsub();
                    }
                });
            });
            if (shouldUnsub) doUnsub();
            return unsub;
        };
        var hasWaiters = function() {
            return waiterObs.length > 0;
        };
        return {
            whenDoneWith: whenDoneWith,
            hasWaiters: hasWaiters,
            inTransaction: inTransaction,
            currentEventId: currentEventId,
            wrappedSubscribe: wrappedSubscribe,
            afterTransaction: afterTransaction
        };
    }();
    function Source(obs, sync) {
        var lazy = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
        this.obs = obs;
        this.sync = sync;
        this.lazy = lazy;
        this.queue = [];
    }
    extend(Source.prototype, {
        _isSource: true,
        subscribe: function(sink) {
            return this.obs.dispatcher.subscribe(sink);
        },
        toString: function() {
            return this.obs.toString();
        },
        markEnded: function() {
            this.ended = true;
            return true;
        },
        consume: function() {
            if (this.lazy) return {
                value: _.always(this.queue[0])
            };
            else return this.queue[0];
        },
        push: function(x) {
            this.queue = [
                x
            ];
            return [
                x
            ];
        },
        mayHave: function() {
            return true;
        },
        hasAtLeast: function() {
            return this.queue.length;
        },
        flatten: true
    });
    function ConsumingSource() {
        Source.apply(this, arguments);
    }
    inherit(ConsumingSource, Source);
    extend(ConsumingSource.prototype, {
        consume: function() {
            return this.queue.shift();
        },
        push: function(x) {
            return this.queue.push(x);
        },
        mayHave: function(c) {
            return !this.ended || this.queue.length >= c;
        },
        hasAtLeast: function(c) {
            return this.queue.length >= c;
        },
        flatten: false
    });
    function BufferingSource(obs) {
        Source.call(this, obs, true);
    }
    inherit(BufferingSource, Source);
    extend(BufferingSource.prototype, {
        consume: function() {
            var values = this.queue;
            this.queue = [];
            return {
                value: function() {
                    return values;
                }
            };
        },
        push: function(x) {
            return this.queue.push(x.value());
        },
        hasAtLeast: function() {
            return true;
        }
    });
    Source.isTrigger = function(s) {
        if (s != null ? s._isSource : void 0) return s.sync;
        else return s != null ? s._isEventStream : void 0;
    };
    Source.fromObservable = function(s) {
        if (s != null ? s._isSource : void 0) return s;
        else if (s != null ? s._isProperty : void 0) return new Source(s, false);
        else return new ConsumingSource(s, true);
    };
    function Desc(context, method, args) {
        this.context = context;
        this.method = method;
        this.args = args;
    }
    extend(Desc.prototype, {
        _isDesc: true,
        deps: function() {
            if (!this.cached) this.cached = findDeps([
                this.context
            ].concat(this.args));
            return this.cached;
        },
        toString: function() {
            return _.toString(this.context) + "." + _.toString(this.method) + "(" + _.map(_.toString, this.args) + ")";
        }
    });
    var describe = function(context, method) {
        var ref = context || method;
        if (ref && ref._isDesc) return context || method;
        else {
            for(var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
            return new Desc(context, method, args);
        }
    };
    var withDesc = function(desc, obs) {
        obs.desc = desc;
        return obs;
    };
    var findDeps = function(x) {
        if (isArray(x)) return _.flatMap(findDeps, x);
        else if (isObservable(x)) return [
            x
        ];
        else if (typeof x !== "undefined" && x !== null ? x._isSource : undefined) return [
            x.obs
        ];
        else return [];
    };
    Bacon.Desc = Desc;
    Bacon.Desc.empty = new Bacon.Desc("", "", []);
    var withMethodCallSupport = function(wrapped) {
        return function(f) {
            for(var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
            if (typeof f === "object" && args.length) {
                var context = f;
                var methodName = args[0];
                f = function() {
                    return context[methodName].apply(context, arguments);
                };
                args = args.slice(1);
            }
            return wrapped.apply(undefined, [
                f
            ].concat(args));
        };
    };
    var makeFunctionArgs = function(args) {
        args = Array.prototype.slice.call(args);
        return makeFunction_.apply(undefined, args);
    };
    var partiallyApplied = function(f, applied) {
        return function() {
            for(var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            return f.apply(undefined, applied.concat(args));
        };
    };
    var toSimpleExtractor = function(args) {
        return function(key) {
            return function(value) {
                if (!(typeof value !== "undefined" && value !== null)) return;
                else {
                    var fieldValue = value[key];
                    if (_.isFunction(fieldValue)) return fieldValue.apply(value, args);
                    else return fieldValue;
                }
            };
        };
    };
    var toFieldExtractor = function(f, args) {
        var parts = f.slice(1).split(".");
        var partFuncs = _.map(toSimpleExtractor(args), parts);
        return function(value) {
            for(var i = 0, f; i < partFuncs.length; i++){
                f = partFuncs[i];
                value = f(value);
            }
            return value;
        };
    };
    var isFieldKey = function(f) {
        return typeof f === "string" && f.length > 1 && f.charAt(0) === ".";
    };
    var makeFunction_ = withMethodCallSupport(function(f) {
        for(var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
        if (_.isFunction(f)) {
            if (args.length) return partiallyApplied(f, args);
            else return f;
        } else if (isFieldKey(f)) return toFieldExtractor(f, args);
        else return _.always(f);
    });
    var makeFunction = function(f, args) {
        return makeFunction_.apply(undefined, [
            f
        ].concat(args));
    };
    var convertArgsToFunction = function(obs, f, args, method) {
        if (typeof f !== "undefined" && f !== null ? f._isProperty : undefined) {
            var sampled = f.sampledBy(obs, function(p, s) {
                return [
                    p,
                    s
                ];
            });
            return method.call(sampled, function(_ref) {
                var p = _ref[0];
                var s = _ref[1];
                return p;
            }).map(function(_ref2) {
                var p = _ref2[0];
                var s = _ref2[1];
                return s;
            });
        } else {
            f = makeFunction(f, args);
            return method.call(obs, f);
        }
    };
    var toCombinator = function(f) {
        if (_.isFunction(f)) return f;
        else if (isFieldKey(f)) {
            var key = toFieldKey(f);
            return function(left, right) {
                return left[key](right);
            };
        } else throw new Exception("not a function or a field key: " + f);
    };
    var toFieldKey = function(f) {
        return f.slice(1);
    };
    function Some(value) {
        this.value = value;
    }
    extend(Some.prototype, {
        _isSome: true,
        getOrElse: function() {
            return this.value;
        },
        get: function() {
            return this.value;
        },
        filter: function(f) {
            if (f(this.value)) return new Some(this.value);
            else return None;
        },
        map: function(f) {
            return new Some(f(this.value));
        },
        forEach: function(f) {
            return f(this.value);
        },
        isDefined: true,
        toArray: function() {
            return [
                this.value
            ];
        },
        inspect: function() {
            return "Some(" + this.value + ")";
        },
        toString: function() {
            return this.inspect();
        }
    });
    var None = {
        _isNone: true,
        getOrElse: function(value) {
            return value;
        },
        filter: function() {
            return None;
        },
        map: function() {
            return None;
        },
        forEach: function() {},
        isDefined: false,
        toArray: function() {
            return [];
        },
        inspect: function() {
            return "None";
        },
        toString: function() {
            return this.inspect();
        }
    };
    var toOption = function(v) {
        if ((typeof v !== "undefined" && v !== null ? v._isSome : undefined) || (typeof v !== "undefined" && v !== null ? v._isNone : undefined)) return v;
        else return new Some(v);
    };
    Bacon.noMore = "<no-more>";
    Bacon.more = "<more>";
    var eventIdCounter = 0;
    function Event() {
        this.id = ++eventIdCounter;
    }
    Event.prototype._isEvent = true;
    Event.prototype.isEvent = function() {
        return true;
    };
    Event.prototype.isEnd = function() {
        return false;
    };
    Event.prototype.isInitial = function() {
        return false;
    };
    Event.prototype.isNext = function() {
        return false;
    };
    Event.prototype.isError = function() {
        return false;
    };
    Event.prototype.hasValue = function() {
        return false;
    };
    Event.prototype.filter = function() {
        return true;
    };
    Event.prototype.inspect = function() {
        return this.toString();
    };
    Event.prototype.log = function() {
        return this.toString();
    };
    function Next(valueF, eager) {
        if (!(this instanceof Next)) return new Next(valueF, eager);
        Event.call(this);
        if (!eager && _.isFunction(valueF) || (valueF != null ? valueF._isNext : void 0)) {
            this.valueF = valueF;
            this.valueInternal = void 0;
        } else {
            this.valueF = void 0;
            this.valueInternal = valueF;
        }
    }
    inherit(Next, Event);
    Next.prototype.isNext = function() {
        return true;
    };
    Next.prototype.hasValue = function() {
        return true;
    };
    Next.prototype.value = function() {
        var ref;
        if ((ref = this.valueF) != null ? ref._isNext : void 0) {
            this.valueInternal = this.valueF.value();
            this.valueF = void 0;
        } else if (this.valueF) {
            this.valueInternal = this.valueF();
            this.valueF = void 0;
        }
        return this.valueInternal;
    };
    Next.prototype.fmap = function(f) {
        var event, value;
        if (this.valueInternal) {
            value = this.valueInternal;
            return this.apply(function() {
                return f(value);
            });
        } else {
            event = this;
            return this.apply(function() {
                return f(event.value());
            });
        }
    };
    Next.prototype.apply = function(value) {
        return new Next(value);
    };
    Next.prototype.filter = function(f) {
        return f(this.value());
    };
    Next.prototype.toString = function() {
        return _.toString(this.value());
    };
    Next.prototype.log = function() {
        return this.value();
    };
    Next.prototype._isNext = true;
    function Initial(valueF, eager) {
        if (!(this instanceof Initial)) return new Initial(valueF, eager);
        Next.call(this, valueF, eager);
    }
    inherit(Initial, Next);
    Initial.prototype._isInitial = true;
    Initial.prototype.isInitial = function() {
        return true;
    };
    Initial.prototype.isNext = function() {
        return false;
    };
    Initial.prototype.apply = function(value) {
        return new Initial(value);
    };
    Initial.prototype.toNext = function() {
        return new Next(this);
    };
    function End() {
        if (!(this instanceof End)) return new End();
        Event.call(this);
    }
    inherit(End, Event);
    End.prototype.isEnd = function() {
        return true;
    };
    End.prototype.fmap = function() {
        return this;
    };
    End.prototype.apply = function() {
        return this;
    };
    End.prototype.toString = function() {
        return "<end>";
    };
    function Error(error) {
        if (!(this instanceof Error)) return new Error(error);
        this.error = error;
        Event.call(this);
    }
    inherit(Error, Event);
    Error.prototype.isError = function() {
        return true;
    };
    Error.prototype.fmap = function() {
        return this;
    };
    Error.prototype.apply = function() {
        return this;
    };
    Error.prototype.toString = function() {
        return "<error> " + _.toString(this.error);
    };
    Bacon.Event = Event;
    Bacon.Initial = Initial;
    Bacon.Next = Next;
    Bacon.End = End;
    Bacon.Error = Error;
    var initialEvent = function(value) {
        return new Initial(value, true);
    };
    var nextEvent = function(value) {
        return new Next(value, true);
    };
    var endEvent = function() {
        return new End();
    };
    var toEvent = function(x) {
        if (x && x._isEvent) return x;
        else return nextEvent(x);
    };
    var idCounter = 0;
    var registerObs = function() {};
    function Observable(desc) {
        this.desc = desc;
        this.id = ++idCounter;
        this.initialDesc = this.desc;
    }
    extend(Observable.prototype, {
        _isObservable: true,
        subscribe: function(sink) {
            return UpdateBarrier.wrappedSubscribe(this, sink);
        },
        subscribeInternal: function(sink) {
            return this.dispatcher.subscribe(sink);
        },
        onValue: function() {
            var f = makeFunctionArgs(arguments);
            return this.subscribe(function(event) {
                if (event.hasValue()) return f(event.value());
            });
        },
        onValues: function(f) {
            return this.onValue(function(args) {
                return f.apply(undefined, args);
            });
        },
        onError: function() {
            var f = makeFunctionArgs(arguments);
            return this.subscribe(function(event) {
                if (event.isError()) return f(event.error);
            });
        },
        onEnd: function() {
            var f = makeFunctionArgs(arguments);
            return this.subscribe(function(event) {
                if (event.isEnd()) return f();
            });
        },
        name: function(name) {
            this._name = name;
            return this;
        },
        withDescription: function() {
            this.desc = describe.apply(undefined, arguments);
            return this;
        },
        toString: function() {
            if (this._name) return this._name;
            else return this.desc.toString();
        },
        deps: function() {
            return this.desc.deps();
        },
        internalDeps: function() {
            return this.initialDesc.deps();
        }
    });
    Observable.prototype.assign = Observable.prototype.onValue;
    Observable.prototype.forEach = Observable.prototype.onValue;
    Observable.prototype.inspect = Observable.prototype.toString;
    Bacon.Observable = Observable;
    function CompositeUnsubscribe() {
        var ss = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
        this.unsubscribe = _.bind(this.unsubscribe, this);
        this.unsubscribed = false;
        this.subscriptions = [];
        this.starting = [];
        for(var i = 0, s; i < ss.length; i++){
            s = ss[i];
            this.add(s);
        }
    }
    extend(CompositeUnsubscribe.prototype, {
        add: function(subscription) {
            var _this2 = this;
            if (this.unsubscribed) return;
            var ended = false;
            var unsub = nop;
            this.starting.push(subscription);
            var unsubMe = function() {
                if (_this2.unsubscribed) return;
                ended = true;
                _this2.remove(unsub);
                return _.remove(subscription, _this2.starting);
            };
            unsub = subscription(this.unsubscribe, unsubMe);
            if (!(this.unsubscribed || ended)) this.subscriptions.push(unsub);
            else unsub();
            _.remove(subscription, this.starting);
            return unsub;
        },
        remove: function(unsub) {
            if (this.unsubscribed) return;
            if (_.remove(unsub, this.subscriptions) !== undefined) return unsub();
        },
        unsubscribe: function() {
            if (this.unsubscribed) return;
            this.unsubscribed = true;
            var iterable = this.subscriptions;
            for(var i = 0; i < iterable.length; i++)iterable[i]();
            this.subscriptions = [];
            this.starting = [];
            return [];
        },
        count: function() {
            if (this.unsubscribed) return 0;
            return this.subscriptions.length + this.starting.length;
        },
        empty: function() {
            return this.count() === 0;
        }
    });
    Bacon.CompositeUnsubscribe = CompositeUnsubscribe;
    function Dispatcher(_subscribe, _handleEvent) {
        this._subscribe = _subscribe;
        this._handleEvent = _handleEvent;
        this.subscribe = _.bind(this.subscribe, this);
        this.handleEvent = _.bind(this.handleEvent, this);
        this.pushing = false;
        this.ended = false;
        this.prevError = undefined;
        this.unsubSrc = undefined;
        this.subscriptions = [];
        this.queue = [];
    }
    Dispatcher.prototype.hasSubscribers = function() {
        return this.subscriptions.length > 0;
    };
    Dispatcher.prototype.removeSub = function(subscription) {
        this.subscriptions = _.without(subscription, this.subscriptions);
        return this.subscriptions;
    };
    Dispatcher.prototype.push = function(event) {
        if (event.isEnd()) this.ended = true;
        return UpdateBarrier.inTransaction(event, this, this.pushIt, [
            event
        ]);
    };
    Dispatcher.prototype.pushToSubscriptions = function(event) {
        try {
            var tmp = this.subscriptions;
            var len = tmp.length;
            for(var i = 0; i < len; i++){
                var sub = tmp[i];
                var reply = sub.sink(event);
                if (reply === Bacon.noMore || event.isEnd()) this.removeSub(sub);
            }
            return true;
        } catch (error) {
            this.pushing = false;
            this.queue = [];
            throw error;
        }
    };
    Dispatcher.prototype.pushIt = function(event) {
        if (!this.pushing) {
            if (event === this.prevError) return;
            if (event.isError()) this.prevError = event;
            this.pushing = true;
            this.pushToSubscriptions(event);
            this.pushing = false;
            while(this.queue.length){
                event = this.queue.shift();
                this.push(event);
            }
            if (this.hasSubscribers()) return Bacon.more;
            else {
                this.unsubscribeFromSource();
                return Bacon.noMore;
            }
        } else {
            this.queue.push(event);
            return Bacon.more;
        }
    };
    Dispatcher.prototype.handleEvent = function(event) {
        if (this._handleEvent) return this._handleEvent(event);
        else return this.push(event);
    };
    Dispatcher.prototype.unsubscribeFromSource = function() {
        if (this.unsubSrc) this.unsubSrc();
        this.unsubSrc = undefined;
    };
    Dispatcher.prototype.subscribe = function(sink) {
        var subscription;
        if (this.ended) {
            sink(endEvent());
            return nop;
        } else {
            assertFunction(sink);
            subscription = {
                sink: sink
            };
            this.subscriptions.push(subscription);
            if (this.subscriptions.length === 1) {
                this.unsubSrc = this._subscribe(this.handleEvent);
                assertFunction(this.unsubSrc);
            }
            return function(_this) {
                return function() {
                    _this.removeSub(subscription);
                    if (!_this.hasSubscribers()) return _this.unsubscribeFromSource();
                };
            }(this);
        }
    };
    Bacon.Dispatcher = Dispatcher;
    function EventStream(desc, subscribe, handler) {
        if (!(this instanceof EventStream)) return new EventStream(desc, subscribe, handler);
        if (_.isFunction(desc)) {
            handler = subscribe;
            subscribe = desc;
            desc = Desc.empty;
        }
        Observable.call(this, desc);
        assertFunction(subscribe);
        this.dispatcher = new Dispatcher(subscribe, handler);
        registerObs(this);
    }
    inherit(EventStream, Observable);
    extend(EventStream.prototype, {
        _isEventStream: true,
        toProperty: function(initValue_) {
            var initValue = arguments.length === 0 ? None : toOption(function() {
                return initValue_;
            });
            var disp = this.dispatcher;
            var desc = new Bacon.Desc(this, "toProperty", [
                initValue_
            ]);
            return new Property(desc, function(sink) {
                var initSent = false;
                var subbed = false;
                var unsub = nop;
                var reply = Bacon.more;
                var sendInit = function() {
                    if (!initSent) return initValue.forEach(function(value) {
                        initSent = true;
                        reply = sink(new Initial(value));
                        if (reply === Bacon.noMore) {
                            unsub();
                            unsub = nop;
                            return nop;
                        }
                    });
                };
                unsub = disp.subscribe(function(event) {
                    if (event.hasValue()) {
                        if (event.isInitial() && !subbed) {
                            initValue = new Some(function() {
                                return event.value();
                            });
                            return Bacon.more;
                        } else {
                            if (!event.isInitial()) sendInit();
                            initSent = true;
                            initValue = new Some(event);
                            return sink(event);
                        }
                    } else {
                        if (event.isEnd()) reply = sendInit();
                        if (reply !== Bacon.noMore) return sink(event);
                    }
                });
                subbed = true;
                sendInit();
                return unsub;
            });
        },
        toEventStream: function() {
            return this;
        },
        withHandler: function(handler) {
            return new EventStream(new Bacon.Desc(this, "withHandler", [
                handler
            ]), this.dispatcher.subscribe, handler);
        }
    });
    Bacon.EventStream = EventStream;
    Bacon.never = function() {
        return new EventStream(describe(Bacon, "never"), function(sink) {
            sink(endEvent());
            return nop;
        });
    };
    Bacon.when = function() {
        if (arguments.length === 0) return Bacon.never();
        var len = arguments.length;
        var usage = "when: expecting arguments in the form (Observable+,function)+";
        assert(usage, len % 2 === 0);
        var sources = [];
        var pats = [];
        var i = 0;
        var patterns = [];
        while(i < len){
            patterns[i] = arguments[i];
            patterns[i + 1] = arguments[i + 1];
            var patSources = _.toArray(arguments[i]);
            var f = constantToFunction(arguments[i + 1]);
            var pat = {
                f: f,
                ixs: []
            };
            var triggerFound = false;
            for(var j = 0, s; j < patSources.length; j++){
                s = patSources[j];
                var index = _.indexOf(sources, s);
                if (!triggerFound) triggerFound = Source.isTrigger(s);
                if (index < 0) {
                    sources.push(s);
                    index = sources.length - 1;
                }
                for(var k = 0, ix; k < pat.ixs.length; k++){
                    ix = pat.ixs[k];
                    if (ix.index === index) ix.count++;
                }
                pat.ixs.push({
                    index: index,
                    count: 1
                });
            }
            assert("At least one EventStream required", triggerFound || !patSources.length);
            if (patSources.length > 0) pats.push(pat);
            i = i + 2;
        }
        if (!sources.length) return Bacon.never();
        sources = _.map(Source.fromObservable, sources);
        var needsBarrier = _.any(sources, function(s) {
            return s.flatten;
        }) && containsDuplicateDeps(_.map(function(s) {
            return s.obs;
        }, sources));
        var desc = new Bacon.Desc(Bacon, "when", patterns);
        var resultStream = new EventStream(desc, function(sink) {
            var triggers = [];
            var ends = false;
            var match = function(p) {
                for(var i1 = 0, i; i1 < p.ixs.length; i1++){
                    i = p.ixs[i1];
                    if (!sources[i.index].hasAtLeast(i.count)) return false;
                }
                return true;
            };
            var cannotSync = function(source) {
                return !source.sync || source.ended;
            };
            var cannotMatch = function(p) {
                for(var i1 = 0, i; i1 < p.ixs.length; i1++){
                    i = p.ixs[i1];
                    if (!sources[i.index].mayHave(i.count)) return true;
                }
            };
            var nonFlattened = function(trigger) {
                return !trigger.source.flatten;
            };
            var part = function(source) {
                return function(unsubAll) {
                    var flushLater = function() {
                        return UpdateBarrier.whenDoneWith(resultStream, flush);
                    };
                    var flushWhileTriggers = function() {
                        if (triggers.length > 0) {
                            var reply = Bacon.more;
                            var trigger = triggers.pop();
                            for(var i1 = 0, p; i1 < pats.length; i1++){
                                p = pats[i1];
                                if (match(p)) {
                                    var events = function() {
                                        var result = [];
                                        for(var i2 = 0, i; i2 < p.ixs.length; i2++){
                                            i = p.ixs[i2];
                                            result.push(sources[i.index].consume());
                                        }
                                        return result;
                                    }();
                                    reply = sink(trigger.e.apply(function() {
                                        var _p;
                                        var values = function() {
                                            var result = [];
                                            for(var i2 = 0, event; i2 < events.length; i2++){
                                                event = events[i2];
                                                result.push(event.value());
                                            }
                                            return result;
                                        }();
                                        return (_p = p).f.apply(_p, values);
                                    }));
                                    if (triggers.length) triggers = _.filter(nonFlattened, triggers);
                                    if (reply === Bacon.noMore) return reply;
                                    else return flushWhileTriggers();
                                }
                            }
                        } else return Bacon.more;
                    };
                    var flush = function() {
                        var reply = flushWhileTriggers();
                        if (ends) {
                            if (_.all(sources, cannotSync) || _.all(pats, cannotMatch)) {
                                reply = Bacon.noMore;
                                sink(endEvent());
                            }
                        }
                        if (reply === Bacon.noMore) unsubAll();
                        return reply;
                    };
                    return source.subscribe(function(e) {
                        if (e.isEnd()) {
                            ends = true;
                            source.markEnded();
                            flushLater();
                        } else if (e.isError()) var reply = sink(e);
                        else {
                            source.push(e);
                            if (source.sync) {
                                triggers.push({
                                    source: source,
                                    e: e
                                });
                                if (needsBarrier || UpdateBarrier.hasWaiters()) flushLater();
                                else flush();
                            }
                        }
                        if (reply === Bacon.noMore) unsubAll();
                        return reply || Bacon.more;
                    });
                };
            };
            return new Bacon.CompositeUnsubscribe(function() {
                var result = [];
                for(var i1 = 0, s; i1 < sources.length; i1++){
                    s = sources[i1];
                    result.push(part(s));
                }
                return result;
            }()).unsubscribe;
        });
        return resultStream;
    };
    var containsDuplicateDeps = function(observables) {
        var state = arguments.length <= 1 || arguments[1] === undefined ? [] : arguments[1];
        var checkObservable = function(obs) {
            if (_.contains(state, obs)) return true;
            else {
                var deps = obs.internalDeps();
                if (deps.length) {
                    state.push(obs);
                    return _.any(deps, checkObservable);
                } else {
                    state.push(obs);
                    return false;
                }
            }
        };
        return _.any(observables, checkObservable);
    };
    var constantToFunction = function(f) {
        if (_.isFunction(f)) return f;
        else return _.always(f);
    };
    Bacon.groupSimultaneous = function() {
        for(var _len5 = arguments.length, streams = Array(_len5), _key5 = 0; _key5 < _len5; _key5++)streams[_key5] = arguments[_key5];
        if (streams.length === 1 && isArray(streams[0])) streams = streams[0];
        var sources = function() {
            var result = [];
            for(var i = 0, s; i < streams.length; i++){
                s = streams[i];
                result.push(new BufferingSource(s));
            }
            return result;
        }();
        return withDesc(new Bacon.Desc(Bacon, "groupSimultaneous", streams), Bacon.when(sources, function() {
            for(var _len6 = arguments.length, xs = Array(_len6), _key6 = 0; _key6 < _len6; _key6++)xs[_key6] = arguments[_key6];
            return xs;
        }));
    };
    function PropertyDispatcher(property, subscribe, handleEvent) {
        Dispatcher.call(this, subscribe, handleEvent);
        this.property = property;
        this.subscribe = _.bind(this.subscribe, this);
        this.current = None;
        this.currentValueRootId = undefined;
        this.propertyEnded = false;
    }
    inherit(PropertyDispatcher, Dispatcher);
    extend(PropertyDispatcher.prototype, {
        push: function(event) {
            if (event.isEnd()) this.propertyEnded = true;
            if (event.hasValue()) {
                this.current = new Some(event);
                this.currentValueRootId = UpdateBarrier.currentEventId();
            }
            return Dispatcher.prototype.push.call(this, event);
        },
        maybeSubSource: function(sink, reply) {
            if (reply === Bacon.noMore) return nop;
            else if (this.propertyEnded) {
                sink(endEvent());
                return nop;
            } else return Dispatcher.prototype.subscribe.call(this, sink);
        },
        subscribe: function(sink) {
            var _this3 = this;
            var initSent = false;
            var reply = Bacon.more;
            if (this.current.isDefined && (this.hasSubscribers() || this.propertyEnded)) {
                var dispatchingId = UpdateBarrier.currentEventId();
                var valId = this.currentValueRootId;
                if (!this.propertyEnded && valId && dispatchingId && dispatchingId !== valId) {
                    UpdateBarrier.whenDoneWith(this.property, function() {
                        if (_this3.currentValueRootId === valId) return sink(initialEvent(_this3.current.get().value()));
                    });
                    return this.maybeSubSource(sink, reply);
                } else {
                    UpdateBarrier.inTransaction(undefined, this, function() {
                        reply = sink(initialEvent(this.current.get().value()));
                        return reply;
                    }, []);
                    return this.maybeSubSource(sink, reply);
                }
            } else return this.maybeSubSource(sink, reply);
        }
    });
    function Property(desc, subscribe, handler) {
        Observable.call(this, desc);
        assertFunction(subscribe);
        this.dispatcher = new PropertyDispatcher(this, subscribe, handler);
        registerObs(this);
    }
    inherit(Property, Observable);
    extend(Property.prototype, {
        _isProperty: true,
        changes: function() {
            var _this4 = this;
            return new EventStream(new Bacon.Desc(this, "changes", []), function(sink) {
                return _this4.dispatcher.subscribe(function(event) {
                    if (!event.isInitial()) return sink(event);
                });
            });
        },
        withHandler: function(handler) {
            return new Property(new Bacon.Desc(this, "withHandler", [
                handler
            ]), this.dispatcher.subscribe, handler);
        },
        toProperty: function() {
            assertNoArguments(arguments);
            return this;
        },
        toEventStream: function() {
            var _this5 = this;
            return new EventStream(new Bacon.Desc(this, "toEventStream", []), function(sink) {
                return _this5.dispatcher.subscribe(function(event) {
                    if (event.isInitial()) event = event.toNext();
                    return sink(event);
                });
            });
        }
    });
    Bacon.Property = Property;
    Bacon.constant = function(value) {
        return new Property(new Bacon.Desc(Bacon, "constant", [
            value
        ]), function(sink) {
            sink(initialEvent(value));
            sink(endEvent());
            return nop;
        });
    };
    Bacon.fromBinder = function(binder) {
        var eventTransformer = arguments.length <= 1 || arguments[1] === undefined ? _.id : arguments[1];
        var desc = new Bacon.Desc(Bacon, "fromBinder", [
            binder,
            eventTransformer
        ]);
        return new EventStream(desc, function(sink) {
            var unbound = false;
            var shouldUnbind = false;
            var unbind = function() {
                if (!unbound) {
                    if (typeof unbinder !== "undefined" && unbinder !== null) {
                        unbinder();
                        return unbound = true;
                    } else return shouldUnbind = true;
                }
            };
            var unbinder = binder(function() {
                var ref;
                for(var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++)args[_key7] = arguments[_key7];
                var value = eventTransformer.apply(this, args);
                if (!(isArray(value) && ((ref = _.last(value)) != null ? ref._isEvent : undefined))) value = [
                    value
                ];
                var reply = Bacon.more;
                for(var i = 0, event; i < value.length; i++){
                    event = value[i];
                    reply = sink(event = toEvent(event));
                    if (reply === Bacon.noMore || event.isEnd()) {
                        unbind();
                        return reply;
                    }
                }
                return reply;
            });
            if (shouldUnbind) unbind();
            return unbind;
        });
    };
    Bacon.Observable.prototype.map = function(p) {
        for(var _len8 = arguments.length, args = Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++)args[_key8 - 1] = arguments[_key8];
        return convertArgsToFunction(this, p, args, function(f) {
            return withDesc(new Bacon.Desc(this, "map", [
                f
            ]), this.withHandler(function(event) {
                return this.push(event.fmap(f));
            }));
        });
    };
    var argumentsToObservables = function(args) {
        if (isArray(args[0])) return args[0];
        else return Array.prototype.slice.call(args);
    };
    var argumentsToObservablesAndFunction = function(args) {
        if (_.isFunction(args[0])) return [
            argumentsToObservables(Array.prototype.slice.call(args, 1)),
            args[0]
        ];
        else return [
            argumentsToObservables(Array.prototype.slice.call(args, 0, args.length - 1)),
            _.last(args)
        ];
    };
    Bacon.combineAsArray = function() {
        var streams = argumentsToObservables(arguments);
        if (streams.length) {
            var sources = [];
            for(var i = 0; i < streams.length; i++){
                var stream = isObservable(streams[i]) ? streams[i] : Bacon.constant(streams[i]);
                sources.push(new Source(stream, true));
            }
            return withDesc(new Bacon.Desc(Bacon, "combineAsArray", streams), Bacon.when(sources, function() {
                for(var _len9 = arguments.length, xs = Array(_len9), _key9 = 0; _key9 < _len9; _key9++)xs[_key9] = arguments[_key9];
                return xs;
            }).toProperty());
        } else return Bacon.constant([]);
    };
    Bacon.onValues = function() {
        return Bacon.combineAsArray(Array.prototype.slice.call(arguments, 0, arguments.length - 1)).onValues(arguments[arguments.length - 1]);
    };
    Bacon.combineWith = function() {
        var _argumentsToObservablesAndFunction = argumentsToObservablesAndFunction(arguments);
        var streams = _argumentsToObservablesAndFunction[0];
        var f = _argumentsToObservablesAndFunction[1];
        var desc = new Bacon.Desc(Bacon, "combineWith", [
            f
        ].concat(streams));
        return withDesc(desc, Bacon.combineAsArray(streams).map(function(values) {
            return f.apply(undefined, values);
        }));
    };
    Bacon.Observable.prototype.combine = function(other, f) {
        var combinator = toCombinator(f);
        var desc = new Bacon.Desc(this, "combine", [
            other,
            f
        ]);
        return withDesc(desc, Bacon.combineAsArray(this, other).map(function(values) {
            return combinator(values[0], values[1]);
        }));
    };
    Bacon.Observable.prototype.withStateMachine = function(initState, f) {
        var state = initState;
        var desc = new Bacon.Desc(this, "withStateMachine", [
            initState,
            f
        ]);
        return withDesc(desc, this.withHandler(function(event) {
            var fromF = f(state, event);
            var newState = fromF[0];
            var outputs = fromF[1];
            state = newState;
            var reply = Bacon.more;
            for(var i = 0, output; i < outputs.length; i++){
                output = outputs[i];
                reply = this.push(output);
                if (reply === Bacon.noMore) return reply;
            }
            return reply;
        }));
    };
    var equals = function(a, b) {
        return a === b;
    };
    var isNone = function(object) {
        return typeof object !== "undefined" && object !== null ? object._isNone : false;
    };
    Bacon.Observable.prototype.skipDuplicates = function() {
        var isEqual = arguments.length <= 0 || arguments[0] === undefined ? equals : arguments[0];
        var desc = new Bacon.Desc(this, "skipDuplicates", []);
        return withDesc(desc, this.withStateMachine(None, function(prev, event) {
            if (!event.hasValue()) return [
                prev,
                [
                    event
                ]
            ];
            else if (event.isInitial() || isNone(prev) || !isEqual(prev.get(), event.value())) return [
                new Some(event.value()),
                [
                    event
                ]
            ];
            else return [
                prev,
                []
            ];
        }));
    };
    Bacon.Observable.prototype.awaiting = function(other) {
        var desc = new Bacon.Desc(this, "awaiting", [
            other
        ]);
        return withDesc(desc, Bacon.groupSimultaneous(this, other).map(function(values) {
            return values[1].length === 0;
        }).toProperty(false).skipDuplicates());
    };
    Bacon.Observable.prototype.not = function() {
        return withDesc(new Bacon.Desc(this, "not", []), this.map(function(x) {
            return !x;
        }));
    };
    Bacon.Property.prototype.and = function(other) {
        return withDesc(new Bacon.Desc(this, "and", [
            other
        ]), this.combine(other, function(x, y) {
            return x && y;
        }));
    };
    Bacon.Property.prototype.or = function(other) {
        return withDesc(new Bacon.Desc(this, "or", [
            other
        ]), this.combine(other, function(x, y) {
            return x || y;
        }));
    };
    Bacon.scheduler = {
        setTimeout: function(f, d) {
            return setTimeout(f, d);
        },
        setInterval: function(f, i) {
            return setInterval(f, i);
        },
        clearInterval: function(id) {
            return clearInterval(id);
        },
        clearTimeout: function(id) {
            return clearTimeout(id);
        },
        now: function() {
            return new Date().getTime();
        }
    };
    Bacon.EventStream.prototype.bufferWithTime = function(delay) {
        return withDesc(new Bacon.Desc(this, "bufferWithTime", [
            delay
        ]), this.bufferWithTimeOrCount(delay, Number.MAX_VALUE));
    };
    Bacon.EventStream.prototype.bufferWithCount = function(count) {
        return withDesc(new Bacon.Desc(this, "bufferWithCount", [
            count
        ]), this.bufferWithTimeOrCount(undefined, count));
    };
    Bacon.EventStream.prototype.bufferWithTimeOrCount = function(delay, count) {
        var flushOrSchedule = function(buffer) {
            if (buffer.values.length === count) return buffer.flush();
            else if (delay !== undefined) return buffer.schedule();
        };
        var desc = new Bacon.Desc(this, "bufferWithTimeOrCount", [
            delay,
            count
        ]);
        return withDesc(desc, this.buffer(delay, flushOrSchedule, flushOrSchedule));
    };
    Bacon.EventStream.prototype.buffer = function(delay) {
        var onInput = arguments.length <= 1 || arguments[1] === undefined ? nop : arguments[1];
        var onFlush = arguments.length <= 2 || arguments[2] === undefined ? nop : arguments[2];
        var buffer = {
            scheduled: null,
            end: undefined,
            values: [],
            flush: function() {
                if (this.scheduled) {
                    Bacon.scheduler.clearTimeout(this.scheduled);
                    this.scheduled = null;
                }
                if (this.values.length > 0) {
                    var valuesToPush = this.values;
                    this.values = [];
                    var reply = this.push(nextEvent(valuesToPush));
                    if (this.end != null) return this.push(this.end);
                    else if (reply !== Bacon.noMore) return onFlush(this);
                } else {
                    if (this.end != null) return this.push(this.end);
                }
            },
            schedule: function() {
                var _this6 = this;
                if (!this.scheduled) return this.scheduled = delay(function() {
                    return _this6.flush();
                });
            }
        };
        var reply = Bacon.more;
        if (!_.isFunction(delay)) {
            var delayMs = delay;
            delay = function(f) {
                return Bacon.scheduler.setTimeout(f, delayMs);
            };
        }
        return withDesc(new Bacon.Desc(this, "buffer", []), this.withHandler(function(event) {
            var _this7 = this;
            buffer.push = function(event) {
                return _this7.push(event);
            };
            if (event.isError()) reply = this.push(event);
            else if (event.isEnd()) {
                buffer.end = event;
                if (!buffer.scheduled) buffer.flush();
            } else {
                buffer.values.push(event.value());
                onInput(buffer);
            }
            return reply;
        }));
    };
    Bacon.Observable.prototype.filter = function(f) {
        assertObservableIsProperty(f);
        for(var _len10 = arguments.length, args = Array(_len10 > 1 ? _len10 - 1 : 0), _key10 = 1; _key10 < _len10; _key10++)args[_key10 - 1] = arguments[_key10];
        return convertArgsToFunction(this, f, args, function(f) {
            return withDesc(new Bacon.Desc(this, "filter", [
                f
            ]), this.withHandler(function(event) {
                if (event.filter(f)) return this.push(event);
                else return Bacon.more;
            }));
        });
    };
    Bacon.once = function(value) {
        return new EventStream(new Desc(Bacon, "once", [
            value
        ]), function(sink) {
            sink(toEvent(value));
            sink(endEvent());
            return nop;
        });
    };
    Bacon.EventStream.prototype.concat = function(right) {
        var left = this;
        return new EventStream(new Bacon.Desc(left, "concat", [
            right
        ]), function(sink) {
            var unsubRight = nop;
            var unsubLeft = left.dispatcher.subscribe(function(e) {
                if (e.isEnd()) {
                    unsubRight = right.toEventStream().dispatcher.subscribe(sink);
                    return unsubRight;
                } else return sink(e);
            });
            return function() {
                return unsubLeft(), unsubRight();
            };
        });
    };
    Bacon.Property.prototype.concat = function(right) {
        return addPropertyInitValueToStream(this, this.changes().concat(right));
    };
    Bacon.concatAll = function() {
        var streams = argumentsToObservables(arguments);
        if (streams.length) return withDesc(new Bacon.Desc(Bacon, "concatAll", streams), _.fold(_.tail(streams), _.head(streams).toEventStream(), function(a, b) {
            return a.concat(b);
        }));
        else return Bacon.never();
    };
    var addPropertyInitValueToStream = function(property, stream) {
        var justInitValue = new EventStream(describe(property, "justInitValue"), function(sink) {
            var value = undefined;
            var unsub = property.dispatcher.subscribe(function(event) {
                if (!event.isEnd()) value = event;
                return Bacon.noMore;
            });
            UpdateBarrier.whenDoneWith(justInitValue, function() {
                if (typeof value !== "undefined" && value !== null) sink(value);
                return sink(endEvent());
            });
            return unsub;
        });
        return justInitValue.concat(stream).toProperty();
    };
    Bacon.Observable.prototype.flatMap = function() {
        return flatMap_(this, makeSpawner(arguments));
    };
    Bacon.Observable.prototype.flatMapFirst = function() {
        return flatMap_(this, makeSpawner(arguments), true);
    };
    var makeSpawner = function(args) {
        if (args.length === 1 && isObservable(args[0])) return _.always(args[0]);
        else return makeFunctionArgs(args);
    };
    var makeObservable = function(x) {
        if (isObservable(x)) return x;
        else return Bacon.once(x);
    };
    var flatMap_ = function(root, f, firstOnly, limit) {
        var rootDep = [
            root
        ];
        var childDeps = [];
        var desc = new Bacon.Desc(root, "flatMap" + (firstOnly ? "First" : ""), [
            f
        ]);
        var result = new EventStream(desc, function(sink) {
            var composite = new CompositeUnsubscribe();
            var queue = [];
            var spawn = function(event) {
                var child = makeObservable(f(event.value()));
                childDeps.push(child);
                return composite.add(function(unsubAll, unsubMe) {
                    return child.dispatcher.subscribe(function(event) {
                        if (event.isEnd()) {
                            _.remove(child, childDeps);
                            checkQueue();
                            checkEnd(unsubMe);
                            return Bacon.noMore;
                        } else {
                            if (typeof event !== "undefined" && event !== null ? event._isInitial : undefined) event = event.toNext();
                            var reply = sink(event);
                            if (reply === Bacon.noMore) unsubAll();
                            return reply;
                        }
                    });
                });
            };
            var checkQueue = function() {
                var event = queue.shift();
                if (event) return spawn(event);
            };
            var checkEnd = function(unsub) {
                unsub();
                if (composite.empty()) return sink(endEvent());
            };
            composite.add(function(__, unsubRoot) {
                return root.dispatcher.subscribe(function(event) {
                    if (event.isEnd()) return checkEnd(unsubRoot);
                    else if (event.isError()) return sink(event);
                    else if (firstOnly && composite.count() > 1) return Bacon.more;
                    else {
                        if (composite.unsubscribed) return Bacon.noMore;
                        if (limit && composite.count() > limit) return queue.push(event);
                        else return spawn(event);
                    }
                });
            });
            return composite.unsubscribe;
        });
        result.internalDeps = function() {
            if (childDeps.length) return rootDep.concat(childDeps);
            else return rootDep;
        };
        return result;
    };
    Bacon.Observable.prototype.flatMapWithConcurrencyLimit = function(limit) {
        for(var _len11 = arguments.length, args = Array(_len11 > 1 ? _len11 - 1 : 0), _key11 = 1; _key11 < _len11; _key11++)args[_key11 - 1] = arguments[_key11];
        var desc = new Bacon.Desc(this, "flatMapWithConcurrencyLimit", [
            limit
        ].concat(args));
        return withDesc(desc, flatMap_(this, makeSpawner(args), false, limit));
    };
    Bacon.Observable.prototype.flatMapConcat = function() {
        var desc = new Bacon.Desc(this, "flatMapConcat", Array.prototype.slice.call(arguments, 0));
        return withDesc(desc, this.flatMapWithConcurrencyLimit.apply(this, [
            1
        ].concat(_slice.call(arguments))));
    };
    Bacon.later = function(delay, value) {
        return withDesc(new Bacon.Desc(Bacon, "later", [
            delay,
            value
        ]), Bacon.fromBinder(function(sink) {
            var sender = function() {
                return sink([
                    value,
                    endEvent()
                ]);
            };
            var id = Bacon.scheduler.setTimeout(sender, delay);
            return function() {
                return Bacon.scheduler.clearTimeout(id);
            };
        }));
    };
    Bacon.Observable.prototype.bufferingThrottle = function(minimumInterval) {
        var desc = new Bacon.Desc(this, "bufferingThrottle", [
            minimumInterval
        ]);
        return withDesc(desc, this.flatMapConcat(function(x) {
            return Bacon.once(x).concat(Bacon.later(minimumInterval).filter(false));
        }));
    };
    Bacon.Property.prototype.bufferingThrottle = function() {
        return Bacon.Observable.prototype.bufferingThrottle.apply(this, arguments).toProperty();
    };
    function Bus() {
        if (!(this instanceof Bus)) return new Bus();
        this.unsubAll = _.bind(this.unsubAll, this);
        this.subscribeAll = _.bind(this.subscribeAll, this);
        this.guardedSink = _.bind(this.guardedSink, this);
        this.sink = undefined;
        this.subscriptions = [];
        this.ended = false;
        EventStream.call(this, new Bacon.Desc(Bacon, "Bus", []), this.subscribeAll);
    }
    inherit(Bus, EventStream);
    extend(Bus.prototype, {
        unsubAll: function() {
            var iterable = this.subscriptions;
            for(var i = 0, sub; i < iterable.length; i++){
                sub = iterable[i];
                if (typeof sub.unsub === "function") sub.unsub();
            }
        },
        subscribeAll: function(newSink) {
            if (this.ended) newSink(endEvent());
            else {
                this.sink = newSink;
                var iterable = cloneArray(this.subscriptions);
                for(var i = 0, subscription; i < iterable.length; i++){
                    subscription = iterable[i];
                    this.subscribeInput(subscription);
                }
            }
            return this.unsubAll;
        },
        guardedSink: function(input) {
            var _this8 = this;
            return function(event) {
                if (event.isEnd()) {
                    _this8.unsubscribeInput(input);
                    return Bacon.noMore;
                } else return _this8.sink(event);
            };
        },
        subscribeInput: function(subscription) {
            subscription.unsub = subscription.input.dispatcher.subscribe(this.guardedSink(subscription.input));
            return subscription.unsub;
        },
        unsubscribeInput: function(input) {
            var iterable = this.subscriptions;
            for(var i = 0, sub; i < iterable.length; i++){
                sub = iterable[i];
                if (sub.input === input) {
                    if (typeof sub.unsub === "function") sub.unsub();
                    this.subscriptions.splice(i, 1);
                    return;
                }
            }
        },
        plug: function(input) {
            var _this9 = this;
            assertObservable(input);
            if (this.ended) return;
            var sub = {
                input: input
            };
            this.subscriptions.push(sub);
            if (typeof this.sink !== "undefined") this.subscribeInput(sub);
            return function() {
                return _this9.unsubscribeInput(input);
            };
        },
        end: function() {
            this.ended = true;
            this.unsubAll();
            if (typeof this.sink === "function") return this.sink(endEvent());
        },
        push: function(value) {
            if (!this.ended && typeof this.sink === "function") {
                var rootPush = !this.pushing;
                if (!rootPush) {
                    if (!this.pushQueue) this.pushQueue = [];
                    this.pushQueue.push(value);
                    return;
                }
                this.pushing = true;
                try {
                    return this.sink(nextEvent(value));
                } finally{
                    if (rootPush && this.pushQueue) {
                        var i = 0;
                        while(i < this.pushQueue.length){
                            var value = this.pushQueue[i];
                            this.sink(nextEvent(value));
                            i++;
                        }
                        this.pushQueue = null;
                    }
                    this.pushing = false;
                }
            }
        },
        error: function(error) {
            if (typeof this.sink === "function") return this.sink(new Error(error));
        }
    });
    Bacon.Bus = Bus;
    var liftCallback = function(desc, wrapped) {
        return withMethodCallSupport(function(f) {
            var stream = partiallyApplied(wrapped, [
                function(values, callback) {
                    return f.apply(undefined, values.concat([
                        callback
                    ]));
                }
            ]);
            for(var _len12 = arguments.length, args = Array(_len12 > 1 ? _len12 - 1 : 0), _key12 = 1; _key12 < _len12; _key12++)args[_key12 - 1] = arguments[_key12];
            return withDesc(new Bacon.Desc(Bacon, desc, [
                f
            ].concat(args)), Bacon.combineAsArray(args).flatMap(stream));
        });
    };
    Bacon.fromCallback = liftCallback("fromCallback", function(f) {
        for(var _len13 = arguments.length, args = Array(_len13 > 1 ? _len13 - 1 : 0), _key13 = 1; _key13 < _len13; _key13++)args[_key13 - 1] = arguments[_key13];
        return Bacon.fromBinder(function(handler) {
            makeFunction(f, args)(handler);
            return nop;
        }, function(value) {
            return [
                value,
                endEvent()
            ];
        });
    });
    Bacon.fromNodeCallback = liftCallback("fromNodeCallback", function(f) {
        for(var _len14 = arguments.length, args = Array(_len14 > 1 ? _len14 - 1 : 0), _key14 = 1; _key14 < _len14; _key14++)args[_key14 - 1] = arguments[_key14];
        return Bacon.fromBinder(function(handler) {
            makeFunction(f, args)(handler);
            return nop;
        }, function(error, value) {
            if (error) return [
                new Error(error),
                endEvent()
            ];
            return [
                value,
                endEvent()
            ];
        });
    });
    Bacon.combineTemplate = function(template) {
        function current(ctxStack) {
            return ctxStack[ctxStack.length - 1];
        }
        function setValue(ctxStack, key, value) {
            current(ctxStack)[key] = value;
            return value;
        }
        function applyStreamValue(key, index) {
            return function(ctxStack, values) {
                setValue(ctxStack, key, values[index]);
            };
        }
        function constantValue(key, value) {
            return function(ctxStack) {
                setValue(ctxStack, key, value);
            };
        }
        function mkContext(template) {
            return isArray(template) ? [] : {};
        }
        function pushContext(key, value) {
            return function(ctxStack) {
                var newContext = mkContext(value);
                setValue(ctxStack, key, newContext);
                ctxStack.push(newContext);
            };
        }
        function containsObservables(value) {
            if (isObservable(value)) return true;
            else if (value && (value.constructor == Object || value.constructor == Array)) {
                for(var key in value)if (Object.prototype.hasOwnProperty.call(value, key)) {
                    var child = value[key];
                    if (containsObservables(child)) return true;
                }
            }
        }
        function compile(key, value) {
            if (isObservable(value)) {
                streams.push(value);
                funcs.push(applyStreamValue(key, streams.length - 1));
            } else if (containsObservables(value)) {
                var popContext = function(ctxStack) {
                    ctxStack.pop();
                };
                funcs.push(pushContext(key, value));
                compileTemplate(value);
                funcs.push(popContext);
            } else funcs.push(constantValue(key, value));
        }
        function combinator(values) {
            var rootContext = mkContext(template);
            var ctxStack = [
                rootContext
            ];
            for(var i = 0, f; i < funcs.length; i++){
                f = funcs[i];
                f(ctxStack, values);
            }
            return rootContext;
        }
        function compileTemplate(template) {
            _.each(template, compile);
        }
        var funcs = [];
        var streams = [];
        var resultProperty = containsObservables(template) ? (compileTemplate(template), Bacon.combineAsArray(streams).map(combinator)) : Bacon.constant(template);
        return withDesc(new Bacon.Desc(Bacon, "combineTemplate", [
            template
        ]), resultProperty);
    };
    Bacon.Observable.prototype.mapEnd = function() {
        var f = makeFunctionArgs(arguments);
        return withDesc(new Bacon.Desc(this, "mapEnd", [
            f
        ]), this.withHandler(function(event) {
            if (event.isEnd()) {
                this.push(nextEvent(f(event)));
                this.push(endEvent());
                return Bacon.noMore;
            } else return this.push(event);
        }));
    };
    Bacon.Observable.prototype.skipErrors = function() {
        return withDesc(new Bacon.Desc(this, "skipErrors", []), this.withHandler(function(event) {
            if (event.isError()) return Bacon.more;
            else return this.push(event);
        }));
    };
    Bacon.EventStream.prototype.takeUntil = function(stopper) {
        var endMarker = {};
        return withDesc(new Bacon.Desc(this, "takeUntil", [
            stopper
        ]), Bacon.groupSimultaneous(this.mapEnd(endMarker), stopper.skipErrors()).withHandler(function(event) {
            if (!event.hasValue()) return this.push(event);
            else {
                var _event$value = event.value();
                var data = _event$value[0];
                var stopper = _event$value[1];
                if (stopper.length) return this.push(endEvent());
                else {
                    var reply = Bacon.more;
                    for(var i = 0, value; i < data.length; i++){
                        value = data[i];
                        if (value === endMarker) reply = this.push(endEvent());
                        else reply = this.push(nextEvent(value));
                    }
                    return reply;
                }
            }
        }));
    };
    Bacon.Property.prototype.takeUntil = function(stopper) {
        var changes = this.changes().takeUntil(stopper);
        return withDesc(new Bacon.Desc(this, "takeUntil", [
            stopper
        ]), addPropertyInitValueToStream(this, changes));
    };
    Bacon.Observable.prototype.flatMapLatest = function() {
        var f = makeSpawner(arguments);
        var stream = this.toEventStream();
        return withDesc(new Bacon.Desc(this, "flatMapLatest", [
            f
        ]), stream.flatMap(function(value) {
            return makeObservable(f(value)).takeUntil(stream);
        }));
    };
    Bacon.Property.prototype.delayChanges = function(desc, f) {
        return withDesc(desc, addPropertyInitValueToStream(this, f(this.changes())));
    };
    Bacon.EventStream.prototype.delayChanges = function(desc, f) {
        return withDesc(desc, f(this));
    };
    Bacon.Observable.prototype.delay = function(delay) {
        return this.delayChanges(new Bacon.Desc(this, "delay", [
            delay
        ]), function(changes) {
            return changes.flatMap(function(value) {
                return Bacon.later(delay, value);
            });
        });
    };
    Bacon.Observable.prototype.debounce = function(delay) {
        return this.delayChanges(new Bacon.Desc(this, "debounce", [
            delay
        ]), function(changes) {
            return changes.flatMapLatest(function(value) {
                return Bacon.later(delay, value);
            });
        });
    };
    Bacon.Observable.prototype.debounceImmediate = function(delay) {
        return this.delayChanges(new Bacon.Desc(this, "debounceImmediate", [
            delay
        ]), function(changes) {
            return changes.flatMapFirst(function(value) {
                return Bacon.once(value).concat(Bacon.later(delay).filter(false));
            });
        });
    };
    Bacon.Observable.prototype.decode = function(cases) {
        return withDesc(new Bacon.Desc(this, "decode", [
            cases
        ]), this.combine(Bacon.combineTemplate(cases), function(key, values) {
            return values[key];
        }));
    };
    Bacon.Observable.prototype.scan = function(seed, f) {
        var _this10 = this;
        var resultProperty;
        f = toCombinator(f);
        var acc = toOption(seed);
        var initHandled = false;
        var subscribe = function(sink) {
            var initSent = false;
            var unsub = nop;
            var reply = Bacon.more;
            var sendInit = function() {
                if (!initSent) return acc.forEach(function(value) {
                    initSent = initHandled = true;
                    reply = sink(new Initial(function() {
                        return value;
                    }));
                    if (reply === Bacon.noMore) {
                        unsub();
                        unsub = nop;
                        return unsub;
                    }
                });
            };
            unsub = _this10.dispatcher.subscribe(function(event) {
                if (event.hasValue()) {
                    if (initHandled && event.isInitial()) return Bacon.more;
                    else {
                        if (!event.isInitial()) sendInit();
                        initSent = initHandled = true;
                        var prev = acc.getOrElse(undefined);
                        var next = f(prev, event.value());
                        acc = new Some(next);
                        return sink(event.apply(function() {
                            return next;
                        }));
                    }
                } else {
                    if (event.isEnd()) reply = sendInit();
                    if (reply !== Bacon.noMore) return sink(event);
                }
            });
            UpdateBarrier.whenDoneWith(resultProperty, sendInit);
            return unsub;
        };
        resultProperty = new Property(new Bacon.Desc(this, "scan", [
            seed,
            f
        ]), subscribe);
        return resultProperty;
    };
    Bacon.Observable.prototype.diff = function(start, f) {
        f = toCombinator(f);
        return withDesc(new Bacon.Desc(this, "diff", [
            start,
            f
        ]), this.scan([
            start
        ], function(prevTuple, next) {
            return [
                next,
                f(prevTuple[0], next)
            ];
        }).filter(function(tuple) {
            return tuple.length === 2;
        }).map(function(tuple) {
            return tuple[1];
        }));
    };
    Bacon.Observable.prototype.doAction = function() {
        var f = makeFunctionArgs(arguments);
        return withDesc(new Bacon.Desc(this, "doAction", [
            f
        ]), this.withHandler(function(event) {
            if (event.hasValue()) f(event.value());
            return this.push(event);
        }));
    };
    Bacon.Observable.prototype.doEnd = function() {
        var f = makeFunctionArgs(arguments);
        return withDesc(new Bacon.Desc(this, "doEnd", [
            f
        ]), this.withHandler(function(event) {
            if (event.isEnd()) f();
            return this.push(event);
        }));
    };
    Bacon.Observable.prototype.doError = function() {
        var f = makeFunctionArgs(arguments);
        return withDesc(new Bacon.Desc(this, "doError", [
            f
        ]), this.withHandler(function(event) {
            if (event.isError()) f(event.error);
            return this.push(event);
        }));
    };
    Bacon.Observable.prototype.doLog = function() {
        for(var _len15 = arguments.length, args = Array(_len15), _key15 = 0; _key15 < _len15; _key15++)args[_key15] = arguments[_key15];
        return withDesc(new Bacon.Desc(this, "doLog", args), this.withHandler(function(event) {
            if (typeof console !== "undefined" && console !== null && typeof console.log === "function") console.log.apply(console, args.concat([
                event.log()
            ]));
            return this.push(event);
        }));
    };
    Bacon.Observable.prototype.endOnError = function(f) {
        if (!(typeof f !== "undefined" && f !== null)) f = true;
        for(var _len16 = arguments.length, args = Array(_len16 > 1 ? _len16 - 1 : 0), _key16 = 1; _key16 < _len16; _key16++)args[_key16 - 1] = arguments[_key16];
        return convertArgsToFunction(this, f, args, function(f) {
            return withDesc(new Bacon.Desc(this, "endOnError", []), this.withHandler(function(event) {
                if (event.isError() && f(event.error)) {
                    this.push(event);
                    return this.push(endEvent());
                } else return this.push(event);
            }));
        });
    };
    Observable.prototype.errors = function() {
        return withDesc(new Bacon.Desc(this, "errors", []), this.filter(function() {
            return false;
        }));
    };
    Bacon.Observable.prototype.take = function(count) {
        if (count <= 0) return Bacon.never();
        return withDesc(new Bacon.Desc(this, "take", [
            count
        ]), this.withHandler(function(event) {
            if (!event.hasValue()) return this.push(event);
            else {
                count--;
                if (count > 0) return this.push(event);
                else {
                    if (count === 0) this.push(event);
                    this.push(endEvent());
                    return Bacon.noMore;
                }
            }
        }));
    };
    Bacon.Observable.prototype.first = function() {
        return withDesc(new Bacon.Desc(this, "first", []), this.take(1));
    };
    Bacon.Observable.prototype.mapError = function() {
        var f = makeFunctionArgs(arguments);
        return withDesc(new Bacon.Desc(this, "mapError", [
            f
        ]), this.withHandler(function(event) {
            if (event.isError()) return this.push(nextEvent(f(event.error)));
            else return this.push(event);
        }));
    };
    Bacon.Observable.prototype.flatMapError = function(fn) {
        var desc = new Bacon.Desc(this, "flatMapError", [
            fn
        ]);
        return withDesc(desc, this.mapError(function(err) {
            return new Error(err);
        }).flatMap(function(x) {
            if (x instanceof Error) return fn(x.error);
            else return Bacon.once(x);
        }));
    };
    Bacon.EventStream.prototype.flatScan = function(seed, f) {
        var current = seed;
        return this.flatMapConcat(function(next) {
            return makeObservable(f(current, next)).doAction(function(updated) {
                return current = updated;
            });
        }).toProperty(seed);
    };
    Bacon.EventStream.prototype.sampledBy = function(sampler, combinator) {
        return withDesc(new Bacon.Desc(this, "sampledBy", [
            sampler,
            combinator
        ]), this.toProperty().sampledBy(sampler, combinator));
    };
    Bacon.Property.prototype.sampledBy = function(sampler, combinator) {
        var lazy = false;
        if (typeof combinator !== "undefined" && combinator !== null) combinator = toCombinator(combinator);
        else {
            lazy = true;
            combinator = function(f) {
                return f.value();
            };
        }
        var thisSource = new Source(this, false, lazy);
        var samplerSource = new Source(sampler, true, lazy);
        var stream = Bacon.when([
            thisSource,
            samplerSource
        ], combinator);
        var result = sampler._isProperty ? stream.toProperty() : stream;
        return withDesc(new Bacon.Desc(this, "sampledBy", [
            sampler,
            combinator
        ]), result);
    };
    Bacon.Property.prototype.sample = function(interval) {
        return withDesc(new Bacon.Desc(this, "sample", [
            interval
        ]), this.sampledBy(Bacon.interval(interval, {})));
    };
    Bacon.Observable.prototype.map = function(p) {
        if (p && p._isProperty) return p.sampledBy(this, former);
        else {
            for(var _len17 = arguments.length, args = Array(_len17 > 1 ? _len17 - 1 : 0), _key17 = 1; _key17 < _len17; _key17++)args[_key17 - 1] = arguments[_key17];
            return convertArgsToFunction(this, p, args, function(f) {
                return withDesc(new Bacon.Desc(this, "map", [
                    f
                ]), this.withHandler(function(event) {
                    return this.push(event.fmap(f));
                }));
            });
        }
    };
    Bacon.Observable.prototype.fold = function(seed, f) {
        return withDesc(new Bacon.Desc(this, "fold", [
            seed,
            f
        ]), this.scan(seed, f).sampledBy(this.filter(false).mapEnd().toProperty()));
    };
    Observable.prototype.reduce = Observable.prototype.fold;
    var eventMethods = [
        [
            "addEventListener",
            "removeEventListener"
        ],
        [
            "addListener",
            "removeListener"
        ],
        [
            "on",
            "off"
        ],
        [
            "bind",
            "unbind"
        ]
    ];
    var findHandlerMethods = function(target) {
        var pair;
        for(var i = 0; i < eventMethods.length; i++){
            pair = eventMethods[i];
            var methodPair = [
                target[pair[0]],
                target[pair[1]]
            ];
            if (methodPair[0] && methodPair[1]) return methodPair;
        }
        for(var j = 0; j < eventMethods.length; j++){
            pair = eventMethods[j];
            var addListener = target[pair[0]];
            if (addListener) return [
                addListener,
                function() {}
            ];
        }
        throw new Error("No suitable event methods in " + target);
    };
    Bacon.fromEventTarget = function(target, eventName, eventTransformer) {
        var _findHandlerMethods = findHandlerMethods(target);
        var sub = _findHandlerMethods[0];
        var unsub = _findHandlerMethods[1];
        var desc = new Bacon.Desc(Bacon, "fromEvent", [
            target,
            eventName
        ]);
        return withDesc(desc, Bacon.fromBinder(function(handler) {
            sub.call(target, eventName, handler);
            return function() {
                return unsub.call(target, eventName, handler);
            };
        }, eventTransformer));
    };
    Bacon.fromEvent = Bacon.fromEventTarget;
    Bacon.fromPoll = function(delay, poll) {
        var desc = new Bacon.Desc(Bacon, "fromPoll", [
            delay,
            poll
        ]);
        return withDesc(desc, Bacon.fromBinder(function(handler) {
            var id = Bacon.scheduler.setInterval(handler, delay);
            return function() {
                return Bacon.scheduler.clearInterval(id);
            };
        }, poll));
    };
    function valueAndEnd(value) {
        return [
            value,
            endEvent()
        ];
    }
    Bacon.fromPromise = function(promise, abort) {
        var eventTransformer = arguments.length <= 2 || arguments[2] === undefined ? valueAndEnd : arguments[2];
        return withDesc(new Bacon.Desc(Bacon, "fromPromise", [
            promise
        ]), Bacon.fromBinder(function(handler) {
            var bound = promise.then(handler, function(e) {
                return handler(new Error(e));
            });
            if (bound && typeof bound.done === "function") bound.done();
            if (abort) return function() {
                if (typeof promise.abort === "function") return promise.abort();
            };
            else return function() {};
        }, eventTransformer));
    };
    Bacon.Observable.prototype.groupBy = function(keyF) {
        var limitF = arguments.length <= 1 || arguments[1] === undefined ? Bacon._.id : arguments[1];
        var streams = {};
        var src = this;
        return src.filter(function(x) {
            return !streams[keyF(x)];
        }).map(function(x) {
            var key = keyF(x);
            var similar = src.filter(function(x) {
                return keyF(x) === key;
            });
            var data = Bacon.once(x).concat(similar);
            var limited = limitF(data, x).withHandler(function(event) {
                this.push(event);
                if (event.isEnd()) return delete streams[key];
            });
            streams[key] = limited;
            return limited;
        });
    };
    Bacon.fromArray = function(values) {
        assertArray(values);
        if (!values.length) return withDesc(new Bacon.Desc(Bacon, "fromArray", values), Bacon.never());
        else {
            var i = 0;
            var stream = new EventStream(new Bacon.Desc(Bacon, "fromArray", [
                values
            ]), function(sink) {
                var unsubd = false;
                var reply = Bacon.more;
                var pushing = false;
                var pushNeeded = false;
                function push() {
                    pushNeeded = true;
                    if (pushing) return;
                    pushing = true;
                    while(pushNeeded){
                        pushNeeded = false;
                        if (reply !== Bacon.noMore && !unsubd) {
                            var value = values[i++];
                            reply = sink(toEvent(value));
                            if (reply !== Bacon.noMore) {
                                if (i === values.length) sink(endEvent());
                                else UpdateBarrier.afterTransaction(stream, push);
                            }
                        }
                    }
                    pushing = false;
                    return pushing;
                }
                push();
                return function() {
                    unsubd = true;
                    return unsubd;
                };
            });
            return stream;
        }
    };
    Bacon.EventStream.prototype.holdWhen = function(valve) {
        var onHold = false;
        var bufferedValues = [];
        var src = this;
        var srcIsEnded = false;
        return new EventStream(new Bacon.Desc(this, "holdWhen", [
            valve
        ]), function(sink) {
            var composite = new CompositeUnsubscribe();
            var subscribed = false;
            var endIfBothEnded = function(unsub) {
                if (typeof unsub === "function") unsub();
                if (composite.empty() && subscribed) return sink(endEvent());
            };
            composite.add(function(unsubAll, unsubMe) {
                return valve.subscribeInternal(function(event) {
                    if (event.hasValue()) {
                        onHold = event.value();
                        if (!onHold) {
                            var toSend = bufferedValues;
                            bufferedValues = [];
                            return function() {
                                var result = [];
                                for(var i = 0, value; i < toSend.length; i++){
                                    value = toSend[i];
                                    result.push(sink(nextEvent(value)));
                                }
                                if (srcIsEnded) {
                                    result.push(sink(endEvent()));
                                    unsubMe();
                                }
                                return result;
                            }();
                        }
                    } else if (event.isEnd()) return endIfBothEnded(unsubMe);
                    else return sink(event);
                });
            });
            composite.add(function(unsubAll, unsubMe) {
                return src.subscribeInternal(function(event) {
                    if (onHold && event.hasValue()) return bufferedValues.push(event.value());
                    else if (event.isEnd() && bufferedValues.length) {
                        srcIsEnded = true;
                        return endIfBothEnded(unsubMe);
                    } else return sink(event);
                });
            });
            subscribed = true;
            endIfBothEnded();
            return composite.unsubscribe;
        });
    };
    Bacon.interval = function(delay) {
        var value = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
        return withDesc(new Bacon.Desc(Bacon, "interval", [
            delay,
            value
        ]), Bacon.fromPoll(delay, function() {
            return nextEvent(value);
        }));
    };
    Bacon.$ = {};
    Bacon.$.asEventStream = function(eventName, selector, eventTransformer) {
        var _this11 = this;
        if (_.isFunction(selector)) {
            eventTransformer = selector;
            selector = undefined;
        }
        return withDesc(new Bacon.Desc(this.selector || this, "asEventStream", [
            eventName
        ]), Bacon.fromBinder(function(handler) {
            _this11.on(eventName, selector, handler);
            return function() {
                return _this11.off(eventName, selector, handler);
            };
        }, eventTransformer));
    };
    if (typeof jQuery !== "undefined" && jQuery) jQuery.fn.asEventStream = Bacon.$.asEventStream;
    if (typeof Zepto !== "undefined" && Zepto) Zepto.fn.asEventStream = Bacon.$.asEventStream;
    Bacon.Observable.prototype.last = function() {
        var lastEvent;
        return withDesc(new Bacon.Desc(this, "last", []), this.withHandler(function(event) {
            if (event.isEnd()) {
                if (lastEvent) this.push(lastEvent);
                this.push(endEvent());
                return Bacon.noMore;
            } else lastEvent = event;
        }));
    };
    Bacon.Observable.prototype.log = function() {
        for(var _len18 = arguments.length, args = Array(_len18), _key18 = 0; _key18 < _len18; _key18++)args[_key18] = arguments[_key18];
        this.subscribe(function(event) {
            if (typeof console !== "undefined" && typeof console.log === "function") console.log.apply(console, args.concat([
                event.log()
            ]));
        });
        return this;
    };
    Bacon.EventStream.prototype.merge = function(right) {
        assertEventStream(right);
        var left = this;
        return withDesc(new Bacon.Desc(left, "merge", [
            right
        ]), Bacon.mergeAll(this, right));
    };
    Bacon.mergeAll = function() {
        var streams = argumentsToObservables(arguments);
        if (streams.length) return new EventStream(new Bacon.Desc(Bacon, "mergeAll", streams), function(sink) {
            var ends = 0;
            var smartSink = function(obs) {
                return function(unsubBoth) {
                    return obs.dispatcher.subscribe(function(event) {
                        if (event.isEnd()) {
                            ends++;
                            if (ends === streams.length) return sink(endEvent());
                            else return Bacon.more;
                        } else {
                            var reply = sink(event);
                            if (reply === Bacon.noMore) unsubBoth();
                            return reply;
                        }
                    });
                };
            };
            var sinks = _.map(smartSink, streams);
            return new Bacon.CompositeUnsubscribe(sinks).unsubscribe;
        });
        else return Bacon.never();
    };
    Bacon.repeatedly = function(delay, values) {
        var index = 0;
        return withDesc(new Bacon.Desc(Bacon, "repeatedly", [
            delay,
            values
        ]), Bacon.fromPoll(delay, function() {
            return values[index++ % values.length];
        }));
    };
    Bacon.repeat = function(generator) {
        var index = 0;
        return Bacon.fromBinder(function(sink) {
            var flag = false;
            var reply = Bacon.more;
            var unsub = function() {};
            function handleEvent(event) {
                if (event.isEnd()) {
                    if (!flag) return flag = true;
                    else return subscribeNext();
                } else return reply = sink(event);
            }
            function subscribeNext() {
                var next;
                flag = true;
                while(flag && reply !== Bacon.noMore){
                    next = generator(index++);
                    flag = false;
                    if (next) unsub = next.subscribeInternal(handleEvent);
                    else sink(endEvent());
                }
                return flag = true;
            }
            subscribeNext();
            return function() {
                return unsub();
            };
        });
    };
    Bacon.retry = function(options) {
        if (!_.isFunction(options.source)) throw new Exception("'source' option has to be a function");
        var source = options.source;
        var retries = options.retries || 0;
        var retriesDone = 0;
        var delay = options.delay || function() {
            return 0;
        };
        var isRetryable = options.isRetryable || function() {
            return true;
        };
        var finished = false;
        var error = null;
        return withDesc(new Bacon.Desc(Bacon, "retry", [
            options
        ]), Bacon.repeat(function(count) {
            function valueStream() {
                return source(count).endOnError().withHandler(function(event) {
                    if (event.isError()) {
                        error = event;
                        if (!(isRetryable(error.error) && (retries === 0 || retriesDone < retries))) {
                            finished = true;
                            return this.push(event);
                        }
                    } else {
                        if (event.hasValue()) {
                            error = null;
                            finished = true;
                        }
                        return this.push(event);
                    }
                });
            }
            if (finished) return null;
            else if (error) {
                var context = {
                    error: error.error,
                    retriesDone: retriesDone
                };
                var pause = Bacon.later(delay(context)).filter(false);
                retriesDone++;
                return pause.concat(Bacon.once().flatMap(valueStream));
            } else return valueStream();
        }));
    };
    Bacon.sequentially = function(delay, values) {
        var index = 0;
        return withDesc(new Bacon.Desc(Bacon, "sequentially", [
            delay,
            values
        ]), Bacon.fromPoll(delay, function() {
            var value = values[index++];
            if (index < values.length) return value;
            else if (index === values.length) return [
                value,
                endEvent()
            ];
            else return endEvent();
        }));
    };
    Bacon.Observable.prototype.skip = function(count) {
        return withDesc(new Bacon.Desc(this, "skip", [
            count
        ]), this.withHandler(function(event) {
            if (!event.hasValue()) return this.push(event);
            else if (count > 0) {
                count--;
                return Bacon.more;
            } else return this.push(event);
        }));
    };
    Bacon.EventStream.prototype.skipUntil = function(starter) {
        var started = starter.take(1).map(true).toProperty(false);
        return withDesc(new Bacon.Desc(this, "skipUntil", [
            starter
        ]), this.filter(started));
    };
    Bacon.EventStream.prototype.skipWhile = function(f) {
        assertObservableIsProperty(f);
        var ok = false;
        for(var _len19 = arguments.length, args = Array(_len19 > 1 ? _len19 - 1 : 0), _key19 = 1; _key19 < _len19; _key19++)args[_key19 - 1] = arguments[_key19];
        return convertArgsToFunction(this, f, args, function(f) {
            return withDesc(new Bacon.Desc(this, "skipWhile", [
                f
            ]), this.withHandler(function(event) {
                if (ok || !event.hasValue() || !f(event.value())) {
                    if (event.hasValue()) ok = true;
                    return this.push(event);
                } else return Bacon.more;
            }));
        });
    };
    Bacon.Observable.prototype.slidingWindow = function(n) {
        var minValues = arguments.length <= 1 || arguments[1] === undefined ? 0 : arguments[1];
        return withDesc(new Bacon.Desc(this, "slidingWindow", [
            n,
            minValues
        ]), this.scan([], function(window, value) {
            return window.concat([
                value
            ]).slice(-n);
        }).filter(function(values) {
            return values.length >= minValues;
        }));
    };
    var spies = [];
    var registerObs = function(obs) {
        if (spies.length) {
            if (!registerObs.running) try {
                registerObs.running = true;
                spies.forEach(function(spy) {
                    spy(obs);
                });
            } finally{
                delete registerObs.running;
            }
        }
    };
    Bacon.spy = function(spy) {
        return spies.push(spy);
    };
    Bacon.Property.prototype.startWith = function(seed) {
        return withDesc(new Bacon.Desc(this, "startWith", [
            seed
        ]), this.scan(seed, function(prev, next) {
            return next;
        }));
    };
    Bacon.EventStream.prototype.startWith = function(seed) {
        return withDesc(new Bacon.Desc(this, "startWith", [
            seed
        ]), Bacon.once(seed).concat(this));
    };
    Bacon.Observable.prototype.takeWhile = function(f) {
        assertObservableIsProperty(f);
        for(var _len20 = arguments.length, args = Array(_len20 > 1 ? _len20 - 1 : 0), _key20 = 1; _key20 < _len20; _key20++)args[_key20 - 1] = arguments[_key20];
        return convertArgsToFunction(this, f, args, function(f) {
            return withDesc(new Bacon.Desc(this, "takeWhile", [
                f
            ]), this.withHandler(function(event) {
                if (event.filter(f)) return this.push(event);
                else {
                    this.push(endEvent());
                    return Bacon.noMore;
                }
            }));
        });
    };
    Bacon.Observable.prototype.throttle = function(delay) {
        return this.delayChanges(new Bacon.Desc(this, "throttle", [
            delay
        ]), function(changes) {
            return changes.bufferWithTime(delay).map(function(values) {
                return values[values.length - 1];
            });
        });
    };
    Observable.prototype.firstToPromise = function(PromiseCtr) {
        var _this12 = this;
        if (typeof PromiseCtr !== "function") {
            if (typeof Promise === "function") PromiseCtr = Promise;
            else throw new Exception("There isn't default Promise, use shim or parameter");
        }
        return new PromiseCtr(function(resolve, reject) {
            return _this12.subscribe(function(event) {
                if (event.hasValue()) resolve(event.value());
                if (event.isError()) reject(event.error);
                return Bacon.noMore;
            });
        });
    };
    Observable.prototype.toPromise = function(PromiseCtr) {
        return this.last().firstToPromise(PromiseCtr);
    };
    Bacon["try"] = function(f) {
        return function(value) {
            try {
                return Bacon.once(f(value));
            } catch (e) {
                return new Bacon.Error(e);
            }
        };
    };
    Bacon.update = function(initial) {
        function lateBindFirst(f) {
            return function() {
                for(var _len22 = arguments.length, args = Array(_len22), _key22 = 0; _key22 < _len22; _key22++)args[_key22] = arguments[_key22];
                return function(i) {
                    return f.apply(undefined, [
                        i
                    ].concat(args));
                };
            };
        }
        for(var _len21 = arguments.length, patterns = Array(_len21 > 1 ? _len21 - 1 : 0), _key21 = 1; _key21 < _len21; _key21++)patterns[_key21 - 1] = arguments[_key21];
        var i = patterns.length - 1;
        while(i > 0){
            if (!(patterns[i] instanceof Function)) patterns[i] = _.always(patterns[i]);
            patterns[i] = lateBindFirst(patterns[i]);
            i = i - 2;
        }
        return withDesc(new Bacon.Desc(Bacon, "update", [
            initial
        ].concat(patterns)), Bacon.when.apply(Bacon, patterns).scan(initial, function(x, f) {
            return f(x);
        }));
    };
    Bacon.zipAsArray = function() {
        for(var _len23 = arguments.length, args = Array(_len23), _key23 = 0; _key23 < _len23; _key23++)args[_key23] = arguments[_key23];
        var streams = argumentsToObservables(args);
        return withDesc(new Bacon.Desc(Bacon, "zipAsArray", streams), Bacon.zipWith(streams, function() {
            for(var _len24 = arguments.length, xs = Array(_len24), _key24 = 0; _key24 < _len24; _key24++)xs[_key24] = arguments[_key24];
            return xs;
        }));
    };
    Bacon.zipWith = function() {
        for(var _len25 = arguments.length, args = Array(_len25), _key25 = 0; _key25 < _len25; _key25++)args[_key25] = arguments[_key25];
        var observablesAndFunction = argumentsToObservablesAndFunction(args);
        var streams = observablesAndFunction[0];
        var f = observablesAndFunction[1];
        streams = _.map(function(s) {
            return s.toEventStream();
        }, streams);
        return withDesc(new Bacon.Desc(Bacon, "zipWith", [
            f
        ].concat(streams)), Bacon.when(streams, f));
    };
    Bacon.Observable.prototype.zip = function(other, f) {
        return withDesc(new Bacon.Desc(this, "zip", [
            other
        ]), Bacon.zipWith([
            this,
            other
        ], f || Array));
    };
    function ESObservable(observable) {
        this.observable = observable;
    }
    ESObservable.prototype.subscribe = function(observerOrOnNext, onError, onComplete) {
        var observer = typeof observerOrOnNext === 'function' ? {
            next: observerOrOnNext,
            error: onError,
            complete: onComplete
        } : observerOrOnNext;
        var subscription = {
            closed: false,
            unsubscribe: function() {
                subscription.closed = true;
                cancel();
            }
        };
        var cancel = this.observable.subscribe(function(event) {
            if (event.isError()) {
                if (observer.error) observer.error(event.error);
                subscription.unsubscribe();
            } else if (event.isEnd()) {
                subscription.closed = true;
                if (observer.complete) observer.complete();
            } else if (observer.next) observer.next(event.value());
        });
        return subscription;
    };
    ESObservable.prototype[symbol('observable')] = function() {
        return this;
    };
    Bacon.Observable.prototype.toESObservable = function() {
        return new ESObservable(this);
    };
    Bacon.Observable.prototype[symbol('observable')] = Bacon.Observable.prototype.toESObservable;
    Bacon.fromESObservable = function(_observable) {
        var observable;
        if (_observable[symbol("observable")]) observable = _observable[symbol("observable")]();
        else observable = _observable;
        var desc = new Bacon.Desc(Bacon, "fromESObservable", [
            observable
        ]);
        return new Bacon.EventStream(desc, function(sink) {
            var cancel = observable.subscribe({
                error: function() {
                    sink(new Bacon.Error());
                    sink(new Bacon.End());
                },
                next: function(value) {
                    sink(new Bacon.Next(value, true));
                },
                complete: function() {
                    sink(new Bacon.End());
                }
            });
            if (cancel.unsubscribe) return function() {
                cancel.unsubscribe();
            };
            else return cancel;
        });
    };
    if (typeof define !== "undefined" && define !== null && define.amd != null) {
        define([], function() {
            return Bacon;
        });
        if (typeof this !== "undefined" && this !== null) this.Bacon = Bacon;
    } else if (module !== null && module.exports != null) {
        module.exports = Bacon;
        Bacon.Bacon = Bacon;
    } else this.Bacon = Bacon;
}).call(this);

});


parcelRegister("U31uw", function(module, exports) {

$parcel$export(module.exports, "getHeaders", function () { return $0a87936474c0bee7$export$6a9b8dd1339b1a17; });
$parcel$export(module.exports, "ajaxGet", function () { return $0a87936474c0bee7$export$c69316772a74a03a; });
$parcel$export(module.exports, "ajaxPost", function () { return $0a87936474c0bee7$export$21170a5f60942297; });
$parcel$export(module.exports, "ajaxPostJSON", function () { return $0a87936474c0bee7$export$8f71cbfea96da277; });
$parcel$export(module.exports, "ajaxPut", function () { return $0a87936474c0bee7$export$a0a30fb45a79f0ca; });
$parcel$export(module.exports, "ajaxPutJSON", function () { return $0a87936474c0bee7$export$8c8ab3c98e320fba; });
$parcel$export(module.exports, "ajaxDelete", function () { return $0a87936474c0bee7$export$5c3a50ea12a8e907; });
$parcel$export(module.exports, "ajaxDeleteJSON", function () { return $0a87936474c0bee7$export$2cd0a475799952f5; });

var $hYSvl = parcelRequire("hYSvl");

var $4D64z = parcelRequire("4D64z");

var $6ov8V = parcelRequire("6ov8V");

var $krtz1 = parcelRequire("krtz1");
function $0a87936474c0bee7$var$getCookie(cookieName) {
    const name = `${cookieName}=`;
    const cookies = document.cookie.split(';');
    for(let index = 0; index < cookies.length; index += 1){
        let cookie = cookies[index];
        while(cookie.charAt(0) === ' ')cookie = cookie.substring(1);
        if (cookie.indexOf(name) === 0) return decodeURIComponent(cookie.substring(name.length, cookie.length));
    }
    return '';
}
const $0a87936474c0bee7$var$isMaintenanceMode = ({ status: status })=>status === 503;
const $0a87936474c0bee7$var$jqueryAjaxWrapper = (jqueryAjaxPromise)=>{
    const ajaxResponseS = (0, (/*@__PURE__*/$parcel$interopDefault($4D64z))).fromPromise(jqueryAjaxPromise).first();
    ajaxResponseS.onError((errorResponse)=>{
        if ($0a87936474c0bee7$var$isMaintenanceMode(errorResponse)) (0, $krtz1.maintenanceModeResponses).push(errorResponse);
    });
    return ajaxResponseS;
};
function $0a87936474c0bee7$var$getDefaultHeaders() {
    return {
        Accept: 'application/json',
        'X-XSRF-TOKEN': $0a87936474c0bee7$var$getCookie('XSRF-TOKEN')
    };
}
function $0a87936474c0bee7$export$6a9b8dd1339b1a17(headers = {}) {
    return {
        ...$0a87936474c0bee7$var$getDefaultHeaders(),
        ...(0, $6ov8V.CustomHeaders).localization(),
        ...headers
    };
}
function $0a87936474c0bee7$export$c69316772a74a03a(url) {
    return $0a87936474c0bee7$var$jqueryAjaxWrapper((0, $hYSvl.default).ajax({
        type: 'GET',
        url: url,
        headers: {
            ...$0a87936474c0bee7$var$getDefaultHeaders(),
            ...(0, $6ov8V.CustomHeaders).localization()
        }
    }));
}
function $0a87936474c0bee7$export$21170a5f60942297(url) {
    return $0a87936474c0bee7$var$jqueryAjaxWrapper((0, $hYSvl.default).ajax({
        type: 'POST',
        url: url,
        headers: {
            ...$0a87936474c0bee7$var$getDefaultHeaders(),
            ...(0, $6ov8V.CustomHeaders).localization()
        }
    }));
}
function $0a87936474c0bee7$export$d444392157512766(url, file, onComplete, fileKey = 'file') {
    const formData = new FormData();
    formData.append(fileKey, file);
    return $0a87936474c0bee7$var$jqueryAjaxWrapper((0, $hYSvl.default).ajax({
        type: 'POST',
        url: url,
        data: formData,
        processData: false,
        contentType: false,
        headers: $0a87936474c0bee7$var$getDefaultHeaders(),
        complete: onComplete
    }));
}
function $0a87936474c0bee7$export$8f71cbfea96da277(url, data) {
    return $0a87936474c0bee7$var$jqueryAjaxWrapper((0, $hYSvl.default).ajax({
        type: 'POST',
        url: url,
        data: data,
        headers: $0a87936474c0bee7$var$getDefaultHeaders()
    }));
}
function $0a87936474c0bee7$export$a0a30fb45a79f0ca(url) {
    return $0a87936474c0bee7$var$jqueryAjaxWrapper((0, $hYSvl.default).ajax({
        type: 'PUT',
        url: url,
        headers: $0a87936474c0bee7$var$getDefaultHeaders()
    }));
}
function $0a87936474c0bee7$export$8c8ab3c98e320fba(url, data) {
    return $0a87936474c0bee7$var$jqueryAjaxWrapper((0, $hYSvl.default).ajax({
        type: 'PUT',
        url: url,
        data: data,
        headers: $0a87936474c0bee7$var$getDefaultHeaders()
    }));
}
function $0a87936474c0bee7$export$5c3a50ea12a8e907(url) {
    return $0a87936474c0bee7$var$jqueryAjaxWrapper((0, $hYSvl.default).ajax({
        type: 'DELETE',
        url: url,
        headers: $0a87936474c0bee7$var$getDefaultHeaders()
    }));
}
function $0a87936474c0bee7$export$2cd0a475799952f5(url, data) {
    return $0a87936474c0bee7$var$jqueryAjaxWrapper((0, $hYSvl.default).ajax({
        type: 'DELETE',
        url: url,
        data: data,
        headers: {
            ...$0a87936474c0bee7$var$getDefaultHeaders(),
            ...(0, $6ov8V.CustomHeaders).localization()
        }
    }));
}

});
parcelRegister("hYSvl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d17251ba33c360a7$export$2e2bcd8739ae039; });
/*!
 * jQuery JavaScript Library v4.0.0
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.com/license/
 *
 * Date: 2026-01-18T00:20Z
 */ // For ECMAScript module environments where a proper `window`
// is present, execute the factory and get jQuery.
function $d17251ba33c360a7$var$jQueryFactory(window1, noGlobal) {
    if (typeof window1 === "undefined" || !window1.document) throw new Error("jQuery requires a window with a document");
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    // Support: IE 11+
    // IE doesn't have Array#flat; provide a fallback.
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    // [[Class]] -> type pairs
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    // All support tests are defined in their respective modules.
    var support = {};
    function toType(obj) {
        if (obj == null) return obj + "";
        return typeof obj === "object" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    function isWindow(obj) {
        return obj != null && obj === obj.window;
    }
    function isArrayLike(obj) {
        var length = !!obj && obj.length, type = toType(obj);
        if (typeof obj === "function" || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    var document$1 = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document$1;
        var i, script = doc.createElement("script");
        script.text = code;
        for(i in preservedScriptAttributes)if (node && node[i]) script[i] = node[i];
        if (doc.head.appendChild(script).parentNode) script.parentNode.removeChild(script);
    }
    var version = "4.0.0", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        }
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && typeof target !== "function") target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Note: an element does not contain itself
        contains: function(a, b) {
            var bup = b && b.parentNode;
            return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
            // IE doesn't have `contains` on SVG.
            (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
        },
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    // https://www.w3.org/TR/css3-selectors/#whitespace
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var isIE = document$1.documentMode;
    var rbuggyQSA = isIE && new RegExp(// Support: IE 9 - 11+
    // IE's :disabled selector does not pick up the children of disabled fieldsets
    ":enabled|:disabled|\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
    var identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+";
    var rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*");
    var rdescend = new RegExp(whitespace + "|>");
    var rsibling = /[+~]/;
    var documentElement$1 = document$1.documentElement;
    // Support: IE 9 - 11+
    // IE requires a prefix.
    var matches = documentElement$1.matches || documentElement$1.msMatchesSelector;
    /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
        var keys = [];
        function cache(key, value) {
            // Use (key + " ") to avoid collision with native prototype properties
            // (see https://github.com/jquery/sizzle/issues/157)
            if (keys.push(key + " ") > jQuery.expr.cacheLength) // Only keep the most recent entries
            delete cache[keys.shift()];
            return cache[key + " "] = value;
        }
        return cache;
    }
    /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
        return context && typeof context.getElementsByTagName !== "undefined" && context;
    }
    // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
    var attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
    "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
    "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]";
    var pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
    // 1. quoted (capture 3; capture 4 or capture 5)
    "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
    "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
    ".*" + ")\\)|)";
    var filterMatchExpr = {
        ID: new RegExp("^#(" + identifier + ")"),
        CLASS: new RegExp("^\\.(" + identifier + ")"),
        TAG: new RegExp("^(" + identifier + "|[*])"),
        ATTR: new RegExp("^" + attributes),
        PSEUDO: new RegExp("^" + pseudos),
        CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i")
    };
    var rpseudo = new RegExp(pseudos);
    // CSS escapes
    // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
    var runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
        var high = "0x" + escape.slice(1) - 0x10000;
        if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
        return nonHex;
        // Replace a hexadecimal escape sequence with the encoded Unicode code point
        // Support: IE <=11+
        // For values outside the Basic Multilingual Plane (BMP), manually construct a
        // surrogate pair
        return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
    };
    function unescapeSelector(sel) {
        return sel.replace(runescape, funescape);
    }
    function selectorError(msg) {
        jQuery.error("Syntax error, unrecognized expression: " + msg);
    }
    var rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*");
    var tokenCache = createCache();
    function tokenize(selector, parseOnly) {
        var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
        if (cached) return parseOnly ? 0 : cached.slice(0);
        soFar = selector;
        groups = [];
        preFilters = jQuery.expr.preFilter;
        while(soFar){
            // Comma and first run
            if (!matched || (match = rcomma.exec(soFar))) {
                if (match) // Don't consume trailing commas as valid
                soFar = soFar.slice(match[0].length) || soFar;
                groups.push(tokens = []);
            }
            matched = false;
            // Combinators
            if (match = rleadingCombinator.exec(soFar)) {
                matched = match.shift();
                tokens.push({
                    value: matched,
                    // Cast descendant combinators to space
                    type: match[0].replace(rtrimCSS, " ")
                });
                soFar = soFar.slice(matched.length);
            }
            // Filters
            for(type in filterMatchExpr)if ((match = jQuery.expr.match[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                matched = match.shift();
                tokens.push({
                    value: matched,
                    type: type,
                    matches: match
                });
                soFar = soFar.slice(matched.length);
            }
            if (!matched) break;
        }
        // Return the length of the invalid excess
        // if we're just parsing
        // Otherwise, throw an error or return tokens
        if (parseOnly) return soFar.length;
        return soFar ? selectorError(selector) : // Cache the tokens
        tokenCache(selector, groups).slice(0);
    }
    var preFilter = {
        ATTR: function(match) {
            match[1] = unescapeSelector(match[1]);
            // Move the given value to match[3] whether quoted or unquoted
            match[3] = unescapeSelector(match[3] || match[4] || match[5] || "");
            if (match[2] === "~=") match[3] = " " + match[3] + " ";
            return match.slice(0, 4);
        },
        CHILD: function(match) {
            /* matches from filterMatchExpr["CHILD"]
			1 type (only|nth|...)
			2 what (child|of-type)
			3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
			4 xn-component of xn+y argument ([+-]?\d*n|)
			5 sign of xn-component
			6 x of xn-component
			7 sign of y-component
			8 y of y-component
		*/ match[1] = match[1].toLowerCase();
            if (match[1].slice(0, 3) === "nth") {
                // nth-* requires argument
                if (!match[3]) selectorError(match[0]);
                // numeric x and y parameters for jQuery.expr.filter.CHILD
                // remember that false/true cast respectively to 0/1
                match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                match[5] = +(match[7] + match[8] || match[3] === "odd");
            // other types prohibit arguments
            } else if (match[3]) selectorError(match[0]);
            return match;
        },
        PSEUDO: function(match) {
            var excess, unquoted = !match[6] && match[2];
            if (filterMatchExpr.CHILD.test(match[0])) return null;
            // Accept quoted arguments as-is
            if (match[3]) match[2] = match[4] || match[5] || "";
            else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
            (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
            (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                // excess is a negative index
                match[0] = match[0].slice(0, excess);
                match[2] = unquoted.slice(0, excess);
            }
            // Return only captures needed by the pseudo filter method (type and argument)
            return match.slice(0, 3);
        }
    };
    function toSelector(tokens) {
        var i = 0, len = tokens.length, selector = "";
        for(; i < len; i++)selector += tokens[i].value;
        return selector;
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    function access(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (typeof value !== "function") raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    }
    // Only count HTML whitespace
    // Other whitespace should count in values
    // https://infra.spec.whatwg.org/#ascii-whitespace
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()];
            if (value !== undefined) {
                if (value === null || // For compat with previous handling of boolean attributes,
                // remove when `false` passed. For ARIA attributes -
                // many of which recognize a `"false"` value - continue to
                // set the `"false"` value as jQuery <4 did.
                value === false && name.toLowerCase().indexOf("aria-") !== 0) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value);
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = elem.getAttribute(name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {},
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Support: IE <=11+
    // An input loses its value after becoming a radio
    if (isIE) jQuery.attrHooks.type = {
        set: function(elem, value) {
            if (value === "radio" && nodeName(elem, "input")) {
                var val = elem.value;
                elem.setAttribute("type", value);
                if (val) elem.value = val;
                return value;
            }
        }
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var sort = arr.sort;
    var splice = arr.splice;
    var hasDuplicate;
    // Document order sorting
    function sortOrder(a, b) {
        // Flag for duplicate removal
        if (a === b) {
            hasDuplicate = true;
            return 0;
        }
        // Sort on method existence if only one input has compareDocumentPosition
        var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
        if (compare) return compare;
        // Calculate position if both inputs belong to the same document
        // Support: IE 11+
        // IE sometimes throws a "Permission denied" error when strict-comparing
        // two documents; shallow comparisons work.
        // eslint-disable-next-line eqeqeq
        compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
        1;
        // Disconnected nodes
        if (compare & 1) {
            // Choose the first element that is related to the document
            // Support: IE 11+
            // IE sometimes throws a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (a == document$1 || a.ownerDocument == document$1 && jQuery.contains(document$1, a)) return -1;
            // Support: IE 11+
            // IE sometimes throws a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (b == document$1 || b.ownerDocument == document$1 && jQuery.contains(document$1, b)) return 1;
            // Maintain original order
            return 0;
        }
        return compare & 4 ? -1 : 1;
    }
    /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
        var elem, duplicates = [], j = 0, i = 0;
        hasDuplicate = false;
        sort.call(results, sortOrder);
        if (hasDuplicate) {
            while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
            while(j--)splice.call(results, duplicates[j], 1);
        }
        return results;
    };
    jQuery.fn.uniqueSort = function() {
        return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
    };
    var i, outermostContext, // Local document vars
    document, documentElement, documentIsHTML, // Instance-specific data
    dirruns = 0, done = 0, classCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), // Regular expressions
    // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
    rwhitespace = new RegExp(whitespace + "+", "g"), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = jQuery.extend({
        // For use in libraries implementing .is()
        // We use this for POS matching in `select`
        needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
    }, filterMatchExpr), rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
    rquickExpr$1 = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, // Used for iframes; see `setDocument`.
    // Support: IE 9 - 11+
    // Removing the function wrapper causes a "Permission Denied"
    // error in IE.
    unloadHandler = function() {
        setDocument();
    }, inDisabledFieldset = addCombinator(function(elem) {
        return elem.disabled === true && nodeName(elem, "fieldset");
    }, {
        dir: "parentNode",
        next: "legend"
    });
    function find(selector, context, results, seed) {
        var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
        nodeType = context ? context.nodeType : 9;
        results = results || [];
        // Return early from calls with invalid selector or context
        if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
        // Try to shortcut find operations (as opposed to filters) in HTML documents
        if (!seed) {
            setDocument(context);
            context = context || document;
            if (documentIsHTML) {
                // If the selector is sufficiently simple, try using a "get*By*" DOM method
                // (excepting DocumentFragment context, where the methods don't exist)
                if (nodeType !== 11 && (match = rquickExpr$1.exec(selector))) {
                    // ID selector
                    if (m = match[1]) {
                        // Document context
                        if (nodeType === 9) {
                            if (elem = context.getElementById(m)) push.call(results, elem);
                            return results;
                        // Element context
                        } else if (newContext && (elem = newContext.getElementById(m)) && jQuery.contains(context, elem)) {
                            push.call(results, elem);
                            return results;
                        }
                    // Type selector
                    } else if (match[2]) {
                        push.apply(results, context.getElementsByTagName(selector));
                        return results;
                    // Class selector
                    } else if ((m = match[3]) && context.getElementsByClassName) {
                        push.apply(results, context.getElementsByClassName(m));
                        return results;
                    }
                }
                // Take advantage of querySelectorAll
                if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                    newSelector = selector;
                    newContext = context;
                    // qSA considers elements outside a scoping root when evaluating child or
                    // descendant combinators, which is not what we want.
                    // In such cases, we work around the behavior by prefixing every selector in the
                    // list with an ID selector referencing the scope context.
                    // The technique has to be used as well when a leading combinator is used
                    // as such selectors are not recognized by querySelectorAll.
                    // Thanks to Andrew Dupont for this technique.
                    if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                        // Expand context for sibling selectors
                        newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                        // Outside of IE, if we're not changing the context we can
                        // use :scope instead of an ID.
                        // Support: IE 11+
                        // IE sometimes throws a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (newContext != context || isIE) {
                            // Capture the context ID, setting it first if necessary
                            if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                            else context.setAttribute("id", nid = jQuery.expando);
                        }
                        // Prefix every selector in the list
                        groups = tokenize(selector);
                        i = groups.length;
                        while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                        newSelector = groups.join(",");
                    }
                    try {
                        push.apply(results, newContext.querySelectorAll(newSelector));
                        return results;
                    } catch (qsaError) {
                        nonnativeSelectorCache(selector, true);
                    } finally{
                        if (nid === jQuery.expando) context.removeAttribute("id");
                    }
                }
            }
        }
        // All others
        return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
    }
    /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
        fn[jQuery.expando] = true;
        return fn;
    }
    /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
        return function(elem) {
            return nodeName(elem, "input") && elem.type === type;
        };
    }
    /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
        return function(elem) {
            return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
        };
    }
    /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
        // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
        return function(elem) {
            // Only certain elements can match :enabled or :disabled
            // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
            // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
            if ("form" in elem) {
                // Check for inherited disabledness on relevant non-disabled elements:
                // * listed form-associated elements in a disabled fieldset
                //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                // * option elements in a disabled optgroup
                //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                // All such elements have a "form" property.
                if (elem.parentNode && elem.disabled === false) {
                    // Option elements defer to a parent optgroup if present
                    if ("label" in elem) {
                        if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                        else return elem.disabled === disabled;
                    }
                    // Support: IE 6 - 11+
                    // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                    return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                    elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                }
                return elem.disabled === disabled;
            // Try to winnow out elements that can't be disabled before trusting the disabled property.
            // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
            // even exist on them, let alone have a boolean value.
            } else if ("label" in elem) return elem.disabled === disabled;
            // Remaining elements are neither :enabled nor :disabled
            return false;
        };
    }
    /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
        return markFunction(function(argument) {
            argument = +argument;
            return markFunction(function(seed, matches) {
                var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                // Match elements found at the specified indexes
                while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
            });
        });
    }
    /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 */ function setDocument(node) {
        var subWindow, doc = node ? node.ownerDocument || node : document$1;
        // Return early if doc is invalid or already selected
        // Support: IE 11+
        // IE sometimes throws a "Permission denied" error when strict-comparing
        // two documents; shallow comparisons work.
        // eslint-disable-next-line eqeqeq
        if (doc == document || doc.nodeType !== 9) return;
        // Update global variables
        document = doc;
        documentElement = document.documentElement;
        documentIsHTML = !jQuery.isXMLDoc(document);
        // Support: IE 9 - 11+
        // Accessing iframe documents after unload throws "permission denied" errors (see trac-13936)
        // Support: IE 11+
        // IE sometimes throws a "Permission denied" error when strict-comparing
        // two documents; shallow comparisons work.
        // eslint-disable-next-line eqeqeq
        if (isIE && document$1 != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) subWindow.addEventListener("unload", unloadHandler);
    }
    find.matches = function(expr, elements) {
        return find(expr, null, null, elements);
    };
    find.matchesSelector = function(elem, expr) {
        setDocument(elem);
        if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
            return matches.call(elem, expr);
        } catch (e) {
            nonnativeSelectorCache(expr, true);
        }
        return find(expr, document, null, [
            elem
        ]).length > 0;
    };
    jQuery.expr = {
        // Can be adjusted by the user
        cacheLength: 50,
        createPseudo: markFunction,
        match: matchExpr,
        find: {
            ID: function(id, context) {
                if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                    var elem = context.getElementById(id);
                    return elem ? [
                        elem
                    ] : [];
                }
            },
            TAG: function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            },
            CLASS: function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            }
        },
        relative: {
            ">": {
                dir: "parentNode",
                first: true
            },
            " ": {
                dir: "parentNode"
            },
            "+": {
                dir: "previousSibling",
                first: true
            },
            "~": {
                dir: "previousSibling"
            }
        },
        preFilter: preFilter,
        filter: {
            ID: function(id) {
                var attrId = unescapeSelector(id);
                return function(elem) {
                    return elem.getAttribute("id") === attrId;
                };
            },
            TAG: function(nodeNameSelector) {
                var expectedNodeName = unescapeSelector(nodeNameSelector).toLowerCase();
                return nodeNameSelector === "*" ? function() {
                    return true;
                } : function(elem) {
                    return nodeName(elem, expectedNodeName);
                };
            },
            CLASS: function(className) {
                var pattern = classCache[className + " "];
                return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                    return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                }));
            },
            ATTR: function(name, operator, check) {
                return function(elem) {
                    var result = jQuery.attr(elem, name);
                    if (result == null) return operator === "!=";
                    if (!operator) return true;
                    result += "";
                    if (operator === "=") return result === check;
                    if (operator === "!=") return result !== check;
                    if (operator === "^=") return check && result.indexOf(check) === 0;
                    if (operator === "*=") return check && result.indexOf(check) > -1;
                    if (operator === "$=") return check && result.slice(-check.length) === check;
                    if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                    if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                    return false;
                };
            },
            CHILD: function(type, what, _argument, first, last) {
                var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                function(elem) {
                    return !!elem.parentNode;
                } : function(elem, _context, xml) {
                    var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                    if (parent) {
                        // :(first|last|only)-(child|of-type)
                        if (simple) {
                            while(dir){
                                node = elem;
                                while(node = node[dir]){
                                    if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                }
                                // Reverse direction for :only-* (if we haven't yet done so)
                                start = dir = type === "only" && !start && "nextSibling";
                            }
                            return true;
                        }
                        start = [
                            forward ? parent.firstChild : parent.lastChild
                        ];
                        // non-xml :nth-child(...) stores cache data on `parent`
                        if (forward && useCache) {
                            // Seek `elem` from a previously-cached index
                            outerCache = parent[jQuery.expando] || (parent[jQuery.expando] = {});
                            cache = outerCache[type] || [];
                            nodeIndex = cache[0] === dirruns && cache[1];
                            diff = nodeIndex && cache[2];
                            node = nodeIndex && parent.childNodes[nodeIndex];
                            while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                            (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                            if (node.nodeType === 1 && ++diff && node === elem) {
                                outerCache[type] = [
                                    dirruns,
                                    nodeIndex,
                                    diff
                                ];
                                break;
                            }
                        } else {
                            // Use previously-cached element index if available
                            if (useCache) {
                                outerCache = elem[jQuery.expando] || (elem[jQuery.expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex;
                            }
                            // xml :nth-child(...)
                            // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                            if (diff === false) {
                                // Use the same loop as above to seek `elem` from the start
                                while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                    // Cache the index of each encountered element
                                    if (useCache) {
                                        outerCache = node[jQuery.expando] || (node[jQuery.expando] = {});
                                        outerCache[type] = [
                                            dirruns,
                                            diff
                                        ];
                                    }
                                    if (node === elem) break;
                                }
                            }
                        }
                        // Incorporate the offset, then check against cycle size
                        diff -= last;
                        return diff === first || diff % first === 0 && diff / first >= 0;
                    }
                };
            },
            PSEUDO: function(pseudo, argument) {
                // pseudo-class names are case-insensitive
                // https://www.w3.org/TR/selectors/#pseudo-classes
                // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                // Remember that setFilters inherits from pseudos
                var fn = jQuery.expr.pseudos[pseudo] || jQuery.expr.setFilters[pseudo.toLowerCase()] || selectorError("unsupported pseudo: " + pseudo);
                // The user may use createPseudo to indicate that
                // arguments are needed to create the filter function
                // just as jQuery does
                if (fn[jQuery.expando]) return fn(argument);
                return fn;
            }
        },
        pseudos: {
            // Potentially complex pseudos
            not: markFunction(function(selector) {
                // Trim the selector passed to compile
                // to avoid treating leading and trailing
                // spaces as combinators
                var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                return matcher[jQuery.expando] ? markFunction(function(seed, matches, _context, xml) {
                    var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                    // Match elements unmatched by `matcher`
                    while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                }) : function(elem, _context, xml) {
                    input[0] = elem;
                    matcher(input, null, xml, results);
                    // Don't keep the element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    input[0] = null;
                    return !results.pop();
                };
            }),
            has: markFunction(function(selector) {
                return function(elem) {
                    return find(selector, elem).length > 0;
                };
            }),
            contains: markFunction(function(text) {
                text = unescapeSelector(text);
                return function(elem) {
                    return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                };
            }),
            // "Whether an element is represented by a :lang() selector
            // is based solely on the element's language value
            // being equal to the identifier C,
            // or beginning with the identifier C immediately followed by "-".
            // The matching of C against the element's language value is performed case-insensitively.
            // The identifier C does not have to be a valid language name."
            // https://www.w3.org/TR/selectors/#lang-pseudo
            lang: markFunction(function(lang) {
                // lang value must be a valid identifier
                if (!ridentifier.test(lang || "")) selectorError("unsupported lang: " + lang);
                lang = unescapeSelector(lang).toLowerCase();
                return function(elem) {
                    var elemLang;
                    do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                        elemLang = elemLang.toLowerCase();
                        return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                    }
                    while ((elem = elem.parentNode) && elem.nodeType === 1);
                    return false;
                };
            }),
            // Miscellaneous
            target: function(elem) {
                var hash = window1.location && window1.location.hash;
                return hash && hash.slice(1) === elem.id;
            },
            root: function(elem) {
                return elem === documentElement;
            },
            focus: function(elem) {
                return elem === document.activeElement && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
            },
            // Boolean properties
            enabled: createDisabledPseudo(false),
            disabled: createDisabledPseudo(true),
            checked: function(elem) {
                // In CSS3, :checked should return both checked and selected elements
                // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
            },
            selected: function(elem) {
                // Support: IE <=11+
                // Accessing the selectedIndex property
                // forces the browser to treat the default option as
                // selected when in an optgroup.
                if (isIE && elem.parentNode) // eslint-disable-next-line no-unused-expressions
                elem.parentNode.selectedIndex;
                return elem.selected === true;
            },
            // Contents
            empty: function(elem) {
                // https://www.w3.org/TR/selectors/#empty-pseudo
                // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                //   but not by others (comment: 8; processing instruction: 7; etc.)
                // nodeType < 6 works because attributes (2) do not appear as children
                for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                    if (elem.nodeType < 6) return false;
                }
                return true;
            },
            parent: function(elem) {
                return !jQuery.expr.pseudos.empty(elem);
            },
            // Element/input types
            header: function(elem) {
                return rheader.test(elem.nodeName);
            },
            input: function(elem) {
                return rinputs.test(elem.nodeName);
            },
            button: function(elem) {
                return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
            },
            text: function(elem) {
                return nodeName(elem, "input") && elem.type === "text";
            },
            // Position-in-collection
            first: createPositionalPseudo(function() {
                return [
                    0
                ];
            }),
            last: createPositionalPseudo(function(_matchIndexes, length) {
                return [
                    length - 1
                ];
            }),
            eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                return [
                    argument < 0 ? argument + length : argument
                ];
            }),
            even: createPositionalPseudo(function(matchIndexes, length) {
                var i = 0;
                for(; i < length; i += 2)matchIndexes.push(i);
                return matchIndexes;
            }),
            odd: createPositionalPseudo(function(matchIndexes, length) {
                var i = 1;
                for(; i < length; i += 2)matchIndexes.push(i);
                return matchIndexes;
            }),
            lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                var i;
                if (argument < 0) i = argument + length;
                else if (argument > length) i = length;
                else i = argument;
                for(; --i >= 0;)matchIndexes.push(i);
                return matchIndexes;
            }),
            gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                var i = argument < 0 ? argument + length : argument;
                for(; ++i < length;)matchIndexes.push(i);
                return matchIndexes;
            })
        }
    };
    jQuery.expr.pseudos.nth = jQuery.expr.pseudos.eq;
    // Add button/input type pseudos
    for(i in {
        radio: true,
        checkbox: true,
        file: true,
        password: true,
        image: true
    })jQuery.expr.pseudos[i] = createInputPseudo(i);
    for(i in {
        submit: true,
        reset: true
    })jQuery.expr.pseudos[i] = createButtonPseudo(i);
    // Easy API for creating new setFilters
    function setFilters() {}
    setFilters.prototype = jQuery.expr.pseudos;
    jQuery.expr.setFilters = new setFilters();
    function addCombinator(matcher, combinator, base) {
        var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
        return combinator.first ? // Check against closest ancestor/preceding element
        function(elem, context, xml) {
            while(elem = elem[dir]){
                if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
            }
            return false;
        } : // Check against all ancestor/preceding elements
        function(elem, context, xml) {
            var oldCache, outerCache, newCache = [
                dirruns,
                doneName
            ];
            // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
            if (xml) {
                while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                    if (matcher(elem, context, xml)) return true;
                }
            } else {
                while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                    outerCache = elem[jQuery.expando] || (elem[jQuery.expando] = {});
                    if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                    else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                    return newCache[2] = oldCache[2];
                    else {
                        // Reuse newcache so results back-propagate to previous elements
                        outerCache[key] = newCache;
                        // A match means we're done; a fail means we have to keep checking
                        if (newCache[2] = matcher(elem, context, xml)) return true;
                    }
                }
            }
            return false;
        };
    }
    function elementMatcher(matchers) {
        return matchers.length > 1 ? function(elem, context, xml) {
            var i = matchers.length;
            while(i--){
                if (!matchers[i](elem, context, xml)) return false;
            }
            return true;
        } : matchers[0];
    }
    function multipleContexts(selector, contexts, results) {
        var i = 0, len = contexts.length;
        for(; i < len; i++)find(selector, contexts[i], results);
        return results;
    }
    function condense(unmatched, map, filter, context, xml) {
        var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
        for(; i < len; i++){
            if (elem = unmatched[i]) {
                if (!filter || filter(elem, context, xml)) {
                    newUnmatched.push(elem);
                    if (mapped) map.push(i);
                }
            }
        }
        return newUnmatched;
    }
    function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
        if (postFilter && !postFilter[jQuery.expando]) postFilter = setMatcher(postFilter);
        if (postFinder && !postFinder[jQuery.expando]) postFinder = setMatcher(postFinder, postSelector);
        return markFunction(function(seed, results, context, xml) {
            var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
            elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                context
            ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
            matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
            if (matcher) {
                // If we have a postFinder, or filtered seed, or non-seed postFilter
                // or preexisting results,
                matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                [] : // ...otherwise use results directly
                results;
                // Find primary matches
                matcher(matcherIn, matcherOut, context, xml);
            } else matcherOut = matcherIn;
            // Apply postFilter
            if (postFilter) {
                temp = condense(matcherOut, postMap);
                postFilter(temp, [], context, xml);
                // Un-match failing elements by moving them back to matcherIn
                i = temp.length;
                while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
            }
            if (seed) {
                if (postFinder || preFilter) {
                    if (postFinder) {
                        // Get the final matcherOut by condensing this intermediate into postFinder contexts
                        temp = [];
                        i = matcherOut.length;
                        while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                        temp.push(matcherIn[i] = elem);
                        postFinder(null, matcherOut = [], temp, xml);
                    }
                    // Move matched elements from seed to results to keep them synchronized
                    i = matcherOut.length;
                    while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                }
            } else {
                matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                if (postFinder) postFinder(null, results, matcherOut, xml);
                else push.apply(results, matcherOut);
            }
        });
    }
    function matcherFromTokens(tokens) {
        var checkContext, matcher, j, len = tokens.length, leadingRelative = jQuery.expr.relative[tokens[0].type], implicitRelative = leadingRelative || jQuery.expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
        matchContext = addCombinator(function(elem) {
            return elem === checkContext;
        }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
            return indexOf.call(checkContext, elem) > -1;
        }, implicitRelative, true), matchers = [
            function(elem, context, xml) {
                // Support: IE 11+
                // IE sometimes throws a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                // Avoid hanging onto element
                // (see https://github.com/jquery/sizzle/issues/299)
                checkContext = null;
                return ret;
            }
        ];
        for(; i < len; i++)if (matcher = jQuery.expr.relative[tokens[i].type]) matchers = [
            addCombinator(elementMatcher(matchers), matcher)
        ];
        else {
            matcher = jQuery.expr.filter[tokens[i].type].apply(null, tokens[i].matches);
            // Return special upon seeing a positional matcher
            if (matcher[jQuery.expando]) {
                // Find the next relative operator (if any) for proper handling
                j = ++i;
                for(; j < len; j++){
                    if (jQuery.expr.relative[tokens[j].type]) break;
                }
                return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                tokens.slice(0, i - 1).concat({
                    value: tokens[i - 2].type === " " ? "*" : ""
                })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
            }
            matchers.push(matcher);
        }
        return elementMatcher(matchers);
    }
    function matcherFromGroupMatchers(elementMatchers, setMatchers) {
        var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
            var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
            elems = seed || byElement && jQuery.expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
            dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1;
            if (outermost) // Support: IE 11+
            // IE sometimes throws a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            outermostContext = context == document || context || outermost;
            // Add elements passing elementMatchers directly to results
            for(; (elem = elems[i]) != null; i++){
                if (byElement && elem) {
                    j = 0;
                    // Support: IE 11+
                    // IE sometimes throws a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (!context && elem.ownerDocument != document) {
                        setDocument(elem);
                        xml = !documentIsHTML;
                    }
                    while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                        push.call(results, elem);
                        break;
                    }
                    if (outermost) dirruns = dirrunsUnique;
                }
                // Track unmatched elements for set filters
                if (bySet) {
                    // They will have gone through all possible matchers
                    if (elem = !matcher && elem) matchedCount--;
                    // Lengthen the array for every element, matched or not
                    if (seed) unmatched.push(elem);
                }
            }
            // `i` is now the count of elements visited above, and adding it to `matchedCount`
            // makes the latter nonnegative.
            matchedCount += i;
            // Apply set filters to unmatched elements
            // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
            // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
            // no element matchers and no seed.
            // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
            // case, which will result in a "00" `matchedCount` that differs from `i` but is also
            // numerically zero.
            if (bySet && i !== matchedCount) {
                j = 0;
                while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                if (seed) {
                    // Reintegrate element matches to eliminate the need for sorting
                    if (matchedCount > 0) {
                        while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                    }
                    // Discard index placeholder values to get only actual matches
                    setMatched = condense(setMatched);
                }
                // Add matches to results
                push.apply(results, setMatched);
                // Seedless set matches succeeding multiple successful matchers stipulate sorting
                if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
            }
            // Override manipulation of globals by nested matchers
            if (outermost) {
                dirruns = dirrunsUnique;
                outermostContext = contextBackup;
            }
            return unmatched;
        };
        return bySet ? markFunction(superMatcher) : superMatcher;
    }
    function compile(selector, match /* Internal Use Only */ ) {
        var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
        if (!cached) {
            // Generate a function of recursive functions that can be used to check each element
            if (!match) match = tokenize(selector);
            i = match.length;
            while(i--){
                cached = matcherFromTokens(match[i]);
                if (cached[jQuery.expando]) setMatchers.push(cached);
                else elementMatchers.push(cached);
            }
            // Cache the compiled function
            cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
            // Save selector and tokenization
            cached.selector = selector;
        }
        return cached;
    }
    /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
        var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
        results = results || [];
        // Try to minimize operations if there is only one selector in the list and no seed
        // (the latter of which guarantees us context)
        if (match.length === 1) {
            // Reduce context if the leading compound selector is an ID
            tokens = match[0] = match[0].slice(0);
            if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && jQuery.expr.relative[tokens[1].type]) {
                context = (jQuery.expr.find.ID(unescapeSelector(token.matches[0]), context) || [])[0];
                if (!context) return results;
                else if (compiled) context = context.parentNode;
                selector = selector.slice(tokens.shift().value.length);
            }
            // Fetch a seed set for right-to-left matching
            i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
            while(i--){
                token = tokens[i];
                // Abort if we hit a combinator
                if (jQuery.expr.relative[type = token.type]) break;
                if (find = jQuery.expr.find[type]) // Search, expanding context for leading sibling combinators
                {
                    if (seed = find(unescapeSelector(token.matches[0]), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                        // If seed is empty or no tokens remain, we can return early
                        tokens.splice(i, 1);
                        selector = seed.length && toSelector(tokens);
                        if (!selector) {
                            push.apply(results, seed);
                            return results;
                        }
                        break;
                    }
                }
            }
        }
        // Compile and execute a filtering function if one is not provided
        // Provide `match` to avoid retokenization if we modified the selector above
        (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
        return results;
    }
    // Initialize against the default document
    setDocument();
    jQuery.find = find;
    // These have always been private, but they used to be documented as part of
    // Sizzle so let's maintain them for now for backwards compatibility purposes.
    find.compile = compile;
    find.select = select;
    find.setDocument = setDocument;
    find.tokenize = tokenize;
    function dir(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    }
    function siblings(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    }
    var rneedsContext = jQuery.expr.match.needsContext;
    // rsingleTag matches a string consisting of a single HTML element with no attributes
    // and captures the element's name
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    function isObviousHtml(input) {
        return input[0] === "<" && input[input.length - 1] === ">" && input.length >= 3;
    }
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (typeof qualifier === "function") return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // HANDLE: $(DOMElement)
        if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (typeof selector === "function") return rootjQuery.ready !== undefined ? rootjQuery.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        else {
            // Handle obvious HTML strings
            match = selector + "";
            if (isObviousHtml(match)) // Assume that strings that start and end with <> are HTML and skip
            // the regex check. This also handles browser-supported HTML wrappers
            // like TrustedHTML.
            match = [
                null,
                selector,
                null
            ];
            else if (typeof selector === "string") match = rquickExpr.exec(selector);
            else return jQuery.makeArray(selector, this);
            // Match html or make sure no context is specified for #id
            // Note: match[1] may be a string or a TrustedHTML wrapper
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document$1, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (typeof this[match] === "function") this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document$1.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || rootjQuery).find(selector);
            else return this.constructor(context).find(selector);
        }
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document$1);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11+
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (typeof arg === "function") {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && typeof (method = value.promise) === "function") method.call(value).done(resolve).fail(reject);
            else if (value && typeof (method = value.then) === "function") method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            reject(value);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                catch: function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = typeof fns[tuple[4]] === "function" && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && typeof returned.promise === "function") returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (typeof then === "function") {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, typeof onProgress === "function" ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, typeof onFulfilled === "function" ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, typeof onRejected === "function" ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || typeof (resolveValues[i] && resolveValues[i].then) === "function") return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        if (error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception", error, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document$1, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document$1.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    if (document$1.readyState !== "loading") // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document$1.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Matches dashed string for camelizing
    var rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase
    function camelCase(string) {
        return string.replace(rdashAlpha, fcamelCase);
    }
    /**
 * Determines whether an object can have data
 */ function acceptData(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    }
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = Object.create(null);
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return value;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45+
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11+
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.set(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.set(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    // isHiddenWithinTree reports if an element has a non-"none" display style (inline and/or
    // through the CSS cascade), which is useful in deciding whether or not to make it visible.
    // It differs from the :hidden selector (jQuery.expr.pseudos.hidden) in two important ways:
    // * A hidden ancestor does not force an element to be classified as hidden.
    // * Being disconnected from the document does not force an element to be classified as hidden.
    // These differences improve the behavior of .toggle() et al. when applied to elements that are
    // detached or contained within hidden ancestors (gh-2404, gh-2863).
    function isHiddenWithinTree(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && jQuery.css(elem, "display") === "none";
    }
    var ralphaStart = /^[a-z]/, // The regex visualized:
    //
    //                         /----------\
    //                        |            |    /-------\
    //                        |  / Top  \  |   |         |
    //         /--- Border ---+-| Right  |-+---+- Width -+---\
    //        |                 | Bottom |                    |
    //        |                  \ Left /                     |
    //        |                                               |
    //        |                              /----------\     |
    //        |          /-------------\    |            |    |- END
    //        |         |               |   |  / Top  \  |    |
    //        |         |  / Margin  \  |   | | Right  | |    |
    //        |---------+-|           |-+---+-| Bottom |-+----|
    //        |            \ Padding /         \ Left /       |
    // BEGIN -|                                               |
    //        |                /---------\                    |
    //        |               |           |                   |
    //        |               |  / Min \  |    / Width  \     |
    //         \--------------+-|       |-+---|          |---/
    //                           \ Max /       \ Height /
    rautoPx = /^(?:Border(?:Top|Right|Bottom|Left)?(?:Width|)|(?:Margin|Padding)?(?:Top|Right|Bottom|Left)?|(?:Min|Max)?(?:Width|Height))$/;
    function isAutoPx(prop) {
        // The first test is used to ensure that:
        // 1. The prop starts with a lowercase letter (as we uppercase it for the second regex).
        // 2. The prop is not empty.
        return ralphaStart.test(prop) && rautoPx.test(prop[0].toUpperCase() + prop.slice(1));
    }
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (isAutoPx(prop) ? "px" : ""), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (!isAutoPx(prop) || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54 - 66+
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/;
    // Convert dashed to camelCase, handle vendor prefixes.
    // Used by the css & effects modules.
    // Support: IE <=9 - 11+
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function cssCamelCase(string) {
        return camelCase(string.replace(rmsPrefix, "ms-"));
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+
    // Check attachment across shadow DOM boundaries when possible (gh-3504).
    // Provide a fallback for browsers without Shadow DOM v1 support.
    if (!documentElement$1.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    };
    // rtagName captures the name from the first start tag in a string of HTML
    // https://html.spec.whatwg.org/multipage/syntax.html#tag-open-state
    // https://html.spec.whatwg.org/multipage/syntax.html#tag-name-state
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var wrapMap = {
        // Table parts need to be wrapped with `<table>` or they're
        // stripped to their contents when put in a div.
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do, so we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            "table"
        ],
        col: [
            "colgroup",
            "table"
        ],
        tr: [
            "tbody",
            "table"
        ],
        td: [
            "tr",
            "tbody",
            "table"
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    function getAll(context, tag) {
        // Support: IE <=9 - 11+
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") // Use slice to snapshot the live collection from gEBTN
        ret = arr.slice.call(context.getElementsByTagName(tag || "*"));
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object" && (elem.nodeType || isArrayLike(elem))) jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || arr;
                    // Create wrappers & descend into them.
                    j = wrap.length;
                    while(--j > -1)tmp = tmp.appendChild(context.createElement(wrap[j]));
                    tmp.innerHTML = jQuery.htmlPrefilter(elem);
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = typeof value === "function";
        if (valueIsFunction) return collection.each(function(index) {
            var self = collection.eq(index);
            args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.get(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce,
                                    crossOrigin: node.crossOrigin
                                }, doc);
                            } else DOMEval(node.textContent, node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement$1, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: Firefox <=42 - 66+
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11+
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: typeof hook === "function" ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: jQuery.extend(Object.create(null), {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    if (event.result !== undefined) // Setting `event.originalEvent.returnValue` in modern
                    // browsers does the same as just calling `preventDefault()`,
                    // the browsers ignore the value anyway.
                    // Incidentally, IE 11 is the only browser from our supported
                    // ones which respects the value returned from a `beforeunload`
                    // handler attached by `addEventListener`; other browsers do
                    // so only for inline handlers, so not setting the value
                    // directly shouldn't reduce any functionality.
                    event.preventDefault();
                }
            }
        })
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                // This controller function is invoked under multiple circumstances,
                // differentiated by the stored value in `saved`:
                // 1. For an outer synthetic `.trigger()`ed event (detected by
                //    `event.isTrigger & 1` and non-array `saved`), it records arguments
                //    as an array and fires an [inner] native event to prompt state
                //    changes that should be observed by registered listeners (such as
                //    checkbox toggling and focus updating), then clears the stored value.
                // 2. For an [inner] native event (detected by `saved` being
                //    an array), it triggers an inner synthetic event, records the
                //    result, and preempts propagation to further jQuery listeners.
                // 3. For an inner synthetic event (detected by `event.isTrigger & 1` and
                //    array `saved`), it prevents double-propagation of surrogate events
                //    but otherwise allows everything to proceed (particularly including
                //    further listeners).
                // Possible `saved` data shapes: `[...], `{ value }`, `false`.
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved.length) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object),
                        // so this array will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            // Support: Chrome 86+
                            // In Chrome, if an element having a focusout handler is
                            // blurred by clicking outside of it, it invokes the handler
                            // synchronously. If that handler calls `.remove()` on
                            // the element, the data is cleared, leaving `result`
                            // undefined. We need to guard against this.
                            return result && result.value;
                        }
                    // If this is an inner synthetic event for an event with a bubbling
                    // surrogate (focus or blur), assume that the surrogate already
                    // propagated from triggering the native event and prevent that
                    // from happening again here.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order.
                // Fire an inner synthetic event with the original arguments.
                } else if (saved.length) {
                    // ...and capture the result
                    dataPriv.set(this, type, {
                        value: jQuery.event.trigger(saved[0], saved.slice(1), this)
                    });
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented ? returnTrue : returnFalse;
            // Create target properties
            this.target = src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        // Support: IE 11+
        // Attach a single focusin/focusout handler on the document while someone wants focus/blur.
        // This is because the former are synchronous in IE while the latter are async. In other
        // browsers, all those handlers are invoked synchronously.
        function focusMappedHandler(nativeEvent) {
            // `eventHandle` would already wrap the event, but we need to change the `type` here.
            var event = jQuery.event.fix(nativeEvent);
            event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
            event.isSimulated = true;
            // focus/blur don't bubble while focusin/focusout do; simulate the former by only
            // invoking the handler at the lower level.
            if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
            // `jQuery.event.add`, so event handle will already have been set
            // by this point.
            dataPriv.get(this, "handle")(event);
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (isIE) this.addEventListener(delegateType, focusMappedHandler);
                else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                if (isIE) this.removeEventListener(delegateType, focusMappedHandler);
                else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11+
    // In IE using regex groups here causes severe slowdowns.
    rnoInnerhtml = /<script|<style|<link/i;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var type, i, l, events = dataPriv.get(src, "events");
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (events) {
            dataPriv.remove(dest, "handle events");
            for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) dataUser.set(dest, jQuery.extend({}, dataUser.get(src)));
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (isIE && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)// Support: IE <=11+
                // IE fails to set the defaultValue to the correct value when
                // cloning textareas.
                if (nodeName(destElements[i], "textarea")) destElements[i].defaultValue = srcElements[i].defaultValue;
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                push.apply(ret, elems);
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    function getStyles(elem) {
        // Support: IE <=11+ (trac-14150)
        // In IE popup's `window` is the opener window which makes `window.getComputedStyle( elem )`
        // break. Using `elem.ownerDocument.defaultView` avoids the issue.
        var view = elem.ownerDocument.defaultView;
        // `document.implementation.createHTMLDocument( "" )` has a `null` `defaultView`
        // property; check `defaultView` truthiness to fallback to window in such a case.
        if (!view) view = window1;
        return view.getComputedStyle(elem);
    }
    // A method for quickly swapping in/out CSS properties to get correct calculations.
    function swap(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    }
    function curCSS(elem, name, computed) {
        var ret, isCustomProp = rcustomProp.test(name);
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for `.css('--customProperty')` (gh-3144)
        if (computed) {
            // A fallback to direct property access is needed as `computed`, being
            // the output of `getComputedStyle`, contains camelCased keys and
            // `getPropertyValue` requires kebab-case ones.
            //
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105 - 135+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
        }
        return ret !== undefined ? // Support: IE <=9 - 11+
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document$1.createElement("div").style;
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped vendor prefixed property
    function finalPropName(name) {
        if (name in emptyStyle) return name;
        return vendorPropName(name) || name;
    }
    var reliableTrDimensionsVal, reliableColDimensionsVal, table = document$1.createElement("table");
    // Executing table tests requires only one layout, so they're executed
    // at the same time to save the second computation.
    function computeTableStyleTests() {
        if (// This is a singleton, we need to execute it only once
        !table || // Finish early in limited (non-browser) environments
        !table.style) return;
        var trStyle, col = document$1.createElement("col"), tr = document$1.createElement("tr"), td = document$1.createElement("td");
        table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate;border-spacing:0";
        tr.style.cssText = "box-sizing:content-box;border:1px solid;height:1px";
        td.style.cssText = "height:9px;width:9px;padding:0";
        col.span = 2;
        documentElement$1.appendChild(table).appendChild(col).parentNode.appendChild(tr).appendChild(td).parentNode.appendChild(td.cloneNode(true));
        // Don't run until window is visible
        if (table.offsetWidth === 0) {
            documentElement$1.removeChild(table);
            return;
        }
        trStyle = window1.getComputedStyle(tr);
        // Support: Firefox 135+
        // Firefox always reports computed width as if `span` was 1.
        // Support: Safari 18.3+
        // In Safari, computed width for columns is always 0.
        // In both these browsers, using `offsetWidth` solves the issue.
        // Support: IE 11+
        // In IE, `<col>` computed width is `"auto"` unless `width` is set
        // explicitly via CSS so measurements there remain incorrect. Because of
        // the lack of a proper workaround, we accept this limitation, treating
        // IE as passing the test.
        reliableColDimensionsVal = isIE || Math.round(parseFloat(window1.getComputedStyle(col).width)) === 18;
        // Support: IE 10 - 11+
        // IE misreports `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Support: Firefox 70 - 135+
        // Only Firefox includes border widths
        // in computed dimensions for table rows. (gh-4529)
        reliableTrDimensionsVal = Math.round(parseFloat(trStyle.height) + parseFloat(trStyle.borderTopWidth) + parseFloat(trStyle.borderBottomWidth)) === tr.offsetHeight;
        documentElement$1.removeChild(table);
        // Nullify the table so it wouldn't be stored in the memory;
        // it will also be a sign that checks were already performed.
        table = null;
    }
    jQuery.extend(support, {
        reliableTrDimensions: function() {
            computeTableStyleTests();
            return reliableTrDimensionsVal;
        },
        reliableColDimensions: function() {
            computeTableStyleTests();
            return reliableColDimensionsVal;
        }
    });
    var cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = isIE || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        if (// Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        (val === "auto" || // Support: IE 9 - 11+
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        isIE && isBorderBox || !support.reliableColDimensions() && nodeName(elem, "col") || !support.reliableTrDimensions() && nodeName(elem, "tr")) && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = cssCamelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If the value is a number, add `px` for certain CSS properties
                if (type === "number") value += ret && ret[3] || (isAutoPx(origName) ? "px" : "");
                // Support: IE <=9 - 11+
                // background-* props of a cloned element affect the source element (trac-8908)
                if (isIE && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = cssCamelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Elements with `display: none` can have dimension info if
                // we invisibly show them.
                return jQuery.css(elem, "display") === "none" ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                isBorderBox = extra && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (isAutoPx(prop) ? "px" : "");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document$1.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, 13);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11+
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.set(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                // eslint-disable-next-line no-loop-func
                anim.done(function() {
                    // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = cssCamelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), percent = 1 - (remaining / animation.duration || 0), index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (typeof result.stop === "function") jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (typeof animation.opts.start === "function") animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (typeof props === "function") {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || easing || typeof speed === "function" && speed,
            duration: speed,
            easing: fn && easing || easing && typeof easing !== "function" && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (typeof opt.old === "function") opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11+
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = elem.getAttribute("tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || // href-less anchor's `tabIndex` property value is `0` and
                    // the `tabindex` attribute value: `null`. We want `-1`.
                    rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11+
    // Accessing the selectedIndex property forces the browser to respect
    // setting selected on the option. The getter ensures a default option
    // is selected when in an optgroup. ESLint rule "no-unused-expressions"
    // is disabled for this code since it considers such accessions noop.
    if (isIE) jQuery.propHooks.selected = {
        get: function(elem) {
            var parent = elem.parentNode;
            if (parent && parent.parentNode) // eslint-disable-next-line no-unused-expressions
            parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            var parent = elem.parentNode;
            if (parent) {
                // eslint-disable-next-line no-unused-expressions
                parent.selectedIndex;
                if (parent.parentNode) // eslint-disable-next-line no-unused-expressions
                parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (typeof value === "function") return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (typeof value === "function") return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self;
            if (typeof value === "function") return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean") return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                // Toggle individual class names
                self = jQuery(this);
                for(i = 0; i < classNames.length; i++){
                    className = classNames[i];
                    // Check each className given, space separated list
                    if (self.hasClass(className)) self.removeClass(className);
                    else self.addClass(className);
                }
            });
            return this;
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = typeof value === "function";
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        if (option.selected && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        if (option.selected = jQuery.inArray(jQuery(option).val(), values) > -1) optionSet = true;
                    }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    if (isIE) jQuery.valHooks.option = {
        get: function(elem) {
            var val = elem.getAttribute("value");
            return val != null ? val : // Support: IE <=10 - 11+
            // option.text throws exceptions (trac-14686, trac-14858)
            // Strip and collapse whitespace
            // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
            stripAndCollapse(jQuery.text(elem));
        }
    };
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
    });
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document$1
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document$1;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document$1)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && typeof elem[type] === "function" && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11+
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = typeof valueOrFunction === "function" ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document$1.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (typeof func === "function") {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))// Support: IE 11+
                            // `getResponseHeader( key )` in IE doesn't combine all header
                            // values for the provided key into a single result with values
                            // joined by commas as other browsers do. Instead, it returns
                            // them on separate lines.
                            responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document$1.createElement("a");
                // Support: IE <=8 - 11+
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11+
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an ESM-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted.
            // Handle the null callback placeholder.
            if (typeof data === "function" || data === null) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            scriptAttrs: options.crossOrigin ? {
                "crossOrigin": options.crossOrigin
            } : undefined,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (typeof html === "function") html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (typeof html === "function") return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = typeof html === "function";
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        return new window1.XMLHttpRequest();
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200
    };
    jQuery.ajaxTransport(function(options) {
        var callback;
        return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                            xhr.status, xhr.statusText);
                            else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") === "text" ? {
                                text: xhr.responseText
                            } : {
                                binary: xhr.response
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                xhr.onabort = xhr.onerror = xhr.ontimeout = callback("error");
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    function canUseScriptTag(s) {
        // A script tag can only be used for async, cross domain or forced-by-attrs requests.
        // Requests with headers cannot use a script tag. However, when both `scriptAttrs` &
        // `headers` options are specified, both are impossible to satisfy together; we
        // prefer `scriptAttrs` then.
        // Sync requests remain handled differently to preserve strict script ordering.
        return s.scriptAttrs || !s.headers && (s.crossDomain || // When dealing with JSONP (`s.dataTypes` include "json" then)
        // don't use a script tag so that error responses still may have
        // `responseJSON` set. Continue using a script tag for JSONP requests that:
        //   * are cross-domain as AJAX requests won't work without a CORS setup
        //   * have `scriptAttrs` set as that's a script-only functionality
        // Note that this means JSONP requests violate strict CSP script-src settings.
        // A proper solution is to migrate from using JSONP to a CORS setup.
        s.async && jQuery.inArray("json", s.dataTypes) < 0);
    }
    // Install script dataType. Don't specify `contents.script` so that an explicit
    // `dataType: "script"` is required (see gh-2432, gh-4822)
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        // These types of requests are handled via a script tag
        // so force their methods to GET.
        if (canUseScriptTag(s)) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        if (canUseScriptTag(s)) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document$1.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Get callback name, remembering preexisting value associated with it
        callbackName = s.jsonpCallback = typeof s.jsonpCallback === "function" ? s.jsonpCallback() : s.jsonpCallback;
        // Insert callback into url or form data
        if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
        else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
        // Use data converter to retrieve json after script execution
        s.converters["script json"] = function() {
            if (!responseContainer) jQuery.error(callbackName + " was not called");
            return responseContainer[0];
        };
        // Force json dataType
        s.dataTypes[0] = "json";
        // Install callback
        overwritten = window1[callbackName];
        window1[callbackName] = function() {
            responseContainer = arguments;
        };
        // Clean-up function (fires after converters)
        jqXHR.always(function() {
            // If previous value didn't exist - remove it
            if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
            else window1[callbackName] = overwritten;
            // Save back as free
            if (s[callbackName]) {
                // Make sure that re-using the options doesn't screw things around
                s.jsonpCallback = originalSettings.jsonpCallback;
                // Save the callback name for future use
                oldCallbacks.push(callbackName);
            }
            // Call if it was a function and we have a response
            if (responseContainer && typeof overwritten === "function") overwritten(responseContainer[0]);
            responseContainer = overwritten = undefined;
        });
        // Delegate to script
        return "script";
    });
    jQuery.ajaxPrefilter(function(s, origOptions) {
        // Binary data needs to be passed to XHR as-is without stringification.
        if (typeof s.data !== "string" && !jQuery.isPlainObject(s.data) && !Array.isArray(s.data) && // Don't disable data processing if explicitly set by the user.
        !("processData" in origOptions)) s.processData = false;
        // `Content-Type` for requests with `FormData` bodies needs to be set
        // by the browser as it needs to append the `boundary` it generated.
        if (s.data instanceof window1.FormData) s.contentType = false;
    });
    // Argument "data" should be string of html or a TrustedHTML wrapper of obvious HTML
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string" && !isObviousHtml(data + "")) return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var parsed, scripts;
        if (!context) // Stop scripts or inline event handlers from being executed immediately
        // by using DOMParser
        context = new window1.DOMParser().parseFromString("", "text/html");
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (typeof params === "function") {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (typeof options === "function") // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11+
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && offsetParent !== doc.documentElement && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent || doc.documentElement;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 && jQuery.css(offsetParent, "position") !== "static") {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement$1;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (typeof fn !== "function") return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.expr[":"] = jQuery.expr.filters = jQuery.expr.pseudos;
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, gh-557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
}
var $d17251ba33c360a7$export$1ea89ccd920d3a7 = $d17251ba33c360a7$var$jQueryFactory(window, true);
var $d17251ba33c360a7$export$2e2bcd8739ae039 = $d17251ba33c360a7$export$1ea89ccd920d3a7;

});

parcelRegister("6ov8V", function(module, exports) {

$parcel$export(module.exports, "Endpoints", function () { return $4a7d244fe77109d0$export$eed022e50baffed5; });
$parcel$export(module.exports, "CustomHeaders", function () { return $4a7d244fe77109d0$export$9b219a63a1479316; });
$parcel$export(module.exports, "useGet", function () { return $4a7d244fe77109d0$export$99b32c99608275e1; });
$parcel$export(module.exports, "get", function () { return $4a7d244fe77109d0$export$3988ae62b71be9a3; });
$parcel$export(module.exports, "post", function () { return $4a7d244fe77109d0$export$299ba2dee77727e9; });
$parcel$export(module.exports, "postFile", function () { return $4a7d244fe77109d0$export$522201eb69c6c5bc; });
$parcel$export(module.exports, "put", function () { return $4a7d244fe77109d0$export$327f7b26ebf455db; });
$parcel$export(module.exports, "del", function () { return $4a7d244fe77109d0$export$1d2f21e549771e67; });

var $jpgPw = parcelRequire("jpgPw");

var $hYSvl = parcelRequire("hYSvl");

var $U31uw = parcelRequire("U31uw");

var $krtz1 = parcelRequire("krtz1");

var $jyFzD = parcelRequire("jyFzD");

var $hiCBt = parcelRequire("hiCBt");
const $4a7d244fe77109d0$export$eed022e50baffed5 = {
    login: ()=>({
            path: '/rest/auth'
        }),
    signUp: ()=>({
            path: '/rest/external-users'
        }),
    invitation: (token)=>({
            path: `/rest/invitations/${token}`
        }),
    invitationById: (id)=>({
            path: `/rest/coordinators/${(0, $krtz1.getCoordinatorId)()}/invitations/${id}`
        }),
    doctoralProgrammes: ()=>({
            path: '/rest/sisu/doctoral-programmes'
        }),
    doctoralCandidates: ()=>({
            path: `/rest/coordinators/doctoral-candidates`
        }),
    invitations: ()=>({
            path: `/rest/coordinators/${(0, $krtz1.getCoordinatorId)()}/invitations`
        }),
    verifySupervisor: ()=>({
            path: `/rest/coordinators/verify`
        }),
    endSupervisorRelationship: (doctoralCandidateId, supervisorRelationshipId)=>({
            path: `/rest/coordinators/${(0, $krtz1.getCoordinatorId)()}/doctoral-candidates/${doctoralCandidateId}/supervisor-relationships/${supervisorRelationshipId}`
        }),
    supervisorRelationship: (supervisorRelationshipId)=>({
            path: `/rest/coordinators/${(0, $krtz1.getCoordinatorId)()}/supervisor-relationships/${supervisorRelationshipId}`
        }),
    findUsersByEmail: (email)=>({
            path: `/rest/coordinators/${(0, $krtz1.getCoordinatorId)()}/users-by-email?email=${email}`
        }),
    updateSupervisorRoles: (supervisorRelationshipId)=>({
            path: `/rest/supervisor-relationships/${supervisorRelationshipId}/roles`
        }),
    createConclusionFeedback: (doctoralCandidateId, reportId)=>({
            path: `/rest/doctoral-candidates/${doctoralCandidateId}/reports/${reportId}/conclusion-feedback`
        }),
    createSupervisorRelationship: (studentNumber)=>({
            path: `/rest/coordinators/${(0, $krtz1.getCoordinatorId)()}/doctoral-candidates/${studentNumber}/supervisor-relationships`
        }),
    createSupervisorRelationships: ()=>({
            path: `/rest/coordinators/supervisor-relationships`
        }),
    myDoctoralCandidates: ()=>({
            path: '/rest/doctoral-candidates'
        }),
    doctoralCandidateOverview: (doctoralCandidateId)=>({
            path: `/rest/doctoral-candidates/${doctoralCandidateId}`
        }),
    courses: (doctoralCandidateId)=>({
            path: `/rest/doctoral-candidates/${doctoralCandidateId}/courses`
        }),
    course: (doctoralCandidateId, courseId)=>({
            path: `/rest/doctoral-candidates/${doctoralCandidateId}/courses/${courseId}`
        }),
    internationalActivities: (doctoralCandidateId)=>({
            path: `/rest/doctoral-candidates/${doctoralCandidateId}/international-activities`
        }),
    internationalActivity: (doctoralCandidateId, conferenceOrMobilityId)=>({
            path: `/rest/doctoral-candidates/${doctoralCandidateId}/international-activities/${conferenceOrMobilityId}`
        }),
    reports: (doctoralCandidateId)=>({
            path: `/rest/doctoral-candidates/${doctoralCandidateId}/reports`
        }),
    report: (doctoralCandidateId, reportId)=>({
            path: `/rest/doctoral-candidates/${doctoralCandidateId}/reports/${reportId}`
        }),
    reportIsSubmitted: (doctoralCandidateId, reportId)=>({
            path: `/rest/doctoral-candidates/${doctoralCandidateId}/reports/${reportId}/is-submitted`
        }),
    reportCommentsAndEvents: (doctoralCandidateId, reportId)=>({
            path: `/rest/doctoral-candidates/${doctoralCandidateId}/reports/${reportId}/comments`
        }),
    reportComment: (doctoralCandidateId, reportId, commentId)=>({
            path: `/rest/doctoral-candidates/${doctoralCandidateId}/reports/${reportId}/comments/${commentId}`
        }),
    reportDeadline: (doctoralCandidateId)=>({
            path: `/rest/doctoral-candidates/${doctoralCandidateId}/deadline`
        }),
    roars: ()=>({
            path: '/rest/roar/versions'
        }),
    reportingStatistics: ()=>({
            path: `/rest/coordinators/${(0, $krtz1.getCoordinatorId)()}/statistics/reporting`
        }),
    createThesisCommitteeMeeting: (doctoralCandidateId)=>({
            path: `/rest/doctoral-candidates/${doctoralCandidateId}/thesis-committee/meetings`
        }),
    thesisCommitteeMeetings: (doctoralCandidateId)=>({
            path: `/rest/doctoral-candidates/${doctoralCandidateId}/thesis-committee/meetings`
        }),
    deleteThesisCommitteeMeeting: (doctoralCandidateId, thesisCommitteeMeetingId)=>({
            path: `/rest/doctoral-candidates/${doctoralCandidateId}/thesis-committee/meetings/${thesisCommitteeMeetingId}/`
        }),
    endThesisCommitteeMeeting: (doctoralCandidateId, thesisCommitteeMeetingId)=>({
            path: `/rest/doctoral-candidates/${doctoralCandidateId}/thesis-committee/meetings/${thesisCommitteeMeetingId}/end`
        }),
    updateThesisCommitteeMeeting: (doctoralCandidateId, thesisCommitteeMeetingId)=>({
            path: `/rest/doctoral-candidates/${doctoralCandidateId}/thesis-committee/meetings/${thesisCommitteeMeetingId}`
        }),
    milestones: (doctoralCandidateId)=>({
            path: `/rest/doctoral-candidates/${doctoralCandidateId}/milestones`
        }),
    createMilestone: (doctoralCandidateId)=>({
            path: `/rest/doctoral-candidates/${doctoralCandidateId}/milestones`
        }),
    updateMilestone: (doctoralCandidateId, milestoneId)=>({
            path: `/rest/doctoral-candidates/${doctoralCandidateId}/milestones/${milestoneId}`
        }),
    deleteMilestone: (doctoralCandidateId, milestoneId)=>({
            path: `/rest/doctoral-candidates/${doctoralCandidateId}/milestones/${milestoneId}`
        }),
    commonMilestones: (doctoralCandidateId)=>({
            path: `/rest/doctoral-candidates/${doctoralCandidateId}/common-milestones`
        }),
    createCommonMilestone: (doctoralCandidateId)=>({
            path: `/rest/doctoral-candidates/${doctoralCandidateId}/common-milestones`
        }),
    updateCommonMilestone: (doctoralCandidateId, milestoneId)=>({
            path: `/rest/doctoral-candidates/${doctoralCandidateId}/common-milestones/${milestoneId}`
        }),
    deleteCommonMilestone: (doctoralCandidateId, milestoneId)=>({
            path: `/rest/doctoral-candidates/${doctoralCandidateId}/common-milestones/${milestoneId}`
        }),
    attachments: (doctoralCandidateId)=>({
            path: `/rest/doctoral-candidates/${doctoralCandidateId}/attachments`
        }),
    createAttachment: (doctoralCandidateId)=>({
            path: `/rest/doctoral-candidates/${doctoralCandidateId}/attachments`
        }),
    updateAttachment: (doctoralCandidateId, attachmentId)=>({
            path: `/rest/doctoral-candidates/${doctoralCandidateId}/attachments/${attachmentId}`
        }),
    deleteAttachment: (doctoralCandidateId, attachmentId)=>({
            path: `/rest/doctoral-candidates/${doctoralCandidateId}/attachments/${attachmentId}`
        }),
    downloadAttachment: (doctoralCandidateId, attachmentId, mediaId)=>({
            path: `/rest/doctoral-candidates/${doctoralCandidateId}/attachments/${attachmentId}/download-media/${mediaId}`
        }),
    closingReasons: ()=>({
            path: '/rest/closing-reasons'
        }),
    reactivateUser: (userId)=>({
            path: `/rest/coordinators/${(0, $krtz1.getCoordinatorId)()}/users/${userId}/reactivate`
        }),
    supervisionPlans: (doctoralCandidateId)=>({
            path: `/rest/doctoral-candidates/${doctoralCandidateId}/supervision-plans`
        }),
    supervisionPlan: (doctoralCandidateId, supervisionPlanId)=>({
            path: `/rest/doctoral-candidates/${doctoralCandidateId}/supervision-plans/${supervisionPlanId}`
        }),
    supervisionPlanSignatures: (doctoralCandidateId, supervisionPlanId)=>({
            path: `/rest/doctoral-candidates/${doctoralCandidateId}/supervision-plans/${supervisionPlanId}/signatures`
        }),
    supervisionPlanSignaturesAsSupervisor: (supervisionPlanId)=>({
            path: `/rest/supervision-plans/${supervisionPlanId}/signatures`
        }),
    deleteSupervisionPlan: (supervisionPlanId)=>({
            path: `/rest/supervision-plans/${supervisionPlanId}`
        }),
    highlights: ()=>({
            path: '/rest/highlights'
        }),
    downloadThessaAdminReportAsCsv: ()=>({
            path: `/rest/coordinators/${(0, $krtz1.getCoordinatorId)()}/statistics/thessa-admin-report/download/csv`
        }),
    downloadThessaAdminReportAsXlsx: ()=>({
            path: `/rest/coordinators/${(0, $krtz1.getCoordinatorId)()}/statistics/thessa-admin-report/download/xlsx`
        })
};
const $4a7d244fe77109d0$export$9b219a63a1479316 = {
    localization: (language)=>({
            'X-Language': (language || (0, $jyFzD.getLocalStorageValue)('currentLanguage')) ?? (0, $hiCBt.defaultLanguage)
        })
};
function $4a7d244fe77109d0$export$99b32c99608275e1(endpoint, defaultValue) {
    const [isLoading, setIsLoading] = (0, $jpgPw.useState)(true);
    const [isError, setIsError] = (0, $jpgPw.useState)(false);
    const [data, setData] = (0, $jpgPw.useState)(defaultValue);
    const [error, setError] = (0, $jpgPw.useState)();
    const makeRequest = ()=>{
        setIsLoading(true);
        setIsError(false);
        setError(undefined);
        (0, $hYSvl.default).ajax({
            method: 'get',
            url: endpoint.path,
            headers: (0, $U31uw.getHeaders)()
        }).then((response)=>{
            setData(response);
            setIsLoading(false);
        }, (error)=>{
            setError(error);
            setIsError(true);
            setIsLoading(false);
            console.error(`Got error when requesting from path: ${endpoint.path}`, error);
        });
    };
    const revalidate = ()=>{
        makeRequest();
    };
    (0, $jpgPw.useEffect)(()=>revalidate(), []);
    return {
        isLoading: isLoading,
        data: data,
        isError: isError,
        error: error,
        revalidate: revalidate
    };
}
function $4a7d244fe77109d0$export$3988ae62b71be9a3(endpoint) {
    return (0, $hYSvl.default).ajax({
        method: 'get',
        url: endpoint.path,
        headers: (0, $U31uw.getHeaders)()
    });
}
function $4a7d244fe77109d0$export$299ba2dee77727e9(endpoint, data) {
    return (0, $hYSvl.default).ajax({
        method: 'post',
        url: endpoint.path,
        data: data !== undefined ? JSON.stringify(data) : undefined,
        headers: (0, $U31uw.getHeaders)({
            'Content-Type': 'application/json'
        })
    });
}
function $4a7d244fe77109d0$export$522201eb69c6c5bc(endpoint, formData) {
    return (0, $hYSvl.default).ajax({
        method: 'post',
        url: endpoint.path,
        data: formData,
        processData: false,
        contentType: false,
        headers: (0, $U31uw.getHeaders)()
    });
}
function $4a7d244fe77109d0$export$327f7b26ebf455db(endpoint, data) {
    return (0, $hYSvl.default).ajax({
        method: 'put',
        url: endpoint.path,
        data: data !== undefined ? JSON.stringify(data) : undefined,
        headers: (0, $U31uw.getHeaders)({
            'Content-Type': 'application/json'
        })
    });
}
function $4a7d244fe77109d0$export$1d2f21e549771e67(endpoint) {
    return (0, $hYSvl.default).ajax({
        method: 'delete',
        url: endpoint.path,
        headers: (0, $U31uw.getHeaders)()
    });
}

});
parcelRegister("hiCBt", function(module, exports) {

$parcel$export(module.exports, "defaultLanguage", function () { return $c9820ff2ec93ffde$export$42940898df819940; });
$parcel$export(module.exports, "default", function () { return $c9820ff2ec93ffde$export$2e2bcd8739ae039; });

var $eQhQZ = parcelRequire("eQhQZ");

var $iJbsS = parcelRequire("iJbsS");

var $3zSOg = parcelRequire("3zSOg");

var $bFM7f = parcelRequire("bFM7f");

var $d525V = parcelRequire("d525V");

var $5AAkb = parcelRequire("5AAkb");
parcelRequire("1BX32");
parcelRequire("jYIEP");
const $c9820ff2ec93ffde$export$42940898df819940 = 'fi';
const $c9820ff2ec93ffde$var$initI18n = (fallbackLanguage = $c9820ff2ec93ffde$export$42940898df819940)=>{
    (0, $eQhQZ.default).on('languageChanged', (currentLanguage)=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($5AAkb))).locale(currentLanguage);
    });
    (0, $eQhQZ.default).use((0, $iJbsS.initReactI18next)).init({
        lng: localStorage.getItem('currentLanguage'),
        fallbackLng: fallbackLanguage,
        interpolation: {
            escapeValue: false
        },
        resources: {
            fi: {
                translation: (0, (/*@__PURE__*/$parcel$interopDefault($3zSOg)))
            },
            sv: {
                translation: (0, (/*@__PURE__*/$parcel$interopDefault($bFM7f)))
            },
            en: {
                translation: (0, (/*@__PURE__*/$parcel$interopDefault($d525V)))
            }
        }
    });
};
var $c9820ff2ec93ffde$export$2e2bcd8739ae039 = $c9820ff2ec93ffde$var$initI18n;

});
parcelRegister("iJbsS", function(module, exports) {

$parcel$export(module.exports, "initReactI18next", function () { return $da2552a3c086da4d$export$ae7e14d40d89f296; });

var $21Cbc = parcelRequire("21Cbc");

var $ch6yl = parcelRequire("ch6yl");
const $da2552a3c086da4d$export$ae7e14d40d89f296 = {
    type: '3rdParty',
    init (instance) {
        (0, $21Cbc.setDefaults)(instance.options.react);
        (0, $ch6yl.setI18n)(instance);
    }
};

});

parcelRegister("3zSOg", function(module, exports) {
module.exports = JSON.parse('{"key":"value","SUPPORT_EMAIL":"uni-help@helsinki.fi","ABOUT":"Lis\xe4tietoja","THESSA":"Thessa","THESSA_IS_THE_DOCTORAL_STUDIES":"Thessa on Helsingin yliopiston jatko-opintojen suunnittelu- ja raportointity\xf6kalu.","ALL_KINDS_OF_FEEDBACK_AND_ERRO":"Kaikenlainen palaute ja virheilmoitukset ovat eritt\xe4in tervetulleita.","RIGHTS_OBLIGATIONS_AND_RESPON":"Oikeudet, velvollisuudet ja vastuut tohtorikoulutuksessa Helsingin yliopistossa","PROBLEMS_LOGGING_IN":"Ongelmia kirjautumisessa?","IF_YOU_FORGOT_YOUR_PASSWORD_Y":"Jos olet unohtanut salasanasi, voit","RESET_IT":"vaihtaa sen","SEND_PASSWORD_RESET_LINK_TO_MY":"L\xe4het\xe4 salasanan palautuslinkki s\xe4hk\xf6postiini","EMAIL_FOR_THESSA_ACCOUNT":"S\xe4hk\xf6posti Thessa-tili\xe4 varten","SEND":"L\xe4het\xe4","BACK_TO_LOGIN":"Takaisin sis\xe4\xe4nkirjautumiseen","BACK_TO_MY_PHD_PROJECT":"Takaisin v\xe4it\xf6skirjaprojektiini","MESSAGE_SENT_CHECK_YOUR_EMAIL":"Viesti l\xe4hetetty. Tarkista s\xe4hk\xf6postisi ja avaa salasanan palautusviestiss\xe4 oleva linkki.","TOO_MANY_PASSWORD_RESET_REQUES":"Liian monta salasanan palautuspyynt\xf6\xe4.","TOO_MANY_PASSWORD_RESET_ATTEMPTS":"Liian monta yrityst\xe4 tallentaa uusi salasana. Odota viisitoista minuuttia ennen kuin yrit\xe4t uudelleen.","WAIT_FIVE_MINUTES_BEFORE_TRYIN":"Odota viisitoista minuuttia ennen kuin yrit\xe4t uudelleen. Jos ongelma jatkuu, <0>ota yhteytt\xe4 meihin</0> saadaksesi lis\xe4\xe4 apua.","HELPDESK":"ota yhteytt\xe4 IT-Helpdeskiin.","YOU_MAY_RESET_YOUR_PASSWORD":"voit vaihtaa salasanasi.","SOMETHING_WENT_WRONG":"Jotain meni pieleen.","TRY_AGAIN_LATER":"Yrit\xe4 my\xf6hemmin uudelleen. Jos ongelma jatkuu, <0>ota meihin yhteytt\xe4</0> saadaksesi apua.","NO_NETWORK_CONNECTION":"Ei verkkoyhteytt\xe4","RIGHTS_OBLIGATIONS_AND_RESPON1":"Oikeudet, velvollisuudet ja vastuut tohtorikoulutuksessa Helsingin yliopistossa","ABOUT_THESSA":"Tietoja Thessasta","THE_DOCTORAL_STUDIES_PLANNING":"Tohtoriopintojen suunnittelu- ja raportointity\xf6kalu.","EMAIL":"S\xe4hk\xf6posti","PASSWORD":"Salasana","LOG_IN":"Kirjaudu sis\xe4\xe4n","LOGIN_WAS_NOT_SUCCESSFUL":"Kirjautuminen ei onnistunut.","CHECK_USERNAME_AND_PASSWORD_I":"Tarkista k\xe4ytt\xe4j\xe4tunnus ja salasana. Jos se ei auta, saat apua t\xe4\xe4lt\xe4","CHECK_USERNAME_AND_PASSWORD_I1":"Tarkista k\xe4ytt\xe4j\xe4tunnus ja salasana. Jos se ei auta,","TOO_MANY_FAILED_LOGIN_ATTEMPTS":"Liian monta ep\xe4onnistunutta kirjautumisyrityst\xe4.","WAIT_FIVE_MINUTES_BEFORE_TRYIN1":"Odota viisitoista minuuttia ennen kuin yrit\xe4t uudelleen. Tarkasta k\xe4ytt\xe4j\xe4tunnus ja salasana. Jos se ei auta, saat apua t\xe4\xe4lt\xe4","YOU_NEED_AN_INVITATION_OR_AN_A":"Tarvitset kutsun tai aktiivisen jatko-opiskeluoikeuden p\xe4\xe4st\xe4ksesi Thessaan.","YOUR_EMAIL_ADDRESS_IS_ALREADY":"S\xe4hk\xf6postiosoitteesi on jo jonkun toisen k\xe4yt\xf6ss\xe4 Thessassa.","HINT_USE_UNIVERSITY_LOGIN":"K\xe4yt\xe4t <0>helsinki.fi</0>-s\xe4hk\xf6postiosoitetta. Kirjaudu yliopiston tunnuksella yll\xe4.","CONTACT_US":"Ota meihin yhteytt\xe4","CONTACT_US1":"ota meihin yhteytt\xe4","CONTACT_US_END_OF_SENTENCE":"ota meihin yhteytt\xe4.","FOR_HELP_WITH_THIS_ERROR":"apua t\xe4h\xe4n virheeseen.","LOG_IN_PAGE":{"UNIVERSITY_STAFF_OR_STUDENTS":"Helsingin yliopiston opiskelijat ja ty\xf6ntekij\xe4t","OTHERS":"Kirjaudu Thessa-tunnuksella"},"LOGIN_FAILED_WITH_ERROR_CODE":"Kirjautuminen ep\xe4onnistui virhekoodilla","LOGIN_FAILED_PASSWORD_MUST_BE_RESET":"Kirjautuminen ep\xe4onnistui, koska salasanasi t\xe4ytyy vaihtaa. K\xe4yt\xe4","LOGIN_FAILED_USE_UNIVERSITY_LOGIN":"Kirjaudu sis\xe4\xe4n Helsingin yliopiston tilill\xe4 s\xe4hk\xf6postin ja salasanan sijaan.","PASSWORD_RESET_REFUSED_USE_UNIVERSITY_LOGIN":"T\xe4m\xe4n tilin salasanaa ei voi vaihtaa. Kirjaudu sis\xe4\xe4n Helsingin yliopiston tilill\xe4.","FORGOT_PASSWORD_PAGE":"unohdin salasanani -sivua","TO_CHANGE_YOUR_PASSWORD":"salasanan vaihtamiseen.","USE_YOUR_UNIVERSITY_OF_HELSINK":"Kirjaudu sis\xe4\xe4n Helsingin yliopiston k\xe4ytt\xe4j\xe4tunnuksellasi ja salasanallasi.","FORGOT_PASSWORD":"Unohtuiko salasana?","LOG_IN_WITH_OIDC":"Kirjaudu Helsingin yliopiston tunnuksella","RESET_PASSWORD":"Nollaa salasana","NEW_PASSWORD":"Uusi salasana","SAVE_PASSWORD":"Tallenna salasana","CANCEL":"Peruuta","PASSWORD_SET_REDIRECTING_YOU":"Salasana asetettu. Ohjataan uudelleen","INSIDE":"sis\xe4\xe4n","THERE_WERE_PROBLEMS_WITH_SAVIN":"Salasanan tallentamisessa oli ongelmia:","SIGN_UP_TO_THESSA":"Kirjaudu Thessaan","IF_YOU_HAVE_A_UNIVERSITY_OF_HE":"Jos sinulla on Helsingin yliopiston tili, k\xe4yt\xe4 sen k\xe4ytt\xe4j\xe4tunnusta ja salasanaa yll\xe4 olevassa kirjautumislomakkeessa. Kaikilla opiskelijoilla ja ty\xf6ntekij\xf6ill\xe4 on tili.","MON":"Ma","TUE":"Ti","WED":"Ke","THU":"To","FRI":"Pe","SAT":"La","SUN":"Su","LOADING_WITH_ELLIPSIS":"Ladataan\u2026","YOU_MAY_USE":"Voit k\xe4ytt\xe4\xe4","MARKDOWN":"Markdown","ITALICS":"*kursivointi*","BOLD":"**lihavoitu**","LINKS_HTTPS":"[linkit](https://...)","HEADINGS":"# otsikkoa","LISTS":"- listat","AND_MORE":"ja enemm\xe4n.","THESSA_FOR":"Thessa","UNIVERSITY_OF_HELSINKI":"Helsingin yliopisto","PRIVACY_POLICY":"Tietosuojak\xe4yt\xe4nt\xf6","ASK_FOR_HELP_AND_GIVE_FEEDBACK":"Pyyd\xe4 apua ja anna palautetta","TOGGLE_NAVIGATION":"Vaihda navigointi","LOG_OUT":"Kirjaudu ulos","LOGIN":"Kirjaudu sis\xe4\xe4n","REMINDERS1":"Muistutukset","PROFILE1":"Profiili","HELP1":"Ohje","MY_PHD_PROJECT":"V\xe4it\xf6skirjaprojektini","MY_DOCTORAL_CANDIDATES":"V\xe4it\xf6skirjatutkijani","DOCTORAL_CANDIDATES1":"V\xe4it\xf6skirjatutkijat","USERS1":"K\xe4ytt\xe4j\xe4t","QUEUE1":"Jono","STATISTICS1":"Tilastot","LEFT":"vasemmalle","BOTTOM":"pohja","ARE_YOU_SURE":"Oletko varma?","CONFIRM_DELETE":"Kyll\xe4, poista","THANKS":"Kiitos!","YOU_CAN_GIVE_MORE_FEEDBACK_HER":"Lis\xe4\xe4 palautetta voit antaa t\xe4\xe4lt\xe4:","SEND_FEEDBACK":"L\xe4het\xe4 palautetta","PAGE_HEADER":"Sivun otsikko","HEADING":"Otsikko 1","HEADING1":"Otsikko 2","HEADING2":"Otsikko 3","HEADING3":"Otsikko 4","HEADING4":"Otsikko 5","HEADING5":"Otsikko 6","LEAD_TEXT":"P\xe4\xe4teksti","BODY_TEXT":"Leip\xe4teksti","SMALL_TEXT":"Pieni teksti","LABEL":"Tunniste 1","LABEL1":"Tunniste 2","LABEL2":"Etiketti 3","CHECK":"Tarkista 1","CHECK1":"Tarkista 2","SUBMIT":"L\xe4het\xe4","SAVE":"Tallenna","TOGGLE":"Vaihda","CALENDAR":"kalenteri","OK":"okei","REMOVE":"Poista","CLEAR":"Tyhjenn\xe4","SUBMITTED":"L\xe4hetetty","CONCLUSION_MISSING":"Loppulause puuttuu","GIVE_FEEDBACK":"Anna palautetta","DEFAULT":"Oletus","RIGHT":"Oikea","LEFT1":"Vasen","CALL_TO_ACTION":"Kehotus toimintaan","SECONDARY":"Toissijainen","ACTION":"Toiminta","ACTIONS":"Toiminnot","STUDENT_NUMBER":"Opiskelijanumero","NAME":"Nimi","ACCOUNT":"Tili","NO_ACCOUNT":"Ei tili\xe4","NO_SUPERVISORS_IN_OODI":"Oodissa ei ole ohjaajia","STUDY_RIGHT_START_DATE":"Opinto-oikeuden alkamisp\xe4iv\xe4","RECENT":"VIIMEAIKAINEN","COORDINATOR_QUEUE":"Koordinaattorijono","LOADING_INACTIVE_USERS":"Ladataan ei-aktiivisia k\xe4ytt\xe4ji\xe4...","THERE_WAS_AN_ERROR_IN_LOADING":"Ei-aktiivisten k\xe4ytt\xe4jien lataamisessa tapahtui virhe.","PLEASE":"Kun haluat antaa palautetta tai tarvitset apua Thessan k\xe4yt\xf6ss\xe4,","TRY_AGAIN":"yrit\xe4 uudelleen","LET_US_KNOW":"kerro meille","IF_THE_PROBLEM_DOES_NOT_GO_AWA":"jos ongelma ei poistu.","INACTIVE_USER":"Ei-aktiivinen k\xe4ytt\xe4j\xe4","TYPE":"Tyyppi","N_A":"Ei k\xe4yt\xf6ss\xe4","NO_COURSES_IN_PLAN_YET":"Opintojaksoja ei ole viel\xe4 suunnitteilla.","ADD":"Lis\xe4\xe4","BUTTON_ABOVE":"painiketta yll\xe4!","TITLE":"Otsikko","COURSES_TOTAL_one":"{{count}} opintojakso","COURSES_TOTAL_other":"{{count}} opintojaksoa","CREDITS":"Opintopisteet","CREDITS_ABBREVIATED":"Op","CREDITS_COMPLETED":"{{completedCredits}} op suoritettu","CREDITS_PLANNED":"{{plannedCredits}} op suorittamatta","CREDITS_TOTAL":"{{totalCredits}} op yhteens\xe4","STATUS":"Tila","COMPLETED":"Suoritettu","COMPLETED_AT":"Suoritettu","TO_BE_COMPLETED_AT":"Suoritetaan p\xe4iv\xe4m\xe4\xe4r\xe4n\xe4","COURSE_UNIT_CODE":"Opintojakson tunniste","COURSE_UNIT_CODE_MISSING":"Tieto puuttuu","FAILED_TO_CREATE_COURSE":"Opinnon tallentaminen ep\xe4onnistui.","CHANGED_SINCE_LAST_OPENED":"Muuttunut edellisen avauksen j\xe4lkeen","REPORT":{"NEXT_REPORT_BY_DATE":"Seuraava raportti {{date}} menness\xe4","REPORT":"Raportti","REPORT_LATE_NOTIFICATION_FOR_SUPERVISOR":"Edellisest\xe4 raportista on yli {{n}} kk","REPORT_STATUS":"Raportin tila","REPORT_STATUS_DRAFT":"Luonnos","REPORT_STATUS_SUBMITTED":"L\xe4hetetty tarkistettavaksi","REPORT_STATUS_FINAL":"Valmis","NOT_SUBMITTED":"T\xe4t\xe4 raporttia ei ole l\xe4hetetty tarkistettavaksi","THESIS_COMMITTEE_MEETING_NOT_HELD":"Kokous pit\xe4m\xe4tt\xe4","THESIS_COMMITTEE_MEETING_INSTRUCTIONS":"Pid\xe4 seurantaryhm\xe4n kokous raportin p\xe4\xe4tt\xe4miseksi","THESIS_COMMITTEE_MEETING_LEGACY_INSTRUCTIONS":"Pid\xe4 seurantaryhm\xe4n kokous ja kirjoita raportin loppulause eli yhteenveto","REPORTING_PERIOD_WHILE_EDITING_LEGACY":"Raportointikausi alkaa {{reportingPeriodStart}} ja p\xe4\xe4ttyy kun tallennat seurantaryhm\xe4n kokouksen loppulauseen Thessaan.","REPORTING_PERIOD_WHILE_EDITING":"Raportointikausi alkaa {{reportingPeriodStart}} ja p\xe4\xe4ttyy samalla kun p\xe4\xe4t\xe4t seurantaryhm\xe4n kokouksen Thessassa.","REPORTING_PERIOD_DATES":"{{reportingPeriodStart}}\u2013{{reportingPeriodEnd}}","REPORTING_PERIOD_STARTING_FROM":"{{reportingPeriodStart}} alkaen","FEEDBACK_DUE_TAG":"Palaute edistymisest\xe4 antamatta"},"SUPERVISION_PLAN":"Ohjaussuunnitelma","SUPERVISION_PLAN_other":"Ohjaussuunnitelmat","MY_DOCTORAL_CANDIDATES1":"V\xe4it\xf6skirjatutkijani","LOADING_DOCTORAL_CANDIDATES":"Ladataan v\xe4it\xf6skirjatutkijoita...","FAILED_TO_LOAD_DOCTORAL_CANDID":"V\xe4it\xf6skirjatutkijoiden lataaminen ep\xe4onnistui. Voit yritt\xe4\xe4 ladata sivun uudelleen. Jos virhe jatkuu, ota yhteytt\xe4 Thessa-tukeen.","MISSING_DOCTORAL_CANDIDATES":"Puuttuuko v\xe4it\xf6skirjatutkijoita?","TO_SEE_YOUR_DOCTORAL_CANDIDATE":"N\xe4hd\xe4ksesi v\xe4it\xf6skirjatutkijasi Thessassa, varmista, ett\xe4 he ilmoittautuvat Thessaan ja kutsuvat sinut ohjaajaksi tai seurantaryhm\xe4n j\xe4seneksi.","YOU_WILL_GET_THE_INVITATION_BY":"Saat kutsun s\xe4hk\xf6postiisi. Hyv\xe4ksy se saadaksesi p\xe4\xe4sy v\xe4it\xf6skirjatutkijan tietoihin.","HIDE":"Piilota","SHOW":"N\xe4yt\xe4","CLOSED_ACCOUNTS":"suljetut tilit","RELATIONSHIP":"Suhde","PROGRESS":"Edistyminen","YOU_HAVE_NO_DOCTORAL_CANDIDATE":"Sinulla ei ole v\xe4it\xf6skirjatutkijoita Thessassa.","NO_DOCTORAL_CANDIDATES":"Ei v\xe4it\xf6skirjatutkijoita.","YOUR_USER_ACCOUNT_NEEDS_TO_BE":"K\xe4ytt\xe4j\xe4tilisi on aktivoitava ennen kuin voit luoda ensimm\xe4isen raportin. Ennen kuin tilisi voidaan aktivoida, sinun on teht\xe4v\xe4 se","INVITE_ALL_YOUR_SUPERVISORS_AN":"kutsu kaikki ohjaajasi ja seurantaryhm\xe4n j\xe4senet","IN_THESSA":"Thessassa.","YOU_WILL_RECEIVE_AN_EMAIL_WHEN":"Saat s\xe4hk\xf6postin, kun tilisi on aktivoitu.","INVITE_SUPERVISORS":"Kutsu ohjaajat","THERE_ARE_NO_SUPERVISION_PLANS":"Ohjaussuunnitelmia ei toistaiseksi ole.","DOCTORAL_CANDIDATE_AND_SUPERVI":"V\xe4it\xf6skirjatutkija ja ohjaajat sopivat noudattavansa ohjaussuunnitelmaa, joka m\xe4\xe4rittelee v\xe4it\xf6skirjatutkijan ja ohjaajien yhteisty\xf6n. Suunnitelma laaditaan ohjaajan tilill\xe4 ja sen j\xe4lkeen v\xe4it\xf6skirjatutkija ja ohjaajat allekirjoittavat sen.","SUPERVISORS":"Ohjaajat","LOADING_NEXT_REPORT_DUE_DATE":"Ladataan seuraavaa raportin er\xe4p\xe4iv\xe4\xe4...","NEXT_REPORT_DUE_ON":"Seuraavan raportin m\xe4\xe4r\xe4aika on","PERIOD":"Kausi","PUBLICATIONS":"Julkaisut","COURSES":"Opinnot","GRADUATION":"Valmistuminen","CONCLUSION":"Loppulause","DRAFT":"Luonnos","OPEN":"Avaa","MISSING":"Puuttuu","HAVE_A_THESIS_COMMITTEE_MEETIN":"Pid\xe4 seurantaryhm\xe4n kokous ja kirjoita loppulause avaamalla raportti.","REPORTS":"Raportit","LOADING_REPORTS":"Ladataan raportteja...","NO_REPORTS_YET":"Ei viel\xe4 raportteja","VIEW_CUMULATIVE_REPORT":"N\xe4yt\xe4 kumulatiivinen raportti","THESSA_IS_IN_MAINTENANCE":"Thessa on huollossa","PLEASE_WAIT_A_FEW_MINUTES_AND":"Odota muutama minuutti ja <0>lataa sivu uudelleen</0>","PAGE_NOT_FOUND":"Sivua ei l\xf6ydetty","SORRY_THE_PAGE_YOU_OPENED_CAN":"Avaamaasi sivua ei valitettavasti l\xf6ydy. Kokeile","FRONT_PAGE_INSTEAD":"etusivua","ADD_GRANT":"Lis\xe4\xe4 apuraha","ADD_SALARY":"Lis\xe4\xe4 palkka","SALARIES":"Palkat","GRANTS":"Apurahat","NO_SALARIES_IN_PLAN_YET":"Palkkaa ei ole viel\xe4 suunnitteilla.","NO_SALARIES":"Ei palkkoja.","NO_GRANTS_IN_PLAN_YET":"Suunnitelmissa ei ole viel\xe4 apurahoja.","NO_GRANTS":"Ei apurahoja.","SOURCE":"L\xe4hde","AMOUNT":"M\xe4\xe4r\xe4","FOR_MONTHS":"Kuukaudet","USED_FOR":"K\xe4ytet\xe4\xe4n","NOT_GRANTED":"Ei my\xf6nnetty","GRANTED":"My\xf6nnetty","FOR_DATES":"P\xe4iv\xe4m\xe4\xe4r\xe4t","HELP_MORE_GUIDES_LINK_PREFIX":"Avaa","HELP_MORE_GUIDES_LINK_URL":"https://studies.helsinki.fi/ohjeet/artikkeli/thessa","HELP_MORE_GUIDES_LINK_LINK_TEXT":"Opiskelijan ohjeet","HELP_MORE_GUIDES_LINK_SUFFIX":"saadaksesi lis\xe4\xe4 ohjeita Thessan k\xe4ytt\xf6\xf6n.","TRY_TO_INCLUDE_AS_MUCH_DETAI":"Kerro ongelmasta tai virhetilanteesta mahdollisimman yksityiskohtaisesti. Thessa on jatkuvan kehityksen kohteena ja kaikki palaute on meille arvokasta.","IF_YOU_NEED_MORE_HELP_PLEASE":"Jos sinulla on kysytt\xe4v\xe4\xe4 Thessasta tai tarvitset apua siihen liittyen,","INVITE":"Kutsu","S_EMAIL_ADDRESS":"{{roleName}} k\xe4ytt\xe4j\xe4n s\xe4hk\xf6postiosoite","INVITE_TO_YOUR_PHD_PROJECT_IN":"Kutsu v\xe4it\xf6skirjaprojektiisi Thessassa","INVITATION_SUBMITTED":"Kutsu l\xe4hetetty","SUBMITTING_INVITATION_FAILED":"Kutsun l\xe4hett\xe4minen ep\xe4onnistui","YOU_ARE_INVITED":"Olet saanut kutsun Thessaan","WHAT_IS_THESSA":"Mik\xe4 on Thessa?","ALL_DOCTORAL_CANDIDATES_AND_TH":"Sit\xe4 voivat k\xe4ytt\xe4\xe4 kaikki v\xe4it\xf6skirjatutkijat ja heid\xe4n ohjaajansa sek\xe4 seurantaryhm\xe4n j\xe4senet.","WELCOME_TO_THESSA":"Tervetuloa Thessaan!","YOU_ARE_NOT_CONNECTED_TO_ANYON":"Et ole yhdistetty keneenk\xe4\xe4n.","ASK_YOUR_DOCTORAL_CANDIDATES_T":"Pyyd\xe4 v\xe4it\xf6skirjatutkijoitasi l\xe4hett\xe4m\xe4\xe4n sinulle kutsu Thessastaan.","OTHERWISE_IT_S_GOING_TO":"Muuten t\xe4\xe4ll\xe4 tulee olemaan yksin\xe4ist\xe4.","NO_NOTES":"Ei muistiinpanoja.","EDIT":"Muokkaa","SAVING":"Tallentaa...","UPDATE_ANNUAL_REPORTS":"P\xe4ivitys: vuosikertomukset","ANNUAL_REPORTS_SECTION_HAS_BEE":"Vuosiraportit-osio on p\xe4ivitetty n\xe4ytt\xe4m\xe4\xe4n selvemmin raportin tilan ja pyydetyt toimenpiteet.","UPDATE_CUMULATIVE_REPORT":"P\xe4ivitys: kumulatiivinen raportti","CUMULATIVE_REPORT_VIEW_SHOWS_A":"Kumulatiivinen raporttin\xe4kym\xe4 n\xe4ytt\xe4\xe4 kaikki raportit samanaikaisesti, mik\xe4 helpottaa kokonaiskuvan ymm\xe4rt\xe4mist\xe4. Avaa vuosiraportit -osiossa painamalla \'N\xe4yt\xe4 kumulatiivinen raportti\' -painiketta.","UPDATE_REVIEWING_REPORTS":"P\xe4ivitys: Raporttien tarkistaminen","CUMULATIVE_REPORT":"Kumulatiivinen raportti","YOU_CAN_NOW_SEE_THE_CUMULATIVE":"Voit nyt n\xe4hd\xe4 kumulatiivisen raportin tarkistaessasi.","COMMENTING_REPORT":"Kommentointiraportti","DISCUSS_REPORTS":"Keskustele raporteista.","NEW_IMPROVEMENTS":"Uusia parannuksia!","INVITE_SUPERVISORS_AND_THESIS":"Kutsu ohjaajia ja seurantaryhm\xe4n j\xe4seni\xe4 k\xe4ytt\xe4m\xe4ll\xe4 s\xe4hk\xf6postiosoitteita.","DISCUSS_IN_SIMPLIFIED_ANNUAL_R":"Keskustele yksinkertaistetussa vuosikertomuksessa.","REPORTS_ARE_CLOSED_BY_WRITING":"Raportit p\xe4\xe4tet\xe4\xe4n kirjoittamalla loppulause.","READ_MORE_FROM_HELP_PAGE":"Lue lis\xe4\xe4 ohjesivulta.","SET_OF_DECISIONS_BETWEEN_DOCTO":"Sopimukset v\xe4it\xf6skirjatutkijan ja ohjaajan v\xe4lill\xe4, jotta varmistetaan, ett\xe4 v\xe4it\xf6skirjaprojekti etenee sujuvasti.","KEEPING_TRACK_OF_FUTURE_PLANS":"Tulevaisuuden opintojen etenemissuunnitelmien seuraaminen, julkaisut ja muut v\xe4it\xf6skirjatutkijan tohtorintutkintoon liittyv\xe4t asiat.","A_SNAPSHOT_OF_PHD_PROJECT_IT":"Tilannekuva v\xe4it\xf6skirjaprojektista. Se luodaan kerran vuodessa auttamaan v\xe4it\xf6skirjatutkijan ja ohjaajan v\xe4list\xe4 kommunikaatiota.","START_USING_THESSA":"Aloita Thessan k\xe4ytt\xf6!","WE_RECOMMEND_THAT_YOU_START_US":"Suosittelemme, ett\xe4 aloitat Thessan k\xe4yt\xf6n luomalla ohjaussuunnitelman. Ota yhteytt\xe4 ohjaajaasi sen luomiseksi.","THEN_YOU_SHOULD_UPDATE_YOUR_PH":"Sitten sinun tulee p\xe4ivitt\xe4\xe4 v\xe4it\xf6skirjaprojektisuunnitelmasi Thessassa niin, ett\xe4 ne n\xe4kyv\xe4t selv\xe4sti sinulle ja ohjaajalle. Voit aloittaa t\xe4m\xe4n my\xf6s heti!","YOU_CAN_FIND_MORE_DETAILS_ABOU":"L\xf6yd\xe4t lis\xe4tietoja Thessasta p\xe4\xe4valikon Ohje-osiosta.","IF_YOU_FIND_BUGS_OR_ERRORS_IN":"Jos l\xf6yd\xe4t bugeja tai virheit\xe4 Thessasta tai sinulla on idea sen parantamiseksi,","DROP_AN_EMAIL_TO_US":"laita meille s\xe4hk\xf6postia","YOUR_DOCTORAL_CANDIDATES_WILL":"V\xe4it\xf6skirjatutkijasi yhdist\xe4v\xe4t pian Thessa-tilins\xe4 sinun tiliisi. Sen j\xe4lkeen suosittelemme, ett\xe4 aloitat Thessan k\xe4yt\xf6n luomalla ohjaussuunnitelman v\xe4it\xf6skirjatutkijoille. Luo se oman Thessa-tilisi kanssa ja sitten jokainen allekirjoittaa sen Thessa-tilill\xe4\xe4n.","REMOVE1":"Poista","INTERNATIONAL_ACTIVITIES":{"TYPE":{"CONFERENCE":"Konferenssi","RESEARCH_VISIT":"Tutkimusvierailu","OTHER":"Muu"},"PARTICIPATION_TYPE":{"PARTICIPANT_POSTER":"Osallistuminen posteriesityksell\xe4","PARTICIPANT_TALK":"Osallistuminen esitelm\xe4ll\xe4","PARTICIPANT_WITHOUT_PRESENTATION":"Osallistuminen ilman esityst\xe4","ORGANISER":"J\xe4rjest\xe4j\xe4"}},"CONFERENCES_AND_MOBILITY":"Konferenssit ja liikkuvuus","LOCATION":"Sijainti","DATE":"P\xe4iv\xe4m\xe4\xe4r\xe4","DATES":"P\xe4iv\xe4m\xe4\xe4r\xe4t","LOADING_CONFERENCES_AND_MOBILI":"Ladataan konferensseja ja liikkuvuutta...","NO_CONFERENCES_OR_MOBILITY_PLA":"Konferensseja tai liikkuvuutta ei ole suunniteltu.","ADD_CONFERENCE_OR_MOBILITY":"Lis\xe4\xe4 konferenssi tai liikkuvuus","FAILED_TO_CREATE_CONFERENCE_OR_MOBILITY":"Virhe konferenssin tai liikkuvuuden luonnissa.","DELETE":"Poista","REALLY_CANCEL_INVITATION":"Perutko todella kutsun?","KEEP_INVITATION":"Pid\xe4 kutsu","CANCEL_INVITATION":"Peruuta kutsu","INVITATION_EXPIRED":"Kutsu on vanhentunut","INVITED_NOT_YET_RESPONDED":"Kutsuttu, ei viel\xe4 vastattu","FIRST_NAME":"Etunimi","LAST_NAME":"Sukunimi","EMAIL_ADDRESS":"S\xe4hk\xf6postiosoite","SAVED":"Tallennettu","REALLY_REMOVE":"Haluatko todella poistaa?","THE_LAST_MEMBER_CANNOT_BE_REMO":"Viimeist\xe4 j\xe4sent\xe4 ei voi poistaa.","RESEND_INVITATION":"L\xe4het\xe4 kutsu uudelleen","INVITATION_TO_BECOME_A":"Kutsu tulla","FOR":"varten","EXPIRES_ON":"Vanhenee","THIS_INVITATION_HAS_EXPIRED_Y":"T\xe4m\xe4 kutsu on vanhentunut. Voit pyyt\xe4\xe4 uutta v\xe4it\xf6skirjatutkijalta","ACCEPT":"Hyv\xe4ksy","DECLINE":"Hylk\xe4\xe4","DUE_TO_DATA_MIGRATION_THESSA":"Tietojen siirron vuoksi Thessa ei tied\xe4 t\xe4m\xe4n tilan alkamisp\xe4iv\xe4\xe4. Valitse oikea p\xe4iv\xe4m\xe4\xe4r\xe4 alta ja tallenna julkaisu.","NO_PUBLICATIONS_IN_PLAN_YET":"Suunnitelmissa ei ole viel\xe4 julkaisuja.","TOPIC_OR_TITLE":"Aihe tai otsikko","EDIT_REMINDER":"Muokkaa muistutusta","LOADING_YOUR_REMINDERS":"Ladataan muistutuksiasi","NEW_REMINDER":"Uusi muistutus","UPCOMING_REMINDERS":"Tulevia muistutuksia","PAST_REMINDERS":"Menneit\xe4 muistutuksia","NO_REMINDERS":"Ei muistutuksia","DUE":"Er\xe4\xe4ntynyt","SEND_REMINDERS_TO":"L\xe4het\xe4 muistutuksia osoitteeseen","REMINDER_TIMING":"Muistutuksen ajoitus","DAYS_BEFORE_DUE_DATE":"p\xe4iv\xe4\xe4 ennen er\xe4p\xe4iv\xe4\xe4","CREATE_REPORT":"Luo raportti","YOUR_ACCOUNT_IS_INACTIVE_THER":"Tilisi ei ole aktiivinen, joten et voi viel\xe4 luoda raporttia.","YOUR_DOCTORAL_PROGRAMME_S_STAF":"Tohtoriohjelmasi henkil\xf6kunta aktivoi tilin puolestasi, kun he ovat tarkastaneet profiilisi.","OPEN_REPORT":"Avaa raportti","OPEN_MEETING":"Avaa kokous","SUMMARIZE_THE_REPORTING_PERIOD":"Tee yhteenveto raportointikaudesta","AS_AN_OVERVIEW_OF_THE_REPORTIN":"Listaa raportointikauden yleiskatsauksena kolme positiivista ja kolme negatiivista asiaa.","PHD_PROJECT_PAGE":"V\xe4it\xf6skirjaprojektin sivu","PUBLICATIONS_IN_REPORTING_PERIOD":"Raportointikaudella kesken olleet tai julkaistut julkaisut.","NO_PUBLICATIONS_IN_REPORTING_PERIOD":"Raportointikaudella ei ole keskener\xe4isi\xe4 eik\xe4 julkaistuja julkaisuja.","COURSES_IN_REPORTING_PERIOD":"Raportointikaudella suoritetut opintojaksot.","INTERNATIONAL_ACTIVITY_IN_REPORTING_PERIOD":"Raportointikaudella toteutuneet konferenssit ja liikkuvuus.","TEACHING_IN_REPORTING_PERIOD":"Raportointikaudella tapahtunut opetus.","NO_COURSES_OR_WORKSHOPS_IN_REPORTING_PERIOD":"Raportointikaudella ei ole pidettyj\xe4 kursseja tai ty\xf6pajoja.","NO_THESIS_INSTRUCTION_IN_REPORTING_PERIOD":"Raportointikaudella ei ole j\xe4rjestetty opinn\xe4ytetty\xf6n ohjausta.","FUNDING_IN_REPORTING_PERIOD":"Raportointikaudella ollut rahoitus.","NO_SALARIES_IN_REPORTING_PERIOD":"Raportointikaudella ei ole palkkoja.","NO_GRANTS_IN_REPORTING_PERIOD":"Raportointikaudella ei ole apurahoja.","NOT_SUBMITTED":"Ei l\xe4hetetty","CONCLUSION_DONE":"Loppulause tehty","WRITE_CONCLUSION":"Kirjoita loppulause","HAVE_A_THESIS_COMMITTEE_MEETIN1":"Pid\xe4 seurantaryhm\xe4n kokous ja kirjoita raportin loppulause eli yhteenveto.","THE_DOCTORAL_CANDIDATE_NEEDS_T":"V\xe4it\xf6skirjatutkijan tulee j\xe4rjest\xe4\xe4 seurantaryhm\xe4n kokous ja kirjoittaa loppulause raporttiin.","DONE":"tehty","REPORT_SUBMITTED_FOR_REVIEW_SU":"Raportti l\xe4hetetty tarkistettavaksi.","REPORT_SUBMITTED":"Raportti l\xe4hetetty","REPORT_UPDATED":"Raportti p\xe4ivitetty","EDIT_REPORT":"Muokkaa raporttia","YOU_CAN_MAKE_CHANGES_TO_THE_RE":"Voit tehd\xe4 muutoksia raporttiin.","NO_REPORTS_TO_REVIEW_FOUND":"Tarkistettavia raportteja ei l\xf6ytynyt.","EDIT_REVIEW":"Muokkaa arviointia","REVIEW_REPORT":"Tarkista raportti","CHANGES_SAVED":"Muutokset tallennettu","LAST_SAVED":"Viimeksi tallennettu","CANCEL_EDITING":"Peruuta muokkaus","SAVE_REPORT":"Tallenna raportti","SUBMIT_REPORT_FOR_REVIEW":"L\xe4het\xe4 raportti tarkistettavaksi","CREATED_IN":"Luotu vuonna","CONFERENCES_AND_MOBILITY1":"Konferenssit ja liikkuvuus","FUNDING":"Rahoitus","TEACHING":"Opetus","COURSES_AND_WORKSHOPS":"Kurssit ja ty\xf6pajat","THESIS_INSTRUCTION":"Opinn\xe4ytet\xf6iden ohjaus","YOU_ARE_EDITING_THE_REPORT_S_C":"Muokkaat raportin p\xe4\xe4telmi\xe4 ja suosituksia","SHOW_EDITOR":"N\xe4yt\xe4 editori","PLEASE_INDICATE_WHO_ATTENDED_T":"Ilmoittakaa, ketk\xe4 osallistuivat seurantaryhm\xe4n kokoukseen.","THESIS_COMMITTEE_MEETING_FORM":"Seurantaryhm\xe4n kokouslomake","CONCLUSION_AND_RECOMMENDATIONS":"Loppulause","NO_REPORT_FOUND_CANNOT_EDIT_CONCLUSION":"Raporttia ei l\xf6ytynyt. Loppulausetta ei voi muokata.","NO_TEXT_TO_PREVIEW":"Ei teksti\xe4 esikatseltavaksi","CANNOT_SUBMIT_CONCLUSION_EMPTY":"Loppulause ei saa olla tyhj\xe4.","THE_DOCTORAL_CANDIDATE_IS_EXPE":"V\xe4it\xf6skirjatutkijan odotetaan t\xe4ytt\xe4v\xe4n t\xe4m\xe4 lomake v\xe4it\xf6skirjatoimikunnan kokouksen p\xe4\xe4tytty\xe4, kun kaikki osallistujat ovat paikalla.","PREVIEW":"Esikatselu","SUBMITTING_PLEASE_WAIT":"L\xe4hetet\xe4\xe4n, odota...","CONCLUSION_CONFIRM_CANCEL":"Oletko varma, ett\xe4 haluat lopettaa loppulauseen muokkaamisen? Kirjoittamasi teksti menetet\xe4\xe4n.","CONCLUSION_CANNOT_BE_EDITED":"Loppulause on jo kirjoitettu t\xe4lle raportille, eik\xe4 sit\xe4 voi muuttaa j\xe4lkik\xe4teen. Voit <0>palata takaisin raportille</0>.","CUMULATIVE_REPORT_FOR":"Kumulatiivinen raportti:","COMPLETED_IN_THE_MOST_RECENT":"valmis viimeisimm\xe4ss\xe4 raportissa","IN_PROGRESS_IN_THE_MOST_RECE":"edistynyt viimeisimm\xe4ss\xe4 raportissa","PUBLICATION_IS_IN_THESIS":"Julkaisu on osa v\xe4it\xf6skirjaa.","COMPLETE":"valmis","NOTHING_REPORTED_YET":"Mit\xe4\xe4n ei ole raportoitu viel\xe4.","DELETE_REPORT":"Poista raportti","YOU_CAN_DELETE_YOUR_REPORT_BEF":"Voit poistaa raportin ennen sen l\xe4hett\xe4mist\xe4.","COMPLETED1":"valmis","ESTIMATE_OF_HOW_COMPLETE_YOUR":"Arvio siit\xe4, kuinka valmis v\xe4it\xf6skirjaprojektisi on prosentteina.","FULL_TIME":"kokop\xe4iv\xe4inen","ESTIMATE_OF_FULL_PART_TIME_WOR":"Arvio koko/osa-aikaisesta ty\xf6st\xe4 v\xe4it\xf6skirjaprojektissa raportointijaksolla.","YOUR_DOCTORAL_PROGRAMME_ASKS_Y":"Tohtoriohjelmasi pyyt\xe4\xe4 sinua kirjoittamaan t\xe4m\xe4n raportin saadaksesi k\xe4sityksen siit\xe4, miten v\xe4it\xf6skirjaprojektisi etenee.","PLEASE_FILL_IN_ALL_OF_THE_FIEL":"T\xe4yt\xe4 kaikki kent\xe4t.","THE_REPORT_WILL_BE_VISIBLE_TO":"Raportti n\xe4kyy ohjaajillesi, seurantaryhm\xe4n j\xe4senille ja koordinaattoreille l\xe4hetyksen j\xe4lkeen.","AND":"ja","WHEN_YOU_ARE_DONE_PRESS_THE_S":"Kun olet valmis, paina L\xe4het\xe4-painiketta. Painike tulee n\xe4kyviin, kun olet t\xe4ytt\xe4nyt kaikki kent\xe4t. L\xe4hett\xe4misen j\xe4lkeen raportti on avoin kommentoitavaksi.","REMEMBER_TO_SAVE_THE_REPORT_PE":"Muista tallentaa raportti s\xe4\xe4nn\xf6llisesti. Voit tallentaa raportin milloin tahansa ja jatkaa sen kirjoittamista my\xf6hemmin.","MESSAGE_REMOVED":"Viesti poistettu.","DISCUSSION":"Keskustelu","LOADING":"Ladataan...","NO_DOCUMENT_FOUND_WITH_DATE":"P\xe4iv\xe4m\xe4\xe4r\xe4ll\xe4 varustettua asiakirjaa ei l\xf6ytynyt","APPROVED_BY_THE_BOARD_OF_DOCTO":"Helsingin yliopiston tohtorikoulutuksen johtoryhm\xe4n hyv\xe4ksym\xe4, <0>{{date}}</0>.","THESSA_JOIN_A_THESIS_COMMITT":"Thessa - Liity seurantaryhm\xe4\xe4n","WITH_YOUR_THESSA_CREDENTIALS_O":"Thessa-tunnuksillasi tai k\xe4yt\xe4 Helsingin yliopiston k\xe4ytt\xe4j\xe4tunnustasi.","OTHERWISE":"Muuten","REGISTER_AN_EXTERNAL_ACCOUNT":"rekister\xf6i ulkoinen tili","YOU_WILL_USE_THIS_FOR_LOGGING":"K\xe4yt\xe4t t\xe4t\xe4 kirjautumiseen.","AT_LEAST_CHARACTERS":"V\xe4hint\xe4\xe4n 8 merkki\xe4.","YOUR_ORGANIZATION":"Organisaatiosi","FOR_EXAMPLE_FINNISH_METEOROLO":"Esimerkiksi: Ilmatieteen laitos tai Acme Oy.","THERE_WERE_PROBLEMS_WITH_SIGN":"Ilmoittautumisessa oli ongelmia:","WELCOME_TO_THESSA_AS_A_NON_UN":"Tervetuloa Thessaan! Mik\xe4li sinulla ei ole Helsingin yliopiston k\xe4ytt\xe4j\xe4tunnusta, voit luoda tilisi t\xe4st\xe4.","ERROR":"Virhe","SORRY_AN_ERROR_HAS_OCCURRED_I":"Valitettavasti rekister\xf6itymisess\xe4 tapahtui virhe. Yrit\xe4 uudelleen p\xe4ivitt\xe4m\xe4ll\xe4 sivu tai","DOCTORAL_STUDIES":"Tohtoriopinnot","FILL_IN_DETAILS_OF_YOUR_STUDIE":"T\xe4yt\xe4 tiedot opinnoistasi.","BEGINNING_OF_DOCTORAL_STUDIES":"Tohtoriopintojen alkaminen","DOCTORAL_PROGRAMME":"Tohtoriohjelma","BACK":"Takaisin","CONTINUE":"Jatka","OR":"tai","LOG_OUT1":"kirjaudu ulos","WELCOME_TO_THESSA1":"Tervetuloa Thessaan","WE_NEED_SOME_INFORMATION_ABOUT":"Tarvitsemme tietoja sinusta, ennen kuin voit jatkaa.","MY_ROLE_IN_THESSA":"Roolini Thessassa","DOCTORAL_CANDIDATE":"V\xe4it\xf6skirjatutkija","SUPERVISOR":"Ohjaaja","SUPERVISOR_other":"Ohjaajat","THESIS_COMMITTEE_MEMBER":"Seurantaryhm\xe4n j\xe4sen","VERIFY_YOUR_DETAILS":"Vahvista tietosi","WE_FOUND_THE_FOLLOWING_DETAILS":"L\xf6ysimme seuraavat tiedot sinusta automaattisesti.","PLEASE_CHECK_THAT_THEY_ARE_COR":"Tarkista, ett\xe4 ne ovat oikein ja korjaa tarvittaessa.","LIST_DOCTORAL_CANDIDATES_BY_RE":"Listaa v\xe4it\xf6skirjatutkijat raportin tilan mukaan","LIST_REVIEWERS_OF_NOT_COMPLETE":"Luettele keskener\xe4isten raporttien arvioijat","DOWNLOAD_THESSA_ADMIN_REPORT":"Lataa Thessan p\xe4\xe4k\xe4ytt\xe4j\xe4raportti","REPORT_CONCLUSIONS_OVERVIEW":"Loppulauseiden yleiskatsaus","FILTER":"Suodata","SHOW_ALL_REPORTS":"N\xe4yt\xe4 kaikki raportit","OVER_MONTH_OLD_REPORTS":"Yli 2 kuukautta vanhoja raportteja","COPY_REVIEWER_EMAIL_ADDRESSES":"Kopioi arvioijien s\xe4hk\xf6postiosoitteet","EMAIL_ADDRESSES_COPIED":"S\xe4hk\xf6postiosoitteet kopioitu","CREATED_AT":"Luotu klo","REVIEWERS":"Arvioijat","FILTER_BY_DOCTORAL_PROGRAMME":"Suodata tohtoriohjelman mukaan","NO_REPORT_CONCLUSIONS_AVAILABL":"Tohtoriohjelmasta ei ole saatavilla loppulauseita","PRELIMINARY_TITLE_OF_DISSERTAT":"V\xe4it\xf6skirjan alustava nimi","STUDENT_NUMBER1":"OPISKELIJANUMERO","NAME1":"NIMI","ACCOUNT_CLOSED":"Tili suljettu:","STUDIES":"OPINNOT","FACULTY":"TIEDEKUNTA","SUPERVISORS1":"OHJAAJAT","THESIS_COMMITTEE2":"SEURANTARYHM\xc4","REPORT_CREATED":"Raportti luotu","PROGRESS1":"edistyminen","LINK_TO_THE_DOCTORAL_CANDIDATE":"Linkki v\xe4it\xf6skirjatutkijan Thessa-sivulle","STUDENT_ID_NUMBER":"Opiskelijanumero","ACCOUNT_STATUS_OPEN_CLOSED":"Tilin tila (avoin/suljettu)","IF_ACCOUNT_IS_CLOSED_REASON_F":"Jos tili suljetaan, sulkemisen syy","IS_ACCOUNT_ACTIVE_ACTIVE_INAC":"Onko tili aktiivinen (aktiivinen/ei-aktiivinen)","EMAIL2":"s\xe4hk\xf6posti","FACULTY1":"tiedekunta","FACULTY_OF_DEGREE":"Tiedekunta","STARTING_DATE_OF_DOCTORAL_STUD":"Tohtoriopintojen alkamisp\xe4iv\xe4","DOES_THE_DOCTORAL_CANDIDATE_HA":"Onko v\xe4ittelij\xe4ll\xe4 ohjaussuunnitelma?","IS_THE_SUPERVISION_PLAN_IN_EFF":"Onko ohjaussuunnitelma voimassa","SUPERVISORS2":"ohjaajat","SUPERVISORS_AND_THEIR_EMAIL_AD":"Ohjaajat ja heid\xe4n s\xe4hk\xf6postiosoitteensa","IS_THE_ANNUAL_REPORT_SUBMITTED":"Onko vuosiraportti toimitettu","LATEST_REPORT_SUBMITTED_AT_DATE":"Viimeisin raportti l\xe4hetetty p\xe4iv\xe4m\xe4\xe4r\xe4n\xe4","THE_ANNUAL_REPORTING_IS_CLOSED":"Vuosiraportointi on p\xe4\xe4ttynyt ja loppulause kirjoitettu","NEXT_REPORT_S_DEADLINE":"Seuraavan raportin m\xe4\xe4r\xe4aika","THESIS_COMMITTEE_HAS_BEEN_ASSI":"Seurantaryhm\xe4 on perustettu","MEMBERS_OF_THE_THESIS_COMMITTE":"Seurantaryhm\xe4n j\xe4senet ja heid\xe4n s\xe4hk\xf6postiosoitteensa","OVERALL_PERCENTAGE_OF_COMPLETI":"V\xe4it\xf6skirjasta valminna prosentteina","ADVANCEMENT_OF_THESIS_WORK_COM":"V\xe4it\xf6skirjan eteneminen raportointikauden aikana","FULL_TIME_PART_TIME":"T\xe4ysiaikainen osa-aikainen","SALARIES2":"palkat","GRANTS2":"apurahat","GRANTS_OBTAINED_AND_APPLIED_FO":"Apurahoja on saatu ja haettu","EXPORT":"Vie","CREATE_SUPERVISION_PLAN":"Luo ohjaussuunnitelma","DELETE_SUPERVISION_PLAN":"Poista ohjaussuunnitelma","ACCEPT_PLAN":"Hyv\xe4ksy suunnitelma","VALID_BETWEEN":"Voimassa v\xe4lill\xe4","VALID_FROM":"Voimassa toistaiseksi alkaen","VALID_INDEFINITELY":"Ohjaussuunnitelma on voimassa toistaiseksi","VALID_INDEFINITELY_SHORT":"Voimassa toistaiseksi","DECISIONS":"P\xe4\xe4t\xf6kset","SIGNATURES":"Allekirjoitukset","SIGNED":"Allekirjoitettu","NOT_YET_SIGNED":"Ei viel\xe4 allekirjoitettu","WHAT_HAVE_YOU_DECIDED_ABOUT_TH":"T\xe4yt\xe4 v\xe4hint\xe4\xe4n yksi valinnainen kentt\xe4 siit\xe4, mit\xe4 olette yhdess\xe4 p\xe4\xe4tt\xe4neet ty\xf6skentelytavoista v\xe4it\xf6skirjaty\xf6n etenemiseksi","ACTIVE":"Aktiivinen","PENDING":"Odottaa","EXPIRED":"Vanhentunut","GENERAL_TERMS_ON":"Yleiset ohjaussuunnitelman ehdot:","RIGHTS_OBLIGATIONS_AND_RESPON2":"Oikeudet, velvollisuudet ja vastuut tohtorikoulutuksessa Helsingin yliopistossa","THAT_APPLY_TO_THE_SUPERVISION":"","NO_COURSES_OR_WORKSHOPS_IN_PLA":"Kursseja tai ty\xf6pajoja ei ole viel\xe4 suunnitteilla.","NO_THESIS_INSTRUCTIONS_IN_PLAN":"Suunnitelmissa ei ole viel\xe4 opinn\xe4ytety\xf6ohjeita.","ADD_TEACHING":"Lis\xe4\xe4 opetus","TYPE_OF_TEACHING":"Opetuksen tyyppi","DATES1":"P\xe4iv\xe4m\xe4\xe4r\xe4t","COURSE_OR_WORKSHOP_NAME":"Kurssin tai ty\xf6pajan nimi","MY_ROLE":"Minun roolini","WORK_HOURS":"Ty\xf6ajat","STUDENT_S_NAME":"Oppilaan nimi","THESIS_LEVEL":"Opinn\xe4ytety\xf6n taso","THESIS_TOPIC_OR_TITLE":"Opinn\xe4ytety\xf6n aihe tai otsikko","SIGNED_UP_ON":"Tili luotu","USERNAME":"K\xe4ytt\xe4j\xe4tunnus","ACTIVATE_ACCOUNT_NOW":"Aktivoi tili nyt","USER_ACCOUNT_IS_NOT_YET_ACTIVA":"K\xe4ytt\xe4j\xe4tili\xe4 ei ole viel\xe4 aktivoitu","CHECK_THE_ACCOUNT_DETAILS_IF":"Tarkista tilin tiedot \u2013 jos k\xe4ytt\xe4j\xe4 todella on organisaatiossasi, aktivoi tili. Muuten","CONTACT_THESSA_S_ADMINS":"ota yhteytt\xe4 Thessan yll\xe4pit\xe4jiin","CLOSE_ACCOUNT":"Sulje tili","REASON_FOR_CLOSING_THE_ACCOUNT":"Syy tilin sulkemiseen","OPEN_ACCOUNT":"Aktivoi tili uudelleen","OPEN_ACCOUNT_ERROR":{"ERROR":"Tilin uudelleenaktivointi ep\xe4onnistui","IS_ALREADY_OPEN":"Tili on jo aktiivinen","NOT_DOCTORAL_CANDIDATE":"K\xe4ytt\xe4j\xe4 ei ole v\xe4it\xf6skirjatutkija","ALREADY_REOPENED_BY_USERNAME":"K\xe4ytt\xe4j\xe4tili on jo aktivoitu uudelleen (v\xe4liaikainen k\xe4ytt\xe4j\xe4tunnus l\xf6ytyi)","ALREADY_REOPENED_BY_EMAIL":"K\xe4ytt\xe4j\xe4tili on jo aktivoitu uudelleen (v\xe4liaikainen s\xe4hk\xf6postiosoite l\xf6ytyi)"},"FACULTY2":"Tiedekunta:","MAJOR":"P\xe4\xe4aine:","DOCTORAL_PROGRAMME1":"Tohtoriohjelma:","BEGINNING_OF_DOCTORAL_STUDIES1":"Tohtoriopintojen alkaminen:","BACK_TO":"Takaisin","ORGANIZATION":"Organisaatio","STUDENT_NUMBER2":"Opiskelijanumero:","VERIFIED_FROM_LDAP":"Vahvistettu LDAP:sta)","NOT_VERIFIED_REPORTED_BY_DOCT":"Ei vahvistettu, v\xe4ittelij\xe4n ilmoittama)","THESIS_COMMITTEE_MEMBER1":"Opinn\xe4ytety\xf6toimikunnan j\xe4sen","IN_THESIS_COMMITTEE_FOR":"Seurantaryhm\xe4ss\xe4 {{count}} v\xe4it\xf6skirjatutkijalle","IN_THESIS_COMMITTEE_FOR_other":"Seurantaryhm\xe4ss\xe4 {{count}} v\xe4it\xf6skirjatutkijalle","THE_INVITATION_HAS_EXPIRED":"<0>Kutsu on vanhentunut.</0>","THE_INVITATION_HAS_ALREADY_BEEN_USED":"<0>T\xe4m\xe4 kutsu on jo k\xe4ytetty.</0>","THERE_WAS_AN_ERROR_IN_LOADING_THE_INVITATION":"<0>Kutsun lataamisessa tapahtui virhe.</0> <1>Yrit\xe4 uudelleen</1>. <2>Ilmoita meille</2>, jos ongelma ei poistu.","INVITATION_DECLINED":"<0>Kutsu hyl\xe4tty.</0> Kiitos vastauksestasi!","YOUR_ACCOUNT_IS_CLOSED":"Tilisi on suljettu","SUPERVISION_PLAN_NOT_FOUND":"Ohjaussuunnitelmaa ei l\xf6ydy","IN_THESIS":"V\xe4it\xf6skirjassa","PUBLISHED":"Julkaistu","NOT_STARTED":"Ei alkanut","THE_SUPERVISION_PLAN_AFFECTS_THE_DOCTORAL":"Ohjaussuunnitelma koskee v\xe4it\xf6skirjatutkijaa ja kaikkia h\xe4nen ohjaajiaan.","IT_IS_RECOMMENDED_THAT_SUPERVISION_PLANS":"Ohjaussuunnitelmat on suositeltava tehd\xe4, silloin kun kaikki, joihin se vaikuttaa, ovat paikalla. Jos joku ei p\xe4\xe4se paikalle, muista tehd\xe4 suunnitelma, jonka h\xe4nkin voi allekirjoittaa.","CREATE_AND_SIGN_PLAN_AS":"Tallenna lopullisesti ja allekirjoita","SAVE_DRAFT":"Tallenna luonnos","SAVE_DRAFT_FEEDBACK":"Luonnos tallennettu","LOADING_DOCTORAL_PROGRAMMES":"Ladataan tohtoriohjelmia...","FORM_IS_INCOMPLETE":"Lomake ei ole valmis","DESCRIPTION":"Kuvaus","ROLE_IN_CONFERENCE":"Rooli konferenssissa","FAILED_TO_SAVE":"<0>Tallennus ep\xe4onnistui.</0> Yrit\xe4 uudelleen tai <1>ota meihin yhteytt\xe4</1>, jos ongelma jatkuu.","ROLE":"Rooli","PREVIOUS_PAGE":"Edellinen <0>sivu</0>","NEXT_PAGE":"Seuraava <0>sivu</0>","ROWS":"rivi\xe4","PAGE_OF":"<0>Sivu {{currentPage}}</0> <1>/{{totalPages}}</1>","PAGE":"Sivu","MAX_SIZE_PER_ATTACHMENT":"Liitteen suurin mahdollinen koko:","UPLOAD_ATTACHMENTS":"Lataa liitteet","UPLOADING":"Ladataan...","WHAT_PLANS_DO_YOU_HAVE":"Mit\xe4 suunnitelmia sinulla on? Tukevatko suoritetut opinnot t\xe4t\xe4 tavoitetta?","WRITE_HERE_ABOUT_YOUR_RESEARCH_PROGRESS":"Kirjoita t\xe4h\xe4n tutkimukseksesi edistymisest\xe4 raportointijaksolla. Pysy p\xe4\xe4kohdissa ja kirjoita lyhyesti, jotta seurantaryhm\xe4 voi arivoida edistymist\xe4si helposti. Huomaa, ett\xe4 voit ladata p\xe4ivitetyn tutkimussuunnitelmasi tai muun asiaankuuluvan materiaalin t\xe4h\xe4n raportin liitteen\xe4.","FOR_EXAMPLE_WRITE_ABOUT_HOSTING_A_VISITOR":"Kirjoita esimerkiksi vierailijan is\xe4nn\xf6imisest\xe4 tai kansallisten opintomatkojen j\xe4rjest\xe4misest\xe4.","FOR_EXAMPLE_HAVE_YOU_WRITTEN_A_BLOG":"Oletko esimerkiksi kirjoittanut blogia tai populaaritieteellist\xe4 artikkelia, j\xe4rjest\xe4nyt oman alasi ulkopuoliselle yleis\xf6lle suunnatun tapahtuman tai yritt\xe4nyt vaikuttaa jollain muulla tavalla?","NO_REPORTS":"Ei raportteja","ANY":"Mik\xe4 tahansa","FILTER_BY":"Suodata {{target}}","SORT_BY":"Lajitteluperuste","THERE_WAS_AN_ERROR_IN_LOADING_DOCTORAL_CANDIDATES":"<0>V\xe4it\xf6skirjatutkijoiden lataamisessa tapahtui virhe.</0> <1>Yrit\xe4 uudelleen</1>. <2>Ilmoita meille</2>, jos ongelma ei poistu.","THERE_ARE_NO_DOCTORAL_CANDIDATES_IN_THE_SELECTED":"Yht\xe4\xe4n v\xe4it\xf6skirjatutkijaa ei l\xf6ytynyt.","DOCTORAL_PROGRAMMES":"Tohtoriohjelmat","ERROR_LOADING_DOCTORAL_PROGRAMMES":"<0>Virhe ladattaessa tohtoriohjelmia.</0> <1>Yrit\xe4 uudelleen</1>. Jos se ei auta, <2>ilmoita siit\xe4 meille</2>.","SELECT_NONE":"\xc4l\xe4 valitse mit\xe4\xe4n","SELECT_ALL":"Valitse kaikki","WHEN_WILL_EACH_STAGE_OF_THE_PUBLICATION_BEGIN":"Milloin jokainen julkaisun vaihe alkaa? Jos vaihe tulevaisuudessa, arvioi, milloin se alkaisi. Jokaisen tilan tulee alkaa edellisen j\xe4lkeen.","THE_STATUSES_ARE_IN_INCORRECT_ORDER":"Tilat ovat v\xe4\xe4r\xe4ss\xe4 j\xe4rjestyksess\xe4: jokaisen tilan tulee alkaa edellisen j\xe4lkeen.","TO_BE_INCLUDED_IN_THE_PHD_THESIS":"Sis\xe4ltyy v\xe4it\xf6skirjaan","SAVE_PUBLICATION":"Tallenna julkaisu","CREATE_ANOTHER":"Luo toinen","CREATING_ANOTHER_PUBLICATION":"Luodaan toista julkaisua","CREATING_ANOTHER_GRANT":"Luodaan toinen apuraha","SOURCE_OF_GRANT":"Apurahan l\xe4hde","FROM_WHICH_ORGANIZATION_IS_THE_GRANT_FROM":"Milt\xe4 organisaatiolta apuraha on per\xe4isin?","HOW_MUCH_IS_THIS_GRANT":"Kuinka paljon t\xe4m\xe4 apuraha on?","SAVE_GRANT":"Tallenna apuraha","ENDS_AT":"P\xe4\xe4ttyy","BEGINS_AT":"Alkaa","WHAT_IS_THE_INTENDED_USAGE_OF_THIS_GRANT":"Mik\xe4 on t\xe4m\xe4n apurahan k\xe4ytt\xf6tarkoitus?","DURATION_OF_GRANT":"Apurahan kesto","WHEN_DOES_THIS_GRANT_BEGIN_AND_END":"Milloin t\xe4m\xe4 apuraha alkaa ja p\xe4\xe4ttyy? Jos tarkkaa p\xe4iv\xe4m\xe4\xe4r\xe4\xe4 ei ole, tee arvio.","CREATING_ANOTHER_TEACHING":"Toisen opetuksen luominen","BEGINNING_DATE":"Aloitusp\xe4iv\xe4m\xe4\xe4r\xe4","END_DATE":"P\xe4\xe4ttymisp\xe4iv\xe4","NAME_OF_THE_COURSE_OR_WORKSHOP":"Kurssin tai ty\xf6pajan nimi","MY_ROLE_IN_TEACHING":"Oma roolini opetuksessa","FOR_EXAMPLE_LECTURER_OR_ASSISTANT":"Esimerkiksi <0>luennoitsija</0> tai <1>assistentti</1>.","TOPIC_OR_TITLE_OF_THE_THESIS":"Opinn\xe4ytety\xf6n aihe tai otsikko","LEVEL_OF_THESIS":"Opinn\xe4ytety\xf6n taso","COURSE_OR_WORKSHOP":"Kurssi tai ty\xf6paja","HOW_MANY_HOURS_OF_WORK_DID_YOU_SPEND_IN_TOTAL":"Kuinka monta tuntia ty\xf6h\xf6n k\xe4ytit yhteens\xe4?","NAME_OF_THE_STUDENT_WHO_YOUR_WERE_INSTRUCTING":"Sen opiskelijan nimi, jota ohjasit","MY_ROLE_IN_INSTRUCTING_THE_STUDENT":"Oma roolini opiskelijan ohjaamisessa","FOR_EXAMPLE_MAIN_SUPERVISOR_OR_CO_SUPERVISOR":"Esimerkiksi <0>p\xe4\xe4ohjaaja</0> tai <1>apuohjaaja</1>.","FOR_EXAMPLE_MASTERS_THESIS_OR_BACHELORS_THESIS":"Esimerkiksi <0>pro gradu</0> tai <1>kandidaattity\xf6</1>.","CREATING_ANOTHER_SALARY":"Toisen palkan luominen","SOURCE_OF_SALARY":"Palkan l\xe4hde","FROM_WHICH_ORGANIZATION_AND_OR_PROJECT_DO_YOU_GET":"Mist\xe4 organisaatiosta ja/tai projektista saat palkkasi?","DURATION_OF_SALARY":"Palkan kesto","WHEN_DOES_THIS_SALARY_BEGIN_AND_END_IF_THERE_IS_NO":"Milloin t\xe4m\xe4 palkka alkaa ja p\xe4\xe4ttyy? Jos tarkkaa p\xe4iv\xe4m\xe4\xe4r\xe4\xe4 ei ole, tee arvio.","SAVE_SALARY":"Tallenna palkka","DUE_DATE":"Er\xe4p\xe4iv\xe4","SEND_REMINDER_EMAILS_AT":"L\xe4het\xe4 muistutuss\xe4hk\xf6postit osoitteeseen","SAVE_REMINDER":"Tallenna muistutus","LOG_IN_OR_SIGN_UP_TO_ACCEPT_INVITATION":"Kirjaudu sis\xe4\xe4n tai rekister\xf6idy hyv\xe4ksy\xe4ksesi kutsu.","LOG_IN_WITH_UNIVERSITY_OF_HELSINKI_ACCOUNT":"Kirjaudu sis\xe4\xe4n Helsingin yliopiston tilill\xe4","I_DON_T_HAVE_A_UNIVERSITY_OF_HELSINKI_ACCOUNT":"Minulla ei ole Helsingin yliopiston tili\xe4","LOG_IN_WITH_AN_EXISTING_THESSA_ACCOUNT":"Kirjaudu sis\xe4\xe4n olemassa olevalla Thessa-tilill\xe4.","LOG_IN_OR_SIGN_UP_FOR_A_THESSA_ACCOUNT_TO":"Kirjaudu sis\xe4\xe4n tai rekister\xf6idy Thessa-tilillesi hyv\xe4ksy\xe4ksesi kutsu.","SIGN_UP_FOR_A_NEW_THESSA_ACCOUNT":"Luo uusi Thessa-tili","ERROR_LOGIN_OR_SIGN_UP":"VIRHE - kirjaudu sis\xe4\xe4n tai rekister\xf6idy!","INVITATION_HAS_EXPIRED_AT":"Kutsu on vanhentunut {{date}}. <0>Siirry Thessan etusivulle</0>","INVITATIONS":{"BY_ACCEPTING_THE_INVITATION":"Hyv\xe4ksym\xe4ll\xe4 kutsun saat n\xe4hd\xe4 t\xe4m\xe4n v\xe4it\xf6skirjaprojektin Thessassa.","UNIVERSITY_STAFF_OR_STUDENTS_HEADING":"Helsingin yliopiston ty\xf6ntekij\xe4t ja opiskelijat","UNIVERSITY_STAFF_OR_STUDENTS_INSTRUCTIONS":"Jos olet t\xf6iss\xe4 tai opiskelet Helsingin yliopistossa, voit hyv\xe4ksy\xe4 kutsun kirjautumalla Helsingin yliopiston tunnuksellasi.","EXTERNAL_USERS_HEADING":"Muut","EXTERNAL_USERS_INSTRUCTIONS":"Jos et ole Helsingin yliopiston ty\xf6ntekij\xe4 tai opiskelija, voit hyv\xe4ksy\xe4 kutsun kirjautumalla Thessa-tilille.","EXTERNAL_EXISTING_USERS_HEADING":"Olemassa oleva Thessa-tili","EXTERNAL_EXISTING_USERS_INSTRUCTIONS":"Jos olet aiemmin k\xe4ytt\xe4nyt Thessaa, kirjaudu sis\xe4\xe4n olemassa olevalle Thessa-tilillesi.","EXTERNAL_NEW_USERS_HEADING":"Luo Thessa-tili","EXTERNAL_NEW_USERS_INSTRUCTIONS":"Jos et ole aiemmin k\xe4ytt\xe4nyt Thessaa, eik\xe4 sinulla ole Helsingin yliopiston tunnusta, voit luoda itsellesi k\xe4ytt\xe4j\xe4tilin Thessaan.","EXTERNAL_NEW_USERS_ACTION":"Luo Thessa-tili","YOU_ARE_USING_UNIVERSITY_EMAIL":"K\xe4yt\xe4t Helsingin yliopiston s\xe4hk\xf6postiosoitetta. Sinun kannattaa todenn\xe4k\xf6isesti kirjautua sis\xe4\xe4n Helsingin yliopiston tunnuksellasi sen sijaan, ett\xe4 loisit uuden Thessa-tilin.","DECLINE_INSTRUCTIONS":"Jos sait t\xe4m\xe4n kutsun vahingossa, pyyd\xe4mme sinua hylk\xe4\xe4m\xe4\xe4n sen.","DECLINE_ACTION":"Hylk\xe4\xe4 kutsu","FAILED_TO_ACCEPT_INVITATION":"<0>Kutsun hyv\xe4ksymisess\xe4 tapahtui virhe.</0> Yrit\xe4 uudelleen. <1>Ilmoita meille</1>, jos ongelma ei poistu."},"YOU_HAVE_BEEN_INVITED_TO_BECOME":"Sinut on kutsuttu <0>{{roles}} henkil\xf6lle {{inviter}}</0> Thessassa.","ACCEPT_INVITATION":"Hyv\xe4ksy kutsu","THERE_WAS_AN_ERROR_IN_DECLINING_THE_INVITATION":"<0>Kutsun hylk\xe4\xe4misess\xe4 tapahtui virhe.</0> Yrit\xe4 uudelleen. <1>Ilmoita meille</1>, jos ongelma ei poistu.","SIGN_UP_FOR_A_NEW_THESSA_ACCOUNT_TO":"Luo uusi Thessa-tili hyv\xe4ksy\xe4ksesi kutsun.","SIGN_UP":"Kirjaudu","ERROR_IN_SIGN_UP":"Virhe rekister\xf6itymisess\xe4.","LOG_IN_FAILED_TRY_AGAIN":"Kirjautuminen ep\xe4onnistui. Yrit\xe4 uudelleen.","ROLES":"Roolit","DOES_NOT_HAVE_ANY_ROLES_ASSIGNED":"K\xe4ytt\xe4j\xe4lle <0>{{name}} ei ole m\xe4\xe4ritettyj\xe4 rooleja.</0> Jokaisella on oltava v\xe4hint\xe4\xe4n yksi rooli.","THERE_WAS_AN_ERROR_IN_UPDATING_ROLES":"<0>Roolien p\xe4ivityksess\xe4 tapahtui virhe.</0> Yrit\xe4 uudelleen. <1>Ilmoita meille</1>, jos ongelma ei poistu.","ONLY_ONE_PERSON_CAN_BE_THE_COORDINATING":"Vain yksi henkil\xf6 voi olla vastuuhenkil\xf6.","ONLY_ONE_PERSON_CAN_BE_THE_MAIN_SUPERVISOR":"P\xe4\xe4ohjaajana voi toimia vain yksi henkil\xf6.","ONE_PERSON_SHOULD_BE_SELECTED_AS_THE_COORDINATING":"Yksi henkil\xf6 tulee valita vastuuhenkil\xf6ksi.","ONE_PERSON_SHOULD_BE_SELECTED_AS_THE_MAIN":"P\xe4\xe4ohjaajaksi tulee valita yksi henkil\xf6.","MYSELF":"Itse","FILTERS":"Suodattimet","CHOOSE_A_DOCTORAL_PROGRAMME":"Valitse tohtoriohjelma","LOADING_INACTIVE_USER":"Ladataan passiivista k\xe4ytt\xe4j\xe4\xe4...","NO_STUDENT_NUMBER":"Ei opiskelijanumeroa","SIGNED_UP":"Rekister\xf6idy","NO_SUPERVISORS":"Ei ohjaajia","SUPERVISOR_INVITATIONS":"Ohjaajakutsut","ACTIVATE":"Aktivoida","SEND_EMAIL":"L\xe4het\xe4 s\xe4hk\xf6postia","NO_EMAIL_ADDRESS":"Ei s\xe4hk\xf6postiosoitetta","THERE_WAS_AN_ERROR_IN_ACTIVATING_THE_USER_ACCOUNT":"<0>K\xe4ytt\xe4j\xe4tilin aktivoinnissa tapahtui virhe.</0> <1>Yrit\xe4 uudelleen</1>. <2>Ilmoita meille</2>, jos ongelma ei poistu.","SELECT_DOCTORAL_PROGRAMME":"Valitse tohtoriohjelma","NO_DOCTORAL_PROGRAMME_SELECTED":"Tohtoriohjelmaa ei ole valittu","SELECT_DOCTORAL_PROGRAMMES":"Valitse tohtoriohjelmat","ALL_DOCTORAL_PROGRAMMES":"Kaikki tohtoriohjelmat","NOT_VERIFIED":"Ei vahvistettu","VERIFY_NOW":"Vahvista nyt","DOCTORAL_CANDIDATE_DOES_NOT_HAVE_ANY_SUPERVISORS":"V\xe4it\xf6skirjatutkijalla ei ole ohjaajia.","COUNT_THESIS_COMMITTEE_MEMBER":"{{count}} seurantaryhm\xe4n j\xe4sen","COUNT_THESIS_COMMITTEE_MEMBER_other":"{{count}} seurantaryhm\xe4n j\xe4sent\xe4","COUNT_SUPERVISOR_RELATIONSHIP":"{{count}} ohjaussuhdetta","COUNT_SUPERVISOR_RELATIONSHIP_other":"{{count}} ohjaussuhdetta","COUNT_PUBLICATION_IN_PROGRESS":"{{count}} julkaisu k\xe4ynniss\xe4","COUNT_PUBLICATION_IN_PROGRESS_other":"{{count}} julkaisua k\xe4ynniss\xe4","COUNT_PUBLICATION_PUBLISHED":"{{count}} julkaisu julkaistu","COUNT_PUBLICATION_PUBLISHED_other":"{{count}} julkaisua julkaistu","MAIN_SUPERVISOR":"P\xe4\xe4ohjaaja","MAIN_SUPERVISOR_other":"P\xe4\xe4ohjaajat","COORDINATING_ACADEMIC":"Vastuuhenkil\xf6","COORDINATING_ACADEMIC_other":"Vastuuhenkil\xf6t","COUNT_DOCTORAL_CANDIDATE":"{{count}} v\xe4it\xf6skirjatutkija l\xf6ydetty","COUNT_DOCTORAL_CANDIDATE_other":"{{count}} v\xe4it\xf6skirjatutkijaa l\xf6ydetty","ONLY_SHOW_DOCTORAL_CANDIDATES_LATE_WITH_NEXT_THESIS_COMMITTEE_MEETING":"N\xe4yt\xe4 vain v\xe4it\xf6skirjatutkijat joiden seurantaryhm\xe4kokous on my\xf6h\xe4ss\xe4","ONLY_SHOW_DOCTORAL_CANDIDATES_WITHOUT_ACCOUNT":"N\xe4yt\xe4 vain v\xe4it\xf6skirjatutkijat ilman tili\xe4","ONLY_SHOW_DOCTORAL_CANDIDATES_WITHOUT_SUPERVISOR":"N\xe4yt\xe4 vain v\xe4it\xf6skirjatutkijat ilman ohjaajaa","COUNT_DOCTORAL_CANDIDATE_S_REPORT":"{{count}} v\xe4it\xf6skirjatutkijan raportti on my\xf6h\xe4ss\xe4 ({{percentage}}%)","COUNT_DOCTORAL_CANDIDATE_S_REPORT_other":"{{count}} v\xe4it\xf6skirjatutkijan raportti on my\xf6h\xe4ss\xe4 ({{percentage}}%)","COUNT_DOCTORAL_CANDIDATE_S_LATEST":"{{count}} v\xe4it\xf6skirjatutkijan viimeisin raportti ei ole viel\xe4 valmis ({{percentage}}%)","COUNT_DOCTORAL_CANDIDATE_S_LATEST_other":"{{count}} v\xe4it\xf6skirjatutkijan viimeisin raportti ei ole viel\xe4 valmis ({{percentage}}%)","COUNT_DOCTORAL_CANDIDATE_IS_ON_TIME":"{{count}} v\xe4it\xf6skirjatutkija on ajoissa ({{percentage}}%)","COUNT_DOCTORAL_CANDIDATE_IS_ON_TIME_other":"{{count}} v\xe4it\xf6skirjatutkijaa on ajoissa ({{percentage}}%)","COUNT_ITEM_IN_QUEUE":"{{count}} kohde jonossa","COUNT_ITEM_IN_QUEUE_other":"{{count}} kohdetta jonossa","OLDEST_ITEM_FIRST":"vanhin ensin","ISPROCEEDING":"edistyminen","IS_THE_ANNUAL_REPORT_PROCEEDING_AS_PLANNED":"Edistyyk\xf6 vuosiraportti suunnitellusti","CONCLUSIONCOMMENT":"johtop\xe4\xe4t\xf6sMiten","COMMENT_ABOUT_THE_PROGRESS_OF_THE":"P\xe4\xe4ohjaajan kommentti v\xe4it\xf6skirjan etenemist\xe4","PROGRESS_FEEDBACK_BY":"Edistymispalautteen l\xe4hett\xe4j\xe4","IS_THE_DISSERTATION_WORK_PROCEEDING_AS_PLANNED":"Sujuuko v\xe4it\xf6skirjaty\xf6 suunnitellusti?","PROGRESS_FEEDBACK_IS_MISSING":"Palaute edistymisest\xe4 puuttuu","PROGRESS_FEEDBACK_SUBMITTED":"Palaute edistymisest\xe4 l\xe4hetetty","GIVE_PROGRESS_FEEDBACK":"Anna palautetta edistymisest\xe4","THERE_WAS_A_PROBLEM_SUBMITTING_PROGRESS_FEEDBACK":"Edistymispalautteen l\xe4hett\xe4misess\xe4 oli ongelma","PROGRESS_FEEDBACK_SUBMITTED_REDIRECTING_YOU_BACK":"Palaute edistymisest\xe4 l\xe4hetetty. Ohjataan takaisin <0>esittelysivulle</0>","PROGRESS_FEEDBACK":"Palaute edistymisest\xe4","COMMENT1":"Kommentti","OPTIONAL_COMMENT_ABOUT_THE_PROGRESS_OF_THE":"Vapaaehtoinen kommentti v\xe4it\xf6skirjan etenemisest\xe4","MOBILE":"mobiili","DESKTOP":"Ty\xf6p\xf6yt\xe4","VIEW_ACCOUNT":"N\xe4yt\xe4 tili","EDIT_ROLES":"Muokkaa rooleja","REMOVE_SUPERVISOR":"Poista ohjaaja","ENDING_ON_DATE":"P\xe4\xe4ttyy {{date}}","INVITE_SUPERVISOR":"Kutsu ohjaaja","ADD_SUPERVISOR":"Lis\xe4\xe4 ohjaaja","FAILED_TO_SEND_INVITE_PLEASE_TRY_AGAIN":"<0>Kutsun l\xe4hett\xe4minen ep\xe4onnistui.</0> Yrit\xe4 uudelleen tai <1>ota yhteytt\xe4 Thessa-tukeen</1> saadaksesi apua.","SAVE_ROLES":"Tallenna roolit","ERROR_IN_SAVING_ROLES_TRY_AGAIN_OR":"Virhe roolien tallentamisessa. Yrit\xe4 uudelleen tai <0>ota yhteytt\xe4 tukeen</0>.","INVITATION":"Kutsu","REMOVE_INVITATION":"Poista kutsu","YOU_HAVE_NO_ACTIVE_DOCTORAL_CANDIDATES_IN_THESSA":"Sinulla ei ole t\xe4ll\xe4 hetkell\xe4 aktiivisia v\xe4it\xf6skirjatutkijoita Thessassa.","NOT_IN_THESSA":"K\xe4ytt\xe4j\xe4n on kirjauduttava sis\xe4\xe4n aktivoidakseen tilins\xe4","UPLOAD_AN_EXCEL_FILE_WITH_SUPERVISOR_RELATIONSHIPS":"L\xe4het\xe4 Excel-tiedosto, jossa on ohjaussuhteet","CHANGE_FILE":"Vaihda tiedosto","GO_BACK":"Mene takaisin","SAVE_SUPERVISOR_RELATIONSHIPS":"Tallenna ohjaussuhteet","DOCTORAL_CANDIDATE_ROW":"V\xe4it\xf6skirjatutkijarivi","IGNORE":"J\xe4t\xe4 huomiotta","COORDINATING_ACADEMIC_EMAIL":"Vastuuhenkil\xf6n s\xe4hk\xf6postiosoite","MAIN_SUPERVISOR_EMAIL":"P\xe4\xe4ohjaajan s\xe4hk\xf6posti","SUPERVISOR_EMAIL":"Ohjaajan s\xe4hk\xf6posti","SUPERVISOR_RELATIONSHIPS":"Ohjaussuhteet","UPLOAD_A_FILE_WITH_SUPERVISOR_RELATIONSHIPS":"L\xe4het\xe4 tiedosto, jossa on ohjaajatiedot","PICK_COLUMNS_AND_ROWS_TO_IMPORT":"Valitse tuotavat sarakkeet ja rivit","FOR_EACH_COLUMN_WITH_RELEVANT_DATA":"Valitse oikea sarake avattavasta valikosta jokaiselle sarakkeelle, jossa on oleellisia tietoja (opiskelijanumero ja ohjaajien s\xe4hk\xf6postiosoitteet). J\xe4t\xe4 loput sarakkeet huomiotta j\xe4tetyiksi.","THEN_SELECT_EACH_ROW_WITH_A_SUPERVISOR":"Valitse sitten jokainen rivi, jonka on ohjaajatiedot haluat tallentaa, ja paina Esikatselu-painiketta.","CHECK_THAT_THE_FOLLOWING_PREVIEW_IS_CORRECT":"Tarkista, ett\xe4 seuraava esikatselu n\xe4ytt\xe4\xe4 oikealta. Jos esikatselu on oikein, aloita tuonti painamalla Tallenna valvojan suhteet -painiketta. Jos esikatselu on virheellinen, voit ladata uuden Excel-tiedoston tai paina paluupainiketta ja muuta sarake- ja rivivalintoja.","IMPORT_SUCCESSFUL":"Tuonti onnistui","IMPORT_FAILED_PLEASE_CONTACT_US_FOR_HELP":"<0>{{message}}</0> <1>Ota meihin yhteytt\xe4</1> saadaksesi apua.","FILE_UPLOAD_WAS_NOT_SUCCESSFUL_PLEASE_TRY_AGAIN":"<0>Tiedoston l\xe4hetys ei onnistunut.</0> Yrit\xe4 uudelleen.","NOTES":"Muistiinpanot","COURSE_TITLE":"Opintojakson nimi","SALARY_SOURCE":"Palkkal\xe4hde","GRANT_SOURCE":"Apurahan l\xe4hde","STUDENT":"Opiskelija","STATUS_OF_THE_PHD_PROJECT":"V\xe4it\xf6skirjaprojektin tila","LATEST_REPORT":"Viimeisin raportti","TIME_SPENT_ON_PHD":"V\xe4it\xf6skirjaprojektiin k\xe4ytetty aika","SOCIAL_IMPACT_AND_PUBLIC_OUTREACH":"Yhteiskunnallinen vaikutus ja tieteen popularisointi","ATTACHMENTS":"Liitteet","THREE_POSITIVE_THINGS":"Kolme positiivista asiaa","THREE_NEGATIVE_THINGS":"Kolme negatiivista asiaa","CAREER_PLANNING":"Urasuunnittelu","CONCLUSIONS":"Loppulause","OTHER_WORK":"Muu ty\xf6","WAIT_FOR_ONE_MINUTE_BEFORE_RESENDING":"Odota minuutti ennen kuin l\xe4het\xe4t uudelleen","ACCOUNT_IS_CLOSED":"Tili on suljettu","ACCOUNT_IS_ACTIVE":"Tili on aktiivinen","ACCOUNT_IS_INACTIVE":"Tili ei ole aktiivinen","ESTIMATED_STATUS_OF_THE_PHD_PROJECT":"V\xe4it\xf6skirjaprojektin arvioitu tila","ESTIMATED_TIME_OF_PHD_DEFENCE":"Arvio v\xe4ittelyajasta","CAREER_PLANS_AFTER_YOUR_PHD":"Urasuunnitelmat tohtorintutkinnon j\xe4lkeen","BACK_TO_OVERVIEW":"Takaisin yleiskatsaukseen","BACK_TO_REPORT":"Takaisin raporttiin","CHANGE_SUPERVISOR":"Vaihda ohjaaja","ADD_SUPERVISOR_FOR_NAME":"Lis\xe4\xe4 ohjaaja k\xe4ytt\xe4j\xe4lle {{name}}","FAILED_TO_ADD_SUPERVISOR_PLEASE_TRY_AGAIN_OR":"<0>Ohjaajan lis\xe4\xe4minen ep\xe4onnistui.</0> Yrit\xe4 uudelleen tai <1>ota yhteytt\xe4 Thessa-tukeen</1> saadaksesi apua.","FAILED_TO_INVITE_SUPERVISOR_PLEASE_TRY_AGAIN_OR":"<0>Ohjaajan kutsuminen ep\xe4onnistui.</0> Yrit\xe4 uudelleen tai <1>ota yhteytt\xe4 Thessa-tukeen</1> saadaksesi apua.","INVITE_SUPERVISOR_FOR_NAME":"Kutsu ohjaaja k\xe4ytt\xe4j\xe4lle {{name}}","CHOOSE_LANGUAGE":"Valitse kieli","PREPARATION_AND_ANALYSIS":"Valmistelu ja analysointi","WRITING":"Kirjoitus","NAME_IS_NOT_YET_ON_THESSA_WHEN_THEY_SIGN_UP":"<0>{{name}} ei ole viel\xe4 ottanut Thessaa k\xe4ytt\xf6\xf6ns\xe4.</0> V\xe4it\xf6skirjatutkijan tulee kirjautua sis\xe4\xe4n Thessaan kerran, ennen kuin h\xe4nen tietonsa voidaan n\xe4ytt\xe4\xe4.","INVITE_THESIS_COMMITTEE":"Kutsu seurantaryhm\xe4","EDIT_THESIS_COMMITTEE":"Muokkaa seurantaryhm\xe4\xe4","YOUR_USER_ACCOUNT_NEEDS_TO_BE_ACTIVATED":"K\xe4ytt\xe4j\xe4tilisi on aktivoitava ennen kuin voit luoda ensimm\xe4isen raportin. Ennen kuin tilisi voidaan aktivoida, sinun on <0>kutsuttava kaikki opinn\xe4ytety\xf6toimikunnan j\xe4senet</0> Thessassa.","YOU_WILL_RECEIVE_AN_EMAIL_WHEN_YOUR_ACCOUNT":"Saat s\xe4hk\xf6postin, kun tilisi on aktivoitu.","ESTIMATE_MADE_ON":"Arvio tehty","PHD_PROJECT_STATUS":"Edistyminen","TIME_SPENT_PERIOD":"Aikav\xe4li","PRELIMINARY_TITLE_OF_DISSERTATION":"V\xe4it\xf6skirjan alustava nimi","EDIT_PRELIMINARY_TITLE_OF_DISSERTATION":"Muokkaa v\xe4it\xf6skirjan alustavaa nime\xe4","CREATE_PRELIMINARY_TITLE_OF_DISSERTATION":"Lis\xe4\xe4 v\xe4it\xf6skirjan alustava nimi","SUBJECT_OR_STUDENT":"Aihe tai opiskelija","APPLICATION_SENT":"Hakemus l\xe4hetetty","PLANNING_TO_APPLY":"Suunnitellaan hakemista","CREDITS_one":"{{count}} opintopiste","CREDITS_other":"{{count}} opintopistett\xe4","CR":"{{count}} op","WHAT_WAS_DECIDED":"Mit\xe4 p\xe4\xe4tettiin?","ROLE_NAME":{"key":"value","doctoral-candidate":"V\xe4it\xf6skirjatutkija","coordinating-academic":"Vastuuhenkil\xf6","main-supervisor":"P\xe4\xe4ohjaaja","supervisor":"Ohjaaja","thesis-committee-member":"Seurantaryhm\xe4n j\xe4sen","salary-system-foreman":"Esimies","coordinator":"Koordinaattori"},"CHECK_REPORT_STATUS":"Tarkista raportin tila.","CHECK_SUPERVISION_PLAN_STATUS":"Tarkista ohjaussuunnitelman tila.","CHECK_NEXT_THESIS_COMMITTEE_MEETING_REPORT_STATUS":"V\xe4it\xf6skirjatutkija ei ole l\xe4hett\xe4nyt raporttia","SEARCH_BY":"Etsi tunnisteella {{keyword}}","COMPLETE_THE_REPORT_FORM":"T\xe4yt\xe4 raporttilomake ja l\xe4het\xe4 raportti.","CONCLUSION_CAN_BE_WRITTER_AFTER":"Loppulause voidaan kirjoittaa raportin j\xe4tt\xe4misen j\xe4lkeen.","YES":"Kyll\xe4","NO":"Ei","PLEASE_INVITE_TCMS_TO_THESSA":"Kutsu kaikki seurantaryhm\xe4si j\xe4senet Thessaan.","COORDINATOR_TOOLS":{"key":"value","MAIN_HEADING":"Ty\xf6kalut","HEADINGS":{"key":"value","MANAGE_USERS":"K\xe4ytt\xe4j\xe4t","STATISTICS":"Tilastot","OTHER":"Muut"},"TOOLS":{"key":"value","LATEST_REPORTS":"Viimeisimm\xe4t raportit","INCOMPLETE_REPORTS":"Keskener\xe4iset raportit","ADMIN_REPORT":"Thessan admin-raportti","IMPORT_SUPERVISOR_RELATIONSHIPS":"Tuo ohjaussuhteita"},"DESCRIPTIONS":{"key":"value","DOCTORAL_CANDIDATES":"Hallitse v\xe4it\xf6skirjatutkijoita","USERS":"Hallitse kaikkia k\xe4ytt\xe4ji\xe4","REPORT_CONCLUSIONS_OVERVIEW":"Kaikkien v\xe4it\xf6skirjatutkijoiden loppulauseet","LATEST_REPORTS":"V\xe4it\xf6skirjatutkijoiden viimeisimpien raporttien tila","INCOMPLETE_REPORTS":"V\xe4it\xf6skirjatutkijat ja ohjaajat, joilla on keskener\xe4isi\xe4 raportteja","ADMIN_REPORT":"Lataa v\xe4it\xf6skirjatutkijoiden tiedot CSV-tiedostona","IMPORT_SUPERVISOR_RELATIONSHIPS":"Excelist\xe4 Thessaan"}},"SHOW_ALL_DOCTORAL_CANDIDATES":"N\xe4yt\xe4 kaikki v\xe4it\xf6skirjatutkijat","HIDE_INACTIVE_DOCTORAL_RESEARCHERS":"Piilota ei-aktiiviset v\xe4it\xf6skirjatutkijat","DOCTORAL_RESEARCHER_OVERVIEW":"V\xe4it\xf6skirjatutkijan yleiskatsaus","LAST_COMPLETED_REPORT":"Viimeksi valmistunut raportti","FILTER_DOCTORAL_RESEARCHERS":"Suodata v\xe4it\xf6skirjatutkijoita","SUPERVISOR_RELATIONSHIP_OVERVIEW":{"key":"value","IF_MISSING":"Jos vastuuhenkil\xf6 tai ohjaajia puuttuu listasta tai ohjausj\xe4rjestelyihin on tullut muutoksia, ota yhteytt\xe4 <0>{{supportEmail}}</0>."},"THESIS_COMMITTEE_MEMBERS":{"key":"value","SUPERVISORS_ARE_HANDLED_BY_OTHERS":"Ohjaajatietoja yll\xe4pit\xe4\xe4 tiedekuntasi jatko-opintopalvelu ja tohtoriohjelmasi suunnittelija. Yhteystiedot l\xf6ytyv\xe4t ","LINK":"https://studies.helsinki.fi/ohjeet/artikkeli/tohtorikoulutuksen-palvelut","LINK_TITLE":"opiskelijan ohjeista","INVITATION_HEADING":"Kutsu seurantaryhm\xe4n j\xe4senet","INVITATION_HEADING_FOR_SUPERVISORS":"Kutsu ohjaajat","INVITATION_LABEL":"Seurantaryhm\xe4n j\xe4senen s\xe4hk\xf6postiosoite","INVITATION_LABEL_FOR_SUPERVISORS":"Ohjaajan s\xe4hk\xf6postiosoite"},"CONTACT":{"HEADING":"Yhteystiedot","CONTACT_TEXT_PREFIX":"Ota yhteytt\xe4","CONTACT_TEXT_SUFFIX":", jos sinulla on kysytt\xe4v\xe4\xe4 Thessan k\xe4ytt\xf6\xf6n liittyen tai teknisi\xe4 ongelmia esimerkiksi Thessaan kirjautumisessa tai kutsun hyv\xe4ksymisess\xe4.","UNIHELP_URL":"https://uni-help.helsinki.fi/fi","UNIHELP_URL_TITLE":"HelsinkiUni Helpiin"},"DATE_RANGE_PICKER":{"INVALID_START_DATE":"Alkamisp\xe4iv\xe4 ei ole oikea p\xe4iv\xe4m\xe4\xe4r\xe4.","INVALID_END_DATE":"Loppumisp\xe4iv\xe4 ei ole oikea p\xe4iv\xe4m\xe4\xe4r\xe4.","INVALID_END_IS_BEFORE_START":"Loppumisp\xe4iv\xe4n tulee olla alkamisp\xe4iv\xe4n j\xe4lkeen."},"COORDINATOR_DOCTORAL_CANDIDATES":{"PLACEHOLDER":"Tohtoriohjelma tai opiskelijanumero","LABEL":"Hae tohtoriohjelmalla tai opiskelijanumerolla","ACTION":"Hae"},"END_OF_SENTENCE_PERIOD":".","RESOURCES":{"INTRO_VIDEO":"PajRucu9XfM"},"MENU":"Valikko","FRONTPAGE":"Etusivu","OPEN_PROFILE_MENU":"Avaa profiilivalikko","CLOSE_PROFILE_MENU":"Sulje profiilivalikko","OPEN_MAIN_MENU":"Avaa p\xe4\xe4valikko","CLOSE_MAIN_MENU":"Sulje p\xe4\xe4valikko","CHANGE_LANGUAGE":"Vaihda kieli","PROFILE_MENU":"Profiilivalikko","MAIN_MENU":"P\xe4\xe4valikko","FOOTER_MENU":"Alatunniste-valikko","DATE_NOT_SPECIFIED":"P\xe4iv\xe4m\xe4\xe4r\xe4\xe4 ei ole m\xe4\xe4ritetty","EMAIL_OR_USER_INPUT":{"HINT":"Kirjoita oikea s\xe4hk\xf6postiosoite tai valitse jokin ehdotuksista"},"FORM":{"REQUIRED_FIELD":"Pakollinen","OPTIONAL_FIELD":"Valinnainen","VALID_EMAIL_ADDRESS_REQUIRED":"Sy\xf6t\xe4 kelvollinen s\xe4hk\xf6postiosoite","PASSWORD_REQUIREMENTS":"V\xe4hint\xe4\xe4n 10 merkki\xe4","VALID":"Kelvollinen","INVALID":"Kelvoton","OPTIONAL":"Valinnainen","COMPLETE_FIELDS_TO_SAVE_FORM":"Huomaa, ett\xe4 kaikki kent\xe4t on t\xe4ytett\xe4v\xe4, jotta lomake voidaan tallentaa.","COMPLETE_FIELDS_TO_SUBMIT_FORM":"Huomaa, ett\xe4 kaikki kent\xe4t on t\xe4ytett\xe4v\xe4, jotta lomake voidaan l\xe4hett\xe4\xe4.","CONFIRM_CANCEL":"Oletko varma, ett\xe4 haluat lopettaa muokkaamisen? Tallentamattomat muutokset menetet\xe4\xe4n."},"INVITATION_ROLE":{"YOUR_ROLE":"Roolisi","COORDINATING_ACADEMIC":"vastuuhenkil\xf6","MAIN_SUPERVISOR":"p\xe4\xe4ohjaaja","SUPERVISOR":"ohjaaja","THESIS_COMMITTEE_MEMBER":"seurantaryhm\xe4n j\xe4sen"},"EDIT_PUBLICATION":"Muokkaa julkaisua","EDIT_SALARY":"Muokkaa palkkaa","EDIT_GRANT":"Muokkaa apurahaa","EDIT_COURSE_WORKSHOP":"Muokkaa kurssia/ty\xf6pajaa","EDIT_THESIS_INSTRUCTION":"Muokkaa opinn\xe4ytety\xf6n ohjausta","EDIT_TEACHING":"Muokkaa opetusta","FOR_STUDENT":"opiskelijalle","CREATE_NEW_REMINDER":"Luo uusi muistutus","LOGO_OF_UNIVERSITY_OF_HELSINKI":"Helsingin Yliopiston logo","NEW":"Uusi","CHANGED":"Muuttunut","INDICATOR":"osoitin","STATUS_IN_THE_MOST_RECENT":"Viimeisimm\xe4n raportin tila","DETAILS_WITH_LABEL":"Lis\xe4tiedot: {{ label }}","ADD_PUBLICATION":"Lis\xe4\xe4 julkaisu","ADD_COURSE":"Lis\xe4\xe4 opintojakso","EDIT_NOTES":"Muokkaa <0>muistiinpanoja</0>","CANCEL_EDITING_NOTES":"Peruuta <0>muistiinpanojen muokkaaminen</0>","SAVE_NOTES":"Tallenna <0>muistiinpanot</0>","SEND_MESSAGE":"L\xe4het\xe4 viesti","REMOVE_COMMENT":"Poista kommentti","REPORT_VIEW":{"ERROR":{"MISSING_REPORT":"Raporttia ei l\xf6ytynyt.","FAILED_TO_SAVE_REPORT":"<0>Raportin tallentaminen ei onnistunut.</0> Tarkista, ett\xe4 raporttilomakkeella ei ole virheit\xe4 ja yrit\xe4 uudelleen tai <1>ota meihin yhteytt\xe4</1>.","FAILED_TO_SUBMIT_REPORT":"<0>Raportin l\xe4hett\xe4minen tarkastettavaksi ei onnistunut.</0> Tarkista, ett\xe4 raporttilomakkeella ei ole virheit\xe4 ja yrit\xe4 uudelleen tai <1>ota meihin yhteytt\xe4</1>.","FAILED_TO_DELETE_REPORT":"<0>Raportin poistaminen ei onnistunut.</0> Yrit\xe4 uudelleen tai <1>ota meihin yhteytt\xe4</1>."}},"PHD_PROJECT":{"ERROR":{"GENERAL_ERROR_HEADING":"Thessassa on k\xe4ynyt virhe.","YOU_CAN_RETRY_OR":"Voit yritt\xe4\xe4 p\xe4ivitt\xe4\xe4 sivun, mutta jos se ei auta","INCLUDE_THIS_TEXT":"Auta vian selvitt\xe4misess\xe4 liitt\xe4m\xe4ll\xe4 t\xe4m\xe4 teksti viestiisi","CANNOT_INITIALIZE":"V\xe4it\xf6skirjaprojektin tietojen lataaminen palvelimelta ep\xe4onnistui."}},"CANCEL_INVITING_THESIS_COMMITTEE_MEMBER":"Peruuta seurantaryhm\xe4n j\xe4senen kutsuminen","INFORMATION":"Tiedot","COMMENT":"Kommentti","WRITE_YOUR_COMMENT_HERE":"Kirjoita kommenttisi t\xe4h\xe4n","HIDE_DISCUSSION":"Piilota keskustelu","SHOW_DISCUSSION":"N\xe4yt\xe4 keskustelu","VIEW_SUPERVISION_PLAN":"N\xe4yt\xe4 ohjaussuunnitelma","ADD_COURSE_WORKSHOP":"Lis\xe4\xe4 kurssi/ty\xf6paja","ADD_THESIS_INSTRUCTION":"Lis\xe4\xe4 opinn\xe4ytety\xf6n ohjaus","UNTITLED":"Nime\xe4m\xe4t\xf6n","UNTITLED_PUBLICATION":"Nime\xe4m\xe4t\xf6n julkaisu","UNTITLED_SALARY":"Nime\xe4m\xe4t\xf6n palkka","UNTITLED_GRANT":"Nime\xe4m\xe4t\xf6n apuraha","UNTITLED_TEACHING":"Nime\xe4m\xe4t\xf6n opetus","REMOVAL_CONFIRMATION":"Vahvista poisto","THESSA_INTRODUCTION_VIDEO":"Thessan esittelyvideo","ACCESSIBILITY_STATEMENT":"Saavutettavuusseloste","INFORMATION_ON_THE_ACCESSIBILITY_OF_THE_WEBSITE":"Tietoa sivuston saavutettavuudesta","LAST_UPDATED":"P\xe4ivitetty viimeksi","YOU_WILL_NOT_BE_ABLE_TO_ACCESS":"Et voi k\xe4ytt\xe4\xe4 Thessaa, sill\xe4 tilisi on suljettu.","REQUEST_ACCOUNT_REACTIVATION":"L\xe4het\xe4 meille s\xe4hk\xf6postia jos haluat jatkaa Thessan k\xe4ytt\xe4mist\xe4.","REMINDER":"Muistutus","BACK_TO_STATISTICS":"Takaisin tilastoihin","BACK_TO_USER_DETAILS":"Takaisin k\xe4ytt\xe4j\xe4tietoihin","FOR_EXAMPLE":"Esimerkiksi","DOWNLOAD":{"DOWNLOAD":"Lataa","DOWNLOAD_CSV_FILE":"Lataa CSV-tiedosto","DOWNLOAD_EXCEL_FILE":"Lataa Excel-tiedosto"},"PLEASE_SELECT_ONE_OF_THE_FOLLOWING_TYPES":"Valitse yksi seuraavista tyypeist\xe4","PLEASE_SELECT_YOUR_ROLE_IN_THE_CONFERENCE":"Valitse roolisi konferenssissa","PLEASE_NOTE_YOU_HAVE_THE_OPTION_TO_SAVE":"Voit tallentaa edistymisesi milloin tahansa, vaikka kaikki pakolliset kent\xe4t eiv\xe4t olisikaan viel\xe4 t\xe4ytetty. Muista palata ja t\xe4ytt\xe4\xe4 kaikki puuttuvat tiedot ennen raportin lopullista l\xe4hett\xe4mist\xe4.","DURATION_OF_TEACHING":"Opetuksen kesto","CURRENT":"Meneill\xe4\xe4n","UPCOMING":"Tulossa","SITEMAP":"Sivukartta","UPON_LOGGING_IN":"Kirjautumisen j\xe4lkeen t\xe4m\xe4 sivukartta p\xe4ivittyy automaattisesti n\xe4ytt\xe4m\xe4\xe4n sinulle Thessassa saatavilla olevia sivuja ja toimintoja.","OVERVIEW_OF_ALL_SITE_PAGES":"Yleiskatsaus kaikista sivuista helpottamaan navigointia ja nopeaa p\xe4\xe4sy\xe4 sis\xe4lt\xf6ihin.","UPDATED":"P\xe4ivitetty","PLEASE_FILL_OUT_ALL_REQUIRED_FIELDS":"T\xe4yt\xe4 kaikki pakolliset kent\xe4t.","PLEASE_FILL_OUT_ALL_REQUIRED_FIELDS_AND_DATES":"T\xe4yt\xe4 kaikki pakolliset kent\xe4t ja tarkista p\xe4iv\xe4m\xe4\xe4r\xe4t.","PLEASE_ENTER_VALID_DATES":"Sy\xf6t\xe4 kelvolliset p\xe4iv\xe4m\xe4\xe4r\xe4t.","IS_MISSING":"puuttuu","THE_VALUE_ENTERED_IS_INVALID":"Sy\xf6tetty arvo on virheellinen","CLOSE":"Sulje","CHOOSE":"Valitse","SUBMITTING_FORM_FAILED":"Lomakkeen l\xe4hett\xe4minen ep\xe4onnistui.","TRANSCRIPT_OF_THESSA_INTRODUCTION_VIDEO":"Thessan esittelyvideon tekstitys","INTRODUCTION_TO_USING_THESSA_FOR_DOCTORAL":"Johdanto Thessan k\xe4ytt\xf6\xf6n v\xe4it\xf6skirjatutkijoille","CHOOSE_LANGUAGE_FROM_THE_LANGUAGE_NAVIGATION":"Valitse kieli kielivalikosta","AFTER_LOGGING_IN":"Kirjautumisen j\xe4lkeen p\xe4\xe4dyt \\"V\xe4it\xf6skirjaprojektini\\" -sivulle, joka koostuu seuraavista osioista","SUPERVISION_PLANS_ARE_CREATED_BY_YOUR_SUPERVISORS":"Ohjaajasi luovat ohjaussuunitelmasi. Saat s\xe4hk\xf6postia, kun ohjaajasi ovat luoneet sinulle uuden ohjaussuunnitelman. Hyv\xe4ksy\xe4ksesi suunnitelman, klikkaa s\xe4hk\xf6postissa olevaa linkki\xe4 ja sen j\xe4lkeen klikkaa \\"Hyv\xe4ksy suunnitelma\\" -painiketta ohjaussuunnitelman sivulla.","PLANS_FOR_YOUR_PHD_PROJECT":"V\xe4it\xf6skirjaprojektisi suunnitelmat","PLANS_FOR_YOUR_PHD_PROJECT_ARE_CREATED_BY_YOU":"V\xe4it\xf6skirjaprojektisi suunnitelmat luot itse. N\xe4m\xe4 suunnitelmat sis\xe4lt\xe4v\xe4t tietoja julkaisuistasi, konferensseista, kursseista ja muista v\xe4it\xf6skirjaprojektiisi liittyvist\xe4 asioista.","REPORTS_ARE_CREATED_BY_YOU_AND_INCLUDE_INFORMATION":"Luot itse raportit ja ne sis\xe4lt\xe4v\xe4t tietoja edistymisest\xe4si v\xe4it\xf6skirjaprojektissasi. Ne voidaan tallentaa luonnoksina ja l\xe4hett\xe4\xe4, kun olet valmis raportin kanssa.","YOUR_SUPERVISORS_ARE_ADDED_AUTOMATICALLY":"Ohjaajasi lis\xe4t\xe4\xe4n automaattisesti. Voit n\xe4hd\xe4 ohjaajasi ja heid\xe4n yhteystietonsa.","YOU_CAN_SEE_INFORMATION_ABOUT_YOUR_THESIS_COMMITTEE":"Voit n\xe4hd\xe4 tietoja serurantaryhm\xe4n j\xe4senist\xe4. Seurantaryhm\xe4n j\xe4senet on kutsuttava manuaalisesti \\"Seurantaryhm\xe4\\" -sivulla.","DIGITAL_SERVICE_ACCESSIBILITY_STATUS":"Digipalvelun saavutettavuuden tila","GENERAL_SECTIONS_AND_FEATURES_THAT_ARE_NOT_ACCESSIBLE":"Yleiset osat ja toiminnallisuudet, jotka eiv\xe4t ole saavutettavia","SERVICES_FOR_DOCTORAL_RESEARCHERS_THAT_ARE_NOT_ACCESSIBLE":"V\xe4it\xf6skirjatutkijoiden palvelut, jotka eiv\xe4t ole saavutettavia","SERVICES_FOR_SUPERVISORS_THAT_ARE_NOT_ACCESSIBLE":"Ohjaajien palvelut, jotka eiv\xe4t ole saavutettavia","SERVICES_FOR_COORDINATORS_THAT_ARE_NOT_ACCESSIBLE":"Koordinaattorien palvelut, jotka eiv\xe4t ole saavutettavia","NOT_WITHIN_THE_SCOPE_OF_LEGISLATION":"Lains\xe4\xe4d\xe4nn\xf6n piiriin kuulumattomat","ACCESSIBILITY_FEEDBACK":"Puutteista raportoiminen","SUPERVISORY_AUTHORITY":"Valvontaviranomainen","CONTACT_INFORMATION_OF_THE_REGULATOR":"Valvontaviranomaisen yhteystiedot","REGULATOR":"Liikenne- ja viestint\xe4virasto Traficom","ACCESSIBILITY_CONTROL_UNIT":"Digitaalisen esteett\xf6myyden ja saavutettavuuden valvontayksikk\xf6","TEL_SWITCHBOARD":"Puhelinnumero vaihde","PERCEIVABLE":"Havaittava","OPERABLE":"Hallittava","UNDERSTANDABLE":"Ymm\xe4rrett\xe4v\xe4","ROBUST":"Toimintavarma","ACCESSIBILITY_OF_THESSA":"Thessan saavutettavuus","THIS_ACCESSIBILITY_STATEMENT_APPLIES":"T\xe4m\xe4 saavutettavuusseloste koskee <0>Helsingin yliopiston Thessa-palvelua</0>","THE_SERVICE_IS_SUBJECT_TO_THE_LAW":"Palvelua koskee laki digitaalisten palvelujen tarjoamisesta, jossa edellytet\xe4\xe4n, ett\xe4 julkisten verkkopalvelujen on oltava saavutettavia. Olemme arvioineet palvelun saavutettavuuden itse.","THE_ACCESSIBILITY_STATEMENT_HAS_BEEN_CREATED_ON":"Saavutettavuusseloste on laadittu {{ createdDate }} ja p\xe4ivitetty viimeksi {{ lastUpdatedDate }}.","INFO_AND_RELATIONSHIPS":"WCAG 1.3.1: Informaatio ja suhteet","ERROR_IDENTIFICATION":"WCAG 3.3.1: Virheen tunnistaminen","ON_INPUT":"WCAG 3.2.2: Sy\xf6te","TIMING_ADJUSTABLE":"WCAG 2.2.1: S\xe4\xe4dett\xe4v\xe4 ajoitus","USE_OF_COLOR":"WCAG 1.4.1: V\xe4rien k\xe4ytt\xf6","CONTRAST_MINIMUM":"WCAG 1.4.3: Kontrasti (minimi)","PARSING":"WCAG 4.1.1: J\xe4sent\xe4minen","NAME_ROLE_VALUE":"WCAG 4.1.2: Nimi, rooli, arvo","STATUS_MESSAGES":"WCAG 4.1.3: Tilasta kertovat viestit","THE_THESSA_SERVICE_OF_THE_UNIVERSITY_OF_HELSINKI_MEETS":"Helsingin yliopiston Thessa-palvelu t\xe4ytt\xe4\xe4 lain vaatimat A ja AA-tason saavutettavuusvaatimukset (WCAG-2.1) suurimmalta osin. Havaitut saavutettavuuspuutteet kuvataan tarkemmin alempana. N\xe4m\xe4 mainitut puutteet pyrit\xe4\xe4n korjaamaan digipalvelun yll\xe4pidon yhteydess\xe4. Lue lis\xe4\xe4 <0>saavutettavuudesta Helsingin yliopistolla.</0>","DATA_TABLES_ARE_NOT_PROGRAMMATICALLY_DISPLAYED":"Taulukkomaista tietoa ei ole esitetty ohjelmallisesti taulukkomuodossa","THE_INFORMATION_ON_THE_CONFERENCES_AND_MOBILITY":"V\xe4it\xf6skirjaprojektini-sivulla oleva Konferenssit ja liikkuvuus -osion tieto ei ole ohjelmallisesti esitetty taulukkomuodossa","FORMS_DO_NOT_SUFFICIENTLY_GUIDE_USERS_ON_INCORRECT":"Lomakkeet eiv\xe4t opasta k\xe4ytt\xe4j\xe4\xe4 riitt\xe4v\xe4sti virheellisist\xe4 tai vajaista sy\xf6tteist\xe4","THE_SUBMISSION_BUTTONS_IN_THE_FORMS_FOR_SUPERVISION":"Ohjaussuunnitelma- ja raporttisivujen lomakkeiden l\xe4hetyspainikkeet ovat poistettu k\xe4yt\xf6st\xe4 lomakkeen ollessaan vajaasti tai virheellisesti t\xe4ytetty","A_FORM_DOES_NOT_DISPLAY_THE_SUBMISSION_BUTTON":"Lomake ei n\xe4yt\xe4 l\xe4hetyspainiketta","THE_SUBMISSION_BUTTON_FOR_THE_PROGRESS_FEEDBACK":"Raportin yhteydess\xe4 j\xe4tett\xe4v\xe4n edistymispalautteen lomakkeen l\xe4hetyspainike n\xe4ytet\xe4\xe4n vasta esikatselu tilassa ja on muutoin piilotettu k\xe4ytt\xe4j\xe4lt\xe4","TITLES_HAVE_NOT_BEEN_USED_TO_PARSE_CONTENT":"Otsikkoja ei olla k\xe4ytetty sis\xe4ll\xf6n j\xe4sentelyyn","THE_TITLES_ON_THE_OVERVIEW_OF_CONCLUDING_STATEMENTS":"Loppulauseiden yleiskatsaus -sivulla otsikoita ei ole k\xe4ytetty sis\xe4ll\xf6n j\xe4sentelyyn","THE_DISTINCTIVENESS_OF_LINKS_FROM_OTHER_TEXT_AND_FOCUS":"Linkkien erotettavuus muusta tekstist\xe4 sek\xe4 kohdistustyylit tukeutuvat ainoastaan v\xe4reihin","IN_THE_COORDINATOR_SERVICES_THE_DISTINCTIVENESS":"Koordinaattoripalveluissa usealla sivulla linkkien erotettavuus muusta tekstist\xe4 sek\xe4 interaktiivisten elementtien kohdistustyylit voivat tukeutua ainoastaan v\xe4ri muutoksiin","THE_CONTRAST_RATIO_OF_TEXT_ELEMENTS_COMPARED":"Tekstielementtien kontrastisuhde taustaan verrattuna ei ole riitt\xe4v\xe4","THE_CONTRAST_RATIO_OF_TEXT_ELEMENTS_ON_THE":"Kaikkien loppulauseiden yleiskatsaus -sivulla olevien tekstielementtien kontrastisuhde taustaan verrattuna ei ole riitt\xe4v\xe4n suuri","THE_SUBMISSION_BUTTON_IN_THE_FORM_FOR_ADDING_SUPERVISORS":"V\xe4it\xf6skirjatutkijat-sivun ohjaajan lis\xe4\xe4mislomakkeen l\xe4hetyspainike on poistettu k\xe4yt\xf6st\xe4 lomakkeen ollessaan vajaasti tai virheellisesti t\xe4ytetty","BUTTONS_HAVE_NO_VISIBLE_OR_PROGRAMMATIC_TEXT":"Painikkeilla ei ole n\xe4kyv\xe4\xe4 eik\xe4 ohjelmallista teksti\xe4","THE_SUPERVISOR_FORM_ON_THE_DOCTORAL_RESEARCHERS_PAGE":"V\xe4it\xf6skirjatutkijat-sivun Ohjaaja-lomakkeella on painikkeita, joilla ei ole n\xe4kyv\xe4\xe4 tai ohjelmallista teksti\xe4","SCREEN_READERS_DO_NOT_AUTOMATICALLY":"Ruudunlukijaohjelmat eiv\xe4t automaattisesti ilmoita tilasta kertovia viestej\xe4","ON_THE_DOCTORAL_RESEARCHERS_AND_LIST_THE_REVIEWERS":"V\xe4it\xf6skirjatutkijat- sek\xe4 Luettele keskener\xe4isten raporttien arvioijat -sivuilla ruudunlukijaohjelmat eiv\xe4t automaattisesti ilmoita tilasta kertovia viestej\xe4","NOT_COVERED_BY_LEGISLATION":"Ei kuulu lains\xe4\xe4d\xe4nn\xf6n piiriin","CONTENT_PUBLISHED_BY_USERS_OR_OTHER_THIRD_PARTIES":"K\xe4ytt\xe4jien tai muiden ulkopuolisten tahojen palvelussa julkaisemia sis\xe4lt\xf6j\xe4, jotka eiv\xe4t ole palveluntarjoajan itsens\xe4 tuottamia, rahoittamia tai valvomia.","CONTENT_PUBLISHED_BY_USERS_THAT_CANNOT":"Sivustolla saattaa esiinty\xe4 k\xe4ytt\xe4jien julkaisemaa sis\xe4lt\xf6\xe4, joita ei voida muokata saavutettavuusvaatimusten mukaisiksi. K\xe4ytt\xe4jien julkaisemaa sis\xe4lt\xf6\xe4 ei my\xf6sk\xe4\xe4n olla ohjelmallisesti merkattu (WCAG 3.1.2) k\xe4ytt\xe4m\xe4\xe4n julkaisun sis\xe4ll\xf6n kielt\xe4.","THE_USER_IS_LOGGED_OUT_AUTOMATICALLY_WHEN_THE_SESSION":"K\xe4ytt\xe4j\xe4 kirjataan ulos automaattisesti istunnon vanhentuessa","THE_WEBSITE_LOGS_THE_USER_OUT_AUTOMATICALLY_WHEN":"Sivusto kirjaa k\xe4ytt\xe4j\xe4n ulos automaattisesti kun istunto on vanhentunut. K\xe4ytt\xe4j\xe4\xe4 ei varoiteta ennen istunnon vanhenemista, eik\xe4 istuntoa ole mahdollista jatkaa tai aikarajaa poistaa k\xe4yt\xf6st\xe4","DID_YOU_NOTICE_AN_ACCESSIBILITY_ISSUE_IN":"Huomasitko saavutettavuuspuutteen digipalvelussamme? Kerro se meille s\xe4hk\xf6postilla ja teemme parhaamme puutteen korjaamiseksi.","IF_YOU_NOTICE_ACCESSIBILITY_ISSUES_ON":"Jos huomaat sivustolla saavutettavuusongelmia, anna ensin palautetta meille eli sivuston yll\xe4pit\xe4j\xe4lle. Vastauksessa voi menn\xe4 14 p\xe4iv\xe4\xe4. Jos et ole tyytyv\xe4inen saamaasi vastaukseen tai et saa vastausta lainkaan kahden viikon aikana, <0>voit tehd\xe4 ilmoituksen Liikenne- ja viestint\xe4virasto Traficomiin</0>. Traficomin sivulla kerrotaan tarkasti, miten ilmoituksen voi tehd\xe4 ja miten asia k\xe4sitell\xe4\xe4n.","PAGINATION":"Sivutus","GO_TO_PAGE":"Mene sivulle","AMOUNT_OF_ITEMS_PER_PAGE":"Tulosten m\xe4\xe4r\xe4 sivulla","THERE_WAS_AN_ERROR_IN_LOADING_SUPERVISION_PLANS":"<0>Ohjaussuunnitelmien lataamisessa tapahtui virhe.</0> <1>Ilmoita meille</1>, jos ongelma ei poistu.","PHD_PROJECT_LIST":{"ERROR_DELETE_FAILED":"Poistaminen ei onnistunut."},"CAREER_COUNSELLING":{"OPEN_CAREER_COUNSELLING":"<0>Tarkastele uraohjauksen kysymyksi\xe4</0>","TITLE":"Uraohjaus","INITIAL_PHASE":{"TITLE":"Alkuvaihe","MOTIVATION_AND_GOALS":"<0>Motivaatio ja tavoitteet:</0> Miksi teen v\xe4it\xf6skirjaa? Mitk\xe4 ovat omat odotuksesi v\xe4it\xf6skirjaprosessille? Mitk\xe4 ovat kiinnostuksen kohteesi liittyen tutkimusalaasi?","INTEGRATION_INTO_THE_ACADEMIC_COMMUNITY":"<0>Akateemiseen yhteis\xf6\xf6n kiinnittyminen:</0> Mik\xe4 on minun akateeminen yhteis\xf6ni?","MY_COMMUNITY_AND_FUTURE":"<0>Omat yhteis\xf6ni ja tulevaisuus:</0> Mik\xe4 on minun tutkimusyhteis\xf6ni yliopiston ulkopuolella? Miten minun pit\xe4isi rakentaa verkostoani v\xe4it\xf6skirjaprosessin aikana?"},"MIDDLE_PHASE":{"TITLE":"Keskivaihe","MOTIVATION_AND_GOALS":"<0>Motivaatio ja tavoitteet:</0> Milt\xe4 syyt tehd\xe4 v\xe4it\xf6skirjaa n\xe4ytt\xe4ytyv\xe4t t\xe4ss\xe4 vaiheessa prosessia? Ovatko syyt tehd\xe4 v\xe4it\xf6skirjaa muuttuneet? Ovatko tavoitteet muuttuneet? Milt\xe4 v\xe4it\xf6skirjaprosessi tuntuu?","SKILLS_AND_DEVELOPMENT_NEEDS":"<0>Osaaminen ja kehittymistarpeet:</0> Mist\xe4 pid\xe4n erityisesti v\xe4it\xf6skirjaty\xf6ss\xe4? Mit\xe4 olen oppinut t\xe4h\xe4n menness\xe4? Miss\xe4 ovat kehittymistarpeet? Kuka minusta on tulossa?","MY_COMMUNITY_AND_FUTURE":"<0>Omat yhteis\xf6ni ja tulevaisuus:</0> Ketk\xe4 inspiroivat minua? Kenelt\xe4 voisin saada vastauksia minua askarruttaviin urakysymyksiin?  Miss\xe4 ollaan kiinnostuneita v\xe4it\xf6skirjani aiheesta / ilmi\xf6st\xe4? Miten hankin tietoa, kokemusta ja n\xe4kemyst\xe4 muista konteksteista?"},"FINAL_PHASE":{"TITLE":"Loppuvaihe","MY_SKILLS_AND_STRENGTHS":"<0>Oma osaaminen ja vahvuudet:</0> Miss\xe4 olen hyv\xe4? Onko jotain osaamisalueita, jotka kiinnostavat, mutta joita en ole p\xe4\xe4ssyt viel\xe4 kokeilemaan?","MY_COMMUNITY_AND_FUTURE":"<0>Omat yhteis\xf6ni ja tulevaisuus:</0> Ketk\xe4 inspiroivat minua? Kenelt\xe4 voisin saada vastauksia minua askarruttaviin urakysymyksiin? Miss\xe4 ollaan kiinnostuneita v\xe4it\xf6skirjani aiheesta / ilmi\xf6st\xe4? Miten hankin tietoa, kokemusta ja n\xe4kemyst\xe4 muista konteksteista?","PROFESSIONAL_LIFE_CAREER_PLANNING_AND_LIFESTYLE":"<0>Ty\xf6el\xe4m\xe4, urasuunnittelu ja el\xe4m\xe4ntapa suhteessa vaihtoehtoihin:</0> Mitk\xe4 asiat ovat ty\xf6ss\xe4 t\xe4rkeit\xe4? Millaisten teemojen ja toiminnan parissa haluan ty\xf6skennell\xe4? Millaisia arvoja haluan toteuttaa ty\xf6ss\xe4ni ja toiminnassani? Miten ja miss\xe4 rakennan toimeentuloni?"},"ASSIGNMENT":{"CONSIDER_QUESTIONS":"Pohdi kysymyksi\xe4 ennen seuraavaa seurantaryhm\xe4n kokousta. Voit keskustella t\xe4rkeimmist\xe4 kysymyksist\xe4 haluamallasi tavalla ja tasolla kokouksen aikana. Kaikista kysymyksist\xe4 ei tarvitse keskustella kokouksessa.","THESIS_PHASE_BASED_ON_REPORT":"<0>Viimeisimm\xe4n raporttisi</0> perusteella v\xe4it\xf6skirjaprojektisi arvioitu tila on <1>{{phdCompletionPercentage}}%</1>. N\xe4in ollen tulevaa kokoustasi koskee <1>{{thesisPhase}}</1> urasuunnittelu kysymykset.","THESIS_PHASE":{"INITIAL_PHASE":"aloitusvaiheen","MIDDLE_PHASE":"keskivaiheen","FINAL_PHASE":"loppuvaiheen"}}},"THESIS_COMMITTEE":{"BACK_TO_THESIS_COMMITTEE":"Takaisin seurantaryhm\xe4\xe4n","CHANGE_DATE":"Vaihda p\xe4iv\xe4","CHOOSE_DATE":"Valitse p\xe4iv\xe4","ADD":"Lis\xe4\xe4 kokous","NO_MEETINGS":"Ei kokouksia","CHOOSE_FIRST_MEETING_DATE":"Valitse ensimm\xe4isen seurantaryhm\xe4n kokouksen p\xe4iv\xe4m\xe4\xe4r\xe4","CONTINUE_MEETING":"Jatka kokousta","END_MEETING":"Tallenna ja p\xe4\xe4t\xe4 kokous pysyv\xe4sti","END_MEETING_NOTIFICATION":"Voit tallentaa kokouksen tiedot, vaikka kaikki pakolliset kent\xe4t eiv\xe4t olisikaan viel\xe4 t\xe4ytetty. Kun olet p\xe4\xe4tt\xe4nyt kokouksen pysyv\xe4sti, et voi en\xe4\xe4 muokata kokouksen tietoja.","ERROR_MEETING_ALREADY_COMPLETED":"Seurantaryhm\xe4kokous on jo p\xe4\xe4tetty.","ERROR_MISSING_DATE":"Valitse kokouksen p\xe4iv\xe4m\xe4\xe4r\xe4 ennen tallentamista.","ERROR_REPORT_NOT_FOUND":"Raporttia ei l\xf6ytynyt.","FAST_DOCTORAL_CANDIDATE_MEETING_EVERY_N_MONTHS":"Pilotti, kokous {{n}} kk v\xe4lein","FIRST_MEETING":"Ensimm\xe4inen seurantaryhm\xe4n kokous","MEETING":"Seurantaryhm\xe4n kokous","MEETINGS":"Kokoukset","THESIS_COMMITTEE_MEETINGS":"Seurantaryhm\xe4n kokoukset","MEETING_AGENDA":"Ehdotettu esityslista","MEETING_AGENDA_NOT_FOUND":"Ehdotettua esityslistaa ei l\xf6ytynyt","MEETING_COMPLETED_AT":"Pidettiin {{date}}","MEETING_DATE":"Kokouksen p\xe4iv\xe4m\xe4\xe4r\xe4","MEETING_DATE_IN_PAST":"Kokouksen p\xe4iv\xe4m\xe4\xe4r\xe4 on menneisyydess\xe4","MEETING_DATE_MISSING":"P\xe4iv\xe4m\xe4\xe4r\xe4 puuttuu","MEETING_EVERY_N_MONTHS":"Kokous {{n}} kk v\xe4lein","MEETING_LATE_NOTIFICATION_FOR_COORDINATOR":"Kokous my\xf6h\xe4ss\xe4","MEETING_LATE_NOTIFICATION_FOR_SUPERVISOR":"Edellisest\xe4 kokouksesta on yli {{n}} kk","MEETING_LATE_NOTIFICATION_FOR_DOCTORAL_CANDIDATE":"Edellisest\xe4 seurantaryhm\xe4kokouksesta on yli kuusi kuukautta aikaa eik\xe4 uutta kokousta ole aikataulutettu. Aikatauluta uusi kokous pian.","MEETING_LATE_NOTIFICATION_FOR_THESIS_COMMITTEE_MEMBERS":"Edellisest\xe4 seurantaryhm\xe4kokouksesta on yli kuusi kuukautta aikaa eik\xe4 uutta kokousta ole aikataulutettu. V\xe4it\xf6skirjatutkijan tulee aikatauluttaa uusi kokous pian.","MEETING_NOTES":"Palaverimuistio","MEETING_NOTES_ALERT":"Palaverimuistio ei voi olla tyhj\xe4.","MEETING_NOTES_INSTRUCTIONS":"Kirjoita kokouksen yhteenveto, joka kattaa keskeiset kohdat, p\xe4\xe4t\xf6kset ja sovitut toimenpiteet.","MEETING_PLANNED_FOR":"Suunniteltu {{date}}","MEETINGS_AND_REPORTS":"Kokoukset ja raportit","NEXT_MEETING_ON_DATE":"Seuraava kokous {{date}}","NO_FIRST_MEETING_DATE_YET":"Ensimm\xe4isen kokouksen p\xe4iv\xe4m\xe4\xe4r\xe4\xe4 ei ole viel\xe4 valittu","NO_NEXT_MEETING_DATE_YET":"Seuraavan kokouksen p\xe4iv\xe4m\xe4\xe4r\xe4\xe4 ei ole viel\xe4 valittu","NOT_SCHEDULED":"Seuraavaa kokousta ei ole suunniteltu","OPEN_REPORT_FOR_MEETING":"Avaa raportti uuteen v\xe4lilehteen","REPORT_EVERY_N_MONTHS":"Raportti {{n}} kk v\xe4lein","REPORT_FOR_MEETING":"Kokouksessa k\xe4sitelt\xe4v\xe4 raportti","REPORT_FOR_MEETING_MISSING":"Raportti puuttuu","SET_MEETING_DATE":"Tallenna kokouksen p\xe4iv\xe4m\xe4\xe4r\xe4 raportin l\xe4hetysp\xe4iv\xe4m\xe4\xe4r\xe4n m\xe4\xe4ritt\xe4miseksi","SUBMIT_A_REPORT":"L\xe4het\xe4 raportti <0>{{ startDate }}\u2013{{ endDate }}</0> v\xe4lisen\xe4 aikana","REPORT_FOR_MEETING_READY":"Raportti on valmis k\xe4sitelt\xe4v\xe4ksi kokouksessa","NOTE_REPORT_SUBMISSION_DATE":"Huomaa, ett\xe4 raportti l\xe4hetettiin <0>{{ submittedAt }}</0>, mik\xe4 on raportin l\xe4hetysajan <0>{{ startDate }}\u2013{{ endDate }}</0> ulkopuolella. Raportti voi sis\xe4lt\xe4\xe4 vanhentunutta tietoa","REPORT_WAS_DISCUSSED":"Raportti k\xe4siteltiin kokouksessa","START_MEETING":"Aloita kokous","TITLE":"Seurantaryhm\xe4","VIEW":"N\xe4yt\xe4 seurantaryhm\xe4","VIEW_MEETING":"N\xe4yt\xe4 kokous","ADDING_MEETING_FAILED_WITH_ERROR_CODE":"Kokouksen lis\xe4\xe4minen ep\xe4onnistui virhekoodilla","UPDATING_MEETING_FAILED_WITH_ERROR_CODE":"Kokouksen p\xe4ivitt\xe4minen ep\xe4onnistui virhekoodilla","DELETING_MEETING_FAILED_WITH_ERROR_CODE":"Kokouksen poistaminen ep\xe4onnistui virhekoodilla","MOVING_MEETING_FAILED_WITH_ERROR_CODE":"Kokouksen siirt\xe4minen ep\xe4onnistui virhekoodilla","PROGRESS_ESTIMATION_MISSING":"Ei edistymisen arviota esikatseltavaksi","ESTIMATE_YOUR_PROGRESS":"Arvioi tohtorin tutkintosi edistymist\xe4","PROGRESS_FASTER":"Edistyn odotettua nopeammin","PROGRESS_EXPECTED":"Edistyn odotetusti","PROGRESS_SLOWER":"Edistyn odotettua hitaammin","SUPPORT_FEEDBACK":"Millainen tuki tai muutokset auttaisivat sinua yll\xe4pit\xe4m\xe4\xe4n tai parantamaan edistymist\xe4si?","CONFIRM_ENDING_MEETING_TITLE":"Vahvista kokouksen p\xe4\xe4tt\xe4minen","CONFIRM_ENDING_MEETING_OPTION":"Ymm\xe4rr\xe4n, ett\xe4 kun p\xe4\xe4t\xe4n kokouksen pysyv\xe4sti, en voi en\xe4\xe4 muokata kokouksen tietoja","MEETING_STATUS":"Kokouksen tila","MEETING_DONE":"Valmis","MEETING_DRAFT":"Luonnos"},"ATTACHMENT":{"TITLE":"Liitteet","ADD":"Lis\xe4\xe4 liite","ADD_NEW":"Lis\xe4\xe4 uusi liite","ADD_TO_REPORT_INFO":"Liite lis\xe4t\xe4\xe4n v\xe4it\xf6skirjaprojektiisi ja merkataan raporttiin kuuluvaksi. Liitett\xe4 ei voi muuttaa tai poistaa sen j\xe4lkeen.","REPORT_INFO":"Merkitse v\xe4it\xf6skirjaprojektin liite kuuluvaksi t\xe4h\xe4n raporttiin. Liitett\xe4 ei voi muuttaa tai poistaa sen j\xe4lkeen","UPLOADING":"Ladataan liitett\xe4","ADDING_ATTACHMENT_FAILED_WITH_ERROR_CODE":"Liitteen lis\xe4\xe4minen ep\xe4onnistui virhekoodilla","DELETING_ATTACHMENT_FAILED_WITH_ERROR_CODE":"Liitteen poistaminen ep\xe4onnistui virhekoodilla","NO_ATTACHMENTS":"Ei liitteit\xe4","FILE":"Liitetiedosto","NAME":"Liitetiedoston nimi","DATE_ADDED":"Lis\xe4tty p\xe4iv\xe4m\xe4\xe4r\xe4","NOT_AVAILABLE":"Liitetiedosto ei saatavilla","SIZE":"Koko","IN_REPORT":"Raportilla","REPORT_NOTICE":"Voit hallita raportin vanhoja liitteit\xe4. K\xe4yt\xe4 yll\xe4 olevaa uutta Liitteet-osiota uusien liitteiden lataamiseen ja liitt\xe4miseen raportille.","ALREADY_ATTACHED_TO_REPORT":"Kuuluu aiempaan raporttiin"},"SUPERVISION_PLAN_TITLE_NO_END_DATE":"{{startDate}} alkaen","SUPERVISION_PLAN_HEAD_TITLE":"Ohjaussuunnitelma {{startDate}} - {{endDate}}","SUPERVISION_PLAN_HEAD_TITLE_NO_END_DATE":"Ohjaussuunnitelma {{startDate}} alkaen","SUPERVISION_PLAN_EXPIRED_SHORT":"Ei voimassa","SUPERVISION_PLAN_IS_VALID_UNTIL_DATE":"Voimassa {{date}} asti","TO_UPLOAD_AN_EXCEL_FILE":"L\xe4hett\xe4\xe4ksesi Excel-tiedoston, sen tulee sis\xe4lt\xe4\xe4 sarakkeet opiskelijanumeroille ja ohjaajien s\xe4hk\xf6postiosoitteille. Jokainen rivi edustaa yht\xe4 tohtoriopiskelijaa. Kun tiedosto on valmis ja oikeassa muodossa, k\xe4yt\xe4 yll\xe4 olevaa l\xe4hetyspainiketta l\xe4hett\xe4\xe4ksesi Excel-tiedoston.","NEED_A_TEMPLATE_FOR_THE_EXCEL_FILE":"Tarvitsetko mallin Excel-tiedostolle? Lataa esimerkkitiedosto ja k\xe4yt\xe4 sit\xe4 seuraamalla alla olevia ohjeita:","DOWNLOAD_THE_SAMPLE_EXCEL_FILE":"<0>Lataa esimerkkitiedosto:</0> Klikkaa alla olevaa linkki\xe4 ladataksesi esimerkkitiedoston. T\xe4m\xe4 tiedosto sis\xe4lt\xe4\xe4 sarakkeet ja yhden esimerkkirivin.","FILL_IN_THE_DATA":"<0>T\xe4yt\xe4 tiedot:</0> Avaa ladattu tiedosto ja sy\xf6t\xe4 opiskelijanumerot ja ohjaajien s\xe4hk\xf6postiosoitteet annettuihin sarakkeisiin. Jokainen rivi edustaa yht\xe4 tohtoriopiskelijaa. Lis\xe4\xe4 uusia rivej\xe4 tarpeen mukaan.","SAVE_AND_UPLOAD_THE_FILE":"<0>Tallenna ja l\xe4het\xe4 tiedosto:</0> Kun tiedot on t\xe4ytetty, tallenna tiedosto tietokoneelle .xlsx-muodossa. Palaa sitten t\xe4lle sivulle ja k\xe4yt\xe4 yll\xe4 olevaa l\xe4hetyspainiketta l\xe4hett\xe4\xe4ksesi Excel-tiedoston.","SAMPLE_EXCEL_FILE":"Lataa esimerkkitiedosto (Excel)","VALIDITY":"Voimassaolo","COPY_DECISIONS_TO_NEW_PLAN":"Kopioi p\xe4\xe4t\xf6kset uuteen suunnitelmaan","COPY_DECISIONS_FROM_A_PREVIOUS_PLAN":"Kopioi p\xe4\xe4t\xf6kset aiemmasta suunnitelmasta","PREVIEW_OF_THE_SUPEVISION_PLAN_FOR":"Henkil\xf6n {{name}} ohjaussuunnitelman esikatselu","SELECT_A_PREVIOUS_SUPERVISION_PLAN_TO_COPY_FROM":"Valitse aiempi ohjaussuunnitelma, josta haluat kopioida p\xe4\xe4t\xf6kset","PLEASE_NOTE_THAT_SUPERVISION_PLANS_MAY_CONTAIN":"Huomaathan, ett\xe4 ohjaussuunnitelmat voivat sis\xe4lt\xe4\xe4 arkaluontoista tietoa, kuten tutkimustietoja ja henkil\xf6tietoja.","DOCTORAL_CANDIDATE_PARTICIPATES_IN_THE_DOCTORAL_EDUCATION_PILOT":"V\xe4it\xf6skirjatutkija kuuluu tohtorikoulutuspilottiin","DOCTORAL_EDUCATION_PILOT_PARTICIPANT":"Tohtorikoulutuspilottiin osallistuja","CHAPTER":"Jakso","CHAPTERS":"Jaksot","CHAPTERS_AND_MILESTONES":"Jaksot ja tavoitteet","CURRENT_CHAPTER":"Nykyinen jakso","COMPLETED_CHAPTER":"suoritettu jakso","COMPLETED_CHAPTER_other":"suoritettua jakso","MILESTONE":"Tavoite","MILESTONES":"Tavoitteet","PERSONAL_MILESTONE":"Henkil\xf6kohtainen tavoite","PERSONAL_MILESTONES":"Henkil\xf6kohtaiset tavoitteet","COMMON_MILESTONE":"Yleinen tavoite","COMMON_MILESTONES":"Yleiset tavoitteet","ADD_PERSONAL_MILESTONE":"Lis\xe4\xe4 henkil\xf6kohtainen tavoite","EDIT_PERSONAL_MILESTONE":"Muokkaa henkil\xf6kohtaista tavoitetta","ADD_COMMON_MILESTONE":"Lis\xe4\xe4 yleinen tavoite","EDIT_COMMON_MILESTONE":"Muokkaa yleist\xe4 tavoitetta","STARTING":"Alkaa","STARTED":"Aloitettu","PLANNED":"Suunniteltu","ESTIMATED":"Arvioitu","STARTED_FROM_GRANTING_STUDY_RIGHT":"Alkoi <0>{{ date }}</0> opinto-oikeuden my\xf6nt\xe4misest\xe4","STARTED_AT_THE_THESIS_COMMITTEE_MEETING_HELD_ON":"Alkoi <0>{{ date }}</0> pidett\xe4v\xe4ss\xe4 seurantaryhm\xe4n kokouksessa","BEGIN_AT_THE_THESIS_COMMITTEE_MEETING_HELD_ON":"Alkaa <0>{{ date }}</0> pidett\xe4v\xe4ss\xe4 seurantaryhm\xe4n kokouksessa","BEGIN_AT_THE_MEETING_ESTIMATED_TO_BE_HELD_ON":"Alkaa arviolta <0>{{ date }}</0> pidett\xe4v\xe4ss\xe4 kokouksessa","EACH_CHAPTER_REPRESENTS_THE_TIME_PERIOD":"Jokainen jakso tarkoittaa ajanjaksoa kahden seurantaryhm\xe4n kokouksen v\xe4lill\xe4.","OVERVIEW":"Yleiskatsaus","NO_MILESTONES_IN_THE_PLAN_FOR_THE_CHAPTER_YET":"T\xe4lle jaksolle ei ole viel\xe4 lis\xe4tty tavoitteita.","VIEW_CHAPTERS":"N\xe4yt\xe4 jaksot","EDIT_MILESTONES":"Muokkaa tavoitteita","CUSTOM_MILESTONES_CREATED_BY_THE_USER":"K\xe4ytt\xe4j\xe4n luomia tavoitteita. Voit lis\xe4t\xe4 niin monta henkil\xf6kohtaista tavoitetta kuin haluat ja liitt\xe4\xe4 ne mihin tahansa jaksoon.","A_PREDEFINED_SET_OF_MILESTONES_THAT_MUST_BE_ASSIGNED":"Ennalta m\xe4\xe4r\xe4tyt tavoitteet, joista jokainen tulee liitt\xe4\xe4 jollekin jaksoille.","STUDY_RIGHT_GRANTED":"Opiskeluoikeus my\xf6nnetty","ADD_ITEM":"Lis\xe4\xe4 kohde <0>{{ id }}. jaksoon</0>","ITEM":"kohde","ITEM_other":"kohdetta","MILESTONE_DESCRIPTION":"Tavoitteen kuvaus","MOVE":"Siirr\xe4","OPEN_CONTEXT_MENU":"Avaa \\"{{ milestone }}\\" tavoitteen kontekstivalikko","CONTEXT_MENU":"Kontekstivalikko","SET_AS_COMPLETED":"Merkitse suoritetuksi","COMMON":"Yleinen","PERSONAL":"Henkil\xf6kohtainen","ADDING_MILESTONE_FAILED_WITH_ERROR_CODE":"Tavoitteen lis\xe4\xe4minen ep\xe4onnistui virhekoodilla","UPDATING_MILESTONE_FAILED_WITH_ERROR_CODE":"Tavoitteen p\xe4ivitt\xe4minen ep\xe4onnistui virhekoodilla","DELETING_MILESTONE_FAILED_WITH_ERROR_CODE":"Tavoitteen poistaminen ep\xe4onnistui virhekoodilla","MOVING_MILESTONE_FAILED_WITH_ERROR_CODE":"Tavoitteen siirt\xe4minen ep\xe4onnistui virhekoodilla","PRESSING_ENTER_ON_THE_KEYBOARD_WILL_ADD_THE_MILESTONE":"Voit painaa Enter-painiketta lis\xe4t\xe4ksesi tavoitteen.","ALL_COMMON_MILESTONES_HAVE_BEEN_ASSIGNED_TO_CHAPTERS":"Kaikki yleiset tavoitteet on liitetty jaksoille","NO_COMMON_MILESTONES_AVAILABLE":"Yleisi\xe4 tavoitteita ei ole saatavilla","INPUT_EXCEEDS_THE_CHARACTER_LIMIT":"Sy\xf6tetty arvo ylitt\xe4\xe4 {{ maxLength }} merkin rajan","FILE_INPUT_EXCEEDS_THE_FILE_SIZE_LIMIT":"Tiedosto ylitt\xe4\xe4 suurimman sallitun {{ maxSizeMB }}\u202FMB koon","UNASSIGNED_COMMON_MILESTONES":"Seuraavia yleisi\xe4 tavotteita ei ole asetettu jaksolle","UNASSIGNED_COMMON_MILESTONES_AMOUNT":"{{ amount }} yleist\xe4 tavoitetta ei ole asetettu jaksolle","MOVE_TO_NEXT_CHAPTER":"Siirr\xe4 seuraavalle jaksolle","MOVE_TO_PREVIOUS_CHAPTER":"Siirr\xe4 edelliselle jaksolle","RETURN":"Palaa","USE_OF_GENERATIVE_ARTIFICIAL_INTELLIGENCE_IN_RESEARCH":"Generatiivisen teko\xe4lyn k\xe4ytt\xf6","AI_RESEARCH":"Generatiivisen teko\xe4lyn k\xe4ytt\xf6 tutkimuksessa \u2013 Helsingin yliopisto","ARTIFICIAL_INTELLIGENCE_AI_SCIENCE":"Artificial Intelligence (AI) in Science \u2013 European Commission","IS_IN_PILOT":"V\xe4it\xf6skirjatutkija osallistuu nopean tohtorintutkinnon pilottiin","LATEST_PROGRESS_ESTIMATION":"Viimeisin arvio v\xe4it\xf6skirjaprojektin edistymisest\xe4","NO_ACTIVE_STUDY_RIGHT":"Ei aktiivista opiskeluoikeutta","CONSORTIUM":"Konsortio","NEXT_STEPS":{"TITLE":"Seuraavat vaiheet","INTRO":{"CYCLIC":"Seurantaryhm\xe4n kokous pidet\xe4\xe4n kerran vuodessa, ja jokaista kokousta varten laaditaan raportti.","FAST":"Seurantaryhm\xe4n kokous pidet\xe4\xe4n kaksi kertaa vuodessa, ja jokaista kokousta varten laaditaan raportti.","LEGACY":"Raportti toimitetaan kerran vuodessa."},"TIMING":{"SUBMISSION_WINDOW":"L\xe4het\xe4 se {{startDate}}\u2013{{endDate}} v\xe4lisen\xe4 aikana, jotta sit\xe4 voidaan k\xe4sitell\xe4 seurantaryhm\xe4n kokouksessa.","SUBMISSION_WINDOW_OBSERVER":"Raportti tulee l\xe4hett\xe4\xe4 {{startDate}}\u2013{{endDate}} v\xe4lisen\xe4 aikana, jotta se ehdit\xe4\xe4n k\xe4sitell\xe4 seurantaryhm\xe4n kokouksessa.","MEETING_DATE":"Kokous on suunniteltu pidett\xe4v\xe4ksi {{date}}.","REPORT_DEADLINE":"L\xe4het\xe4 se noin viikkoa ennen seurantaryhm\xe4n kokousta {{date}}, mutta viimeist\xe4\xe4n kokousp\xe4iv\xe4n\xe4.","REPORT_DEADLINE_OBSERVER":"Raportti tulee l\xe4hett\xe4\xe4 noin viikkoa ennen seurantaryhm\xe4n kokousta {{date}}, mutta viimeist\xe4\xe4n kokousp\xe4iv\xe4n\xe4.","REPORT_BEFORE_MEETING":"L\xe4het\xe4 se noin viikkoa ennen seurantaryhm\xe4n kokousta.","REPORT_BEFORE_MEETING_OBSERVER":"Raportti tulee l\xe4hett\xe4\xe4 noin viikkoa ennen seurantaryhm\xe4n kokousta."},"REPORT":{"SUBMIT_STUDENT":"L\xe4het\xe4 raportti, jossa kerrot v\xe4it\xf6skirjaprojektisi edistymisest\xe4.","SUBMIT_OBSERVER":"V\xe4it\xf6skirjatutkijan tulee l\xe4hett\xe4\xe4 raporttinsa.","CONCLUSION_STUDENT":"Kirjoita raportille loppulause seurantaryhm\xe4n kokouksessa k\xe4siteltyjen asioiden pohjalta.","CONCLUSION_OBSERVER":"V\xe4it\xf6skirjatutkija kirjoittaa raportille loppulauseen seurantaryhm\xe4n kokouksessa k\xe4siteltyjen asioiden pohjalta.","FEEDBACK_REMINDER":"Raportti on valmistunut \xe4skett\xe4in \u2014 on aika antaa palautetta edistymisest\xe4.","SUBMIT_LABEL":"Raportin l\xe4hetys","CONCLUSION_LABEL":"Loppulauseen kirjoitus"},"MEETING":{"PLAN_STUDENT":"Aikatauluta seuraava seurantaryhm\xe4n kokous.","PLAN_OBSERVER":"Seurantaryhm\xe4n kokous tulisi aikatauluttaa.","ATTEND_STUDENT":"Pid\xe4 seurantaryhm\xe4n kokous. K\xe4y kokouksessa l\xe4pi v\xe4it\xf6skirjaprojektisi edistymist\xe4 raporttisi avulla.","ATTEND_OBSERVER":"Seurantaryhm\xe4n kokouksessa k\xe4yd\xe4\xe4n l\xe4pi v\xe4it\xf6skirjatutkijan edistyminen ja raportti.","ATTEND_LATE_STUDENT":"Seurantaryhm\xe4n kokous on my\xf6h\xe4ss\xe4. Pid\xe4 kokous nyt.","ATTEND_LATE_OBSERVER":"Seurantaryhm\xe4n kokous on my\xf6h\xe4ss\xe4 ja se tulee j\xe4rjest\xe4\xe4.","LATE_STUDENT":"Edellisest\xe4 seurantaryhm\xe4n kokouksesta on kulunut yli {{months}} kuukautta, eik\xe4 uutta kokousta ole aikataulutettu. Aikatauluta uusi kokous nyt.","LATE_OBSERVER":"Edellisest\xe4 seurantaryhm\xe4n kokouksesta on kulunut yli {{months}} kuukautta, eik\xe4 uutta kokousta ole aikataulutettu. V\xe4it\xf6skirjatutkijan tulee aikatauluttaa uusi kokous nyt.","SCHEDULE_LABEL":"Kokouksen aikataulutus","ATTEND_LABEL":"Kokouksen pit\xe4minen"}},"REPORTING":{"TITLE":"Raportointi"},"COURSE":{"NOT_EDITABLE":"Opintojakso on tuotu Sisusta eik\xe4 sit\xe4 siksi voi muokata Thessassa"}}');

});

parcelRegister("bFM7f", function(module, exports) {
module.exports = JSON.parse('{"key":"value","SUPPORT_EMAIL":"uni-help@helsinki.fi","ABOUT":"Om","THESSA":"Thessa","THESSA_IS_THE_DOCTORAL_STUDIES":"Thessa \xe4r Helsingfors universitets planerings- och rapporteringsverktyg f\xf6r doktorandstudier.","ALL_KINDS_OF_FEEDBACK_AND_ERRO":"Alla typer av respons och felrapporter \xe4r mycket uppskattade.","RIGHTS_OBLIGATIONS_AND_RESPON":"R\xe4ttigheter, f\xf6rpliktelser och skyldigheter i forskarutbildningen vid Helsingfors universitet","PROBLEMS_LOGGING_IN":"Problem med att logga in?","IF_YOU_FORGOT_YOUR_PASSWORD_Y":"Om du har gl\xf6mt ditt l\xf6senord kan du","RESET_IT":"\xe5terst\xe4ll det","SEND_PASSWORD_RESET_LINK_TO_MY":"Skicka l\xe4nk f\xf6r \xe5terst\xe4llande av l\xf6senord till min e-post","EMAIL_FOR_THESSA_ACCOUNT":"E-post f\xf6r Thessa-konto","SEND":"Skicka","BACK_TO_LOGIN":"Tillbaka till login","BACK_TO_MY_PHD_PROJECT":"Tillbaka till Mitt doktorandprojekt","MESSAGE_SENT_CHECK_YOUR_EMAIL":"Meddelande skickat. Kontrollera din e-postinkorg och \xf6ppna l\xe4nken i e-postmeddelandet om l\xf6senords\xe5terst\xe4llning.","TOO_MANY_PASSWORD_RESET_REQUES":"F\xf6r m\xe5nga f\xf6rfr\xe5gningar om l\xf6senords\xe5terst\xe4llning.","TOO_MANY_PASSWORD_RESET_ATTEMPTS":"F\xf6r m\xe5nga f\xf6rs\xf6k att spara ett nytt l\xf6senord. V\xe4nta femton minuter innan du f\xf6rs\xf6ker igen.","WAIT_FIVE_MINUTES_BEFORE_TRYIN":"V\xe4nta femton minuter innan du f\xf6rs\xf6ker igen. Om problemet kvarst\xe5r, <0>kontakta oss</0> f\xf6r mer hj\xe4lp.","HELPDESK":"kontakta IT-Helpdesk.","YOU_MAY_RESET_YOUR_PASSWORD":"du kan \xe5terst\xe4lla ditt l\xf6senord.","SOMETHING_WENT_WRONG":"N\xe5got gick fel.","TRY_AGAIN_LATER":"F\xf6rs\xf6k igen senare. Om problemet kvarst\xe5r, <0>kontakta oss</0> f\xf6r hj\xe4lp.","NO_NETWORK_CONNECTION":"Ingen n\xe4tverksanslutning","RIGHTS_OBLIGATIONS_AND_RESPON1":"R\xe4ttigheter, f\xf6rpliktelser och skyldigheter i forskarutbildningen vid Helsingfors universitet","ABOUT_THESSA":"Om Thessa","THE_DOCTORAL_STUDIES_PLANNING":"Planerings- och rapporteringsverktyget f\xf6r doktorandstudier.","EMAIL":"E-post","PASSWORD":"L\xf6senord","LOG_IN":"Logga in","LOGIN_WAS_NOT_SUCCESSFUL":"Inloggningen lyckades inte.","CHECK_USERNAME_AND_PASSWORD_I":"Kontrollera anv\xe4ndarnamn och l\xf6senord. Om det inte hj\xe4lper, f\xe5r du mer hj\xe4lp fr\xe5n","CHECK_USERNAME_AND_PASSWORD_I1":"Kontrollera anv\xe4ndarnamn och l\xf6senord. Om det inte hj\xe4lper,","TOO_MANY_FAILED_LOGIN_ATTEMPTS":"F\xf6r m\xe5nga misslyckade inloggningsf\xf6rs\xf6k.","WAIT_FIVE_MINUTES_BEFORE_TRYIN1":"V\xe4nta femton minuter innan du f\xf6rs\xf6ker igen. Kontrollera anv\xe4ndarnamn och l\xf6senord. Om det inte hj\xe4lper, f\xe5r du mer hj\xe4lp fr\xe5n","YOU_NEED_AN_INVITATION_OR_AN_A":"Du beh\xf6ver en inbjudan eller en aktiv studier\xe4tt f\xf6r doktorsexamen f\xf6r att f\xe5 tillg\xe5ng till Thessa.","YOUR_EMAIL_ADDRESS_IS_ALREADY":"Din e-postadress anv\xe4nds redan av n\xe5gon i Thessa.","HINT_USE_UNIVERSITY_LOGIN":"Du anv\xe4nder en <0>helsinki.fi</0>-e-postadress. Logga in med ditt universitetskonto ovan.","CONTACT_US":"Kontakta oss","CONTACT_US1":"kontakta oss","CONTACT_US_END_OF_SENTENCE":"kontakta oss.","FOR_HELP_WITH_THIS_ERROR":"f\xf6r hj\xe4lp med detta fel.","LOG_IN_PAGE":{"UNIVERSITY_STAFF_OR_STUDENTS":"Studerande och anst\xe4llda vid Helsingfors universitet","OTHERS":"Logga in med Thessa-konto"},"LOGIN_FAILED_WITH_ERROR_CODE":"Inloggning misslyckades med felkod","LOGIN_FAILED_PASSWORD_MUST_BE_RESET":"Inloggningen misslyckades eftersom du m\xe5ste byta ditt l\xf6senord f\xf6rst. Anv\xe4nd","LOGIN_FAILED_USE_UNIVERSITY_LOGIN":"Logga in med Helsingfors universitets konto i st\xe4llet f\xf6r e-post och l\xf6senord.","PASSWORD_RESET_REFUSED_USE_UNIVERSITY_LOGIN":"L\xf6senordet kan inte \xe5terst\xe4llas f\xf6r detta konto. Anv\xe4nd Helsingfors universitets konto f\xf6r att logga in.","FORGOT_PASSWORD_PAGE":"sidan f\xf6r gl\xf6mt l\xf6senord","TO_CHANGE_YOUR_PASSWORD":"f\xf6r att byta ditt l\xf6senord.","USE_YOUR_UNIVERSITY_OF_HELSINK":"Anv\xe4nd ditt anv\xe4ndarnamn och l\xf6senord till Helsingfors universitets informationssystem f\xf6r att logga in.","FORGOT_PASSWORD":"Har du gl\xf6mt ditt l\xf6senord?","LOG_IN_WITH_OIDC":"Logga in med Helsingfors universitets konto","RESET_PASSWORD":"\xc5terst\xe4ll l\xf6senord","NEW_PASSWORD":"Nytt l\xf6senord","SAVE_PASSWORD":"Spara l\xf6senord","CANCEL":"Avbryt","PASSWORD_SET_REDIRECTING_YOU":"L\xf6senord inst\xe4llt. Omdirigerar dig","INSIDE":"inne","THERE_WERE_PROBLEMS_WITH_SAVIN":"Det uppstod problem med att spara l\xf6senordet:","SIGN_UP_TO_THESSA":"Registrera dig i Thessa","IF_YOU_HAVE_A_UNIVERSITY_OF_HE":"Om du har ett konto vid Helsingfors universitet, ska du anv\xe4nda dess anv\xe4ndarnamn och l\xf6senord i inloggningsformul\xe4ret ovan. Alla studenter och anst\xe4llda har ett konto.","MON":"M\xe5n","TUE":"Tis","WED":"Ons","THU":"Tors","FRI":"Fre","SAT":"L\xf6r","SUN":"S\xf6n","LOADING_WITH_ELLIPSIS":"Laddar\u2026","YOU_MAY_USE":"Du kan anv\xe4nda","MARKDOWN":"Markdown","ITALICS":"*kursiv*","BOLD":"**fet stil**","LINKS_HTTPS":"[l\xe4nkar](https://...)","HEADINGS":"# rubriker","LISTS":"- listor","AND_MORE":"och mer.","THESSA_FOR":"Thessa f\xf6r","UNIVERSITY_OF_HELSINKI":"Helsingfors universitet","PRIVACY_POLICY":"Integritetspolicy","ASK_FOR_HELP_AND_GIVE_FEEDBACK":"Be om hj\xe4lp och ge feedback","TOGGLE_NAVIGATION":"V\xe4xla navigering","LOG_OUT":"Logga ut","LOGIN":"Logga in","REMINDERS1":"P\xe5minnelser","PROFILE1":"Profil","HELP1":"Hj\xe4lp","MY_PHD_PROJECT":"Mitt doktorandprojekt","MY_DOCTORAL_CANDIDATES":"Mina doktorander","DOCTORAL_CANDIDATES1":"Doktorander","USERS1":"Anv\xe4ndare","QUEUE1":"K\xf6","STATISTICS1":"Statistik","LEFT":"v\xe4nster","BOTTOM":"botten","ARE_YOU_SURE":"\xc4r du s\xe4ker?","CONFIRM_DELETE":"Ja, ta bort","THANKS":"Tack!","YOU_CAN_GIVE_MORE_FEEDBACK_HER":"Du kan ge mer respons h\xe4r:","SEND_FEEDBACK":"Skicka respons","PAGE_HEADER":"Sidhuvud","HEADING":"Rubrik 1","HEADING1":"Rubrik 2","HEADING2":"Rubrik 3","HEADING3":"Rubrik 4","HEADING4":"Rubrik 5","HEADING5":"Rubrik 6","LEAD_TEXT":"Ingress","BODY_TEXT":"Br\xf6dtext","SMALL_TEXT":"Liten text","LABEL":"Etikett 1","LABEL1":"Etikett 2","LABEL2":"Etikett 3","CHECK":"Kontroll 1","CHECK1":"Kontroll 2","SUBMIT":"Skicka in","SAVE":"Spara","TOGGLE":"V\xe4xla","CALENDAR":"kalender","OK":"ok","REMOVE":"ta bort","CLEAR":"Rensa","SUBMITTED":"L\xe4mnad","CONCLUSION_MISSING":"Avslutning saknas","GIVE_FEEDBACK":"Ge respons","DEFAULT":"Standard","RIGHT":"H\xf6ger","LEFT1":"V\xe4nster","CALL_TO_ACTION":"Uppmaning till handling","SECONDARY":"Sekund\xe4r","ACTION":"Handling","ACTIONS":"\xc5tg\xe4rder","STUDENT_NUMBER":"Student nummer","NAME":"Namn","ACCOUNT":"Konto","NO_ACCOUNT":"Inget konto","NO_SUPERVISORS_IN_OODI":"Inga handledare i Oodi","STUDY_RIGHT_START_DATE":"Studier\xe4ttens r\xe4tta startdatum","RECENT":"NYLIGEN","COORDINATOR_QUEUE":"Koordinatork\xf6","LOADING_INACTIVE_USERS":"Laddar inaktiva anv\xe4ndare...","THERE_WAS_AN_ERROR_IN_LOADING":"Det uppstod ett fel n\xe4r inaktiva anv\xe4ndare laddades.","PLEASE":"V\xe4nligen","TRY_AGAIN":"f\xf6rs\xf6k igen","LET_US_KNOW":"l\xe5t oss f\xe5 veta","IF_THE_PROBLEM_DOES_NOT_GO_AWA":"om problemet inte f\xf6rsvinner.","INACTIVE_USER":"Inaktiv anv\xe4ndare","TYPE":"Typ","N_A":"Inte i bruk","NO_COURSES_IN_PLAN_YET":"Inga studieavsnitt finns \xe4nnu i planen.","ADD":"L\xe4gg till","BUTTON_ABOVE":"knappen ovan!","TITLE":"Titel","COURSES_TOTAL_one":"{{count}} studieavsnitt","COURSES_TOTAL_other":"{{count}} studieavsnitt","CREDITS":"Studiepo\xe4ng","CREDITS_ABBREVIATED":"Sp","CREDITS_COMPLETED":"{{completedCredits}} sp avlagt","CREDITS_PLANNED":"{{plannedCredits}} sp ej avlagt","CREDITS_TOTAL":"{{totalCredits}} sp totalt","STATUS":"Status","COMPLETED":"Avlagt","COMPLETED_AT":"Avlagt den","TO_BE_COMPLETED_AT":"Ska avl\xe4ggas den","COURSE_UNIT_CODE":"Studieavsnittets kod","COURSE_UNIT_CODE_MISSING":"Uppgift saknas","FAILED_TO_CREATE_COURSE":"Det gick inte att spara i studierna.","CHANGED_SINCE_LAST_OPENED":"\xc4ndrad sedan senaste \xf6ppnade","REPORT":{"NEXT_REPORT_BY_DATE":"N\xe4sta rapport ska l\xe4mnas in den {{date}}","REPORT":"Rapportera","REPORT_LATE_NOTIFICATION_FOR_SUPERVISOR":"Senast rapport var \xf6ver {{n}} m\xe5nader sedan","REPORT_STATUS":"Rapportstatus","REPORT_STATUS_DRAFT":"Utkast","REPORT_STATUS_SUBMITTED":"Inskickad f\xf6r granskning","REPORT_STATUS_FINAL":"Gjort","NOT_SUBMITTED":"Denna rapport har inte l\xe4mnats in f\xf6r granskning","THESIS_COMMITTEE_MEETING_NOT_HELD":"M\xf6te inte h\xe5llt","THESIS_COMMITTEE_MEETING_INSTRUCTIONS":"H\xe5ll ett m\xf6te med uppf\xf6ljningsgruppen f\xf6r att avsluta rapporten","THESIS_COMMITTEE_MEETING_LEGACY_INSTRUCTIONS":"H\xe5ll ett m\xf6te med uppf\xf6ljningsgruppen och skriv avslutningen genom att \xf6ppna rapporten","REPORTING_PERIOD_WHILE_EDITING_LEGACY":"Rapporteringsperioden b\xf6rjar {{reportingPeriodStart}} och avslutas n\xe4r du sparar avslutningen fr\xe5n uppf\xf6ljningsgruppens m\xf6te i Thessa.","REPORTING_PERIOD_WHILE_EDITING":"Rapporteringsperioden b\xf6rjar {{reportingPeriodStart}} och avslutas n\xe4r du avslutar uppf\xf6ljningsgruppens m\xf6te i Thessa.","REPORTING_PERIOD_DATES":"{{reportingPeriodStart}}\u2013{{reportingPeriodEnd}}","REPORTING_PERIOD_STARTING_FROM":"Fr\xe5n och med {{reportingPeriodStart}}","FEEDBACK_DUE_TAG":"Feedback om framsteg saknas"},"SUPERVISION_PLAN":"Handledningsplan","SUPERVISION_PLAN_other":"Handledningsplaner","MY_DOCTORAL_CANDIDATES1":"Mina doktorander","LOADING_DOCTORAL_CANDIDATES":"Laddar doktorander...","FAILED_TO_LOAD_DOCTORAL_CANDID":"Det gick inte att ladda doktorander. Du kan prova att ladda om sidan. Om felet kvarst\xe5r, kontakta Thessa-anv\xe4ndarst\xf6det.","MISSING_DOCTORAL_CANDIDATES":"Fattas doktorander?","TO_SEE_YOUR_DOCTORAL_CANDIDATE":"F\xf6r att se dina doktorander i Thessa, se till att de registrerar sig i Thessa och bjuder in dig att bli handledare eller medlem av uppf\xf6ljningsgruppen.","YOU_WILL_GET_THE_INVITATION_BY":"Du f\xe5r inbjudan via e-post. Acceptera det f\xf6r att f\xe5 tillg\xe5ng till dina doktorander.","HIDE":"D\xf6lj","SHOW":"Visa","CLOSED_ACCOUNTS":"st\xe4ngda konton","RELATIONSHIP":"Relation","PROGRESS":"Framsteg","YOU_HAVE_NO_DOCTORAL_CANDIDATE":"Du har inga doktorander i Thessa.","NO_DOCTORAL_CANDIDATES":"Inga doktorander.","YOUR_USER_ACCOUNT_NEEDS_TO_BE":"Ditt anv\xe4ndarkonto m\xe5ste aktiveras innan du kan skapa din f\xf6rsta rapport. Innan ditt konto kan aktiveras m\xe5ste du","INVITE_ALL_YOUR_SUPERVISORS_AN":"bjud in alla dina handledare och medlemmar av uppf\xf6ljningsgruppen","IN_THESSA":"i Thessa.","YOU_WILL_RECEIVE_AN_EMAIL_WHEN":"Du kommer att f\xe5 ett e-postmeddelande n\xe4r ditt konto har aktiverats.","INVITE_SUPERVISORS":"Bjud in handledare","THERE_ARE_NO_SUPERVISION_PLANS":"Det finns inga handledningsplaner tills vidare.","DOCTORAL_CANDIDATE_AND_SUPERVI":"Doktoranden och handledaren kommer \xf6verens om att f\xf6lja en handledningsplan som ska definiera samarbetet mellan doktoranden och handledare. Planen skapas p\xe5 handledarens konto och undertecknas sedan av doktoranden och handledaren.","SUPERVISORS":"Handledare","LOADING_NEXT_REPORT_DUE_DATE":"Laddar n\xe4sta rapportf\xf6rfallodatum...","NEXT_REPORT_DUE_ON":"N\xe4sta rapport kommer","PERIOD":"Period","PUBLICATIONS":"Publikationer","COURSES":"Studier","GRADUATION":"Utexaminering","CONCLUSION":"Avslutning","DRAFT":"Utkast","OPEN":"\xd6ppna","MISSING":"Saknas","HAVE_A_THESIS_COMMITTEE_MEETIN":"H\xe5ll ett m\xf6te med uppf\xf6ljningsgruppen och skriv avslutningen genom att \xf6ppna rapporten.","REPORTS":"Rapporter","LOADING_REPORTS":"Laddar rapporter...","NO_REPORTS_YET":"Inga rapporter \xe4nnu","VIEW_CUMULATIVE_REPORT":"Visa kumulativ rapport","THESSA_IS_IN_MAINTENANCE":"Thessa \xe4r under underh\xe5ll","PLEASE_WAIT_A_FEW_MINUTES_AND":"V\xe4nta n\xe5gra minuter och <0>ladda om sidan</0>","PAGE_NOT_FOUND":"Sidan hittas inte","SORRY_THE_PAGE_YOU_OPENED_CAN":"Tyv\xe4rr, sidan du \xf6ppnade kan inte hittas. Prova","FRONT_PAGE_INSTEAD":"framsidan ist\xe4llet","ADD_GRANT":"L\xe4gg till stipendium","ADD_SALARY":"L\xe4gg till l\xf6n","SALARIES":"L\xf6ner","GRANTS":"Stipendier","NO_SALARIES_IN_PLAN_YET":"Inga l\xf6ner finns \xe4nnu i planen.","NO_SALARIES":"Inga l\xf6ner.","NO_GRANTS_IN_PLAN_YET":"Inga stipendier finns \xe4nnu i planen.","NO_GRANTS":"Inga stipendier.","SOURCE":"K\xe4lla","AMOUNT":"Belopp","FOR_MONTHS":"I m\xe5nader","USED_FOR":"Anv\xe4nds f\xf6r","NOT_GRANTED":"Inte beviljat","GRANTED":"Beviljas","FOR_DATES":"F\xf6r datumen","HELP_MORE_GUIDES_LINK_PREFIX":"\xd6ppna","HELP_MORE_GUIDES_LINK_URL":"https://studies.helsinki.fi/instruktioner/artikel/thessa","HELP_MORE_GUIDES_LINK_LINK_TEXT":"Instruktioner f\xf6r studerande","HELP_MORE_GUIDES_LINK_SUFFIX":"f\xf6r mer instruktioner om hur du anv\xe4nder Thessa.","TRY_TO_INCLUDE_AS_MUCH_DETAI":"Ber\xe4tta om problemet eller felet s\xe5 noggrant som m\xf6jligt. Thessa utvecklas fortg\xe5ende och all resons \xe4r v\xe4rdefull f\xf6r oss.","IF_YOU_NEED_MORE_HELP_PLEASE":"Om du har fr\xe5gor ang\xe5ende Thessa eller beh\xf6ver mer hj\xe4lp","INVITE":"Inbjudan","S_EMAIL_ADDRESS":"{{roleName}}s e-postadress","INVITE_TO_YOUR_PHD_PROJECT_IN":"Bjud in till ditt doktorandprojekt i Thessa","INVITATION_SUBMITTED":"Inbjudan skickad","SUBMITTING_INVITATION_FAILED":"Det gick inte att skicka inbjudan","YOU_ARE_INVITED":"Du \xe4r inbjuden till Thessa","WHAT_IS_THESSA":"Vad \xe4r Thessa?","ALL_DOCTORAL_CANDIDATES_AND_TH":"Alla doktorander och deras handledare och medlemmar i uppf\xf6ljningsgruppen kan anv\xe4nda det.","WELCOME_TO_THESSA":"V\xe4lkommen till Thessa!","YOU_ARE_NOT_CONNECTED_TO_ANYON":"Du \xe4r inte kopplad till n\xe5gon.","ASK_YOUR_DOCTORAL_CANDIDATES_T":"Be dina doktorander att skicka en inbjudan fr\xe5n dera Thessa-konto.","OTHERWISE_IT_S_GOING_TO":"Annars blir det ensamt h\xe4r.","NO_NOTES":"Inga anteckningar.","EDIT":"Redigera","SAVING":"Sparar...","UPDATE_ANNUAL_REPORTS":"Uppdatering: \xc5rsrapport","ANNUAL_REPORTS_SECTION_HAS_BEE":"\xc5rsrapportsektionen har uppdaterats f\xf6r att tydligare visa rapportens status och beg\xe4rda \xe5tg\xe4rder.","UPDATE_CUMULATIVE_REPORT":"Uppdatering: Kumulativ rapport","CUMULATIVE_REPORT_VIEW_SHOWS_A":"Den kumulativa rapportvyn visar alla dina rapporter samtidigt vilket g\xf6r det l\xe4ttare att f\xe5 en helhetsbild. Tryck p\xe5 knappen \'Visa kumulativ rapport\' i avsnittet f\xf6r \xe5rsrapporter f\xf6r att \xf6ppna den.","UPDATE_REVIEWING_REPORTS":"Uppdatering: Granska rapporter","CUMULATIVE_REPORT":"Kumulativ rapport","YOU_CAN_NOW_SEE_THE_CUMULATIVE":"Du kan nu se den kumulativa rapporten n\xe4r du granskar.","COMMENTING_REPORT":"Kommenterande rapport","DISCUSS_REPORTS":"Diskutera rapporter.","NEW_IMPROVEMENTS":"Nya f\xf6rb\xe4ttringar!","INVITE_SUPERVISORS_AND_THESIS":"Bjud in handledare och uppf\xf6ljningsgruppens medlemmar med hj\xe4lp av e-postadresser.","DISCUSS_IN_SIMPLIFIED_ANNUAL_R":"Diskutera i f\xf6renklad \xe5rsredovisnings\xf6versikt.","REPORTS_ARE_CLOSED_BY_WRITING":"Rapporten avslutas genom att skriva \'slutsatser och rekommendationer\'.","READ_MORE_FROM_HELP_PAGE":"L\xe4s mer fr\xe5n hj\xe4lpsidan.","SET_OF_DECISIONS_BETWEEN_DOCTO":"En ppps\xe4ttning beslut mellan doktorand och handledare f\xf6r att s\xe4kerst\xe4lla att doktorandprojektet fortl\xf6per smidigt.","KEEPING_TRACK_OF_FUTURE_PLANS":"Uppf\xf6ljning av framtida planer f\xf6r avancemang av studier, publikationer och annat relaterat till doktosexamen.","A_SNAPSHOT_OF_PHD_PROJECT_IT":"En \xf6gonblicksbild av doktorandprojektet. Den skapas en g\xe5ng per \xe5r f\xf6r att underl\xe4tta kommunikationen mellan doktorand och handledare.","START_USING_THESSA":"B\xf6rja anv\xe4nda Thessa!","WE_RECOMMEND_THAT_YOU_START_US":"Vi rekommenderar att du b\xf6rjar anv\xe4nda Thessa genom att skapa en handledningsplan. Kontakta din handledare f\xf6r att skapa den.","THEN_YOU_SHOULD_UPDATE_YOUR_PH":"D\xe5 b\xf6r du uppdatera dina doktorandprojektplaner i Thessa s\xe5 att de blir tydligt synliga f\xf6r dig och din handledare. Du kan b\xf6rja med det h\xe4r genast!","YOU_CAN_FIND_MORE_DETAILS_ABOU":"Du hittar mer information om Thessa fr\xe5n hj\xe4lpsektionen i huvudmenyn.","IF_YOU_FIND_BUGS_OR_ERRORS_IN":"Om du hittar buggar eller fel i Thessa, eller har en id\xe9 om hur du kan g\xf6ra det b\xe4ttre,","DROP_AN_EMAIL_TO_US":"skicka oss ett e-posmeddelande","YOUR_DOCTORAL_CANDIDATES_WILL":"Dina doktorander kommer snart att l\xe4nka sina Thessa-konton till dina. D\xe4refter rekommenderar vi att du b\xf6rjar anv\xe4nda Thessa genom att skapa en handledningsplan f\xf6r dina doktorander. Skapa den med ditt konto och sedan kommer alla att signera den via sitt Thessa-konto.","REMOVE1":"Avl\xe4gsna","INTERNATIONAL_ACTIVITIES":{"TYPE":{"CONFERENCE":"Konferens","RESEARCH_VISIT":"Forskningsbes\xf6k","OTHER":"\xd6vrigt"},"PARTICIPATION_TYPE":{"PARTICIPANT_POSTER":"Deltagande med posterpresentation","PARTICIPANT_TALK":"Deltagande med muntlig presentation","PARTICIPANT_WITHOUT_PRESENTATION":"Deltagande utan presentation","ORGANISER":"Arrang\xf6r"}},"CONFERENCES_AND_MOBILITY":"Konferens och mobilitet","LOCATION":"Plats","DATE":"Datum","DATES":"Datum","LOADING_CONFERENCES_AND_MOBILI":"Laddar konferenser och mobilitet...","NO_CONFERENCES_OR_MOBILITY_PLA":"Inga konferenser eller mobilitet planerade.","ADD_CONFERENCE_OR_MOBILITY":"L\xe4gg till konferens eller mobilitet","FAILED_TO_CREATE_CONFERENCE_OR_MOBILITY":"Det gick inte att skapa konferens eller mobilitet.","DELETE":"Radera","REALLY_CANCEL_INVITATION":"Vill du verkligen avbryta inbjudan?","KEEP_INVITATION":"Beh\xe5ll inbjudan","CANCEL_INVITATION":"Avbryt inbjudan","INVITATION_EXPIRED":"Inbjudan har l\xf6pt ut","INVITED_NOT_YET_RESPONDED":"Inbjuden, v\xe4ntar p\xe5 svar","FIRST_NAME":"F\xf6rnamn","LAST_NAME":"Efternamn","EMAIL_ADDRESS":"E-postadress","SAVED":"Sparad","REALLY_REMOVE":"Vill du verkligen ta bort?","THE_LAST_MEMBER_CANNOT_BE_REMO":"Den sista medlemmen kan inte tas bort.","RESEND_INVITATION":"Skicka inbjudan igen","INVITATION_TO_BECOME_A":"Inbjudan att bli en","FOR":"f\xf6r","EXPIRES_ON":"G\xe5r ut den","THIS_INVITATION_HAS_EXPIRED_Y":"Denna inbjudan har upph\xf6rt att g\xe4lla. Du kan beg\xe4ra en ny inbjudan av doktorandanden","ACCEPT":"Acceptera","DECLINE":"Avsl\xe5","DUE_TO_DATA_MIGRATION_THESSA":"P\xe5 grund av datamigrering k\xe4nner Thessa inte till startdatumet f\xf6r denna status. V\xe4lj r\xe4tt datum nedan och spara publiceringen.","NO_PUBLICATIONS_IN_PLAN_YET":"Inga publikationer i planen \xe4nnu.","TOPIC_OR_TITLE":"\xc4mne eller titel","EDIT_REMINDER":"Redigera p\xe5minnelse","LOADING_YOUR_REMINDERS":"Laddar dina p\xe5minnelser","NEW_REMINDER":"Ny p\xe5minnelse","UPCOMING_REMINDERS":"Kommande p\xe5minnelser","PAST_REMINDERS":"Tidigare p\xe5minnelser","NO_REMINDERS":"Inga p\xe5minnelser","DUE":"Till f\xf6ljd av","SEND_REMINDERS_TO":"Skicka p\xe5minnelser till","REMINDER_TIMING":"Tidpunkt f\xf6r p\xe5minnelse","DAYS_BEFORE_DUE_DATE":"dagar f\xf6re f\xf6rfallodatum","CREATE_REPORT":"Skapa rapport","YOUR_ACCOUNT_IS_INACTIVE_THER":"Ditt konto \xe4r inaktivt, d\xe4rf\xf6r kan du inte skapa en rapport \xe4nnu.","YOUR_DOCTORAL_PROGRAMME_S_STAF":"Personalen p\xe5 din doktorandprogram kommer att aktivera kontot \xe5t dig n\xe4r de har kontrollerat din profil.","OPEN_REPORT":"\xd6ppna rapporten","OPEN_MEETING":"\xd6ppna m\xf6tet","SUMMARIZE_THE_REPORTING_PERIOD":"Sammanfatta rapporteringsperioden","AS_AN_OVERVIEW_OF_THE_REPORTIN":"Lista tre positiva och tre negativa saker som en sammanfattning av rapporteringsperioden.","PHD_PROJECT_PAGE":"Sida f\xf6r doktorandprojekt","PUBLICATIONS_IN_REPORTING_PERIOD":"Publikationer som var p\xe5g\xe5ende eller publicerade under rapporteringsperioden.","NO_PUBLICATIONS_IN_REPORTING_PERIOD":"Inga publikationer var p\xe5g\xe5ende eller publicerade under rapporteringsperioden.","COURSES_IN_REPORTING_PERIOD":"Studieavsnitt som genomf\xf6rdes under rapporteringsperioden.","INTERNATIONAL_ACTIVITY_IN_REPORTING_PERIOD":"Konferenser och mobilitet som genomf\xf6rdes under rapporteringsperioden.","TEACHING_IN_REPORTING_PERIOD":"Undervisning under rapporteringsperioden.","NO_COURSES_OR_WORKSHOPS_IN_REPORTING_PERIOD":"Inga kurser eller workshoppar under rapporteringsperioden.","NO_THESIS_INSTRUCTION_IN_REPORTING_PERIOD":"Inga avhandlingsinstruktioner under rapporteringsperioden.","FUNDING_IN_REPORTING_PERIOD":"Finansiering under rapporteringsperioden.","NO_SALARIES_IN_REPORTING_PERIOD":"Inga l\xf6ner under rapporteringsperioden.","NO_GRANTS_IN_REPORTING_PERIOD":"Inga stipendier under rapporteringsperioden.","NOT_SUBMITTED":"Os\xe4nd","CONCLUSION_DONE":"Avslutning gjord","WRITE_CONCLUSION":"Skriv avslutning","HAVE_A_THESIS_COMMITTEE_MEETIN1":"H\xe5ll ett m\xf6te med uppf\xf6ljningsgruppen och skriv avslutningen till din rapport.","THE_DOCTORAL_CANDIDATE_NEEDS_T":"Doktoranden ska h\xe5lla ett m\xf6te med uppf\xf6ljningsgruppen och skriva avslutningen till rapporten.","DONE":"Gjort","REPORT_SUBMITTED_FOR_REVIEW_SU":"Rapporten har skickats f\xf6r granskning.","REPORT_SUBMITTED":"Rapport inl\xe4mnad","REPORT_UPDATED":"Rapport uppdaterad","EDIT_REPORT":"Redigera rapport","YOU_CAN_MAKE_CHANGES_TO_THE_RE":"Du kan g\xf6ra \xe4ndringar i rapporten.","NO_REPORTS_TO_REVIEW_FOUND":"Inga rapporter att granska hittades.","EDIT_REVIEW":"Redigera bed\xf6mning","REVIEW_REPORT":"Granska rapporten","CHANGES_SAVED":"\xc4ndringar sparade","LAST_SAVED":"Senast sparad","CANCEL_EDITING":"Avbryt redigering","SAVE_REPORT":"Spara rapport","SUBMIT_REPORT_FOR_REVIEW":"Skicka in rapport f\xf6r granskning","CREATED_IN":"Skapad \xe5r","CONFERENCES_AND_MOBILITY1":"Konferenser och mobilitet","FUNDING":"Finansiering","TEACHING":"Undervisning","COURSES_AND_WORKSHOPS":"Kurser och workshops","THESIS_INSTRUCTION":"Instruktion f\xf6r examensarbetet","YOU_ARE_EDITING_THE_REPORT_S_C":"Du redigerar rapportens avslutning och rekommendationer","SHOW_EDITOR":"Visa redakt\xf6r","PLEASE_INDICATE_WHO_ATTENDED_T":"Ange v\xe4nligen vem som deltog i uppf\xf6ljningsgruppens m\xf6te.","THESIS_COMMITTEE_MEETING_FORM":"M\xf6tesblankett f\xf6r uppf\xf6ljningsgruppen","CONCLUSION_AND_RECOMMENDATIONS":"Slutsats och rekommendationer","NO_REPORT_FOUND_CANNOT_EDIT_CONCLUSION":"Rapporten hittades inte. Det g\xe5r inte att redigera slutsatsen.","NO_TEXT_TO_PREVIEW":"Ingen text att f\xf6rhandsgranska","CANNOT_SUBMIT_CONCLUSION_EMPTY":"Slutsatsen kan inte vara tom.","THE_DOCTORAL_CANDIDATE_IS_EXPE":"Doktoranden f\xf6rv\xe4ntas fylla i detta formul\xe4r i slutet av uppf\xf6ljningsgruppens m\xf6te n\xe4r alla deltagare \xe4r n\xe4rvarande.","PREVIEW":"F\xf6rhandsvisning","SUBMITTING_PLEASE_WAIT":"Skickar, v\xe4nta...","CONCLUSION_CONFIRM_CANCEL":"\xc4r du s\xe4ker p\xe5 att du vill sluta skriva slutsatsen? Det du har skrivit hittills kommer att g\xe5 f\xf6rlorat.","CONCLUSION_CANNOT_BE_EDITED":"Slutsats har redan skrivits f\xf6r denna rapport och den kan inte \xe4ndras i efterhand. Du kan <0>g\xe5 tillbaka till rapporten</0>.","CUMULATIVE_REPORT_FOR":"Kumulativ rapport f\xf6r","COMPLETED_IN_THE_MOST_RECENT":"slutf\xf6rt i den senaste rapporten","IN_PROGRESS_IN_THE_MOST_RECE":"framskridit i den senaste rapporten","PUBLICATION_IS_IN_THESIS":"Publiceras i avhandlingen","COMPLETE":"klar","NOTHING_REPORTED_YET":"Inget rapporterat \xe4nnu.","DELETE_REPORT":"Ta bort rapport","YOU_CAN_DELETE_YOUR_REPORT_BEF":"Du kan radera din rapport innan den har skickats.","COMPLETED1":"klar","ESTIMATE_OF_HOW_COMPLETE_YOUR":"Uppskattning av hur fullst\xe4ndigt ditt doktorandprojekt \xe4r i procent.","FULL_TIME":"heltid","ESTIMATE_OF_FULL_PART_TIME_WOR":"Uppskattning av heltids-/deltidsarbete p\xe5 doktorandprojekt under rapportperioden.","YOUR_DOCTORAL_PROGRAMME_ASKS_Y":"Ditt doktorandprogram ber dig att skriva denna rapport f\xf6r att f\xe5 en uppfattning om hur ditt doktorandprojekt fortskrider.","PLEASE_FILL_IN_ALL_OF_THE_FIEL":"Fyll v\xe4nligen i alla f\xe4lt.","THE_REPORT_WILL_BE_VISIBLE_TO":"Rapporten kommer att vara synlig f\xf6r dina handledare, uppf\xf6ljningsgruppmedlemmar och samordnare n\xe4r den v\xe4l har l\xe4mnats in.","AND":"och","WHEN_YOU_ARE_DONE_PRESS_THE_S":"Tryck p\xe5 Skicka-knappen n\xe4r du \xe4r klar. Knappen blir synlig n\xe4r du har fyllt i varje f\xe4lt. Efter inl\xe4mning \xe4r rapporten \xf6ppen f\xf6r diskussion.","REMEMBER_TO_SAVE_THE_REPORT_PE":"Kom ih\xe5g att spara rapporten med j\xe4mna mellanrum. Du kan n\xe4r som helst spara rapporten och forts\xe4tta skriva den senare.","MESSAGE_REMOVED":"Meddelandet har tagits bort.","DISCUSSION":"Diskussion","LOADING":"Laddar upp...","NO_DOCUMENT_FOUND_WITH_DATE":"Inget dokument hittades med datum","APPROVED_BY_THE_BOARD_OF_DOCTO":"Godk\xe4nd av ledingsruppen f\xf6r doktorsutbildning vid Helsingfors universitet, <0>{{date}}</0>.","THESSA_JOIN_A_THESIS_COMMITT":"Thessa - G\xe5 med i en uppf\xf6ljningsgrupp","WITH_YOUR_THESSA_CREDENTIALS_O":"med ditt Thessa-anv\xe4ndar-ID eller anv\xe4nd ditt anv\xe4ndar-ID f\xf6r Helsingfors universitet.","OTHERWISE":"Annars","REGISTER_AN_EXTERNAL_ACCOUNT":"registrera ett externt konto","YOU_WILL_USE_THIS_FOR_LOGGING":"Du kommer att anv\xe4nda detta f\xf6r att logga in.","AT_LEAST_CHARACTERS":"Minst 8 tecken.","YOUR_ORGANIZATION":"Din organisation","FOR_EXAMPLE_FINNISH_METEOROLO":"Till exempel: Meteorologiska institutet eller Acme Inc.","THERE_WERE_PROBLEMS_WITH_SIGN":"Det uppstod problem med registreringen:","WELCOME_TO_THESSA_AS_A_NON_UN":"V\xe4lkommen till Thessa! Som anv\xe4ndare utanf\xf6r Helsingfors universitet kan du skapa ditt konto h\xe4r.","ERROR":"Fel","SORRY_AN_ERROR_HAS_OCCURRED_I":"Ett fel har uppst\xe5tt vid registreringen. F\xf6rs\xf6k igen genom att uppdatera sidan, eller","DOCTORAL_STUDIES":"Doktorandstudier","FILL_IN_DETAILS_OF_YOUR_STUDIE":"Fyll i detaljer om dina studier.","BEGINNING_OF_DOCTORAL_STUDIES":"B\xf6rjan av doktorandstudier","DOCTORAL_PROGRAMME":"Doktorandprogram","BACK":"Tillbaka","CONTINUE":"Forts\xe4tt","OR":"eller","LOG_OUT1":"logga ut","WELCOME_TO_THESSA1":"V\xe4lkommen till Thessa","WE_NEED_SOME_INFORMATION_ABOUT":"Vi beh\xf6ver lite information om dig innan du kan forts\xe4tta.","MY_ROLE_IN_THESSA":"Min roll i Thessa","DOCTORAL_CANDIDATE":"Doktorand","SUPERVISOR":"Handledare","SUPERVISOR_other":"Handledare","THESIS_COMMITTEE_MEMBER":"Uppf\xf6ljningsgruppmedlem","VERIFY_YOUR_DETAILS":"Verifiera dina uppgifter","WE_FOUND_THE_FOLLOWING_DETAILS":"Vi hittade f\xf6ljande information om dig automatiskt.","PLEASE_CHECK_THAT_THEY_ARE_COR":"Kontrollera att de \xe4r korrekta och korrigera vid behov.","LIST_DOCTORAL_CANDIDATES_BY_RE":"Lista doktorander efter rapportstatus","LIST_REVIEWERS_OF_NOT_COMPLETE":"Lista granskare av ej f\xe4rdigst\xe4llda rapporter","DOWNLOAD_THESSA_ADMIN_REPORT":"Ladda ner Thessa admin rapport","REPORT_CONCLUSIONS_OVERVIEW":"Rapport \xf6versikt \xf6ver slutsatser","FILTER":"Filtrera","SHOW_ALL_REPORTS":"Visa alla rapporter","OVER_MONTH_OLD_REPORTS":"\xd6ver 2 m\xe5nader gamla rapporter","COPY_REVIEWER_EMAIL_ADDRESSES":"Kopiera granskarens e-postadresser","EMAIL_ADDRESSES_COPIED":"E-postadresser kopierade","CREATED_AT":"Skapad","REVIEWERS":"Bed\xf6mare","FILTER_BY_DOCTORAL_PROGRAMME":"Filtrera enligt doktorandprogram","NO_REPORT_CONCLUSIONS_AVAILABL":"Inga slutsatser tillg\xe4ngliga f\xf6r doktorandprogrammet i","PRELIMINARY_TITLE_OF_DISSERTAT":"Avhandlingens prelimin\xe4ra titel","STUDENT_NUMBER1":"STUDENTNUMMER","NAME1":"NAMN","ACCOUNT_CLOSED":"Konto st\xe4ngt:","STUDIES":"STUDIER","FACULTY":"FAKULTET","SUPERVISORS1":"HANDLEDARE","THESIS_COMMITTEE2":"UPPF\xd6LJNINGSGRUPPEN","REPORT_CREATED":"Rapport skapad","PROGRESS1":"framsteg","LINK_TO_THE_DOCTORAL_CANDIDATE":"L\xe4nk till doktorandens Thessa-sida","STUDENT_ID_NUMBER":"Student-ID-nummer","ACCOUNT_STATUS_OPEN_CLOSED":"Kontostatus (\xf6ppet/st\xe4ngt)","IF_ACCOUNT_IS_CLOSED_REASON_F":"Anledning till st\xe4ngning om kontot \xe4r st\xe4ngt","IS_ACCOUNT_ACTIVE_ACTIVE_INAC":"\xc4r kontot aktivt (aktivt/inaktivt)","EMAIL2":"e-post","FACULTY1":"fakultet","FACULTY_OF_DEGREE":"examensfakultet","STARTING_DATE_OF_DOCTORAL_STUD":"Startdatum f\xf6r doktorandstudier","DOES_THE_DOCTORAL_CANDIDATE_HA":"Har doktoranden en handledningsplan","IS_THE_SUPERVISION_PLAN_IN_EFF":"\xc4r handledningsplanen i kraft","SUPERVISORS2":"handledare","SUPERVISORS_AND_THEIR_EMAIL_AD":"Handledare och deras e-postadresser","IS_THE_ANNUAL_REPORT_SUBMITTED":"\xc4r \xe5rsrapporten inl\xe4mnad","LATEST_REPORT_SUBMITTED_AT_DATE":"Senaste rapporten inl\xe4mnad den","THE_ANNUAL_REPORTING_IS_CLOSED":"\xc5rsrapporten \xe4r avslutad och slutsatsen \xe4r skriven","NEXT_REPORT_S_DEADLINE":"Deadline f\xf6r n\xe4sta rapport","THESIS_COMMITTEE_HAS_BEEN_ASSI":"Uppf\xf6ljningsgruppen har tillsatts","MEMBERS_OF_THE_THESIS_COMMITTE":"Medlemmarna i uppf\xf6lningsgruppen och deras e-postadresser","OVERALL_PERCENTAGE_OF_COMPLETI":"Andel av examensarbetet f\xe4rdig i procent","ADVANCEMENT_OF_THESIS_WORK_COM":"Examensarbetets fortskridande under rapporteringsperioden","FULL_TIME_PART_TIME":"Full tid del tid","SALARIES2":"l\xf6ner","GRANTS2":"Stipdendier","GRANTS_OBTAINED_AND_APPLIED_FO":"Stipendier erh\xe5llits och s\xf6kts","EXPORT":"Exportera","CREATE_SUPERVISION_PLAN":"Skapa handledningsplan","DELETE_SUPERVISION_PLAN":"Ta bort handledningplan","ACCEPT_PLAN":"Acceptera planen","VALID_BETWEEN":"G\xe4ller mellan","VALID_FROM":"G\xe4ller tillsvidare fr\xe5n","VALID_INDEFINITELY":"Handledningsplan \xe4r giltig tillsvidare","VALID_INDEFINITELY_SHORT":"Giltig tills vidare","DECISIONS":"Beslut","SIGNATURES":"Signaturer","SIGNED":"Signerad","NOT_YET_SIGNED":"Inte \xe4nnu undertecknad","WHAT_HAVE_YOU_DECIDED_ABOUT_TH":"V\xe4nligen fyll i minst ett valfritt f\xe4lt med ert beslut om hur ni kommer att arbeta tillsammans mot er doktorsexamen","ACTIVE":"Aktiv","PENDING":"V\xe4ntar","EXPIRED":"F\xf6rldrar","GENERAL_TERMS_ON":"Allm\xe4nna villkor p\xe5","RIGHTS_OBLIGATIONS_AND_RESPON2":"R\xe4ttigheter, f\xf6rpliktelser och skyldigheter i forskarutbildningen vid Helsingfors universitet","THAT_APPLY_TO_THE_SUPERVISION":"som g\xe4ller f\xf6r handledningsplanen.","NO_COURSES_OR_WORKSHOPS_IN_PLA":"Inga kurser eller workshops finns \xe4nnu i planen.","NO_THESIS_INSTRUCTIONS_IN_PLAN":"Inga instruktioner f\xf6r avnahndlingen finns \xe4nnu i planen.","ADD_TEACHING":"L\xe4gg till undervisning","TYPE_OF_TEACHING":"Typ av undervisning","DATES1":"Datum","COURSE_OR_WORKSHOP_NAME":"Namn p\xe5 kursen eller workshopen","MY_ROLE":"Min roll","WORK_HOURS":"Arbetstimmar","STUDENT_S_NAME":"Studentens namn","THESIS_LEVEL":"Avhandlingens sniv\xe5","THESIS_TOPIC_OR_TITLE":"Avhandlingens \xe4mne eller titel","SIGNED_UP_ON":"Konto skapat","USERNAME":"Anv\xe4ndarnamn","ACTIVATE_ACCOUNT_NOW":"Aktivera kontot nu","USER_ACCOUNT_IS_NOT_YET_ACTIVA":"Anv\xe4ndarkontot \xe4r inte \xe4nnu aktiverat","CHECK_THE_ACCOUNT_DETAILS_IF":"Kontrollera kontoinformationen \u2013 om anv\xe4ndaren faktiskt tillh\xf6r din organisation, aktivera kontot. Annars","CONTACT_THESSA_S_ADMINS":"kontakta Thessas administrat\xf6rer","CLOSE_ACCOUNT":"St\xe4ng Konto","REASON_FOR_CLOSING_THE_ACCOUNT":"Anledning till st\xe4ngande av kontot","OPEN_ACCOUNT":"\xc5teraktivera konto","OPEN_ACCOUNT_ERROR":{"ERROR":"Det gick inte att \xe5teraktivera kontot","IS_ALREADY_OPEN":"Kontot \xe4r redan aktivt","NOT_DOCTORAL_CANDIDATE":"Anv\xe4ndaren \xe4r inte doktorand","ALREADY_REOPENED_BY_USERNAME":"Anv\xe4ndarkontot har redan \xe5teraktiverats (tillf\xe4lligt anv\xe4ndarnamn hittades)","ALREADY_REOPENED_BY_EMAIL":"Anv\xe4ndarkontot har redan \xe5teraktiverats (tillf\xe4llig e-postadress hittades)"},"FACULTY2":"Fakultet:","MAJOR":"Huvud\xe4mne:","DOCTORAL_PROGRAMME1":"Doktorandprogram:","BEGINNING_OF_DOCTORAL_STUDIES1":"B\xf6rjan p\xe5 doktorandstudier:","BACK_TO":"Tillbaka till","ORGANIZATION":"Organisation","STUDENT_NUMBER2":"Studentnummer:","VERIFIED_FROM_LDAP":"Verifierad fr\xe5n LDAP)","NOT_VERIFIED_REPORTED_BY_DOCT":"Ej verifierad, rapporterad av doktorand)","THESIS_COMMITTEE_MEMBER1":"Uppf\xf6ljningsgruppmedlem","IN_THESIS_COMMITTEE_FOR":"I uppf\xf6ljningsgruppen f\xf6r {{count}} doktorand","IN_THESIS_COMMITTEE_FOR_other":"I uppf\xf6ljningsgruppen f\xf6r {{count}} doktorander","THE_INVITATION_HAS_EXPIRED":"<0>Inbjudan har g\xe5tt ut.</0>","THE_INVITATION_HAS_ALREADY_BEEN_USED":"<0>Denna inbjudan har redan anv\xe4nts.</0>","THERE_WAS_AN_ERROR_IN_LOADING_THE_INVITATION":"<0>Det uppstod ett fel n\xe4r inbjudan laddades.</0> V\xe4nligen <1>F\xf6rs\xf6k igen</1>. V\xe4nligen <2>meddela oss</2> om problemet inte f\xf6rsvinner.","INVITATION_DECLINED":"<0>Inbjudan avvisades.</0> Tack f\xf6r ditt svar!","YOUR_ACCOUNT_IS_CLOSED":"Ditt konto \xe4r st\xe4ngt","SUPERVISION_PLAN_NOT_FOUND":"Handledningsplan hittades inte","IN_THESIS":"I avhandlingen","PUBLISHED":"Publicerad","NOT_STARTED":"Ej p\xe5b\xf6rjad","THE_SUPERVISION_PLAN_AFFECTS_THE_DOCTORAL":"Handledningsplanen ber\xf6r doktoranden och doktorandens samtliga handledare.","IT_IS_RECOMMENDED_THAT_SUPERVISION_PLANS":"Det rekommenderas att avhandlingsplanen skapas n\xe4r alla ber\xf6rda \xe4r n\xe4rvarande. Om n\xe5gon inte kan n\xe4rvara, se till att skapa en plan som de ocks\xe5 kan skriva under.","CREATE_AND_SIGN_PLAN_AS":"Spara slutversionen och signera","SAVE_DRAFT":"Spara utkast","SAVE_DRAFT_FEEDBACK":"Utkastet sparat","LOADING_DOCTORAL_PROGRAMMES":"Laddar doktorandprogram...","FORM_IS_INCOMPLETE":"Formul\xe4ret \xe4r ofullst\xe4ndigt","DESCRIPTION":"Beskrivning","ROLE_IN_CONFERENCE":"Roll p\xe5 konferens","FAILED_TO_SAVE":"<0>Det gick inte att spara.</0> F\xf6rs\xf6k igen eller <1>kontakta oss</1> om problemet kvarst\xe5r.","ROLE":"Roll","PREVIOUS_PAGE":"F\xf6reg\xe5ende <0>sida</0>","NEXT_PAGE":"N\xe4sta <0>sida</0>","ROWS":"rader","PAGE_OF":"<0>Sida {{currentPage}}</0> <1>av {{totalPages}}</1>","PAGE":"Sida","MAX_SIZE_PER_ATTACHMENT":"Max storlek per bilaga:","UPLOAD_ATTACHMENTS":"Ladda upp bilagor","UPLOADING":"Laddar upp...","WHAT_PLANS_DO_YOU_HAVE":"Vilka planer har du? St\xf6djer dina avlagda studier detta m\xe5l?","WRITE_HERE_ABOUT_YOUR_RESEARCH_PROGRESS":"Skriv h\xe4r om dina forskningsframsteg under rapportperioden. H\xe5ll dig till huvudpunkterna och var kortfattad f\xf6r att hj\xe4lpa avhandlingskommitt\xe9n att enkelt utv\xe4rdera dina framsteg. Observera att du kan ladda upp din uppdaterade forskningsplan eller annat relevant material som en bilaga till denna rapport.","FOR_EXAMPLE_WRITE_ABOUT_HOSTING_A_VISITOR":"Skriv till exempel om att ta emot en bes\xf6kare eller organisera nationella studiebes\xf6k.","FOR_EXAMPLE_HAVE_YOU_WRITTEN_A_BLOG":"Har du till exempel skrivit en blogg eller en popul\xe4rvetenskaplig artikel, anordnat ett evenemang riktat till en publik utanf\xf6r ditt eget omr\xe5de eller f\xf6rs\xf6kt p\xe5verka p\xe5 n\xe5got annat s\xe4tt?","NO_REPORTS":"Inga rapporter","ANY":"N\xe5gra","FILTER_BY":"Filtrera enligt {{target}}","SORT_BY":"Sortera enligt","THERE_WAS_AN_ERROR_IN_LOADING_DOCTORAL_CANDIDATES":"<0>Det uppstod ett fel med laddandet av doktorander.</0> V\xe4nligen <1>F\xf6rs\xf6k igen</1>. V\xe4nligen <2>meddela oss</2> om problemet inte f\xf6rsvinner.","THERE_ARE_NO_DOCTORAL_CANDIDATES_IN_THE_SELECTED":"Inga doktorander hittade.","DOCTORAL_PROGRAMMES":"Doktorandprogram","ERROR_LOADING_DOCTORAL_PROGRAMMES":"<0>Fel med laddabdet av doktorandprogram.</0> V\xe4nligen <1>F\xf6rs\xf6k igen</1>. <2>Meddela oss</2> om det inte hj\xe4lper.","SELECT_NONE":"V\xe4lj inget","SELECT_ALL":"V\xe4lj alla","WHEN_WILL_EACH_STAGE_OF_THE_PUBLICATION_BEGIN":"N\xe4r b\xf6rjar varje skede av publiceringen? Uppskatta n\xe4r skedet skulle b\xf6rja om det \xe4r i framtiden. Varje status m\xe5ste b\xf6rja efter den f\xf6reg\xe5ende.","THE_STATUSES_ARE_IN_INCORRECT_ORDER":"Statusarna \xe4r i felaktig ordning: varje status m\xe5ste b\xf6rja efter den f\xf6reg\xe5ende.","TO_BE_INCLUDED_IN_THE_PHD_THESIS":"Ska ing\xe5 i doktorsavhandlingen","SAVE_PUBLICATION":"Spara publikationen","CREATE_ANOTHER":"Skapa en till","CREATING_ANOTHER_PUBLICATION":"Skapar en till publikation","CREATING_ANOTHER_GRANT":"Skapar ett till stipendium","SOURCE_OF_GRANT":"Stipendiek\xe4lla","FROM_WHICH_ORGANIZATION_IS_THE_GRANT_FROM":"Fr\xe5n vilken organisation kommer stipendiet?","HOW_MUCH_IS_THIS_GRANT":"Hur stort \xe4r detta stipendiun?","SAVE_GRANT":"Spara stipendium","ENDS_AT":"Slutar","BEGINS_AT":"B\xf6rjar","WHAT_IS_THE_INTENDED_USAGE_OF_THIS_GRANT":"Vad \xe4r den avsedda anv\xe4ndningen f\xf6r detta stipendium?","DURATION_OF_GRANT":"Stipendiets varaktighet","WHEN_DOES_THIS_GRANT_BEGIN_AND_END":"N\xe4r b\xf6rjar och slutar detta stipendium? G\xf6r en uppskattning om det inte finns n\xe5got tydligt datum.","CREATING_ANOTHER_TEACHING":"Skapa en till undervisning","BEGINNING_DATE":"Startdatum","END_DATE":"Slutdatum","NAME_OF_THE_COURSE_OR_WORKSHOP":"Namn p\xe5 kursen eller workshopen","MY_ROLE_IN_TEACHING":"Min roll i undervisningen","FOR_EXAMPLE_LECTURER_OR_ASSISTANT":"Till exempel <0>f\xf6rel\xe4sare</0> eller <1>assistent</1>.","TOPIC_OR_TITLE_OF_THE_THESIS":"Avhandlingens \xe4mne eller titel","LEVEL_OF_THESIS":"Niv\xe5 p\xe5 avhandlingen","COURSE_OR_WORKSHOP":"Kurs eller workshop","HOW_MANY_HOURS_OF_WORK_DID_YOU_SPEND_IN_TOTAL":"Hur m\xe5nga timmar arbete anv\xe4nde du totalt?","NAME_OF_THE_STUDENT_WHO_YOUR_WERE_INSTRUCTING":"Namn p\xe5 studenten som du hanledde","MY_ROLE_IN_INSTRUCTING_THE_STUDENT":"Min roll i studentens handledning","FOR_EXAMPLE_MAIN_SUPERVISOR_OR_CO_SUPERVISOR":"Till exempel <0>huvudhandledare</0> eller <1>andra handledare</1>.","FOR_EXAMPLE_MASTERS_THESIS_OR_BACHELORS_THESIS":"Till exempel <0>magisteravhandling</0> eller <1>kandidatavhandling</1>.","CREATING_ANOTHER_SALARY":"Skapa en annan l\xf6n","SOURCE_OF_SALARY":"L\xf6nek\xe4lla","FROM_WHICH_ORGANIZATION_AND_OR_PROJECT_DO_YOU_GET":"Fr\xe5n vilken organisation och/eller projekt f\xe5r du din l\xf6n fr\xe5n?","DURATION_OF_SALARY":"L\xf6nens varaktighet","WHEN_DOES_THIS_SALARY_BEGIN_AND_END_IF_THERE_IS_NO":"N\xe4r b\xf6rjar och slutar denna l\xf6n? G\xf6r en uppskattning om det inte finns n\xe5got tydligt datum.","SAVE_SALARY":"Spara l\xf6n","DUE_DATE":"F\xf6rfallodatum","SEND_REMINDER_EMAILS_AT":"Skicka p\xe5minnelsemail","SAVE_REMINDER":"Spara p\xe5minnelse","LOG_IN_OR_SIGN_UP_TO_ACCEPT_INVITATION":"Logga in eller registrera dig f\xf6r att acceptera inbjudan.","LOG_IN_WITH_UNIVERSITY_OF_HELSINKI_ACCOUNT":"Logga in med Helsingfors universitets konto","I_DON_T_HAVE_A_UNIVERSITY_OF_HELSINKI_ACCOUNT":"Jag har inget konto vid Helsingfors universitet","LOG_IN_WITH_AN_EXISTING_THESSA_ACCOUNT":"Logga in med ett befintligt Thessa-konto.","LOG_IN_OR_SIGN_UP_FOR_A_THESSA_ACCOUNT_TO":"Logga in eller skapa ett Thessa-konto f\xf6r att acceptera inbjudan.","SIGN_UP_FOR_A_NEW_THESSA_ACCOUNT":"Skapa ett nytt Thessa-konto","ERROR_LOGIN_OR_SIGN_UP":"FEL - logga in eller skapa ett konto!","INVITATION_HAS_EXPIRED_AT":"Inbjudan har g\xe5tt ut {{date}}. <0>G\xe5 till Thessas f\xf6rstasida</0>","INVITATIONS":{"BY_ACCEPTING_THE_INVITATION":"Genom att acceptera inbjudan f\xe5r du se detta doktorsavhandlingsprojekt i Thessa.","UNIVERSITY_STAFF_OR_STUDENTS_HEADING":"Anst\xe4llda och studenter vid Helsingfors universitet","UNIVERSITY_STAFF_OR_STUDENTS_INSTRUCTIONS":"Om du arbetar eller studerar vid Helsingfors universitet, kan du acceptera inbjudan genom att logga in med ditt universitetskonto.","EXTERNAL_USERS_HEADING":"\xd6vriga","EXTERNAL_USERS_INSTRUCTIONS":"Om du inte \xe4r anst\xe4lld eller student vid Helsingfors universitet kan du acceptera inbjudan genom att logga in p\xe5 ditt Thessa-konto.","EXTERNAL_EXISTING_USERS_HEADING":"Befintligt Thessa-konto","EXTERNAL_EXISTING_USERS_INSTRUCTIONS":"Om du tidigare har anv\xe4nt Thessa, logga in p\xe5 ditt befintliga Thessa-konto.","EXTERNAL_NEW_USERS_HEADING":"Skapa Thessa-konto","EXTERNAL_NEW_USERS_INSTRUCTIONS":"Om du inte har anv\xe4nt Thessa tidigare och inte har ett anv\xe4ndarnamn vid Helsingfors universitet kan du skapa ett anv\xe4ndarkonto i Thessa.","EXTERNAL_NEW_USERS_ACTION":"Skapa Thessa-konto","YOU_ARE_USING_UNIVERSITY_EMAIL":"Du anv\xe4nder en e-postadress fr\xe5n Helsingfors universitet. Du b\xf6r antagligen logga in med ditt konto fr\xe5n Helsingfors universitet ist\xe4llet f\xf6r att skapa ett nytt Thessa-konto.","DECLINE_INSTRUCTIONS":"Om du fick den h\xe4r inbjudan av misstag, ber vi dig att avb\xf6ja den.","DECLINE_ACTION":"Avb\xf6j inbjudan","FAILED_TO_ACCEPT_INVITATION":"<0>Det gick inte att acceptera inbjudan.</0> F\xf6rs\xf6k igen. V\xe4nligen <1>meddela oss</1> om problemet inte f\xf6rsvinner."},"YOU_HAVE_BEEN_INVITED_TO_BECOME":"Du har blivit inbjuden att bli <0>{{roles}} f\xf6r {{inviter}}</0> i Thessa.","ACCEPT_INVITATION":"Acceptera inbjudan","THERE_WAS_AN_ERROR_IN_DECLINING_THE_INVITATION":"<0>Det gick inte att tacka nej till inbjudan.</0> F\xf6rs\xf6k igen. V\xe4nligen <1>meddela oss</1> om problemet inte f\xf6rsvinner.","SIGN_UP_FOR_A_NEW_THESSA_ACCOUNT_TO":"Skapa ett nytt Thessa-konto f\xf6r att acceptera inbjudan.","SIGN_UP":"Bli Medlem","ERROR_IN_SIGN_UP":"Fel vid registrering.","LOG_IN_FAILED_TRY_AGAIN":"Inloggningen misslyckades. F\xf6rs\xf6k igen.","ROLES":"Roller","DOES_NOT_HAVE_ANY_ROLES_ASSIGNED":"<0>{{name}} har inga roller tilldelade.</0> Alla m\xe5ste ha minst en roll.","THERE_WAS_AN_ERROR_IN_UPDATING_ROLES":"<0>Det uppstod ett fel n\xe4r rollerna skulle uppdateras.</0> F\xf6rs\xf6k igen. V\xe4nligen <1>meddela oss</1> om problemet inte f\xf6rsvinner.","ONLY_ONE_PERSON_CAN_BE_THE_COORDINATING":"Endast en person kan vara den samordnande akademikern.","ONLY_ONE_PERSON_CAN_BE_THE_MAIN_SUPERVISOR":"Endast en person kan vara huvudhandledare.","ONE_PERSON_SHOULD_BE_SELECTED_AS_THE_COORDINATING":"En person b\xf6r v\xe4ljas som samordnande akademiker.","ONE_PERSON_SHOULD_BE_SELECTED_AS_THE_MAIN":"En person b\xf6r v\xe4ljas till huvudhandledare.","MYSELF":"Jag sj\xe4lv","FILTERS":"Filter","CHOOSE_A_DOCTORAL_PROGRAMME":"V\xe4lj ett doktorandprogram","LOADING_INACTIVE_USER":"Laddar inaktiv anv\xe4ndare...","NO_STUDENT_NUMBER":"Inget studentnummer","SIGNED_UP":"Anm\xe4ld","NO_SUPERVISORS":"Inga handledare","SUPERVISOR_INVITATIONS":"Handledareinbjudningar","ACTIVATE":"Aktivera","SEND_EMAIL":"Skicka epost","NO_EMAIL_ADDRESS":"Ingen e-postadress","THERE_WAS_AN_ERROR_IN_ACTIVATING_THE_USER_ACCOUNT":"<0>Det uppstod ett fel n\xe4r anv\xe4ndarkontot skulle aktiveras.</0> V\xe4nligen <1>F\xf6rs\xf6k igen</1>. V\xe4nligen <2>meddela oss</2> om problemet inte f\xf6rsvinner.","SELECT_DOCTORAL_PROGRAMME":"V\xe4lj doktorandprogram","NO_DOCTORAL_PROGRAMME_SELECTED":"Inget doktorandprogram valt","SELECT_DOCTORAL_PROGRAMMES":"V\xe4lj doktorandprogram","ALL_DOCTORAL_PROGRAMMES":"Alla doktorandprogram","NOT_VERIFIED":"obekr\xe4ftat","VERIFY_NOW":"Verifiera nu","DOCTORAL_CANDIDATE_DOES_NOT_HAVE_ANY_SUPERVISORS":"Doktoranden har inga handledare.","COUNT_THESIS_COMMITTEE_MEMBER":"{{count}} uppf\xf6jningsgruppmedlem","COUNT_THESIS_COMMITTEE_MEMBER_other":"{{count}} uppf\xf6jningsgruppmedlemmar","COUNT_SUPERVISOR_RELATIONSHIP":"{{count}} handledningsf\xf6rh\xe5llande","COUNT_SUPERVISOR_RELATIONSHIP_other":"{{count}} handledningsf\xf6rh\xe5llanden","COUNT_PUBLICATION_IN_PROGRESS":"{{count}} publicering p\xe5g\xe5r","COUNT_PUBLICATION_IN_PROGRESS_other":"{{count}} publiceringar p\xe5g\xe5r","COUNT_PUBLICATION_PUBLISHED":"{{count}} publikation publicerad","COUNT_PUBLICATION_PUBLISHED_other":"{{count}} publikationer publicerade","MAIN_SUPERVISOR":"Huvudhandledare","MAIN_SUPERVISOR_other":"Huvudhandledare","COORDINATING_ACADEMIC":"Koordinerande akademiker","COORDINATING_ACADEMIC_other":"Samordnande akademiker","COUNT_DOCTORAL_CANDIDATE":"{{count}} doktorand hittades","COUNT_DOCTORAL_CANDIDATE_other":"{{count}} doktorander hittade","ONLY_SHOW_DOCTORAL_CANDIDATES_LATE_WITH_NEXT_THESIS_COMMITTEE_MEETING":"Visa endast doktorander med sen n\xe4sta uppf\xf6ljningsgruppm\xf6te","ONLY_SHOW_DOCTORAL_CANDIDATES_WITHOUT_ACCOUNT":"Visa endast doktorander utan konto","ONLY_SHOW_DOCTORAL_CANDIDATES_WITHOUT_SUPERVISOR":"Visa endast doktorander utan handledare","COUNT_DOCTORAL_CANDIDATE_S_REPORT":"{{count}} doktoranders doktorandrapport \xe4r sen ({{percentage}}%)","COUNT_DOCTORAL_CANDIDATE_S_REPORT_other":"{{count}} doktoranders rapport \xe4r f\xf6rsenad ({{percentage}}%)","COUNT_DOCTORAL_CANDIDATE_S_LATEST":"{{count}} doktorands senaste rapport \xe4r inte \xe4nnu f\xe4rdig ({{percentage}}%)","COUNT_DOCTORAL_CANDIDATE_S_LATEST_other":"{{count}} doktoranders senaste rapport \xe4r inte \xe4nnu f\xe4rdig ({{percentage}}%)","COUNT_DOCTORAL_CANDIDATE_IS_ON_TIME":"{{count}} doktorand \xe4r i tid ({{percentage}}%)","COUNT_DOCTORAL_CANDIDATE_IS_ON_TIME_other":"{{count}} doktorander \xe4r i tid ({{percentage}}%)","COUNT_ITEM_IN_QUEUE":"{{count}} objekt i k\xf6","COUNT_ITEM_IN_QUEUE_other":"{{count}} objekt i k\xf6","OLDEST_ITEM_FIRST":"\xe4ldsta objektet f\xf6rst","ISPROCEEDING":"p\xe5g\xe5r","IS_THE_ANNUAL_REPORT_PROCEEDING_AS_PLANNED":"G\xe5r \xe5rsrapporten som planerat","CONCLUSIONCOMMENT":"slutsatsHur","COMMENT_ABOUT_THE_PROGRESS_OF_THE":"Kommentar om framstegen i avhandlingsarbetet skriven av huvudhandledare","PROGRESS_FEEDBACK_BY":"Framstegsfeedback av","IS_THE_DISSERTATION_WORK_PROCEEDING_AS_PLANNED":"Fortl\xf6per avhandlingsarbetet som planerat?","PROGRESS_FEEDBACK_IS_MISSING":"Framstegsfeedback saknas","PROGRESS_FEEDBACK_SUBMITTED":"Feedback om framsteg har skickats","GIVE_PROGRESS_FEEDBACK":"Ge feedback om framsteg","THERE_WAS_A_PROBLEM_SUBMITTING_PROGRESS_FEEDBACK":"Det uppstod ett problem med att skicka in framstegsfeedback","PROGRESS_FEEDBACK_SUBMITTED_REDIRECTING_YOU_BACK":"Framstegsfeedback har skickats. Omdirigerar dig tillbaka till <0>\xf6versiktssidan</0>","PROGRESS_FEEDBACK":"Framstegsfeedback","COMMENT1":"Kommentar","OPTIONAL_COMMENT_ABOUT_THE_PROGRESS_OF_THE":"Valfri kommentar om framstegen i avhandlingsarbetet","MOBILE":"Mobil","DESKTOP":"Arbetsbord","VIEW_ACCOUNT":"Visa konto","EDIT_ROLES":"Redigera roller","REMOVE_SUPERVISOR":"Avl\xe4gsna handledare","ENDING_ON_DATE":"Slutar den {{date}}","INVITE_SUPERVISOR":"Bjud in handledare","ADD_SUPERVISOR":"L\xe4gg till handledare","FAILED_TO_SEND_INVITE_PLEASE_TRY_AGAIN":"<0>Det gick inte att skicka inbjudan.</0> F\xf6rs\xf6k igen eller <1>kontakta Thessa-st\xf6det</1> f\xf6r hj\xe4lp.","SAVE_ROLES":"Spara roller","ERROR_IN_SAVING_ROLES_TRY_AGAIN_OR":"Det gick inte att spara roller. F\xf6rs\xf6k igen eller <0>kontakta Thessa-st\xf6det</0>.","INVITATION":"Inbjudan","REMOVE_INVITATION":"Ta bort inbjudan","YOU_HAVE_NO_ACTIVE_DOCTORAL_CANDIDATES_IN_THESSA":"Du har inga aktiva doktorander i Thessa just nu.","NOT_IN_THESSA":"Anv\xe4ndaren m\xe5ste logga in f\xf6r att aktivera sitt konto","UPLOAD_AN_EXCEL_FILE_WITH_SUPERVISOR_RELATIONSHIPS":"Ladda upp en Excel-fil med handledningsf\xf6rh\xe5llanden","CHANGE_FILE":"Byt fil","GO_BACK":"G\xe5 tillbaka","SAVE_SUPERVISOR_RELATIONSHIPS":"Spara handledningsf\xf6rh\xe5llanden","DOCTORAL_CANDIDATE_ROW":"Doktorandrad","IGNORE":"Ignorera","COORDINATING_ACADEMIC_EMAIL":"Den koordinerande akademikerns e-post","MAIN_SUPERVISOR_EMAIL":"Huvudhandledarens e-post","SUPERVISOR_EMAIL":"Handledarens e-post","SUPERVISOR_RELATIONSHIPS":"Handledningsf\xf6rh\xe5llanden","UPLOAD_A_FILE_WITH_SUPERVISOR_RELATIONSHIPS":"Ladda upp en fil med handledningsf\xf6rh\xe5llanden","PICK_COLUMNS_AND_ROWS_TO_IMPORT":"V\xe4lj kolumner och rader du vill importera","FOR_EACH_COLUMN_WITH_RELEVANT_DATA":"V\xe4lj r\xe4tt typ av kolumn fr\xe5n rullgardinsmenyn f\xf6r varje kolumn med relevant information (studentnummer och handledarens e-postadresser). Markera resten av kolumnerna som ignorerade.","THEN_SELECT_EACH_ROW_WITH_A_SUPERVISOR":"V\xe4lj sedan varje rad med en handledningsrelation och tryck p\xe5 knappen F\xf6rhandsgranska.","CHECK_THAT_THE_FOLLOWING_PREVIEW_IS_CORRECT":"Kontrollera att f\xf6ljande f\xf6rhandsvisning \xe4r korrekt. Om f\xf6rhandsgranskningen \xe4r korrekt trycker du p\xe5 knappen Spara handledningsf\xf6rh\xe5llanden f\xf6r att starta importen. Om f\xf6rhandsgranskningen \xe4r felaktig kan du ladda upp en ny Excel-fil eller trycka p\xe5 g\xe5 tillbaka-knappen och \xe4ndra kolumn- och radval.","IMPORT_SUCCESSFUL":"Importen lyckades","IMPORT_FAILED_PLEASE_CONTACT_US_FOR_HELP":"<0>Import misslyckades.</0> <1>Kontakta oss</1> f\xf6r hj\xe4lp.","FILE_UPLOAD_WAS_NOT_SUCCESSFUL_PLEASE_TRY_AGAIN":"<0>Fil\xf6verf\xf6ringen lyckades inte.</0> F\xf6rs\xf6k igen.","NOTES":"Anteckningar","COURSE_TITLE":"Studieavsnittets namn","SALARY_SOURCE":"L\xf6nek\xe4lla","GRANT_SOURCE":"Stipendiek\xe4lla","STUDENT":"Studerande","STATUS_OF_THE_PHD_PROJECT":"Doktorandprojektets status","LATEST_REPORT":"Senaste rapporten","TIME_SPENT_ON_PHD":"Tid spenderad p\xe5 doktorsexamen","SOCIAL_IMPACT_AND_PUBLIC_OUTREACH":"Social p\xe5verkan och populariserande av vetenskap","ATTACHMENTS":"Bilagor","THREE_POSITIVE_THINGS":"Tre positiva saker","THREE_NEGATIVE_THINGS":"Tre negativa saker","CAREER_PLANNING":"Karri\xe4rplanering","CONCLUSIONS":"Slutsatser","OTHER_WORK":"Annat arbete","WAIT_FOR_ONE_MINUTE_BEFORE_RESENDING":"V\xe4nta en minut innan du s\xe4nder igen","ACCOUNT_IS_CLOSED":"Kontot \xe4r st\xe4ngt","ACCOUNT_IS_ACTIVE":"Kontot \xe4r aktivt","ACCOUNT_IS_INACTIVE":"Kontot \xe4r inaktivt","ESTIMATED_STATUS_OF_THE_PHD_PROJECT":"Ber\xe4knad status f\xf6r doktorandprojektet","ESTIMATED_TIME_OF_PHD_DEFENCE":"Ber\xe4knad tid f\xf6r disputation","CAREER_PLANS_AFTER_YOUR_PHD":"Karri\xe4rplaner efter din doktorsexamen","BACK_TO_OVERVIEW":"Tillbaka till \xf6versikten","BACK_TO_REPORT":"Tillbaka till rapporten","CHANGE_SUPERVISOR":"Byt handledare","ADD_SUPERVISOR_FOR_NAME":"L\xe4gg till handledare f\xf6r {{name}}","FAILED_TO_ADD_SUPERVISOR_PLEASE_TRY_AGAIN_OR":"<0>Det gick inte att l\xe4gga till handledare.</0> F\xf6rs\xf6k igen eller <1>kontakta Thessa-supporten</1> f\xf6r att f\xe5 hj\xe4lp.","FAILED_TO_INVITE_SUPERVISOR_PLEASE_TRY_AGAIN_OR":"<0>Det gick inte att bjuda in handledaren.</0> F\xf6rs\xf6k igen eller <1>kontakta Thessa-st\xf6det</1> f\xf6r att f\xe5 hj\xe4lp.","INVITE_SUPERVISOR_FOR_NAME":"Bjud in handledare f\xf6r {{name}}","CHOOSE_LANGUAGE":"V\xe4lj spr\xe5k","PREPARATION_AND_ANALYSIS":"F\xf6rberedelse och analys","WRITING":"Skrivande","NAME_IS_NOT_YET_ON_THESSA_WHEN_THEY_SIGN_UP":"<0>{{name}} har \xe4nnu inte tagit Thessa i bruk.</0> En doktorand m\xe5ste logga in i Thessa en g\xe5ng innan hens uppgifter kan visas.","INVITE_THESIS_COMMITTEE":"Bjud in uppf\xf6ljningsgrupp","EDIT_THESIS_COMMITTEE":"Redigera uppf\xf6ljningsgrupp","YOUR_USER_ACCOUNT_NEEDS_TO_BE_ACTIVATED":"Ditt anv\xe4ndarkonto m\xe5ste aktiveras innan du kan skapa din f\xf6rsta rapport. Innan ditt konto kan aktiveras m\xe5ste du <0>bjuda in alla uppf\xf6ljningsgruppmedlemmar</0> i Thessa.","YOU_WILL_RECEIVE_AN_EMAIL_WHEN_YOUR_ACCOUNT":"Du kommer att f\xe5 ett e-postmeddelande n\xe4r ditt konto har aktiverats.","ESTIMATE_MADE_ON":"Uppskattning gjord","PHD_PROJECT_STATUS":"Framskridande","TIME_SPENT_PERIOD":"Period","PRELIMINARY_TITLE_OF_DISSERTATION":"Avhandlingens prelimin\xe4ra namn","EDIT_PRELIMINARY_TITLE_OF_DISSERTATION":"Redigera avhandlingens prelimin\xe4ra namn","CREATE_PRELIMINARY_TITLE_OF_DISSERTATION":"L\xe4gg till prelimin\xe4r titel f\xf6r avhandlingen","SUBJECT_OR_STUDENT":"\xc4mne eller student","APPLICATION_SENT":"Ans\xf6kan skickad","PLANNING_TO_APPLY":"Planerar att ans\xf6ka","CREDITS_one":"{{count}} studiepo\xe4ng","CREDITS_other":"{{count}} studiepo\xe4ng","CR":"{{count}} sp","WHAT_WAS_DECIDED":"Vad best\xe4mdes?","ROLE_NAME":{"key":"value","doctoral-candidate":"Doktorand","coordinating-academic":"Ansvarsperson","main-supervisor":"Huvudhandledare","supervisor":"Handledare","thesis-committee-member":"Uppf\xf6ljningsgruppmedlem","salary-system-foreman":"F\xf6rman","coordinator":"Koordinator"},"CHECK_REPORT_STATUS":"Kontrollera rapportstatus.","CHECK_SUPERVISION_PLAN_STATUS":"Kontrollera handledningsplanens status.","CHECK_NEXT_THESIS_COMMITTEE_MEETING_REPORT_STATUS":"Doktoranden har inte skickat in rapporten","SEARCH_BY":"S\xf6k enligt {{keyword}}","COMPLETE_THE_REPORT_FORM":"Fyll i rapporteringsblanketten och skicka in rapporten","CONCLUSION_CAN_BE_WRITTER_AFTER":"Slutsatsen kan skrivas efter att rapporten har l\xe4mnats in.","YES":"Ja","NO":"Nej","PLEASE_INVITE_TCMS_TO_THESSA":"Bjud in alla medlemmar i din uppf\xf6ljningsgrupp till Thessa.","COORDINATOR_TOOLS":{"key":"value","MAIN_HEADING":"Verktyg","HEADINGS":{"key":"value","MANAGE_USERS":"Anv\xe4ndare","STATISTICS":"Statistik","OTHER":"\xd6vrig"},"TOOLS":{"key":"value","LATEST_REPORTS":"Senaste rapporterna","INCOMPLETE_REPORTS":"Ofullst\xe4ndiga rapporter","ADMIN_REPORT":"Thessas adminrapport","IMPORT_SUPERVISOR_RELATIONSHIPS":"Importera handledningsrelationer"},"DESCRIPTIONS":{"key":"value","DOCTORAL_CANDIDATES":"Hantera doktorander","USERS":"Hantera alla anv\xe4ndare","REPORT_CONCLUSIONS_OVERVIEW":"Se rapportslutsats f\xf6r varje doktorand","LATEST_REPORTS":"Se senaste rapportens status f\xf6r varje doktorand","INCOMPLETE_REPORTS":"Se doktorander och handledare med ofullst\xe4ndiga rapporter","ADMIN_REPORT":"Exportera information om doktorander till CSV","IMPORT_SUPERVISOR_RELATIONSHIPS":"Fr\xe5n Excel till Thessa"}},"SHOW_ALL_DOCTORAL_CANDIDATES":"Visa alla doktorander","HIDE_INACTIVE_DOCTORAL_RESEARCHERS":"D\xf6lj inaktiva doktorander","DOCTORAL_RESEARCHER_OVERVIEW":"Doktorandens \xf6versikt","LAST_COMPLETED_REPORT":"Senast f\xe4rdig rapport","FILTER_DOCTORAL_RESEARCHERS":"Filtrera doktorander","SUPERVISOR_RELATIONSHIP_OVERVIEW":{"key":"value","IF_MISSING":"Om en ansvarspersonen eller handledare saknas p\xe5 listan eller om det har skett \xe4ndringar i handledningsarrangemangen, v\xe4nligen kontakta <0>{{supportEmail}}</0>."},"THESIS_COMMITTEE_MEMBERS":{"key":"value","SUPERVISORS_ARE_HANDLED_BY_OTHERS":"Handledarinformationen hanteras av din fakultets doktorandtj\xe4nster och ditt doktorandprograms planerare. Kontaktuppgifter finns i","LINK":"https://studies.helsinki.fi/instruktioner/artikel/service-doktorander","LINK_TITLE":"instruktioner f\xf6r studerande","INVITATION_HEADING":"Bjud in uppf\xf6jningsgruppmedlemmar","INVITATION_HEADING_FOR_SUPERVISORS":"Bjud in handledare","INVITATION_LABEL":"Uppf\xf6ljningsgruppmedlems e-postadress","INVITATION_LABEL_FOR_SUPERVISORS":"Handledares e-postadress"},"CONTACT":{"HEADING":"Kontakta oss","CONTACT_TEXT_PREFIX":"Kontakta","CONTACT_TEXT_SUFFIX":" om du har n\xe5gra fr\xe5gor om hur du anv\xe4nder Thessa eller om du st\xf6ter p\xe5 tekniska problem, till exempel med att logga in p\xe5 Thessa eller acceptera en inbjudan.","UNIHELP_URL":"https://uni-help.helsinki.fi/sv","UNIHELP_URL_TITLE":"HelsinkiUni Help"},"DATE_RANGE_PICKER":{"INVALID_START_DATE":"Startdatumet \xe4r inte ett giltigt datum.","INVALID_END_DATE":"Slutdatumet \xe4r inte ett giltigt datum.","INVALID_END_IS_BEFORE_START":"Slutdatumet m\xe5ste vara efter startdatumet."},"COORDINATOR_DOCTORAL_CANDIDATES":{"PLACEHOLDER":"Doktorandprogram eller studentnummer","LABEL":"S\xf6k p\xe5 doktorandprogram eller studentnummer","ACTION":"S\xf6k"},"END_OF_SENTENCE_PERIOD":".","RESOURCES":{"INTRO_VIDEO":"LF7j_ITOYTw"},"MENU":"Meny","FRONTPAGE":"Framsida","OPEN_PROFILE_MENU":"\xd6ppna profilmenyn","CLOSE_PROFILE_MENU":"St\xe4ng profilmenyn","OPEN_MAIN_MENU":"\xd6ppna huvudmenyn","CLOSE_MAIN_MENU":"St\xe4ng huvudmenyn","CHANGE_LANGUAGE":"\xc4ndra spr\xe5k","PROFILE_MENU":"Profilmenyn","MAIN_MENU":"Huvudmenyn","FOOTER_MENU":"Sidfot-meny","DATE_NOT_SPECIFIED":"Datum ej specificat","EMAIL_OR_USER_INPUT":{"HINT":"En giltig e-postadress kr\xe4vs, eller v\xe4lj en anv\xe4ndare fr\xe5n f\xf6rslag"},"FORM":{"REQUIRED_FIELD":"Obligatoriskt","OPTIONAL_FIELD":"Valfritt","VALID_EMAIL_ADDRESS_REQUIRED":"Ange en giltig e-postadress","PASSWORD_REQUIREMENTS":"Minsta l\xe4ngd 10 tecken","VALID":"Giltig","INVALID":"Ogiltig","OPTIONAL":"Valfri","COMPLETE_FIELDS_TO_SAVE_FORM":"Observera att alla f\xe4lt m\xe5ste fyllas i f\xf6r att kunna spara formul\xe4ret.","COMPLETE_FIELDS_TO_SUBMIT_FORM":"Observera att alla f\xe4lt m\xe5ste fyllas i f\xf6r att kunna skicka in formul\xe4ret.","CONFIRM_CANCEL":"\xc4r du s\xe4ker p\xe5 att du vill sluta redigera? Osparade \xe4ndringar kommer att g\xe5 f\xf6rlorade."},"INVITATION_ROLE":{"YOUR_ROLE":"Din roll","COORDINATING_ACADEMIC":"en samordnande akademiker","MAIN_SUPERVISOR":"en huvudhandledare","SUPERVISOR":"en handledare","THESIS_COMMITTEE_MEMBER":"en uppf\xf6ljningsgruppmedlem"},"EDIT_PUBLICATION":"Redigera publikation","EDIT_SALARY":"Redigera l\xf6n","EDIT_GRANT":"Redigera stipendium","EDIT_COURSE_WORKSHOP":"Redigera kurs/workshop","EDIT_THESIS_INSTRUCTION":"Redigera instruktion f\xf6r examensarbetet","EDIT_TEACHING":"Redigera undervisning","FOR_STUDENT":"f\xf6r student","CREATE_NEW_REMINDER":"Skapa ny p\xe5minnelse","LOGO_OF_UNIVERSITY_OF_HELSINKI":"Helsingfors universitets logotyp","NEW":"Ny","CHANGED":"\xc4ndrats","INDICATOR":"indikator","STATUS_IN_THE_MOST_RECENT":"Status i den senaste rapporten","DETAILS_WITH_LABEL":"Detaljer: {{ label }}","ADD_PUBLICATION":"L\xe4gg till publikation","ADD_COURSE":"L\xe4gg till studieavsnitt","EDIT_NOTES":"Redigera <0>anteckningar</0>","CANCEL_EDITING_NOTES":"Avbryt <0>redigering av anteckningar</0>","SAVE_NOTES":"Spara <0>anteckningar</0>","SEND_MESSAGE":"Skicka meddelande","REMOVE_COMMENT":"Ta bort kommentar","REPORT_VIEW":{"ERROR":{"MISSING_REPORT":"Rapporten saknas.","FAILED_TO_SAVE_REPORT":"<0>Det gick inte att spara rapporten.</0> Kontrollera rapportformul\xe4ret f\xf6r fel och f\xf6rs\xf6k igen, eller <1>kontakta oss</1>.","FAILED_TO_SUBMIT_REPORT":"<0>Det gick inte att skicka rapporten f\xf6r granskning.</0> Kontrollera rapportformul\xe4ret f\xf6r fel och f\xf6rs\xf6k igen, eller <1>kontakta oss</1>.","FAILED_TO_DELETE_REPORT":"<0>Det gick inte att ta bort rapporten.</0> F\xf6rs\xf6k igen eller <1>kontakta oss</1>."}},"PHD_PROJECT":{"ERROR":{"GENERAL_ERROR_HEADING":"Ett fel har intr\xe4ffat i Thessa.","YOU_CAN_RETRY_OR":"Du kan prova att uppdatera sidan men om det inte hj\xe4lper","INCLUDE_THIS_TEXT":"V\xe4nligen inkludera denna text i ditt e-postmeddelande","CANNOT_INITIALIZE":"Det gick inte att ladda doktorandprojektdetaljer fr\xe5n servern."}},"CANCEL_INVITING_THESIS_COMMITTEE_MEMBER":"Avbryt inbjudande uppf\xf6ljningsgruppmedlem","INFORMATION":"Information","COMMENT":"Kommentar","WRITE_YOUR_COMMENT_HERE":"Skriv din kommentar h\xe4r","HIDE_DISCUSSION":"D\xf6lj diskussion","SHOW_DISCUSSION":"Visa diskussion","VIEW_SUPERVISION_PLAN":"Visa handledningsplan","ADD_COURSE_WORKSHOP":"L\xe4gg till kurs/workshop","ADD_THESIS_INSTRUCTION":"L\xe4gg till instruktion f\xf6r examensarbetet","UNTITLED":"Namnl\xf6s","UNTITLED_PUBLICATION":"Namnl\xf6s publikation","UNTITLED_SALARY":"Namnl\xf6s l\xf6n","UNTITLED_GRANT":"Namnl\xf6st stipendium","UNTITLED_TEACHING":"Namnl\xf6s undervisning","REMOVAL_CONFIRMATION":"Bekr\xe4fta borttagning","THESSA_INTRODUCTION_VIDEO":"Thessa introduktionsvideo","ACCESSIBILITY_STATEMENT":"Tillg\xe4nglighetsutl\xe5tande","INFORMATION_ON_THE_ACCESSIBILITY_OF_THE_WEBSITE":"Information om webbplatsens tillg\xe4nglighet","LAST_UPDATED":"Senast uppdaterad","YOU_WILL_NOT_BE_ABLE_TO_ACCESS":"Du kan inte komma \xe5t Thessa eftersom ditt konto har st\xe4ngts.","REQUEST_ACCOUNT_REACTIVATION":"Skicka oss ett e-postmeddelande om du vill forts\xe4tta anv\xe4nda Thessa.","REMINDER":"P\xe5minnelse","BACK_TO_STATISTICS":"Tillbaka till statistik","BACK_TO_USER_DETAILS":"Tillbaka till anv\xe4ndardetaljer","FOR_EXAMPLE":"Till exempel","DOWNLOAD":{"DOWNLOAD":"Ladda ner","DOWNLOAD_CSV_FILE":"Ladda ner CSV-fil","DOWNLOAD_EXCEL_FILE":"Ladda ner Excel-fil"},"PLEASE_SELECT_ONE_OF_THE_FOLLOWING_TYPES":"V\xe4nligen v\xe4lj en av f\xf6ljande typer","PLEASE_SELECT_YOUR_ROLE_IN_THE_CONFERENCE":"V\xe4nligen v\xe4lj din roll i konferensen","PLEASE_NOTE_YOU_HAVE_THE_OPTION_TO_SAVE":"Observera att du har m\xf6jlighet att spara dina framsteg n\xe4r som helst, \xe4ven om inte alla obligatoriska f\xe4lt \xe4r ifyllda. Kom ih\xe5g att \xe5terv\xe4nda och fylla i all saknad information innan slutlig inl\xe4mning.","DURATION_OF_TEACHING":"Undervisningens varaktighet","CURRENT":"Aktuell","UPCOMING":"Kommande","SITEMAP":"Webbplatskarta","UPON_LOGGING_IN":"N\xe4r du loggar in kommer denna webbplatskarta att uppdateras automatiskt f\xf6r att \xe5terspegla de sidor och funktioner som \xe4r tillg\xe4ngliga f\xf6r dig baserat p\xe5 din roll i Thessa.","OVERVIEW_OF_ALL_SITE_PAGES":"\xd6versikt \xf6ver alla webbplatsens sidor f\xf6r enkel navigering och snabb \xe5tkomst till inneh\xe5ll.","UPDATED":"Uppdaterad","PLEASE_FILL_OUT_ALL_REQUIRED_FIELDS":"V\xe4nligen fyll i alla obligatoriska f\xe4lt.","PLEASE_FILL_OUT_ALL_REQUIRED_FIELDS_AND_DATES":"V\xe4nligen fyll i alla obligatoriska f\xe4lt och datum.","PLEASE_ENTER_VALID_DATES":"V\xe4nligen ange giltiga datum.","IS_MISSING":"saknas","THE_VALUE_ENTERED_IS_INVALID":"Det angivna v\xe4rdet \xe4r ogiltigt","CLOSE":"St\xe4ng","CHOOSE":"V\xe4lj","SUBMITTING_FORM_FAILED":"Det gick inte att skicka formul\xe4ret.","TRANSCRIPT_OF_THESSA_INTRODUCTION_VIDEO":"Transkript av Thessa introduktionsvideo","INTRODUCTION_TO_USING_THESSA_FOR_DOCTORAL":"Introduktion till att anv\xe4nda Thessa f\xf6r doktorander","CHOOSE_LANGUAGE_FROM_THE_LANGUAGE_NAVIGATION":"V\xe4lj spr\xe5k fr\xe5n spr\xe5knavigeringen","AFTER_LOGGING_IN":"Efter att du har loggat in kommer du att landa p\xe5 hemsidan som kallas \\"Mitt doktorandprojekt\\" sida, som best\xe5r av avsnitt f\xf6","SUPERVISION_PLANS_ARE_CREATED_BY_YOUR_SUPERVISORS":"Handledningsplaner skapas av dina handledare. Du kommer att f\xe5 ett e-postmeddelande n\xe4r dina handledare har skapat en ny handledningsplan f\xf6r dig. F\xf6r att signera planen, klicka p\xe5 l\xe4nken i e-postmeddelandet, och klicka sedan p\xe5 \\"Acceptera planen\\"-knappen p\xe5 handledningsplansidan.","PLANS_FOR_YOUR_PHD_PROJECT":"Planer f\xf6r ditt doktorandprojekt","PLANS_FOR_YOUR_PHD_PROJECT_ARE_CREATED_BY_YOU":"Planer f\xf6r ditt doktorandprojekt skapas av dig. Dessa planer inneh\xe5ller information om dina publikationer, konferenser, kurser och andra aktiviteter relaterade till ditt doktorandprojekt.","REPORTS_ARE_CREATED_BY_YOU_AND_INCLUDE_INFORMATION":" Rapporter skapas av dig och inneh\xe5ller information om dina framsteg i ditt doktorandprojekt. De kan sparas som utkast och skickas in n\xe4r du \xe4r redo.","YOUR_SUPERVISORS_ARE_ADDED_AUTOMATICALLY":"Dina handledare l\xe4ggs till automatiskt. Du kan se vilka dina handledare \xe4r och deras kontaktinformation.","YOU_CAN_SEE_INFORMATION_ABOUT_YOUR_THESIS_COMMITTEE":"Du kan se information om medlemmarna i din uppf\xf6ljningsgrupp. Medlemmar i uppf\xf6ljningsgruppen m\xe5ste bjudas in manuellt genom att navigera till uppf\xf6ljningsgruppens sida.","DIGITAL_SERVICE_ACCESSIBILITY_STATUS":"Tillg\xe4nglighetsstatus f\xf6r digital tj\xe4nst","GENERAL_SECTIONS_AND_FEATURES_THAT_ARE_NOT_ACCESSIBLE":"Allm\xe4nna avsnitt och funktioner som inte \xe4r tillg\xe4ngliga","SERVICES_FOR_DOCTORAL_RESEARCHERS_THAT_ARE_NOT_ACCESSIBLE":"Tj\xe4nster f\xf6r doktorander som inte \xe4r tillg\xe4ngliga","SERVICES_FOR_SUPERVISORS_THAT_ARE_NOT_ACCESSIBLE":"Tj\xe4nster f\xf6r handledare som inte \xe4r tillg\xe4ngliga","SERVICES_FOR_COORDINATORS_THAT_ARE_NOT_ACCESSIBLE":"Tj\xe4nster f\xf6r koordinatorer som inte \xe4r tillg\xe4ngliga","NOT_WITHIN_THE_SCOPE_OF_LEGISLATION":"Inte inom lagstiftningens omfattning","ACCESSIBILITY_FEEDBACK":"Tillg\xe4nglighetsfeedback","SUPERVISORY_AUTHORITY":"Tillsynsmyndighet","CONTACT_INFORMATION_OF_THE_REGULATOR":"Kontaktinformation f\xf6r tillsynsmyndigheten","REGULATOR":"Transport- och kommunikationsverket Traficom","ACCESSIBILITY_CONTROL_UNIT":"Enheten f\xf6r tillsyn \xf6ver digital tillg\xe4nglighet","TEL_SWITCHBOARD":"V\xe4xel","PERCEIVABLE":"M\xf6jlig att uppfatta","OPERABLE":"Hanterbar","UNDERSTANDABLE":"Begriplig","ROBUST":"Robust","ACCESSIBILITY_OF_THESSA":"Tillg\xe4nglighet i Thessa","THIS_ACCESSIBILITY_STATEMENT_APPLIES":"Detta tillg\xe4nglighetsutl\xe5tande g\xe4ller <0>Thessa-tj\xe4nsten f\xf6r Helsingfors universitet</0>","THE_SERVICE_IS_SUBJECT_TO_THE_LAW":"Tj\xe4nsten omfattas av lagen om att tillhandah\xe5lla digitala tj\xe4nster, vilken kr\xe4ver att offentliga n\xe4ttj\xe4nster m\xe5ste vara tillg\xe4ngliga. Vi har sj\xe4lva bed\xf6mt tj\xe4nstens tillg\xe4nglighet.","THE_ACCESSIBILITY_STATEMENT_HAS_BEEN_CREATED_ON":"Tillg\xe4nglighetsutl\xe5tandet har skapats den {{ createdDate }} och senast uppdaterats den {{ lastUpdatedDate }}.","INFO_AND_RELATIONSHIPS":"WCAG 1.3.1: Information och relationer","ERROR_IDENTIFICATION":"CAG 3.3.1: Identifiering av fel","ON_INPUT":"WCAG 3.2.2: Vid inmatning","TIMING_ADJUSTABLE":"WCAG 2.2.1: Justerbar tidsgr\xe4ns","USE_OF_COLOR":"WCAG 1.4.1: Anv\xe4ndning av f\xe4rger","CONTRAST_MINIMUM":"WCAG 1.4.3: Kontrast (minimum)","PARSING":"WCAG 4.1.1: Parsing","NAME_ROLE_VALUE":"WCAG 4.1.2: Namn, roll, v\xe4rde","STATUS_MESSAGES":"WCAG 4.1.3: Statusmeddelanden","THE_THESSA_SERVICE_OF_THE_UNIVERSITY_OF_HELSINKI_MEETS":"Helsingfors universitets tj\xe4nst Thessa uppfyller de flesta tillg\xe4nglighetskraven p\xe5 A- och AA-niv\xe5 (WCAG-2.1). De uppt\xe4ckta bristerna i tillg\xe4ngligheten beskrivs n\xe4rmare nedan. Det str\xe4vas efter att \xe5tg\xe4rda dessa brister i samband med underh\xe5llet av den digitala tj\xe4nsten. L\xe4s mer om <0>tillg\xe4nglighet vid Helsingfors universitet.</0>","DATA_TABLES_ARE_NOT_PROGRAMMATICALLY_DISPLAYED":"Information som presenteras i tabeller \xe4r inte automatiskt angiven i tabellformat","THE_INFORMATION_ON_THE_CONFERENCES_AND_MOBILITY":"Informationen i delen konferens och mobilitet p\xe5 sidan Mitt doktorandprojekt \xe4r inte automatiskt angiven i tabellformat","FORMS_DO_NOT_SUFFICIENTLY_GUIDE_USERS_ON_INCORRECT":"Formul\xe4ren ger inte anv\xe4ndaren tillr\xe4cklig v\xe4gledning vid felaktig eller ofullst\xe4ndig inmatning av information","THE_SUBMISSION_BUTTONS_IN_THE_FORMS_FOR_SUPERVISION":"Knapparna f\xf6r att skicka formul\xe4ren p\xe5 sidorna f\xf6r handledningsplanen och rapporter \xe4r ur bruk om formul\xe4ren \xe4r ofullst\xe4ndigt eller felaktigt ifyllda","A_FORM_DOES_NOT_DISPLAY_THE_SUBMISSION_BUTTON":"Formul\xe4ret visar inte knappen f\xf6r att skicka in formul\xe4ret","THE_SUBMISSION_BUTTON_FOR_THE_PROGRESS_FEEDBACK":"Knappen f\xf6r att skicka in framstegsfeedback i samband med rapporten visas f\xf6rst i f\xf6rhandsgranskningsl\xe4get, och \xe4r annars dold f\xf6r anv\xe4ndaren","TITLES_HAVE_NOT_BEEN_USED_TO_PARSE_CONTENT":"Rubriker har inte anv\xe4nts f\xf6r att strukturera inneh\xe5llet","THE_TITLES_ON_THE_OVERVIEW_OF_CONCLUDING_STATEMENTS":"Rubriker har inte anv\xe4nts f\xf6r att strukturera inneh\xe5llet p\xe5 sidan Rapport \xf6versikt \xf6ver slutsatser.","THE_DISTINCTIVENESS_OF_LINKS_FROM_OTHER_TEXT_AND_FOCUS":"L\xe4nkar urskiljs fr\xe5n annan text endast med hj\xe4lp av f\xe4rger och fokusstilarna f\xf6rlitar sig endast p\xe5 f\xe4rger","IN_THE_COORDINATOR_SERVICES_THE_DISTINCTIVENESS":"P\xe5 flera sidor i koordinatortj\xe4nsterna kan urskiljningen av l\xe4nkar fr\xe5n annan text samt interaktiva elements fokusstilar f\xf6rlita sig endast p\xe5 f\xf6r\xe4ndringar i f\xe4rg","THE_CONTRAST_RATIO_OF_TEXT_ELEMENTS_COMPARED":"Textelementens kontrastv\xe4rde \xe4r f\xf6r l\xe5gt i f\xf6rh\xe5llande till bakgrunden","THE_CONTRAST_RATIO_OF_TEXT_ELEMENTS_ON_THE":"Textelementen p\xe5 sidan Rapport \xf6versikt \xf6ver slutsatser har f\xf6r l\xe5gt kontrastv\xe4rde i f\xf6rh\xe5llande till bakgrunden","THE_SUBMISSION_BUTTON_IN_THE_FORM_FOR_ADDING_SUPERVISORS":"Knappen f\xf6r att skicka formul\xe4ret f\xf6r att l\xe4gga till en handledare p\xe5 sidan Doktorander \xe4r ur bruk om formul\xe4ret \xe4r ofullst\xe4ndigt eller felaktigt ifyllt","BUTTONS_HAVE_NO_VISIBLE_OR_PROGRAMMATIC_TEXT":"Knapparna saknar b\xe5de synlig och programmerad text","THE_SUPERVISOR_FORM_ON_THE_DOCTORAL_RESEARCHERS_PAGE":"Formul\xe4ret Handledare p\xe5 sidan Doktorander har knappar som saknar b\xe5de synlig och programmerad text","SCREEN_READERS_DO_NOT_AUTOMATICALLY":"Sk\xe4rml\xe4sarprogram presenterar inte automatiskt meddelanden om status","ON_THE_DOCTORAL_RESEARCHERS_AND_LIST_THE_REVIEWERS":"Sidorna Doktorander och Lista granskare av ej f\xe4rdigst\xe4llda rapporter presenterar inte automatiskt meddelanden om status","NOT_COVERED_BY_LEGISLATION":"Inneh\xe5ll som inte omfattas av lagstiftningens krav \xe4r","CONTENT_PUBLISHED_BY_USERS_OR_OTHER_THIRD_PARTIES":"Inneh\xe5ll som publiceras i tj\xe4nsten av anv\xe4ndare eller andra utomst\xe5ende akt\xf6rer, och som inte produceras, finansieras eller \xf6vervakas av tj\xe4nsteleverant\xf6ren","CONTENT_PUBLISHED_BY_USERS_THAT_CANNOT":"Det kan f\xf6rekomma inneh\xe5ll p\xe5 webbplatsen som publicerats av anv\xe4ndarna och som inte kan \xe4ndras s\xe5 att de uppfyller tillg\xe4nglighetskraven. Inneh\xe5ll som publicerats av anv\xe4ndarna har inte heller programmerats att anv\xe4nda samma spr\xe5k som inneh\xe5llet.","THE_USER_IS_LOGGED_OUT_AUTOMATICALLY_WHEN_THE_SESSION":"Anv\xe4ndaren loggas ut automatiskt n\xe4r sessionen g\xe5r ut","THE_WEBSITE_LOGS_THE_USER_OUT_AUTOMATICALLY_WHEN":"Webbplatsen loggar ut anv\xe4ndaren automatiskt n\xe4r sessionen g\xe5r ut. Anv\xe4ndaren varnas inte innan sessionen g\xe5r ut och det finns inget s\xe4tt att f\xf6rl\xe4nga sessionen eller st\xe4nga av tidsgr\xe4nsen","DID_YOU_NOTICE_AN_ACCESSIBILITY_ISSUE_IN":"Har du uppt\xe4ckt bristande tillg\xe4nglighet i v\xe5r digitala tj\xe4nst? Meddela oss per e-post s\xe5 g\xf6r vi v\xe5rt b\xe4sta f\xf6r att \xe5tg\xe4rda bristen.","IF_YOU_NOTICE_ACCESSIBILITY_ISSUES_ON":"Om du uppt\xe4cker tillg\xe4nglighetsproblem p\xe5 webbplatsen, ge respons till oss som \xe4r webbansvariga. Det kan dr\xf6ja 14 dagar innan du f\xe5r ett svar. Om du inte \xe4r n\xf6jd med det svar du har f\xe5tt eller inte f\xe5r n\xe5got svar alls inom tv\xe5 veckor <0>kan du l\xe4mna in en anm\xe4lan om bristande tillg\xe4nglighet till Transport- och kommunikationsverket Traficom</0>. P\xe5 Traficom webbplats beskrivs i detalj hur du kan l\xe4mna in en anm\xe4lan och hur \xe4rendet behandlas.","PAGINATION":"Sidindelning","GO_TO_PAGE":"G\xe5 till sida","AMOUNT_OF_ITEMS_PER_PAGE":"Antal objekt per sida","THERE_WAS_AN_ERROR_IN_LOADING_SUPERVISION_PLANS":"<0>Det uppstod ett fel vid inl\xe4sningen av handledningsplaner.</0> V\xe4nligen <1>meddela oss</1> om problemet inte f\xf6rsvinner.","PHD_PROJECT_LIST":{"ERROR_DELETE_FAILED":"Raderingen misslyckades."},"CAREER_COUNSELLING":{"OPEN_CAREER_COUNSELLING":"<0>G\xe5 igenom karri\xe4rr\xe5dgivningsfr\xe5gor</0>","TITLE":"Karri\xe4rv\xe4gledning","INITIAL_PHASE":{"TITLE":"I b\xf6rjan av processen","MOTIVATION_AND_GOALS":"<0>Motivation och m\xe5l:</0> Varf\xf6r skriver jag en doktorsavhandling? Vilka f\xf6rv\xe4ntningar har jag p\xe5 avhandlingsprocessen? Vad intresserar mig inom mitt forskningsomr\xe5de?","INTEGRATION_INTO_THE_ACADEMIC_COMMUNITY":"<0>Engagemang i den akademiska gemenskapen:</0> Vilken \xe4r min akademiska gemenskap?","MY_COMMUNITY_AND_FUTURE":"<0>Mina gemenskaper och framtiden:</0> Vilket \xe4r mitt forskningssamh\xe4lle utanf\xf6r universitetet? Hur borde jag bygga upp mitt n\xe4tverk under avhandlingsprocessen?"},"MIDDLE_PHASE":{"TITLE":"I mitten av processen","MOTIVATION_AND_GOALS":"<0>Motivation och m\xe5l:</0> Hur ter sig orsakerna till att jag skriver doktorsavhandlingen i det h\xe4r skedet av processen? Har mina anledningar till att skriva en doktorsavhandling f\xf6r\xe4ndrats? Har mina m\xe5l f\xf6r\xe4ndrats? Hur k\xe4nns avhandlingsprocessen?","SKILLS_AND_DEVELOPMENT_NEEDS":"<0>Kunskaper och utvecklingsbehov:</0> Vad tycker jag s\xe4rskilt mycket om i arbetet med doktorsavhandlingen? Vad har jag l\xe4rt mig hittills? Var finns det behov f\xf6r utveckling? Vem h\xe5ller jag p\xe5 att bli?","MY_COMMUNITY_AND_FUTURE":"<0>Mina gemenskaper och framtiden:</0> Vem inspirerar mig? Vem kan ge mig svar p\xe5 mina fr\xe5gor om karri\xe4ren? Var finns det intresse f\xf6r \xe4mnet/fenomenet i min doktorsavhandling? Hur skaffar jag mig kunskap och insikt om samt erfarenhet av andra kontexter?"},"FINAL_PHASE":{"TITLE":"I slutet av processen","MY_SKILLS_AND_STRENGTHS":"<0>Mina kunskaper och styrkor:</0> Vad \xe4r jag bra p\xe5? Finns det kompetensomr\xe5den som intresserar mig, men som jag \xe4nnu inte f\xe5tt pr\xf6va p\xe5?","MY_COMMUNITY_AND_FUTURE":"<0>Mina gemenskaper och framtiden:</0> Vem inspirerar mig? Vem kan ge mig svar p\xe5 mina fr\xe5gor om karri\xe4ren? Var finns det intresse f\xf6r \xe4mnet/fenomenet i min doktorsavhandling? Hur skaffar jag mig kunskap och insikt om samt erfarenhet av andra kontexter?","PROFESSIONAL_LIFE_CAREER_PLANNING_AND_LIFESTYLE":"<0>Arbetsliv, karri\xe4rplanering och livsstil i f\xf6rh\xe5llande till alternativen:</0> Vad \xe4r viktigt f\xf6r mig i mitt arbete? Hurdana teman och hurdan verksamhet vill jag arbeta med? Vilka v\xe4rderingar vill jag f\xf6rverkliga i mitt arbete och i min verksamhet? Hur och var f\xe5r jag min utkomst?"},"ASSIGNMENT":{"CONSIDER_QUESTIONS":"Reflektera fr\xe5gorna ovan f\xf6re n\xe4sta m\xf6te med uppf\xf6ljningsgruppen. Ni kan behandla de viktigaste fr\xe5gorna p\xe5 det s\xe4tt och p\xe5 den niv\xe5 ni vill p\xe5 m\xf6tet. Ni beh\xf6ver inte g\xe5 igenom alla fr\xe5gor.","THESIS_PHASE_BASED_ON_REPORT":"Baserat p\xe5 <0>din senaste rapport</0> \xe4r ditt doktorandprojekt uppskattningsvis <1>{{phdCompletionPercentage}}%</1> f\xe4rdigt. D\xe4rf\xf6r kommer ditt kommande m\xf6te att fokusera p\xe5 fr\xe5gor relaterade till den <1>{{thesisPhase}}</1>.","THESIS_PHASE":{"INITIAL_PHASE":"b\xf6rjan av processen","MIDDLE_PHASE":"mitten av processen","FINAL_PHASE":"slutet av processen"}}},"THESIS_COMMITTEE":{"BACK_TO_THESIS_COMMITTEE":"Tillbaka till uppf\xf6ljningsgruppen","CHANGE_DATE":"\xc4ndra datum","CHOOSE_DATE":"V\xe4lj datum","ADD":"L\xe4gg till m\xf6te","NO_MEETINGS":"Inga m\xf6ten","CHOOSE_FIRST_MEETING_DATE":"V\xe4lj datum f\xf6r f\xf6rsta uppf\xf6ljningsgruppens m\xf6te","CONTINUE_MEETING":"Forts\xe4tt m\xf6tet","END_MEETING":"Spara och avsluta m\xf6tet","END_MEETING_NOTIFICATION":"Observera att du har m\xf6jlighet att spara m\xf6tesinformationen, \xe4ven om inte alla obligatoriska f\xe4lt \xe4r ifyllda. N\xe4r du har avslutat ett m\xf6te permanent kan du inte l\xe4ngre redigera m\xf6tesinformationen.","ERROR_MEETING_ALREADY_COMPLETED":"M\xf6tet har redan avslutats.","ERROR_MISSING_DATE":"V\xe4lj m\xf6tesdatum innan du sparar.","ERROR_REPORT_NOT_FOUND":"Rapport hittades inte.","FAST_DOCTORAL_CANDIDATE_MEETING_EVERY_N_MONTHS":"Pilot, m\xf6te var {{n}} m\xe5nader","FIRST_MEETING":"F\xf6rsta uppf\xf6ljningsgruppens m\xf6te","MEETING":"Uppf\xf6ljningsgruppens m\xf6te","MEETINGS":"M\xf6ten","THESIS_COMMITTEE_MEETINGS":"Uppf\xf6ljningsgruppens m\xf6ten","MEETING_AGENDA":"F\xf6reslagen dagordning","MEETING_AGENDA_NOT_FOUND":"F\xf6reslagen dagordning hittades inte","MEETING_COMPLETED_AT":"H\xf6lls den {{date}}","MEETING_DATE":"M\xf6tesdatum","MEETING_DATE_IN_PAST":"M\xf6tesdatum ligger i det f\xf6rflutna","MEETING_DATE_MISSING":"Datum ej valt","MEETING_EVERY_N_MONTHS":"M\xf6te var {{n}} m\xe5nader","MEETING_LATE_NOTIFICATION_FOR_COORDINATOR":"M\xf6te f\xf6rsenat","MEETING_LATE_NOTIFICATION_FOR_SUPERVISOR":"Senast m\xf6te var \xf6ver {{n}} m\xe5nader sedan","MEETING_LATE_NOTIFICATION_FOR_DOCTORAL_CANDIDATE":"Det har g\xe5tt \xf6ver sex m\xe5nader sedan det senaste m\xf6tet och inget nytt m\xf6te \xe4r schemalagt. Schemal\xe4gg ett nytt m\xf6te snart.","MEETING_LATE_NOTIFICATION_FOR_THESIS_COMMITTEE_MEMBERS":"Det har g\xe5tt \xf6ver sex m\xe5nader sedan det senaste m\xf6tet och inget nytt m\xf6te \xe4r schemalagt. Doktoranden b\xf6r schemal\xe4gga ett nytt m\xf6te s\xe5 fort som m\xf6jligt.","MEETING_NOTES":"M\xf6tesanteckningar","MEETING_NOTES_ALERT":"M\xf6tesanteckningar kan inte vara tom.","MEETING_NOTES_INSTRUCTIONS":"Skriv en sammanfattning av m\xf6tet som t\xe4cker viktiga punkter, beslut och \xf6verenskomna \xe5tg\xe4rder.","MEETING_PLANNED_FOR":"Planerat till {{date}}","MEETINGS_AND_REPORTS":"M\xf6ten och rapporter","NEXT_MEETING_ON_DATE":"N\xe4sta m\xf6te den {{date}}","NO_FIRST_MEETING_DATE_YET":"Datum f\xf6r f\xf6rsta m\xf6te \xe4r \xe4nnu inte valt","NO_NEXT_MEETING_DATE_YET":"Datum f\xf6r n\xe4sta m\xf6te \xe4r \xe4nnu inte valt","NOT_SCHEDULED":"N\xe4sta m\xf6te har inte schemalagts","OPEN_REPORT_FOR_MEETING":"\xd6ppna rapporten i en ny flik","REPORT_EVERY_N_MONTHS":"Rapport var {{n}} m\xe5nader","REPORT_FOR_MEETING":"Rapport f\xf6r m\xf6tet","REPORT_FOR_MEETING_MISSING":"Rapport saknas","SET_MEETING_DATE":"Spara m\xf6tesdatumet f\xf6r att fastst\xe4lla deadline f\xf6r rapportinl\xe4mning","SUBMIT_A_REPORT":"L\xe4mna en rapport mellan <0>{{ startDate }}\u2013{{ endDate }}</0>","REPORT_FOR_MEETING_READY":"En rapport \xe4r redo att diskuteras p\xe5 m\xf6tet","NOTE_REPORT_SUBMISSION_DATE":"Observera att rapporten l\xe4mnades in <0>{{ submittedAt }}</0>, vilket \xe4r utanf\xf6r inl\xe4mningsperioden <0>{{ startDate }}\u2013{{ endDate }}</0>. Rapporten kan inneh\xe5lla f\xf6r\xe5ldrad information","REPORT_WAS_DISCUSSED":"En rapport diskuterades p\xe5 m\xf6tet","START_MEETING":"Starta m\xf6tet","TITLE":"Uppf\xf6ljningsgrupp","VIEW":"Visa uppf\xf6ljningsgrupp","VIEW_MEETING":"Visa m\xf6tet","ADDING_MEETING_FAILED_WITH_ERROR_CODE":"M\xf6tet kunde inte l\xe4ggas till med felkod","UPDATING_MEETING_FAILED_WITH_ERROR_CODE":"M\xf6tet kunde inte uppdateras med felkod","DELETING_MEETING_FAILED_WITH_ERROR_CODE":"M\xf6tet kunde inte tas bort med felkod","MOVING_MEETING_FAILED_WITH_ERROR_CODE":"M\xf6tet kunde inte flyttas med felkod","PROGRESS_ESTIMATION_MISSING":"Ingen framsteg","ESTIMATE_YOUR_PROGRESS":"V\xe4nligen uppskatta dina framsteg mot doktorsexamen","PROGRESS_FASTER":"G\xe5r snabbare \xe4n v\xe4ntat","PROGRESS_EXPECTED":"G\xe5r som v\xe4ntat","PROGRESS_SLOWER":"G\xe5r l\xe5ngsammare \xe4n v\xe4ntat","SUPPORT_FEEDBACK":"Vilken typ av st\xf6d eller f\xf6r\xe4ndringar skulle hj\xe4lpa dig att uppr\xe4tth\xe5lla eller f\xf6rb\xe4ttra dina framsteg?","CONFIRM_ENDING_MEETING_TITLE":"Bekr\xe4fta m\xf6tets avslutning","CONFIRM_ENDING_MEETING_OPTION":"Jag f\xf6rst\xe5r att n\xe4r jag avslutar m\xf6tet permanent kan jag inte l\xe4ngre redigera m\xf6tesuppgifterna","MEETING_STATUS":"M\xf6tets status","MEETING_DONE":"Gjort","MEETING_DRAFT":"Utkast"},"ATTACHMENT":{"TITLE":"Bilagor","ADD":"L\xe4gg till bilaga","ADD_NEW":"L\xe4gg till ny bilaga","ADD_TO_REPORT_INFO":"Bifogad fil l\xe4ggs till i ditt doktorandprojekt och markeras som en del av rapporten. Bilagan kan inte redigeras eller tas bort efter\xe5t.","REPORT_INFO":"Markera bilagan i doktorandprojekt som en del av den h\xe4r rapporten. Bilagan kan inte \xe4ndras eller tas bort efter\xe5t.","UPLOADING":"Ladda upp bilaga","ADDING_ATTACHMENT_FAILED_WITH_ERROR_CODE":"Bilaga kunde inte l\xe4ggas med felkod","DELETING_ATTACHMENT_FAILED_WITH_ERROR_CODE":"Bilaga kunde inte tas bort med felkod","NO_ATTACHMENTS":"Inga bilagor","FILE":"Bifogad fil","NAME":"Bifogad fil namn","DATE_ADDED":"Datum tillagt","NOT_AVAILABLE":"Bilagan \xe4r inte tillg\xe4nglig","SIZE":"Storlek","IN_REPORT":"I rapport","REPORT_NOTICE":"Du kan hantera gamla bilagor i en rapport. Anv\xe4nd det nya avsnittet Bilagor ovan f\xf6r att ladda upp och bifoga nya bilagor till din rapport.","ALREADY_ATTACHED_TO_REPORT":"Tillh\xf6r en tidigare rapport"},"SUPERVISION_PLAN_TITLE_NO_END_DATE":"Giltig fr\xe5n {{startDate}}","SUPERVISION_PLAN_HEAD_TITLE":"Handledningsplan {{startDate}} - {{endDate}}","SUPERVISION_PLAN_HEAD_TITLE_NO_END_DATE":"Handledningsplan fr\xe5n {{startDate}}","SUPERVISION_PLAN_EXPIRED_SHORT":"Inte giltig","SUPERVISION_PLAN_IS_VALID_UNTIL_DATE":"Giltig till {{date}}","TO_UPLOAD_AN_EXCEL_FILE":"F\xf6r att ladda upp en Excel-fil m\xe5ste den inneh\xe5lla kolumner f\xf6r studentnummer och handledares e-postadresser. Varje rad ska representera en enskild doktorand. N\xe4r filen \xe4r klar och korrekt formaterad, anv\xe4nd uppladdningsknappen ovan f\xf6r att skicka Excel-filen.","NEED_A_TEMPLATE_FOR_THE_EXCEL_FILE":"Beh\xf6ver du en mall f\xf6r Excel-filen? Ladda ner en exempel fil och anv\xe4nd den genom att f\xf6lja dessa steg:","DOWNLOAD_THE_SAMPLE_EXCEL_FILE":"<0>Ladda ner exempel Excel-fil:</0> Klicka p\xe5 l\xe4nken nedan f\xf6r att ladda ner exempel Excel-filen. Denna fil har kolumnerna och en exempelsrad.","FILL_IN_THE_DATA":"<0>Fyll i uppgifterna:</0> \xd6ppna den nedladdade filen och skriv in studentnummer och handledares e-postadresser i de angivna kolumnerna. Varje rad ska representera en enskild doktorand. L\xe4gg till nya rader om fler doktorander beh\xf6ver inkluderas.","SAVE_AND_UPLOAD_THE_FILE":"<0>Spara och ladda upp filen:</0> N\xe4r uppgifterna har fyllts i, spara filen p\xe5 datorn i .xlsx-format. \xc5terv\xe4nd sedan till denna sida och anv\xe4nd uppladdningsknappen ovan f\xf6r att skicka Excel-filen.","SAMPLE_EXCEL_FILE":"Ladda ner exempel Excel-fil","VALIDITY":"Giltighet","COPY_DECISIONS_TO_NEW_PLAN":"Kopiera beslut till ny plan","COPY_DECISIONS_FROM_A_PREVIOUS_PLAN":"Kopiera beslut fr\xe5n en tidigare plan","PREVIEW_OF_THE_SUPEVISION_PLAN_FOR":"F\xf6rh\xe4ndsgranskning av handledningsplanen f\xf6r {{name}}","SELECT_A_PREVIOUS_SUPERVISION_PLAN_TO_COPY_FROM":"V\xe4lj en tidigare handledningsplan att kopiera fr\xe5n","PLEASE_NOTE_THAT_SUPERVISION_PLANS_MAY_CONTAIN":"Observera att handledningsplaner kan inneh\xe5lla k\xe4nslig information, s\xe5som forskningsdetaljer och personuppgifter.","DOCTORAL_CANDIDATE_PARTICIPATES_IN_THE_DOCTORAL_EDUCATION_PILOT":"Doktorand tillh\xf6r pilotf\xf6rs\xf6ket med doktorandutbildning","DOCTORAL_EDUCATION_PILOT_PARTICIPANT":"Doktorandutbildning pilotdeltagare","CHAPTER":"Period","CHAPTERS":"Perioder","CHAPTERS_AND_MILESTONES":"Perioder och Milstolpar","CURRENT_CHAPTER":"Aktuell period","COMPLETED_CHAPTER":"avslutad period","COMPLETED_CHAPTER_other":"avslutade perioderna","MILESTONE":"Milstolpe","MILESTONES":"Milstolpar","PERSONAL_MILESTONE":"Personlig milstolpe","PERSONAL_MILESTONES":"Personliga milstolpar","COMMON_MILESTONE":"Allm\xe4n milstolpe","COMMON_MILESTONES":"Allm\xe4nna milstolpar","ADD_PERSONAL_MILESTONE":"L\xe4gg till personlig milstolpe","EDIT_PERSONAL_MILESTONE":"Redigera personlig milstolpe","ADD_COMMON_MILESTONE":"L\xe4gg till ett allm\xe4nt m\xe5l","EDIT_COMMON_MILESTONE":"Redigera allm\xe4nt m\xe5l","STARTING":"Startar","STARTED":"Startade","PLANNED":"Planerad","ESTIMATED":"Uppskattas","STARTED_FROM_GRANTING_STUDY_RIGHT":"Startade <0>{{ date }}</0> fr\xe5n beviljandet av studier\xe4tt","STARTED_AT_THE_THESIS_COMMITTEE_MEETING_HELD_ON":"Startade vid uppf\xf6ljningsgruppen som h\xe5lls den <0>{{ date }}</0>","BEGIN_AT_THE_THESIS_COMMITTEE_MEETING_HELD_ON":"B\xf6rjar vid uppf\xf6ljningsgruppen som h\xe5lls den <0>{{ date }}</0>","BEGIN_AT_THE_MEETING_ESTIMATED_TO_BE_HELD_ON":"B\xf6rjar vid uppf\xf6ljningsgruppen h\xe5llas den <0>{{ date }}</0>","EACH_CHAPTER_REPRESENTS_THE_TIME_PERIOD":"Varje perioden representerar tidsperioden mellan tv\xe5 m\xf6te med uppf\xf6ljningsgruppen.","OVERVIEW":"\xd6versikt","NO_MILESTONES_IN_THE_PLAN_FOR_THE_CHAPTER_YET":"Inga milstolpar i planen f\xf6r perioden \xe4nnu.","VIEW_CHAPTERS":"Visa perioder","EDIT_MILESTONES":"Redigera milstolpar","CUSTOM_MILESTONES_CREATED_BY_THE_USER":"Anpassade milstolpar skapade av anv\xe4ndaren. Du kan l\xe4gga till s\xe5 m\xe5nga personliga milstolpar du vill och tilldela dem till vilket period som helst.","A_PREDEFINED_SET_OF_MILESTONES_THAT_MUST_BE_ASSIGNED":"En f\xf6rdefinierad upps\xe4ttning milstolpar, som var och en m\xe5ste placeras i en period.","STUDY_RIGHT_GRANTED":"Studier\xe4tt beviljad","ADD_ITEM":"L\xe4gg till objekt <0>i period {{ id }}</0>","ITEM":"objekt","ITEM_other":"objekten","MILESTONE_DESCRIPTION":"Milstolpens beskrivning","MOVE":"Flytta","OPEN_CONTEXT_MENU":"\xd6ppna kontextmenyn f\xf6r \\"{{ milestone }}\\" milstolpe","CONTEXT_MENU":"Kontextmeny","SET_AS_COMPLETED":"S\xe4tt som f\xe4rdigt","COMMON":"Allm\xe4n","PERSONAL":"Personlig","ADDING_MILESTONE_FAILED_WITH_ERROR_CODE":"Milstolpen kunde inte l\xe4ggas till med felkod","UPDATING_MILESTONE_FAILED_WITH_ERROR_CODE":"Milstolpen kunde inte uppdateras med felkod","DELETING_MILESTONE_FAILED_WITH_ERROR_CODE":"Milstolpen kunde inte tas bort med felkod","MOVING_MILESTONE_FAILED_WITH_ERROR_CODE":"Milstolpen kunde inte flyttas med felkod","PRESSING_ENTER_ON_THE_KEYBOARD_WILL_ADD_THE_MILESTONE":"Tryck p\xe5 Enter p\xe5 tangentbordet f\xf6r att l\xe4gga till milstolpen.","ALL_COMMON_MILESTONES_HAVE_BEEN_ASSIGNED_TO_CHAPTERS":"Alla allm\xe4nna milstolpar har tilldelats perioderna","NO_COMMON_MILESTONES_AVAILABLE":"Inga allm\xe4nna milstolpar tillg\xe4ngliga","INPUT_EXCEEDS_THE_CHARACTER_LIMIT":"Indata \xf6verskrider {{ maxLength }} tecken","FILE_INPUT_EXCEEDS_THE_FILE_SIZE_LIMIT":"Filen \xf6verskrider den maximala till\xe5tna storleken p\xe5 {{ maxSizeMB }}\u202FMB","UNASSIGNED_COMMON_MILESTONES":"F\xf6ljande allm\xe4nna milstolpar anges inte f\xf6r n\xe5got period","UNASSIGNED_COMMON_MILESTONES_AMOUNT":"{{ amount }} allm\xe4nna milstolpar anges inte f\xf6r n\xe5got period","MOVE_TO_NEXT_CHAPTER":"Flytta till n\xe4sta period","MOVE_TO_PREVIOUS_CHAPTER":"Flytta till f\xf6reg\xe5ende period","RETURN":"Tillbaka","USE_OF_GENERATIVE_ARTIFICIAL_INTELLIGENCE_IN_RESEARCH":"Riktlinjer f\xf6r anv\xe4ndning av generativ artificiell intelligens","AI_RESEARCH":"Riktlinjer f\xf6r anv\xe4ndning av generativ artificiell intelligens inom forskning \u2013 Helsingfors universitet","ARTIFICIAL_INTELLIGENCE_AI_SCIENCE":"Artificial Intelligence (AI) in Science \u2013 European Commission","IS_IN_PILOT":"Doktorand deltar i pilotprogrammet f\xf6r snabb doktorsexamen","LATEST_PROGRESS_ESTIMATION":"Senaste bed\xf6mningen av doktorsexaminens framsteg","NO_ACTIVE_STUDY_RIGHT":"Ingen aktiv studier\xe4tt","CONSORTIUM":"Konsortium","NEXT_STEPS":{"TITLE":"N\xe4sta steg","INTRO":{"CYCLIC":"Ett uppf\xf6ljningsgruppsm\xf6te h\xe5lls en g\xe5ng om \xe5ret, och en rapport f\xf6rbereds inf\xf6r varje m\xf6te.","FAST":"Ett uppf\xf6ljningsgruppsm\xf6te h\xe5lls tv\xe5 g\xe5nger om \xe5ret, och en rapport f\xf6rbereds inf\xf6r varje m\xf6te.","LEGACY":"En rapport l\xe4mnas in en g\xe5ng om \xe5ret."},"TIMING":{"SUBMISSION_WINDOW":"Skicka in den mellan {{startDate}} och {{endDate}} s\xe5 att den kan behandlas p\xe5 uppf\xf6ljningsgruppsm\xf6tet.","SUBMISSION_WINDOW_OBSERVER":"Rapporten b\xf6r skickas in mellan {{startDate}} och {{endDate}} s\xe5 att den kan behandlas p\xe5 uppf\xf6ljningsgruppsm\xf6tet.","MEETING_DATE":"M\xf6tet \xe4r planerat att h\xe5llas {{date}}.","REPORT_DEADLINE":"Skicka in den ungef\xe4r en vecka f\xf6re uppf\xf6ljningsgruppsm\xf6tet {{date}}, men senast p\xe5 m\xf6tesdagen.","REPORT_DEADLINE_OBSERVER":"Rapporten b\xf6r skickas in ungef\xe4r en vecka f\xf6re uppf\xf6ljningsgruppsm\xf6tet {{date}}, men senast p\xe5 m\xf6tesdagen.","REPORT_BEFORE_MEETING":"Skicka in den ungef\xe4r en vecka f\xf6re uppf\xf6ljningsgruppsm\xf6tet.","REPORT_BEFORE_MEETING_OBSERVER":"Rapporten b\xf6r skickas in ungef\xe4r en vecka f\xf6re uppf\xf6ljningsgruppsm\xf6tet."},"REPORT":{"SUBMIT_STUDENT":"Skicka in en rapport d\xe4r du beskriver hur ditt doktorandprojekt framskrider.","SUBMIT_OBSERVER":"Doktoranden beh\xf6ver skicka in sin rapport.","CONCLUSION_STUDENT":"Skriv en avslutning f\xf6r rapporten utifr\xe5n det som diskuterades p\xe5 uppf\xf6ljningsgruppsm\xf6tet.","CONCLUSION_OBSERVER":"Doktoranden skriver en avslutning f\xf6r rapporten utifr\xe5n det som diskuterades p\xe5 uppf\xf6ljningsgruppsm\xf6tet.","FEEDBACK_REMINDER":"En rapport har nyligen slutf\xf6rts \u2014 det \xe4r dags att ge feedback om framsteg.","SUBMIT_LABEL":"Skicka in rapport","CONCLUSION_LABEL":"Skriv avslutning"},"MEETING":{"PLAN_STUDENT":"Boka ditt n\xe4sta uppf\xf6ljningsgruppsm\xf6te.","PLAN_OBSERVER":"Ett uppf\xf6ljningsgruppsm\xf6te b\xf6r bokas.","ATTEND_STUDENT":"H\xe5ll ditt uppf\xf6ljningsgruppsm\xf6te. G\xe5 igenom hur ditt doktorandprojekt framskrider med hj\xe4lp av din rapport.","ATTEND_OBSERVER":"P\xe5 uppf\xf6ljningsgruppsm\xf6tet diskuteras doktorandens framsteg och rapport.","ATTEND_LATE_STUDENT":"Ditt uppf\xf6ljningsgruppsm\xf6te \xe4r f\xf6rsenat. H\xe5ll det nu.","ATTEND_LATE_OBSERVER":"Uppf\xf6ljningsgruppsm\xf6tet \xe4r f\xf6rsenat och b\xf6r h\xe5llas.","LATE_STUDENT":"Det har g\xe5tt \xf6ver {{months}} m\xe5nader sedan det senaste m\xf6tet och inget nytt m\xf6te \xe4r bokat. Boka ett nytt m\xf6te nu.","LATE_OBSERVER":"Det har g\xe5tt \xf6ver {{months}} m\xe5nader sedan det senaste m\xf6tet och inget nytt m\xf6te \xe4r bokat. Doktoranden b\xf6r boka ett nytt m\xf6te nu.","SCHEDULE_LABEL":"Boka m\xf6te","ATTEND_LABEL":"H\xe5ll m\xf6te"}},"REPORTING":{"TITLE":"Rapportering"},"COURSE":{"NOT_EDITABLE":"Studieavsnittet \xe4r importerat fr\xe5n Sisu och kan d\xe4rf\xf6r inte redigeras i Thessa"}}');

});

parcelRegister("d525V", function(module, exports) {
module.exports = JSON.parse('{"key":"value","SUPPORT_EMAIL":"uni-help@helsinki.fi","ABOUT":"About","THESSA":"Thessa","THESSA_IS_THE_DOCTORAL_STUDIES":"Thessa is the doctoral studies planning and reporting tool for University of Helsinki.","ALL_KINDS_OF_FEEDBACK_AND_ERRO":"All kinds of feedback and error reports are much appreciated.","RIGHTS_OBLIGATIONS_AND_RESPON":"Rights, Obligations and Responsibilities in Doctoral Training at the University of Helsinki","PROBLEMS_LOGGING_IN":"Problems logging in?","IF_YOU_FORGOT_YOUR_PASSWORD_Y":"If you forgot your password, you can","RESET_IT":"reset it","SEND_PASSWORD_RESET_LINK_TO_MY":"Send password reset link to my email","EMAIL_FOR_THESSA_ACCOUNT":"Email for Thessa account","SEND":"Send","BACK_TO_LOGIN":"Back to login","BACK_TO_MY_PHD_PROJECT":"Back to My PhD project","MESSAGE_SENT_CHECK_YOUR_EMAIL":"Message sent. Check your email inbox and open the link in the password reset email.","TOO_MANY_PASSWORD_RESET_REQUES":"Too many password reset requests.","TOO_MANY_PASSWORD_RESET_ATTEMPTS":"Too many attempts to save a new password. Wait fifteen minutes before trying again.","WAIT_FIVE_MINUTES_BEFORE_TRYIN":"Please wait fifteen minutes before trying again. If the problem continues, <0>contact us</0> for more help.","HELPDESK":"contact IT-Helpdesk.","YOU_MAY_RESET_YOUR_PASSWORD":"try changing your password.","SOMETHING_WENT_WRONG":"Something went wrong.","TRY_AGAIN_LATER":"Please try again later. If the problem continues, <0>contact us</0> for more help.","NO_NETWORK_CONNECTION":"No network connection","RIGHTS_OBLIGATIONS_AND_RESPON1":"Rights, Obligations and Responsibilities in Doctoral Training at the University of Helsinki","ABOUT_THESSA":"About Thessa","THE_DOCTORAL_STUDIES_PLANNING":"The doctoral studies planning and reporting tool.","EMAIL":"Email","PASSWORD":"Password","LOG_IN":"Log in","LOGIN_WAS_NOT_SUCCESSFUL":"Login was not successful.","CHECK_USERNAME_AND_PASSWORD_I":"Check username and password. If that doesn\'t help, find more help from","CHECK_USERNAME_AND_PASSWORD_I1":"Check username and password. If that doesn\'t help,","TOO_MANY_FAILED_LOGIN_ATTEMPTS":"Too many failed login attempts.","WAIT_FIVE_MINUTES_BEFORE_TRYIN1":"Wait fifteen minutes before trying again. Check username and password. If that doesn\'t help, find more help from","YOU_NEED_AN_INVITATION_OR_AN_A":"You need an invitation or an active doctoral study right to access Thessa.","YOUR_EMAIL_ADDRESS_IS_ALREADY":"Your email address is already in use by someone in Thessa.","HINT_USE_UNIVERSITY_LOGIN":"You\u2019re using a <0>helsinki.fi</0> email address. Please log in with your university account above.","CONTACT_US":"Contact us","CONTACT_US1":"contact us","CONTACT_US_END_OF_SENTENCE":"contact us.","FOR_HELP_WITH_THIS_ERROR":"for help with this error.","LOG_IN_PAGE":{"UNIVERSITY_STAFF_OR_STUDENTS":"University of Helsinki students and staff","OTHERS":"Log in with Thessa account"},"LOGIN_FAILED_WITH_ERROR_CODE":"Login failed with error code","LOGIN_FAILED_PASSWORD_MUST_BE_RESET":"Log in failed because you need to change your password first. Please use","LOGIN_FAILED_USE_UNIVERSITY_LOGIN":"Log in with your University of Helsinki account instead of email and password.","PASSWORD_RESET_REFUSED_USE_UNIVERSITY_LOGIN":"Password cannot be reset for this account. Use University of Helsinki account to log in.","FORGOT_PASSWORD_PAGE":"forgot password page","TO_CHANGE_YOUR_PASSWORD":"to change your password.","USE_YOUR_UNIVERSITY_OF_HELSINK":"Use your University of Helsinki username and password to log in.","FORGOT_PASSWORD":"Forgot password?","LOG_IN_WITH_OIDC":"Log in with University of Helsinki account","RESET_PASSWORD":"Reset password","NEW_PASSWORD":"New password","SAVE_PASSWORD":"Save password","CANCEL":"Cancel","PASSWORD_SET_REDIRECTING_YOU":"Password set. Redirecting you","INSIDE":"inside","THERE_WERE_PROBLEMS_WITH_SAVIN":"There were problems with saving the password:","SIGN_UP_TO_THESSA":"Sign up to Thessa","IF_YOU_HAVE_A_UNIVERSITY_OF_HE":"If you have a University of Helsinki account, use its username and password in the login form above. All students and employees have an account.","MON":"Mon","TUE":"Tue","WED":"Wed","THU":"Thu","FRI":"Fri","SAT":"Sat","SUN":"Sun","LOADING_WITH_ELLIPSIS":"Loading\u2026","YOU_MAY_USE":"You may use","MARKDOWN":"Markdown","ITALICS":"*italics*","BOLD":"**bold**","LINKS_HTTPS":"[links](https://...)","HEADINGS":"# headings","LISTS":"- lists","AND_MORE":"and more.","THESSA_FOR":"Thessa for","UNIVERSITY_OF_HELSINKI":"University of Helsinki","PRIVACY_POLICY":"Privacy policy","ASK_FOR_HELP_AND_GIVE_FEEDBACK":"Ask for help and give feedback","TOGGLE_NAVIGATION":"Toggle navigation","LOG_OUT":"Log out","LOGIN":"Login","REMINDERS1":"Reminders","PROFILE1":"Profile","HELP1":"Help","MY_PHD_PROJECT":"My PhD project","MY_DOCTORAL_CANDIDATES":"My doctoral researchers","DOCTORAL_CANDIDATES1":"Doctoral researchers","USERS1":"Users","QUEUE1":"Queue","STATISTICS1":"Statistics","LEFT":"left","BOTTOM":"bottom","ARE_YOU_SURE":"Are you sure?","CONFIRM_DELETE":"Yes, remove","THANKS":"Thanks!","YOU_CAN_GIVE_MORE_FEEDBACK_HER":"You can give more feedback here:","SEND_FEEDBACK":"Send feedback","PAGE_HEADER":"Page Header","HEADING":"Heading 1","HEADING1":"Heading 2","HEADING2":"Heading 3","HEADING3":"Heading 4","HEADING4":"Heading 5","HEADING5":"Heading 6","LEAD_TEXT":"Lead text","BODY_TEXT":"Body text","SMALL_TEXT":"Small text","LABEL":"Label 1","LABEL1":"Label 2","LABEL2":"Label 3","CHECK":"Check 1","CHECK1":"Check 2","SUBMIT":"Submit","SAVE":"Save","TOGGLE":"Toggle","CALENDAR":"calendar","OK":"ok","REMOVE":"remove","CLEAR":"Clear","SUBMITTED":"Submitted","CONCLUSION_MISSING":"Conclusion missing","GIVE_FEEDBACK":"Give feedback","DEFAULT":"Default","RIGHT":"Right","LEFT1":"Left","CALL_TO_ACTION":"Call to action","SECONDARY":"Secondary","ACTION":"Action","ACTIONS":"Actions","STUDENT_NUMBER":"Student number","NAME":"Name","ACCOUNT":"Account","NO_ACCOUNT":"No account","NO_SUPERVISORS_IN_OODI":"No supervisors in Oodi","STUDY_RIGHT_START_DATE":"Study right start date","RECENT":"RECENT","COORDINATOR_QUEUE":"Coordinator Queue","LOADING_INACTIVE_USERS":"Loading inactive users...","THERE_WAS_AN_ERROR_IN_LOADING":"There was an error in loading inactive users.","PLEASE":"Please","TRY_AGAIN":"try again","LET_US_KNOW":"let us know","IF_THE_PROBLEM_DOES_NOT_GO_AWA":"if the problem does not go away.","INACTIVE_USER":"Inactive user","TYPE":"Type","N_A":"N/A","NO_COURSES_IN_PLAN_YET":"No study units planned.","ADD":"Add","BUTTON_ABOVE":"button above!","TITLE":"Title","COURSES_TOTAL_one":"{{count}} study unit","COURSES_TOTAL_other":"{{count}} study units","CREDITS":"Credits","CREDITS_ABBREVIATED":"Cr","CREDITS_COMPLETED":"{{completedCredits}} cr completed","CREDITS_PLANNED":"{{plannedCredits}} cr not completed","CREDITS_TOTAL":"{{totalCredits}} cr total","STATUS":"Status","COMPLETED":"Completed","COMPLETED_AT":"Completed at","TO_BE_COMPLETED_AT":"To be completed at","COURSE_UNIT_CODE":"Study unit code","COURSE_UNIT_CODE_MISSING":"Not available","FAILED_TO_CREATE_COURSE":"Failed to save to studies.","CHANGED_SINCE_LAST_OPENED":"Changed since last opened","REPORT":{"NEXT_REPORT_BY_DATE":"Next report is due by {{date}}","REPORT":"Report","REPORT_LATE_NOTIFICATION_FOR_SUPERVISOR":"Previous report was over {{n}} months ago","REPORT_STATUS":"Report status","REPORT_STATUS_DRAFT":"Draft","REPORT_STATUS_SUBMITTED":"Submitted for review","REPORT_STATUS_FINAL":"Done","NOT_SUBMITTED":"This report has not been submitted for review","THESIS_COMMITTEE_MEETING_NOT_HELD":"Meeting not held","THESIS_COMMITTEE_MEETING_INSTRUCTIONS":"Hold a thesis committee meeting to conclude the report","THESIS_COMMITTEE_MEETING_LEGACY_INSTRUCTIONS":"Hold a thesis committee meeting and write the conclusions by opening the report","REPORTING_PERIOD_WHILE_EDITING_LEGACY":"Reporting period starts on {{reportingPeriodStart}} and ends when you save the conclusion from the thesis committee meeting in Thessa.","REPORTING_PERIOD_WHILE_EDITING":"Reporting period starts on {{reportingPeriodStart}} and ends when you conclude the thesis committee meeting in Thessa.","REPORTING_PERIOD_DATES":"{{reportingPeriodStart}}\u2013{{reportingPeriodEnd}}","REPORTING_PERIOD_STARTING_FROM":"From {{reportingPeriodStart}} onwards","FEEDBACK_DUE_TAG":"Progress feedback due"},"SUPERVISION_PLAN":"Supervision plan","SUPERVISION_PLAN_other":"Supervision plans","MY_DOCTORAL_CANDIDATES1":"My Doctoral Researchers","LOADING_DOCTORAL_CANDIDATES":"Loading doctoral researchers...","FAILED_TO_LOAD_DOCTORAL_CANDID":"Failed to load doctoral researchers. You can try reloading the page. If the error persists, please contact Thessa support.","MISSING_DOCTORAL_CANDIDATES":"Missing doctoral researchers?","TO_SEE_YOUR_DOCTORAL_CANDIDATE":"To see your doctoral researchers in Thessa, make sure they sign up to Thessa and invite you to become a supervisor or a thesis committee member for them.","YOU_WILL_GET_THE_INVITATION_BY":"You will get the invitation by email. Accept it to get access to your doctoral researchers.","HIDE":"Hide","SHOW":"Show","CLOSED_ACCOUNTS":"closed accounts","RELATIONSHIP":"Relationship","PROGRESS":"Progress","YOU_HAVE_NO_DOCTORAL_CANDIDATE":"You have no doctoral researchers in Thessa.","NO_DOCTORAL_CANDIDATES":"No doctoral researchers.","YOUR_USER_ACCOUNT_NEEDS_TO_BE":"Your user account needs to be activated before you can create your first report. Before your account can be activated, you need to","INVITE_ALL_YOUR_SUPERVISORS_AN":"invite all your supervisors and thesis committee members","IN_THESSA":"in Thessa.","YOU_WILL_RECEIVE_AN_EMAIL_WHEN":"You will receive an email when your account has been activated.","INVITE_SUPERVISORS":"Invite supervisors","THERE_ARE_NO_SUPERVISION_PLANS":"There are no supervision plans so far.","DOCTORAL_CANDIDATE_AND_SUPERVI":"Doctoral researcher and supervisors agree to follow a supervision plan that will define the co-operation of the doctoral researcher and supervisors. The plan is created using a supervisor\'s account and then signed by the doctoral researcher and supervisors.","SUPERVISORS":"Supervisors","LOADING_NEXT_REPORT_DUE_DATE":"Loading next report due date...","NEXT_REPORT_DUE_ON":"Next report due on","PERIOD":"Period","PUBLICATIONS":"Publications","COURSES":"Studies","GRADUATION":"Graduation","CONCLUSION":"Conclusion","DRAFT":"Draft","OPEN":"Open","MISSING":"Missing","HAVE_A_THESIS_COMMITTEE_MEETIN":"Have a thesis committee meeting and write the conclusions by opening the report.","REPORTS":"Reports","LOADING_REPORTS":"Loading reports...","NO_REPORTS_YET":"No reports yet","VIEW_CUMULATIVE_REPORT":"View cumulative report","THESSA_IS_IN_MAINTENANCE":"Thessa is in maintenance","PLEASE_WAIT_A_FEW_MINUTES_AND":"Please wait a few minutes and <0>reload the page</0>","PAGE_NOT_FOUND":"Page not found","SORRY_THE_PAGE_YOU_OPENED_CAN":"Sorry, the page you opened cannot be found. Try the","FRONT_PAGE_INSTEAD":"front page instead","ADD_GRANT":"Add grant","ADD_SALARY":"Add salary","SALARIES":"Salaries","GRANTS":"Grants","NO_SALARIES_IN_PLAN_YET":"No salaries in plan yet.","NO_SALARIES":"No salaries.","NO_GRANTS_IN_PLAN_YET":"No grants in plan yet.","NO_GRANTS":"No grants.","SOURCE":"Source","AMOUNT":"Amount","FOR_MONTHS":"For months","USED_FOR":"Used for","NOT_GRANTED":"Not granted","GRANTED":"Granted","FOR_DATES":"For dates","HELP_MORE_GUIDES_LINK_PREFIX":"Go to","HELP_MORE_GUIDES_LINK_URL":"https://studies.helsinki.fi/instructions/article/thessa","HELP_MORE_GUIDES_LINK_LINK_TEXT":"Instructions for students","HELP_MORE_GUIDES_LINK_SUFFIX":"to get more help regarding Thessa.","TRY_TO_INCLUDE_AS_MUCH_DETAI":"Try to include as much details about your issue with your email. Thessa is in active development and any help in the form of feedback of error reports is much appreciated.","IF_YOU_NEED_MORE_HELP_PLEASE":"If you need more help, please don\'t hesitate to","INVITE":"Invite","S_EMAIL_ADDRESS":"{{roleName}}\'s email address","INVITE_TO_YOUR_PHD_PROJECT_IN":"Invite to your PhD project in Thessa","INVITATION_SUBMITTED":"Invitation submitted","SUBMITTING_INVITATION_FAILED":"Submitting invitation failed","YOU_ARE_INVITED":"You are invited to Thessa","WHAT_IS_THESSA":"What is Thessa?","ALL_DOCTORAL_CANDIDATES_AND_TH":"All doctoral researchers and their supervisors and thesis committee members can use it.","WELCOME_TO_THESSA":"Welcome to Thessa!","YOU_ARE_NOT_CONNECTED_TO_ANYON":"You are not connected to anyone.","ASK_YOUR_DOCTORAL_CANDIDATES_T":"Ask your doctoral researchers to send you an invitation from their Thessa.","OTHERWISE_IT_S_GOING_TO":"Otherwise it\'s going to be lonely in here.","NO_NOTES":"No notes.","EDIT":"Edit","SAVING":"Saving...","UPDATE_ANNUAL_REPORTS":"Update: Annual reports","ANNUAL_REPORTS_SECTION_HAS_BEE":"Annual reports section has been updated to show report\'s status and requested actions more clearly.","UPDATE_CUMULATIVE_REPORT":"Update: Cumulative report","CUMULATIVE_REPORT_VIEW_SHOWS_A":"Cumulative report view shows all of your reports at the same time making it easier to grasp the full picture. Press \\"View cumulative report\\" button in the annual reports section to open it.","UPDATE_REVIEWING_REPORTS":"Update: Reviewing reports","CUMULATIVE_REPORT":"Cumulative report","YOU_CAN_NOW_SEE_THE_CUMULATIVE":"You can now see the cumulative report when reviewing.","COMMENTING_REPORT":"Commenting report","DISCUSS_REPORTS":"Discuss reports.","NEW_IMPROVEMENTS":"New improvements!","INVITE_SUPERVISORS_AND_THESIS":"Invite Supervisors and Thesis committee members using email addresses.","DISCUSS_IN_SIMPLIFIED_ANNUAL_R":"Discuss in simplified Annual Report Review.","REPORTS_ARE_CLOSED_BY_WRITING":"Reports are closed by writing the \\"Conclusions and Recommendations\\".","READ_MORE_FROM_HELP_PAGE":"Read more from help page.","SET_OF_DECISIONS_BETWEEN_DOCTO":"Set of decisions between doctoral researcher and supervisor to make sure PhD project makes smooth progress.","KEEPING_TRACK_OF_FUTURE_PLANS":"Keeping track of future plans for advancing studies, publications and other things related to doctoral researcher\'s PhD.","A_SNAPSHOT_OF_PHD_PROJECT_IT":"A snapshot of PhD project. It is created once per year to help communication between doctoral researcher and supervisor.","START_USING_THESSA":"Start using Thessa!","WE_RECOMMEND_THAT_YOU_START_US":"We recommend that you start using Thessa by creating a supervision plan. Contact your supervisor to create it.","THEN_YOU_SHOULD_UPDATE_YOUR_PH":"Then you should update your PhD project plans in Thessa to make them clearly visible to you and your supervisor. You may start this right now as well!","YOU_CAN_FIND_MORE_DETAILS_ABOU":"You can find more details about Thessa from the Help section in the main menu.","IF_YOU_FIND_BUGS_OR_ERRORS_IN":"If you find bugs or errors in Thessa, or have an idea about how to make it better,","DROP_AN_EMAIL_TO_US":"drop an email to us","YOUR_DOCTORAL_CANDIDATES_WILL":"Your doctoral researchers will soon link their Thessa accounts with yours. After that, we recommend that you start using Thessa by creating a supervision plan for your doctoral researchers. Create it together with your account and then everyone will sign it with their Thessa account.","REMOVE1":"Remove","INTERNATIONAL_ACTIVITIES":{"TYPE":{"CONFERENCE":"Conference","RESEARCH_VISIT":"Research visit","OTHER":"Other"},"PARTICIPATION_TYPE":{"PARTICIPANT_POSTER":"Participation with poster","PARTICIPANT_TALK":"Participation with talk","PARTICIPANT_WITHOUT_PRESENTATION":"Participation without presentation","ORGANISER":"Organiser"}},"CONFERENCES_AND_MOBILITY":"Conferences and mobility","LOCATION":"Location","DATE":"Date","DATES":"Dates","LOADING_CONFERENCES_AND_MOBILI":"Loading conferences and mobility...","NO_CONFERENCES_OR_MOBILITY_PLA":"No conferences or mobility planned.","ADD_CONFERENCE_OR_MOBILITY":"Add conference or mobility","FAILED_TO_CREATE_CONFERENCE_OR_MOBILITY":"Failed to create conference or mobility.","DELETE":"Delete","REALLY_CANCEL_INVITATION":"Really cancel invitation?","KEEP_INVITATION":"Keep invitation","CANCEL_INVITATION":"Cancel invitation","INVITATION_EXPIRED":"Invitation expired","INVITED_NOT_YET_RESPONDED":"Invited, not yet responded","FIRST_NAME":"First name","LAST_NAME":"Last name","EMAIL_ADDRESS":"Email address","SAVED":"Saved","REALLY_REMOVE":"Really remove?","THE_LAST_MEMBER_CANNOT_BE_REMO":"The last member cannot be removed.","RESEND_INVITATION":"Resend invitation","INVITATION_TO_BECOME_A":"Invitation to become a","FOR":"for","EXPIRES_ON":"Expires on","THIS_INVITATION_HAS_EXPIRED_Y":"This invitation has expired. You can request a new one from doctoral researcher","ACCEPT":"Accept","DECLINE":"Decline","DUE_TO_DATA_MIGRATION_THESSA":"Due to data migration, Thessa doesn\'t know the start date of this status. Please select the correct date below and save publication.","NO_PUBLICATIONS_IN_PLAN_YET":"No publications in plan yet.","TOPIC_OR_TITLE":"Topic or title","EDIT_REMINDER":"Edit reminder","LOADING_YOUR_REMINDERS":"Loading your reminders","NEW_REMINDER":"New reminder","UPCOMING_REMINDERS":"Upcoming reminders","PAST_REMINDERS":"Past reminders","NO_REMINDERS":"No reminders","DUE":"Due","SEND_REMINDERS_TO":"Send reminders to","REMINDER_TIMING":"Reminder timing","DAYS_BEFORE_DUE_DATE":"days before due date","CREATE_REPORT":"Create report","YOUR_ACCOUNT_IS_INACTIVE_THER":"Your account is inactive, therefore you cannot create a report yet.","YOUR_DOCTORAL_PROGRAMME_S_STAF":"Your doctoral programme\'s staff will activate the account for you once they have checked your profile.","OPEN_REPORT":"Open report","OPEN_MEETING":"Open meeting","SUMMARIZE_THE_REPORTING_PERIOD":"Summarize the reporting period","AS_AN_OVERVIEW_OF_THE_REPORTIN":"As an overview of the reporting period, list three positive and three negative things about it.","PHD_PROJECT_PAGE":"PhD project page","PUBLICATIONS_IN_REPORTING_PERIOD":"Publications that were published or in progress during the reporting period.","NO_PUBLICATIONS_IN_REPORTING_PERIOD":"No publications published or in progress during the reporting period.","COURSES_IN_REPORTING_PERIOD":"Study units completed during the reporting period.","INTERNATIONAL_ACTIVITY_IN_REPORTING_PERIOD":"Conferences and other mobility that happened during the reporting period.","TEACHING_IN_REPORTING_PERIOD":"Teaching during the reporting period.","NO_COURSES_OR_WORKSHOPS_IN_REPORTING_PERIOD":"No courses or workshops during the reporting period.","NO_THESIS_INSTRUCTION_IN_REPORTING_PERIOD":"No thesis instruction during the reporting period.","FUNDING_IN_REPORTING_PERIOD":"Funding during the reporting period.","NO_SALARIES_IN_REPORTING_PERIOD":"No salaries during the reporting period.","NO_GRANTS_IN_REPORTING_PERIOD":"No grants during the reporting period.","NOT_SUBMITTED":"Not submitted","CONCLUSION_DONE":"Conclusion done","WRITE_CONCLUSION":"Write conclusion","HAVE_A_THESIS_COMMITTEE_MEETIN1":"Have a thesis committee meeting and write about the conclusions to your report.","THE_DOCTORAL_CANDIDATE_NEEDS_T":"The doctoral researcher needs to have a thesis committee meeting and write about the conclusions to the report.","DONE":"done","REPORT_SUBMITTED_FOR_REVIEW_SU":"Report submitted for review successfully.","REPORT_SUBMITTED":"Report submitted","REPORT_UPDATED":"Report updated","EDIT_REPORT":"Edit report","YOU_CAN_MAKE_CHANGES_TO_THE_RE":"You can make changes to the report.","NO_REPORTS_TO_REVIEW_FOUND":"No reports to review found.","EDIT_REVIEW":"Edit review","REVIEW_REPORT":"Review report","CHANGES_SAVED":"Changes saved","LAST_SAVED":"Last saved","CANCEL_EDITING":"Cancel editing","SAVE_REPORT":"Save report","SUBMIT_REPORT_FOR_REVIEW":"Submit report for review","CREATED_IN":"Created in","CONFERENCES_AND_MOBILITY1":"Conferences and mobility","FUNDING":"Funding","TEACHING":"Teaching","COURSES_AND_WORKSHOPS":"Courses and workshops","THESIS_INSTRUCTION":"Thesis instruction","YOU_ARE_EDITING_THE_REPORT_S_C":"You are editing the report\'s conclusion & recommendations","SHOW_EDITOR":"Show editor","PLEASE_INDICATE_WHO_ATTENDED_T":"Please indicate who attended the thesis committee meeting.","THESIS_COMMITTEE_MEETING_FORM":"Thesis Committee Meeting Form","CONCLUSION_AND_RECOMMENDATIONS":"Conclusion and recommendations","NO_REPORT_FOUND_CANNOT_EDIT_CONCLUSION":"Report was not found. Cannot edit conclusion.","NO_TEXT_TO_PREVIEW":"No text to preview","CANNOT_SUBMIT_CONCLUSION_EMPTY":"Conclusion cannot be empty.","THE_DOCTORAL_CANDIDATE_IS_EXPE":"The doctoral researcher is expected to complete this form at the conclusion of the thesis committee meeting when all participants are present.","PREVIEW":"Preview","SUBMITTING_PLEASE_WAIT":"Submitting, please wait...","CONCLUSION_CONFIRM_CANCEL":"Are you sure you want to stop writing the conclusion? What you have written so far will be lost.","CONCLUSION_CANNOT_BE_EDITED":"Conclusion has already been written for this report and it cannot be changed afterwards. You can <0>go back to the report</0>.","CUMULATIVE_REPORT_FOR":"Cumulative Report: ","COMPLETED_IN_THE_MOST_RECENT":"completed in the most recent report","IN_PROGRESS_IN_THE_MOST_RECE":"in progress in the most recent report","PUBLICATION_IS_IN_THESIS":"Publication is in thesis.","COMPLETE":"complete","NOTHING_REPORTED_YET":"Nothing reported yet.","DELETE_REPORT":"Delete report","YOU_CAN_DELETE_YOUR_REPORT_BEF":"You can delete your report before it has been submitted.","COMPLETED1":"completed","ESTIMATE_OF_HOW_COMPLETE_YOUR":"Estimate of how complete your PhD project is in percentage.","FULL_TIME":"full time","ESTIMATE_OF_FULL_PART_TIME_WOR":"Estimate of full/part time work on PhD project during the reporting period.","YOUR_DOCTORAL_PROGRAMME_ASKS_Y":"Your doctoral programme asks you to write this report to get a sense of how your PhD project is going.","PLEASE_FILL_IN_ALL_OF_THE_FIEL":"Please fill in all of the fields.","THE_REPORT_WILL_BE_VISIBLE_TO":"The report will be visible to your supervisors, thesis committee members and coordinators once submitted.","AND":"and","WHEN_YOU_ARE_DONE_PRESS_THE_S":"When you are done, press the Submit-button. The button becomes visible when you have filled in every field. After submitting, the report is open for discussion.","REMEMBER_TO_SAVE_THE_REPORT_PE":"Remember to save the report periodically. You may save the report at any time and continue writing it later.","MESSAGE_REMOVED":"Message removed.","DISCUSSION":"Discussion","LOADING":"Loading...","NO_DOCUMENT_FOUND_WITH_DATE":"No document found with date","APPROVED_BY_THE_BOARD_OF_DOCTO":"Approved by the Board of Doctoral Training at the University of Helsinki, <0>{{date}}</0>.","THESSA_JOIN_A_THESIS_COMMITT":"Thessa - Join a thesis committee","WITH_YOUR_THESSA_CREDENTIALS_O":"with your Thessa credentials or use your University of Helsinki username.","OTHERWISE":"Otherwise","REGISTER_AN_EXTERNAL_ACCOUNT":"register an external account","YOU_WILL_USE_THIS_FOR_LOGGING":"You will use this for logging in.","AT_LEAST_CHARACTERS":"At least 8 characters.","YOUR_ORGANIZATION":"Your organization","FOR_EXAMPLE_FINNISH_METEOROLO":"For example: Finnish Meteorological Institute or Acme Inc.","THERE_WERE_PROBLEMS_WITH_SIGN":"There were problems with sign up:","WELCOME_TO_THESSA_AS_A_NON_UN":"Welcome to Thessa! As a non-University-of-Helsinki user, you can create your account here.","ERROR":"Error","SORRY_AN_ERROR_HAS_OCCURRED_I":"Sorry, an error has occurred in sign up. Please try again by refreshing the page, or","DOCTORAL_STUDIES":"Doctoral studies","FILL_IN_DETAILS_OF_YOUR_STUDIE":"Fill in details of your studies.","BEGINNING_OF_DOCTORAL_STUDIES":"Beginning of doctoral studies","DOCTORAL_PROGRAMME":"Doctoral programme","BACK":"Back","CONTINUE":"Continue","OR":"or","LOG_OUT1":"log out","WELCOME_TO_THESSA1":"Welcome to Thessa","WE_NEED_SOME_INFORMATION_ABOUT":"We need some information about you before you can continue.","MY_ROLE_IN_THESSA":"My role in Thessa","DOCTORAL_CANDIDATE":"Doctoral researcher","SUPERVISOR":"Supervisor","SUPERVISOR_other":"Supervisors","THESIS_COMMITTEE_MEMBER":"Thesis committee member","VERIFY_YOUR_DETAILS":"Verify your details","WE_FOUND_THE_FOLLOWING_DETAILS":"We found the following details of you automatically.","PLEASE_CHECK_THAT_THEY_ARE_COR":"Please check that they are correct and fix if needed.","LIST_DOCTORAL_CANDIDATES_BY_RE":"List doctoral researchers by report status","LIST_REVIEWERS_OF_NOT_COMPLETE":"List reviewers of not completed reports","DOWNLOAD_THESSA_ADMIN_REPORT":"Download Thessa admin report","REPORT_CONCLUSIONS_OVERVIEW":"Report conclusions overview","FILTER":"Filter","SHOW_ALL_REPORTS":"Show all reports","OVER_MONTH_OLD_REPORTS":"Over 2 month old reports","COPY_REVIEWER_EMAIL_ADDRESSES":"Copy reviewer email addresses","EMAIL_ADDRESSES_COPIED":"Email addresses copied","CREATED_AT":"Created at","REVIEWERS":"Reviewers","FILTER_BY_DOCTORAL_PROGRAMME":"Filter by doctoral programme","NO_REPORT_CONCLUSIONS_AVAILABL":"No report conclusions available for doctoral programme in","PRELIMINARY_TITLE_OF_DISSERTAT":"Preliminary title of dissertation","STUDENT_NUMBER1":"STUDENT NUMBER","NAME1":"NAME","ACCOUNT_CLOSED":"Account closed:","STUDIES":"STUDIES","FACULTY":"FACULTY","SUPERVISORS1":"SUPERVISORS","THESIS_COMMITTEE2":"THESIS COMMITTEE","REPORT_CREATED":"Report created","PROGRESS1":"progress","LINK_TO_THE_DOCTORAL_CANDIDATE":"Link to the doctoral researcher\'s Thessa page","STUDENT_ID_NUMBER":"Student ID number","ACCOUNT_STATUS_OPEN_CLOSED":"Account status (open/closed)","IF_ACCOUNT_IS_CLOSED_REASON_F":"If account is closed, reason for closing","IS_ACCOUNT_ACTIVE_ACTIVE_INAC":"Is account active (active/inactive)","EMAIL2":"email","FACULTY1":"faculty","FACULTY_OF_DEGREE":"Faculty of degree","STARTING_DATE_OF_DOCTORAL_STUD":"Starting date of doctoral studies","DOES_THE_DOCTORAL_CANDIDATE_HA":"Does the doctoral researcher have a supervision plan","IS_THE_SUPERVISION_PLAN_IN_EFF":"Is the supervision plan in effect","SUPERVISORS2":"supervisors","SUPERVISORS_AND_THEIR_EMAIL_AD":"Supervisors and their email addresses","IS_THE_ANNUAL_REPORT_SUBMITTED":"Is the annual report submitted","LATEST_REPORT_SUBMITTED_AT_DATE":"Latest report submitted at date","THE_ANNUAL_REPORTING_IS_CLOSED":"The annual reporting is closed and concluded","NEXT_REPORT_S_DEADLINE":"Next report\'s deadline","THESIS_COMMITTEE_HAS_BEEN_ASSI":"Thesis committee has been assigned","MEMBERS_OF_THE_THESIS_COMMITTE":"Members of the thesis committee and their email addresses","OVERALL_PERCENTAGE_OF_COMPLETI":"Overall percentage of completion of thesis work","ADVANCEMENT_OF_THESIS_WORK_COM":"Advancement of thesis work completion during the reporting period","FULL_TIME_PART_TIME":"Full time/part time","SALARIES2":"salaries","GRANTS2":"grants","GRANTS_OBTAINED_AND_APPLIED_FO":"Grants obtained and applied for","EXPORT":"Export","CREATE_SUPERVISION_PLAN":"Create supervision plan","DELETE_SUPERVISION_PLAN":"Delete supervision plan","ACCEPT_PLAN":"Accept plan","VALID_BETWEEN":"Valid between","VALID_FROM":"Valid indefinitely from","VALID_INDEFINITELY":"Supervision plan is valid indefinitely","VALID_INDEFINITELY_SHORT":"Valid indefinitely","DECISIONS":"Decisions","SIGNATURES":"Signatures","SIGNED":"Signed","NOT_YET_SIGNED":"Not yet signed","WHAT_HAVE_YOU_DECIDED_ABOUT_TH":"Please fill out at least one optional field with your decision on how you will work towards the PhD together.","ACTIVE":"Active","PENDING":"Pending","EXPIRED":"Expired","GENERAL_TERMS_ON":"General terms on","RIGHTS_OBLIGATIONS_AND_RESPON2":"Rights, Obligations and Responsibilities in doctoral training at the University of Helsinki","THAT_APPLY_TO_THE_SUPERVISION":"that apply to the Supervision Plan.","NO_COURSES_OR_WORKSHOPS_IN_PLA":"No courses or workshops in plan yet.","NO_THESIS_INSTRUCTIONS_IN_PLAN":"No thesis instructions in plan yet.","ADD_TEACHING":"Add teaching","TYPE_OF_TEACHING":"Type of teaching","DATES1":"Dates","COURSE_OR_WORKSHOP_NAME":"Course or workshop name","MY_ROLE":"My role","WORK_HOURS":"Work hours","STUDENT_S_NAME":"Student\'s name","THESIS_LEVEL":"Thesis level","THESIS_TOPIC_OR_TITLE":"Thesis topic or title","SIGNED_UP_ON":"Signed up on","USERNAME":"Username","ACTIVATE_ACCOUNT_NOW":"Activate account now","USER_ACCOUNT_IS_NOT_YET_ACTIVA":"User account is not yet activated","CHECK_THE_ACCOUNT_DETAILS_IF":"Check the account details \u2014 if the user is actually in your organization, activate the account. Otherwise","CONTACT_THESSA_S_ADMINS":"contact Thessa\'s admins","CLOSE_ACCOUNT":"Close account","REASON_FOR_CLOSING_THE_ACCOUNT":"Reason for closing the account","OPEN_ACCOUNT":"Reactivate account","OPEN_ACCOUNT_ERROR":{"ERROR":"Failed to reactivate account","IS_ALREADY_OPEN":"Account is already active","NOT_DOCTORAL_CANDIDATE":"User is not a doctoral researcher","ALREADY_REOPENED_BY_USERNAME":"User account has already been reactivated (temporary username found)","ALREADY_REOPENED_BY_EMAIL":"User account has already been reactivated (temporary email found)"},"FACULTY2":"Faculty:","MAJOR":"Major:","DOCTORAL_PROGRAMME1":"Doctoral programme:","BEGINNING_OF_DOCTORAL_STUDIES1":"Beginning of doctoral studies:","BACK_TO":"Back to","ORGANIZATION":"Organization","STUDENT_NUMBER2":"Student number:","VERIFIED_FROM_LDAP":"Verified from LDAP)","NOT_VERIFIED_REPORTED_BY_DOCT":"Not verified, reported by doctoral researcher)","THESIS_COMMITTEE_MEMBER1":"Thesis Committee Member","IN_THESIS_COMMITTEE_FOR":"In thesis committee for {{count}} doctoral researcher","IN_THESIS_COMMITTEE_FOR_other":"In thesis committee for {{count}} doctoral researchers","THE_INVITATION_HAS_EXPIRED":"<0>The invitation has expired.</0>","THE_INVITATION_HAS_ALREADY_BEEN_USED":"<0>This invitation has already been used.</0>","THERE_WAS_AN_ERROR_IN_LOADING_THE_INVITATION":"<0>There was an error in loading the invitation.</0> Please <1>try again</1>. Please <2>let us know</2> if the problem does not go away.","INVITATION_DECLINED":"<0>Invitation declined.</0> Thank you for responding!","YOUR_ACCOUNT_IS_CLOSED":"Your account is closed","SUPERVISION_PLAN_NOT_FOUND":"Supervision plan not found","IN_THESIS":"In thesis","PUBLISHED":"Published","NOT_STARTED":"Not started","THE_SUPERVISION_PLAN_AFFECTS_THE_DOCTORAL":"The supervision plan affects the doctoral researcher and all supervisors of the doctoral researcher.","IT_IS_RECOMMENDED_THAT_SUPERVISION_PLANS":"It is recommended that supervision plans are created when everyone it affects is present. If someone can\'t make it, be sure to create a plan that they too can sign.","CREATE_AND_SIGN_PLAN_AS":"Save final version and sign","SAVE_DRAFT":"Save draft","SAVE_DRAFT_FEEDBACK":"Draft saved","LOADING_DOCTORAL_PROGRAMMES":"Loading doctoral programmes...","FORM_IS_INCOMPLETE":"Form is incomplete","DESCRIPTION":"Description","ROLE_IN_CONFERENCE":"Role in conference","FAILED_TO_SAVE":"<0>Failed to save.</0> Try again or <1>contact us</1> if the problem persists.","ROLE":"Role","PREVIOUS_PAGE":"Previous <0>page</0>","NEXT_PAGE":"Next <0>page</0>","ROWS":"rows","PAGE_OF":"<0>Page {{currentPage}}</0> <1>of {{totalPages}}</1>","PAGE":"Page","MAX_SIZE_PER_ATTACHMENT":"Max size per attachment:","UPLOAD_ATTACHMENTS":"Upload attachments","UPLOADING":"Uploading...","WHAT_PLANS_DO_YOU_HAVE":"What plans do you have? Do your completed studies support this goal?","WRITE_HERE_ABOUT_YOUR_RESEARCH_PROGRESS":"Write here about your research progress during the reporting period. Stick to the main points and be brief in order to help the Thesis Committee easily evaluate your progress. Note, that you can upload your updated research plan, or other relevant material, as an attachment to this report.","FOR_EXAMPLE_WRITE_ABOUT_HOSTING_A_VISITOR":"For example, write about hosting a visitor or organising national field trips.","FOR_EXAMPLE_HAVE_YOU_WRITTEN_A_BLOG":"For example, have you written a blog or a popular science article, organized an event aimed at an audience outside your own field or tried to have an impact in any other ways?","NO_REPORTS":"No reports","ANY":"Any","FILTER_BY":"Filter by {{target}}","SORT_BY":"Sort by","THERE_WAS_AN_ERROR_IN_LOADING_DOCTORAL_CANDIDATES":"<0>There was an error in loading doctoral researchers.</0> Please <1>try again</1>. Please <2>let us know</2> if the problem does not go away.","THERE_ARE_NO_DOCTORAL_CANDIDATES_IN_THE_SELECTED":"No doctoral researchers found.","DOCTORAL_PROGRAMMES":"Doctoral programmes","ERROR_LOADING_DOCTORAL_PROGRAMMES":"<0>Error loading doctoral programmes.</0> Please <1>try again</1>. If it does not help, please <2>let us know</2>.","SELECT_NONE":"Select none","SELECT_ALL":"Select all","WHEN_WILL_EACH_STAGE_OF_THE_PUBLICATION_BEGIN":"When will each stage of the publication begin? If the stage in the future, estimate when it would begin. Each status has to start after the previous one","THE_STATUSES_ARE_IN_INCORRECT_ORDER":"The statuses are in incorrect order: each status has to start after the previous one.","TO_BE_INCLUDED_IN_THE_PHD_THESIS":"To be included in the PhD thesis","SAVE_PUBLICATION":"Save publication","CREATE_ANOTHER":"Create another","CREATING_ANOTHER_PUBLICATION":"Creating another publication","CREATING_ANOTHER_GRANT":"Creating another grant","SOURCE_OF_GRANT":"Source of grant","FROM_WHICH_ORGANIZATION_IS_THE_GRANT_FROM":"From which organization is the grant from?","HOW_MUCH_IS_THIS_GRANT":"How much is this grant?","SAVE_GRANT":"Save grant","ENDS_AT":"Ends at","BEGINS_AT":"Begins at","WHAT_IS_THE_INTENDED_USAGE_OF_THIS_GRANT":"What is the intended usage of this grant?","DURATION_OF_GRANT":"Duration of grant","WHEN_DOES_THIS_GRANT_BEGIN_AND_END":"When does this grant begin and end? If there is no clear date, make an estimate.","CREATING_ANOTHER_TEACHING":"Creating another teaching","BEGINNING_DATE":"Beginning date","END_DATE":"End date","NAME_OF_THE_COURSE_OR_WORKSHOP":"Name of the course or workshop","MY_ROLE_IN_TEACHING":"My role in teaching","FOR_EXAMPLE_LECTURER_OR_ASSISTANT":"For example <0>lecturer</0> or <1>assistant</1>.","TOPIC_OR_TITLE_OF_THE_THESIS":"Topic or title of the thesis","LEVEL_OF_THESIS":"Level of thesis","COURSE_OR_WORKSHOP":"Course or workshop","HOW_MANY_HOURS_OF_WORK_DID_YOU_SPEND_IN_TOTAL":"How many hours of work did you spend in total?","NAME_OF_THE_STUDENT_WHO_YOUR_WERE_INSTRUCTING":"Name of the student who your were instructing","MY_ROLE_IN_INSTRUCTING_THE_STUDENT":"My role in instructing the student","FOR_EXAMPLE_MAIN_SUPERVISOR_OR_CO_SUPERVISOR":"For example <0>main supervisor</0> or <1>co-supervisor</1>.","FOR_EXAMPLE_MASTERS_THESIS_OR_BACHELORS_THESIS":"For example <0>master\'s thesis</0> or <1>bachelor\'s thesis</1>.","CREATING_ANOTHER_SALARY":"Creating another salary","SOURCE_OF_SALARY":"Source of salary","FROM_WHICH_ORGANIZATION_AND_OR_PROJECT_DO_YOU_GET":"From which organization and/or project do you get your salary from?","DURATION_OF_SALARY":"Duration of salary","WHEN_DOES_THIS_SALARY_BEGIN_AND_END_IF_THERE_IS_NO":"When does this salary begin and end? If there is no clear date, make an estimate.","SAVE_SALARY":"Save salary","DUE_DATE":"Due date","SEND_REMINDER_EMAILS_AT":"Send reminder emails at","SAVE_REMINDER":"Save reminder","LOG_IN_OR_SIGN_UP_TO_ACCEPT_INVITATION":"Log in or sign up to accept invitation.","LOG_IN_WITH_UNIVERSITY_OF_HELSINKI_ACCOUNT":"Log in with University of Helsinki account","I_DON_T_HAVE_A_UNIVERSITY_OF_HELSINKI_ACCOUNT":"I don\'t have a University of Helsinki account","LOG_IN_WITH_AN_EXISTING_THESSA_ACCOUNT":"Log in with an existing Thessa account.","LOG_IN_OR_SIGN_UP_FOR_A_THESSA_ACCOUNT_TO":"Log in or sign up for a Thessa account to accept invitation.","SIGN_UP_FOR_A_NEW_THESSA_ACCOUNT":"Sign up for a new Thessa account","ERROR_LOGIN_OR_SIGN_UP":"ERROR - login or sign up!","INVITATION_HAS_EXPIRED_AT":"Invitation has expired at {{date}}. <0>Go to Thessa\'s front page</0>","INVITATIONS":{"BY_ACCEPTING_THE_INVITATION":"By accepting the invitation, you will be able to see this PhD project in Thessa.","UNIVERSITY_STAFF_OR_STUDENTS_HEADING":"University of Helsinki staff and students","UNIVERSITY_STAFF_OR_STUDENTS_INSTRUCTIONS":"If you work or study at the University of Helsinki, you should accept the invitation by logging in with your University of Helsinki account.","EXTERNAL_USERS_HEADING":"Others","EXTERNAL_USERS_INSTRUCTIONS":"If you are not a staff member or a student at the University of Helsinki, you can accept the invitation by logging in to your Thessa account.","EXTERNAL_EXISTING_USERS_HEADING":"Existing Thessa account","EXTERNAL_EXISTING_USERS_INSTRUCTIONS":"If you have used Thessa before, log in to your existing Thessa account.","EXTERNAL_NEW_USERS_HEADING":"Create a Thessa account","EXTERNAL_NEW_USERS_INSTRUCTIONS":"If you have not used Thessa before and do not have University of Helsinki credentials, you can create a user account in Thessa.","EXTERNAL_NEW_USERS_ACTION":"Create Thessa account","YOU_ARE_USING_UNIVERSITY_EMAIL":"You are using a University of Helsinki email address. You should probably log in with your University of Helsinki account, instead of creating a new Thessa account.","DECLINE_INSTRUCTIONS":"If you received this invitation by accident, we ask you to decline it.","DECLINE_ACTION":"Decline invitation","FAILED_TO_ACCEPT_INVITATION":"<0>There was an error in accepting the invitation.</0> Please try again. Please <1>let us know</1> if the problem does not go away."},"YOU_HAVE_BEEN_INVITED_TO_BECOME":"You have been invited to become <0>{{roles}} for {{inviter}}</0> in Thessa.","ACCEPT_INVITATION":"Accept invitation","THERE_WAS_AN_ERROR_IN_DECLINING_THE_INVITATION":"<0>There was an error in declining the invitation.</0> Please try again. Please <1>let us know</1> if the problem does not go away.","SIGN_UP_FOR_A_NEW_THESSA_ACCOUNT_TO":"Sign up for a new Thessa account to accept invitation.","SIGN_UP":"Sign up","ERROR_IN_SIGN_UP":"Error in sign up.","LOG_IN_FAILED_TRY_AGAIN":"Log in failed. Try again.","ROLES":"Roles","DOES_NOT_HAVE_ANY_ROLES_ASSIGNED":"<0>{{name}} does not have any roles assigned.</0> Everyone must have at least one role.","THERE_WAS_AN_ERROR_IN_UPDATING_ROLES":"<0>There was an error in updating roles.</0> Please try again. Please <1>let us know</1> if the problem does not go away.","ONLY_ONE_PERSON_CAN_BE_THE_COORDINATING":"Only one person can be the coordinating academic.","ONLY_ONE_PERSON_CAN_BE_THE_MAIN_SUPERVISOR":"Only one person can be the main supervisor.","ONE_PERSON_SHOULD_BE_SELECTED_AS_THE_COORDINATING":"One person should be selected as the coordinating academic.","ONE_PERSON_SHOULD_BE_SELECTED_AS_THE_MAIN":"One person should be selected as the main supervisor.","MYSELF":"Myself","FILTERS":"Filters","CHOOSE_A_DOCTORAL_PROGRAMME":"Choose a doctoral programme","LOADING_INACTIVE_USER":"Loading inactive user...","NO_STUDENT_NUMBER":"No student number","SIGNED_UP":"Signed up","NO_SUPERVISORS":"No supervisors","SUPERVISOR_INVITATIONS":"Supervisor invitations","ACTIVATE":"Activate","SEND_EMAIL":"Send email","NO_EMAIL_ADDRESS":"No email address","THERE_WAS_AN_ERROR_IN_ACTIVATING_THE_USER_ACCOUNT":"<0>There was an error in activating the user account.</0> Please <1>try again</1>. Please <2>let us know</2> if the problem does not go away.","SELECT_DOCTORAL_PROGRAMME":"Select doctoral programme","NO_DOCTORAL_PROGRAMME_SELECTED":"No doctoral programme selected","SELECT_DOCTORAL_PROGRAMMES":"Select doctoral programmes","ALL_DOCTORAL_PROGRAMMES":"All doctoral programmes","NOT_VERIFIED":"Not verified","VERIFY_NOW":"Verify now","DOCTORAL_CANDIDATE_DOES_NOT_HAVE_ANY_SUPERVISORS":"Doctoral researcher does not have any supervisors.","COUNT_THESIS_COMMITTEE_MEMBER":"{{count}} thesis committee member","COUNT_THESIS_COMMITTEE_MEMBER_other":"{{count}} thesis committee members","COUNT_SUPERVISOR_RELATIONSHIP":"{{count}} supervisor relationship","COUNT_SUPERVISOR_RELATIONSHIP_other":"{{count}} supervisor relationships","COUNT_PUBLICATION_IN_PROGRESS":"{{count}} publication in progress","COUNT_PUBLICATION_IN_PROGRESS_other":"{{count}} publications in progress","COUNT_PUBLICATION_PUBLISHED":"{{count}} publication published","COUNT_PUBLICATION_PUBLISHED_other":"{{count}} publications published","MAIN_SUPERVISOR":"Main supervisor","MAIN_SUPERVISOR_other":"Main supervisors","COORDINATING_ACADEMIC":"Coordinating academic","COORDINATING_ACADEMIC_other":"Coordinating academics","COUNT_DOCTORAL_CANDIDATE":"{{count}} doctoral researcher found","COUNT_DOCTORAL_CANDIDATE_other":"{{count}} doctoral researchers found","ONLY_SHOW_DOCTORAL_CANDIDATES_LATE_WITH_NEXT_THESIS_COMMITTEE_MEETING":"Only show doctoral researchers late with next thesis committee meeting","ONLY_SHOW_DOCTORAL_CANDIDATES_WITHOUT_ACCOUNT":"Only show doctoral researchers without account","ONLY_SHOW_DOCTORAL_CANDIDATES_WITHOUT_SUPERVISOR":"Only show doctoral researchers without supervisor","COUNT_DOCTORAL_CANDIDATE_S_REPORT":"{{count}} doctoral researcher\'s report is late ({{percentage}}%)","COUNT_DOCTORAL_CANDIDATE_S_REPORT_other":"{{count}} doctoral researchers\' report is late ({{percentage}}%)","COUNT_DOCTORAL_CANDIDATE_S_LATEST":"{{count}} doctoral researcher\'s latest report has not yet been completed ({{percentage}}%)","COUNT_DOCTORAL_CANDIDATE_S_LATEST_other":"{{count}} doctoral researchers\' latest report has not yet been completed ({{percentage}}%)","COUNT_DOCTORAL_CANDIDATE_IS_ON_TIME":"{{count}} doctoral researcher is on time ({{percentage}}%)","COUNT_DOCTORAL_CANDIDATE_IS_ON_TIME_other":"{{count}} doctoral researchers are on time ({{percentage}}%)","COUNT_ITEM_IN_QUEUE":"{{count}} item in queue","COUNT_ITEM_IN_QUEUE_other":"{{count}} items in queue","OLDEST_ITEM_FIRST":"oldest item first","ISPROCEEDING":"isProceeding","IS_THE_ANNUAL_REPORT_PROCEEDING_AS_PLANNED":"Is the annual report proceeding as planned","CONCLUSIONCOMMENT":"conclusionComment","COMMENT_ABOUT_THE_PROGRESS_OF_THE":"Comment about the progress of the dissertation work written by main supervisor","PROGRESS_FEEDBACK_BY":"Progress feedback by","IS_THE_DISSERTATION_WORK_PROCEEDING_AS_PLANNED":"Is the dissertation work proceeding as planned?","PROGRESS_FEEDBACK_IS_MISSING":"Progress feedback is missing","PROGRESS_FEEDBACK_SUBMITTED":"Progress feedback submitted","GIVE_PROGRESS_FEEDBACK":"Give progress feedback","THERE_WAS_A_PROBLEM_SUBMITTING_PROGRESS_FEEDBACK":"There was a problem submitting progress feedback","PROGRESS_FEEDBACK_SUBMITTED_REDIRECTING_YOU_BACK":"Progress feedback submitted. Redirecting you back to <0>overview page</0>","PROGRESS_FEEDBACK":"Progress feedback","COMMENT1":"Comment","OPTIONAL_COMMENT_ABOUT_THE_PROGRESS_OF_THE":"Optional comment about the progress of the dissertation work","MOBILE":"Mobile","DESKTOP":"Desktop","VIEW_ACCOUNT":"View account","EDIT_ROLES":"Edit roles","REMOVE_SUPERVISOR":"Remove supervisor","ENDING_ON_DATE":"Ending on {{date}}","INVITE_SUPERVISOR":"Invite supervisor","ADD_SUPERVISOR":"Add supervisor","FAILED_TO_SEND_INVITE_PLEASE_TRY_AGAIN":"<0>Failed to send invite.</0> Please try again or <1>contact Thessa support</1> for help.","SAVE_ROLES":"Save roles","ERROR_IN_SAVING_ROLES_TRY_AGAIN_OR":"Error in saving roles. Try again or <0>contact support</0>.","INVITATION":"Invitation","REMOVE_INVITATION":"Remove invitation","YOU_HAVE_NO_ACTIVE_DOCTORAL_CANDIDATES_IN_THESSA":"You have no active doctoral researchers in Thessa right now.","NOT_IN_THESSA":"The user must log in to activate their account","UPLOAD_AN_EXCEL_FILE_WITH_SUPERVISOR_RELATIONSHIPS":"Upload an Excel file with supervisor relationships","CHANGE_FILE":"Change file","GO_BACK":"Go back","SAVE_SUPERVISOR_RELATIONSHIPS":"Save supervisor relationships","DOCTORAL_CANDIDATE_ROW":"Doctoral researcher row","IGNORE":"Ignore","COORDINATING_ACADEMIC_EMAIL":"Coordinating academic email","MAIN_SUPERVISOR_EMAIL":"Main supervisor email","SUPERVISOR_EMAIL":"Supervisor email","SUPERVISOR_RELATIONSHIPS":"Supervisor relationships","UPLOAD_A_FILE_WITH_SUPERVISOR_RELATIONSHIPS":"Upload a file with supervisor relationships","PICK_COLUMNS_AND_ROWS_TO_IMPORT":"Pick columns and rows to import","FOR_EACH_COLUMN_WITH_RELEVANT_DATA":"For each column with relevant data (student number and supervisors\' email addresses), pick the correct type of column from the dropdown menu. Leave rest of the columns marked as ignored.","THEN_SELECT_EACH_ROW_WITH_A_SUPERVISOR":"Then, select each row with a supervisor relationship and press the Preview button.","CHECK_THAT_THE_FOLLOWING_PREVIEW_IS_CORRECT":"Check that the following preview is correct. If the preview is correct, press the Save supervisor relationships button to start the import. If the preview is incorrect, you can upload a new Excel file or press the go back button and change the column and row selections.","IMPORT_SUCCESSFUL":"Import successful","IMPORT_FAILED_PLEASE_CONTACT_US_FOR_HELP":"<0>{{message}}</0> If needed, please <1>contact us</1> for help.","FILE_UPLOAD_WAS_NOT_SUCCESSFUL_PLEASE_TRY_AGAIN":"<0>File upload was not successful.</0> Please try again.","NOTES":"Notes","COURSE_TITLE":"Study unit name","SALARY_SOURCE":"Salary source","GRANT_SOURCE":"Grant source","STUDENT":"Student","STATUS_OF_THE_PHD_PROJECT":"Status of the PhD project","LATEST_REPORT":"Latest report","TIME_SPENT_ON_PHD":"Time spent on PhD","SOCIAL_IMPACT_AND_PUBLIC_OUTREACH":"Social impact and public outreach","ATTACHMENTS":"Attachments","THREE_POSITIVE_THINGS":"Three positive things","THREE_NEGATIVE_THINGS":"Three negative things","CAREER_PLANNING":"Career planning","CONCLUSIONS":"Conclusions","OTHER_WORK":"Other work","WAIT_FOR_ONE_MINUTE_BEFORE_RESENDING":"Wait for one minute before resending","ACCOUNT_IS_CLOSED":"Account is closed","ACCOUNT_IS_ACTIVE":"Account is active","ACCOUNT_IS_INACTIVE":"Account is inactive","ESTIMATED_STATUS_OF_THE_PHD_PROJECT":"Estimated status of the PhD project","ESTIMATED_TIME_OF_PHD_DEFENCE":"Estimated time of PhD defence","CAREER_PLANS_AFTER_YOUR_PHD":"Career plans after your PhD","BACK_TO_OVERVIEW":"Back to overview","BACK_TO_REPORT":"Back to report","CHANGE_SUPERVISOR":"Change supervisor","ADD_SUPERVISOR_FOR_NAME":"Add supervisor for {{name}}","FAILED_TO_ADD_SUPERVISOR_PLEASE_TRY_AGAIN_OR":"<0>Failed to add supervisor.</0> Please try again or <1>contact Thessa support</1> for help.","FAILED_TO_INVITE_SUPERVISOR_PLEASE_TRY_AGAIN_OR":"<0>Failed to invite supervisor.</0> Please try again or <1>contact Thessa support</1> for help.","INVITE_SUPERVISOR_FOR_NAME":"Invite supervisor for {{name}}","CHOOSE_LANGUAGE":"Choose language","PREPARATION_AND_ANALYSIS":"Preparation and analysis","WRITING":"Writing","NAME_IS_NOT_YET_ON_THESSA_WHEN_THEY_SIGN_UP":"<0>{{name}} has not yet started using Thessa.</0> A doctoral researcher must log in to Thessa once before their information can be displayed.","INVITE_THESIS_COMMITTEE":"Invite thesis committee","EDIT_THESIS_COMMITTEE":"Edit thesis committee","YOUR_USER_ACCOUNT_NEEDS_TO_BE_ACTIVATED":"Your user account needs to be activated before you can create your first report. Before your account can be activated, you need to <0>invite all thesis committee members</0> in Thessa.","YOU_WILL_RECEIVE_AN_EMAIL_WHEN_YOUR_ACCOUNT":"You will receive an email when your account has been activated.","ESTIMATE_MADE_ON":"Estimate made on","PHD_PROJECT_STATUS":"Status","TIME_SPENT_PERIOD":"Period","PRELIMINARY_TITLE_OF_DISSERTATION":"Preliminary title of dissertation","EDIT_PRELIMINARY_TITLE_OF_DISSERTATION":"Edit preliminary title of dissertation","CREATE_PRELIMINARY_TITLE_OF_DISSERTATION":"Add preliminary title of dissertation","SUBJECT_OR_STUDENT":"Subject or student","APPLICATION_SENT":"Application sent","PLANNING_TO_APPLY":"Planning to apply","CREDITS_one":"{{count}} credit","CREDITS_other":"{{count}} credits","CR":"{{count}} cr","WHAT_WAS_DECIDED":"What was decided?","ROLE_NAME":{"key":"value","doctoral-candidate":"Doctoral researcher","coordinating-academic":"Coordinating academic","main-supervisor":"Main supervisor","supervisor":"Supervisor","thesis-committee-member":"Thesis committee member","salary-system-foreman":"Line manager","coordinator":"Coordinator"},"CHECK_REPORT_STATUS":"Check report status.","CHECK_SUPERVISION_PLAN_STATUS":"Check supervision plan status.","CHECK_NEXT_THESIS_COMMITTEE_MEETING_REPORT_STATUS":"The doctoral candidate hasn\'t submitted a report","SEARCH_BY":"Search by {{keyword}}","COMPLETE_THE_REPORT_FORM":"Complete the report form and submit the report.","CONCLUSION_CAN_BE_WRITTER_AFTER":"Conclusion can be written after report has been submitted.","YES":"Yes","NO":"No","PLEASE_INVITE_TCMS_TO_THESSA":"Please invite all your thesis committee members to Thessa.","COORDINATOR_TOOLS":{"key":"value","MAIN_HEADING":"Tools","HEADINGS":{"key":"value","MANAGE_USERS":"Users","STATISTICS":"Statistics","OTHER":"Other"},"TOOLS":{"key":"value","LATEST_REPORTS":"Latest reports","INCOMPLETE_REPORTS":"Incomplete reports","ADMIN_REPORT":"Thessa Admin Report","IMPORT_SUPERVISOR_RELATIONSHIPS":"Import supervisor relationships"},"DESCRIPTIONS":{"key":"value","DOCTORAL_CANDIDATES":"Manage doctoral researchers","USERS":"Manage all users","REPORT_CONCLUSIONS_OVERVIEW":"See report conclusion for every doctoral researcher","LATEST_REPORTS":"See latest report\'s status for every doctoral researcher","INCOMPLETE_REPORTS":"See doctoral researchers and supervisors for incomplete reports","ADMIN_REPORT":"Export details of doctoral researchers to CSV","IMPORT_SUPERVISOR_RELATIONSHIPS":"From Excel to Thessa"}},"SHOW_ALL_DOCTORAL_CANDIDATES":"Show all doctoral researchers","HIDE_INACTIVE_DOCTORAL_RESEARCHERS":"Hide inactive doctoral researchers","DOCTORAL_RESEARCHER_OVERVIEW":"Doctoral researcher overview","LAST_COMPLETED_REPORT":"Last completed report","FILTER_DOCTORAL_RESEARCHERS":"Filter doctoral researchers","SUPERVISOR_RELATIONSHIP_OVERVIEW":{"key":"value","IF_MISSING":"If the coordinating academic or supervisor is missing from the list or there have been changes to the supervision arrangements, please contact <0>{{supportEmail}}</0>."},"THESIS_COMMITTEE_MEMBERS":{"key":"value","SUPERVISORS_ARE_HANDLED_BY_OTHERS":"Supervisors are handled by doctoral student services of your faculty and by your doctoral programme\'s officer. Contact details are in ","LINK":"https://studies.helsinki.fi/instructions/article/services-doctoral-education","LINK_TITLE":"instructions for students","INVITATION_HEADING":"Invite thesis committee members","INVITATION_HEADING_FOR_SUPERVISORS":"Invite supervisors","INVITATION_LABEL":"Thesis committee member\'s email address","INVITATION_LABEL_FOR_SUPERVISORS":"Supervisor\'s email address"},"CONTACT":{"HEADING":"Contact us","CONTACT_TEXT_PREFIX":"Contact","CONTACT_TEXT_SUFFIX":" if you have any questions regarding the use of Thessa or if you encounter technical issues, such as logging into Thessa or accepting an invitation.","UNIHELP_URL":"https://uni-help.helsinki.fi/en","UNIHELP_URL_TITLE":"HelsinkiUni Help"},"DATE_RANGE_PICKER":{"INVALID_START_DATE":"The start date is not a valid date.","INVALID_END_DATE":"The end date is not a valid date.","INVALID_END_IS_BEFORE_START":"The end date must be after the start date."},"COORDINATOR_DOCTORAL_CANDIDATES":{"PLACEHOLDER":"Doctoral programme or student number","LABEL":"Search by doctoral programme or student number","ACTION":"Search"},"END_OF_SENTENCE_PERIOD":".","RESOURCES":{"INTRO_VIDEO":"LF7j_ITOYTw"},"MENU":"Menu","FRONTPAGE":"Front page","OPEN_PROFILE_MENU":"Open profile menu","CLOSE_PROFILE_MENU":"Close profile menu","OPEN_MAIN_MENU":"Open main menu","CLOSE_MAIN_MENU":"Close main menu","CHANGE_LANGUAGE":"Change language","PROFILE_MENU":"Profile menu","MAIN_MENU":"Main menu","FOOTER_MENU":"Footer menu","DATE_NOT_SPECIFIED":"Date not specified","EMAIL_OR_USER_INPUT":{"HINT":"A valid email address is required, or pick a user from suggestions"},"FORM":{"REQUIRED_FIELD":"Required","OPTIONAL_FIELD":"Optional","VALID_EMAIL_ADDRESS_REQUIRED":"Please enter a valid email address","PASSWORD_REQUIREMENTS":"Minimum length 10 characters","VALID":"Valid","INVALID":"Invalid","OPTIONAL":"Optional","COMPLETE_FIELDS_TO_SAVE_FORM":"Please note that all fields must be completed in order to save the form.","COMPLETE_FIELDS_TO_SUBMIT_FORM":"Please note that all fields must be completed in order to submit the form.","CONFIRM_CANCEL":"Are you sure you want to stop editing? Unsaved changes will be lost."},"INVITATION_ROLE":{"YOUR_ROLE":"Your role","COORDINATING_ACADEMIC":"a coordinating academic","MAIN_SUPERVISOR":"a main supervisor","SUPERVISOR":"a supervisor","THESIS_COMMITTEE_MEMBER":"a thesis committee member"},"EDIT_PUBLICATION":"Edit publication","EDIT_SALARY":"Edit salary","EDIT_GRANT":"Edit grant","EDIT_COURSE_WORKSHOP":"Edit course/workshop","EDIT_THESIS_INSTRUCTION":"Edit thesis instruction","EDIT_TEACHING":"Edit teaching","FOR_STUDENT":"for student","CREATE_NEW_REMINDER":"Create new reminder","LOGO_OF_UNIVERSITY_OF_HELSINKI":"Logo of University of Helsinki","NEW":"New","CHANGED":"Changed","INDICATOR":"indicator","STATUS_IN_THE_MOST_RECENT":"Status in the most recent report","DETAILS_WITH_LABEL":"Details: {{ label }}","ADD_PUBLICATION":"Add publication","ADD_COURSE":"Add study unit","EDIT_NOTES":"Edit <0>notes</0>","CANCEL_EDITING_NOTES":"Cancel <0>editing notes</0>","SAVE_NOTES":"Save <0>notes</0>","SEND_MESSAGE":"Send message","REMOVE_COMMENT":"Remove comment","REPORT_VIEW":{"ERROR":{"MISSING_REPORT":"The report is missing.","FAILED_TO_SAVE_REPORT":"<0>Could not save report.</0> Check the report form for errors and try again, or <1>contact us</1>.","FAILED_TO_SUBMIT_REPORT":"<0>Could not submit report for review.</0> Check the report form for errors and try again, or <1>contact us</1>.","FAILED_TO_DELETE_REPORT":"<0>Deleting report failed.</0> Try again or <1>contact us</1>."}},"PHD_PROJECT":{"ERROR":{"GENERAL_ERROR_HEADING":"An error has occurred in Thessa.","YOU_CAN_RETRY_OR":"You can try refreshing the page but if it does not help, please","INCLUDE_THIS_TEXT":"Please include this text in your email","CANNOT_INITIALIZE":"Failed to load PhD Project details from server."}},"CANCEL_INVITING_THESIS_COMMITTEE_MEMBER":"Cancel inviting thesis committee member","INFORMATION":"Information","COMMENT":"Comment","WRITE_YOUR_COMMENT_HERE":"Write your comment here","HIDE_DISCUSSION":"Hide discussion","SHOW_DISCUSSION":"Show discussion","VIEW_SUPERVISION_PLAN":"View supervision plan","ADD_COURSE_WORKSHOP":"Add course/workshop","ADD_THESIS_INSTRUCTION":"Add thesis instruction","UNTITLED":"Untitled","UNTITLED_PUBLICATION":"Untitled publication","UNTITLED_SALARY":"Untitled salary","UNTITLED_GRANT":"Untitled grant","UNTITLED_TEACHING":"Untitled teaching","REMOVAL_CONFIRMATION":"Removal confirmation","THESSA_INTRODUCTION_VIDEO":"Thessa introduction video","ACCESSIBILITY_STATEMENT":"Accessibility statement","INFORMATION_ON_THE_ACCESSIBILITY_OF_THE_WEBSITE":"Information on the accessibility of the website.","LAST_UPDATED":"Last updated","YOU_WILL_NOT_BE_ABLE_TO_ACCESS":"You are not able to access Thessa because your account has been closed.","REQUEST_ACCOUNT_REACTIVATION":"Send us an email if you want to continue using Thessa.","REMINDER":"Reminder","BACK_TO_STATISTICS":"Back to statistics","BACK_TO_USER_DETAILS":"Back to user details","FOR_EXAMPLE":"For example","DOWNLOAD":{"DOWNLOAD":"Download","DOWNLOAD_CSV_FILE":"Download CSV file","DOWNLOAD_EXCEL_FILE":"Download Excel file"},"PLEASE_SELECT_ONE_OF_THE_FOLLOWING_TYPES":"Please select one of the following types","PLEASE_SELECT_YOUR_ROLE_IN_THE_CONFERENCE":"Please select your role in the conference","PLEASE_NOTE_YOU_HAVE_THE_OPTION_TO_SAVE":"Please note you have the option to save your progress at any time, even if not all required fields are filled. Remember to return and complete any missing information before final submission.","DURATION_OF_TEACHING":"Duration of teaching","CURRENT":"Current","UPCOMING":"Upcoming","SITEMAP":"Sitemap","UPON_LOGGING_IN":"Upon logging in, this sitemap will automatically update to reflect the pages and features accessible to you based on your role in Thessa.","OVERVIEW_OF_ALL_SITE_PAGES":"Overview of all site pages, designed for easy navigation and quick access to content.","UPDATED":"Updated","PLEASE_FILL_OUT_ALL_REQUIRED_FIELDS":"Please fill out all required fields.","PLEASE_FILL_OUT_ALL_REQUIRED_FIELDS_AND_DATES":"Please fill out all required fields and enter valid dates.","PLEASE_ENTER_VALID_DATES":"Please enter valid dates.","IS_MISSING":"is missing","THE_VALUE_ENTERED_IS_INVALID":"The value entered is invalid","CLOSE":"Close","CHOOSE":"Choose","SUBMITTING_FORM_FAILED":"Submitting form failed","TRANSCRIPT_OF_THESSA_INTRODUCTION_VIDEO":"Transcript of Thessa introduction video","INTRODUCTION_TO_USING_THESSA_FOR_DOCTORAL":"Introduction to using Thessa for doctoral researchers","CHOOSE_LANGUAGE_FROM_THE_LANGUAGE_NAVIGATION":"Choose language from the language navigation","AFTER_LOGGING_IN":"After logging in, you will land on the homepage called \\"My PhD Project\\" page, which consists of sections for","SUPERVISION_PLANS_ARE_CREATED_BY_YOUR_SUPERVISORS":"Supervision plans are created by your supervisors. You will receive an email when your supervisors have created a new supervision plan for you. To sign the plan, click the link in the email, and then click the \\"Accept Plan\\" button on the supervision plan page.","PLANS_FOR_YOUR_PHD_PROJECT":"Plans for your PhD project","PLANS_FOR_YOUR_PHD_PROJECT_ARE_CREATED_BY_YOU":"Plans for your PhD project are created by you. These plans include information about your publications, conferences, courses, and other activities related to your PhD project.","REPORTS_ARE_CREATED_BY_YOU_AND_INCLUDE_INFORMATION":"Reports are created by you and include information about your progress in your PhD project. They can be saved as drafts and submitted when you are ready.","YOUR_SUPERVISORS_ARE_ADDED_AUTOMATICALLY":"Your supervisors are added automatically. You can see who your supervisors are and their contact information.","YOU_CAN_SEE_INFORMATION_ABOUT_YOUR_THESIS_COMMITTEE":"You can see information about your thesis committee members. Thesis committees members need to be invited manually by navigating to the thesis committee page.","DIGITAL_SERVICE_ACCESSIBILITY_STATUS":"Digital service accessibility status","GENERAL_SECTIONS_AND_FEATURES_THAT_ARE_NOT_ACCESSIBLE":"General sections and features that are not accessible","SERVICES_FOR_DOCTORAL_RESEARCHERS_THAT_ARE_NOT_ACCESSIBLE":"Services for doctoral researchers that are not accessible","SERVICES_FOR_SUPERVISORS_THAT_ARE_NOT_ACCESSIBLE":"Services for supervisors that are not accessible","SERVICES_FOR_COORDINATORS_THAT_ARE_NOT_ACCESSIBLE":"Services for coordinators that are not accessible","NOT_WITHIN_THE_SCOPE_OF_LEGISLATION":"Not within the scope of legislation","ACCESSIBILITY_FEEDBACK":"Accessibility feedback","SUPERVISORY_AUTHORITY":"Supervisory authority","CONTACT_INFORMATION_OF_THE_REGULATOR":"Contact information of the regulator","REGULATOR":"Finnish Transport and Communications Agency Traficom","ACCESSIBILITY_CONTROL_UNIT":"Digital Accessibility Supervision Unit","TEL_SWITCHBOARD":"Tel. (switchboard)","PERCEIVABLE":"Perceivable","OPERABLE":"Operable","UNDERSTANDABLE":"Understandable","ROBUST":"Robust","ACCESSIBILITY_OF_THESSA":"Accessibility of Thessa","THIS_ACCESSIBILITY_STATEMENT_APPLIES":"This accessibility statement applies to <0>the Thessa service for University of Helsinki</0>","THE_SERVICE_IS_SUBJECT_TO_THE_LAW":"The service is subject to the law on providing digital services, which requires that public online services must be accessible. We have assessed the accessibility of the service ourselves.","THE_ACCESSIBILITY_STATEMENT_HAS_BEEN_CREATED_ON":"The accessibility statement has been created on {{ createdDate }} and last updated on {{ lastUpdatedDate }}.","INFO_AND_RELATIONSHIPS":"WCAG 1.3.1: Info and Relationships","ERROR_IDENTIFICATION":"WCAG 3.3.1: Error Identification","ON_INPUT":"WCAG 3.2.2: On Input","TIMING_ADJUSTABLE":"WCAG 2.2.1: Timing Adjustable","USE_OF_COLOR":"WCAG 1.4.1: Use of Color","CONTRAST_MINIMUM":"WCAG 1.4.3: Contrast (Minimum)","PARSING":"WCAG 4.1.1: Parsing","NAME_ROLE_VALUE":"WCAG 4.1.2: Name, Role, Value","STATUS_MESSAGES":"WCAG 4.1.3: Status Messages","THE_THESSA_SERVICE_OF_THE_UNIVERSITY_OF_HELSINKI_MEETS":"The Thessa service of the University of Helsinki meets most of the A and AA level accessibility requirements of the Web Content Accessibility Guidelines (WCAG) 2.1. The accessibility deficiencies identified are described in detail below. The aim is to remedy these deficiencies in connection with the maintenance of the digital service. Read more about <0>accessibility at the University of Helsinki.</0>","DATA_TABLES_ARE_NOT_PROGRAMMATICALLY_DISPLAYED":"Data tables are not programmatically displayed in table format.","THE_INFORMATION_ON_THE_CONFERENCES_AND_MOBILITY":"The information on the \'Conferences and mobility\' section of the \'My PhD Project\' page is not programmatically displayed in table format.","FORMS_DO_NOT_SUFFICIENTLY_GUIDE_USERS_ON_INCORRECT":"Forms do not sufficiently guide users on incorrect or incomplete feeds.","THE_SUBMISSION_BUTTONS_IN_THE_FORMS_FOR_SUPERVISION":"The submission buttons in the forms for supervision plans and reports are disabled when the form is filled in incompletely or incorrectly.","A_FORM_DOES_NOT_DISPLAY_THE_SUBMISSION_BUTTON":"A form does not display the submission button.","THE_SUBMISSION_BUTTON_FOR_THE_PROGRESS_FEEDBACK":"The submission button for the progress feedback form submitted in connection with the report is only displayed in preview mode and is otherwise hidden from users.","TITLES_HAVE_NOT_BEEN_USED_TO_PARSE_CONTENT":"Titles have not been used to structure content.","THE_TITLES_ON_THE_OVERVIEW_OF_CONCLUDING_STATEMENTS":"The titles on the \'Overview of concluding statements\' page have not been used to parse content.","THE_DISTINCTIVENESS_OF_LINKS_FROM_OTHER_TEXT_AND_FOCUS":"The distinctiveness of links from other text and focus styles rely solely on colours.","IN_THE_COORDINATOR_SERVICES_THE_DISTINCTIVENESS":"In the coordinator services, the distinctiveness of links from other text and the focus styles of interactive elements can rely solely on colour changes.","THE_CONTRAST_RATIO_OF_TEXT_ELEMENTS_COMPARED":"The contrast ratio of text elements compared to the background is insufficient.","THE_CONTRAST_RATIO_OF_TEXT_ELEMENTS_ON_THE":"The contrast ratio of text elements on the \'Overview of all concluding statements\' page compared to the background is insufficient.","THE_SUBMISSION_BUTTON_IN_THE_FORM_FOR_ADDING_SUPERVISORS":"The submission button in the form for adding supervisors on the \'Doctoral researchers\' page is disabled when the form is filled in incompletely or incorrectly.","BUTTONS_HAVE_NO_VISIBLE_OR_PROGRAMMATIC_TEXT":"Buttons have no visible or programmatic text.","THE_SUPERVISOR_FORM_ON_THE_DOCTORAL_RESEARCHERS_PAGE":"The supervisor form on the \'Doctoral researchers\' page contains buttons that do not contain visible or programmatic text.","SCREEN_READERS_DO_NOT_AUTOMATICALLY":"Screen readers do not automatically display status messages.","ON_THE_DOCTORAL_RESEARCHERS_AND_LIST_THE_REVIEWERS":"On the \'Doctoral researchers\' and \'List the reviewers of incomplete reports\' pages, screen readers do not automatically display status messages.","NOT_COVERED_BY_LEGISLATION":"Not covered by legislation","CONTENT_PUBLISHED_BY_USERS_OR_OTHER_THIRD_PARTIES":"Content published by users or other third parties in the service that is not produced, funded or controlled by the service provider.","CONTENT_PUBLISHED_BY_USERS_THAT_CANNOT":"Content published by users that cannot be edited to comply with the accessibility requirements may appear on the website. Content published by users has not been programmatically marked to use the language of the content of the publication.","THE_USER_IS_LOGGED_OUT_AUTOMATICALLY_WHEN_THE_SESSION":"The user is logged out automatically when the session expires.","THE_WEBSITE_LOGS_THE_USER_OUT_AUTOMATICALLY_WHEN":"The website logs the user out automatically when the session expires. The user is not warned before the session expires, and there is no way to extend the session or to turn off the time limit.","DID_YOU_NOTICE_AN_ACCESSIBILITY_ISSUE_IN":"Did you notice an accessibility issue in our digital service? Tell us about it via email and we will do our best to rectify it.","IF_YOU_NOTICE_ACCESSIBILITY_ISSUES_ON":"If you notice accessibility issues on the website, first leave your feedback with us, the administrators of the website. It may take up to 14 days to receive an answer. If you are not satisfied with the answer or do not receive an answer from us within two weeks, <0>you may file a complaint with the Finnish Transport and Communications Agency Traficom</0>. The Traficom website has detailed instructions on how to file a complaint and how the issue will be handled.","PAGINATION":"Pagination","GO_TO_PAGE":"Go to page","AMOUNT_OF_ITEMS_PER_PAGE":"Amount of items per page","THERE_WAS_AN_ERROR_IN_LOADING_SUPERVISION_PLANS":"<0>There was an error in loading supervision plans.</0> Please <1>let us know</1> if the problem does not go away.","PHD_PROJECT_LIST":{"ERROR_DELETE_FAILED":"Failed to delete."},"CAREER_COUNSELLING":{"OPEN_CAREER_COUNSELLING":"<0>Review career counselling questions</0>","TITLE":"Career counselling","INITIAL_PHASE":{"TITLE":"Initial phase","MOTIVATION_AND_GOALS":"<0>Motivation and goals:</0> Why am I writing a doctoral thesis? What are my expectations for the doctoral thesis process? What are my interests in my field of research?","INTEGRATION_INTO_THE_ACADEMIC_COMMUNITY":"<0>Integration into the academic community:</0> What is my academic community?","MY_COMMUNITY_AND_FUTURE":"<0>My community and future:</0> What is my research community outside the University? How should I build my network during the doctoral thesis process?"},"MIDDLE_PHASE":{"TITLE":"Middle phase","MOTIVATION_AND_GOALS":"<0>Motivation and goals:</0> How do my reasons for writing a doctoral thesis appear at this time? Have my reasons for writing a doctoral thesis changed? Have my goals changed? How does the doctoral thesis process feel?","SKILLS_AND_DEVELOPMENT_NEEDS":"<0>Skills and development needs:</0> What do I particularly like about writing a doctoral thesis? What have I learned so far? What are my development needs? Who am I becoming?","MY_COMMUNITY_AND_FUTURE":"<0>My community and future:</0> Who inspires me? Who can provide answers to career questions that concern me? Who is interested in the topic or phenomenon I discuss in my doctoral thesis? How do I seek knowledge, experience and insight from other contexts?"},"FINAL_PHASE":{"TITLE":"Final phase","MY_SKILLS_AND_STRENGTHS":"<0>My skills and strengths:</0> What am I good at? Are there any areas of expertise that interest me but which I haven\'t yet had the chance to try?","MY_COMMUNITY_AND_FUTURE":"<0>My community and future:</0> Who inspires me? Who can answer career-related questions that concern me? Who is interested in the subject of my doctoral thesis? How do I seek knowledge, experience and insight from other contexts?","PROFESSIONAL_LIFE_CAREER_PLANNING_AND_LIFESTYLE":"<0>Professional life, career planning and lifestyle in relation to options:</0> What are the things that matter at work? What are the themes and activities I like to work with? What values do I wish to express through my professional life and activities? How and where will I cultivate my livelihood?"},"ASSIGNMENT":{"CONSIDER_QUESTIONS":"Consider the questions before the next meeting of the thesis committee. You can discuss the most important questions in any way and level you wish during the meeting. Not all questions need to be discussed in the meeting.","THESIS_PHASE_BASED_ON_REPORT":"Based on <0>your latest report</0>, your PhD project is estimated to be <1>{{phdCompletionPercentage}}%</1> complete. Therefore, your upcoming meeting will focus on questions related to the <1>{{thesisPhase}}</1>.","THESIS_PHASE":{"INITIAL_PHASE":"initial phase","MIDDLE_PHASE":"middle phase","FINAL_PHASE":"final phase"}}},"THESIS_COMMITTEE":{"BACK_TO_THESIS_COMMITTEE":"Back to thesis committee","CHANGE_DATE":"Change date","CHOOSE_DATE":"Select date","ADD":"Add meeting","NO_MEETINGS":"No meetings","CHOOSE_FIRST_MEETING_DATE":"Select first thesis committee meeting\'s date","CONTINUE_MEETING":"Continue the meeting","END_MEETING":"Save and conclude the meeting permanently","END_MEETING_NOTIFICATION":"Please note you have the option to save the meeting details, even if not all required fields are filled. Once you have permanently concluded the meeting, you will no longer be able to edit the meeting details.","ERROR_MEETING_ALREADY_COMPLETED":"Meeting has already been concluded.","ERROR_MISSING_DATE":"Please choose meeting date before saving.","ERROR_REPORT_NOT_FOUND":"Report not found.","FAST_DOCTORAL_CANDIDATE_MEETING_EVERY_N_MONTHS":"Pilot, meeting every {{n}} months","FIRST_MEETING":"First thesis committee meeting","MEETING":"Thesis committee meeting","MEETINGS":"Meetings","THESIS_COMMITTEE_MEETINGS":"Thesis committee meetings","MEETING_AGENDA":"Proposed agenda","MEETING_AGENDA_NOT_FOUND":"Proposed agenda not found","MEETING_COMPLETED_AT":"Held on {{date}}","MEETING_DATE":"Meeting date","MEETING_DATE_IN_PAST":"Meeting date is in the past","MEETING_DATE_MISSING":"Date not chosen","MEETING_EVERY_N_MONTHS":"Meeting every {{n}} months","MEETING_LATE_NOTIFICATION_FOR_COORDINATOR":"Meeting late","MEETING_LATE_NOTIFICATION_FOR_SUPERVISOR":"Previous meeting was over {{n}} months ago","MEETING_LATE_NOTIFICATION_FOR_DOCTORAL_CANDIDATE":"It has been over six months since the last meeting and no new meetings are scheduled. You should schedule one soon.","MEETING_LATE_NOTIFICATION_FOR_THESIS_COMMITTEE_MEMBERS":"It has been over six months since the last meeting and no new meetings are scheduled. The doctoral researcher should schedule one soon.","MEETING_NOTES":"Meeting notes","MEETING_NOTES_ALERT":"Meeting notes cannot be empty.","MEETING_NOTES_INSTRUCTIONS":"Write a summary of the meeting, covering key points, decisions, and agreed actions.","MEETING_PLANNED_FOR":"Planned for {{date}}","MEETINGS_AND_REPORTS":"Meetings and reports","NEXT_MEETING_ON_DATE":"Next meeting on {{date}}","NO_FIRST_MEETING_DATE_YET":"First meeting date has not yet been chosen","NO_NEXT_MEETING_DATE_YET":"Next meeting date has not yet been chosen","NOT_SCHEDULED":"Next meeting hasn\'t been scheduled","OPEN_REPORT_FOR_MEETING":"Open the report in a new tab","REPORT_EVERY_N_MONTHS":"Report every {{n}} months","REPORT_FOR_MEETING":"Report for the meeting","REPORT_FOR_MEETING_MISSING":"Report is missing","SET_MEETING_DATE":"Save the meeting date to determine the report submission deadline","SUBMIT_A_REPORT":"Submit a report between <0>{{ startDate }}\u2013{{ endDate }}</0>","REPORT_FOR_MEETING_READY":"A report is ready to be discussed in the meeting","NOTE_REPORT_SUBMISSION_DATE":"Note that the report was submitted on <0>{{ submittedAt }}</0>, which is outside the submission time of <0>{{ startDate }}\u2013{{ endDate }}</0>. The report may contain outdated information","REPORT_WAS_DISCUSSED":"A report was discussed in the meeting","START_MEETING":"Start the meeting","TITLE":"Thesis committee","VIEW":"View thesis committee","VIEW_MEETING":"View meeting","ADDING_MEETING_FAILED_WITH_ERROR_CODE":"Adding meeting failed with error code","UPDATING_MEETING_FAILED_WITH_ERROR_CODE":"Updating meeting failed with error code","DELETING_MEETING_FAILED_WITH_ERROR_CODE":"Deleting meeting failed with error code","MOVING_MEETING_FAILED_WITH_ERROR_CODE":"Moving meeting failed with error code","PROGRESS_ESTIMATION_MISSING":"No progress estimation to preview","ESTIMATE_YOUR_PROGRESS":"Estimate your progress toward doctoral degree","PROGRESS_FASTER":"Progressing faster than expected","PROGRESS_EXPECTED":"Progressing as expected","PROGRESS_SLOWER":"Progressing slower than expected","SUPPORT_FEEDBACK":"What kinds of support or changes would help you maintain or improve your progress?","CONFIRM_ENDING_MEETING_TITLE":"Confirm meeting conclusion","CONFIRM_ENDING_MEETING_OPTION":"I understand that when I permanently conclude the meeting, I can no longer edit the meeting details","MEETING_STATUS":"Meeting status","MEETING_DONE":"Done","MEETING_DRAFT":"Draft"},"ATTACHMENT":{"TITLE":"Attachments","ADD":"Add attachment","ADD_NEW":"Add new attachment","ADD_TO_REPORT_INFO":"The attachment will be added to your phd project and marked as part of the report. The attachment cannot be edited or removed afterward.","REPORT_INFO":"Include the phd project attachment as part of this report. The attachment cannot be edited or removed afterward","UPLOADING":"Uploading attachment","ADDING_ATTACHMENT_FAILED_WITH_ERROR_CODE":"Adding attachment failed with error code","DELETING_ATTACHMENT_FAILED_WITH_ERROR_CODE":"Deleting attachment failed with error code","NO_ATTACHMENTS":"No attachments","FILE":"Attachment file","NAME":"Attachment file name","DATE_ADDED":"Date added","NOT_AVAILABLE":"Attachment file not available","SIZE":"Size","IN_REPORT":"In report","REPORT_NOTICE":"You can manage old report attachments. Use the new Attachments section above to upload and attach new attachments to your report.","ALREADY_ATTACHED_TO_REPORT":"Belongs to a previous report"},"SUPERVISION_PLAN_TITLE_NO_END_DATE":"Valid from {{startDate}}","SUPERVISION_PLAN_HEAD_TITLE":"Supervision plan {{startDate}} - {{endDate}}","SUPERVISION_PLAN_HEAD_TITLE_NO_END_DATE":"Supervision plan from {{startDate}}","SUPERVISION_PLAN_EXPIRED_SHORT":"Expired","SUPERVISION_PLAN_IS_VALID_UNTIL_DATE":"Valid until {{date}}","TO_UPLOAD_AN_EXCEL_FILE":"To upload an Excel file, it must contain columns for student numbers and supervisors email addresses. Each row should represent an individual doctoral researcher. Once the file is ready and properly formatted, use the upload button above to submit the Excel file","NEED_A_TEMPLATE_FOR_THE_EXCEL_FILE":"Need a template for the Excel file? Download a sample file and use it by following these steps:","DOWNLOAD_THE_SAMPLE_EXCEL_FILE":"<0>Download the sample Excel file:</0> Click the link below to download the sample Excel file. This file has the columns and one example row.","FILL_IN_THE_DATA":"<0>Fill in the data:</0> Open the downloaded file and enter student numbers and supervisors email addresses into the provided columns. Each row should represent an individual doctoral researcher. Add new rows if more doctoral researchers need to be included.","SAVE_AND_UPLOAD_THE_FILE":"<0>Save and upload the file:</0> Once the data has been filled in, save the file on the computer in the .xlsx format. Then return to this page and use the upload button above to submit the Excel file","SAMPLE_EXCEL_FILE":"Download sample Excel file","VALIDITY":"Validity","COPY_DECISIONS_TO_NEW_PLAN":"Copy decisions to new plan","COPY_DECISIONS_FROM_A_PREVIOUS_PLAN":"Copy decisions from a previous plan","PREVIEW_OF_THE_SUPEVISION_PLAN_FOR":"Preview of the supervision plan for {{name}}","SELECT_A_PREVIOUS_SUPERVISION_PLAN_TO_COPY_FROM":"Select a previous supervision plan to copy from","PLEASE_NOTE_THAT_SUPERVISION_PLANS_MAY_CONTAIN":"Please note that supervision plans may contain sensitive information, such as research details and personal data.","DOCTORAL_CANDIDATE_PARTICIPATES_IN_THE_DOCTORAL_EDUCATION_PILOT":"Doctoral researcher belongs to the doctoral education pilot","DOCTORAL_EDUCATION_PILOT_PARTICIPANT":"Doctoral education pilot participant","CHAPTER":"Chapter","CHAPTERS":"Chapters","CHAPTERS_AND_MILESTONES":"Chapters and Milestones","CURRENT_CHAPTER":"Current chapter","COMPLETED_CHAPTER":"completed chapter","COMPLETED_CHAPTER_other":"completed chapters","MILESTONE":"Milestone","MILESTONES":"Milestones","PERSONAL_MILESTONE":"Personal milestone","PERSONAL_MILESTONES":"Personal milestones","COMMON_MILESTONE":"General milestone","COMMON_MILESTONES":"General milestones","ADD_PERSONAL_MILESTONE":"Add personal milestone","EDIT_PERSONAL_MILESTONE":"Edit personal milestone","ADD_COMMON_MILESTONE":"Add general milestone","EDIT_COMMON_MILESTONE":"Edit general milestone","STARTING":"Starting","STARTED":"Started","PLANNED":"Planned","ESTIMATED":"Estimated","STARTED_FROM_GRANTING_STUDY_RIGHT":"Started <0>{{ date }}</0> from granting study right","STARTED_AT_THE_THESIS_COMMITTEE_MEETING_HELD_ON":"Started at the thesis committee meeting held on <0>{{ date }}</0>","BEGIN_AT_THE_THESIS_COMMITTEE_MEETING_HELD_ON":"Begins at the thesis committee meeting held on <0>{{ date }}</0>","BEGIN_AT_THE_MEETING_ESTIMATED_TO_BE_HELD_ON":"Begins at the meeting estimated to be held on <0>{{ date }}</0>","EACH_CHAPTER_REPRESENTS_THE_TIME_PERIOD":"Each chapter represents the time period between two thesis committee meetings.","OVERVIEW":"Overview","NO_MILESTONES_IN_THE_PLAN_FOR_THE_CHAPTER_YET":"No milestones in the plan for the chapter yet.","VIEW_CHAPTERS":"View chapters","EDIT_MILESTONES":"Edit milestones","CUSTOM_MILESTONES_CREATED_BY_THE_USER":"Custom milestones created by the user. You can add as many personal milestones as you like and assign them to any chapter.","A_PREDEFINED_SET_OF_MILESTONES_THAT_MUST_BE_ASSIGNED":"A predefined set of milestones, each of which must be placed in any chapter.","STUDY_RIGHT_GRANTED":"Study right granted","ADD_ITEM":"Add item <0>to chapter {{ id }}</0>","ITEM":"item","ITEM_other":"items","MILESTONE_DESCRIPTION":"Milestone description","MOVE":"Move","OPEN_CONTEXT_MENU":"Open context menu for \\"{{ milestone }}\\" milestone","CONTEXT_MENU":"Context menu","SET_AS_COMPLETED":"Set as completed","COMMON":"General","PERSONAL":"Personal","ADDING_MILESTONE_FAILED_WITH_ERROR_CODE":"Adding milestone failed with error code","UPDATING_MILESTONE_FAILED_WITH_ERROR_CODE":"Updating milestone failed with error code","DELETING_MILESTONE_FAILED_WITH_ERROR_CODE":"Deleting milestone failed with error code","MOVING_MILESTONE_FAILED_WITH_ERROR_CODE":"Moving milestone failed with error code","PRESSING_ENTER_ON_THE_KEYBOARD_WILL_ADD_THE_MILESTONE":"Pressing enter on the keyboard will add the milestone","ALL_COMMON_MILESTONES_HAVE_BEEN_ASSIGNED_TO_CHAPTERS":"All general milestones have been assigned to chapters","NO_COMMON_MILESTONES_AVAILABLE":"No general milestones available","INPUT_EXCEEDS_THE_CHARACTER_LIMIT":"Input exceeds the character limit of {{ maxLength }} characters","FILE_INPUT_EXCEEDS_THE_FILE_SIZE_LIMIT":"The file exceeds the maximum allowed size of {{ maxSizeMB }}\u202FMB","UNASSIGNED_COMMON_MILESTONES":"Following general milestones are not set for any chapter","UNASSIGNED_COMMON_MILESTONES_AMOUNT":"{{ amount }} general milestones are not set for any chapter","MOVE_TO_NEXT_CHAPTER":"Move to next chapter","MOVE_TO_PREVIOUS_CHAPTER":"Move to previous chapter","RETURN":"Return","USE_OF_GENERATIVE_ARTIFICIAL_INTELLIGENCE_IN_RESEARCH":"Use of Generative Artificial Intelligence","AI_RESEARCH":"Use of Generative Artificial Intelligence in Research \u2013 University of Helsinki","ARTIFICIAL_INTELLIGENCE_AI_SCIENCE":"Artificial Intelligence (AI) in Science \u2013 European Commission","IS_IN_PILOT":"Doctoral researcher participates in the fast doctoral pilot program","LATEST_PROGRESS_ESTIMATION":"Latest estimation of progress toward doctoral degree","NO_ACTIVE_STUDY_RIGHT":"No active study right","CONSORTIUM":"Consortium","NEXT_STEPS":{"TITLE":"Next steps","INTRO":{"CYCLIC":"A thesis committee meeting is held once a year, and a progress report is prepared for each meeting.","FAST":"A thesis committee meeting is held twice a year, and a progress report is prepared for each meeting.","LEGACY":"A progress report is submitted once a year."},"TIMING":{"SUBMISSION_WINDOW":"Submit it between {{startDate}} and {{endDate}} so it can be discussed at the thesis committee meeting.","SUBMISSION_WINDOW_OBSERVER":"The report should be submitted between {{startDate}} and {{endDate}} so it can be discussed at the thesis committee meeting.","MEETING_DATE":"The meeting is planned to be held on {{date}}.","REPORT_DEADLINE":"Submit it about a week before the thesis committee meeting on {{date}}, but no later than the meeting day.","REPORT_DEADLINE_OBSERVER":"The report should be submitted about a week before the thesis committee meeting on {{date}}, but no later than the meeting day.","REPORT_BEFORE_MEETING":"Submit it about a week before the thesis committee meeting.","REPORT_BEFORE_MEETING_OBSERVER":"The report should be submitted about a week before the thesis committee meeting."},"REPORT":{"SUBMIT_STUDENT":"Submit a report describing the progress of your doctoral project.","SUBMIT_OBSERVER":"The doctoral researcher needs to submit their report.","CONCLUSION_STUDENT":"Write a conclusion for the report based on what was discussed at the thesis committee meeting.","CONCLUSION_OBSERVER":"The doctoral researcher writes a conclusion for the report based on what was discussed at the thesis committee meeting.","FEEDBACK_REMINDER":"A report was completed recently \u2014 it\'s time to give progress feedback.","SUBMIT_LABEL":"Submit report","CONCLUSION_LABEL":"Write conclusion"},"MEETING":{"PLAN_STUDENT":"Schedule your next thesis committee meeting.","PLAN_OBSERVER":"A thesis committee meeting should be scheduled.","ATTEND_STUDENT":"Hold your thesis committee meeting. Go through your doctoral project\'s progress with the help of your report.","ATTEND_OBSERVER":"The thesis committee meeting is held to discuss the doctoral researcher\'s progress and report.","ATTEND_LATE_STUDENT":"Your thesis committee meeting is overdue. Hold it now.","ATTEND_LATE_OBSERVER":"The thesis committee meeting is overdue and should be held.","LATE_STUDENT":"It has been over {{months}} months since the last meeting and no new meetings are scheduled. You should schedule one now.","LATE_OBSERVER":"It has been over {{months}} months since the last meeting and no new meetings are scheduled. The doctoral researcher should schedule one now.","SCHEDULE_LABEL":"Schedule meeting","ATTEND_LABEL":"Hold meeting"}},"REPORTING":{"TITLE":"Reporting"},"COURSE":{"NOT_EDITABLE":"Study unit is imported from Sisu, therefore it cannot be edited in Thessa"}}');

});

parcelRegister("1BX32", function(module, exports) {
//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof

(function(global, factory) {
    factory((parcelRequire("5AAkb")));
})(module.exports, function(moment) {
    'use strict';
    //! moment.js locale configuration
    var numbersPast = "nolla yksi kaksi kolme nelj\xe4 viisi kuusi seitsem\xe4n kahdeksan yhdeks\xe4n".split(' '), numbersFuture = [
        'nolla',
        'yhden',
        'kahden',
        'kolmen',
        "nelj\xe4n",
        'viiden',
        'kuuden',
        numbersPast[7],
        numbersPast[8],
        numbersPast[9]
    ];
    function translate(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch(key){
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'ss':
                result = isFuture ? 'sekunnin' : 'sekuntia';
                break;
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? "p\xe4iv\xe4n" : "p\xe4iv\xe4";
            case 'dd':
                result = isFuture ? "p\xe4iv\xe4n" : "p\xe4iv\xe4\xe4";
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10 ? isFuture ? numbersFuture[number] : numbersPast[number] : number;
    }
    var fi = moment.defineLocale('fi', {
        months: "tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kes\xe4kuu_hein\xe4kuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu".split('_'),
        monthsShort: "tammi_helmi_maalis_huhti_touko_kes\xe4_hein\xe4_elo_syys_loka_marras_joulu".split('_'),
        weekdays: 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM[ta] YYYY',
            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l: 'D.M.YYYY',
            ll: 'Do MMM YYYY',
            lll: 'Do MMM YYYY, [klo] HH.mm',
            llll: 'ddd, Do MMM YYYY, [klo] HH.mm'
        },
        calendar: {
            sameDay: "[t\xe4n\xe4\xe4n] [klo] LT",
            nextDay: '[huomenna] [klo] LT',
            nextWeek: 'dddd [klo] LT',
            lastDay: '[eilen] [klo] LT',
            lastWeek: '[viime] dddd[na] [klo] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: "%s p\xe4\xe4st\xe4",
            past: '%s sitten',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4
        }
    });
    return fi;
});

});

parcelRegister("jYIEP", function(module, exports) {
//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

(function(global, factory) {
    factory((parcelRequire("5AAkb")));
})(module.exports, function(moment) {
    'use strict';
    //! moment.js locale configuration
    var sv = moment.defineLocale('sv', {
        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: "s\xf6ndag_m\xe5ndag_tisdag_onsdag_torsdag_fredag_l\xf6rdag".split('_'),
        weekdaysShort: "s\xf6n_m\xe5n_tis_ons_tors_fre_l\xf6r".split('_'),
        weekdaysMin: "s\xf6_m\xe5_ti_on_to_fr_l\xf6".split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd D MMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: "[Ig\xe5r] LT",
            nextWeek: "[P\xe5] dddd LT",
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'om %s',
            past: "f\xf6r %s sedan",
            s: "n\xe5gra sekunder",
            ss: '%d sekunder',
            m: 'en minut',
            mm: '%d minuter',
            h: 'en timme',
            hh: '%d timmar',
            d: 'en dag',
            dd: '%d dagar',
            M: "en m\xe5nad",
            MM: "%d m\xe5nader",
            y: "ett \xe5r",
            yy: "%d \xe5r"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
        ordinal: function(number) {
            var b = number % 10, output = ~~(number % 100 / 10) === 1 ? ':e' : b === 1 ? ':a' : b === 2 ? ':a' : b === 3 ? ':e' : ':e';
            return number + output;
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    return sv;
});

});




parcelRegister("aOv8q", function(module, exports) {

$parcel$export(module.exports, "logInAction", function () { return $7df6b9a09a7dd814$export$8c7ecc1a2dd632f; });
$parcel$export(module.exports, "logOutAction", function () { return $7df6b9a09a7dd814$export$1a3865346be34527; });
$parcel$export(module.exports, "requestPasswordResetEmail", function () { return $7df6b9a09a7dd814$export$4f7758d35d8372e9; });
$parcel$export(module.exports, "resetPassword", function () { return $7df6b9a09a7dd814$export$dc726c8e334dd814; });
$parcel$export(module.exports, "loadAuthStatus", function () { return $7df6b9a09a7dd814$export$dbd639d1825c28d7; });

var $4D64z = parcelRequire("4D64z");
const $7df6b9a09a7dd814$export$8c7ecc1a2dd632f = new (0, (/*@__PURE__*/$parcel$interopDefault($4D64z))).Bus();
const $7df6b9a09a7dd814$export$1a3865346be34527 = new (0, (/*@__PURE__*/$parcel$interopDefault($4D64z))).Bus();
const $7df6b9a09a7dd814$export$4f7758d35d8372e9 = new (0, (/*@__PURE__*/$parcel$interopDefault($4D64z))).Bus();
const $7df6b9a09a7dd814$export$dc726c8e334dd814 = new (0, (/*@__PURE__*/$parcel$interopDefault($4D64z))).Bus();
const $7df6b9a09a7dd814$export$dbd639d1825c28d7 = new (0, (/*@__PURE__*/$parcel$interopDefault($4D64z))).Bus();

});

parcelRegister("EgKdY", function(module, exports) {

$parcel$export(module.exports, "signedUp", function () { return $0790b9a94f680f7a$export$4d4dc3115ed3c3e1; });

var $4D64z = parcelRequire("4D64z");
const $0790b9a94f680f7a$export$4d4dc3115ed3c3e1 = new (0, $4D64z.Bus)();

});

parcelRegister("bTAuY", function(module, exports) {

$parcel$export(module.exports, "saveProfileResponse", function () { return $8a91249c52697feb$export$6740bbb7d0a63516; });

var $R2YAC = parcelRequire("R2YAC");

var $U31uw = parcelRequire("U31uw");
const $8a91249c52697feb$export$6740bbb7d0a63516 = (0, $R2YAC.saveProfile).flatMap((user)=>(0, $U31uw.ajaxPutJSON)(`/rest/users/${user.id}`, user));

});
parcelRegister("R2YAC", function(module, exports) {

$parcel$export(module.exports, "saveProfile", function () { return $09f7425f9bbebe1b$export$c24b1bb8dcb54b7f; });

var $4D64z = parcelRequire("4D64z");
const $09f7425f9bbebe1b$export$c24b1bb8dcb54b7f = new (0, $4D64z.Bus)();

});


parcelRegister("lSubk", function(module, exports) {

$parcel$export(module.exports, "Role", function () { return $fed60d9533d15287$export$46919bad18fb2f76; });
var $fed60d9533d15287$export$46919bad18fb2f76;
(function(Role) {
    Role["DOCTORAL_CANDIDATE"] = "doctoral-candidate";
    Role["CYCLIC_DOCTORAL_CANDIDATE"] = "cyclic-doctoral-candidate";
    Role["FAST_DOCTORAL_CANDIDATE"] = "fast-doctoral-candidate";
    Role["LEGACY_DOCTORAL_CANDIDATE"] = "legacy-doctoral-candidate";
    Role["COORDINATING_ACADEMIC"] = "coordinating-academic";
    Role["MAIN_SUPERVISOR"] = "main-supervisor";
    Role["SUPERVISOR"] = "supervisor";
    Role["THESIS_COMMITTEE_MEMBER"] = "thesis-committee-member";
    Role["SALARY_SYSTEM_FOREMAN"] = "salary-system-foreman";
    Role["COORDINATOR"] = "coordinator";
})($fed60d9533d15287$export$46919bad18fb2f76 || ($fed60d9533d15287$export$46919bad18fb2f76 = {}));

});


parcelRegister("aOwwP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7df7ce5b410fe23f$export$2e2bcd8739ae039; });

var $caZvI = parcelRequire("caZvI");

var $3da5u = parcelRequire("3da5u");
parcelRequire("jpgPw");

var $b9h0p = parcelRequire("b9h0p");

var $2eqHs = parcelRequire("2eqHs");

var $hSeA2 = parcelRequire("hSeA2");

var $1Hynf = parcelRequire("1Hynf");

var $c3mfK = parcelRequire("c3mfK");

var $cVY6z = parcelRequire("cVY6z");

var $b1LPP = parcelRequire("b1LPP");
const $7df7ce5b410fe23f$var$Navigation = ({ id: id, isLoading: isLoading, isCollapsed: isCollapsed, items: items, className: className })=>{
    const { t: t } = (0, $2eqHs.useTranslation)();
    const isItemActive = (item)=>!!location && item.isActive?.test(location.pathname);
    return (0, $caZvI.jsx)($7df7ce5b410fe23f$var$Nav, {
        id: id,
        "$collapsed": isCollapsed,
        "$isLoading": isLoading,
        "aria-hidden": isCollapsed,
        className: className,
        "aria-label": t((0, $b1LPP.default).MAIN_MENU),
        children: (0, $caZvI.jsx)($7df7ce5b410fe23f$var$List, {
            children: !isLoading && items.map((navigationItem, key)=>(0, $caZvI.jsx)($7df7ce5b410fe23f$var$Item, {
                    children: (0, $caZvI.jsxs)($7df7ce5b410fe23f$var$NavigationLink, {
                        to: navigationItem.path,
                        onClick: navigationItem.onClickFunction,
                        "aria-current": isItemActive(navigationItem) ? 'page' : false,
                        children: [
                            navigationItem.icon && (0, $caZvI.jsx)($7df7ce5b410fe23f$var$Icon, {
                                [navigationItem.icon]: true
                            }),
                            (0, $caZvI.jsx)("span", {
                                children: navigationItem.title
                            })
                        ]
                    })
                }, key))
        })
    });
};
const $7df7ce5b410fe23f$var$Nav = (0, $3da5u.default).nav`
  background-color: ${(0, $hSeA2.GRAYSCALE_WHITE)};
  margin: 0;
  padding: 0;
  gap: 2px;
  overflow: visible;
  transition:
    opacity 0.2s,
    transform 0.2s;

  ${({ $isLoading: $isLoading })=>$isLoading && (0, $3da5u.css)`
      opacity: 0;
    `}
`;
const $7df7ce5b410fe23f$var$List = (0, $3da5u.default).ul`
  margin: 0;
  padding: 0;

  ${(0, $1Hynf.fromTabletUp)((0, $3da5u.css)`
    gap: 4px;
    overflow: auto;
    display: flex;
    flex-flow: row wrap;
  `)}
`;
const $7df7ce5b410fe23f$var$Item = (0, $3da5u.default).li`
  list-style: none;
`;
const $7df7ce5b410fe23f$var$NavigationLink = (0, $3da5u.default)((0, $b9h0p.Link))`
  position: relative;
  ${(0, $cVY6z.LinkStyles)()}
  ${({ 'aria-current': ariaCurrent })=>(0, $cVY6z.LinkInteractionStyles)(ariaCurrent)}
`;
const $7df7ce5b410fe23f$var$Icon = (0, $3da5u.default)((0, $c3mfK.HyIcon))`
  position: relative;
  font-size: 18px;
`;
var $7df7ce5b410fe23f$export$2e2bcd8739ae039 = $7df7ce5b410fe23f$var$Navigation;

});
parcelRegister("cVY6z", function(module, exports) {

$parcel$export(module.exports, "LinkStyles", function () { return $96a96e7ed99c6046$export$10b6eba3c5b6ca23; });
$parcel$export(module.exports, "LinkInteractionStyles", function () { return $96a96e7ed99c6046$export$c790817447d6abeb; });

var $3da5u = parcelRequire("3da5u");

var $1Hynf = parcelRequire("1Hynf");

var $hSeA2 = parcelRequire("hSeA2");
const $96a96e7ed99c6046$export$10b6eba3c5b6ca23 = (small)=>(0, $3da5u.css)`
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  color: ${0, $hSeA2.BRAND_MAIN_NEARLY_BLACK};
  font-weight: bold;
  text-transform: uppercase;
  padding: 12px 16px;
  border-radius: 100px;

  ${(0, $1Hynf.fromPhoneUp)((0, $3da5u.css)`
    gap: 12px;
  `)}

  ${small && (0, $3da5u.css)`
      padding: 8px 16px;
    `}

  &:focus,
  &:hover,
  &:active {
    color: ${0, $hSeA2.BRAND_MAIN_NEARLY_BLACK};
    text-decoration: none;
  }
`;
const $96a96e7ed99c6046$export$c790817447d6abeb = (current = false)=>(0, $3da5u.css)`
  &:before {
    content: '';
    position: absolute;
    inset: 4px 2px;
    background-color: ${0, $hSeA2.GRAYSCALE_MEDIUM};
    opacity: 0;
    transition:
      opacity 0.1s,
      0.1s transform 0.1s;
    border-radius: 16px;
    transform: scale(0.75);

    ${(0, $1Hynf.fromPhoneUp)((0, $3da5u.css)`
      inset: 6px 4px;
    `)}
  }

  @media (hover: hover) {
    &:hover:not(:disabled) {
      color: ${0, $hSeA2.BRAND_MAIN_NEARLY_BLACK};
      text-decoration: none;

      &:before {
        opacity: 0.5;
        transform: scale(1);
        transition:
          opacity 0.2s,
          transform 0.1s;
      }
    }
  }

  &:active:not(:disabled) {
    &:before {
      opacity: 0.36;
      transform: scale(0.96);
    }
  }

  &:disabled {
    color: ${0, $hSeA2.GRAYSCALE_MEDIUM_TEXT};
    cursor: not-allowed;
  }

  ${current && (0, $3da5u.css)`
      &:before {
        opacity: 0.5;
        transform: scale(1);
        transition:
          opacity 0.2s,
          transform 0.1s;
      }

      @media (hover: hover) {
        &:hover:not(:disabled) {
          &:before {
            opacity: 0.54;
            transform: scale(1.04);
          }
        }
      }

      &:active:not(:disabled) {
        &:before {
          opacity: 0.36;
          transform: scale(0.96);
        }
      }
    `}

  & > * {
    position: relative;
  }
`;

});


parcelRegister("ig0WQ", function(module, exports) {

$parcel$export(module.exports, "DropdownStyles", function () { return $d4aa74e61bfc9b36$export$37b661aa637217be; });

var $3da5u = parcelRequire("3da5u");

var $1Hynf = parcelRequire("1Hynf");

var $hSeA2 = parcelRequire("hSeA2");
const $d4aa74e61bfc9b36$export$37b661aa637217be = (alignment, small)=>(0, $3da5u.css)`
  background-color: ${0, $hSeA2.GRAYSCALE_WHITE};
  position: absolute;
  padding: 0;
  border: 1px solid ${0, $hSeA2.GRAYSCALE_MEDIUM};
  box-shadow: 0 10px 20px 0 rgb(0 0 0 / 20%);
  padding: ${small ? '6px 4px' : '12px 8px'};
  top: calc(100% + 6px);

  ${(0, $1Hynf.fromPhoneUp)((0, $3da5u.css)`
    top: calc(100%);
  `)}

  ${(0, $1Hynf.fromTabletUp)((0, $3da5u.css)`
    top: calc(100% + 12px);
  `)}

  ${alignment === 'static' && (0, $3da5u.css)`
      position: relative;
      top: 0;
    `}

  ${alignment === 'bottomLeft' && (0, $3da5u.css)`
      left: 12px;
      right: 12px;

      ${(0, $1Hynf.fromPhoneUp)((0, $3da5u.css)`
        left: 12px;
        right: auto;
      `)}

      ${(0, $1Hynf.fromTabletUp)((0, $3da5u.css)`
        left: -18px;
        right: auto;
      `)}

    ${(0, $1Hynf.fromDesktopUp)((0, $3da5u.css)`
        left: -36px;
        right: auto;
      `)}
    `}

  ${alignment === 'bottomRight' && (0, $3da5u.css)`
      left: 12px;
      right: 12px;

      ${(0, $1Hynf.fromPhoneUp)((0, $3da5u.css)`
        left: auto;
        right: 12px;
      `)}

      ${(0, $1Hynf.fromTabletUp)((0, $3da5u.css)`
        left: auto;
        right: -18px;
      `)}

    ${(0, $1Hynf.fromDesktopUp)((0, $3da5u.css)`
        left: auto;
        right: -36px;
      `)}
    `}

  &:before {
    content: '';
    width: 12px;
    height: 12px;
    position: absolute;
    background-color: ${0, $hSeA2.GRAYSCALE_WHITE};

    ${alignment === 'static' && (0, $3da5u.css)`
        display: none;
      `}

    ${alignment === 'top' && (0, $3da5u.css)`
        top: auto;
        left: 50%;
        bottom: 0px;
        border-top: none;
        border-bottom: 1px solid ${0, $hSeA2.GRAYSCALE_MEDIUM};
        border-left: 1px solid ${0, $hSeA2.GRAYSCALE_MEDIUM};
        transform: translateY(7px) translateX(-50%) rotate(-45deg);
      `}

    ${alignment === 'bottom' && (0, $3da5u.css)`
        top: 0;
        left: 50%;
        border-top: 1px solid ${0, $hSeA2.GRAYSCALE_MEDIUM};
        border-left: 1px solid ${0, $hSeA2.GRAYSCALE_MEDIUM};
        transform: translateY(-7px) translateX(-50%) rotate(45deg);
      `}

    ${alignment === 'bottomLeft' && (0, $3da5u.css)`
        top: 0;
        left: 32px;
        right: auto;
        border-top: 1px solid ${0, $hSeA2.GRAYSCALE_MEDIUM};
        border-left: 1px solid ${0, $hSeA2.GRAYSCALE_MEDIUM};
        transform: translateY(-7px) translateX(-50%) rotate(45deg);

        ${(0, $1Hynf.fromPhoneUp)((0, $3da5u.css)`
          left: 48px;
          right: auto;
        `)}

        ${(0, $1Hynf.fromTabletUp)((0, $3da5u.css)`
          left: 32px;
          right: auto;
        `)}
      `}

    ${alignment === 'bottomRight' && (0, $3da5u.css)`
        top: 0;
        left: auto;
        right: 32px;
        border-top: 1px solid ${0, $hSeA2.GRAYSCALE_MEDIUM};
        border-left: 1px solid ${0, $hSeA2.GRAYSCALE_MEDIUM};
        transform: translateY(-7px) translateX(-50%) rotate(45deg);

        ${(0, $1Hynf.fromPhoneUp)((0, $3da5u.css)`
          left: auto;
          right: 48px;
        `)}

        ${(0, $1Hynf.fromTabletUp)((0, $3da5u.css)`
          left: auto;
          right: 32px;
        `)}
      `}

    ${alignment === 'left' && (0, $3da5u.css)`
        top: 50%;
        left: auto;
        right: 0px;
        border-bottom: 1px solid ${0, $hSeA2.GRAYSCALE_MEDIUM};
        border-right: 1px solid ${0, $hSeA2.GRAYSCALE_MEDIUM};
        transform: translateY(-50%) translateX(7px) rotate(-45deg);
      `}

    ${alignment === 'right' && (0, $3da5u.css)`
        top: 50%;
        left: 0px;
        border-top: 1px solid ${0, $hSeA2.GRAYSCALE_MEDIUM};
        border-left: 1px solid ${0, $hSeA2.GRAYSCALE_MEDIUM};
        transform: translateY(-50%) translateX(-7px) rotate(-45deg);
      `}
  }
`;

});

parcelRegister("kPFSZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2a90fb7b8d520b4$export$2e2bcd8739ae039; });

var $caZvI = parcelRequire("caZvI");

var $2eqHs = parcelRequire("2eqHs");

var $3da5u = parcelRequire("3da5u");

var $b1LPP = parcelRequire("b1LPP");
parcelRequire("jpgPw");

var $b9h0p = parcelRequire("b9h0p");

var $aOv8q = parcelRequire("aOv8q");

var $hSeA2 = parcelRequire("hSeA2");

var $1Hynf = parcelRequire("1Hynf");

var $c3mfK = parcelRequire("c3mfK");

var $cVY6z = parcelRequire("cVY6z");

var $ig0WQ = parcelRequire("ig0WQ");
const $f2a90fb7b8d520b4$var$Profile = ({ isLoading: isLoading, isLoggedIn: isLoggedIn, isCollapsed: isCollapsed, setIsCollapsed: setIsCollapsed, name: name, items: items, collapseAll: collapseAll, className: className })=>{
    const { t: t } = (0, $2eqHs.useTranslation)();
    const isItemActive = (item)=>!!location && item.isActive?.test(location.pathname);
    const hasActiveItem = (items)=>items.map((item)=>isItemActive(item)).some((item)=>item);
    const ButtonText = isLoggedIn ? name ?? t((0, $b1LPP.default).PROFILE1) : t((0, $b1LPP.default).LOGIN);
    const ButtonTextTruncated = ButtonText.split(/-| /)[0];
    return (0, $caZvI.jsxs)($f2a90fb7b8d520b4$var$Wrapper, {
        "$isLoading": isLoading,
        className: className,
        children: [
            (0, $caZvI.jsxs)($f2a90fb7b8d520b4$var$ProfileButton, {
                id: 'profileMenuButton',
                onClick: ()=>{
                    collapseAll();
                    setIsCollapsed(!isCollapsed);
                },
                "aria-expanded": !isCollapsed,
                "aria-controls": 'profileNavigation',
                "aria-label": isCollapsed ? `${ButtonText} - ${t((0, $b1LPP.default).OPEN_PROFILE_MENU)}` : `${ButtonText} - ${t((0, $b1LPP.default).CLOSE_PROFILE_MENU)}`,
                "$active": !isCollapsed || hasActiveItem(items),
                children: [
                    (0, $caZvI.jsx)($f2a90fb7b8d520b4$var$Avatar, {
                        children: (0, $caZvI.jsx)($f2a90fb7b8d520b4$var$AvatarIcon, {
                            avatar: true
                        })
                    }),
                    (0, $caZvI.jsx)($f2a90fb7b8d520b4$var$ProfileButtonTextDesktop, {
                        children: ButtonText
                    }),
                    (0, $caZvI.jsx)($f2a90fb7b8d520b4$var$ProfileButtonTextMobile, {
                        children: ButtonTextTruncated
                    }),
                    (0, $caZvI.jsx)($f2a90fb7b8d520b4$var$CaretDown, {
                        caretDown: true
                    })
                ]
            }),
            (0, $caZvI.jsx)($f2a90fb7b8d520b4$var$ProfileNavigation, {
                id: 'profileNavigation',
                "$isCollapsed": isCollapsed,
                "aria-hidden": isCollapsed,
                "aria-label": t((0, $b1LPP.default).PROFILE_MENU),
                children: (0, $caZvI.jsxs)($f2a90fb7b8d520b4$var$ProfileList, {
                    children: [
                        items.map((profileItem, key)=>(0, $caZvI.jsx)($f2a90fb7b8d520b4$var$ProfileItem, {
                                children: (0, $caZvI.jsxs)($f2a90fb7b8d520b4$var$ProfileLink, {
                                    to: profileItem.path,
                                    onClick: profileItem.onClickFunction,
                                    "aria-current": isItemActive(profileItem) ? 'page' : false,
                                    children: [
                                        profileItem.icon && (0, $caZvI.jsx)($f2a90fb7b8d520b4$var$ProfileIcon, {
                                            [profileItem.icon]: true
                                        }),
                                        (0, $caZvI.jsx)($f2a90fb7b8d520b4$var$ProfileText, {
                                            children: profileItem.title
                                        })
                                    ]
                                })
                            }, key)),
                        isLoggedIn && (0, $caZvI.jsx)($f2a90fb7b8d520b4$var$ProfileItem, {
                            children: (0, $caZvI.jsxs)($f2a90fb7b8d520b4$var$Logout, {
                                id: 'logoutButton',
                                type: "button",
                                onClick: ()=>(0, $aOv8q.logOutAction).push(undefined),
                                children: [
                                    (0, $caZvI.jsx)($f2a90fb7b8d520b4$var$ProfileIcon, {
                                        logout: true
                                    }),
                                    (0, $caZvI.jsx)($f2a90fb7b8d520b4$var$ProfileText, {
                                        children: t((0, $b1LPP.default).LOG_OUT)
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const $f2a90fb7b8d520b4$var$Wrapper = (0, $3da5u.default).div`
  transition: opacity 0.2s;

  ${(0, $1Hynf.fromTabletUp)((0, $3da5u.css)`
    position: relative;
  `)}

  ${({ $isLoading: $isLoading })=>$isLoading && (0, $3da5u.css)`
      opacity: 0;
    `}
`;
const $f2a90fb7b8d520b4$var$ProfileButton = (0, $3da5u.default).button`
  position: relative;
  appearance: none;
  background: none;
  border: 0;
  ${(0, $cVY6z.LinkStyles)()}
  font-size: 12px;
  justify-content: flex-end;
  ${({ $active: $active })=>(0, $cVY6z.LinkInteractionStyles)($active)}
  margin-inline-end: -12px;

  ${(0, $1Hynf.fromPhoneUp)((0, $3da5u.css)`
    font-size: 14px;
  `)}
`;
const $f2a90fb7b8d520b4$var$ProfileButtonTextDesktop = (0, $3da5u.default).span`
  display: none;

  ${(0, $1Hynf.fromTabletUp)((0, $3da5u.css)`
    display: block;
  `)}
`;
const $f2a90fb7b8d520b4$var$ProfileButtonTextMobile = (0, $3da5u.default).span`
  display: block;

  ${(0, $1Hynf.fromTabletUp)((0, $3da5u.css)`
    display: none;
  `)}
`;
const $f2a90fb7b8d520b4$var$Avatar = (0, $3da5u.default).div`
  background-color: ${(0, $hSeA2.BRAND_MAIN_NEARLY_BLACK)};
  border-radius: 100px;
  box-shadow: 0 0 0 2px ${(0, $hSeA2.BRAND_MAIN_NEARLY_BLACK)};
  width: 12px;
  height: 12px;
  display: flex;
  align-items: center;
  justify-content: center;

  ${(0, $1Hynf.fromPhoneUp)((0, $3da5u.css)`
    width: 18px;
    height: 18px;
    margin-right: 8px;
  `)}
`;
const $f2a90fb7b8d520b4$var$AvatarIcon = (0, $3da5u.default)((0, $c3mfK.HyIcon))`
  font-size: 12px;
  color: ${(0, $hSeA2.GRAYSCALE_WHITE)};
  padding-bottom: 2px;

  ${(0, $1Hynf.fromPhoneUp)((0, $3da5u.css)`
    font-size: 18px;
  `)}
`;
const $f2a90fb7b8d520b4$var$CaretDown = (0, $3da5u.default)((0, $c3mfK.HyIcon))`
  font-size: 10px;
`;
const $f2a90fb7b8d520b4$var$ProfileNavigation = (0, $3da5u.default).nav`
  ${({ $isCollapsed: $isCollapsed })=>$isCollapsed && (0, $3da5u.css)`
      display: none;
    `}
`;
const $f2a90fb7b8d520b4$var$ProfileList = (0, $3da5u.default).ul`
  ${(0, $ig0WQ.DropdownStyles)('bottomRight')}
`;
const $f2a90fb7b8d520b4$var$ProfileItem = (0, $3da5u.default).li`
  list-style: none;

  &:not(:only-child):last-child {
    position: relative;

    &:before {
      content: '';
      position: absolute;
      top: -6px;
      right: 12px;
      left: 12px;
      height: 1px;
      background-color: ${(0, $hSeA2.GRAYSCALE_MEDIUM)};
    }
  }
`;
const $f2a90fb7b8d520b4$var$ProfileLink = (0, $3da5u.default)((0, $b9h0p.Link))`
  ${(0, $cVY6z.LinkStyles)()}
  ${({ 'aria-current': ariaCurrent })=>(0, $cVY6z.LinkInteractionStyles)(ariaCurrent)}

  ${$f2a90fb7b8d520b4$var$ProfileItem}:not(:only-child):nth-last-child(2) > & {
    margin-bottom: 12px;
  }
`;
const $f2a90fb7b8d520b4$var$ProfileIcon = (0, $3da5u.default)((0, $c3mfK.HyIcon))`
  font-size: 18px;
`;
const $f2a90fb7b8d520b4$var$Logout = (0, $3da5u.default).button`
  width: 100%;
  appearance: none;
  background: none;
  border: 0;
  ${(0, $cVY6z.LinkStyles)()}
  ${(0, $cVY6z.LinkInteractionStyles)()}
  white-space: nowrap;
  text-align: start;
`;
const $f2a90fb7b8d520b4$var$ProfileText = (0, $3da5u.default).span``;
var $f2a90fb7b8d520b4$export$2e2bcd8739ae039 = $f2a90fb7b8d520b4$var$Profile;

});

parcelRegister("jIMj0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e5b798e1998e4b20$export$2e2bcd8739ae039; });

var $caZvI = parcelRequire("caZvI");

var $2eqHs = parcelRequire("2eqHs");

var $3da5u = parcelRequire("3da5u");

var $b1LPP = parcelRequire("b1LPP");
parcelRequire("jpgPw");

var $hSeA2 = parcelRequire("hSeA2");

var $1Hynf = parcelRequire("1Hynf");

var $cVY6z = parcelRequire("cVY6z");
const $e5b798e1998e4b20$var$ToggleButton = ({ isCollapsed: isCollapsed, setIsCollapsed: setIsCollapsed, collapseAll: collapseAll, controls: controls, className: className })=>{
    const { t: t } = (0, $2eqHs.useTranslation)();
    return (0, $caZvI.jsxs)($e5b798e1998e4b20$var$Button, {
        onClick: ()=>{
            collapseAll();
            setIsCollapsed(!isCollapsed);
        },
        className: className,
        "aria-expanded": !isCollapsed,
        "aria-controls": controls,
        "aria-label": isCollapsed ? t((0, $b1LPP.default).OPEN_MAIN_MENU) : t((0, $b1LPP.default).CLOSE_MAIN_MENU),
        children: [
            (0, $caZvI.jsxs)($e5b798e1998e4b20$var$Bars, {
                children: [
                    (0, $caZvI.jsx)($e5b798e1998e4b20$var$Bar, {}),
                    (0, $caZvI.jsx)($e5b798e1998e4b20$var$Bar, {}),
                    (0, $caZvI.jsx)($e5b798e1998e4b20$var$Bar, {})
                ]
            }),
            (0, $caZvI.jsx)($e5b798e1998e4b20$var$MenuText, {
                children: t((0, $b1LPP.default).MENU)
            })
        ]
    });
};
const $e5b798e1998e4b20$var$Button = (0, $3da5u.default).button`
  appearance: none;
  background: none;
  border: 0;
  ${(0, $cVY6z.LinkStyles)()}
  font-size: 12px;
  ${({ 'aria-expanded': active })=>(0, $cVY6z.LinkInteractionStyles)(active)}

  ${(0, $1Hynf.fromPhoneUp)((0, $3da5u.css)`
    font-size: 14px;
  `)}
`;
const $e5b798e1998e4b20$var$Bars = (0, $3da5u.default).div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  align-items: stretch;
  gap: 2px;
  width: 18px;
  height: 12px;
`;
const $e5b798e1998e4b20$var$Bar = (0, $3da5u.default).span`
  background-color: ${(0, $hSeA2.BRAND_MAIN_NEARLY_BLACK)};
  flex: 1 1 auto;
  border-radius: 10px;
`;
const $e5b798e1998e4b20$var$MenuText = (0, $3da5u.default).div``;
var $e5b798e1998e4b20$export$2e2bcd8739ae039 = $e5b798e1998e4b20$var$ToggleButton;

});



parcelRegister("fwuoM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4d16cb3931bec77$export$2e2bcd8739ae039; });

var $caZvI = parcelRequire("caZvI");
parcelRequire("jpgPw");

var $2eqHs = parcelRequire("2eqHs");

var $b1LPP = parcelRequire("b1LPP");
const $b4d16cb3931bec77$var$LoadingIndicator = ({ id: id, className: className, children: children })=>{
    const { t: t } = (0, $2eqHs.useTranslation)();
    return (0, $caZvI.jsxs)("div", {
        id: id,
        className: className,
        children: [
            (0, $caZvI.jsx)("div", {
                className: "progress-indicator"
            }),
            " ",
            children || t((0, $b1LPP.default).LOADING_WITH_ELLIPSIS)
        ]
    });
};
var $b4d16cb3931bec77$export$2e2bcd8739ae039 = $b4d16cb3931bec77$var$LoadingIndicator;

});

parcelRegister("dQN7N", function(module, exports) {

$parcel$export(module.exports, "WindowWidthContext", function () { return $029a2a45a4c7eae7$export$7401abfd52109262; });
$parcel$export(module.exports, "WindowWidthContextProvider", function () { return $029a2a45a4c7eae7$export$e117f8d3664c8d60; });

var $caZvI = parcelRequire("caZvI");

var $jpgPw = parcelRequire("jpgPw");

var $1Hynf = parcelRequire("1Hynf");
const $029a2a45a4c7eae7$export$7401abfd52109262 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jpgPw))).createContext({
    isDesktopOrLarger: false,
    isLargeDesktopOrSmaller: false,
    isDesktopOrSmaller: false,
    isTabletOrSmaller: false,
    isPhoneOrSmaller: false,
    bootstrapContainerInnerWidth: 0
});
function $029a2a45a4c7eae7$export$bf99da6dabb41c73(width) {
    return {
        isDesktopOrLarger: width >= (0, $1Hynf.DESKTOP_MIN),
        isLargeDesktopOrSmaller: width < (0, $1Hynf.LARGE_DESKTOP_MIN),
        isDesktopOrSmaller: width < (0, $1Hynf.DESKTOP_MIN),
        isTabletOrSmaller: width <= (0, $1Hynf.TABLET_MAX),
        isPhoneOrSmaller: width <= (0, $1Hynf.PHONE_MAX),
        bootstrapContainerInnerWidth: $029a2a45a4c7eae7$var$getBootstrapContainerInnerWidth(width)
    };
}
const $029a2a45a4c7eae7$export$e117f8d3664c8d60 = ({ children: children })=>{
    const [windowWidth, setWindowWidth] = (0, $jpgPw.useState)($029a2a45a4c7eae7$export$bf99da6dabb41c73(window.innerWidth));
    const onResize = ()=>{
        setWindowWidth($029a2a45a4c7eae7$export$bf99da6dabb41c73(window.innerWidth));
    };
    (0, $jpgPw.useEffect)(()=>{
        onResize();
        window.addEventListener('resize', onResize);
        return ()=>window.removeEventListener('resize', onResize);
    }, []);
    return (0, $caZvI.jsx)($029a2a45a4c7eae7$export$7401abfd52109262.Provider, {
        value: windowWidth,
        children: children
    });
};
const $029a2a45a4c7eae7$var$horizontalContainerPadding = 30;
function $029a2a45a4c7eae7$var$getBootstrapContainerInnerWidth(windowWidth) {
    if (windowWidth < (0, $1Hynf.TABLET_MIN)) return windowWidth - $029a2a45a4c7eae7$var$horizontalContainerPadding;
    else if (windowWidth < (0, $1Hynf.DESKTOP_MIN)) return 750 - $029a2a45a4c7eae7$var$horizontalContainerPadding;
    else if (windowWidth < (0, $1Hynf.LARGE_DESKTOP_MIN)) return 970 - $029a2a45a4c7eae7$var$horizontalContainerPadding;
    else return 1170 - $029a2a45a4c7eae7$var$horizontalContainerPadding;
}

});

parcelRegister("gZCd7", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("8m0NT"))($parcel$resolve("cuM2L")),
    $parcel$import("iARsX"),
    $parcel$import("2hEDb"),
    $parcel$import("hDFC1")
]).then(()=>parcelRequire('5xmOX'));

});
parcelRegister("8m0NT", function(module, exports) {
"use strict";

var $4jfl8 = parcelRequire("4jfl8");
module.exports = $4jfl8(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("4jfl8", function(module, exports) {
"use strict";
var $3234d5f919caf8ee$var$cachedBundles = {};
var $3234d5f919caf8ee$var$cachedPreloads = {};
var $3234d5f919caf8ee$var$cachedPrefetches = {};
function $3234d5f919caf8ee$var$getCache(type) {
    switch(type){
        case 'preload':
            return $3234d5f919caf8ee$var$cachedPreloads;
        case 'prefetch':
            return $3234d5f919caf8ee$var$cachedPrefetches;
        default:
            return $3234d5f919caf8ee$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $3234d5f919caf8ee$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("d9j9z", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("iARsX"),
    $parcel$import("2hEDb"),
    $parcel$import("i2QsB")
]).then(()=>parcelRequire('5tHAU'));

});

parcelRegister("6Bahu", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("iARsX"),
    $parcel$import("43FT9")
]).then(()=>parcelRequire('d0lBY'));

});

parcelRegister("BcAtT", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("iARsX"),
    $parcel$import("2hEDb"),
    $parcel$import("9qjNT")
]).then(()=>parcelRequire('bY4j2'));

});

parcelRegister("eElnv", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("8m0NT"))($parcel$resolve("as1R0")),
    $parcel$import("8eHpN"),
    $parcel$import("2hEDb"),
    $parcel$import("6Dp1Z")
]).then(()=>parcelRequire('4bcNg'));

});

parcelRegister("bc8Kw", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("8m0NT"))($parcel$resolve("h4HYr")),
    $parcel$import("kt06Z")
]).then(()=>parcelRequire('5qRof'));

});

parcelRegister("11fjV", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("8m0NT"))($parcel$resolve("fRDg7")),
    $parcel$import("1fxbZ")
]).then(()=>parcelRequire('eubcw'));

});

parcelRegister("bflLj", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("8m0NT"))($parcel$resolve("gm7Nm")),
    $parcel$import("iARsX"),
    $parcel$import("2hEDb"),
    $parcel$import("iakSR")
]).then(()=>parcelRequire('6Ccg5'));

});

parcelRegister("kJh1S", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("8m0NT"))($parcel$resolve("h7jmK")),
    $parcel$import("iARsX"),
    $parcel$import("jx1gd")
]).then(()=>parcelRequire('3mqyy'));

});

var $c74601c85f374a88$exports = {};
$parcel$extendImportMap({
    "7olxG": "logo.fc8b8920.png",
    "hDFC1": "ThessaApplication.3d2deeec.js",
    "aCCMh": "background.1084a079.jpg",
    "lj3iP": "DoctoralCandidateOverviewRoutes.d2428201.js",
    "2yJUU": "Chapters.1869686a.js",
    "8z3bI": "EditPublication.c32dc30e.js",
    "3va5i": "ViewPublication.92bfa948.js",
    "1MzWT": "EditSalary.0b5d2c06.js",
    "5o9ok": "ViewSalary.ee2de4f1.js",
    "2vuLC": "EditGrant.a60f64fe.js",
    "9KZal": "ViewGrant.3d22fe30.js",
    "ldChO": "EditTeaching.5f6e1e30.js",
    "fqFcN": "ViewTeaching.c8795469.js",
    "jQ90X": "ViewSupervisionPlan.fc780c81.js",
    "jfFWl": "ViewSupervisionPlan.79f9a18e.css",
    "6YOO4": "ReportView.043eff48.js",
    "fp78F": "ReportView.644cbc44.js",
    "14yHu": "ReportView.fda5de77.css",
    "8hpwl": "CumulativeReport.7024d221.js",
    "2YUe3": "highlight-bullet-yellow.af4fdae4.svg",
    "jNlYF": "ConclusionManager.989a0939.js",
    "alEj8": "ReviewReport.cb21eb84.js",
    "4AEIO": "ConclusionFeedback.a976d40e.js",
    "g58ya": "ThesisCommittee.89fa5cf3.js",
    "1yUmf": "EditMeeting.58550e91.js",
    "3nE5Q": "ViewMeeting.379ef3dd.js",
    "dgLyA": "MyDoctoralCandidates.289a961f.js",
    "fw8Xb": "MyDoctoralCandidates.8c6f6864.js",
    "3y0Hs": "MyDoctoralCandidates.31f126eb.js",
    "fl9Wc": "DoctoralCandidateOverviewRoutes.6a356bfc.css",
    "b6uRT": "DoctoralCandidateOverviewRoutes.ab65608a.js",
    "8eHpN": "DoctoralCandidateOverviewRoutes.1b72ebc1.js",
    "lMJZi": "DoctoralCandidateOverviewRoutes.95c5c38a.js",
    "TBriH": "MyDoctoralCandidatesRoutes.bdad5ba5.js",
    "d01Ek": "CoordinatorRoutes.fbcac8b4.js",
    "7DI1F": "CoordinatorFrontPage.148becb0.js",
    "5vllX": "CoordinatorDoctoralCandidates.517246b7.js",
    "jHvu5": "SupervisorRelationships.7230b2b6.js",
    "7QKrV": "supervisor-relationships.ef3a4465.xlsx",
    "5sWVa": "SupervisorRelationships.7555a5d0.css",
    "h0kC3": "ReminderRoutes.926df0eb.js",
    "jqDw9": "ReminderDetails.0512bc73.js",
    "gjLIm": "ProfileRoutes.4d526f4c.js",
    "44v7x": "ProfileDetails.da229aa3.js",
    "hUmSu": "ProfileDetails.b78d9960.css",
    "fDUY5": "ProfileThesisCommittee.232e095a.js",
    "goP6U": "ProfileThesisCommittee.612da8f3.css",
    "7RR7D": "HelpIndex.8b7e6eeb.js",
    "jlFkx": "UsersRoutes.2e071257.js",
    "2CtP2": "UserManager.3545c3cf.js",
    "9Inhd": "UserDetailsRoutes.d238496e.js",
    "4yPxQ": "UserDetails.efb74f35.js",
    "95B5P": "icon-collapse.c6b4f72c.svg",
    "htZDs": "StatisticsRoutes.f43c4f0d.js",
    "1Z6yI": "Statistics.20532ed9.js",
    "leQ3x": "ReportingStatistics.0dbc822f.js",
    "6k7QS": "ListSupervisorsOfNotCompletedReports.68d2c792.js",
    "kGELy": "DownloadThessaAdminReport.622fc8d2.js",
    "2ht7h": "ReportConclusionsOverview.472485ef.js",
    "kngNr": "ReportConclusionsOverview.a59c8bdb.css",
    "2hEDb": "ThessaApplication.fcd58730.js",
    "iARsX": "ThessaApplication.f0244731.js",
    "cuM2L": "ThessaApplication.a427a556.css",
    "i2QsB": "ForgotPassword.1722c985.js",
    "43FT9": "ResetPassword.182beab6.js",
    "9qjNT": "Invitation.3fa0ed03.js",
    "6Dp1Z": "ViewRoar.f5c3394a.js",
    "as1R0": "ViewRoar.d25d0e10.css",
    "kt06Z": "About.0be3493c.js",
    "h4HYr": "About.2d3f1bb3.css",
    "1fxbZ": "Contact.e71251fb.js",
    "fRDg7": "Contact.04c0f48e.css",
    "iakSR": "AccessibilityStatement.f9a2b16c.js",
    "gm7Nm": "AccessibilityStatement.8950a544.css",
    "jx1gd": "Sitemap.6d940068.js",
    "h7jmK": "Sitemap.c1f27976.css"
});


var $caZvI = parcelRequire("caZvI");

var $jpgPw = parcelRequire("jpgPw");
var $0957aa571687c4d4$exports = {};
'use strict';
function $0957aa571687c4d4$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($0957aa571687c4d4$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$0957aa571687c4d4$var$checkDCE();

$0957aa571687c4d4$exports = (parcelRequire("k7KD3"));



var $2qbEs = parcelRequire("2qbEs");




var $hiCBt = parcelRequire("hiCBt");

var $caZvI = parcelRequire("caZvI");

var $jpgPw = parcelRequire("jpgPw");

var $caZvI = parcelRequire("caZvI");

var $2eqHs = parcelRequire("2eqHs");

var $3AnAR = parcelRequire("3AnAR");

var $2qbEs = parcelRequire("2qbEs");

var $jyFzD = parcelRequire("jyFzD");

var $b1LPP = parcelRequire("b1LPP");

var $eUJ8V = parcelRequire("eUJ8V");

var $fwuoM = parcelRequire("fwuoM");
parcelRequire("jpgPw");
const $d69535d6d57e217e$export$e98dd63ef181176d = ()=>{
    const { t: t } = (0, $2eqHs.useTranslation)();
    return (0, $caZvI.jsxs)((0, $3AnAR.default), {
        children: [
            (0, $caZvI.jsx)((0, $2qbEs.Helmet), {
                children: (0, $caZvI.jsx)("title", {
                    children: (0, $jyFzD.generatePageTitle)(t((0, $b1LPP.default).LOADING), t((0, $b1LPP.default).THESSA))
                })
            }),
            (0, $caZvI.jsx)((0, $eUJ8V.UniContainer), {
                "$wide": true,
                "$marginBlock": true,
                children: (0, $caZvI.jsx)((0, $fwuoM.default), {})
            })
        ]
    });
};



var $caZvI = parcelRequire("caZvI");

var $jpgPw = parcelRequire("jpgPw");

var $jyFzD = parcelRequire("jyFzD");
var $b1af6b1b1b129368$export$df35587a8f95f16f;
(function(FeatureFlag) {
    FeatureFlag["DummyFlag"] = "DummyFlag";
})($b1af6b1b1b129368$export$df35587a8f95f16f || ($b1af6b1b1b129368$export$df35587a8f95f16f = {}));
const $b1af6b1b1b129368$var$featureFlagQueryParameterKey = 'ff';
const $b1af6b1b1b129368$export$a94f9e4f07f0c0a6 = /*#__PURE__*/ (0, $jpgPw.createContext)({
    hasFeatureFlag: ()=>false
});
const $b1af6b1b1b129368$export$b76be5afdfbb7199 = ({ children: children })=>{
    const queryParameters = (0, $jyFzD.getQueryParameters)();
    const flags = queryParameters[$b1af6b1b1b129368$var$featureFlagQueryParameterKey] || [];
    const validFlags = flags.filter($b1af6b1b1b129368$var$isValidFeatureFlag);
    const hasFeatureFlag = (featureFlag)=>validFlags.includes(featureFlag);
    return (0, $caZvI.jsx)($b1af6b1b1b129368$export$a94f9e4f07f0c0a6.Provider, {
        value: {
            hasFeatureFlag: hasFeatureFlag
        },
        children: children
    });
};
function $b1af6b1b1b129368$var$isValidFeatureFlag(possibleFeatureFlag) {
    return Object.values($b1af6b1b1b129368$export$df35587a8f95f16f).includes(possibleFeatureFlag);
}



var $dQN7N = parcelRequire("dQN7N");

var $b9h0p = parcelRequire("b9h0p");
var $lx2i2 = parcelRequire("lx2i2");

var $bdpx3 = parcelRequire("bdpx3");

var $jpgPw = parcelRequire("jpgPw");
const $c0b05aa92dba6660$export$e0a2fa2ca78dc95 = ()=>{
    const { pathname: pathname } = (0, $bdpx3.useLocation)();
    (0, $jpgPw.useEffect)(()=>{
        window.scrollTo(0, 0);
    }, [
        pathname
    ]);
    return null;
};



var $caZvI = parcelRequire("caZvI");

var $2eqHs = parcelRequire("2eqHs");

var $jyFzD = parcelRequire("jyFzD");

var $2qbEs = parcelRequire("2qbEs");

var $b1LPP = parcelRequire("b1LPP");
parcelRequire("jpgPw");
const $e27d4f7e808f7073$export$6b078b7f3183d525 = ()=>{
    const { t: t } = (0, $2eqHs.useTranslation)();
    const currentLanguage = (0, $jyFzD.useCurrentLanguage)();
    return (0, $caZvI.jsx)((0, $caZvI.Fragment), {
        children: (0, $caZvI.jsxs)((0, $2qbEs.Helmet), {
            children: [
                (0, $caZvI.jsx)("html", {
                    lang: currentLanguage
                }),
                (0, $caZvI.jsx)("meta", {
                    name: "description",
                    content: t((0, $b1LPP.default).THESSA_IS_THE_DOCTORAL_STUDIES)
                })
            ]
        })
    });
};



var $bdpx3 = parcelRequire("bdpx3");

var $jpgPw = parcelRequire("jpgPw");

var $krtz1 = parcelRequire("krtz1");
const $71455fde114e984c$export$c2407059afa9f6d1 = ()=>{
    const navigate = (0, $bdpx3.useNavigate)();
    (0, $jpgPw.useEffect)(()=>{
        return (0, $krtz1.logOutResponse).onValue(()=>{
            navigate('/');
        });
    }, []);
    return null;
};



const $d8431e4858007d4e$var$ThessaApplication = /*#__PURE__*/ (0, $jpgPw.lazy)(()=>(parcelRequire("gZCd7")));

const $d8431e4858007d4e$var$ForgotPassword = /*#__PURE__*/ (0, $jpgPw.lazy)(()=>(parcelRequire("d9j9z")));

const $d8431e4858007d4e$var$ResetPassword = /*#__PURE__*/ (0, $jpgPw.lazy)(()=>(parcelRequire("6Bahu")));

const $d8431e4858007d4e$var$Invitation = /*#__PURE__*/ (0, $jpgPw.lazy)(()=>(parcelRequire("BcAtT")));

const $d8431e4858007d4e$var$ViewRoar = /*#__PURE__*/ (0, $jpgPw.lazy)(()=>(parcelRequire("eElnv")));

const $d8431e4858007d4e$var$About = /*#__PURE__*/ (0, $jpgPw.lazy)(()=>(parcelRequire("bc8Kw")));

const $d8431e4858007d4e$var$Contact = /*#__PURE__*/ (0, $jpgPw.lazy)(()=>(parcelRequire("11fjV")));

const $d8431e4858007d4e$var$AccessibilityStatement = /*#__PURE__*/ (0, $jpgPw.lazy)(()=>(parcelRequire("bflLj")));

const $d8431e4858007d4e$var$Sitemap = /*#__PURE__*/ (0, $jpgPw.lazy)(()=>(parcelRequire("kJh1S")));
const $d8431e4858007d4e$export$d438c9a42e72f081 = ()=>(0, $caZvI.jsxs)((0, $caZvI.Fragment), {
        children: [
            (0, $caZvI.jsx)((0, $e27d4f7e808f7073$export$6b078b7f3183d525), {}),
            (0, $caZvI.jsx)((0, $b1af6b1b1b129368$export$b76be5afdfbb7199), {
                children: (0, $caZvI.jsx)((0, $dQN7N.WindowWidthContextProvider), {
                    children: (0, $caZvI.jsxs)((0, $b9h0p.BrowserRouter), {
                        children: [
                            (0, $caZvI.jsx)((0, $71455fde114e984c$export$c2407059afa9f6d1), {}),
                            (0, $caZvI.jsxs)((0, $jpgPw.Suspense), {
                                fallback: (0, $caZvI.jsx)((0, $d69535d6d57e217e$export$e98dd63ef181176d), {}),
                                children: [
                                    (0, $caZvI.jsx)((0, $c0b05aa92dba6660$export$e0a2fa2ca78dc95), {}),
                                    (0, $caZvI.jsxs)((0, $lx2i2.Routes), {
                                        children: [
                                            (0, $caZvI.jsx)((0, $lx2i2.Route), {
                                                path: "/forgot-password",
                                                element: (0, $caZvI.jsx)($d8431e4858007d4e$var$ForgotPassword, {})
                                            }),
                                            (0, $caZvI.jsx)((0, $lx2i2.Route), {
                                                path: "/reset-password/:email/:resetPasswordToken",
                                                element: (0, $caZvI.jsx)($d8431e4858007d4e$var$ResetPassword, {})
                                            }),
                                            (0, $caZvI.jsx)((0, $lx2i2.Route), {
                                                path: "/invitations/:token",
                                                element: (0, $caZvI.jsx)($d8431e4858007d4e$var$Invitation, {})
                                            }),
                                            (0, $caZvI.jsx)((0, $lx2i2.Route), {
                                                path: "/roar/:roarValidFrom?",
                                                element: (0, $caZvI.jsx)($d8431e4858007d4e$var$ViewRoar, {})
                                            }),
                                            (0, $caZvI.jsx)((0, $lx2i2.Route), {
                                                path: "/about",
                                                element: (0, $caZvI.jsx)($d8431e4858007d4e$var$About, {})
                                            }),
                                            (0, $caZvI.jsx)((0, $lx2i2.Route), {
                                                path: "/contact",
                                                element: (0, $caZvI.jsx)($d8431e4858007d4e$var$Contact, {})
                                            }),
                                            (0, $caZvI.jsx)((0, $lx2i2.Route), {
                                                path: "/accessibility-statement",
                                                element: (0, $caZvI.jsx)($d8431e4858007d4e$var$AccessibilityStatement, {})
                                            }),
                                            (0, $caZvI.jsx)((0, $lx2i2.Route), {
                                                path: "/sitemap",
                                                element: (0, $caZvI.jsx)($d8431e4858007d4e$var$Sitemap, {})
                                            }),
                                            (0, $caZvI.jsx)((0, $lx2i2.Route), {
                                                path: "/external-login",
                                                element: (0, $caZvI.jsx)((0, $lx2i2.Navigate), {
                                                    to: "/",
                                                    replace: true
                                                })
                                            }),
                                            (0, $caZvI.jsx)((0, $lx2i2.Route), {
                                                path: "/*",
                                                element: (0, $caZvI.jsx)($d8431e4858007d4e$var$ThessaApplication, {})
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });


(0, $hiCBt.default)('fi');
(0, $0957aa571687c4d4$exports.createRoot)(document.getElementById('thessa-application')).render((0, $caZvI.jsx)((0, $jpgPw.StrictMode), {
    children: (0, $caZvI.jsx)((0, $2qbEs.HelmetProvider), {
        children: (0, $caZvI.jsx)((0, $d8431e4858007d4e$export$d438c9a42e72f081), {})
    })
}));


//# sourceMappingURL=thessa-front.39c660c3.js.map
